webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var ApiProduccion = 'produccion/php/api/';

var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(ApiProduccion + url);
};

var post = function post(url, data) {
	return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(ApiProduccion + url, data);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	// TAREAS

	/**
  * Obtener un listado de tareas
  */
	getListadoTareas: function getListadoTareas() {
		return get('get-listado-tareas-new.php');
	},

	buscaTareas: function buscaTareas(filtro) {
		var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filtro));
		if (filtro.fechaIni) {
			filtro.fechaIni.setHours(0);
			filtro.fechaIni.setMinutes(0);
			filtro.fechaIni.setSeconds(0);
		}

		if (filtro.fechaFin) {
			filtro.fechaFin.setHours(23);
			filtro.fechaFin.setMinutes(59);
			filtro.fechaFin.setSeconds(59);
		}
		form.fechaIni = filtro.fechaIni ? Math.floor(filtro.fechaIni.getTime() / 1000) : null;
		form.fechaFin = filtro.fechaFin ? Math.floor(filtro.fechaFin.getTime() / 1000) : null;
		return post('buscaTareas.php', form);
	},

	/**
  * Obtenemos la tarea pasando su ID
  */
	getTarea: function getTarea(idTarea) {
		return get('get-tarea.php?ID_tarea=' + idTarea);
	},

	/**
  * Editamos los datos de una tarea
  */
	setTarea: function setTarea(datos) {
		return post('set-tarea.php', datos);
	},

	setTareaExpress: function setTareaExpress(datos) {
		return post('set-tarea-express.php', datos);
	},

	/**
  * Elimina una tarea en función de su ID
  */
	delTarea: function delTarea(idTarea) {
		return get('del-tarea.php?ID_tarea=' + idTarea);
	},

	setTiempoEstimado: function setTiempoEstimado(idVersion, tiempo) {
		var datos = {
			ID_version: idVersion,
			tiempo: tiempo
		};
		return post('set-tiempo-estimado.php', datos);
	},

	/**
  * Añade un soporte a la tarea
  */
	tareaAddSoporte: function tareaAddSoporte(datos) {
		return post('tarea-add-soporte.php', datos);
	},

	/**
  * Añade uno o más ficheros a la tarea
  */
	tareaAddFicheros: function tareaAddFicheros(formData) {
		return post('set-ficheros-tarea.php', formData);
	},

	/**
  * Elimina un fichero de una tarea
  */
	tareaDelFichero: function tareaDelFichero(datos) {
		return post('del-ficheros-tarea.php', datos);
	},

	/**
  * Elimina un soporte de la tarea
  */
	tareaDelSoporte: function tareaDelSoporte(datos) {
		return post('tarea-del-soporte.php', datos);
	},

	/**
  * Comentar en una tarea
  */
	setComentarioTarea: function setComentarioTarea(datos) {
		return post('set-comentario-tarea.php', datos);
	},

	/**
  * Obtenemos el historial de versiones
  */
	getHistorial: function getHistorial(idTarea) {
		return get('get-historial-tarea.php?ID_tarea=' + idTarea);
	},

	// PERMISOS
	getPermisos: function getPermisos() {
		return get('get-permisos.php');
	},

	// CONTRATOS

	/**
  * Buscamos contratos en base a un criterio
  */
	buscaContratos: function buscaContratos(filtro) {
		return post('buscaContratos.php', filtro);
	},

	// PRODUCCIONES

	/**
  * Obtenemos una producción en base a su id
  */
	getProduccion: function getProduccion(idProduccion) {
		return get('get-produccion.php?ID_produccion=' + idProduccion);
	},

	setProduccion: function setProduccion(datos) {
		return post('set-produccion.php', datos);
	},

	/**
  * Enviamos ficheros para la órden de producción
  */
	setFicherosProduccion: function setFicherosProduccion(formData) {
		return post('set-ficheros-produccion.php', formData);
	},

	delFicherosProduccion: function delFicherosProduccion(datos) {
		return post('del-ficheros-produccion.php', datos);
	},

	// VERSIONES

	/**
  * Crear/modificar un texto
  */
	setTexto: function setTexto(datos) {
		return post('set-texto.php', datos);
	},

	/**
  * Marcamos un texto como grabado o no
  */
	setTextoGrabado: function setTextoGrabado(datos) {
		return post('set-texto-grabado.php', datos);
	},

	/**
  * Elimina un texto
  */
	delTexto: function delTexto(datos) {
		return post('del-texto.php', datos);
	},

	/**
  * Elimina un fichero producido
  */
	delFicheroVersion: function delFicheroVersion(datos) {
		return post('del-ficheros-version.php', datos);
	},

	/**
  * Sube un fichero al XFrame
  */
	setSubirXFrame: function setSubirXFrame(datos) {
		return post('set-subir-xframe.php', datos);
	},

	/**
  * Envia un texto al teleprompter
  */
	setTeleprompter: function setTeleprompter(datos) {
		return post('set-teleprompter.php', datos);
	},

	/**
  * Pasamos a la siguiente fase
  */
	setSiguienteFase: function setSiguienteFase(datos) {
		return post('set-siguiente-fase.php', datos);
	},

	cancelarTarea: function cancelarTarea(idTarea) {
		var datos = {
			ID_tarea: idTarea
		};
		return post('set-cancela-tarea.php', datos);
	},

	// RECHAZOS DE TAREAS

	/**
  * Obtenemos los motivos de rechazo de una tarea
  */
	getMotivosRechazo: function getMotivosRechazo() {
		return get('get-motivos-rechazo.php');
	},

	/**
  * Rechazar una versión
  */
	setRechazarVersion: function setRechazarVersion(datos) {
		return post('set-rechazar-version.php', datos);
	},

	// SOPORTES
	getSoportes: function getSoportes() {
		return get('get-soportes.php');
	},

	// LOCUTORES

	/**
  * Obtenemos un listado de procedencias de los locutores
  */
	getProcedencias: function getProcedencias() {
		return get('get-procedencias.php');
	},

	/**
  * Creamos una nueva procedencia
  */
	setProcedencia: function setProcedencia(datos) {
		return post('set-procedencia.php', datos);
	},

	/**
  * Creamos/editamos un locutor
  */
	setLocutor: function setLocutor(datos) {
		return post('set-locutor.php', datos);
	},

	/**
  * Asigna un locutor a una tarea
  */
	asignaLocutor: function asignaLocutor(datos) {
		return post('asigna-locutor.php', datos);
	},

	/**
  * Obtiene un listado de locutores habituales
  */
	getLocutoresHabituales: function getLocutoresHabituales(tipo, IDAnunciante) {
		var datos = {
			tipo: tipo,
			ID_anunciante: IDAnunciante
		};
		return post('get-locutores-habituales.php', datos);
	},

	/**
  * Buscamos locutores
  */
	queryLocutores: function queryLocutores(filtro) {
		return post('query-locutores.php', filtro);
	},

	// AUDITOR
	getAuditor: function getAuditor(idFichero) {
		return get('get-auditor.php?ID_fichero=' + idFichero);
	},

	getProgramacion: function getProgramacion(idFichero) {
		return get('get-programacion.php?ID_fichero=' + idFichero);
	},

	getProgramacionPDF: function getProgramacionPDF(datos) {
		return post('get-programacion-pdf.php', datos);
	}
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);






var apiContratos = 'mis-contratos/php/api/';

/* harmony default export */ __webpack_exports__["a"] = ({
	_post: function _post(url, data) {
		data = this._convierteFechas(data);
		return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(apiContratos + url, data);
	},
	_get: function _get(url) {
		return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(apiContratos + url);
	},
	getPermisos: function getPermisos() {
		return this._get('get-permisos.php');
	},
	getDestinos: function getDestinos() {
		return this._get('get-destinos.php');
	},
	getFormasDePago: function getFormasDePago() {
		return this._get('get-forma-pago.php');
	},
	getImpuestos: function getImpuestos() {
		return this._get('get-impuestos.php');
	},
	getCierre: function getCierre() {
		return this._get('get-cierre.php');
	},
	getSoportes: function getSoportes() {
		return this._get('get-soportes.php');
	},
	getPartidas: function getPartidas() {
		return this._get('get-partidas.php');
	},
	getEventos: function getEventos() {
		return this._get('get-eventos.php');
	},
	getContrato: function getContrato(idContrato) {
		var _this = this;

		return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			_this._get('get-contrato.php?ContratoID=' + idContrato).then(function (res) {
				// Procesamos todas las fechas
				var contrato = _this._procesaContrato(res.data);
				resolve(contrato);
			}).catch(function (e) {
				reject(e);
			});
		});
	},
	getEmpresas: function getEmpresas() {
		return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('mis-contratos/php/api/get-listado-empresas.php').then(function (res) {
				resolve(res.data);
			}).catch(function (e) {
				reject(e.response.data);
			});
		});
	},
	getCliente: function getCliente(idCliente) {
		return this._get('get-cliente.php?ID_cliente=' + idCliente);
	},
	getProductos: function getProductos(idSoporte) {
		return this._get('get-productos.php?ID_soporte=' + idSoporte);
	},
	setIntermediario: function setIntermediario(datos) {
		return this._post('set-intermediario.php', datos);
	},
	setCandidato: function setCandidato(idContrato) {
		return this._get('set-contrato-candidato.php?ContratoID=' + idContrato);
	},
	setAprobar: function setAprobar(idContrato) {
		return this._get('set-contrato-aprobado.php?ContratoID=' + idContrato);
	},
	setRechazar: function setRechazar(idContrato) {
		return this._get('set-contrato-rechazado.php?ContratoID=' + idContrato);
	},
	setEliminado: function setEliminado(idContrato) {
		return this._get('set-contrato-eliminado.php?ContratoID=' + idContrato);
	},
	setContrato: function setContrato(datos) {
		var _this2 = this;

		return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			var form = void 0;
			try {
				form = _this2._convierteFechas(datos);
			} catch (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.message
				});
				return;
			}
			_this2._post('set-contrato.php', form).then(function (res) {
				var contrato = _this2._procesaContrato(res.data);
				resolve(contrato);
			}).catch(reject);
		});
	},
	buscar: function buscar(filtro) {
		return this._post('buscaContratos.php', filtro);
	},
	_convierteFechas: function _convierteFechas(orig) {
		var dest = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(orig));
		var analiza = function analiza(objeto, destino) {
			for (var k in objeto) {
				if (objeto.hasOwnProperty(k)) {
					if (typeof objeto[k] !== 'undefined' && objeto[k] !== null && objeto[k].getDate) {
						destino[k] = Math.floor(objeto[k].getTime() / 1000);
					} else if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(objeto[k]) === 'object' && objeto[k] !== null && typeof objeto[k] !== 'undefined') {
						analiza(objeto[k], destino[k]);
					} else {
						destino[k] = objeto[k];
					}
				}
			}
		};

		analiza(orig, dest);
		return dest;
	},
	_procesaContrato: function _procesaContrato(contrato) {
		contrato.FechaCreacion = new Date(contrato.FechaCreacion * 1000);
		contrato.FechaInicio = new Date(contrato.FechaInicio * 1000);
		contrato.FechaFin = new Date(contrato.FechaFin * 1000);
		contrato.FechaModificacion = contrato.FechaModificacion ? new Date(contrato.FechaModificacion * 1000) : null;
		contrato.FechaCandidato = contrato.FechaCandidato ? new Date(contrato.FechaCandidato * 1000) : null;
		contrato.FechaAprobado = contrato.FechaAprobado ? new Date(contrato.FechaAprobado * 1000) : null;
		contrato.FechaRechazado = contrato.FechaRechazado ? new Date(contrato.FechaRechazado * 1000) : null;

		// Agrupamos la facturación por fechas
		var facturacion = void 0;
		try {
			facturacion = contrato.facturacion.reduce(function (ant, actual) {
				var FechaFactura = actual.FechaFactura;
				var importe = Math.round(actual.ImporteTotal * 1000) / 1000;
				var importeNeto = Math.round(actual.ImporteNeto * 1000) / 1000;
				var FechaPagada = actual.FechaPagada;
				var ReciboPagadaID = actual.ReciboPagadaID;

				if (!ant.has(FechaFactura)) {
					ant.set(FechaFactura, {
						Importe: importe,
						ImporteNeto: importeNeto,
						FechaPagada: FechaPagada,
						ReciboPagadaID: ReciboPagadaID,
						FacturacionID: 'L-' + actual.FacturacionID.toString()
					});
				} else {
					var obj = ant.get(FechaFactura);
					obj.Importe = obj.Importe + importe;
					obj.ImporteNeto = obj.ImporteNeto + importeNeto;
					obj.FacturacionID = obj.FacturacionID + '-' + actual.FacturacionID.toString();
					ant.set(FechaFactura, obj);
				}

				return ant;
			}, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a());

			// Sobreescribimos la facturación
			contrato.facturacion = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(facturacion).map(function (i) {
				var elem = {
					FechaFactura: new Date(i[0] * 1000),
					ImporteTotal: i[1].Importe,
					ImporteNeto: i[1].ImporteNeto,
					FechaPagada: i[1].FechaPagada,
					ReciboPagadaID: i[1].ReciboPagadaID,
					FacturacionID: i[1].FacturacionID
				};
				return elem;
			});
		} catch (e) {
			console.error(e);
			console.error('Error agrupando la facturación');
		}

		for (var i = 0; i < contrato.lineas.length; i++) {
			contrato.lineas[i].FechaCreacion = new Date(contrato.lineas[i].FechaCreacion * 1000);
		}

		for (var _i = 0; _i < contrato.recibos.length; _i++) {
			contrato.recibos[_i].FechaCreado = new Date(contrato.recibos[_i].FechaCreado * 1000);
			contrato.recibos[_i].FechaEmision = new Date(contrato.recibos[_i].FechaEmision * 1000);
			contrato.recibos[_i].FechaVencimiento = new Date(contrato.recibos[_i].FechaVencimiento * 1000);
		}

		for (var _i2 = 0; _i2 < contrato.historico.length; _i2++) {
			contrato.historico[_i2].FechaCreacion = new Date(contrato.historico[_i2].FechaCreacion * 1000);
		}
		return contrato;
	}
});

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alertas__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__permisos__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toast__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contextual__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notificaciones__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__top__ = __webpack_require__(797);











__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = '/src/modulos/';

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
	modules: {
		session: __WEBPACK_IMPORTED_MODULE_3__session__["a" /* default */],
		alertas: __WEBPACK_IMPORTED_MODULE_4__alertas__["a" /* default */],
		permisos: __WEBPACK_IMPORTED_MODULE_5__permisos__["a" /* default */],
		toast: __WEBPACK_IMPORTED_MODULE_6__toast__["a" /* default */],
		contextual: __WEBPACK_IMPORTED_MODULE_7__contextual__["a" /* default */],
		top: __WEBPACK_IMPORTED_MODULE_9__top__["a" /* default */],
		notificaciones: __WEBPACK_IMPORTED_MODULE_8__notificaciones__["a" /* default */]
	}
}));

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendario_anual_vue__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86de4c18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendario_anual_vue__ = __webpack_require__(1188);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendario_anual_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86de4c18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendario_anual_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visor_contrato_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7aefa3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visor_contrato_vue__ = __webpack_require__(981);
function injectStyle (ssrContext) {
  __webpack_require__(942)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visor_contrato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7aefa3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visor_contrato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mini_galeria_vue__ = __webpack_require__(488);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a799bd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mini_galeria_vue__ = __webpack_require__(1139);
function injectStyle (ssrContext) {
  __webpack_require__(1138)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10a799bd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mini_galeria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a799bd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mini_galeria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
	_get: function _get(url) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('gestion-horaria/php/api/' + url);
	},
	_post: function _post(uri, data) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-horaria/php/api/' + uri, data);
	},
	getResumen: function getResumen(mio) {
		if (mio) {
			return this._get('getResumenEmpleados.php?yo=1');
		} else {
			return this._get('getResumenEmpleados.php');
		}
	},
	getRegistro: function getRegistro(idRegistro) {
		return this._get('get-registro.php?ID_registro=' + idRegistro);
	},
	setRegistro: function setRegistro(data) {
		return this._post('set-registro.php', data);
	},
	misHoras: function misHoras(filtro) {
		return this._post('get-mis-horas.php', filtro);
	},
	getListado: function getListado(filtro) {
		return this._post('get-listado.php', filtro);
	},
	infoUsuario: function infoUsuario(idUsuario) {
		var data = {
			ID_usuario: idUsuario
		};

		return this._post('get-usuario.php', data);
	},
	soyLider: function soyLider() {
		return this._get('soy-lider.php');
	},
	validar: function validar(idRegistro) {
		var data = {
			ID_registro: idRegistro
		};
		return this._post('validar.php', data);
	},
	validarTodo: function validarTodo(filtro) {
		return this._post('validar-todo.php', filtro);
	},
	eliminar: function eliminar(idRegistro) {
		var data = {
			ID_registro: idRegistro
		};
		return this._post('eliminar.php', data);
	}
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var uri = 'gestion-usuarios/php/';

var _get = function _get(url) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(uri + url);
};

var post = function post(url, datos) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(uri + url, datos);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	buscar: function buscar(filtro) {
		return post('buscar.php', filtro);
	},
	getGrupos: function getGrupos() {
		return _get('getGrupos.php');
	},
	get: function get(idUsuario) {
		return _get('getUsuario.php?ID=' + idUsuario);
	},
	getEmpresas: function getEmpresas() {
		return _get('getEmpresas.php');
	},
	setUsuario: function setUsuario(datos) {
		var form = _.clone(datos);
		form.fecha_expiracion_cuenta = datos.fecha_expiracion_cuenta ? Math.floor(datos.fecha_expiracion_cuenta.getTime() / 1000) : 0;
		form.caduca_password = datos.caduca_password ? Math.floor(datos.caduca_password.getTime() / 1000) : 0;
		form.fecha_nacimiento = datos.fecha_nacimiento ? Math.floor(datos.fecha_nacimiento.getTime() / 1000) : 0;
		return post('setUsuario.php', form);
	},
	delOTP: function delOTP(ID) {
		var datos = {
			ID: ID
		};
		return post('delOTP.php', datos);
	},
	resetPassword: function resetPassword(datos) {
		return post('resetPassword.php', datos);
	},
	crearLdap: function crearLdap(ID, usuario) {
		var datos = {
			ID: ID,
			usuario: usuario
		};

		return post('nuevoLdap.php', datos);
	},
	eliminaLdap: function eliminaLdap(ID) {
		var datos = {
			ID: ID
		};

		return post('eliminaLdap.php', datos);
	},
	setUnix: function setUnix(ID, datos) {
		var form = {
			ID: ID,
			datos: datos
		};
		return post('setUnix.php', form);
	},
	setSamba: function setSamba(ID, datos) {
		var form = {
			ID: ID,
			datos: datos
		};
		return post('setSamba.php', form);
	},
	getDominios: function getDominios() {
		return _get('getDominios.php');
	},
	getEmails: function getEmails(ID) {
		var form = {
			ID: ID
		};

		return post('getEmails.php', form);
	},
	setEmails: function setEmails(ID, emails) {
		var form = {
			ID: ID,
			emails: emails
		};

		return post('setEmails.php', form);
	}
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
	GetLineasContrato: function GetLineasContrato(ContratoID) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('radiacion/php/api/get-lineas-contrato.php?ContratoID=' + ContratoID).then(function (res) {
				resolve(res.data);
			}).catch(function (e) {
				reject(e.response.error);
			});
		});
	},
	GetBloques: function GetBloques(form) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('radiacion/php/api/bloques/buscar.php', form).then(function (res) {
				resolve(res.data);
			}).catch(function (e) {
				reject(e.response.error);
			});
		});
	},
	GetOriginales: function GetOriginales(filtro) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('radiacion/php/api/originales/buscar.php', filtro).then(function (res) {
				resolve(res.data);
			}).catch(function (e) {
				reject(e.response.data.error);
			});
		});
	},


	/**
  * Devuelve la programación (bloques, programas y contenidos) de unos días dados
  * Los días se pasarán como un array de fechas en formato 'YYYY-MM-DD'
  */
	GetProgramacionDias: function GetProgramacionDias(EmisoraID, dias) {
		var form = {
			EmisoraID: EmisoraID,
			Dias: dias.map(function (d) {
				return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].$moment(d).format('YYYY-MM-DD');
			})
		};

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('radiacion/php/api/programacion/get-programacion-dias.php', form).then(function (res) {
				resolve(res.data);
			}).catch(function (e) {
				reject(e.response.error);
			});
		});
	},


	/**
  * Genera una nueva inserción en el día establecido y la devuelve
  * @param {String} dia Fecha en Formato YYYY-MM-DD
  */
	NuevaInsercion: function NuevaInsercion(dia) {
		var d = dia.split('-').map(function (d) {
			return parseInt(d);
		});
		var diaUnix = Math.floor(new Date(d[0], d[1] - 1, d[2], 0, 0, 0, 0).getTime() / 1000);
		var insercion = {
			InsercionID: 'I-' + new Date().getTime() + Math.round(Math.random() * 100000),
			FicheroID: null,
			Inserciones: 1,
			Descripcion: null,
			Dia: dia,
			DiaUnix: diaUnix,
			UsuarioID: null,
			Bloques: [],
			Posicion: null,
			DuracionReal: 0,
			DuracionEstimada: 0,
			ImporteUnitario: 0,
			ImporteFinal: 0,
			Descuento: 0,
			ProgramaID: null,
			ProgramaNombre: null,
			ContenidoID: null,
			ContenidoNombre: null,
			HoraInicio: null,
			HoraFin: null,
			Fijar: null,
			Anulada: false,
			RefExterna: null
		};
		return insercion;
	}
});

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fichar_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07048d30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fichar_vue__ = __webpack_require__(778);
function injectStyle (ssrContext) {
  __webpack_require__(777)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07048d30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fichar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07048d30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fichar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
	_get: function _get(uri) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('galerias/php/api/' + uri);
	},
	_post: function _post(uri, datos) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('galerias/php/api/' + uri, datos);
	},
	setGaleria: function setGaleria(datos) {
		var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(datos));
		form.FechaGaleria = Math.floor(datos.FechaGaleria.getTime() / 1000);
		return this._post('set-galeria.php', form);
	},
	delGaleria: function delGaleria(GaleriaID) {
		return this._post('del-galeria.php', { GaleriaID: GaleriaID });
	},
	getGaleria: function getGaleria(idGaleria) {
		return this._post('get-galeria.php', { GaleriaID: idGaleria });
	},
	getItem: function getItem(ItemID) {
		var form = {
			ItemID: ItemID
		};
		return this._post('get-item.php', form);
	},
	delItem: function delItem(ItemID) {
		return this._post('del-item.php', { ItemID: ItemID });
	},
	getGalerias: function getGalerias(idUltima) {
		return this._post('get-galerias.php', { idUltima: idUltima });
	},
	addItemTag: function addItemTag(idItem, etiqueta) {
		var form = {
			ItemID: idItem,
			etiqueta: etiqueta
		};
		return this._post('set-etiqueta-item.php', form);
	},
	delItemTag: function delItemTag(idItem, etiqueta) {
		var form = {
			ItemID: idItem,
			etiqueta: etiqueta
		};
		return this._post('del-etiqueta-item.php', form);
	},
	setPortada: function setPortada(GaleriaID, ItemID) {
		var form = {
			GaleriaID: GaleriaID,
			ItemID: ItemID
		};
		return this._post('set-portada.php', form);
	},
	setPersona: function setPersona(ItemID, PersonaID, Nombre) {
		var form = {
			ItemID: ItemID,
			PersonaID: PersonaID,
			Nombre: Nombre
		};
		return this._post('set-persona-item.php', form);
	},
	delPersona: function delPersona(ItemID, PersonaID) {
		var form = {
			ItemID: ItemID,
			PersonaID: PersonaID
		};
		return this._post('del-persona-item.php', form);
	}
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dias_vue__ = __webpack_require__(509);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4996a19a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_select_dias_vue__ = __webpack_require__(1187);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_select_dias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4996a19a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_select_dias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(529);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73f1e79e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1238);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73f1e79e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
	_get: function _get(uri) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('invitaciones/php/api/' + uri);
	},
	_post: function _post(uri, data) {
		return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('invitaciones/php/api/' + uri, data);
	},
	getEventos: function getEventos(soloAbiertos) {
		if (soloAbiertos) {
			return this._get('listado-eventos.php?abiertos=true');
		} else {
			return this._get('listado-eventos.php');
		}
	},
	getGrupos: function getGrupos(idEvento) {
		return this._get('listado-grupos.php?EventoID=' + idEvento);
	},
	buscarInvitados: function buscarInvitados(datos) {
		return this._post('buscar-invitados.php', datos);
	},
	getInvitado: function getInvitado(idInvitado) {
		return this._get('get-invitado.php?InvitadoID=' + idInvitado);
	},
	setInvitado: function setInvitado(datos) {
		return this._post('set-invitado.php', datos);
	},
	getRecinto: function getRecinto(EventoID) {
		return this._get('verRecinto.php?EventoID=' + EventoID);
	},
	download: function download(datos, orden) {
		var filtro = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, datos, orden);
		__WEBPACK_IMPORTED_MODULE_1_axios___default()({
			url: 'invitaciones/php/api/getPDF.php',
			method: 'POST',
			data: filtro,
			responseType: 'blob',
			headers: {
				'Content-type': 'application/json',
				'Accept': 'application/x-binary'
			}
		}).then(function (res) {
			var a = document.createElement('a');
			var file = new Blob([res.data], { type: 'application/pdf' });
			console.log(file);
			var url = URL.createObjectURL(file);
			a.name = 'informe.pdf';
			a.href = url;
			a.download = 'informe.pdf';
			document.body.appendChild(a);
			a.click();
			window.setTimeout(function () {
				document.body.removeChild(a);
			}, 3000);
		}).catch(function (e) {
			console.error(e);
		});
	}
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var uri = 'libreta-direcciones/php/';

var post = function post(url, data) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(uri + url, data);
};

var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(uri + url);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	buscarRegistros: function buscarRegistros(filtro) {
		return post('buscaRegistros.php', filtro);
	},
	getRegistro: function getRegistro(idRegistro) {
		return get('getRegistro.php?ID_registro=' + idRegistro);
	},
	getLibretas: function getLibretas(escritura) {
		if (escritura !== undefined && escritura === true) {
			return get('getLibretas.php?escritura=true');
		} else {
			return get('getLibretas.php');
		}
	},
	getLibreta: function getLibreta(idLibreta) {
		return post('getLibreta.php', { ID_libreta: idLibreta });
	},
	setLibreta: function setLibreta(datos) {
		return post('setLibreta.php', datos);
	},
	eliminarLibreta: function eliminarLibreta(idLibreta) {
		return post('delLibreta.php', { ID_libreta: idLibreta });
	},
	setRegistro: function setRegistro(datos) {
		return post('setRegistro.php', datos);
	},
	eliminar: function eliminar(idRegistro) {
		return post('delRegistro.php', { ID_registro: idRegistro });
	}
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colocacion_vue__ = __webpack_require__(647);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00da32b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_colocacion_vue__ = __webpack_require__(1508);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colocacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00da32b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_colocacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(465);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89e47e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1109);
function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89e47e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visor_item_vue__ = __webpack_require__(480);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba43584_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visor_item_vue__ = __webpack_require__(1127);
function injectStyle (ssrContext) {
  __webpack_require__(1126)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ba43584"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visor_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba43584_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visor_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var uri = 'gestion-cuentas-email/php/';
var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(uri + url);
};
var post = function post(url, datos) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(uri + url, datos);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getDominios: function getDominios() {
		return get('getDominios.php');
	},
	getCuentas: function getCuentas() {
		return get('getCuentas.php');
	},
	getCuenta: function getCuenta(idCuenta) {
		var datos = {
			idCuenta: idCuenta
		};
		return post('getCuenta.php', datos);
	},
	getAlias: function getAlias(origen, dominio) {
		var datos = {
			origen: origen,
			dominio_origen: dominio
		};
		return post('getAlias.php', datos);
	},
	getAliases: function getAliases() {
		return get('getAliases.php');
	},
	setCuenta: function setCuenta(datos) {
		return post('setCuenta.php', datos);
	},
	setAlias: function setAlias(datos) {
		return post('setAlias.php', datos);
	},
	delCuenta: function delCuenta(idCuenta) {
		var datos = {
			idCuenta: idCuenta
		};
		return post('delCuenta.php', datos);
	},
	eliminarAlias: function eliminarAlias(datos) {
		return post('delAliasCompleto.php', datos);
	},
	delAlias: function delAlias(datos) {
		return post('delAlias.php', datos);
	},
	setToken: function setToken(idCuenta, nombre) {
		var datos = {
			idCuenta: idCuenta,
			nombre: nombre
		};
		return post('setToken.php', datos);
	},
	delToken: function delToken(idToken) {
		var datos = {
			idToken: idToken
		};
		return post('delToken.php', datos);
	}
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalSeleccionOriginal_component_vue__ = __webpack_require__(656);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c256a1a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modalSeleccionOriginal_component_vue__ = __webpack_require__(1521);
function injectStyle (ssrContext) {
  __webpack_require__(1520)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c256a1a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalSeleccionOriginal_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c256a1a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modalSeleccionOriginal_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_alertas__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mi_perfil_cambio_pass_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_login_bloqueo__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_toasts_wrapper__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_contextual_contextual_vue__ = __webpack_require__(744);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	data: function data() {
		return {
			cambiarPass: false,
			intervaloSesion: null,
			intervaloPermisos: null,
			sesionBloqueada: null,
			timeoutBloqueo: null,
			timeoutAvisoBloqueo: null,
			minutosAutoBloqueo: 30,
			verTutorialNotificaciones: false,
			moduloActivo: null
		};
	},

	components: {
		'alertas': __WEBPACK_IMPORTED_MODULE_2__components_common_alertas__["a" /* default */],
		'cambio-pass': __WEBPACK_IMPORTED_MODULE_5__components_mi_perfil_cambio_pass_vue__["a" /* default */],
		'bloqueo': __WEBPACK_IMPORTED_MODULE_6__components_login_bloqueo__["a" /* default */],
		'toasts': __WEBPACK_IMPORTED_MODULE_7__components_toasts_wrapper__["a" /* default */],
		'contextual': __WEBPACK_IMPORTED_MODULE_8__components_contextual_contextual_vue__["a" /* default */]
	},
	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		sesion: 'session/haySesion',
		permisos: 'permisos/permisos',
		afterLoginPath: 'session/afterLoginPath'
	})),
	beforeCreate: function beforeCreate() {
		var _this = this;

		// Cuando la sesión está bloqueada solo permitiremos peticiones a /src/modulos/core/php/api/{get.php,desbloquear.php,logout.php}
		this.$moment.locale('es');
		var cancelToken = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.CancelToken;
		var source = cancelToken.source();
		__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.request.use(function (req) {
			var url = req.url;
			var permitidas = ['core/php/api/sesion/get.php', 'core/php/api/sesion/desbloquear.php', 'core/php/api/sesion/logout.php'];

			if (_this.sesionBloqueada && permitidas.indexOf(url) < 0) {
				req.cancelToken = source.token;
				source.cancel();
				return;
			}
			return req;
		}, function (err) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
		});

		// Interceptamos los 401
		__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.response.use(function (res) {
			return res;
		}, function (err) {
			if (!err.response) {
				throw new __WEBPACK_IMPORTED_MODULE_4_axios___default.a.Cancel({
					code: 423,
					message: 'Sesión bloqueada'
				});
			} else if (err.response.status === 423) {
				_this.$store.commit('session/setBloqueado', err.response.data.usuario);
				throw new __WEBPACK_IMPORTED_MODULE_4_axios___default.a.Cancel({
					code: 423,
					message: 'Sesión bloqueada'
				});
			} else if (err.response.status === 401) {
				// Si la ruta es para resetear password no redireccionamos
				if (!_this.$route.path.match(/^\/password-restore/)) {
					_this.$router.push('/login');
				}
			} else {
				if (!err.response.data.error) {
					err.response.data = {
						error: 'Error desconocido'
					};
				}
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
			}
		});

		this.$store.watch(function (a) {
			return a.session.activa;
		}, function (newValue, oldValue) {
			if (newValue === false) {
				if (_this.$route.path.match(/^\/password-restore/)) {
					return;
				}
				if (oldValue === null && _this.$route.path !== '/login') {
					// Almacenamos la url para acceder despues del login
					_this.$store.commit('session/SET_AFTER_LOGIN', _this.$route.path);
				}
				_this.$router.push('/login');

				if (_this.intervaloSesion) {
					window.clearInterval(_this.intervaloSesion);
				}

				if (_this.intervaloPermisos) {
					window.clearInterval(_this.intervaloPermisos);
				}
			} else {
				if (!oldValue && _this.afterLoginPath) {
					_this.$router.push(_this.afterLoginPath);
				} else if (!_this.$route.path.match(/^\/main/)) {
					_this.$router.push('/main');
				}

				_this.$store.dispatch('permisos/getPermisos');

				_this.intervaloSesion = window.setInterval(function () {
					_this.$store.dispatch('session/getSesion');
				}, 10000);

				_this.intervaloPermisos = window.setInterval(function () {
					_this.$store.dispatch('permisos/getPermisos');
				}, 60000);
			}
		});

		this.$store.watch(function (a) {
			return a.session.cambioPass;
		}, function (nuevo) {
			if (nuevo === true) {
				_this.cambiarPass = true;
			} else {
				_this.cambiarPass = false;
			}
		});

		this.$store.watch(function (a) {
			return a.session.bloqueado;
		}, function (nuevo) {
			_this.sesionBloqueada = nuevo;
		});

		this.$store.dispatch('session/getSesion');

		this.$router.beforeEach(function (to, from, next) {
			var ruta = to.path.split('/');
			if (_this.moduloActivo !== null && _this.moduloActivo !== ruta[2]) {
				console.log(_this.moduloActivo + '!=' + ruta[2]);
				_this.$store.commit('top/clearMenu');
			}
			_this.moduloActivo = ruta[2];
			if (to.path.match(/^\/password-restore/)) {
				next();
			} else if (!_this.sesion && to.path !== '/login') {
				_this.$router.push('/login');
			} else if (!_this.session && to.path === '/login') {
				next();
			} else if (!to.path.match(/^\/main/)) {
				_this.$router.push('/main');
			} else {
				next();
			}
		});
	},
	created: function created() {
		// Preguntamos por el permiso de notificaciones
		if (window.Notification && (Notification.permission === 'denied' || Notification.permission === 'default')) {
			Notification.requestPermission().then(function (permiso) {
				if (permiso === 'denied') {
					// this.verTutorialNotificaciones = true
					// No obligamos a que acepten las notificaciones
				}
			}).catch(function (e) {
				console.error(e);
			});
		}
	},

	methods: {
		bloquear: function bloquear() {
			this.$store.dispatch('session/lock');
		}
	}
});

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'alertas',

	data: function data() {
		return {};
	},
	watch: {
		actual: function actual(newVal) {
			var _this = this;

			if (newVal) {
				window.setTimeout(function () {
					if (_this.$refs['boton-0'].length > 0) {
						_this.$refs['boton-0'][0].focus();
					}
				}, 100);
			}
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('alertas', ['actual'])),

	methods: {
		cerrar: function cerrar(payload) {
			if (this.actual.callback) {
				this.actual.callback(payload);
			}

			this.$store.commit('alertas/cerrar');
		}
	}
});

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cambio_pass_vue__ = __webpack_require__(115);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53230222_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cambio_pass_vue__ = __webpack_require__(734);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cambio_pass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53230222_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cambio_pass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apiUsuario__ = __webpack_require__(116);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			form: {
				passwordAnterior: '',
				passwordNueva1: '',
				passwordNueva2: ''
			}
		};
	},

	methods: {
		cambiar: function cambiar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__apiUsuario__["a" /* default */].updatePassword(this.form).then(function (res) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Cambio de password correcto',
					mensaje: 'Se ha actualizado tu contraseña correctamente'
				});

				_this.$store.dispatch('session/getSesion');
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var apiUsuario = 'core/php/api/perfil/';

var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiUsuario + url);
};

var post = function post(url, data) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiUsuario + url, data);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getUsuario: function getUsuario(idUsuario) {
		return get('get-perfil.php');
	},
	setUsuario: function setUsuario(datos) {
		var form = _.clone(datos);
		form.fecha_nacimiento = form.fecha_nacimiento ? Math.floor(datos.fecha_nacimiento.getTime() / 1000) : null;
		return post('set-perfil.php', form);
	},
	setOTP: function setOTP(datos) {
		return post('set-otp.php', datos);
	},
	changePassword: function changePassword(datos) {
		return post('set-password.php', datos);
	},
	updatePassword: function updatePassword(datos) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('core/php/api/sesion/cambiar-pass.php', datos);
	}
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['usuario'],
	data: function data() {
		return {
			password: '',
			strNow: new Date().getTime().toString()
		};
	},
	mounted: function mounted() {
		var _this = this;

		window.setTimeout(function () {
			_this.$refs.entraPass.focus();
		}, 300);
	},

	methods: {
		desbloquear: function desbloquear() {
			this.$store.dispatch('session/doDesbloquear', this.password);
			this.password = '';
		},
		logout: function logout() {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Cerrar sesión',
				mensaje: '\xBFQuieres cerrar la sesi\xF3n del usuario?\n\t\t\t\tTodo el trabajo que no tuviera guardado se perder\xE1',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.$store.dispatch('session/logout');
					}
				}
			});
		}
	}
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toast__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		toast: __WEBPACK_IMPORTED_MODULE_1__toast__["a" /* default */]
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		toasts: 'toast/toasts'
	}), {
		tops: function tops() {
			var tops = {};

			var alto = 60;

			for (var i = 0; i < this.toasts.length; i++) {
				var t = this.toasts[i];
				tops[t.id] = {
					top: alto + 'px'
				};

				if (this.$refs['toast-' + t.id]) {
					if (this.$refs['toast-' + t.id].length > 0) {
						alto = alto + this.$refs['toast-' + t.id][0].$el.offsetHeight + 10;
					}
				} else {
					alto = alto + 60;
				}
			}

			return tops;
		}
	})
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['t', 'top'],

	data: function data() {
		return {
			active: false,
			closed: false,
			timeout: null
		};
	},
	created: function created() {
		var _this = this;

		window.setTimeout(function () {
			_this.active = true;
		}, 100);

		if (this.t.timeout) {
			this.timeout = window.setTimeout(function () {
				if (!_this.closed) {
					_this.close(true);
				}
			}, this.t.timeout * 1000);
		}
	},

	watch: {
		t: function t(newVal, oldVal) {
			if (typeof newVal.active === 'boolean') {
				this.active = newVal.active;
			}
			if (typeof newVal.closed === 'boolean') {
				this.closed = newVal.closed;
			}
		}
	},
	computed: {
		estiloProgreso: function estiloProgreso() {
			if (this.t.type !== 'progress') {
				return {};
			}

			return {
				width: this.t.progress + '%',
				transition: 'width 500ms ease-in-out'
			};
		}
	},

	methods: {
		close: function close(auto) {
			var _this2 = this;

			auto = typeof auto !== 'boolean' ? false : auto;

			if (!this.t.closable && !auto) {
				return;
			}
			this.active = false;
			this.closed = true;

			window.clearTimeout(this.timeout);
			window.setTimeout(function () {
				_this2.$store.commit('toast/delete', _this2.t.id);
			}, 500);
		}
	}
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		menu: 'contextual/menu',
		activo: 'contextual/activo'
	})),
	created: function created() {
		this.$store.watch(function (a) {
			return a.contextual.activo;
		}, function (newValue, oldValue) {
			console.log('Cambia a: ' + newValue);
		});
	},

	methods: {
		clickItem: function clickItem(item) {
			if (!item.activo) {
				this.cerrar();
				return;
			}
			item.callback();
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$store.commit('contextual/cerrar');
		}
	}
});

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__update_update__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sidebar__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mi_perfil_mi_perfil__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__topbar_topbar__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gestion_jornada_vue_components_editor_fichar_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'principal',
	components: {
		'topbar': __WEBPACK_IMPORTED_MODULE_4__topbar_topbar__["a" /* default */],
		'sidebar': __WEBPACK_IMPORTED_MODULE_2__sidebar__["a" /* default */],
		'mi-perfil': __WEBPACK_IMPORTED_MODULE_3__mi_perfil_mi_perfil__["a" /* default */],
		'fichar': __WEBPACK_IMPORTED_MODULE_5__gestion_jornada_vue_components_editor_fichar_vue__["a" /* default */],
		Update: __WEBPACK_IMPORTED_MODULE_1__update_update__["a" /* default */]
	},

	watch: {
		'usuario': function usuario(newVal) {
			if (newVal === null) {
				this.ultimoAvisoFichar = null;
				window.clearInterval(this.intervaloFichar);
			}
		}
	},
	created: function created() {
		var _this = this;

		this.$router.beforeEach(function (to, from, next) {
			var nombre = to.name ? to.name : '';
			_this.setTitulo(nombre);
			_this.verMenu = false;
			next();
		});

		this.calculaDimensiones();

		this.setTitulo(this.$router.history.current.name);

		window.addEventListener('resize', function () {
			_this.calculaDimensiones();
		});

		this.intervaloFichar = window.setInterval(function () {
			_this.checkFichaje();
		}, 60000);
		this.checkFichaje();
	},
	data: function data() {
		return {
			verMenu: false,
			verPerfil: false,
			nombreSeccion: '',
			estiloMain: {
				position: 'relative',
				display: 'block'
			},
			fichando: null,
			ultimoAvisoFichar: null,
			mostrandoAvisoFichar: false,
			intervaloFichar: null
		};
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
		'usuario': 'session/usuario'
	})),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])({
		setTitulo: 'top/setTitulo'
	}), {
		checkFichaje: function checkFichaje() {
			var _this2 = this;

			if (!this.usuario || this.mostrandoAvisoFichar) {
				return;
			}

			if (!this.ultimoAvisoFichar || this.ultimoAvisoFichar && new Date().getTime() - this.ultimoAvisoFichar > 300000) {
				this.$http.get('gestion-jornada/php/api/checkFichajePendiente.php').then(function (res) {
					var datos = res.data;
					if (datos.ignorar) {
						_this2.mostrandoAvisoFichar = false;
						return;
					}
					if (datos.trabajando && !datos.haFichado) {
						_this2.ultimoAvisoFichar = new Date().getTime();
						_this2.$store.commit('alertas/confirm', {
							titulo: '¿Fichar entrada?',
							mensaje: 'Parece ser que no has fichado la entrada.\n\n¿Quieres hacerlo ahora?',
							buttons: [{
								titulo: 'Fichar ahora',
								clase: 'btn btn-sm btn-success',
								icono: 'fa fa-address-card',
								valor: true
							}, {
								titulo: 'Postponer 5 minutos',
								clase: 'btn btn-sm btn-warning',
								icono: 'fa fa-clock-o',
								valor: false
							}],
							callback: function callback(acepta) {
								if (acepta) {
									_this2.fichar();
								}
								_this2.mostrandoAvisoFichar = false;
							}
						});
						_this2.mostrandoAvisoFichar = true;
					} else if (!datos.trabajando && datos.haFichado) {
						_this2.ultimoAvisoFichar = new Date().getTime();
						_this2.$store.commit('alertas/confirm', {
							titulo: '¿Fichar salida?',
							mensaje: 'Parece ser que no has fichado la salida.\n\n¿Quieres hacerlo ahora?',
							buttons: [{
								titulo: 'Fichar ahora',
								clase: 'btn btn-sm btn-success',
								icono: 'fa fa-address-card',
								valor: true
							}, {
								titulo: 'Postponer 5 minutos',
								clase: 'btn btn-sm btn-warning',
								icono: 'fa fa-clock-o',
								valor: false
							}],
							callback: function callback(acepta) {
								if (acepta) {
									_this2.fichar();
								}
								_this2.mostrandoAvisoFichar = false;
							}
						});
						_this2.mostrandoAvisoFichar = true;
					}
				}).catch(function (e) {
					console.error(e);
				});
			}
		},
		calculaDimensiones: function calculaDimensiones() {
			// Calculamos las dimensiones del scope
			var altoVentana = window.innerHeight;
			var anchoVentana = window.innerWidth;

			var altoMain = altoVentana - 60;
			var anchoMain = anchoVentana > 1500 ? anchoVentana - 200 : anchoVentana > 1200 ? anchoVentana - 40 : anchoVentana;

			if (anchoVentana < 1200) {
				this.estiloMain = {
					position: 'absolute',
					display: 'block',
					left: anchoVentana - anchoMain + 'px',
					right: 0,
					top: 50 + 'px',
					height: altoMain + 'px',
					'overflow-y': 'auto'
				};
			} else {
				this.estiloMain = {
					position: 'absolute',
					display: 'block',
					marginLeft: anchoVentana - anchoMain + 'px',
					top: 50 + 'px',
					left: 0,
					height: altoMain + 'px',
					'overflow-y': 'auto'
				};
			}
		},
		fichar: function fichar() {
			this.fichando = true;
		},
		logout: function logout() {
			this.$store.dispatch('session/logout');
		}
	})
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_update_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d38ad890_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_update_vue__ = __webpack_require__(758);
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d38ad890"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_update_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d38ad890_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_update_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['version', 'actual', 'pospuesto'],
	data: function data() {
		return {
			mostrar: false,
			ocultar: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		window.setTimeout(function () {
			_this.mostrar = true;
		}, 300);
	},

	methods: {
		actualizar: function actualizar() {
			window.location.reload(true);
		},
		posponer: function posponer() {
			this.mostrar = false;
			this.ocultar = true;
			this.$emit('posponer');
		}
	}
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_item__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sidebar',
	components: {
		'menu-item': __WEBPACK_IMPORTED_MODULE_2__menu_item__["a" /* default */]
	},

	data: function data() {
		return {
			menuItems: [],
			timer: null
		};
	},

	created: function created() {
		var _this = this;

		// FIX: A veces hay que pedir el menú con ciertro retraso para que cargue
		window.setTimeout(function () {
			_this.getMenu();
		}, 300);

		this.timer = window.setInterval(function () {
			if (_this.usuario && _this.usuario.ID) {
				_this.getMenu();
			}
		}, 30000);

		this.$store.watch(function (a) {
			return a.session.activa;
		}, function (newValue, oldValue) {
			if (newValue && !oldValue) {
				_this.getMenu();
			}
		});

		this.$store.watch(function (a) {
			return a.session.bloqueado;
		}, function (newValue, oldValue) {
			if (!newValue && oldValue) {
				_this.getMenu();
			}
		});
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.timer);
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		externo: 'session/externo',
		ip: 'session/ip',
		permisos: 'permisos/permisos'
	})),

	methods: {
		getMenu: function getMenu() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('core/php/api/menu/get-menu.php').then(function (res) {
				_this2.menuItems = res.data.menu.items;
			}).catch(function (e) {
				if (e.message && e.message.code === 423) {
					return;
				}
				_this2.$store.commit('toast/danger', {
					titulo: 'Error consultando el menú',
					mensaje: e.response && e.response.data && e.response.data.error ? e.response.data.error : ''
				});
			});
		},
		logout: function logout() {
			var _this3 = this;

			this.$store.dispatch('session/logout');
			window.setTimeout(function () {
				_this3.$router.push('/login');
			}, 300);
		},
		verPerfil: function verPerfil() {
			this.$emit('verperfil');
		},
		lock: function lock() {
			this.$store.dispatch('session/lock');
		},
		fichar: function fichar() {
			this.$emit('fichar');
		}
	}
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cb3a3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_item_vue__ = __webpack_require__(762);
function injectStyle (ssrContext) {
  __webpack_require__(761)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25cb3a3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cb3a3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__menu_item__ = __webpack_require__(253);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'menu-item',

	data: function data() {
		return {
			activo: false
		};
	},
	components: {
		'menu-item': __WEBPACK_IMPORTED_MODULE_0__menu_item__["a" /* default */]
	},
	props: ['item'],
	computed: {
		mostrar: function mostrar() {
			if (this.item.tipo === 'categoria' && this.item.items.length === 0) {
				return false;
			}
			return true;
		}
	},
	methods: {
		clica: function clica(item) {
			if (item.path) {
				this.$router.push(item.path);
			} else if (item.items && item.items.length > 0) {
				this.activo = !this.activo;
			}
		}
	}
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiUsuario__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__crop_avatar__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'set-avatar': __WEBPACK_IMPORTED_MODULE_2__crop_avatar__["a" /* default */]
	},
	data: function data() {
		return {
			usu: {
				otps: false
			},
			pass: {
				passwordAnterior: '',
				passwordNueva1: '',
				passwordNueva2: ''
			},
			verificaToken: null,
			configOTPS: false,
			muestraBtnAvatar: false,
			nuevoAvatar: false
		};
	},
	created: function created() {
		var _this = this;

		// Obtenemos la información del usuario
		__WEBPACK_IMPORTED_MODULE_1__apiUsuario__["a" /* default */].getUsuario().then(function (res) {
			res.data.usuario.fecha_nacimiento = res.data.usuario.fecha_nacimiento ? new Date(res.data.usuario.fecha_nacimiento * 1000) : null;
			_this.usu = res.data.usuario;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		avatar: function avatar() {
			var sexo = this.usu.sexo ? this.usu.sexo : 'otro';
			return this.usu.avatar && !this.usu.avatar.match(/\.svg$/) ? this.usu.avatar : '/static/recursos/' + sexo + '.svg';
		}
	}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	})),
	methods: {
		setNuevoAvatar: function setNuevoAvatar(data) {
			this.usu.avatar = data;
		},
		guardarDatos: function guardarDatos() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1__apiUsuario__["a" /* default */].setUsuario(this.usu).then(function (res) {
				_this2.$store.commit('alertas/alert', {
					titulo: 'Datos guardados',
					mensaje: 'Se han guardado los cambios correctamente'
				});

				// Ahora actualizamos los datos de la sesión
				_this2.$store.dispatch('session/getSesion');
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		changePassword: function changePassword() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__apiUsuario__["a" /* default */].changePassword(this.pass).then(function (res) {
				_this3.$store.commit('alertas/alert', {
					titulo: 'Cambio correcto',
					mensaje: '\n\t\t\t\t\t\tSe ha actualizado tu contrase\xF1a correctamente.\n\n\t\t\t\t\t\tTe en cuenta que el resto de servicios, como el correo electr\xF3nico, el acceso a tu ordenador, la mensajer\xEDa interna (pidgin), etc., comparten esta contrase\xF1a, por lo que deber\xE1s actualizar los programas que acceden a estos servicios para que continuen funcionando.'
				});
				_this3.pass.passwordAnterior = '';
				_this3.pass.passwordNueva1 = '';
				_this3.pass.passwordNueva2 = '';
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		getOTPSecret: function getOTPSecret() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_1__apiUsuario__["a" /* default */].setOTP({ getSecret: true }).then(function (res) {
				_this4.usu.otps = null;
				_this4.configOTPS = res.data.uri;
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		verificarToken: function verificarToken() {
			var _this5 = this;

			__WEBPACK_IMPORTED_MODULE_1__apiUsuario__["a" /* default */].setOTP({ verificar: this.verificaToken }).then(function (res) {
				_this5.usu.otps = 'configurado';
				_this5.configOTPS = null;
				_this5.$store.commit('alertas/alert', {
					titulo: 'Correcto',
					mensaje: 'Has configurado correctamente tu doble factor de autenticación'
				});
			}).catch(function (e) {
				_this5.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'set-avatar',

	data: function data() {
		return {
			url: null
		};
	},

	methods: {
		setImg: function setImg(url) {
			this.url = url;
		},
		confirmar: function confirmar() {
			this.$emit('img', this.url);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notificaciones_listado__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__update_update__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		ListadoNotificaciones: __WEBPACK_IMPORTED_MODULE_2__notificaciones_listado__["a" /* default */],
		Update: __WEBPACK_IMPORTED_MODULE_3__update_update__["a" /* default */]
	},
	data: function data() {
		return {
			version: null,
			intervalo: null,
			estilo: {},
			dev: false,
			verNotificaciones: false,
			polling: false,
			ajax: null,
			nextUpdateCheck: new Date().getTime() - 2000,
			updatePospuesto: false
		};
	},
	created: function created() {
		if (window.webpackHotUpdate) {
			this.dev = true;
		}
		this.pollNotificaciones();
	},
	mounted: function mounted() {
		var _this = this;

		window.addEventListener('resize', this.calculaAncho);
		this.calculaAncho();
		this.intervalo = window.setInterval(function () {
			_this.getVersion();
		}, 60000);
		this.getVersion();
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('resize', this.calculaAncho);
		this.ajax.abort();
		this.polling = false;
		window.clearInterval(this.intervalo);
	},
	beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
		console.log(to);
		next();
	},

	watch: {
		titulo: function titulo() {
			var _this2 = this;

			window.setTimeout(function () {
				_this2.calculaAncho();
			}, 300);
		},
		menu: function menu() {
			var _this3 = this;

			window.setTimeout(function () {
				_this3.calculaAncho();
			}, 300);
		},
		iconos: function iconos() {
			var _this4 = this;

			window.setTimeout(function () {
				_this4.calculaAncho();
			}, 300);
		},
		notificacionesNuevas: function notificacionesNuevas(newVal, oldVal) {
			if (newVal.length > oldVal.length) {
				this.$refs.notificacion.play();
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		titulo: 'top/titulo',
		menu: 'top/menu',
		iconos: 'top/iconos',
		notificaciones: 'notificaciones/listado',
		notificacionesNuevas: 'notificaciones/nuevas'
	})),
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
		getNotificaciones: 'notificaciones/get'
	}), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
		addNotificaciones: 'notificaciones/ADD'
	}), {
		posponerUpdate: function posponerUpdate() {
			var _this5 = this;

			this.nextUpdateCheck = new Date().getTime() + 300000;
			window.setTimeout(function () {
				_this5.version = null;
				_this5.updatePospuesto = true;
			}, 1000);
		},
		pollNotificaciones: function pollNotificaciones() {
			var _this6 = this;

			if (!this.usuario || !this.usuario.ID || this.polling) {
				console.log('No hay usuario');
				return;
			}
			this.polling = true;
			var LastID = this.notificaciones.reduce(function (acc, noti) {
				if (acc === 0 || acc < noti.NotificacionID) {
					acc = noti.NotificacionID;
				}
				return acc;
			}, 0);
			this.ajax = new XMLHttpRequest();
			this.ajax.open('GET', 'src/modulos/core/php/api/notificaciones/polling_notificaciones.php?LastID=' + LastID, true);
			this.ajax.onreadystatechange = function () {
				if (_this6.ajax.readyState === 4) {
					if (_this6.ajax.status === 200) {
						_this6.polling = false;
						if (!_this6.usuario) {
							return;
						}
						var res = JSON.parse(_this6.ajax.responseText);
						res.forEach(function (noti) {
							_this6.addNotificaciones(noti);
						});
						_this6.pollNotificaciones();
					} else {
						window.setTimeout(function () {
							_this6.polling = false;
							_this6.pollNotificaciones();
						}, 30000);
					}
				}
			};
			this.ajax.send();
		},
		calculaAncho: function calculaAncho() {
			var ventana = window.outerWidth;
			var capaSide = this.$refs.sidetop.offsetWidth;
			// const nombre = this.$refs.capanombre.offsetWidth
			var iconos = this.$refs.capaiconos.offsetWidth;
			var ancho = ventana - iconos - capaSide;
			this.estilo = {
				width: ancho + 'px'
			};
			this.$forceUpdate();
		},
		toggleMenu: function toggleMenu() {
			this.$emit('togglemenu');
		},
		getVersion: function getVersion() {
			var _this7 = this;

			if (new Date().getTime() < this.nextUpdateCheck) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('core/php/api/version.php').then(function (res) {
				_this7.version = res.data;
			}).catch(function (e) {
				console.error(e);
			});
		},
		clickItem: function clickItem(item) {
			if (item.callback) {
				item.callback(item);
			}
		}
	})
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notificacion__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Notificacion: __WEBPACK_IMPORTED_MODULE_1__notificacion__["a" /* default */]
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		listadoNotificaciones: 'notificaciones/listado',
		nuevas: 'notificaciones/nuevas'
	})),
	watch: {
		listadoNotificaciones: function listadoNotificaciones() {
			var noLeidas = 0;
			for (var i = 0; i < this.listadoNotificaciones.length; i++) {
				if (!this.listadoNotificaciones[i].FechaMostrada) {
					noLeidas++;
				}
			}

			if (noLeidas) {
				this.setLeidas();
			}
		}
	},
	created: function created() {
		// this.setLeidas()
	},
	beforeDestroy: function beforeDestroy() {
		this.setLeidas();
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
		descartar: 'notificaciones/del',
		descartarTodas: 'notificaciones/delTodas',
		setLeidas: 'notificaciones/leidas'
	}), {
		eliminarTodas: function eliminarTodas() {
			var _this = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar todas las notificaciones',
				mensaje: '¿Quieres eliminar todas las notificaciones?',
				callback: function callback(acepta) {
					if (acepta) {
						_this.descartarTodas();
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	})
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['notificacion', 'index', 'total'],
	data: function data() {
		return {
			cerrando: false,
			estilo: {
				transform: 'translateY(' + this.index * 50 + 'px)'
			}
		};
	},

	watch: {
		index: function index(newVal) {
			this.estilo = {
				transform: 'translateY(' + this.index * 50 + 'px)'
			};
		}
	},
	computed: {
		clase: function clase() {
			if (!this.notificacion.FechaMostrada) {
				return 'nueva';
			}

			var dif = Math.floor(new Date().getTime() / 1000) - this.notificacion.FechaMostrada;

			if (dif < 5) {
				return 'nueva';
			}

			return '';
		}
	},
	methods: {
		descartar: function descartar(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			this.$emit('descartar', this.notificacion.NotificacionID);
		},
		go: function go() {
			if (!this.notificacion.URI) {
				return;
			}

			this.$router.push(this.notificacion.URI);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			fecha: this.$moment().format('YYYY-MM-DD'),
			hora: null,
			ip: null,
			externo: false,
			comentarios: null,
			ultimoRegistro: false,
			tipoJornada: 'Normal',
			UsuarioID: null,
			tiposJornadas: ['Normal', 'Extra', 'Libre', 'Nocturna'],
			latitud: null,
			longitud: null,
			map: null,
			marcador: null,
			tipoRegistro: null,
			ahora: this.$moment().format('HH:mm'),
			intervalo: null
		};
	},
	created: function created() {
		var _this = this;

		this.getIP(function () {
			if (!navigator.geolocation) {
				_this.$error('Error', 'Debes fichar en un navegador que soporte geolocalización');
				_this.cerrar();
			}

			// Detectamos pc o movil
			var check = false;
			// eslint-disable-next-line
			(function (a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);
			_this.tipoRegistro = check ? 'Móvil' : 'PC';
		});

		this.intervalo = window.setInterval(function () {
			_this.ahora = _this.$moment().format('HH:mm:ss');
		}, 200);
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.intervalo);
	},
	mounted: function mounted() {
		var _this2 = this;

		navigator.geolocation.getCurrentPosition(this.init.bind(this), function (err) {
			console.error('Error geolocalizando');
			console.error(err);
			// this.$error('Error', 'Es necesaria la geolocalización para efectuar el fichaje')
			// this.cerrar()
			_this2.$store.commit('toast/danger', {
				titulo: 'Geolocalización no disponible',
				mensaje: 'No es posible geolocalizar este dispositivo.'
			});
			_this2.externo = true;
			_this2.init();
		});
	},

	watch: {
		tipoMovimiento: function tipoMovimiento(newVal) {
			var _this3 = this;

			if (newVal && !this.map) {
				window.setTimeout(function () {
					_this3.initMap();
				}, 500);
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		tipoMovimiento: function tipoMovimiento() {
			if (this.ultimoRegistro === undefined || this.ultimoRegistro === false) {
				return false;
			}

			if (this.ultimoRegistro === null) {
				return 'Entrada';
			}

			if (!this.ultimoRegistro.FechaFinJornada) {
				return 'Salida';
			}

			return 'Entrada';
		},
		tiempoJornada: function tiempoJornada() {
			var exp = /^[0-9]{2}:[0-9]{2}$/;
			if (!exp.test(this.horaFin)) {
				return null;
			}
			var fechaEntrada = void 0;
			if (this.tipoRegistro === 'Salida') {
				// Calculamos
				fechaEntrada = new Date(this.ultimoRegistro.FechaInicioJornada * 1000);
			} else if (this.tipoRegistro !== 'Entrada') {
				fechaEntrada = new Date(this.fechaInicio.getTime());
			} else {
				return null;
			}

			var fechaSalida = new Date(this.fechaFin.getTime());
			var hora = this.horaFin.split(':');
			fechaSalida.setHours(parseInt(hora[0]));
			fechaSalida.setMinutes(parseInt(hora[1]));

			var dif = fechaSalida.getTime() - fechaEntrada.getTime();

			if (dif < 0) {
				return 0;
			}

			dif = Math.floor(dif / 1000);
			var horas = Math.floor(dif / 3600);
			dif = dif % 3600;
			var minutos = Math.floor(dif / 60);

			horas = horas < 10 ? '0' + horas : horas;
			minutos = minutos < 10 ? '0' + minutos : minutos;

			return horas + ':' + minutos;
		}
	}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	})),
	methods: {
		init: function init(pos) {
			if (this.externo && pos) {
				this.latitud = pos.coords.latitude;
				this.longitud = pos.coords.longitude;
			} else {
				this.latitud = 39.985061;
				this.longitud = -0.020440;
			}

			this.getUltimo();
		},
		initMap: function initMap() {
			if (!this.latitud || !this.longitud) {
				this.$store.commit('toast/danger', {
					titulo: 'Geolocalización no disponible',
					mensaje: 'No es posible geolocalizar este dispositivo.'
				});
				return;
			}
			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('mapaFichar'), {
				center: { lat: this.latitud, lng: this.longitud },
				zoom: 16
			});

			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				// eslint-disable-next-line
				position: new google.maps.LatLng(this.latitud, this.longitud),
				title: 'Tu posición',
				map: this.map
			});
		},
		getIP: function getIP(callback) {
			var _this4 = this;

			this.$http.get('core/php/api/sesion/get.php').then(function (res) {
				_this4.ip = res.data.ip;
				_this4.externo = res.data.externo;
				callback();
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Error obteniendo la IP'
				});
				_this4.cerrar();
			});
		},
		getUltimo: function getUltimo() {
			var _this5 = this;

			this.$http.get('gestion-jornada/php/api/getUltimo.php').then(function (res) {
				if (!res.data) {
					_this5.ultimoRegistro = null;
				} else {
					_this5.ultimoRegistro = res.data;
				}
			}).catch(function (e) {
				_this5.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		setAhora: function setAhora(ahora) {
			if (ahora) {
				this.hora = null;
			} else {
				this.hora = this.$moment().format('HH:mm');
			}
		},
		guardar: function guardar() {
			var _this6 = this;

			var datos = {};
			var exp = /^(Entrada|Salida)$/;
			if (!exp.test(this.tipoMovimiento)) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Tipo de registro no válido'
				});
				return;
			}

			datos.TipoMovimiento = this.tipoMovimiento;

			datos.Hora = this.hora;

			datos.UsuarioID = this.usuario.ID;
			datos.Comentarios = this.comentarios;

			datos.Latitud = this.latitud;
			datos.Longitud = this.longitud;
			datos.TipoRegistro = this.tipoRegistro;

			var url = 'gestion-jornada/php/api/fichar.php';
			this.$http.post(url, datos).then(function (res) {
				_this6.$store.commit('toast/success', {
					titulo: 'Registro guardado'
				});
				_this6.cerrar();
			}).catch(function (e) {
				_this6.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'input-query',
	props: ['input-class', 'url', 'realtime', 'placeholder', 'disabled', 'conservar'],
	data: function data() {
		return {
			cadena: '',
			resultados: [],
			preseleccionado: null,
			preseleccionadoIndex: null,
			seleccionado: null,
			estiloCaja: {}
		};
	},
	mounted: function mounted() {
		var inp = this.$refs.inp;
		var top = inp.offsetTop + inp.offsetHeight;
		var left = inp.offsetLeft;
		var width = inp.offsetWidth;

		this.estiloCaja = {
			top: top + 'px',
			left: left + 'px',
			width: width + 'px'
		};
	},

	methods: {
		calculaEstilo: function calculaEstilo() {
			var inp = this.$refs.inp;
			var top = inp.offsetTop + inp.offsetHeight;
			var left = inp.offsetLeft;
			var width = inp.offsetWidth;

			this.estiloCaja = {
				top: top + 'px',
				left: left + 'px',
				width: width + 'px'
			};
		},
		preseleccionar: function preseleccionar(i) {
			this.preseleccionado = this.resultados[i];
			this.preseleccionadoIndex = i;
			var el = this.$refs['resultado'][i];
			el.scrollIntoViewIfNeeded();
		},
		teclaPulsada: function teclaPulsada(ev) {
			ev.stopPropagation();
			ev.preventDefault();
			this.calculaEstilo();
			if (ev.keyCode === 40 || ev.keyCode === 38) {
				return;
			} else if (ev.keyCode === 27) {
				this.resultados = [];
				this.cadena = '';
				this.preseleccionado = null;
				this.preseleccionadoIndex = null;
				return;
			} else if (ev.keyCode === 13 && (this.preseleccionado !== null || this.resultados.length > 0)) {
				if (this.preseleccionado !== null) {
					this.seleccionar(this.preseleccionado);
				} else {
					this.seleccionar(this.resultados[0]);
				}
				return;
			}

			if (!this.cadena.trim()) {
				this.resultados = [];
				return;
			}
			this.preseleccionado = null;
			this.preseleccionadoIndex = null;
			if (this.realtime) {
				this.buscar();
			} else if (ev.keyCode === 13) {
				this.buscar();
			}
		},
		abajo: function abajo() {
			if (!this.preseleccionado) {
				this.preseleccionar(0);
				return;
			}

			var i = this.resultados.indexOf(this.preseleccionado);
			if (i === this.resultados.length - 1) {
				this.preseleccionar(0);
			} else {
				this.preseleccionar(i + 1);
			}
		},
		arriba: function arriba() {
			if (!this.preseleccionado) {
				this.preseleccionar(this.resultados.length - 1);
				return;
			}
			var i = this.resultados.indexOf(this.preseleccionado);

			if (i === 0) {
				this.preseleccionar(this.resultados.length - 1);
			} else {
				this.preseleccionar(i - 1);
			}
		},
		getClase: function getClase(resultado) {
			if (resultado === this.preseleccionado) {
				return 'result active';
			} else {
				return 'result';
			}
		},
		buscar: function buscar() {
			var _this = this;

			var amp = this.url.match(/\?/) ? '&' : '?';
			var datos = {
				q: this.cadena
			};
			this.$http.post(this.url + amp + 'q=' + this.cadena, datos).then(function (res) {
				_this.resultados = res.data.resultados;
			}).catch(function (e) {
				console.error(e);
			});
		},
		seleccionar: function seleccionar(valor) {
			this.$emit('selected', valor);
			this.seleccionado = valor;
			this.resultados = [];
			if (!this.conservar) {
				this.cadena = '';
			} else {
				this.cadena = valor.texto;
			}
		},
		focus: function focus() {
			var _this2 = this;

			window.setTimeout(function () {
				_this2.$refs['inp'].focus();
			}, 100);
		}
	}
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'input-query',
	props: ['input-class', 'url', 'realtime', 'placeholder', 'disabled', 'conservar'],
	data: function data() {
		return {
			cadena: '',
			resultados: [],
			preseleccionado: null,
			preseleccionadoIndex: null,
			seleccionado: null,
			estiloCaja: {}
		};
	},
	mounted: function mounted() {
		var inp = this.$refs.inp;
		var top = inp.offsetTop + inp.offsetHeight;
		var left = inp.offsetLeft;
		var width = inp.offsetWidth;

		this.estiloCaja = {
			top: top + 'px',
			left: left + 'px',
			width: width + 'px'
		};
	},

	methods: {
		calculaEstilo: function calculaEstilo() {
			var inp = this.$refs.inp;
			var top = inp.offsetTop + inp.offsetHeight;
			var left = inp.offsetLeft;
			var width = inp.offsetWidth;

			this.estiloCaja = {
				top: top + 'px',
				left: left + 'px',
				width: width + 'px'
			};
		},
		preseleccionar: function preseleccionar(i) {
			this.preseleccionado = this.resultados[i];
			this.preseleccionadoIndex = i;
			var el = this.$refs['resultado'][i];
			el.scrollIntoViewIfNeeded();
		},
		teclaPulsada: function teclaPulsada(ev) {
			ev.stopPropagation();
			ev.preventDefault();
			this.calculaEstilo();
			if (ev.keyCode === 40 || ev.keyCode === 38) {
				return;
			} else if (ev.keyCode === 27) {
				this.resultados = [];
				this.cadena = '';
				this.preseleccionado = null;
				this.preseleccionadoIndex = null;
				return;
			} else if (ev.keyCode === 13 && (this.preseleccionado !== null || this.resultados.length > 0)) {
				if (this.preseleccionado !== null) {
					this.seleccionar(this.preseleccionado);
				} else {
					this.seleccionar(this.resultados[0]);
				}
				return;
			}

			if (!this.cadena.trim()) {
				this.resultados = [];
				return;
			}
			this.preseleccionado = null;
			this.preseleccionadoIndex = null;
			if (this.realtime) {
				this.buscar();
			} else if (ev.keyCode === 13) {
				this.buscar();
			}
		},
		abajo: function abajo() {
			if (!this.preseleccionado) {
				this.preseleccionar(0);
				return;
			}

			var i = this.resultados.indexOf(this.preseleccionado);
			if (i === this.resultados.length - 1) {
				this.preseleccionar(0);
			} else {
				this.preseleccionar(i + 1);
			}
		},
		arriba: function arriba() {
			if (!this.preseleccionado) {
				this.preseleccionar(this.resultados.length - 1);
				return;
			}
			var i = this.resultados.indexOf(this.preseleccionado);

			if (i === 0) {
				this.preseleccionar(this.resultados.length - 1);
			} else {
				this.preseleccionar(i - 1);
			}
		},
		getClase: function getClase(resultado) {
			if (resultado === this.preseleccionado) {
				return 'result active';
			} else {
				return 'result';
			}
		},
		buscar: function buscar() {
			var _this = this;

			var datos = {
				q: this.cadena
			};
			this.$http.post('core/php/api/places/buscaEnGoogle.php?q=' + this.cadena, datos).then(function (res) {
				_this.resultados = res.data;
			}).catch(function (e) {
				console.error(e);
			});
		},
		seleccionar: function seleccionar(valor) {
			this.$emit('selected', valor);
			this.seleccionado = valor;
			this.resultados = [];
			if (!this.conservar) {
				this.cadena = '';
			} else {
				this.cadena = valor.texto;
			}
		},
		focus: function focus() {
			var _this2 = this;

			window.setTimeout(function () {
				_this2.$refs['inp'].focus();
			}, 100);
		}
	}
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['value', 'readonly'],
	data: function data() {
		return {
			UsuarioID: null,
			UsuarioNombre: null
		};
	},
	created: function created() {
		var _this = this;

		if (this.value) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('core/php/api/usuarios/get.php?UsuarioID=' + this.value).then(function (res) {
				_this.UsuarioID = res.data.ID;
				_this.UsuarioNombre = res.data.nombre + ' ' + res.data.apellidos;
			}).catch(function (e) {
				console.error(e);
			});
		}
	},

	methods: {
		seleccionaUsuario: function seleccionaUsuario(ev) {
			this.UsuarioID = ev.datos.ID;
			this.UsuarioNombre = ev.datos.nombre + ' ' + ev.datos.apellidos;
			this.$emit('input', ev.datos.ID);
		},
		quitar: function quitar() {
			this.$emit('input', null);
			this.UsuarioNombre = null;
			this.UsuarioID = null;
		}
	}
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_downloadjs__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			animate: true,
			animation: ''
		};
	},
	props: {
		'type': {
			type: String,
			default: "xls"
		},
		'button_text': {
			type: String,
			default: "Download Excel"
		},
		'data': {
			type: Array,
			required: true
		},
		'fields': {
			type: Object,
			required: true
		},
		'name': {
			type: String,
			default: "data.xls"
		},
		'meta': {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	created: function created() {},
	computed: {
		id_name: function id_name() {
			var now = new Date().getTime();
			return 'export_' + now;
		}
	},
	methods: {
		generate: function generate() {
			if (this.type == 'csv') {
				return this.exportCSV(this.data, this.name, this.fields);
			}
			return this.exportXLS(this.data, this.name, this.fields);
		},

		generate_excel: function generate_excel() {
			this.exportXLS(this.data, this.name, this.fields);
		},
		jsonToXLS: function jsonToXLS(data, header) {
			var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';

			var xlsData = '',
			    keys = [];
			if (header) {
				xlsData += '<thead>';
				for (var key in header) {
					keys.push(key);
					xlsData += '<th>' + key + '</th>';
				}
				xlsData += '</thead>';
				xlsData += '<tbody>';
				data.map(function (item, index) {
					xlsData += '<tr>';
					for (var i = 0; i < keys.length; i++) {
						if (keys[i].indexOf(".") !== -1) {
							var keyNestedSplit = keys[i].split(".");
							var valueFromNestedKey = item[keyNestedSplit[0]];

							for (var j = 1; j < keyNestedSplit.length; j++) {
								valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
							}

							xlsData += '<td>' + valueFromNestedKey + '</td>';
						} else {
							xlsData += '<td>' + item[keys[i]] + '</td>';
						}
					}
					xlsData += '</tr>';
				});
				xlsData += '</tbody>';
				return xlsTemp.replace('${table}', xlsData);
			}
			data.map(function (item, index) {
				xlsData += '<tbody><tr>';
				for (var key in item) {
					xlsData += '<td>' + item[key] + '</td>';
				}
				xlsData += '</tr></tbody>';
			});
			return xlsTemp.replace('${table}', xlsData);
		},
		jsonToCSV: function jsonToCSV(data, header) {
			var csvData = '';

			if (header) {
				for (var key in header) {
					csvData += key + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			}
			data.map(function (item) {
				for (var k in item) {
					var escapedCSV = item[k] + ''; // cast Numbers to string
					if (escapedCSV.match(/[,"\n]/)) {
						escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
					}
					csvData += escapedCSV + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			});
			return csvData;
		},
		base64: function base64(s) {
			return window.btoa(window.unescape(encodeURIComponent(s)));
		},
		exportXLS: function exportXLS(data, fileName, header) {
			var XLSData = 'data:application/vnd.ms-excel;base64,' + this.base64(this.jsonToXLS(data, header));
			this.download(XLSData, fileName, 'application/vnd.ms-excel');
		},
		exportCSV: function exportCSV(data, fileName, keys) {
			var CSVData = 'data:application/csv;base64,' + this.base64(this.jsonToCSV(data, keys));
			this.download(CSVData, fileName, 'application/csv');
		},
		base64ToBlob: function base64ToBlob(base64Data) {
			var arr = base64Data.split(',');
			var mime = arr[0].match(/:(.*?);/)[1];
			var bstr = atob(arr[1]);
			var n = bstr.length;
			var u8arr = new Uint8ClampedArray(n);

			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], { type: mime });
		},
		download: function download(base64data, fileName, fileType) {
			var blob = this.base64ToBlob(base64data);

			__WEBPACK_IMPORTED_MODULE_0_downloadjs___default()(blob, fileName, fileType);
		} //end download
	}
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['maxWidth', 'top'],
	computed: {
		ancho: function ancho() {
			if (!this.maxWidth) {
				return 'default';
			} else {
				return this.maxWidth + 'px';
			}
		},
		arriba: function arriba() {
			if (!this.top) {
				return 'default';
			} else {
				return this.top + 'px';
			}
		}
	}
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['menu', 'defecto'],
	methods: {
		irSeccion: function irSeccion(item) {
			if (item.url) {
				this.$router.push(item.url);
			} else if (item.callback) {
				item.callback(item);
			}
		}
	}
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(815);


/* harmony default export */ __webpack_exports__["a"] = ({
	extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bubble */],
	mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp, __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveData],
	props: ['data', 'options'],
	mounted: function mounted() {
		this.renderChart(this.data, this.options);
	}
});

/***/ }),
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: '404'
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['usuario', 'width', 'avatar'],
	data: function data() {
		return {
			ruta: null,
			timestamp: null,
			estilo: {
				width: '50px',
				height: '50px'
			}
		};
	},
	created: function created() {
		if (this.usuario) {
			this.timestamp = this.avatar ? this.avatar : new Date().getTime();
			this.ruta = '/src/modulos/core/php/api/perfil/avatar.php?avatar=avatar_' + this.usuario + '_' + this.timestamp;

			if (this.width) {
				this.estilo = {
					width: this.width + 'px',
					height: this.width + 'px'
				};
			}
		} else {
			this.ruta = '/static/recursos/otro.svg';
		}
	}
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['color', 'dobleCara', 'impresora'],
	data: function data() {
		return {
			impresion: {
				ImpresoraID: null,
				Color: false,
				DobleCara: false,
				Collate: false,
				Landscape: false,
				Copias: 1
			},
			impresoras: ['Comercial', 'Multifunción', 'Informativos']
		};
	},
	created: function created() {
		this.impresion.Color = this.color;
		this.impresion.DobleCara = this.dobleCara;
		// this.getImpresoras()
	},

	methods: {
		/* getImpresoras () {
  	axios.get('core/php/api/impresoras/get.php')
  		.then(res => {
  			this.impresoras = res.data
  				if (this.impresora) {
  				this.impresion.ImpresoraID = this.impresoras.reduce((ant, actual) => {
  					if (actual.Nombre === this.impresora) {
  						ant = actual.ImpresoraID
  					}
  					return ant
  				}, null)
  			}
  		})
  		.catch(this.$responseError)
  }, */
		imprimir: function imprimir() {
			this.$emit('imprimir', this.impresion);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			seccion: null
		};
	},
	created: function created() {
		// this.go('listados')
	},


	methods: {
		go: function go(seccion) {
			this.$router.push('/main/agenda-comercial/' + seccion);
			this.seccion = seccion;
		}
	}
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_editor__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'editor': __WEBPACK_IMPORTED_MODULE_2__editor_editor__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				usuario: '',
				cliente: '',
				fechaIni: new Date(new Date().getTime() - 604800000), // Fecha de inicio una semana antes
				fechaFin: null,
				estado: null,
				tipo: null,
				tipoContacto: null,
				objetivo: null
			},
			tiposContacto: [],
			objetivosContacto: [],
			listado: [],
			editar: null
		};
	},

	watch: {
		'$route.params.id': function $routeParamsId(newVal) {
			this.editar = newVal;
		}
	},
	created: function created() {
		var _this = this;

		this.buscar();

		var uri = '/agenda-comercial/php/api/';

		// Obtenemos el listado de tipos de contacto
		__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(uri + 'get-listado-tipos.php').then(function (res) {
			_this.tiposContacto = res.data;
		}).catch(this.apiError);
		// Obtenemos eli listado de objetivos
		__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(uri + 'get-listado-objetivos.php').then(function (res) {
			_this.objetivosContacto = res.data;
		}).catch(this.apiError);

		if (this.$route.params.id) {
			this.editar = this.$route.params.id;
		}
	},


	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
		'usuario': 'session/usuario',
		'permisos': 'permisos/permisos'
	}), {
		listadoEntradas: function listadoEntradas() {
			return this.listado.map(function (entrada) {
				entrada.estilo = {};
				entrada.clase = '';

				if (entrada.gestion === 1) {
					entrada.clase = '';
					entrada.estilo = {
						backgroundColor: '#fff716'
					};
				} else {
					if (entrada.cancelada) {
						entrada.clase = 'text-danger';
						entrada.estilo = {};
					} else if (entrada.fecha_fin_contacto < new Date().getTime() / 1000 && !entrada.fecha_cierre_informe) {
						entrada.clase = 'bg-warning';
						entrada.estilo = {};
					}
				}
				return entrada;
			});
		}
	}),
	methods: {
		nuevoRegistro: function nuevoRegistro() {
			this.$router.push('/main/agenda-comercial/listados/nuevo');
		},
		borraFechaIni: function borraFechaIni() {
			this.filtro.fechaIni = null;
			this.buscar();
		},
		borraFechaFin: function borraFechaFin() {
			this.filtro.fechaFin = null;
			this.buscar();
		},
		setTipo: function setTipo(tipo) {
			this.filtro.tipo = tipo;
			if (this.filtro.tipo === 'gestion') {
				this.filtro.tipoContacto = null;
				this.filtro.objetivo = null;
				this.filtro.estado = null;
				this.filtro.estado = null;
			}
		},
		buscar: function buscar() {
			var _this2 = this;

			var filtro = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));

			if (this.filtro.fechaIni) {
				this.filtro.fechaIni.setHours(0);
				this.filtro.fechaIni.setMinutes(0);
				this.filtro.fechaIni.setSeconds(0);
				this.filtro.fechaIni.setMilliseconds(0);
				filtro.fechaIni = this.filtro.fechaIni ? Math.round(this.filtro.fechaIni.getTime() / 1000) : null;
			}

			if (this.filtro.fechaFin) {
				this.filtro.fechaFin.setHours(23);
				this.filtro.fechaFin.setMinutes(59);
				this.filtro.fechaFin.setSeconds(59);
				this.filtro.fechaFin.setMilliseconds(999);
				filtro.fechaFin = this.filtro.fechaFin ? Math.round(this.filtro.fechaFin.getTime() / 1000) : null;
			}

			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('/agenda-comercial/php/api/busca-entradas.php', filtro).then(function (res) {
				_this2.listado = res.data.entradas;
			}).catch(this.$responseError);
		},
		editarEntrada: function editarEntrada(entrada) {
			this.$router.push('/main/agenda-comercial/listados/' + entrada.ID_entrada);
			// this.editar = entrada.ID_entrada
		}
	}
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(396);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3219fd90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(905);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3219fd90_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__propuestas_editor_propuestas__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cancelar__ = __webpack_require__(903);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var uri = '/agenda-comercial/php/api/';

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idRegistro', 'fecha', 'hora'],
	components: {
		'propuesta': __WEBPACK_IMPORTED_MODULE_4__propuestas_editor_propuestas__["a" /* default */],
		'cancelar-cita': __WEBPACK_IMPORTED_MODULE_5__cancelar__["a" /* default */]
	},
	data: function data() {
		return {
			verEditorPropuestas: false,
			copiarPropuesta: null,
			registro: null,
			listadoTipos: [],
			listadoObjetivos: [],
			detallePropuesta: null,
			cancelando: false
		};
	},
	created: function created() {
		var _this = this;

		if (this.idRegistro === 'nuevo') {
			this.nuevo();
		} else {
			this.getEntrada(this.idRegistro);
		}

		// Obtenemos el listado de tipos de contacto
		__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(uri + 'get-listado-tipos.php').then(function (res) {
			_this.listadoTipos = res.data;
		}).catch(this.apiError);
		// Obtenemos eli listado de objetivos
		__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(uri + 'get-listado-objetivos.php').then(function (res) {
			_this.listadoObjetivos = res.data;
		}).catch(this.apiError);
	},


	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		'permisos': 'permisos/permisos',
		'usuario': 'session/usuario'
	}), {
		horaIniValida: function horaIniValida() {
			if (!this.registro || !this.registro.horaIni || typeof this.registro.horaIni !== 'string') {
				return false;
			}

			if (!this.registro.horaIni.match(/^[0-9]{2}:[0-9]{2}$/)) {
				return false;
			}

			var hora = parseInt(this.registro.horaIni.split(':')[0]);
			var minutos = parseInt(this.registro.horaIni.split(':')[1]);

			if (hora > 23 || minutos > 59) {
				return false;
			}

			return true;
		},
		horaFinValida: function horaFinValida() {
			if (!this.horaIniValida) {
				return false;
			}
			if (!this.registro || !this.registro.horaFin || typeof this.registro.horaFin !== 'string') {
				return false;
			}

			if (!this.registro.horaFin.match(/^[0-9]{2}:[0-9]{2}$/)) {
				return false;
			}

			var hora = parseInt(this.registro.horaFin.split(':')[0]);
			var minutos = parseInt(this.registro.horaFin.split(':')[1]);

			if (hora > 23 || minutos > 59) {
				return false;
			}

			var horaIni = parseInt(this.registro.horaIni.split(':')[0]);
			var minutosIni = parseInt(this.registro.horaIni.split(':')[1]);

			if (hora < horaIni) {
				return false;
			}

			if (hora === horaIni && minutos <= minutosIni) {
				return false;
			}
			return true;
		},
		formValido: function formValido() {
			return this.registro && this.registro.usuario_ID && (this.registro.cliente_ID || this.registro.gestion === 1) && (this.registro.fecha_inicio_contacto || this.registro.fechaContacto) && this.horaIniValida && this.horaFinValida && (this.registro.gestion === 1 || this.registro.tipo_contacto_ID && this.registro.objetivo_contacto_ID) && this.registro.comentarios_previos;
		},
		accionesPropuestas: function accionesPropuestas() {
			for (var i = 0; i < this.registro.propuestas.length; i++) {
				var p = this.registro.propuestas[i];

				if (p.entrada_ID_presentada === this.registro.ID_entrada) {
					return true;
				}

				if (p.entrada_ID_asociada === this.registro.ID_entrada) {
					return true;
				}

				if (p.entrada_ID_decision === this.registro.ID_entrada) {
					return true;
				}

				return false;
			}
		},
		citaPasada: function citaPasada() {
			return new Date().getTime() >= new Date(this.registro.fecha_inicio_contacto * 1000).getTime();
		},
		editable: function editable() {
			// Si la cita está cancelada no se puede editar
			if (this.registro.cancelada) {
				return false;
			}

			if (this.usuario.ID !== this.registro.usuario_ID && !this.permisos.agenda_comercial_crear_todos) {
				return false;
			}

			// Si es una entrada nueva se puede editar
			if (this.registro.ID_entrada === null || this.registro.ID_entrada === 'nuevo') {
				return true;
			}

			// Si han pasado menos de 1 semana horas desde el registro de la cita
			var tiempo = 7 * 24 * 3600 * 1000;
			if (new Date().getTime() - new Date(this.registro.fecha_registro * 1000).getTime() > tiempo) {
				return false;
			}

			return true;
		}
	}),

	methods: {
		getEntrada: function getEntrada(idEntrada) {
			var _this2 = this;

			if (!idEntrada && this.registro.ID_entrada) {
				idEntrada = this.registro.ID_entrada;
			}

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/agenda-comercial/php/api/get-entrada.php?ID_entrada=' + idEntrada).then(function (res) {
				var reg = res.data.entrada;
				reg.fechaContacto = new Date(reg.fecha_inicio_contacto * 1000);
				reg.horaIni = _this2.$moment(reg.fechaContacto).format('HH:mm');
				reg.horaFin = _this2.$moment(reg.fecha_fin_contacto * 1000).format('HH:mm');
				_this2.registro = reg;
			}).catch(function (e) {
				_this2.$responseError(e);
				_this2.cerrar();
			});
		},
		nuevo: function nuevo() {
			var agenteID = !this.permisos['agenda_comercial_crear_todos'] ? this.usuario.ID : null;
			var infoAgente = !this.permisos['agenda_comercial_crear_todos'] ? this.usuario.nombre + ' ' + this.usuario.apellidos : null;

			this.registro = {
				ID_entrada: null,
				gestion: 0,
				usuario_ID: agenteID,
				usuarioNombre: infoAgente,
				cliente_ID: null,
				infoCliente: null,
				fechaContacto: this.fecha ? new Date(this.fecha.getTime()) : new Date(),
				horaIni: this.hora ? this.$moment(this.hora).format('HH:mm') : '',
				horaFin: this.hora ? this.$moment(this.hora.getTime() + 3600000).format('HH:mm') : '',
				tipo_contacto_ID: null,
				objetivo_contacto_ID: null,
				comentarios_previos: '',
				comentarios_finales: '',
				propuestas: []
			};
		},
		citaCancelada: function citaCancelada() {
			this.cancelando = false;
			this.getEntrada();
		},
		seleccionaAgente: function seleccionaAgente(ev) {
			var nombre = ev.datos.nombre;
			var apellidos = typeof ev.datos.apellidos === 'string' ? ev.datos.apellidos : '';
			this.registro.usuario_ID = ev.datos.ID;
			this.registro.usuarioNombre = nombre + ' ' + apellidos;
			this.registro.usuarioAvatar = ev.datos.avatar;
			this.registro.cliente_ID = null;
			this.registro.infoCliente = null;
			if (this.registro.gestion === 0) {
				this.$refs['inpCliente'].focus();
			}
		},
		quitarAgente: function quitarAgente() {
			this.registro.usuario_ID = null;
			this.registro.usuarioNombre = null;
			this.registro.usuarioAvatar = null;
			this.registro.cliente_ID = null;
			this.registro.infoCliente = null;
		},
		seleccionaCliente: function seleccionaCliente(ev) {
			this.registro.cliente_ID = ev.datos.ID;
			this.registro.clienteNombre = ev.datos.cliente;
			this.$forceUpdate();
		},
		quitarCliente: function quitarCliente() {
			this.registro.cliente_ID = null;
			this.registro.infoCliente = null;
		},
		asignaPropuesta: function asignaPropuesta(datos) {
			var _this3 = this;

			if (datos.entrada_ID_asociada) {
				this.verEditorPropuestas = true;
				this.copiarPropuesta = datos.ID_propuesta;
				return;
			}

			var asigna = {
				entrada_ID: this.registro.ID_entrada,
				propuesta_ID: datos.ID_propuesta
			};

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/agenda-comercial/php/api/asigna-propuesta-entrada.php', asigna).then(function () {
				_this3.getEntrada(_this3.registro.ID_entrada);
				_this3.copiarPropuesta = null;
				_this3.$store.commit('toast/success', {
					titulo: 'Propuesta asignada',
					mensaje: 'Se ha asignado la propuesta correctamente'
				});
			}).catch(this.apiError.bind(this));
		},
		desasignaPropuesta: function desasignaPropuesta(idPropuesta) {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Desasignar propuesta',
				mensaje: '¿Quieres desasignar esta propuesta de esta entrada?',
				callback: function callback(acepta) {
					if (acepta) {
						var asigna = {
							propuesta_ID: idPropuesta
						};

						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/agenda-comercial/php/api/desasigna-propuesta-entrada.php', asigna).then(function () {
							_this4.getEntrada(_this4.registro.ID_entrada);
							_this4.$store.commit('toast/info', {
								titulo: 'Propuesta desasignada',
								mensaje: 'Se ha desasignado la propuesta correctamente'
							});
						}).catch(_this4.apiError.bind(_this4));
					}
				}
			});
		},
		setPresentada: function setPresentada(idPropuesta) {
			var _this5 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Marcar como presentada',
				mensaje: '\xBFQuieres marcar la propuesta como presentada en esta visita?\n\t\t\t\tEsta acci\xF3n no se puede revertir.',
				callback: function callback(acepta) {
					if (acepta) {
						var datos = {
							entrada_ID: _this5.registro.ID_entrada,
							propuesta_ID: idPropuesta
						};

						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/agenda-comercial/php/api/set-propuesta-presentada.php', datos).then(function (res) {
							_this5.getEntrada(_this5.registro.ID_entrada);
							_this5.$store.commit('toast/success', {
								titulo: 'Propuesta presentada',
								mensaje: 'La propuesta se ha marcado como presentada'
							});
						}).catch(_this5.apiError.bind(_this5));
					}
				}
			});
		},
		setDecision: function setDecision(idPropuesta, decision) {
			var _this6 = this;

			var mensaje = decision === 'aprobada' ? 'aprobar' : 'rechazar';

			this.$store.commit('alertas/confirm', {
				titulo: mensaje.toUpperCase(),
				mensaje: '\xBFQuieres ' + mensaje + ' esta propuesta?',
				callback: function callback(acepta) {
					if (acepta) {
						var datos = {
							propuesta_ID: idPropuesta,
							decision: decision,
							entrada_ID: _this6.registro.ID_entrada
						};

						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/agenda-comercial/php/api/set-propuesta-decision.php', datos).then(function () {
							_this6.getEntrada(_this6.registro.ID_entrada);
							_this6.$store.commit('toast/success', {
								titulo: 'Propuesta finalizada',
								mensaje: 'Se ha marcado la propuesta como ' + decision
							});
						}).catch(_this6.apiError.bind(_this6));
					}
				}
			});
		},
		apiError: function apiError(e) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		},
		guardar: function guardar() {
			var _this7 = this;

			var objeto = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.registro));
			var fechaContacto = this.$moment(this.registro.fechaContacto).format('D-M-YYYY');
			objeto.fechaContacto = fechaContacto;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/agenda-comercial/php/api/set-entrada.php', objeto).then(function (res) {
				_this7.getEntrada(res.data.entrada.ID_entrada);
				_this7.$emit('saved', res.data.entrada.ID_entrada);

				_this7.$store.commit('toast/success', {
					titulo: 'Entrada guardada',
					mensaje: 'Se ha guardado la entrada correctamente'
				});
			}).catch(this.apiError);
		},
		eliminar: function eliminar() {
			var _this8 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar entrada',
				mensaje: '\xBFQuieres eliminar esta entrada?\n\t\t\t\tEsta acci\xF3n no se podr\xE1 deshacer',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/agenda-comercial/php/api/del-entrada.php?ID_entrada=' + _this8.registro.ID_entrada).then(function () {
							_this8.$store.commit('toast/success', {
								titulo: 'Entrada eliminada'
							});
							_this8.$emit('saved', _this8.registro.ID_entrada);
							_this8.cerrar();
						}).catch(_this8.$responseError);
					}
				}
			});
		},
		finalizar: function finalizar() {
			var _this9 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Finalizar informe',
				mensaje: 'Est\xE1s a punto de finalizar este informe.\n\t\t\t\tUna vez aceptes ya no podr\xE1s hacer modificaciones de ning\xFAn tipo.\n\t\t\t\tPor favor revisa bien tus comentarios y los estados de las propuestas antes de continuar.',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/agenda-comercial/php/api/set-finalizar-entrada.php', _this9.registro).then(function () {
							_this9.getEntrada(_this9.registro.ID_entrada);

							_this9.$store.commit('toast/success', {
								titulo: 'Finalizada',
								mensaje: 'Esta entrada ha quedado finalizada'
							});
						}).catch(function (e) {
							_this9.$store.commit('toast/danger', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_propuestas_vue__ = __webpack_require__(398);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af2fb65_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_propuestas_vue__ = __webpack_require__(902);
function injectStyle (ssrContext) {
  __webpack_require__(901)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5af2fb65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_propuestas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5af2fb65_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_propuestas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idCliente', 'idAgente', 'idPropuesta', 'copiar'],
	data: function data() {
		return {
			indice: 0,
			propuesta: {
				ID_propuesta: null,
				empresa_ID: null,
				cliente_ID: null,
				clienteInfo: null,
				usuario_ID: null,
				usuarioInfo: null,
				titulo: null,
				descripcion: null,
				descuento: 0,
				fecha_presentada: null,
				lineas: []
			},
			listadoEmpresas: []
		};
	},
	created: function created() {
		var _this = this;

		// Obtenemos el listado de empresas
		__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/agenda-comercial/php/api/get-listado-empresas.php').then(function (res) {
			_this.listadoEmpresas = res.data;
		}).catch(function (e) {
			_this.$store.commit('totast/danger', {
				titulo: 'Error',
				mensaje: 'Error obteniendo el listado de empresas'
			});
		});

		if (this.copiar) {
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/agenda-comercial/php/api/get-propuesta.php?ID_propuesta=' + this.copiar).then(function (res) {
				_this.propuesta = res.data.propuesta;
				_this.propuesta.fecha_presentada = null;
				_this.propuesta.ID_propuesta = null;

				if (typeof _this.idCliente === 'number') {
					_this.propuesta.cliente_ID = _this.idCliente + 0;

					// Ahora buscamos la información del cliente
					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/agenda-comercial/php/api/get-cliente.php?ID_cliente=' + _this.idCliente).then(function (res) {
						_this.propuesta.clienteInfo = res.data.cliente.cliente;
					}).catch(function (e) {
						_this.propuesta.clienteInfo = 'Cliente no encontrado';
					});
				}

				if (typeof _this.idAgente === 'number') {
					_this.propuesta.usuario_ID = _this.idAgente + 0;

					__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/agenda-comercial/php/api/get-agente.php?ID_agente=' + _this.idAgente).then(function (res) {
						_this.propuesta.usuarioInfo = res.data.agente.nombre + ' ' + res.data.agente.apellidos;
					}).catch(function (e) {
						_this.propuesta.usuarioInfo = 'Agente no encontrado';
					});
				}
			}).catch(this.$responseError);
			return;
		}

		if (this.idPropuesta && this.idPropuesta !== 'nueva') {
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/agenda-comercial/php/api/get-propuesta.php?ID_propuesta=' + this.idPropuesta).then(function (res) {
				_this.propuesta = res.data.propuesta;
			}).catch(this.$responseError);
			return;
		}

		if (typeof this.idCliente === 'number') {
			this.propuesta.cliente_ID = this.idCliente + 0;

			// Ahora buscamos la información del cliente
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/agenda-comercial/php/api/get-cliente.php?ID_cliente=' + this.idCliente).then(function (res) {
				_this.propuesta.clienteInfo = res.data.cliente.cliente;
			}).catch(function (e) {
				_this.propuesta.clienteInfo = 'Cliente no encontrado';
			});
		}

		if (typeof this.idAgente === 'number') {
			this.propuesta.usuario_ID = this.idAgente + 0;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/agenda-comercial/php/api/get-agente.php?ID_agente=' + this.idAgente).then(function (res) {
				_this.propuesta.usuarioInfo = res.data.agente.nombre + ' ' + res.data.agente.apellidos;
			}).catch(function (e) {
				_this.propuesta.usuarioInfo = 'Agente no encontrado';
			});
		}
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		'usuario': 'session/usuario',
		'permisos': 'permisos/permisos'
	}), {
		formValido: function formValido() {
			if (!this.propuesta.usuario_ID) {
				return false;
			}

			if (!this.propuesta.empresa_ID) {
				return false;
			}

			if (!this.propuesta.cliente_ID) {
				return false;
			}

			if (!this.propuesta.titulo) {
				return false;
			}

			if (this.propuesta.lineas.length === 0) {
				return false;
			}

			return true;
		},
		totalPropuesta: function totalPropuesta() {
			return this.propuesta.importe;
			// let importe = 0

			// for (let i = 0; i < this.propuesta.lineas.length; i++) {
			// 	importe = importe + (this.propuesta.lineas[i].importe * (100 - this.propuesta.lineas[i].descuento) / 100)
			// }

			// return importe
		},
		editable: function editable() {
			// TODO: En el futuro las propeustas no serán editables una vez se hayan presentado
			return this.propuesta.fecha_presentada === null;
		}
	}),
	methods: {
		nuevaLinea: function nuevaLinea() {
			this.propuesta.lineas.push({
				ID_linea: 'nueva' + ++this.indice,
				tarifa_ID: null,
				empresa_ID: null,
				tipo: 'tarifa',
				concepto: '',
				cantidad: 1,
				descuento: 0,
				precio_unitario: 0,
				forzado: null,
				importe: 0
			});
		},
		quitarLinea: function quitarLinea(ID) {
			for (var i = 0; i < this.propuesta.lineas.length; i++) {
				if (this.propuesta.lineas[i].ID_linea === ID) {
					this.propuesta.lineas.splice(i, 1);
				}
			}
		},
		ponAgente: function ponAgente(ev) {
			this.propuesta.usuario_ID = ev.datos.ID;
			this.propuesta.usuarioInfo = ev.datos.nombre + ' ' + ev.datos.apellidos;
		},
		quitarAgente: function quitarAgente() {
			this.propuesta.usuario_ID = null;
			this.propuesta.cliente_ID = null;
			this.propuesta.usuarioInfo = null;
			this.propuesta.clienteInfo = null;
		},
		ponCliente: function ponCliente(ev) {
			this.propuesta.cliente_ID = ev.datos.ID;
			this.propuesta.clienteInfo = ev.datos.cliente;
		},
		quitarCliente: function quitarCliente() {
			this.propuesta.cliente_ID = null;
			this.propuesta.clienteInfo = null;
		},
		setTipo: function setTipo(linea, tipo) {
			linea.tipo = tipo;
			linea.concepto = null;
			linea.tarifa_ID = null;
			linea.precio_unitario = null;
		},
		seleccionaTarifa: function seleccionaTarifa(linea, ev) {
			linea.tarifa_ID = ev.datos.ID_tarifa;
			linea.precio_unitario = parseFloat(ev.datos.precio);
			linea.concepto = ev.datos.titulo;
		},
		quitarTarifa: function quitarTarifa(linea) {
			linea.tarifa_ID = null;
			linea.importe = 0;
			linea.forzado = null;
			linea.descuento = null;
			linea.concepto = null;
			linea.tarifa_ID = null;
			linea.precio_unitario = null;
		},
		getTotal: function getTotal(linea) {
			var importe = 0;
			if (typeof linea.forzado === 'number' && linea.forzado !== 0) {
				importe = linea.forzado + 0;

				// Calculamos el descuento
				var descuento = 100 - linea.forzado * 100 / (linea.precio_unitario * linea.cantidad);
				linea.descuento = descuento + 0;
			} else {
				var pUnitario = void 0,
				    cantidad = void 0,
				    _descuento = void 0;

				try {
					pUnitario = typeof linea.precio_unitario === 'number' ? linea.precio_unitario : 0;
					cantidad = typeof linea.cantidad === 'number' ? linea.cantidad : 0;
					_descuento = typeof linea.descuento === 'number' ? linea.descuento : 0;
				} catch (e) {
					return 0;
				}

				importe = pUnitario * cantidad;

				if (_descuento !== 0) {
					importe = importe - importe * _descuento / 100;
				}
			}

			if (typeof this.propuesta.descuento === 'number') {
				importe = importe - importe * this.propuesta.descuento / 100;
			}

			linea.importe = importe;
			return importe;
		},
		guardar: function guardar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/agenda-comercial/php/api/set-propuesta.php', this.propuesta).then(function (res) {
				_this2.$emit('saved', res.data.propuesta);
				_this2.cerrar();

				_this2.$store.commit('toast/success', {
					titulo: 'Propuesta guardada',
					mensaje: 'Se ha guardado la propuesta correctamente'
				});
			}).catch(this.$responseError);
		},
		descargar: function descargar() {
			var _this3 = this;

			if (this.propuesta.impresa || !this.editable) {
				this.$refs.linkDescarga.click();
			} else {
				this.$store.commit('alertas/confirm', {
					titulo: 'Descargar propuesta',
					mensaje: 'Est\xE1s a punto de exportar esta propuesta.\n\t\t\t\t\tUna vez contin\xFAes, ya no podr\xE1s editarla de nuevo. Si quieres modificarla, tendr\xE1s que crear una nueva.\n\t\t\t\t\t\xBFQuieres continuar?',
					callback: function callback(acepta) {
						if (acepta) {
							_this3.$refs.linkDescarga.click();
						}
					}
				});
			}
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idEntrada'],
	data: function data() {
		return {
			form: {
				quien_cancela: 'cliente',
				motivos_cancelacion: ''
			}
		};
	},


	methods: {
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		setQuien: function setQuien(quien) {
			this.form.quien_cancela = quien;
		},
		cancelar: function cancelar() {
			var _this = this;

			var datos = {
				quien_cancela: this.form.quien_cancela,
				motivos_cancelacion: this.form.motivos_cancelacion,
				ID_entrada: this.idEntrada
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/agenda-comercial/php/api/set-entrada-cancelada.php', datos).then(function () {
				_this.$emit('cancelada');
				_this.$store.commit('toast/success', {
					titulo: 'Cita cancelada',
					mensaje: 'Se ha marcado la cita como cancelada'
				});
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mes__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semana__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editor_editor__ = __webpack_require__(395);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'vista-mes': __WEBPACK_IMPORTED_MODULE_1__mes__["a" /* default */],
		'vista-semana': __WEBPACK_IMPORTED_MODULE_2__semana__["a" /* default */],
		'editor-entradas': __WEBPACK_IMPORTED_MODULE_5__editor_editor__["a" /* default */]
	},
	data: function data() {
		return {
			vista: 'semana',
			meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
			fecha: new Date(),
			filtro: {
				fechaIni: null,
				fechaFin: null,
				usuario_ID: null
			},
			usuarioNombre: null,
			listaEntradas: [],
			editor: {
				ID_entrada: null,
				fecha: null,
				hora: null
			}
		};
	},
	created: function created() {
		this.getEventos();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		'permisos': 'permisos/permisos',
		'usuario': 'session/usuario'
	}), {
		fechaInicioMes: function fechaInicioMes() {
			var fecha = new Date(this.fecha.getTime());
			fecha.setDate(1);
			fecha.setHours(0);
			fecha.setMinutes(0);
			fecha.setSeconds(0);
			return fecha;
		},
		fechaFinMes: function fechaFinMes() {
			var fecha = new Date(this.fecha.getTime());
			fecha.setDate(1);
			fecha.setHours(0);
			fecha.setMinutes(0);
			fecha.setSeconds(0);
			fecha.setMonth(fecha.getMonth() + 1);
			fecha.setDate(fecha.getDate() - 1);
			return fecha;
		},
		fechaInicioSemana: function fechaInicioSemana() {
			if (this.dias === 1) {
				return new Date(this.fecha.getTime());
			}

			var ahora = this.fecha;
			var offset = ahora.getDay() === 0 ? 6 : ahora.getDay() - 1;

			var fecha = new Date(ahora.getTime());
			fecha.setDate(fecha.getDate() - offset);
			fecha.setHours(0);
			fecha.setMinutes(0);
			fecha.setSeconds(0);
			return fecha;
		},
		fechaFinSemana: function fechaFinSemana() {
			var ahora = this.fecha;
			var offset = ahora.getDay() === 0 ? 0 : 7 - ahora.getDay();

			var fecha = new Date(ahora.getTime());
			fecha.setDate(fecha.getDate() + offset);
			fecha.setHours(23);
			fecha.setMinutes(59);
			fecha.setSeconds(59);
			return fecha;
		},
		fechaInicioDia: function fechaInicioDia() {
			var fecha = new Date(this.fecha.getTime());
			fecha.setHours(0);
			fecha.setMinutes(0);
			fecha.setSeconds(0);
			return fecha;
		},
		fechaFinDia: function fechaFinDia() {
			var fecha = new Date(this.fecha.getTime());
			fecha.setHours(23);
			fecha.setMinutes(59);
			fecha.setSeconds(59);
			return fecha;
		},
		entradas: function entradas() {
			var arr = [];

			for (var i = 0; i < this.listaEntradas.length; i++) {
				this.listaEntradas[i].fechaIni = new Date(this.listaEntradas[i].fecha_inicio_contacto * 1000);
				this.listaEntradas[i].fechaFin = new Date(this.listaEntradas[i].fecha_fin_contacto * 1000);
				this.listaEntradas[i].bgColor = !this.listaEntradas[i].bgColor ? 'darkred' : this.listaEntradas[i].bgColor;
				this.listaEntradas[i].textColor = !this.listaEntradas[i].textColor ? 'white' : this.listaEntradas[i].textColor;
				if (!this.listaEntradas[i].cancelada) {
					arr.push(this.listaEntradas[i]);
				}
			}

			return arr;
		}
	}),
	methods: {
		setVista: function setVista(vista) {
			this.fecha = new Date();
			this.vista = vista;
			this.getEventos();
		},
		getEventos: function getEventos() {
			var _this = this;

			if (this.vista === 'mes') {
				this.filtro.fechaIni = this.fechaInicioMes;
				this.filtro.fechaFin = this.fechaFinMes;
			} else if (this.vista === 'semana') {
				this.filtro.fechaIni = this.fechaInicioSemana;
				this.filtro.fechaFin = this.fechaFinSemana;
			} else if (this.vista === 'dia') {
				this.filtro.fechaIni = this.fechaInicioDia;
				this.filtro.fechaFin = this.fechaFinDia;
			} else {
				return;
			}

			this.filtro.fechaIni = Math.round(this.filtro.fechaIni.getTime() / 1000);
			this.filtro.fechaFin = Math.round(this.filtro.fechaFin.getTime() / 1000);
			__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/agenda-comercial/php/api/busca-entradas.php', this.filtro).then(function (res) {
				_this.listaEntradas = res.data.entradas;
			}).catch(this.$responseError);
		},
		abreEditor: function abreEditor(datos) {
			this.editor = datos;
		},
		cerrarEditor: function cerrarEditor() {
			this.editor = {
				ID_entrada: null,
				fecha: null,
				hora: null
			};
		},
		siguiente: function siguiente() {
			if (this.vista === 'mes') {
				this.fecha.setMonth(this.fecha.getMonth() + 1);
				this.fecha = new Date(this.fecha.getTime());
			} else if (this.vista === 'semana') {
				this.fecha.setDate(this.fecha.getDate() + 7);
				this.fecha = new Date(this.fecha.getTime());
			} else if (this.vista === 'dia') {
				this.fecha.setDate(this.fecha.getDate() + 1);
				this.fecha = new Date(this.fecha.getTime());
			}
			this.getEventos();
			this.$forceUpdate();
		},
		anterior: function anterior() {
			if (this.vista === 'mes') {
				this.fecha.setMonth(this.fecha.getMonth() - 1);
				this.fecha = new Date(this.fecha.getTime());
			} else if (this.vista === 'semana') {
				this.fecha.setDate(this.fecha.getDate() - 7);
				this.fecha = new Date(this.fecha.getTime());
			} else if (this.vista === 'dia') {
				this.fecha.setDate(this.fecha.getDate() - 1);
				this.fecha = new Date(this.fecha.getTime());
			}
			this.getEventos();
			this.$forceUpdate();
		},
		verDia: function verDia(fecha) {
			this.fecha = new Date(fecha.getTime());
			this.vista = 'dia';
		},
		verSemana: function verSemana(fecha) {
			this.fecha = new Date(fecha.getTime());
			this.vista = 'semana';
		},
		seleccionaUsuario: function seleccionaUsuario(ev) {
			this.filtro.usuario_ID = ev.datos.ID;
			this.usuarioNombre = ev.texto;
			this.getEventos();
		},
		quitaUsuario: function quitaUsuario() {
			this.filtro.usuario_ID = null;
			this.usuarioNombre = null;
			this.getEventos();
		}
	}
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['fecha', 'entradas'],
	data: function data() {
		return {
			diasSemana: ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom']
		};
	},


	computed: {
		fechaInicioMes: function fechaInicioMes() {
			var fecha = new Date(this.fecha.getTime());
			fecha.setDate(1);
			fecha.setHours(0);
			fecha.setMinutes(0);
			fecha.setSeconds(0);
			fecha.setMilliseconds(0);
			return fecha;
		},
		getSemanas: function getSemanas() {
			// Calculamos el día de la semana en el que empieza el mes
			this.fecha.setDate(1);
			var inicioMes = this.fecha.getDay() > 0 ? this.fecha.getDay() - 1 : 6;

			// offset de días del mes anterios
			var anteriores = inicioMes;

			// Iremos construyendo las semanas una a una
			var semanas = [];

			// La primera semana contendrá (si es necesario) los días del mes anterior
			var mesSiguiente = new Date(this.fecha.getTime());
			mesSiguiente.setMonth(mesSiguiente.getMonth() + 1);
			var fecha = new Date(this.fecha.getTime());
			fecha.setDate(1);
			fecha.setHours(0);
			fecha.setMinutes(0);
			fecha.setMilliseconds(0);

			if (anteriores > 0) {
				fecha.setDate(fecha.getDate() - anteriores);
			}

			while (fecha.getMonth() !== mesSiguiente.getMonth()) {
				var semana = {
					numero: this.$moment(fecha).isoWeek(),
					dias: []
				};
				for (var d = 0; d < 7; d++) {
					var nuevoDia = {
						dia: new Date(fecha.getTime()),
						eventos: []
					};
					var inicioDia = new Date(nuevoDia.dia.getTime());
					inicioDia.setHours(0);
					inicioDia.setMinutes(0);
					inicioDia.setSeconds(0);
					inicioDia.setMilliseconds(0);

					var finDia = new Date(nuevoDia.dia.getTime());
					finDia.setHours(23);
					finDia.setMinutes(59);
					finDia.setSeconds(59);
					finDia.setMilliseconds(999);

					var diaStr = nuevoDia.dia.getFullYear() + '' + nuevoDia.dia.getMonth() + '' + nuevoDia.dia.getDate();

					// Extraemos los eventos
					for (var i = 0; i < this.entradas.length; i++) {
						var ev = this.entradas[i];
						// Calculamos si el evento está dentro de este día
						var fechaIni = this.entradas[i].fechaIni;
						var diaIni = fechaIni.getFullYear() + '' + fechaIni.getMonth() + '' + fechaIni.getDate();
						var fechaFin = this.entradas[i].fechaFin;
						var diaFin = fechaFin.getFullYear() + '' + fechaFin.getMonth() + '' + fechaFin.getDate();

						// El evento está en el mismo día
						if (diaStr === diaIni) {
							nuevoDia.eventos.push(ev);
						} else if (inicioDia > fechaIni && finDia < fechaFin) {
							nuevoDia.eventos.push(ev);
						} else if (diaStr === diaFin) {
							nuevoDia.eventos.push(ev);
						}
					}

					semana.dias.push(nuevoDia);

					fecha.setDate(fecha.getDate() + 1);
				}

				semanas.push(semana);
			}

			return semanas;
		}
	},

	methods: {
		verEntrada: function verEntrada(entrada) {
			this.$emit('editar', {
				ID_entrada: entrada.ID_entrada,
				fecha: null,
				hora: null
			});
		},
		crearEntrada: function crearEntrada(fecha) {
			this.$emit('editar', {
				ID_entrada: 'nuevo',
				fecha: fecha,
				hora: null
			});
		},
		estiloDia: function estiloDia(dia) {
			if (dia.toLocaleDateString() === new Date().toLocaleDateString()) {
				return {
					'background-color': '#fbfbfb',
					'font-weight': 'bold'
				};
			}
			if (dia.getMonth() !== this.fecha.getMonth()) {
				return {
					'background-color': '#f0f0f0',
					'color': '#888888'
				};
			} else {
				return {};
			}
		},
		estiloEvento: function estiloEvento(dia, evento) {
			var diaStr = dia.getFullYear() + '' + dia.getMonth() + '' + dia.getDate();
			var inicioStr = evento.fechaIni.getFullYear() + '' + evento.fechaIni.getMonth() + '' + evento.fechaIni.getDate();
			var finStr = evento.fechaFin.getFullYear() + '' + evento.fechaFin.getMonth() + '' + evento.fechaFin.getDate();

			var estilo = {
				borderRadius: ['0', '0', '0', '0'],
				backgroundColor: evento.bgColor,
				color: evento.textColor,
				marginTop: '2px'
			};

			if (diaStr === inicioStr) {
				estilo.borderRadius[0] = '5px';
				estilo.borderRadius[3] = '5px';

				if (diaStr !== finStr) {
					estilo.marginRight = '-6px';
				}
			}

			if (diaStr === finStr) {
				estilo.borderRadius[1] = '5px';
				estilo.borderRadius[2] = '5px';

				if (diaStr !== inicioStr) {
					estilo.marginLeft = '-6px';
				}

				if (inicioStr !== finStr) {
					estilo.textAlign = 'right';
				}
			}

			if (diaStr !== inicioStr && diaStr !== finStr) {
				estilo.marginLeft = '-6px';
				estilo.marginRight = '-6px';
				estilo.color = evento.bgColor;
			}

			estilo.borderRadius = estilo.borderRadius.join(' ');

			return estilo;
		},
		verSemana: function verSemana(fecha) {
			this.$emit('verSemana', fecha);
		},
		verDia: function verDia(fecha) {
			this.$emit('verDia', fecha);
		}
	}
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__evento__ = __webpack_require__(913);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'evento': __WEBPACK_IMPORTED_MODULE_1__evento__["a" /* default */]
	},
	props: ['fecha', 'dias', 'entradas'],
	data: function data() {
		return {
			diasSemana: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
			horaInicio: 8
		};
	},


	watch: {
		entradas: function entradas(nuevoValor) {
			console.log('Información actualizada');
			var dias = this.getDias;
			for (var i = 0; i < dias.length; i++) {
				// this.eventosUnDia(dias[i])
			}
		}
	},

	computed: {
		fechaValida: function fechaValida() {
			if (this.dias === 1) {
				return new Date(this.fecha.getTime());
			}

			var ahora = this.fecha;
			var offset = ahora.getDay() === 0 ? 6 : ahora.getDay() - 1;

			var fecha = new Date(ahora.getTime());
			fecha.setDate(fecha.getDate() - offset);

			return fecha;
		},
		getDias: function getDias() {
			var dias = [];

			var total = typeof this.dias !== 'number' || this.dias < 1 || this.dias > 7 ? 7 : this.dias;

			for (var i = 0; i < total; i++) {
				var fecha = new Date(this.fechaValida.getTime());
				fecha.setDate(fecha.getDate() + i);
				fecha.setHours(0);
				fecha.setMinutes(0);
				fecha.setSeconds(0);
				fecha.setMilliseconds(0);
				dias.push({
					fecha: fecha,
					titulo: this.diasSemana[fecha.getDay()]
				});
			}

			return dias;
		},
		getHoras: function getHoras() {
			var date = new Date();
			date.setHours(0);
			date.setMinutes(0);
			var dia = date.getDate();

			var horas = [];

			while (date.getDate() === dia) {
				horas.push({
					hora: date.getHours(),
					minutos: date.getMinutes(),
					fecha: new Date(date.getTime())
				});
				date = new Date(date.getTime() + 30 * 60000);
			}

			return horas;
		},
		altoDia: function altoDia() {
			if (!this.$refs.colHoras) {
				return null;
			}

			console.log(this.$refs.colHoras);

			return this.$refs.colHoras.offsetHeight;
		}
	},

	methods: {
		actualizar: function actualizar() {
			this.$emit('actualizar');
		},
		leaveDrag: function leaveDrag(ev) {
			var elem = ev.srcElement;
			while (elem.parentElement) {
				if (elem.className === 'mediaHoraClass') {
					elem.style.backgroundColor = 'inherit';
					ev.preventDefault();
					ev.stopPropagation();
					return;
				}
				elem = elem.parentElement;
			}
		},
		overDrag: function overDrag(ev) {
			var elem = ev.srcElement;
			while (elem.parentElement) {
				if (elem.className === 'mediaHoraClass') {
					elem.style.backgroundColor = 'rgba(0,0,0,0.4)';
					ev.preventDefault();
					ev.stopPropagation();
					return;
				}
				elem = elem.parentElement;
			}
		},
		droped: function droped(ev) {
			var _this = this;

			ev.stopPropagation();
			ev.preventDefault();
			var evento = JSON.parse(ev.dataTransfer.getData('text/plain'));
			var dia = ev.srcElement.id.split('-');
			var fecha = new Date(parseInt(dia[0]));
			fecha.setHours(parseInt(dia[1]));
			fecha.setMinutes(parseInt(dia[2]));

			fecha.setSeconds(0);
			fecha.setMilliseconds(0);
			ev.srcElement.style.backgroundColor = 'inherit';
			// const top = ev.layerY - ev.offsetY
			var datos = {
				ID_entrada: evento.evento.ID_entrada,
				fechaIni: Math.floor(fecha.getTime() / 1000)
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/agenda-comercial/php/api/set-fecha-inicio-evento.php', datos).then(function () {
				// recargamos los eventos
				_this.$emit('actualizar');
			}).catch(function (e) {
				_this.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		eventosUnDia: function eventosUnDia(dia) {
			var eventos = [];
			var inicioDia = new Date(dia.fecha.getTime());
			inicioDia.setHours(0);
			inicioDia.setMinutes(0);
			inicioDia.setSeconds(0);
			inicioDia.setMilliseconds(0);
			var inicioStr = inicioDia.getDate() + '-' + (inicioDia.getMonth() + 1) + '-' + inicioDia.getFullYear();

			var finDia = new Date(dia.fecha.getTime());
			finDia.setHours(23);
			finDia.setMinutes(59);
			finDia.setSeconds(59);
			finDia.setMilliseconds(999);
			// const finStr = finDia.getDate() + '-' + (finDia.getMonth() + 1) + '-' + finDia.getFullYear()
			var minutosDia = (24 - this.horaInicio) * 60;
			for (var i = 0; i < this.entradas.length; i++) {
				// Si el evento es de día completo o abarca varios días, lo ignoramos
				var ev = this.entradas[i];
				var diaIniStr = ev.fechaIni.getDate() + '-' + (ev.fechaIni.getMonth() + 1) + '-' + ev.fechaIni.getFullYear();
				var diaFinStr = ev.fechaFin.getDate() + '-' + (ev.fechaFin.getMonth() + 1) + '-' + ev.fechaFin.getFullYear();

				if (diaIniStr === diaFinStr && diaIniStr === inicioStr) {
					// Calculamos su altura
					// El día tiene 1440 minutos

					var minutoEmpieza = (ev.fechaIni.getHours() - this.horaInicio) * 60 + ev.fechaIni.getMinutes();
					var minutoTermina = (ev.fechaFin.getHours() - this.horaInicio) * 60 + ev.fechaFin.getMinutes();

					var top = minutoEmpieza * 100 / minutosDia;
					var altura = (minutoTermina - minutoEmpieza) * 100 / minutosDia;

					var data = {
						evento: ev,
						intervalo: {
							top: top,
							altura: altura,
							coinciden: 0,
							previos: 0
						},
						dim: {
							top: top,
							left: 0,
							width: 100,
							height: altura,
							calculado: false
						},
						style: {
							top: top + 'px',
							height: altura + '%',
							width: '100%',
							left: '0'
						},
						estilo: {
							bgColor: ev.bgColor,
							color: ev.textColor
						}
					};
					eventos.push(data);
				}
			}
			// Ordenamos por fecha de inicio
			eventos.sort(function (a, b) {
				if (a.evento.fechaIni < b.evento.fechaIni) {
					return -1;
				} else if (a.evento.fechaIni === b.evento.fechaIni) {
					// Ordenamos de más largo a más corto
					if (a.evento.fechaFin < b.evento.fechaFin) {
						return 1;
					} else if (a.evento.fechaFin === b.evento.fechaFin) {
						return 0;
					} else {
						return -1;
					}
				} else {
					return 1;
				}
			});

			return this.posicionar(eventos);
		},
		getTopYBottom: function getTopYBottom(porcentaje) {
			var totalAlto = 1671;
			console.log(totalAlto);
			return porcentaje / 100 * totalAlto;
		},
		posicionar: function posicionar(eventos) {
			/**
   	Los eventos vienen ordenados por hora de inicio (menos a mayor)
   	y después por duración (mayor a menor)
    */
			for (var i = 0; i < eventos.length; i++) {
				var actual = eventos[i];
				var diaActual = actual.evento.fechaIni.getDate();
				var topActual = actual.dim.top;
				var bottomActual = actual.dim.top + actual.dim.height;
				var coinciden = [];

				// Vamos a ver cuantos eventos empiezan dentro del intérvalo de este evento
				// Estos eventos se repartirán el ancho con este evento
				for (var o = i + 1; o < eventos.length; o++) {
					var siguiente = eventos[o];
					var diaSiguiente = siguiente.evento.fechaIni.getDate();
					var topSiguiente = siguiente.dim.top;
					var coincide = topSiguiente >= topActual && topSiguiente < bottomActual;

					if (diaActual === diaSiguiente && coincide) {
						coinciden.push(o);
					}
				}

				var anchoTotal = 100;

				// Ahora vamos a ver si este intérvalo empieza dentro del tiempo de otro evento y si hay que ponerlo a la izquierda
				// de éste o a la derecha
				for (var p = 0; p < i; p++) {
					var anterior = eventos[p];
					var diaAnterior = anterior.evento.fechaIni.getDate();
					var topAnterior = anterior.dim.top;
					var bottomAnterior = anterior.dim.top + anterior.dim.height;
					var coincideAnterior = topAnterior < topActual && bottomAnterior > topActual;

					if (diaActual === diaAnterior && coincideAnterior) {
						anchoTotal = anterior.dim.left === 0 ? anterior.dim.width : anterior.dim.left;
					}
				}

				// Los eventos coincidentes tendrán el mismo ancho
				var width = anchoTotal / (coinciden.length + 1);
				if (!actual.dim.calculado) {
					actual.dim.width = width;
					// actual.dim.left = (!actual.dim.left) ? 0 : actual.dim.left
				}

				for (var c = 0; c < coinciden.length; c++) {
					var n = eventos[coinciden[c]];
					n.dim.width = width;
					n.dim.left = width + width * c;
					n.dim.calculado = true;

					n.style = {
						top: n.dim.top + '%',
						left: n.dim.left + '%',
						width: n.dim.width + '%',
						height: n.dim.height + '%'
					};
				}

				if (coinciden.length > 0) {
					i = coinciden[coinciden.length - 1];
				}

				actual.style = {
					top: actual.dim.top + '%',
					left: actual.dim.left + '%',
					width: actual.dim.width + '%',
					height: actual.dim.height + '%'
				};
			}
			return eventos;
		},
		verEntrada: function verEntrada(entrada) {
			this.$emit('editar', {
				ID_entrada: entrada.ID_entrada,
				fecha: null,
				hora: null
			});
		},
		nuevaEntrada: function nuevaEntrada(hora, parte, dia) {
			var fecha = new Date(dia.getTime());
			fecha.setHours(hora);

			if (parte === 2) {
				fecha.setMinutes(30);
			}

			this.$emit('editar', {
				ID_entrada: 'nuevo',
				fecha: fecha,
				hora: fecha
			});
		},
		toggleHoras: function toggleHoras() {
			this.horaInicio = this.horaInicio !== 0 ? 0 : 8;
		},
		verDia: function verDia(fecha) {
			this.$emit('verDia', fecha);
		},
		arrastraAbajo: function arrastraAbajo(ev) {}
	}
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['evento', 'alto'],
	data: function data() {
		return {
			datos: null,
			offset: {
				bottom: 0,
				top: 0
			},
			resized: {
				top: 0,
				bottom: 0
			},
			arrastrando: false,
			listener: null
		};
	},

	watch: {
		evento: function evento(nuevo) {
			var _this = this;

			window.setTimeout(function () {
				console.log('Arrastrando antes: ' + _this.arrastrando);
				console.log('Reiniciando datos');
				_this.datos = nuevo;
				_this.offset = {
					bottom: 0,
					top: 0
				};
				_this.resized = {
					top: 0,
					bottom: 0
				};
				_this.arrastrando = false;
				_this.listener = null;
			}, 300);
		}
	},
	created: function created() {
		this.datos = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.evento));
	},

	computed: {
		estilo: function estilo() {
			if (!this.datos) {
				return {};
			}

			var e = {
				position: 'absolute',
				display: 'block',
				top: 0 + this.resized.top + 'px',
				left: 0,
				right: 0,
				bottom: 0 - this.resized.bottom + 'px',
				backgroundColor: this.datos.evento.gestion === 1 ? '#fff716' : this.datos.estilo.bgColor,
				color: this.datos.evento.gestion === 1 ? '#000000' : this.datos.estilo.color,
				overflow: 'hidden'
			};
			return e;
		},
		estiloSup: function estiloSup() {
			return {};
		}
	},
	methods: {
		inicioArrastre: function inicioArrastre(ev) {
			ev.preventDefault();
			ev.stopPropagation();
		},
		test: function test(ev) {
			ev.stopPropagation();
			ev.dataTransfer.setData('text/plain', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.datos));
		},
		verEntrada: function verEntrada(ev, evento) {
			console.log('Arrastrando es: ' + this.arrastrando);
			if (this.arrastrando) {
				ev.stopPropagation();
				ev.preventDefault();
				return;
			}
			this.$emit('ver', evento);
		},
		captura: function captura(ev) {
			ev.stopPropagation();
			ev.preventDefault();
			var elem = ev.srcElement;

			this.arrastrando = true;

			while (elem.className !== 'eventoCalendario') {
				elem = elem.parentElement;
			}
			this.offset.bottom = ev.clientY - ev.clientY % 20;
			window.addEventListener('mousemove', this.mueveRatonBottom);
			window.addEventListener('click', this.libera);
			window.addEventListener('mouseup', this.libera);
		},
		libera: function libera(ev, zona) {
			var _this2 = this;

			ev.stopPropagation();
			ev.preventDefault();

			window.removeEventListener('click', this.libera);
			window.removeEventListener('mouseup', this.libera);
			window.removeEventListener('mousemove', this.mueveRatonBottom);

			var total = Math.floor(this.resized.bottom / 20);
			var minutos = total * 15;
			var datos = {
				ID_entrada: this.datos.evento.ID_entrada,
				minutos: minutos
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/agenda-comercial/php/api/set-fecha-incremento-evento.php', datos).then(function () {
				_this2.$emit('actualizar');
				_this2.offset.top = _this2.resized.top + 0;
				_this2.offset.bottom = _this2.resized.bottom + 0;
				_this2.resized = {
					top: 0,
					bottom: 0
				};
			}).catch(function (e) {
				_this2.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		stopProp: function stopProp(ev) {
			ev.stopPropagation();
			ev.preventDefault();
		},
		mueveRatonTop: function mueveRatonTop(ev) {
			var inc = ev.clientY - ev.clientY % 20.5;
			this.resized.top = inc - this.offset.top;
		},
		mueveRatonBottom: function mueveRatonBottom(ev) {
			// Calculamos cuanto porcentaje es 30 minutos
			var porcion = 20;
			var inc = ev.clientY - ev.clientY % porcion;
			this.resized.bottom = inc - this.offset.bottom;
		}
	}
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_propuestas__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'editor-propuesta': __WEBPACK_IMPORTED_MODULE_3__editor_propuestas__["a" /* default */]
	},
	data: function data() {
		return {
			ID_propuesta: null,
			filtro: {
				usuario: '',
				cliente: '',
				titulo: '',
				fechaIni: new Date(new Date().getTime() - 2592000000), // Propuestas de hace un mes
				fechaFin: null,
				tipo: 'todas',
				estado: 'todas'
			},
			listado: []
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		'permisos': 'permisos/permisos',
		'usuario': 'session/usuario'
	})),

	created: function created() {
		this.buscar();
	},


	methods: {
		nuevaPropuesta: function nuevaPropuesta() {
			this.ID_propuesta = 'nueva';
		},
		buscar: function buscar() {
			var _this = this;

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.fechaIni = this.filtro.fechaIni ? Math.floor(this.filtro.fechaIni.getTime() / 1000) : null;
			form.fechaFin = this.filtro.fechaFin ? Math.floor(this.filtro.fechaFin.getTime() / 1000) : null;
			__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/agenda-comercial/php/api/busca-propuestas.php', form).then(function (res) {
				_this.listado = res.data.propuestas;
			}).catch(this.$responseError);
		},
		delFechaIni: function delFechaIni() {
			this.filtro.fechaIni = null;
			this.buscar();
		},
		delFechaFin: function delFechaFin() {
			this.filtro.fechaFin = null;
			this.buscar();
		},
		setTipo: function setTipo(tipo) {
			this.filtro.tipo = tipo;
			this.buscar();
		},
		setEstado: function setEstado(estado) {
			this.filtro.estado = estado;
			this.buscar();
		},
		aprobar: function aprobar(propuesta) {
			var _this2 = this;

			var form = {
				entrada_ID: propuesta.entrada_ID_asociada,
				propuesta_ID: propuesta.ID_propuesta,
				decision: 'aprobada'
			};
			this.$store.commit('alertas/confirm', {
				titulo: 'Aprobar propuesta',
				mensaje: '\xBFQuieres aprobar esta propuesta?',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.$http.post('agenda-comercial/php/api/set-propuesta-decision.php', form).then(function (res) {
							_this2.buscar();
						}).catch(function (e) {
							_this2.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		rechazar: function rechazar(propuesta) {
			var _this3 = this;

			var form = {
				entrada_ID: propuesta.entrada_ID_asociada,
				propuesta_ID: propuesta.ID_propuesta,
				decision: 'rechazada'
			};
			this.$store.commit('alertas/confirm', {
				titulo: 'Rechazar propuesta',
				mensaje: '\xBFQuieres rechazar esta propuesta?',
				callback: function callback(acepta) {
					if (acepta) {
						_this3.$http.post('agenda-comercial/php/api/set-propuesta-decision.php', form).then(function (res) {
							_this3.buscar();
						}).catch(function (e) {
							_this3.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		var _this = this;

		return {
			uri: '/agenda-comercial/php/api/estadisticas/',
			diaSem: ['', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb', 'Dom', ''],
			form: {
				usuario_ID: null,
				clientes: [],
				fechaIni: null,
				fechaFin: null
			},
			nombreUsuario: null,
			resultados: {
				clientesMasVisitados: null,
				propuestasRechazadas: null,
				visitasDiaSemana: null,
				visitasHoras: null,
				visitasHorasSemana: null,
				visitasObjetivo: null,
				visitasTipo: null,
				visitasCanceladas: null
			},
			opcionesPie: {
				ticks: {
					min: 0
				}
			},
			opcionesBubble: {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
						ticks: {
							beginAtZero: true,
							callback: function callback(value, index, values) {
								return _this.diaSem[value];
							}
						},
						gridLines: {
							display: false
						}
					}]
				},
				legend: {
					display: false
				},
				tooltips: {
					enabled: true,
					mode: 'single',
					callbacks: {
						label: function label(tooltipItems, data) {
							for (var i = 0; i < data.datasets[0].data.length; i++) {
								if (data.datasets[0].data[i].x === parseInt(tooltipItems.xLabel) && data.datasets[0].data[i].y === parseInt(tooltipItems.yLabel)) {
									return tooltipItems.yLabel + ':00 - ' + data.datasets[0].data[i].r + ' %';
								}
							}
							return tooltipItems.yLabel + ':00';
						}
					}
				},
				responsive: true,
				maintainAspectRatio: false,
				height: 200
			}
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		'permisos': 'permisos/permisos'
	})),

	methods: {
		setAgente: function setAgente(ev) {
			this.form.usuario_ID = ev.datos.ID;
			this.nombreUsuario = ev.datos.nombre + ' ' + ev.datos.apellidos;
			this.buscar();
		},
		addCliente: function addCliente(ev) {
			for (var i = 0; i < this.form.clientes.length; i++) {
				if (this.form.clientes[i].ID === ev.datos.ID) {
					return;
				}
			}

			this.form.clientes.push(ev.datos);
		},
		quitaCliente: function quitaCliente(ID) {
			for (var i = this.form.clientes.length - 1; i >= 0; i--) {
				if (this.form.clientes[i].ID === ID) {
					this.form.clientes.splice(i, 1);
				}
			}
		},
		buscar: function buscar() {
			var _this2 = this;

			if (this.form.fechaIni) {
				this.form.fechaIni.setHours(0);
				this.form.fechaIni.setMinutes(0);
				this.form.fechaIni.setSeconds(0);
				this.form.fechaIni.setMilliseconds(0);
			}

			if (this.form.fechaFin) {
				this.form.fechaFin.setHours(23);
				this.form.fechaFin.setMinutes(59);
				this.form.fechaFin.setSeconds(59);
				this.form.fechaFin.setMilliseconds(999);
			}
			var form = {
				usuario_ID: this.form.usuario_ID,
				clientes: this.form.clientes,
				fechaIni: this.form.fechaIni ? Math.floor(this.form.fechaIni.getTime() / 1000) : null,
				fechaFin: this.form.fechaFin ? Math.floor(this.form.fechaFin.getTime() / 1000) : null
			};

			this.resultados = {
				clientesMasVisitados: null,
				propuestasRechazadas: null,
				visitasDiaSemana: null,
				visitasHoras: null,
				visitasHorasSemana: null,
				visitasObjetivo: null,
				visitasTipo: null,
				visitasCanceladas: null
			};
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.uri + 'index.php', form).then(function (res) {
				_this2.resultados = res.data.resultados;
			}).catch(this.$responseError);
			// axios.post(this.uri + 'visitas-por-objetivo.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasObjetivo = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})

			// axios.post(this.uri + 'visitas-por-tipo.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasTipo = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})

			// axios.post(this.uri + 'visitas-rechazadas.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasCanceladas = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})
			// axios.post(this.uri + 'propuestas-rechazadas.php', form)
			// 	.then(res => {
			// 		this.resultados.propuestasRechazadas = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})

			// axios.post(this.uri + 'visitas-por-diasemana.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasDiaSemana = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})
			// axios.post(this.uri + 'visitas-por-horas.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasHoras = res.data
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})
			// axios.post(this.uri + 'visitas-por-horas-semana.php', form)
			// 	.then(res => {
			// 		this.resultados.visitasHorasSemana = {
			// 			labels: ['Visitas por días y horas'],
			// 			datasets: [
			// 				{
			// 					backgroundColor: '#f87979',
			// 					pointBackgroundColor: 'white',
			// 					borderWidth: 1,
			// 					pointBorderColor: '#249EBF',
			// 					labels: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
			// 					data: res.data.datos
			// 				}
			// 			]
			// 		}
			// 	})
			// 	.catch(e => {
			// 		console.error(e)
			// 	})
		}
	}
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			filtro: {
				FechaInicio: null,
				FechaFin: null,
				AgenteID: null,
				AnuncianteNombre: null,
				ClienteNombre: null,
				ContratoID: null,
				Descripcion: null,
				DestinoID: null,
				IntermediarioID: null,
				Soportes: [],
				CampoAgrupado: null
			},
			agenteNombre: null,
			contratoTitulo: null,
			intermediarioNombre: null,
			listadoDestinos: [],
			listadoCampos: [{
				campo: 'ClienteID',
				descripcion: 'Cliente'
			}, {
				campo: 'AnuncianteID',
				descripcion: 'Anunciante'
			}, {
				campo: 'AgenteID',
				descripcion: 'Agente'
			}, {
				campo: 'SoporteID',
				descripcion: 'Soporte'
			}, {
				campo: 'FicheroMatricula',
				descripcion: 'Matrícula'
			}, {
				campo: 'ContratoID',
				descripcion: 'Contrato'
			}],
			resultados: [],
			resultadosAgrupados: false,
			pagina: 0,
			resultadosPorPagina: 100,
			saltarPagina: null
		};
	},
	created: function created() {
		this.getlistadoDestinos();
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	}), {
		columnasOcultas: function columnasOcultas() {
			var cols = [];
			if (!this.resultadosAgrupados) {
				return [];
			}

			switch (this.resultadosAgrupados) {
				case 'ClienteID':
					cols = ['AnuncianteNombre', 'SoporteNombre', 'FechaEmision', 'ContratoTitulo', 'ProduccionTitulo', 'FicheroNombre', 'FicheroMatricula', 'AgenteNombre'];
					break;
				case 'AnuncianteID':
					cols = ['ClienteNombre', 'SoporteNombre', 'FechaEmision', 'ContratoTitulo', 'ProduccionTitulo', 'FicheroNombre', 'FicheroMatricula', 'AgenteNombre'];
					break;
				case 'AgenteID':
					cols = ['ClienteNombre', 'AnuncianteNombre', 'SoporteNombre', 'FechaEmision', 'ContratoTitulo', 'ProduccionTitulo', 'FicheroNombre', 'FicheroMatricula'];
					break;
				case 'SoporteID':
					cols = ['ClienteNombre', 'AnuncianteNombre', 'FechaEmision', 'ContratoTitulo', 'ProduccionTitulo', 'FicheroNombre', 'FicheroMatricula', 'AgenteNombre'];
					break;
				case 'FicheroMatricula':
					cols = ['FechaEmision', 'SoporteNombre'];
					break;
				case 'ContratoID':
					cols = ['AnuncianteNombre', 'SoporteNombre', 'FechaEmision', 'ProduccionTitulo', 'FicheroNombre', 'FicheroMatricula'];
					break;
				default:
					cols = [];
					break;
			}

			return cols;
		},
		paginaActual: function paginaActual() {
			var _this = this;

			if (this.resultados.length <= this.resultadosPorPagina) {
				return this.resultados;
			}

			return this.resultados.filter(function (val, i) {
				return i >= _this.pagina * _this.resultadosPorPagina && i <= (_this.pagina + 1) * _this.resultadosPorPagina;
			});
		},
		paginas: function paginas() {
			return Math.ceil(this.resultados.length / this.resultadosPorPagina);
		},
		botonesPagina: function botonesPagina() {
			var paginas = [];
			if (this.paginas < 10) {
				for (var i = 0; i < this.paginas; i++) {
					paginas.push({
						pagina: i,
						activa: true
					});
				}
				return paginas;
			}

			var inicio = this.pagina <= 5 ? 0 : this.pagina - 5;
			for (var _i = inicio; _i < inicio + 7; _i++) {
				paginas.push({
					pagina: _i,
					activa: true
				});
			}

			paginas.push({
				pagina: '...',
				activa: false
			});

			for (var _i2 = this.paginas - 6; _i2 < this.paginas; _i2++) {
				paginas.push({
					pagina: _i2,
					activa: true
				});
			}

			return paginas;
		},
		json_data: function json_data() {
			return this.resultados;
		},
		json_fields: function json_fields() {
			var arr = {
				AnuncianteNombre: 'AnuncianteNombre',
				ClienteNombre: 'ClienteNombre',
				SoporteNombre: 'SoporteNombre',
				FechaEmision: 'FechaEmision',
				ContratoTitulo: 'ContratoTitulo',
				ProduccionTitulo: 'ProduccionTitulo',
				FicheroNombre: 'FicheroNombre',
				FicheroMatricula: 'FicheroMatricula',
				AgenteNombre: 'AgenteNombre'
			};

			if (this.resultadosAgrupados) {
				arr.EmisionesTotales = 'EmisionesTotales';
			}
			return arr;
		},
		json_meta: function json_meta() {
			return [[{
				'key': 'charset',
				'value': 'utf-8'
			}]];
		}
	}),
	methods: {
		verPagina: function verPagina(p) {
			this.pagina = p;
		},
		paginaSiguiente: function paginaSiguiente() {
			if (this.pagina + 1 < this.paginas) {
				this.pagina++;
			} else {
				this.pagina = 0;
			}
		},
		paginaAnterior: function paginaAnterior() {
			if (this.pagina === 0) {
				this.pagina = this.paginas - 1;
			} else {
				this.pagina--;
			}
		},
		getlistadoDestinos: function getlistadoDestinos() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/auditor/php/api/listado-destinos.php').then(function (res) {
				_this2.listadoDestinos = res.data.resultados;
			}).catch(function (e) {
				_this2.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: 'Error obteniendo el listado de destinos'
				});
			});
		},
		setAgente: function setAgente(e) {
			this.filtro.AgenteID = e.data.ID;
			this.agenteNombre = e.data.Nombre;
		},
		quitarAgente: function quitarAgente() {
			this.filtro.AgenteID = null;
			this.agenteNombre = null;
		},
		setContrato: function setContrato(e) {
			this.filtro.ContratoID = e.data.ID_contrato;
		},
		quitarContrato: function quitarContrato() {
			this.filtro.ContratoID = null;
			this.contratoTitulo = null;
		},
		setSoporte: function setSoporte(e) {
			if (this.filtro.Soportes.filter(function (a) {
				return a.ID_soporte === e.data.ID_soporte;
			}).length === 0) {
				this.filtro.Soportes.push(e.data);
			}
		},
		quitarSoporte: function quitarSoporte(sop) {
			this.filtro.Soportes = this.filtro.Soportes.filter(function (a) {
				return a !== sop;
			});
		},
		setIntermediario: function setIntermediario(e) {
			this.filtro.IntermediarioID = e.data.ID_intermediario;
			this.intermediarioNombre = e.data.nombre;
		},
		quitarIntermediario: function quitarIntermediario() {
			this.filtro.IntermediarioID = null;
			this.intermediarioNombre = null;
		},
		descargarFicheros: function descargarFicheros() {
			var _this3 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Descargar audios',
				mensaje: 'Este proceso puede demorarse, por lo que tendrás que tener paciencia. ¿Quieres continuar?',
				callback: function callback(accept) {
					if (accept) {
						var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.filtro));
						form.FechaInicio = _this3.filtro.FechaInicio ? Math.round(_this3.filtro.FechaInicio.getTime() / 1000) : null;
						form.FechaFin = _this3.filtro.FechaFin ? Math.round(_this3.filtro.FechaFin.getTime() / 1000) : null;
						_this3.resultadosAgrupados = null;
						_this3.download('/auditor/php/api/descargar.php', form, 'audios.zip', function () {
							console.log('Terminado');
						});
					}
				}
			});
		},
		buscar: function buscar() {
			var _this4 = this;

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.FechaInicio = this.filtro.FechaInicio ? Math.round(this.filtro.FechaInicio.getTime() / 1000) : null;
			form.FechaFin = this.filtro.FechaFin ? Math.round(this.filtro.FechaFin.getTime() / 1000) : null;
			this.resultadosAgrupados = null;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/auditor/php/api/consultar.php', form).then(function (res) {
				_this4.pagina = 0;
				_this4.resultados = res.data.resultados;
				_this4.resultadosAgrupados = res.data.agrupado;
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Error en la búsqueda'
				});
			});
		}
	}
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			seccion: 'porAgente'
		};
	},
	created: function created() {
		var _this = this;

		var menu = [{
			'icono': 'fa fa-user',
			'nombre': 'Por agente',
			activo: true,
			'callback': function callback(a) {
				_this.setMenuActivo(a);
				_this.go('porAgente');
			}
		}, {
			'icono': 'fa fa-users',
			'nombre': 'Por clientes',
			activo: false,
			callback: function callback(a) {
				_this.setMenuActivo(a);
				_this.go('porClientes');
			}
		}];
		this.setMenu(menu);
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
		setMenu: 'top/setMenu',
		setMenuActivo: 'top/setMenuActivo'
	}), {
		go: function go(seccion) {
			this.seccion = seccion;
			this.$router.push('/main/facturacion/' + seccion);
		}
	})
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__graficosTotales__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graficoDetalle__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'graficos-totales': __WEBPACK_IMPORTED_MODULE_2__graficosTotales__["a" /* default */],
		'graficos-detalles': __WEBPACK_IMPORTED_MODULE_3__graficoDetalle__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				agentes: [],
				verTodosAgentes: false,
				verSinAgente: false,
				fecha_ini: new Date(new Date().getFullYear(), 0, 1),
				fecha_fin: new Date(new Date().getFullYear(), 11, 1),
				titulo: '',
				partidas: [],
				soportes: [],
				campos: [],
				destinos: [],
				eventos: [{
					id: 'real',
					nombre: 'Eventos',
					d: false,
					c: true,
					r: true
				}, {
					id: 'acum',
					nombre: 'Eventos acumulados',
					d: false,
					c: null,
					r: true
				}]
			},
			listadoSoportes: [],
			listadoPartidas: [],
			listadoDestinos: [],
			listadoCampos: [],
			resultados: null,
			grafico: null,
			detalles: null
		};
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	})),

	created: function created() {
		var _this = this;

		// Obtenemos todos los campos del formulario
		__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getCamposFormulario().then(function (res) {
			_this.listadoSoportes = res.data.soportes;
			_this.listadoDestinos = res.data.destinos;
			_this.listadoCampos = res.data.campos;

			for (var i = 0; i < _this.listadoSoportes.length; i++) {
				_this.toggleSoporte(_this.listadoSoportes[i].ID_soporte);
			}

			for (var _i = 0; _i < _this.listadoCampos.length; _i++) {
				_this.toggleCampo(_this.listadoCampos[_i].ID);
			}

			for (var _i2 = 0; _i2 < res.data.partidas.length; _i2++) {
				_this.filtro.partidas.push({
					id: res.data.partidas[_i2].ID_partida,
					titulo: res.data.partidas[_i2].titulo,
					d: false,
					c: true,
					r: true
				});
			}
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},


	methods: {
		getActivos: function getActivos() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getAgentesActivos().then(function (res) {
				_this2.filtro.agentes = res.data.usuarios;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		otroAgente: function otroAgente(datos) {
			for (var i = 0; i < this.filtro.agentes.length; i++) {
				if (this.filtro.agentes[i].ID === datos.datos.ID) {
					return;
				}
			}
			var age = {
				nombre: datos.datos.nombre + ' ' + datos.datos.apellidos,
				ID: datos.datos.ID
			};
			this.filtro.agentes.push(age);
		},
		quitaAgente: function quitaAgente(ID) {
			for (var i = 0; i < this.filtro.agentes.length; i++) {
				if (this.filtro.agentes[i].ID === ID) {
					this.filtro.agentes.splice(i, 1);
				}
			}
		},
		toggleSoporte: function toggleSoporte(ID) {
			var idx = this.filtro.soportes.indexOf(ID);

			if (idx >= 0) {
				this.filtro.soportes.splice(idx, 1);
				return;
			}

			this.filtro.soportes.push(ID);
		},
		toggleCampo: function toggleCampo(ID) {
			var idx = this.filtro.campos.indexOf(ID);

			if (idx >= 0) {
				this.filtro.campos.splice(idx, 1);
				return;
			}

			this.filtro.campos.push(ID);
		},
		toggleDestino: function toggleDestino(ID) {
			var idx = this.filtro.destinos.indexOf(ID);

			if (idx >= 0) {
				this.filtro.destinos.splice(idx, 1);
				return;
			}

			this.filtro.destinos.push(ID);
		},
		consultar: function consultar() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].consultarPorAgentes(this.filtro).then(function (res) {
				_this3.resultados = res.data;
				_this3.resultados.fechas = {
					fecha_ini: _this3.filtro.fecha_ini,
					fecha_fin: _this3.filtro.fecha_fin
				};
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		verGraficos: function verGraficos(data, campo) {
			if (campo.id === 'real') {
				data.fechas = this.resultados.fechas;
				this.grafico = data;
			}
		},
		verDetalles: function verDetalles(agente, campo, facturacion, dimension) {
			this.detalles = {
				agente: agente,
				campo: campo,
				facturacion: facturacion,
				dimension: dimension,
				fechas: this.resultados.fechas
			};
		}
	}
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__representarDatos__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mis_contratos_vue_components_visor_contrato_visor_contrato_vue__ = __webpack_require__(45);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['datos'],
	components: {
		'representar': __WEBPACK_IMPORTED_MODULE_2__representarDatos__["a" /* default */],
		VisorContrato: __WEBPACK_IMPORTED_MODULE_3__mis_contratos_vue_components_visor_contrato_visor_contrato_vue__["a" /* default */]
	},

	data: function data() {
		return {
			meses: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			labels: [],
			graficoReal: null,
			graficoTotal: null,
			graficoAcumulado: null,
			listadoContratos: null,
			seccion: 'real',
			ContratoID: null
		};
	},

	created: function created() {
		console.time();
		console.info('Comenzamos');
		this.graficoReal = this.getTotal();
		this.graficoTotal = this.getTotalFacturacionAnos();
		this.graficoAcumulado = this.getAcumulados();
		this.listadoContratos = this.getListadoContratos();
		console.log('Terminamos');
		console.timeEnd();
	},


	computed: {
		json_data: function json_data() {
			var _this = this;

			if (!this.listadoContratos) {
				return [];
			}

			return this.listadoContratos.reduce(function (acum, contrato) {
				var item = {
					mes: _this.meses[contrato.fecha.getMonth()] + ', ' + contrato.fecha.getFullYear(),
					soporte: contrato.soporteNombre,
					cliente: contrato.clienteNombre,
					agente: contrato.agenteNombre,
					contrato: contrato.contratoTitulo,
					importe: _this.$options.filters.currency(contrato.importe)
				};
				acum.push(item);
				return acum;
			}, []);
		},
		json_fields: function json_fields() {
			if (!this.listadoContratos) {
				return {};
			}
			var f = {};

			f.mes = 'String';
			f.soporte = 'String';
			f.cliente = 'String';
			f.agente = 'String';
			f.contrato = 'String';
			f.importe = 'String';
			return f;
		},
		json_meta: function json_meta() {
			return [[{
				'key': 'charset',
				'value': 'utf-8'
			}]];
		},
		mesMenor: function mesMenor() {
			var actual = this.datos.fechas.fecha_ini;
			var mes = actual.getMonth();
			while (actual.getTime() <= this.datos.fechas.fecha_fin.getTime()) {
				var m = actual.getMonth();
				mes = mes > m ? m : mes;
				var ano = m === 11 ? actual.getFullYear() + 1 : actual.getFullYear();
				var sig = m === 11 ? 0 : m + 1;

				actual = new Date(ano, sig, 1, 0, 0, 0, 0);
			}

			return mes;
		},
		mesMayor: function mesMayor() {
			var actual = this.datos.fechas.fecha_ini;
			var mes = actual.getMonth();
			while (actual.getTime() <= this.datos.fechas.fecha_fin.getTime()) {
				var m = actual.getMonth();
				mes = mes < m ? m : mes;
				var ano = m === 11 ? actual.getFullYear() + 1 : actual.getFullYear();
				var sig = m === 11 ? 0 : m + 1;

				actual = new Date(ano, sig, 1, 0, 0, 0, 0);
			}

			return mes;
		},
		sumaFacturacion: function sumaFacturacion() {
			var importe = 0;

			for (var i = 0; i < this.listadoContratos.length; i++) {
				importe += parseFloat(this.listadoContratos[i].importe);
			}

			return importe;
		}
	},

	methods: {
		setSeccion: function setSeccion(seccion) {
			this.seccion = seccion;
		},
		creaDataSets: function creaDataSets() {
			var d = [];
			var labels = [];
			var actual = this.datos.fechas.fecha_ini;

			do {
				var ano = actual.getFullYear();
				var encontrado = false;
				for (var i = 0; i < d.length; i++) {
					if (d[i].label === ano.toString()) {
						encontrado = true;
					}
				}

				if (!encontrado) {
					var color = this.getRandomColor();
					d.push({
						label: ano.toString(),
						data: [],
						backgroundColor: color,
						borderColor: color,
						fill: false
					});
				}
				var mes = actual.getMonth();
				ano = mes === 11 ? actual.getFullYear() + 1 : actual.getFullYear();
				var sig = mes === 11 ? 0 : mes + 1;

				actual = new Date(ano, sig, 1, 0, 0, 0, 0);
			} while (actual.getTime() <= this.datos.fechas.fecha_fin.getTime());

			// ahora rellenamos todos los datasets con ceros en todos sus meses
			for (var _i = 0; _i < d.length; _i++) {
				for (var m = this.mesMenor; m <= this.mesMayor; m++) {
					var clave = this.meses[m];

					if (labels.indexOf(clave) < 0) {
						labels.push(clave);
					}

					d[_i].data[m] = 0;
				}
			}

			return {
				labels: labels,
				data: d
			};
		},
		getTotal: function getTotal() {
			// Evolución del real total
			var totales = {};

			if (this.datos.totales && this.datos.totales.TOTAL) {
				var info = this.creaDataSets();
				var totalReal = {
					titulo: 'Evolución Real',
					datos: {},
					labels: info.labels,
					datasets: info.data,
					tipo: 'barras'
				};

				for (var i = 0; i < this.datos.totales.TOTAL.datos.campos.real.facturacion.length; i++) {
					var d = this.datos.totales.TOTAL.datos.campos.real.facturacion[i];
					var fecha = new Date(parseInt(d.fecha) * 1000);
					var ano = fecha.getFullYear();
					var mes = fecha.getMonth();
					var offset = mes - this.mesMenor;

					for (var f = 0; f < totalReal.datasets.length; f++) {
						if (totalReal.datasets[f].label === ano.toString()) {
							totalReal.datasets[f].data[offset] += parseFloat(d.importe);
							totales[ano] = totales[ano] ? totales[ano] + parseFloat(d.importe) : parseFloat(d.importe);
						}
					}
				}

				return totalReal;
			} else {
				return null;
			}
		},
		getCoberturas: function getCoberturas() {
			// Obtenemos las coberturas por soportes

		},
		getAcumulados: function getAcumulados() {
			var totales = null;

			try {
				totales = this.datos.totales.TOTAL.datos.campos.real.facturacion;
			} catch (e) {
				return null;
			}

			var info = this.creaDataSets();
			var totalAcum = {
				titulo: 'Evolución acumulado',
				datos: {},
				labels: info.labels,
				datasets: info.data,
				tipo: 'lineas'
			};

			for (var i = 0; i < totales.length; i++) {
				var fecha = new Date(parseInt(totales[i].fecha) * 1000);
				var ano = fecha.getFullYear().toString();
				var mes = fecha.getMonth();

				var m = mes;

				for (var a = 0; a < totalAcum.datasets.length; a++) {
					if (totalAcum.datasets[a].label === ano) {
						while (m <= 11) {
							totalAcum.datasets[a].data[m] = totalAcum.datasets[a].data[m] + parseFloat(totales[i].importe);
							m++;
						}
					}
				}
			}

			return totalAcum;
		},
		getTotalFacturacionAnos: function getTotalFacturacionAnos() {
			if (this.datos.fechas.fecha_ini.getFullYear() !== this.datos.fechas.fecha_fin.getFullYear()) {
				// Sumamos los importes de cada ano
				var datos = {};
				var arr = null;

				try {
					arr = this.datos.totales.TOTAL.datos.campos.real.facturacion;
				} catch (e) {
					console.error(e);
					return null;
				}
				for (var i = 0; i < arr.length; i++) {
					var ano = new Date(parseInt(arr[i].fecha) * 1000).getFullYear().toString();
					datos[ano] = !datos[ano] ? parseFloat(arr[i].importe) : datos[ano] + parseFloat(arr[i].importe);
				}

				var objeto = {
					titulo: 'Total años',
					labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(datos),
					datasets: [{
						data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(datos),
						label: 'Total REAL'
					}],
					tipo: 'barras'
				};

				console.log(objeto);

				return objeto;
			} else {
				return null;
			}
		},
		getRandomColor: function getRandomColor() {
			var letters = '0123456789ABCDEF';
			var color = '#';
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			return color;
		},
		getListadoContratos: function getListadoContratos() {
			var arr = [];
			var datos = null;
			try {
				datos = this.datos.totales.TOTAL.datos.campos.real.facturacion;
			} catch (e) {
				return null;
			}

			for (var i = 0; i < datos.length; i++) {
				var nuevo = _.clone(datos[i]);
				nuevo.fecha = new Date(parseInt(nuevo.fecha) * 1000);
				arr.push(nuevo);
			}

			return arr;
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_representarDatos_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a632c2be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_representarDatos_vue__ = __webpack_require__(941);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_representarDatos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a632c2be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_representarDatos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['datos']
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detalles_contrato__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modalFirma__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['ContratoID'],
	components: {
		'detalles-contrato': __WEBPACK_IMPORTED_MODULE_3__detalles_contrato__["a" /* default */],
		'firmar': __WEBPACK_IMPORTED_MODULE_4__modalFirma__["a" /* default */]
	},
	data: function data() {
		return {
			imprimir: null,
			contrato: null,
			verFirma: false,
			firmaManuscrita: null
		};
	},
	created: function created() {
		if (!this.ContratoID) {
			this.$error('Error', 'Debes proporcionar el ID de contrato');
			return;
		}
		this.getContrato();
	},

	watch: {
		ContratoID: function ContratoID(id) {
			this.getContrato();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	}), {
		hayFirma: function hayFirma() {
			return this.contrato.ficheros.reduce(function (ant, actual) {
				if (actual.EsContratoFirmado) {
					ant = true;
				}
				return ant;
			}, false);
		},

		/**
   * Determina si un contrato es eliminable.
   * Para ello el contrato debe estar en fase borrador y
   * no tener recibos ni facturación en periodos cerrados
   */
		eliminable: function eliminable() {
			return true;
		},

		/**
   * Determina si un contrato está finalizado o no.
   * Para ello la fecha de fin de contrato debe ser anterior a la actual
   */
		finalizado: function finalizado() {
			if (!this.contrato) {
				return false;
			}
			return this.contrato.FechaFin <= new Date();
		}
	}),
	methods: {
		getContrato: function getContrato() {
			var _this = this;

			if (this.ContratoID) {
				__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getContrato(this.ContratoID).then(function (res) {
					_this.contrato = res;
				}).catch(function (e) {
					_this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					});
				});
			}
		},
		setCandidato: function setCandidato() {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Convertir en candidato',
				mensaje: '\xBFQuieres convertir este contrato en candidato?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].setCandidato(_this2.contrato.ContratoID).then(function (res) {
							_this2.getContrato();
						}).catch(function (e) {
							_this2.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		setAprobado: function setAprobado() {
			var _this3 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Aprobar contrato',
				mensaje: '\xBFQuieres aprobar este contrato?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].setAprobar(_this3.contrato.ContratoID).then(function (res) {
							_this3.getContrato();
						}).catch(function (e) {
							_this3.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		setRechazado: function setRechazado() {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Rechazar contrato',
				mensaje: '\xBFQuieres rechazar este contrato?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].setRechazar(_this4.contrato.ContratoID).then(function (res) {
							_this4.getContrato();
						}).catch(function (e) {
							_this4.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		setEliminado: function setEliminado() {
			var _this5 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar contrato',
				mensaje: '\xBFQuieres eliminar este contrato?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].setEliminado(_this5.contrato.ContratoID).then(function (res) {
							_this5.getContrato();
						}).catch(function (e) {
							_this5.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		firmar: function firmar() {
			this.verFirma = true;
		},
		permisoBorrarFichero: function permisoBorrarFichero(fichero) {
			var tiempoLimite = new Date().getTime() - 86400000;
			if (fichero.EsContratoFirmado) {
				if (!this.permisos.contratos_eliminaFirma) {
					return false;
				} else if (fichero.FechaSubidoUnix * 1000 < tiempoLimite) {
					return false;
				} else if (this.contrato.AgenteID !== this.usuario.ID && !this.permisos.contratos_crearAjenos) {
					return false;
				} else {
					return true;
				}
			} else if (this.contrato.AgenteID !== this.usuario.ID && !this.permisos.contratos_crearAjenos) {
				return false;
			}
			return true;
		},
		editar: function editar() {
			var _this6 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Editar contrato',
				mensaje: 'Cuando editar un contrato generar\xE1s una copia del mismo, quedando \xE9ste como parte de su hist\xF3rico.\n\t\t\t\t\xBFQuieres continuar?',
				callback: function callback(acepta) {
					if (acepta) {
						_this6.$router.push('/main/contratos/editar/' + _this6.ContratoID);
					}
				}
			});
		},
		goImprimir: function goImprimir(opciones) {
			var _this7 = this;

			var form = {
				OpcionesImpresion: opciones,
				Contrato: this.contrato.ContratoID,
				imprimir: true
			};

			__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('mis-contratos/php/api/get-pdf-contrato.php?ContratoID=' + this.contrato.ContratoID, form).then(function (res) {
				_this7.$store.commit('toast/success', {
					titulo: 'Impresión iniciada'
				});
			}).catch(this.$responseError);
		},
		eliminarFichero: function eliminarFichero(fichero) {
			var _this8 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar fichero',
				mensaje: '¿Quieres eliminar este fichero?\nEsta acción no la podrás deshacer',
				callback: function callback(acepta) {
					if (acepta) {
						_this8.$http.delete('mis-contratos/php/api/ficheroDel.php?FicheroID=' + fichero.FicheroID).then(function (res) {
							_this8.getContrato();
							_this8.$store.commit('toast/success', {
								titulo: 'Fichero eliminado'
							});
						}).catch(_this8.$responseError);
					}
				}
			});
		},
		contratoFirmado: function contratoFirmado() {
			this.verFirma = false;
			this.getContrato();
		},
		upload: function upload(esFirma) {
			var _this9 = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.multiple = true;
			inp.accept = 'application/pdf';
			inp.addEventListener('change', function () {
				document.body.removeChild(inp);

				// Creamos el form
				var form = new FormData();
				for (var i = 0; i < inp.files.length; i++) {
					form.append('fichero[]', inp.files[i]);
				}
				form.append('EsContratoFirmado', esFirma);
				form.append('ContratoID', _this9.contrato.ContratoID);

				var ajax = new XMLHttpRequest();
				ajax.open('POST', '/src/modulos/mis-contratos/php/api/ficheroAdd.php?ContratoID=' + _this9.contrato.ContratoID);
				ajax.onreadystatechange = function () {
					if (ajax.readyState === 4) {
						if (ajax.status === 200) {
							_this9.getContrato();
						} else {
							var mensaje = void 0;
							try {
								mensaje = JSON.parse(ajax.responseText);
							} catch (e) {
								mensaje = { error: 'Error desconocido' };
							}
							_this9.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: mensaje.error
							});
						}
					}
				};

				ajax.send(form);
			});

			document.body.appendChild(inp);
			inp.click();
		}
	}
});

/***/ }),
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_datos_cliente__ = __webpack_require__(971);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato'],
	components: {
		EditorCliente: __WEBPACK_IMPORTED_MODULE_2__editor_datos_cliente__["a" /* default */]
	},
	data: function data() {
		return {
			imprimir: null,
			editaCliente: null,
			verEditor: false
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	}), {
		permisoEditarCliente: function permisoEditarCliente() {
			if (this.contrato.Estado !== 'Borrador') {
				return false;
			}
			if (this.contrato.AgenteID !== this.usuario.ID && !this.permisos.contratos_crearAjenos) {
				return false;
			}

			return true;
		}
	})
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato'],
	data: function data() {
		return {
			datos: {
				RelacionID: '',
				ContratoID: '',
				ClienteID: '',
				CIF: '',
				NombreCliente: '',
				Representante: '',
				Telefono: '',
				Email: '',
				Direccion: '',
				IBAN: ''
			}
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	})),
	created: function created() {
		var _this = this;

		console.log('Creado');
		this.$http.get('mis-contratos/php/api/getDatosCliente.php?ContratoID=' + this.contrato.ContratoID).then(function (res) {
			_this.datos = res.data;
		}).catch(function (e) {
			_this.$responseError(e);
			_this.cerrar();
		});
	},

	methods: {
		actualizar: function actualizar() {
			var _this2 = this;

			this.datos.ContratoID = this.contrato.ContratoID;
			this.datos.ClienteID = this.contrato.ClienteID;
			this.$http.post('mis-contratos/php/api/setDatosCliente.php', this.datos).then(function (res) {
				_this2.$emit('actualizar', _this2.datos);
				_this2.cerrar();
			}).catch(this.$responseError);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firmar__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validaNIF__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_validaNIF___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_validaNIF__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato'],
	components: {
		Firma: __WEBPACK_IMPORTED_MODULE_0__firmar__["a" /* default */]
	},
	data: function data() {
		return {
			fase: 1,
			DNI: '',
			firmando: false
		};
	},

	computed: {
		DNIValido: function DNIValido() {
			return __WEBPACK_IMPORTED_MODULE_1__services_validaNIF___default()(this.DNI);
		}
	},
	methods: {
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		siguiente: function siguiente() {
			this.fase++;
		},
		anterior: function anterior() {
			this.fase--;
		},
		reset: function reset() {
			this.$refs.firma.reset();
		},
		firmar: function firmar() {
			this.$refs.firma.firmar();
		},
		setFirma: function setFirma(ev) {
			var _this = this;

			if ('geolocation' in navigator) {
				navigator.geolocation.getCurrentPosition(function (position) {
					if (position.coords.latitude && position.coords.longitude) {
						console.log('Posición: ');
						console.log(position);

						var form = {
							firmaCliente: ev,
							DNI: _this.DNI,
							lat: position.coords.latitude,
							long: position.coords.longitude,
							accuracy: position.coords.accuracy
						};

						_this.firmando = true;

						_this.$http.post('mis-contratos/php/api/firmar-contrato.php?ContratoID=' + _this.contrato.ContratoID, form, {
							responseType: 'arraybuffer',
							headers: {
								'Content-type': 'application/json',
								'Accept': 'application/pdf'
							}
						}).then(function (res) {
							_this.$emit('firmado');
						}).catch(function (e) {
							console.error(e);
							_this.$responseError(e);
							_this.firmando = false;
						});
					} else {
						_this.$error('Es necesaria la geolocalización para la firma manuscrita');
					}
				}, function () {
					_this.$error('Error', 'Es necesaria la geolocalización para la firma manuscrita');
				});
			} else {
				this.$error('Es necesaria la geolocalización para la firma manuscrita');
			}
		}
	}
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			ancho: 0,
			alto: 0,
			x: 0,
			y: 0,
			mensaje: null,
			presion: 0
		};
	},
	mounted: function mounted() {
		var _this = this;

		var canvas = this.$refs.canvas;
		var isMousedown = false;
		var context = canvas.getContext('2d');
		var lineWidth = 0;
		var points = [];
		var pressure = 0.1;
		this.getDim();
		canvas.width = canvas.offsetWidth;
		canvas.height = canvas.offsetHeight;['touchstart', 'mousedown'].forEach(function (ev) {
			canvas.addEventListener(ev, function (e) {
				var x, y;
				if (e.touches && e.touches[0]) {
					if (e.touches[0].force && e.touches[0]['force'] > 0) {
						pressure = e.touches[0]['force'];
					}
					var dim = _this.getOffset(e.target);
					x = e.touches[0].pageX - dim.left;
					y = e.touches[0].pageY - dim.top;
				} else {
					_this.mensaje = 'No touch';
					pressure = 0.2;
					x = e.layerX;
					y = e.layerY;
				}
				isMousedown = true;
				// lineWidth = (pressure * 50 * 0.8 + lineWidth * 0.2)
				context.lineWidth = lineWidth; // pressure * 50;
				context.strokeStyle = 'black';
				context.lineCap = 'round';
				context.lineJoin = 'round';
				context.beginPath();
				context.moveTo(x, y);
				points.push({
					x: x, y: y, lineWidth: lineWidth
				});

				_this.x = x;
				_this.y = y;
			});
		});['touchmove', 'mousemove'].forEach(function (ev) {
			canvas.addEventListener(ev, function (e) {
				if (!isMousedown) {
					_this.mensaje = 'No hay pulsación';
					return;
				}
				var x, y;
				if (e.touches && e.touches[0] && typeof e.touches[0]['force'] !== 'undefined') {
					if (e.touches[0]['force'] > 0) {
						pressure = e.touches[0]['force'];
					}
					var dim = _this.getOffset(e.target);
					x = e.touches[0].pageX - dim.left;
					y = e.touches[0].pageY - dim.top;
				} else {
					pressure = 0.2;
					x = e.layerX;
					y = e.layerY;
				}

				lineWidth = Math.log(pressure + 1) * 15 * 0.4 + lineWidth * 0.6;
				points.push({
					x: x, y: y, lineWidth: lineWidth
				});
				context.strokeStyle = 'black';
				context.lineCap = 'round';
				context.lineJoin = 'round';
				// context.lineWidth   = lineWidth// pressure * 50;
				// context.lineTo(x, y);
				// context.moveTo(x, y);
				if (points.length >= 3) {
					var l = points.length - 1;
					var xc = (points[l].x + points[l - 1].x) / 2;
					var yc = (points[l].y + points[l - 1].y) / 2;
					context.lineWidth = points[l - 1].lineWidth;
					context.quadraticCurveTo(points[l - 1].x, points[l - 1].y, xc, yc);
					context.stroke();
					context.beginPath();
					context.moveTo(xc, yc);
				}

				_this.presion = pressure;
				// $force.innerHTML = 'force = ' + pressure
				// $touches.innerHTML = 'touchev = ' + (e.touches ? JSON.stringify(e.touches[0]) : '')
				e.preventDefault();
				_this.x = x;
				_this.y = y;
			});
		});['touchend', 'touchleave', 'mouseup'].forEach(function (ev) {
			canvas.addEventListener(ev, function (e) {
				isMousedown = false;
				context.strokeStyle = 'black';
				context.lineCap = 'round';
				context.lineJoin = 'round';
				if (points.length >= 3) {
					var l = points.length - 1;
					context.quadraticCurveTo(points[l].x, points[l].y, _this.x, _this.y);
					context.stroke();
				}
				points = [];
				lineWidth = 0;
			});
		});
	},

	methods: {
		reset: function reset() {
			var canvas = this.$refs.canvas;
			var context = canvas.getContext('2d');
			context.clearRect(0, 0, canvas.width, canvas.height);
		},
		getOffset: function getOffset(el) {
			var dim = {
				top: 0,
				left: 0
			};

			do {
				dim.top += el.offsetTop || 0;
				dim.left += el.offsetLeft || 0;
				el = el.offsetParent;
			} while (el);
			return dim;
		},
		getDim: function getDim() {
			var canvas = this.$refs.canvas;
			this.ancho = canvas.offsetWidth;
			this.alto = canvas.offsetHeight;
		},
		firmar: function firmar() {
			var canvas = this.$refs.canvas;
			var img = canvas.toDataURL('image/png');
			this.$emit('firma', img);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__representarDatos__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mis_contratos_vue_components_visor_contrato_visor_contrato_vue__ = __webpack_require__(45);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['datos'],
	components: {
		'representar': __WEBPACK_IMPORTED_MODULE_2__representarDatos__["a" /* default */],
		VisorContrato: __WEBPACK_IMPORTED_MODULE_3__mis_contratos_vue_components_visor_contrato_visor_contrato_vue__["a" /* default */]
	},

	data: function data() {
		return {
			meses: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			seccion: 'real',
			ContratoID: null
		};
	},

	created: function created() {},


	computed: {
		json_data: function json_data() {
			var _this = this;

			if (!this.lineasFacturacion) {
				return [];
			}

			return this.lineasFacturacion.reduce(function (acum, contrato) {
				var item = {
					mes: _this.meses[contrato.fecha.getMonth()] + ', ' + contrato.fecha.getFullYear(),
					soporte: contrato.soporteNombre,
					cliente: contrato.clienteNombre,
					agente: contrato.agenteNombre,
					contrato: contrato.contratoTitulo,
					importe: _this.$options.filters.currency(contrato.importe)
				};
				acum.push(item);
				return acum;
			}, []);
		},
		json_fields: function json_fields() {
			if (!this.lineasFacturacion) {
				return {};
			}
			var f = {};

			f.mes = 'String';
			f.soporte = 'String';
			f.cliente = 'String';
			f.agente = 'String';
			f.contrato = 'String';
			f.importe = 'String';
			return f;
		},
		json_meta: function json_meta() {
			return [[{
				'key': 'charset',
				'value': 'utf-8'
			}]];
		},

		/**
   * Devuelve un array con la factuación procesada (rellenando con ceros los meses intermedios)
   */
		facturacion: function facturacion() {
			var arr = [];
			if (!this.datos) {
				return {};
			}

			var f = this.datos.facturacion;

			for (var i = 0; i < f.length; i++) {
				var fecha = new Date(parseInt(f[i].fecha) * 1000);
				var clave = new Date(fecha.getFullYear(), fecha.getMonth(), 1, 0, 0, 0, 0);

				var encontrado = false;
				for (var a = 0; a < arr.length; a++) {
					if (arr[a].fecha.getTime() === clave.getTime()) {
						arr[a].importe = arr[a].importe + parseFloat(f[i].importe);
						encontrado = true;
					}
				}

				if (!encontrado) {
					arr.push({
						fecha: clave,
						importe: parseFloat(f[i].importe),
						clienteNombre: f[i].clienteNombre,
						agenteNombre: f[i].agenteNombre,
						contratoTitulo: f[i].contratoTitulo
					});
				}
			}

			if (this.datos.fechas.fecha_fin !== this.datos.fechas.fecha_ini) {
				// Rellenamos
				var actual = this.datos.fechas.fecha_ini;

				do {
					var _encontrado = false;

					for (var _a = 0; _a < arr.length; _a++) {
						if (arr[_a].fecha.getTime() === actual.getTime()) {
							_encontrado = true;
						}
					}

					if (!_encontrado) {
						arr.push({
							fecha: actual,
							importe: 0
						});
					}

					var mes = actual.getMonth();
					var ano = actual.getFullYear();
					var nuevoMes = null;
					if (mes < 11) {
						nuevoMes = mes + 1;
					} else {
						nuevoMes = 0;
						ano = ano + 1;
					}

					actual = new Date(ano, nuevoMes, 1, 0, 0, 0, 0);
				} while (actual.getTime() < this.datos.fechas.fecha_fin.getTime());
			}

			// ordenamos por clave
			arr.sort(function (a, b) {
				if (a.fecha > b.fecha) {
					return 1;
				} else {
					return -1;
				}
			});

			return arr;
		},
		lineasFacturacion: function lineasFacturacion() {
			var arr = [];

			for (var i = 0; i < this.datos.facturacion.length; i++) {
				var f = this.datos.facturacion[i];
				var fecha = new Date(parseInt(f.fecha) * 1000);

				var nuevo = _.clone(f);
				nuevo.fecha = fecha;
				arr.push(nuevo);
			}
			return arr;
		},
		sumaFacturacion: function sumaFacturacion() {
			var importe = 0;
			for (var i = 0; i < this.datos.facturacion.length; i++) {
				importe += parseFloat(this.datos.facturacion[i].importe);
			}

			return importe;
		},
		labelsDatasetReal: function labelsDatasetReal() {
			var arr = [];
			for (var i = 0; i < this.facturacion.length; i++) {
				var label = this.meses[this.facturacion[i].fecha.getMonth()];
				if (arr.indexOf(label) < 0) {
					arr.push(label);
				}
			}
			return arr;
		},
		datasetReal: function datasetReal() {
			var ds = [];

			for (var i = 0; i < this.facturacion.length; i++) {
				var fecha = this.facturacion[i].fecha;
				var ano = fecha.getFullYear().toString();
				var mes = fecha.getMonth();
				var importe = parseFloat(this.facturacion[i].importe);

				var encontrado = false;
				for (var a = 0; a < ds.length; a++) {
					if (ds[a].label === ano) {
						encontrado = true;
						ds[a].data[mes] = typeof ds[a].data[mes] !== 'undefined' ? ds[a].data[mes] + importe : importe;
					}
				}

				if (!encontrado) {
					var color = this.getRandomColor();
					var nuevo = {
						label: ano,
						data: [],
						backgroundColor: color,
						borderColor: color,
						fill: false
					};
					nuevo.data[mes] = importe;
					ds.push(nuevo);
				}
			}

			return ds;
		},
		datosReal: function datosReal() {
			return {
				labels: this.labelsDatasetReal,
				datasets: this.datasetReal,
				tipo: 'barras'
			};
		},


		/**
   * TOTAL ANUAL
   */
		graficoAnual: function graficoAnual() {
			var datos = {};

			for (var i = 0; i < this.facturacion.length; i++) {
				var ano = this.facturacion[i].fecha.getFullYear().toString();
				var importe = parseFloat(this.facturacion[i].importe);

				if (!datos[ano]) {
					datos[ano] = importe;
				} else {
					datos[ano] = datos[ano] + importe;
				}
			}

			return datos;
		},
		datosRealTotal: function datosRealTotal() {
			return {
				tipo: 'barras',
				labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.graficoAnual),
				datasets: [{
					label: 'Total anual',
					data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.graficoAnual)
				}]
			};
		},


		/**
   * REAL ACUMULADO
   */

		datasetRealAcum: function datasetRealAcum() {
			var ds = [];

			for (var i = 0; i < this.facturacion.length; i++) {
				var fecha = this.facturacion[i].fecha;
				var ano = fecha.getFullYear().toString();
				var mes = fecha.getMonth();
				var importe = parseFloat(this.facturacion[i].importe);

				var encontrado = false;
				for (var a = 0; a < ds.length; a++) {
					if (ds[a].label === ano) {
						encontrado = a;
					}
				}

				if (encontrado === false) {
					var color = this.getRandomColor();
					var nuevo = {
						label: ano,
						data: [],
						backgroundColor: color,
						borderColor: color,
						fill: false
					};
					ds.push(nuevo);
					encontrado = ds.length - 1;
				}

				var m = mes;
				while (m <= 11) {
					ds[encontrado].data[m] = typeof ds[encontrado].data[m] === 'undefined' ? importe : ds[encontrado].data[m] + importe;
					m++;
				}
			}

			return ds;
		},
		datosRealAcumulado: function datosRealAcumulado() {
			return {
				tipo: 'lineas',
				labels: this.labelsDatasetReal,
				datasets: this.datasetRealAcum
			};
		}
	},

	methods: {
		setSeccion: function setSeccion(seccion) {
			this.seccion = seccion;
		},
		getRandomColor: function getRandomColor() {
			var letters = '0123456789ABCDEF';
			var color = '#';
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			return color;
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__verDetalles__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tablaIntervalo__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tablaComparativa__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'detalles-meses': __WEBPACK_IMPORTED_MODULE_2__verDetalles__["a" /* default */],
		'TablaIntervalo': __WEBPACK_IMPORTED_MODULE_3__tablaIntervalo__["a" /* default */],
		'TablaComparativa': __WEBPACK_IMPORTED_MODULE_4__tablaComparativa__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				tipoFecha: 'intervalo',
				clientes: [],
				tipoCliente: null,
				clientesAgente: null,
				soportes: [],
				campos: [],
				verEventos: true,
				partidas: [],
				fecha_ini: new Date(new Date().getFullYear(), 0, 1),
				fecha_fin: new Date(new Date().getFullYear(), 11, 1),
				soloPositivos: true
			},
			orden: {
				tipo: 'nombre',
				campo: 'nombre',
				sentido: 1
			},
			listadoSoportes: [],
			listadoPartidas: [],
			listadoCampos: [],
			resultados: null,
			detalles: null
		};
	},
	created: function created() {
		var _this = this;

		this.$store.watch(function (a) {
			return a.session.bloqueado;
		}, function (nuevo, viejo) {
			if (nuevo === false) {
				_this.getFormulario();
			}
		});

		this.getFormulario();
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	}), {
		resultadosClientes: function resultadosClientes() {
			var _this2 = this;

			if (!this.resultados) {
				return [];
			}
			if (this.orden.campo) {
				return [].concat(this.resultados.clientes).sort(function (a, b) {
					if (_this2.orden.tipo === 'campo') {
						if (a.campos[_this2.orden.campo].importe > b.campos[_this2.orden.campo].importe) {
							return _this2.orden.sentido;
						} else if (a.campos[_this2.orden.campo].importe < b.campos[_this2.orden.campo].importe) {
							return _this2.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this2.orden.tipo === 'soporte') {
						if (a.soportes[_this2.orden.campo].total.real > b.soportes[_this2.orden.campo].total.real) {
							return _this2.orden.sentido;
						} else if (a.soportes[_this2.orden.campo].total.real < b.soportes[_this2.orden.campo].total.real) {
							return _this2.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this2.orden.tipo === 'eventos') {
						if (a.eventos.importe > b.eventos.importe) {
							return _this2.orden.sentido;
						} else if (a.eventos.importe < b.eventos.importe) {
							return _this2.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this2.orden.tipo === 'nombre') {
						if (a.nombre > b.nombre) {
							return _this2.orden.sentido;
						} else if (a.nombre < b.nombre) {
							return _this2.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this2.orden.tipo === 'partida') {
						if (a.partidas[_this2.orden.campo].importe > b.partidas[_this2.orden.campo].importe) {
							return _this2.orden.sentido;
						} else if (a.partidas[_this2.orden.campo].importe < b.partidas[_this2.orden.campo].importe) {
							return _this2.orden.sentido * -1;
						} else {
							return 0;
						}
					}
				});
			} else {
				return this.resultados.clientes;
			}
		}
	}),

	methods: {
		getFormulario: function getFormulario() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getFormulario().then(function (res) {
				_this3.listadoSoportes = res.data.soportes;
				_this3.listadoPartidas = res.data.partidas;
				_this3.listadoCampos = res.data.campos;

				_this3.listadoCampos.forEach(function (campo) {
					_this3.toggleCampo(campo.ID);
				});

				_this3.listadoSoportes.forEach(function (soporte) {
					_this3.toggleSoporte(soporte.ID_soporte);
				});

				_this3.listadoPartidas.forEach(function (partida) {
					_this3.togglePartida(partida.ID_partida);
				});
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		toggleMisClientes: function toggleMisClientes() {
			this.filtro.clientesAgente = this.filtro.clientesAgente ? null : this.usuario;
		},
		toggleCampo: function toggleCampo(ID) {
			var i = this.filtro.campos.indexOf(ID);

			if (i >= 0) {
				this.filtro.campos.splice(i, 1);
				return;
			}

			this.filtro.campos.push(ID);
		},
		toggleSoporte: function toggleSoporte(ID) {
			var i = this.filtro.soportes.indexOf(ID);

			if (i >= 0) {
				this.filtro.soportes.splice(i, 1);
				return;
			}

			this.filtro.soportes.push(ID);
		},
		togglePartida: function togglePartida(ID) {
			var i = this.filtro.partidas.indexOf(ID);

			if (i >= 0) {
				this.filtro.partidas.splice(i, 1);
				return;
			}

			this.filtro.partidas.push(ID);
		},
		porAjente: function porAjente(d) {
			this.filtro.clientesAgente = d.datos;
			this.filtro.tipoCliente = null;
			this.filtro.clientes = [];
		},
		porTipo: function porTipo(d) {
			this.filtro.tipoCliente = d.datos;
			this.filtro.clientesAgente = null;
			this.filtro.clientes = [];
		},
		ponCliente: function ponCliente(d) {
			this.filtro.tipoCliente = null;
			this.filtro.clientesAgente = null;

			for (var i = 0; i < this.filtro.clientes.length; i++) {
				if (this.filtro.clientes[i].ID === d.datos.ID) {
					return;
				}
			}

			this.filtro.clientes.push(d.datos);
		},
		quitaCliente: function quitaCliente(ID) {
			for (var i = 0; i < this.filtro.clientes.length; i++) {
				if (this.filtro.clientes[i].ID === ID) {
					this.filtro.clientes.splice(i, 1);
					return;
				}
			}
		},
		consultar: function consultar() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].consultar(this.filtro).then(function (res) {
				if (!res.data.resultados.clientes || res.data.resultados.clientes.length === 0) {
					_this4.resultados = false;
					return;
				}
				_this4.resultados = res.data.resultados;
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verDetalles_vue__ = __webpack_require__(425);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a3cf2b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verDetalles_vue__ = __webpack_require__(992);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verDetalles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a3cf2b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verDetalles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['cliente', 'meses', 'tipo'],

	data: function data() {
		return {};
	},
	created: function created() {
		console.log(this.tipo);
		console.log(this.meses);
	},


	computed: {
		labelMeses: function labelMeses() {
			var m = [];

			for (var i in this.meses) {
				m.push(this.getMes(i));
			}

			return m;
		},
		chartData: function chartData() {
			var data = [];

			for (var i in this.meses) {
				data.push(this.meses[i].importe);
			}
			return data;
		},
		importeTotal: function importeTotal() {
			var total = 0;

			for (var i in this.meses) {
				total += this.meses[i].importe;
			}

			return total;
		}
	},

	methods: {
		getMes: function getMes(mes) {
			var d = new Date(parseInt(mes));
			var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
			return meses[d.getMonth()] + ', ' + d.getFullYear();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verDetalles__ = __webpack_require__(424);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['resultados'],
	components: {
		DetallesMeses: __WEBPACK_IMPORTED_MODULE_0__verDetalles__["a" /* default */]
	},
	data: function data() {
		return {
			detalles: null,
			orden: {
				tipo: 'nombre',
				campo: 'nombre',
				sentido: 1
			}
		};
	},

	computed: {
		resultadosClientes: function resultadosClientes() {
			var _this = this;

			if (!this.resultados) {
				return [];
			}
			if (this.orden.campo) {
				return [].concat(this.resultados.clientes).sort(function (a, b) {
					if (_this.orden.tipo === 'campo') {
						if (a.campos[_this.orden.campo].importe > b.campos[_this.orden.campo].importe) {
							return _this.orden.sentido;
						} else if (a.campos[_this.orden.campo].importe < b.campos[_this.orden.campo].importe) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this.orden.tipo === 'soporte') {
						if (a.soportes[_this.orden.campo].total.real > b.soportes[_this.orden.campo].total.real) {
							return _this.orden.sentido;
						} else if (a.soportes[_this.orden.campo].total.real < b.soportes[_this.orden.campo].total.real) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this.orden.tipo === 'eventos') {
						if (a.eventos.importe > b.eventos.importe) {
							return _this.orden.sentido;
						} else if (a.eventos.importe < b.eventos.importe) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this.orden.tipo === 'nombre') {
						if (a.nombre > b.nombre) {
							return _this.orden.sentido;
						} else if (a.nombre < b.nombre) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this.orden.tipo === 'partida') {
						if (a.partidas[_this.orden.campo].importe > b.partidas[_this.orden.campo].importe) {
							return _this.orden.sentido;
						} else if (a.partidas[_this.orden.campo].importe < b.partidas[_this.orden.campo].importe) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					}
				});
			} else {
				return this.resultados.clientes;
			}
		},
		json_data: function json_data() {
			if (!this.resultados) {
				return [];
			}

			var arr = [];

			for (var i = 0; i < this.resultados.clientes.length; i++) {
				var cliente = this.resultados.clientes[i];
				var obj = {};
				obj.cliente = cliente.nombre;

				for (var k in cliente.campos) {
					obj[k] = cliente.campos[k].importe.toString().replace('.', ',');
				}

				for (var _k in cliente.soportes) {
					obj[cliente.soportes[_k].nombre] = cliente.soportes[_k].total.real.toString().replace('.', ',');
				}

				if (cliente.eventos) {
					obj['eventos'] = cliente.eventos.importe.toString().replace('.', ',');
				}

				for (var _k2 in cliente.partidas) {
					obj[cliente.partidas[_k2].nombre] = cliente.partidas[_k2].importe.toString().replace('.', ',');
				}

				arr.push(obj);
			}

			return arr;
		},
		json_fields: function json_fields() {
			if (!this.resultados) {
				return {};
			}
			var f = {};

			f.cliente = 'Number';
			for (var k in this.resultados.clientes[0].campos) {
				f[k] = 'Number';
			}

			for (var _k3 in this.resultados.clientes[0].soportes) {
				var nombre = this.resultados.clientes[0].soportes[_k3].nombre;
				f[nombre] = 'Number';
			}

			if (this.resultados.clientes[0].eventos) {
				f['eventos'] = 'Number';
			}

			for (var _k4 in this.resultados.clientes[0].partidas) {
				var _nombre = this.resultados.clientes[0].partidas[_k4].nombre;
				f[_nombre] = 'Number';
			}
			return f;
		},
		json_meta: function json_meta() {
			return [[{
				'key': 'charset',
				'value': 'utf-8'
			}]];
		}
	},
	methods: {
		ordenar: function ordenar(tipo, campo) {
			this.orden.tipo = tipo;
			if (this.orden.campo === campo) {
				this.orden.sentido = this.orden.sentido * -1;
			} else {
				this.orden.campo = campo;
				this.orden.sentido = 1;
			}
		},
		verDetalles: function verDetalles(cliente, meses, tipo) {
			this.detalles = {
				cliente: cliente,
				meses: meses,
				tipo: tipo,
				fechas: this.resultados.fechas
			};
		},
		verDetallesSoporte: function verDetallesSoporte(cliente, meses, tipo) {
			var m = {};

			for (var i = 0; i < meses.length; i++) {
				m[meses[i].mes] = { importe: meses[i].real };
			}

			this.verDetalles(cliente, m, tipo);
		}
	}
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__verDetallesComparados__ = __webpack_require__(998);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['resultados'],
	components: {
		DetallesMeses: __WEBPACK_IMPORTED_MODULE_3__verDetallesComparados__["a" /* default */]
	},
	data: function data() {
		return {
			detalles: null,
			orden: {
				tipo: 'nombre',
				campo: 'nombre',
				sentido: 1
			}
		};
	},

	computed: {
		anos: function anos() {
			var mapa = this.resultados.clientes.reduce(function (anos, resul) {
				if (resul.campos && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(resul.campos) === 'object') {
					for (var campo in resul.campos) {
						for (var mes in resul.campos[campo].meses) {
							var ano = new Date(parseInt(mes)).getFullYear();
							if (!anos.has(ano)) {
								anos.set(ano, ano);
							}
						}
					}
				} else if (resul.eventos && resul.eventos.meses) {
					for (var _mes in resul.eventos.meses) {
						var _ano = new Date(parseInt(_mes)).getFullYear();
						if (!anos.has(_ano)) {
							anos.set(_ano, _ano);
						}
					}
				} else if (resul.partidas && Array.isArray(resul.partidas)) {
					for (var i = 0; i < resul.partidas.length; i++) {
						anos = resul.partidas[i].meses.reduce(function (datos, mes) {
							var ano = new Date(parseInt(mes)).getFullYear();
							if (!anos.has(ano)) {
								anos.set(ano, ano);
							}
						}, anos);
					}
				}
				return anos;
			}, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a());
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(mapa).map(function (a) {
				return a[0];
			}).sort();
		},
		resultadosClientes: function resultadosClientes() {
			var _this = this;

			if (!this.resultados) {
				return [];
			}
			if (this.orden.campo) {
				var clientes = [].concat(this.resultados.clientes).sort(function (a, b) {
					if (_this.orden.tipo === 'campo') {
						if (a.campos[_this.orden.campo].importe > b.campos[_this.orden.campo].importe) {
							return _this.orden.sentido;
						} else if (a.campos[_this.orden.campo].importe < b.campos[_this.orden.campo].importe) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this.orden.tipo === 'soporte') {
						if (a.soportes[_this.orden.campo].total.real > b.soportes[_this.orden.campo].total.real) {
							return _this.orden.sentido;
						} else if (a.soportes[_this.orden.campo].total.real < b.soportes[_this.orden.campo].total.real) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this.orden.tipo === 'eventos') {
						if (a.eventos.importe > b.eventos.importe) {
							return _this.orden.sentido;
						} else if (a.eventos.importe < b.eventos.importe) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this.orden.tipo === 'nombre') {
						if (a.nombre > b.nombre) {
							return _this.orden.sentido;
						} else if (a.nombre < b.nombre) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					} else if (_this.orden.tipo === 'partida') {
						if (a.partidas[_this.orden.campo].importe > b.partidas[_this.orden.campo].importe) {
							return _this.orden.sentido;
						} else if (a.partidas[_this.orden.campo].importe < b.partidas[_this.orden.campo].importe) {
							return _this.orden.sentido * -1;
						} else {
							return 0;
						}
					}
				});

				// Ahora tenemos que separar por los años
				return clientes.reduce(function (ant, cliente) {
					if (cliente.campos) {
						var _loop = function _loop(campo) {
							cliente.campos[campo].anos = _this.anos.reduce(function (acum, ano) {
								var anoActual = { importe: 0, importes: [], ano: ano, meses: new Array(12).fill(0, 0) };
								for (var mes in cliente.campos[campo].meses) {
									var importe = parseFloat(cliente.campos[campo].meses[mes].importe);
									var fecha = new Date(parseInt(mes));
									if (fecha.getFullYear() === ano) {
										if (!isNaN(importe)) {
											anoActual.importes.push(importe);
											anoActual.importe = anoActual.importe + importe;
											anoActual.meses[fecha.getMonth()] += importe;
										}
									}
								}
								acum.push(anoActual);
								return acum;
							}, []).sort(function (a, b) {
								if (a.ano > b.ano) {
									return 1;
								} else {
									return -1;
								}
							});
						};

						for (var campo in cliente.campos) {
							_loop(campo);
						}
					}
					if (cliente.soportes && cliente.soportes.length > 0) {
						cliente.soportes = cliente.soportes.reduce(function (acum, soporte) {
							soporte.anos = _this.anos.reduce(function (anos, ano) {
								var anoActual = { importe: 0, importes: [], ano: ano, meses: new Array(12).fill(0, 0) };
								for (var m in soporte.meses) {
									var mes = soporte.meses[m];
									var fecha = new Date(parseInt(mes.mes));
									if (ano === fecha.getFullYear()) {
										var importe = mes.real;
										anoActual.importe = anoActual.importe + importe;
										anoActual.importes.push(importe);
										anoActual.meses[fecha.getMonth()] += importe;
									}
								}
								anos.push(anoActual);
								return anos;
							}, []).sort(function (a, b) {
								if (a.ano > b.ano) {
									return 1;
								} else {
									return -1;
								}
							});
							acum.push(soporte);
							return acum;
						}, []);
					}

					if (cliente.eventos) {
						cliente.eventos.anos = _this.anos.reduce(function (anos, ano) {
							var anoActual = { importe: 0, importes: [], ano: ano, meses: new Array(12).fill(0, 0) };
							for (var m in cliente.eventos.meses) {
								var importe = cliente.eventos.meses[m].importe;
								var fecha = new Date(parseInt(m));
								if (ano === fecha.getFullYear()) {
									anoActual.importe = anoActual.importe + importe;
									anoActual.importes.push(importe);
									anoActual.meses[fecha.getMonth()] += importe;
								}
							}
							anos.push(anoActual);
							return anos;
						}, []).sort(function (a, b) {
							if (a.ano > b.ano) {
								return 1;
							} else {
								return -1;
							}
						});
					}

					if (cliente.partidas && cliente.partidas.length > 0) {
						cliente.partidas = cliente.partidas.reduce(function (acum, partida) {
							partida.anos = _this.anos.reduce(function (anos, ano) {
								var anoActual = { importe: 0, importes: [], ano: ano, meses: new Array(12).fill(0, 0) };
								for (var m in partida.meses) {
									var importe = partida.meses[m].importe;
									var fecha = new Date(parseInt(m));
									if (ano === fecha.getFullYear()) {
										anoActual.importe = anoActual.importe + importe;
										anoActual.importes.push(importe);
										anoActual.meses[fecha.getMonth()] += importe;
									}
								}
								anos.push(anoActual);
								return anos;
							}, []).sort(function (a, b) {
								if (a.ano > b.ano) {
									return 1;
								} else {
									return -1;
								}
							});
							acum.push(partida);
							return acum;
						}, []);
					}

					ant.push(cliente);
					return ant;
				}, []);
			} else {
				return this.resultados.clientes;
			}
		},
		json_data: function json_data() {
			if (!this.resultadosClientes) {
				return [];
			}

			var arr = [];

			for (var i = 0; i < this.resultadosClientes.length; i++) {
				var cliente = this.resultadosClientes[i];
				var obj = {};
				obj.cliente = cliente.nombre;

				if (cliente.campos) {
					for (var k in cliente.campos) {
						for (var a in cliente.campos[k].anos) {
							var ano = cliente.campos[k].anos[a];
							obj[k + ' ' + ano.ano] = ano.importe.toString().replace('.', ',');
						}
					}
				}

				if (cliente.soportes) {
					for (var _k in cliente.soportes) {
						for (var _a in cliente.soportes[_k].anos) {
							var _ano2 = cliente.soportes[_k].anos[_a];
							obj[cliente.soportes[_k].nombre + ' ' + _ano2.ano] = _ano2.importe.toString().replace('.', ',');
						}
					}
				}

				if (cliente.eventos) {
					for (var _a2 in cliente.eventos.anos) {
						var _ano3 = cliente.eventos.anos[_a2];
						obj['eventos ' + _ano3.ano] = _ano3.importe.toString().replace('.', ',');
					}
				}

				if (cliente.partidas) {
					for (var _k2 in cliente.partidas) {
						for (var _a3 in cliente.partidas[_k2].anos) {
							var _ano4 = cliente.partidas[_k2].anos[_a3];
							obj[cliente.partidas[_k2].nombre + ' ' + _ano4.ano] = _ano4.importe.toString().replace('.', ',');
						}
					}
				}

				arr.push(obj);
			}

			return arr;
		},
		json_fields: function json_fields() {
			if (!this.resultados) {
				return {};
			}
			var f = {};

			var cliente = this.resultadosClientes[0];

			f.cliente = 'Number';
			for (var k in cliente.campos) {
				for (var a in cliente.campos[k].anos) {
					var ano = cliente.campos[k].anos[a];
					f[k + ' ' + ano.ano] = 'Number';
				}
			}

			for (var _k3 in cliente.soportes) {
				var nombre = cliente.soportes[_k3].nombre;
				for (var _a4 in cliente.soportes[_k3].anos) {
					var _ano5 = cliente.soportes[_k3].anos[_a4];
					f[nombre + ' ' + _ano5.ano] = 'Number';
				}
			}

			if (cliente.eventos) {
				for (var _a5 in cliente.eventos.anos) {
					var _ano6 = cliente.eventos.anos[_a5];
					f['eventos ' + _ano6.ano] = 'Number';
				}
			}

			for (var _k4 in cliente.partidas) {
				var _nombre = cliente.partidas[_k4].nombre;
				for (var _a6 in cliente.partidas[_k4].anos) {
					var _ano7 = cliente.partidas[_k4].anos[_a6];
					f[_nombre + ' ' + _ano7.ano] = 'Number';
				}
			}
			return f;
		},
		json_meta: function json_meta() {
			return [[{
				'key': 'charset',
				'value': 'utf-8'
			}]];
		}
	},
	methods: {
		ordenar: function ordenar(tipo, campo) {
			this.orden.tipo = tipo;
			if (this.orden.campo === campo) {
				this.orden.sentido = this.orden.sentido * -1;
			} else {
				this.orden.campo = campo;
				this.orden.sentido = 1;
			}
		},
		verDetalles: function verDetalles(cliente, anos, tipo) {
			this.detalles = {
				cliente: cliente,
				anos: anos,
				tipo: tipo,
				fechas: this.resultados.fechas
			};
		},
		verDetallesSoporte: function verDetallesSoporte(cliente, anos, tipo) {
			this.verDetalles(cliente, anos, tipo);
			// const m = {}

			// for (let i = 0; i < meses.length; i++) {
			// 	m[meses[i].mes] = {importe: meses[i].real}
			// }

			// this.verDetalles(cliente, m, tipo)
		}
	}
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['cliente', 'anos', 'tipo'],

	data: function data() {
		return {};
	},


	computed: {
		labelMeses: function labelMeses() {
			var m = [];

			for (var i = 0; i < 12; i++) {
				m.push(this.getMes(i));
			}

			return m;
		},
		chartData: function chartData() {
			/**
    *  label: ano,
   	data: [],
   	backgroundColor: color,
   	borderColor: color,
   	fill: false
    */
			var sets = [];
			for (var i in this.anos) {
				var color = this.getRandomColor();
				var set = {
					label: this.anos[i].ano,
					data: [],
					backgroundColor: color,
					borderColor: color,
					fill: false
				};
				for (var m = 0; m < this.anos[i].meses.length; m++) {
					set.data.push(this.anos[i].meses[m]);
				}
				sets.push(set);
			}
			return sets;
		},
		importeTotal: function importeTotal() {
			var total = 0;

			for (var i in this.anos) {
				total += this.anos[i].importe;
			}

			return total;
		}
	},

	methods: {
		getMes: function getMes(mes) {
			var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
			return meses[mes];
		},
		getRandomColor: function getRandomColor() {
			var letters = '0123456789ABCDEF';
			var color = '#';
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			return color;
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	created: function created() {
		var _this = this;

		var menu = [{
			'icono': 'fa fa-map',
			'nombre': 'Mapa',
			activo: false,
			callback: function callback(a) {
				_this.setMenuActivo(a);
				_this.$router.push('/main/control-emisoras/mapa');
			}
		}];
		this.setMenu(menu);
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
		setMenu: 'top/setMenu',
		setMenuActivo: 'top/setMenuActivo',
		clearMenu: 'top/clearMenu'
	}))
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var iconBase = 'https://sip.radiocastellon.com/src/modulos/control-emisoras/static/png/';
/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			alto: null,
			emisora: null,
			listado: [],
			filtro: {
				emisoras: [],
				CoberturaMinima: 0,
				CoberturaMaxima: 5
			},
			marcadores: [],
			heatmap: null,
			iconos: {
				0: {
					icon: iconBase + 'zero.png'
				},
				1: {
					icon: iconBase + 'one.png'
				},
				2: {
					icon: iconBase + 'two.png'
				},
				3: {
					icon: iconBase + 'three.png'
				},
				4: {
					icon: iconBase + 'four.png'
				},
				5: {
					icon: iconBase + 'five.png'
				},
				6: {
					icon: iconBase + 'six.png'
				},
				7: {
					icon: iconBase + 'seven.png'
				},
				8: {
					icon: iconBase + 'eight.png'
				},
				9: {
					icon: iconBase + 'nine.png'
				},
				10: {
					icon: iconBase + 'ten.png'
				}
			}
		};
	},
	created: function created() {
		// Calculamos las dimensiones
		this.calcular();
		window.addEventListener('resize', this.calcular);
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('resize', this.calcular);
	},
	mounted: function mounted() {
		var _this = this;

		var initMap = function initMap() {
			// eslint-disable-next-line
			_this.map = new google.maps.Map(document.getElementById('map'), {
				center: { lat: 39.986038, lng: -0.036070 },
				zoom: 12,
				zoomControl: false,
				minZoom: 11,
				maxZoom: 13
			});
		};
		initMap();
	},

	methods: {
		calcular: function calcular() {
			this.alto = window.innerHeight - 120;
		},
		quitarEmisora: function quitarEmisora() {
			this.emisora = null;
		},
		seleccionaEmisora: function seleccionaEmisora(ev) {
			this.emisora = ev.datos;
			this.filtro.emisoras = [ev.datos.EmisoraID];
			this.getCoberturas();
		},
		limpiarMapa: function limpiarMapa(cb) {
			for (var i = 0; i < this.marcadores.length; i++) {
				this.marcadores[i].setMap(null);
			}

			if (this.heatmap) {
				this.heatmap.setMap(null);
			}

			if (cb) {
				window.setTimeout(function () {
					cb();
				}, 100);
			}
		},
		getCoberturas: function getCoberturas(ev) {
			var _this2 = this;

			if (!this.emisora) {
				this.$error('Error', 'Selecciona una emisora');
				return;
			}
			if (typeof this.filtro.CoberturaMinima !== 'number' || this.filtro.CoberturaMinima < 0 || this.filtro.CoberturaMinima > 10) {
				this.$error('Error', 'La cobertura mínima debe ser un número entre 0 y 10');
				return;
			}

			if (typeof this.filtro.CoberturaMaxima !== 'number' || this.filtro.CoberturaMaxima < 0 || this.filtro.CoberturaMaxima > 10) {
				this.$error('Error', 'La cobertura máxima debe ser un número entre 0 y 10');
				return;
			}

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.CoberturaMinima = typeof form.CoberturaMinima === 'number' ? form.CoberturaMinima * 10 : 0;
			form.CoberturaMaxima = typeof form.CoberturaMaxima === 'number' ? form.CoberturaMaxima * 10 : 100;

			this.limpiarMapa(function () {
				_this2.$http.post('control-emisoras/php/api/buscar.php', form).then(function (res) {
					var resultados = res.data.filter(function (r) {
						return r.latitud && r.longitud;
					}).map(function (r) {
						var puntuacion = Math.round(r.calidad);
						r.Icono = puntuacion;
						r.Nombre = r.municipio;
						var pos = {
							// eslint-disable-next-line
							position: new google.maps.LatLng(r.latitud, r.longitud),
							Nombre: r.Nombre,
							type: r.Icono,
							weight: r.calidad
						};
						return pos;
					});

					var heatmapData = resultados.reduce(function (accum, result) {
						var data = {
							location: result.position,
							weight: result.weight
						};
						accum.push(data);
						return accum;
					}, []);
					/*
     for (let i = 0; i < resultados.length; i++) {
     	// eslint-disable-next-line
     	this.marcadores.push(new google.maps.Marker({
     		position: resultados[i].position,
     		icon: this.iconos[resultados[i].type].icon,
     		title: resultados[i].Nombre,
     		map: this.map
     	}))
     }
     */
					// eslint-disable-next-line no-undef
					_this2.heatmap = new google.maps.visualization.HeatmapLayer({
						data: heatmapData,
						radius: 20
					});
					_this2.heatmap.setMap(_this2.map);
				}).catch(function (e) {
					console.error(e);
					_this2.$responseError(e);
				});
			});
		}
	}
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mi_perfil_cambio_pass_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__restore__ = __webpack_require__(1011);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'login',
	components: {
		'cambio-pass': __WEBPACK_IMPORTED_MODULE_2__mi_perfil_cambio_pass_vue__["a" /* default */],
		'restore-pass': __WEBPACK_IMPORTED_MODULE_3__restore__["a" /* default */]
	},
	data: function data() {
		return {
			form: {
				usuario: '',
				password: '',
				token: '',
				recordar: false
			},
			fase: 'login',
			strNow: new Date().getTime().toString()
		};
	},

	created: function created() {
		var _this = this;

		this.$store.watch(function (a) {
			return a.session.cambioPass;
		}, function (nuevo) {
			console.log(nuevo);
			if (nuevo === true) {
				_this.fase = 'cambiopass';
			} else {
				_this.fase = 'login';
			}
		});

		this.$store.dispatch('session/getSesion');
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		externo: ['session/externo'],
		requiere2fa: ['session/requiere2fa'],
		cambiarPass: ['session/cambiarPass']
	})),

	methods: {
		login: function login() {
			this.$store.dispatch('session/login', this.form);
		}
	}
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			form: {
				usuario: ''
			}
		};
	},


	methods: {
		iniciar: function iniciar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('core/php/api/password-restore/restore.php', this.form).then(function (res) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Correcto',
					mensaje: 'Se te ha enviado un e-mail con instrucciones para restaurar tu contraseña'
				});
				_this.cerrar();
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			form: {
				idUsuario: null,
				token: null,
				password: '',
				password2: ''
			}
		};
	},
	created: function created() {
		// Ahora obtenemos de la ruta las variables
		this.form.idUsuario = this.$route.params.idUsuario;
		this.form.token = this.$route.params.token;
	},


	methods: {
		cambiar: function cambiar() {
			var _this = this;

			if (this.form.password !== this.form.password2) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Las contraseñas no coinciden'
				});
				return;
			}
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('core/php/api/password-restore/update.php', this.form).then(function (res) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Contraseña actualizada',
					mensaje: 'Se ha actualizado tu contrase\xF1a correctamente.',
					callback: function callback() {
						_this.$router.push('/login');
					}
				});
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33bb31aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1054);
function injectStyle (ssrContext) {
  __webpack_require__(1017)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33bb31aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33bb31aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__componentes_nueva_nuevaPublicacion__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__componentes_publicacion_publicacion_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__componentes_publicacion_modalPublicacion__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__componentes_alertas_alertas_del_dia__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__componentes_changelog_change_log__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__componentes_calendario_calendario__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		nuevaPublicacion: __WEBPACK_IMPORTED_MODULE_1__componentes_nueva_nuevaPublicacion__["a" /* default */],
		publicacion: __WEBPACK_IMPORTED_MODULE_2__componentes_publicacion_publicacion_vue__["a" /* default */],
		ModalPublicacion: __WEBPACK_IMPORTED_MODULE_3__componentes_publicacion_modalPublicacion__["a" /* default */],
		AlertasDelDia: __WEBPACK_IMPORTED_MODULE_4__componentes_alertas_alertas_del_dia__["a" /* default */],
		ChangeLog: __WEBPACK_IMPORTED_MODULE_5__componentes_changelog_change_log__["a" /* default */],
		Calendario: __WEBPACK_IMPORTED_MODULE_6__componentes_calendario_calendario__["a" /* default */]
	},
	data: function data() {
		return {
			adjuntarFicheros: false,
			nueva: {
				PublicacionID: null,
				ficheros: [],
				mensaje: null,
				encuesta: null,
				youtube: null
			},
			abrir_publicar: false
		};
	},
	created: function created() {
		this.getPublicaciones();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])({
		publicaciones: 'muro/publicaciones'
	}), {
		ultimoID: function ultimoID() {
			if (this.publicaciones.length === 0) {
				return null;
			}
			return this.publicaciones[this.publicaciones.length - 1].PublicacionID;
		}
	}),
	methods: {
		getPublicaciones: function getPublicaciones() {
			this.$store.dispatch('muro/getPublicaciones', this.ultimoID);
		}
	}
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editorEncuesta__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buscarGifs__ = __webpack_require__(1022);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		abrir_publicar: Boolean
	},
	components: {
		EditorEncuesta: __WEBPACK_IMPORTED_MODULE_2__editorEncuesta__["a" /* default */],
		BuscarGifs: __WEBPACK_IMPORTED_MODULE_3__buscarGifs__["a" /* default */]
	},
	data: function data() {
		return {
			nueva: {
				PublicacionID: null,
				Mensaje: '',
				Archivos: [],
				Gifs: [],
				Encuestas: [],
				Youtube: []
			},
			panelGifs: false,
			videoOver: null,
			editarEncuesta: false
		};
	},

	computed: {
		formValido: function formValido() {
			if (!this.nueva.Mensaje) {
				return false;
			}
			return true;
		},
		hayAdjuntos: function hayAdjuntos() {
			return this.nueva.Archivos && this.nueva.Archivos.length > 0 || this.nueva.Encuestas && this.nueva.Encuestas.length > 0 || this.nueva.Youtube && this.nueva.Youtube.length;
		}
	},
	methods: {
		adjuntar: function adjuntar() {
			var _this = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.multiple = true;
			inp.addEventListener('change', function (ev) {
				for (var i = 0; i < inp.files.length; i++) {
					_this.nueva.Archivos.push(inp.files[i]);
				}

				document.body.removeChild(inp);
			});
			document.body.appendChild(inp);
			inp.click();
		},
		eliminarGif: function eliminarGif(i) {
			this.nueva.Gifs.splice(i, 1);
		},
		eliminarArchivo: function eliminarArchivo(i) {
			this.nueva.Archivos.splice(i, 1);
		},
		analizarMensaje: function analizarMensaje() {
			var _this2 = this;

			// Buscamos enlaces de youtube
			var enlaceYoutube = /https:\/\/www\.youtube\.com\/[^\s]*v=([\w\d_-]+)/igm;
			var enlaces = this.nueva.Mensaje.match(enlaceYoutube);
			var encontrados = [];
			if (enlaces) {
				var expID = /v=([\w\d_-]*)/;
				enlaces.forEach(function (e) {
					if (e) {
						var id = expID.exec(e);
						if (id) {
							if (_this2.nueva.Youtube.indexOf(id[1]) < 0) {
								encontrados.push(id[1]);
							}
						}
					}
				});
			}

			this.nueva.Youtube = this.nueva.Youtube.concat(encontrados);
		},
		quitarVideo: function quitarVideo(id) {
			var i = this.nueva.Youtube.indexOf(id);

			if (i >= 0) {
				this.nueva.Youtube.splice(i, 1);
			}
		},
		addEncuesta: function addEncuesta(datos) {
			// Comprobamos si ya existe la encuesta
			for (var i = 0; i < this.nueva.Encuestas.length; i++) {
				if (this.nueva.Encuestas[i].EncuestaID === datos.EncuestaID) {
					this.nueva.Encuestas[i] = datos;
					return;
				}
			}

			this.nueva.Encuestas.push(datos);
		},
		delEncuesta: function delEncuesta(i) {
			this.nueva.Encuestas.splice(i, 1);
		},
		publicar: function publicar() {
			var _this3 = this;

			var form = new FormData();
			if (this.nueva.Archivos.length > 0) {
				for (var i = 0; i < this.nueva.Archivos.length; i++) {
					form.append('ficheros[]', this.nueva.Archivos[i]);
				}
			}

			var datos = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.nueva));
			delete datos.Archivos;
			form.append('datos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(datos));

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('muro/php/api/setPublicacion.php', form, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				_this3.$store.commit('muro/ADD_PUBLICACION', res.data);

				_this3.nueva = {
					PublicacionID: null,
					Mensaje: '',
					Archivos: [],
					Encuestas: [],
					Youtube: [],
					Gifs: []
				};
				_this3.$emit('cerrarPublicar');
			}).catch(function (e) {
				console.error(e.response.data);
			});
		}
	}
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['encuesta'],
	data: function data() {
		return {
			editor: {
				EncuestaID: null,
				FechaFinalizacion: null,
				Titulo: '',
				Opciones: []
			}
		};
	},

	computed: {
		encuestaValida: function encuestaValida() {
			if (this.editor.Titulo.trim() === '') {
				return false;
			}

			if (this.editor.Opciones.length < 2) {
				return false;
			}

			// si las opciones no son válidas...
			for (var i = 0; i < this.editor.Opciones.length; i++) {
				if (this.editor.Opciones[i].trim() === '') {
					return false;
				}
			}

			return true;
		}
	},
	created: function created() {
		if (typeof this.encuesta === 'boolean') {
			console.log('Es una encuesta nueva');
			this.editor.EncuestaID = 'N' + new Date().getTime() + Math.floor(Math.random() * 1000);
			this.editor.FechaFinalizacion = null;
		} else if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.encuesta) === 'object') {
			// Estamos editando
			this.editor = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.encuesta));
			this.editor.FechaFinalizacion = typeof this.encuesta.FechaFinalizacion === 'string' ? new Date(this.encuesta.FechaFinalizacion) : null;
		}
	},

	methods: {
		nuevaOpcion: function nuevaOpcion() {
			this.editor.Opciones.push('');
		},
		quitarOpcion: function quitarOpcion(i) {
			this.editor.Opciones.splice(i, 1);
		},
		guardar: function guardar() {
			this.$emit('updated', this.editor);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			cadena: null,
			resultados: []
		};
	},

	methods: {
		buscar: function buscar() {
			var _this = this;

			this.$http.post('muro/php/api/buscaGifs.php', { q: this.cadena }).then(function (res) {
				_this.resultados = res.data.data;
			}).catch(function (e) {
				console.error(e);
			});
		},
		adjuntar: function adjuntar(gif) {
			this.$emit('adjuntar', gif);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_publicacion_vue__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1181080_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_publicacion_vue__ = __webpack_require__(1039);
function injectStyle (ssrContext) {
  __webpack_require__(1026)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1181080"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_publicacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1181080_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_publicacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contenidoMultimedia__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contenidoEncuesta__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contenidoArchivo__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__comentarios__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['publicacion'],
	data: function data() {
		return {
			claseLike: 'fa-thumbs-o-up',
			claseDislike: 'fa-thumbs-o-down',
			claseComments: 'fa-comments-o',
			verMenu: false
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		numLikes: function numLikes() {
			return this.publicacion.Reacciones.reduce(function (ant, reaccion) {
				if (reaccion.Reaccion === 'like') {
					ant++;
				}
				return ant;
			}, 0);
		},
		numDislikes: function numDislikes() {
			return this.publicacion.Reacciones.reduce(function (ant, reaccion) {
				if (reaccion.Reaccion === 'dislike') {
					ant++;
				}
				return ant;
			}, 0);
		}
	}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	})),
	components: {
		'comentarios': __WEBPACK_IMPORTED_MODULE_4__comentarios__["a" /* default */],
		'contenido-multimedia': __WEBPACK_IMPORTED_MODULE_1__contenidoMultimedia__["a" /* default */],
		'contenido-encuesta': __WEBPACK_IMPORTED_MODULE_2__contenidoEncuesta__["a" /* default */],
		'contenido-archivo': __WEBPACK_IMPORTED_MODULE_3__contenidoArchivo__["a" /* default */]
	},
	methods: {
		togglePin: function togglePin() {
			var _this = this;

			var datos = {
				PublicacionID: this.publicacion.PublicacionID,
				MantenerArriba: !this.publicacion.MantenerArriba
			};
			__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('muro/php/api/setMantenerArriba.php', datos).then(function () {
				// Recargamos
				_this.$store.dispatch('muro/recargar');
				_this.verMenu = false;
			}).catch(function (e) {
				console.error(e.response.data.error);
			});
		},
		eliminar: function eliminar() {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar publicación',
				mensaje: '\xBFQuieres eliminar esta publicaci\xF3n?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('muro/php/api/delPublicacion.php', { PublicacionID: _this2.publicacion.PublicacionID }).then(function () {
							_this2.$store.dispatch('muro/recargar');
							_this2.verMenu = false;
						}).catch(function (e) {
							console.error(e.response.data.error);
						});
					}
				}
			});
		},
		over: function over(tipo) {
			if (tipo === 'like') {
				this.claseLike = 'fa-thumbs-up text-danger';
			} else if (tipo === 'dislike') {
				this.claseDislike = 'fa-thumbs-down text-danger';
			} else if (tipo === 'comments') {
				this.claseComments = 'fa-comments text-danger';
			}
		},
		leave: function leave(tipo) {
			if (tipo === 'like') {
				this.claseLike = 'fa-thumbs-o-up';
			} else if (tipo === 'dislike') {
				this.claseDislike = 'fa-thumbs-o-down';
			} else if (tipo === 'comments') {
				this.claseComments = 'fa-comments-o';
			}
		},
		reaccionar: function reaccionar(Reaccion) {
			var _this3 = this;

			var datos = {
				PublicacionID: this.publicacion.PublicacionID,
				Reaccion: Reaccion
			};

			__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('muro/php/api/reaccionar.php', datos).then(function () {
				_this3.$store.dispatch('muro/actualizarPublicacion', _this3.publicacion.PublicacionID);
			}).catch(function (e) {
				console.error(e);
			});
		}
	}
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['datos'],
	data: function data() {
		return {
			i: 0,
			anchoContainer: 0,
			estiloWrapper: {}
		};
	},

	computed: {
		imagenes: function imagenes() {
			var _this = this;

			var imagenes = this.datos.Archivos.filter(function (ar) {
				return ar.Tipo === 'imagen' || ar.Tipo === 'video';
			});
			imagenes = imagenes.map(function (im) {
				im.estilo = {
					width: _this.anchoContainer + 'px'
				};

				if (im.Tipo === 'imagen') {
					im.src = '/src/modulos/muro/php/api/verImagen.php?ArchivoID=' + im.ArchivoID;
					im.estilo.backgroundImage = 'url(' + im.src + ')';
				} else if (im.Tipo === 'video') {
					im.src = '/src/modulos/muro/php/api/verVideo.php?ArchivoID=' + im.ArchivoID;
					im.estilo.height = '400px';
				}
				return im;
			});

			imagenes = this.datos.Youtube.reduce(function (ant, im) {
				im.estilo = {
					width: _this.anchoContainer + 'px'
				};
				im.Tipo = 'youtube';
				ant.push(im);
				return ant;
			}, imagenes);

			return imagenes;
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		this.calculaDimensiones();
		window.addEventListener('resize', this.calculaDimensiones);
		window.setTimeout(function () {
			_this2.calculaDimensiones();
		}, 200);
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('resize', this.calculaDimensiones);
	},

	methods: {
		calculaDimensiones: function calculaDimensiones() {
			var cont = this.$refs.contenedor;
			if (cont) {
				var ancho = cont.offsetWidth;
				this.anchoContainer = ancho;
				this.estiloWrapper = {
					width: this.imagenes.length * this.anchoContainer + 'px',
					transform: 'translateX(' + this.i * this.anchoContainer * -1 + 'px)'
				};
			}
		},
		siguiente: function siguiente() {
			this.i++;
			if (this.i >= this.imagenes.length) {
				this.i = 0;
			}

			this.estiloWrapper = {
				width: this.imagenes.length * this.anchoContainer + 'px',
				transform: 'translateX(' + this.i * this.anchoContainer * -1 + 'px)'
			};

			this.$forceUpdate();
		},
		anterior: function anterior() {
			this.i--;
			if (this.i < 0) {
				this.i = this.imagenes.length - 1;
			}

			this.estiloWrapper = {
				width: this.imagenes.length * this.anchoContainer + 'px',
				transform: 'translateX(' + this.i * this.anchoContainer * -1 + 'px)'
			};

			this.$forceUpdate();
		},
		verImagen: function verImagen(ind) {
			this.i = ind;
			this.estiloWrapper = {
				width: this.imagenes.length * this.anchoContainer + 'px',
				transform: 'translateX(' + this.i * this.anchoContainer * -1 + 'px)'
			};

			this.$forceUpdate();
		}
	}
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['id', 'datos', 'publicacionID'],
	data: function data() {
		return {
			verResultados: false
		};
	},

	computed: {
		labels: function labels() {
			return this.datos.Opciones.map(function (val) {
				return val.Titulo;
			});
		},
		data: function data() {
			return this.datos.Opciones.map(function (val) {
				return val.Votos;
			});
		}
	},
	methods: {
		votar: function votar(opcion) {
			var _this = this;

			var datos = {
				OpcionID: opcion.OpcionID
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('muro/php/api/votarEncuesta.php', datos).then(function (res) {
				_this.$store.dispatch('muro/actualizarPublicacion', _this.publicacionID);
			}).catch(function (e) {
				console.error(e.response.data.error);
			});
		}
	}
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['datos'],
	data: function data() {
		return {
			verTodos: false
		};
	},

	methods: {
		download: function download(archivo) {
			window.location.href = '/src/modulos/muro/php/api/download.php?ArchivoID=' + archivo.ArchivoID;
		}
	}
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['datos'],
	data: function data() {
		return {
			verTodos: false,
			Comentario: null
		};
	},

	computed: {
		comentarios: function comentarios() {
			if (!this.datos.Comentarios) {
				return [];
			}
			if (!this.verTodos) {
				return this.datos.Comentarios.slice(0, 3);
			} else {
				return this.datos.Comentarios;
			}
		},
		hayMas: function hayMas() {
			if (!this.datos.Comentarios) {
				return false;
			}
			return !this.verTodos && this.datos.Comentarios.length > 3;
		}
	},
	methods: {
		comentar: function comentar() {
			var _this = this;

			var datos = {
				PublicacionID: this.datos.PublicacionID,
				Comentario: this.Comentario
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('muro/php/api/setComentario.php', datos).then(function (res) {
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('muro/php/api/getPublicacion.php?PublicacionID=' + _this.datos.PublicacionID).then(function (res) {
					_this.$store.dispatch('muro/actualizarPublicacion', _this.datos.PublicacionID);
					_this.verTodos = true;
					_this.Comentario = null;
				}).catch(function (e) {
					console.error(e.response.data.error);
				});
			}).catch(function (e) {
				console.error(e.response.data.error);
			});
		}
	}
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__publicacion__ = __webpack_require__(439);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['PublicacionID'],
	components: {
		Publicacion: __WEBPACK_IMPORTED_MODULE_0__publicacion__["a" /* default */]
	},
	data: function data() {
		return {
			publicacion: null
		};
	},
	created: function created() {
		var _this = this;

		this.$http.get('muro/php/api/getPublicacion.php?PublicacionID=' + this.PublicacionID).then(function (res) {
			_this.publicacion = res.data;
		}).catch(function (e) {
			console.error(e);
			_this.$responseError(e);
		});
	},

	methods: {
		cerrar: function cerrar() {
			this.$router.push('/main');
		}
	}
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			alertas: []
		};
	},
	created: function created() {
		this.getAlertas();
	},

	methods: {
		getAlertas: function getAlertas() {
			var _this = this;

			var inicio = new Date();
			inicio.setHours(0);
			inicio.setMinutes(0);
			inicio.setSeconds(0);
			inicio.setDate(inicio.getDate() + 1);
			var fin = new Date();
			fin.setHours(23);
			fin.setMinutes(59);
			inicio.setSeconds(59);
			var form = {
				fecha_inicio: inicio,
				fecha_fin: fin
			};
			console.log(form.fecha_inicio);
			console.log(form.fecha_fin);
			this.$http.post('muro/php/ddd/Infrastructure/GetAlertasController.php', form).then(function (res) {
				_this.alertas = res.data;
			}).catch(function (e) {
				console.error(e);
			});
		}
	}
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__servicios__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addEvent__ = __webpack_require__(1048);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		AddEvent: __WEBPACK_IMPORTED_MODULE_1__addEvent__["a" /* default */]
	},
	data: function data() {
		return {
			fechasCalendario: [],
			popoverDate: null
		};
	},
	created: function created() {
		this.popoverDate = this.getToday();
		this.getEventos({
			year: new Date().getFullYear(),
			month: new Date().getMonth() + 1
		});
	},

	methods: {
		setPopover: function setPopover(e) {
			this.popoverDate = e;
		},
		getEventos: function getEventos(e) {
			var _this = this;

			if (!e) {
				this.getEventos({
					year: new Date().getFullYear(),
					month: new Date().getMonth() + 1
				});
			} else {
				__WEBPACK_IMPORTED_MODULE_0__servicios__["a" /* default */].getEventos(e.year, e.month).then(function (eventos) {
					_this.fechasCalendario = eventos;
				}).catch(function (e) {
					_this.$error(e);
				});
			}
		},
		moveToday: function moveToday() {
			var calendar = this.$refs.calendar;
			calendar.move(new Date());
			this.popoverDate = this.getToday();
		},
		getToday: function getToday() {
			var fechaCompleta = new Date();
			var month = fechaCompleta.getMonth() + 1;
			return fechaCompleta.getFullYear() + '-' + month + '-' + fechaCompleta.getDate();
		}
	}
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__today__ = __webpack_require__(1049);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		popoverDate: String
	},
	components: {
		TodayEvents: __WEBPACK_IMPORTED_MODULE_1__today__["a" /* default */]
	},
	data: function data() {
		return {
			event: {
				id: null,
				title: null,
				description: null,
				startHour: '09:00',
				endHour: '20:00',
				color: 'red',
				userID: null
			},
			mesAno: null,
			addingEvent: false,
			editingEvent: false,
			colors: ['blue', 'red', 'green']
		};
	},

	methods: {
		addEvent: function addEvent() {
			var _this = this;

			var fechastartHour = this.popoverDate + ' ' + this.event.startHour + ':00';
			var fechaendHour = this.popoverDate + ' ' + this.event.endHour + ':00';
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('muro/php/lib/eventos/addEvent.php?fechastartHour=' + fechastartHour + '&fechaendHour=' + fechaendHour + '&title=' + this.event.title + '&description=' + this.event.description + '&color=' + this.event.color).then(function (res) {
				_this.cancel();
				_this.$emit('updateEvents');
				_this.getDayEvents();
			}).catch(function (e) {
				_this.$error(e);
			});
		},
		editEvent: function editEvent() {
			var _this2 = this;

			var fechastartHour = this.popoverDate + ' ' + this.event.startHour;
			var fechaendHour = this.popoverDate + ' ' + this.event.endHour;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('muro/php/lib/eventos/editEvent.php?id=' + this.event.id + '&fechastartHour=' + fechastartHour + '&fechaendHour=' + fechaendHour + '&title=' + this.event.title + '&description=' + this.event.description + '&color=' + this.event.color + '&userID=' + this.event.userID).then(function (res) {
				_this2.cancel();
				_this2.$emit('updateEvents');
				_this2.getDayEvents();
			}).catch(function (e) {
				_this2.$error(e);
			});
		},
		removeEvent: function removeEvent(event) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('muro/php/lib/eventos/removeEvent.php?id=' + event.id + '&userID=' + event.userID).then(function (res) {
				_this3.cancel();
				_this3.$emit('updateEvents');
				_this3.getDayEvents();
			}).catch(function (e) {
				console.log(e);
				_this3.$error(e);
			});
		},
		cancel: function cancel() {
			this.event.id = null;
			this.event.title = null;
			this.event.description = null;
			this.event.startHour = '09:00';
			this.event.endHour = '20:00';
			this.addingEvent = false;
			this.editingEvent = false;
		},
		editedEvent: function editedEvent(event) {
			this.event = event;
			this.editingEvent = true;
			this.addingEvent = false;
		},
		getDayEvents: function getDayEvents() {
			var child = this.$refs.tEvents;
			child.getEvents();
		}
	}
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		popoverDate: String
	},
	data: function data() {
		return {
			events: [],
			today: null
		};
	},
	created: function created() {
		this.getEvents();
		var fechaCompleta = new Date();
		var month = fechaCompleta.getMonth() + 1;
		this.today = fechaCompleta.getFullYear() + '-' + month + '-' + fechaCompleta.getDate();
	},

	methods: {
		getEvents: function getEvents() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('muro/php/lib/eventos/getTodayEvents.php?today=' + this.popoverDate).then(function (res) {
				_this.events = res.data;
			}).catch(function (e) {
				_this.$error(e);
			});
		},
		edit: function edit(e) {
			this.$emit('edit', e);
		},
		remove: function remove(e) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar evento',
				mensaje: '\xBFSeguro que quieres eliminar este evento?',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.$emit('remove', e);
					}
				}
			});
		}
	},
	watch: {
		popoverDate: function popoverDate() {
			this.getEvents();
		}
	}
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			listadoItems: []
		};
	},
	created: function created() {
		this.getItems();
	},


	methods: {
		getItems: function getItems() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('core/php/api/panel/getItems.php').then(function (res) {
				_this.listadoItems = res.data.items.items;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		go: function go(path) {
			this.$router.push(path);
		}
	}
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__componentes_programador__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'programador-copion': __WEBPACK_IMPORTED_MODULE_2__componentes_programador__["a" /* default */]
	},
	data: function data() {
		return {
			listadoFicheros: [],
			listadoProgramaciones: [],
			programacion: null,
			dias: ['', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
			refrescar: null
		};
	},
	created: function created() {
		var _this = this;

		this.getListadoProgramaciones();
		this.getListadoDescargas();

		this.refrescar = window.setInterval(function () {
			_this.getListadoProgramaciones();
			_this.getListadoDescargas();
		}, 10000);
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.refrescar);
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	})),

	methods: {
		nueva: function nueva() {
			this.programacion = {
				titulo: '',
				notificaEmail: true,
				fecha: null,
				horaIni: '',
				horaFin: '',
				publica: false,
				periodica: null,
				diferido: null,
				EmisoraID: null
			};
		},
		cierraProgramacion: function cierraProgramacion() {
			this.programacion = null;
			this.getListadoProgramaciones();
		},
		getListadoProgramaciones: function getListadoProgramaciones() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getListadoProgramaciones().then(function (res) {
				_this2.listadoProgramaciones = res;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		getListadoDescargas: function getListadoDescargas() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getListadoDescargas().then(function (res) {
				_this3.listadoFicheros = res.data.descargas;
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		descargar: function descargar(idDescarga) {
			document.location.href = '/src/modulos/descargar-copion/php/api/descargar.php?ID_descarga=' + idDescarga;
		},
		getDiasBonitos: function getDiasBonitos(dias) {
			dias = dias.toString();
			var d = [];
			for (var i = 0; i <= 7; i++) {
				if (dias.search(i.toString()) >= 0) {
					d.push(this.dias[i]);
				}
			}
			var cadena = d.join(', ', d);
			return cadena.replace(/,([^,]{1,})$/, ' y $1');
		},
		eliminarPrograma: function eliminarPrograma(prog) {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar programación',
				mensaje: '\xBFQuieres eliminar esta programaci\xF3n?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].eliminarProgramacion(prog.ID_programacion).then(function () {
							_this4.getListadoProgramaciones();
						}).catch(function (e) {
							_this4.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var uri = 'descargar-copion/php/api/';
var post = function post(url, data) {
	return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(uri + url, data);
};

var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(uri + url);
};
/* harmony default export */ __webpack_exports__["a"] = ({
	getEmisoras: function getEmisoras() {
		return get('listadoEmisoras.php');
	},
	getListadoProgramaciones: function getListadoProgramaciones() {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			get('get-listado-programaciones.php').then(function (res) {
				var listado = res.data.listado;

				for (var i = 0; i < listado.length; i++) {
					listado[i].fecha = listado[i].fecha ? new Date(listado[i].fecha) : null;

					if (listado[i].diferida) {
						listado[i].diferida.fecha = new Date(listado[i].diferida.fecha);
					}

					if (listado[i].periodica) {
						listado[i].periodica.fechaIni = new Date(listado[i].periodica.fechaIni);
						listado[i].periodica.fechaFin = listado[i].periodica.fechaFin ? new Date(listado[i].periodica.fechaFin) : null;
						listado[i].periodica.dias = listado[i].periodica.dias.toString();
					}
				}

				resolve(listado);
			}).catch(reject);
		});
	},
	getListadoDescargas: function getListadoDescargas() {
		return get('get-descargas.php');
	},
	programar: function programar(form) {
		var datos = {
			ID_programacion: form.ID_programacion,
			fecha: form.fecha ? Math.floor(form.fecha.getTime() / 1000) : null,
			horaIni: form.horaIni,
			horaFin: form.horaFin,
			avisar: typeof form.avisar === 'boolean' ? form.avisar : true,
			titulo: form.titulo,
			publica: typeof form.publica === 'boolean' ? form.publica : false,
			diferida: null,
			periodica: null,
			EmisoraID: form.EmisoraID
		};

		if (form.diferida) {
			datos.periodica = null;
			datos.diferida = {
				fecha: Math.floor(form.diferida.fecha.getTime() / 1000),
				hora: form.diferida.hora
			};
		} else if (form.periodica) {
			datos.diferida = null;
			datos.fecha = null;
			datos.periodica = {
				fechaIni: Math.floor(form.periodica.fechaIni.getTime() / 1000),
				fechaFin: form.periodica.fechaFin ? Math.floor(form.periodica.fechaFin.getTime() / 1000) : null,
				hora: form.periodica.hora,
				dias: form.periodica.dias
			};
		}

		return post('programar.php', datos);
	},
	eliminarProgramacion: function eliminarProgramacion(idProgramacion) {
		var datos = {
			ID_programacion: idProgramacion
		};

		return post('del-programacion.php', datos);
	}
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(452);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['data'],
	data: function data() {
		return {
			form: null,
			listadoEmisoras: []
		};
	},

	computed: {
		diasSem: function diasSem() {
			return ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb', 'Dom'];
		}
	},

	created: function created() {
		this.getListadoEmisoras();
		this.form = _.clone(this.data);
	},

	methods: {
		getListadoEmisoras: function getListadoEmisoras() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getEmisoras().then(function (res) {
				_this.listadoEmisoras = res.data;
			}).catch(this.$responseError);
		},
		setAhora: function setAhora() {
			this.form.diferida = null;
			this.form.periodica = null;
			this.form.fecha = new Date();
			this.$forceUpdate();
		},
		setDiferida: function setDiferida() {
			this.form.diferida = {
				fecha: null
			};
			this.form.fecha = null;
			this.form.periodica = null;
			this.$forceUpdate();
		},
		setProgramado: function setProgramado() {
			this.form.diferida = null;
			this.form.fecha = null;
			this.form.periodica = {
				fechaIni: new Date(),
				fechaFin: null,
				dias: ''
			};
			this.$forceUpdate();
		},
		toggleDiaProgramado: function toggleDiaProgramado(dia) {
			if (!this.form.periodica) {
				return;
			}
			if (this.form.periodica.dias.search(dia) >= 0) {
				this.form.periodica.dias = this.form.periodica.dias.replace(dia, '');
				return;
			}

			this.form.periodica.dias += '' + dia;
		},
		programar: function programar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].programar(_.clone(this.form)).then(function (res) {
				_this2.$store.commit('alertas/alert', {
					titulo: 'Programado',
					mensaje: 'Se ha programado tu descarga. Te llegar\xE1 un correo electr\xF3nico tan pronto como est\xE9 disponible'
				});
				_this2.cerrar();
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(1068);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			listadoBuzones: [],
			listadoFicheros: [],
			filtro: {
				nombre: '',
				fecha: null,
				buzon: null
			},
			buscando: false
		};
	},
	created: function created() {
		this.getBuzones();
	},


	methods: {
		getBuzones: function getBuzones() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getBuzones().then(function (res) {
				_this.listadoBuzones = res.data.buzones;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		buscar: function buscar() {
			var _this2 = this;

			if (this.filtro.buzon === null && this.filtro.nombre.trim() === '' && this.filtro.fecha === null) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes filtrar al menos por un campo'
				});
				return;
			}

			this.buscando = true;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].buscar(this.filtro).then(function (res) {
				_this2.listadoFicheros = res.data.ficheros;
				_this2.buscando = false;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
				_this2.buscando = false;
			});
		}
	}
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__telefono__ = __webpack_require__(1075);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Telefono: __WEBPACK_IMPORTED_MODULE_0__telefono__["a" /* default */]
	},
	data: function data() {
		return {
			Escaleta: {
				ProgramaID: null,
				ProgramaNombre: null,
				Dia: null,
				Estilo: null,
				Lineas: []
			}
		};
	},

	methods: {
		nuevaLinea: function nuevaLinea() {
			console.log('Creamos una nueva línea');
			this.Escaleta.Lineas.push({
				Hora: null,
				Duacion: null,
				Contenido: [],
				NotasTecnicas: []
			});
		},
		nuevoComentario: function nuevoComentario(destino) {
			destino.push({
				tipo: 'comentario',
				contenido: ''
			});
		},
		nuevoTelefono: function nuevoTelefono(destino) {
			destino.push({
				tipo: 'telefono',
				telefono: '0034',
				nombre: ''
			});
		},
		importarNoticia: function importarNoticia(destino) {}
	}
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['telefono', 'nombre'],
	data: function data() {
		return {
			tel: '',
			nom: ''
		};
	},
	created: function created() {
		this.tel = this.telefono;
		this.nom = this.nombre;
	},

	watch: {
		tel: function tel(newVal) {
			this.$emit('update:telefono', this.tel);
		},
		nom: function nom(newVal) {
			this.$emit('update:nombre', this.nom);
		}
	}
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			filtro: {
				cadena: '',
				FechaInicio: null,
				FechaFin: null
			},
			resultados: []
		};
	},
	created: function created() {
		this.buscar();
	},

	computed: {
		resultadosFiltrados: function resultadosFiltrados() {
			return this.resultados.map(function (r) {
				var asis = typeof r.Asistentes === 'number' ? r.Asistentes : 0;
				var inscritos = typeof r.AsistentesInscritos === 'number' ? r.AsistentesInscritos : 0;
				r.Asistentes = asis + inscritos;
				return r;
			});
		}
	},
	methods: {
		buscar: function buscar() {
			var _this = this;

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.FechaInicio = this.filtro.FechaInicio ? Math.floor(this.filtro.FechaInicio.getTime() / 1000) : null;
			form.FechaFin = this.filtro.FechaFin ? Math.floor(this.filtro.FechaFin.getTime() / 1000) : null;

			this.$http.post('/eventos/php/api/buscarEventos.php', form).then(function (res) {
				_this.resultados = res.data;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevo: function nuevo() {
			this.$router.push('/main/eventos/editor');
		},
		editar: function editar(evento) {
			this.$router.push('/main/eventos/editor/' + evento.EventoID);
		},
		promocionar: function promocionar(evento) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: 'Opción no implementada por el momento'
			});
		},
		eliminar: function eliminar(EventoID) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar evento',
				mensaje: '¿Quieres eliminar este evento?',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.$http.post('eventos/php/api/delEvento.php', { EventoID: EventoID }).then(function (res) {
							_this2.$store.commit('toast/success', {
								titulo: 'Evento eliminado'
							});
							_this2.buscar();
						}).catch(function (e) {
							_this2.$responseError(e);
						});
					}
				}
			});
		},
		quitarFechaInicio: function quitarFechaInicio() {
			this.filtro.FechaInicio = null;
			this.buscar();
		},
		quitarFechaFin: function quitarFechaFin() {
			this.filtro.FechaFin = null;
			this.buscar();
		}
	}
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vistaPrevia__ = __webpack_require__(1086);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		VistaPrevia: __WEBPACK_IMPORTED_MODULE_1__vistaPrevia__["a" /* default */]
	},
	data: function data() {
		return {
			evento: {
				EventoID: null,
				PublicID: null,
				Activo: true,
				Titulo: null,
				Descripcion: null,
				Lugar: null,
				FechaInicioEvento: new Date(),
				FechaFinEvento: new Date(),
				FechaInicioInscripciones: new Date(),
				FechaFinInscripciones: new Date(),
				MaximoInscritosEmail: null,
				MaximoInscripciones: null,
				SoloInvitacion: null,
				FechaCreacion: new Date(),
				LOPD: '',
				ImagenCabecera: null,
				ImagenInvitacion: null,
				ImagenCartel: null
			},
			FechaInicio: null,
			HoraInicio: null,
			FechaFin: null,
			HoraFin: null,
			FechaInicioInscripciones: null,
			HoraInicioInscripciones: null,
			FechaFinInscripciones: null,
			HoraFinInscripciones: null,
			configuracionEditor: {
				menubar: false,
				theme: 'modern',
				plugins: ['advlist autolink lists link image charmap print preview anchor textcolor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table contextmenu paste code help wordcount paste'],
				toolbar: 'insert paste | undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat',
				paste_as_text: true,
				table_default_attributes: {
					'border': '1'
				},
				table_default_styles: {
					'border-collapsed': 'collapse',
					'width': '100%'
				},
				table_responsive_width: true,
				content_style: '\n\t\t\t\t\ttable {width: 100%;border-spacing: 0;border-collapse: separate;border: 1px solid #aaa;}\n\t\t\t\t\ttable tr:nth-child(even) {background-color: #fafafa;}\n\t\t\t\t\ttable td, table th {border: 1px solid #aaa; border-collapse:collapse;padding: 5px;}\n\t\t\t\t'
			},
			preview: null
		};
	},
	created: function created() {
		if (this.$route.params.id) {
			this.getEvento(this.$route.params.id);
		} else {
			this.nuevo();
		}
	},

	watch: {
		FechaInicio: function FechaInicio(newVal) {
			if (newVal.length < 10) {
				return;
			}

			this.evento.FechaInicioEvento = !this.evento.FechaInicioEvento ? new Date() : this.evento.FechaInicioEvento;

			var f = newVal.split('-');
			this.evento.FechaInicioEvento.setYear(parseInt(f[2]));
			this.evento.FechaInicioEvento.setMonth(parseInt(f[1] - 1));
			this.evento.FechaInicioEvento.setDate(parseInt(f[0]));
		},
		HoraInicio: function HoraInicio(newVal) {
			if (newVal.length < 5) {
				return;
			}

			this.evento.FechaInicioEvento = !this.evento.FechaInicioEvento ? new Date() : this.evento.FechaInicioEvento;

			var f = newVal.split(':');
			this.evento.FechaInicioEvento.setHours(parseInt(f[0]));
			this.evento.FechaInicioEvento.setMinutes(parseInt(f[1]));
		},
		FechaFin: function FechaFin(newVal) {
			if (newVal.length < 10) {
				return;
			}

			this.evento.FechaFinEvento = !this.evento.FechaFinEvento ? new Date() : this.evento.FechaFinEvento;

			var f = newVal.split('-');
			this.evento.FechaFinEvento.setYear(parseInt(f[2]));
			this.evento.FechaFinEvento.setMonth(parseInt(f[1] - 1));
			this.evento.FechaFinEvento.setDate(parseInt(f[0]));
		},
		HoraFin: function HoraFin(newVal) {
			if (newVal.length < 5) {
				return;
			}

			this.evento.FechaFinEvento = !this.evento.FechaFinEvento ? new Date() : this.evento.FechaFinEvento;

			var f = newVal.split(':');
			this.evento.FechaFinEvento.setHours(parseInt(f[0]));
			this.evento.FechaFinEvento.setMinutes(parseInt(f[1]));
		},
		FechaInicioInscripciones: function FechaInicioInscripciones(newVal) {
			if (newVal.length < 10) {
				return;
			}

			this.evento.FechaInicioInscripciones = !this.evento.FechaInicioInscripciones ? new Date() : this.evento.FechaInicioInscripciones;

			var f = newVal.split('-');
			this.evento.FechaInicioInscripciones.setYear(parseInt(f[2]));
			this.evento.FechaInicioInscripciones.setMonth(parseInt(f[1] - 1));
			this.evento.FechaInicioInscripciones.setDate(parseInt(f[0]));
		},
		HoraInicioInscripciones: function HoraInicioInscripciones(newVal) {
			if (newVal.length < 5) {
				return;
			}

			this.evento.FechaInicioInscripciones = !this.evento.FechaInicioInscripciones ? new Date() : this.evento.FechaInicioInscripciones;

			var f = newVal.split(':');
			this.evento.FechaInicioInscripciones.setHours(parseInt(f[0]));
			this.evento.FechaInicioInscripciones.setMinutes(parseInt(f[1]));
		},
		FechaFinInscripciones: function FechaFinInscripciones(newVal) {
			if (newVal.length < 10) {
				return;
			}

			this.evento.FechaFinInscripciones = !this.evento.FechaFinInscripciones ? new Date() : this.evento.FechaFinInscripciones;

			var f = newVal.split('-');
			this.evento.FechaFinInscripciones.setYear(parseInt(f[2]));
			this.evento.FechaFinInscripciones.setMonth(parseInt(f[1] - 1));
			this.evento.FechaFinInscripciones.setDate(parseInt(f[0]));
		},
		HoraFinInscripciones: function HoraFinInscripciones(newVal) {
			if (newVal.length < 5) {
				return;
			}

			this.evento.FechaFinInscripciones = !this.evento.FechaFinInscripciones ? new Date() : this.evento.FechaFinInscripciones;

			var f = newVal.split(':');
			this.evento.FechaFinInscripciones.setHours(parseInt(f[0]));
			this.evento.FechaFinInscripciones.setMinutes(parseInt(f[1]));
		}
	},
	methods: {
		nuevo: function nuevo() {
			this.evento.EventoID = 'nuevo';
		},
		getEvento: function getEvento(id) {
			var _this = this;

			this.$http.post('eventos/php/api/getEvento.php', { EventoID: id }).then(function (res) {
				res.data.FechaInicioEvento = res.data.FechaInicioEvento ? new Date(res.data.FechaInicioEvento * 1000) : null;
				res.data.FechaFinEvento = res.data.FechaFinEvento ? new Date(res.data.FechaFinEvento * 1000) : null;
				res.data.FechaInicioInscripciones = res.data.FechaInicioInscripciones ? new Date(res.data.FechaInicioInscripciones * 1000) : null;
				res.data.FechaFinInscripciones = res.data.FechaFinInscripciones ? new Date(res.data.FechaFinInscripciones * 1000) : null;
				_this.evento = res.data;

				// Parseamos la fecha
				if (_this.evento.FechaInicioEvento) {
					_this.FechaInicio = _this.$moment(res.data.FechaInicioEvento).format('DD-MM-YYYY');
					_this.HoraInicio = _this.$moment(res.data.FechaInicioEvento).format('HH:mm');
				}

				if (_this.evento.FechaFinEvento) {
					_this.FechaFin = _this.$moment(res.data.FechaFinEvento).format('DD-MM-YYYY');
					_this.HoraFin = _this.$moment(res.data.FechaFinEvento).format('HH:mm');
				}

				if (_this.evento.FechaInicioInscripciones) {
					_this.FechaInicioInscripciones = _this.$moment(res.data.FechaInicioInscripciones).format('DD-MM-YYYY');
					_this.HoraInicioInscripciones = _this.$moment(res.data.FechaInicioInscripciones).format('HH:mm');
				}

				if (_this.evento.FechaFinInscripciones) {
					_this.FechaFinInscripciones = _this.$moment(res.data.FechaFinInscripciones).format('DD-MM-YYYY');
					_this.HoraFinInscripciones = _this.$moment(res.data.FechaFinInscripciones).format('HH:mm');
				}
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		guardar: function guardar() {
			var _this2 = this;

			if (!this.evento.Titulo) {
				this.error('Debes definir el título');
				return;
			}

			if (!this.evento.Lugar) {
				this.error('Debes definir el lugar del evento');
				return;
			}

			if (!this.evento.FechaInicioEvento) {
				this.error('Debes definir la fecha de inicio del evento');
				return;
			}

			if (!this.evento.FechaFinEvento) {
				this.error('Debes definir la fecha de fin del evento');
				return;
			}

			if (!this.evento.FechaInicioInscripciones) {
				this.error('Debes definir la fecha de inicio de las inscripciones');
				return;
			}

			if (!this.evento.FechaFinInscripciones) {
				this.error('Debes definir la fecha de fin de las inscripciones');
				return;
			}

			if (!this.evento.LOPD || !this.evento.LOPD.trim()) {
				this.error('Debes escribir las cláusulas de protección de datos');
				return;
			}

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.evento));
			form.FechaInicioEvento = Math.floor(this.evento.FechaInicioEvento.getTime() / 1000);
			form.FechaFinEvento = Math.floor(this.evento.FechaFinEvento.getTime() / 1000);
			form.FechaInicioInscripciones = Math.floor(this.evento.FechaInicioInscripciones.getTime() / 1000);
			form.FechaFinInscripciones = Math.floor(this.evento.FechaFinInscripciones.getTime() / 1000);

			this.$http.post('eventos/php/api/setEvento.php', form).then(function (res) {
				_this2.getEvento(res.data.EventoID);

				_this2.$store.commit('toast/success', {
					titulo: 'Cambios guardados',
					mensaje: 'Evento actualizado correctamente'
				});
			}).catch(function (e) {
				_this2.error(e.response.data.error);
			});
		},
		error: function error(msj) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: msj
			});
		},
		upload: function upload(tipo) {
			var _this3 = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.accept = '.jpg';
			inp.style.display = 'none';

			inp.addEventListener('change', function () {
				var form = new FormData();
				form.append('EventoID', _this3.evento.EventoID);
				form.append('Tipo', tipo);
				form.append('fichero', inp.files[0]);

				_this3.$http.post('eventos/php/api/setImagen.php', form).then(function (res) {
					_this3.getEvento(_this3.evento.EventoID);
				}).catch(function (e) {
					_this3.error(e.response.data.error);
				});
				_this3.$refs.cabecera.removeChild(inp);
			});

			inp.addEventListener('blur', function () {
				console.log('Cancelado');
			});

			this.$refs.cabecera.appendChild(inp);
			inp.click();
		},
		verImagen: function verImagen(nombre) {
			this.preview = nombre;
		}
	}
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['tipo', 'evento'],
	methods: {
		eliminar: function eliminar() {
			var _this = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar imagen',
				mensaje: '¿Quieres eliminar esta imagen?',
				callback: function callback(acepta) {
					if (acepta) {
						_this.$http.post('eventos/php/api/delImagen.php', { EventoID: _this.evento.EventoID, tipo: _this.tipo }).then(function (res) {
							_this.evento[_this.tipo] = null;
							_this.$emit('cerrar');
						}).catch(function (e) {
							_this.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__insertar__ = __webpack_require__(1091);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Insertar: __WEBPACK_IMPORTED_MODULE_2__insertar__["a" /* default */]
	},
	data: function data() {
		return {
			evento: null,
			asistentes: [],
			filtro: {
				cadena: '',
				soloConfirmados: false,
				soloPagados: false
			},
			insertando: null,
			InscritoID: null,
			intervalo: null,
			sort: {
				campo: 'Nombre',
				orden: 1
			},
			detallesPago: null
		};
	},
	created: function created() {
		var _this = this;

		if (!this.$route.params.id) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: 'No has seleccionado un evento válido'
			});
		} else {
			this.getEvento(this.$route.params.id);

			this.intervalo = window.setInterval(function () {
				_this.getEvento(_this.$route.params.id);
			}, 5000);
		}
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.intervalo);
	},

	computed: {
		json_data: function json_data() {
			var _this2 = this;

			return this.listadoAsistentes.map(function (a) {
				a.ID = a.InscritoID + '-' + a.AsistenteID;
				a.Fecha = _this2.$moment(a.FechaInscrito * 1000).format('DD-MM-YYYY HH:mm');
				return a;
			});
		},
		json_fields: function json_fields() {
			var arr = {
				ID: 'ID',
				Nombre: 'Nombre',
				Empresa: 'Empresa',
				Email: 'Email',
				Telefono: 'Telefono',
				Fecha: 'Fecha'
			};
			return arr;
		},
		json_meta: function json_meta() {
			return [[{
				'key': 'charset',
				'value': 'utf-8'
			}]];
		},
		inscritos: function inscritos() {
			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(this.asistentes.reduce(function (ant, actual) {
				if (ant.has(actual.InscritoID)) {
					var ins = ant.get(actual.InscritoID);
					ins.asistentes.push(actual);
					if (actual.NumeroAsistentes) {
						ins.numeroAsistentes += actual.NumeroAsistentes;
					}
				} else {
					ant.set(actual.InscritoID, {
						Empresa: actual.Empresa,
						Telefono: actual.Telefono,
						Email: actual.Email,
						numeroAsistentes: actual.NumeroAsistentes || 0,
						asistentes: [actual]
					});
				}
				return ant;
			}, new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a())).map(function (a) {
				return a[1];
			});
		},
		listadoAsistentes: function listadoAsistentes() {
			var _this3 = this;

			var reg = /.*/ig;
			if (this.filtro.cadena) {
				reg = new RegExp(this.filtro.cadena, 'ig');
			}
			var asis = this.asistentes.map(function (a) {
				a.Nombre = a.Nombre + ' ' + a.Apellidos;
				return a;
			}).filter(function (a) {
				var nombre = a.Nombre;
				if (_this3.filtro.cadena && !reg.test(nombre) && !reg.test(a.Empresa)) {
					return false;
				}
				if (_this3.filtro.soloConfirmados && !a.Asiste) {
					return false;
				}
				if (_this3.filtro.soloPagados && a.OrderID && (!a.CaptureID || a.AnulacionID)) {
					return false;
				}

				return true;
			});

			if (!this.sort.campo) {
				return asis;
			}

			this.sort.orden = !this.sort.orden ? 'asc' : this.sort.orden;

			return asis.sort(function (anterior, siguiente) {
				var valAnterior = void 0;
				var valSiguiente = void 0;

				if (_this3.sort.campo === 'Nombre') {
					valAnterior = anterior.Nombre + ' ' + anterior.Apellidos;
					valSiguiente = siguiente.Nombre + ' ' + siguiente.Apellidos;
				} else if (_this3.sort.campo === 'ID') {
					valAnterior = anterior.InscritoID + '.' + anterior.AsistenteID;
					valSiguiente = siguiente.InscritoID + '.' + siguiente.AsistenteID;
				} else {
					valAnterior = anterior[_this3.sort.campo];
					valSiguiente = siguiente[_this3.sort.campo];
				}

				if (valAnterior > valSiguiente) {
					return _this3.sort.orden;
				} else if (valAnterior < valSiguiente) {
					return _this3.sort.orden * -1;
				} else {
					return 0;
				}
			});
		},
		asistentesConfirmados: function asistentesConfirmados() {
			return this.asistentes.filter(function (a) {
				if (!a.OrderIDID && a.Asiste) {
					return a;
				} else if (a.OrderID && a.CaptureID && !a.AnulacionID) {
					return a;
				}
			}).reduce(function (acum, ins) {
				if (ins.NumeroAsistentes) {
					return acum + ins.NumeroAsistentes;
				} else {
					return acum + 1;
				}
			}, 0);
		},
		importes: function importes() {
			return this.asistentes.reduce(function (acum, asis) {
				if (asis.CaptureID && !asis.AnulacionID) {
					acum.ImportePagado = typeof acum.ImportePagado !== 'undefined' ? acum.ImportePagado : 0;
					acum.ImporteComision = typeof acum.ImporteComision !== 'undefined' ? acum.ImporteComision : 0;
					acum.ImportePercibido = typeof acum.ImportePercibido !== 'undefined' ? acum.ImportePercibido : 0;

					if (asis.ImportePagado) {
						acum.ImportePagado = acum.ImportePagado + asis.ImportePagado;
						acum.ImporteComision = acum.ImporteComision + asis.ImporteComision;
						acum.ImportePercibido = acum.ImportePercibido + asis.ImportePercibido;
					}
				}
				return acum;
			}, {});
		}
	},
	methods: {
		getEvento: function getEvento(id) {
			var _this4 = this;

			this.$http.post('eventos/php/api/getEvento.php', { EventoID: id }).then(function (res) {
				_this4.evento = res.data;

				// Obtenemos los asistentes
				_this4.$http.post('eventos/php/api/getAsistentes.php', { EventoID: id }).then(function (resA) {
					_this4.asistentes = resA.data;
				}).catch(function (eA) {
					_this4.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: eA.response.data.error
					});
				});
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		ordenar: function ordenar(campo) {
			if (this.sort.campo === campo) {
				this.sort.orden = this.sort.orden * -1;
			} else {
				this.sort.campo = campo;
				this.sort.orden = 1;
			}
		},
		editarRegistro: function editarRegistro(InscritoID) {
			this.insertando = this.evento.EventoID;
			this.InscritoID = InscritoID;
		},
		cierraEditor: function cierraEditor() {
			this.insertando = null;
			this.InscritoID = null;
		},
		verDetallesPago: function verDetallesPago(ev, asis) {
			ev.preventDefault();
			ev.stopPropagation();
			this.detallesPago = asis;
		},
		asiste: function asiste(AsistenteID, ev) {
			var _this5 = this;

			ev.preventDefault();
			ev.stopPropagation();
			this.$http.post('eventos/php/api/setAsistencia.php', { AsistenteID: AsistenteID }).then(function () {
				for (var i in _this5.asistentes) {
					if (_this5.asistentes[i].AsistenteID === AsistenteID) {
						_this5.asistentes[i].Asiste = true;
					}
				}

				_this5.$forceUpdate();
			}).catch(function (e) {
				_this5.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		noAsiste: function noAsiste(AsistenteID, ev) {
			var _this6 = this;

			ev.preventDefault();
			ev.stopPropagation();
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar asistencia',
				mensaje: '¿Quieres marcar que esta persona no ha asistido al evento?',
				callback: function callback(acepta) {
					if (acepta) {
						_this6.$http.post('eventos/php/api/delAsistencia.php', { AsistenteID: AsistenteID }).then(function () {
							for (var i in _this6.asistentes) {
								if (_this6.asistentes[i].AsistenteID === AsistenteID) {
									_this6.asistentes[i].Asiste = false;
								}
							}

							_this6.$forceUpdate();
						}).catch(function (e) {
							_this6.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['EventoID', 'InscritoID'],
	data: function data() {
		return {
			registro: {
				Empresa: '',
				Telefono: '',
				Email: '',
				asistentes: [{
					AsistenteID: 'Nuevo' + new Date().getTime(),
					nombre: '',
					apellidos: ''
				}],
				enteradoPor: [],
				enteradoPorOtros: '',
				EventoID: this.EventoID,
				AceptaComunicaciones: false
			},
			listadoOpcionesEnterado: ['Radio', 'Amigo', 'Facebook', 'Página web', 'Prensa', 'Otra']
		};
	},
	created: function created() {
		if (this.InscritoID) {
			this.getInscrito();
		}
	},

	methods: {
		getInscrito: function getInscrito() {
			var _this = this;

			this.$http.post('eventos/php/api/getInscripcion.php', { InscritoID: this.InscritoID }).then(function (res) {
				res.data.enteradoPor = res.data.enteradoPor.map(function (e) {
					return e.Nombre;
				});
				_this.registro = res.data;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		addAsistente: function addAsistente() {
			this.registro.asistentes.push({
				AsistenteID: 'Nuevo' + new Date().getTime(),
				nombre: '',
				apellidos: ''
			});
		},
		delAsistente: function delAsistente(i) {
			var _this2 = this;

			if (this.registro.asistentes[i].AsistenteID && typeof this.registro.asistentes[i].AsistenteID === 'number') {
				this.$store.commit('alertas/confirm', {
					titulo: 'Atención',
					mensaje: '\xBFQuieres eliminar este asistente?\n\t\t\t\t\tSe invalidar\xE1 su token en caso de que la asistencia sea numerada',
					callback: function callback(acepta) {
						if (acepta) {
							_this2.registro.asistentes.splice(i, 1);
							_this2.$forceUpdate();
						}
					}
				});
			} else {
				this.registro.asistentes.splice(i, 1);
				this.$forceUpdate();
			}
		},
		setEnterado: function setEnterado(opcion) {
			var k = this.registro.enteradoPor.indexOf(opcion);
			if (k < 0) {
				this.registro.enteradoPor.push(opcion);
			} else if (k >= 0) {
				this.registro.enteradoPor.splice(k, 1);
			}
			this.$forceUpdate();
		},
		insertar: function insertar() {
			var _this3 = this;

			this.$http.post('eventos/php/api/insertarRegistro.php', this.registro).then(function (res) {
				_this3.$store.commit('toast/success', {
					titulo: 'Registro insertado',
					mensaje: 'Has insertado el registro de ' + _this3.registro.Empresa + ' correctamente'
				});
				_this3.$emit('actualizar');
				_this3.cerrar();
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		eliminar: function eliminar() {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar empresa',
				mensaje: '\xBFQuieres eliminar esta empresa y todos sus asistentes de este evento?\n\t\t\t\tEsta acci\xF3n no se puede deshacer',
				callback: function callback(acepta) {
					if (acepta) {
						_this4.$http.post('eventos/php/api/delInscripcion.php', { InscritoID: _this4.InscritoID }).then(function (res) {
							_this4.$emit('actualizar');
							_this4.cerrar();
						}).catch(function (e) {
							_this4.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},
	created: function created() {
		var _this = this;

		var menu = [{
			'icono': 'fa fa-money',
			'nombre': 'Recibos',
			activo: this.$route.path.split('/').splice(-1)[0] === 'cobros',
			'callback': function callback(a) {
				_this.$store.commit('top/setMenuActivo', a);
				_this.$router.push('/main/cobros/cobros');
			}
		}, {
			'icono': 'fa fa-plus-circle',
			'nombre': 'Comisiones',
			activo: this.$route.path.split('/').splice(-1)[0] === 'comisiones',
			'callback': function callback(a) {
				_this.$router.push('/main/cobros/comisiones');
				_this.$store.commit('top/setMenuActivo', a);
			}
		}];

		this.$store.commit('top/setMenu', menu);
	},
	beforeDestroy: function beforeDestroy() {
		this.$store.commit('top/setMenu', []);
	}
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resultados__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buscador__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_nuevo__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'listado-resultados': __WEBPACK_IMPORTED_MODULE_1__resultados__["a" /* default */],
		'buscador': __WEBPACK_IMPORTED_MODULE_2__buscador__["a" /* default */],
		'editor': __WEBPACK_IMPORTED_MODULE_3__editor_nuevo__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				AgenteNombre: null,
				ClienteNombre: null,
				FechaIni: null,
				FechaFin: new Date(),
				ordenarPor: null,
				ordenarDir: null,
				estado: 'Pendiente'
			},
			resultados: [],
			idRecibo: null,
			verEditor: false
		};
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
		permisos: ['permisos/permisos']
	})),

	methods: {
		buscar: function buscar() {
			var _this = this;

			if (this.filtro.FechaIni) {
				this.filtro.FechaIni.setDate(1);
				this.filtro.FechaIni.setHours(0);
				this.filtro.FechaIni.setMinutes(0);
				this.filtro.FechaIni.setSeconds(0);
				this.filtro.FechaIni.setMilliseconds(0);
			}

			if (this.filtro.FechaFin) {
				this.filtro.FechaFin.setDate(1);
				this.filtro.FechaFin.setHours(23);
				this.filtro.FechaFin.setMinutes(59);
				this.filtro.FechaFin.setSeconds(59);
				this.filtro.FechaFin.setMilliseconds(0);

				this.filtro.FechaFin.setMonth(this.filtro.FechaFin.getMonth() + 1);
				this.filtro.FechaFin.setDate(0);
			}
			__WEBPACK_IMPORTED_MODULE_4__services_api_js__["a" /* default */].buscar(this.filtro).then(function (res) {
				_this.resultados = res.data;
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		descargar: function descargar(tipo) {
			__WEBPACK_IMPORTED_MODULE_4__services_api_js__["a" /* default */].buscar(this.filtro, tipo).then(function (res) {
				var texto = res.data;

				var element = document.createElement('a');
				switch (tipo) {
					case 'csv':
						element.setAttribute('href', 'data:text/x-csv;charset=utf-8,' + encodeURIComponent(texto));
						element.setAttribute('download', 'cobros.csv');
						break;
					case 'xls':
						element.setAttribute('href', 'data:application/octet-stream;charset=utf-8,' + encodeURIComponent(texto));
						element.setAttribute('download', 'cobros.xlsx');
						break;
				}

				element.style.display = 'none';
				document.body.appendChild(element);

				element.click();

				document.body.removeChild(element);
			}).catch(function (e) {
				console.error(e);
			});
		},
		nuevoRecibo: function nuevoRecibo() {
			this.idRecibo = 'nuevo';
		},
		editar: function editar(recibo) {
			this.idRecibo = recibo.ReciboID;
		},
		elimina: function elimina(recibo) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar recibo',
				mensaje: '¿Estás seguro de que quieres eliminar este recibo?\n\nEsta acción no se podrá deshacer',
				callback: function callback(acepta) {
					if (!acepta) {
						return;
					}

					__WEBPACK_IMPORTED_MODULE_4__services_api_js__["a" /* default */].eliminar(recibo.ReciboID).then(function (res) {
						_this2.buscar();
					}).catch(function (e) {
						_this2.$store.commit('alertas/alert', {
							titulo: 'Error',
							mensaje: e.response.data.error
						});
					});
				}
			});
		}
	}
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mis_contratos_vue_components_visor_contrato_visor_contrato_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gestion_clientes_vue_components_editor_editor_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'resultados-cobros',
	props: ['resultados'],
	components: {
		VisorContrato: __WEBPACK_IMPORTED_MODULE_1__mis_contratos_vue_components_visor_contrato_visor_contrato_vue__["a" /* default */],
		EditarCliente: __WEBPACK_IMPORTED_MODULE_2__gestion_clientes_vue_components_editor_editor_vue__["a" /* default */]
	},
	data: function data() {
		return {
			order: 'fecha_cobro',
			direccion: 'desc',
			ContratoID: null,
			ClienteID: null
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	}), {
		resultadosProcesados: function resultadosProcesados() {
			return _.orderBy(this.resultados, [this.order], [this.direccion]);
		},
		totalPagado: function totalPagado() {
			var importe = 0;
			for (var i = 0; i < this.resultados.length; i++) {
				var r = this.resultados[i];
				if (r.Estado === 'Pagado') {
					importe = importe + r.ImporteTotal;
				}
			}

			return this.round(importe);
		},
		totalPendiente: function totalPendiente() {
			var importe = 0;
			for (var i = 0; i < this.resultados.length; i++) {
				var r = this.resultados[i];
				if (r.Estado === 'Pendiente') {
					importe = importe + r.ImporteTotal;
				}
			}

			return this.round(importe);
		},
		importeTotal: function importeTotal() {
			var total = 0;

			for (var i = 0; i < this.resultados.length; i++) {
				total = total + parseFloat(this.resultados[i].importeTotal);
			}

			return total;
		},
		netoTotal: function netoTotal() {
			var total = 0;

			for (var i = 0; i < this.resultados.length; i++) {
				total = total + parseFloat(this.resultados[i].netoAgente);
			}

			return total;
		}
	}),

	methods: {
		redondea: function redondea(importe) {
			return _.round(importe, 2);
		},
		setOrden: function setOrden(columna) {
			if (columna === this.order) {
				this.direccion = this.direccion === 'asc' ? 'desc' : 'asc';
				return;
			}

			this.order = columna;
			this.direccion = 'asc';
		},
		verCobro: function verCobro(cobro) {
			this.$emit('ver', cobro);
		},
		eliminaCobro: function eliminaCobro(cobro) {
			this.$emit('eliminar', cobro);
		}
	}
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datos_facturacion__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contacto__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bitacora__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__(469);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editor-cliente',
	props: ['idCliente'],
	components: {
		DatosContacto: __WEBPACK_IMPORTED_MODULE_2__contacto__["a" /* default */],
		DatosFacturacion: __WEBPACK_IMPORTED_MODULE_1__datos_facturacion__["a" /* default */],
		Bitacora: __WEBPACK_IMPORTED_MODULE_3__bitacora__["a" /* default */]
	},
	watch: {
		idCliente: function idCliente(val) {
			var _this = this;

			if (val === 'nuevo') {
				// Generamos un nuevo objeto de tipo cliente
				this.nuevo();
			} else {
				// Cargamos el cliente
				this.$http.get('get-cliente.php?ID=' + val).then(function (res) {
					_this.cliente = res.data.cliente;
				}).catch(function (e) {
					console.error(e);
				});
			}
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	}), {
		permisoEditar: function permisoEditar() {
			return this.cliente.ID === null || this.cliente.agente.ID === this.usuario.ID || this.permisos.clientes_crearTodos;
		},
		clienteCorrecto: function clienteCorrecto() {
			if (!this.cliente.cliente) {
				this.error = 'Debes poner un nombre al cliente';
				return false;
			}

			if (!this.cliente.nombre) {
				this.error = 'Debes asignar una persona de contacto en el cliente';
				return false;
			}

			if (!this.cliente.place_id) {
				this.error = 'Debes asignar la dirección del cliente';
				return false;
			}

			return true;
		}
	}),

	created: function created() {
		var _this2 = this;

		if (this.idCliente === 'nuevo') {
			// Generamos un nuevo objeto de tipo cliente
			this.nuevo();
		} else {
			// Cargamos el cliente
			this.getCliente(this.idCliente);
		}

		// Obtenemos las formas de pago
		__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getFormasPago().then(function (res) {
			_this2.formasPago = res.data.formas;
		}).catch(function (e) {
			console.error(e);
		});
	},


	data: function data() {
		return {
			error: null,
			seccion: 'contacto',
			cliente: {
				ID: null,
				nombre: '',
				agente: {
					ID: null,
					nombre: null,
					avatar: null
				},
				CIF: null,
				telefonos: [],
				emails: [],
				direccion: {
					pais: 'España',
					region: 'Comunidad Valenciana',
					provincia: 'Castellón',
					via: null,
					numero: null,
					esc: null,
					piso: null,
					puerta: null,
					cp: null,
					anotaciones: null
				},
				facturacion: {
					forma_de_pago_ID: null,
					tipoCuenta: 'iban',
					cuenta: null
				},
				anotaciones: null
			},
			formasPago: []
		};
	},
	methods: {
		getCliente: function getCliente(ClienteID) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getCliente(ClienteID).then(function (res) {
				_this3.cliente = res.data.cliente;
			}).catch(function (e) {
				console.error(e);
			});
		},
		nuevo: function nuevo() {
			this.cliente = {
				ID: null,
				nombre: '',
				place_id: null,
				agente: {
					ID: null,
					nombre: null,
					avatar: null
				},
				CIF: null,
				telefonos: [],
				emails: [],
				direccion: {
					pais: 'España',
					region: 'Comunidad Valenciana',
					provincia: 'Castellón',
					via: null,
					numero: null,
					esc: null,
					piso: null,
					puerta: null,
					cp: null,
					indicaciones: null,
					direccion_formateada: null
				},
				facturacion: {
					forma_de_pago_ID: null,
					tipoCuenta: 'iban',
					cuenta: null
				},
				anotaciones: null
			};

			if (!this.permisos.clientes_crearTodos) {
				this.cliente.agente.ID = this.usuario.ID;
				this.cliente.agente.nombre = this.usuario.nombre;
				this.cliente.agente.avatar = this.usuario.avatar;
			}
		},
		setAgente: function setAgente(datos) {
			if (!this.permisos.clientes_crearTodos) {
				return;
			}
			if (!datos) {
				this.cliente.agente.ID = null;
				this.cliente.agente.nombre = null;
				this.cliente.agente.avatar = null;
			} else {
				this.cliente.agente.ID = datos.datos.ID;
				this.cliente.agente.nombre = datos.datos.nombre;
				this.cliente.agente.avatar = datos.datos.avatar;
			}
		},
		guardar: function guardar() {
			var _this4 = this;

			if (!this.cliente.cliente) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Por favor escribe el nombre del cliente'
				});
				return;
			}

			__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].setCliente(this.cliente).then(function (res) {
				_this4.$store.commit('alertas/alert', {
					titulo: 'Guardado',
					mensaje: 'Cliente guardado correctamente'
				});
				_this4.getCliente(res.data.cliente.ID);
			}).catch(function (e) {
				_this4.$store.commit('alertas/alert', {
					title: 'Error',
					mensaje: 'Error guardando los cambios'
				});
			});
		},
		eliminar: function eliminar() {
			var _this5 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar cliente',
				mensaje: '¿Estás seguro de que quieres eliminar este cliente?\n\nEsta acción no se podrá deshacer',
				callback: function callback(acepta) {
					if (!acepta) {
						return;
					}

					__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].eliminar(_this5.cliente.ID).then(function (res) {
						_this5.$store.commit('alertas/alert', {
							titulo: 'Cliente eliminado',
							mensaje: 'Se ha eliminado el cliente correctamente'
						});
						_this5.cerrar();
					}).catch(function (e) {
						_this5.$store.commit('alertas/alert', {
							titulo: 'Error',
							mensaje: e.response.data.error
						});
					});
				}
			});
		},
		liberar: function liberar() {
			var _this6 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Liberar cliente',
				mensaje: 'Vas a liberar este cliente desasignándolo del agente',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].liberar(_this6.cliente.ID).then(function () {
							_this6.$store.commit('toast/success', {
								titulo: 'Cliente liberado'
							});
							_this6.cerrar();
						}).catch(function (e) {
							_this6.$store.commit('alertas/alert', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		cerrado: function cerrado() {
			var _this7 = this;

			this.$store.commit('alertas/confirm', {
				titulo: '¿Cerrar cliente?',
				mensaje: 'Vas a marcar este cliente como ' + (this.cliente.activo ? 'cerrado' : 'abierto'),
				callback: function callback(acepta) {
					if (acepta) {
						var abierto = _this7.cliente.activo === 1 ? 0 : 1;
						__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].cerrado(_this7.cliente.ID, abierto).then(function () {
							_this7.$store.commit('toast/success', {
								titulo: 'Cliente cerrado'
							});
							_this7.cerrar();
						}).catch(function (e) {
							_this7.$store.commit('alertas/alert', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.nuevo();
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['cliente', 'formasPago', 'permisoEditar'],
	data: function data() {
		return {
			mascaras: {
				cc: '#### #### ## ##########',
				iban: 'AA## #### #### #### #### ####'
			}
		};
	},

	methods: {
		setTipoCuenta: function setTipoCuenta(tipo) {
			this.cliente.facturacion.tipoCuenta = tipo;
		}
	}
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['cliente', 'permisoEditar'],
	data: function data() {
		return {
			map: null,
			marcador: null,
			campoGoogle: null,
			resultadosGoogle: [],
			buscadoGoogle: false
		};
	},

	watch: {
		cliente: function cliente(newVal) {
			if (newVal.place_id) {
				this.muestraMapa();
			}
		}
	},
	mounted: function mounted() {
		if (this.cliente.place_id) {
			this.muestraMapa();
		}
	},

	methods: {
		modificarDireccion: function modificarDireccion() {
			this.cliente.place_id = null;
			this.resultadosGoogle = [];
		},
		buscaEnGoogle: function buscaEnGoogle() {
			var _this = this;

			this.cliente.place_id = null;
			this.resultadosGoogle = [];
			this.$http.post('gestion-clientes/php/api/buscaEnGoogle.php', { q: this.campoGoogle }).then(function (res) {
				_this.resultadosGoogle = res.data;
				_this.buscadoGoogle = true;
			}).catch(function (e) {
				console.error(e.response);
			});
		},
		seleccionaPlace: function seleccionaPlace(placeid) {
			var _this2 = this;

			this.$http.get('gestion-clientes/php/api/detallesGoogle.php?place_id=' + placeid).then(function (res) {
				_this2.cliente.direccion.direccion_formateada = res.data.formatted_address;
				_this2.cliente.place_id = placeid;
				_this2.cliente.lat = res.data.geometry.location.lat;
				_this2.cliente.long = res.data.geometry.location.lng;

				// Construye mapa
				_this2.muestraMapa();

				if (res.data.formatted_phone_number) {
					var tel = res.data.formatted_phone_number.trim().replace(/\s/ig, '');
					for (var i = 0; i < _this2.cliente.telefonos.length; i++) {
						var telAnterior = void 0;
						try {
							telAnterior = _this2.cliente.telefonos[i].telefono.toString();
						} catch (e) {
							continue;
						}
						if (telAnterior.trim().replace(/\s/ig, '') === tel) {
							_this2.cliente.telefonos[i].telefono = res.data.formatted_phone_number.trim();
							return;
						}
					}
				}

				_this2.cliente.telefonos.push({
					ID_telefono: null,
					nombre: null,
					telefono: res.data.formatted_phone_number
				});
			}).catch(function (e) {
				console.error(e.response);
			});
		},
		muestraMapa: function muestraMapa() {
			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('map'), {
				center: { lat: this.cliente.lat, lng: this.cliente.long },
				zoom: 15
			});

			if (this.marcador) {
				this.marcador.setMap(null);
			}

			// Añadimos el marcador
			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: { lat: this.cliente.lat, lng: this.cliente.long },
				title: this.cliente.cliente,
				map: this.map
			});
		},
		addTel: function addTel() {
			this.cliente.telefonos.push({
				ID_telefono: null,
				telefono: null,
				nombre: null
			});
		},
		quitaTel: function quitaTel(i) {
			this.cliente.telefonos.splice(i, 1);
		},
		addEmail: function addEmail() {
			this.cliente.emails.push({
				ID_email: null,
				email: null,
				nombre: null
			});
		},
		quitaEmail: function quitaEmail(i) {
			this.cliente.emails.splice(i, 1);
		},
		parseaDireccion: function parseaDireccion(direccion) {
			if (direccion.via) {
				var dir = '';
				dir = direccion.via;
				dir = direccion.numero ? dir + ', nº ' + direccion.numero : dir;
				dir = direccion.esc ? dir + ', esc. ' + direccion.esc : dir;
				dir = direccion.piso ? dir + ', ' + direccion.piso + ' piso' : dir;
				dir = direccion.puerta ? dir + ' ' + direccion.puerta : dir;
				dir = direccion.cp ? dir + ' ' + 'C.P. ' + direccion.cp : dir;
				dir = direccion.localidad ? dir + ' ' + direccion.localidad : dir;
				dir = direccion.region ? dir + ' ' + direccion.region : dir;
				dir = direccion.pais ? dir + ' ' + direccion.pais.toUpperCase() : dir;
				dir = direccion.indicaciones ? dir + ' - ' + direccion.indicaciones : dir;
				return dir;
			} else {
				return direccion.indicaciones;
			}
		}
	}
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['cliente']
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var apiClientes = 'gestion-clientes/php/api/';

/* harmony default export */ __webpack_exports__["a"] = ({
	buscar: function buscar(filtro) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiClientes + 'get-buscar.php', filtro);
	},
	getPermisos: function getPermisos() {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiClientes + 'get-permisos.php');
	},
	getFormasPago: function getFormasPago() {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiClientes + 'get-formas-pago.php');
	},
	setCliente: function setCliente(datos) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiClientes + 'set-cliente.php', datos);
	},
	getCliente: function getCliente(idCliente) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiClientes + 'get-cliente.php?ID=' + idCliente);
	},
	liberar: function liberar(idCliente) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiClientes + 'apiLiberarCliente.php', { ClienteID: idCliente });
	},
	cerrado: function cerrado(idCliente, abierto) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiClientes + 'apiCerrarCliente.php', { ClienteID: idCliente, abierto: abierto });
	},
	eliminar: function eliminar(idCliente) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiClientes + 'del-cliente.php?ID=' + idCliente);
	}
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['form', 'resultados'],
	data: function data() {
		return {};
	},

	created: function created() {
		this.buscar();
	},


	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	}), {
		json_data: function json_data() {
			if (!this.resultados) {
				return [];
			}

			var arr = [];

			for (var i = 0; i < this.resultados.length; i++) {
				arr[i] = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.resultados[i]));
				arr[i]['fecha_cobro'] = new Date(this.resultados[i].fecha_cobro * 1000).toLocaleDateString();
				arr[i]['fecha_registro'] = new Date(this.resultados[i].fecha_registro * 1000).toLocaleDateString();
			}

			return arr;
		},
		json_fields: function json_fields() {
			if (!this.resultados) {
				return {};
			}
			var f = {};
			for (var k in this.resultados[0]) {
				f[k] = k;
			}
			return f;
		},
		json_meta: function json_meta() {
			return [[{
				'key': 'charset',
				'value': 'utf-8'
			}]];
		}
	}),

	methods: {
		quitarFechaIni: function quitarFechaIni() {
			this.form.FechaIni = null;
			this.buscar();
		},
		quitarFechaFin: function quitarFechaFin() {
			this.form.FechaFin = null;
			this.buscar();
		},
		buscar: function buscar() {
			this.$emit('buscar');
		},
		descargar: function descargar(tipo) {
			this.$emit('descargar', tipo);
		},
		nuevo: function nuevo() {
			this.$emit('nuevo');
		}
	}
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idRecibo'],
	data: function data() {
		return {
			recibo: null,
			listadoFormasDePago: [],
			listadoEmpresas: [],
			comisionAgente: null
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	}), {
		reciboContrato: function reciboContrato() {
			if (this.idRecibo === 'nuevo' || !this.recibo) {
				return false;
			}

			return this.recibo.ContratoID;
		},
		necesarioIBAN: function necesarioIBAN() {
			if (this.recibo && this.recibo.FormaDePagoID) {
				for (var i = 0; i < this.listadoFormasDePago.length; i++) {
					var f = this.listadoFormasDePago[i];
					if (f.ID_forma_de_pago === this.recibo.FormaDePagoID) {
						return f.requiere_iban;
					}
				}
			}
			return false;
		},
		valido: function valido() {
			if (!this.recibo.AgenteID) {
				return {
					resultado: false,
					error: 'No hay un agente asociado'
				};
			}

			if (!this.recibo.ImportePagadoRecibo) {
				return {
					resultado: false,
					error: 'Debes escribir un importe a cobrar'
				};
			}

			if (!this.recibo.FormaDePagoID) {
				return {
					resultado: false,
					error: 'Debes definir la forma de pago'
				};
			}

			if (this.necesarioIBAN && !this.recibo.IBAN) {
				return {
					resultado: false,
					error: 'Debes escribir el IBAN'
				};
			}

			return {
				resultado: true
			};
		}
	}),
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getFormasDePago().then(function (res) {
			_this.listadoFormasDePago = res.data.formas;
		}).catch(function (e) {
			_this.$store.commit('toast/danger', {
				titulo: 'Error',
				mensaje: 'Error obteniendo las formas de pago'
			});
		});
		__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getEmpresas().then(function (res) {
			_this.listadoEmpresas = res.data;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
		if (this.idRecibo && this.idRecibo !== 'nuevo') {
			__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].get(this.idRecibo).then(function (res) {
				res.data.ImportePagadoRecibo = res.data.ContratoID && res.data.Estado === 'Pendiente' ? null : res.data.ImporteRecibo;
				_this.recibo = res.data;
				_this.verEditor = true;

				// Cargamos la comisión del agente
				if (_this.recibo.AgenteID) {
					__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getComisionAgente(_this.recibo.AgenteID).then(function (res) {
						_this.comisionAgente = res.data.comision;
						console.log('Tenemos la comisión');
						if (_this.recibo.ComisionAgente === null && _this.recibo.Estado === 'Pendiente') {
							console.log('Asignamos la comisión');
							_this.recibo.ComisionAgente = _this.comisionAgente + 0;
						}
					}).catch(function (e) {
						_this.$store.commit('toast/danger', {
							titulo: 'Error',
							mensaje: e.response.data.error
						});
					});
				}
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		} else if (this.idRecibo === 'nuevo') {
			this.recibo = {
				ReciboID: null,
				ClienteID: null,
				ClienteNombre: null,
				AgenteID: null,
				AgenteNombre: null,
				UsuarioID: this.usuario.ID.toString(),
				UsuarioNombre: this.usuario.nombre + ' ' + this.usuario.apellidos,
				FechaVencimiento: new Date(),
				FechaPago: new Date(),
				Estado: 'Pendiente',
				FormaDePagoID: null,
				ImporteTotal: null,
				ContratoID: null,
				ComisionAgente: null
			};
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		window.setTimeout(function () {
			if (_this2.$refs.importe) {
				_this2.$refs.importe.focus();
			}
		}, 300);
	},

	methods: {
		seleccionaCliente: function seleccionaCliente(ev) {
			this.recibo.ClienteID = ev.datos.ID;
			this.recibo.ClienteNombre = ev.datos.cliente;
		},
		quitarCliente: function quitarCliente() {
			this.recibo.ClienteID = null;
			this.recibo.ClienteNombre = null;
		},
		seleccionaAgente: function seleccionaAgente(ev) {
			var _this3 = this;

			this.recibo.AgenteID = ev.datos.ID;
			this.recibo.AgenteNombre = ev.datos.nombre + ' ' + ev.datos.apellidos;

			__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getComisionAgente(this.recibo.AgenteID).then(function (res) {
				_this3.comisionAgente = res.data.comision;
				console.log('Tenemos la comisión');
				if (_this3.recibo.ComisionAgente === null && _this3.recibo.Estado === 'Pendiente') {
					console.log('Asignamos la comisión');
					_this3.recibo.ComisionAgente = _this3.comisionAgente + 0;
				}
			}).catch(function (e) {
				_this3.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		quitarAgente: function quitarAgente() {
			this.recibo.AgenteID = null;
			this.recibo.AgenteNombre = null;
		},
		asignaImporteDefinido: function asignaImporteDefinido() {
			this.recibo.ImportePagadoRecibo = this.recibo.ImporteTotal * 1;
		},
		cobrar: function cobrar() {
			var _this4 = this;

			if (this.valido.resultado === false) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: this.valido.error
				});
				return;
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Pagar recibo',
				mensaje: '<div class="text-center">Estas a punto de registrar el pago de\n\t\t\t\t<h3>' + this.recibo.ImportePagadoRecibo + ' \u20AC</h3>\n\t\t\t\ten este contrato.\n\t\t\t\t\xBFQuieres continuar?</div>',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].pagarRecibo(_this4.recibo).then(function (res) {
							_this4.$store.commit('toast/success', {
								titulo: 'Recibo pagado',
								mensaje: 'Se ha pagado el recibo correctamente'
							});
							_this4.$emit('actualizar');
							_this4.$emit('cerrar');
						}).catch(function (e) {
							_this4.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var apiCobro = 'facturacion-cobros/php/api/';

/* harmony default export */ __webpack_exports__["a"] = ({
	buscar: function buscar(datos, descarga) {
		var form = _.clone(datos);
		form.FechaIni = form.FechaIni ? datos.FechaIni.getTime() / 1000 : null;
		form.FechaFin = form.FechaFin ? datos.FechaFin.getTime() / 1000 : null;
		form.descargar = descarga;
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiCobro + 'buscar-recibos.php', form);
	},
	set: function set(datos) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiCobro + 'set-cobro.php', datos);
	},
	get: function get(reciboID) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiCobro + 'get-recibo.php?ReciboID=' + reciboID);
	},
	getPermisos: function getPermisos() {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiCobro + 'get-permisos.php');
	},
	getFormasDePago: function getFormasDePago() {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiCobro + 'get-forma-pago.php');
	},
	getEmpresas: function getEmpresas() {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiCobro + 'get-listado-empresas.php');
	},
	getComisionAgente: function getComisionAgente(AgenteID) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(apiCobro + 'get-comision-agente.php?AgenteID=' + AgenteID);
	},
	pagarRecibo: function pagarRecibo(datos) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiCobro + 'pagar-recibo.php', datos);
	},
	eliminar: function eliminar(idCobro) {
		var datos = {
			ID_cobro: idCobro
		};

		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiCobro + 'del-cobro.php', datos);
	}
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtro__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resultados__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		filtro: __WEBPACK_IMPORTED_MODULE_1__filtro__["a" /* default */],
		resultados: __WEBPACK_IMPORTED_MODULE_2__resultados__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				AgenteNombre: null,
				Mes: new Date(),
				Estado: null
			},
			resultados: []
		};
	},

	methods: {
		buscarComisiones: function buscarComisiones() {
			var _this = this;

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.Mes = this.filtro.Mes ? Math.floor(this.filtro.Mes.getTime() / 1000) : null;
			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('facturacion-cobros/php/api/comisiones/buscar-comisiones.php', form).then(function (res) {
				_this.resultados = res.data;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editarPago_vue__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['filtro'],
	components: {
		Comision: __WEBPACK_IMPORTED_MODULE_1__editarPago_vue__["a" /* default */]
	},
	data: function data() {
		return {
			editarComision: null
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	})),
	methods: {
		setEstado: function setEstado(estado) {
			this.filtro.Estado = estado;
			this.buscar();
		},
		quitarFecha: function quitarFecha() {
			this.filtro.Mes = null;
			this.buscar();
		},
		buscar: function buscar() {
			this.$emit('buscar');
		}
	}
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['ComisionID'],
	data: function data() {
		return {
			datos: {
				PagoID: null,
				AgenteID: null,
				AgenteNombre: null,
				FechaPagado: new Date(),
				UsuarioID: null,
				UsuarioNombre: null,
				ComisionesID: []
			},
			comisionesPendientes: null
		};
	},
	created: function created() {
		if (this.ComisionID && this.ComisionID !== 'nueva') {
			this.getComision();
		} else {
			this.datos.ComisionID = 'nueva';
			this.datos.UsuarioID = this.usuario.ID;
			this.datos.UsuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos;
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		'usuario': 'session/usuario'
	}), {
		importePago: function importePago() {
			var _this = this;

			if (this.comisionesPendientes === null) {
				return 0;
			}

			return this.comisionesPendientes.reduce(function (ant, actual) {
				if (_this.datos.ComisionesID.indexOf(actual.ComisionID) >= 0) {
					ant = ant + actual.ImporteComision;
				}
				return ant;
			}, 0);
		},
		formValido: function formValido() {
			if (!this.datos.AgenteID) {
				return false;
			}

			if (!this.datos.Importe) {
				return false;
			}

			if (!this.datos.FechaPagado) {
				return false;
			}

			return true;
		},
		editable: function editable() {
			return this.datos.ComisionID === 'nueva';
		}
	}),
	methods: {
		getComision: function getComision() {
			var _this2 = this;

			this.$http.post('facturacion-cobros/php/api/comisiones/getComision.php', { ComisionID: this.ComisionID }).then(function (res) {
				_this2.datos = res.data;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		seleccionaAgente: function seleccionaAgente(ev) {
			var _this3 = this;

			this.datos.AgenteID = ev.datos.ID;
			this.datos.AgenteNombre = ev.datos.nombre + ' ' + ev.datos.apellidos;

			this.$http.post('facturacion-cobros/php/api/comisiones/getComisionesPendientesAgente.php', { AgenteID: ev.datos.ID }).then(function (res) {
				_this3.comisionesPendientes = res.data;
			}).catch(function (e) {
				_this3.$error('Error', e.response.data.error);
			});
		},
		quitarAgente: function quitarAgente() {
			this.datos.AgenteID = null;
			this.datos.AgenteNombre = null;
			this.comisionesPendientes = [];
		},
		seleccionaTodos: function seleccionaTodos(ev) {
			var checked = ev.srcElement.checked;

			if (checked) {
				this.datos.ComisionesID = this.comisionesPendientes.map(function (c) {
					return c.ComisionID;
				});
			} else {
				this.datos.ComisionesID = [];
			}
		},
		toggleComision: function toggleComision(comision, ev) {
			ev.stopPropagation();
			// ev.preventDefault()
			var idx = this.datos.ComisionesID.indexOf(comision.ComisionID);

			if (idx >= 0) {
				this.datos.ComisionesID.splice(idx, 1);
			} else {
				this.datos.ComisionesID.push(comision.ComisionID);
			}

			if (this.datos.ComisionesID.length !== this.comisionesPendientes.length) {
				this.$refs.todasComisiones.checked = false;
			} else {
				this.$refs.todasComisiones.checked = true;
			}
		},
		pagar: function pagar() {
			var _this4 = this;

			var form = {
				ComisionesID: this.datos.ComisionesID
			};

			this.$http.post('facturacion-cobros/php/api/comisiones/pagarComision.php', form).then(function (res) {
				_this4.$emit('actualizar');
				_this4.cerrar();
			}).catch(function (e) {
				_this4.$error('Error', e.response.data.error);
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['resultados'],
	computed: {
		importeComisiones: function importeComisiones() {
			if (!this.resultados) {
				return 0;
			}

			return this.resultados.reduce(function (ant, actual) {
				if (actual.ImporteComision) {
					ant = ant + actual.ImporteComision;
				}
				return ant;
			}, 0);
		},
		importePagado: function importePagado() {
			if (!this.resultados || this.resultados.length === 0) {
				return 0;
			}

			return this.resultados.reduce(function (ant, actual) {
				if (actual.FechaPagada) {
					ant = ant + actual.ImporteComision;
				}
				return ant;
			}, 0);
		},
		importePendiente: function importePendiente() {
			return this.importeComisiones - this.importePagado;
		}
	}
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__componentes_visor_galerias_visor_galeria__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__componentes_buscador_modal_buscador_vue__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__componentes_gestion_etiquetas_gestion_etiquetas_vue__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'visor-galeria': __WEBPACK_IMPORTED_MODULE_1__componentes_visor_galerias_visor_galeria__["a" /* default */],
		'modal-buscador': __WEBPACK_IMPORTED_MODULE_2__componentes_buscador_modal_buscador_vue__["a" /* default */],
		'gestion-etiquetas': __WEBPACK_IMPORTED_MODULE_3__componentes_gestion_etiquetas_gestion_etiquetas_vue__["a" /* default */]
	},
	created: function created() {
		var _this = this;

		// Seteamos el menú superior
		var menu = [{
			id: 'buscador',
			nombre: 'Buscador',
			icono: 'fa fa-search',
			callback: function callback(e) {
				_this.buscar = true;
			}
		}];

		if (this.permisos.galerias_editarTodos) {
			menu.push({
				id: 'gestorEtiquetas',
				nombre: 'Etiquetas',
				icono: 'fa fa-tag',
				callback: function callback(e) {
					_this.gestionEtiquetas = true;
				}
			});
		}

		this.$store.commit('top/setMenu', menu);
	},
	data: function data() {
		return {
			buscar: false,
			gestionEtiquetas: false,
			cadena: ''
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
		galeria: 'galerias/galeria',
		permisos: 'permisos/permisos'
	})),
	methods: {
		seleccionaNombre: function seleccionaNombre(ev) {
			this.cadena = ev.data.Nombre + ' ' + ev.data.Apellidos;
			this.doSearch();
		},
		doSearch: function doSearch() {
			this.$store.dispatch('galerias/buscar', { cadena: this.cadena });
			this.$router.push('/main/galerias/buscador');
		}
	}
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visor_galeria_vue__ = __webpack_require__(479);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5153b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visor_galeria_vue__ = __webpack_require__(1131);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visor_galeria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5153b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visor_galeria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__visor_item_visor_item__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listado_galerias_modal_galeria__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visor_item_mini_item__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['listadoItems'],
	components: {
		'mini-item': __WEBPACK_IMPORTED_MODULE_3__visor_item_mini_item__["a" /* default */],
		'visor-item': __WEBPACK_IMPORTED_MODULE_1__visor_item_visor_item__["a" /* default */],
		'modal-galeria': __WEBPACK_IMPORTED_MODULE_2__listado_galerias_modal_galeria__["a" /* default */]
	},
	data: function data() {
		return {
			idGaleria: null,
			imagenes: [],
			item: null,
			editarGaleria: null,
			anchoEfectivo: 200,
			margen: 2
		};
	},
	created: function created() {
		var _this = this;

		this.getGaleria(this.$route.params.id);

		var menu2 = {
			id: 'nuevoItem',
			nombre: 'Subir ficheros',
			icono: 'fa fa-upload',
			callback: function callback(e) {
				_this.$refs.uploader.click();
			}
		};

		var download = {
			id: 'descargaGaleria',
			nombre: 'Descargar galería',
			icono: 'fa fa-download',
			callback: function callback(e) {
				_this.$refs.download.click();
			}
		};

		this.$store.commit('top/addMenu', menu2);
		this.$store.commit('top/addMenu', download);
	},
	mounted: function mounted() {
		var _this2 = this;

		this.$refs.uploader.addEventListener('change', function () {
			var ficheros = _this2.$refs.uploader.files;
			for (var i = 0; i < ficheros.length; i++) {
				_this2.$store.commit('galerias/ADD_COLA', {
					GaleriaID: _this2.galeria.GaleriaID,
					fichero: ficheros[i]
				});
			}
		});
	},
	beforeDestroy: function beforeDestroy() {
		this.$store.commit('top/delMenu', 'nuevoItem');
		this.$store.commit('top/delMenu', 'editarGaleria');
		this.$store.commit('top/delMenu', 'descargaGaleria');
	},

	watch: {
		idGaleria: function idGaleria(newVal, oldVal) {
			if (newVal !== this.idGaleria) {
				this.getGaleria(newVal);
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
		galeria: 'galerias/galeria'
	}), {
		listado: function listado() {
			return this.galeria.items.map(function (i) {
				return i.ItemID;
			});
		}
	}),
	methods: {
		calcular: function calcular() {
			var cont = this.$refs.contenedor;
			var ancho = cont.clientWidth;
			var anchoDeseado = 250;
			var anchoFinal = anchoDeseado + this.margen * 2;
			var caben = Math.round(ancho / anchoFinal);
			this.anchoEfectivo = Math.floor(ancho / caben) - this.margen * 2 - 2;
			console.log('Ancho: ' + ancho + ', efectivo: ' + this.anchoEfectivo);
		},
		getGaleria: function getGaleria(idGaleria) {
			var _this3 = this;

			this.$store.commit('galerias/SET_GALERIA', null);
			__WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getGaleria(idGaleria).then(function (res) {
				_this3.calcular();
				res.data.galeria.FechaGaleria = new Date(res.data.galeria.FechaGaleriaUnix * 1000);

				_this3.$store.commit('galerias/SET_GALERIA', res.data.galeria);

				if (res.data.galeria.Escritura) {
					var menu = {
						id: 'editarGaleria',
						nombre: 'Editar galería',
						icono: 'fa fa-edit',
						callback: function callback(e) {
							_this3.editarGaleria = _this3.$route.params.id;
						}
					};

					_this3.$store.commit('top/addMenu', menu);
				}
			}).catch(function (e) {
				_this3.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		selecciona: function selecciona(item) {
			this.item = item.ItemID + 0;
		}
	}
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(59);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['itemId', 'listado'],
	data: function data() {
		return {
			estilo: null,
			estiloImg: null,
			etiqueta: '',
			persona: '',
			item: null,
			galeria: null
		};
	},
	mounted: function mounted() {
		this.calcular();
		window.addEventListener('resize', this.calcular);
		window.addEventListener('keyup', this.teclaPulsada);
	},
	created: function created() {
		this.getItem();
	},

	watch: {
		itemId: function itemId(newVal) {
			this.getItem();
		}
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('resize', this.calcular);
		window.removeEventListener('keyup', this.teclaPulsada);
	},

	computed: {
		tamano: function tamano() {
			var bytes = this.item.Tamano;
			var decimals = 2;
			if (bytes === 0) return '0 Bytes';
			var k = 1024;
			var dm = decimals <= 0 ? 0 : decimals || 2;
			var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
			var i = Math.floor(Math.log(bytes) / Math.log(k));
			return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
		}
	},
	methods: {
		getItem: function getItem() {
			var _this = this;

			if (this.estilo) {
				this.estilo.display = 'none';
			} else {
				this.estilo = {
					display: 'none'
				};
			}

			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getItem(this.itemId).then(function (res) {
				_this.item = res.data.item;
				_this.galeria = res.data.galeria;
				_this.calcular();
			}).catch(function (e) {
				_this.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		teclaPulsada: function teclaPulsada(ev) {
			switch (ev.keyCode) {
				case 27:
					this.cerrar();
					break;
				case 39:
					this.siguiente();
					break;
				case 37:
					this.anterior();
					break;
				case 46:
					this.eliminar();
					break;
				default:
			}
		},
		siguiente: function siguiente() {
			var i = this.listado.indexOf(this.itemId);
			if (i === this.listado.length - 1) {
				i = 0;
			} else {
				i++;
			}
			this.$emit('update:itemId', this.listado[i]);
		},
		anterior: function anterior() {
			var i = this.listado.indexOf(this.itemId);
			if (i === 0) {
				i = this.listado.length - 1;
			} else {
				i--;
			}
			this.$emit('update:itemId', this.listado[i]);
		},
		calcular: function calcular() {
			if (!this.item) {
				return;
			}

			var altoVideo = this.item.Alto;
			var anchoVideo = this.item.Ancho;
			var rotacion = 0;

			// Vemos la información exif de la imagen
			if (this.item.exif) {
				var orientacion = this.item.exif.Orientation;
				if (orientacion) {
					switch (orientacion) {
						case 3:
							rotacion = 180;
							break;
						case 6:
							rotacion = 90;
							altoVideo = this.item.Ancho;
							anchoVideo = this.item.Alto;
							break;
						case 8:
							rotacion = 270;
							// altoVideo = this.item.Ancho
							// anchoVideo = this.item.Alto
							break;
						default:
							rotacion = 0;
							break;
					}
				}
			}

			console.log('La rotación es: ' + rotacion);

			var rVideo = anchoVideo / altoVideo;

			// Dimensiones de la ventana
			var altoVentana = window.innerHeight;
			var anchoVentana = window.innerWidth - 300;
			// const rVentana = anchoVentana / altoVentana

			if (anchoVentana / rVideo < altoVentana) {
				var alto = anchoVentana / rVideo;
				this.estilo = {
					position: 'fixed',
					display: 'block',
					top: Math.round((altoVentana - alto) / 2) + 'px',
					left: 0,
					width: anchoVentana + 'px',
					height: alto + 'px',
					overflow: 'hidden'
				};

				this.estiloImg = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.estilo));
				this.estiloImg.transform = 'rotate(' + rotacion + 'deg)';
				delete this.estiloImg.transform;
			} else {
				var ancho = altoVentana * rVideo;
				this.estilo = {
					position: 'fixed',
					display: 'block',
					top: 0,
					left: Math.round((anchoVentana - ancho) / 2) + 'px',
					height: altoVentana + 'px',
					width: ancho + 'px',
					overflow: 'hidden'
				};

				this.estiloImg = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.estilo));
				this.estiloImg.transform = 'rotate(' + rotacion + 'deg)';
				delete this.estiloImg.transform;
			}
		},
		setPersona: function setPersona(ev) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].setPersona(this.itemId, ev.data.PersonaID, ev.data.Nombre).then(function (res) {
				_this2.item = res.data.item;
			}).catch(function (e) {
				_this2.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		delPersona: function delPersona(persona) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].delPersona(this.itemId, persona.PersonaID).then(function (res) {
				_this3.item = res.data.item;
			}).catch(function (e) {
				_this3.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		setEtiqueta: function setEtiqueta() {
			var _this4 = this;

			var etis = this.etiqueta.split(' ').map(function (e) {
				return e.toString().toUpperCase();
			}).filter(function (e) {
				return e.length > 3;
			});
			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].addItemTag(this.item.ItemID, etis).then(function (res) {
				_this4.item = res.data.item;
				_this4.etiqueta = '';
			}).catch(function (e) {
				_this4.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		delEtiqueta: function delEtiqueta(tag) {
			var _this5 = this;

			if (!this.galeria.Escritura) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].delItemTag(this.item.ItemID, tag).then(function (res) {
				_this5.item = res.data.item;
				_this5.etiqueta = '';
			}).catch(function (e) {
				_this5.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		setPortada: function setPortada() {
			var _this6 = this;

			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].setPortada(this.galeria.GaleriaID, this.item.ItemID).then(function (res) {
				_this6.$store.commit('toast/success', {
					titulo: 'Portada actualizada'
				});
			}).catch(function (e) {
				_this6.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		eliminar: function eliminar() {
			var _this7 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar fichero',
				mensaje: '\xBFQuieres eliminar este fichero?\n\t\t\t\tEsta acci\xF3n no se podr\xE1 deshacer',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].delItem(_this7.itemId).then(function (res) {
							var itemEliminado = _this7.itemId + 0;
							if (_this7.listado.length > 1) {
								_this7.siguiente();
								_this7.listado = _this7.listado.filter(function (i) {
									return i !== itemEliminado;
								});
							} else {
								_this7.cerrar();
							}
							_this7.$store.commit('toast/success', {
								titulo: 'Fichero eliminado'
							});
							_this7.$store.commit('galerias/DEL_ITEM', itemEliminado);
						}).catch(function (e) {
							_this7.$store.commit('toast/danger', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		toggleFavorito: function toggleFavorito() {},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_galeria_vue__ = __webpack_require__(482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba69e800_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_galeria_vue__ = __webpack_require__(1128);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_galeria_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba69e800_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_galeria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_js__ = __webpack_require__(59);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idGaleria'],
	data: function data() {
		return {
			galeria: {
				GaleriaID: null,
				Nombre: null,
				Descripcion: null,
				UsuarioID: null,
				UsuarioNombre: null,
				FechaCreacion: null,
				FechaGaleria: null,
				Eliminada: null,
				AccesoDefecto: true,
				EscrituraDefecto: true,
				permisos: [],
				rrss: false,
				prensa: false,
				tv: false,
				web: false,
				etiquetas: []
			}
		};
	},
	created: function created() {
		var _this = this;

		if (this.idGaleria && this.idGaleria !== 'nueva') {
			__WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].getGaleria(this.idGaleria).then(function (res) {
				res.data.galeria.FechaGaleria = new Date(res.data.galeria.FechaGaleriaUnix * 1000);
				_this.galeria = res.data.galeria;
			}).catch(function (e) {
				_this.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	})),
	methods: {
		addEtiqueta: function addEtiqueta(ev) {
			if (this.galeria.etiquetas.indexOf(ev.texto) >= 0) {
				return false;
			}
			this.galeria.etiquetas.push(ev.texto);
		},
		quitarEtiqueta: function quitarEtiqueta(eti) {
			this.galeria.etiquetas.splice(this.galeria.etiquetas.indexOf(eti), 1);
		},
		seleccionaPermiso: function seleccionaPermiso(ev) {
			if (ev.datos.ID_grupo) {
				// Buscamos que el grupo no esté ya
				for (var i = 0; i < this.galeria.permisos.length; i++) {
					if (this.galeria.permisos[i].GrupoID === ev.datos.ID_grupo) {
						return;
					}
				}
				var j = this.galeria.permisos.length;
				this.galeria.permisos.push({
					PermisoID: 'permiso' + j,
					GaleriaID: this.galeria.GaleriaID,
					UsuarioID: null,
					GrupoID: ev.datos.ID_grupo,
					UsuarioNombre: null,
					GrupoNombre: ev.datos.nombre,
					Acceso: false,
					Escritura: false
				});
			} else if (ev.datos.ID) {
				for (var _i = 0; _i < this.galeria.permisos.length; _i++) {
					if (this.galeria.permisos[_i].UsuarioID === ev.datos.ID) {
						return;
					}
				}
				var _j = this.galeria.permisos.length;
				// Es un usuario
				this.galeria.permisos.push({
					PermisoID: 'permiso' + _j,
					GaleriaID: this.galeria.GaleriaID,
					UsuarioID: ev.datos.ID,
					UsuarioNombre: ev.datos.nombre + ' ' + ev.datos.apellidos,
					GrupoNombre: null,
					GrupoID: null,
					Acceso: false,
					Escritura: false
				});
			}
		},
		quitaPermiso: function quitaPermiso(idPermiso) {
			this.galeria.permisos = this.galeria.permisos.filter(function (per) {
				if (per.PermisoID === idPermiso) {
					return false;
				}
				return true;
			});
		},
		guardar: function guardar() {
			var _this2 = this;

			if (!this.galeria.Nombre) {
				this.$error('Error', 'Debes definir el nombre de la galería');
				return;
			}
			if (!this.galeria.FechaGaleria) {
				this.$error('Error', 'Debes definir la fecha de la galería');
				return;
			}
			var nueva = this.galeria.GaleriaID === null;
			__WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].setGaleria(this.galeria).then(function (res) {
				_this2.$store.commit('toast/success', {
					titulo: 'Guardada',
					mensaje: 'Se ha guardado la galería'
				});
				res.data.galeria.FechaGaleria = new Date(res.data.galeria.FechaGaleriaUnix * 1000);
				_this2.galeria = res.data.galeria;
				if (nueva) {
					_this2.$router.push('/main/galerias/' + _this2.galeria.GaleriaID);
				}
				_this2.cerrar();
			}).catch(function (e) {
				_this2.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: 'Error guardando la galería'
				});
			});
		},
		eliminar: function eliminar() {
			var _this3 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar galería',
				mensaje: '\xBFQuieres eliminar esta galer\xEDa?\n\t\t\t\tEsta acci\xF3n no se podr\xE1 deshacer',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_2__api_js__["a" /* default */].delGaleria(_this3.galeria.GaleriaID).then(function (res) {
							_this3.$store.commit('toast/success', {
								titulo: 'Galería eliminada'
							});
							_this3.$router.push('/main/galerias');
							_this3.cerrar();
						}).catch(function (e) {
							_this3.$store.commit('toast/danger', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mini_item_vue__ = __webpack_require__(484);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffef71d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mini_item_vue__ = __webpack_require__(1130);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ffef71d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mini_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffef71d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mini_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['item', 'ancho', 'margen'],
	data: function data() {
		return {
			miMargen: 2,
			miAncho: 200
		};
	},
	created: function created() {
		if (this.ancho) {
			this.miAncho = this.ancho;
		}
		if (this.margen) {
			this.miMargen = this.margen;
		}
	},

	methods: {
		selecciona: function selecciona() {
			this.$emit('selecciona', this.item);
		}
	}
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			filtro: {
				cadena: '',
				tipo: null,
				fecha: null
			}
		};
	},

	methods: {
		setTipo: function setTipo(tipo) {
			this.filtro.tipo = tipo;
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		buscar: function buscar() {
			this.$store.dispatch('galerias/buscar', this.filtro);
			this.$router.push('/main/galerias/buscador');
			this.cerrar();
		}
	}
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			persona: null
		};
	},

	methods: {
		seleccionada: function seleccionada(ev) {
			this.persona = ev.data;
		},
		guardar: function guardar() {
			var _this = this;

			if (!this.persona.Nombre) {
				this.$error('Debes escribir un nombre');
				return;
			}

			this.$http.post('galerias/php/api/set-persona.php', this.persona).then(function (res) {
				_this.$store.commit('toast/success', {
					titulo: 'Etiqueta guardada'
				});
			}).catch(function (e) {
				_this.$error(e.response.data.error);
			});
		},
		eliminar: function eliminar() {
			var _this2 = this;

			// Buscamos las fotos asociadas
			this.$http.get('galerias/php/api/get-numero-de-fotos-persona.php?PersonaID=' + this.persona.PersonaID).then(function (res) {
				if (res.data.items > 0) {
					_this2.$store.commit('alertas/confirm', {
						titulo: 'Atención',
						mensaje: 'Esta etiqueta est\xE1 asociada a ' + res.data.items + ' items.\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\tSi la eliminas se eliminar\xE1n tambi\xE9n las asociaciones',
						callback: function callback(acepta) {
							_this2.confirmaEliminacion();
						}
					});
				} else {
					_this2.confirmaEliminacion();
				}
			});
		},
		confirmaEliminacion: function confirmaEliminacion() {
			var _this3 = this;

			this.$http.post('galerias/php/api/del-persona.php', { PersonaID: this.persona.PersonaID }).then(function (res) {
				_this3.persona = null;
				_this3.$store.commit('toast/success', {
					titulo: 'Etiqueta eliminada'
				});
			}).catch(function (e) {
				_this3.$error(e.response.data.error);
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_galeria__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mini_galeria_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(59);
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'mini-galeria': __WEBPACK_IMPORTED_MODULE_1__mini_galeria_vue__["a" /* default */],
		'modal-galeria': __WEBPACK_IMPORTED_MODULE_0__modal_galeria__["a" /* default */]
	},
	data: function data() {
		return {
			idGaleria: null,
			editarGaleria: null,
			galerias: []
		};
	},
	created: function created() {
		var _this = this;

		var menu = {
			id: 'nuevaGaleria',
			nombre: 'Nueva galería',
			icono: 'fa fa-plus',
			callback: function callback(e) {
				_this.editarGaleria = 'nueva';
			}
		};

		this.$store.commit('top/addMenu', menu);

		this.$store.commit('galerias/SET_GALERIA', null);

		this.getGalerias();
	},
	beforeDestroy: function beforeDestroy() {
		this.$store.commit('top/delMenu', 'nuevaGaleria');
	},

	methods: {
		selecciona: function selecciona(i) {
			this.$router.push('/main/galerias/' + i);
		},
		detallesGaleria: function detallesGaleria(ev, e) {
			ev.preventDefault();
			ev.stopPropagation();

			this.editarGaleria = e;
		},
		getGalerias: function getGalerias() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getGalerias(null).then(function (res) {
				res.data.galeras = res.data.galerias.map(function (gal) {
					gal.PortadaUrl = gal.PortadaID ? '/src/modulos/galerias/php/api/thumb.php?ItemID=' + gal.PortadaID : '/src/modulos/galerias/static/noimage.png';
				});
				_this2.galerias = res.data.galerias;
			}).catch(function (e) {
				console.error(e.response);
			});
		}
	}
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['galeria', 'GaleriaID'],
	data: function data() {
		return {
			datos: null,
			listo: false
		};
	},
	created: function created() {
		var _this = this;

		if (this.galeria) {
			this.datos = this.galeria;
			this.listo = true;
		} else if (this.GaleriaID) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('galerias/php/api/get-galeria-portada.php', { GaleriaID: this.GaleriaID }).then(function (res) {
				_this.datos = res.data;
				_this.listo = true;
			}).catch(function (e) {
				_this.datos = {
					Nombre: 'Galería no encontrada',
					GaleriaID: _this.GaleriaID,
					FechaUnix: Math.floor(new Date().getTime() / 1000)
				};
				_this.listo = true;
			});
		}
	},

	computed: {
		portada: function portada() {
			if (!this.datos) {
				return '/src/modulos/galerias/static/noimage.png';
			}
			return this.datos.PortadaID ? '/src/modulos/galerias/php/api/thumb.php?ItemID=' + this.datos.PortadaID : '/src/modulos/galerias/static/noimage.png';
		}
	}
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visor_item_mini_item__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listado_galerias_mini_galeria__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__visor_item_visor_item__ = __webpack_require__(89);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'mini-item': __WEBPACK_IMPORTED_MODULE_2__visor_item_mini_item__["a" /* default */],
		'visor-item': __WEBPACK_IMPORTED_MODULE_4__visor_item_visor_item__["a" /* default */],
		'mini-galeria': __WEBPACK_IMPORTED_MODULE_3__listado_galerias_mini_galeria__["a" /* default */]
	},
	data: function data() {
		return {
			verItem: null
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		'resultados': 'galerias/buscador'
	}), {
		listado: function listado() {
			return this.resultados.items.map(function (i) {
				return i.ItemID;
			});
		}
	}),
	methods: {
		verGaleria: function verGaleria(GaleriaID) {
			this.$router.push('/main/galerias/' + GaleriaID);
		}
	}
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listado_listado__ = __webpack_require__(1146);
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	components: {
		'listado': __WEBPACK_IMPORTED_MODULE_0__components_listado_listado__["a" /* default */]
	}
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listado_filtro__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_editor__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__(494);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'listado-filtro': __WEBPACK_IMPORTED_MODULE_2__listado_filtro__["a" /* default */],
		'editor-anunciante': __WEBPACK_IMPORTED_MODULE_3__editor_editor__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				semaforo: null,
				agente: '',
				nombre: '',
				activo: null,
				bloqueado: null,
				facturacion: null,
				max: 50
			},
			resultados: [],
			idAnunciante: null
		};
	},

	created: function created() {
		this.buscar();
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		session: 'session/usuario'
	})),

	methods: {
		buscar: function buscar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].buscar(this.filtro).then(function (res) {
				_this.resultados = res.data.resultados;
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error realizando la búsqueda'
				});
			});
		}
	}
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['filtro'],
	data: function data() {
		return {};
	},
	name: 'filtro-listado',

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	})),

	methods: {
		buscar: function buscar() {
			this.$emit('buscar');
		},
		nuevo: function nuevo() {
			this.$emit('nuevo');
		}
	}
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(494);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editor-anunciante',
	props: ['idAnunciante'],

	watch: {
		idAnunciante: function idAnunciante(val) {
			var _this = this;

			if (val === 'nuevo') {
				// Generamos un nuevo objeto de tipo anunciante
				this.nuevo();
			} else {
				// Cargamos el anunciante
				__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getAnunciante(val).then(function (res) {
					_this.anunciante = res.data.anunciante;
				}).catch(function (e) {
					_this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error obteniendo el anunciante'
					});
				});
			}
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	})),

	created: function created() {
		var _this2 = this;

		if (this.idAnunciante === 'nuevo') {
			// Generamos un nuevo objeto de tipo anunciante
			this.nuevo();
		} else {
			// Cargamos el anunciante
			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getAnunciante(this.idAnunciante).then(function (res) {
				_this2.anunciante = res.data.anunciante;
			}).catch(function (e) {
				_this2.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error obteniendo el anunciante'
				});
			});
		}
	},


	data: function data() {
		return {
			anunciante: null
		};
	},

	methods: {
		nuevo: function nuevo() {
			this.anunciante = {
				ID: null,
				nombre: '',
				agente: {
					ID: null,
					nombre: null,
					avatar: null
				},
				activo: true,
				telefonos: [],
				emails: [],
				direcciones: [{
					pais: 'España',
					region: 'Comunidad Valenciana',
					provincia: 'Castellón',
					via: null,
					numero: null,
					esc: null,
					piso: null,
					puerta: null,
					cp: null,
					indicaciones: null
				}],
				ficheros: [],
				anotaciones: null,
				categorias: []
			};

			if (!this.permisos['anunciantes-crearTodos']) {
				this.anunciante.agente.ID = this.usuario.ID;
				this.anunciante.agente.nombre = this.usuario.nombre;
				this.anunciante.agente.avatar = this.usuario.avatar;
			}
		},
		setAgente: function setAgente(datos) {
			if (!this.permisos.anunciantes_crearTodos) {
				return;
			}
			if (!datos) {
				this.anunciante.agente.ID = null;
				this.anunciante.agente.nombre = null;
				this.anunciante.agente.avatar = null;
			} else {
				this.anunciante.agente.ID = datos.datos.ID;
				this.anunciante.agente.nombre = datos.datos.nombre;
				this.anunciante.agente.avatar = datos.datos.avatar;
			}
		},
		addCategoria: function addCategoria(d) {
			for (var i = 0; i < this.anunciante.categorias.length; i++) {
				if (this.anunciante.categorias[i].CategoriaID === d.datos.CategoriaID) {
					return;
				}
			}

			this.anunciante.categorias.push(d.datos);
		},
		delCategoria: function delCategoria(CategoriaID) {
			this.anunciante.categorias = this.anunciante.categorias.filter(function (c) {
				return c.CategoriaID !== CategoriaID;
			});
		},
		addTel: function addTel() {
			this.anunciante.telefonos.push({
				ID_telefono: null,
				telefono: null,
				nombre: null
			});
		},
		quitaTel: function quitaTel(i) {
			this.anunciante.telefonos.splice(i, 1);
		},
		addEmail: function addEmail() {
			this.anunciante.emails.push({
				ID_email: null,
				email: null,
				nombre: null
			});
		},
		addDireccion: function addDireccion() {
			this.anunciante.direcciones.push({
				ID_direccion: null,
				pais: 'España',
				region: 'Comunidad Valenciana',
				provincia: 'Castellón',
				via: null,
				numero: null,
				esc: null,
				piso: null,
				puerta: null,
				cp: null,
				indicaciones: null
			});
		},
		quitaEmail: function quitaEmail(i) {
			this.anunciante.emails.splice(i, 1);
		},
		quitarFichero: function quitarFichero(idFichero) {
			var _this3 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar fichero',
				mensaje: '¿Quieres eliminar este fichero?\nEsta acción no se podrá deshacer',
				callback: function callback(acepta) {
					if (!acepta) {
						return;
					}

					var datos = {
						ID_anunciante: _this3.anunciante.ID_anunciante,
						ID_fichero: idFichero
					};

					__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].delFichero(datos).then(function (res) {
						_this3.anunciante = res.data.anunciante;
					}).catch(function (e) {
						_this3.$store.commit('alertas/alert', {
							titulo: 'Error',
							mensaje: 'Error eliminando el fichero'
						});
					});
				}
			});
		},
		doUpload: function doUpload() {
			var _this4 = this;

			// creamos el input
			var inp = document.createElement('input');
			inp.setAttribute('type', 'file');
			inp.setAttribute('multiple', 'true');
			inp.name = 'ficheros';

			// Vigilamos el evento change
			inp.addEventListener('change', function (ev) {
				var form = new FormData();
				form.append('ID_anunciante', _this4.anunciante.ID_anunciante);
				for (var i = 0; i < ev.srcElement.files.length; i++) {
					form.append('fichero[]', ev.srcElement.files[i]);
				}

				__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setFichero(form).then(function (res) {
					inp.parentNode.removeChild(inp);
					_this4.anunciante = res.data.anunciante;
				}).catch(function (e) {
					_this4.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'Error subiendo el fichero'
					});
					inp.parentNode.removeChild(inp);
				});
			});

			// lo añadimos al dom
			document.body.appendChild(inp);

			// disparamos el evento
			inp.click();
		},
		guardar: function guardar() {
			var _this5 = this;

			if (!this.anunciante.nombre) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Por favor escribe el nombre del anunciante'
				});
				return;
			}

			if (!this.anunciante.agente.ID) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Por favor selecciona el agente'
				});
				return;
			}

			if (this.anunciante.categorias.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos una categoría');
				return;
			}

			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setAnunciante(this.anunciante).then(function (res) {
				_this5.anunciante = res.data.anunciante;
				_this5.$store.commit('alertas/alert', {
					titulo: 'Guardado',
					mensaje: 'Se han guardado los cambios correctamente'
				});
			}).catch(function (e) {
				_this5.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error guardando los cambios'
				});
			});
		},
		descargar: function descargar(idFichero) {
			document.location.href = '/src/modulos/gestion-anunciantes/php/api/descarga-fichero.php?ID_anunciante=' + this.anunciante.ID_anunciante + '&ID_fichero=' + idFichero;
		},
		cerrar: function cerrar() {
			this.nuevo();
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


// Definimos la ruta de la api
var ApiAnunciantes = 'gestion-anunciantes/php/api/';

/* harmony default export */ __webpack_exports__["a"] = ({
	getPermisos: function getPermisos() {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(ApiAnunciantes + 'get-permisos.php');
	},
	buscar: function buscar(filtro) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(ApiAnunciantes + 'get-buscar.php', filtro);
	},
	getAnunciante: function getAnunciante(idAnunciante) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(ApiAnunciantes + 'get-anunciante.php?ID=' + idAnunciante);
	},
	setAnunciante: function setAnunciante(datos) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(ApiAnunciantes + 'set-anunciante.php', datos);
	},
	setFichero: function setFichero(formData) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(ApiAnunciantes + 'set-fichero.php', formData);
	},
	delFichero: function delFichero(datos) {
		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(ApiAnunciantes + 'del-fichero.php', datos);
	}
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listado_listado_vue__ = __webpack_require__(1156);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'clientes',
	components: {
		'listado': __WEBPACK_IMPORTED_MODULE_0__components_listado_listado_vue__["a" /* default */]
	}
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listado_filtro__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_editor__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api__ = __webpack_require__(469);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'listado-filtro': __WEBPACK_IMPORTED_MODULE_2__listado_filtro__["a" /* default */],
		'editor-cliente': __WEBPACK_IMPORTED_MODULE_3__editor_editor__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				semaforoContratos: null,
				semaforoPropuestas: null,
				agente: '',
				nombre: '',
				activo: true,
				asignado: true,
				facturacion: null,
				max: 50,
				Google: null,
				ordenarCampo: 'cliente.cliente',
				ordenarOrden: 'ASC'
			},
			resultados: [],
			idCliente: null
		};
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	})),
	methods: {
		buscar: function buscar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_4__services_api__["a" /* default */].buscar(this.filtro).then(function (res) {
				// procesamos el color del semaforo
				res.data.resultados = res.data.resultados.map(function (r) {
					if (typeof r.dias_sin_campana !== 'number') {
						r.color = 'semaforoRojo';
					} else {
						if (r.dias_sin_campana <= 150) {
							r.color = 'semaforoVerde'; // Verde
						} else if (r.dias_sin_campana <= 300) {
							r.color = 'semaforoAmarillo'; // Naranja
						} else {
							r.color = 'semaforoRojo';
						}
					}

					if (typeof r.dias_sin_contacto !== 'number') {
						r.colorPropuesta = 'semaforoRojo';
					} else {
						if (r.dias_sin_contacto <= 150) {
							r.colorPropuesta = 'semaforoVerde';
						} else if (r.dias_sin_contacto <= 300) {
							r.colorPropuesta = 'semaforoAmarillo';
						} else {
							r.colorPropuesta = 'semaforoRojo';
						}
					}

					return r;
				});
				_this.resultados = res.data.resultados;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cierraEditor: function cierraEditor() {
			this.idCliente = null;
			this.buscar();
		}
	}
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['filtro'],
	data: function data() {
		return {
			listadoCampos: [{
				nombre: 'Agente',
				campo: 'agente.nombre'
			}, {
				nombre: 'Cliente',
				campo: 'cliente.cliente'
			}, {
				nombre: 'Fecha de creación',
				campo: 'cliente.fecha_creacion'
			}, {
				nombre: 'CIF',
				campo: 'cliente.CIF'
			}, {
				nombre: 'Facturación',
				campo: 'cliente.importe_facturado'
			}, {
				nombre: 'Semáforo',
				campo: 'cliente.dias_sin_campana'
			}]
		};
	},
	name: 'filtro-listado',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	})),
	methods: {
		buscar: function buscar() {
			this.$emit('buscar');
		},
		nuevo: function nuevo() {
			this.$emit('nuevo');
		}
	}
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__seleccion_agente_component__ = __webpack_require__(1164);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		SeleccionAgente: __WEBPACK_IMPORTED_MODULE_1__seleccion_agente_component__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				nombre: '',
				agente: '',
				semaforo: ''
			},
			traspasar: false,
			seleccionados: [],
			resultados: []
		};
	},

	methods: {
		setSemaforo: function setSemaforo(color) {
			this.filtro.semaforo = color;
			this.buscar();
		},
		toggleCliente: function toggleCliente(ID) {
			var idx = this.seleccionados.indexOf(ID);

			if (idx < 0) {
				this.seleccionados.push(ID);
			} else {
				this.seleccionados.splice(idx, 1);
			}
		},
		buscar: function buscar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-clientes/php/api/cartera/buscar.php', this.filtro).then(function (res) {
				_this.seleccionados = [];
				_this.resultados = res.data.resultados;
			}).catch(function (e) {
				_this.$error('Error', e.response.data.error);
			});
		}
	}
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['clientes'],
	data: function data() {
		return {
			datos: {
				AgenteID: null,
				FechaInicioContratos: null,
				FechaInicioProducciones: null,
				contratos: true,
				anunciantes: true,
				producciones: true
			},
			AgenteNombre: null
		};
	},

	methods: {
		seleccionaAgente: function seleccionaAgente(ev) {
			this.datos.AgenteID = ev.datos.ID;
			this.AgenteNombre = ev.datos.nombre;
		},
		asignar: function asignar() {
			var _this = this;

			if (!this.datos.AgenteID) {
				this.$error('Error', 'No has seleccionado el agente');
				return;
			}

			if (this.datos.contratos && !this.datos.FechaInicioContratos) {
				this.$error('Error', 'No has la fecha de inicio de los contratos a migrar');
				return;
			}

			if (this.datos.producciones && !this.datos.FechaInicioProducciones) {
				this.$error('Error', 'No has la fecha de inicio de las producciones a migrar');
				return;
			}

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.datos));
			form.FechaInicioContratos = this.datos.FechaInicioContratos ? this.$moment(this.FechaInicioContratos).format('DD-MM-YYYY') : null;
			form.FechaInicioProducciones = this.datos.FechaInicioProducciones ? this.$moment(this.FechaInicioProducciones).format('DD-MM-YYYY') : null;
			form.clientes = this.clientes;
			this.$store.commit('alertas/confirm', {
				titulo: 'Traspasar clientes',
				mensaje: '\xBFQuieres continuar con el traspaso de clientes?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('gestion-clientes/php/api/cartera/asignar.php', form).then(function (res) {
							_this.$store.commit('toast/success', {
								titulo: 'Traspaso realizado con éxito'
							});
							_this.$emit('traspasado');
							_this.cerrar();
						}).catch(_this.$responseError);
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editor_cuentas__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_alias__ = __webpack_require__(1172);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'editor-cuenta': __WEBPACK_IMPORTED_MODULE_1__editor_cuentas__["a" /* default */],
		'editor-alias': __WEBPACK_IMPORTED_MODULE_2__editor_alias__["a" /* default */]
	},
	data: function data() {
		return {
			tipo: 'cuentas',
			cuenta: null,
			listadoCuentas: [],
			listadoAlias: [],
			editandoAlias: null
		};
	},
	created: function created() {
		this.getCuentas();
	},


	methods: {
		nuevaCuenta: function nuevaCuenta() {
			this.cuenta = 'nueva';
		},
		editarCuenta: function editarCuenta(id) {
			this.cuenta = id;
			this.$forceUpdate();
		},
		nuevoAlias: function nuevoAlias() {
			this.editandoAlias = 'nuevo';
		},
		editarAlias: function editarAlias(alias) {
			this.editandoAlias = {
				cuenta: alias.origen,
				dominio: alias.dominio_origen
			};
		},
		setTipo: function setTipo(tipo) {
			this.tipo = tipo;

			if (tipo === 'cuentas') {
				this.getCuentas();
			} else {
				this.getAlias();
			}
		},
		getCuentas: function getCuentas() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCuentas().then(function (res) {
				_this.listadoCuentas = res.data.cuentas;
				_this.listadoAlias = [];
				_this.editandoAlias = false;
			}).catch(this.error);
		},
		getAlias: function getAlias() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getAliases().then(function (res) {
				_this2.listadoAlias = res.data.alias;
				_this2.cuenta = null;
				_this2.listadoCuentas = [];
			}).catch(this.error);
		},
		error: function error(e) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		}
	}
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idCuenta'],
	data: function data() {
		return {
			cuenta: null,
			listadoDominios: [],
			token: {
				nombre: ''
			},
			creandoToken: false
		};
	},


	watch: {
		idCuenta: function idCuenta(nuevo, anterior) {
			if (nuevo === 'nueva') {
				this.cuenta = {
					id: null,
					cuenta: '',
					dominio_id: null,
					quota_gb: 5,
					usuario_id: null,
					usuario: null
				};
			} else {
				this.getCuenta();
			}
		}
	},

	computed: {
		formValido: function formValido() {
			return this.cuenta.cuenta && this.cuenta.dominio_id && this.cuenta.quota_gb;
		}
	},

	created: function created() {
		this.getDominios();
		if (this.idCuenta !== 'nueva') {
			// Obtenemos la cuenta
			this.getCuenta();
		} else {
			this.cuenta = {
				id: null,
				cuenta: '',
				dominio_id: null,
				quota_gb: 5,
				usuario_id: null,
				usuario: null
			};
		}
	},


	methods: {
		getCuenta: function getCuenta() {
			var _this = this;

			if (!this.idCuenta) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'No existe un id de cuenta válido'
				});
				return;
			}
			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCuenta(this.idCuenta).then(function (res) {
				_this.cuenta = res.data.cuenta;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		getDominios: function getDominios() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getDominios().then(function (res) {
				_this2.listadoDominios = res.data.dominios;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		setUsuario: function setUsuario(ev) {
			this.cuenta.usuario_id = ev.datos.ID;
			this.cuenta.usuario = ev.datos;
		},
		quitaUsuario: function quitaUsuario() {
			this.cuenta.usuario_id = null;
			this.cuenta.usuario = null;
		},
		guardar: function guardar() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].setCuenta(this.cuenta).then(function (res) {
				_this3.cuenta = res.data.cuenta;
				_this3.$emit('update');
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevoToken: function nuevoToken() {
			var _this4 = this;

			if (!this.token.nombre) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes escribir un nombre'
				});
				return;
			}

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].setToken(this.cuenta.id, this.token.nombre).then(function (res) {
				_this4.getCuenta();

				_this4.$store.commit('alertas/alert', {
					titulo: 'Correcto',
					mensaje: 'Se ha generado un nuevo token de acceso para esta cuenta. \xC9ste es:\n\t\t\t\t\t\t<b>' + res.data.token + '</b>\n\t\t\t\t\t\tEs recomendable que configures tu cuenta ahora con este token, pues ya no lo podr\xE1s recuperar.'
				});
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cancelarCrearToken: function cancelarCrearToken() {
			this.token.nombre = '';
			this.creandoToken = false;
		},
		delToken: function delToken(idToken) {
			var _this5 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar token',
				mensaje: '¿Quieres eliminar este token?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delToken(idToken).then(function (res) {
							_this5.getCuenta();
						}).catch(function (e) {
							_this5.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		eliminar: function eliminar() {
			var _this6 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Error',
				mensaje: '¿Quieres eliminar esta cuenta de correo?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delCuenta(_this6.cuenta.id).then(function () {
							_this6.$emit('update');
							_this6.cuenta = null;
							_this6.idCuenta = null;
						}).catch(function (e) {
							_this6.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}

});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['alias'],

	watch: {
		alias: function alias(nuevo, anterior) {
			if (this.alias !== 'nuevo') {
				this.editarOrigen = false;
				this.getAlias();
				this.cuentaOld = this.alias.cuenta;
				this.dominioOld = this.alias.dominio;
				this.nuevo = null;
			} else {
				this.editarOrigen = true;
				this.cuentas = [];
				this.nuevo = {
					cuenta: '',
					dominio_destino: null
				};
			}
		}
	},

	created: function created() {
		var _this = this;

		if (this.alias === 'nuevo') {
			this.editarOrigen = true;
			this.cuentas = [];
			this.nuevo = {
				cuenta: '',
				dominio_destino: null
			};
		} else {
			this.editarOrigen = false;
			this.getAlias();
			this.cuentaOld = this.alias.cuenta;
			this.dominioOld = this.alias.dominio;
		}
		__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getDominios().then(function (res) {
			_this.listadoDominios = res.data.dominios;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},
	data: function data() {
		return {
			cuentas: [],
			datos: {
				cuentaOld: '',
				dominioOld: null,
				cuentaNew: '',
				dominioNew: null
			},
			nuevo: null,
			editarOrigen: false,
			listadoDominios: []
		};
	},


	methods: {
		nuevoDestino: function nuevoDestino() {
			this.nuevo = {
				cuenta: '',
				dominio_destino: null
			};
		},
		getAlias: function getAlias() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getAlias(this.alias.cuenta, this.alias.dominio).then(function (res) {
				_this2.cuentas = res.data.alias;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cambiarOrigen: function cambiarOrigen() {
			this.datos.cuentaNew = this.alias.cuenta.toString();
			this.datos.dominioNew = this.alias.dominio + 0;
			this.editarOrigen = true;
		},
		crear: function crear() {
			var _this3 = this;

			var datos = {
				cuenta_origen: this.datos.cuentaNew,
				dominio_origen: this.datos.dominioNew,
				cuenta_destino: this.nuevo.cuenta,
				dominio_destino: this.nuevo.dominio_destino
			};
			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].setAlias(datos).then(function (res) {
				_this3.$emit('update:alias', res.data.alias);
				_this3.getAlias();
				_this3.getDominios();
				_this3.nuevo = null;
				_this3.editarOrigen = false;
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		addDestino: function addDestino() {
			var _this4 = this;

			var datos = {
				cuenta_origen: this.alias.cuenta,
				dominio_origen: this.alias.dominio,
				cuenta_destino: this.nuevo.cuenta,
				dominio_destino: this.nuevo.dominio_destino
			};
			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].setAlias(datos).then(function (res) {
				_this4.$emit('update:alias', res.data.alias);
				_this4.getAlias();
				_this4.getDominios();
				_this4.nuevo = null;
				_this4.editarOrigen = false;
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		eliminar: function eliminar() {
			var _this5 = this;

			// Vamos a eliminar el alias y todos sus destinos
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar alias',
				mensaje: '\xBFQuieres eliminar este alias y todos sus destinos?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].eliminarAlias(_this5.alias).then(function (res) {
							_this5.$emit('update');
							_this5.$emit('update:alias', null);
						}).catch(function (e) {
							_this5.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		eliminarDestino: function eliminarDestino(destino) {
			var _this6 = this;

			var eliminaTodo = this.cuentas.length === 1;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar destino',
				mensaje: '¿Quieres eliminar este destino del alias?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delAlias(destino).then(function (res) {
							if (eliminaTodo) {
								_this6.$emit('update');
								_this6.$emit('update:alias', null);
							} else {
								_this6.getAlias();
							}
						}).catch(function (e) {
							_this6.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_gestion_ediciones__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'gestion-ediciones': __WEBPACK_IMPORTED_MODULE_1__components_gestion_ediciones__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				emisoras: [],
				fechaIni: null,
				fechaFin: null,
				tipo: 'general',
				incluirTablas: true,
				incluirGraficas: true
			},
			resultados: {
				porHoras: null,
				general: null
			},
			gestionEdiciones: false,
			ignoraFechas: {
				customPredictor: function customPredictor(date) {
					if (!date.getMonth().toString().match(/^(3|6|11)$/)) {
						return true;
					}

					return false;
				}
			},
			opcionesPie: {
				ticks: {
					min: 0
				}
			}
		};
	},


	computed: {
		datosQuesito: function datosQuesito() {
			if (!this.resultados.general) {
				return null;
			}

			if (this.resultados.general.labels.length > 1) {
				return null;
			}

			var datasets = this.resultados.general.datasets;

			var obj = {
				labels: [],
				data: [],
				options: {
					ticks: {
						min: 0
					},
					backgroundColor: []
				}
			};

			for (var i = 0; i < datasets.length; i++) {
				obj.labels.push(datasets[i].label);
				obj.data.push(datasets[i].data[0]);
				obj.options.backgroundColor.push(datasets[i].backgroundColor);
			}

			return obj;
		}
	},

	methods: {
		ponEmisora: function ponEmisora(ev) {
			for (var i = 0; i < this.filtro.emisoras.length; i++) {
				if (this.filtro.emisoras[i].ID_emisora === ev.datos.ID_emisora) {
					return;
				}
			}

			this.filtro.emisoras.push(ev.datos);
		},
		quitaEmisora: function quitaEmisora(datos) {
			for (var i = 0; i < this.filtro.emisoras.length; i++) {
				if (this.filtro.emisoras[i].ID_emisora === datos.ID_emisora) {
					this.filtro.emisoras.splice(i, 1);
					return;
				}
			}
		},
		consultar: function consultar() {
			var _this = this;

			this.resultados.porHoras = null;
			this.resultados.general = null;

			this.filtro.fechaIni.setDate(1);
			this.filtro.fechaIni.setHours(0);
			this.filtro.fechaIni.setMinutes(0);
			this.filtro.fechaIni.setSeconds(0);
			this.filtro.fechaIni.setMilliseconds(0);

			if (this.filtro.fechaFin) {
				this.filtro.fechaFin.setDate(1);
				this.filtro.fechaFin.setHours(0);
				this.filtro.fechaFin.setMinutes(0);
				this.filtro.fechaFin.setSeconds(0);
				this.filtro.fechaFin.setMilliseconds(0);
			} else {
				this.filtro.fechaFin = new Date(this.filtro.fechaIni.getTime());
			}

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.fechaIni = this.filtro.fechaIni ? Math.floor(this.filtro.fechaIni.getTime() / 1000) : null;
			form.fechaFin = this.filtro.fechaFin ? Math.floor(this.filtro.fechaFin.getTime() / 1000) : null;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/gestion-egm/php/api/consulta.php', form).then(function (res) {
				if (res.data.resultados.porHoras) {
					_this.resultados.porHoras = res.data.resultados.porHoras;
					_this.resultados.general = null;
				} else if (res.data.resultados.general) {
					_this.resultados.porHoras = null;
					_this.resultados.general = res.data.resultados.general;
				} else {
					_this.resultados.porHoras = null;
					_this.resultados.general = null;
				}
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nueva_emisora__ = __webpack_require__(1178);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'editor-emisora': __WEBPACK_IMPORTED_MODULE_1__nueva_emisora__["a" /* default */]
	},
	data: function data() {
		return {
			idEmisora: null,
			edicion: {
				fecha: null,
				fechaUnix: null,
				emisora_ID: null,
				emisoraInfo: null,
				oyentes: null,
				horas: []
			},
			ignoraFechas: {
				customPredictor: function customPredictor(date) {
					if (!date.getMonth().toString().match(/^(3|6|11)$/)) {
						return true;
					}

					return false;
				}
			}
		};
	},


	methods: {
		setEdicion: function setEdicion(ev) {
			this.edicion.ano = this.edicion.fecha.getFullYear();
			this.edicion.mes = this.edicion.fecha.getMonth() + 1;
			if (this.edicion.emisora_ID) {
				this.getEdicion();
			}
		},
		seleccionaEmisora: function seleccionaEmisora(ev) {
			this.edicion.emisora_ID = ev.datos.ID_emisora;
			this.edicion.emisoraInfo = ev.datos;
			this.getEdicion();
		},
		getEdicion: function getEdicion() {
			var _this = this;

			// Ahora obtenemos las cifras de audiencia si existen
			var datos = {
				fechaUnix: Math.floor(this.edicion.fecha.getTime() / 1000),
				emisora_ID: this.edicion.emisora_ID
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/gestion-egm/php/api/get-edicion.php', datos).then(function (res) {
				_this.edicion = res.data.edicion;
				_this.edicion.fecha = new Date(_this.edicion.fechaUnix * 1000);
				_this.$forceUpdate();
			}).catch(function () {
				_this.generaHoras();
			});
		},
		generaHoras: function generaHoras() {
			this.edicion.horas = [];
			for (var i = 0; i < 24; i++) {
				this.edicion.horas.push({
					hora: i,
					oyentes: 0
				});
			}
		},
		guardar: function guardar() {
			var _this2 = this;

			this.edicion.fechaUnix = Math.floor(this.edicion.fecha.getTime() / 1000);
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/gestion-egm/php/api/set-edicion.php', this.edicion).then(function (res) {
				_this2.edicion = res.data.edicion;
				_this2.edicion.fecha = new Date(_this2.edicion.fechaUnix * 1000);
				_this2.$store.commit('toast/success', {
					titulo: 'Guardado',
					mensaje: 'Se han guardado los datos'
				});
			}).catch(this.$responseError);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idEmisora'],
	data: function data() {
		return {
			emisora: null
		};
	},
	created: function created() {
		var _this = this;

		if (this.idEmisora === 'nueva') {
			this.nueva();
		} else {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/gestion-egm/php/api/get-emisora.php?ID_emisora=' + this.idEmisora).then(function (res) {
				_this.emisora = res.data.emisora;
			}).catch(this.$responseError);
		}
	},

	methods: {
		nueva: function nueva() {
			this.emisora = {
				ID_emisora: null,
				nombre: null,
				logo: null,
				grupo_ID: null
			};
		},
		guardar: function guardar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/gestion-egm/php/api/set-emisora.php', this.emisora).then(function (res) {
				_this2.$store.commit('toast/success', {
					titulo: 'Emisora guardada',
					mensaje: 'Se ha guardado correctamente'
				});
				_this2.cerrar();
			}).catch(this.$responseError);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			menu: [{
				url: '/main/panel-control/gestion-emisoras/emisoras',
				icono: 'fa fa-podcast',
				nombre: 'Emisoras'
			}, {
				url: '/main/panel-control/gestion-emisoras/bloques',
				icono: 'fa fa-braille',
				nombre: 'Bloques'
			}, {
				url: '/main/panel-control/gestion-emisoras/contenidos',
				icono: 'fa fa-cubes',
				nombre: 'Contenidos'
			}, {
				url: '/main/panel-control/gestion-emisoras/programas',
				icono: 'fa fa-puzzle-piece',
				nombre: 'Programas'
			}]
		};
	}
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generador_bloques_vue__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilidades_select_dias_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_bloque_vue__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'generador-bloques': __WEBPACK_IMPORTED_MODULE_1__generador_bloques_vue__["a" /* default */],
		'btn-dias': __WEBPACK_IMPORTED_MODULE_2__utilidades_select_dias_vue__["a" /* default */],
		'editor-bloque': __WEBPACK_IMPORTED_MODULE_3__editor_bloque_vue__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				emisora: null,
				dia: new Date()
			},
			ID_bloque: null,
			listadoEmisoras: [],
			listadoBloques: [],
			editarBloque: null,
			dias: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
			plantillaDia: null,
			generarBloques: null
		};
	},
	created: function created() {
		this.getListadoEmisoras();
	},

	methods: {
		buscar: function buscar() {
			var _this = this;

			var buscar = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			buscar.dia = Math.floor(new Date(this.filtro.dia.getTime()).getTime() / 1000);
			__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('gestion-emisoras/php/api/bloques/buscar-bloques.php', buscar).then(function (res) {
				_this.listadoBloques = res.data.listado;
			}).catch(this.$responseError);
		},
		getDias: function getDias(misDias) {
			var str = [];
			for (var i = 0; i < misDias.length; i++) {
				str.push(this.dias[misDias[i]]);
			}
			return str.join(', ');
		},
		getListadoEmisoras: function getListadoEmisoras() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/gestion-emisoras/php/api/emisoras/buscar-emisoras.php', { activa: true }).then(function (res) {
				_this2.listadoEmisoras = res.data.listado;
			}).catch(this.$responseError);
		},
		nuevoBloque: function nuevoBloque() {
			this.plantillaDia = null;
			this.generarBloques = true;
		},
		editar: function editar(bloque) {
			this.editarBloque = bloque;
		},
		eliminar: function eliminar(bloque) {
			var _this3 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar bloque',
				mensaje: '\xBFQuieres eliminar este bloque?\n\t\t\t\tSi hay publicidad insertada, quedar\xE1 desasignada',
				callback: function callback(acepta) {
					if (acepta) {
						_this3.$http.delete('gestion-emisoras/php/api/bloques/del-bloque.php?ID_bloque=' + bloque.ID_bloque).then(function (res) {
							_this3.$store.commit('toast/success', {
								titulo: 'Eliminado',
								mensaje: 'Se ha eliminado el bloque correctamente'
							});
							_this3.buscar();
						}).catch(_this3.$responseError);
					}
				}
			});
		},
		clonar: function clonar() {
			var _this4 = this;

			var buscar = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			buscar.dia = Math.floor(new Date(this.filtro.dia.getTime()).getTime() / 1000);
			__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('gestion-emisoras/php/api/bloques/buscar-bloques.php', buscar).then(function (res) {
				// Armamos el objeto
				_this4.plantillaDia = {
					ID_bloque: null,
					emisora_ID: _this4.filtro.emisora,
					hora_inicio: null,
					hora_fin: null,
					programa_ID: null,
					activo: true,
					dias: [],
					horas: []
				};

				for (var i = 0; i < res.data.listado.length; i++) {
					_this4.plantillaDia.horas.push({
						hora_inicio: res.data.listado[i].hora_inicio,
						hora_fin: res.data.listado[i].hora_fin,
						id: res.data.listado[i].ID_bloque
					});
				}

				_this4.generarBloques = true;
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilidades_select_dias_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilidades_calendario_anual_vue__ = __webpack_require__(34);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'btn-dias': __WEBPACK_IMPORTED_MODULE_3__utilidades_select_dias_vue__["a" /* default */],
		'calendario-anual': __WEBPACK_IMPORTED_MODULE_4__utilidades_calendario_anual_vue__["a" /* default */]
	},
	props: ['plantilla'],
	data: function data() {
		return {
			bloque: {
				ID_bloque: null,
				emisora_ID: null,
				hora_inicio: null,
				hora_fin: null,
				programa_ID: null,
				activo: true,
				dias: [],
				horas: []
			},
			fechaCertificada: new Date(),
			anoCalendario: new Date().getFullYear(),
			festivos: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a(),
			atajos: {
				fecha_inicio: null,
				fecha_fin: null,
				dias_semana: [],
				excluir: []
			},
			listadoEmisoras: []
		};
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('gestion-emisoras/php/api/emisoras/buscar-emisoras.php').then(function (res) {
			_this.listadoEmisoras = res.data.listado;
		}).catch(this.$responseError);

		if (this.plantilla) {
			this.bloque = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.plantilla));
		}
	},

	methods: {
		cambiaAno: function cambiaAno(ano) {
			this.anoCalendario = ano;
			this.getFestivos();
		},
		nuevaHora: function nuevaHora() {
			this.bloque.horas.push({
				id: new Date().getTime(),
				hora_inicio: '',
				hora_fin: '',
				tipo_bloque: 'automatico',
				tipo_disparo: 'contacto',
				ventana: 15,
				max_inserciones: null
			});
		},
		quitaHora: function quitaHora(id) {
			for (var i = 0; i < this.bloque.horas.length; i++) {
				if (this.bloque.horas[i].id === id) {
					this.bloque.horas.splice(i, 1);
					return;
				}
			}
		},
		guardar: function guardar() {
			var _this2 = this;

			// convertimos las fechas
			if (!this.bloque.emisora_ID) {
				this.$error('Error', 'No has seleccionado la emisora');
				return;
			}
			if (this.bloque.horas.length === 0) {
				this.$error('Error', 'Debes proporcionar al menos un intérvalo de horas');
				return;
			}
			if (this.bloque.dias.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un día en el calendario');
				return;
			}
			var post = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bloque));
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('gestion-emisoras/php/api/bloques/generar-bloques.php', post).then(function (res) {
				_this2.$store.commit('toast/success', {
					titulo: 'Bloques generados',
					mensaje: 'Se han guardado los bloques correctamente'
				});
				_this2.cerrar();
			}).catch(this.$responseError);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['dias'],
	data: function data() {
		return {
			misDias: [],
			diasSTR: ['L', 'M', 'X', 'J', 'V', 'S', 'D']
		};
	},
	created: function created() {
		this.misDias = [].concat(this.dias);
	},

	watch: {
		dias: function dias(newValue) {
			this.misDias = [].concat(newValue);
			this.misDias.sort();
		}
	},
	computed: {
		filtroTodosDias: function filtroTodosDias() {
			return this.misDias.length === 7;
		},
		filtroEntreSemana: function filtroEntreSemana() {
			var dias = [0, 1, 2, 3, 4];

			for (var i = 0; i < dias.length; i++) {
				if (this.misDias.indexOf(dias[i]) < 0) {
					return false;
				}
			}
			return true;
		},
		filtroSyV: function filtroSyV() {
			return this.misDias.indexOf(5) >= 0 && this.misDias.indexOf(6) >= 0;
		}
	},
	methods: {
		toggleTodosDias: function toggleTodosDias() {
			if (this.misDias.length === 0) {
				for (var i = 0; i < 7; i++) {
					this.misDias.push(i);
				}
			} else {
				this.misDias = [];
			}

			this.update();
		},
		toggleEntreSemana: function toggleEntreSemana() {
			var dias = [0, 1, 2, 3, 4];
			var encontrado = false;

			for (var i = 0; i < dias.length; i++) {
				if (this.misDias.indexOf(dias[i]) >= 0) {
					encontrado = true;
				}
			}

			if (encontrado) {
				for (var _i = 0; _i < dias.length; _i++) {
					var pos = this.misDias.indexOf(dias[_i]);
					if (pos >= 0) {
						this.misDias.splice(pos, 1);
					}
				}
			} else {
				for (var _i2 = 0; _i2 < dias.length; _i2++) {
					var _pos = this.misDias.indexOf(dias[_i2]);
					if (_pos < 0) {
						this.misDias.push(dias[_i2]);
					}
				}
			}
			this.update();
		},
		toggleFinde: function toggleFinde() {
			if (this.misDias.indexOf(5) >= 0 || this.misDias.indexOf(6) >= 0) {
				var s = this.misDias.indexOf(5);
				if (s >= 0) {
					this.misDias.splice(s, 1);
				}
				var d = this.misDias.indexOf(6);
				if (d >= 0) {
					this.misDias.splice(d, 1);
				}
			} else {
				if (this.misDias.indexOf(5) < 0) {
					this.misDias.push(5);
				}
				if (this.misDias.indexOf(6) < 0) {
					this.misDias.push(6);
				}
			}
			this.update();
		},
		toggleDiaFiltro: function toggleDiaFiltro(dia) {
			var i = this.misDias.indexOf(dia);
			if (i >= 0) {
				this.misDias.splice(i, 1);
			} else {
				this.misDias.push(dia);
			}
			this.update();
		},
		update: function update() {
			this.misDias.sort();
			this.$emit('update:dias', this.misDias);
		}
	}
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__select_dias_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['seleccion', 'ano', 'to', 'from', 'error', 'menu'],
	components: {
		'select-dias': __WEBPACK_IMPORTED_MODULE_1__select_dias_vue__["a" /* default */]
	},
	data: function data() {
		return {
			miSeleccion: [],
			semana: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
			meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
			filtro: {
				fecha_inicio: null,
				fecha_fin: null,
				excluir: [],
				dias_semana: []
			},
			anoActual: new Date().getFullYear(),
			verMenu: false,
			festivos: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a()
		};
	},
	created: function created() {
		this.miSeleccion = !this.seleccion ? [] : [].concat(this.seleccion);
		this.verMenu = typeof this.menu === 'boolean' ? this.menu : false;
		this.anoActual = typeof this.ano === 'number' ? this.ano : new Date().getFullYear();
		this.getFestivos();
	},

	watch: {
		seleccion: function seleccion(newValue) {
			this.miSeleccion = [].concat(newValue);
		},
		ano: function ano(newValue) {
			this.getFestivos();
		}
	},
	computed: {
		listadoMeses: function listadoMeses() {
			// En función del año, construímos los meses
			// cada mes contendrá tantos arrays como semanas tenga
			// y cada semana será un array de los días que la contiene
			var meses = [];
			var fecha = new Date(this.anoActual, 0, 1, 0, 0, 0, 0);

			// vemos en que día empieza el año (domingo = 0, lunes = 1, martes = 2....)
			// como en españa las semanas empiezan el lunes, restaremos uno al día de la semana y los negativos serán un 7
			var mesActual = null;
			var mes = null;
			var contador = 0;
			while (fecha.getFullYear() === this.anoActual) {
				if (++contador === 500) {
					return meses;
				}
				var semana = [];
				if (mesActual !== fecha.getMonth()) {
					mes = {
						nombre: this.meses[fecha.getMonth()],
						diaIni: new Date(fecha.getTime()),
						semanas: []
					};

					meses.push(mes);
					mesActual = fecha.getMonth();
					fecha.setDate(1);

					// Calculamos el offset
					var diasOffset = fecha.getDay() === 0 ? 6 : fecha.getDay() - 1;
					if (diasOffset !== 0) {
						for (var i = 0; i < diasOffset; i++) {
							semana.push({
								activo: false,
								fecha: new Date(fecha.getTime() - (diasOffset - i) * 86400000)
							});
						}
					}
				}

				var diaSem = fecha.getDay() === 0 ? 6 : fecha.getDay() - 1;
				for (var _i = diaSem; _i <= 6; _i++) {
					var activo = this.to && this.to < fecha || this.from && this.from > fecha ? false : fecha.getMonth() === mesActual;
					semana.push({
						activo: activo,
						fecha: new Date(fecha.getTime())
					});
					fecha.setDate(fecha.getDate() + 1);
				}

				// Si ha terminado el mes, comprobamos en que día de la semana lo hace para rellenarlo con días vacíos
				if (fecha.getMonth() !== mesActual) {
					var diaFin = fecha.getDay() === 0 ? 6 : fecha.getDay() - 1;
					if (diaFin !== 6) {
						var d = 1;
						for (var _i2 = diaFin - 1; _i2 >= 6; _i2++) {
							semana.push({
								activo: false,
								fecha: new Date(fecha.getTime() + d * 86400000)
							});
							d++;
						}
					}
				}
				mes.semanas.push(semana);
			}
			// meses.push(mes)

			return meses;
		}
	},
	methods: {
		getFestivos: function getFestivos() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('gestion-emisoras/php/api/bloques/get-festivos.php?ano=' + this.anoActual).then(function (res) {
				_this.festivos = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
				for (var i = 0; i < res.data.festivos.length; i++) {
					_this.festivos.set(res.data.festivos[i].dia * 1000, res.data.festivos[i]);
				}
			}).catch(this.$responseError);
		},
		setAno: function setAno(ano) {
			this.anoActual = ano;
			this.getFestivos();
		},
		toggleExcluir: function toggleExcluir(tipo) {
			var idx = this.filtro.excluir.indexOf(tipo);
			if (idx < 0) {
				this.filtro.excluir.push(tipo);
			} else {
				this.filtro.excluir.splice(idx, 1);
			}
		},
		toggleDia: function toggleDia(dia) {
			if (!dia.activo) {
				return;
			}
			var idx = this.miSeleccion.indexOf(dia.fecha.getTime());
			if (idx >= 0) {
				this.miSeleccion.splice(idx, 1);
			} else {
				this.miSeleccion.push(dia.fecha.getTime());
			}

			this.update();
		},
		seleccionar: function seleccionar(reset) {
			reset = reset !== false;
			if (reset) {
				this.seleccionDias = [];
			}

			if (!this.filtro.fecha_inicio || !this.filtro.fecha_fin) {
				this.$error('Error', 'Debes seleccionar una fecha de inicio y una fecha de fin');
				return;
			}

			if (this.filtro.fecha_inicio >= this.filtro.fecha_fin) {
				this.$error('Error', 'La fecha de inicio tiene que ser menor que la de fin');
				return;
			}

			if (this.filtro.dias_semana.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un día de la semana');
				return;
			}

			var fecha = new Date(this.filtro.fecha_inicio.getTime());
			fecha.setHours(0);
			fecha.setMinutes(0);
			fecha.setSeconds(0);
			fecha.setMilliseconds(0);

			while (fecha.getTime() <= this.filtro.fecha_fin.getTime()) {
				var dia = fecha.getDay() === 0 ? 6 : fecha.getDay() - 1;
				var esFestivo = this.festivos.has(fecha.getTime()) ? this.festivos.get(fecha.getTime()).tipo : null;
				var activo = this.to && this.to > fecha || this.from && this.from < fecha;
				if (activo && this.filtro.dias_semana.indexOf(dia) >= 0 && this.filtro.excluir.indexOf(esFestivo) < 0) {
					var unix = new Date(fecha.getTime()).getTime();
					if (this.miSeleccion.indexOf(unix) < 0) {
						this.miSeleccion.push(unix);
					}
				}
				fecha.setDate(fecha.getDate() + 1);
			}
			this.update();
		},
		quitar: function quitar() {
			if (!this.filtro.fecha_inicio || !this.filtro.fecha_fin) {
				this.$error('Error', 'Debes seleccionar una fecha de inicio y una fecha de fin');
				return;
			}

			if (this.filtro.fecha_inicio >= this.filtro.fecha_fin) {
				this.$error('Error', 'La fecha de inicio tiene que ser menor que la de fin');
				return;
			}

			if (this.filtro.dias_semana.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un día de la semana');
				return;
			}

			var fecha = new Date(this.filtro.fecha_inicio.getTime());
			fecha.setHours(0);
			fecha.setMinutes(0);
			fecha.setSeconds(0);
			fecha.setMilliseconds(0);

			while (fecha.getTime() <= this.filtro.fecha_fin.getTime()) {
				var dia = fecha.getDay() === 0 ? 6 : fecha.getDay() - 1;
				var esFestivo = this.festivos.has(fecha.getTime()) ? this.festivos.get(fecha.getTime()).tipo : null;
				if (this.filtro.dias_semana.indexOf(dia) >= 0 && this.filtro.excluir.indexOf(esFestivo) < 0) {
					var unix = new Date(fecha.getTime()).getTime();
					var idx = this.miSeleccion.indexOf(unix);
					if (idx >= 0) {
						this.miSeleccion.splice(idx, 1);
					}
				}
				fecha.setDate(fecha.getDate() + 1);
			}

			this.update();
		},
		update: function update() {
			this.$emit('update:seleccion', this.miSeleccion);
		}
	}
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['bloque'],
	methods: {
		guardar: function guardar() {
			var _this = this;

			this.$http.post('gestion-emisoras/php/api/bloques/set-bloque.php', this.bloque).then(function (res) {
				_this.$store.commit('toast/success', {
					titulo: 'Cambios guardados',
					mensaje: 'Se ha actualizado el bloque correctamente'
				});
				_this.$emit('guardado');
				_this.cerrar();
			}).catch(this.$responseError);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__agrega_buzon_vue__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'agregar-buzon': __WEBPACK_IMPORTED_MODULE_0__agrega_buzon_vue__["a" /* default */]
	},
	data: function data() {
		return {
			listadoEmisoras: [],
			emisora: null,
			verBtnLogotipo: false,
			relleno: null
		};
	},
	created: function created() {
		this.getEmisoras();
	},

	methods: {
		getEmisoras: function getEmisoras() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/gestion-emisoras/php/api/emisoras/buscar-emisoras.php').then(function (res) {
				_this.listadoEmisoras = res.data.listado;
			}).catch(this.$responseError);
		},
		editarEmisora: function editarEmisora(emisora) {
			this.emisora = emisora;
		},
		nuevaEmisora: function nuevaEmisora() {
			this.emisora = {
				ID_emisora: null,
				nombre: '',
				descripcion: '',
				activa: true
			};
		},
		subirLogotipo: function subirLogotipo() {
			var _this2 = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.multiple = false;
			inp.accept = '.png,.svg,.jpg';

			inp.onchange = function () {
				var form = new FormData();
				form.append('fichero', inp.files[0]);
				__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('gestion-emisoras/php/api/emisoras/set-logo.php?ID_emisora=' + _this2.emisora.ID_emisora, form).then(function (res) {
					_this2.emisora = res.data.emisora;
					_this2.getEmisoras();
					document.body.removeChild(inp);
				}).catch(function (err) {
					document.body.removeChild(inp);
					_this2.$responseError(err);
				});
			};

			document.body.appendChild(inp);
			inp.click();
		},
		guardarEmisora: function guardarEmisora() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/gestion-emisoras/php/api/emisoras/set-emisora.php', this.emisora).then(function (res) {
				// Se ha añadido la emisora
				_this3.getEmisoras();
				_this3.emisora = res.data.emisora;
				_this3.$store.commit('toast/success', {
					titulo: 'Guardado',
					mensaje: 'Cambios guardados'
				});
			}).catch(this.$responseError);
		},
		seleccionaBuzon: function seleccionaBuzon(e) {
			this.relleno = {
				ID_relleno: 'nuevo',
				nombre_buzon: e.datos.BuzonDescripcion,
				BuzonID: e.datos.BuzonID
			};
		}
	}
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idRelleno', 'idBuzon', 'nombreBuzon'],
	data: function data() {
		return {
			tipo_ID: null,
			listadoTipos: []
		};
	},
	created: function created() {
		this.getListadoTipos();
	},

	methods: {
		getListadoTipos: function getListadoTipos() {
			var _this = this;

			this.$http.get('gestion-emisoras/php/api/emisoras/get-tipos-buzones.php').then(function (res) {
				_this.listadoTipos = res.data.listado;
			}).catch(this.$responseError);
		},
		asignar: function asignar() {
			var _this2 = this;

			var datos = {
				ID_relleno: this.idRelleno,
				tipo_ID: this.tipo_ID
			};
			this.$http.post('gestion-emisoras/php/api/emisoras/set-buzon.php', datos).then(function (res) {
				_this2.$store.commit('toast/success', {
					titulo: 'Asignado',
					mensaje: 'Se ha asignado el buzón correctamente'
				});
				_this2.cerrar();
			}).catch(this.$responseError);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_contenidos__ = __webpack_require__(1199);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'editor-contenidos': __WEBPACK_IMPORTED_MODULE_0__editor_contenidos__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				emisora_ID: null,
				activo: true,
				nombre: null
			},
			ID_contenido: null,
			listadoEmisoras: [],
			listadoContenidos: [],
			dias: ['L', 'M', 'X', 'J', 'V', 'S', 'D']
		};
	},
	created: function created() {
		var _this = this;

		this.$http.post('gestion-emisoras/php/api/emisoras/buscar-emisoras.php', { activa: true }).then(function (res) {
			_this.listadoEmisoras = res.data.listado;
		}).catch(this.$responseError);

		this.buscar();
	},


	methods: {
		cierraEditor: function cierraEditor() {
			this.ID_contenido = null;
			this.buscar();
		},
		buscar: function buscar() {
			var _this2 = this;

			this.$http.post('gestion-emisoras/php/api/contenidos/buscar-contenidos.php', this.filtro).then(function (res) {
				_this2.listadoContenidos = res.data.listado;
			}).catch(this.$responseError);
		},
		filtraEstado: function filtraEstado(estado) {
			this.filtro.activo = estado;
			this.buscar();
		},
		nuevo: function nuevo() {
			this.ID_contenido = 'nuevo';
		},
		del: function del(idContenido) {
			var _this3 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar contenido',
				mensaje: '\xBFEst\xE1s seguro de que quieres eliminar este contenido?\n\t\t\t\tEn ocasiones es mejor marcarlo como inactivo ya que as\xED las inserciones asociadas a \xE9l no se quedar\xE1n hu\xE9rfanas.\n\t\t\t\t\xBFQuieres continuar y eliminarlo?',
				callback: function callback(acepta) {
					if (acepta) {
						_this3.$http.delete('gestion-emisoras/php/api/contenidos/del-contenido.php?ID_contenido=' + idContenido).then(function (res) {
							_this3.$store.commit('toast/danger', {
								titulo: 'Eliminado',
								mensaje: 'Se ha eliminado el contenido correctamente'
							});
							_this3.buscar();
						}).catch(_this3.$responseError);
					}
				}
			});
		}
	}
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idContenido'],
	data: function data() {
		return {
			contenido: {
				ID_contenido: null,
				emisora_ID: null,
				nombre: null,
				hora_inicio: null,
				hora_fin: null,
				dias_semana: [],
				activo: true
			},
			listadoEmisoras: [],
			dias: ['L', 'M', 'X', 'J', 'V', 'S', 'D']
		};
	},
	created: function created() {
		var _this = this;

		console.log(' El ID_contenido es: ' + this.idContenido);
		if (this.idContenido && this.idContenido !== 'nuevo') {
			this.$http.get('gestion-emisoras/php/api/contenidos/get-contenido.php?ID_contenido=' + this.idContenido).then(function (res) {
				_this.contenido = res.data.contenido;
			}).catch(this.$responseError);
		}

		this.$http.get('gestion-emisoras/php/api/emisoras/buscar-emisoras.php').then(function (res) {
			_this.listadoEmisoras = res.data.listado;
		}).catch(this.$responseError);
	},

	methods: {
		toggleDia: function toggleDia(dia) {
			var idx = this.contenido.dias_semana.indexOf(dia);
			if (idx < 0) {
				this.contenido.dias_semana.push(dia);
			} else {
				this.contenido.dias_semana.splice(idx, 1);
			}
		},
		guardar: function guardar() {
			var _this2 = this;

			this.$http.post('gestion-emisoras/php/api/contenidos/set-contenido.php', this.contenido).then(function (res) {
				_this2.$store.commit('toast/success', {
					titulo: 'Guardado',
					mensaje: 'Se ha guardado el contenido correctamente'
				});
				_this2.cerrar();
			}).catch(this.$responseError);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editor_programas_vue__ = __webpack_require__(1203);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'editor-programas': __WEBPACK_IMPORTED_MODULE_1__editor_programas_vue__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				emisora_ID: null,
				dia: new Date()
			},
			listadoEmisoras: [],
			listadoProgramas: [],
			ID_programa: null
		};
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-emisoras/php/api/emisoras/buscar-emisoras.php', { activa: true }).then(function (res) {
			_this.listadoEmisoras = res.data.listado;
		}).catch(this.$responseError);
	},

	methods: {
		nuevo: function nuevo() {
			this.ID_programa = 'nuevo';
		},
		buscar: function buscar() {
			var _this2 = this;

			if (!this.filtro.emisora_ID) {
				return;
			}
			var datos = {
				emisora_ID: this.filtro.emisora_ID,
				dia: Math.floor(this.filtro.dia.getTime() / 1000)
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-emisoras/php/api/programas/buscar-programas.php', datos).then(function (res) {
				_this2.listadoProgramas = res.data.listado;
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilidades_select_dias_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilidades_calendario_anual__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selecciona_estrategia__ = __webpack_require__(1204);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'select-dias': __WEBPACK_IMPORTED_MODULE_1__utilidades_select_dias_vue__["a" /* default */],
		'calendario-anual': __WEBPACK_IMPORTED_MODULE_2__utilidades_calendario_anual__["a" /* default */],
		'selecciona-estrategia': __WEBPACK_IMPORTED_MODULE_3__selecciona_estrategia__["a" /* default */]
	},
	data: function data() {
		return {
			programa: {
				ID_programa: null,
				emisora_ID: null,
				nombre: '',
				hora_inicio: '',
				hora_fin: '',
				dias_semana: [],
				activo: true,
				dias: [],
				estrategia: null
			},
			diasSem: ['L', 'M', 'X', 'J', 'V', 'S', 'D'],
			ano: new Date().getFullYear(),
			listadoEmisoras: [],
			seleccionarEstrategia: null
		};
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('gestion-emisoras/php/api/emisoras/buscar-emisoras.php').then(function (res) {
			_this.listadoEmisoras = res.data.listado;
		}).catch(this.$responseError);
	},

	methods: {
		toggleDiaSemana: function toggleDiaSemana(dia) {
			var idx = this.programa.dias_semana.indexOf(dia);

			if (idx < 0) {
				this.programa.dias_semana.push(dia);
			} else {
				this.programa.dias_semana.splice(idx, 1);
			}
		},
		guardar: function guardar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-emisoras/php/api/programas/set-programa.php', this.programa).then(function (res) {
				_this2.$store.commit('alertas/alert', {
					titulo: 'Guardado',
					mensaje: 'Se han realizado un total de: <b>' + res.data.totalInserciones + ' inserciones</b>'
				});
				_this2.cerrar();
			}).catch(function (e) {
				console.log(e.response.data);
				if (e.response.data.error === 100) {
					_this2.seleccionarEstrategia = true;
				} else {
					_this2.$responseError(e);
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['estrategia'],
	methods: {
		cancelar: function cancelar() {
			this.$emit('update:estrategia', null);
			this.cerrar();
		},
		setEstrategia: function setEstrategia(dato) {
			this.$emit('update:estrategia', dato);
		},
		continuar: function continuar() {
			this.$emit('continuar');
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(1210);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			listadoGrupos: [],
			grupo: null
		};
	},
	created: function created() {
		this.getListado();
	},


	methods: {
		getListado: function getListado() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getListado().then(function (res) {
				_this.listadoGrupos = res.data.listado;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		getGrupo: function getGrupo(idGrupo) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getGrupo(idGrupo).then(function (res) {
				_this2.grupo = res.data.grupo;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevo: function nuevo() {
			this.grupo = {
				ID_grupo: null,
				nombre: '',
				descripcion: '',
				usuarios: []
			};
		},
		addUsuario: function addUsuario(ev) {
			for (var i = 0; i < this.grupo.usuarios.length; i++) {
				if (this.grupo.usuarios[i].ID === ev.datos.ID) {
					return;
				}
			}

			this.grupo.usuarios.push(ev.datos);
		},
		guardar: function guardar() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].setGrupo(this.grupo).then(function (res) {
				_this3.grupo = res.data.grupo;
				_this3.getListado();
				_this3.$store.commit('alertas/alert', {
					titulo: 'Guardado',
					mensaje: 'Se han guardado los cambios correctamente'
				});
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		eliminar: function eliminar(idGrupo) {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar grupo',
				mensaje: '¿Estás seguro de que quieres eliminar este grupo?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delGrupo(idGrupo).then(function (res) {
							_this4.grupo = null;
							_this4.getListado();
						}).catch(function (e) {
							_this4.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(48);

//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {};
	},
	beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
		this.$store.commit('top/setMenuActivo', to.name);
		next();
	},
	beforeDestroy: function beforeDestroy() {
		this.$store.commit('top/setMenu', []);
	},
	created: function created() {
		var _this = this;

		var menu = [];

		// Menú para insertar un nuevo registro
		menu.push({
			'icono': 'fa fa-plus',
			'nombre': 'Registrar',
			activo: false,
			callback: function callback(a) {
				_this.setMenuActivo(a);
				_this.$router.push('/main/horas-extra/editor/nuevo');
			}
		});

		// Menú para consultar mis horas
		menu.push({
			'icono': 'fa fa-user',
			'nombre': 'Mis horas',
			activo: true,
			callback: function callback(a) {
				_this.setMenuActivo(a);
				_this.$router.push('/main/horas-extra/usuario/yo');
			}
		});

		// Módulo de estadísticas
		// Menú para el listado de usuarios (si el usuario es un director de equipo)
		// menu.push({
		// 	'icono': 'fa fa-pie-chart',
		// 	'nombre': 'Estadísticas',
		// 	activo: false,
		// 	callback: (a) => {
		// 		this.setMenuActivo(a)
		// 		this.$router.push('/main/horas-extra/estadisticas')
		// 	}
		// })

		// Comprobamos si puede acceder al menú de listados
		__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].soyLider().then(function (res) {
			if (res.data.lider) {
				// Menú para el listado de usuarios (si el usuario es un director de equipo)
				menu.push({
					'icono': 'fa fa-list',
					'nombre': 'Listados',
					activo: false,
					callback: function callback(a) {
						_this.setMenuActivo(a);
						_this.$router.push('/main/horas-extra/listado');
					}
				});
			}

			_this.setMenu(menu);
		}).catch(function (e) {
			_this.$store.commit('toast/danger', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	})),
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
		setMenu: 'top/setMenu',
		setMenuActivo: 'top/setMenuActivo'
	}))
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detalleUsuario__ = __webpack_require__(1218);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'detalle-usuario': __WEBPACK_IMPORTED_MODULE_2__detalleUsuario__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				fechaInicio: new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
				fechaFin: new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999),
				descripcion: null,
				tipo_registro: null,
				usuario_ID: null,
				usuarioNombre: null,
				estado: null
			},
			detalle: null,
			registros: [],
			listadoEmpleados: [],
			num_sin_validar: 0
		};
	},
	created: function created() {
		this.buscar();
		this.getResumen();
	},

	methods: {
		getResumen: function getResumen() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getResumen().then(function (res) {
				_this.listadoEmpleados = res.data;
			}).catch(this.$responseError);
		},
		seleccionarUsuario: function seleccionarUsuario(ev) {
			this.filtro.usuario_ID = ev.data.ID;
			this.filtro.usuarioNombre = ev.data.nombre + ' ' + ev.data.apellidos;
			this.buscar();
		},
		quitarUsuario: function quitarUsuario(ev) {
			this.filtro.usuario_ID = null;
			this.filtro.usuarioNombre = null;
			this.buscar();
		},
		detalleUsuario: function detalleUsuario(idUsuario) {
			this.detalle = idUsuario;
		},
		setTipoRegistro: function setTipoRegistro(tipo) {
			this.filtro.tipo_registro = tipo;
			this.buscar();
		},
		setEstado: function setEstado(estado) {
			this.filtro.estado = estado;
			this.buscar();
		},
		buscar: function buscar() {
			var _this2 = this;

			var filtro = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			filtro.fechaInicio = Math.floor(this.filtro.fechaInicio.getTime() / 1000);
			filtro.fechaFin = Math.floor(this.filtro.fechaFin.getTime() / 1000);

			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getListado(filtro).then(function (res) {
				_this2.registros = res.data.resultados;
				_this2.num_sin_validar = res.data.num_sin_validar;
			}).catch(function (e) {
				_this2.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		verRegistro: function verRegistro(registro) {
			this.$router.push('/main/horas-extra/editor/' + registro.ID_registro);
		},
		validarTodo: function validarTodo() {
			var _this3 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Validar todos los registros',
				mensaje: '\xBFQuieres validar todos los registros pendientes de ' + this.filtro.usuarioNombre + '?',
				callback: function callback(acepta) {
					if (acepta) {
						var filtro = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.filtro));
						filtro.fechaInicio = Math.floor(_this3.filtro.fechaInicio.getTime() / 1000);
						filtro.fechaFin = Math.floor(_this3.filtro.fechaFin.getTime() / 1000);
						__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].validarTodo(filtro).then(function (res) {
							_this3.$store.commit('toast/success', {
								titulo: 'Registros validados'
							});
							_this3.buscar();
							_this3.getResumen();
						}).catch(function (e) {
							_this3.$store.commit('toast/danger', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		validar: function validar(registro) {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Validar registro',
				mensaje: '\xBFQuieres validar este registro del usuario?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].validar(registro.ID_registro).then(function (res) {
							_this4.$store.commit('toast/success', {
								titulo: 'Registro validado'
							});
							_this4.buscar();
							_this4.getResumen();
						}).catch(function (e) {
							_this4.$store.commit('toast/danger', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		eliminar: function eliminar(registro) {
			var _this5 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar registro',
				mensaje: '\xBFQuieres eliminar este registro del usuario?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].eliminar(registro.ID_registro).then(function (res) {
							_this5.$store.commit('toast/success', {
								titulo: 'Registro eliminado'
							});
							_this5.buscar();
							_this5.getResumen();
						}).catch(function (e) {
							_this5.$store.commit('toast/danger', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_detalle__ = __webpack_require__(523);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idUsuario'],
	components: {
		Detalle: __WEBPACK_IMPORTED_MODULE_0__common_detalle__["a" /* default */]
	}
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalle_vue__ = __webpack_require__(524);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b00e9a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalle_vue__ = __webpack_require__(1219);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b00e9a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idUsuario', 'card'],
	data: function data() {
		return {
			usuario: null,
			horas: {}
		};
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].infoUsuario(this.idUsuario).then(function (res) {
			_this.usuario = res.data.usuario;
			_this.horas = res.data.horas;
		}).catch(function (e) {
			_this.cerrar();
			_this.$store.commit('toast/danger', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},

	methods: {
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_detalle__ = __webpack_require__(523);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Detalle: __WEBPACK_IMPORTED_MODULE_4__common_detalle__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				fechaInicio: new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
				fechaFin: new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999),
				descripcion: null,
				tipo_registro: null,
				estado: null
			},
			registros: [],
			resumen: null
		};
	},
	created: function created() {
		this.buscar();
		this.getResumen();
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	})),
	methods: {
		getResumen: function getResumen() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getResumen(true).then(function (res) {
				_this.resumen = res.data.length === 1 ? res.data[0] : null;
			}).catch(this.$responseError);
		},
		setTipoRegistro: function setTipoRegistro(tipo) {
			this.filtro.tipo_registro = tipo;
			this.buscar();
		},
		setEstado: function setEstado(estado) {
			this.filtro.estado = estado;
			this.buscar();
		},
		buscar: function buscar() {
			var _this2 = this;

			var filtro = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			filtro.fechaInicio = Math.floor(this.filtro.fechaInicio.getTime() / 1000);
			filtro.fechaFin = Math.floor(this.filtro.fechaFin.getTime() / 1000);

			__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].misHoras(filtro).then(function (res) {
				_this2.registros = res.data.resultados;
				_this2.horas = res.data.horas;
			}).catch(function (e) {
				_this2.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		verRegistro: function verRegistro(registro) {
			this.$router.push('/main/horas-extra/editor/' + registro.ID_registro);
		},
		eliminar: function eliminar(registro) {
			var _this3 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar registro',
				mensaje: '\xBFQuieres eliminar este registro del usuario?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].eliminar(registro.ID_registro).then(function (res) {
							_this3.$store.commit('toast/success', {
								titulo: 'Registro eliminado'
							});
							_this3.buscar();
						}).catch(function (e) {
							_this3.$store.commit('toast/danger', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			registro: {
				ID_registro: null,
				usuario_ID: null,
				infoUsuario: null,
				fecha: null,
				horasRaw: null,
				descripcion: null,
				original_ID: null,
				tipo_registro: null
			},
			historico: [],
			soyLider: false
		};
	},
	created: function created() {
		var _this = this;

		if (this.$route.params.id !== 'nuevo') {
			this.getRegistro(this.$route.params.id);
		} else {
			this.nuevo();
		}

		__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].soyLider().then(function (res) {
			_this.soyLider = res.data.lider;
		}).catch(function (e) {
			_this.$store.commit('toast/danger', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},
	beforeRouteUpdate: function beforeRouteUpdate(to, form, next) {
		if (to.params.id && to.params.id !== 'nuevo') {
			this.getRegistro(to.params.id);
		} else {
			this.nuevo();
		}
		next();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		formOk: function formOk() {
			return this.registro.usuario_ID && this.registro.fecha && typeof this.registro.horasRaw === 'number' && this.registro.horasRaw > 0 && this.registro.tipo_registro && this.registro.descripcion;
		},
		esUltimo: function esUltimo() {
			if (this.historico.length === 0) {
				return true;
			}
			return this.registro.ID_registro === this.historico[this.historico.length - 1].ID_registro;
		},
		editable: function editable() {
			if (this.registro.aprobado && !this.soyLider) {
				return false;
			}
			if (this.historico.length === 0) {
				return true;
			}

			return this.registro.ID_registro === this.historico[this.historico.length - 1].ID_registro;
		}
	}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	})),
	methods: {
		nuevo: function nuevo() {
			this.registro.ID_registro = null;
			this.registro.usuario_ID = null;
			this.registro.infoUsuario = null;
			this.registro.fecha = null;
			this.registro.horasRaw = null;
			this.registro.descripcion = null;
			this.registro.original_ID = null;
			this.registro.tipo_registro = null;

			if (!this.soyLider) {
				this.registro.usuario_ID = this.usuario.ID;
				this.registro.usuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos;
			} else {
				this.registro.usuario_ID = null;
				this.registro.usuarioNombre = null;
			}
		},
		getRegistro: function getRegistro(idRegistro) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].getRegistro(idRegistro).then(function (res) {
				_this2.registro = res.data.registro;
				_this2.registro.horasRaw = _this2.registro.horasRaw < 0 ? -_this2.registro.horasRaw : _this2.registro.horasRaw;
				_this2.historico = res.data.historico;
			}).catch(function (e) {
				_this2.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		seleccionaUsuario: function seleccionaUsuario(ev) {
			this.registro.usuario_ID = ev.data.ID;
			this.registro.usuarioNombre = ev.data.nombre + ' ' + ev.data.apellidos;
		},
		quitarUsuario: function quitarUsuario() {
			this.registro.usuario_ID = null;
			this.registro.usuarioNombre = null;
		},
		setTipo: function setTipo(tipo) {
			if (!this.esUltimo) {
				return;
			}
			this.registro.tipo_registro = tipo;
		},
		guardar: function guardar() {
			var _this3 = this;

			if (!this.soyLider) {
				this.registro.usuario_ID = this.usuario.ID;
			}
			__WEBPACK_IMPORTED_MODULE_1__api_js__["a" /* default */].setRegistro(this.registro).then(function (res) {
				_this3.$store.commit('toast/success', {
					titulo: 'Horas registradas',
					mensaje: 'Se han registrado las horas correctamente'
				});
				if (_this3.registro.usuario_ID === _this3.usuario.ID) {
					_this3.$router.push('/main/horas-extra/usuario/yo');
				} else {
					_this3.$router.push('/main/horas-extra/listado');
				}
			}).catch(function (e) {
				_this3.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			listadoEquipos: [],
			equipo: {
				ID_equipo: null,
				nombre: null,
				miembros: [],
				lideres: []
			},
			editando: false
		};
	},
	created: function created() {
		this.getListado();
	},

	methods: {
		nuevo: function nuevo() {
			this.equipo.ID_equipo = null;
			this.equipo.nombre = null;
			this.equipo.miembros = [];
			this.equipo.lideres = [];
			this.editando = true;
		},
		getListado: function getListado() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('gestion-horaria/php/api/getEquipos.php').then(function (res) {
				_this.listadoEquipos = res.data;
			}).catch(this.$responseError);
		},
		getEquipo: function getEquipo(EquipoID) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('gestion-horaria/php/api/getEquipo.php?EquipoID=' + EquipoID).then(function (res) {
				_this2.equipo = res.data;
				_this2.editando = true;
			}).catch(this.$responseError);
		},
		nuevoMiembro: function nuevoMiembro(ev) {
			this.equipo.miembros.push({
				UsuarioID: ev.data.ID,
				UsuarioNombre: ev.data.nombre + ' ' + ev.data.apellidos
			});
		},
		quitaMiembro: function quitaMiembro(ID) {
			this.equipo.miembros = this.equipo.miembros.filter(function (m) {
				return m.UsuarioID !== ID;
			});
		},
		nuevoLider: function nuevoLider(ev) {
			this.equipo.lideres.push({
				LiderID: ev.data.ID,
				LiderNombre: ev.data.nombre + ' ' + ev.data.apellidos
			});
		},
		quitaLider: function quitaLider(ID) {
			this.equipo.lideres = this.equipo.lideres.filter(function (m) {
				return m.LiderID !== ID;
			});
		},
		muestraLideres: function muestraLideres(lideres) {
			return lideres.reduce(function (ant, l) {
				ant.push(l.LiderNombre);
				return ant;
			}, []).join(', ');
		},
		guardar: function guardar() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-horaria/php/api/setEquipo.php', this.equipo).then(function (res) {
				_this3.getListado();
				_this3.getEquipo(res.data.ID_equipo);
				_this3.$store.commit('toast/success', {
					titulo: 'Equipo guardado'
				});
			}).catch(this.$responseError);
		},
		delEquipo: function delEquipo(ID) {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar equipo',
				mensaje: '\xBFQuieres eliminar este equipo?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-horaria/php/api/delEquipo.php', { ID_equipo: ID }).then(function (res) {
							_this4.getListado();
							_this4.editando = false;
							_this4.$store.commit('toast/success', {
								titulo: 'Equipo eliminado'
							});
						}).catch(_this4.$responseError);
					}
				}
			});
		}
	}
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_editor_editor__ = __webpack_require__(61);

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Editor: __WEBPACK_IMPORTED_MODULE_2__components_editor_editor__["a" /* default */]
	},
	data: function data() {
		return {
			editor: null
		};
	},
	created: function created() {
		var _this = this;

		var menu = [{
			'icono': 'fa fa-address-card',
			'nombre': 'Fichar',
			activo: false,
			'callback': function callback(a) {
				_this.editor = true;
			}
		}, {
			'icono': 'fa fa-list',
			'nombre': 'Registros',
			activo: true,
			'callback': function callback(a) {
				_this.$router.push('/main/gestion-jornada/registros');
				_this.setMenuActivo(a);
			}
		}, {
			'icono': 'fa fa-file-pdf-o',
			'nombre': 'Informes',
			activo: false,
			'callback': function callback(a) {
				_this.$router.push('/main/gestion-jornada/informes');
				_this.setMenuActivo(a);
			}
		}];
		window.setTimeout(function () {
			_this.setMenu(menu);
		}, 100);
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	})),
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
		setMenu: 'top/setMenu',
		setMenuActivo: 'top/setMenuActivo'
	}))
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['RegistroID'],
	data: function data() {
		return {
			registro: {
				RegistroID: null,
				FechaEntrada: null,
				HoraEntrada: null,
				FechaSalida: null,
				HoraSalida: null,
				Comentarios: null,
				Naturaleza: null,
				Latitud: null,
				Longitud: null,
				UsuarioID: null,
				ficheros: []
			},
			ficheros: []
		};
	},
	created: function created() {
		var _this = this;

		if (this.RegistroID) {
			this.registro.RegistroID = this.RegistroID;
			this.getRegistro();
		}
		if (!navigator.geolocation) {
			this.$error('Error', 'Debes fichar en un navegador que soporte geolocalización');
			this.cerrar();
		} else {
			this.registro.UsuarioID = this.usuario.ID;
			navigator.geolocation.getCurrentPosition(function (data) {
				_this.registro.Latitud = data.coords.latitude;
				_this.registro.Longitud = data.coords.longitude;
			}, function () {
				// this.$error('Error', 'Es necesaria la geolocalización para efectuar el fichaje')
				// this.cerrar()
				_this.$store.commit('toast/danger', {
					titulo: 'Geolocalización no disponible',
					mensaje: 'No es posible geolocalizar este dispositivo.'
				});
			});
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	})),
	methods: {
		getRegistro: function getRegistro() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('gestion-jornada/php/api/getRegistro.php?RegistroID=' + this.RegistroID).then(function (res) {
				_this2.registro.RegistroID = _this2.RegistroID;
				_this2.registro.FechaEntrada = res.data.FechaEntrada;
				_this2.registro.HoraEntrada = res.data.HoraEntrada;
				_this2.registro.FechaSalida = res.data.FechaSalida;
				_this2.registro.HoraSalida = res.data.HoraSalida;
				_this2.registro.Comentarios = res.data.Comentarios;
				_this2.registro.Naturaleza = res.data.Naturaleza;
				_this2.registro.UsuarioID = res.data.UsuarioID;
			}).catch(function (e) {
				_this2.$error('Error', e.response.data.error);
			});
		},
		adjuntar: function adjuntar() {
			var _this3 = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.multiple = true;
			inp.addEventListener('change', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
				var i;
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								for (i = 0; i < inp.files.length; i++) {
									_this3.ficheros.push(inp.files[i]);
								}
								document.body.removeChild(inp);

							case 2:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this3);
			})));
			inp.style.display = 'none';
			document.body.appendChild(inp);
			inp.click();
		},
		toBase64: function toBase64(file) {
			var _this4 = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
				return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
									var reader = new FileReader();
									reader.readAsDataURL(file);
									reader.onload = function () {
										return resolve(reader.result);
									};
									reader.onerror = function (error) {
										return reject(error);
									};
								}));

							case 1:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, _this4);
			}))();
		},
		quitaFichero: function quitaFichero(f) {
			this.ficheros = this.ficheros.filter(function (fichero) {
				return fichero.name !== f.name;
			});
		},
		guardar: function guardar() {
			var _this5 = this;

			var expHora = /^\d{2}:\d{2}$/;
			if (!this.registro.FechaEntrada) {
				this.$error('Error', 'Debes definir el día de entrada');
				return;
			}

			if (!expHora.test(this.registro.HoraEntrada)) {
				this.$error('Error', 'Debes definir una hora de entrada correcta');
				return;
			}

			if (!this.registro.FechaSalida) {
				this.$error('Error', 'Debes definir el día de salida');
				return;
			}

			if (!expHora.test(this.registro.HoraSalida)) {
				this.$error('Error', 'Debes definir una hora de salida correcta');
				return;
			}

			var fechaEntrada = this.registro.FechaEntrada + ' ' + this.registro.HoraEntrada;
			var fechaSalida = this.registro.FechaSalida + ' ' + this.registro.HoraSalida;

			if (this.registro.Naturaleza === 'Libre') {
				var _expHora = /^\d{2}:00$/;
				if (!_expHora.test(this.registro.HoraEntrada)) {
					this.$error('Error', 'La hora de entrada y salida debe en punto');
					return;
				}

				if (!_expHora.test(this.registro.HoraSalida)) {
					this.$error('Error', 'La hora de entrada y salida debe en punto');
					return;
				}
			}

			var form = {
				RegistroID: this.registro.RegistroID,
				FechaEntrada: fechaEntrada,
				FechaSalida: fechaSalida,
				Comentarios: this.registro.Comentarios,
				Naturaleza: this.registro.Naturaleza,
				UsuarioID: this.registro.UsuarioID
			};

			this.procesarFicheros(function (ficheros) {
				form.ficheros = ficheros;
				__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('gestion-jornada/php/api/editar.php', form).then(function (res) {
					_this5.$store.commit('toast/success', {
						titulo: 'Guardado'
					});
					_this5.cerrar();
				}).catch(function (e) {
					_this5.$error('Error', e.response.data.error);
				});
			});
		},
		procesarFicheros: function procesarFicheros(cb) {
			var _this6 = this;

			var f = [];
			var i = 0;
			var procesar = function procesar() {
				if (i >= _this6.ficheros.length) {
					cb(f);
					return;
				}
				var fichero = _this6.ficheros[i];
				i++;
				_this6.toBase64(fichero).then(function (b) {
					f.push({
						Nombre: fichero.name,
						Tamano: fichero.size,
						Contenido: b
					});
					procesar();
				}).catch(function (e) {
					_this6.$error('Error', 'Error procesando el fichero: ' + fichero.name);
					procesar();
				});
			};
			procesar();
		},
		eliminar: function eliminar() {
			var _this7 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar registro',
				mensaje: '¿Quieres eliminar este registro?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('gestion-jornada/php/api/delRegistro.php', { RegistroID: _this7.registro.RegistroID }).then(function (res) {
							_this7.$store.commit('toast/success', {
								titulo: 'Registro eliminado'
							});
							_this7.cerrar();
						}).catch(_this7.$responseError);
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formulario__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resultados__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resultados_dias__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_fichar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Formulario: __WEBPACK_IMPORTED_MODULE_1__formulario__["a" /* default */],
		Resultados: __WEBPACK_IMPORTED_MODULE_2__resultados__["a" /* default */],
		ResultadosDias: __WEBPACK_IMPORTED_MODULE_3__resultados_dias__["a" /* default */],
		Editor: __WEBPACK_IMPORTED_MODULE_4__editor_fichar__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				UsuarioID: null,
				fecha: new Date(),
				tipoJornada: 'Todos',
				vista: 'Normal'
			},
			RegistroID: null,
			registros: [],
			resumen: {
				Trabajado: 0,
				Acumulado: 0,
				Consumido: 0,
				Pentiende: 0
			},
			resumenSemana: {
				Trabajado: 0,
				Acumulado: 0,
				Consumido: 0,
				Pentiende: 0
			}
		};
	},
	created: function created() {
		this.filtro.UsuarioID = this.usuario.ID;
		this.filtro.fechaInicio = this.$moment().format('YYYY-MM');
		this.filtro.fechaFin = this.$moment().format('YYYY-MM');
		this.buscar();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	})),
	methods: {
		nuevo: function nuevo() {
			this.RegistroID = 'nuevo';
		},
		cierraEditor: function cierraEditor() {
			this.RegistroID = null;
			this.buscar();
		},
		buscar: function buscar() {
			var _this = this;

			var form = {
				UsuarioID: this.filtro.UsuarioID,
				fecha: this.filtro.fecha,
				tipoJornada: this.filtro.tipoJornada
			};
			this.$http.post('gestion-jornada/php/api/getRegistros.php', form).then(function (res) {
				_this.registros = res.data.registros;
				_this.resumen = res.data.resumen;
				_this.resumenSemana = res.data.resumenSemana;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_editor__ = __webpack_require__(61);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['filtro', 'resultados'],
	components: {
		Editor: __WEBPACK_IMPORTED_MODULE_2__editor_editor__["a" /* default */]
	},
	data: function data() {
		return {
			fecha: new Date(),
			UsuarioNombre: null,
			editor: {
				tipoJornada: null,
				registroId: null
			},
			TiposJornada: ['Todos', 'Trabajo', 'Falta', 'Libre', 'Vacaciones'],
			TiposVista: ['Normal', 'Agrupada']
		};
	},
	created: function created() {
		this.filtro.UsuarioID = this.usuario.ID;
		this.UsuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos;
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	})),
	watch: {
		fecha: function fecha(newVal) {
			this.filtro.fecha = this.$moment(this.fecha).format('YYYY-MM-DD');
			this.buscar();
		}
	},
	methods: {
		seleccionaUsuario: function seleccionaUsuario(ev) {
			this.filtro.UsuarioID = ev.datos.ID;
			this.UsuarioNombre = ev.datos.nombre + ' ' + ev.datos.apellidos;
			this.buscar();
		},
		setTipo: function setTipo(tipo) {
			this.filtro.tipoJornada = tipo;
			this.buscar();
		},
		buscar: function buscar() {
			this.$emit('buscar');
		},
		nuevo: function nuevo() {
			this.$emit('nuevo');
		}
	}
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_editor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editor_fichar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__detalles__ = __webpack_require__(533);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['registros', 'resumen', 'resumenSemana'],
	components: {
		Editor: __WEBPACK_IMPORTED_MODULE_4__editor_editor__["a" /* default */],
		Detalle: __WEBPACK_IMPORTED_MODULE_6__detalles__["a" /* default */],
		Fichar: __WEBPACK_IMPORTED_MODULE_5__editor_fichar__["a" /* default */]
	},
	data: function data() {
		return {
			verDetalle: null,
			editar: null,
			fichando: false
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	}), {
		agrupados: function agrupados() {
			var _this = this;

			var resultados = this.registros.reduce(function (mapa, registro) {
				var RegistroID = registro.RegistroID;
				var total = registro.Tiempo;
				var horasTotal = Math.floor(total / 3600);
				total = total % 3600;
				var minutosTotal = Math.floor(total / 60);
				total = total % 60;
				var segundosTotal = total;
				horasTotal = horasTotal < 10 ? 0 + '' + horasTotal : horasTotal;
				minutosTotal = minutosTotal < 10 ? 0 + '' + minutosTotal : minutosTotal;
				segundosTotal = segundosTotal < 10 ? 0 + '' + segundosTotal : segundosTotal;
				var totalStr = horasTotal + ':' + minutosTotal + ':' + segundosTotal;

				total = registro.Acumulado;
				var horasAcumulado = Math.floor(total / 3600);
				total = total % 3600;
				var minutosAcumulado = Math.floor(total / 60);
				total = total % 60;
				var segundosAcumulado = total;
				var acumuladoStr = '';
				if (horasAcumulado !== 0 || minutosAcumulado !== 0 || segundosAcumulado !== 0) {
					horasAcumulado = horasAcumulado < 10 ? 0 + '' + horasAcumulado : horasAcumulado;
					minutosAcumulado = minutosAcumulado < 10 ? 0 + '' + minutosAcumulado : minutosAcumulado;
					segundosAcumulado = segundosAcumulado < 10 ? 0 + '' + segundosAcumulado : segundosAcumulado;
					acumuladoStr = horasAcumulado + ':' + minutosAcumulado + ':' + segundosAcumulado;
				}

				if (!mapa.has(RegistroID)) {
					var reg = {
						RegistroID: RegistroID,
						FechaInicioJornada: registro.FechaInicioJornada,
						FechaFinJornada: registro.FechaFinJornada,
						FechaRegistroEntrada: registro.FechaRegistroEntrada,
						FechaRegistroSalida: registro.FechaRegistroSalida,
						Total: registro.Total,
						Bloqueado: registro.Bloqueado,
						DuracionStr: _this.$moment.utc(registro.Total).format('H:mm:ss'),
						UsuarioNombre: registro.UsuarioNombre,
						Naturaleza: registro.Naturaleza,
						UsuarioID: registro.UsuarioID,
						IPLocalEntrada: registro.IPLocalEntrada,
						IPLocalSalida: registro.IPLocalSalida,
						LatitudEntrada: registro.LatitudEntrada,
						LatitudSalida: registro.LatitudSalida,
						LongitudEntrada: registro.LongitudEntrada,
						LongitudSalida: registro.LongitudSalida,
						Desglose: [{
							TipoJornada: registro.TipoJornada,
							Total: registro.Tiempo,
							TotalStr: totalStr,
							Acumulado: registro.Acumulado,
							AcumuladoStr: acumuladoStr
						}]
					};
					mapa.set(RegistroID, reg);
				} else {
					var _reg = mapa.get(RegistroID);
					_reg.Desglose.push({
						TipoJornada: registro.TipoJornada,
						Total: registro.Tiempo,
						TotalStr: totalStr,
						Acumulado: registro.Acumulado,
						AcumuladoStr: acumuladoStr
					});
					mapa.set(RegistroID, _reg);
				}
				return mapa;
			}, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a());
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(resultados).map(function (r) {
				return r[1];
			});
		},
		dias: function dias() {
			if (!this.registros) {
				return 0;
			}

			var anterior = null;
			return this.registros.reduce(function (dias, registro) {
				var fecha = new Date(registro.FechaInicioJornada * 1000);
				if (fecha.getDate() !== anterior) {
					dias = dias + 1;
					anterior = fecha.getDate();
				}
				return dias;
			}, 0);
		},
		resultados: function resultados() {
			if (!this.registros) {
				return [];
			}

			return this.registros.map(function (reg) {
				if (reg.FechaInicioJornada && reg.FechaFinJornada) {
					var dif = reg.FechaFinJornada - reg.FechaInicioJornada;
					var horas = void 0,
					    minutos = void 0;
					horas = Math.floor(dif / 3600) + 'h ';
					dif = dif % 3600;
					minutos = Math.floor(dif / 60) + 'm ';
					dif = dif % 60;
					reg.Duracion = horas + minutos + dif + 's';
				} else {
					reg.Duracion = '';
				}

				return reg;
			});
		}
	}),
	methods: {
		getClase: function getClase(registro) {
			var clase = [];
			if (!registro.FechaFinJornada) {
				clase.push('abierto');
			}

			if (registro.FechaFinJornada && registro.FechaFinJornada - registro.FechaInicioJornada >= 43200) {
				clase.push('incidencia');
			}

			return clase.join(' ');
		},
		cerrarEditor: function cerrarEditor() {
			this.editar = null;
			this.$emit('buscar');
		},
		permiteEditar: function permiteEditar(registro) {
			if (this.usuario.ID !== registro.UsuarioID && !this.permisos.gestion_jornada_editarTodos) {
				return false;
			}

			if (!registro.FechaRegistroSalida) {
				return false;
			}

			return registro.Bloqueado === null;
		}
	}
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_vue__ = __webpack_require__(534);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7f0b210_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_vue__ = __webpack_require__(1246);
function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7f0b210"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7f0b210_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['RegistroID'],
	data: function data() {
		return {
			registro: null,
			mapaEntrada: null,
			marcadorEntrada: null,
			mapaSalida: null,
			marcadorSalida: null
		};
	},
	created: function created() {
		this.getRegistro();
	},

	methods: {
		getRegistro: function getRegistro() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('gestion-jornada/php/api/getRegistro.php?RegistroID=' + this.RegistroID).then(function (res) {
				_this.registro = res.data;
				window.setTimeout(function () {
					_this.initMapaEntrada();
					_this.initMapaSalida();
				}, 300);
			}).catch(function (e) {
				_this.$error('Error', e.response.data.error);
				_this.cerrar();
			});
		},
		initMapaEntrada: function initMapaEntrada() {
			console.log('Vamos a por el mapa de entrada');
			if (!this.registro.LatitudEntrada || !this.registro.LongitudEntrada) {
				console.log('Sin datos de entrada');
				return;
			}
			// eslint-disable-next-line
			this.mapaEntrada = new google.maps.Map(document.getElementById('mapaEntrada'), {
				center: { lat: this.registro.LatitudEntrada, lng: this.registro.LongitudEntrada },
				zoom: 16
			});

			// eslint-disable-next-line
			this.marcadorEntrada = new google.maps.Marker({
				// eslint-disable-next-line
				position: new google.maps.LatLng(this.registro.LatitudEntrada, this.registro.LongitudEntrada),
				title: 'Tu posición',
				map: this.mapaEntrada
			});
			console.log('Ya tenemos el mapa de entrada');
		},
		initMapaSalida: function initMapaSalida() {
			if (!this.registro.LatitudSalida || !this.registro.LongitudSalida) {
				return;
			}
			// eslint-disable-next-line
			this.mapaSalida = new google.maps.Map(document.getElementById('mapaSalida'), {
				center: { lat: this.registro.LatitudSalida, lng: this.registro.LongitudSalida },
				zoom: 16
			});

			// eslint-disable-next-line
			this.marcadorSalida = new google.maps.Marker({
				// eslint-disable-next-line
				position: new google.maps.LatLng(this.registro.LatitudSalida, this.registro.LongitudSalida),
				title: 'Tu posición',
				map: this.mapaSalida
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_editor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editor_fichar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__detalles__ = __webpack_require__(533);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['registros', 'resumen', 'resumenSemana'],
	components: {
		Editor: __WEBPACK_IMPORTED_MODULE_4__editor_editor__["a" /* default */],
		Detalle: __WEBPACK_IMPORTED_MODULE_6__detalles__["a" /* default */],
		Fichar: __WEBPACK_IMPORTED_MODULE_5__editor_fichar__["a" /* default */]
	},
	data: function data() {
		return {
			verDetalle: null,
			editar: null,
			fichando: false
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	}), {
		agrupados: function agrupados() {
			var _this = this;

			// Agrupamos por día y usuario
			var resultados = this.registros.reduce(function (mapa, registro) {
				var RegistroID = registro.RegistroID;
				var UsuarioID = registro.UsuarioID;
				var dia = _this.$moment(registro.FechaInicioJornada * 1000).format('DD-MM-YYYY');
				var clave = UsuarioID + '-' + dia;
				var total = registro.Tiempo;
				var horasTotal = Math.floor(total / 3600);
				total = total % 3600;
				var minutosTotal = Math.floor(total / 60);
				total = total % 60;
				var segundosTotal = total;
				horasTotal = horasTotal < 10 ? 0 + '' + horasTotal : horasTotal;
				minutosTotal = minutosTotal < 10 ? 0 + '' + minutosTotal : minutosTotal;
				segundosTotal = segundosTotal < 10 ? 0 + '' + segundosTotal : segundosTotal;
				var totalStr = horasTotal + ':' + minutosTotal + ':' + segundosTotal;

				total = registro.Acumulado;
				var horasAcumulado = Math.floor(total / 3600);
				total = total % 3600;
				var minutosAcumulado = Math.floor(total / 60);
				total = total % 60;
				var segundosAcumulado = total;
				var acumuladoStr = '';
				if (horasAcumulado !== 0 || minutosAcumulado !== 0 || segundosAcumulado !== 0) {
					horasAcumulado = horasAcumulado < 10 ? 0 + '' + horasAcumulado : horasAcumulado;
					minutosAcumulado = minutosAcumulado < 10 ? 0 + '' + minutosAcumulado : minutosAcumulado;
					segundosAcumulado = segundosAcumulado < 10 ? 0 + '' + segundosAcumulado : segundosAcumulado;
					acumuladoStr = horasAcumulado + ':' + minutosAcumulado + ':' + segundosAcumulado;
				}

				var regi = {
					RegistroID: RegistroID,
					FechaInicioJornada: registro.FechaInicioJornada,
					FechaFinJornada: registro.FechaFinJornada,
					FechaRegistroEntrada: registro.FechaRegistroEntrada,
					FechaRegistroSalida: registro.FechaRegistroSalida,
					Total: registro.Total,
					Bloqueado: registro.Bloqueado,
					DuracionStr: _this.$moment.utc(registro.Total).format('H:mm:ss'),
					UsuarioNombre: registro.UsuarioNombre,
					Naturaleza: registro.Naturaleza,
					UsuarioID: registro.UsuarioID,
					IPLocalEntrada: registro.IPLocalEntrada,
					IPLocalSalida: registro.IPLocalSalida,
					LatitudEntrada: registro.LatitudEntrada,
					LatitudSalida: registro.LatitudSalida,
					LongitudEntrada: registro.LongitudEntrada,
					LongitudSalida: registro.LongitudSalida
				};
				var desglose = {
					TipoJornada: registro.TipoJornada,
					Total: registro.Tiempo,
					TotalStr: totalStr,
					Acumulado: registro.Acumulado,
					AcumuladoStr: acumuladoStr
				};

				if (!mapa.has(clave)) {
					mapa.set(clave, {
						Dia: dia,
						UsuarioNombre: registro.UsuarioNombre,
						Total: registro.Tiempo,
						registros: [regi],
						desgloses: [desglose]
					});
				} else {
					var reg = mapa.get(clave);
					reg.Total = reg.Total + registro.Tiempo;
					reg.registros.push(regi);
					reg.desgloses.push(desglose);
					reg.registros.sort(function (a, b) {
						if (a.FechaInicioJornada <= b.FechaInicioJornada) {
							return -1;
						} else {
							return 1;
						}
					});
					mapa.set(clave, reg);
				}
				return mapa;
			}, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a());
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(resultados).map(function (r) {
				return r[1];
			});
		},
		dias: function dias() {
			if (!this.registros) {
				return 0;
			}

			var anterior = null;
			return this.registros.reduce(function (dias, registro) {
				var fecha = new Date(registro.FechaInicioJornada * 1000);
				if (fecha.getDate() !== anterior) {
					dias = dias + 1;
					anterior = fecha.getDate();
				}
				return dias;
			}, 0);
		},
		resultados: function resultados() {
			if (!this.registros) {
				return [];
			}

			return this.registros.map(function (reg) {
				if (reg.FechaInicioJornada && reg.FechaFinJornada) {
					var dif = reg.FechaFinJornada - reg.FechaInicioJornada;
					var horas = void 0,
					    minutos = void 0;
					horas = Math.floor(dif / 3600) + 'h ';
					dif = dif % 3600;
					minutos = Math.floor(dif / 60) + 'm ';
					dif = dif % 60;
					reg.Duracion = horas + minutos + dif + 's';
				} else {
					reg.Duracion = '';
				}

				return reg;
			});
		}
	}),
	methods: {
		getClase: function getClase(registro) {
			var clase = [];
			if (!registro.Tiempo < 3600 * 8 * 1000) {
				clase.push('abierto');
			} else {
				clase.push('incidencia');
				return 'incidencia';
			}

			return '';
		},
		cerrarEditor: function cerrarEditor() {
			this.editar = null;
			this.$emit('buscar');
		},
		permiteEditar: function permiteEditar(registro) {
			if (this.usuario.ID !== registro.UsuarioID && !this.permisos.gestion_jornada_editarTodos) {
				return false;
			}

			if (!registro.FechaRegistroSalida) {
				return false;
			}

			return registro.Bloqueado === null;
		}
	}
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cierre__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Cierre: __WEBPACK_IMPORTED_MODULE_2__cierre__["a" /* default */]
	},
	data: function data() {
		return {
			fecha: new Date(),
			filtro: {
				UsuarioID: null,
				mes: this.$moment().format('YYYY-MM-DD')
			},
			cierres: [],
			cerrandoMes: false,
			UsuarioNombre: null
		};
	},

	watch: {
		fecha: function fecha(newVal) {
			this.filtro.mes = this.$moment(newVal).format('YYYY-MM-DD');
			this.buscar();
		}
	},
	created: function created() {
		this.filtro.UsuarioID = this.usuario.ID;
		this.UsuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos;
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	})),
	methods: {
		setUsuario: function setUsuario(e) {
			this.filtro.UsuarioID = e.datos.ID;
			this.UsuarioNombre = e.datos.nombre + ' ' + e.datos.apellidos;
		},
		cerrarMes: function cerrarMes() {
			this.cerrandoMes = !this.cerrandoMes;

			if (!this.cerrandoMes) {
				this.buscar();
			}
		},
		getPDF: function getPDF(cierre) {
			this.download('gestion-jornada/php/api/getPDF.php', { UsuarioID: cierre.UsuarioID, Mes: cierre.Mes }, 'informe.pdf');
		},
		buscar: function buscar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('gestion-jornada/php/api/getCierres.php', this.filtro).then(function (res) {
				_this.cierres = res.data;
			}).catch(function (e) {
				_this.$error('Error', e.response.data.error);
			});
		},
		revertirCierre: function revertirCierre(cierre) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Revertir cierre',
				mensaje: '¿Quieres revertir el cierre de este usuario?',
				callback: function callback(acepta) {
					if (acepta) {
						var form = {
							UsuarioID: cierre.UsuarioID,
							ano: parseInt(cierre.Mes.split('-')[0]),
							mes: parseInt(cierre.Mes.split('-')[1])
						};
						__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('gestion-jornada/php/api/revertirCierre.php', form).then(function () {
							_this2.$store.commit('toast/success', {
								titulo: 'Cierre revertido'
							});
							_this2.buscar();
						}).catch(function (e) {
							_this2.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			fecha: null,
			cierre: {
				UsuarioID: null,
				Mes: null
			},
			UsuarioNombre: null
		};
	},
	created: function created() {
		this.cierre.UsuarioID = this.usuario.ID;
		this.UsuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos;
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	})),
	methods: {
		setUsuario: function setUsuario(e) {
			this.cierre.UsuarioID = e.datos.ID;
			this.UsuarioNombre = e.datos.nombre + ' ' + e.datos.apellidos;
		},
		cerrarMes: function cerrarMes() {
			var _this = this;

			if (!this.cierre.UsuarioID) {
				this.$error('Error', 'Debes seleccionar el usuario');
				return;
			}
			if (!this.fecha) {
				this.$error('Error', 'Debes seleccionar el mes');
				return;
			} else {
				this.cierre.Mes = this.$moment(this.fecha).format('YYYY-MM-DD');
			}
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('gestion-jornada/php/api/cerrarMes.php', this.cierre).then(function (res) {
				_this.$store.commit('toast/success', {
					titulo: 'Cierre completo',
					mensaje: 'Se ha cerrado el mes correctamente'
				});
				_this.cerrar();
			}).catch(function (e) {
				_this.$error('Error', e.response.data.error);
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resultados__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Resultados: __WEBPACK_IMPORTED_MODULE_1__resultados__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				usuarios: [],
				todos: false,
				ano: new Date().getFullYear()
			},
			empleados: [],
			festivos: []
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	})),
	created: function created() {
		this.buscar();
	},

	methods: {
		cambiaAno: function cambiaAno(inc) {
			this.filtro.ano = this.filtro.ano + inc;
			this.buscar();
		},
		seleccionaUsuario: function seleccionaUsuario(e) {
			this.usuarios.push(e.datos);
		},
		buscar: function buscar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('gestion-jornada/php/api/vacaciones/listado.php', { ano: this.filtro.ano }).then(function (res) {
				_this.empleados = res.data.empleados;
				_this.festivos = res.data.festivos;
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['ano', 'empleados', 'festivos'],
	data: function data() {
		return {
			diaSem: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
			form: {
				quitar: [],
				agregar: []
			},
			validacion: {
				aprobar: [],
				rechazar: []
			},
			cargandoGuardar: false,
			aprobando: false,
			rechazando: false
		};
	},

	watch: {
		aprobando: function aprobando(newVal) {
			if (!newVal) {
				this.validacion.aprobar = [];
				this.validacion.rechazar = [];
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	}), {
		diasFestivos: function diasFestivos() {
			return this.festivos.reduce(function (acum, d) {
				acum.push(d.dia);
				return acum;
			}, []);
		},
		meses: function meses() {
			var _this = this;

			return new Array(12).fill(0).reduce(function (meses, i, mes) {
				var fecha = new Date(_this.ano, mes, 1, 12, 0, 0, 0);
				var mesActual = {
					mes: _this.$moment(fecha).format('MMMM, YYYY'),
					dias: []
				};
				while (fecha.getMonth() === mes) {
					var diaStr = _this.$moment(fecha).format('YYYY-MM-DD');
					mesActual.dias.push({
						dia: fecha.getDate(),
						diaSem: _this.diaSem[fecha.getDay()],
						id: diaStr,
						// finde: /^(S|D)$/.test(this.diaSem[fecha.getDay()]),
						festivo: _this.diasFestivos.indexOf(diaStr) >= 0
					});
					fecha.setTime(fecha.getTime() + 86400000);
				}
				meses.push(mesActual);
				return meses;
			}, []);
		},
		validacionesPendientes: function validacionesPendientes() {
			return this.empleados.reduce(function (hay, empleado) {
				for (var i = 0; i < empleado.dias.length; i++) {
					var dia = empleado.dias[i];
					if (dia.EstadoValidacion === 'Pendiente de aprobar' || dia.EstadoValidacion === 'Por quitar') {
						hay = true;
					}
				}
				return hay;
			}, false);
		}
	}),
	methods: {
		cuentaUsuario: function cuentaUsuario(u) {
			if (u.UsuarioID !== this.usuario.ID) {
				return u.dias.length;
			} else {
				return u.dias.length + this.form.agregar.length - this.form.quitar.length;
			}
		},
		esVacaciones: function esVacaciones(dia, empleado) {
			return empleado.dias.reduce(function (acum, d) {
				if (d.Dia === dia) {
					acum = true;
				}
				return acum;
			}, false);
		},
		claseDia: function claseDia(dia, empleado) {
			var _this2 = this;

			var clase = [];
			if (empleado.UsuarioID === this.usuario.ID) {
				clase.push('usuario');
			}

			if (this.permisos.gestion_jornada_aprobar_vacaciones) {
				clase.push('validador');
			}

			if (this.aprobando || this.rechazando) {
				clase.push('validando');
			}
			return empleado.dias.reduce(function (acum, d) {
				if (d.Dia === dia) {
					if (_this2.validacion.aprobar.indexOf(d.RegistroID) >= 0) {
						acum.push('aprobando');
					} else if (_this2.validacion.rechazar.indexOf(d.RegistroID) >= 0) {
						acum.push('rechazando');
					}
					if (d.EstadoValidacion === 'Pendiente de aprobar' || d.EstadoValidacion === 'Por quitar') {
						acum.push('pendiente');
					} else if (d.EstadoValidacion === 'Aprobado') {
						acum.push('aprobado');
					} else {
						acum.push('rechazado');
					}

					if (d.Bloqueado) {
						acum.push('bloqueado');
					}
				}
				return acum;
			}, clase).join(' ');
		},
		iconoDia: function iconoDia(dia, empleado) {
			if (this.form.quitar.indexOf(dia) >= 0 && empleado.UsuarioID === this.usuario.ID) {
				return 'fa fa-trash';
			} else if (this.form.agregar.indexOf(dia) >= 0 && empleado.UsuarioID === this.usuario.ID) {
				return 'fa fa-plus';
			}
			return empleado.dias.reduce(function (acum, d) {
				if (d.Dia === dia) {
					if (d.EstadoValidacion === 'Pendiente de aprobar') {
						acum = 'fa fa-clock-o';
					} else if (d.EstadoValidacion === 'Aprobado') {
						acum = 'fa fa-check';
					} else {
						acum = 'fa fa-ban';
					}
				}
				return acum;
			}, '');
		},
		getTitulo: function getTitulo(dia, empleado) {
			return empleado.dias.reduce(function (acum, d) {
				if (d.Dia === dia) {
					acum = d.EstadoValidacion;
				}
				return acum;
			}, '');
		},
		toggleAccion: function toggleAccion(accion) {
			if (accion === 'aprobar') {
				this.rechazando = false;
				this.aprobando = !this.aprobando;
			} else if (accion === 'rechazar') {
				this.aprobando = false;
				this.rechazando = !this.rechazando;
			}
		},
		toggleValidacion: function toggleValidacion(infoDia, empleado) {
			if (!this.permisos.gestion_jornada_aprobar_vacaciones || !this.aprobando && !this.rechazando) {
				return false;
			}

			for (var i = 0; i < empleado.dias.length; i++) {
				var d = empleado.dias[i];
				if ((d.EstadoValidacion === 'Pendiente de aprobar' || d.EstadoValidacion === 'Por quitar') && infoDia.id === d.Dia) {
					var idx = this.validacion.aprobar.indexOf(d.RegistroID);
					var idxR = this.validacion.rechazar.indexOf(d.RegistroID);

					if (idx < 0 && idxR < 0) {
						this.validacion.aprobar.push(d.RegistroID);
					} else if (idx >= 0) {
						this.validacion.aprobar.splice(idx, 1);
						this.validacion.rechazar.push(d.RegistroID);
					} else if (idxR >= 0) {
						this.validacion.rechazar.splice(idxR, 1);
					}
				}
			}
			return true;
		},
		diasJornada: function diasJornada(dia, empleado) {
			return !empleado.jornada.includes(dia.diaSem);
		},
		toggleDia: function toggleDia(infoDia, empleado) {
			var dia = infoDia.id;
			if (this.diasJornada(infoDia, empleado) || infoDia.festivo) {
				return;
			}
			if (this.toggleValidacion(infoDia, empleado)) {
				return false;
			}
			if (empleado.UsuarioID !== this.usuario.ID) {
				return;
			}
			var idE = this.form.quitar.indexOf(dia);
			var idA = this.form.agregar.indexOf(dia);

			if (idE >= 0) {
				if (this.form.agregar.length + 1 - this.form.quitar.length + empleado.dias.length > 23) {
					this.$error('Error', 'El límite de días de vacaciones al año es de 23 días laborables');
					return;
				}
				this.form.quitar.splice(idE, 1);
			} else if (idA >= 0) {
				this.form.agregar.splice(idA, 1);
			} else {
				var bloqueado = false;
				var seleccionado = empleado.dias.reduce(function (acum, d) {
					if (d.Dia === dia) {
						acum = true;
						if (d.Bloqueado) {
							bloqueado = true;
						}
					}
					return acum;
				}, false);

				if (bloqueado) {
					return;
				}

				if (seleccionado) {
					this.form.quitar.push(dia);
				} else {
					this.form.agregar.push(dia);
					if (this.form.agregar.length - this.form.quitar.length + empleado.dias.length > 23) {
						this.$error('Error', 'El límite de días de vacaciones al año es de 23 días laborables');
						this.form.agregar.splice(-1, 1);
					}
				}
			}
		},
		guardar: function guardar() {
			var _this3 = this;

			if (this.cargandoGuardar) return;
			this.cargandoGuardar = true;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('gestion-jornada/php/api/vacaciones/set.php', this.form).then(function (res) {
				_this3.$store.commit('toast/success', {
					titulo: 'Vacaciones solicitadas'
				});
				_this3.form.agregar = [];
				_this3.form.quitar = [];
				_this3.$emit('buscar');
			}).catch(this.$responseError).finally(function () {
				setTimeout(function () {
					_this3.cargandoGuardar = false;
				}, 2000);
			});
		},
		validar: function validar() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('gestion-jornada/php/api/vacaciones/validar.php', this.validacion).then(function (res) {
				_this4.$store.commit('toast/success', {
					titulo: 'Modificaciones guardadas',
					mensaje: 'Se notificará a los empleados implicados los cambios'
				});
				_this4.validacion.aprobar = [];
				_this4.validacion.rechazar = [];
				_this4.aprobando = false;
				_this4.$emit('buscar');
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			mod: null,
			permiso: null,
			listadoPermisos: []
		};
	},
	created: function created() {
		this.getPermisos();
	},


	methods: {
		getPermisos: function getPermisos() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('gestion-permisos/php/getPermisos.php').then(function (res) {
				_this.listadoPermisos = res.data.permisos;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		getPermiso: function getPermiso(permiso) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('gestion-permisos/php/getPermiso.php?permiso=' + permiso).then(function (res) {
				_this2.permiso = res.data.permiso;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cambiaModulo: function cambiaModulo(modulo) {
			this.mod = modulo.nombre;
			this.permiso = null;
		},
		ponGrupo: function ponGrupo(ev) {
			for (var i = 0; i < this.permiso.grupos.length; i++) {
				if (this.permiso.grupos[i].grupo_ID === ev.datos.ID_grupo) {
					return;
				}
			}
			this.permiso.grupos.push({
				grupo_ID: ev.datos.ID_grupo,
				nombre: ev.datos.nombre,
				permitido: false
			});
		},
		ponUsuario: function ponUsuario(ev) {
			for (var i = 0; i < this.permiso.usuarios.length; i++) {
				if (this.permiso.usuarios[i].usuario_ID === ev.datos.ID) {
					return;
				}
			}
			this.permiso.usuarios.push({
				usuario_ID: ev.datos.ID,
				nombre: ev.datos.nombre,
				apellidos: ev.datos.apellidos,
				permitido: false
			});
		},
		guardar: function guardar() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-permisos/php/setPermiso.php', this.permiso).then(function (res) {
				_this3.$store.commit('alertas/alert', {
					titulo: 'Guardado',
					mensaje: 'Permiso guardado'
				});
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__componentes_nuevoProducto__ = __webpack_require__(1267);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'nuevo-producto': __WEBPACK_IMPORTED_MODULE_2__componentes_nuevoProducto__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				ano: new Date().getFullYear(),
				SoporteID: null,
				ProductoID: null
			},
			editando: null,
			nuevoProducto: null,
			listadoSoportes: [],
			listadoProductos: [],
			tarifas: [],
			idNueva: 0
		};
	},

	computed: {
		formValido: function formValido() {
			return this.filtro.ano && this.filtro.SoporteID && this.filtro.ProductoID && this.filtro.ProductoID !== 'nuevo';
		},
		tituloTarifas: function tituloTarifas() {
			if (!this.formValido) {
				return null;
			}

			var cadena = this.filtro.ano.toString() + ': ';

			for (var i = 0; i < this.listadoSoportes.length; i++) {
				if (this.listadoSoportes[i].ID_soporte === this.filtro.SoporteID) {
					cadena = cadena + this.listadoSoportes[i].soporte + ' - ';
				}
			}

			for (var _i = 0; _i < this.listadoProductos.length; _i++) {
				if (this.listadoProductos[_i].ID_producto === this.filtro.ProductoID) {
					cadena = cadena + this.listadoProductos[_i].nombre;
				}
			}

			return cadena;
		}
	},
	created: function created() {
		this.getSoportes();
	},

	watch: {
		'filtro.ano': function filtroAno() {
			this.tarifas = [];
			this.getTarifas();
		},
		'filtro.SoporteID': function filtroSoporteID() {
			this.tarifas = [];
			this.filtro.ProductoID = null;
			this.listadoProductos = [];
			this.getProductos();
		},
		'filtro.ProductoID': function filtroProductoID(newVal) {
			if (newVal === 'nuevo') {
				this.nuevoProducto = {
					ID_producto: null,
					nombre: null,
					soporte_ID: this.filtro.SoporteID
				};
			} else {
				this.getTarifas();
			}
		}
	},
	methods: {
		getSoportes: function getSoportes() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('gestion-tarifas/php/api/get-soportes.php').then(function (res) {
				_this.listadoSoportes = res.data;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		productoCreado: function productoCreado(ID) {
			this.filtro.ProductoID = ID;
			this.getProductos();
		},
		getProductos: function getProductos() {
			var _this2 = this;

			if (!this.filtro.SoporteID) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('gestion-tarifas/php/api/get-productos.php', { SoporteID: this.filtro.SoporteID }).then(function (res) {
				_this2.listadoProductos = res.data;

				_this2.listadoProductos.push({
					ID_producto: 'nuevo',
					nombre: 'Crear nuevo',
					soporte_ID: _this2.filtro.SoporteID
				});
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		getTarifas: function getTarifas() {
			var _this3 = this;

			if (!this.filtro.ano || typeof this.filtro.ano !== 'number') {
				return;
			}

			if (!this.filtro.SoporteID) {
				return;
			}

			if (!this.filtro.ProductoID) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('gestion-tarifas/php/api/get-tarifas.php', this.filtro).then(function (res) {
				_this3.tarifas = res.data;
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevaTarifa: function nuevaTarifa() {
			var ID = 'N-' + ++this.idNueva;
			var tarifa = {
				ID_tarifa: ID,
				duracion: null,
				unidades: 'segundos',
				precio_unitario: null,
				producto_ID: this.filtro.ProductoID,
				ano: this.filtro.ano
			};

			this.tarifas.push(tarifa);
			this.editando = tarifa;
		},
		cancelarEdicion: function cancelarEdicion() {
			var _this4 = this;

			if (this.editando && typeof this.editando.ID_tarifa === 'string' && this.editando.ID_tarifa.match(/^N/)) {
				this.tarifas = this.tarifas.filter(function (t) {
					return t.ID_tarifa !== _this4.editando.ID_tarifa;
				});
			}

			this.editando = null;
		},
		setTarifa: function setTarifa() {
			var _this5 = this;

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editando));
			if (typeof form.ID_tarifa === 'string' && form.ID_tarifa.match(/^N/)) {
				form.ID_tarifa = null;
			}
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('gestion-tarifas/php/api/set-tarifa.php', form).then(function (res) {
				_this5.editando = null;
				_this5.getTarifas();
			}).catch(function (e) {
				_this5.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['producto'],
	data: function data() {
		return {
			nombre: null
		};
	},

	methods: {
		crear: function crear() {
			var _this = this;

			var datos = {
				soporte_ID: this.producto.soporte_ID,
				nombre: this.nombre
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-tarifas/php/api/set-producto.php', datos).then(function (e) {
				_this.$emit('nuevo', e.data.ID_producto);
				_this.$emit('cerrar');
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editor_editor_vue__ = __webpack_require__(1273);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'editor-usuario': __WEBPACK_IMPORTED_MODULE_1__editor_editor_vue__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				nombre: '',
				sexo: null,
				activo: null,
				grupo: null
			},
			listadoUsuarios: [],
			grupos: [],
			editar: null
		};
	},
	created: function created() {
		this.getGrupos();
		this.buscar();
	},


	methods: {
		getGrupos: function getGrupos() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getGrupos().then(function (res) {
				_this.grupos = res.data.grupos;
				console.log(_this.grupos);
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevo: function nuevo() {
			this.editar = 'nuevo';
		},
		setSexo: function setSexo(sexo) {
			this.filtro.sexo = sexo;
			this.buscar();
		},
		setActivo: function setActivo(activo) {
			this.filtro.activo = activo;
			this.buscar();
		},
		setGrupo: function setGrupo(grupo) {
			this.filtro.grupo = grupo;
			console.log(this.filtro.grupo);
			this.buscar();
		},
		buscar: function buscar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].buscar(this.filtro).then(function (res) {
				_this2.listadoUsuarios = res.data.usuarios;
				console.log(_this2.listadoUsuarios);
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extras__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__horario__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emails__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__crop_avatar__ = __webpack_require__(1285);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import Unix from './unix'
// import Samba from './samba'





/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idusuario'],
	components: {
		'general': __WEBPACK_IMPORTED_MODULE_1__general__["a" /* default */],
		// 'datos-unix': Unix,
		// 'samba': Samba,
		'usuario-extras': __WEBPACK_IMPORTED_MODULE_2__extras__["a" /* default */],
		'emails': __WEBPACK_IMPORTED_MODULE_4__emails__["a" /* default */],
		'crop-avatar': __WEBPACK_IMPORTED_MODULE_5__crop_avatar__["a" /* default */],
		'horario': __WEBPACK_IMPORTED_MODULE_3__horario__["a" /* default */]
	},
	data: function data() {
		return {
			usuario: null,
			// ldap: null,
			seccion: 'general',
			nuevoAvatar: false,
			listadoEmpresas: [],
			listadoCategorias: ['Empleado', 'Prácticas', 'Colaborador']
		};
	},
	created: function created() {
		var _this = this;

		if (this.idusuario === 'nuevo') {
			this.nuevo();
		} else {
			this.getUsuario();
		}

		__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getEmpresas().then(function (res) {
			_this.listadoEmpresas = res.data;
		}).catch(this.$responseError);
	},


	computed: {
		avatar: function avatar() {
			if (!this.usuario.avatar) {
				return '/static/recursos/' + this.usuario.sexo + '.svg';
			} else {
				return this.usuario.avatar;
			}
		}
	},

	methods: {
		nuevo: function nuevo() {
			this.usuario = {
				ID: null,
				usuario: '',
				nombre: '',
				DNI: null,
				empresa_ID: null,
				tipo: null,
				apellidos: '',
				sexo: 'otro',
				nacimiento: null,
				telefono: '',
				email: '',
				// ldap: null,
				caduca_password: null,
				otps: null,
				fecha_expiracion_cuenta: null,
				extras: [],
				password: '',
				periodo_password: 45,
				horario: []
				// this.ldap = null
			};
		},
		getUsuario: function getUsuario() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get(this.idusuario).then(function (res) {
				res.data.usuario.fecha_nacimiento = res.data.usuario.fecha_nacimiento ? new Date(res.data.usuario.fecha_nacimiento * 1000) : null;
				res.data.usuario.caduca_password = res.data.usuario.caduca_password ? new Date(res.data.usuario.caduca_password * 1000) : null;
				res.data.usuario.fecha_expiracion_cuenta = res.data.usuario.fecha_expiracion_cuenta ? new Date(res.data.usuario.fecha_expiracion_cuenta * 1000) : null;

				_this2.usuario = res.data.usuario;
				// this.ldap = (res.data.ldap) ? res.data.ldap : null
			}).catch(function (e) {
				console.log(e);
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		setNuevoAvatar: function setNuevoAvatar(img) {
			this.usuario.avatar = img;
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['usuario'],
	// props: ['usuario', 'ldap'],

	methods: {
		guardar: function guardar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].setUsuario(this.usuario).then(function (res) {
				console.log(res);
				res.data.usuario.fecha_nacimiento = res.data.usuario.fecha_nacimiento ? new Date(res.data.usuario.fecha_nacimiento * 1000) : null;
				res.data.usuario.caduca_password = res.data.usuario.caduca_password ? new Date(res.data.usuario.caduca_password * 1000) : null;
				res.data.usuario.fecha_expiracion_cuenta = res.data.usuario.fecha_expiracion_cuenta ? new Date(res.data.usuario.fecha_expiracion_cuenta * 1000) : null;

				_this.$emit('update:usuario', res.data.usuario);
				// this.$emit('update:ldap', res.data.ldap)
				_this.$store.commit('alertas/alert', {
					titulo: 'Correcto',
					mensaje: 'Se han guardado los cambios'
				});
			}).catch(function (e) {
				console.log(e);
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},

		/* crearLdap () {
  	API.crearLdap(this.usuario.ID, this.usuario.usuario)
  		.then(res => {
  			this.$store.commit('alertas/alert', {
  				titulo: 'Correcto',
  				mensaje: 'Se ha creado el objecto en el directorio correctamente'
  			})
  			this.$emit('update:ldap', res.data.ldap)
  			this.$emit('update:usuario', res.data.usuario)
  		})
  		.catch(e => {
  			this.$store.commit('alertas/error', {
  				titulo: 'Error',
  				mensaje: e.response.data.error
  			})
  		})
  },
  eliminarLdap () {
  	this.$store.commit('alertas/confirm', {
  		titulo: 'Eliminar usuario LDAP',
  		mensaje: `¿Estás seguro de que quieres eliminar este usuario del directorio LDAP?
  			Una vez eliminado no podrá loggearse en los equipos Linux ni Windows`,
  		callback: (acepta) => {
  			if (acepta) {
  				API.eliminaLdap(this.usuario.ID)
  					.then(res => {
  						this.$store.commit('alertas/alert', {
  							titulo: 'Correcto',
  							mensaje: 'Se ha eliminado el usuario del directorio LDAP'
  						})
  						this.$emit('update:ldap', null)
  					})
  					.catch(e => {
  						this.$store.commit('alertas/error', {
  							titulo: 'Error',
  							mensaje: e.response.data.error
  						})
  					})
  			}
  		}
  	})
  }, */
		resetPassword: function resetPassword() {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmación',
				mensaje: '¿Quieres generar una contraseña aleatoria para este usuario?',
				callback: function callback(acepta) {
					if (acepta) {
						var datos = {
							usuario: _this2.usuario.usuario,
							ID: _this2.usuario.ID
						};

						__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].resetPassword(datos).then(function (res) {
							_this2.$store.commit('alertas/alert', {
								titulo: 'Password temporal',
								mensaje: 'El nuevo password temporal es: ' + res.data.nuevo_pass
							});
						}).catch(function (e) {
							_this2.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		quitaOTP: function quitaOTP() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delOTP(this.usuario.ID).then(function (res) {
				_this3.$emit('update:usuario', res.data.usuario);
				_this3.$store.commit('alertas/alert', {
					titulo: 'Correcto',
					mensaje: 'Se ha eliminado el segundo factor de autentificación de este usuario'
				});
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['usuario'],
	data: function data() {
		return {
			tipos: ['Huella entrada', 'Huella salida', 'Huella CPD']
		};
	},


	methods: {
		nuevoExtra: function nuevoExtra() {
			this.usuario.extras.push({
				ID_extra: null,
				clave: '',
				valor: ''
			});
		},
		quitarExtra: function quitarExtra(i) {
			this.usuario.extras.splice(i, 1);
		},
		guardar: function guardar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].setUsuario(this.usuario).then(function (res) {
				res.data.usuario.fecha_nacimiento = res.data.usuario.fecha_nacimiento ? new Date(res.data.usuario.fecha_nacimiento * 1000) : null;
				res.data.usuario.caduca_password = res.data.usuario.caduca_password ? new Date(res.data.usuario.caduca_password * 1000) : null;
				res.data.usuario.fecha_expiracion_cuenta = res.data.usuario.fecha_expiracion_cuenta ? new Date(res.data.usuario.fecha_expiracion_cuenta * 1000) : null;

				_this.$emit('update:usuario', res.data.usuario);
				_this.$store.commit('alertas/alert', {
					titulo: 'Guardado',
					mensaje: 'Se ha guardado la información del usuario correctamente'
				});
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['usuario'],
	data: function data() {
		return {
			dias: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
			horario: []
		};
	},

	computed: {
		jornadaSemanal: function jornadaSemanal() {
			var _this = this;

			if (!this.usuario || !this.usuario.horario) {
				return 0;
			}
			return this.usuario.horario.reduce(function (acum, horario) {
				if (horario.HoraEntrada && horario.HoraSalida) {
					var entrada = _this.$options.filters.segundos(horario.HoraEntrada);
					var salida = _this.$options.filters.segundos(horario.HoraSalida);
					acum = acum + (salida - entrada);
				}

				return acum;
			}, 0);
		}
	},
	methods: {
		nuevoHorario: function nuevoHorario() {
			this.usuario.horario.push({
				HorarioID: new Date().getTime(),
				DiaSemana: 'Lunes',
				HoraEntrada: null,
				HoraSalida: null
			});
		},
		quitar: function quitar(id) {
			this.usuario.horario = this.usuario.horario.filter(function (h) {
				return h.HorarioID !== id;
			});
		},
		guardarHorario: function guardarHorario() {
			var _this2 = this;

			var form = {
				UsuarioID: this.usuario.ID,
				horario: this.usuario.horario
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('gestion-jornada/php/api/setHorario.php', form).then(function (res) {
				_this2.$store.commit('toast/success', {
					titulo: 'Guardar',
					mensaje: 'Se ha guardado el horario correctamente'
				});
			}).catch(function (e) {
				_this2.$error('Error', e.response.data.error);
			});
		}
	}
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['usuario'],
	data: function data() {
		return {
			emails: [],
			aliases: [],
			dominios: []
		};
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getDominios().then(function (res) {
			_this.dominios = res.data.dominios;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
		// Vamos a obtener las direcciones de e-mail de este usuario
		__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getEmails(this.usuario.ID).then(function (res) {
			_this.emails = res.data.emails;
			_this.aliases = res.data.alias;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},


	methods: {
		guardar: function guardar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].setEmails(this.usuario.ID, this.emails).then(function (res) {
				_this2.$store.commit('alertas/alert', {
					titulo: 'Correcto',
					mensaje: 'Se han guardado los cambios correctamente'
				});
				_this2.emails = res.data.emails;
				_this2.alias = res.data.alias;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevoEmail: function nuevoEmail() {
			this.emails.push({
				cuenta: '',
				cuenta_id: null,
				dominio_id: 1,
				dominio: '',
				cuota: 10
			});
		}
	}
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'set-avatar',

	data: function data() {
		return {
			url: null
		};
	},

	methods: {
		setImg: function setImg(url) {
			this.url = url;
		},
		confirmar: function confirmar() {
			this.$emit('img', this.url);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buscador_index__ = __webpack_require__(1291);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		buscador: __WEBPACK_IMPORTED_MODULE_0__components_buscador_index__["a" /* default */]
	}
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtro__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resultados__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_main__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(62);
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		filtro: __WEBPACK_IMPORTED_MODULE_0__filtro__["a" /* default */],
		resultados: __WEBPACK_IMPORTED_MODULE_1__resultados__["a" /* default */],
		editor: __WEBPACK_IMPORTED_MODULE_2__editor_main__["a" /* default */]
	},
	data: function data() {
		return {
			orden: {
				OrdenColumna: 'Nombre',
				OrdenSentido: 'asc'
			},
			filtro: {
				EventoID: null,
				Nombre: null,
				Fila: null,
				Asiento: null,
				Localizacion: null,
				Estados: {
					'No Avisado': true,
					Pendiente: true,
					Entregado: true,
					Confirmado: true,
					Denegado: false
				},
				Usuario: null,
				VIP: null
			},
			resultados: [],
			editar: null
		};
	},

	methods: {
		cerrarEditor: function cerrarEditor() {
			this.editar = null;
		},
		editarInvitado: function editarInvitado(invitado) {
			this.editar = invitado.InvitadoID;
		},
		guardado: function guardado() {
			this.editar = null;
			this.buscar();
		},
		buscar: function buscar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].buscarInvitados(this.filtro).then(function (res) {
				_this.resultados = res.data;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		descargar: function descargar() {
			__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].download(this.filtro, this.orden);
		}
	}
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_verRecinto__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['filtro'],
	components: {
		VerRecinto: __WEBPACK_IMPORTED_MODULE_2__editor_verRecinto__["a" /* default */]
	},
	data: function data() {
		return {
			RecintoEventoID: null,
			listadoEventos: [],
			listadoGrupos: [],
			editar: null
		};
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getEventos().then(function (res) {
			_this.listadoEventos = res.data;
			if (_this.listadoEventos.length === 1) {
				_this.filtro.EventoID = _this.listadoEventos[0].EventoID;
				_this.getGrupos();
			}
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	})),
	methods: {
		buscar: function buscar() {
			this.$emit('buscar');
		},
		setLocalizacion: function setLocalizacion(estado) {
			this.filtro.Localizacion = estado;
			this.buscar();
		},
		toggleEstado: function toggleEstado(estado) {
			this.filtro.Estados[estado] = !this.filtro.Estados[estado];
			this.buscar();
		},
		setVIP: function setVIP(value) {
			this.filtro.VIP = value;
			this.buscar();
		},
		verRecinto: function verRecinto() {
			this.RecintoEventoID = parseInt(this.filtro.EventoID);
		},
		getGrupos: function getGrupos() {
			var _this2 = this;

			if (!this.filtro.EventoID) {
				this.listadoGrupos = [];
				this.filtro.GrupoID = null;
				return;
			}
			__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getGrupos(this.filtro.EventoID).then(function (res) {
				_this2.listadoGrupos = res.data;
				_this2.buscar();
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verRecinto_vue__ = __webpack_require__(554);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06e7a1a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_verRecinto_vue__ = __webpack_require__(1297);
function injectStyle (ssrContext) {
  __webpack_require__(1293)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06e7a1a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verRecinto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06e7a1a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_verRecinto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__asiento__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(62);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['EventoID', 'objetivo', 'asientos'],
	data: function data() {
		return {
			evento: null,
			ocupacion: null,
			seleccion: [],
			cadena: null,
			zonas: new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a()
		};
	},

	components: {
		Asiento: __WEBPACK_IMPORTED_MODULE_2__asiento__["a" /* default */]
	},
	created: function created() {
		var _this = this;

		if (this.asientos) {
			this.seleccion = this.asientos.filter(function (a) {
				return a.Fila && a.Asiento;
			}).map(function (a) {
				var asiento = a.Fila.toString() + '-' + a.Asiento.toString();
				return asiento;
			});
		}

		__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getRecinto(this.EventoID).then(function (res) {
			_this.evento = res.data;
			_this.calculaOcupacion();
		}).catch(function (e) {
			console.error(e);
		});
	},

	computed: {
		capacidad: function capacidad() {
			if (!this.evento || !this.evento.Recinto) {
				return 0;
			}

			return this.evento.Recinto.Filas.reduce(function (acum, fila) {
				acum = acum + fila.Localidades;
				return acum;
			}, 0);
		},
		ocupadas: function ocupadas() {
			if (!this.evento || !this.evento.Recinto) {
				return 0;
			}

			return this.evento.Invitados.reduce(function (acum, invitado) {
				if (invitado.Localidades && invitado.Estado !== 'Denegado' && invitado.Localidades.length > 0) {
					acum = invitado.Localidades.reduce(function (a, i) {
						if (i.Fila && i.Asiento) {
							a = a + 1;
						}
						return a;
					}, acum);
				}

				return acum;
			}, 0);
		},
		filas: function filas() {
			var _this2 = this;

			var res = this.evento.Recinto.Filas.map(function (fila) {
				var asientos = fila.Patron.split('');
				var numeroAsiento = 0;
				fila.Asientos = asientos.map(function (a) {
					numeroAsiento = a === 'A' ? numeroAsiento + 1 : numeroAsiento;
					var coordenadas = fila.Numero.toString() + '-' + numeroAsiento;
					var asiento = {
						Etiqueta: a,
						Ocupado: a !== 'A' ? false : _this2.ocupacion.has(coordenadas) && _this2.seleccion.indexOf(coordenadas) < 0,
						Numero: a === 'A' ? numeroAsiento : null,
						Fila: fila.Numero,
						Datos: _this2.ocupacion.has(coordenadas) ? _this2.ocupacion.get(coordenadas) : null,
						Coordenadas: coordenadas,
						Seleccionado: _this2.seleccion.indexOf(coordenadas) >= 0,
						ColorFondo: fila.ColorFondo,
						ColorLetra: fila.ColorLetra
					};

					return asiento;
				});
				return fila;
			}).reverse().reduce(function (acum, fila) {
				var zona = fila.ZonaID || 0;
				var totalFila = fila.Localidades;
				var ocupados = fila.Asientos.reduce(function (sum, asiento) {
					if (asiento.Ocupado) {
						sum = sum + 1;
					}
					return sum;
				}, 0);
				if (!acum.has(zona)) {
					acum.set(zona, {
						nombre: fila.ZonaNombre,
						ZonaID: fila.ZonaID,
						filas: [fila],
						asientosTotal: totalFila,
						asientosOcupados: ocupados
					});
				} else {
					var z = acum.get(zona);
					z.filas.push(fila);
					z.asientosTotal += totalFila;
					z.asientosOcupados += ocupados;
					acum.set(zona, z);
				}
				return acum;
			}, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a());

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(res).map(function (a) {
				return a[1];
			});
		}
	},
	methods: {
		calculaOcupacion: function calculaOcupacion() {
			var _this3 = this;

			this.ocupacion = this.evento.Invitados.reduce(function (acum, invitado) {
				for (var i = 0; i < invitado.Localidades.length; i++) {
					var coordenadas = invitado.Localidades[i].Fila.toString() + '-' + invitado.Localidades[i].Asiento.toString();
					if (_this3.seleccion.indexOf(coordenadas) < 0) {
						acum.set(coordenadas, {
							Asistente: invitado,
							Persona: invitado.Localidades[i]
						});
					}
				}

				return acum;
			}, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a());
		},
		doClick: function doClick(asiento) {
			if (!this.objetivo) {
				return;
			}

			var ind = this.seleccion.indexOf(asiento.Coordenadas);

			if (ind < 0 && this.objetivo > this.seleccion.length) {
				if (asiento.Ocupado) {
					return;
				}
				this.seleccion.push(asiento.Coordenadas);
			} else if (ind >= 0) {
				this.seleccion.splice(ind, 1);
			}
		},
		confirmar: function confirmar() {
			var asientos = [];
			for (var i = 0; i < this.seleccion.length; i++) {
				var coord = this.seleccion[i].split('-');
				asientos.push({
					Fila: parseInt(coord[0]),
					Asiento: parseInt(coord[1])
				});
			}
			this.$emit('confirmar', asientos);
			this.cerrar();
		},
		zonaActiva: function zonaActiva(ZonaID) {
			if (!this.zonas.has(ZonaID)) {
				return true;
			}
			return this.zonas.get(ZonaID);
		},
		toggleZona: function toggleZona(ZonaID) {
			if (!this.zonas.has(ZonaID)) {
				this.zonas.set(ZonaID, false);
			} else {
				var zona = this.zonas.get(ZonaID);
				this.zonas.set(ZonaID, !zona);
			}
			this.$forceUpdate();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['asiento', 'cadena'],
	computed: {
		clase: function clase() {
			var clase = ['base'];
			if (this.asiento.Etiqueta === 'A') {
				clase.push('asiento');
				if (this.asiento.Seleccionado) {
					clase.push('preseleccion');
				} else if (this.asiento.Ocupado) {
					clase.push('ocupado');
				}

				if (this.cadena) {
					var exp = new RegExp(this.cadena, 'ig');
					var coincide = false;
					if (this.asiento.Datos) {
						coincide = exp.test(this.asiento.Datos.Asistente.Nombre) || exp.test(this.asiento.Datos.Persona.Nombre);
					}

					if (!coincide) {
						clase.push('noCoincide');
					}
				}
			}

			return clase.join(' ');
		},
		titulo: function titulo() {
			var cadena = 'Fila ' + this.asiento.Fila + ':' + this.asiento.Numero;

			if (this.asiento.Datos === null) {
				return cadena;
			}
			if (this.asiento.Datos.Asistente.Nombre) {
				cadena = cadena + '. ' + this.asiento.Datos.Asistente.Nombre;
			}

			if (this.asiento.Datos.Persona.Nombre) {
				cadena = cadena + ' - ' + this.asiento.Datos.Persona.Nombre;
			}

			return cadena;
		},
		estilo: function estilo() {
			var est = {};

			if (this.asiento.Etiqueta !== 'A') {
				return est;
			}
			if (this.asiento.Seleccionado) {
				est.backgroundColor = 'orange';
				est.color = 'black';
			} else if (this.asiento.Ocupado) {
				est.backgroundColor = this.asiento.ColorFondo;
				est.color = this.asiento.ColorLetra;
			} else {
				est.backgroundColor = '#fdfdfd';
				est.border = '1px solid ' + this.asiento.ColorFondo;
				est.color = '#333333';
			}
			return est;
		}
	},
	methods: {
		haceClick: function haceClick() {
			this.$emit('pulsado', this.asiento);
		}
	}
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['resultados', 'orden'],
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	}), {
		listado: function listado() {
			var _this = this;

			if (!this.orden.OrdenColumna) {
				return this.resultados;
			}

			return this.resultados.sort(function (a, b) {
				if (a[_this.orden.OrdenColumna]) {
					if (a[_this.orden.OrdenColumna] > b[_this.orden.OrdenColumna]) {
						return _this.orden.OrdenSentido === 'asc' ? 1 : -1;
					} else if (a[_this.orden.OrdenColumna] === b[_this.orden.OrdenColumna]) {
						return 0;
					} else {
						return _this.orden.OrdenSentido === 'asc' ? -1 : 1;
					}
				} else {
					return a;
				}
			});
		},
		listadoXLS: function listadoXLS() {
			return [].concat(this.listado).map(function (l) {
				if (!l.Localidades) {
					l.LocalidadesSTR = '';
				} else {
					l.LocalidadesSTR = l.Localidades.reduce(function (acum, localidad) {
						acum = acum + localidad.FilaNombre + ': A' + localidad.Asiento + ', ';
						return acum;
					}, '');
				}
				return l;
			});
		},
		sumaAsistentes: function sumaAsistentes() {
			var suma = 0;
			for (var i = 0; i < this.listado.length; i++) {
				suma = suma + this.listado[i].Asistentes;
			}
			return suma;
		},
		sumaVIPS: function sumaVIPS() {
			var suma = 0;
			for (var i = 0; i < this.listado.length; i++) {
				suma = suma + this.listado[i].VIP;
			}
			return suma;
		},
		json_fields: function json_fields() {
			if (!this.resultados) {
				return {};
			}
			var f = {
				GrupoNombre: 'Grupo',
				Nombre: 'Nombre',
				VIP: 'VIP',
				Estado: 'Estado',
				UsuarioNombre: 'UsuarioNombre',
				Asistentes: 'Asistentes',
				LocalidadesSTR: 'Localidades',
				Anotaciones: 'Anotaciones',
				FechaCreacion: 'FechaCreacion'
			};
			return f;
		},
		json_meta: function json_meta() {
			return [[{
				'key': 'charset',
				'value': 'utf-8'
			}]];
		}
	}),
	methods: {
		estiloInvitado: function estiloInvitado(invitado) {
			if (invitado.Estado === 'Denegado') {
				return 'bg-danger text-white';
			} else if (invitado.VIP) {
				return 'bg-warning';
			}

			return '';
		},
		setOrden: function setOrden(campo) {
			if (this.orden.OrdenColumna === campo) {
				this.orden.OrdenSentido = this.orden.OrdenSentido === 'asc' ? 'desc' : 'asc';
			} else {
				this.orden.OrdenColumna = campo;
				this.orden.OrdenSentido = 'asc';
			}
		}
	}
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__localidades__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(62);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['invitadoId'],
	components: {
		EditorLocalidades: __WEBPACK_IMPORTED_MODULE_1__localidades__["a" /* default */]
	},
	data: function data() {
		return {
			editarLocalidades: false,
			listadoEventos: [],
			listadoGrupos: [],
			listadoEstados: ['No avisado', 'Pendiente', 'Entregado', 'Confirmado', 'Denegado'],
			invitado: {
				InvitadoID: null,
				InvitadoOriginalID: null,
				Nombre: null,
				FechaCreacion: new Date(),
				FechaModificacion: null,
				EventoID: null,
				UsuarioID: null,
				Estado: 'No avisado',
				VIP: 0,
				Asistentes: 1,
				Localidades: [{
					Fila: null,
					Asiento: null,
					Nombre: null,
					Comentarios: null
				}],
				Anotaciones: null
			}
		};
	},

	watch: {
		'invitado.Asistentes': function invitadoAsistentes(newVal) {
			this.actualizaLocalidades();
		}
	},
	created: function created() {
		var _this = this;

		if (this.invitadoId === 'nuevo') {
			this.nuevo();
		} else {
			this.getInvitado();
		}

		__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getEventos(true).then(function (res) {
			_this.listadoEventos = res.data;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: 'Error obteniendo el listado de eventos'
			});
		});
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	}), {
		localidadesCompletas: function localidadesCompletas() {
			return this.invitado.Localidades.reduce(function (acum, actual) {
				if (actual.Fila && actual.Asiento) {
					acum++;
				}
				return acum;
			}, 0);
		},
		eventoCerrado: function eventoCerrado() {
			if (!this.invitado.EventoID) {
				return false;
			} else if (!this.invitado.EventoEstado) {
				return false;
			} else {
				return this.invitado.EventoEstado === 'Cerrado';
			}
		}
	}),
	methods: {
		nuevo: function nuevo() {
			this.invitado = {
				InvitadoID: null,
				InvitadoOriginalID: null,
				Nombre: null,
				FechaCreacion: new Date(),
				FechaModificacion: null,
				EventoID: null,
				UsuarioID: this.usuario.ID,
				Estado: 'No avisado',
				VIP: 0,
				Asistentes: 1,
				Localidades: [{
					Fila: null,
					Asiento: null,
					Nombre: null,
					Comentarios: null
				}],
				Anotaciones: null
			};
			this.actualizaLocalidades();
		},
		actualizaLocalidades: function actualizaLocalidades() {
			var exp = /^[0-9]{1,}$/;
			var newVal = this.invitado.Asistentes;
			if (!exp.test(newVal)) {
				this.invitado.Localidades = [];
			} else {
				newVal = parseInt(newVal);
				var oldVal = this.invitado.Localidades.length;
				if (!exp.test(oldVal)) {
					this.invitado.Localidades = [];
					for (var i = 0; i < newVal; i++) {
						this.invitado.Localidades.push({
							LocalidadID: null,
							Fila: null,
							Asiento: null,
							Nombre: null,
							Comentarios: null
						});
					}
				} else if (oldVal > newVal) {
					this.invitado.Localidades.splice(newVal);
				} else {
					for (var _i = oldVal; _i < newVal; _i++) {
						this.invitado.Localidades.push({
							LocalidadID: null,
							Fila: null,
							Asiento: null,
							Nombre: null,
							Comentarios: null
						});
					}
				}
			}
		},
		getGrupos: function getGrupos() {
			var _this2 = this;

			if (!this.invitado.EventoID) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getGrupos(this.invitado.EventoID).then(function (res) {
				_this2.listadoGrupos = res.data;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.reponse.data.error
				});
			});
		},
		getInvitado: function getInvitado() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getInvitado(this.invitadoId).then(function (res) {
				_this3.invitado = res.data;
				_this3.getGrupos();
				_this3.actualizaLocalidades();
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.reponse.data.error
				});
			});
		},
		guardar: function guardar() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].setInvitado(this.invitado).then(function (res) {
				_this4.$store.commit('toast/success', {
					titulo: 'Guardado',
					mensaje: 'Se han guardado los cambios'
				});
				_this4.invitado = res.data;
				_this4.$emit('guardado', _this4.invitado);
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verRecinto__ = __webpack_require__(553);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['invitado', 'EventoID'],
	components: {
		VerRecinto: __WEBPACK_IMPORTED_MODULE_1__verRecinto__["a" /* default */]
	},
	data: function data() {
		return {
			mostrarRecinto: false
		};
	},

	computed: {
		duplicados: function duplicados() {
			var mapa = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
			return this.invitado.Localidades.reduce(function (acum, actual, l) {
				if (actual.Fila && actual.Asiento) {
					var cadena = actual.Fila + '-' + actual.Asiento;
					if (mapa.has(cadena)) {
						acum++;
					} else {
						mapa.set(cadena, true);
					}
				}
				return acum;
			}, 0);
		}
	},
	methods: {
		aplicarLocalizaciones: function aplicarLocalizaciones(datos) {
			datos.sort(function (a, b) {
				if (a.Fila > b.Fila) {
					return 1;
				} else if (a.Fila < b.Fila) {
					return -1;
				} else {
					if (a.Asiento > b.Asiento) {
						return 1;
					} else if (a.Asiento < b.Asiento) {
						return -1;
					} else {
						return 0;
					}
				}
			});

			for (var i = 0; i < this.invitado.Localidades.length; i++) {
				this.invitado.Localidades[i].Fila = datos[i].Fila;
				this.invitado.Localidades[i].Asiento = datos[i].Asiento;
			}
		},
		borrar: function borrar(l) {
			this.invitado.Localidades[l].Fila = null;
			this.invitado.Localidades[l].Asiento = null;
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contactos_contactos__ = __webpack_require__(1311);
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'seccion-contactos': __WEBPACK_IMPORTED_MODULE_0__contactos_contactos__["a" /* default */]
	},
	data: function data() {
		return {};
	}
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_contacto__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__detalles_registro__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libretas_gestion_libretas__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'editor-contacto': __WEBPACK_IMPORTED_MODULE_0__editor_contacto__["a" /* default */],
		'detalles-registro': __WEBPACK_IMPORTED_MODULE_1__detalles_registro__["a" /* default */],
		'gestion-libretas': __WEBPACK_IMPORTED_MODULE_2__libretas_gestion_libretas__["a" /* default */]
	},
	data: function data() {
		return {
			resultados: [],
			filtro: {
				ID_libreta: null,
				nombre: '',
				organizacion: '',
				cargo: '',
				ordenar: [{
					campo: 'nombre',
					tipo: 'asc'
				}]
			},
			listadoLibretas: [],
			listadoCamposOrdena: [{
				campo: 'nombre',
				nombre: 'Nombre'
			}, {
				campo: 'apellidos',
				nombre: 'Apellidos'
			}, {
				campo: 'cargo',
				nombre: 'Cargo'
			}, {
				campo: 'organizacion',
				nombre: 'Organización'
			}, {
				campo: 'libreta',
				nombre: 'Libreta'
			}],
			contacto: null,
			detalles: null,
			gestion_libretas: false
		};
	},
	created: function created() {
		var _this = this;

		this.buscar();

		__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].getLibretas().then(function (res) {
			_this.listadoLibretas = res.data.libretas;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},

	methods: {
		buscar: function buscar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_3__service__["a" /* default */].buscarRegistros(this.filtro).then(function (res) {
				_this2.resultados = res.data.registros;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevoContacto: function nuevoContacto() {
			console.log('Nuevo contacto');
			this.contacto = 'nuevo';
		},
		editar: function editar(idRegistro) {
			this.contacto = idRegistro;
			this.detalles = null;
		}
	}
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['datos'],
	data: function data() {
		return {
			contacto: null,
			listadoLibretas: []
		};
	},
	created: function created() {
		var _this = this;

		console.log(this.datos);
		if (this.datos === 'nuevo') {
			this.nuevoContacto();
		} else {
			this.getContacto();
		}

		__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].getLibretas(true).then(function (res) {
			_this.listadoLibretas = res.data.libretas;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},

	computed: {
		avatar: function avatar() {
			if (this.contacto.avatar) {
				return this.contacto.avatar;
			}

			if (this.contacto.genero === 'mujer') {
				return '/static/recursos/mujer.svg';
			} else {
				return '/static/recursos/hombre.svg';
			}
		}
	},
	methods: {
		nuevoContacto: function nuevoContacto() {
			this.contacto = {
				ID_registro: null,
				nombre: '',
				apellidos: '',
				genero: 'hombre',
				nacimiento: null,
				avatar: null,
				organizaciones: [],
				telefonos: [],
				emails: [],
				direcciones: [],
				libretas: []
			};
		},
		getContacto: function getContacto() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].getRegistro(this.datos).then(function (res) {
				_this2.contacto = res.data.registro;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		seleccionaLibreta: function seleccionaLibreta(ev) {
			var id = parseInt(ev.srcElement.value);
			if (id === 'null') {
				return;
			}

			for (var i = 0; i < this.contacto.libretas.length; i++) {
				if (this.contacto.libretas[i].ID_libreta === id) {
					ev.srcElement.value = 'null';
					return;
				}
			}

			for (var _i = 0; _i < this.listadoLibretas.length; _i++) {
				if (parseInt(this.listadoLibretas[_i].ID_libreta) === parseInt(ev.srcElement.value)) {
					this.contacto.libretas.push(this.listadoLibretas[_i]);
				}
			}
			ev.srcElement.value = 'null';
		},
		quitaLibreta: function quitaLibreta(idLibreta) {
			for (var i = 0; i < this.contacto.libretas.length; i++) {
				if (this.contacto.libretas[i].ID_libreta === idLibreta) {
					this.contacto.libretas.splice(i, 1);
					return;
				}
			}
		},
		nuevaOrganizacion: function nuevaOrganizacion() {
			this.contacto.organizaciones.push({
				ID_organizacion: null,
				nombreOrganizacion: '',
				cargo: ''
			});
		},
		nuevoTelefono: function nuevoTelefono() {
			var id = 'nuevo_telefono_' + (this.contacto.telefonos.length + 1).toString();
			this.contacto.telefonos.push({
				ID_telefono: id,
				telefono: ''
			});
		},
		quitaTelefono: function quitaTelefono(telefono) {
			for (var i = 0; i < this.contacto.telefonos.length; i++) {
				if (this.contacto.telefonos[i].ID_telefono === telefono.ID_telefono) {
					this.contacto.telefonos.splice(i, 1);
				}
			}
		},
		nuevoEmail: function nuevoEmail() {
			var id = 'nuevo_email_' + (this.contacto.emails.length + 1).toString();
			this.contacto.emails.push({
				ID_email: id,
				email: ''
			});
		},
		quitaEmail: function quitaEmail(email) {
			for (var i = 0; i < this.contacto.emails.length; i++) {
				if (this.contacto.emails[i].ID_email === email.ID_email) {
					this.contacto.emails.splice(i, 1);
					return;
				}
			}
		},
		nuevaDireccion: function nuevaDireccion() {
			var id = 'nueva_direccion_' + (this.contacto.direcciones.length + 1).toString();
			this.contacto.direcciones.push({
				ID_direccion: id,
				pais: '',
				comunidad: '',
				provincia: '',
				localidad: '',
				via: '',
				numero: '',
				esc: '',
				piso: '',
				puerta: '',
				cp: '',
				comentarios: ''
			});
		},
		quitarDireccion: function quitarDireccion(direccion) {
			for (var i = 0; i < this.contacto.direcciones.length; i++) {
				if (this.contacto.direcciones[i].ID_direccion === direccion.ID_direccion) {
					this.contacto.direcciones.splice(i, 1);
				}
			}
		},
		setOrganizacion: function setOrganizacion(i, ev) {
			var _this3 = this;

			if (ev.datos.ID_organizacion === 'nueva') {
				this.$store.commit('alertas/confirm', {
					titulo: 'Crear nueva organización',
					mensaje: '\xBFQuieres crear la organizaci\xF3n: "' + ev.datos.nombre + '"?',
					callback: function callback(acepta) {
						if (!acepta) {
							return false;
						}

						_this3.contacto.organizaciones[i].ID_organizacion = 'nueva';
						_this3.contacto.organizaciones[i].nombre = ev.datos.nombre;
					}
				});
			} else {
				this.contacto.organizaciones[i].ID_organizacion = ev.datos.ID_organizacion;
				this.contacto.organizaciones[i].nombre = ev.datos.nombre;
			}
		},
		guardar: function guardar() {
			var _this4 = this;

			if (this.contacto.nombre === '') {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes escribir el nombre del contacto'
				});
				return;
			}

			if (this.contacto.apellidos === '') {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes escribir los apellidos del contacto'
				});
				return;
			}

			if (this.contacto.libretas.length === 0) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes seleccionar al menos una libreta para almacenar el contacto'
				});
				return;
			}

			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].setRegistro(this.contacto).then(function (res) {
				_this4.contacto = res.data.registro;
				_this4.$store.commit('toast/success', {
					titulo: 'Contacto guardado',
					mensaje: 'Se ha guardado el contacto correctamente'
				});
				_this4.cerrar();
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		eliminar: function eliminar() {
			var _this5 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar contacto',
				mensaje: '\xBFEst\xE1s seguro de que quieres eliminar este contacto?\n\t\t\t\tSe borrar\xE1 tambi\xE9n de todas las libretas en las que est\xE9 inclu\xEDdo',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].eliminar(_this5.contacto.ID_registro).then(function (res) {
							_this5.cerrar();
						}).catch(function (e) {
							_this5.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idregistro'],

	data: function data() {
		return {
			registro: null
		};
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].getRegistro(this.idregistro).then(function (res) {
			_this.registro = res.data.registro;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},


	computed: {
		avatar: function avatar() {
			if (!this.registro) {
				return '/static/recursos/hombre.svg';
			}

			if (this.registro.avatar) {
				return this.registro.avatar;
			}

			if (this.registro.genero === 'mujer') {
				return '/static/recursos/mujer.svg';
			} else {
				return '/static/recursos/hombre.svg';
			}
		}
	},

	methods: {
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		editar: function editar() {
			this.$emit('editar', this.registro.ID_registro);
		}
	}
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			listadoLibretas: [],
			ID_libreta: null,
			libreta: null
		};
	},
	created: function created() {
		this.getLibretas();
	},

	computed: {
		listadoPermisos: function listadoPermisos() {
			var arr = [];

			if (this.libreta !== null) {
				// Primero los grupos
				for (var i = 0; i < this.libreta.grupos.length; i++) {
					arr.push({
						tipo: 'grupo',
						ID: this.libreta.grupos[i].ID_rel,
						nombre: this.libreta.grupos[i].ID_grupo !== null ? this.libreta.grupos[i].info.nombre : 'Grupo desconocido',
						escritura: this.libreta.grupos[i].escritura
					});
				}

				for (var _i = 0; _i < this.libreta.usuarios.length; _i++) {
					arr.push({
						tipo: 'usuario',
						ID: this.libreta.usuarios[_i].ID_rel,
						nombre: this.libreta.usuarios[_i].info.nombre + ' ' + this.libreta.usuarios[_i].info.apellidos,
						escritura: this.libreta.usuarios[_i].escritura
					});
				}
			}

			return arr;
		}
	},
	methods: {
		getLibretas: function getLibretas() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].getLibretas(true).then(function (res) {
				_this.listadoLibretas = res.data.libretas;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nueva: function nueva() {
			this.libreta = {
				ID_libreta: null,
				nombre: '',
				descripcion: '',
				usuarios: [],
				grupos: []
			};

			this.ID_libreta = null;
		},
		setLibreta: function setLibreta(idLibreta) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].getLibreta(idLibreta).then(function (res) {
				_this2.libreta = res.data.libreta;
				_this2.ID_libreta = idLibreta;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevoPermiso: function nuevoPermiso(ev) {
			if (ev.datos.tipo === 'grupo') {
				// es un grupo
				for (var i = 0; i < this.libreta.grupos.length; i++) {
					if (this.libreta.grupos[i].ID_grupo === ev.datos.ID_grupo) {
						return;
					}
				}

				this.libreta.grupos.push({
					ID_libreta: this.libreta.ID_libreta,
					ID_rel: null,
					ID_grupo: ev.datos.ID_grupo,
					escritura: false,
					info: {
						nombre: ev.datos.nombre
					}
				});
			} else {
				// es un usuario
				for (var _i2 = 0; _i2 < this.libreta.usuarios.length; _i2++) {
					if (this.libreta.usuarios[_i2].ID === ev.datos.ID) {
						return;
					}
				}

				this.libreta.usuarios.push({
					ID_libreta: this.libreta.ID_libreta,
					ID_rel: null,
					ID_usuario: ev.datos.ID,
					escritura: false,
					info: {
						ID: ev.datos.ID,
						nombre: ev.datos.nombre
					}
				});
			}
		},
		toggleEscritura: function toggleEscritura(tipo, ID) {
			if (tipo === 'grupo') {
				for (var i = 0; i < this.libreta.grupos.length; i++) {
					if (this.libreta.grupos[i].ID_rel === ID) {
						this.libreta.grupos[i].escritura = this.libreta.grupos[i].escritura !== true && this.libreta.grupos[i].escritura !== 1;
						return;
					}
				}
			} else {
				for (var _i3 = 0; _i3 < this.libreta.usuarios.length; _i3++) {
					if (this.libreta.usuarios[_i3].ID_rel === ID) {
						this.libreta.usuarios[_i3].escritura = this.libreta.usuarios[_i3].escritura === false;
						return;
					}
				}
			}
		},
		quitaPermiso: function quitaPermiso(tipo, ID) {
			if (tipo === 'grupo') {
				for (var i = 0; i < this.libreta.grupos.length; i++) {
					if (this.libreta.grupos[i].ID_rel === ID) {
						this.libreta.grupos.splice(i, 1);
						return;
					}
				}
			} else {
				for (var _i4 = 0; _i4 < this.libreta.usuarios.length; _i4++) {
					if (this.libreta.usuarios[_i4].ID_rel === ID) {
						this.libreta.usuarios.splice(_i4, 1);
						return;
					}
				}
			}
		},
		guardar: function guardar() {
			var _this3 = this;

			if (this.libreta.nombre === '') {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Debes escribir el nombre de la libreta'
				});
				return;
			}

			__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].setLibreta(this.libreta).then(function (res) {
				var encontrado = false;
				for (var i = 0; i < _this3.listadoLibretas.length; i++) {
					if (_this3.listadoLibretas[i].ID_libreta === res.data.libreta.ID_libreta) {
						_this3.listadoLibretas[i] = res.data.libreta;
						encontrado = true;
					}
				}

				if (!encontrado) {
					_this3.listadoLibretas.push(res.data.libreta);
				}

				_this3.getLibretas();
				_this3.$store.commit('alertas/alert', {
					titulo: 'Guardada',
					mensaje: 'Se han guardado los cambios'
				});
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		eliminar: function eliminar() {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar libreta',
				mensaje: '\xBFQuieres eliminar esta libreta?\n\t\t\t\tTodos los contactos que no est\xE9n asignados a otras libretas quedar\xE1n hu\xE9rfanos',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_0__service__["a" /* default */].eliminarLibreta(_this4.libreta.ID_libreta).then(function (res) {
							_this4.getLibretas();
							_this4.libreta = null;
							_this4.ID_libreta = null;
						}).catch(function (e) {
							_this4.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listado_index__ = __webpack_require__(565);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	components: {
		'listado': __WEBPACK_IMPORTED_MODULE_0__components_listado_index__["a" /* default */]
	}
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cecb137e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1335);
function injectStyle (ssrContext) {
  __webpack_require__(1324)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cecb137e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cecb137e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visor_contrato_visor_contrato__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal_descargar_vue__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'detalle-contrato': __WEBPACK_IMPORTED_MODULE_2__visor_contrato_visor_contrato__["a" /* default */],
		'editor-contrato': __WEBPACK_IMPORTED_MODULE_3__editor__["a" /* default */],
		'modal-descarga': __WEBPACK_IMPORTED_MODULE_4__modal_descargar_vue__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				agente: '',
				fechaIni: null,
				fechaFin: null,
				cliente: '',
				partida: '',
				titulo: '',
				evento: '',
				estado: null,
				max: 50,
				destino: null,
				intermediario: ''
			},
			mostrarEliminados: false,
			verDescargaVacio: false,
			listadoDestinos: [],
			listadoContratos: [],
			verDetalles: null,
			editarContrato: null
		};
	},

	created: function created() {
		var _this = this;

		this.buscar();
		__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getDestinos().then(function (res) {
			_this.listadoDestinos = res.data.destinos;
		}).catch(function (e) {
			_this.$store.commit('alertas/alert', {
				titulo: 'Error',
				mensaje: 'Error cargando los destinos'
			});
		});
	},

	filters: {
		estado: function estado(_estado) {
			switch (parseInt(_estado)) {
				case 0:
					return 'Previsión';
				case 1:
					return 'Sin aprobar';
				case 2:
					return 'Aprobado';
				default:
					return '';
			}
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	}), {
		hayEventos: function hayEventos() {
			return this.listadoFiltrado.reduce(function (ant, actual) {
				if (ant === true) {
					return true;
				}

				return actual.EventoID;
			}, false);
		},
		hayPartidas: function hayPartidas() {
			return this.listadoFiltrado.reduce(function (ant, actual) {
				if (ant === true) {
					return true;
				}

				return actual.PartidaID;
			}, false);
		},
		compTotalImporteAprobados: function compTotalImporteAprobados() {
			var total = 0;

			for (var i = 0; i < this.listadoFiltrado.length; i++) {
				var importe = parseFloat(this.listadoFiltrado[i].ImporteTotal);

				if (!isNaN(importe)) {
					total = total + importe;
				}
			}

			return total;
		},
		listadoFiltrado: function listadoFiltrado() {
			return this.listadoContratos;
		}
	}),

	methods: {
		claseCeldaEstado: function claseCeldaEstado(contrato) {
			var color = void 0,
			    bg = void 0;
			switch (contrato.Estado) {
				case 'Aprobado':
					color = '#112211';
					bg = '#29D967';
					break;
				case 'Borrador':
					color = '#222222';
					bg = '#e0e0e0';
					break;
				case 'Candidato':
					color = '#222222';
					bg = '#F2B950';
					break;
				case 'Eliminado':
					color = 'white';
					bg = '#F28066';
					break;
				case 'Rechazado':
					color = '#222222';
					bg = '#F2E5BD';
					break;
				default:
					color = '#222222';
					bg = '#F2E5BD';
			}

			return {
				color: color,
				backgroundColor: bg,
				textAlign: 'center'
			};
		},
		claseContrato: function claseContrato(contrato) {
			if (contrato.Estado === 'Borrador') {
				return 'bg-warning';
			} else if (contrato.Estado === 'Candidato') {
				return 'bg-success text-white';
			} else if (contrato.Estado === 'Eliminado') {
				return 'bg-danger text-white';
			}

			if (contrato.ImporteTotal < 0) {
				return 'text-danger';
			}

			return '';
		},
		claseBtnEstado: function claseBtnEstado(estado) {
			if (estado === this.filtro.estado) {
				if (estado === null) {
					return 'btn btn-sm btn-success';
				}
				return 'btn btn-sm btn-primary';
			} else {
				return 'btn btn-sm btn-default';
			}
		},
		setEstado: function setEstado(estado) {
			this.filtro.estado = estado;
			this.buscar();
		},
		setLimite: function setLimite(limite) {
			this.filtro.max = limite;
			this.buscar();
		},
		buscar: function buscar() {
			var _this2 = this;

			var filtro = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			filtro.fechaIni = this.getFechaString(this.filtro.fechaIni);
			filtro.fechaFin = this.getFechaString(this.filtro.fechaFin);

			__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].buscar(filtro).then(function (listado) {
				_this2.listadoContratos = listado.data.resultados;
			}).catch(function (e) {
				_this2.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error buscando los contratos'
				});
			});
		},
		getFechaString: function getFechaString(fecha) {
			if (fecha === null) {
				return null;
			}

			return Math.floor(fecha.getTime() / 1000);
		},
		reset: function reset() {
			this.filtro = {
				agente: '',
				fechaIni: null,
				fechaFin: null,
				cliente: '',
				partida: '',
				evento: '',
				estado: null,
				max: 50
			};
			this.buscar();
		},
		ver: function ver(idContrato) {
			// this.$router.push('/main/contratos/ver/' + idContrato)
			this.$router.push('/main/contratos/listado/' + idContrato);
			// this.verDetalles = idContrato
		},
		cerrarVista: function cerrarVista() {
			this.verDetalles = null;
		},
		goEditarContrato: function goEditarContrato(ID) {
			if (this.verDetalles) {
				this.cerrarVista();
			}
			this.$router.push('/main/contratos/editar/' + ID);
			// this.editarContrato = ID
		},
		cerrarEditor: function cerrarEditor() {
			this.editarContrato = null;
			this.buscar();
		}
	}
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editar_facturacion__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repartirImportes__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idContrato'],
	components: {
		'editar-facturacion': __WEBPACK_IMPORTED_MODULE_3__editar_facturacion__["a" /* default */],
		'repartir-todos': __WEBPACK_IMPORTED_MODULE_4__repartirImportes__["a" /* default */]
	},

	/**
  * Cuando se crea el componente ya hacemos la petición para descargarnos el listado de soportes
  * @return {[type]} [description]
  */
	created: function created() {
		var _this = this;

		// obtenemos los destinos
		__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getDestinos().then(function (res) {
			_this.listadoDestinos = res.data.destinos;
		}).catch(function (e) {
			_this.error = e.data.error || 'Error desconocido';
			_this.$store.commit('alertas/alert', {
				titulo: 'Error',
				mensaje: _this.error
			});
		});

		// Obtenemos el cierre
		__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getCierre().then(function (res) {
			_this.cerrado.ano = parseInt(res.data.cierre.ano);
			_this.cerrado.mes = parseInt(res.data.cierre.mes);
		}).catch(function (e) {
			_this.error = e.data.error || 'Error desconocido';
			_this.$store.commit('alertas/alert', {
				titulo: 'Error',
				mensaje: _this.error
			});
		});

		__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getSoportes().then(function (res) {
			_this.listadoSoportes = res.data.soportes;

			for (var i = 0; i < res.data.soportes.length; i++) {
				var sop = res.data.soportes[i];
				_this.soportesRAW.set(sop.ID_soporte, sop);
			}

			// También buscamos las partidas
			__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getPartidas().then(function (res) {
				_this.listadoPartidas = res.data.partidas;

				// También buscamos los eventos
				__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getEventos().then(function (res) {
					_this.listadoEventos = res.data.eventos;

					if (_this.idContrato !== 'nuevo') {
						__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getContrato(_this.idContrato).then(function (res) {
							_this.contrato = res.data.contrato;

							_this.contrato.fecha_inicio = new Date(_this.contrato.fecha_inicio);
							_this.contrato.fecha_fin = new Date(_this.contrato.fecha_fin);

							// Obtenemos la info del cliente
							__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getCliente(_this.contrato.cliente).then(function (res) {
								_this.infoCliente = res.data.cliente;
							}).catch(function (e) {
								_this.$store.commit('toast/danger', {
									titulo: 'Error',
									mensaje: e.response.data.error
								});
							});
						}).catch(function (e) {
							_this.error = e.data.error || 'Error desconocido';
							_this.$store.commit('alertas/alert', {
								titulo: 'Error',
								mensaje: _this.error
							});
						});
					} else {
						_this.contrato.agente = _this.usuario.ID;
						_this.contrato.nombreAgente = _this.usuario.nombre;
					}
				}).catch(function (e) {
					_this.error = e.data.error || 'Error desconocido';
					_this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: _this.error
					});
				});
			}).catch(function (e) {
				_this.error = e.data.error || 'Error desconocido';
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: _this.error
				});
			});
		}).catch(function (e) {
			_this.error = e.data.error || 'Error desconocido';
			_this.$store.commit('alertas/alert', {
				titulo: 'Error',
				mensaje: _this.error
			});
		});
	},

	data: function data() {
		return {
			contrato: {
				agente: null,
				nombreAgente: null,
				cliente: null,
				nombreCliente: null,
				destino: null,
				nombreDestino: null,
				intermediario: null,
				dto_global: 0,
				intermediarioNombre: null,
				titulo: null,
				fecha_inicio: null,
				fecha_fin: null,
				partida: null,
				evento: null,
				comentarios: null,
				lineas: [],
				lineasConceptos: []
			},
			listadoPartidas: [],
			listadoEventos: [],
			listadoSoportes: [],
			listadoDestinos: [],
			listadoProductos: {},
			listadoTarifas: {},
			soportesRAW: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
			productosRAW: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
			tarifasRAW: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
			facturacion: null,
			sinAgente: false,
			meses: ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			cerrado: {
				ano: 4000,
				mes: 1
			},
			error: 'Error desconocido',
			datosUsuario: {
				nombre: '',
				avatar: ''
			},
			infoCliente: null,
			verRepartirTodo: false,
			creandoIntermediario: false,
			nuevoIntermediario: ''
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
		contratoValido: function contratoValido() {
			var descuadre = 0;

			for (var i = 0; i < this.contrato.lineas.length; i++) {
				descuadre += this.calculaPagos(this.contrato.lineas[i]);
			}

			for (var _i = 0; _i < this.contrato.lineasConceptos.length; _i++) {
				descuadre += this.calculaPagos(this.contrato.lineasConceptos[_i]);
			}

			return descuadre === 0;
		}
	}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	})),

	methods: {
		alertaAntiguo: function alertaAntiguo() {
			this.$store.commit('alertas/alert', {
				titulo: 'Atención',
				mensaje: 'Este es un contrato antiguo y no fue creado con esta herramienta\n\n\t\t\t\t\t\tEs por ello que no es posible ver el desglose de facturaci\xF3n por l\xEDneas\n\n\t\t\t\t\t\tEn su lugar podr\xE1s ver la planificaci\xF3n de facturaci\xF3n por soporte'
			});
		},
		setDestino: function setDestino(ev) {
			this.contrato.destino = parseInt(ev.target.value);

			for (var i = 0; i < this.listadoDestinos.length; i++) {
				if (parseInt(this.listadoDestinos[i].ID_destino) === this.contrato.destino) {
					this.contrato.nombreDestino = this.listadoDestinos[i].nombre;
					return;
				}
			}

			this.contrato.nombreDestino = null;
		},
		seleccionaSoporte: function seleccionaSoporte(linea, ev) {
			var soporte = JSON.parse(ev.target.value);
			linea.soporte = soporte.ID_soporte;
			linea.nombreSoporte = soporte.soporte;

			this.buscaProductos(null, soporte.ID_soporte);
		},
		seleccionaProducto: function seleccionaProducto(linea, ev) {
			var producto = JSON.parse(ev.target.value);
			linea.producto = producto.ID_producto;
			linea.nombreProducto = producto.nombre;
			this.buscaTarifas(null, linea.producto);
		},
		seleccionaIntermediario: function seleccionaIntermediario(datos) {
			this.contrato.intermediario = datos.datos.ID_intermediario;
			this.contrato.intermediarioNombre = datos.datos.nombre;
		},
		crearIntermediario: function crearIntermediario(crear) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Crear intermediario',
				mensaje: '\xBFQuieres crear el intermediario "' + this.nuevoIntermediario + '"?',
				callback: function callback(acepta) {
					if (!acepta) {
						return;
					}

					var datos = {
						nombre: _this2.nuevoIntermediario
					};

					__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].setIntermediario(datos).then(function (res) {
						_this2.contrato.intermediario = res.data.ID_intermediario;
						_this2.contrato.intermediarioNombre = res.data.nombre;
						_this2.creandoIntermediario = false;
						_this2.nuevoIntermediario = '';
					}).catch(function (e) {
						_this2.$store.commit('alertas/error', {
							titulo: 'Error',
							mensaje: e.response.data.error
						});
					});
				}
			});
		},
		seleccionaTarifa: function seleccionaTarifa(linea, ev) {
			var tarifa = JSON.parse(ev.target.value);
			linea.tarifa = tarifa.ID_tarifa;
			linea.precio_unitario = tarifa.precio_unitario;
			linea.duracion = tarifa.duracion;
			linea.unidades = tarifa.unidades;
		},
		seleccionaTarifaNueva: function seleccionaTarifaNueva(linea, ev) {
			linea.soporte = ev.datos.ID_soporte;
			linea.producto = ev.datos.ID_producto;
			linea.tarifa = ev.datos.ID_tarifa;
			linea.precio_unitario = ev.datos.precio_unitario;
			linea.duracion = ev.datos.duracion;
			linea.unidades = 1;
			linea.cantidad = 0;
			linea.importe = 0;
			linea.descuento = null;
			linea.descuentoForzado = null;
			linea.precio_trucado = null;
			linea.tipo = 'radio';
			linea.descripcion = ev.datos.titulo;
			linea.pagos = [];
		},
		quitaTarifa: function quitaTarifa(linea) {
			linea.tarifa = null;
			linea.unidades = null;
			linea.duracion = null;
			linea.cantidad = null;
			linea.descuento = null;
			linea.precio_trucado = null;

			this.buscaTarifas(null, linea.producto);
		},
		quitaProducto: function quitaProducto(linea) {
			linea.producto = null;
			linea.nombreProducto = null;
			linea.tarifa = null;
			linea.unidades = null;
			linea.duracion = null;
			linea.cantidad = null;
			linea.descuento = null;
			linea.precio_trucado = null;

			this.buscaProductos(null, linea.soporte);
		},
		quitaSoporte: function quitaSoporte(linea) {
			linea.soporte = null;
			linea.nombreSoporte = null;
			linea.producto = null;
			linea.nombreProducto = null;
			linea.tarifa = null;
			linea.unidades = null;
			linea.duracion = null;
			linea.cantidad = null;
			linea.descuento = null;
			linea.precio_trucado = null;
		},
		quitaLinea: function quitaLinea(index, linea) {
			// Comprobamos que la línea no tenga pagos en periodo cerrado
			for (var i = 0; i < linea.pagos.length; i++) {
				var p = linea.pagos[i];

				var dateCerrado = new Date(this.cerrado.ano, this.cerrado.mes, 1, 0, 0, 0, 0).getTime();
				var datePago = new Date(p.ano, p.mes, 1, 0, 0, 0, 0).getTime();

				if (dateCerrado >= datePago) {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'No se puede eliminar esta línea porque contiene pagos en periodo de facturación cerrado'
					});
					return;
				}
			}

			if (linea.tipo === 'radio') {
				this.contrato.lineas.splice(index, 1);
			} else {
				this.contrato.lineasConceptos.splice(index, 1);
			}
		},


		/**
   * Cuando se selecciona un soporte, se verifica si ya tenemos los productos en la caché,
   * en caso contrario, los descargamos
   * @param  {[type]} ev [description]
   * @return {[type]}	[description]
   */
		buscaProductos: function buscaProductos(ev, idSoporte) {
			var _this3 = this;

			var ID = ev !== null ? ev.target.value : idSoporte;

			if (Array.isArray(this.listadoProductos[ID])) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getProductos(ID).then(function (res) {
				_this3.listadoProductos[ID] = res.data.productos;

				for (var i = 0; i < res.data.productos.length; i++) {
					var prod = res.data.productos[i];
					_this3.productosRAW.set(prod.ID_producto, prod);
				}

				_this3.$forceUpdate();
			}).catch(function (e) {
				_this3.error = e.data.error || 'Error desconocido';
				_this3.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: _this3.error
				});
			});
		},


		/**
   * Cuando se selecciona un producto, se verifica si ya tenemos sus tarifas en la caché,
   * en caso contrario, las descargamos
   * @param  {[type]} ev [description]
   * @return {[type]}	[description]
   */
		buscaTarifas: function buscaTarifas(ev, idProducto) {
			var _this4 = this;

			var ID = ev !== null ? ev.target.value : idProducto;

			if (Array.isArray(this.listadoTarifas[ID])) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getTarifas(ID).then(function (res) {
				_this4.listadoTarifas[ID] = res.data.tarifas;

				for (var ano in res.data.tarifas) {
					var tarifas = res.data.tarifas[ano];

					for (var i = 0; i < tarifas.length; i++) {
						_this4.tarifasRAW.set(tarifas[i].ID_tarifa, tarifas[i]);
					}
				}
				_this4.$forceUpdate();
			}).catch(function (e) {
				_this4.error = e.data.error || 'Error desconocido';
				_this4.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: _this4.error
				});
			});
		},


		/**
   * Método para calcular el importe de la línea
   * @param  {[type]} linea [description]
   * @return {[type]}	   [description]
   */
		getImporte: function getImporte(linea) {
			var precioOriginal = null;
			if (!linea.precio_unitario && !linea.duracion) {
				var tarifa = this.tarifasRAW.get(linea.tarifa);

				if (!tarifa) {
					return 0;
				}

				precioOriginal = tarifa.precio_unitario * tarifa.duracion * linea.cantidad;
			} else {
				precioOriginal = linea.precio_unitario * linea.duracion * linea.cantidad;
			}

			if (linea.precio_trucado !== null && linea.precio_trucado !== '' && linea.precio_trucado !== 0) {
				// Calculamos el descuento
				linea.descuentoForzado = 100 - Math.round(linea.precio_trucado * 100 / precioOriginal);
				linea.descuento = 0;

				linea.importe = linea.precio_trucado;

				if (typeof this.contrato.dto_global === 'number' && this.contrato.dto_global > 0) {
					return linea.precio_trucado - linea.precio_trucado * this.contrato.dto_global / 100;
				} else {
					return linea.precio_trucado;
				}
			}

			// vemos la tarifa
			var precioFinal = precioOriginal - precioOriginal * linea.descuento / 100;
			linea.importe = precioFinal;

			if (typeof this.contrato.dto_global === 'number' && this.contrato.dto_global > 0) {
				return precioFinal - precioFinal * this.contrato.dto_global / 100;
			} else {
				return precioFinal;
			}
		},
		getImporteConcepto: function getImporteConcepto(item) {
			if (!item.precio_unitario) {
				return 0;
			}

			if (item.precio_trucado !== null && item.precio_trucado !== '') {
				return item.precio_trucado;
			}

			item.importe = item.precio_unitario * item.cantidad - item.descuento * item.precio_unitario * item.cantidad / 100;

			return item.importe;
		},
		calculaDescuentoConcepto: function calculaDescuentoConcepto(item) {
			if (!item.precio_unitario || !item.cantidad) {
				return 0;
			}

			return 100 - item.precio_trucado * 100 / (item.precio_unitario * item.cantidad);
		},
		calculaPagos: function calculaPagos(linea) {
			var acum = 0;

			for (var i = 0; i < linea.pagos.length; i++) {
				if (typeof linea.pagos[i].importe === 'number') {
					acum += linea.pagos[i].importe;
				}
			}

			var dif = typeof this.contrato.dto_global === 'number' && this.contrato.dto_global > 0 ? linea.importe - acum - linea.importe * this.contrato.dto_global / 100 : linea.importe - acum;

			return this.roundNumber(dif, 2);
		},
		abrirFacturacion: function abrirFacturacion(tipo, linea) {
			var datos = {
				tipo: tipo,
				soporte: linea.nombreSoporte,
				tarifa: linea.duracion + ' ' + linea.unidades,
				producto: linea.nombreProducto,
				linea: linea,
				contrato: this.contrato
			};

			this.facturacion = datos;
		},
		cerrarFacturacion: function cerrarFacturacion() {
			this.facturacion = null;
		},
		setRepartirTodo: function setRepartirTodo() {
			this.verRepartirTodo = true;
		},
		seleccionaAgente: function seleccionaAgente(agente) {
			this.contrato.agente = agente.datos.ID;
			this.contrato.nombreAgente = agente.datos.nombre;
		},
		cambiaAgente: function cambiaAgente() {
			this.contrato.agente = null;
			this.contrato.nombreAgente = null;
		},
		seleccionaCliente: function seleccionaCliente(cliente) {
			var _this5 = this;

			this.contrato.cliente = cliente.datos.ID;
			this.contrato.nombreCliente = cliente.datos.cliente;
			__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].getCliente(cliente.datos.ID).then(function (res) {
				_this5.infoCliente = res.data.cliente;
			}).catch(function (e) {
				_this5.$store.commit('toast/error', {
					titulo: 'Error',
					mensaje: 'Error obteniendo el cliente'
				});
			});
		},
		cambiaCliente: function cambiaCliente() {
			this.contrato.cliente = null;
			this.contrato.nombreCliente = null;
			this.infoCliente = null;
		},
		nuevaLinea: function nuevaLinea() {
			this.contrato.lineas.push({
				soporte: null,
				producto: null,
				tarifa: null,
				cantidad: 0,
				importe: null,
				descuento: null,
				descuentoForzado: null,
				precio_trucado: null,
				tipo: 'radio',
				pagos: []
			});
		},
		nuevoConcepto: function nuevoConcepto() {
			this.contrato.lineasConceptos.push({
				ID: null,
				concepto: '',
				soporte: null,
				precio_unitario: null,
				importe: null,
				cantidad: 0,
				descuento: 0,
				precio_trucado: null,
				tipo: 'otros',
				pagos: []
			});
		},
		formatoFecha: function formatoFecha(date) {
			var ano = date.getFullYear();
			var mes = date.getMonth() + 1;
			var dia = date.getDate();

			mes = mes < 10 ? '0' + mes : mes;
			dia = dia < 10 ? '0' + dia : dia;

			return dia + '/' + mes + '/' + ano;
		},
		guardar: function guardar() {
			var _this6 = this;

			if (!this.contrato.destino) {
				this.error = 'Debes especificar el destino de facturacion';
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				});
				return;
			}

			if (!this.contrato.titulo) {
				this.error = 'Por favor escribe el título del contrato';
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				});
				return;
			}

			if (!this.contrato.fecha_inicio) {
				this.error = 'Debes especificar la fecha de inicio';
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				});
				return;
			}

			if (!this.contrato.fecha_fin) {
				this.error = 'Debes especificar la fecha de fin';
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				});
				return;
			}

			var datos = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.contrato));
			datos.fecha_fin = Math.round(this.contrato.fecha_fin.getTime() / 1000);
			datos.fecha_inicio = Math.round(this.contrato.fecha_inicio.getTime() / 1000);

			if (this.contrato.estado === 2) {
				if (!confirm('Este contrato ya está aprobado.\nSi lo modificas pasará a estado de pre-aprobación')) {
					return;
				}
			}

			__WEBPACK_IMPORTED_MODULE_5__services_api__["a" /* default */].setContrato(datos).then(function (res) {
				_this6.contrato = res.data.contrato;
				_this6.contrato.fecha_inicio = new Date(_this6.contrato.fecha_inicio);
				_this6.contrato.fecha_fin = new Date(_this6.contrato.fecha_fin);
				_this6.$store.commit('alertas/alert', {
					titulo: 'Contrato guardado',
					mensaje: 'Se ha guardado el contrato correctamente'
				});
			}).catch(function (e) {
				_this6.error = e.data.error || 'Error desconocido';
				_this6.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: _this6.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		roundNumber: function roundNumber(num, scale) {
			return _.round(num, scale);
		}
	}
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['datos', 'cliente'],

	created: function created() {
		var _this = this;

		// Debemos obtener el mes de cierre
		__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].getCierre().then(function (res) {
			_this.cerrado.ano = parseInt(res.data.cierre.ano);
			_this.cerrado.mes = parseInt(res.data.cierre.mes);
		}).catch(function (e) {
			_this.$store.commit('alertas/alert', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});

		if (this.cliente) {
			this.diaFactura = this.cliente.facturacion.dia_cobro + 0;
		}
	},

	data: function data() {
		return {
			meses: ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			cerrado: {
				ano: new Date().getFullYear(),
				mes: new Date().getMonth()
			},
			diaFactura: null,
			error: null,
			anosActivados: []
		};
	},

	computed: {
		importeTotal: function importeTotal() {
			if (typeof this.datos.contrato.dto_global === 'number' && this.datos.contrato.dto_global > 0) {
				return parseFloat(this.datos.linea.importe - this.datos.linea.importe * this.datos.contrato.dto_global / 100);
			} else {
				return parseFloat(this.datos.linea.importe);
			}
		},
		importePendiente: function importePendiente() {
			var pendiente = this.importeTotal + 0;

			for (var i = 0; i < this.datos.linea.pagos.length; i++) {
				var pag = this.datos.linea.pagos[i];
				pendiente = pendiente - pag.importe;
			}
			return pendiente;
		},
		anosFacturados: function anosFacturados() {
			var anos = [];

			for (var i = 0; i < this.datos.linea.pagos.length; i++) {
				var ano = parseInt(this.datos.linea.pagos[i].ano);

				if (anos.indexOf(ano) < 0) {
					anos.push(ano);
				}
			}

			return anos;
		},
		listadoAnos: function listadoAnos() {
			var anos = [];
			if (this.anosFacturados.length > 0) {
				anos = anos.concat(this.anosFacturados);
			}

			for (var i = new Date().getFullYear() - 1; i <= new Date().getFullYear() + 1; i++) {
				if (anos.indexOf(i) < 0) {
					anos.push(i);
				}
			}

			anos.sort();
			return anos;
		},
		anosActivos: function anosActivos() {
			var anos = [];

			anos = anos.concat(this.anosActivados);

			for (var i = 0; i < this.datos.linea.pagos.length; i++) {
				var ano = parseInt(this.datos.linea.pagos[i].ano);

				if (anos.indexOf(ano) < 0) {
					anos.push(ano);
				}
			}

			return anos;
		}
	},
	methods: {
		cambiaDia: function cambiaDia() {
			for (var i = this.datos.linea.pagos.length - 1; i >= 0; i--) {
				var l = this.datos.linea.pagos[i];
				if (!this.mesCerrado(l.ano, l.mes)) {
					this.datos.linea.pagos[i].dia = this.diaFactura + 0;
				}
			}
		},
		roundNumber: function roundNumber(num, scale) {
			return _.round(num, scale);
		},
		compruebaDia: function compruebaDia(fecha) {
			if (fecha.getFullYear() <= this.cerrado.ano && fecha.getMonth() + 1 <= this.cerrado.mes) {
				return false;
			}

			return fecha.getDate() === 1;
		},
		claseAno: function claseAno(ano) {
			if (this.anosActivados.indexOf(ano) < 0 && this.anosFacturados.indexOf(ano) < 0) {
				return 'btn btn-sm btn-default';
			}

			return 'btn btn-sm btn-primary';
		},
		toggleAno: function toggleAno(ano) {
			var i = this.anosActivados.indexOf(ano);
			if (i < 0) {
				this.anosActivados.push(ano);
				this.anosActivados.sort();
				return;
			}
			// Quitamos todos los importes de ese año
			var todos = true;
			for (var _i = this.datos.linea.pagos.length - 1; _i >= 0; _i--) {
				var p = this.datos.linea.pagos[_i];

				if (p.ano === ano) {
					if (parseInt(p.ano) >= this.cerrado.ano && parseInt(p.mes) > this.cerrado.mes) {
						this.datos.linea.pagos.splice(_i, 1);
					} else {
						todos = false;
					}
				}
			}

			if (!todos) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'No se puede quitar el año ya que hay meses activos'
				});
				return;
			}

			this.anosActivados.splice(i, 1);
			this.anosActivados.sort();
		},
		anoActivo: function anoActivo(ano) {
			return ano >= this.cerrado.ano;
		},
		mesActivo: function mesActivo(ano, mes) {
			if (ano > this.cerrado.ano) {
				return true;
			} else if (ano < this.cerrado.ano) {
				return false;
			} else if (mes > this.cerrado.mes) {
				return true;
			} else {
				return false;
			}
		},
		getClaseMes: function getClaseMes(ano, mes) {
			for (var i = 0; i < this.datos.linea.pagos.length; i++) {
				var p = this.datos.linea.pagos[i];

				if (parseInt(p.ano) === ano && parseInt(p.mes) === mes) {
					return 'btn btn-sm btn-primary';
				}
			}

			return 'btn btn-sm btn-default';
		},
		mesCerrado: function mesCerrado(ano, mes) {
			return this.cerrado.ano >= parseInt(ano) && this.cerrado.mes >= parseInt(mes);
		},
		toggleMes: function toggleMes(ano, mes) {
			if (this.mesCerrado(ano, mes)) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Este mes ya está cerrado, no se puede quitar'
				});
				return;
			}

			for (var i = 0; i < this.datos.linea.pagos.length; i++) {
				var p = this.datos.linea.pagos[i];

				if (parseInt(p.ano) === ano && parseInt(p.mes) === mes) {
					this.datos.linea.pagos.splice(i, 1);
					return;
				}
			}

			if (!this.diaFactura) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Debes seleccionar un día de cobro'
				});
				return;
			}

			// Calculamos el día máximo
			var fechaMes = new Date(ano, mes - 1, 1, 0, 0, 0, 0);
			// Sumamos un mes y restamos un día
			fechaMes.setMonth(fechaMes.getMonth() + 1);
			fechaMes.setDate(fechaMes.getDate() - 1);
			var diaMax = fechaMes.getDate();
			var diaFactura = this.diaFactura > diaMax ? diaMax : this.diaFactura + 0;

			this.datos.linea.pagos.push({
				ano: ano,
				mes: mes,
				dia: diaFactura,
				importe: 0
			});
		},
		reset: function reset() {
			for (var i = this.datos.linea.pagos.length - 1; i >= 0; i--) {
				var l = this.datos.linea.pagos[i];
				if (!this.mesCerrado(l.ano, l.mes)) {
					this.datos.linea.pagos.splice(i, 1);
				}
			}
		},
		distribuir: function distribuir() {
			if (this.datos.linea.pagos.length === 0) {
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Debes agregar al menos un mes de facturación'
				});
				return;
			}

			var pendiente = this.importeTotal + 0;
			var mesesPte = 0;

			for (var i = this.datos.linea.pagos.length - 1; i >= 0; i--) {
				var l = this.datos.linea.pagos[i];
				if (this.mesCerrado(l.ano, l.mes)) {
					pendiente = pendiente - l.importe;
				} else {
					mesesPte++;
				}
			}

			var media = this.roundNumber(pendiente / mesesPte, 2);

			for (var _i2 = this.datos.linea.pagos.length - 1; _i2 >= 0; _i2--) {
				var _l = this.datos.linea.pagos[_i2];
				if (!this.mesCerrado(_l.ano, _l.mes)) {
					this.datos.linea.pagos[_i2].importe = media;
				}
			}
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(23);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'repartir-todos',
	props: ['contrato', 'cliente'],
	data: function data() {
		return {
			diaFactura: null,
			listaAnos: [],
			listaMeses: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
			cerrado: {
				ano: null,
				mes: null
			},
			error: null,
			meses: ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			mesesSeleccionados: []
		};
	},

	created: function created() {
		var _this = this;

		// Debemos obtener el mes de cierre
		__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getCierre().then(function (res) {
			if (res.data.cierre.ano === 0) {
				// Tiene permisos para modificar facturación cerrada
				_this.cerrado.ano = new Date().getFullYear() - 1;
			} else {
				_this.cerrado.ano = parseInt(res.data.cierre.ano);
				_this.cerrado.mes = parseInt(res.data.cierre.mes);
			}
			_this.listaAnos = [_this.cerrado.ano, _this.cerrado.ano + 1, _this.cerrado.ano + 2];
		}).catch(function (e) {
			_this.error = e.response.data.error || 'Error desconocido';
			_this.$store.commit('alertas/alert', {
				titulo: 'Error',
				mensaje: _this.error
			});
		});
	},

	methods: {
		claseMes: function claseMes(ano, mes) {
			mes = mes < 10 ? '0' + mes : mes;
			var id = ano.toString() + mes.toString();

			if (this.mesesSeleccionados.indexOf(id) >= 0) {
				return 'btn btn-sm btn-primary';
			} else {
				return 'btn btn-sm btn-default';
			}
		},
		toggleMes: function toggleMes(ano, mes) {
			mes = mes < 10 ? '0' + mes : mes;
			var id = ano.toString() + mes.toString();
			var ind = this.mesesSeleccionados.indexOf(id);

			if (ind < 0) {
				this.mesesSeleccionados.push(id);
			} else {
				this.mesesSeleccionados.splice(ind, 1);
			}
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		checkLinea: function checkLinea(pagos) {
			for (var i = 0; i < pagos.length; i++) {
				if (pagos[i].ano < this.cerrado.ano || pagos[i].ano === this.cerrado.ano && pagos[i].mes <= this.cerrado.mes) {
					return false;
				}
			}

			return true;
		},
		repartir: function repartir() {
			var nuevo = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.contrato));
			nuevo.fecha_inicio = this.contrato.fecha_inicio;
			nuevo.fecha_fin = this.contrato.fecha_fin;

			// TODO: Repartimos
			for (var i = 0; i < nuevo.lineas.length; i++) {
				if (!this.checkLinea(nuevo.lineas[i].pagos)) {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'La l\xEDnea de soporte ' + nuevo.lineas[i].nombreSoporte + ' con el producto ' + nuevo.lineas[i].nombreProducto + ' con importe ' + nuevo.lienas[i].importe + ' ya contiene facturaci\xF3n en meses cerrados, por lo que no se va a recalcular'
					});
				} else {
					nuevo.lineas[i].pagos = [];

					if (this.contrato.dto_global > 0) {
						nuevo.lineas[i].importe = nuevo.lineas[i].importe - nuevo.lineas[i].importe * this.contrato.dto_global / 100;
					}

					var media = nuevo.lineas[i].importe / this.mesesSeleccionados.length;

					media = this.roundNumber(media, 2);
					var dif = nuevo.lineas[i].importe - media * this.mesesSeleccionados.length;

					for (var m = 0; m < this.mesesSeleccionados.length; m++) {
						// Calculamos los días que tiene el mes por si el usuario ha seleccionado un día erróneo
						var ano = parseInt(this.mesesSeleccionados[m].substr(0, 4));
						var mes = parseInt(this.mesesSeleccionados[m].substr(4, 2)) - 1;
						var fechaMes = new Date(ano, mes, 1, 0, 0, 0, 0);
						// Sumamos un mes y restamos un día
						fechaMes.setMonth(fechaMes.getMonth() + 1);
						fechaMes.setDate(fechaMes.getDate() - 1);
						var diaMax = fechaMes.getDate();
						var diaFactura = this.diaFactura > diaMax ? diaMax : this.diaFactura + 0;
						nuevo.lineas[i].pagos.push({
							ID_facturacion: null,
							importe: media,
							ano: parseInt(this.mesesSeleccionados[m].substr(0, 4)),
							mes: parseInt(this.mesesSeleccionados[m].substr(4, 2)),
							dia: diaFactura
						});
					}

					nuevo.lineas[i].pagos[nuevo.lineas[i].pagos.length - 1].importe = this.roundNumber(media + dif, 2);
				}
			}

			for (var _i = 0; _i < nuevo.lineasConceptos.length; _i++) {
				nuevo.lineasConceptos[_i].pagos = [];

				var _media = nuevo.lineasConceptos[_i].importe / this.mesesSeleccionados.length;

				_media = this.roundNumber(_media, 2);
				var _dif = nuevo.lineas[_i].importe - _media * this.mesesSeleccionados.length;

				for (var _m = 0; _m < this.mesesSeleccionados.length; _m++) {
					var _ano = parseInt(this.mesesSeleccionados[_m].substr(0, 4));
					var _mes = parseInt(this.mesesSeleccionados[_m].substr(4, 2)) - 1;
					var _fechaMes = new Date(_ano, _mes, 1, 0, 0, 0, 0);
					// Sumamos un mes y restamos un día
					_fechaMes.setMonth(_fechaMes.getMonth() + 1);
					_fechaMes.setDate(_fechaMes.getDate() - 1);
					var _diaMax = _fechaMes.getDate();
					var _diaFactura = this.diaFactura > _diaMax ? _diaMax : this.diaFactura + 0;
					nuevo.lineasConceptos[_i].pagos.push({
						ID_facturacion: null,
						importe: _media,
						ano: parseInt(this.mesesSeleccionados[_m].substr(0, 4)),
						mes: parseInt(this.mesesSeleccionados[_m].substr(4, 2)),
						dia: _diaFactura
					});
				}

				nuevo.lineasConceptos[_i].pagos[nuevo.lineasConceptos[_i].pagos.length - 1].importe = this.roundNumber(_media + _dif, 2);
			}
			this.$emit('update:contrato', nuevo);
			this.$emit('cerrar');
		},
		roundNumber: function roundNumber(num, scale) {
			return _.round(num, scale);
		}
	}
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			listadoEmpresas: []
		};
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].getEmpresas().then(function (listado) {
			_this.listadoEmpresas = listado;
		}).catch(function (e) {
			_this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: e.error
			});
		});
	},

	methods: {
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__detalles__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__radiacion__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'detalles-contrato': __WEBPACK_IMPORTED_MODULE_1__detalles__["a" /* default */],
		'radiacion-contrato': __WEBPACK_IMPORTED_MODULE_2__radiacion__["a" /* default */]
	},
	data: function data() {
		return {
			vista: 'detalles',
			contrato: null,
			ContratoID: null
		};
	},
	beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
		if (to.params.vista) {
			this.vista = to.params.vista;
		}
		next();
	},
	created: function created() {
		this.ContratoID = this.$route.params.id;

		if (this.ContratoID === 'nuevo') {
			this.nuevoContrato();
		} else {
			this.getContrato();
		}
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	}), {
		mostrarRadiacion: function mostrarRadiacion() {
			return false;
		}
	}),

	methods: {
		nuevoContrato: function nuevoContrato() {
			this.contrato = {
				ContratoID: 'nuevo',
				ContratoOriginal: null,
				FormaDePagoID: null,
				IBAN: null,
				EmpresaID: null,
				AgenteID: this.usuario.ID,
				AnuncianteID: null,
				AnuncianteNombre: '',
				AgenteNombre: this.usuario.nombre + ' ' + this.usuario.apellidos,
				ClienteID: null,
				ClienteNombre: null,
				DestinoID: null,
				DestinoNombre: null,
				IntermediarioID: null,
				DescuentoCadenaValor: 0,
				DescuentoComercial: 0,
				IntermediarioNombre: null,
				Titulo: null,
				FechaInicio: null,
				FechaFin: null,
				PartidaID: null,
				EventoID: null,
				Comentarios: null,
				FacturacionEnNeto: false,
				lineas: [],
				facturacion: [],
				recibos: [],
				cliente: {
					ClienteID: null,
					Representante: null,
					CIF: null,
					NombreCliente: null,
					Telefono: null,
					Email: null,
					Direccion: null,
					IBAN: null
				}
			};
		},
		setVista: function setVista(vista) {
			this.$router.push('/main/contratos/editar/' + this.contrato.ContratoID + '/' + vista);
		},
		getContrato: function getContrato() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].getContrato(this.ContratoID).then(function (contrato) {
				console.log(contrato);
				_this.contrato = contrato;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linea_contrato_vue__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cobros__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__facturacion__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__comentarios__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cliente_seleccionaDatos__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gestion_clientes_vue_components_editor_editor_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_api__ = __webpack_require__(23);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato'],
	components: {
		'linea-contrato': __WEBPACK_IMPORTED_MODULE_2__linea_contrato_vue__["a" /* default */],
		'facturacion': __WEBPACK_IMPORTED_MODULE_4__facturacion__["a" /* default */],
		'cobros': __WEBPACK_IMPORTED_MODULE_3__cobros__["a" /* default */],
		'comentarios': __WEBPACK_IMPORTED_MODULE_5__comentarios__["a" /* default */],
		'selecciona-datos-cliente': __WEBPACK_IMPORTED_MODULE_6__cliente_seleccionaDatos__["a" /* default */],
		'editar-cliente': __WEBPACK_IMPORTED_MODULE_7__gestion_clientes_vue_components_editor_editor_vue__["a" /* default */]
	},
	data: function data() {
		return {
			listadoEmpresas: [],
			listadoTipos: [],
			listadoEventos: [],
			listadoDestinos: [],
			listadoPartidas: [],
			listadoFormasDePago: [],
			idNuevaLinea: 0,
			ibanCliente: null,
			verCapa: null,
			modalCliente: null,
			falloForm: null,
			campoFallo: null,
			editaCliente: null
		};
	},

	watch: {
		'contrato.FormaDePagoID': function contratoFormaDePagoID(newVal) {
			for (var i = 0; i < this.listadoFormasDePago.length; i++) {
				var f = this.listadoFormasDePago[i];
				if (f.ID_forma_de_pago === newVal) {
					if (f.requiere_iban === 0) {
						this.contrato.cliente.IBAN = null;
					}
				}
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario',
		permisos: 'permisos/permisos'
	}), {
		fase1: function fase1() {
			return this.contrato.EmpresaID && this.contrato.ClienteID;
		},
		necesitaIBAN: function necesitaIBAN() {
			if (!this.listadoFormasDePago) {
				return false;
			}
			if (!this.contrato.FormaDePagoID) {
				return false;
			}

			for (var i = 0; i < this.listadoFormasDePago.length; i++) {
				var f = this.listadoFormasDePago[i];
				if (f.ID_forma_de_pago === this.contrato.FormaDePagoID) {
					return f.requiere_iban === 1;
				}
			}

			return false;
		},
		diaFacturacion: function diaFacturacion() {
			var _this = this;

			if (!this.contrato.TipoID) {
				return -1;
			}

			if (this.listadoTipos.length === 0) {
				return -1;
			}

			var tipo = this.listadoTipos.filter(function (t) {
				return t.TipoID === _this.contrato.TipoID;
			})[0];
			if (!tipo) {
				return -1;
			}

			return tipo.DiaFacturacion;
		},
		importeBruto: function importeBruto() {
			var importe = 0;
			for (var i = 0; i < this.contrato.lineas.length; i++) {
				var l = this.contrato.lineas[i];
				importe += l.ImporteBruto;
			}
			return isNaN(importe) ? 0 : importe;
		},
		importeNeto: function importeNeto() {
			var total = 0;
			for (var i = 0; i < this.contrato.lineas.length; i++) {
				var l = this.contrato.lineas[i];
				total += l.ImporteNeto;
			}
			// Aplicamos los descuentos
			if (this.contrato.DescuentoCadenaValor) {
				total = total - total * this.contrato.DescuentoCadenaValor / 100;
			}

			if (this.contrato.DescuentoComercial) {
				total = total - total * this.contrato.DescuentoComercial / 100;
			}

			return total;
		},
		importeTotal: function importeTotal() {
			// Calculamos el importe de los impuestos
			var suma = 0;
			for (var i = 0; i < this.contrato.lineas.length; i++) {
				var l = this.contrato.lineas[i];
				suma = suma + l.ImporteTotal;
			}

			return suma;
		},
		importeBrutoContratoImpuestos: function importeBrutoContratoImpuestos() {
			// Calculamos el importe de los impuestos
			var suma = this.importeBrutoContrato + 0;
			for (var i = 0; i < this.contrato.lineas.length; i++) {
				var l = this.contrato.lineas[i];
				var importeLinea = l.ImporteBruto;
				var impuestos = l.Impuestos ? l.Impuestos : 0;
				var cantidadImpuestos = importeLinea * impuestos / 100;
				suma = suma + cantidadImpuestos;
			}
			return Math.round(suma * 100) / 100;
		},
		recibosValidos: function recibosValidos() {
			var importe = 0;
			for (var i = 0; i < this.contrato.recibos.length; i++) {
				if (this.contrato.recibos[i].FechaVencimiento === null) {
					return false;
				}
				if (this.contrato.recibos[i].ImporteTotal === 0 || !this.contrato.recibos[i].ImporteTotal) {
					return false;
				}

				importe = importe + this.contrato.recibos[i].ImporteTotal;
			}

			if (Math.round(importe * 100) !== Math.round(this.importeTotal * 100)) {
				return false;
			}
			return true;
		},
		facturacionValida: function facturacionValida() {
			var importe = 0;
			for (var i = 0; i < this.contrato.facturacion.length; i++) {
				if (this.contrato.facturacion[i].FechaFactura === null) {
					return false;
				}
				if (this.contrato.facturacion[i].ImporteTotal === 0 || !this.contrato.facturacion[i].ImporteTotal) {
					return false;
				}

				importe = importe + parseFloat(this.contrato.facturacion[i].ImporteTotal);
			}

			var importeAComprobar = this.contrato.FacturacionEnNeto ? this.importeNeto : this.importeTotal;
			if (this.round(importe, 2) !== this.round(importeAComprobar, 2)) {
				return false;
			}
			return true;
		},
		contratoValido: function contratoValido() {
			var contrato = this.contrato;

			if (!contrato.EmpresaID) {
				this.falloForm = 'No has seleccionado la empresa desde la que haces el contrato';
				this.campoFallo = 'empresa';
				return false;
			}
			this.campoFallo = null;

			if (!contrato.AgenteID && !this.permisos.contratos_crearContratosSinAgente) {
				this.falloForm = 'No has definido el agente del contrato';
				this.campoFallo = 'agente';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.ClienteID) {
				this.falloForm = 'No has definido el cliente';
				this.campoFallo = 'cliente';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.FormaDePagoID) {
				this.falloForm = 'Selecciona una forma de pago';
				this.campoFallo = 'formaDePago';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.Titulo) {
				this.falloForm = 'Debes definir el título del contrato';
				this.campoFallo = 'titulo';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.AnuncianteID) {
				this.falloForm = 'No has asignado un anunciante';
				this.campoFallo = 'anunciante';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.FechaInicio) {
				this.falloForm = 'Debes definir la fecha de inicio de contrato';
				this.campoFallo = 'fechaIni';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.FechaFin) {
				this.falloForm = 'Debes definir la fecha de fin de contrato';
				this.campoFallo = 'fechaFin';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.cliente.NombreCliente) {
				this.falloForm = 'Debes escribir el nombre de la empresa (cliente)';
				this.campoFallo = 'clienteNombre';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.cliente.Representante) {
				this.falloForm = 'Debes escribir quien es el representante de la empresa del cliente';
				this.campoFallo = 'clienteRepresentante';
				return false;
			}

			this.campoFallo = null;

			var iban = typeof contrato.cliente.IBAN === 'string' ? contrato.cliente.IBAN.replace(/\s/ig, '').trim() : null;
			if (this.necesitaIBAN && !iban) {
				this.falloForm = 'Debes proporcionar el IBAN para esta forma de pago';
				this.campoFallo = 'clienteIBAN';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.TipoID) {
				this.falloForm = 'Selecciona el tipo de contrato';
				this.campoFallo = 'tipo';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.DestinoID) {
				this.falloForm = 'Selecciona el destino del contrato';
				this.campoFallo = 'destino';
				return false;
			}

			this.campoFallo = null;

			if (!contrato.lineas || contrato.lineas.length === 0) {
				this.falloForm = 'No has añadido ninguna línea en el contrato';
				return false;
			}

			if (!this.facturacionValida) {
				this.falloForm = 'La facturación no es válida';
				return false;
			}

			if (!this.recibosValidos) {
				this.falloForm = 'Los cobros no son válidos';
				return false;
			}

			// Las líneas deben tener impuestos
			for (var i = 0; i < contrato.lineas.length; i++) {
				var l = contrato.lineas[i];
				if (typeof contrato.lineas[i].Impuestos !== 'number') {
					this.falloForm = 'No has definido los impuestos de la línea ' + (i + 1);
					return false;
				}

				if (!l.Concepto || typeof l.ImporteUnitario !== 'number' || typeof l.Unidades !== 'number' || typeof l.Cantidad !== 'number') {
					this.falloForm = 'No has definido el concepto de la línea ' + (i + 1);
					return false;
				}

				if (!l.Cantidad || l.Cantidad <= 0) {
					this.falloForm = 'La cantidad de la línea ' + (i + 1) + ' debe ser un número superior a 0';
					return false;
				}
			}

			return true;
		}
	}),
	created: function created() {
		var _this2 = this;

		__WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('mis-contratos/php/api/get-listado-empresas.php').then(function (res) {
			_this2.listadoEmpresas = res.data;
		}).catch(this.$responseError);

		__WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('mis-contratos/php/api/get-tipos-contrato.php').then(function (res) {
			_this2.listadoTipos = res.data.tipos;
		}).catch(this.$responseError);

		__WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('mis-contratos/php/api/get-destinos.php').then(function (res) {
			_this2.listadoDestinos = res.data.destinos;
		}).catch(this.$responseError);
		__WEBPACK_IMPORTED_MODULE_9__services_api__["a" /* default */].getFormasDePago().then(function (res) {
			_this2.listadoFormasDePago = res.data.formas;
		}).catch(this.$responseError);
		__WEBPACK_IMPORTED_MODULE_9__services_api__["a" /* default */].getPartidas().then(function (res) {
			_this2.listadoPartidas = res.data;
		}).catch(this.$responseError);
	},

	methods: {
		importarDatosCliente: function importarDatosCliente() {
			this.modalCliente = parseInt(this.contrato.ClienteID);
		},
		asociarDatoCliente: function asociarDatoCliente(ev) {
			if (!this.necesitaIBAN && ev.campo === 'IBAN') {
				return;
			}
			this.contrato.cliente[ev.campo] = ev.dato;
		},
		quitarAgente: function quitarAgente() {
			this.contrato.AgenteID = null;
			this.contrato.AgenteNombre = null;
		},
		setAgente: function setAgente(e) {
			this.contrato.AgenteID = e.datos.ID;
			this.contrato.AgenteNombre = e.datos.nombre + ' ' + e.datos.apellidos;
		},
		cerrarEditorCliente: function cerrarEditorCliente() {
			this.editaCliente = null;
		},
		quitarCliente: function quitarCliente() {
			this.contrato.ClienteID = null;
			this.contrato.ClienteNombre = null;
			this.contrato.cliente.ClienteID = null;
		},
		setCliente: function setCliente(e) {
			this.contrato.ClienteID = e.datos.ID;
			this.contrato.ClienteNombre = e.datos.cliente;
			this.ibanCliente = e.datos.iban;

			this.contrato.cliente.ClienteID = parseInt(e.datos.ID);

			// Buscamos la forma de pago del cliente
			this.contrato.FormaDePagoID = parseInt(e.datos.FormaPagoID);

			var necesitaIBAN = this.listadoFormasDePago.reduce(function (acc, forma) {
				if (forma.ID_forma_de_pago === e.datos.FormaPagoID) {
					acc = forma.requiere_iban === 1 && acc === null ? true : acc;
				}
			}, null);

			this.importarDatosCliente();

			if (necesitaIBAN) {
				this.contrato.cliente.IBAN = null;
			}
		},
		importarIBAN: function importarIBAN() {
			if (!this.ibanCliente) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'El cliente seleccionado no tiene un número de IBAN válido'
				});
				return;
			}
			this.contrato.IBAN = this.ibanCliente;
		},
		asignaAnunciante: function asignaAnunciante(ev) {
			this.contrato.AnuncianteID = ev.datos.AnuncianteID;
			this.contrato.AnuncianteNombre = ev.datos.AnuncianteNombre;
		},
		seleccionaEvento: function seleccionaEvento(ev) {
			this.contrato.EventoID = ev.datos.ID_evento;
			this.contrato.EventoNombre = ev.datos.titulo;
		},
		quitarEvento: function quitarEvento() {
			this.contrato.EventoID = null;
			this.contrato.EventoNombre = null;
		},
		quitarIntermediario: function quitarIntermediario() {
			this.contrato.IntermediarioID = null;
			this.contrato.IntermediarioNombre = null;
		},
		setIntermediario: function setIntermediario(e) {
			this.contrato.IntermediarioID = e.datos.IntermediarioID;
			this.contrato.IntermediarioNombre = e.datos.Nombre;
		},
		cambiaTipo: function cambiaTipo() {
			var _this3 = this;

			var tipo = this.listadoTipos.filter(function (p) {
				return p.TipoID === _this3.contrato.TipoID;
			})[0];
			if (!tipo) {
				tipo = {
					DiaFacturacion: -1
				};
			}
			// Ajustamos los días
			for (var i = 0; i < this.contrato.facturacion.length; i++) {
				var f = this.contrato.facturacion[i];
				if (!f.FacturacionID.match(/^[0-9]{1,}$/)) {
					// Ajustamos el día de facturación
					if (tipo.DiaFacturacion > 0) {
						this.contrato.facturacion[i].FechaFactura.setDate(tipo.DiaFacturacion);
					} else {
						this.contrato.facturacion[i].FechaFactura.setDate(1);
						this.contrato.facturacion[i].FechaFactura.setMonth(this.contrato.facturacion[i].FechaFactura.getMonth() + 1);
						this.contrato.facturacion[i].FechaFactura.setDate(this.contrato.facturacion[i].FechaFactura.getDate() + tipo.DiaFacturacion);
					}
				}
			}
			this.$emit('update:contrato', this.contrato);
			this.$forceUpdate();
		},
		cambiaDestino: function cambiaDestino() {
			this.$emit('update:contrato', this.contrato);
			this.$forceUpdate();
		},
		cambiaPartida: function cambiaPartida() {
			this.$emit('update:contrato', this.contrato);
			this.$forceUpdate();
		},
		nuevaLineaContrato: function nuevaLineaContrato() {
			this.contrato.lineas.push({
				LineaID: 'L-' + (++this.idNuevaLinea).toString(),
				ContratoID: null,
				CatalogoID: null,
				ArticuloID: null,
				ArticuloUnitario: 0,
				ImporteUnitario: null,
				Unidades: 1,
				Cantidad: 1,
				Descuento: null,
				Impuestos: 21,
				ImpuestosNombre: 'IVA',
				ImpuestosID: 1,
				ImporteBruto: null,
				ImporteNeto: null,
				ImporteTotal: null,
				ImporteImpuestos: null,
				Tipo: 'Articulo',
				DescuentoCadenaValor: null,
				DescuentoComercial: null
			});

			this.$forceUpdate();
		},
		quitarLinea: function quitarLinea(linea) {
			for (var i = 0; i < this.contrato.lineas.length; i++) {
				if (this.contrato.lineas[i].LineaID === linea.LineaID) {
					this.contrato.lineas.splice(i, 1);
					return;
				}
			}
		},
		guardar: function guardar() {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Guardar el contrato',
				mensaje: '\xBFQuieres guardar este contrato?\n\t\t\t\tEsto generar\xE1 una nueva versi\xF3n del contrato',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_9__services_api__["a" /* default */].setContrato(_this4.contrato).then(function (res) {
							_this4.$store.commit('toast/success', {
								titulo: 'Contrato guardado',
								mensaje: 'Se ha guardado el contrato correctamente'
							});
							_this4.$router.push('/main/contratos/listado/' + res.ContratoID);
						}).catch(function (e) {
							if (e.response) {
								_this4.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								});
							} else {
								console.error(e);
							}
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['value', 'idx', 'dtoCadValor', 'dtoComercial'],
	data: function data() {
		return {
			listadoDestinos: [],
			listadoImpuestos: [],
			descuento: 0
		};
	},

	watch: {
		dtoCadValor: function dtoCadValor(newVal) {
			this.value.DescuentoCadenaValor = newVal;
			this.calculaImporte();
		},
		dtoComercial: function dtoComercial(newVal) {
			this.value.DescuentoComercial = newVal;
			this.calculaImporte();
		}
	},
	created: function created() {
		var _this = this;

		if (this.value.Descuento) {
			this.descuento = this.value.Descuento + 0;
		}
		this.getSoportes();
		this.calculaImporte();
		__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getImpuestos().then(function (res) {
			_this.listadoImpuestos = res.data.impuestos;

			if (_this.value.Impuestos === null) {
				for (var i = 0; i < _this.listadoImpuestos.length; i++) {
					if (_this.listadoImpuestos[i].predeterminado) {
						_this.value.Impuestos = _this.listadoImpuestos[i].valor;
						_this.value.ImpuestosID = _this.listadoImpuestos[i].ID_impuesto;
						_this.value.ImpuestosNombre = _this.listadoImpuestos[i].nombre;
					}
				}
			}
		}).catch(function (e) {
			_this.$store.commit('toast/danger', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},

	computed: {
		seleccionValida: function seleccionValida() {
			if (this.value.Tipo === 'Articulo') {
				return this.value.ArticuloID;
			} else {
				return this.value.Concepto;
			}
		}
	},
	methods: {
		calculaDescuento: function calculaDescuento() {
			var bruto = this.value.ImporteUnitario * this.value.Unidades * this.value.Cantidad;
			var total = this.value.ImporteNeto;
			var descuento = 100 - total * 100 / bruto;
			this.descuento = this.round(descuento, 2);

			// this.calculaImporte()
			this.calculaTotal();
		},
		resetImportes: function resetImportes() {
			this.value.CatalogoID = null;
			this.value.ArticuloID = null;
			this.value.Concepto = null;
			this.value.ImporteUnitario = null;
			this.value.Unidades = null;
			this.value.Cantidad = null;
			this.value.Descuento = null;
			this.value.ImpuestosID = 1;
			this.value.Impuestos = 21;
			this.value.ImpuestosNombre = 'IVA';
			this.value.ImporteBruto = null;
			this.value.ImporteNeto = null;
			this.value.ImpoteTotal = null;
			this.value.Tipo = 'Articulo';
		},
		setTipo: function setTipo(tipo) {
			this.value.Tipo = tipo;
			this.value.ArticuloID = null;
			this.value.CatalogoID = null;

			if (this.value.Tipo === 'Otros') {
				this.value.ArticuloUnitario = 0;
				this.value.Unidades = 1;
				this.getSoportes();
			}
		},
		seleccionaTarifa: function seleccionaTarifa(e) {
			this.value.CatalogoID = e.datos.CatalogoID;
			this.value.ArticuloID = e.datos.ArticuloID;
			this.value.Concepto = e.datos.CatalogoNombre + ' - ' + e.datos.Nombre;
			this.value.ImporteUnitario = e.datos.Importe;
			this.value.Unidades = 1;
			this.value.ArticuloUnitario = e.datos.ArticuloUnitario === 'Si';
			this.value.Cantidad = 1;
			this.value.Descuento = 0;
			this.value.Tipo = 'Articulo';
			this.calculaImporte();
		},
		quitarTarifa: function quitarTarifa() {
			this.resetImportes();
		},
		getSoportes: function getSoportes() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/mis-contratos/php/api/get-catalogos.php').then(function (res) {
				_this2.listadoDestinos = res.data.catalogos;
			}).catch(this.$responseError);
		},
		cambiaImpuestos: function cambiaImpuestos() {
			if (this.value.ImpuestosID === null) {
				this.value.Impuestos = null;
				this.value.ImpuestosNombre = null;
				this.calculaImporte();
				return;
			}

			for (var i = 0; i < this.listadoImpuestos.length; i++) {
				if (this.listadoImpuestos[i].ID_impuesto === this.value.ImpuestosID) {
					this.value.Impuestos = this.listadoImpuestos[i].valor;
					this.value.ImpuestosNombre = this.listadoImpuestos[i].nombre;
				}
			}

			this.calculaImporte();
		},
		calculaImporte: function calculaImporte() {
			this.value.ImporteBruto = this.value.ImporteUnitario * this.value.Unidades * this.value.Cantidad;
			this.value.ImporteNeto = this.value.ImporteBruto + 0;
			if (this.descuento) {
				this.value.ImporteNeto = this.value.ImporteNeto * (100 - this.descuento) / 100;
				this.value.Descuento = 0 + this.descuento;
			} else {
				this.value.Descuento = this.value.ImporteNeto * 100 / this.value.ImporteBruto;
			}

			this.value.ImporteBruto = this.round(this.value.ImporteBruto, 2);
			this.value.ImporteNeto = this.round(this.value.ImporteNeto, 2);

			this.calculaTotal();

			this.$emit('input', this.value);
			this.$forceUpdate();
		},
		calculaTotal: function calculaTotal() {
			this.value.ImporteTotal = this.value.ImporteNeto + 0;

			if (this.dtoCadValor) {
				this.value.ImporteTotal = this.value.ImporteTotal - this.value.ImporteTotal * this.dtoCadValor / 100;
				this.value.ImporteTotal = this.round(this.value.ImporteTotal, 2);
			}

			if (this.dtoComercial) {
				this.value.ImporteTotal = this.value.ImporteTotal - this.value.ImporteTotal * this.dtoComercial / 100;
				this.value.ImporteTotal = this.round(this.value.ImporteTotal, 2);
			}

			if (this.value.Impuestos) {
				this.value.ImporteTotal = this.value.ImporteTotal + this.value.ImporteTotal * this.value.Impuestos / 100;
				this.value.ImporteTotal = this.round(this.value.ImporteTotal, 2);
			}

			this.value.Descuento = this.round(this.descuento, 2);

			this.$emit('input', this.value);
			this.$forceUpdate();
		}
	}
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato', 'importe', 'facturacionValida'],
	created: function created() {
		for (var i = 0; i < this.contrato.recibos.length; i++) {
			if (!this.contrato.ReciboID || !this.contrato.recibos[i].ReciboID.match(/^[0-9]{1,}$/)) {
				this.setFechaEmision(this.contrato.recibos[i]);
			}
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	}), {
		MesesBloqueados: function MesesBloqueados() {
			if (!this.permisos.contratos_ignoraCierre) {
				return {
					to: new Date()
				};
			}
			return {};
		},
		ImportePendiente: function ImportePendiente() {
			var pendiente = Math.round((this.importe - this.totalRecibos) * 100);
			return this.round(pendiente / 100, 2);
		},
		totalRecibos: function totalRecibos() {
			var importe = 0;
			for (var i = 0; i < this.contrato.recibos.length; i++) {
				importe = importe + this.contrato.recibos[i].ImporteTotal;
			}
			return this.round(importe, 2);
		},
		variosPorMes: function variosPorMes() {
			var meses = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

			for (var i = 0; i < this.contrato.recibos.length; i++) {
				if (this.contrato.recibos[i].FechaVencimiento) {
					var fecha = this.contrato.recibos[i].FechaVencimiento;
					var mes = fecha.getFullYear().toString() + '-' + fecha.getMonth().toString();

					if (meses.has(mes)) {
						return true;
					}

					meses.set(mes, 1);
				}
			}
			return false;
		}
	}),
	methods: {
		nuevo: function nuevo() {
			var rnd = Math.floor(Math.random() * 10000);
			this.contrato.recibos.push({
				ReciboID: 'recibo-' + rnd + ' - ' + new Date().getTime().toString(),
				FechaVencimiento: null,
				FechaEmision: null,
				ImporteTotal: null,
				Estado: 'Pendiente'
			});
		},
		quitar: function quitar(recibo) {
			var editor = this.contrato;
			editor.recibos = editor.recibos.filter(function (r) {
				return r !== recibo;
			});
			this.$emit('update:contrato', editor);
		},
		setFechaEmision: function setFechaEmision(recibo) {
			if (!recibo.FechaVencimiento) {
				return null;
			}
			if (recibo.FechaEmision && recibo.FechaEmision < new Date()) {
				return recibo.FechaEmision;
			}
			var fecha = new Date(recibo.FechaVencimiento.getTime());
			if (this.contrato.partida === 3) {
				// ES SER EMPRESARIOS
				fecha.setDate(15);
			} else {
				fecha.setDate(1);
				fecha.setMonth(fecha.getMonth() + 1);
				fecha.setDate(fecha.getDate() - 1);
			}
			recibo.FechaEmision = fecha;
		},
		repartir: function repartir() {
			/**
    * Redondeamos a dos decimales
    */
			if (this.contrato.recibos.length === 0) {
				return;
			}

			if (this.importe === 0) {
				return;
			}

			// Calculamos el total de recibos que podemos modificar (no están pasados de fecha)
			// TODO: Esta condición debería ser la de que si están cobrados o no
			var totalRecibos = 0;
			var importeRestante = this.importe + 0;

			for (var i = 0; i < this.contrato.recibos.length; i++) {
				if (this.contrato.recibos[i].Estado === 'Pendiente') {
					totalRecibos++;
				} else {
					importeRestante = importeRestante - this.contrato.recibos[i].ImporteTotal;
				}
			}

			// Calculamos el importe por meses
			var media = Math.round(importeRestante / totalRecibos * 100);
			var acumulado = 0;
			var cantidad = media;
			for (var _i = 0; _i < this.contrato.recibos.length; _i++) {
				if (this.contrato.recibos[_i].Estado === 'Pendiente') {
					if (_i === this.contrato.recibos.length - 1) {
						// Es el último, redondeamos
						cantidad = this.round(importeRestante * 100, 2) - acumulado;
					}
					this.contrato.recibos[_i].ImporteTotal = this.round(cantidad / 100, 2);
					acumulado = acumulado + cantidad;
				}
			}
		},
		aplicarFormaDePago: function aplicarFormaDePago() {
			var _this = this;

			if (!this.contrato.FormaDePagoID) {
				this.$alert('No has definido una forma de pago');
				return;
			}

			this.$http.get('mis-contratos/php/api/get-forma-pago-detalles.php?FormaID=' + this.contrato.FormaDePagoID).then(function (res) {
				var forma = res.data;

				// if (forma.numero_pagos && forma.numero_pagos !== this.contrato.facturacion.length) {
				// 	console.error('No coinciden')
				// 	this.$store.commit('alertas/error', {
				// 		titulo: 'Error',
				// 		mensaje: `La forma de pago seleccionada exige un total de ${forma.numero_pagos} facturas. Ajusta el número de facturas o cambia la forma de pago`
				// 	})
				// 	return
				// }

				_this.contrato.recibos = [];

				var numeroRecibo = 0;
				for (var i = 0; i < _this.contrato.facturacion.length; i++) {
					for (var p = 0; p < forma.pagos.length; p++) {
						_this.nuevo();
						var dias = forma.pagos[p].Dias;
						var milis = new Date(_this.contrato.facturacion[i].FechaFactura).getTime();
						milis = milis + dias * 3600000 * 24;
						var fecha = new Date(milis);
						_this.contrato.recibos[numeroRecibo].FechaVencimiento = fecha;
						_this.contrato.recibos[numeroRecibo].ImporteTotal = _this.round(_this.contrato.facturacion[i].ImporteTotal / forma.pagos.length, 2);
						_this.setFechaEmision(_this.contrato.recibos[numeroRecibo]);
						numeroRecibo++;
					}
				}
			}).catch(function (e) {
				console.error(e);
				_this.$responseError(e);
			});
		}
	}
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
			props: ['contrato', 'importe', 'diaFacturacion', 'importeNeto'],
			data: function data() {
						return {
									FacturacionEnNeto: false
						};
			},
			created: function created() {
						this.calculaImporteTotal();
			},

			computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
						permisos: 'permisos/permisos'
			}), {
						MesesBloqueados: function MesesBloqueados() {
									if (!this.permisos.contratos_ignoraCierre) {
												return {
															to: new Date()
												};
									}
									return {};
						},
						ImportePendiente: function ImportePendiente() {
									var pendiente = Math.round((this.importe - this.totalFacturacion) * 100);
									return pendiente / 100;
						},
						ImportePendienteNeto: function ImportePendienteNeto() {
									var pendiente = Math.round((this.importeNeto - this.totalFacturacionNeto) * 100);
									return pendiente / 100;
						},
						totalFacturacion: function totalFacturacion() {
									var importe = 0;
									for (var i = 0; i < this.contrato.facturacion.length; i++) {
												var importeF = void 0;
												try {
															importeF = !this.contrato.facturacion[i].ImporteTotal ? 0 : parseFloat(this.contrato.facturacion[i].ImporteTotal);
												} catch (e) {
															console.error(e);
												}
												importe = importe + importeF;
									}
									return this.round(importe, 2);
						},
						totalFacturacionNeto: function totalFacturacionNeto() {
									var importe = 0;
									for (var i = 0; i < this.contrato.facturacion.length; i++) {
												var importeF = void 0;
												try {
															importeF = !this.contrato.facturacion[i].ImporteNeto ? 0 : parseFloat(this.contrato.facturacion[i].ImporteNeto);
												} catch (e) {
															console.error(e);
												}
												importe = importe + importeF;
									}
									return this.round(importe, 2);
						}
			}),
			watch: {
						diaFacturacion: function diaFacturacion(newVal) {
									var _this = this;

									var _loop = function _loop(i) {
												var linea = _this.contrato.facturacion[i];
												var picker = _this.$refs['picker' + _this.contrato.facturacion[i].FacturacionID][0];
												if (!picker) {
															return 'continue';
												}
												var editar = _this.contrato;
												editar.facturacion = editar.facturacion.map(function (l) {
															if (l.FacturacionID === linea.FacturacionID) {
																		l.FechaFactura = new Date(picker.selectedDate.getTime());
															}
															return l;
												});
												_this.$emit('update:contrato', editar);
									};

									for (var i = 0; i < this.contrato.facturacion.length; i++) {
												var _ret = _loop(i);

												if (_ret === 'continue') continue;
									}
						}
			},
			methods: {
						nuevo: function nuevo() {
									this.contrato.facturacion.push({
												FacturacionID: 'L-' + new Date().getTime().toString(),
												FechaFactura: null,
												ImporteBruto: null,
												ImporteNeto: null,
												ImporteTotal: null
									});
						},
						editable: function editable(linea) {
									if (linea.FechaPagada) {
												return false;
									}
									var fechaLimite = new Date();
									fechaLimite.setDate(1);
									fechaLimite.setDate(fechaLimite.getDate() - 1);

									if (!linea.FechaFactura || linea.FechaFactura > fechaLimite || this.permisos.contratos_ignoraCierre) {
												return true;
									}

									return false;
						},
						quitar: function quitar(linea) {
									var editor = this.contrato;
									editor.facturacion = editor.facturacion.filter(function (r) {
												return r !== linea;
									});
									this.$emit('update:contrato', editor);
						},
						seleccionaFecha: function seleccionaFecha(linea, ev) {
									var editar = this.contrato;

									// Cambiamos la fecha al final del mes
									if (this.diaFacturacion > 0) {
												// SER EMPRESARIOS SE FACTURA EL DÍA 15
												ev.setDate(this.diaFacturacion);
									} else {
												ev.setDate(1);
												ev.setMonth(ev.getMonth() + 1);
												ev.setDate(ev.getDate() + this.diaFacturacion);
									}
									editar.facturacion = editar.facturacion.map(function (l) {
												if (l.FacturacionID === linea.FacturacionID) {
															l.FechaFactura = ev;
												}
												return l;
									});
									this.$emit('update:contrato', editar);
						},

						/**
      * Repartimos el importe neto total del contrato entre los meses de facturación
      */
						repartirTotal: function repartirTotal() {
									/**
          * Redondeamos a dos decimales
          */
									var importe = this.FacturacionEnNeto ? this.importeNeto : this.importe;
									if (this.contrato.facturacion.length === 0) {
												return;
									}

									if (importe === 0) {
												return;
									}
									var importeRestante = importe + 0;

									// Calculamos el total de recibos que podemos modificar (no están pasados de fecha)
									// TODO: Esta condición debería ser la de que si están cobrados o no
									var totalFacturacion = 0;
									var acumulado = 0;
									for (var i = 0; i < this.contrato.facturacion.length; i++) {
												if (this.editable(this.contrato.facturacion[i]) && this.contrato.facturacion[i].FechaFactura) {
															totalFacturacion++;
												} else if (this.contrato.facturacion[i].Importe) {
															importeRestante = importeRestante - this.contrato.facturacion[i].ImporteTotal;
												} else if (!this.editable(this.contrato.facturacion[i])) {
															importeRestante = importeRestante - this.contrato.facturacion[i].ImporteTotal;
												}
									}

									// Calculamos el importe por meses
									var media = this.round(importeRestante / totalFacturacion, 2);
									var cantidad = media;
									for (var _i = 0; _i < this.contrato.facturacion.length; _i++) {
												if (this.editable(this.contrato.facturacion[_i]) && this.contrato.facturacion[_i].FechaFactura) {
															if (_i === this.contrato.facturacion.length - 1) {
																		// Si es la última línea
																		// Es el último, redondeamos
																		cantidad = this.round(importeRestante - acumulado, 2);
															}
															this.contrato.facturacion[_i].ImporteTotal = this.round(cantidad, 2);
															acumulado = this.round(acumulado + cantidad, 2);
												}
									}

									this.calculaImporteTotal();

									this.$emit('update:contrato', this.contrato);

									this.$forceUpdate();
						},
						repartirNeto: function repartirNeto() {
									/**
          * Redondeamos a dos decimales
          */
									var importe = this.importeNeto;
									if (this.contrato.facturacion.length === 0) {
												return;
									}

									if (importe === 0) {
												return;
									}
									var importeRestante = importe + 0;

									// Calculamos el total de recibos que podemos modificar (no están pasados de fecha)
									// TODO: Esta condición debería ser la de que si están cobrados o no
									var totalFacturacion = 0;
									var acumulado = 0;
									for (var i = 0; i < this.contrato.facturacion.length; i++) {
												if (this.editable(this.contrato.facturacion[i]) && this.contrato.facturacion[i].FechaFactura) {
															totalFacturacion++;
												} else if (this.contrato.facturacion[i].Importe) {
															importeRestante = importeRestante - this.contrato.facturacion[i].ImporteNeto;
												} else if (!this.editable(this.contrato.facturacion[i])) {
															importeRestante = importeRestante - this.contrato.facturacion[i].ImporteNeto;
												}
									}

									// Calculamos el importe por meses
									var media = this.round(importeRestante / totalFacturacion, 2);
									var cantidad = media;
									for (var _i2 = 0; _i2 < this.contrato.facturacion.length; _i2++) {
												if (this.editable(this.contrato.facturacion[_i2]) && this.contrato.facturacion[_i2].FechaFactura) {
															if (_i2 === this.contrato.facturacion.length - 1) {
																		// Si es la última línea
																		// Es el último, redondeamos
																		cantidad = this.round(importeRestante - acumulado, 2);
															}
															this.contrato.facturacion[_i2].ImporteNeto = this.round(cantidad, 2);
															acumulado = this.round(acumulado + cantidad, 2);
												}
									}

									this.calculaImporteTotal();

									this.$emit('update:contrato', this.contrato);

									this.$forceUpdate();
						},
						calculaImporteTotal: function calculaImporteTotal() {
									var _this2 = this;

									if (!this.FacturacionEnNeto) {
												var acumulado = 0;

												var _loop2 = function _loop2(i) {
															var linea = _this2.contrato.facturacion[i];
															var importeTotal = linea.ImporteTotal;
															var meses = _this2.contrato.facturacion.length;

															var total = _this2.contrato.lineas.reduce(function (acc, lineaContrato) {
																		if (importeTotal === 0 || isNaN(importeTotal)) {
																					return acc;
																		}
																		var netoL = lineaContrato.ImporteNeto;
																		var netoMes = netoL / meses;
																		var totalL = lineaContrato.ImporteTotal;
																		var totalMes = totalL / meses;

																		var porcentaje = importeTotal * 100 / totalMes;
																		var totalLinea = netoMes * porcentaje / 100 / _this2.contrato.lineas.length;
																		acc = acc + totalLinea;
																		return _this2.round(acc, 2);
															}, 0);

															for (var j = 0; j < _this2.contrato.facturacion.length; j++) {
																		if (_this2.contrato.facturacion[j].FacturacionID === linea.FacturacionID) {
																					_this2.contrato.facturacion[j].ImporteNeto = total;
																					acumulado = acumulado + total;
																		}
															}

															if (_this2.contrato.facturacion.length - 1 === i) {
																		// El la última línea de facturación
																		if (_this2.importeNeto !== acumulado) {
																					_this2.contrato.facturacion[_this2.contrato.facturacion.length - 1].ImporteNeto = _this2.round(total + (_this2.importeNeto - acumulado), 2);
																		}
															}
												};

												for (var i = 0; i < this.contrato.facturacion.length; i++) {
															_loop2(i);
												}
									} else {
												var _acumulado = 0;

												var _loop3 = function _loop3(i) {
															var linea = _this2.contrato.facturacion[i];
															var importeNeto = parseFloat(linea.ImporteNeto);
															var meses = _this2.contrato.facturacion.length;

															var total = _this2.contrato.lineas.reduce(function (acc, lineaContrato) {
																		if (importeNeto === 0 || isNaN(importeNeto)) {
																					return acc;
																		}
																		var netoL = lineaContrato.ImporteNeto;
																		var netoMes = netoL / meses;
																		var totalL = lineaContrato.ImporteTotal;
																		var totalMes = totalL / meses;

																		var porcentaje = importeNeto * 100 / netoMes;
																		var totalLinea = totalMes * porcentaje / 100 / _this2.contrato.lineas.length;
																		acc = acc + totalLinea;
																		return _this2.$options.filters.round(acc, 2);
															}, 0);

															for (var j = 0; j < _this2.contrato.facturacion.length; j++) {
																		if (_this2.contrato.facturacion[j].FacturacionID === linea.FacturacionID) {
																					_this2.contrato.facturacion[j].ImporteTotal = total;
																					_acumulado = _acumulado + total;
																		}
															}

															if (_this2.contrato.facturacion.length - 1 === i) {
																		// El la última línea de facturación
																		if (_this2.importeNeto !== _acumulado) {
																					_this2.contrato.facturacion[_this2.contrato.facturacion.length - 1].ImporteTotal = _this2.round(total + (_this2.importe - _acumulado), 2);
																		}
															}
												};

												for (var i = 0; i < this.contrato.facturacion.length; i++) {
															_loop3(i);
												}
									}
						}
			}
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato']
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['ClienteID'],
	data: function data() {
		return {
			cliente: null,
			telefonoSeleccionado: null,
			emailSeleccionado: null
		};
	},
	created: function created() {
		if (!this.ClienteID) {
			this.$error('Error', 'Debes proporcionar un ID de cliente');
			this.cerrar();
		} else {
			this.getCliente();
		}
	},

	methods: {
		getCliente: function getCliente() {
			var _this = this;

			this.$http.get('gestion-clientes/php/api/get-cliente.php?ID=' + this.ClienteID).then(function (res) {
				var cliente = res.data.cliente;

				_this.asignar('NombreCliente', cliente.cliente);
				_this.asignar('Representante', cliente.nombre);
				_this.asignar('CIF', cliente.CIF);

				if (cliente.facturacion) {
					_this.asignar('IBAN', cliente.facturacion.cuenta);
				}

				if (cliente.telefonos && cliente.telefonos.length === 1) {
					_this.asignar('Telefono', cliente.telefonos[0].telefono);
				} else if (cliente.telefonos && cliente.telefonos.length > 1) {
					_this.cliente = cliente;
				}

				if (cliente.emails && cliente.emails.length === 1) {
					_this.asignar('Email', cliente.emails[0].email);
				} else if (cliente.emails && cliente.emails.length > 1) {
					_this.cliente = cliente;
				}

				// Ahora pasamos la dirección del cliente
				if (!cliente.place_id) {
					_this.asignar('Direccion', _this.parseaDireccion(cliente.direccion));
				} else {
					_this.asignar('Direccion', cliente.direccion.direccion_formateada);
				}

				if (!_this.cliente) {
					_this.cerrar();
				}
			}).catch(function (e) {
				console.error(e);
				_this.$responseError(e);
			});
		},
		parseaDireccion: function parseaDireccion(direccion) {
			if (direccion.via) {
				var dir = '';
				dir = direccion.via;
				dir = direccion.numero ? dir + ', nº ' + direccion.numero : dir;
				dir = direccion.esc ? dir + ', esc. ' + direccion.esc : dir;
				dir = direccion.piso ? dir + ', ' + direccion.piso + ' piso' : dir;
				dir = direccion.puerta ? dir + ' ' + direccion.puerta : dir;
				dir = direccion.cp ? dir + '\n' + 'C.P. ' + direccion.cp : dir;
				dir = direccion.localidad ? dir + '\n' + direccion.localidad : dir;
				dir = direccion.region ? dir + '\n' + direccion.region : dir;
				dir = direccion.pais ? dir + '\n' + direccion.pais.toUpperCase() : dir;
				dir = direccion.indicaciones ? dir + '\n-\n' + direccion.indicaciones : dir;
				return dir;
			} else {
				return direccion.indicaciones;
			}
		},
		asignar: function asignar(campo, dato, indice) {
			this.$emit('asociar', { campo: campo, dato: dato });

			if (campo === 'Telefono') {
				this.telefonoSeleccionado = indice;
			} else if (campo === 'Email') {
				this.emailSeleccionado = indice;
			}
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__radiacion_colocacion_vue__ = __webpack_require__(1355);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato'],
	components: {
		colocacion: __WEBPACK_IMPORTED_MODULE_0__radiacion_colocacion_vue__["a" /* default */]
	},
	data: function data() {
		return {
			nombreMes: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiempre', 'Octubre', 'Noviembre', 'Diciembre'],
			lineaSeleccionada: null,
			ver: '',
			mesActivo: null
		};
	},
	created: function created() {
		this.mesActivo = this.meses[0];
	},

	computed: {
		opciones: function opciones() {
			var opt = {
				activoColocacion: false,
				activoInsertar: false,
				activoRotacionV: false,
				activoRotacionH: false,
				activoAnulaIns: false,
				activoRecuperaIns: false,
				activoModVarias: false
			};

			if (this.lineaSeleccionada) {
				opt.activoColocacion = true;
				opt.activoInsertar = true;
				opt.activoRotacionV = true;
				opt.activoRotacionH = true;
				opt.activoAnulaIns = true;
				opt.activoRecuperaIns = true;
			}

			return opt;
		},
		dias: function dias() {
			if (!this.mesActivo) {
				return [];
			}

			var mes = new Date(this.mesActivo.getTime());
			var mesNum = mes.getMonth();
			mes.setDate(1);
			mes.setHours(0);
			mes.setMinutes(0);
			mes.setSeconds(0);
			mes.setMilliseconds(0);

			var dias = [];
			while (mesNum === mes.getMonth()) {
				dias.push(new Date(mes.getTime()));
				mes.setDate(mes.getDate() + 1);
			}

			return dias;
		},
		meses: function meses() {
			var arr = [];

			var mes = new Date(this.contrato.fecha_inicio.getTime());
			mes.setDate(1);

			while (mes.getTime() <= this.contrato.fecha_fin.getTime()) {
				arr.push(new Date(mes.getTime()));
				mes.setMonth(mes.getMonth() + 1);
			}

			return arr;
		},
		variosAnos: function variosAnos() {
			return this.meses[0].getFullYear() !== this.meses[this.meses.length - 1].getFullYear();
		}
	},

	methods: {
		seleccionaLinea: function seleccionaLinea(linea) {
			this.lineaSeleccionada = linea;
		}
	}
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['lineaContrato'],
	data: function data() {
		return {
			linea: null
		};
	},
	created: function created() {
		this.linea = this.lineaContrato;
	},

	watch: {
		lineaContrato: function lineaContrato(newVal) {
			this.linea = newVal;
		}
	},
	methods: {
		setTipoColocacion: function setTipoColocacion(tipo) {
			this.linea.tipoColocacion = tipo;
			this.$forceUpdate();
		},
		actualizar: function actualizar() {
			this.$emit('update:linea-contrato', this.linea);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__seleccion_icono__ = __webpack_require__(1364);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		SeleccionarIconos: __WEBPACK_IMPORTED_MODULE_1__seleccion_icono__["a" /* default */]
	},
	data: function data() {
		return {
			alertas: [],
			seleccionaIcono: false,
			alerta: {
				id: this.$uuid.generate(),
				Titulo: '',
				Descripcion: '',
				Icono: 'fa fa-exclamation-triangle',
				FechaInicio: new Date(),
				FechaFin: new Date()
			},
			editar: false
		};
	},
	created: function created() {
		this.getListado();
	},

	methods: {
		borrar: function borrar(ev, alerta) {
			var _this = this;

			ev.preventDefault();
			ev.stopPropagation();
			this.$http.delete('muro/php/ddd/Infrastructure/DeleteAlertaController.php?AlertaID=' + alerta.id).then(function () {
				_this.getListado();
			}).catch(function (e) {
				console.error(e);
			});
		},
		editarAlerta: function editarAlerta(alerta) {
			this.editar = true;
			this.alerta = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(alerta));
		},
		reiniciar: function reiniciar() {
			this.editar = false;
			this.alerta.id = this.$uuid.generate();
			this.alerta.Titulo = '';
			this.alerta.Descripcion = '';
			this.alerta.FechaFin = new Date();
			this.alerta.FechaInicio = new Date();
			this.alerta.Icono = 'fa fa-exclamation-triangle';
		},
		getListado: function getListado() {
			var _this2 = this;

			var inicio = new Date();
			inicio.setHours(0);
			inicio.setMinutes(0);
			inicio.setSeconds(0);
			inicio.setDate(inicio.getDate() + 1);
			var fin = new Date();
			fin.setDate(inicio.getDate() + 1);
			fin.setFullYear(fin.getFullYear() + 10);
			var form = {
				fecha_inicio: inicio,
				fecha_fin: fin
			};
			console.log(form.fecha_inicio);
			console.log(form.fecha_fin);
			this.$http.post('muro/php/ddd/Infrastructure/GetAlertasController.php', form).then(function (res) {
				_this2.alertas = res.data;
			}).catch(function (e) {
				console.error(e);
			});
		},
		guardar: function guardar() {
			var _this3 = this;

			var method = 'post';
			if (this.editar) {
				method = 'patch';
			}
			this.$http({
				method: method,
				url: 'muro/php/ddd/Infrastructure/PostAlertaController.php',
				data: this.alerta
			}).then(function () {
				_this3.reiniciar();
				_this3.getListado();
				_this3.$store.commit('toast/success', { titulo: 'Creada' });
			}).catch(function (e) {
				_this3.$alert('Error', e.response.data.error);
			});
		}
	}
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			filtro: '',
			iconos: [{
				name: 'Glass',
				id: 'glass',
				unicode: 'f000',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Music',
				id: 'music',
				unicode: 'f001',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Search',
				id: 'search',
				unicode: 'f002',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Envelope Outlined',
				id: 'envelope-o',
				unicode: 'f003',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Heart',
				id: 'heart',
				unicode: 'f004',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Star',
				id: 'star',
				unicode: 'f005',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Star Outlined',
				id: 'star-o',
				unicode: 'f006',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'User',
				id: 'user',
				unicode: 'f007',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Film',
				id: 'film',
				unicode: 'f008',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'th-large',
				id: 'th-large',
				unicode: 'f009',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'th',
				id: 'th',
				unicode: 'f00a',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'th-list',
				id: 'th-list',
				unicode: 'f00b',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'Check',
				id: 'check',
				unicode: 'f00c',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Times',
				id: 'times',
				unicode: 'f00d',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Search Plus',
				id: 'search-plus',
				unicode: 'f00e',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Search Minus',
				id: 'search-minus',
				unicode: 'f010',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Power Off',
				id: 'power-off',
				unicode: 'f011',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'signal',
				id: 'signal',
				unicode: 'f012',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'cog',
				id: 'cog',
				unicode: 'f013',
				created: 1,
				aliases: ['gear'],
				categories: ['Web Application Icons', 'Spinner Icons']
			}, {
				name: 'Trash Outlined',
				id: 'trash-o',
				unicode: 'f014',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'home',
				id: 'home',
				unicode: 'f015',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'File Outlined',
				id: 'file-o',
				unicode: 'f016',
				created: 1,
				categories: ['Text Editor Icons', 'File Type Icons']
			}, {
				name: 'Clock Outlined',
				id: 'clock-o',
				unicode: 'f017',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'road',
				id: 'road',
				unicode: 'f018',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Download',
				id: 'download',
				unicode: 'f019',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Arrow Circle Outlined Down',
				id: 'arrow-circle-o-down',
				unicode: 'f01a',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'Arrow Circle Outlined Up',
				id: 'arrow-circle-o-up',
				unicode: 'f01b',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'inbox',
				id: 'inbox',
				unicode: 'f01c',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Play Circle Outlined',
				id: 'play-circle-o',
				unicode: 'f01d',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'Repeat',
				id: 'repeat',
				unicode: 'f01e',
				created: 1,
				aliases: ['rotate-right'],
				categories: ['Text Editor Icons']
			}, {
				name: 'refresh',
				id: 'refresh',
				unicode: 'f021',
				created: 1,
				categories: ['Web Application Icons', 'Spinner Icons']
			}, {
				name: 'list-alt',
				id: 'list-alt',
				unicode: 'f022',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'lock',
				id: 'lock',
				unicode: 'f023',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'flag',
				id: 'flag',
				unicode: 'f024',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'headphones',
				id: 'headphones',
				unicode: 'f025',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'volume-off',
				id: 'volume-off',
				unicode: 'f026',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'volume-down',
				id: 'volume-down',
				unicode: 'f027',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'volume-up',
				id: 'volume-up',
				unicode: 'f028',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'qrcode',
				id: 'qrcode',
				unicode: 'f029',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'barcode',
				id: 'barcode',
				unicode: 'f02a',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'tag',
				id: 'tag',
				unicode: 'f02b',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'tags',
				id: 'tags',
				unicode: 'f02c',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'book',
				id: 'book',
				unicode: 'f02d',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'bookmark',
				id: 'bookmark',
				unicode: 'f02e',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'print',
				id: 'print',
				unicode: 'f02f',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'camera',
				id: 'camera',
				unicode: 'f030',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'font',
				id: 'font',
				unicode: 'f031',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'bold',
				id: 'bold',
				unicode: 'f032',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'italic',
				id: 'italic',
				unicode: 'f033',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'text-height',
				id: 'text-height',
				unicode: 'f034',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'text-width',
				id: 'text-width',
				unicode: 'f035',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'align-left',
				id: 'align-left',
				unicode: 'f036',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'align-center',
				id: 'align-center',
				unicode: 'f037',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'align-right',
				id: 'align-right',
				unicode: 'f038',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'align-justify',
				id: 'align-justify',
				unicode: 'f039',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'list',
				id: 'list',
				unicode: 'f03a',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'Outdent',
				id: 'outdent',
				unicode: 'f03b',
				created: 1,
				aliases: ['dedent'],
				categories: ['Text Editor Icons']
			}, {
				name: 'Indent',
				id: 'indent',
				unicode: 'f03c',
				created: 1,
				categories: ['Text Editor Icons']
			}, {
				name: 'Video Camera',
				id: 'video-camera',
				unicode: 'f03d',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Picture Outlined',
				id: 'picture-o',
				unicode: 'f03e',
				created: 1,
				aliases: ['photo', 'image'],
				categories: ['Web Application Icons']
			}, {
				name: 'pencil',
				id: 'pencil',
				unicode: 'f040',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'map-marker',
				id: 'map-marker',
				unicode: 'f041',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'adjust',
				id: 'adjust',
				unicode: 'f042',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'tint',
				id: 'tint',
				unicode: 'f043',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Pencil Square Outlined',
				id: 'pencil-square-o',
				unicode: 'f044',
				created: 1,
				aliases: ['edit'],
				categories: ['Web Application Icons']
			}, {
				name: 'Share Square Outlined',
				id: 'share-square-o',
				unicode: 'f045',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Check Square Outlined',
				id: 'check-square-o',
				unicode: 'f046',
				created: 1,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Arrows',
				id: 'arrows',
				unicode: 'f047',
				created: 1,
				categories: ['Web Application Icons', 'Directional Icons']
			}, {
				name: 'step-backward',
				id: 'step-backward',
				unicode: 'f048',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'fast-backward',
				id: 'fast-backward',
				unicode: 'f049',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'backward',
				id: 'backward',
				unicode: 'f04a',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'play',
				id: 'play',
				unicode: 'f04b',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'pause',
				id: 'pause',
				unicode: 'f04c',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'stop',
				id: 'stop',
				unicode: 'f04d',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'forward',
				id: 'forward',
				unicode: 'f04e',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'fast-forward',
				id: 'fast-forward',
				unicode: 'f050',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'step-forward',
				id: 'step-forward',
				unicode: 'f051',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'eject',
				id: 'eject',
				unicode: 'f052',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'chevron-left',
				id: 'chevron-left',
				unicode: 'f053',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'chevron-right',
				id: 'chevron-right',
				unicode: 'f054',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'Plus Circle',
				id: 'plus-circle',
				unicode: 'f055',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Minus Circle',
				id: 'minus-circle',
				unicode: 'f056',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Times Circle',
				id: 'times-circle',
				unicode: 'f057',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Check Circle',
				id: 'check-circle',
				unicode: 'f058',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Question Circle',
				id: 'question-circle',
				unicode: 'f059',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Info Circle',
				id: 'info-circle',
				unicode: 'f05a',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Crosshairs',
				id: 'crosshairs',
				unicode: 'f05b',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Times Circle Outlined',
				id: 'times-circle-o',
				unicode: 'f05c',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Check Circle Outlined',
				id: 'check-circle-o',
				unicode: 'f05d',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'ban',
				id: 'ban',
				unicode: 'f05e',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'arrow-left',
				id: 'arrow-left',
				unicode: 'f060',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'arrow-right',
				id: 'arrow-right',
				unicode: 'f061',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'arrow-up',
				id: 'arrow-up',
				unicode: 'f062',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'arrow-down',
				id: 'arrow-down',
				unicode: 'f063',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'Share',
				id: 'share',
				unicode: 'f064',
				created: 1,
				aliases: ['mail-forward'],
				categories: ['Web Application Icons']
			}, {
				name: 'Expand',
				id: 'expand',
				unicode: 'f065',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'Compress',
				id: 'compress',
				unicode: 'f066',
				created: 1,
				categories: ['Video Player Icons']
			}, {
				name: 'plus',
				id: 'plus',
				unicode: 'f067',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'minus',
				id: 'minus',
				unicode: 'f068',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'asterisk',
				id: 'asterisk',
				unicode: 'f069',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Exclamation Circle',
				id: 'exclamation-circle',
				unicode: 'f06a',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'gift',
				id: 'gift',
				unicode: 'f06b',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'leaf',
				id: 'leaf',
				unicode: 'f06c',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'fire',
				id: 'fire',
				unicode: 'f06d',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Eye',
				id: 'eye',
				unicode: 'f06e',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Eye Slash',
				id: 'eye-slash',
				unicode: 'f070',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Exclamation Triangle',
				id: 'exclamation-triangle',
				unicode: 'f071',
				created: 1,
				aliases: ['warning'],
				categories: ['Web Application Icons']
			}, {
				name: 'plane',
				id: 'plane',
				unicode: 'f072',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'calendar',
				id: 'calendar',
				unicode: 'f073',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'random',
				id: 'random',
				unicode: 'f074',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'comment',
				id: 'comment',
				unicode: 'f075',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'magnet',
				id: 'magnet',
				unicode: 'f076',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'chevron-up',
				id: 'chevron-up',
				unicode: 'f077',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'chevron-down',
				id: 'chevron-down',
				unicode: 'f078',
				created: 1,
				categories: ['Directional Icons']
			}, {
				name: 'retweet',
				id: 'retweet',
				unicode: 'f079',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'shopping-cart',
				id: 'shopping-cart',
				unicode: 'f07a',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Folder',
				id: 'folder',
				unicode: 'f07b',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Folder Open',
				id: 'folder-open',
				unicode: 'f07c',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Arrows Vertical',
				id: 'arrows-v',
				unicode: 'f07d',
				created: 1,
				categories: ['Web Application Icons', 'Directional Icons']
			}, {
				name: 'Arrows Horizontal',
				id: 'arrows-h',
				unicode: 'f07e',
				created: 1,
				categories: ['Web Application Icons', 'Directional Icons']
			}, {
				name: 'Bar Chart Outlined',
				id: 'bar-chart-o',
				unicode: 'f080',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Twitter Square',
				id: 'twitter-square',
				unicode: 'f081',
				created: 1,
				categories: ['Brand Icons']
			}, {
				name: 'Facebook Square',
				id: 'facebook-square',
				unicode: 'f082',
				created: 1,
				categories: ['Brand Icons']
			}, {
				name: 'camera-retro',
				id: 'camera-retro',
				unicode: 'f083',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'key',
				id: 'key',
				unicode: 'f084',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'cogs',
				id: 'cogs',
				unicode: 'f085',
				created: 1,
				aliases: ['gears'],
				categories: ['Web Application Icons']
			}, {
				name: 'comments',
				id: 'comments',
				unicode: 'f086',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Thumbs Up Outlined',
				id: 'thumbs-o-up',
				unicode: 'f087',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Thumbs Down Outlined',
				id: 'thumbs-o-down',
				unicode: 'f088',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'star-half',
				id: 'star-half',
				unicode: 'f089',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Heart Outlined',
				id: 'heart-o',
				unicode: 'f08a',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Sign Out',
				id: 'sign-out',
				unicode: 'f08b',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'LinkedIn Square',
				id: 'linkedin-square',
				unicode: 'f08c',
				created: 1,
				categories: ['Brand Icons']
			}, {
				name: 'Thumb Tack',
				id: 'thumb-tack',
				unicode: 'f08d',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'External Link',
				id: 'external-link',
				unicode: 'f08e',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Sign In',
				id: 'sign-in',
				unicode: 'f090',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'trophy',
				id: 'trophy',
				unicode: 'f091',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'GitHub Square',
				id: 'github-square',
				unicode: 'f092',
				created: 1,
				categories: ['Brand Icons']
			}, {
				name: 'Upload',
				id: 'upload',
				unicode: 'f093',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Lemon Outlined',
				id: 'lemon-o',
				unicode: 'f094',
				created: 1,
				categories: ['Web Application Icons']
			}, {
				name: 'Phone',
				id: 'phone',
				unicode: 'f095',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Square Outlined',
				id: 'square-o',
				unicode: 'f096',
				created: 2,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Bookmark Outlined',
				id: 'bookmark-o',
				unicode: 'f097',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Phone Square',
				id: 'phone-square',
				unicode: 'f098',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Twitter',
				id: 'twitter',
				unicode: 'f099',
				created: 2,
				categories: ['Brand Icons']
			}, {
				name: 'Facebook',
				id: 'facebook',
				unicode: 'f09a',
				created: 2,
				categories: ['Brand Icons']
			}, {
				name: 'GitHub',
				id: 'github',
				unicode: 'f09b',
				created: 2,
				categories: ['Brand Icons']
			}, {
				name: 'unlock',
				id: 'unlock',
				unicode: 'f09c',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'credit-card',
				id: 'credit-card',
				unicode: 'f09d',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'rss',
				id: 'rss',
				unicode: 'f09e',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'HDD',
				id: 'hdd-o',
				unicode: 'f0a0',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'bullhorn',
				id: 'bullhorn',
				unicode: 'f0a1',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'bell',
				id: 'bell',
				unicode: 'f0f3',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'certificate',
				id: 'certificate',
				unicode: 'f0a3',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Hand Outlined Right',
				id: 'hand-o-right',
				unicode: 'f0a4',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Hand Outlined Left',
				id: 'hand-o-left',
				unicode: 'f0a5',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Hand Outlined Up',
				id: 'hand-o-up',
				unicode: 'f0a6',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Hand Outlined Down',
				id: 'hand-o-down',
				unicode: 'f0a7',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Arrow Circle Left',
				id: 'arrow-circle-left',
				unicode: 'f0a8',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Arrow Circle Right',
				id: 'arrow-circle-right',
				unicode: 'f0a9',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Arrow Circle Up',
				id: 'arrow-circle-up',
				unicode: 'f0aa',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Arrow Circle Down',
				id: 'arrow-circle-down',
				unicode: 'f0ab',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Globe',
				id: 'globe',
				unicode: 'f0ac',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Wrench',
				id: 'wrench',
				unicode: 'f0ad',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Tasks',
				id: 'tasks',
				unicode: 'f0ae',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Filter',
				id: 'filter',
				unicode: 'f0b0',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Briefcase',
				id: 'briefcase',
				unicode: 'f0b1',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Arrows Alt',
				id: 'arrows-alt',
				unicode: 'f0b2',
				created: 2,
				categories: ['Video Player Icons', 'Directional Icons']
			}, {
				name: 'Users',
				id: 'users',
				unicode: 'f0c0',
				created: 2,
				aliases: ['group'],
				categories: ['Web Application Icons']
			}, {
				name: 'Link',
				id: 'link',
				unicode: 'f0c1',
				created: 2,
				aliases: ['chain'],
				categories: ['Text Editor Icons']
			}, {
				name: 'Cloud',
				id: 'cloud',
				unicode: 'f0c2',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Flask',
				id: 'flask',
				unicode: 'f0c3',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Scissors',
				id: 'scissors',
				unicode: 'f0c4',
				created: 2,
				aliases: ['cut'],
				categories: ['Text Editor Icons']
			}, {
				name: 'Files Outlined',
				id: 'files-o',
				unicode: 'f0c5',
				created: 2,
				aliases: ['copy'],
				categories: ['Text Editor Icons']
			}, {
				name: 'Paperclip',
				id: 'paperclip',
				unicode: 'f0c6',
				created: 2,
				categories: ['Text Editor Icons']
			}, {
				name: 'Floppy Outlined',
				id: 'floppy-o',
				unicode: 'f0c7',
				created: 2,
				aliases: ['save'],
				categories: ['Text Editor Icons']
			}, {
				name: 'Square',
				id: 'square',
				unicode: 'f0c8',
				created: 2,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Bars',
				id: 'bars',
				unicode: 'f0c9',
				created: 2,
				aliases: ['navicon', 'reorder'],
				categories: ['Web Application Icons']
			}, {
				name: 'list-ul',
				id: 'list-ul',
				unicode: 'f0ca',
				created: 2,
				categories: ['Text Editor Icons']
			}, {
				name: 'list-ol',
				id: 'list-ol',
				unicode: 'f0cb',
				created: 2,
				categories: ['Text Editor Icons']
			}, {
				name: 'Strikethrough',
				id: 'strikethrough',
				unicode: 'f0cc',
				created: 2,
				categories: ['Text Editor Icons']
			}, {
				name: 'Underline',
				id: 'underline',
				unicode: 'f0cd',
				created: 2,
				categories: ['Text Editor Icons']
			}, {
				name: 'table',
				id: 'table',
				unicode: 'f0ce',
				created: 2,
				categories: ['Text Editor Icons']
			}, {
				name: 'magic',
				id: 'magic',
				unicode: 'f0d0',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'truck',
				id: 'truck',
				unicode: 'f0d1',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Pinterest',
				id: 'pinterest',
				unicode: 'f0d2',
				created: 2,
				categories: ['Brand Icons']
			}, {
				name: 'Pinterest Square',
				id: 'pinterest-square',
				unicode: 'f0d3',
				created: 2,
				categories: ['Brand Icons']
			}, {
				name: 'Google Plus Square',
				id: 'google-plus-square',
				unicode: 'f0d4',
				created: 2,
				categories: ['Brand Icons']
			}, {
				name: 'Google Plus',
				id: 'google-plus',
				unicode: 'f0d5',
				created: 2,
				categories: ['Brand Icons']
			}, {
				name: 'Money',
				id: 'money',
				unicode: 'f0d6',
				created: 2,
				categories: ['Web Application Icons', 'Currency Icons']
			}, {
				name: 'Caret Down',
				id: 'caret-down',
				unicode: 'f0d7',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Caret Up',
				id: 'caret-up',
				unicode: 'f0d8',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Caret Left',
				id: 'caret-left',
				unicode: 'f0d9',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Caret Right',
				id: 'caret-right',
				unicode: 'f0da',
				created: 2,
				categories: ['Directional Icons']
			}, {
				name: 'Columns',
				id: 'columns',
				unicode: 'f0db',
				created: 2,
				categories: ['Text Editor Icons']
			}, {
				name: 'Sort',
				id: 'sort',
				unicode: 'f0dc',
				created: 2,
				aliases: ['unsorted'],
				categories: ['Web Application Icons']
			}, {
				name: 'Sort Descending',
				id: 'sort-desc',
				unicode: 'f0dd',
				created: 2,
				aliases: ['sort-down'],
				categories: ['Web Application Icons']
			}, {
				name: 'Sort Ascending',
				id: 'sort-asc',
				unicode: 'f0de',
				created: 2,
				aliases: ['sort-up'],
				categories: ['Web Application Icons']
			}, {
				name: 'Envelope',
				id: 'envelope',
				unicode: 'f0e0',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'LinkedIn',
				id: 'linkedin',
				unicode: 'f0e1',
				created: 2,
				categories: ['Brand Icons']
			}, {
				name: 'Undo',
				id: 'undo',
				unicode: 'f0e2',
				created: 2,
				aliases: ['rotate-left'],
				categories: ['Text Editor Icons']
			}, {
				name: 'Gavel',
				id: 'gavel',
				unicode: 'f0e3',
				created: 2,
				aliases: ['legal'],
				categories: ['Web Application Icons']
			}, {
				name: 'Tachometer',
				id: 'tachometer',
				unicode: 'f0e4',
				created: 2,
				aliases: ['dashboard'],
				categories: ['Web Application Icons']
			}, {
				name: 'comment-o',
				id: 'comment-o',
				unicode: 'f0e5',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'comments-o',
				id: 'comments-o',
				unicode: 'f0e6',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Lightning Bolt',
				id: 'bolt',
				unicode: 'f0e7',
				created: 2,
				aliases: ['flash'],
				categories: ['Web Application Icons']
			}, {
				name: 'Sitemap',
				id: 'sitemap',
				unicode: 'f0e8',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Umbrella',
				id: 'umbrella',
				unicode: 'f0e9',
				created: 2,
				categories: ['Web Application Icons']
			}, {
				name: 'Clipboard',
				id: 'clipboard',
				unicode: 'f0ea',
				created: 2,
				aliases: ['paste'],
				categories: ['Text Editor Icons']
			}, {
				name: 'Lightbulb Outlined',
				id: 'lightbulb-o',
				unicode: 'f0eb',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Exchange',
				id: 'exchange',
				unicode: 'f0ec',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Cloud Download',
				id: 'cloud-download',
				unicode: 'f0ed',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Cloud Upload',
				id: 'cloud-upload',
				unicode: 'f0ee',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'user-md',
				id: 'user-md',
				unicode: 'f0f0',
				created: 2,
				categories: ['Medical Icons']
			}, {
				name: 'Stethoscope',
				id: 'stethoscope',
				unicode: 'f0f1',
				created: 3,
				categories: ['Medical Icons']
			}, {
				name: 'Suitcase',
				id: 'suitcase',
				unicode: 'f0f2',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Bell Outlined',
				id: 'bell-o',
				unicode: 'f0a2',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Coffee',
				id: 'coffee',
				unicode: 'f0f4',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Cutlery',
				id: 'cutlery',
				unicode: 'f0f5',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'File Text Outlined',
				id: 'file-text-o',
				unicode: 'f0f6',
				created: 3,
				categories: ['Text Editor Icons', 'File Type Icons']
			}, {
				name: 'Building Outlined',
				id: 'building-o',
				unicode: 'f0f7',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'hospital Outlined',
				id: 'hospital-o',
				unicode: 'f0f8',
				created: 3,
				categories: ['Medical Icons']
			}, {
				name: 'ambulance',
				id: 'ambulance',
				unicode: 'f0f9',
				created: 3,
				categories: ['Medical Icons']
			}, {
				name: 'medkit',
				id: 'medkit',
				unicode: 'f0fa',
				created: 3,
				categories: ['Medical Icons']
			}, {
				name: 'fighter-jet',
				id: 'fighter-jet',
				unicode: 'f0fb',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'beer',
				id: 'beer',
				unicode: 'f0fc',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'H Square',
				id: 'h-square',
				unicode: 'f0fd',
				created: 3,
				categories: ['Medical Icons']
			}, {
				name: 'Plus Square',
				id: 'plus-square',
				unicode: 'f0fe',
				created: 3,
				categories: ['Medical Icons', 'Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Angle Double Left',
				id: 'angle-double-left',
				unicode: 'f100',
				created: 3,
				categories: ['Directional Icons']
			}, {
				name: 'Angle Double Right',
				id: 'angle-double-right',
				unicode: 'f101',
				created: 3,
				categories: ['Directional Icons']
			}, {
				name: 'Angle Double Up',
				id: 'angle-double-up',
				unicode: 'f102',
				created: 3,
				categories: ['Directional Icons']
			}, {
				name: 'Angle Double Down',
				id: 'angle-double-down',
				unicode: 'f103',
				created: 3,
				categories: ['Directional Icons']
			}, {
				name: 'angle-left',
				id: 'angle-left',
				unicode: 'f104',
				created: 3,
				categories: ['Directional Icons']
			}, {
				name: 'angle-right',
				id: 'angle-right',
				unicode: 'f105',
				created: 3,
				categories: ['Directional Icons']
			}, {
				name: 'angle-up',
				id: 'angle-up',
				unicode: 'f106',
				created: 3,
				categories: ['Directional Icons']
			}, {
				name: 'angle-down',
				id: 'angle-down',
				unicode: 'f107',
				created: 3,
				categories: ['Directional Icons']
			}, {
				name: 'Desktop',
				id: 'desktop',
				unicode: 'f108',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Laptop',
				id: 'laptop',
				unicode: 'f109',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'tablet',
				id: 'tablet',
				unicode: 'f10a',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Mobile Phone',
				id: 'mobile',
				unicode: 'f10b',
				created: 3,
				aliases: ['mobile-phone'],
				categories: ['Web Application Icons']
			}, {
				name: 'Circle Outlined',
				id: 'circle-o',
				unicode: 'f10c',
				created: 3,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'quote-left',
				id: 'quote-left',
				unicode: 'f10d',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'quote-right',
				id: 'quote-right',
				unicode: 'f10e',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Spinner',
				id: 'spinner',
				unicode: 'f110',
				created: 3,
				categories: ['Web Application Icons', 'Spinner Icons']
			}, {
				name: 'Circle',
				id: 'circle',
				unicode: 'f111',
				created: 3,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Reply',
				id: 'reply',
				unicode: 'f112',
				created: 3,
				aliases: ['mail-reply'],
				categories: ['Web Application Icons']
			}, {
				name: 'GitHub Alt',
				id: 'github-alt',
				unicode: 'f113',
				created: 3,
				categories: ['Brand Icons']
			}, {
				name: 'Folder Outlined',
				id: 'folder-o',
				unicode: 'f114',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Folder Open Outlined',
				id: 'folder-open-o',
				unicode: 'f115',
				created: 3,
				categories: ['Web Application Icons']
			}, {
				name: 'Smile Outlined',
				id: 'smile-o',
				unicode: 'f118',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Frown Outlined',
				id: 'frown-o',
				unicode: 'f119',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Meh Outlined',
				id: 'meh-o',
				unicode: 'f11a',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Gamepad',
				id: 'gamepad',
				unicode: 'f11b',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Keyboard Outlined',
				id: 'keyboard-o',
				unicode: 'f11c',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Flag Outlined',
				id: 'flag-o',
				unicode: 'f11d',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'flag-checkered',
				id: 'flag-checkered',
				unicode: 'f11e',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Terminal',
				id: 'terminal',
				unicode: 'f120',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Code',
				id: 'code',
				unicode: 'f121',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'reply-all',
				id: 'reply-all',
				unicode: 'f122',
				created: 3.1,
				aliases: ['mail-reply-all'],
				categories: ['Web Application Icons']
			}, {
				name: 'Star Half Outlined',
				id: 'star-half-o',
				unicode: 'f123',
				created: 3.1,
				aliases: ['star-half-empty', 'star-half-full'],
				categories: ['Web Application Icons']
			}, {
				name: 'location-arrow',
				id: 'location-arrow',
				unicode: 'f124',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'crop',
				id: 'crop',
				unicode: 'f125',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'code-fork',
				id: 'code-fork',
				unicode: 'f126',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Chain Broken',
				id: 'chain-broken',
				unicode: 'f127',
				created: 3.1,
				aliases: ['unlink'],
				categories: ['Text Editor Icons']
			}, {
				name: 'Question',
				id: 'question',
				unicode: 'f128',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Info',
				id: 'info',
				unicode: 'f129',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'exclamation',
				id: 'exclamation',
				unicode: 'f12a',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'superscript',
				id: 'superscript',
				unicode: 'f12b',
				created: 3.1,
				categories: ['Text Editor Icons']
			}, {
				name: 'subscript',
				id: 'subscript',
				unicode: 'f12c',
				created: 3.1,
				categories: ['Text Editor Icons']
			}, {
				name: 'eraser',
				id: 'eraser',
				unicode: 'f12d',
				created: 3.1,
				categories: ['Text Editor Icons', 'Web Application Icons']
			}, {
				name: 'Puzzle Piece',
				id: 'puzzle-piece',
				unicode: 'f12e',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'microphone',
				id: 'microphone',
				unicode: 'f130',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Microphone Slash',
				id: 'microphone-slash',
				unicode: 'f131',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'shield',
				id: 'shield',
				unicode: 'f132',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'calendar-o',
				id: 'calendar-o',
				unicode: 'f133',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'fire-extinguisher',
				id: 'fire-extinguisher',
				unicode: 'f134',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'rocket',
				id: 'rocket',
				unicode: 'f135',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'MaxCDN',
				id: 'maxcdn',
				unicode: 'f136',
				created: 3.1,
				categories: ['Brand Icons']
			}, {
				name: 'Chevron Circle Left',
				id: 'chevron-circle-left',
				unicode: 'f137',
				created: 3.1,
				categories: ['Directional Icons']
			}, {
				name: 'Chevron Circle Right',
				id: 'chevron-circle-right',
				unicode: 'f138',
				created: 3.1,
				categories: ['Directional Icons']
			}, {
				name: 'Chevron Circle Up',
				id: 'chevron-circle-up',
				unicode: 'f139',
				created: 3.1,
				categories: ['Directional Icons']
			}, {
				name: 'Chevron Circle Down',
				id: 'chevron-circle-down',
				unicode: 'f13a',
				created: 3.1,
				categories: ['Directional Icons']
			}, {
				name: 'HTML 5 Logo',
				id: 'html5',
				unicode: 'f13b',
				created: 3.1,
				categories: ['Brand Icons']
			}, {
				name: 'CSS 3 Logo',
				id: 'css3',
				unicode: 'f13c',
				created: 3.1,
				categories: ['Brand Icons']
			}, {
				name: 'Anchor',
				id: 'anchor',
				unicode: 'f13d',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Unlock Alt',
				id: 'unlock-alt',
				unicode: 'f13e',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Bullseye',
				id: 'bullseye',
				unicode: 'f140',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Ellipsis Horizontal',
				id: 'ellipsis-h',
				unicode: 'f141',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Ellipsis Vertical',
				id: 'ellipsis-v',
				unicode: 'f142',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'RSS Square',
				id: 'rss-square',
				unicode: 'f143',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Play Circle',
				id: 'play-circle',
				unicode: 'f144',
				created: 3.1,
				categories: ['Video Player Icons']
			}, {
				name: 'Ticket',
				id: 'ticket',
				unicode: 'f145',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Minus Square',
				id: 'minus-square',
				unicode: 'f146',
				created: 3.1,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Minus Square Outlined',
				id: 'minus-square-o',
				unicode: 'f147',
				created: 3.1,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Level Up',
				id: 'level-up',
				unicode: 'f148',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Level Down',
				id: 'level-down',
				unicode: 'f149',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Check Square',
				id: 'check-square',
				unicode: 'f14a',
				created: 3.1,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Pencil Square',
				id: 'pencil-square',
				unicode: 'f14b',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'External Link Square',
				id: 'external-link-square',
				unicode: 'f14c',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Share Square',
				id: 'share-square',
				unicode: 'f14d',
				created: 3.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Compass',
				id: 'compass',
				unicode: 'f14e',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Caret Square Outlined Down',
				id: 'caret-square-o-down',
				unicode: 'f150',
				created: 3.2,
				aliases: ['toggle-down'],
				categories: ['Web Application Icons', 'Directional Icons']
			}, {
				name: 'Caret Square Outlined Up',
				id: 'caret-square-o-up',
				unicode: 'f151',
				created: 3.2,
				aliases: ['toggle-up'],
				categories: ['Web Application Icons', 'Directional Icons']
			}, {
				name: 'Caret Square Outlined Right',
				id: 'caret-square-o-right',
				unicode: 'f152',
				created: 3.2,
				aliases: ['toggle-right'],
				categories: ['Web Application Icons', 'Directional Icons']
			}, {
				name: 'Euro (EUR)',
				id: 'eur',
				unicode: 'f153',
				created: 3.2,
				aliases: ['euro'],
				categories: ['Currency Icons']
			}, {
				name: 'GBP',
				id: 'gbp',
				unicode: 'f154',
				created: 3.2,
				categories: ['Currency Icons']
			}, {
				name: 'US Dollar',
				id: 'usd',
				unicode: 'f155',
				created: 3.2,
				aliases: ['dollar'],
				categories: ['Currency Icons']
			}, {
				name: 'Indian Rupee (INR)',
				id: 'inr',
				unicode: 'f156',
				created: 3.2,
				aliases: ['rupee'],
				categories: ['Currency Icons']
			}, {
				name: 'Japanese Yen (JPY)',
				id: 'jpy',
				unicode: 'f157',
				created: 3.2,
				aliases: ['cny', 'rmb', 'yen'],
				categories: ['Currency Icons']
			}, {
				name: 'Russian Ruble (RUB)',
				id: 'rub',
				unicode: 'f158',
				created: 4,
				aliases: ['ruble', 'rouble'],
				categories: ['Currency Icons']
			}, {
				name: 'Korean Won (KRW)',
				id: 'krw',
				unicode: 'f159',
				created: 3.2,
				aliases: ['won'],
				categories: ['Currency Icons']
			}, {
				name: 'Bitcoin (BTC)',
				id: 'btc',
				unicode: 'f15a',
				created: 3.2,
				aliases: ['bitcoin'],
				categories: ['Currency Icons', 'Brand Icons']
			}, {
				name: 'File',
				id: 'file',
				unicode: 'f15b',
				created: 3.2,
				categories: ['Text Editor Icons', 'File Type Icons']
			}, {
				name: 'File Text',
				id: 'file-text',
				unicode: 'f15c',
				created: 3.2,
				categories: ['Text Editor Icons', 'File Type Icons']
			}, {
				name: 'Sort Alpha Ascending',
				id: 'sort-alpha-asc',
				unicode: 'f15d',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Sort Alpha Descending',
				id: 'sort-alpha-desc',
				unicode: 'f15e',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Sort Amount Ascending',
				id: 'sort-amount-asc',
				unicode: 'f160',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Sort Amount Descending',
				id: 'sort-amount-desc',
				unicode: 'f161',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Sort Numeric Ascending',
				id: 'sort-numeric-asc',
				unicode: 'f162',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Sort Numeric Descending',
				id: 'sort-numeric-desc',
				unicode: 'f163',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'thumbs-up',
				id: 'thumbs-up',
				unicode: 'f164',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'thumbs-down',
				id: 'thumbs-down',
				unicode: 'f165',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'YouTube Square',
				id: 'youtube-square',
				unicode: 'f166',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'YouTube',
				id: 'youtube',
				unicode: 'f167',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Xing',
				id: 'xing',
				unicode: 'f168',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Xing Square',
				id: 'xing-square',
				unicode: 'f169',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'YouTube Play',
				id: 'youtube-play',
				unicode: 'f16a',
				created: 3.2,
				categories: ['Brand Icons', 'Video Player Icons']
			}, {
				name: 'Dropbox',
				id: 'dropbox',
				unicode: 'f16b',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Stack Overflow',
				id: 'stack-overflow',
				unicode: 'f16c',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Instagram',
				id: 'instagram',
				unicode: 'f16d',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Flickr',
				id: 'flickr',
				unicode: 'f16e',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'App.net',
				id: 'adn',
				unicode: 'f170',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Bitbucket',
				id: 'bitbucket',
				unicode: 'f171',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Bitbucket Square',
				id: 'bitbucket-square',
				unicode: 'f172',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Tumblr',
				id: 'tumblr',
				unicode: 'f173',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Tumblr Square',
				id: 'tumblr-square',
				unicode: 'f174',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Long Arrow Down',
				id: 'long-arrow-down',
				unicode: 'f175',
				created: 3.2,
				categories: ['Directional Icons']
			}, {
				name: 'Long Arrow Up',
				id: 'long-arrow-up',
				unicode: 'f176',
				created: 3.2,
				categories: ['Directional Icons']
			}, {
				name: 'Long Arrow Left',
				id: 'long-arrow-left',
				unicode: 'f177',
				created: 3.2,
				categories: ['Directional Icons']
			}, {
				name: 'Long Arrow Right',
				id: 'long-arrow-right',
				unicode: 'f178',
				created: 3.2,
				categories: ['Directional Icons']
			}, {
				name: 'Apple',
				id: 'apple',
				unicode: 'f179',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Windows',
				id: 'windows',
				unicode: 'f17a',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Android',
				id: 'android',
				unicode: 'f17b',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Linux',
				id: 'linux',
				unicode: 'f17c',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Dribbble',
				id: 'dribbble',
				unicode: 'f17d',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Skype',
				id: 'skype',
				unicode: 'f17e',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Foursquare',
				id: 'foursquare',
				unicode: 'f180',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Trello',
				id: 'trello',
				unicode: 'f181',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Female',
				id: 'female',
				unicode: 'f182',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Male',
				id: 'male',
				unicode: 'f183',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Gittip',
				id: 'gittip',
				unicode: 'f184',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Sun Outlined',
				id: 'sun-o',
				unicode: 'f185',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Moon Outlined',
				id: 'moon-o',
				unicode: 'f186',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Archive',
				id: 'archive',
				unicode: 'f187',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'Bug',
				id: 'bug',
				unicode: 'f188',
				created: 3.2,
				categories: ['Web Application Icons']
			}, {
				name: 'VK',
				id: 'vk',
				unicode: 'f189',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Weibo',
				id: 'weibo',
				unicode: 'f18a',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Renren',
				id: 'renren',
				unicode: 'f18b',
				created: 3.2,
				categories: ['Brand Icons']
			}, {
				name: 'Pagelines',
				id: 'pagelines',
				unicode: 'f18c',
				created: 4,
				categories: ['Brand Icons']
			}, {
				name: 'Stack Exchange',
				id: 'stack-exchange',
				unicode: 'f18d',
				created: 4,
				categories: ['Brand Icons']
			}, {
				name: 'Arrow Circle Outlined Right',
				id: 'arrow-circle-o-right',
				unicode: 'f18e',
				created: 4,
				categories: ['Directional Icons']
			}, {
				name: 'Arrow Circle Outlined Left',
				id: 'arrow-circle-o-left',
				unicode: 'f190',
				created: 4,
				categories: ['Directional Icons']
			}, {
				name: 'Caret Square Outlined Left',
				id: 'caret-square-o-left',
				unicode: 'f191',
				created: 4,
				aliases: ['toggle-left'],
				categories: ['Web Application Icons', 'Directional Icons']
			}, {
				name: 'Dot Circle O',
				id: 'dot-circle-o',
				unicode: 'f192',
				created: 4,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Wheelchair',
				id: 'wheelchair',
				unicode: 'f193',
				created: 4,
				categories: ['Web Application Icons', 'Medical Icons']
			}, {
				name: 'Vimeo Square',
				id: 'vimeo-square',
				unicode: 'f194',
				created: 4,
				categories: ['Brand Icons']
			}, {
				name: 'Turkish Lira (TRY)',
				id: 'try',
				unicode: 'f195',
				created: 4,
				aliases: ['turkish-lira'],
				categories: ['Currency Icons']
			}, {
				name: 'Plus Square Outlined',
				id: 'plus-square-o',
				unicode: 'f196',
				created: 4,
				categories: ['Web Application Icons', 'Form Control Icons']
			}, {
				name: 'Space Shuttle',
				id: 'space-shuttle',
				unicode: 'f197',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Slack Logo',
				id: 'slack',
				unicode: 'f198',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Envelope Square',
				id: 'envelope-square',
				unicode: 'f199',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Wordpress Logo',
				id: 'wordpress',
				unicode: 'f19a',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'OpenID',
				id: 'openid',
				unicode: 'f19b',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'University',
				id: 'university',
				unicode: 'f19c',
				created: 4.1,
				aliases: ['institution', 'bank'],
				categories: ['Web Application Icons']
			}, {
				name: 'Graduation Cap',
				id: 'graduation-cap',
				unicode: 'f19d',
				created: 4.1,
				aliases: ['mortar-board'],
				categories: ['Web Application Icons']
			}, {
				name: 'Yahoo Logo',
				id: 'yahoo',
				unicode: 'f19e',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Google Logo',
				id: 'google',
				unicode: 'f1a0',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'reddit Logo',
				id: 'reddit',
				unicode: 'f1a1',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'reddit Square',
				id: 'reddit-square',
				unicode: 'f1a2',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'StumbleUpon Circle',
				id: 'stumbleupon-circle',
				unicode: 'f1a3',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'StumbleUpon Logo',
				id: 'stumbleupon',
				unicode: 'f1a4',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Delicious Logo',
				id: 'delicious',
				unicode: 'f1a5',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Digg Logo',
				id: 'digg',
				unicode: 'f1a6',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Pied Piper Logo',
				id: 'pied-piper',
				unicode: 'f1a7',
				created: 4.1,
				categories: ['Brand Icons'],
				aliases: ['pied-piper-square']
			}, {
				name: 'Pied Piper Alternate Logo',
				id: 'pied-piper-alt',
				unicode: 'f1a8',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Drupal Logo',
				id: 'drupal',
				unicode: 'f1a9',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Joomla Logo',
				id: 'joomla',
				unicode: 'f1aa',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Language',
				id: 'language',
				unicode: 'f1ab',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Fax',
				id: 'fax',
				unicode: 'f1ac',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Building',
				id: 'building',
				unicode: 'f1ad',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Child',
				id: 'child',
				unicode: 'f1ae',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Paw',
				id: 'paw',
				unicode: 'f1b0',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'spoon',
				id: 'spoon',
				unicode: 'f1b1',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Cube',
				id: 'cube',
				unicode: 'f1b2',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Cubes',
				id: 'cubes',
				unicode: 'f1b3',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Behance',
				id: 'behance',
				unicode: 'f1b4',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Behance Square',
				id: 'behance-square',
				unicode: 'f1b5',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Steam',
				id: 'steam',
				unicode: 'f1b6',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Steam Square',
				id: 'steam-square',
				unicode: 'f1b7',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Recycle',
				id: 'recycle',
				unicode: 'f1b8',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Car',
				id: 'car',
				unicode: 'f1b9',
				created: 4.1,
				categories: ['Web Application Icons'],
				aliases: ['automobile']
			}, {
				name: 'Taxi',
				id: 'taxi',
				unicode: 'f1ba',
				created: 4.1,
				categories: ['Web Application Icons'],
				aliases: ['cab']
			}, {
				name: 'Tree',
				id: 'tree',
				unicode: 'f1bb',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Spotify',
				id: 'spotify',
				unicode: 'f1bc',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'deviantART',
				id: 'deviantart',
				unicode: 'f1bd',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'SoundCloud',
				id: 'soundcloud',
				unicode: 'f1be',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Database',
				id: 'database',
				unicode: 'f1c0',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'PDF File Outlined',
				id: 'file-pdf-o',
				unicode: 'f1c1',
				created: 4.1,
				categories: ['Web Application Icons', 'File Type Icons']
			}, {
				name: 'Word File Outlined',
				id: 'file-word-o',
				unicode: 'f1c2',
				created: 4.1,
				categories: ['Web Application Icons', 'File Type Icons']
			}, {
				name: 'Excel File Outlined',
				id: 'file-excel-o',
				unicode: 'f1c3',
				created: 4.1,
				categories: ['Web Application Icons', 'File Type Icons']
			}, {
				name: 'Powerpoint File Outlined',
				id: 'file-powerpoint-o',
				unicode: 'f1c4',
				created: 4.1,
				categories: ['Web Application Icons', 'File Type Icons']
			}, {
				name: 'Image File Outlined',
				id: 'file-image-o',
				unicode: 'f1c5',
				created: 4.1,
				aliases: ['file-photo-o', 'file-picture-o'],
				categories: ['Web Application Icons', 'File Type Icons']
			}, {
				name: 'Archive File Outlined',
				id: 'file-archive-o',
				unicode: 'f1c6',
				created: 4.1,
				aliases: ['file-zip-o'],
				categories: ['Web Application Icons', 'File Type Icons']
			}, {
				name: 'Audio File Outlined',
				id: 'file-audio-o',
				unicode: 'f1c7',
				created: 4.1,
				aliases: ['file-sound-o'],
				categories: ['Web Application Icons', 'File Type Icons']
			}, {
				name: 'Video File Outlined',
				id: 'file-video-o',
				unicode: 'f1c8',
				created: 4.1,
				aliases: ['file-movie-o'],
				categories: ['Web Application Icons', 'File Type Icons']
			}, {
				name: 'Code File Outlined',
				id: 'file-code-o',
				unicode: 'f1c9',
				created: 4.1,
				categories: ['Web Application Icons', 'File Type Icons']
			}, {
				name: 'Vine',
				id: 'vine',
				unicode: 'f1ca',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Codepen',
				id: 'codepen',
				unicode: 'f1cb',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'jsFiddle',
				id: 'jsfiddle',
				unicode: 'f1cc',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Life Ring',
				id: 'life-ring',
				unicode: 'f1cd',
				created: 4.1,
				aliases: ['life-bouy', 'life-saver', 'support'],
				categories: ['Web Application Icons']
			}, {
				name: 'Circle Outlined Notched',
				id: 'circle-o-notch',
				unicode: 'f1ce',
				created: 4.1,
				categories: ['Web Application Icons', 'Spinner Icons']
			}, {
				name: 'Rebel Alliance',
				id: 'rebel',
				unicode: 'f1d0',
				created: 4.1,
				aliases: ['ra'],
				categories: ['Brand Icons']
			}, {
				name: 'Galactic Empire',
				id: 'empire',
				unicode: 'f1d1',
				created: 4.1,
				aliases: ['ge'],
				categories: ['Brand Icons']
			}, {
				name: 'Git Square',
				id: 'git-square',
				unicode: 'f1d2',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Git',
				id: 'git',
				unicode: 'f1d3',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Hacker News',
				id: 'hacker-news',
				unicode: 'f1d4',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Tencent Weibo',
				id: 'tencent-weibo',
				unicode: 'f1d5',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'QQ',
				id: 'qq',
				unicode: 'f1d6',
				created: 4.1,
				categories: ['Brand Icons']
			}, {
				name: 'Weixin (WeChat)',
				id: 'weixin',
				unicode: 'f1d7',
				created: 4.1,
				aliases: ['wechat'],
				categories: ['Brand Icons']
			}, {
				name: 'Paper Plane',
				id: 'paper-plane',
				unicode: 'f1d8',
				created: 4.1,
				aliases: ['send'],
				categories: ['Web Application Icons']
			}, {
				name: 'Paper Plane Outlined',
				id: 'paper-plane-o',
				unicode: 'f1d9',
				created: 4.1,
				aliases: ['send-o'],
				categories: ['Web Application Icons']
			}, {
				name: 'History',
				id: 'history',
				unicode: 'f1da',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Circle Outlined Thin',
				id: 'circle-thin',
				unicode: 'f1db',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'header',
				id: 'header',
				unicode: 'f1dc',
				created: 4.1,
				categories: ['Text Editor Icons']
			}, {
				name: 'paragraph',
				id: 'paragraph',
				unicode: 'f1dd',
				created: 4.1,
				categories: ['Text Editor Icons']
			}, {
				name: 'Sliders',
				id: 'sliders',
				unicode: 'f1de',
				created: 4.1,
				categories: ['Web Application Icons']
			}, {
				name: 'Share Alt',
				id: 'share-alt',
				unicode: 'f1e0',
				created: 4.1,
				categories: ['Web Application Icons', 'Brand Icons']
			}, {
				name: 'Share Alt Square',
				id: 'share-alt-square',
				unicode: 'f1e1',
				created: 4.1,
				categories: ['Web Application Icons', 'Brand Icons']
			}, {
				name: 'Bomb',
				id: 'bomb',
				unicode: 'f1e2',
				created: 4.1,
				categories: ['Web Application Icons']
			}]
		};
	},

	computed: {
		listado: function listado() {
			if (!this.filtro) {
				return this.iconos;
			}
			var regexp = new RegExp(this.filtro, 'ig');
			return this.iconos.filter(function (icono) {
				return regexp.test(icono.name);
			});
		}
	},
	methods: {
		seleccionar: function seleccionar(icono) {
			this.$emit('seleccion', 'fa fa-' + icono.id);
			this.$emit('close');
		}
	}
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			filtro: {
				ano: new Date().getFullYear(),
				AgenteID: null,
				AgenteNombre: null
			},
			objetivos: {}
		};
	},

	watch: {
		'filtro.ano': function filtroAno(newVal) {
			this.objetivos = [];

			if (this.filtro.ano && this.filtro.AgenteID) {
				this.getObjetivos();
			}
		},
		'filtro.AgenteID': function filtroAgenteID(newVal) {
			this.objetivos = [];
			if (this.filtro.ano && this.filtro.AgenteID) {
				this.getObjetivos();
			}
		}
	},
	methods: {
		total: function total(sop) {
			var suma = sop.meses.reduce(function (ant, actual) {
				ant = ant + actual;
				return ant;
			}, 0);
			return suma;
		},
		seleccionaAgente: function seleccionaAgente(ev) {
			this.filtro.AgenteID = ev.datos.ID;
			this.filtro.AgenteNombre = ev.texto;
		},
		getObjetivos: function getObjetivos() {
			var _this = this;

			var form = {
				ano: this.filtro.ano,
				AgenteID: this.filtro.AgenteID
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('objetivos-agentes/php/api/get.php', form).then(function (res) {
				_this.objetivos = res.data;
			}).catch(function (e) {
				console.error(e);
			});
		},
		asignarSoporte: function asignarSoporte(soporte, mes, ev) {
			var _this2 = this;

			var importe = parseFloat(ev.target.value);
			if (typeof importe !== 'number') {
				importe = 0;
			}

			if (!importe) {
				importe = 0;
			}
			var form = {
				SoporteID: soporte.SoporteID,
				mes: mes,
				importe: importe,
				ano: this.filtro.ano,
				AgenteID: this.filtro.AgenteID
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('objetivos-agentes/php/api/setSoporte.php', form).catch(function (e) {
				_this2.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: 'Error guardando el objetivo'
				});
			});
		},
		asignarPartida: function asignarPartida(partida, mes, ev) {
			var _this3 = this;

			var importe = parseFloat(ev.target.value);
			if (typeof importe !== 'number') {
				importe = 0;
			}

			if (!importe) {
				importe = 0;
			}
			var form = {
				PartidaID: partida.PartidaID,
				mes: mes,
				importe: importe,
				ano: this.filtro.ano,
				AgenteID: this.filtro.AgenteID
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('objetivos-agentes/php/api/setPartida.php', form).catch(function (e) {
				_this3.$store.commit('toast/danger', {
					titulo: 'Error',
					mensaje: 'Error guardando el objetivo'
				});
			});
		}
	}
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			menu: [{
				url: '/main/organizar-emisoras/opcion-a',
				nombre: 'Opcion A',
				icono: 'fa fa-cube'
			}, {
				url: '/main/organizar-emisoras/opcion-b',
				nombre: 'Opcion B',
				icono: 'fa fa-cube'
			}]
		};
	}
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arbol_buzones__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objetos_buzon_vue__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bloques_vue__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parrilla_vue__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__componentes_reproductor_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__favoritos_vue__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__busqueda_global_vue__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'arbol-buzones': __WEBPACK_IMPORTED_MODULE_1__arbol_buzones__["a" /* default */],
		'objetos-buzon': __WEBPACK_IMPORTED_MODULE_2__objetos_buzon_vue__["a" /* default */],
		'bloques': __WEBPACK_IMPORTED_MODULE_3__bloques_vue__["a" /* default */],
		'parrilla': __WEBPACK_IMPORTED_MODULE_4__parrilla_vue__["a" /* default */],
		'reproductor': __WEBPACK_IMPORTED_MODULE_5__componentes_reproductor_vue__["a" /* default */],
		'favoritos': __WEBPACK_IMPORTED_MODULE_6__favoritos_vue__["a" /* default */],
		'busqueda-global': __WEBPACK_IMPORTED_MODULE_7__busqueda_global_vue__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: null,
			actualizarBloques: false,
			busquedaGlobal: false,
			insercionActiva: null,
			inserciones: [],
			objetosInsertar: [],
			arrastrando: null,
			buzonActivo: null,
			listadoEmisoras: [],
			listadoBuzones: [],
			reproducir: null
		};
	},
	created: function created() {
		this.filtro = this.filtroStore;
		this.getListadoEmisoras();
		this.getFavoritos();
		if (!this.bloqueActivo) {
			this.getBuzones();
		}
	},
	mounted: function mounted() {
		window.addEventListener('resize', this.calculaAlto);
		this.calculaAlto();
	},

	watch: {
		bloqueActivo: function bloqueActivo(newVal) {
			if (newVal) {
				this.getParrilla(this.filtroPost);
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["e" /* mapState */])({
		'bloqueActivo': function bloqueActivo(state) {
			return state['organizar-emisoras'].bloqueActivo;
		},
		'filtroStore': function filtroStore(state) {
			return state['organizar-emisoras'].filtro;
		}
	}), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])({
		'ocultarBloquesVacios': 'organizar-emisoras/omitirBloquesSinMatricula'
	}), {
		imagenEmisora: function imagenEmisora() {
			var _this = this;

			if (this.EmisoraID && this.listadoEmisoras.length > 0) {
				var emisora = this.listadoEmisoras.filter(function (e) {
					return e.xframe_ID === _this.EmisoraID;
				})[0];
				return emisora.logotipo || null;
			}
			return null;
		},

		EmisoraID: {
			get: function get() {
				return this.filtroStore.EmisoraID;
			},
			set: function set(data) {
				this.setFiltro({ EmisoraID: data });
			}
		},
		dia: {
			get: function get() {
				return new Date(this.filtroStore.dia * 1000);
			},
			set: function set(value) {
				this.setFiltro({ dia: Math.round(value.getTime() / 1000) });
			}
		},
		buscaInsercion: {
			get: function get() {
				return this.filtroStore.buscaInsercion;
			},
			set: function set(value) {
				this.setFiltro({ buscaInsercion: value });
			}
		},
		filtroPost: function filtroPost() {
			if (!this.filtro || !this.filtro.EmisoraID || !this.filtro.dia) {
				return {};
			}
			return {
				EmisoraID: this.filtro.EmisoraID,
				dia: Math.round(this.filtro.dia.getTime() / 1000),
				BloqueID: this.bloqueActivo ? this.bloqueActivo.BloqueID : null
			};
		}
	}),
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])({
		getBloques: 'organizar-emisoras/getBloques',
		getParrilla: 'organizar-emisoras/getParrilla',
		getFavoritos: 'organizar-emisoras/getBuzonesFavoritos',
		setFiltro: 'organizar-emisoras/setFiltro',
		buscarInserciones: 'organizar-emisoras/buscarInserciones'
	}), Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["d" /* mapMutations */])({
		toggleOmitir: 'organizar-emisoras/TOGGLE_SIN_MATRICULA'
	}), {
		calculaAlto: function calculaAlto() {
			var el = this.$refs.contenedor;
			var offsetTop = this.$refs.contenedor.offsetTop;
			while (el.parentElement) {
				el = el.parentElement;
				offsetTop += el.offsetTop;
			}
			var alto = window.innerHeight - offsetTop;

			this.$refs.contenedor.style.height = alto + 'px';
		},
		cambiaDia: function cambiaDia(dia) {
			var diaActual = new Date(this.dia.getTime());
			diaActual.setDate(diaActual.getDate() + dia);
			this.dia = diaActual;
		},
		getBuzones: function getBuzones() {
			var _this2 = this;

			this.$http.get('organizar-emisoras/php/api/get-arbol-buzones.php').then(function (res) {
				_this2.listadoBuzones = res.data.listado;
			}).catch(this.$responseError);
		},
		seleccionaBuzon: function seleccionaBuzon(e) {
			if (this.buzonActivo === e) return;
			this.buzonActivo = e;
		},
		_getEstilo: function _getEstilo(Color) {
			var hex = Color.toString(16);
			var reverse = function reverse(str) {
				return str === '' ? '' : reverse(str.substr(1)) + str.charAt(0);
			};
			hex = reverse(hex);

			// Calculamos si la cadena es de 6
			while (hex.length < 6) {
				hex = hex + '0';
			}

			hex = hex === '000000' ? 'ffffff' : hex;
			var getContrastYIQ = function getContrastYIQ(r, g, b, opacidad) {
				opacidad = 1 + opacidad;
				var yiq = (r * 299 * opacidad + g * 587 * opacidad + b * 114 * opacidad) / 1000;
				return yiq >= 128 ? 'black' : 'white';
			};

			hex = hex.replace('#', '');
			var r = parseInt(hex.substring(0, 2), 16);
			var g = parseInt(hex.substring(2, 4), 16);
			var b = parseInt(hex.substring(4, 6), 16);
			var opacidad = 0.6;

			hex = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacidad + ')';

			return {
				backgroundColor: hex,
				color: getContrastYIQ(r, g, b, opacidad)
			};
		},
		getListadoEmisoras: function getListadoEmisoras() {
			var _this3 = this;

			this.$http.get('organizar-emisoras/php/api/get-emisoras.php').then(function (res) {
				_this3.listadoEmisoras = res.data.listado;
			}).catch(this.$responseError);
		}
	})
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arbol_buzones_vue__ = __webpack_require__(586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f07cb700_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_arbol_buzones_vue__ = __webpack_require__(1378);
function injectStyle (ssrContext) {
  __webpack_require__(1377)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f07cb700"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arbol_buzones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f07cb700_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_arbol_buzones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arbol_buzones_vue__ = __webpack_require__(585);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'arbol-buzones',
	components: {
		'arbol-buzones': __WEBPACK_IMPORTED_MODULE_0__arbol_buzones_vue__["a" /* default */]
	},
	props: ['listado', 'nivel', 'activo'],
	data: function data() {
		return {
			expandir: []
		};
	},

	computed: {
		estilo: function estilo() {
			return {
				paddingLeft: 5 + this.nivel * 10 + 'px',
				cursor: 'default'
			};
		}
	},
	methods: {
		toggleExpandir: function toggleExpandir(e, BuzonID) {
			e.preventDefault();
			e.stopPropagation();
			var idx = this.expandir.indexOf(BuzonID);

			if (idx >= 0) {
				this.expandir.splice(idx, 1);
			} else {
				this.expandir.push(BuzonID);
			}
		},
		estiloBuzon: function estiloBuzon(buzon) {
			var hex = buzon.Color.toString(16);
			var reverse = function reverse(str) {
				return str === '' ? '' : reverse(str.substr(1)) + str.charAt(0);
			};
			hex = reverse(hex);

			// Calculamos si la cadena es de 6
			while (hex.length < 6) {
				hex = hex + '0';
			}
			hex = hex.toLowerCase() === 'ffffff' ? '000000' : hex;
			return {
				color: '#' + hex
			};
		},
		selecciona: function selecciona(buzon) {
			this.$emit('select', buzon);
		}
	}
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['bloque', 'buzon'],
	data: function data() {
		return {
			ficheros: [],
			ordenar: {
				campo: 'ObjetoDescripcion',
				asc: true
			},
			teclas: {
				ctrl: false,
				shift: false
			},
			filtroNombre: '',
			filtroSegundos: null,
			indice: 0,
			objetoActivo: null,
			seleccion: []
		};
	},

	watch: {
		buzon: function buzon(newVal, oldVal) {
			// Consultamos los ficheros del buzón
			if (newVal !== oldVal && newVal !== null) {
				this.getFicheros();
			}
		}
	},
	created: function created() {
		if (this.buzon) {
			this.getFicheros();
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		parrilla: 'organizar-emisoras/insercionesParrilla'
	}), {
		listaFicheros: function listaFicheros() {
			var _this = this;

			if (!this.ficheros) {
				return [];
			}
			var arr = [].concat(this.ficheros);
			if (this.filtroNombre) {
				var reg = new RegExp(this.filtroNombre, 'ig');
				arr = arr.filter(function (fichero) {
					if (typeof fichero.ObjetoDescripcion === 'string') {
						return fichero.ObjetoDescripcion.match(reg);
					}
					return false;
				});
			}
			if (this.filtroSegundos > 0) {
				arr = arr.filter(function (f) {
					return Math.round(f.DuracionFisica / 10000000) === _this.filtroSegundos;
				});
			}

			arr.sort(function (a, b) {
				if (a[_this.ordenar.campo]) {
					if (a[_this.ordenar.campo] > b[_this.ordenar.campo]) {
						return _this.ordenar.asc ? 1 : -1;
					} else {
						return _this.ordenar.asc ? -1 : 1;
					}
				} else {
					return 1;
				}
			});

			return arr.splice(0, 500);
		}
	}),
	methods: {
		getFicheros: function getFicheros() {
			var _this2 = this;

			this.ficheros = [];
			this.indice = null;
			if (!this.buzon) {
				return;
			}
			this.$http.post('organizar-emisoras/php/api/get-objetos-buzon.php?BuzonID=' + this.buzon.BuzonID).then(function (res) {
				_this2.ficheros = res.data.listado.map(function (fichero) {
					fichero.style = _this2._getEstilo(fichero.BuzonColor);
					return fichero;
				});

				if (_this2.ficheros.length > 0) {
					_this2.indice = 0;
				}
			}).catch(this.$responseError);
		},
		teclaAbajo: function teclaAbajo(e) {
			if (e.keyCode !== 9) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;
			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(this.indice + 1);
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(this.indice - 1);
			} else if (e.keyCode === 32) {
				if (this.seleccion.length > 0) {
					this.$emit('reproducir', this.seleccion[0].ObjetoID);
				}
			} else if (e.keyCode === 35) {
				// Fin
				this.seleccionaIndice(this.listaFicheros.length - 1);
			} else if (e.keyCode === 36) {
				// Inicio
				this.seleccionaIndice(0);
			} else if (e.keyCode === 34) {
				// Av pag
				if (this.listaFicheros.length > 0) {
					var altoContainer = this.$refs.tablaContainer.offsetHeight;
					var altoElemento = this.$refs['objeto' + this.listaFicheros[0].ObjetoID][0].offsetHeight;

					// Cuantos caben por "página"
					var num = Math.floor(altoContainer / altoElemento);
					var indiceActual = this.listaFicheros.indexOf(this.seleccion[0]);
					var indiceFinal = this.listaFicheros[indiceActual + num] ? indiceActual + num : this.listaFicheros.length - 1;
					this.seleccion = [this.listaFicheros[indiceFinal]];
					this.$refs['objeto' + this.seleccion[0].ObjetoID][0].scrollIntoView({ block: 'end', behavior: 'instant' });
				}
			} else if (e.keyCode === 33) {
				// arr pag
				if (this.listaFicheros.length > 0) {
					var _altoContainer = this.$refs.tablaContainer.offsetHeight;
					var _altoElemento = this.$refs['objeto' + this.listaFicheros[0].ObjetoID][0].offsetHeight;

					// Cuantos caben por "página"
					var _num = Math.floor(_altoContainer / _altoElemento);
					var _indiceActual = this.listaFicheros.indexOf(this.seleccion[0]);
					var _indiceFinal = _indiceActual - _num >= 0 ? _indiceActual - _num : 0;
					this.seleccion = [this.listaFicheros[_indiceFinal]];
					this.$refs['objeto' + this.seleccion[0].ObjetoID][0].scrollIntoView({ block: 'end', behavior: 'instant' });
				}
			} else {
				console.log(e.keyCode);
			}
		},
		teclaArriba: function teclaArriba(e) {
			e.preventDefault();
			e.stopPropagation();
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;
		},
		setOrdenBuzon: function setOrdenBuzon(campo) {
			if (this.ordenar.campo === campo) {
				this.ordenar.asc = !this.ordenar.asc;
			} else {
				this.ordenar.campo = campo;
				this.ordenar.asc = true;
			}
		},
		seleccionaIndice: function seleccionaIndice(i) {
			var tamano = this.listaFicheros.length;
			this.indice = i >= tamano ? 0 : i < 0 ? tamano - 1 : i;
			this.seleccion = [this.listaFicheros[this.indice]];
			this.$refs['objeto' + this.seleccion[0].ObjetoID][0].scrollIntoView({ block: 'end', behavior: 'instant' });
		},
		agregarObjetos: function agregarObjetos(objeto) {
			this.$store.dispatch('organizar-emisoras/programarInserciones', {
				ficheros: [objeto.ObjetoID],
				posicion: this.parrilla.length > 0 ? this.parrilla[this.parrilla.length - 1].ProgramacionOrden + 1 : 1
			});
		},
		seleccionaObjeto: function seleccionaObjeto(objeto) {
			this.objetoActivo = objeto;
			if (this.teclas.ctrl) {
				var idx = this.seleccion.indexOf(objeto);
				if (idx >= 0) {
					this.seleccion.splice(idx, 1);
				} else {
					this.seleccion.push(objeto);
				}
			} else if (this.teclas.shift) {
				if (this.seleccion.length === 0) {
					this.seleccion = [objeto];
				} else {
					// Hayamos el índice más bajo de la selección
					var indiceSeleccion = this.listaFicheros.indexOf(objeto);
					var ind = null;
					for (var i = 0; i < this.seleccion.length; i++) {
						var e = this.listaFicheros.indexOf(this.seleccion[i]);
						ind = ind === null || e < ind ? e : ind;
					}

					// Ahora comprobamos si es mayor que el seleccionado
					var primero = ind > indiceSeleccion ? indiceSeleccion : ind;
					var ultimo = ind > indiceSeleccion ? ind : indiceSeleccion;

					this.seleccion = [];

					for (var p = primero; p <= ultimo; p++) {
						this.seleccion.push(this.listaFicheros[p]);
					}
				}
			} else {
				this.seleccion = [objeto];
			}

			this.indice = this.listaFicheros.indexOf(objeto);
		},
		arrastraObjeto: function arrastraObjeto(e, objeto) {
			if (this.seleccion.indexOf(objeto) < 0) {
				this.seleccionaObjeto(objeto);
			}
			e.dataTransfer.setData('text/json', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.seleccion));
		},
		menuContextual: function menuContextual(e, objeto) {
			var _this3 = this;

			e.preventDefault();
			e.stopPropagation();
			if (this.seleccion.indexOf(objeto) < 0) {
				this.seleccionaObjeto(objeto);
			}
			var menu = {
				titulo: 'Acciones',
				evento: e,
				items: []
			};

			menu.items.push({
				texto: 'Reproducir',
				icono: 'fa fa-play',
				activo: true,
				callback: function callback() {
					_this3.$emit('reproducir', objeto.ObjetoID);
				}
			});

			menu.items.push({
				texto: 'Insertar',
				icono: 'fa fa-plus',
				activo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.bloque) === 'object',
				callback: function callback() {
					_this3.$store.dispatch('organizar-emisoras/programarInserciones', {
						ficheros: _this3.seleccion.map(function (o) {
							return o.ObjetoID;
						}),
						posicion: _this3.parrilla.length > 0 ? _this3.parrilla[_this3.parrilla.length - 1].ProgramacionOrden + 1 : 1
					});
				}
			});

			this.$store.commit('contextual/mostrar', menu);
		},


		// MÉTODOS PRIVADOS
		_getEstilo: function _getEstilo(Color) {
			var hex = Color.toString(16);
			var reverse = function reverse(str) {
				return str === '' ? '' : reverse(str.substr(1)) + str.charAt(0);
			};
			hex = reverse(hex);

			// Calculamos si la cadena es de 6
			while (hex.length < 6) {
				hex = hex + '0';
			}

			hex = hex === '000000' ? 'ffffff' : hex;
			var getContrastYIQ = function getContrastYIQ(r, g, b, opacidad) {
				opacidad = 1 + opacidad;
				var yiq = (r * 299 * opacidad + g * 587 * opacidad + b * 114 * opacidad) / 1000;
				return yiq >= 128 ? 'black' : 'white';
			};

			hex = hex.replace('#', '');
			var r = parseInt(hex.substring(0, 2), 16);
			var g = parseInt(hex.substring(2, 4), 16);
			var b = parseInt(hex.substring(4, 6), 16);
			var opacidad = 0.6;

			hex = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacidad + ')';

			return {
				backgroundColor: hex,
				color: getContrastYIQ(r, g, b, opacidad)
			};
		},
		_getDuracionFisica: function _getDuracionFisica(dur) {
			var valor = Math.round(dur / 10000000);
			var neg = valor < 0;
			valor = valor < 0 ? valor * -1 : valor;
			var h = '00';
			var m = '00';
			var s = '00';
			var decimas = '000';
			decimas = valor.toString().match(/\./) ? valor.toString().split('.')[1] : '000';

			if (valor >= 3600) {
				h = Math.floor(valor / 3600);
				h = h < 10 ? '0' + h : h;
				valor = valor % 3600;
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60);
				m = m < 10 ? '0' + m : m;
				valor = valor % 60;
			}

			s = parseInt(valor);
			s = s < 10 ? '0' + s : s;

			decimas = decimas.toString();
			while (decimas.length < 3) {
				decimas = decimas + '0';
			}

			var menos = neg ? '-' : '';
			return menos + '' + h + ':' + m + ':' + s;
		}
	}
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			indice: null,
			teclas: {
				ctrl: false,
				shift: false
			}
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		bloqueActivo: 'organizar-emisoras/bloqueActivo',
		bloques: 'organizar-emisoras/listadoBloques'
	}), {
		tiempoRestanteParrilla: function tiempoRestanteParrilla() {
			if (!this.bloqueActivo) {
				return this._getTiempo(0);
			} else {
				return this._getTiempo(this.bloqueActivo.duracion - this.bloqueActivo.DuracionObjetosFisica, true);
			}
		},
		sobreOcupacionParrilla: function sobreOcupacionParrilla() {
			if (!this.bloqueActivo) {
				return 0;
			}
			return this.bloqueActivo.duracion - this.bloqueActivo.DuracionObjetosFisica < 0;
		}
	}),
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
		seleccionaBloque: 'organizar-emisoras/seleccionaBloque'
	}), {
		teclaAbajo: function teclaAbajo(e) {
			if (e.keyCode !== 9) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;

			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(1);
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(-1);
			}
		},
		teclaArriba: function teclaArriba(e) {
			if (e.keyCode !== 9) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;
		},
		seleccionaIndice: function seleccionaIndice(pos) {
			var _this = this;

			if (this.bloques.length === 0) {
				return;
			}
			var i = this.bloques.indexOf(this.bloqueActivo);
			if (i + pos >= this.bloques.length) {
				// Seleccionamos el primero
				this.seleccionaBloque(this.bloques[0]);
			} else if (i + pos < 0) {
				// Seleccionamos el último
				this.seleccionaBloque(this.bloques[this.bloques.length - 1]);
			} else {
				this.seleccionaBloque(this.bloques[i + pos]);
			}
			if (this.bloqueActivo) {
				window.setTimeout(function () {
					var el = document.getElementById('bloque-' + _this.bloqueActivo.BloqueID);
					if (el) {
						el.scrollIntoView({ block: 'end', behavior: 'instant' });
					}
				}, 100);
			}
		},
		porcentajeBloque: function porcentajeBloque(bloque) {
			return Math.round(bloque.DuracionObjetosFisica * 100 / bloque.duracion);
		},


		// PRIVADOS
		_getTiempo: function _getTiempo(valor, decimales) {
			valor = Math.round(valor * 100) / 100;
			var neg = valor < 0;
			valor = valor < 0 ? valor * -1 : valor;
			var h = '00';
			var m = '00';
			var s = '00';
			var decimas = '0';
			decimas = valor.toString().match(/\./) ? valor.toString().split('.')[1] : '0';

			if (valor >= 3600) {
				h = Math.floor(valor / 3600);
				h = h < 10 ? '0' + h : h;
				valor = valor % 3600;
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60);
				m = m < 10 ? '0' + m : m;
				valor = valor % 60;
			}

			s = parseInt(valor);
			s = s < 10 ? '0' + s : s;

			decimas = decimas.toString();
			while (decimas.length < 1) {
				decimas = decimas + '0';
			}

			var menos = neg ? '-' : '';

			return !decimales ? menos + '' + h + ':' + m + ':' + s : menos + '' + h + ':' + m + ':' + s + '.' + decimas;
		}
	})
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['filtro', 'insertar'],
	data: function data() {
		return {
			indice: null,
			teclas: {
				ctrl: false,
				shift: false
			},
			nuevaPosicion: 1
		};
	},
	mounted: function mounted() {
		if (!this.parrilla || !this.bloque) {
			this.getParrilla();
		}
	},

	watch: {
		insertar: function insertar(newVal) {
			if (Array.isArray(newVal) && newVal.length > 0) {
				this.agregarObjetos(newVal, null, false);
				this.$emit('update:insertar', []);
			}
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		bloque: 'organizar-emisoras/bloqueActivo',
		parrilla: 'organizar-emisoras/insercionesParrilla',
		seleccion: 'organizar-emisoras/seleccionInserciones'
	}), {
		listadoParrilla: function listadoParrilla() {
			var _this = this;

			if (!this.parrilla) {
				return [];
			}
			var anunciantesMap = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
			return this.parrilla.map(function (v, i) {
				v.alertaLocs = false;
				v.alertaAnun = false;

				if (v.anunciante && anunciantesMap.has(v.anunciante.AnuncianteID)) {
					v.alertaAnun = true;
				} else if (v.anunciante) {
					anunciantesMap.set(v.anunciante.AnuncianteID, i);
				}

				if (v.locutores && v.locutores.length === 0) {
					return v;
				}
				var anterior = null;
				var siguiente = null;
				if (i > 0) {
					anterior = _this.parrilla[i - 1];
				}
				if (i < _this.parrilla.length - 1) {
					siguiente = _this.parrilla[i + 1];
				}

				if (anterior && anterior.locutores && anterior.locutores.length > 0) {
					for (var _i = 0; _i < anterior.locutores.length; _i++) {
						var antL = anterior.locutores[_i];
						for (var l = 0; l < v.locutores.length; l++) {
							var actL = v.locutores[l];
							if (actL.ID_locutor === antL.ID_locutor) {
								v.alertaLocs = true;
							}
						}
					}
				}

				if (siguiente && siguiente.locutores && siguiente.locutores.length > 0) {
					for (var _i2 = 0; _i2 < siguiente.locutores.length; _i2++) {
						var _antL = siguiente.locutores[_i2];
						for (var _l = 0; _l < v.locutores.length; _l++) {
							var _actL = v.locutores[_l];
							if (_actL.ID_locutor === _antL.ID_locutor) {
								v.alertaLocs = true;
							}
						}
					}
				}

				return v;
			});
		}
	}),
	methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
		getParrilla: 'organizar-emisoras/getParrilla',
		programar: 'organizar-emisoras/programarInserciones',
		desprogramar: 'organizar-emisoras/desprogramarInserciones'
	}), {
		selecciona: function selecciona(ins) {
			var datos = {
				insercion: ins,
				ctrl: this.teclas.ctrl,
				shift: this.teclas.shift
			};
			this.$store.commit('organizar-emisoras/SELECCIONA_INSERCION', datos);
		},
		teclaAbajo: function teclaAbajo(e) {
			if (e.keyCode !== 9) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;

			if (e.keyCode === 46) {
				// Eliminamos
				this.quitarObjetos();
			}

			if (e.keyCode === 32 && this.seleccion.length > 0) {
				this.$emit('reproducir', this.seleccion[0].ObjetoID);
			}

			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(1);
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(-1);
			}
		},
		teclaArriba: function teclaArriba(e) {
			if (e.keyCode !== 9) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;
		},
		seleccionaIndice: function seleccionaIndice(inc) {
			var idx = this.parrilla.indexOf(this.seleccion[this.seleccion.length - 1]);
			var indice = idx + inc >= this.parrilla.length ? 0 : idx + inc < 0 ? this.parrilla.length - 1 : idx + inc;
			this.selecciona(this.parrilla[indice]);
			this.$refs['objeto-parrilla-' + this.seleccion[0].ProgramacionID][0].scrollIntoView({ block: 'end', behavior: 'instant' });
		},
		dragStart: function dragStart(e, objeto) {
			if (this.seleccion.indexOf(objeto) < 0) {
				this.selecciona(objeto);
			}
			e.dataTransfer.setData('text/json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.seleccion));
			e.dataTransfer.setData('text/from', 'parrilla');
			e.dataTransfer.setData('text/eliminar', this.teclas.ctrl);
			e.dataTransfer.setDragImage(this.$refs.imgdrag, 0, 0);
		},
		dragOver: function dragOver(e, final, objeto) {
			e.preventDefault();
			e.stopPropagation();
			if (final) return;
			var el = this._getElement(e.target);
			var per = this._getPercent(e);
			var idx = this.parrilla.indexOf(objeto);

			if (el) {
				if (per < 50) {
					el.className = 'fila up';
					if (this.seleccion.indexOf(objeto) >= 0) {
						el.className += ' bg-info';
					}
					if (idx >= 0) {
						this.nuevaPosicion = this.parrilla[idx].ProgramacionOrden;
					}
				} else {
					el.className = 'fila down';
					if (this.seleccion.indexOf(objeto) >= 0) {
						el.className += ' bg-info';
					}
					if (idx) {
						this.nuevaPosicion = this.parrilla[idx].ProgramacionOrden + 1;
					}
				}
			}
		},
		dragEnter: function dragEnter(e, final, objeto) {
			e.preventDefault();
			e.stopPropagation();
		},
		dragOut: function dragOut(e, final, objeto) {
			e.preventDefault();
			e.stopPropagation();
			if (final) return;
			var el = this._getElement(e.target);
			if (el) {
				el.className = 'fila';
			}
			if (this.seleccion.indexOf(objeto) >= 0) {
				el.className += ' bg-info';
			}
		},
		dropped: function dropped(e, objeto) {
			var _this2 = this;

			e.preventDefault();
			e.stopPropagation();
			var objetos = JSON.parse(e.dataTransfer.getData('text/json')).map(function (o) {
				return o.ObjetoID;
			});
			var from = e.dataTransfer.getData('text/from');
			var ctrl = e.dataTransfer.getData('text/eliminar');
			var el = this._getElement(e.target);
			var posicion = 1;
			if (el) {
				var per = this._getPercent(e);
				posicion = per < 50 ? objeto.ProgramacionOrden : objeto.ProgramacionOrden + 1;
				el.className = 'fila';
				// this.agregarObjetos(objetos, posicion, eliminar)
			} else {
				if (e.target.tagName === 'TH') {
					posicion = 1;
				} else {
					// Última posicion
					posicion = this.parrilla.length > 0 ? this.parrilla[this.parrilla.length - 1].ProgramacionOrden + 1 : 1;
				}
				// this.agregarObjetos(objetos, pos, eliminar)
			}
			var fnEliminar = null;
			if (ctrl === 'false' && from === 'parrilla') {
				fnEliminar = function fnEliminar() {
					return _this2.desprogramar(_this2.seleccion);
				};
			}
			if (ctrl === 'true' && from === 'favoritos') {
				var favs = JSON.parse(e.dataTransfer.getData('text/json')).map(function (f) {
					return f.ID_favorito;
				});
				fnEliminar = function fnEliminar() {
					_this2.$store.dispatch('organizar-emisoras/delFicherosFavoritos', favs);
					_this2.$store.dispatch('organizar-emisoras/getParrilla');
				};
			}
			var datos = {
				ficheros: objetos,
				posicion: isNaN(posicion) ? 1 : posicion,
				callback: fnEliminar
			};
			this.programar(datos);
		},
		menuContextual: function menuContextual(e, objeto) {
			var _this3 = this;

			e.preventDefault();
			e.stopPropagation();
			if (this.seleccion.indexOf(objeto) < 0) {
				this.selecciona({ ProgramacionID: objeto.ProgramacionID, agregado: this.teclas.ctrl });
			}
			var menu = {
				titulo: 'Fichero',
				items: [],
				evento: e
			};

			menu.items.push({
				texto: 'Reproducir',
				icono: 'fa fa-play',
				activo: true,
				callback: function callback() {
					_this3.$emit('reproducir', objeto.ObjetoID);
				}
			});

			menu.items.push({
				texto: 'Quitar',
				icono: 'fa fa-trash',
				activo: true,
				callback: function callback() {
					_this3.quitarObjetos();
				}
			});

			this.$store.commit('contextual/mostrar', menu);
		},
		agregarObjetos: function agregarObjetos(ObjetosID, posicion, eliminar) {
			var _this4 = this;

			// Verificamos si ObjetoID es un int
			if (!Array.isArray(ObjetosID)) {
				return;
			}

			if (!this.bloque) {
				return;
			}

			eliminar = typeof eliminar === 'boolean' ? eliminar : false;
			if (this.parrilla.length > 0) {
				posicion = typeof posicion !== 'number' || posicion <= 0 ? this.parrilla[this.parrilla.length - 1].ProgramacionOrden + 1 : posicion;
			} else {
				posicion = 1;
			}

			var programa = function programa() {
				if (ObjetosID.length === 0) {
					// TODO: Emitir evento para actualizar los bloques
					if (eliminar && _this4.parrilla.length > 0) {
						_this4.quitarObjetos(true);
					} else {
						_this4.$emit('actualizar');
						_this4.getParrilla();
					}
					return;
				}

				var oID = ObjetosID.splice(0, 1)[0];
				_this4.programaObjeto(oID, posicion).then(function (res) {
					posicion++;
					programa();
				}).catch(_this4.$responseError);
			};
			programa();
		},
		programaObjeto: function programaObjeto(ObjetoID, ProgramacionOrden) {
			var datos = {
				ObjetoID: ObjetoID,
				dia: Math.round(this.filtro.dia.getTime() / 1000),
				BloqueID: this.bloque.BloqueID,
				ProgramacionOrden: ProgramacionOrden <= 0 ? 1 : ProgramacionOrden
			};
			return this.$http.post('organizar-emisoras/php/api/programar-objeto.php', datos);
		},
		quitarObjetos: function quitarObjetos(directo) {
			var _this5 = this;

			var datos = {
				ProgramacionesID: this.seleccion.map(function (p) {
					return p.ProgramacionID;
				})
			};
			if (!directo) {
				this.$store.commit('alertas/confirm', {
					titulo: 'Quitar programación',
					mensaje: '\xBFQuieres quitar estos elementos del bloque?',
					callback: function callback(acepta) {
						if (acepta) {
							_this5.desprogramar(_this5.seleccion);
						}
					}
				});
			} else {
				this.$store.dispatch('organizar-emisoras/desprogramar', datos);
			}
		},


		// PRIVADO
		_getDuracionFisica: function _getDuracionFisica(dur) {
			var valor = dur / 10000000;
			var neg = valor < 0;
			valor = valor < 0 ? valor * -1 : valor;
			var h = '00';
			var m = '00';
			var s = '00';
			var decimas = '000';
			decimas = valor.toString().match(/\./) ? valor.toString().split('.')[1] : '000';

			if (valor >= 3600) {
				h = Math.floor(valor / 3600);
				h = h < 10 ? '0' + h : h;
				valor = valor % 3600;
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60);
				m = m < 10 ? '0' + m : m;
				valor = valor % 60;
			}

			s = parseInt(valor);
			s = s < 10 ? '0' + s : s;

			decimas = decimas.toString();
			while (decimas.length < 3) {
				decimas = decimas + '0';
			}

			var menos = neg ? '-' : '';
			return menos + '' + h + ':' + m + ':' + s + '.' + decimas;
		},
		_getEstilo: function _getEstilo(Color) {
			var hex = Color.toString(16);
			var reverse = function reverse(str) {
				return str === '' ? '' : reverse(str.substr(1)) + str.charAt(0);
			};
			hex = reverse(hex);

			// Calculamos si la cadena es de 6
			while (hex.length < 6) {
				hex = hex + '0';
			}

			hex = hex === '000000' ? 'ffffff' : hex;
			var getContrastYIQ = function getContrastYIQ(r, g, b, opacidad) {
				opacidad = 1 + opacidad;
				var yiq = (r * 299 * opacidad + g * 587 * opacidad + b * 114 * opacidad) / 1000;
				return yiq >= 128 ? 'black' : 'white';
			};

			hex = hex.replace('#', '');
			var r = parseInt(hex.substring(0, 2), 16);
			var g = parseInt(hex.substring(2, 4), 16);
			var b = parseInt(hex.substring(4, 6), 16);
			var opacidad = 0.6;

			hex = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacidad + ')';

			return {
				backgroundColor: hex,
				color: getContrastYIQ(r, g, b, opacidad)
			};
		},
		_getElement: function _getElement(el) {
			if (el.className.match(/contieneBloque/)) {
				// Estamos dropando en el contenedor, situaremos la inserción al final
				return null;
			}
			while (el && !el.className.match(/fila/)) {
				el = el.parentElement;
			}

			return el && el.className.match(/fila/) ? el : null;
		},
		_getPercent: function _getPercent(e) {
			var el = this._getElement(e.target);
			var alto = el.offsetHeight;
			var top = e.offsetY;
			return Math.round(top * 100 / alto);
		}
	})
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reproductor_vue__ = __webpack_require__(591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d23cf7c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_reproductor_vue__ = __webpack_require__(1390);
function injectStyle (ssrContext) {
  __webpack_require__(1389)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d23cf7c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reproductor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d23cf7c6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_reproductor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idObjeto'],
	data: function data() {
		return {
			estiloBarra: {
				width: 0
			},
			actual: 0,
			duracion: 0
		};
	},

	watch: {
		idObjeto: function idObjeto(newVal, oldVal, next) {
			if (newVal) {
				this.$refs.player.play();
			}
		}
	},
	mounted: function mounted() {
		this.$refs.player.addEventListener('ended', this.cerrar);
		this.$refs.player.addEventListener('timeupdate', this.progreso);
		this.$refs.player.addEventListener('durationchange', this.cambiaDuracion);
		this.$refs.barra.addEventListener('click', this.click);
	},
	beforeDestroy: function beforeDestroy() {
		this.$refs.player.removeEventListener('ended', this.cerrar);
		this.$refs.player.removeEventListener('timeupdate', this.progreso);
		this.$refs.player.removeEventListener('durationchange', this.cambiaDuracion);
		this.$refs.barra.removeEventListener('click', this.click);
	},

	methods: {
		click: function click(e) {
			console.log(e.offsetX);
			var porcentaje = e.offsetX * 100 / this.$refs.barra.offsetWidth;
			var tiempo = Math.round(this.duracion * porcentaje / 100);
			this.$refs.player.currentTime = tiempo;
		},
		cambiaDuracion: function cambiaDuracion(e) {
			console.log(e);
			console.log('Duracion: ' + this.$refs.player.duration);
		},
		progreso: function progreso(e) {
			// console.log(e)
			this.actual = this.$refs.player.currentTime;
			this.duracion = this.$refs.player.duration;
			var percent = this.actual * 100 / this.duracion;
			this.estiloBarra = {
				width: percent + '%'
			};
		},
		cerrar: function cerrar() {
			this.$refs.player.pause();
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arbol_favoritos_vue__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_favoritos_vue__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ficheros_favoritos_vue__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'arbol-favoritos': __WEBPACK_IMPORTED_MODULE_1__arbol_favoritos_vue__["a" /* default */],
		'editor-buzones': __WEBPACK_IMPORTED_MODULE_2__editor_favoritos_vue__["a" /* default */],
		'ficheros-favoritos': __WEBPACK_IMPORTED_MODULE_3__ficheros_favoritos_vue__["a" /* default */]
	},
	data: function data() {
		return {
			editarBuzon: null
		};
	},
	created: function created() {
		this.$store.dispatch('organizar-emisoras/getBuzonesFavoritos');
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
		'listadoBuzones': 'organizar-emisoras/buzonesFavoritos',
		'listadoItems': 'organizar-emisoras/ficherosFavoritos',
		'buzonActivo': 'organizar-emisoras/buzonActivoFavoritos'
	})),
	methods: {
		menuContextualArbol: function menuContextualArbol(e) {
			var _this = this;

			e.preventDefault();
			e.stopPropagation();
			var menu = {
				titulo: 'Favoritos',
				evento: e,
				items: []
			};

			menu.items.push({
				texto: 'Nuevo buzón',
				icono: 'fa fa-plus',
				activo: true,
				callback: function callback() {
					_this.editarBuzon = {
						padre: {
							nombre: 'RAÍZ'
						},
						buzon: {
							ID_buzon: null,
							nombre: null,
							BuzonPadre: null
						}
					};
				}
			});
			this.$store.commit('contextual/mostrar', menu);
		},
		insertar: function insertar(e) {
			this.$emit('insertar', e);
		},
		reproducir: function reproducir(e) {
			this.$emit('reproducir', e);
		}
	}
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arbol_favoritos_vue__ = __webpack_require__(594);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5b620a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_arbol_favoritos_vue__ = __webpack_require__(1395);
function injectStyle (ssrContext) {
  __webpack_require__(1393)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e5b620a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arbol_favoritos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e5b620a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_arbol_favoritos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arbol_favoritos_vue__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_favoritos_vue__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'arbol-favoritos',
	components: {
		'arbol-favoritos': __WEBPACK_IMPORTED_MODULE_1__arbol_favoritos_vue__["a" /* default */],
		'editor-buzones': __WEBPACK_IMPORTED_MODULE_2__editor_favoritos_vue__["a" /* default */]
	},
	props: ['listado', 'nivel'],
	data: function data() {
		return {
			expandir: [],
			editar: null
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		'activo': 'organizar-emisoras/buzonActivoFavoritos'
	}), {
		estilo: function estilo() {
			return {
				paddingLeft: 5 + this.nivel * 10 + 'px',
				cursor: 'default'
			};
		}
	}),
	methods: {
		selecciona: function selecciona(buzon) {
			this.$store.dispatch('organizar-emisoras/seleccionaBuzonFavorito', buzon);
		},
		toggleExpandir: function toggleExpandir(e, idBuzon) {
			e.preventDefault();
			e.stopPropagation();
			var idx = this.expandir.indexOf(idBuzon);

			if (idx >= 0) {
				this.expandir.splice(idx, 1);
			} else {
				this.expandir.push(idBuzon);
			}
		},
		estiloBuzon: function estiloBuzon(buzon) {
			return {};
		},
		menuContextual: function menuContextual(e, buzon) {
			var _this = this;

			e.preventDefault();
			e.stopPropagation();
			this.selecciona(buzon);
			var menu = {
				titulo: 'Favoritos',
				evento: e,
				items: []
			};

			menu.items.push({
				texto: 'Nuevo buzón',
				icono: 'fa fa-folder',
				activo: true,
				callback: function callback() {
					_this.editar = {
						padre: buzon,
						buzon: {
							ID_buzon: null,
							nombre: null,
							BuzonPadre: buzon.ID_buzon
						}
					};
				}
			});

			menu.items.push({
				texto: 'Eliminar',
				icono: 'fa fa-trash',
				activo: true,
				callback: function callback() {
					_this.eliminar(buzon);
				}
			});
			this.$store.commit('contextual/mostrar', menu);
		},
		eliminar: function eliminar(buzon) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar buzón',
				mensaje: '¿Quieres eliminar este buzón?',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.$store.dispatch('organizar-emisoras/delBuzonFavorito', buzon);
					}
				}
			});
		},
		update: function update() {
			this.$emit('update');
		}
	}
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_favoritos_vue__ = __webpack_require__(596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d8c6992_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_favoritos_vue__ = __webpack_require__(1394);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_favoritos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d8c6992_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_favoritos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['padre', 'buzon'],
	mounted: function mounted() {
		this.$refs.nombre.focus();
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
		setBuzon: 'organizar-emisoras/setBuzonFavorito'
	}), {
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		guardar: function guardar() {
			var url = this.buzon.ID_buzon ? 'editar-buzon.php' : 'nuevo-buzon.php';
			var data = {
				url: url,
				buzon: this.buzon
			};
			this.setBuzon(data);
			this.cerrar();
		}
	})
});

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			ficheroActivo: null,
			indice: 0,
			teclas: {
				ctrl: false,
				shift: false
			}
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		listadoFicheros: 'organizar-emisoras/ficherosFavoritos',
		seleccion: 'organizar-emisoras/seleccionFavoritos',
		buzon: 'organizar-emisoras/buzonActivoFavoritos',
		parrilla: 'organizar-emisoras/insercionesParrilla',
		bloqueActivo: 'organizar-emisoras/bloqueActivo'
	})),
	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])({
		seleccionaFavoritos: 'organizar-emisoras/SELECCIONA_FAVORITO'
	}), {
		teclaAbajo: function teclaAbajo(e) {
			if (e.keyCode !== 9) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;
			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(1);
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(-1);
			} else if (e.keyCode === 32) {
				if (this.seleccion.length > 0) {
					this.$emit('reproducir', this.seleccion[0].ObjetoID);
				}
			}
		},
		teclaArriba: function teclaArriba(e) {
			e.preventDefault();
			e.stopPropagation();
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;
		},
		seleccionaIndice: function seleccionaIndice(i) {
			var idx = this.listadoFicheros.indexOf(this.seleccion[this.seleccion.length - 1]) + i;
			if (!this.listadoFicheros[idx]) {
				return;
			}
			this.seleccionaFichero(this.listadoFicheros[idx]);
			document.getElementById('favorito-' + this.seleccion[0].ID_favorito).scrollIntoView({ block: 'end', behavior: 'instant' });
		},
		seleccionaFichero: function seleccionaFichero(fichero) {
			this.ficheroActivo = fichero;
			this.seleccionaFavoritos({
				fichero: fichero,
				ctrl: this.teclas.ctrl,
				shift: this.teclas.shift
			});
		},
		agregarObjeto: function agregarObjeto(fichero) {
			if (!this.bloqueActivo) {
				return;
			}
			var datos = {
				ficheros: [fichero.ObjetoID],
				posicion: this.parrilla.length > 0 ? this.parrilla[this.parrilla.length - 1].ProgramacionOrden + 1 : 1
			};
			console.log(datos);
			this.$store.dispatch('organizar-emisoras/programarInserciones', datos);
		},
		dragStart: function dragStart(e, fichero) {
			if (this.seleccion.indexOf(fichero) < 0) {
				this.seleccionaFichero(fichero);
			}
			e.dataTransfer.setData('text/json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.seleccion));
			e.dataTransfer.setData('text/from', 'favoritos');
			e.dataTransfer.setData('text/eliminar', this.teclas.ctrl);
		},
		dragOverFicheros: function dragOverFicheros(e) {
			e.preventDefault();
			e.stopPropagation();
			this.$refs.caja.style.opacity = '0.6';
		},
		dragLeaveFicheros: function dragLeaveFicheros(e) {
			e.preventDefault();
			e.stopPropagation();
			this.$refs.caja.style.opacity = '1';
		},
		droppedFicheros: function droppedFicheros(e) {
			e.preventDefault();
			e.stopPropagation();
			this.$refs.caja.style.opacity = '1';
			var transf = JSON.parse(e.dataTransfer.getData('text/json'));
			var from = e.dataTransfer.getData('text/from');
			var ctrl = e.dataTransfer.getData('text/eliminar');

			if (Array.isArray(transf)) {
				this.$store.dispatch('organizar-emisoras/addFicherosFavoritos', transf);

				if (from === 'parrilla' && ctrl === 'false') {
					this.$store.dispatch('organizar-emisoras/desprogramarInserciones', transf);
				}
			}
		},
		menuContextual: function menuContextual(e, fichero) {
			var _this = this;

			e.preventDefault();
			e.stopPropagation();
			if (this.seleccion.indexOf(fichero) < 0) {
				this.seleccionaFichero(fichero);
			}
			var menu = {
				titulo: 'Favoritos',
				evento: e,
				items: []
			};

			menu.items.push({
				texto: 'Quitar de favoritos',
				icono: 'fa fa-trash',
				activo: true,
				callback: function callback() {
					_this.quitarFavorito(fichero);
				}
			});
			this.$store.commit('contextual/mostrar', menu);
		},
		quitarFavorito: function quitarFavorito(fichero) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Quitar favorito',
				mensaje: '¿Quieres quitar los favoritos seleccionados?',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.$store.dispatch('organizar-emisoras/delFicherosFavoritos', _this2.seleccion.map(function (f) {
							return f.ID_favorito;
						}));
					}
				}
			});
		},
		_getDuracionFisica: function _getDuracionFisica(dur) {
			var valor = dur;
			var neg = valor < 0;
			valor = valor < 0 ? valor * -1 : valor;
			var h = '00';
			var m = '00';
			var s = '00';
			var decimas = '000';
			decimas = valor.toString().match(/\./) ? valor.toString().split('.')[1] : '000';

			if (valor >= 3600) {
				h = Math.floor(valor / 3600);
				h = h < 10 ? '0' + h : h;
				valor = valor % 3600;
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60);
				m = m < 10 ? '0' + m : m;
				valor = valor % 60;
			}

			s = parseInt(valor);
			s = s < 10 ? '0' + s : s;

			decimas = decimas.toString();
			while (decimas.length < 3) {
				decimas = decimas + '0';
			}

			var menos = neg ? '-' : '';
			return menos + '' + h + ':' + m + ':' + s;
		}
	})
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			cadena: '',
			listadoFicheros: [],
			ficheroActivo: null,
			seleccion: [],
			indice: 0,
			teclas: {
				ctrl: false,
				shift: false
			}
		};
	},


	methods: {
		buscar: function buscar() {
			var _this = this;

			this.seleccion = [];
			this.indice = 0;
			this.$http.post('organizar-emisoras/php/api/query-ficheros.php', { q: this.cadena }).then(function (res) {
				_this.listadoFicheros = res.data.resultados.map(function (r) {
					return r.datos;
				});
			}).catch(this.$responseError);
		},
		teclaAbajo: function teclaAbajo(e) {
			if (e.keyCode !== 9) {
				e.preventDefault();
				e.stopPropagation();
			}
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;
			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(this.indice + 1);
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(this.indice - 1);
			} else if (e.keyCode === 32) {
				if (this.seleccion.length > 0) {
					this.$emit('reproducir', this.seleccion[0].ObjetoID);
				}
			}
		},
		teclaArriba: function teclaArriba(e) {
			e.preventDefault();
			e.stopPropagation();
			this.teclas.ctrl = e.ctrlKey;
			this.teclas.shift = e.shiftKey;
		},
		seleccionaIndice: function seleccionaIndice(i) {
			var tamano = this.listadoFicheros.length;
			this.indice = i >= tamano ? 0 : i < 0 ? tamano - 1 : i;
			this.seleccion = [this.listadoFicheros[this.indice]];
			document.getElementById('fichero-' + this.seleccion[0].ObjetoID).scrollIntoView({ block: 'end', behavior: 'instant' });
		},
		seleccionaFichero: function seleccionaFichero(fichero) {
			this.ficheroActivo = fichero;
			if (this.teclas.ctrl) {
				var idx = this.seleccion.indexOf(fichero);
				if (idx >= 0) {
					this.seleccion.splice(idx, 1);
				} else {
					this.seleccion.push(fichero);
				}
			} else if (this.teclas.shift) {
				if (this.seleccion.length === 0) {
					this.seleccion = [fichero];
				} else {
					// Hayamos el índice más bajo de la selección
					var indiceSeleccion = this.listadoFicheros.indexOf(fichero);
					var ind = null;
					for (var i = 0; i < this.seleccion.length; i++) {
						var e = this.listadoFicheros.indexOf(this.seleccion[i]);
						ind = ind === null || e < ind ? e : ind;
					}

					// Ahora comprobamos si es mayor que el seleccionado
					var primero = ind > indiceSeleccion ? indiceSeleccion : ind;
					var ultimo = ind > indiceSeleccion ? ind : indiceSeleccion;

					this.seleccion = [];

					for (var p = primero; p <= ultimo; p++) {
						this.seleccion.push(this.listadoFicheros[p]);
					}
				}
			} else {
				this.seleccion = [fichero];
			}

			this.indice = this.listadoFicheros.indexOf(fichero);
		},
		dragStart: function dragStart(e, fichero) {
			if (this.seleccion.indexOf(fichero) < 0) {
				this.seleccionaFichero(fichero);
			}

			e.dataTransfer.setData('text/json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.seleccion));
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		_getDuracionFisica: function _getDuracionFisica(dur) {
			var valor = dur;
			var neg = valor < 0;
			valor = valor < 0 ? valor * -1 : valor;
			var h = '00';
			var m = '00';
			var s = '00';
			var decimas = '000';
			decimas = valor.toString().match(/\./) ? valor.toString().split('.')[1] : '000';

			if (valor >= 3600) {
				h = Math.floor(valor / 3600);
				h = h < 10 ? '0' + h : h;
				valor = valor % 3600;
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60);
				m = m < 10 ? '0' + m : m;
				valor = valor % 60;
			}

			s = parseInt(valor);
			s = s < 10 ? '0' + s : s;

			decimas = decimas.toString();
			while (decimas.length < 3) {
				decimas = decimas + '0';
			}

			var menos = neg ? '-' : '';
			return menos + '' + h + ':' + m + ':' + s;
		}
	}
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_listado_fases_listado_vue__ = __webpack_require__(1406);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'produccion',
	components: {
		'listado-tareas': __WEBPACK_IMPORTED_MODULE_0__components_listado_fases_listado_vue__["a" /* default */]
	}
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__produccion_produccion__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buscador_buscador__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__produccion_fase_tareas_new__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__estadisticas_estadisticas__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nueva_nueva__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * FASES DEL PROCESO DE PRODUCCIÓN:
 * 	- pteIdea
 * 	- pteApruebaIdea
 *	- pteProduccion
 *	- pteAprobar
 */








/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Listado',
	components: {
		'estadisticas': __WEBPACK_IMPORTED_MODULE_4__estadisticas_estadisticas__["a" /* default */],
		'vista-tarea': __WEBPACK_IMPORTED_MODULE_1__produccion_produccion__["a" /* default */],
		'fase-tareas': __WEBPACK_IMPORTED_MODULE_3__produccion_fase_tareas_new__["a" /* default */],
		'buscador': __WEBPACK_IMPORTED_MODULE_2__buscador_buscador__["a" /* default */],
		'nueva-orden': __WEBPACK_IMPORTED_MODULE_5__nueva_nueva__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				fases: [],
				locutor: null,
				agente: null,
				anunciante: null,
				tipo: null
			},
			verFiltros: false,
			tareas: [],
			seccion: 'listado',
			seccionAnterior: 'listado',
			ID_tarea: null,
			listadoAbiertos: [],
			/* fasesB: [
   	{
   		id: 'pteIdea',
   		titulo: 'Pdte. de idea creativa',
   		tareas: []
   	},
   	{
   		id: 'pteAprobarTexto',
   		titulo: 'Pdte. de aprobar idea',
   		tareas: []
   	},
   	{
   		id: 'pteProduccion',
   		titulo: 'Pdte. de producción',
   		tareas: []
   	},
   	{
   		id: 'pteAprobarProduccion',
   		titulo: 'Pdte. de aprobar producción',
   		tareas: []
   	}
   ], */
			intervalo: null
		};
	},

	watch: {
		'$route.params': function $routeParams(newVal) {
			var _this = this;

			if (newVal.seccion === 'tarea' && newVal.TareaID) {
				__WEBPACK_IMPORTED_MODULE_6__services_api__["a" /* default */].getTarea(newVal.TareaID).then(function (res) {
					_this.cargaOrden(res.data.tarea);
				}).catch(function (e) {
					console.error(e);
					_this.$responseError(e);
				});
			} else if (newVal.seccion === 'listado') {
				this.seccion = 'listado';
			} else if (newVal.seccion === 'buscador') {
				this.seccion = 'buscador';
			} else if (newVal.seccion === 'nueva') {
				this.seccion = 'nueva';
			} else if (newVal.seccion === 'estadisticas') {
				this.seccion = 'estadisticas';
			}
		}
	},

	created: function created() {
		var _this2 = this;

		this.getTareas();
		this.intervalo = window.setInterval(function () {
			return _this2.getTareas();
		}, 5000);

		var menu = [{
			'icono': 'fa fa-plus-circle',
			'nombre': 'Nueva',
			activo: false,
			'callback': function callback(a) {
				_this2.setMenuActivo(a);
				_this2.$router.push('/main/produccion/nueva');
				// this.seccion = 'nueva'
			}
		}, {
			'icono': 'fa fa-list',
			'nombre': 'Listado',
			activo: true,
			callback: function callback(a) {
				_this2.setMenuActivo(a);
				_this2.$router.push('/main/produccion/listado');
				// this.seccion = 'listado'
			}
		}, {
			'icono': 'fa fa-search',
			'nombre': 'Buscador',
			activo: false,
			callback: function callback(a) {
				_this2.setMenuActivo(a);
				_this2.$router.push('/main/produccion/buscador');
				// this.seccion = 'buscador'
			}
		}];

		if (this.permisos.producciones_verEstadisticas) {
			menu.push({
				'icono': 'fa fa-line-chart',
				'nombre': 'Estadíst...',
				activo: false,
				callback: function callback(a) {
					_this2.setMenuActivo(a);
					_this2.$router.push('/main/produccion/estadisticas');
					// this.seccion = 'estadisticas'
				}
			});
		}

		this.setMenu(menu);

		var params = this.$route.params;
		if (params.seccion === 'tarea' && params.TareaID) {
			__WEBPACK_IMPORTED_MODULE_6__services_api__["a" /* default */].getTarea(params.TareaID).then(function (res) {
				_this2.cargaOrden(res.data.tarea);
			}).catch(function (e) {
				console.error(e);
				_this2.$responseError(e);
			});
		} else if (params.seccion === 'listado') {
			this.seccion = 'listado';
		} else if (params.seccion === 'buscador') {
			this.seccion = 'buscador';
		} else if (params.seccion === 'nueva') {
			this.seccion = 'nueva';
		} else if (params.seccion === 'estadisticas') {
			this.seccion = 'estadisticas';
		}
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.intervalo);
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	}), {
		fases: function fases() {
			var fases = [{
				id: 'pteIdea',
				titulo: 'Pdte. de idea creativa',
				tareas: [],
				clase: 'bg-warning'
			}, {
				id: 'pteAprobarIdea',
				titulo: 'Pdte. de aprobar idea',
				tareas: [],
				clase: 'bg-danger'
			}, {
				id: 'pteProduccion',
				titulo: 'Pdte. de producción',
				tareas: [],
				clase: 'bg-info'
			}, {
				id: 'pteAprobarProduccion',
				titulo: 'Pdte. de aprobar producción',
				tareas: [],
				clase: 'bg-success'
			}];

			// Recorremos las tareas para clasificarlas
			for (var i = 0; i < this.tareas.length; i++) {
				var tarea = this.tareas[i];
				if (this.filtro.locutor) {
					var exp = new RegExp(this.filtro.locutor, 'ig');
					var encontrado = false;
					for (var loc in tarea.locutores) {
						if (tarea.locutores[loc].LocutorNombre.match(exp)) {
							encontrado = true;
						}
					}

					if (!encontrado) {
						continue;
					}
				}

				if (this.filtro.agente) {
					var _exp = new RegExp(this.filtro.agente, 'ig');
					var _encontrado = false;
					if (tarea.agenteNombre.match(_exp)) {
						_encontrado = true;
					}

					if (!_encontrado) {
						continue;
					}
				}

				if (this.filtro.anunciante) {
					var _exp2 = new RegExp(this.filtro.anunciante, 'ig');
					var _encontrado2 = false;
					if (tarea.anuncianteNombre.match(_exp2)) {
						_encontrado2 = true;
					}

					if (!_encontrado2) {
						continue;
					}
				}

				if (this.filtro.tipo) {
					if (this.filtro.tipo === 'propias' && tarea.externa === 1) {
						continue;
					} else if (this.filtro.tipo === 'externas' && tarea.externa === 0) {
						continue;
					}
				}
				for (var f = 0; f < fases.length; f++) {
					if (fases[f].id === tarea.fase) {
						fases[f].tareas.push(tarea);
					}
				}
			}

			return fases;
		},
		listadoPteIdea: function listadoPteIdea() {
			var lista = [];

			for (var i = 0; i < this.tareas.length; i++) {
				if (this.tareas[i].fase === 'pteIdea') {
					lista.push(this.tareas[i]);
				}
			}

			return lista;
		},
		listadoPteAprobarIdea: function listadoPteAprobarIdea() {
			var lista = [];

			for (var i = 0; i < this.tareas.length; i++) {
				if (this.tareas[i].fase === 'pteAprobarIdea') {
					lista.push(this.tareas[i]);
				}
			}

			return lista;
		},
		listadoPteProduccion: function listadoPteProduccion() {
			var lista = [];

			for (var i = 0; i < this.tareas.length; i++) {
				if (this.tareas[i].fase === 'pteProduccion') {
					lista.push(this.tareas[i]);
				}
			}

			return lista;
		},
		listadoPteAprobar: function listadoPteAprobar() {
			var lista = [];

			for (var i = 0; i < this.tareas.length; i++) {
				if (this.tareas[i].fase === 'pteAprobar') {
					lista.push(this.tareas[i]);
				}
			}

			return lista;
		}
	}),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapMutations */])({
		setMenu: 'top/setMenu',
		setMenuActivo: 'top/setMenuActivo'
	}), {
		getTareas: function getTareas() {
			var _this3 = this;

			// Vamos a obtener el listado de tareas
			__WEBPACK_IMPORTED_MODULE_6__services_api__["a" /* default */].getListadoTareas('get-listado-tareas.php').then(function (res) {
				_this3.tareas = res.data.tareas;
			}).catch(function (e) {
				console.error(e);
			});
		},
		esFaseActiva: function esFaseActiva(fase) {
			return this.filtro.fases.indexOf(fase) >= 0;
		},
		activaFase: function activaFase(fase) {
			var ind = this.filtro.fases.indexOf(fase);
			if (ind < 0) {
				this.filtro.fases.push(fase);
			} else {
				this.filtro.fases.splice(ind, 1);
			}
		},
		cargaOrden: function cargaOrden(datos) {
			console.log(datos);
			// Comprobamos si está ya añadida
			for (var i = 0; i < this.listadoAbiertos.length; i++) {
				if (this.listadoAbiertos[i].ID_tarea === datos.ID_tarea) {
					this.maximizar(datos.ID_tarea);
					return;
				}
			}

			datos.titulo = datos.titulo || 'Sin título';

			this.listadoAbiertos.push({
				ID_tarea: datos.ID_tarea,
				nombre: datos.titulo
			});

			this.maximizar(datos.ID_tarea);

			this.setMenuActivo({});
		},
		cerrarTarea: function cerrarTarea(idTarea) {
			var cerrado = false;
			for (var i = this.listadoAbiertos.length - 1; i >= 0; i--) {
				if (cerrado === true) {
					this.maximizar(this.listadoAbiertos[i].ID_tarea);
					return;
				}
				if (this.listadoAbiertos[i].ID_tarea === idTarea) {
					this.listadoAbiertos.splice(i, 1);
					cerrado = true;
				}
			}

			// Si llegamos aquí es porque no queda nada abierto
			if (this.seccion === 'tarea' && this.ID_tarea === idTarea) {
				this.seccion = this.seccionAnterior;
			}
		},
		maximizar: function maximizar(idTarea) {
			this.$router.push('/main/produccion/tarea/' + idTarea);
			this.seccionAnterior = this.seccion;
			this.seccion = 'tarea';
			this.ID_tarea = idTarea;
		}
	})
});

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comentarios__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_texto__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__visualiza_texto__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__seleccion_locutor__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rechazo_tarea__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editando_tarea__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editando_produccion__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reproductor__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__listado_versiones__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__historial__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__cronometro__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__componentes_tarjeta_locutor__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'vista-tarea',
	props: ['idtarea', 'focoactivo'],
	components: {
		'comentarios': __WEBPACK_IMPORTED_MODULE_1__comentarios__["a" /* default */],
		'editor-texto': __WEBPACK_IMPORTED_MODULE_2__editor_texto__["a" /* default */],
		'visualiza-texto': __WEBPACK_IMPORTED_MODULE_3__visualiza_texto__["a" /* default */],
		'selecciona-locutor': __WEBPACK_IMPORTED_MODULE_4__seleccion_locutor__["a" /* default */],
		'rechazo-tarea': __WEBPACK_IMPORTED_MODULE_5__rechazo_tarea__["a" /* default */],
		'editando-tarea': __WEBPACK_IMPORTED_MODULE_6__editando_tarea__["a" /* default */],
		'editando-produccion': __WEBPACK_IMPORTED_MODULE_7__editando_produccion__["a" /* default */],
		'reproductor': __WEBPACK_IMPORTED_MODULE_8__reproductor__["a" /* default */],
		'historial': __WEBPACK_IMPORTED_MODULE_10__historial__["a" /* default */],
		'listado-versiones': __WEBPACK_IMPORTED_MODULE_9__listado_versiones__["a" /* default */],
		'tarjeta-locutor': __WEBPACK_IMPORTED_MODULE_12__componentes_tarjeta_locutor__["a" /* default */],
		'cronometro': __WEBPACK_IMPORTED_MODULE_11__cronometro__["a" /* default */]
	},
	data: function data() {
		return {
			tarea: null,
			error: null,
			editarTarea: false,
			mostrarAnotacionesProduccion: false,
			mostrarAnotacionesTarea: false,
			mostrarRechazo: true,
			versionActual: null,
			versionAnterior: null,
			locutorActual: null,
			rechazaTarea: false,
			idproduccion: null,
			previsualizaFichero: null,
			verHistorial: false,
			listadoVersiones: false,
			atajos: {
				ctrl: false
			}
		};
	},

	created: function created() {
		// Buscamos la tarea
		this.getTarea();
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	}), {
		esTareaValida: function esTareaValida() {
			if (this.tarea.fase === 'finalizada') {
				return true;
			}
			return this.tarea.duracion && this.tarea.fecha_inicio && this.tarea.fecha_fin;
		},
		tituloFase: function tituloFase() {
			switch (this.tarea.fase) {
				case 'pteIdea':
					return 'Pendiente de creatividad';
				case 'pteAprobarIdea':
					return 'Pendiente de aprobar texto';
				case 'pteProduccion':
					return 'Pendiente de producción';
				case 'pteAprobarProduccion':
					return 'Pendiente de aprobar producción';
				case 'finalizada':
					return 'Producción finalizada';
				case 'cancelada':
					return 'Producción cancelada';
			}

			return 'Fase desconocida';
		},
		txtSiguienteFase: function txtSiguienteFase() {
			switch (this.tarea.fase) {
				case 'pteIdea':
					return 'Creatividad terminada';
				case 'pteAprobarIdea':
					return 'Aprobar creatividad';
				case 'pteProduccion':
					return 'Producción terminada';
				case 'pteAprobarProduccion':
					return 'Aprobar producción';
			}

			return this.tarea.fase;
		},
		iconoSiguienteFase: function iconoSiguienteFase() {
			switch (this.tarea.fase) {
				case 'pteIdea':
					return 'fa fa-lightbulb-o';
				case 'pteAprobarIdea':
					return 'fa fa-check';
				case 'pteProduccion':
					return 'fa fa-flag-checkered';
				case 'pteAprobarProduccion':
					return 'fa fa-thumbs-up';
			}

			return this.tarea.fase;
		},
		esUltima: function esUltima() {
			return this.versionActual.ultima_version.ultima;
		},
		textoPlano: function textoPlano() {
			var txt = '';

			for (var i = 0; i < this.versionActual.textos.length; i++) {
				var t = this.versionActual.textos[i];
				txt += t.tipo.toUpperCase() + t.numero + ': ' + t.texto + '\n\n-------\n\n';
			}

			return txt;
		}
	}),

	methods: {
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		editarProduccion: function editarProduccion() {
			this.idproduccion = this.tarea.produccion.ID_produccion;
		},
		getTarea: function getTarea() {
			var _this = this;

			// Examinamos la tarea
			__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].getTarea(this.idtarea).then(function (res) {
				_this.tarea = res.data.tarea;
				_this.versionActual = _this.tarea.versiones.slice(-1).pop();

				if (_this.tarea.versiones.length > 1) {
					_this.versionAnterior = _this.tarea.versiones[_this.tarea.versiones.length - 2];
				} else {
					_this.versionAnterior = null;
				}
			}).catch(function (e) {
				_this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cierraEditorTarea: function cierraEditorTarea() {
			this.editarTarea = false;
			this.getTarea();
		},
		setVersion: function setVersion(datos) {
			this.versionActual = datos.actual;
			this.versionAnterior = datos.anterior;
			this.listadoVersiones = false;
		},
		copiarTexto: function copiarTexto() {
			var el = document.createElement('pre');
			document.body.appendChild(el);
			el.textContent = this.textoPlano.toString();
			var selection = document.getSelection();
			var range = document.createRange();
			range.selectNode(el);
			selection.removeAllRanges();
			selection.addRange(range);
			document.execCommand('copy');
			selection.removeAllRanges();
			document.body.removeChild(el);
			this.$store.commit('alertas/alert', {
				titulo: 'Texto copiado',
				mensaje: 'Se ha copiado el texto en formato plano.\n\t\t\t\tP\xE9galo en cualquier edito de texto o de correo electr\xF3nico'
			});
		},
		setLocutor: function setLocutor(locutor) {
			var _this2 = this;

			if (!this.locutorActual) {
				return;
			}

			// Veamos si ese locutor ya está asignado
			for (var i = 0; i < this.versionActual.locutores.length; i++) {
				if (this.versionActual.locutores[i].info && this.versionActual.locutores[i].info.ID_locutor === locutor.ID_locutor) {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: 'Este locutor ya está asignado'
					});
					return;
				}
			}

			var datos = {
				ID_version: this.versionActual.ID_version,
				titulo: this.locutorActual,
				ID_locutor: locutor.ID_locutor
			};

			__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].asignaLocutor(datos).then(function (res) {
				_this2.versionActual = res.data.version;
				_this2.locutorActual = null;
				_this2.emiteActualizar();
			}).catch(function (e) {
				_this2.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		quitaLocutor: function quitaLocutor(loc) {
			var _this3 = this;

			var datos = {
				ID_version: this.versionActual.ID_version,
				titulo: loc,
				ID_locutor: null
			};

			__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].asignaLocutor(datos).then(function (res) {
				_this3.versionActual = res.data.version;
				_this3.locutorActual = null;
				_this3.emiteActualizar();
			}).catch(function (e) {
				_this3.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		setDuracionEstimada: function setDuracionEstimada(ev) {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].setTiempoEstimado(this.versionActual.ID_version, ev).then(function (res) {
				_this4.getTarea();
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevoFichero: function nuevoFichero(tipo) {
			var _this5 = this;

			if (tipo !== 'final') {
				this.nuevoFicheroFase2(tipo, 0);
			} else {
				this.$store.commit('alertas/confirm', {
					titulo: 'Derechos de autor',
					mensaje: '<b>Importante</b>\n\t\t\t\t\tEs necesario que especifiques si el o los ficheros que vas a adjuntar contienen m\xFAsica protegida por derechos de autor.\n\t\t\t\t\t<b>\xBFTienen derechos de autor?</b>',
					buttons: [{
						titulo: 'Sí',
						clase: 'btn btn-sm btn-primary',
						icono: 'fa fa-check',
						valor: 1
					}, {
						titulo: 'No',
						clase: 'btn btn-sm btn-danger',
						icono: 'fa fa-ban',
						valor: 0
					}],
					callback: function callback(tieneDerechos) {
						_this5.nuevoFicheroFase2(tipo, tieneDerechos);
					}
				});
			}
		},
		nuevoFicheroFase2: function nuevoFicheroFase2(tipo, derechos) {
			var _this6 = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.style.display = 'none';
			inp.multiple = true;
			inp.accept = '.mp3,audio/mpeg';

			inp.addEventListener('change', function (ev) {
				var form = new FormData();
				form.append('ID_tarea', _this6.tarea.ID_tarea);
				form.append('ID_version', _this6.versionActual.ID_version);
				form.append('tipo', tipo);
				form.append('musica_autor', derechos);

				for (var i = 0; i < inp.files.length; i++) {
					form.append('fichero[]', inp.files[i]);
				}

				__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].tareaAddFicheros(form).then(function (res) {
					_this6.tarea = res.data.tarea;
					_this6.versionActual = _this6.tarea.versiones.slice(-1).pop();
					_this6.emiteActualizar();
				}).catch(function (e) {
					_this6.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					});
				});
			});

			document.body.appendChild(inp);

			inp.click();
		},
		eliminaFichero: function eliminaFichero(fichero) {
			var _this7 = this;

			var doEliminar = function doEliminar() {
				var datos = {
					ID_tarea: _this7.tarea.ID_tarea,
					ID_fichero: fichero.ID_fichero
				};

				__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].tareaDelFichero(datos).then(function (res) {
					_this7.tarea = res.data.tarea;
					_this7.versionActual = _this7.tarea.versiones.slice(-1).pop();
					_this7.emiteActualizar();
				}).catch(function (e) {
					_this7.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					});
				});
			};

			this.$store.commit('alertas/nueva', {
				titulo: 'Confirmación',
				mensaje: '¿Quieres eliminar el fichero \'' + fichero.nombre + '\'?\n\nEsta acción no podrá deshacerse',
				callback: function callback(acepta) {
					if (acepta) {
						doEliminar();
					}
				},
				buttons: [{
					titulo: 'Cancelar',
					clase: 'btn btn-sm btn-danger',
					valor: false,
					icono: 'fa fa-ban'
				}, {
					titulo: 'Aceptar',
					clase: 'btn btn-sm btn-primary',
					vaor: true,
					icono: 'fa fa-check'
				}]
			});
		},
		eliminaFicheroVersion: function eliminaFicheroVersion(fichero) {
			var _this8 = this;

			var doEliminar = function doEliminar() {
				var datos = {
					ID_version: _this8.versionActual.ID_version,
					ID_fichero: fichero.ID_fichero
				};

				__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].delFicheroVersion(datos).then(function (res) {
					_this8.versionActual = res.data.version;
					_this8.emiteActualizar();
				}).catch(function (e) {
					_this8.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					});
				});
			};

			this.$store.commit('alertas/nueva', {
				titulo: 'Confirmación',
				mensaje: '¿Quieres eliminar el fichero \'' + fichero.nombre + '\'?\n\nEsta acción no podrá deshacerse',
				callback: function callback(acepta) {
					if (acepta) {
						doEliminar();
					}
				},
				buttons: [{
					titulo: 'Cancelar',
					clase: 'btn btn-sm btn-danger',
					valor: false,
					icono: 'fa fa-ban'
				}, {
					titulo: 'Aceptar',
					clase: 'btn btn-sm btn-primary',
					valor: true,
					icono: 'fa fa-check'
				}]
			});
		},


		// La fase previa a ésta es: pteTexto
		textoTerminado: function textoTerminado() {
			if (this.versionActual.textos.length === 0) {
				this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: 'No has escrito nada de texto'
				});
				return;
			}

			for (var i = 0; i < this.versionActual.textos.length; i++) {
				if (this.versionActual.textos[i].texto.trim().length === 0) {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: 'El texto número ' + (i + 1) + ' no tiene nada escrito. No se admiten textos vacíos'
					});
					return;
				}
			}

			this.tarea.fase = 'pteApruebaTexto';
		},


		// la fase previa a ésta es: pteApruebaTexto
		textoAprobado: function textoAprobado() {
			this.tarea.fase = 'pteProduccion';
		},


		// La fase previa a esta es: pteProduccion
		produccionTerminada: function produccionTerminada() {
			// Comprobamos que todos los textos estén grabados
			for (var i = 0; i < this.versionActual.textos.length; i++) {
				if (!this.versionActual.textos[i].grabado) {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'El texto: ' + (i + 1) + ' no está grabado'
					});
					return;
				}
			}

			this.tarea.fase = 'pteApruebaProduccion';
		},


		// La fase previa a ésta es: pteApruebaProduccion
		produccionRechazada: function produccionRechazada() {
			this.tarea.fase = 'pteProduccion';
		},


		// La fase previa a ésta es: pteApruebaProduccion
		produccionAprobada: function produccionAprobada() {
			this.tarea.fase = 'finalizada';
		},
		checkDuraciones: function checkDuraciones(cb) {
			if (this.tarea.fase === 'pteAprobarProduccion') {
				var ficherosPasados = [];
				console.log(this.$options.filters);
				for (var i = 0; i < this.versionActual.ficheros.length; i++) {
					if (this.versionActual.ficheros[i].duracion > this.tarea.duracion) {
						var exceso = this.versionActual.ficheros[i].duracion - this.tarea.duracion;

						if (exceso > 0.5) {
							ficherosPasados.push({
								titulo: this.versionActual.ficheros[i].nombre,
								duracion: this.$options.filters.round(this.versionActual.ficheros[i].duracion, 2),
								exceso: this.$options.filters.round(exceso, 2)
							});
						}
					}
				}

				if (ficherosPasados.length > 0) {
					var texto = ficherosPasados.reduce(function (ant, fichero) {
						ant = ant + ('<li>' + fichero.titulo + ':\n\t\t\t\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t\t\t\t<li>Duraci\xF3n: ' + fichero.duracion + ' seg.</li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li>Excede: ' + fichero.exceso + ' seg.</li>\n\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t</li>');
						return ant;
					}, '');
					texto = '<ul>' + texto + '</ul>';

					this.$store.commit('alertas/confirm', {
						titulo: 'Ficheros fuera de duración detectados',
						mensaje: 'Se han detectado ficheros producidos que exceden el tiempo contratado (<b>' + this.tarea.duracion + ' seg.</b>). Si continuas y apruebas <b>se generar\xE1 una incidencia.</b>\n\t\t\t\t\t\tEstos son los ficheros:\n\t\t\t\t\t\t' + texto,
						callback: function callback(acepta) {
							if (acepta) {
								cb();
							}
						}
					});
				} else {
					cb();
				}
			} else {
				cb();
			}
		},
		siguienteFase: function siguienteFase() {
			var _this9 = this;

			this.checkDuraciones(function () {
				_this9.$store.commit('alertas/confirm', {
					titulo: 'Confirmación',
					mensaje: '¿Estás seguro de que quieres dar esta fase por completada?',
					callback: function callback(acepta) {
						if (acepta) {
							var datos = {
								ID_version: _this9.versionActual.ID_version
							};

							__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].setSiguienteFase(datos).then(function (res) {
								_this9.versionActual = res.data.version;
								_this9.emiteActualizar();
							}).catch(function (e) {
								var msj = e.response.data.error || 'Error pasando a la siguiente fase';
								_this9.$store.commit('alertas/nueva', {
									titulo: 'Error',
									mensaje: msj
								});
							});
						}
					}
				});
			});
		},
		cancelarTarea: function cancelarTarea() {
			var _this10 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Cancelar tarea',
				mensaje: 'Si cancelas esta tarea se expulsar\xE1 del proceso de producci\xF3n',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].cancelarTarea(_this10.tarea.ID_tarea).then(function (res) {
							_this10.getTarea();
						}).catch(function (e) {
							_this10.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		verFichero: function verFichero(fichero, tipo) {
			this.previsualizaFichero = {
				fichero: fichero,
				tipo: tipo
			};
		},
		rechazar: function rechazar() {
			this.rechazaTarea = true;
		},
		subirXFrame: function subirXFrame(fichero) {
			var _this11 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Subir al XFrame',
				mensaje: '¿Quieres subir este fichero al XFrame?\nEsto generará un nuevo número de XFrame',
				callback: function callback(acepta) {
					if (!acepta) {
						return;
					}

					var datos = {
						ID_fichero: fichero.ID_fichero,
						ID_version: _this11.versionActual.ID_version
					};

					__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].setSubirXFrame(datos).then(function (res) {
						_this11.$store.commit('alertas/alert', {
							titulo: 'Fichero subido',
							mensaje: 'Se ha subido el fichero y se le ha asignado el número ' + res.data.fichero.xframe_num
						});
						_this11.getTarea();
					}).catch(function (e) {
						_this11.$store.commit('alertas/alert', {
							titulo: 'Error',
							mensaje: e.response.data.error
						});
					});
				}
			});
		},
		nuevaVersion: function nuevaVersion(data) {
			this.versionActual = data;
			this.emiteActualizar();
		},
		setTeleprompter: function setTeleprompter() {
			var _this12 = this;

			var datos = {
				ID_version: this.versionActual.ID_version
			};

			__WEBPACK_IMPORTED_MODULE_13__services_api__["a" /* default */].setTeleprompter(datos).then(function (res) {
				_this12.getTarea();
			}).catch(function (e) {
				_this12.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		emiteActualizar: function emiteActualizar(eliminada) {
			if (eliminada) {
				this.$emit('actualizar');
				this.cerrar();
			} else {
				this.getTarea();
				this.$emit('actualizar');
			}
		}
	}
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'comentarios',
	props: ['tarea'],

	data: function data() {
		return {
			texto: null
		};
	},

	methods: {
		enviar: function enviar() {
			var _this = this;

			var datos = {
				ID_tarea: this.tarea.ID_tarea,
				comentario: this.texto
			};

			__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].setComentarioTarea(datos).then(function (res) {
				_this.$emit('update:tarea', res.data.tarea);
				_this.texto = null;
			}).catch(function (e) {
				_this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editor-texto',
	props: ['version', 'focoactivo'],

	data: function data() {
		return {
			ID_version: null,
			locutorActual: null,
			atajos: {
				ctrl: false
			},
			foco: {
				tipo: null,
				posicion: null,
				index: null
			}
		};
	},

	created: function created() {
		if (this.version) {
			if (this.version.textos.length === 0) {
				this.nuevoTexto('loc', 1);
			}
		}

		window.addEventListener('keydown', this.teclaPulsada);
		window.addEventListener('keyup', this.teclaLiberada);
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('keydown', this.teclaPulsada);
		window.removeEventListener('keyup', this.teclaLiberada);
	},
	mounted: function mounted() {
		this.calculaAlturas();
	},
	updated: function updated() {
		this.calculaAlturas();
		this.actualiza();
	},


	computed: {
		listaLocutores: function listaLocutores() {
			var textos = this.version.textos;

			var locs = [];
			for (var i = 0; i < textos.length; i++) {
				if (textos[i].tipo !== 'tec') {
					var l = textos[i].tipo + textos[i].numero;

					if (locs.indexOf(l) < 0) {
						locs.push(l);
					}
				}
			}

			return locs.sort();
		}
	},

	methods: {
		enfocado: function enfocado(obj, index) {
			this.foco.tipo = obj.tipo;
			this.foco.posicion = obj.posicion;
			this.foco.index = index;
		},
		teclaPulsada: function teclaPulsada(e) {
			if (!this.focoactivo) {
				return;
			}
			if (e.keyCode === 17) {
				this.atajos.ctrl = true;
			} else {
				if (this.atajos.ctrl) {
					switch (e.keyCode) {
						case 38:
							if (this.foco.tipo !== null) {
								this.guardaTexto(this.foco.index);
								this.nuevoTexto(this.foco.tipo, this.foco.posicion, 0);
							}
							break;
						case 40:
							if (this.foco.tipo !== null) {
								this.guardaTexto(this.foco.index);
								this.nuevoTexto(this.foco.tipo, this.foco.posicion + 1, 1);
							}
							break;
					}
				}
			}
		},
		teclaLiberada: function teclaLiberada(e) {
			if (!this.focoactivo) {
				return;
			}
			if (e.keyCode === 17) {
				this.atajos.ctrl = false;
			}
		},
		validaNumero: function validaNumero(i) {
			var num = parseInt(this.version.textos[i].numero);
			this.version.textos[i].numero = num <= 0 ? 1 : num;
		},
		calculaAlturas: function calculaAlturas() {
			var txt = this.$el.querySelectorAll('textarea');

			if (txt) {
				txt.forEach(function (el) {
					el.style.cssText = 'height:auto; padding:0';
					// for box-sizing other than 'content-box' use:
					// el.style.cssText = '-moz-box-sizing:content-box'
					el.style.cssText = 'height:' + (el.scrollHeight + 10) + 'px';
				});
			}
		},
		setTipo: function setTipo(texto, tipo) {
			var _this = this;

			var datos = {
				ID_texto: texto.ID_texto,
				ID_tarea: this.version.tarea_ID,
				ID_version: this.version.ID_version,
				tipo: tipo,
				texto: texto.texto,
				posicion: texto.posicion,
				numero: texto.numero
			};

			__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].setTexto(datos).then(function (res) {
				_this.actualiza(res.data.version);
			}).catch(function (e) {
				_this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		permisoBorrar: function permisoBorrar(i) {
			if (i === 0 && this.version.textos.length === 1) {
				return false;
			}

			return true;
		},
		nuevoTexto: function nuevoTexto(tipo, posicion, idx) {
			var _this2 = this;

			var datos = {
				ID_tarea: this.version.tarea_ID,
				ID_version: this.version.ID_version,
				tipo: tipo,
				posicion: posicion,
				numero: 1
				// creamos el texto en el backend
			};__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].setTexto(datos).then(function (res) {
				_this2.actualiza(res.data.version);
				if (idx === 0) {
					window.setTimeout(function () {
						_this2.$refs.texto[_this2.foco.index].focus();
					}, 200);
				} else if (idx === 1) {
					window.setTimeout(function () {
						_this2.$refs.texto[_this2.foco.index + 1].focus();
					}, 200);
				}
			}).catch(function (e) {
				_this2.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response ? e.response.data.error : 'Error'
				});
			});
		},
		guardaTexto: function guardaTexto(i) {
			var _this3 = this;

			var texto = this.version.textos[i];
			// Guardamos los datos del texto en el servidor
			var datos = {
				ID_texto: texto.ID_texto,
				ID_tarea: this.version.tarea_ID,
				ID_version: this.version.ID_version,
				tipo: texto.tipo,
				texto: texto.texto,
				posicion: texto.posicion,
				numero: texto.numero
			};

			__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].setTexto(datos).then(function (res) {
				_this3.actualiza(res.data.version);
			}).catch(function (e) {
				_this3.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		quitarTexto: function quitarTexto(idTexto) {
			var _this4 = this;

			var datos = {
				ID_texto: idTexto,
				ID_version: this.version.ID_version
			};

			__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].delTexto(datos).then(function (res) {
				_this4.actualiza(res.data.version);
			}).catch(function (e) {
				_this4.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		ajustaCaja: function ajustaCaja(ev) {
			var el = ev.srcElement;

			if (!el) {
				return;
			}
			setTimeout(function () {
				el.style.cssText = 'height:auto; padding:0';
				el.style.overflow = 'hidden';
				el.style.resize = 'none';
				// for box-sizing other than 'content-box' use:
				// el.style.cssText = '-moz-box-sizing:content-box'
				el.style.cssText = 'height:' + (el.scrollHeight + 10) + 'px';
			}, 0);
		},
		actualiza: function actualiza(version) {
			if (version) {
				this.$emit('update:version', version);
			}
		}
	}
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'visualiza-texto',
	props: ['version', 'tarea'],

	data: function data() {
		return {};
	},

	computed: {},

	methods: {
		getAvatar: function getAvatar(tipo, num) {
			var titulo = tipo.toString() + num.toString();

			for (var i = 0; i < this.version.locutores.length; i++) {
				if (this.version.locutores[i].titulo === titulo) {
					if (this.version.locutores[i].info !== null) {
						return this.version.locutores[i].info.avatar;
					} else if (tipo === 'loc') {
						return '/static/recursos/hombre.svg';
					} else if (tipo === 'loca') {
						return '/static/recursos/mujer.svg';
					} else if (tipo === 'locx') {
						return '/static/recursos/otro.svg';
					} else {
						return '/static/recursos/hombre.svg';
					}
				}
			}
		},
		setTextoGrabado: function setTextoGrabado(idTexto, grabado) {
			var _this = this;

			if (this.tarea.fase === 'finalizada') {
				return;
			}
			var datos = {
				ID_version: this.version.ID_version,
				ID_texto: idTexto,
				grabado: grabado
			};

			__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].setTextoGrabado(datos).then(function (res) {
				_this.actualiza(res.data.version);
			}).catch(function (e) {
				_this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		actualiza: function actualiza(version) {
			this.$emit('update:version', version);
		}
	}
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccion_locutor_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb83314_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_seleccion_locutor_vue__ = __webpack_require__(1421);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccion_locutor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fb83314_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_seleccion_locutor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editor_locutor__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'selecciona-locutor',
	components: {
		'editor-locutor': __WEBPACK_IMPORTED_MODULE_0__editor_locutor__["a" /* default */]
	},
	props: ['etiqueta', 'tarea'],
	data: function data() {
		return {
			filtro: '',
			listado: [],
			habituales: [],
			seleccionado: null,
			editando: null
		};
	},

	created: function created() {
		var _this = this;

		var tipo = this.etiqueta.replace(/[^a-zA-Z]/g, '');
		// Buscamos los locutores habituales
		__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getLocutoresHabituales(tipo, this.tarea.produccion.anunciante_ID).then(function (res) {
			_this.habituales = res.data.listado;
		}).catch(function (e) {
			_this.$store.commit('alertas/nueva', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},


	methods: {
		buscar: function buscar() {
			var _this2 = this;

			if (this.filtro === '') {
				this.listado = [];
				return;
			}
			__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].queryLocutores({ cadena: this.filtro }).then(function (res) {
				_this2.listado = res.data.listado;
			}).catch(function (e) {
				_this2.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		selecciona: function selecciona(locutor) {
			this.$emit('seleccion', locutor);
		},
		nuevo: function nuevo() {
			this.editando = {
				ID_locutor: null,
				nombre: '',
				apellidos: '',
				avatar: '/media/static/hombre.svg',
				email: '',
				telefono: '',
				procedencia_ID: null,
				sexo: 'hombre',
				estilos: [],
				activo: true
			};
		},
		editar: function editar(loc) {
			this.editando = loc;
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cropper_crop_image__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editor-locutor',
	props: ['locutor'],
	components: {
		'set-avatar': __WEBPACK_IMPORTED_MODULE_1__cropper_crop_image__["a" /* default */]
	},

	data: function data() {
		return {
			setAvatar: false,
			listadoProcedencias: [],
			avatar: null,
			nuevoAvatar: false,
			nuevaProcedencia: false,
			nuevaProcedenciaValue: ''
		};
	},

	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getProcedencias().then(function (res) {
			_this.listadoProcedencias = res.data.procedencias;
		}).catch(function (e) {
			_this.$store.commit('alertas/nueva', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},


	computed: {
		avatarData: function avatarData() {
			if (this.nuevoAvatar) {
				return this.avatar;
			} else {
				return this.locutor.avatar;
			}
		}
	},

	methods: {
		setNuevoAvatar: function setNuevoAvatar(e) {
			this.avatar = e;
			this.nuevoAvatar = true;
		},
		setSexo: function setSexo(sexo) {
			this.locutor.sexo = sexo;

			if (this.locutor.avatar.match(/\.svg$/)) {
				this.locutor.avatar = sexo === 'hombre' ? '/media/static/hombre.svg' : '/media/static/mujer.svg';
			}
		},
		setEstilo: function setEstilo(ev) {
			this.locutor.estilos.push(ev.target.value.toLowerCase());
			ev.target.value = '';
		},
		quitaEstilo: function quitaEstilo(estilo) {
			this.locutor.estilos.splice(this.locutor.estilos.indexOf(estilo), 1);
		},
		setProcedencia: function setProcedencia(e) {
			if (e.target.value === 'nuevo') {
				this.nuevaProcedencia = true;
			} else {
				this.locutor.procedencia_ID = e.target.value;
			}
		},
		guardaProcedencia: function guardaProcedencia() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setProcedencia({ nombre: this.nuevaProcedenciaValue }).then(function (res) {
				_this2.listadoProcedencias.push(res.data.procedencia);
				_this2.locutor.procedencia = res.data.procedencia.ID_procedencia;

				_this2.nuevaProcedenciaValue = '';
				_this2.nuevaProcedencia = false;
			}).catch(function (e) {
				_this2.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		guardar: function guardar() {
			var _this3 = this;

			var form = new FormData();
			form.append('locutor', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locutor));

			if (this.nuevoAvatar) {
				form.append('avatar', this.avatar);
			}

			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setLocutor(form).then(function (res) {
				_this3.$store.commit('alertas/alert', {
					titulo: 'Cambios guardados',
					mensaje: 'Se han guardado los cambios correctamente'
				});
			}).catch(function (e) {
				_this3.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'set-avatar',

	data: function data() {
		return {
			url: null
		};
	},

	methods: {
		setImg: function setImg(url) {
			this.url = url;
		},
		confirmar: function confirmar() {
			this.$emit('img', this.url);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'rechazo-tarea',
	props: ['tarea', 'version'],
	data: function data() {
		return {
			form: {
				ID_version: null,
				cambiaTexto: true,
				descripcion: '',
				motivos: []
			},
			motivos: {
				'cliente': [],
				'agente': [],
				'marketing': [],
				'tecnico': []
			}
		};
	},

	created: function created() {
		var _this = this;

		// Obtenemos los motivos de rechazo
		this.form.ID_version = this.version.ID_version;

		__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].getMotivosRechazo().then(function (res) {
			_this.motivos = res.data.motivos;
		}).catch(function (e) {
			_this.$store.commit('alertas/nueva', {
				titulo: 'Error',
				mensaje: e.response.data.error
			});
		});
	},


	computed: {
		motivosDeQuien: function motivosDeQuien() {
			if (this.tarea.fase.match(/pteAprobar/)) {
				return 'Motivos del agente';
			} else if (this.tarea.fase === 'pteIdea') {
				return 'Motivos de márketing';
			} else if (this.tarea.fase === 'pteProduccion') {
				return 'Motivos de técnica';
			} else {
				return '';
			}
		}
	},

	methods: {
		toggleMotivo: function toggleMotivo(motivo) {
			var i = this.form.motivos.indexOf(motivo);
			if (i >= 0) {
				this.form.motivos.splice(i, 1);
			} else {
				this.form.motivos.push(motivo);
			}
		},
		esMotivo: function esMotivo(motivo) {
			return this.form.motivos.indexOf(motivo) >= 0;
		},
		doRechazar: function doRechazar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].setRechazarVersion(this.form).then(function (res) {
				// Se ha rechazado correctamente, recibimos la nueva versión
				_this2.$emit('nueva', res.data.version);
				_this2.cerrar();
				_this2.$store.commit('toast/success', {
					titulo: 'Tarea rechazada',
					mensaje: 'Se ha rechazado la tarea correctamente'
				});
			}).catch(function (e) {
				_this2.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nueva_tarea__ = __webpack_require__(611);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['tarea'],
	name: 'editando-tarea',
	components: {
		'editor-tarea': __WEBPACK_IMPORTED_MODULE_0__nueva_tarea__["a" /* default */]
	},
	created: function created() {},
	methods: {
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		emiteActualizar: function emiteActualizar(eliminada) {
			this.$emit('actualizar', eliminada);
		}
	}
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tarea_vue__ = __webpack_require__(612);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_051a6197_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tarea_vue__ = __webpack_require__(1426);
function injectStyle (ssrContext) {
  __webpack_require__(1425)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-051a6197"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_051a6197_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['tarea', 'index'],
	name: 'tarea',
	data: function data() {
		return {
			listadoSoportes: [],
			nuevoFicheroIndex: 0,
			salvado: false,
			disabledInicio: {
				to: new Date(new Date().getTime() + 172800000)
			},
			disabledFin: {
				to: new Date(new Date().getTime() + 172800000)
			}
		};
	},

	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getSoportes().then(function (res) {
			_this.listadoSoportes = res.data.soportes;
		}).catch(function (e) {
			console.error(e);
		});
	},


	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	}), {
		esFaseInicial: function esFaseInicial() {
			return typeof this.tarea.fase === 'undefined' || this.tarea.fase === 'pteIdea' || this.tarea.fase === '' || this.tarea.fase === null;
		}
	}),

	methods: {
		toggleExpress: function toggleExpress() {
			if (!this.tarea.express_fecha) {
				this.tarea.express = typeof this.tarea.express === 'boolean' ? !this.tarea.express : true;
			}
		},
		quitarTarea: function quitarTarea() {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmación',
				mensaje: '\xBFQuieres eliminar esta tarea?\n\t\t\t\tTodos los datos relacionados (inclu\xEDdos ficheros) ser\xE1n eliminados.\n\t\t\t\tEsta acci\xF3n no se puede deshacer.',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].delTarea(_this2.tarea.ID_tarea).then(function (res) {
							_this2.$emit('quitar');
							_this2.emiteActualizar(true);
						}).catch(function (e) {
							console.error(e);
						});
					}
				}
			});
		},
		setSoporte: function setSoporte(e) {
			var _this3 = this;

			var datos = {
				ID_tarea: this.tarea.ID_tarea,
				ID_soporte: e.datos.ID_soporte
			};

			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].tareaAddSoporte(datos).then(function (res) {
				_this3.$emit('update:tarea', res.data.tarea);
				_this3.emiteActualizar();
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		quitaSoporte: function quitaSoporte(soporte) {
			var _this4 = this;

			var datos = {
				ID_tarea: this.tarea.ID_tarea,
				ID_soporte: soporte.ID_soporte
			};

			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].tareaDelSoporte(datos).then(function (res) {
				_this4.$emit('update:tarea', res.data.tarea);
				_this4.emiteActualizar();
			}).catch(function (e) {
				_this4.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		nuevoFichero: function nuevoFichero() {
			var _this5 = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.setAttribute('multiple', 'true');
			inp.addEventListener('change', function (ev) {
				var ficheros = ev.srcElement.files;
				var form = new FormData();
				form.append('ID_tarea', _this5.tarea.ID_tarea);

				for (var i = 0; i < ficheros.length; i++) {
					form.append('fichero[]', ficheros[i]);
				}

				__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].tareaAddFicheros(form).then(function (res) {
					_this5.$emit('update:tarea', res.data.tarea);

					_this5.emiteActualizar();
				}).catch(function (e) {
					console.error(e);
				});

				document.body.removeChild(inp);
			});
			inp.style.display = 'none';

			document.body.appendChild(inp);

			inp.click();
		},
		quitaFichero: function quitaFichero(idFichero) {
			var _this6 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmación',
				mensaje: '\xBFQuieres eliminar este fichero?\n\t\t\t\tEsta acci\xF3n no se puede deshacer',
				callback: function callback(acepta) {
					if (acepta) {
						var datos = {
							ID_tarea: _this6.tarea.ID_tarea,
							ID_fichero: idFichero
						};

						__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].tareaDelFichero(datos).then(function (res) {
							_this6.$emit('update:tarea', res.data.tarea);
							_this6.emiteActualizar();
						}).catch(function (e) {
							console.error(e);
						});
					}
				}
			});
		},
		solicitarExpress: function solicitarExpress() {
			var _this7 = this;

			if (!this.tarea.express_motivos) {
				this.$error('Error', 'Debes escribir los motivos por los que solicitas esta tarea express');
				return;
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Crear tarea express',
				mensaje: 'Una vez crees esta tarea como express, ya no podr\xE1s cambiar su estado.\n\t\t\t\t\xBFQuieres continuar?',
				callback: function callback(acepta) {
					if (acepta) {
						var datos = {
							ID_tarea: _this7.tarea.ID_tarea,
							motivos: _this7.tarea.express_motivos
						};
						__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setTareaExpress(datos).then(function (res) {
							_this7.$emit('update:tarea', res.data.tarea);
							_this7.emiteActualizar();
							_this7.$store.commit('toast/success', {
								titulo: 'Tarea express',
								mensaje: 'Se ha marcado la tarea como express'
							});
						}).catch(_this7.$responseError);
					}
				}
			});
		},
		guardarTarea: function guardarTarea() {
			var _this8 = this;

			var tarea = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tarea));
			tarea.fecha_inicio = this.$moment(this.tarea.fecha_inicio).format('DD/MM/YYYY');
			tarea.fecha_fin = this.$moment(this.tarea.fecha_fin).format('DD/MM/YYYY');
			console.log(tarea.fecha_inicio);
			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setTarea(tarea).then(function (res) {
				_this8.$emit('update:tarea', res.data.tarea);
				_this8.emiteActualizar();
			}).catch(function (e) {
				console.error(e);
			});
		},
		emiteActualizar: function emiteActualizar(eliminada) {
			var _this9 = this;

			eliminada = typeof eliminada === 'boolean' ? eliminada : false;
			this.$emit('actualizar', eliminada);

			this.salvado = true;
			window.setTimeout(function () {
				_this9.salvado = false;
			}, 2000);
		}
	}
});

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nueva_nueva__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editando-produccion',
	props: ['idproduccion'],
	components: {
		'nueva-produccion': __WEBPACK_IMPORTED_MODULE_0__nueva_nueva__["a" /* default */]
	},

	data: function data() {
		return {
			produccion: null
		};
	},

	created: function created() {
		// Descargamos los datos de la producción
		this.getProduccion();
	},


	methods: {
		getProduccion: function getProduccion() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getProduccion(this.idproduccion).then(function (res) {
				_this.produccion = res.data.produccion;
			}).catch(function (e) {
				_this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		emiteActualizar: function emiteActualizar() {
			this.$emit('actualizar');
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nueva_vue__ = __webpack_require__(615);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3969e41e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nueva_vue__ = __webpack_require__(1433);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nueva_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3969e41e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nueva_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orden__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tarea__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['idOrden'],
	components: {
		'tarea': __WEBPACK_IMPORTED_MODULE_1__tarea__["a" /* default */],
		'editor-orden': __WEBPACK_IMPORTED_MODULE_0__orden__["a" /* default */]
	},
	data: function data() {
		return {
			produccion: null,
			nuevaTareaIndex: 1,
			nuevoFicheroIndex: 1,
			verAsociar: false
		};
	},

	created: function created() {
		var _this = this;

		if (this.idOrden) {
			// Hemos recibido una órden, por lo que vamos a cargarla
			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].getProduccion(this.idOrden).then(function (res) {
				_this.produccion = res.data.produccion;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		} else {
			this.nuevaProduccion();
		}
	},


	methods: {
		nuevaProduccion: function nuevaProduccion() {
			this.produccion = {
				ID_produccion: null,
				titulo: null,
				publica: 0,
				externa: 0,
				contrato: {
					ID_contrato: null,
					titulo: null,
					nombreCliente: null
				},
				anunciante: {
					ID_anunciante: null,
					nombre: null
				},
				descripcion: null,
				agente: {
					ID: null,
					nombre: null
				},
				ficheros: [],
				tareas: []
			};
		},
		nuevaTarea: function nuevaTarea() {
			var _this2 = this;

			var tarea = {
				produccion_ID: this.produccion.ID_produccion,
				ID_tarea: null,
				tipo: null,
				descripcion: null,
				fecha_inicio: new Date(),
				fecha_fin: new Date()
			};

			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setTarea(tarea).then(function (res) {
				_this2.produccion.tareas.push(res.data.tarea);
				_this2.emiteActualizar();
			}).catch(function (e) {
				console.error(e);
			});
		},
		quitarTarea: function quitarTarea(i) {
			this.produccion.tareas.splice(i, 1);

			if (this.produccion.tareas.length === 0) {
				// Se ha eliminado la producciópn también
				this.nuevaProduccion();
			}
		},
		emiteActualizar: function emiteActualizar() {
			this.$emit('actualizar');
		},
		finalizar: function finalizar() {
			this.nuevaProduccion();
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__asocia_contrato__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editor-orden',
	props: ['produccion', 'editando'],
	components: {
		'asocia-contrato': __WEBPACK_IMPORTED_MODULE_1__asocia_contrato__["a" /* default */]
	},

	data: function data() {
		return {
			verAsociar: false,
			salvado: false
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	}), {
		hayAnunciante: function hayAnunciante() {
			return this.produccion.anunciante.ID_anunciante !== null;
		},
		permisoEditaContrato: function permisoEditaContrato() {
			// Si tiene permiso para editar siempre los contratos le dejamos
			if (this.permisos.produccion_editaContratosSiempre) {
				return true;
			}
			// Podrá editar si todavía no lo ha asociado a ningún contrato
			if (!this.produccion.contrato || !this.produccion.contrato.ID_contrato) {
				return true;
			}

			// No podrá editarlo si ya ha finalizado alguna tarea
			for (var i = 0; i < this.produccion.tareas.length; i++) {
				if (this.produccion.tareas[i].fase === 'finalizada') {
					return false;
				}
			}

			// En cualquier otro caso, si
			return true;
		}
	}),

	methods: {
		setPublica: function setPublica(estado) {
			this.produccion.publica = estado;
			this.guardar();
		},
		setExterna: function setExterna(estado) {
			this.produccion.externa = estado;
			this.guardar();
		},
		nuevaOrden: function nuevaOrden() {
			this.$emit('nueva');
		},
		seleccionaAnunciante: function seleccionaAnunciante(datos) {
			this.produccion.anunciante.ID_anunciante = datos.datos.ID_anunciante;
			this.produccion.anunciante.nombre = datos.datos.nombre;
			this.guardar();
		},
		quitaAnunciante: function quitaAnunciante() {
			this.produccion.anunciante = {
				ID_anunciante: null,
				nombre: null
			};
		},
		asociaContrato: function asociaContrato(datos) {
			this.produccion.contrato.ID_contrato = datos.ID_contrato;
			this.produccion.contrato.titulo = datos.titulo;
			this.produccion.contrato.nombreCliente = datos.nombreCliente;
			this.verAsociar = false;

			this.guardar();
		},
		cambiaContrato: function cambiaContrato() {
			this.produccion.contrato = {
				ID_contrato: null,
				titulo: null
			};
		},
		nuevoFichero: function nuevoFichero() {
			var _this = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.setAttribute('multiple', 'true');
			inp.addEventListener('change', function (ev) {
				var form = new FormData();
				form.append('ID_produccion', _this.produccion.ID_produccion);
				var ficheros = ev.srcElement.files;

				for (var i = 0; i < ficheros.length; i++) {
					form.append('fichero[]', ficheros[i]);
				}

				// enviamos
				__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setFicherosProduccion(form).then(function (res) {
					// this.produccion = res.data.produccion
					_this.$emit('update:produccion', res.data.produccion);
					_this.emiteActualizar();
				}).catch(function (e) {
					console.error(e);
				});

				document.body.removeChild(inp);
			});
			inp.style.display = 'none';

			document.body.appendChild(inp);

			inp.click();
		},
		quitaFichero: function quitaFichero(idFichero) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmación',
				mensaje: '¿Quieres eliminar este fichero?\n\nEsta acción no se puede deshacer',
				callback: function callback(acepta) {
					if (acepta) {
						var datos = {
							ID_produccion: _this2.produccion.ID_produccion,
							ID_fichero: idFichero
						};

						__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].delFicherosProduccion(datos).then(function (res) {
							// this.produccion = res.data.produccion
							_this2.$emit('update:produccion', res.data.produccion);
							_this2.emiteActualizar();
						}).catch(function (e) {
							_this2.$store.commit('alertas/alert', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		},
		guardar: function guardar() {
			var _this3 = this;

			if (!this.produccion.anunciante.ID_anunciante) {
				console.error('Debes seleccionar un anunciante');
				return;
			}

			if (!this.produccion.titulo) {
				console.error('Debes proporcionar un título');
				return;
			}

			if (!this.produccion.contrato.ID_contrato) {
				console.info('No has asociado la producción a ningún contrato.\n\nTen en cuenta que deberás hacerlo antes de finalizarla');
			}

			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].setProduccion(this.produccion).then(function (res) {
				_this3.emiteActualizar();
				_this3.$emit('update:produccion', res.data.produccion);
			}).catch(function (e) {
				console.error(e);
			});
		},
		emiteActualizar: function emiteActualizar() {
			var _this4 = this;

			this.$emit('actualizar');

			this.salvado = true;

			window.setTimeout(function () {
				_this4.salvado = false;
			}, 2000);
		}
	}
});

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asocia_contrato_vue__ = __webpack_require__(618);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ce5d8dd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_asocia_contrato_vue__ = __webpack_require__(1431);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asocia_contrato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ce5d8dd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_asocia_contrato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'asocia-contrato',
	data: function data() {
		return {
			cadena: null,
			listadoContratos: []
		};
	},

	created: function created() {
		this.buscar();
	},


	methods: {
		buscar: function buscar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].buscaContratos({ cadena: this.cadena }).then(function (res) {
				_this.listadoContratos = res.data.contratos;
			}).catch(function (e) {
				console.error(e);
			});
		},
		asignalo: function asignalo(payload) {
			this.$emit('asignar', payload);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auditor_detalles__ = __webpack_require__(620);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'reproductor',
	props: ['fichero'],
	components: {
		'detalles-auditor': __WEBPACK_IMPORTED_MODULE_0__auditor_detalles__["a" /* default */]
	},

	data: function data() {
		return {
			verAuditor: false
		};
	},

	computed: {
		tipoFichero: function tipoFichero() {
			if (!this.fichero) {
				return;
			}
			var ext = this.fichero.fichero.fichero.split('.').splice(-1, 1)[0].toLowerCase();

			if (ext.match(/(mp3|ogg|mp2)/)) {
				return 'audio';
			}

			if (ext.match(/(mp4|webm)/)) {
				return 'video';
			}

			if (ext.match(/(jpeg|jpg|gif|bmp|png)/)) {
				return 'imagen';
			}

			return 'desconocido';
		},
		url: function url() {
			return '/src/modulos/produccion/php/api/descargar.php?ID_fichero=' + this.fichero.fichero.ID_fichero + '&tipo=' + this.fichero.tipo;
		},
		tamano: function tamano() {
			if (!this.fichero) {
				return '0 kB';
			}

			var bytes = this.fichero.fichero.tamano;
			var si = true;
			var thresh = si ? 1000 : 1024;
			if (Math.abs(bytes) < thresh) {
				return bytes + ' B';
			}
			var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
			var u = -1;
			do {
				bytes /= thresh;
				++u;
			} while (Math.abs(bytes) >= thresh && u < units.length - 1);
			return bytes.toFixed(1) + ' ' + units[u];
		}
	},

	methods: {
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_vue__ = __webpack_require__(621);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2039fba6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_vue__ = __webpack_require__(1441);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2039fba6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_descargar__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'detalles',
	props: ['idfichero', 'idversion'],
	components: {
		'modal-descargar': __WEBPACK_IMPORTED_MODULE_0__modal_descargar__["a" /* default */]
	},
	watch: {
		idfichero: function idfichero(nuevo) {
			if (nuevo) {
				this.auditar();
			}
		}
	},

	data: function data() {
		return {
			radiacion: {
				emitidos: [],
				programados: []
			},
			auditando: false,
			verTipo: 'programados',
			descargando: false
		};
	},

	created: function created() {
		this.auditar();
	},

	computed: {
		detalles: function detalles() {
			if (this.radiacion.programados.length === 0) {
				return [];
			}

			var arr = {};

			for (var emisora in this.radiacion.programados) {
				var items = this.radiacion.programados[emisora];
				arr[emisora] = arr[emisora] ? arr[emisora] : { items: [], emitidos: 0 };

				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					item.emisora = emisora;

					var idProg = items[i].ID_programacion;

					for (var emi in this.radiacion.emitidos) {
						var emis = this.radiacion.emitidos[emi];

						for (var e = 0; e < emis.length; e++) {
							if (idProg === emis[e].ID_programacion) {
								item.emitido = emis[e];
								arr[emisora].emitidos++;
							}
						}
					}

					arr[emisora].items.push(item);
				}
			}

			return arr;
		},
		detallesEmitidos: function detallesEmitidos() {
			if (this.radiacion.emitidos.length === 0) {
				return [];
			}

			var arr = {};

			for (var emisora in this.radiacion.emitidos) {
				arr[emisora] = !arr[emisora] ? [] : arr[emisora];
				arr[emisora] = arr[emisora].concat(this.radiacion.emitidos[emisora]);
			}

			return arr;
		}
	},

	methods: {
		auditar: function auditar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getAuditor(this.idfichero).then(function (res) {
				_this.auditando = _this.idfichero;
				var emitidos = res.data.emitidos;

				var e = {};

				for (var i = 0; i < emitidos.length; i++) {
					var idProgramacion = emitidos[i].ID_programacion;
					var emisora = emitidos[i].emisora_nombre;

					e[emisora] = e[emisora] ? e[emisora] : [];

					e[emisora].push({
						fecha: emitidos[i].fecha_unix * 1000,
						ID_programacion: idProgramacion
					});
				}

				_this.radiacion.emitidos = e;
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});

			// AHora la programación
			__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getProgramacion(this.idfichero).then(function (res) {
				var programados = res.data.programados;
				var prog = {};

				for (var i = 0; i < programados.length; i++) {
					var emisora = programados[i].emisora_descripcion;

					prog[emisora] = prog[emisora] ? prog[emisora] : [];
					prog[emisora].push({
						fecha: programados[i].unix_inicio * 1000,
						emisora: emisora,
						ID_programacion: programados[i].programacion_ID
					});
				}
				_this.radiacion.programados = prog;
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		descargar: function descargar() {
			this.descargando = true;
		}
	}
});

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'modal-descargar',
	props: ['idfichero', 'idversion'],

	data: function data() {
		return {
			form: {
				verListado: false,
				verProgramacion: false,
				verEmision: false,
				verEstadisticas: false,
				verStatsProgreso: false,
				verStatsHoras: false,
				verStatsPresencia: false
			},
			link: null,
			generando: false
		};
	},

	computed: {
		haySeleccion: function haySeleccion() {
			for (var i in this.form) {
				if (this.form[i]) {
					return true;
				}
			}
		}
	},

	methods: {
		generar: function generar() {
			var _this = this;

			this.form.verListado = this.form.verProgramacion || this.form.verEmision;
			this.form.verEstadisticas = this.form.verStatsPresencia || this.form.verStatsProgreso || this.form.verStatsHoras;

			var datos = {
				ID_fichero: this.idfichero,
				ID_version: this.idversion,
				data: this.form
			};

			this.link = null;
			this.generando = true;

			__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].getProgramacionPDF(datos).then(function (res) {
				_this.link = res.data.link;
				_this.generando = false;
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
				_this.generando = false;
			});
		},
		descargar: function descargar() {
			window.location.href = this.link;
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/listado.f7a4dc4.png";

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'listado-versiones',
	props: ['tarea', 'actual'],
	data: function data() {
		return {};
	},

	methods: {
		selecciona: function selecciona(version) {
			var anterior = null;
			for (var i = 0; i < this.tarea.versiones.length; i++) {
				if (this.tarea.versiones[i].ID_version === version.ID_version) {
					if (i > 0) {
						anterior = this.tarea.versiones[i - 1];
					}
				}
			}

			this.$emit('cambia-version', {
				actual: version,
				anterior: anterior
			});
		}
	}
});

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'historial',
	props: ['idtarea'],
	data: function data() {
		return {
			fases: [],
			diaSem: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb']
		};
	},

	created: function created() {
		// Descargamos el historial de esta tarea
		this.getHistorial();
	},


	methods: {
		getHistorial: function getHistorial() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* default */].getHistorial(this.idtarea).then(function (res) {
				var historial = res.data.historial;
				for (var i = 0; i < historial.length; i++) {
					historial[i].fecha = new Date(historial[i].fecha);
				}
				_this.fases = historial;
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		getAccion: function getAccion(fase) {
			switch (fase) {
				case 'creada':
					return 'Versión creada';
				case 'pteIdea':
					return 'Pendiente de creatividad';
				case 'pteAprobarIdea':
					return 'Pendiente de aprobar idea creativa';
				case 'pteProduccion':
					return 'Pendiente de producción';
				case 'pteAprobarProduccion':
					return 'Pendiente de aprobar producción';
				case 'finalizada':
					return 'Tarea finalizada';
				case 'rechazada':
					return 'Versión rechazada';
				default:
					return 'Fase no reconocida';
			}
		},
		getClase: function getClase(fase) {
			switch (fase) {
				case 'creada':
					return 'bg-info text-white';
				case 'pteIdea':
					return 'bg-light';
				case 'pteAprobarIdea':
					return 'bg-warning';
				case 'pteProduccion':
					return 'bg-light';
				case 'pteAprobarProduccion':
					return 'bg-warning';
				case 'finalizada':
					return 'bg-success';
				case 'rechazada':
					return 'bg-danger text-white';
				default:
					return 'Fase no reconocida';
			}
		},
		getIcono: function getIcono(fase) {
			switch (fase) {
				case 'creada':
					return 'fa fa-new';
				case 'pteIdea':
					return 'fa fa-light';
				case 'pteAprobarIdea':
					return 'fa fa-check';
				case 'pteProduccion':
					return 'fa fa-gear';
				case 'pteAprobarProduccion':
					return 'fa fa-check';
				case 'finalizada':
					return 'fa fa-finish';
				case 'rechazada':
					return 'fa fa-ban';
				default:
					return 'fa fa-question';
			}
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			inicioCrono: 0,
			tiempoCrono: '0:00:00.000',
			offsetCrono: 0,
			momentoPause: null,
			hCrono: null,
			statusCrono: 'stop',
			tiempoActual: null
		};
	},


	methods: {
		startCrono: function startCrono() {
			var _this = this;

			if (this.hCrono) {
				return;
			}

			this.hCrono = window.setInterval(function () {
				if (!_this.inicioCrono) {
					_this.inicioCrono = new Date().getTime();
				}

				var ahora = new Date().getTime();

				if (_this.momentoPause) {
					_this.offsetCrono += ahora - _this.momentoPause;
					_this.momentoPause = null;
				}

				_this.tiempoActual = new Date(ahora - _this.inicioCrono - _this.offsetCrono);
				var hora = _this.tiempoActual.getHours() - 1;
				var minutos = _this.tiempoActual.getMinutes() < 10 ? '0' + _this.tiempoActual.getMinutes() : _this.tiempoActual.getMinutes();
				var segundos = _this.tiempoActual.getSeconds() < 10 ? '0' + _this.tiempoActual.getSeconds() : _this.tiempoActual.getSeconds();
				var milisec = _this.tiempoActual.getMilliseconds();
				milisec = milisec < 100 ? milisec < 10 ? '00' + milisec : '0' + milisec : milisec;

				_this.tiempoCrono = hora + ':' + minutos + ':' + segundos + '.' + milisec;
			}, 10);
		},
		resetCrono: function resetCrono() {
			if (!this.momentoPause) {
				return;
			}
			if (this.hCrono) {
				window.clearInterval(this.hCrono);
			}
			this.tiempoCrono = '0:00:00.000';
			window.clearInterval(this.hCrono);
			this.hCrono = null;
			this.offsetCrono = 0;
			this.inicioCrono = null;
			this.momentoPause = null;
		},
		pauseCrono: function pauseCrono() {
			this.momentoPause = new Date().getTime();
			window.clearInterval(this.hCrono);
			this.hCrono = null;
		},
		confirmar: function confirmar() {
			var _this2 = this;

			var total = Math.round((this.tiempoActual.getTime() + 2000) / 1000);
			var horas = total < 3600 ? 0 : Math.floor(total / 3600);
			var minutos = total % 3600 < 0 ? 0 : Math.floor(total % 3600 / 60);
			var segundos = total < 60 ? total : total < 3600 ? Math.floor(total % 60) : Math.floor(total % 3600);

			var cadena = '';
			if (horas > 0) {
				cadena += horas + ' horas ';
			}
			if (minutos > 0) {
				cadena += minutos + ' minutos ';
			}

			cadena += segundos + ' segundos.';

			this.$store.commit('alertas/confirm', {
				titulo: 'Confirmar tiempo',
				mensaje: '\xBFConfirmas este tiempo como una estimaci\xF3n valida de duraci\xF3n de la cu\xF1a?\n\t\t\t\tA este tiempo se le sumar\xE1n 2 segundos en concepto de ajuste por locuci\xF3n y efectos.\n\t\t\t\tTiempo total estimado: <b>' + cadena + '</b>',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.$emit('tiempo', total);
						_this2.resetCrono();
					}
				}
			});
		}
	}
});

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__seleccion_locutor__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['tarea', 'locutor', 'versionActual'],
	components: {
		'selecciona-locutor': __WEBPACK_IMPORTED_MODULE_2__seleccion_locutor__["a" /* default */]
	},
	data: function data() {
		return {
			locutorActual: null
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos'
	}), {
		esUltima: function esUltima() {
			return this.versionActual.ultima_version.ultima;
		}
	}),
	methods: {
		asignaLocutor: function asignaLocutor(locutor) {
			var _this = this;

			if (!this.locutorActual) {
				return;
			}

			// Veamos si ese locutor ya está asignado
			for (var i = 0; i < this.versionActual.locutores.length; i++) {
				if (this.versionActual.locutores[i].info && this.versionActual.locutores[i].info.ID_locutor === locutor.ID_locutor) {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: 'Este locutor ya está asignado'
					});
					return;
				}
			}

			var datos = {
				ID_version: this.versionActual.ID_version,
				titulo: this.locutorActual,
				ID_locutor: locutor.ID_locutor
			};

			__WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].asignaLocutor(datos).then(function (res) {
				_this.$emit('update:versionActual', res.data.version);
				_this.locutorActual = null;
			}).catch(function (e) {
				_this.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		desasignaLocutor: function desasignaLocutor(loc) {
			var _this2 = this;

			var datos = {
				ID_version: this.versionActual.ID_version,
				titulo: loc,
				ID_locutor: null
			};

			__WEBPACK_IMPORTED_MODULE_3__services_api__["a" /* default */].asignaLocutor(datos).then(function (res) {
				_this2.$emit('update:versionActual', res.data.version);
				_this2.locutorActual = null;
			}).catch(function (e) {
				_this2.$store.commit('alertas/nueva', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		uploadOff: function uploadOff() {
			var inp = this.$refs.input;
			inp.click();
		},
		doUpload: function doUpload(file) {
			console.log('Ey, hacemos un upload');
			var inp = this.$refs.input;
			console.log(inp.files);
		}
	}
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auditor_vue__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_api__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'buscador',
	components: {
		'auditor': __WEBPACK_IMPORTED_MODULE_1__auditor_vue__["a" /* default */]
	},
	data: function data() {
		return {
			descargando: false,
			form: {
				anunciante: '',
				cliente: '',
				agente: '',
				tipo: null,
				estado: 'todas',
				locutores: [],
				externa: null,
				fechaIni: null,
				fechaFin: null,
				procedencia: null,
				xframe: ''
			},
			resultados: [],
			auditando: null,
			limite: 0
		};
	},

	created: function created() {
		this.form.fechaIni = new Date();
		this.form.fechaIni.setMonth(this.form.fechaIni.getMonth() - 2);
		this.buscar();
	},


	methods: {
		buscar: function buscar() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_2__services_api__["a" /* default */].buscaTareas(this.form).then(function (res) {
				_this.resultados = res.data.resultados;
				_this.limite = res.data.limite;
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error ? e.response.data.error : 'Error desconocido'
				});
			});
		},
		descargar: function descargar() {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Descargar audios',
				mensaje: 'Este proceso puede demorarse, por lo que tendrás que tener paciencia. ¿Quieres continuar?',
				callback: function callback(accept) {
					if (accept) {
						_this2.descargando = true;
						var filtro = _this2.form;
						var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filtro));
						if (filtro.fechaIni) {
							filtro.fechaIni.setHours(0);
							filtro.fechaIni.setMinutes(0);
							filtro.fechaIni.setSeconds(0);
						}

						if (filtro.fechaFin) {
							filtro.fechaFin.setHours(23);
							filtro.fechaFin.setMinutes(59);
							filtro.fechaFin.setSeconds(59);
						}
						form.fechaIni = filtro.fechaIni ? Math.floor(filtro.fechaIni.getTime() / 1000) : null;
						form.fechaFin = filtro.fechaFin ? Math.floor(filtro.fechaFin.getTime() / 1000) : null;
						_this2.download('produccion/php/api/descargarAudios.php', form, 'audios.zip', function () {
							_this2.descargando = false;
						});
					}
				}
			});
		},
		seleccionaLocutor: function seleccionaLocutor(datos) {
			for (var i = 0; i < this.form.locutores.length; i++) {
				if (this.form.locutores[i].ID_locutor === datos.datos.ID_locutor) {
					return;
				}
			}

			this.form.locutores.push(datos.datos);

			this.buscar();
		},
		quitaLocutor: function quitaLocutor(loc) {
			for (var i = 0; i < this.form.locutores.length; i++) {
				if (this.form.locutores[i].ID_locutor === loc.ID_locutor) {
					this.form.locutores.splice(i, 1);
					this.buscar();
					return;
				}
			}
		},
		setEstado: function setEstado(est) {
			this.form.estado = est;
			this.buscar();
		},
		setDestino: function setDestino(dest) {
			this.form.externa = dest;
			this.buscar();
		},
		abrir: function abrir(tarea) {
			var datos = {
				ID_tarea: tarea.ID_tarea,
				nombre: tarea.tareaTitulo
			};
			this.$emit('abrir', datos);
		}
	}
});

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auditor_detalles__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'auditor',
	props: ['idtarea'],
	components: {
		'detalles': __WEBPACK_IMPORTED_MODULE_0__auditor_detalles__["a" /* default */]
	},

	data: function data() {
		return {
			radiacion: {
				emitidos: [],
				programados: []
			},
			tarea: null,
			auditando: null,
			verTipo: 'programados'
		};
	},

	created: function created() {
		this.getTarea();

		window.addEventListener('keypress', this.teclaPulsada);
	},


	computed: {
		version: function version() {
			return this.tarea.versiones[this.tarea.versiones.length - 1];
		},
		ficheros: function ficheros() {
			if (!this.tarea) {
				return [];
			}

			var version = this.tarea.versiones[this.tarea.versiones.length - 1];

			var arr = [];

			for (var i = 0; i < version.ficheros.length; i++) {
				if (version.ficheros[i].xframe_ID || version) {
					arr.push(version.ficheros[i]);
				}
			}

			return arr;
		},
		detalles: function detalles() {
			if (this.radiacion.programados.length === 0) {
				return [];
			}

			var arr = {};

			for (var emisora in this.radiacion.programados) {
				var items = this.radiacion.programados[emisora];
				arr[emisora] = arr[emisora] ? arr[emisora] : { items: [], emitidos: 0 };

				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					item.emisora = emisora;

					var idProg = items[i].ID_programacion;

					for (var emi in this.radiacion.emitidos) {
						var emis = this.radiacion.emitidos[emi];

						for (var e = 0; e < emis.length; e++) {
							if (idProg === emis[e].ID_programacion) {
								item.emitido = emis[e];
								arr[emisora].emitidos++;
							}
						}
					}

					arr[emisora].items.push(item);
				}
			}

			return arr;
		},
		detallesEmitidos: function detallesEmitidos() {
			if (this.radiacion.emitidos.length === 0) {
				return [];
			}

			var arr = {};

			for (var emisora in this.radiacion.emitidos) {
				arr[emisora] = !arr[emisora] ? [] : arr[emisora];
				arr[emisora] = arr[emisora].concat(this.radiacion.emitidos[emisora]);
			}

			return arr;
		}
	},

	methods: {
		teclaPulsada: function teclaPulsada(e) {
			if (e.keyCode === 27) {
				this.cerrar();
			}
		},
		getTarea: function getTarea() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1__services_api__["a" /* default */].getTarea(this.idtarea).then(function (res) {
				_this.tarea = res.data.tarea;

				if (_this.ficheros.length === 1) {
					_this.auditando = _this.ficheros[0].ID_fichero;
				}
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			window.removeEventListener('keypress', this.teclaPulsada);
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'fase-tarea',
	props: ['titulo', 'listado', 'clase'],
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	}), {
		listadoProcesado: function listadoProcesado() {
			var arr = [];

			for (var i = 0; i < this.listado.length; i++) {
				if (this.listado[i].fase !== 'cancelada' && (this.esTareaValida(this.listado[i]) || this.listado[i].agente_ID === this.usuario.ID)) {
					arr.push(this.listado[i]);
				}
			}

			return arr;
		}
	}),
	methods: {
		seleccionar: function seleccionar(idTarea, titulo) {
			this.$router.push('/main/produccion/tarea/' + idTarea);
			// this.$emit('abrir', {ID_tarea: idTarea, nombre: titulo})
		},
		tareaVieja: function tareaVieja(tarea) {
			if (!tarea.fecha_creacion_unix) {
				return false;
			}

			var ahora = Math.floor(new Date().getTime() / 1000);

			return ahora - tarea.fecha_creacion_unix > 2678400;
		},
		esTareaValida: function esTareaValida(tarea) {
			if (tarea.fase === 'finalizada') {
				return true;
			}
			return tarea.duracion && tarea.fecha_inicio && tarea.fecha_fin;
		}
	}
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			filtro: {
				ID_agente: null,
				ID_anunciante: null,
				fechaInicio: null,
				fechaFin: null,
				excluirNoProducidas: true,
				omitirCanceladas: true,
				omitirExternas: false
			},
			anunciante: null,
			agente: null,
			resultados: {}
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	})),
	methods: {
		seleccionaAgente: function seleccionaAgente(info) {
			this.agente = info.datos;
			this.filtro.ID_agente = info.datos.ID;
		},
		seleccionaAnunciante: function seleccionaAnunciante(info) {
			this.anunciante = info.datos;
			this.filtro.ID_anunciante = info.datos.ID_anunciante;
		},
		consultar: function consultar() {
			var _this = this;

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.fechaInicioUnix = this.filtro.fechaInicio ? Math.floor(this.filtro.fechaInicio.getTime() / 1000) : null;
			form.fechaFinUnix = this.filtro.fechaFin ? Math.floor(this.filtro.fechaFin.getTime() / 1000) : null;
			this.resultados = {};
			this.$http.post('produccion/php/api/estadisticas/calcular.php', form).then(function (res) {
				_this.resultados = res.data;
			}).catch(function (e) {
				console.error(e);
			});
		}
	}
});

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_nueva_nueva_component__ = __webpack_require__(633);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Nueva: __WEBPACK_IMPORTED_MODULE_0__components_nueva_nueva_component__["a" /* default */]
	},
	data: function data() {
		return {
			crear: null
		};
	},
	created: function created() {
		var _this = this;

		var menu = [{
			'icono': 'fa fa-list',
			'nombre': 'Listado',
			activo: true,
			callback: function callback(a) {
				_this.$store.commit('top/setMenuActivo', a);
				_this.$router.push('/main/produccion-audiovisual');
				// this.seccion = 'listado'
			}
		}, {
			'icono': 'fa fa-search',
			'nombre': 'Buscador',
			activo: false,
			callback: function callback(a) {
				_this.$store.commit('top/setMenuActivo', a);
				_this.$router.push('/main/produccion-audiovisual/buscador');
				// this.seccion = 'buscador'
			}
		}];

		this.$store.commit('top/setMenu', menu);
	}
});

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nueva_component_vue__ = __webpack_require__(634);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340ad1e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nueva_component_vue__ = __webpack_require__(1468);
function injectStyle (ssrContext) {
  __webpack_require__(1467)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-340ad1e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nueva_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340ad1e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nueva_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['TareaID'],
	data: function data() {
		return {
			datos: {
				UsuarioID: null,
				Titulo: '',
				Descripcion: '',
				LatitudEvento: null,
				LongitudEvento: null,
				PlaceID: null,
				Fotografia: 'No',
				Video: 'No',
				FechaEvento: null,
				HoraEvento: null,
				FechaPublicacion: null,
				Destinos: []
			},
			destinos: [],
			map: null,
			marcador: null,
			campoGoogle: null,
			resultadosGoogle: []
		};
	},
	created: function created() {
		var _this = this;

		this.getDestinos();

		this.datos.UsuarioID = parseInt(this.usuario.ID);

		if (this.TareaID && this.TareaID !== 'nueva') {
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('produccion-audiovisual/php/api/getTarea.php?TareaID=' + this.TareaID).then(function (res) {
				res.data.HoraEvento = res.data.FechaEvento ? res.data.FechaEvento.split(' ')[1] : null;
				res.data.FechaEvento = res.data.FechaEvento ? res.data.FechaEvento.split(' ')[0] : null;
				_this.datos = res.data;
				_this.muestraMapa();
			}).catch(this.$responseError);
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	})),
	methods: {
		getDestinos: function getDestinos() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('produccion-audiovisual/php/api/getDestinos.php').then(function (res) {
				_this2.destinos = res.data;
			}).catch(this.$responseError);
		},
		claseDestino: function claseDestino(d) {
			var c = [d.Icono];
			if (this.datos.Destinos.indexOf(d.DestinoID) >= 0) {
				c.push('active');
			}
			return c.join(' ');
		},
		toggleDestino: function toggleDestino(d) {
			var idx = this.datos.Destinos.indexOf(d);

			if (idx >= 0) {
				this.datos.Destinos.splice(idx, 1);
			} else {
				this.datos.Destinos.push(d);
			}
		},
		toggleTipo: function toggleTipo(tipo) {
			if (this.datos[tipo] === undefined) {
				return;
			}

			this.datos[tipo] = this.datos[tipo] === 'Si' ? 'No' : 'Si';
		},
		seleccionaUbicacion: function seleccionaUbicacion(ev) {
			this.datos.LatitudEvento = ev.geometry.location.lat;
			this.datos.LongitudEvento = ev.geometry.location.lng;
			this.muestraMapa();
		},
		muestraMapa: function muestraMapa() {
			var _this3 = this;

			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('mapaEvento'), {
				center: { lat: this.datos.LatitudEvento, lng: this.datos.LongitudEvento },
				zoom: 15
			});

			this.map.addListener('click', function (e) {
				_this3.placeMarkerAndPanTo(e.latLng);
			});

			if (this.marcador) {
				this.marcador.setMap(null);
			}

			// Añadimos el marcador
			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: { lat: this.datos.LatitudEvento, lng: this.datos.LongitudEvento },
				title: this.datos.Titulo || 'Evento',
				map: this.map
			});
		},
		placeMarkerAndPanTo: function placeMarkerAndPanTo(latLng) {
			if (this.marcador) {
				this.marcador.setMap(null);
			}

			this.datos.LatitudEvento = latLng.lat();
			this.datos.LongitudEvento = latLng.lng();

			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: latLng,
				map: this.map
			});
			this.map.panTo(latLng);
		},
		guardar: function guardar() {
			var _this4 = this;

			if (!this.datos.UsuarioID) {
				this.$error('Error', 'Debes definir el usuario que realiza la petición');
				return;
			}
			if (!this.datos.Titulo) {
				this.$error('Error', 'Debes definir el título');
				return;
			}

			if (!this.datos.Descripcion) {
				this.$error('Error', 'Debes describir detalladamente lo que necesitas');
				return;
			}

			if (!this.datos.Fotografia && !this.datos.Video) {
				this.$error('Error', 'Debes seleccionar al menos fotografía o vídeo');
				return;
			}

			if (this.datos.Destinos.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un destino');
				return;
			}

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.datos));
			form.FechaEvento = this.datos.FechaEvento ? this.$moment(this.datos.FechaEvento).format('YYYY-MM-DD') : null;

			if (this.datos.FechaEvento && !this.datos.HoraEvento) {
				this.$error('Error', 'No has definido la hora del evento');
				return;
			}

			if (form.FechaEvento !== null) {
				form.FechaEvento = form.FechaEvento + ' ' + this.datos.HoraEvento + ':00';
			}

			form.FechaPublicacion = this.datos.FechaPublicacion ? this.$moment(this.datos.FechaPublicacion).format('YYYY-MM-DD') : null;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('produccion-audiovisual/php/api/setProduccion.php', form).then(function (res) {
				_this4.$store.commit('toast/success', {
					titulo: 'Tarea guardada'
				});
				_this4.$emit('actualizar');
				_this4.cerrar();
			}).catch(function (e) {
				_this4.$error('Error', e.response.data.error);
			});
		},
		cerrar: function cerrar() {
			this.$emit('actualizar');
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendario_component__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overview_component__ = __webpack_require__(1477);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Calendario: __WEBPACK_IMPORTED_MODULE_0__calendario_component__["a" /* default */],
		Overview: __WEBPACK_IMPORTED_MODULE_1__overview_component__["a" /* default */]
	}
});

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mes_component__ = __webpack_require__(1473);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Mes: __WEBPACK_IMPORTED_MODULE_0__mes_component__["a" /* default */]
	},
	data: function data() {
		return {
			fecha: new Date(),
			eventos: [{
				component: 'editor-producciones',
				titulo: 'Grabación',
				descripcion: 'Grabación speech noticia',
				inicio: new Date(2020, 0, 6, 12, 0, 0),
				fin: new Date(2020, 0, 6, 13, 0, 0)
			}, {
				component: 'editor-producciones',
				titulo: 'Grabación',
				descripcion: 'Grabación speech noticia',
				inicio: new Date(2020, 0, 8, 12, 0, 0),
				fin: new Date(2020, 0, 8, 13, 0, 0)
			}, {
				component: 'editor-producciones',
				titulo: 'Grabación 2',
				descripcion: 'Grabación speech noticia',
				inicio: new Date(2020, 0, 10, 12, 0, 0),
				fin: new Date(2020, 0, 10, 13, 0, 0)
			}, {
				component: 'editor-producciones',
				titulo: 'Grabación 2',
				descripcion: 'Grabación speech noticia',
				inicio: new Date(2020, 0, 12, 12, 0, 0),
				fin: new Date(2020, 0, 12, 13, 0, 0)
			}, {
				component: 'editor-producciones',
				titulo: 'Grabación',
				descripcion: 'Grabación speech noticia',
				inicio: new Date(2020, 0, 14, 12, 0, 0),
				fin: new Date(2020, 0, 14, 13, 0, 0)
			}, {
				component: 'editor-producciones',
				titulo: 'Grabación',
				descripcion: 'Grabación speech noticia',
				inicio: new Date(2020, 0, 16, 12, 0, 0),
				fin: new Date(2020, 0, 16, 13, 0, 0)
			}, {
				component: 'editor-producciones',
				titulo: 'Grabación 2',
				descripcion: 'Grabación speech noticia',
				inicio: new Date(2020, 0, 18, 12, 0, 0),
				fin: new Date(2020, 0, 18, 13, 0, 0)
			}]
		};
	},

	methods: {
		siguiente: function siguiente() {
			this.fecha = new Date(this.fecha.getFullYear(), this.fecha.getMonth() + 1, 1);
			this.$emit('fecha', this.fecha);
		},
		anterior: function anterior() {
			this.fecha = new Date(this.fecha.getFullYear(), this.fecha.getMonth() - 1, 1);
			this.$emit('fecha', this.fecha);
		}
	}
});

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['fecha', 'eventos'],
	data: function data() {
		return {
			inicioMes: null, // Inicio real del mes
			inicioCalendario: null, // Día inicial del calendario
			finCalendario: null, // Dia final del calendario
			finMes: null, // Fin real del mes
			semanas: [],
			dias: ['LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB', 'DOM'],
			altoCelda: '60px'
		};
	},
	created: function created() {
		this.construyeMes();
	},
	mounted: function mounted() {
		window.addEventListener('resize', this.calculaAlto);
		this.calculaAlto();
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('resize', this.calculaAlto);
	},

	watch: {
		fecha: function fecha(newVal) {
			this.construyeMes();
		}
	},
	methods: {
		calculaAlto: function calculaAlto() {
			var altoVentana = window.innerHeight;
			this.altoCelda = altoVentana / 7;
		},
		construyeMes: function construyeMes() {
			if (!this.fecha) {
				return;
			}

			// Calculamos la fecha de inicio de mes
			this.inicioMes = new Date(this.fecha.getTime());
			this.inicioMes.setDate(1);

			// Calculamos el día de la semana en la que empieza el mes
			var diaSemanaInicio = this.inicioMes.getDay() === 0 ? 6 : this.inicioMes.getDay() - 1;

			this.inicioCalendario = new Date(this.inicioMes.getFullYear(), this.inicioMes.getMonth(), 1 - diaSemanaInicio, 0, 0, 0, 0);

			// Calculamos la fecha de fin de mes
			this.finMes = new Date(this.inicioMes.getFullYear(), this.inicioMes.getMonth() + 1, 0);

			// Calculamos el día de la semana en la que termina el mes
			var diaSemanaFin = this.finMes.getDay() === 0 ? 6 : this.finMes.getDay() - 1;

			this.finCalendario = new Date(this.finMes.getFullYear(), this.finMes.getMonth(), this.finMes.getDate() + 6 - diaSemanaFin, 23, 59, 59, 999);

			// Ahora construímos las semanas teniendo en cuenta el offset del inicio de semana
			var diaActual = this.inicioCalendario;
			this.semanas = [];
			var semana = {
				dias: [],
				numero: this.getWeek(diaActual),
				eventos: [],
				inicio: new Date(diaActual),
				inicioStr: this.$moment(diaActual).format('YYYYMMDD'),
				fin: new Date(diaActual),
				finStr: this.$moment(diaActual).format('YYYYMMDD')
			};
			while (diaActual <= this.finCalendario) {
				if (diaActual.getDay() === 1 && diaActual !== this.inicioCalendario) {
					this.semanas.push(semana);
					semana = {
						dias: [],
						eventos: [],
						numero: this.getWeek(diaActual),
						inicio: new Date(diaActual),
						inicioStr: this.$moment(diaActual).format('YYYYMMDD'),
						fin: new Date(diaActual),
						finStr: this.$moment(diaActual).format('YYYYMMDD')
					};
				}

				semana.dias.push({
					dia: new Date(diaActual.getTime()),
					diaStr: this.$moment(diaActual).format('YYYYMMDD'),
					hoy: this.$moment().format('YYYYMMDD') === this.$moment(diaActual).format('YYYYMMDD')
				});

				semana.fin = new Date(diaActual);
				semana.finStr = this.$moment(semana.fin).format('YYYYMMDD');
				diaActual = new Date(diaActual.getFullYear(), diaActual.getMonth(), diaActual.getDate() + 1);
			}

			semana.inicioStr = this.$moment(semana.inicio).format('YYYYMMDD');
			semana.finStr = this.$moment(semana.fin).format('YYYYMMDD');
			this.semanas.push(semana);
			this._reparteEventos();
		},
		_reparteEventos: function _reparteEventos() {
			for (var i = 0; i < this.eventos.length; i++) {
				var ev = this.eventos[i];
				var inicioStr = this.$moment(ev.inicio).format('YYYYMMDD');
				var finStr = this.$moment(ev.fin).format('YYYYMMDD');

				var evento = {
					left: 0,
					diaInicio: 0,
					titulo: ev.titulo,
					inicio: ev.inicio,
					fin: ev.fin,
					descripcion: ev.descripcion
				};
				for (var s = 0; s < this.semanas.length; s++) {
					var sem = this.semanas[s];
					var duracionDias = 0;
					var dentro = false;

					for (var d = 0; d < sem.dias.length; d++) {
						var dia = sem.dias[d];

						if (sem.inicioStr <= inicioStr && sem.finStr >= inicioStr || sem.inicioStr <= finStr && sem.finStr >= finStr || sem.inicioStr >= inicioStr && sem.finStr <= finStr) {
							// Está dentro de esta semana
							if (dia.diaStr >= inicioStr && dia.diaStr <= finStr) {
								if (!dentro) {
									console.log('El evento entra en el día ' + dia.diaStr + ': ' + d);
									evento.left = parseInt(14 * d);
									evento.diaInicio = d + 1;
									dentro = true;
									console.log(evento);
								}
								duracionDias++;
								evento.width = 14 * duracionDias;
							}
						} else {
							console.log('No está entre ' + sem.inicioStr + ' y ' + sem.finStr);
						}
					}

					if (dentro) {
						var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(evento));
						obj.inicio = new Date(evento.inicio);
						obj.fin = new Date(evento.fin);
						this.semanas[s].eventos.push(obj);
					}
				}
			}
		},
		estiloEvento: function estiloEvento(evento) {
			var offset = evento.diaInicio * 2;
			// const marginLeft = evento.diaInicio * 3 + evento.diaInicio + 3
			var left = (evento.diaInicio - 1) * 14;
			return {
				width: 'calc(' + evento.width + '% + ' + offset + 'px)',
				padding: '3px',
				marginLeft: left + '%'
			};
		},
		getWeek: function getWeek(date) {
			var onejan = new Date(date.getFullYear(), 0, 1);
			return Math.ceil(((date - onejan) / 86400000 + onejan.getDay() + 1) / 7);
		}
	}
});

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nueva_nueva_component__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__detalles_tareaDetalle_component__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tarea_component__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Tarea: __WEBPACK_IMPORTED_MODULE_2__tarea_component__["a" /* default */],
		TareaDetalle: __WEBPACK_IMPORTED_MODULE_1__detalles_tareaDetalle_component__["a" /* default */],
		Editor: __WEBPACK_IMPORTED_MODULE_0__nueva_nueva_component__["a" /* default */]
	},
	data: function data() {
		return {
			tareas: [],
			intervalo: null,
			TareaID: null,
			EditarID: null
		};
	},
	created: function created() {
		var _this = this;

		this.buscar();
		this.intervalo = window.setInterval(function () {
			_this.buscar();
		}, 10000);

		if (this.$route.params.TareaID) {
			this.TareaID = this.$route.params.TareaID;
		}
	},

	watch: {
		'$route.params': function $routeParams(newVal) {
			if (newVal.TareaID) {
				this.TareaID = newVal.TareaID;
			} else {
				this.TareaID = null;
			}
		}
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.intervalo);
	},

	computed: {
		tareasPendientes: function tareasPendientes() {
			return this.tareas.filter(function (t) {
				return !t.FechaFinalizada && !t.GaleriaID;
			});
		},
		tareasRealizadas: function tareasRealizadas() {
			return this.tareas.filter(function (t) {
				return !t.FechaFinalizada && t.GaleriaID;
			});
		},
		tareasFinalizadas: function tareasFinalizadas() {
			return this.tareas.filter(function (t) {
				return t.FechaFinalizada && t.GaleriaID;
			});
		}
	},
	methods: {
		setNueva: function setNueva() {
			this.EditarID = 'nueva';
		},
		buscar: function buscar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('produccion-audiovisual/php/api/getTareas.php').then(function (res) {
				_this2.tareas = res.data;
			}).catch(function (e) {
				console.error(e);
			});
		},
		verTarea: function verTarea(tarea) {
			this.$router.push('/main/produccion-audiovisual/tarea/' + tarea.TareaID);
			// this.TareaID = tarea.TareaID
		}
	}
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tareaRealizada_component__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rechazarTarea_component__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__galerias_vue_componentes_listado_galerias_mini_galeria__ = __webpack_require__(47);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['TareaID'],
	components: {
		RealizarTarea: __WEBPACK_IMPORTED_MODULE_3__tareaRealizada_component__["a" /* default */],
		RechazarTarea: __WEBPACK_IMPORTED_MODULE_4__rechazarTarea_component__["a" /* default */],
		MiniGaleria: __WEBPACK_IMPORTED_MODULE_5__galerias_vue_componentes_listado_galerias_mini_galeria__["a" /* default */]
	},
	data: function data() {
		return {
			map: null,
			marcador: null,
			realizar: null,
			rechazar: null,
			destinos: [],
			tarea: {
				TareaID: null,
				TareaOriginalID: null,
				Titulo: null,
				Descripcion: null,
				Fotografia: 'No',
				Video: 'No',
				FechaPublicacion: null,
				FechaEvento: null,
				LatitudEvento: null,
				LongitudEvento: null,
				UsuarioAsignado: null,
				UsuarioAsignadoNombre: null,
				UsuarioID: null,
				UsuarioNombre: null,
				UsuarioAvatar: null,
				UsuarioCreador: null,
				UsuarioCreadorNombre: null,
				UsuarioDescarta: null,
				UsuarioDescartaNombre: null,
				FechaModificada: null,
				FechaDescartada: null,
				FechaCreacion: null,
				FechaFinalizada: null,
				FechaRealizada: null,
				GaleriaID: null,
				ComentariosFinales: null
			}
		};
	},
	created: function created() {
		this.getDestinos();
		this.getTarea();
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		permisos: 'permisos/permisos',
		usuario: 'session/usuario'
	}), {
		puedeEditar: function puedeEditar() {
			/*
   	Puede editar si...
   		- No se ha hecho ya el trabajo
   		- Es el usuario que creó la tarea
   		- Es el usuario de la tarea
   		- Tiene permisos para ello
   */
			if (this.tarea.FechaRealizada) {
				return false;
			}

			if (this.tarea.UsuarioID === this.usuario.ID || this.tarea.UsuarioCreador === this.usuario.ID || this.permisos.produccion_audiovisual_editarTodas) {
				return true;
			}
			return false;
		},
		puedePublicar: function puedePublicar() {
			/*
   	Puede publicar si...
   		- Se ha hecho ya el trabajo
   		- Es el usuario que creó la tarea
   		- Es el usuario de la tarea
   		- Tiene permisos para ello
   */
			if (!this.tarea.FechaRealizada || this.tarea.FechaFinalizada) {
				return false;
			}

			if (this.tarea.UsuarioID === this.usuario.ID || this.tarea.UsuarioCreador === this.usuario.ID || this.permisos.produccion_audiovisual_editarTodas) {
				return true;
			}
			return false;
		},
		puedeRealizar: function puedeRealizar() {
			/*
   	Puede editar si...
   		- No se ha hecho y a el trabajo
   		- Tiene permisos para ello
   */
			if (this.tarea.FechaRealizada) {
				return false;
			}

			if (this.permisos.produccion_audiovisual_realizador) {
				return true;
			}
			return false;
		},
		Descripcion: function Descripcion() {
			if (!this.tarea.Descripcion) {
				return '';
			}

			var desc = this.tarea.Descripcion.split('\n');

			return desc.reduce(function (acum, linea) {
				acum = acum + '<p>' + linea + '</p>';
				return acum;
			}, '');
		},
		Destinos: function Destinos() {
			var _this = this;

			if (!this.tarea.TareaID) {
				return [];
			}

			return this.destinos.filter(function (d) {
				return _this.tarea.Destinos.indexOf(d.DestinoID) >= 0;
			});
		}
	}),
	methods: {
		getDestinos: function getDestinos() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('produccion-audiovisual/php/api/getDestinos.php').then(function (res) {
				_this2.destinos = res.data;
			}).catch(function (e) {
				console.error(e);
			});
		},
		getTarea: function getTarea() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('produccion-audiovisual/php/api/getTarea.php?TareaID=' + this.TareaID).then(function (res) {
				_this3.tarea = res.data;
				window.setTimeout(function () {
					_this3.muestraMapa();
				}, 300);
			}).catch(function (e) {
				console.error(e);
			});
		},
		muestraMapa: function muestraMapa() {
			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('mapaEvento'), {
				center: { lat: this.tarea.LatitudEvento, lng: this.tarea.LongitudEvento },
				zoom: 15
			});

			if (this.marcador) {
				this.marcador.setMap(null);
			}

			// Añadimos el marcador
			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: { lat: this.tarea.LatitudEvento, lng: this.tarea.LongitudEvento },
				title: this.tarea.Titulo || 'Evento',
				map: this.map
			});
		},
		acceder: function acceder() {
			this.$router.push('/main/galerias/' + this.tarea.GaleriaID);
		},
		editar: function editar() {
			this.$emit('editar', this.TareaID);
			this.cerrar();
		},
		publicar: function publicar() {
			var _this4 = this;

			this.$store.commit('alertas/confirm', {
				titulo: '¿Marcar tarea como publicada?',
				mensaje: '\xBFQuieres marcar la tarea como publicada?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('produccion-audiovisual/php/api/publicar.php', { TareaID: _this4.TareaID }).then(function (res) {
							_this4.$store.commit('toast/success', {
								titulo: 'Tarea publicada correctamente'
							});
							_this4.cerrar();
						}).catch(_this4.$responseError);
					}
				}
			});
		},
		eliminar: function eliminar() {
			var _this5 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar tarea',
				mensaje: '\xBFQuieres eliminar esta tarea?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('produccion-audiovisual/php/api/eliminar.php', { TareaID: _this5.TareaID }).then(function (res) {
							_this5.$store.commit('toast/success', {
								titulo: 'Tarea eliminada'
							});
							_this5.cerrar();
						}).catch(_this5.$responseError);
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('actualizar');
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__galerias_vue_componentes_listado_galerias_mini_galeria__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['TareaID'],
	data: function data() {
		return {
			cadena: '',
			galerias: [],
			seleccion: null,
			datos: {
				TareaID: null,
				ComentariosFinales: '',
				GaleriaID: null
			}
		};
	},

	components: {
		MiniGaleria: __WEBPACK_IMPORTED_MODULE_1__galerias_vue_componentes_listado_galerias_mini_galeria__["a" /* default */]
	},
	created: function created() {
		this.buscarGalerias();
	},

	methods: {
		buscarGalerias: function buscarGalerias() {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('produccion-audiovisual/php/api/buscaGalerias.php', { cadena: this.cadena }).then(function (res) {
				_this.galerias = res.data;
			}).catch(this.$responseError);
		},
		selecciona: function selecciona(ev) {
			var sel = this.galerias.filter(function (g) {
				return g.GaleriaID === ev;
			})[0];
			this.seleccion = sel === this.seleccion ? null : sel;
		},
		confirmar: function confirmar() {
			var _this2 = this;

			this.datos.TareaID = this.TareaID;
			this.datos.GaleriaID = this.seleccion.GaleriaID;

			if (!this.datos.GaleriaID) {
				this.$error('Error', 'Debes seleccionar una galería');
				return;
			}

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('produccion-audiovisual/php/api/finalizar.php', this.datos).then(function (res) {
				_this2.$store.commit('toast/success', {
					titulo: 'Tarea finalizada'
				});
				_this2.$emit('finalizada');
				_this2.cerrar();
			}).catch(this.$responseError);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['TareaID'],
	data: function data() {
		return {
			datos: {
				TareaID: null,
				ComentariosFinales: ''
			}
		};
	},

	methods: {
		rechazar: function rechazar() {
			var _this = this;

			this.datos.TareaID = this.TareaID;

			if (!this.datos.ComentariosFinales) {
				this.$error('Error', 'No has proporcionado ningún motivo');
				return;
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Rechazar tarea',
				mensaje: '\xBFQuieres rechazar esta tarea?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('produccion-audiovisual/php/api/rechazar.php', _this.datos).then(function (res) {
							_this.$store.commit('toast/success', {
								titulo: 'Tarea rechazada'
							});
							_this.$emit('rechazada');
							_this.cerrar();
						}).catch(_this.$responseError);
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['tarea']
});

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resultados__ = __webpack_require__(1494);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Resultados: __WEBPACK_IMPORTED_MODULE_0__resultados__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				agente: null,
				cliente: null,
				contrato: null
			},
			resultados: []
		};
	},

	methods: {
		buscar: function buscar() {
			console.log('Buscamos');
		},
		nueva: function nueva() {
			this.$router.push('/main/radiacion/nueva');
		}
	}
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['resultados']
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__menu__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__servicios_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__colocacion_colocacion_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__insertar_originales_insertar_originales_vue__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__eliminar_eliminar_inserciones__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__recuperar_recuperar_inserciones_vue__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__detalles_dia_detalles_dia__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__copiar_inserciones_copiar_inserciones_vue__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rotacion_vertical_rotacion_vertical__ = __webpack_require__(1527);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['RadiacionID'],
	components: {
		colocacion: __WEBPACK_IMPORTED_MODULE_6__colocacion_colocacion_vue__["a" /* default */],
		InsertarOriginales: __WEBPACK_IMPORTED_MODULE_7__insertar_originales_insertar_originales_vue__["a" /* default */],
		EliminarInserciones: __WEBPACK_IMPORTED_MODULE_8__eliminar_eliminar_inserciones__["a" /* default */],
		RecuperarInserciones: __WEBPACK_IMPORTED_MODULE_9__recuperar_recuperar_inserciones_vue__["a" /* default */],
		MenuOriginales: __WEBPACK_IMPORTED_MODULE_4__menu__["a" /* default */],
		DetallesDia: __WEBPACK_IMPORTED_MODULE_10__detalles_dia_detalles_dia__["a" /* default */],
		CopiarInserciones: __WEBPACK_IMPORTED_MODULE_11__copiar_inserciones_copiar_inserciones_vue__["a" /* default */],
		RotacionVertical: __WEBPACK_IMPORTED_MODULE_12__rotacion_vertical_rotacion_vertical__["a" /* default */]
	},
	data: function data() {
		return {
			contrato: null,
			nombreMes: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiempre', 'Octubre', 'Noviembre', 'Diciembre'],
			lineaSeleccionada: null,
			diaSeleccionado: null,
			radiacion: null,
			ver: '',
			mesActivo: null,
			bloques: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(),
			historialModificaciones: [],
			punteroHistorial: null
		};
	},
	created: function created() {
		if (this.RadiacionID) {
			// TODO: Obtener la radiación
		}
		this.mesActivo = this.meses[0];
	},

	computed: {
		dias: function dias() {
			if (!this.mesActivo) {
				return [];
			}

			var mes = new Date(this.mesActivo.getTime());
			var mesNum = mes.getMonth();
			mes.setDate(1);
			mes.setHours(0);
			mes.setMinutes(0);
			mes.setSeconds(0);
			mes.setMilliseconds(0);

			var dias = [];
			while (mesNum === mes.getMonth()) {
				dias.push(new Date(mes.getTime()));
				mes.setDate(mes.getDate() + 1);
			}

			return dias;
		},
		meses: function meses() {
			if (!this.contrato) {
				return [];
			}
			var arr = [];

			var mes = new Date(this.contrato.FechaInicio);
			mes.setDate(1);

			while (mes.getTime() <= this.contrato.FechaFin) {
				arr.push(new Date(mes.getTime()));
				mes.setMonth(mes.getMonth() + 1);
			}

			return arr;
		},
		variosAnos: function variosAnos() {
			return this.meses[0].getFullYear() !== this.meses[this.meses.length - 1].getFullYear();
		},
		totalInserciones: function totalInserciones() {
			return this.radiacion.lineas.reduce(function (acc, linea) {
				if (linea.inserciones) {
					var total = linea.inserciones.reduce(function (cant, ins) {
						if (!ins.Anulada) {
							cant = cant + ins.Inserciones;
						}
						return cant;
					}, 0);
					acc = acc + total;
				}
				return acc;
			}, 0);
		},
		totalInsercionesMes: function totalInsercionesMes() {
			var _this = this;

			return this.radiacion.lineas.reduce(function (acc, linea) {
				acc = acc + _this.getInsercionesMes(linea);
				return acc;
			}, 0);
		},
		desgloseLinea: function desgloseLinea() {
			if (!this.lineaSeleccionada) {
				console.log('No hay linea seleccionada');
				console.log(this.lineaSeleccionada);
				return null;
			}

			// Desglosamos por ficheros
			var ficheros = this.lineaSeleccionada.inserciones.reduce(function (acc, ins) {
				if (!acc.has(ins.FicheroID)) {
					acc.set(ins.FicheroID, {
						FicheroID: ins.FicheroID,
						Descripcion: ins.Descripcion,
						inserciones: [ins]
					});
				} else {
					var i = acc.get(ins.FicheroID);
					i.inserciones.push(ins);
					acc.set(ins.FicheroID, i);
				}
				return acc;
			}, new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a());

			return {
				linea: this.lineaSeleccionada,
				ficheros: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(ficheros).map(function (l) {
					return l[1];
				})
			};
		}
	},

	methods: {
		seleccionaContrato: function seleccionaContrato(ev) {
			ev.datos.lineas = [];
			this.contrato = ev.datos;
			this.getLineas();
		},
		getLineas: function getLineas() {
			var _this2 = this;

			if (!this.contrato) {
				return;
			}

			__WEBPACK_IMPORTED_MODULE_5__servicios_js__["a" /* default */].GetLineasContrato(this.contrato.ContratoID).then(function (lineas) {
				_this2.contrato.lineas = lineas;
				_this2.mesActivo = _this2.meses[0];
				_this2.generarRadiacion();
			}).catch(function (e) {
				_this2.$error('Error', e);
			});
		},
		getBloques: function getBloques() {
			var _this3 = this;

			var form = {
				EmisoraID: this.contrato.lineas.reduce(function (acc, linea) {
					if (acc.indexOf(linea.CatalogoID) < 0) {
						acc.push(linea.CatalogoID);
					}
					return acc;
				}, []),
				DiaInicio: this.$moment(this.contrato.FechaInicio).format('YYYY-MM-DD'),
				DiaFin: this.$moment(this.contrato.FechaFin).format('YYYY-MM-DD'),
				RadiacionID: this.radiacion.RadiacionID
			};
			__WEBPACK_IMPORTED_MODULE_5__servicios_js__["a" /* default */].GetBloques(form).then(function (bloques) {
				_this3.bloques = bloques.reduce(function (acc, bloque) {
					bloque.DuracionInsercionesNuevas = 0;
					bloque.LineasInserciones = [];
					acc.set(bloque.BloqueID, bloque);
					return acc;
				}, new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a());
				// this.seleccionarBloquesInserciones()
			}).catch(function (e) {
				console.error(e);
				_this3.$error('Error', e);
			});
		},
		generarRadiacion: function generarRadiacion() {
			this.radiacion = {
				RadiacionID: null,
				ContratoID: this.contrato.ContratoID,
				ContratoOriginal: this.contrato.ContratoOriginal,
				UsuarioID: null,
				FechaInicio: this.contrato.FechaInicio,
				FechaFin: this.contrato.FechaFin,
				FechaCreacion: new Date(),
				FechaModificacion: null,
				FechaEliminado: null,
				Comentarios: null,
				lineas: this.contrato.lineas.map(function (l) {
					var linea = {
						LineaID: 'L-' + new Date().getTime().toString() + '' + Math.round(Math.random() * 1000),
						ArticuloID: l.ArticuloID,
						LineaContratoID: l.LineaID,
						RadiacionID: null,
						EmisoraID: l.CatalogoID,
						EmisoraNombre: l.CatalogoNombre,
						Concepto: l.Concepto,
						ImporteNeto: l.ImporteNeto,
						ImporteBruto: l.ImporteBruto,
						ImporteTotal: l.ImporteTotal,
						ImporteUnitario: l.ImporteUnitario,
						Cantidad: l.Cantidad,
						Descuento: l.Descuento,
						TipoColocacion: null,
						ProgramaID: null,
						ContenidoID: null,
						HoraInicio: null,
						HoraFin: null,
						Fijacion: null,
						originales: [],
						inserciones: []
					};
					return linea;
				})
			};

			this.guardarHistorial();
			this.getBloques();
			this.$forceUpdate();
		},
		guardarHistorial: function guardarHistorial() {
			if (this.punteroHistorial !== null) {
				this.historialModificaciones.splice(this.punteroHistorial + 1);
			}
			this.historialModificaciones.push({
				radiacion: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.radiacion)),
				lineaSeleccionada: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.lineaSeleccionada))
			});
			this.punteroHistorial = this.historialModificaciones.length - 1;
		},
		cargarHistorial: function cargarHistorial() {
			this.radiacion = this.historialModificaciones[this.punteroHistorial].radiacion;
			this.lineaSeleccionada = this.historialModificaciones[this.punteroHistorial].lineaSeleccionada;
		},
		deshacer: function deshacer() {
			if (this.punteroHistorial === null) {
				this.punteroHistorial = this.historialModificaciones.length - 1;
				if (this.punteroHistorial < 0) {
					this.punteroHistorial = null;
					return;
				}
			}
			this.punteroHistorial = this.punteroHistorial - 1;
			this.cargarHistorial();
		},
		rehacer: function rehacer() {
			if (this.punteroHistorial === null) {
				return;
			}
			this.punteroHistorial = this.punteroHistorial + 1;
			if (this.punteroHistorial >= this.historialModificaciones.length) {
				this.punteroHistorial = this.historialModificaciones.length - 1;
			}
			this.cargarHistorial();
		},
		verDetallesDia: function verDetallesDia(linea, dia) {
			this.diaSeleccionado = {
				dia: this.$moment(dia).format('YYYY-MM-DD'),
				linea: linea
			};
		},
		guardarInsercionesDia: function guardarInsercionesDia($event) {
			var _this4 = this;

			// Lo primero es borrar las inserciones del día
			for (var i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.diaSeleccionado.linea.LineaID) {
					console.log('Linea encontrada');
					this.radiacion.lineas[i].inserciones = this.radiacion.lineas[i].inserciones.filter(function (i) {
						return i.Dia !== _this4.diaSeleccionado.dia;
					});
					this.radiacion.lineas[i].inserciones = this.radiacion.lineas[i].inserciones.concat($event);
				}
			}
			this.cerrarDetallesDia();
			this.seleccionarBloquesInserciones();
		},
		cerrarDetallesDia: function cerrarDetallesDia() {
			this.diaSeleccionado = null;
		},
		setColocacion: function setColocacion(colocacion) {
			this.lineaSeleccionada.ProgramaID = colocacion.ProgramaID;
			this.lineaSeleccionada = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.lineaSeleccionada, colocacion);

			for (var i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.lineaSeleccionada.LineaID) {
					this.radiacion.lineas[i] = this.lineaSeleccionada;
				}
			}
			this.guardarHistorial();
		},
		reemplazaInserciones: function reemplazaInserciones(inserciones) {
			for (var l = 0; l < this.radiacion.lineas.length; l++) {
				if (this.radiacion.lineas[l].LineaID === this.lineaSeleccionada.LineaID) {
					this.radiacion.lineas[l].inserciones = inserciones;
				}
			}
			try {
				this.seleccionarBloquesInserciones();
			} catch (e) {
				console.error(e);
			}
		},
		setInserciones: function setInserciones(inserciones) {
			for (var l = 0; l < this.radiacion.lineas.length; l++) {
				if (this.radiacion.lineas[l].LineaID === this.lineaSeleccionada.LineaID) {
					for (var i = 0; i < inserciones.length; i++) {
						var dia = new Date(inserciones[i].DiaUnix);
						dia.setHours(0);
						dia.setMinutes(0);
						dia.setSeconds(0);
						dia.setMilliseconds(0);

						var diaFin = new Date(inserciones[i].DiaUnix);
						diaFin.setHours(23);
						diaFin.setMinutes(59);
						diaFin.setSeconds(59);
						diaFin.setMilliseconds(999);
						if (dia > this.radiacion.FechaInicio && diaFin < this.radiacion.FechaFin) {
							this.radiacion.lineas[l].inserciones.push(inserciones[i]);
						}
					}
					this.radiacion.lineas[l].originales = [];
				}
			}
			// this.lineaSeleccionada = null
			try {
				this.seleccionarBloquesInserciones();
			} catch (e) {
				console.error(e);
			}
		},
		eliminarInserciones: function eliminarInserciones(dias) {
			var _this5 = this;

			var indice = null;
			dias = dias.map(function (d) {
				return _this5.$moment(d).format('YYYY-MM-DD');
			});
			for (var i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.lineaSeleccionada.LineaID) {
					indice = i;
				}
			}

			if (indice === null) {
				return;
			}

			this.radiacion.lineas[indice].inserciones = this.radiacion.lineas[indice].inserciones.filter(function (i) {
				return dias.indexOf(i.Dia) < 0;
			});
			this.seleccionarBloquesInserciones();
		},
		anularInserciones: function anularInserciones(dias) {
			var _this6 = this;

			var indice = null;
			dias = dias.map(function (d) {
				return _this6.$moment(d).format('YYYY-MM-DD');
			});
			for (var i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.lineaSeleccionada.LineaID) {
					indice = i;
				}
			}

			if (indice === null) {
				return;
			}

			this.radiacion.lineas[indice].inserciones = this.radiacion.lineas[indice].inserciones.map(function (i) {
				if (dias.indexOf(i.Dia) >= 0) {
					i.Anulada = true;
				}
				return i;
			});
			this.seleccionarBloquesInserciones();
		},
		recuperarInserciones: function recuperarInserciones(dias) {
			var _this7 = this;

			var indice = null;
			dias = dias.map(function (d) {
				return _this7.$moment(d).format('YYYY-MM-DD');
			});
			for (var i = 0; i < this.radiacion.lineas.length; i++) {
				if (this.radiacion.lineas[i].LineaID === this.lineaSeleccionada.LineaID) {
					indice = i;
				}
			}

			if (indice === null) {
				return;
			}

			this.radiacion.lineas[indice].inserciones = this.radiacion.lineas[indice].inserciones.map(function (i) {
				if (dias.indexOf(i.Dia) >= 0) {
					i.Anulada = false;
				}
				return i;
			});
			this.seleccionarBloquesInserciones();
		},
		getInsercionesMes: function getInsercionesMes(linea) {
			var _this8 = this;

			var mesStr = this.$moment(this.mesActivo).format('YYYY-MM');

			return linea.inserciones.reduce(function (acc, ins) {
				var mesLinea = _this8.$moment(ins.DiaUnix).format('YYYY-MM');
				if (mesLinea === mesStr && !ins.Anulada) {
					acc = acc + ins.Inserciones;
				}
				return acc;
			}, 0);
		},
		getInsercionesMesFichero: function getInsercionesMesFichero(fichero) {
			var _this9 = this;

			var mesStr = this.$moment(this.mesActivo).format('YYYY-MM');

			return fichero.inserciones.reduce(function (acc, ins) {
				var mesLinea = _this9.$moment(ins.DiaUnix).format('YYYY-MM');
				if (mesLinea === mesStr && !ins.Anulada) {
					acc = acc + ins.Inserciones;
				}
				return acc;
			}, 0);
		},
		getTotalLinea: function getTotalLinea(linea) {
			if (!linea.inserciones) {
				return 0;
			}
			return linea.inserciones.reduce(function (acc, ins) {
				acc = ins.Anulada ? acc : acc + ins.Inserciones;
				return acc;
			}, 0);
		},
		getTotalFichero: function getTotalFichero(fichero) {
			return fichero.inserciones.reduce(function (acc, ins) {
				acc = ins.Anulada ? acc : acc + ins.Inserciones;
				return acc;
			}, 0);
		},
		insercionesDia: function insercionesDia(LineaID, dia) {
			var _this10 = this;

			if (!this.radiacion || !this.radiacion.lineas || !Array.isArray(this.radiacion.lineas)) {
				return null;
			}
			var sinBloque = 0;
			var inserciones = this.radiacion.lineas.reduce(function (acc, linea) {
				if (LineaID && linea.LineaID === LineaID && linea.inserciones && Array.isArray(linea.inserciones) || !LineaID) {
					var diaStr = _this10.$moment(dia).format('YYYY-MM-DD');
					acc = linea.inserciones.reduce(function (acc, insercion) {
						if (diaStr === insercion.Dia) {
							if (insercion.Anulada) {
								acc = false;
							}
							acc = acc === false ? false : acc + insercion.Inserciones;

							if (insercion.Inserciones !== insercion.Bloques.length) {
								sinBloque = sinBloque + insercion.Inserciones - insercion.Bloques.length;
							}
						}

						return acc;
					}, acc);
				}
				return acc;
			}, 0);

			if (inserciones === false) {
				return '<span class="fa fa-ban text-danger"></span>';
			} else if (inserciones === 0) {
				return '<span>&nbsp;</span>';
			} else {
				if (sinBloque > 0) {
					return '<span class="text-warning" style="text-decoration:underline;">' + inserciones + '</span>';
				} else {
					return '<span>' + inserciones + '</span>';
				}
			}
		},
		insercionesDiaFichero: function insercionesDiaFichero(fichero, dia) {
			var sinBloque = 0;
			var diaStr = this.$moment(dia).format('YYYY-MM-DD');
			var inserciones = fichero.inserciones.reduce(function (acc, insercion) {
				if (diaStr === insercion.Dia) {
					if (insercion.Anulada) {
						acc = false;
					}
					acc = acc === false ? false : acc + insercion.Inserciones;

					if (insercion.Inserciones !== insercion.Bloques.length) {
						sinBloque = sinBloque + insercion.Inserciones - insercion.Bloques.length;
					}
				}
				return acc;
			}, 0);

			if (inserciones === false) {
				return '<span class="fa fa-ban text-danger"></span>';
			} else if (inserciones === 0) {
				return '<span>&nbsp;</span>';
			} else {
				if (sinBloque > 0) {
					return '<span class="text-warning" style="text-decoration:underline;">' + inserciones + '</span>';
				} else {
					return '<span>' + inserciones + '</span>';
				}
			}
		},
		seleccionaLinea: function seleccionaLinea(linea) {
			this.lineaSeleccionada = linea;
		},
		seleccionarBloquesInserciones: function seleccionarBloquesInserciones() {
			var _this11 = this;

			console.log('-------------------------------------------------------');
			console.log('-------------------------------------------------------');
			console.log('-------------------------------------------------------');
			console.log('------------------ RECALCULANDO -----------------------');
			console.log('-------------------------------------------------------');
			console.log('-------------------------------------------------------');
			console.log('-------------------------------------------------------');
			// Reseteamos los bloques
			this.bloques = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(this.bloques).reduce(function (acc, b) {
				b[1].DuracionInsercionesNuevas = 0;
				b[1].LineasInserciones = [];
				acc.set(b[1].BloqueID, b[1]);
				return acc;
			}, new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a());
			for (var l = 0; l < this.radiacion.lineas.length; l++) {
				var linea = this.radiacion.lineas[l];

				var _loop = function _loop(i) {
					var insercion = linea.inserciones[i];
					var horaInicio = _this11.$moment(insercion.Dia + ' ' + insercion.HoraInicio).unix();
					var horaFin = _this11.$moment(insercion.Dia + ' ' + insercion.HoraFin).unix();

					// Reseteamos el bloque
					_this11.radiacion.lineas[l].inserciones[i].BloqueID = null;

					// Ahora buscamos un bloque adecuado
					var bloquesCompatibles = [];
					var bloques = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(_this11.bloques).map(function (b) {
						return b[1];
					});
					for (var b = 0; b < bloques.length; b++) {
						var bloque = bloques[b];
						if (bloque.EmisoraID === linea.EmisoraID && bloque.Dia === insercion.Dia) {
							// Vemos si está en el rango horario que queremos
							if (horaInicio <= bloque.UnixTime && horaFin >= bloque.UnixTime) {
								bloquesCompatibles.push(bloque);
							}
						}
					}

					if (bloquesCompatibles.length === 0) {
						return 'continue';
					}

					_this11.radiacion.lineas[l].inserciones[i].Bloques = [];

					// TODO: Ordenar los bloques en función del tiempo libre que quede en cada uno de ellos

					for (var j = 0; j < insercion.Inserciones; j++) {
						/*
      	TODO: Ordenar los bloques compatibles por:
      		- Nº Inserciones (de este original) de menos a mayor
      		- % de ocupación del bloque (de menor a mayor)
      		- Hora de inicio del bloque (de menor a mayor)
      */
						// Actualizamos la información de los bloques compatibles
						bloquesCompatibles = bloquesCompatibles.map(function (b) {
							b = _this11.bloques.get(b.BloqueID);
							return b;
						});

						bloquesCompatibles.sort(function (a, b) {
							var insercionesA = a.LineasInserciones.reduce(function (acc, linea) {
								if (linea.InsercionID === insercion.InsercionID) {
									acc = acc + 1;
								}
							}, 0);

							var insercionesB = b.LineasInserciones.reduce(function (acc, linea) {
								if (linea.InsercionID === insercion.InsercionID) {
									acc = acc + 1;
								}
							}, 0);
							var duracionA = a.DuracionInserciones + a.DuracionInsercionesNuevas;
							var duracionB = b.DuracionInserciones + b.DuracionInsercionesNuevas;
							var completoA = duracionA * 100 / a.Duracion;
							var completoB = duracionB * 100 / b.Duracion;

							if (insercionesA > insercionesB) {
								return 1;
							} else if (insercionesA < insercionesB) {
								return -1;
							} else {
								if (completoA > completoB) {
									return 1;
								} else if (completoB > completoA) {
									return -1;
								} else {
									if (a.HoraInicioUnix > b.HoraInicioUnix) {
										return 1;
									} else if (a.HoraInicioUnix < b.HoraInicioUnix) {
										return -1;
									} else {
										return 0;
									}
								}
							}
						});
						// const indiceBloque = bloquesCompatibles.length < j + 1 ? j % bloquesCompatibles.length : j
						var indiceBloque = 0;
						var _bloque = bloquesCompatibles[indiceBloque];

						var pos = void 0;
						switch (insercion.Fijar) {
							case 'Primera':
								pos = 0;
								break;
							case 'Segunda':
								pos = 1;
								break;
							case 'Mitad':
								pos = Math.floor(_bloque.Inserciones / 2);
								break;
							case 'Penultima':
								pos = _bloque.Inserciones - 2;
								break;
							case 'Ultima':
								pos = _bloque.Inserciones - 1;
								break;
							default:
								pos = null;
								break;
						}
						_this11.radiacion.lineas[l].inserciones[i].Bloques.push({
							BloqueID: bloquesCompatibles[indiceBloque].BloqueID,
							HoraInicio: bloquesCompatibles[indiceBloque].HoraInicio,
							Duracion: bloquesCompatibles[indiceBloque].Duracion,
							DuracionInserciones: bloquesCompatibles[indiceBloque].DuracionInserciones,
							Posicion: pos
						});

						var _b = _this11.bloques.get(bloquesCompatibles[indiceBloque].BloqueID);
						_b.DuracionInsercionesNuevas = _b.DuracionInsercionesNuevas + _this11.radiacion.lineas[l].inserciones[i].DuracionReal;
						_b.LineasInserciones.push(_this11.radiacion.lineas[l].inserciones[i]);
						_this11.bloques.set(bloquesCompatibles[indiceBloque].BloqueID, _b);
					}
				};

				for (var i = 0; i < linea.inserciones.length; i++) {
					var _ret = _loop(i);

					if (_ret === 'continue') continue;
				}
			}

			this.guardarHistorial();
		}
	}
});

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['linea'],
	computed: {
		colocacionCorrecta: function colocacionCorrecta() {
			if (!this.linea) {
				return false;
			}
			if (this.linea.ProgramaID) {
				return true;
			} else if (this.linea.ContenidoID) {
				return true;
			} else if (this.linea.HoraInicio && this.linea.HoraFin) {
				return true;
			}
			return false;
		},
		opciones: function opciones() {
			var opt = {
				activoColocacion: false,
				activoInsertar: false,
				activoRotacionV: false,
				activoRotacionH: false,
				activoAnulaIns: false,
				activoRecuperaIns: false,
				activoModVarias: false
			};

			if (this.linea) {
				opt.activoColocacion = true;
				opt.activoInsertar = true & this.colocacionCorrecta;
				opt.activoRotacionV = true & this.colocacionCorrecta;
				opt.activoRotacionH = true & this.colocacionCorrecta;
				opt.activoAnulaIns = true & this.colocacionCorrecta;
				opt.activoRecuperaIns = true & this.colocacionCorrecta;
			}

			return opt;
		}
	},
	methods: {
		accion: function accion(_accion) {
			if (_accion !== 'colocacion' && !this.colocacionCorrecta) {
				return;
			}
			this.$emit('accion', _accion);
		}
	}
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__programa_vue__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contenido__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__manual__ = __webpack_require__(1506);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['EmisoraID', 'datos'],
	components: {
		SeleccionPrograma: __WEBPACK_IMPORTED_MODULE_1__programa_vue__["a" /* default */],
		SeleccionContenido: __WEBPACK_IMPORTED_MODULE_2__contenido__["a" /* default */],
		ColocacionManual: __WEBPACK_IMPORTED_MODULE_3__manual__["a" /* default */]
	},
	data: function data() {
		return {
			colocacion: {
				ContenidoID: null,
				ContenidoNombre: null,
				ProgramaID: null,
				ProgramaNombre: null,
				Posicion: null,
				Fijar: null,
				HoraInicio: null,
				HoraFin: null
			},
			tipoColocacion: 'Programa',
			fijaciones: ['Primera', 'Segunda', 'Mitad', 'Penultima', 'Ultima']
		};
	},
	created: function created() {
		if (this.datos) {
			this.colocacion = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.colocacion, this.datos);
		}
	},

	methods: {
		setTipoColocacion: function setTipoColocacion(tipo) {
			this.colocacion.ProgramaID = null;
			this.colocacion.ProgramaNombre = null;
			this.colocacion.ContenidoID = null;
			this.colocacion.ContenidoNombre = null;
			this.colocacion.HoraInicio = null;
			this.colocacion.HoraFin = null;
			this.tipoColocacion = tipo;
		},
		confirmar: function confirmar() {
			this.$emit('colocacion', this.colocacion);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['EmisoraID', 'colocacion'],
	data: function data() {
		return {
			listadoProgramas: []
		};
	},
	created: function created() {
		var _this = this;

		// Obtenemos los programas de esa emisora
		this.$http.post('gestion-emisoras/php/api/programas/buscar-programas.php', { EmisoraID: this.EmisoraID }).then(function (res) {
			_this.listadoProgramas = res.data;
		}).catch(this.$responseError);
	},

	methods: {
		seleccionaPrograma: function seleccionaPrograma(programa) {
			this.colocacion.ProgramaID = programa.ProgramaID;
			this.colocacion.ProgramaNombre = programa.Nombre;
		}
	}
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['EmisoraID', 'colocacion'],
	data: function data() {
		return {
			listadoContenidos: []
		};
	},
	created: function created() {
		var _this = this;

		// Obtenemos los programas de esa emisora
		this.$http.post('gestion-emisoras/php/api/contenidos/buscar-contenidos.php', { EmisoraID: this.EmisoraID }).then(function (res) {
			_this.listadoContenidos = res.data.listado;
		}).catch(this.$responseError);
	},

	methods: {
		seleccionaPrograma: function seleccionaPrograma(contenido) {
			this.colocacion.ContenidoID = contenido.ContenidoID;
			this.colocacion.ContenidoNombre = contenido.Nombre;
			this.colocacion.HoraInicio = contenido.HoraInicio;
			this.colocacion.HoraFin = contenido.HoraFin;
		}
	}
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['colocacion']
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__servicios_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal_calendario__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colocacion_colocacion_vue__ = __webpack_require__(64);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['linea', 'contrato'],
	components: {
		ModalCalendario: __WEBPACK_IMPORTED_MODULE_3__modal_calendario__["a" /* default */],
		Colocacion: __WEBPACK_IMPORTED_MODULE_4__colocacion_colocacion_vue__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				ClienteID: this.contrato.ClienteID,
				FechaDesde: new Date().setFullYear(new Date().getFullYear() - 1),
				FechaHasta: new Date(),
				Cadena: ''
			},
			listadoFicheros: [],
			originalSeleccionado: null,
			definirFechas: null,
			dias: [],
			colocando: null
		};
	},
	created: function created() {
		this.buscarOriginales();
		window.addEventListener('keyup', this.teclaPulsada);
	},
	beforeDestroy: function beforeDestroy() {
		window.removeEventListener('keyup', this.teclaPulsada);
	},

	methods: {
		buscarOriginales: function buscarOriginales() {
			var _this = this;

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.FechaDesde = this.$moment(this.filtro.FechaDesde).format('YYYY-MM-DD');
			form.FechaHasta = this.$moment(this.filtro.FechaHasta).format('YYYY-MM-DD');
			__WEBPACK_IMPORTED_MODULE_2__servicios_js__["a" /* default */].GetOriginales(form).then(function (listado) {
				_this.listadoFicheros = listado;
			}).catch(function (e) {
				console.error(e);
				_this.$error('Error', e);
			});
		},
		agregarOriginal: function agregarOriginal(fichero) {
			this.linea.originales.push({
				OriginalID: 'L-' + new Date().getTime() + Math.round(Math.random() * 10000),
				FicheroID: fichero.FicheroID,
				Descripcion: fichero.Nombre,
				UsuarioID: null,
				FechaCreacion: fichero.FechaCreacion,
				DuracionComercial: null,
				DuracionReal: fichero.FicheroDuracion,
				Importe: this.linea.ImporteBruto / this.linea.Cantidad,
				ImporteFinal: 0,
				Recargo: 0,
				Descuento: this.linea.Descuento,
				Inserciones: 1,
				ContenidoID: this.linea.ContenidoID,
				ContenidoNombre: this.linea.ContenidoNombre,
				ProgramaID: this.linea.ProgramaID,
				ProgramaNombre: this.linea.ProgramaNombre,
				HoraInicio: this.linea.HoraInicio,
				HoraFin: this.linea.HoraFin,
				dias: []
			});

			this.calculaImportes();
		},
		setFechas: function setFechas() {
			if (!this.originalSeleccionado) {
				return;
			}
			this.definirFechas = this.originalSeleccionado;
		},
		seleccionarTodo: function seleccionarTodo(e) {
			e.target.setSelectionRange(0, e.target.value.length);
		},
		setColocacion: function setColocacion() {
			if (!this.originalSeleccionado) {
				return;
			}
			this.colocando = this.originalSeleccionado;
		},
		colocar: function colocar(e) {
			for (var i = 0; i < this.linea.originales.length; i++) {
				if (this.linea.originales[i].OriginalID === this.originalSeleccionado.OriginalID) {
					this.linea.originales[i] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.linea.originales[i], e);
				}
			}
		},
		teclaPulsada: function teclaPulsada(e) {
			if (e.target.tagName === 'INPUT') {
				return;
			}
			if (e.keyCode === 46 && this.originalSeleccionado) {
				e.preventDefault();
				e.stopPropagation();
				this.eliminarOriginal(this.originalSeleccionado);
			}
		},
		eliminarOriginal: function eliminarOriginal(original) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar original',
				mensaje: '¿Quieres eliminar este original de la lista?',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.linea.originales = _this2.linea.originales.filter(function (o) {
							return o.OriginalID !== original.OriginalID;
						});
						_this2.originalSeleccionado = null;
					}
				}
			});
		},

		// Enviamos al padre todos los originales y sus fechas de inserción, así como el tramo horario
		insertar: function insertar() {
			var _this3 = this;

			var inserciones = this.linea.originales.reduce(function (acc, o) {
				for (var i in o.dias) {
					var ins = __WEBPACK_IMPORTED_MODULE_2__servicios_js__["a" /* default */].NuevaInsercion(_this3.$moment(o.dias[i]).format('YYYY-MM-DD'));

					ins.FicheroID = o.FicheroID;
					ins.Inserciones = o.Inserciones;
					ins.Descripcion = o.Descripcion;
					ins.Dia = _this3.$moment(o.dias[i]).format('YYYY-MM-DD');
					ins.DiaUnix = o.dias[i];
					ins.DuracionReal = o.DuracionReal;
					ins.DuracionEstimada = o.DuracionComercial;
					ins.Importe = o.Importe;
					ins.ImporteUnitario = o.ImporteUnitario;
					ins.ImporteFinal = o.ImporteFinal;
					ins.Descuento = o.Descuento;
					ins.ProgramaID = o.ProgramaID;
					ins.ProgramaNombre = o.ProgramaNombre;
					ins.ContenidoID = o.ContenidoID;
					ins.ContenidoNombre = o.ContenidoNombre;
					ins.HoraInicio = o.HoraInicio;
					ins.HoraFin = o.HoraFin;
					ins.Fijar = o.Fijar;
					ins.RefExterna = o.RefExterna;

					acc.push(ins);
				}
				return acc;
			}, []);

			var total = inserciones.reduce(function (acum, ins) {
				acum = acum + ins.Inserciones;
				return acum;
			}, 0);
			this.$store.commit('alertas/confirm', {
				titulo: 'Insertar originales',
				mensaje: 'Vas a insertar un total de ' + total + ' originales.\n\t\t\t\t\xBFQuieres continuar?',
				callback: function callback(acepta) {
					if (acepta) {
						_this3.$emit('inserciones', inserciones);
						_this3.cerrar();
					}
				}
			});
		},
		calculaImportes: function calculaImportes() {
			for (var i = 0; i < this.linea.originales.length; i++) {
				var l = this.linea.originales[i];
				var importe = isNaN(l.Importe) ? 0 : l.Importe;
				if (!isNaN(l.Descuento)) {
					importe = importe - importe * l.Descuento / 100;
				}

				if (!isNaN(l.Recargo)) {
					importe = importe + l.Recargo;
				}

				this.linea.originales[i].ImporteFinal = importe;
			}
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gestion_emisoras_vue_componentes_utilidades_calendario_anual_vue__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['linea', 'contrato'],
	components: {
		CalendarioAnual: __WEBPACK_IMPORTED_MODULE_0__gestion_emisoras_vue_componentes_utilidades_calendario_anual_vue__["a" /* default */]
	},
	created: function created() {
		console.log(this.linea);
	},

	methods: {
		cerrar: function cerrar() {
			// Emitimos cierre
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gestion_emisoras_vue_componentes_utilidades_calendario_anual_vue__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato', 'radiacion'],
	components: {
		CalendarioAnual: __WEBPACK_IMPORTED_MODULE_0__gestion_emisoras_vue_componentes_utilidades_calendario_anual_vue__["a" /* default */]
	},
	data: function data() {
		return {
			dias: []
		};
	},

	computed: {
		resaltados: function resaltados() {
			return this.radiacion.lineas.reduce(function (acc, linea) {
				acc = linea.inserciones.reduce(function (acc, insercion) {
					if (acc.indexOf(insercion.Dia) < 0 && !insercion.Anulada) {
						acc.push(insercion.Dia);
					}
					return acc;
				}, acc);
				return acc;
			}, []);
		}
	},
	methods: {
		filtrar: function filtrar() {
			var _this = this;

			this.dias = this.dias.filter(function (d) {
				var diaStr = _this.$moment(d).format('YYYY-MM-DD');
				return _this.resaltados.indexOf(diaStr) >= 0;
			});
		},
		eliminar: function eliminar() {
			this.filtrar();
			this.$emit('eliminar', this.dias);
			this.cerrar();
		},
		anular: function anular() {
			this.filtrar();
			this.$emit('anular', this.dias);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gestion_emisoras_vue_componentes_utilidades_calendario_anual_vue__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato', 'radiacion'],
	components: {
		CalendarioAnual: __WEBPACK_IMPORTED_MODULE_0__gestion_emisoras_vue_componentes_utilidades_calendario_anual_vue__["a" /* default */]
	},
	data: function data() {
		return {
			dias: []
		};
	},

	computed: {
		resaltados: function resaltados() {
			return this.radiacion.lineas.reduce(function (acc, linea) {
				acc = linea.inserciones.reduce(function (acc, insercion) {
					if (acc.indexOf(insercion.Dia) < 0 && insercion.Anulada) {
						acc.push(insercion.Dia);
					}
					return acc;
				}, acc);
				return acc;
			}, []);
		}
	},
	methods: {
		filtrar: function filtrar() {
			var _this = this;

			this.dias = this.dias.filter(function (d) {
				var diaStr = _this.$moment(d).format('YYYY-MM-DD');
				return _this.resaltados.indexOf(diaStr) >= 0;
			});
		},
		recuperar: function recuperar() {
			this.filtrar();
			this.$emit('recuperar', this.dias);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilidades_modalSeleccionOriginal_component_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resumen_bloques_component__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colocacion_colocacion_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__servicios__ = __webpack_require__(50);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['linea', 'dia', 'contrato', 'bloques'],
	components: {
		Colocacion: __WEBPACK_IMPORTED_MODULE_4__colocacion_colocacion_vue__["a" /* default */],
		ModalSeleccionOriginal: __WEBPACK_IMPORTED_MODULE_2__utilidades_modalSeleccionOriginal_component_vue__["a" /* default */],
		ResumenBloques: __WEBPACK_IMPORTED_MODULE_3__resumen_bloques_component__["a" /* default */]
	},
	data: function data() {
		return {
			insercionSeleccionada: null,
			inserciones: [],
			colocando: false,
			seleccionOriginal: null,
			resumen: null
		};
	},
	created: function created() {
		var _this = this;

		this.inserciones = [].concat(this.linea.inserciones).filter(function (i) {
			return i.Dia === _this.dia && !i.Anulada;
		}).map(function (i) {
			return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(i));
		});
	},

	methods: {
		seleccionarInsercion: function seleccionarInsercion(InsercionID) {
			this.insercionSeleccionada = InsercionID;
		},
		seleccionarOriginal: function seleccionarOriginal(insercion) {
			this.seleccionOriginal = insercion;
		},
		onSeleccionarOriginal: function onSeleccionarOriginal($event) {
			this.seleccionOriginal.FicheroID = $event[0].FicheroID;
			this.seleccionOriginal.Descripcion = $event[0].Descripcion;
		},
		nuevaInsercion: function nuevaInsercion() {
			var ins = __WEBPACK_IMPORTED_MODULE_5__servicios__["a" /* default */].NuevaInsercion(this.dia);
			this.inserciones.push(ins);
		},
		eliminarRadiacion: function eliminarRadiacion() {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar insercion',
				mensaje: '¿Quieres eliminar esta(s) insercion(es)?',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.inserciones = _this2.inserciones.filter(function (r) {
							return r.InsercionID !== _this2.insercionSeleccionada;
						});
						_this2.insercionSeleccionada = null;
					}
				}
			});
		},
		colocar: function colocar() {
			if (!this.insercionSeleccionada) {
				return;
			}

			this.colocando = true;
		},
		setColocacion: function setColocacion(datos) {
			var _this3 = this;

			this.inserciones = this.inserciones.map(function (r) {
				if (r.InsercionID === _this3.insercionSeleccionada) {
					r = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, r, datos);
				}
				return r;
			});
		},
		guardar: function guardar() {
			// this.linea.inserciones = this.inserciones.filter(i => (i.FicheroID))
			this.$emit('guardar', this.inserciones);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		calculaImportes: function calculaImportes() {
			for (var i = 0; i < this.inserciones.length; i++) {
				var l = this.inserciones[i];
				var importe = isNaN(l.Importe) ? 0 : l.Importe;
				if (!isNaN(l.Descuento)) {
					importe = importe - importe * l.Descuento / 100;
				}

				if (!isNaN(l.Recargo)) {
					importe = importe + l.Recargo;
				}

				this.inserciones[i].ImporteFinal = importe;
			}
		},
		seleccionarTodo: function seleccionarTodo(e) {
			e.target.setSelectionRange(0, e.target.value.length);
		}
	}
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__servicios__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['AnuncianteID', 'ClienteID', 'solo'],
	data: function data() {
		return {
			filtro: {
				fechas: {
					start: this.$moment().subtract(1, 'year').toDate(),
					end: new Date()
				},
				ClienteID: null,
				Titulo: null
			},
			ClienteNombre: null,
			ficheros: [],
			seleccionado: []
		};
	},
	created: function created() {
		if (this.ClienteID) {
			this.filtro.ClienteID = parseInt(this.ClienteID);
		}
		this.getFicheros();
		this.getCliente();
	},

	methods: {
		getCliente: function getCliente() {
			var _this = this;

			this.$http.get('gestion-clientes/php/api/get-cliente.php?ID=' + this.ClienteID).then(function (res) {
				_this.ClienteNombre = res.data.cliente.cliente;
			}).catch(function (e) {
				console.error(e);
				_this.$responseError(e);
			});
		},
		toggle: function toggle(fichero) {
			if (this.solo) {
				this.seleccionado = [];
			}
			for (var i = 0; i < this.seleccionado.length; i++) {
				if (this.seleccionado[i] === fichero) {
					this.seleccionado.splice(i, 1);
					return;
				}
			}

			this.seleccionado.push(fichero);
		},
		getFicheros: function getFicheros() {
			var _this2 = this;

			var form = {
				ClienteID: this.filtro.ClienteID,
				FechaDesde: this.$moment(this.filtro.fechas.start).format('YYYY-MM-DD'),
				FechaHasta: this.$moment(this.filtro.fechas.end).format('YYYY-MM-DD'),
				Cadena: this.filtro.Titulo
			};
			__WEBPACK_IMPORTED_MODULE_0__servicios__["a" /* default */].GetOriginales(form).then(function (ficheros) {
				_this2.ficheros = ficheros;
			}).catch(function (e) {
				console.log(e);
				_this2.$error('Error', e);
			});
		},
		setCliente: function setCliente(e) {
			this.filtro.ClienteID = e.datos.ID;
			this.ClienteNombre = e.datos.cliente;
			this.getFicheros();
		},
		delCliente: function delCliente() {
			this.filtro.ClienteID = null;
		},
		seleccionar: function seleccionar() {
			this.$emit('seleccionar', this.seleccionado.map(function (s) {
				return {
					FicheroID: s.FicheroID,
					Descripcion: s.Nombre,
					Duracion: s.FicheroDuracion
				};
			}));
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['insercion', 'bloques'],
	computed: {
		bloquesUsados: function bloquesUsados() {
			var bloques = this.insercion.Bloques.reduce(function (acc, bloque) {
				if (acc.has(bloque.BloqueID)) {
					var b = acc.get(bloque.BloqueID);
					b.Inserciones = b.Inserciones + 1;
					acc.set(bloque.BloqueID, b);
				} else {
					acc.set(bloque.BloqueID, {
						BloqueID: bloque.BloqueID,
						Inserciones: 1,
						HoraInicio: bloque.HoraInicio,
						Duracion: bloque.Duracion,
						DuracionInserciones: bloque.DuracionInserciones
					});
				}
				return acc;
			}, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a());

			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(bloques).map(function (b) {
				return b[1];
			});
		}
	},
	methods: {
		getOcupacion: function getOcupacion(bloque) {
			var b = this.bloques.get(bloque.BloqueID);
			var total = bloque.Duracion;
			var ocupado = bloque.DuracionInserciones + b.DuracionInsercionesNuevas;

			return {
				porcentaje: this.$options.filters.round(ocupado * 100 / total, 2),
				segundos: total - ocupado
			};
		},
		getInsercionesTotales: function getInsercionesTotales(bloque) {
			var BloqueID = bloque.BloqueID;

			var b = this.bloques.get(BloqueID);
			return b.TotalInserciones + b.LineasInserciones.length;
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilidades_modalSeleccionOriginal_component_vue__ = __webpack_require__(91);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato', 'linea'],
	components: {
		ModalOriginal: __WEBPACK_IMPORTED_MODULE_4__utilidades_modalSeleccionOriginal_component_vue__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				Origen: null,
				Destinos: [],
				DestinosAsignados: [],
				FechaInicio: null,
				FechaFin: null,
				Accion: 'copiar',
				ModificarImportes: false,
				Importe: null,
				Descuento: null,
				Recargo: null,
				ImporteFinal: null
			},
			nuevosDestinos: [],
			nuevoDestino: null,
			inserciones: []
		};
	},
	created: function created() {
		this.inserciones = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.linea.inserciones));
	},

	computed: {
		listadoFicheros: function listadoFicheros() {
			var mapa = this.inserciones.reduce(function (acc, ins) {
				if (!acc.has(ins.FicheroID)) {
					acc.set(ins.FicheroID, {
						FicheroID: ins.FicheroID,
						Descripcion: ins.Descripcion
					});
				}
				return acc;
			}, new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a());

			mapa = this.nuevosDestinos.reduce(function (acc, ins) {
				if (!acc.has(ins.FicheroID)) {
					acc.set(ins.FicheroID, {
						FicheroID: ins.FicheroID,
						Descripcion: ins.Descripcion
					});
				}
				return acc;
			}, mapa);

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(mapa).map(function (d) {
				return d[1];
			});
		},
		importeFinal: function importeFinal() {
			return 0;
		}
	},
	methods: {
		agregarDestino: function agregarDestino() {
			this.nuevoDestino = true;
		},
		setNuevoDestino: function setNuevoDestino(ficheros) {
			this.nuevosDestinos = this.nuevosDestinos.concat(ficheros);
		},
		nombreFichero: function nombreFichero(FicheroID) {
			return this.listadoFicheros.reduce(function (acc, fichero) {
				if (fichero.FicheroID === FicheroID) {
					acc = fichero.Descripcion;
				}
				return acc;
			}, '');
		},
		calculaImporte: function calculaImporte() {
			var importe = 0;
			if (this.filtro.ModificarImportes) {
				importe = typeof this.filtro.Importe === 'number' ? this.filtro.Importe : 0;
				var descuento = typeof this.filtro.Descuento === 'number' ? this.filtro.Descuento : 0;
				var recargo = typeof this.filtro.Recargo === 'number' ? this.filtro.Recargo : 0;

				importe = importe - importe * descuento / 100 + recargo;
				importe = this.$options.filters.round(importe, 2);
			}

			this.filtro.ImporteFinal = importe;
		},
		cambiaDestinos: function cambiaDestinos(ev) {
			var _this = this;

			// Quitamos los destinos no seleccionados
			this.filtro.DestinosAsignados = this.filtro.DestinosAsignados.filter(function (d) {
				return _this.filtro.Destinos.indexOf(d.FicheroID) >= 0;
			});

			// Agregamos los que no tenemos
			this.filtro.Destinos.forEach(function (d) {
				var presente = false;
				_this.filtro.DestinosAsignados.forEach(function (a, i) {
					if (a.FicheroID === d) {
						presente = true;
					}
				});

				if (!presente) {
					_this.filtro.DestinosAsignados.push({
						FicheroID: d,
						Porcentaje: 0,
						Descripcion: _this.nombreFichero(d)
					});
				}
			});
		},
		guardar: function guardar() {
			if (!this.filtro.Origen) {
				this.$error('Error', 'Debes seleccionar el fichero de origen');
				return;
			}

			if (!this.filtro.Destinos.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un destino');
				return;
			}

			if (this.filtro.DestinosAsignados.length === 1) {
				this.filtro.DestinosAsignados = this.filtro.DestinosAsignados.map(function (d) {
					d.Porcentaje = 100;
					return d;
				});
			}

			var porcentajeTotal = this.filtro.DestinosAsignados.reduce(function (acc, fichero) {
				acc = acc + fichero.Porcentaje;
				return acc;
			}, 0);

			if (porcentajeTotal !== 100) {
				this.$error('Error', 'Los porcentajes deben sumar 100');
				return;
			}

			if (!this.filtro.FechaInicio) {
				this.$error('Error', 'Debes seleccionar la fecha de inicio');
				return;
			}

			if (!this.filtro.FechaFin) {
				this.$error('Error', 'Debes seleccionar la fecha de fin');
				return;
			}

			this.filtro.FechaInicio.setHours(0);
			this.filtro.FechaInicio.setMinutes(0);
			this.filtro.FechaInicio.setSeconds(0);
			this.filtro.FechaInicio.setMilliseconds(0);

			this.filtro.FechaFin.setHours(23);
			this.filtro.FechaFin.setMinutes(59);
			this.filtro.FechaFin.setSeconds(59);
			this.filtro.FechaFin.setMilliseconds(999);

			if (this.filtro.FechaInicio > this.filtro.FechaFin) {
				this.$error('Error', 'La fecha de inicio debe ser anterior o igual a la de fin');
			}

			this.repartir();
		},
		repartir: function repartir() {
			var _this2 = this;

			// Lo primero es analizar cuantas inserciones tiene origen
			var totalInserciones = this.inserciones.reduce(function (acc, ins) {
				if (ins.FicheroID === _this2.filtro.Origen) {
					acc = acc + ins.Inserciones;
				}
				return acc;
			}, 0);

			// Ahora calculamos las que corresponden a cada destino
			var destinos = this.filtro.DestinosAsignados.map(function (d) {
				d.Inserciones = Math.floor(d.Porcentaje * totalInserciones / 100);
				return d;
			});

			// Si sobrara alguna inserción se la asignamos al que tenga mayor porcentaje
			var asignadas = destinos.reduce(function (acc, dst) {
				acc = acc + dst.Inserciones;
				return acc;
			}, 0);

			if (asignadas !== totalInserciones) {
				destinos.sort(function (a, b) {
					if (a.Porcentaje > b.Porcentaje) {
						return 1;
					} else if (a.Porcentaje < b.Porcentaje) {
						return -1;
					} else {
						return 0;
					}
				});

				destinos[0].Inserciones = destinos[0].Inserciones + totalInserciones - asignadas;
			}

			// Construimos un contador para restart inserciones a los destinos
			var pendientes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(destinos.reduce(function (acc, dst) {
				acc.set(dst.FicheroID, dst);
				return acc;
			}, new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a())).map(function (d) {
				return d[1];
			});
			// Ahora recorremos las inserciones de la línea para sustituir las que correspondan en fecha y origen
			var indicePendientes = 0;

			var _loop = function _loop(i) {
				var ins = _this2.inserciones[i];
				var insID = _this2.filtro.Accion + '-' + ins.InsercionID;
				var insercionesInsercion = ins.Inserciones + 0;
				var destinoAnterior = null;
				if (ins.DiaUnix < _this2.filtro.FechaInicio.getTime() || ins.DiaUnix > _this2.filtro.FechaFin.getTime()) {
					return 'continue';
				}
				for (var a = 0; a < insercionesInsercion; a++) {
					if (ins.FicheroID === _this2.filtro.Origen) {
						var _ret2 = function () {
							var iP = null;
							var destino = null;
							var bucle = 0;
							while (iP === null && bucle < 1000) {
								bucle++;
								iP = indicePendientes > pendientes.length - 1 ? indicePendientes % pendientes.length : indicePendientes;
								console.log(iP);
								if (pendientes[iP].Inserciones === 0) {
									iP = null;
									indicePendientes++;
								} else {
									destino = pendientes[iP];

									if (destino.FicheroID === destinoAnterior) {
										destinoAnterior = null;
										iP = null;
										indicePendientes++;
									}
								}
							}

							if (destino === null) {
								_this2.$error('Error', 'Error repartiendo');
								return {
									v: {
										v: void 0
									}
								};
							}

							destinoAnterior = destino.FicheroID;

							var nueva = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this2.inserciones[i]));
							nueva.InsercionID = insID;

							var existente = _this2.inserciones.reduce(function (acc, ins, i) {
								if (ins.InsercionID === insID && ins.FicheroID === destino.FicheroID) {
									ins.Indice = i;
									acc.push(ins);
								}
								return acc;
							}, []);

							if (existente.length > 0) {
								_this2.inserciones[existente[0].Indice].Inserciones = _this2.inserciones[existente[0].Indice].Inserciones + 1;
							} else {
								nueva.FicheroID = destino.FicheroID;
								nueva.Descripcion = destino.Descripcion;
								nueva.Inserciones = 1;
								_this2.inserciones.push(nueva);
							}
							if (_this2.filtro.Accion === 'mover') {
								ins.Inserciones = ins.Inserciones - 1;

								if (ins.Inserciones <= 0) {
									_this2.inserciones.splice(i, 1);
								}
							}

							pendientes[iP].Inserciones = pendientes[iP].Inserciones - 1;
						}();

						if ((typeof _ret2 === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret2)) === "object") return _ret2.v;
					}
				}
			};

			for (var i = this.inserciones.length - 1; i >= 0; i--) {
				var _ret = _loop(i);

				switch (_ret) {
					case 'continue':
						continue;

					default:
						if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
				}
			}
			// AHora asignamos nuevos IDs a todas las inserciones
			this.inserciones = this.inserciones.map(function (i) {
				i.InsercionID = 'I-' + new Date().getTime() + Math.round(Math.random() * 100000);
				return i;
			});
			this.$emit('guardar', this.inserciones);
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilidades_modalSeleccionOriginal_component_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gestion_emisoras_vue_componentes_utilidades_calendario_anual_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colocacion_colocacion_vue__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__servicios__ = __webpack_require__(50);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['contrato', 'linea'],
	components: {
		ModalSeleccionFicheros: __WEBPACK_IMPORTED_MODULE_2__utilidades_modalSeleccionOriginal_component_vue__["a" /* default */],
		CalendarioAnual: __WEBPACK_IMPORTED_MODULE_3__gestion_emisoras_vue_componentes_utilidades_calendario_anual_vue__["a" /* default */],
		ModalColocacion: __WEBPACK_IMPORTED_MODULE_4__colocacion_colocacion_vue__["a" /* default */]
	},
	data: function data() {
		return {
			Accion: 'reemplazar',
			ficheros: [],
			ficheroFoco: null,
			dias: [],
			inserciones: [],
			insercionSel: null,
			reemplazar: true,
			verSeleccionFicheros: false,
			listadoFicheros: [],
			seleccionado: null,
			verSeleccionarFechas: false,
			verColocacion: false
		};
	},

	methods: {
		addFicheros: function addFicheros(e) {
			var _this = this;

			e.forEach(function (fichero) {
				var existe = false;
				for (var i = 0; i < _this.listadoFicheros.length; i++) {
					if (_this.listadoFicheros[i].FicheroID === fichero.FicheroID) {
						existe = true;
					}
				}

				if (!existe) {
					_this.listadoFicheros.push(fichero);
				}
			});
		},
		delFichero: function delFichero(i) {
			this.ficheros.splice(i, 1);
			this.ficheroFoco = null;
		},
		addInsercion: function addInsercion() {
			this.inserciones.push({
				Inserciones: null,
				RefExterna: null,
				DuracionReal: null,
				HoraInicio: '00:00:00',
				HoraFin: '00:00:00',
				ContenidoID: null,
				ContenidoNombre: null,
				ProgramaID: null,
				ProgramaNombre: null,
				Fijar: null,
				Importe: null,
				Descuento: null,
				Recargo: null,
				ImporteFinal: null
			});
			this.calculaImporte();
		},
		delInsercion: function delInsercion(i) {
			this.inserciones.splice(i, 1);
			this.insercionSel = null;
		},
		setColocacion: function setColocacion(datos) {
			this.inserciones[this.insercionSel] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.inserciones[this.insercionSel], datos);
		},
		insertar: function insertar(fichero) {
			this.ficheros.push(fichero);
		},
		calculaImporte: function calculaImporte() {
			this.inserciones = this.inserciones.map(function (i) {
				var importe = typeof i.Importe === 'number' ? i.Importe : 0;
				var importeFinal = importe;
				if (typeof i.Descuento === 'number' && importe !== 0) {
					importeFinal = importe - importe * i.Descuento / 100;
				}

				if (typeof i.Recargo === 'number') {
					importeFinal = importeFinal + i.Recargo;
				}

				i.ImporteFinal = importeFinal;
				return i;
			});
		},
		aplicar: function aplicar() {
			var _this2 = this;

			// Revisamos que hay al menos un día seleccionado
			if (this.dias.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un día');
				return;
			}

			if (this.ficheros.length === 0) {
				this.$error('Error', 'Debes insertar al menos un fichero en originales');
				return;
			}

			if (this.inserciones.length === 0) {
				this.$error('Error', 'No has definido ninguna inserción');
				return;
			}

			// Ahora repasamos cada inserción
			for (var i = 0; i < this.inserciones.length; i++) {
				var _ins = this.inserciones[i];

				if (!_ins.Inserciones || _ins.inserciones <= 0) {
					this.$error('Error', 'La l\xEDnea ' + (i + 1) + ' no tiene un n\xFAmero de inserciones v\xE1lido');
					return;
				}

				var exp = /^[0-9]{2}:[0-9]{2}:[0-9]{2}$/;

				if (!exp.test(_ins.HoraInicio)) {
					this.$error('Error', 'La hora de inicio de la l\xEDnea ' + (i + 1) + ' no es v\xE1lida');
					return;
				}

				if (!exp.test(_ins.HoraFin)) {
					this.$error('Error', 'La hora de fin de la l\xEDnea ' + (i + 1) + ' no es v\xE1lida');
					return;
				}

				var horaInicio = _ins.HoraInicio.split(':').map(function (d) {
					return parseInt(d);
				});
				var horaFin = _ins.HoraFin.split(':').map(function (d) {
					return parseInt(d);
				});

				if (horaInicio[0] > horaFin[0]) {
					this.$error('Error', 'En la l\xEDnea ' + (i + 1) + ' la hora de inicio es posterior a la de fin');
					return;
				} else if (horaInicio[0] === horaFin[0] && horaInicio[1] > horaFin[1]) {
					this.$error('Error', 'En la l\xEDnea ' + (i + 1) + ' la hora de inicio es posterior a la de fin');
					return;
				} else if (horaInicio[0] === horaFin[0] && horaInicio[1] > horaFin[1] && horaInicio[2] > horaFin[2]) {
					this.$error('Error', 'En la l\xEDnea ' + (i + 1) + ' la hora de inicio es posterior a la de fin');
					return;
				}
			}

			// Ahora mapeamos los datos
			var ins = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.linea.inserciones));

			// En caso de que sea sustitució, quitamos las de los días seleccionados
			var diasSeleccionados = this.dias.map(function (d) {
				return _this2.$moment(d).format('YYYY-MM-DD');
			});

			if (this.Accion === 'reemplazar') {
				ins = ins.filter(function (i) {
					return diasSeleccionados.indexOf(i.Dia) < 0;
				});
			}

			// Ahora empezamos con la rotación
			var indiceFichero = 0;
			for (var d = 0; d < this.dias.length; d++) {
				for (var l = 0; l < this.inserciones.length; l++) {
					var linea = this.inserciones[l];

					for (var _i = 0; _i < linea.Inserciones; _i++) {
						var fichero = indiceFichero < this.ficheros.length ? indiceFichero : indiceFichero % this.ficheros.length;
						// Generamos la inserción para este día, está línea y ese fichero
						var nuevaInsercion = __WEBPACK_IMPORTED_MODULE_5__servicios__["a" /* default */].NuevaInsercion(this.$moment(this.dias[d]).format('YYYY-MM-DD'));
						nuevaInsercion.FicheroID = this.ficheros[fichero].FicheroID;
						nuevaInsercion.Descripcion = this.ficheros[fichero].Descripcion;
						nuevaInsercion.DuracionReal = this.ficheros[fichero].Duracion;
						nuevaInsercion.HoraInicio = linea.HoraInicio;
						nuevaInsercion.HoraFin = linea.HoraFin;
						nuevaInsercion.ProgramaID = linea.ProgramaID;
						nuevaInsercion.ProgramaNombre = linea.ProgramaNombre;
						nuevaInsercion.ContenidoID = linea.ContenidoID;
						nuevaInsercion.ContenidoNombre = linea.ContenidoNombre;
						nuevaInsercion.Fijar = linea.Fijar;

						// TODO: faltan parámetros
						ins.push(nuevaInsercion);
						indiceFichero++;
					}
				}
			}
			this.$emit('rotacion', ins);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__etiquetas__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__categorias__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__agenda__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__audios__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__imagenes__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__palabrasClave__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__visor_texto__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Etiquetas: __WEBPACK_IMPORTED_MODULE_3__etiquetas__["a" /* default */],
		Agenda: __WEBPACK_IMPORTED_MODULE_5__agenda__["a" /* default */],
		Categorias: __WEBPACK_IMPORTED_MODULE_4__categorias__["a" /* default */],
		Audios: __WEBPACK_IMPORTED_MODULE_6__audios__["a" /* default */],
		Imagenes: __WEBPACK_IMPORTED_MODULE_7__imagenes__["a" /* default */],
		PalabrasClave: __WEBPACK_IMPORTED_MODULE_8__palabrasClave__["a" /* default */],
		VisorTexto: __WEBPACK_IMPORTED_MODULE_9__visor_texto__["a" /* default */]
	},
	data: function data() {
		return {
			Texto: {
				NoticiaID: null,
				Nombre: '',
				Nevera: false,
				Titular: '',
				Lead: '',
				Audios: [],
				Imagenes: [],
				Etiquetas: [],
				Categorias: [],
				Texto: ''
			},
			EdicionID: null,
			configuracionEditor: {
				menubar: false,
				theme: 'modern',
				plugins: ['advlist autolink lists link image charmap print preview anchor textcolor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table contextmenu paste code help wordcount paste'],
				toolbar: 'insert paste | undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat',
				paste_as_text: true,
				table_default_attributes: {
					'border': '1'
				},
				table_default_styles: {
					'border-collapsed': 'collapse',
					'width': '100%'
				},
				table_responsive_width: true,
				content_style: '\n\t\t\t\t\ttable {width: 100%;border-spacing: 0;border-collapse: separate;border: 1px solid #aaa;}\n\t\t\t\t\ttable tr:nth-child(even) {background-color: #fafafa;}\n\t\t\t\t\ttable td, table th {border: 1px solid #aaa; border-collapse:collapse;padding: 5px;}\n\t\t\t\t'
			},
			modificado: false,
			intervalo: null,
			intervaloEditando: null,
			imprimir: false
		};
	},
	created: function created() {
		var _this = this;

		if (this.$route.params.id !== 'nueva') {
			// Buscamos
			this.Texto.NoticiaID = this.$route.params.id;
			this.obtenerNoticia();
		} else {
			this.guardarNoticia(true);
		}
		this.intervalo = window.setInterval(function () {
			_this.guardarNoticia();
		}, 30000);

		this.intervaloEditando = window.setInterval(function () {
			_this.actualizaEditando();
		}, 10000);
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.intervalo);
		window.clearInterval(this.intervaloEditando);

		if (this.EdicionID) {
			this.cerrarEdicion();
		}
	},

	watch: {
		'Texto.Texto': function TextoTexto(newVal) {
			this.modificado = true;
		},
		'Texto.Titular': function TextoTitular(newVal) {
			this.modificado = true;
		}
	},
	computed: {
		readonly: function readonly() {
			if (!this.Texto) {
				return false;
			}

			if (this.Texto.Editando && this.Texto.Editando.EdicionID === this.EdicionID) {
				return false;
			}
			return true;
		},
		contador: function contador() {
			if (!this.Texto.Texto) {
				return 0;
			}
			var striped = this.Texto.Texto.replace(/<[^>]*>/gm, '');
			var resultado = striped.match(/[^\s]\s/gm);
			if (!resultado) {
				return 1;
			}
			return resultado.length + 1;
		},
		palabrasClave: function palabrasClave() {
			if (!this.Texto.Texto) {
				console.log('No hay texto');
				return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
			}
			var striped = this.Texto.Texto.replace(/<[^>]*>/gm, '');
			striped = striped.replace(/&aacute;/igm, 'á');
			striped = striped.replace(/&eacute;/igm, 'é');
			striped = striped.replace(/&iacute;/igm, 'í');
			striped = striped.replace(/&oacute;/igm, 'ó');
			striped = striped.replace(/&uacute;/igm, 'ú');
			striped = striped.replace(/(ntilde|nbsp)/igm, '');
			striped = striped.replace(/(cuando|había|ante|contra|saber|tras|según|hasta|para)/igm, '');
			var resultado = striped.match(/\s?([\wáéíóú]{4,})\s?/igm);
			if (!resultado) {
				return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
			}

			return resultado.reduce(function (ant, palabra) {
				palabra = palabra.trim().toUpperCase();
				if (palabra.length > 1) {
					if (ant.has(palabra)) {
						var cant = ant.get(palabra);
						ant.set(palabra, cant + 1);
					} else {
						ant.set(palabra, 1);
					}
				}
				return ant;
			}, new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a());
		}
	},
	methods: {
		cerrarEdicion: function cerrarEdicion() {
			var _this2 = this;

			var form = {
				NoticiaID: this.Texto.NoticiaID,
				EdicionID: this.EdicionID
			};
			__WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('redaccion/php/api/del-editando.php', form).then(function () {
				console.log('Cerrando la edición');
				_this2.EdicionID = null;
				_this2.Texto.Editando = null;
			}).catch(this.$responseError);
		},
		actualizaEditando: function actualizaEditando() {
			var _this3 = this;

			if (this.EdicionID) {
				var form = {
					NoticiaID: this.Texto.NoticiaID,
					EdicionID: this.EdicionID
				};

				__WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('redaccion/php/api/set-editando.php', form).then(function (res) {
					_this3.EdicionID = res.data.EdicionID;
				}).catch(function () {
					_this3.EdicionID = null;
				});
			} else {
				this.obtenerNoticia();
			}
		},
		obtenerNoticia: function obtenerNoticia() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_10_axios___default.a.get('redaccion/php/api/get-noticia.php?NoticiaID=' + this.Texto.NoticiaID).then(function (res) {
				_this4.Texto = res.data;
			}).catch(this.$responseError);
		},
		editarNoticia: function editarNoticia() {
			var _this5 = this;

			var form = {
				NoticiaID: this.Texto.NoticiaID,
				EdicionID: this.EdicionID
			};
			__WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('redaccion/php/api/editar-noticia.php', form).then(function (resEd) {
				_this5.obtenerNoticia();
				_this5.EdicionID = resEd.data.EdicionID;
			}).catch(this.$responseError);
		},
		guardarNoticia: function guardarNoticia(ini) {
			var _this6 = this;

			if ((!this.modificado || !this.EdicionID) && !ini) {
				return;
			}

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.Texto));
			form.NumeroPalabras = this.contador;
			form.PalabrasClave = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.palabrasClave).reduce(function (ant, actual) {
				ant.push({
					Palabra: actual[0],
					Apariciones: actual[1]
				});
				return ant;
			}, []);
			__WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('redaccion/php/api/set-noticia.php', form).then(function (res) {
				_this6.Texto.NoticiaID = res.data.NoticiaID;
				_this6.$store.commit('toast/success', {
					titulo: 'Autoguardado',
					mensaje: 'Se han guardado los cambios automáticamente'
				});
				_this6.modificado = false;

				if (ini) {
					_this6.editarNoticia();
				}
			}).catch(this.$responseError);
		},
		eliminarNoticia: function eliminarNoticia() {
			var _this7 = this;

			if (!this.Texto.NoticiaID) {
				return;
			}

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar noticia',
				mensaje: '\xBFQuieres eliminar este noticia?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_10_axios___default.a.delete('redaccion/php/api/del-noticia.php?NoticiaID=' + _this7.Texto.NoticiaID).then(function (res) {
							_this7.$store.commit('toast/success', {
								titulo: 'Noticia eliminada',
								mensaje: 'Se ha eliminado la noticia correctamente'
							});
							_this7.$router.push('/main/redaccion');
						}).catch(_this7.$responseError);
					}
				}
			});
		},
		descargarPDF: function descargarPDF() {
			window.location.href = '/src/modulos/redaccion/php/api/get-pdf.php?NoticiaID=' + this.Texto.NoticiaID;
		},
		goImprimir: function goImprimir(opciones) {
			var _this8 = this;

			console.log(opciones);
			var form = {
				OpcionesImpresion: opciones,
				Noticias: [this.Texto.NoticiaID]
			};

			__WEBPACK_IMPORTED_MODULE_10_axios___default.a.post('redaccion/php/api/imprimir.php', form).then(function (res) {
				_this8.$store.commit('toast/success', {
					titulo: 'Impresión iniciada'
				});
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['texto', 'readonly'],
	data: function data() {
		return {
			nueva: ''
		};
	},

	methods: {
		crear: function crear() {
			var _this = this;

			if (this.nueva) {
				var form = {
					NoticiaID: this.texto.NoticiaID,
					Etiqueta: this.nueva
				};
				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('redaccion/php/api/add-etiqueta.php', form).then(function (res) {
					_this.texto.Etiquetas = res.data;
					_this.nueva = '';
				}).catch(this.$responseError);
			}
		},
		quitar: function quitar(Etiqueta) {
			var _this2 = this;

			if (this.readonly) {
				return;
			}
			var form = {
				NoticiaID: this.texto.NoticiaID,
				Etiqueta: Etiqueta
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('redaccion/php/api/del-etiqueta.php', form).then(function (res) {
				_this2.texto.Etiquetas = res.data;
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['texto', 'readonly'],
	data: function data() {
		return {
			nueva: '',
			listadoCategorias: []
		};
	},

	methods: {
		seleccionada: function seleccionada(ev) {
			var _this = this;

			if (this.readonly) {
				return;
			}
			var form = {
				CategoriaID: ev.datos.CategoriaID,
				NoticiaID: this.texto.NoticiaID
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('redaccion/php/api/add-categoria.php', form).then(function (res) {
				_this.texto.Categorias = res.data;
			}).catch(this.$responseError);
		},
		crear: function crear() {
			if (this.readonly) {
				return;
			}
			if (this.nueva) {
				var nueva = this.nueva.toUpperCase();
				if (this.listadoCategorias.indexOf(nueva) < 0) {
					this.listadoCategorias.push(nueva);
					this.nueva = '';
				}
			}
		},
		quitar: function quitar(CategoriaID) {
			var _this2 = this;

			if (this.readonly) {
				return;
			}
			var form = {
				NoticiaID: this.texto.NoticiaID,
				CategoriaID: CategoriaID
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('redaccion/php/api/del-categoria.php', form).then(function (res) {
				_this2.texto.Categorias = res.data;
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['texto', 'readonly'],
	methods: {
		seleccionada: function seleccionada(ev) {
			var _this = this;

			if (this.readonly) {
				return;
			}
			var form = {
				AgendaID: ev.datos.AgendaID,
				NoticiaID: this.texto.NoticiaID
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('redaccion/php/api/add-agenda.php', form).then(function (res) {
				_this.texto.Agenda = res.data;
			}).catch(this.$responseError);
		},
		quitar: function quitar(AgendaID) {
			var _this2 = this;

			if (this.readonly) {
				return;
			}
			var form = {
				NoticiaID: this.texto.NoticiaID,
				AgendaID: AgendaID
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('redaccion/php/api/del-agenda.php', form).then(function (res) {
				_this2.texto.Agenda = res.data;
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__organizar_emisoras_vue_componentes_reproductor_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['texto', 'readonly'],
	components: {
		Reproductor: __WEBPACK_IMPORTED_MODULE_0__organizar_emisoras_vue_componentes_reproductor_vue__["a" /* default */]
	},
	data: function data() {
		return {
			desplegado: false,
			ReproducirID: null,
			procesando: false
		};
	},

	methods: {
		addAudio: function addAudio(data) {
			var _this = this;

			if (this.readonly) {
				return;
			}
			this.procesando = true;
			var form = {
				NoticiaID: this.texto.NoticiaID,
				XFrameID: data.datos.ObjetoID
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('redaccion/php/api/importar-audio.php', form).then(function (res) {
				_this.texto.Audios.push(res.data.audio);
				_this.procesando = false;
			}).catch(function (e) {
				_this.$responseError(e);
				_this.procesando = false;
			});
		},
		delAudio: function delAudio(AudioID) {
			var _this2 = this;

			if (this.readonly) {
				return;
			}
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar audio',
				mensaje: '¿Quieres eliminar este audio?',
				callback: function callback(acepta) {
					if (acepta) {
						__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('redaccion/php/api/del-audio.php?AudioID=' + AudioID).then(function () {
							for (var i = 0; i < _this2.texto.Audios.length; i++) {
								if (_this2.texto.Audios[i].AudioID === AudioID) {
									_this2.texto.Audios.splice(i, 1);
								}
							}
							_this2.$store.commit('toast/success', {
								titulo: 'Eliminado',
								mensaje: 'Se ha eliminado el audio correctamente'
							});
						}).catch(_this2.$responseError);
					}
				}
			});
		}
	}
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buscadorImagenes__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__galerias_vue_componentes_visor_item_visor_item_vue__ = __webpack_require__(89);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['texto', 'palabrasClave', 'readonly'],
	components: {
		VisorItem: __WEBPACK_IMPORTED_MODULE_3__galerias_vue_componentes_visor_item_visor_item_vue__["a" /* default */],
		BuscadorImagenes: __WEBPACK_IMPORTED_MODULE_2__buscadorImagenes__["a" /* default */]
	},
	data: function data() {
		return {
			sugerencias: [],
			ultimaBusqueda: null,
			intervalo: null,
			verSugerencias: false,
			modificado: true,
			ultimo: null,
			verItem: null,
			buscador: null
		};
	},
	created: function created() {
		if (this.palabrasClave.length > 0) {
			// this.buscarSugerencias()
		}
	},

	watch: {
		'palabrasClave': function palabrasClave(newVal) {
			this.modificado = true;

			if (!this.ultimo || new Date().getTime() - this.ultimo > 5000) {
				this.ultimo = new Date().getTime();
				// this.buscarSugerencias()
			}
		}
	},
	computed: {
		listadoItemID: function listadoItemID() {
			if (!this.texto.Imagenes) {
				return [];
			}
			return this.texto.Imagenes.map(function (i) {
				return i.ItemID;
			});
		},
		palabras: function palabras() {
			var arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.palabrasClave);
			arr.sort(function (a, b) {
				if (a[1] > b[1]) {
					return -1;
				} else if (a[1] === b[1]) {
					return 0;
				} else {
					return 1;
				}
			});
			return arr;
		}
	},
	mounted: function mounted() {
		this.intervalo = window.setInterval(function () {
			// this.buscarSugerencias()
		}, 10000);
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.intervalo);
	},

	methods: {
		buscarSugerencias: function buscarSugerencias() {
			var _this = this;

			if (!this.modificado) {
				return;
			}
			if (!this.palabras || this.palabras.length < 5) {
				return;
			}
			var cadena = this.palabras.reduce(function (ant, val) {
				ant = ant + ' ' + val[0];
				return ant;
			}, '');
			this.ultimaBusqueda = new Date().getTime();
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('galerias/php/api/buscador.php', { cadena: cadena }).then(function (res) {
				_this.sugerencias = res.data.items;
				_this.modificado = false;
			}).catch(function (e) {
				console.error(e.response);
			});
		},
		adjuntar: function adjuntar(items) {
			var _this2 = this;

			var form = {
				NoticiaID: this.texto.NoticiaID,
				ItemID: items
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('redaccion/php/api/add-imagen.php', form).then(function (res) {
				_this2.texto.Imagenes = res.data;
			}).catch(this.$responseError);
		},
		addImagen: function addImagen(ItemID) {
			var _this3 = this;

			var form = {
				NoticiaID: this.texto.NoticiaID,
				ItemID: ItemID
			};

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('redaccion/php/api/add-imagen.php', form).then(function (res) {
				_this3.texto.Imagenes = res.data;
			}).catch(this.$responseError);
		},
		delImagen: function delImagen(ev, ItemID) {
			var _this4 = this;

			ev.preventDefault();
			ev.stopPropagation();
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar',
				mensaje: '\xBFQuieres eliminar esta imagen de esta noticia?',
				callback: function callback(acepta) {
					if (acepta) {
						var form = {
							NoticiaID: _this4.texto.NoticiaID,
							ItemID: ItemID
						};
						__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('redaccion/php/api/del-imagen.php', form).then(function () {
							for (var i = 0; i < _this4.texto.Imagenes.length; i++) {
								if (_this4.texto.Imagenes[i].ItemID === ItemID) {
									_this4.texto.Imagenes.splice(i, 1);
									return;
								}
							}
						}).catch(_this4.$responseError);
					}
				}
			});
		}
	}
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__galerias_vue_componentes_listado_galerias_mini_galeria_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		MiniGaleria: __WEBPACK_IMPORTED_MODULE_0__galerias_vue_componentes_listado_galerias_mini_galeria_vue__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				cadena: ''
			},
			buscado: false,
			resultados: {
				items: [],
				galerias: []
			},
			seleccion: []
		};
	},

	computed: {
		imagenes: function imagenes() {
			return this.resultados.items.map(function (i) {
				i.estilo = {
					'background-image': 'url("src/modulos/galerias/php/api/thumb.php?ItemID=' + i.ItemID + '")'
				};
				return i;
			});
		},
		galerias: function galerias() {
			return this.resultados.galerias.map(function (g) {
				g.estilo = {
					'background-image': 'url("src/modulos/galerias/php/api/thumb.php?ItemID=' + g.PortadaID + '")'
				};
				return g;
			});
		}
	},
	methods: {
		getGaleria: function getGaleria(GaleriaID) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('galerias/php/api/get-galeria.php', { GaleriaID: GaleriaID }).then(function (res) {
				_this.resultados.galerias = [];
				_this.resultados.items = res.data.galeria.items;
			}).catch(this.$responseError);
		},
		buscar: function buscar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('galerias/php/api/buscador.php', { cadena: this.filtro.cadena }).then(function (res) {
				_this2.resultados = res.data;
				_this2.buscado = true;
			}).catch(this.$responseError);
		},
		selecciona: function selecciona(ItemID) {
			if (this.seleccion.indexOf(ItemID) < 0) {
				this.seleccion.push(ItemID);
			} else {
				this.seleccion.splice(this.seleccion.indexOf(ItemID), 1);
			}
		},
		adjuntar: function adjuntar() {
			this.$emit('adjuntar', this.seleccion);
			this.cerrar();
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['palabrasClave'],
	computed: {
		palabras: function palabras() {
			var arr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.palabrasClave);
			arr.sort(function (a, b) {
				if (a[1] > b[1]) {
					return -1;
				} else if (a[1] === b[1]) {
					return 0;
				} else {
					return 1;
				}
			});
			return arr.slice(0, 10);
		}
	}
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['texto']
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resultados__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Resultados: __WEBPACK_IMPORTED_MODULE_2__resultados__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				Texto: '',
				Autor: '',
				FechaIni: new Date(new Date().getTime() - 604800000),
				FechaFin: new Date(),
				Categorias: [],
				verNevera: false
			}
		};
	},
	created: function created() {
		if (this.resultados.length === 0) {
			this.buscar();
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		resultados: 'redaccion/resultados'
	})),
	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
		buscarNoticias: 'redaccion/buscar'
	}), {
		toggleNevera: function toggleNevera() {
			this.filtro.verNevera = !this.filtro.verNevera;
			this.buscar();
		},
		seleccionaCategoria: function seleccionaCategoria(ev) {
			this.filtro.Categorias = [{
				Titulo: ev.datos.Titulo,
				CategoriaID: ev.datos.CategoriaID
			}];

			this.buscar();
		},
		quitarCategoria: function quitarCategoria(Categoria) {
			this.filtro.Categorias.splice(this.filtro.Categorias.indexOf(Categoria));
			this.buscar();
		},
		buscar: function buscar() {
			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.FechaIni = this.filtro.FechaIni ? Math.floor(this.filtro.FechaIni / 1000) : null;
			form.FechaFin = this.filtro.FechaFin ? Math.floor(this.filtro.FechaFin / 1000) : null;

			this.buscarNoticias(form);
		}
	})
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['resultados'],
	data: function data() {
		return {
			imprimir: null,
			NoticiaID: null
		};
	},

	methods: {
		editarNoticia: function editarNoticia(noticia) {
			this.$router.push('/main/redaccion/editor/' + noticia.NoticiaID);
		},
		setImprimir: function setImprimir(ev, noticia) {
			ev.preventDefault();
			ev.stopPropagation();
			this.NoticiaID = noticia.NoticiaID;
			this.imprimir = true;
		},
		goImprimir: function goImprimir(opciones) {
			var _this = this;

			var form = {
				OpcionesImpresion: opciones,
				Noticias: [this.NoticiaID]
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('redaccion/php/api/imprimir.php', form).then(function (res) {
				_this.$store.commit('toast/success', {
					titulo: 'Impresión iniciada'
				});
			}).catch(this.$responseError);
		}
	}
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editor__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listadoNoticias__ = __webpack_require__(1563);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Editor: __WEBPACK_IMPORTED_MODULE_1__editor__["a" /* default */],
		ListadoNoticias: __WEBPACK_IMPORTED_MODULE_2__listadoNoticias__["a" /* default */]
	},
	data: function data() {
		return {
			filtro: {
				cadena: '',
				caducada: false,
				FechaLimite: new Date()
			},
			editando: null,
			resultados: [],
			verNoticiasAgenda: null
		};
	},
	created: function created() {
		this.buscar();
	},

	methods: {
		verNoticias: function verNoticias(agenda) {
			this.verNoticiasAgenda = agenda;
		},
		setEstado: function setEstado(estado) {
			this.filtro.caducada = estado;
			this.buscar();
		},
		borrarMes: function borrarMes() {
			this.filtro.FechaLimite = null;
			this.buscar();
		},
		buscar: function buscar() {
			var _this = this;

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filtro));
			form.FechaLimite = this.filtro.FechaLimite ? Math.floor(this.filtro.FechaLimite.getTime() / 1000) : null;
			this.$http.post('redaccion/php/api/agenda/buscar.php', form).then(function (res) {
				_this.resultados = res.data;
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		eliminar: function eliminar(agenda) {
			var _this2 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar',
				mensaje: '\xBFQuieres eliminar este elemento de la agenda?\n\n\t\t\t\t<b>Atenci\xF3n</b> Todas las noticias que est\xE9n relacionadas dejar\xE1n de estarlo',
				callback: function callback(acepta) {
					if (acepta) {
						_this2.$http.post('redaccion/php/api/agenda/delAgenda.php', { AgendaID: agenda.AgendaID }).then(function () {
							_this2.buscar();
						}).catch(function (e) {
							_this2.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['AgendaID'],
	data: function data() {
		return {
			datos: {
				AgendaID: null,
				FechaLimite: new Date(),
				Titulo: null,
				Descripcion: null
			}
		};
	},
	created: function created() {
		if (this.AgendaID && this.AgendaID !== 'nuevo') {
			this.getElemento(this.AgendaID);
		}
	},

	methods: {
		getElemento: function getElemento(AgendaID) {
			var _this = this;

			this.$http.post('redaccion/php/api/agenda/getAgenda.php', { AgendaID: AgendaID }).then(function (res) {
				if (res.data.FechaLimite) {
					res.data.FechaLimite = new Date(res.data.FechaLimite * 1000);
					_this.datos = res.data;
				}
			}).catch(function (e) {
				_this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		guardar: function guardar() {
			var _this2 = this;

			if (!this.datos.Titulo) {
				this.error('Debes proporcionar un título');
				return;
			}

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.datos));
			form.FechaLimite = this.datos.FechaLimite ? Math.floor(this.datos.FechaLimite.getTime() / 1000) : null;
			this.$http.post('redaccion/php/api/agenda/setAgenda.php', form).then(function (res) {
				_this2.$emit('actualizar');
				_this2.cerrar();
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		},
		error: function error(mensaje) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: mensaje
			});
		}
	}
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['agenda'],
	created: function created() {
		this.getNoticias();
	},
	data: function data() {
		return {
			listado: []
		};
	},

	methods: {
		getNoticias: function getNoticias() {
			var _this = this;

			this.$http.post('redaccion/php/api/agenda/listadoNoticias.php', { AgendaID: this.agenda.AgendaID }).then(function (res) {
				_this.listado = res.data;
			}).catch(function (e) {
				_this.$error('Error', e.response.data.error);
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_nueva__ = __webpack_require__(675);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Nueva: __WEBPACK_IMPORTED_MODULE_0__components_nueva__["a" /* default */]
	},
	data: function data() {
		return {
			crear: null
		};
	},
	created: function created() {
		var _this = this;

		var menu = [{
			'icono': 'fa fa-list',
			'nombre': 'Tablero',
			activo: true,
			callback: function callback(a) {
				_this.$store.commit('top/setMenuActivo', a);
				_this.$router.push('/main/solicitudes');
			}
		}, {
			'icono': 'fa fa-search',
			'nombre': 'Buscador',
			activo: false,
			callback: function callback(a) {
				_this.$store.commit('top/setMenuActivo', a);
				_this.$router.push('/main/solicitudes/buscador');
			}
		}];

		this.$store.commit('top/setMenu', menu);
	}
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nueva_vue__ = __webpack_require__(676);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6daea1d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nueva_vue__ = __webpack_require__(1570);
function injectStyle (ssrContext) {
  __webpack_require__(1569)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6daea1d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nueva_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6daea1d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nueva_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['TareaID'],
	data: function data() {
		return {
			datos: {
				UsuarioID: null,
				Titulo: '',
				Descripcion: '',
				LatitudEvento: null,
				LongitudEvento: null,
				PlaceID: null,
				Fotografia: 'No',
				Video: 'No',
				FechaEvento: null,
				HoraEvento: null,
				FechaPublicacion: null,
				Destinos: []
			},
			destinos: [],
			map: null,
			marcador: null,
			campoGoogle: null,
			resultadosGoogle: []
		};
	},
	created: function created() {
		var _this = this;

		this.getDestinos();

		this.datos.UsuarioID = parseInt(this.usuario.ID);

		if (this.TareaID && this.TareaID !== 'nueva') {
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('produccion-audiovisual/php/api/getTarea.php?TareaID=' + this.TareaID).then(function (res) {
				res.data.HoraEvento = res.data.FechaEvento ? res.data.FechaEvento.split(' ')[1] : null;
				res.data.FechaEvento = res.data.FechaEvento ? res.data.FechaEvento.split(' ')[0] : null;
				_this.datos = res.data;
				_this.muestraMapa();
			}).catch(this.$responseError);
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
		usuario: 'session/usuario'
	})),
	methods: {
		getDestinos: function getDestinos() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('produccion-audiovisual/php/api/getDestinos.php').then(function (res) {
				_this2.destinos = res.data;
			}).catch(this.$responseError);
		},
		claseDestino: function claseDestino(d) {
			var c = [d.Icono];
			if (this.datos.Destinos.indexOf(d.DestinoID) >= 0) {
				c.push('active');
			}
			return c.join(' ');
		},
		toggleDestino: function toggleDestino(d) {
			var idx = this.datos.Destinos.indexOf(d);

			if (idx >= 0) {
				this.datos.Destinos.splice(idx, 1);
			} else {
				this.datos.Destinos.push(d);
			}
		},
		togglePrioridad: function togglePrioridad(prioridad) {
			this.datos.prioridad = prioridad;
		},
		seleccionaUbicacion: function seleccionaUbicacion(ev) {
			this.datos.LatitudEvento = ev.geometry.location.lat;
			this.datos.LongitudEvento = ev.geometry.location.lng;
			this.muestraMapa();
		},
		muestraMapa: function muestraMapa() {
			var _this3 = this;

			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('mapaEvento'), {
				center: { lat: this.datos.LatitudEvento, lng: this.datos.LongitudEvento },
				zoom: 15
			});

			this.map.addListener('click', function (e) {
				_this3.placeMarkerAndPanTo(e.latLng);
			});

			if (this.marcador) {
				this.marcador.setMap(null);
			}

			// Añadimos el marcador
			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: { lat: this.datos.LatitudEvento, lng: this.datos.LongitudEvento },
				title: this.datos.Titulo || 'Evento',
				map: this.map
			});
		},
		placeMarkerAndPanTo: function placeMarkerAndPanTo(latLng) {
			if (this.marcador) {
				this.marcador.setMap(null);
			}

			this.datos.LatitudEvento = latLng.lat();
			this.datos.LongitudEvento = latLng.lng();

			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: latLng,
				map: this.map
			});
			this.map.panTo(latLng);
		},
		guardar: function guardar() {
			var _this4 = this;

			if (!this.datos.UsuarioID) {
				this.$error('Error', 'Debes definir el usuario que realiza la petición');
				return;
			}
			if (!this.datos.Titulo) {
				this.$error('Error', 'Debes definir el título');
				return;
			}

			if (!this.datos.Descripcion) {
				this.$error('Error', 'Debes describir detalladamente lo que necesitas');
				return;
			}

			if (!this.datos.Fotografia && !this.datos.Video) {
				this.$error('Error', 'Debes seleccionar al menos fotografía o vídeo');
				return;
			}

			if (this.datos.Destinos.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un destino');
				return;
			}

			var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.datos));
			form.FechaEvento = this.datos.FechaEvento ? this.$moment(this.datos.FechaEvento).format('YYYY-MM-DD') : null;

			if (this.datos.FechaEvento && !this.datos.HoraEvento) {
				this.$error('Error', 'No has definido la hora del evento');
				return;
			}

			if (form.FechaEvento !== null) {
				form.FechaEvento = form.FechaEvento + ' ' + this.datos.HoraEvento + ':00';
			}

			form.FechaPublicacion = this.datos.FechaPublicacion ? this.$moment(this.datos.FechaPublicacion).format('YYYY-MM-DD') : null;

			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('produccion-audiovisual/php/api/setProduccion.php', form).then(function (res) {
				_this4.$store.commit('toast/success', {
					titulo: 'Tarea guardada'
				});
				_this4.$emit('actualizar');
				_this4.cerrar();
			}).catch(function (e) {
				_this4.$error('Error', e.response.data.error);
			});
		},
		cerrar: function cerrar() {
			this.$emit('actualizar');
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nueva__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__solicitudDetalle__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__solicitud__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* import { library } from '@fortawesome/fontawesome-svg-core'
import { faGhost, faBug, faSpinner } from '@fortawesome/free-solid-svg-icons'
library.add(faGhost, faBug, faSpinner) */

/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Solicitud: __WEBPACK_IMPORTED_MODULE_2__solicitud__["a" /* default */],
		SolicitudDetalle: __WEBPACK_IMPORTED_MODULE_1__solicitudDetalle__["a" /* default */],
		Editor: __WEBPACK_IMPORTED_MODULE_0__nueva__["a" /* default */]
	},
	data: function data() {
		return {
			solicitudes: [],
			intervalo: null,
			SolicitudID: null,
			EditarID: null
		};
	},
	created: function created() {
		var _this = this;

		this.buscar();
		this.intervalo = window.setInterval(function () {
			_this.buscar();
		}, 10000);

		if (this.$route.params.SolicitudID) {
			this.SolicitudID = this.$route.params.SolicitudID;
		}
	},

	watch: {
		'$route.params': function $routeParams(newVal) {
			if (newVal.SolicitudID) {
				this.SolicitudID = newVal.SolicitudID;
			} else {
				this.SolicitudID = null;
			}
		}
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.intervalo);
	},

	computed: {
		solicitudesPendientes: function solicitudesPendientes() {
			return this.solicitudes.filter(function (s) {
				return !s.FechaEnCurso;
			});
		},
		solicitudesRealizadas: function solicitudesRealizadas() {
			return this.solicitudes.filter(function (s) {
				return !s.FechaFinalizada;
			});
		},
		solicitudesFinalizadas: function solicitudesFinalizadas() {
			return this.solicitudes.filter(function (s) {
				return s.FechaFinalizada;
			});
		}
	},
	methods: {
		setNueva: function setNueva() {
			this.EditarID = 'nueva';
		},
		buscar: function buscar() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('solicitudes/php/api/getSolicitudes.php').then(function (res) {
				_this2.solicitudes = res.data;
			}).catch(function (e) {
				console.error(e);
			});
		},
		verSolicitud: function verSolicitud(solicitud) {
			this.$router.push('/main/solicitudes/solicitud/' + solicitud.SolicitudID);
			// this.TareaID = tarea.TareaID
		}
	}
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['solicitud']
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Main_vue__ = __webpack_require__(1580);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		'subir-cunas': __WEBPACK_IMPORTED_MODULE_0__components_Main_vue__["a" /* default */]
	}
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__produccion_vue_components_nueva_asocia_contrato__ = __webpack_require__(617);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'subir-cunas',
	components: {
		'asocia-contrato': __WEBPACK_IMPORTED_MODULE_1__produccion_vue_components_nueva_asocia_contrato__["a" /* default */]
	},
	data: function data() {
		return {
			produccion: null,
			ficheros: [],
			asociando: false
		};
	},
	created: function created() {
		this.nuevaProduccion();
	},

	computed: {
		esValido: function esValido() {
			return this.produccion.anunciante.ID_anunciante && this.produccion.contrato.ID_contrato && this.produccion.titulo;
		}
	},

	methods: {
		getTamano: function getTamano(size) {
			var bytes = size;
			var si = true;
			var thresh = si ? 1000 : 1024;
			if (Math.abs(bytes) < thresh) {
				return bytes + ' B';
			}
			var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
			var u = -1;
			do {
				bytes /= thresh;
				++u;
			} while (Math.abs(bytes) >= thresh && u < units.length - 1);

			return bytes.toFixed(1) + ' ' + units[u];
		},
		nuevaProduccion: function nuevaProduccion() {
			this.produccion = {
				ID_produccion: null,
				titulo: null,
				publica: 0,
				contrato: {
					ID_contrato: null,
					titulo: null,
					nombreCliente: null
				},
				anunciante: {
					ID_anunciante: null,
					nombre: null
				},
				descripcion: null,
				agente: {
					ID: null,
					nombre: null
				},
				ficheros: [],
				tareas: []
			};

			this.ficheros = [];
		},
		seleccionaAnunciante: function seleccionaAnunciante(e) {
			this.produccion.anunciante = {
				ID_anunciante: e.datos.ID_anunciante,
				nombre: e.datos.nombre
			};
		},
		quitaAnunciante: function quitaAnunciante() {
			this.produccion.anunciante.ID_anunciante = null;
			this.produccion.contrato.ID_contrato = null;
		},
		asociaContrato: function asociaContrato(e) {
			this.produccion.contrato = {
				ID_contrato: e.ID_contrato,
				titulo: e.titulo,
				nombreCliente: e.nombreCliente
			};

			this.asociando = false;
		},
		quitaFichero: function quitaFichero(i) {
			this.ficheros.splice(i, 1);
		},
		seleccionaFicheros: function seleccionaFicheros() {
			var _this = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Derechos de autor',
				mensaje: '<b>Importante</b>\n\t\t\t\tEs necesario que especifiques si el o los ficheros que vas a adjuntar contienen m\xFAsica protegida por derechos de autor.\n\t\t\t\t<b>\xBFTienen derechos de autor?</b>',
				buttons: [{
					titulo: 'Sí',
					clase: 'btn btn-sm btn-primary',
					icono: 'fa fa-check',
					valor: 1
				}, {
					titulo: 'No',
					clase: 'btn btn-sm btn-danger',
					icono: 'fa fa-ban',
					valor: 0
				}],
				callback: function callback(tieneDerechos) {
					_this.seleccionaFicherosFase2(tieneDerechos);
				}
			});
		},
		seleccionaFicherosFase2: function seleccionaFicherosFase2(derechos) {
			var _this2 = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.multiple = true;
			inp.style.display = 'none';
			inp.accept = '.mp3,audio/mpeg';

			inp.addEventListener('change', function (e) {
				for (var i = 0; i < inp.files.length; i++) {
					var encontrado = false;
					for (var f = 0; f < _this2.ficheros.length; f++) {
						if (inp.files[i].name === _this2.ficheros[f].fichero.name) {
							encontrado = true;
						}
					}

					if (!inp.files[i].name.match(/\.mp3$/i)) {
						encontrado = true;
						_this2.$store.commit('alertas/alert', {
							titulo: 'Error',
							mensaje: 'El fichero ' + inp.files[i].name + ' no es un fichero mp3'
						});
					}

					if (!encontrado) {
						_this2.ficheros.push({
							musica_autor: derechos,
							fichero: inp.files[i]
						});
					}
				}

				inp.parentElement.removeChild(inp);
			});
			document.body.appendChild(inp);
			inp.click();
		},
		subirFicheros: function subirFicheros() {
			var _this3 = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Subir ficheros',
				mensaje: '¿Deseas subir estos ficheros con los datos proporcionados?\nEsto implica que el anunciante y el contrato son correctos.',
				callback: function callback(acepta) {
					if (acepta) {
						var form = new FormData();
						form.append('datos', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.produccion));

						for (var i = 0; i < _this3.ficheros.length; i++) {
							form.append('musica_autor[]', _this3.ficheros[i].musica_autor);
							form.append('ficheros[]', _this3.ficheros[i].fichero);
						}

						_this3.$http.post('subir-cunas/php/api/subir.php', form).then(function (res) {
							_this3.$store.commit('alertas/alert', {
								titulo: 'Subido',
								mensaje: 'Archivos subidos correctamente'
							});

							_this3.nuevaProduccion();
						}).catch(function (e) {
							_this3.$store.commit('alertas/alert', {
								titulo: 'Error',
								mensaje: e.response.data.error
							});
						});
					}
				}
			});
		}
	}
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(1586);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			form: {
				ID_buzon: null,
				ficheros: []
			},
			pendientes: [],
			contador: 0,
			listadoBuzones: [],
			listadoCola: [],
			handler: null
		};
	},
	created: function created() {
		var _this = this;

		this.getBuzones();

		this.handler = window.setInterval(function () {
			_this.getPendientes();
		}, 1000);

		this.getPendientes();
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.handler);
	},


	methods: {
		getBuzones: function getBuzones() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getBuzones().then(function (res) {
				_this2.listadoBuzones = res.data.buzones;
			}).catch(function (e) {
				_this2.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		getPendientes: function getPendientes() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getPendientes().then(function (res) {
				_this3.listadoCola = res.data.ficheros;
			}).catch(function (e) {
				_this3.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},
		seleccionarFicheros: function seleccionarFicheros() {
			var _this4 = this;

			var inp = document.createElement('input');
			inp.type = 'file';
			inp.multiple = true;

			inp.addEventListener('change', function (ev) {
				var ficheros = ev.target.files;

				for (var i = 0; i < ficheros.length; i++) {
					_this4.pendientes.push({
						ID: ++_this4.contador,
						ID_buzon: _this4.form.ID_buzon,
						fichero: ficheros[i],
						porcentaje: 0
					});
				}

				_this4.procesar();
			});

			document.body.appendChild(inp);

			inp.click();
		},
		procesar: function procesar() {
			var _this5 = this;

			if (this.pendientes.length === 0) {
				return;
			}

			var item = this.pendientes[0];

			var ajax = new XMLHttpRequest();
			ajax.open('POST', '/src/modulos/subir-xframe/php/upload.php');
			ajax.onreadystatechange = function () {
				if (ajax.readyState === 4) {
					if (ajax.status !== 200) {
						_this5.$store.commit('alertas/error', {
							titulo: 'Error',
							mensaje: 'Error subiendo el fichero'
						});
					}
					_this5.pendientes.splice(0, 1);
					_this5.procesar();
				}
			};

			ajax.upload.onprogress = function (ev) {
				if (ev.lengthComputable) {
					var total = ev.total;
					var loaded = ev.loaded;

					var porcentaje = Math.floor(loaded * 100 / total);
					item.porcentaje = porcentaje;
				}
			};

			var form = new FormData();
			form.append('fichero', item.fichero);
			form.append('ID_buzon', item.ID_buzon);
			ajax.send(form);
		}
	}
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buzones_buzones__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mensajes_mensajes__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Buzones: __WEBPACK_IMPORTED_MODULE_1__components_buzones_buzones__["a" /* default */],
		Mensajes: __WEBPACK_IMPORTED_MODULE_2__components_mensajes_mensajes__["a" /* default */]
	},
	data: function data() {
		return {
			buzon: {
				Nombre: 'Entrada',
				Name: 'INBOX',
				Icono: 'fa fa-envelope'
			},
			email: 'dcanada@radiocastellon.com'
		};
	},
	created: function created() {
		this.$store.commit('webmail/SET_CUENTA', this.email);
		this.getBuzones();
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
		getBuzones: 'webmail/getListadoBuzones'
	}))
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buzon__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Buzon: __WEBPACK_IMPORTED_MODULE_1__buzon__["a" /* default */]
	},
	data: function data() {
		return {
			buzonSeleccionado: 'INBOX',
			redactar: false
		};
	},
	created: function created() {
		// this.cargaBuzonInicial()
	},

	watch: {
		listadoBuzones: function listadoBuzones() {
			this.cargaBuzonInicial();
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
		buzones: 'webmail/buzonesAnidados'
	})),
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])({
		setBuzonActivo: 'webmail/SELECCIONA_BUZON'
	}), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
		getMensajes: 'webmail/getMensajes'
	}), {
		cargaBuzonInicial: function cargaBuzonInicial() {
			var _this = this;

			if (this.$route.params.buzon) {
				var buzonActivo = this.listadoBuzones.filter(function (b) {
					return b.Path === _this.$route.params.buzon;
				});

				if (buzonActivo.length === 0) {
					// buscamos el INBOX
					var inbox = this.listadoBuzones.filter(function (b) {
						return b.Path === 'INBOX';
					})[0];
					this.seleccionaBuzon(inbox);
					return;
				}
				this.seleccionaBuzon(buzonActivo[0]);
			} else {
				// Vamos a por el INBOX
				var _inbox = this.listadoBuzones.filter(function (b) {
					return b.Path === 'INBOX';
				});
				if (_inbox.length > 0) {
					console.log('INBOX encontrado');
					this.seleccionaBuzon(_inbox[0]);
				}
			}
		},
		seleccionaBuzon: function seleccionaBuzon(buzon) {
			this.setBuzonActivo(buzon);
			this.getMensajes();
		}
	})
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Buzon',
	props: ['buzon'],
	data: function data() {
		return {
			desplegado: false,
			hover: false
		};
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		buzonActivo: 'webmail/buzonActivo'
	})),
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])({
		setBuzonActivo: 'webmail/SELECCIONA_BUZON'
	}), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
		getMensajes: 'webmail/getMensajes'
	}), {
		getClase: function getClase() {
			var clase = [];
			if (this.hover) {
				clase.push('resaltar');
			}

			if (this.buzonActivo && this.buzonActivo.Path === this.buzon.Path) {
				clase.push('active');
			}

			return clase.join(' ');
		},
		entraRaton: function entraRaton(ev) {
			ev.stopPropagation();
			ev.preventDefault();
			this.hover = true;
			// this.setBuzonOver(this.buzon.Path)
		},
		saleRaton: function saleRaton(ev) {
			ev.stopPropagation();
			ev.preventDefault();
			this.hover = false;
		},
		desplegar: function desplegar(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			this.desplegado = !this.desplegado;
		},
		acceder: function acceder(ev, buzon) {
			if (ev !== null) {
				ev.preventDefault();
				ev.stopPropagation();
			}
			this.$router.push('/main/webmail/' + buzon.Path);
			this.setBuzonActivo(buzon);
			this.getMensajes();
		}
	})
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__servicios__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visorMensaje__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vistaBuzones__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		VisorMensaje: __WEBPACK_IMPORTED_MODULE_2__visorMensaje__["a" /* default */],
		VistaBuzones: __WEBPACK_IMPORTED_MODULE_3__vistaBuzones__["a" /* default */]
	},
	data: function data() {
		return {
			seleccionados: [],
			resultados: [],
			ver: null,
			intervalo: 1,
			total: 0,
			busqueda: '',
			buscando: false,
			verContextual: null,
			seleccionarBuzon: false
		};
	},

	watch: {
		buzon: function buzon() {
			this.seleccionados = [];
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
		mensajes: 'webmail/mensajes',
		buzon: 'webmail/buzonActivo',
		pagina: 'webmail/pagina'
	}), {
		paginas: function paginas() {
			var total = Math.ceil(this.buzon.mensajes / 100);
			var arr = [];
			for (var i = 1; i <= total; i++) {
				arr.push(i);
			}
			return arr;
		},
		listado: function listado() {
			return this.mensajes.reduce(function (acc, m, i) {
				m.id = m.message_id + '-' + i + '-' + m.Size;
				acc.push(m);

				// Comprobamos si tiene adjunto
				m.hasAttachments = m.estructura.reduce(function (hay, part) {
					if (part.part_object) {
						hay = part.part_object.type > 2 ? true : hay;
					}
					return hay;
				}, false);
				return acc;
			}, []);
		},

		// Devuelve true cuando la selección es solo de mensaje favoritos
		soloFavoritos: function soloFavoritos() {
			var _this = this;

			return this.seleccionados.reduce(function (acc, uid) {
				var mensaje = _this.mensajes.filter(function (m) {
					return m.uid === uid;
				});
				if (mensaje.length === 1) {
					acc = mensaje[0].Flagged !== 'F' ? false : acc;
				}
				return acc;
			}, true);
		},

		// Devuelve true cuando la selección es solo de mensajes no favoritos
		soloNoFavoritos: function soloNoFavoritos() {
			var _this2 = this;

			return this.seleccionados.reduce(function (acc, uid) {
				var mensaje = _this2.mensajes.filter(function (m) {
					return m.uid === uid;
				});
				if (mensaje.length === 1) {
					acc = mensaje[0].Flagged !== ' ' ? false : acc;
				}
				return acc;
			}, true);
		},
		seleccionLeidos: function seleccionLeidos() {
			var _this3 = this;

			return this.seleccionados.reduce(function (acc, uid) {
				var mensaje = _this3.mensajes.filter(function (m) {
					return m.uid === uid;
				});
				if (mensaje.length > 0) {
					acc = mensaje[0].Unseen === 'U' ? false : acc;
				}
				return acc;
			}, true);
		},
		seleccionNoLeidos: function seleccionNoLeidos() {
			var _this4 = this;

			return this.seleccionados.reduce(function (acc, uid) {
				var mensaje = _this4.mensajes.filter(function (m) {
					return m.uid === uid;
				});
				if (mensaje.length > 0) {
					acc = mensaje[0].Unseen !== 'U' ? false : acc;
				}
				return acc;
			}, true);
		}
	}),
	created: function created() {
		var _this5 = this;

		// this.getMensajes()
		this.intervalo = window.setInterval(function () {
			_this5.getMensajes();
		}, 60000);
		window.addEventListener('keypress', this.onTeclaPulsadaEnFila);
	},
	beforeDestroy: function beforeDestroy() {
		window.clearInterval(this.intervalo);
		window.removeEventListener('keypress', this.onTeclaPulsadaEnFila);
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
		getMensajes: 'webmail/getMensajes',
		setFlag: 'webmail/setFlag',
		enviarPapelera: 'webmail/enviarPapelera',
		enviarBuzon: 'webmail/enviarBuzon',
		setLeido: 'webmail/setLeido'
	}), Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["d" /* mapMutations */])({
		setPagina: 'webmail/SET_PAGINA'
	}), {
		verPagina: function verPagina(pagina) {
			this.setPagina(pagina);
			this.getMensajes();
		},
		comprobarCadena: function comprobarCadena() {
			if (this.busqueda === '') {
				this.getMensajes();
			}
		},
		botonDerecho: function botonDerecho(ev, uid) {
			ev.preventDefault();
			ev.stopPropagation();
			if (!ev.ctrlKey && this.seleccionados.length <= 1) {
				this.seleccionados = [uid];
			}

			var altoPantalla = window.innerHeight;
			var anchoPantalla = window.innerWidth;
			var clickX = ev.clientX;
			var clickY = ev.clientY;

			var top = void 0,
			    bottom = void 0,
			    left = void 0,
			    right = void 0;
			if (altoPantalla / 2 > clickY) {
				top = clickY + 'px';
				bottom = 'auto';
			} else {
				top = 'auto';
				bottom = altoPantalla - clickY + 'px';
			}

			if (anchoPantalla / 2 > clickX) {
				left = clickX + 'px';
				right = 'auto';
			} else {
				left = 'auto';
				right = anchoPantalla - clickX + 'px';
			}
			this.verContextual = {
				top: top,
				bottom: bottom,
				left: left,
				right: right
			};
		},
		buscar: function buscar() {
			var _this6 = this;

			this.buscando = true;
			__WEBPACK_IMPORTED_MODULE_1__servicios__["a" /* default */].Buscar(this.email, this.buzon.Name, this.busqueda).then(function (listado) {
				_this6.resultados = listado;
				_this6.buscando = false;
			}).catch(function (e) {
				_this6.$error(e);
			});
		},
		verMensaje: function verMensaje(numero) {
			this.ver = numero;
		},
		cerrarMensaje: function cerrarMensaje() {
			var _this7 = this;

			this.ver = null;
			window.setTimeout(function () {
				_this7.$store.commit('webmail/SET_MENSAJE', null);
			}, 300);
		},
		claseMensaje: function claseMensaje(m) {
			var clase = [];
			if (this.seleccionados.indexOf(m.uid) >= 0) {
				clase.push('bg-warning');
			}

			if (m.Recent === 'R' || m.Unseen === 'U') {
				clase.push('mensajeNuevo');
			} else {
				clase.push('mensajeLeido');
			}

			return clase.join(' ');
		},
		toggleFlag: function toggleFlag(ev, mensaje, i) {
			ev.preventDefault();
			ev.stopPropagation();
			var flag = this.mensajes[i].Flagged === 'F' ? '' : 'F';
			this.setFlag({ numero: [mensaje.uid], flag: flag });
		},
		setFav: function setFav(flag) {
			this.setFlag({ numero: this.seleccionados, flag: flag });
		},
		marcaLeido: function marcaLeido(leido) {
			this.setLeido({ numero: this.seleccionados, leido: leido });
		},
		prePapelera: function prePapelera() {
			var _this8 = this;

			if (this.seleccionados.length === 0) {
				return;
			}
			this.verContextual = null;
			this.$store.commit('alertas/confirm', {
				titulo: 'Enviar a la papelera',
				mensaje: '\xBFQuieres mandar estos mensajes a la papelera?',
				callback: function callback(acepta) {
					if (acepta) {
						_this8.enviarBuzon({ uid: _this8.seleccionados, Destino: 'Trash' });
						_this8.seleccionados = [];
					}
				}
			});
		},
		enviarSpam: function enviarSpam() {
			this.enviarBuzon({ uid: this.seleccionados, Destino: 'Junk' });
		},
		onTeclaPulsadaEnFila: function onTeclaPulsadaEnFila(ev, mensaje) {
			if (ev.keyCode === 127) {
				// Suprimir... suprimimos
				this.prePapelera();
			}
		},
		onClickFila: function onClickFila(ev, mensajeId) {
			var _this9 = this;

			if (ev.shiftKey) {
				if (this.seleccionados.length === 0) {
					this.seleccionados = [mensajeId];
				} else if (this.seleccionados[0] > mensajeId) {
					this.seleccionados = this.mensajes.filter(function (m) {
						return m.uid >= mensajeId && m.uid <= _this9.seleccionados[0];
					}).map(function (m) {
						return m.uid;
					});
				} else {
					this.seleccionados = this.mensajes.filter(function (m) {
						return m.uid >= _this9.seleccionados[0] && m.uid <= mensajeId;
					}).map(function (m) {
						return m.uid;
					});
				}
			} else if (ev.ctrlKey) {
				var ind = this.seleccionados.indexOf(mensajeId);
				if (ind >= 0) {
					this.seleccionados.splice(ind, 1);
				} else {
					this.seleccionados.push(mensajeId);
				}
			} else {
				this.seleccionados = [mensajeId];
			}
		}
	})
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
	GetBuzones: function GetBuzones(email) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('webmail/php/api/get-buzones.php', { email: email }).then(function (res) {
				resolve(res.data);
			}).catch(function (e) {
				console.error(e);
				reject(e.response.data.error);
			});
		});
	},
	GetMensajes: function GetMensajes(email, buzon, pagina) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('webmail/php/api/get-mensajes.php', { buzon: buzon, email: email, pagina: pagina }).then(function (res) {
				resolve(res.data);
			}).catch(function (e) {
				console.error(e);
				reject(e.response.data.error);
			});
		});
	},
	GetMensaje: function GetMensaje(email, buzon, numero) {
		numero = parseInt(numero);
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('webmail/php/api/get-mensaje.php', { email: email, buzon: buzon, numero: numero }).then(function (res) {
				resolve(res.data);
			}).catch(function (e) {
				reject(e.response.data.error);
			});
		});
	},
	SetFlag: function SetFlag(email, buzon, numeroMensaje, flag) {
		numeroMensaje = numeroMensaje.map(function (m) {
			return parseInt(m);
		});
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('webmail/php/api/set-flag.php', { email: email, flag: flag, buzon: buzon, numero: numeroMensaje }).then(resolve).catch(function (e) {
				console.error(e);
				reject(e.response.data.error);
			});
		});
	},
	SetLeido: function SetLeido(email, buzon, numeroMensaje, leido) {
		numeroMensaje = numeroMensaje.map(function (m) {
			return parseInt(m);
		});
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('webmail/php/api/set-leido.php', { email: email, leido: leido, buzon: buzon, numero: numeroMensaje }).then(resolve).catch(function (e) {
				console.error(e);
				reject(e.response.data.error);
			});
		});
	},
	enviarPapelera: function enviarPapelera(email, buzon, uid) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('webmail/php/api/enviar-papelera.php', { email: email, buzon: buzon, uid: uid }).then(function (res) {
				resolve();
			}).catch(function (e) {
				reject(e.response.data.error);
			});
		});
	},
	enviarBuzon: function enviarBuzon(email, buzon, uid, Destino) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('webmail/php/api/enviar-buzon.php', { email: email, buzon: buzon, uid: uid, Destino: Destino }).then(function (res) {
				resolve();
			}).catch(function (e) {
				reject(e.response.data.error);
			});
		});
	},
	Buscar: function Buscar(email, buzon, cadena) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('webmail/php/api/buscador.php', { email: email, buzon: buzon, cadena: cadena }).then(function (res) {
				resolve(res.data);
			}).catch(function (e) {
				reject(e.response.data.error);
			});
		});
	}
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['numero'],
	data: function data() {
		return {
			cuerpo: null,
			cabecera: null,
			estructura: null,
			asunto: 'Vacaciones',
			remitenteNombre: 'Daniel Cañada',
			remitente: 'dcanada@radiocastellon.com',
			verTodosDestinatarios: false
		};
	},
	created: function created() {
		this.verMensaje(this.numero);
	},

	watch: {
		numero: {
			handler: 'verMensaje',
			inmediate: true
		}
	},
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		buzonActivo: 'webmail/buzonActivo',
		cuenta: 'webmail/cuenta',
		mensaje: 'webmail/mensaje',
		email: 'webmail/cuenta'
	}), {
		adjuntos: function adjuntos() {
			// Comprobamos si tiene adjunto
			return this.mensaje.estructura.reduce(function (hay, part) {
				if (part.part_object) {
					if (part.part_object.type > 2) {
						for (var i = 0; i < part.part_object.parameters.length; i++) {
							var param = part.part_object.parameters[i];
							if (param.attribute === 'name') {
								hay.push({
									size: part.part_object.bytes,
									nombre: param.value,
									tipo: part.part_object.subtype,
									part: part.part_number
								});
							}
						}
					}
				}
				return hay;
			}, []);
		}
	}),
	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
		verMensaje: 'webmail/verMensaje'
	}), {
		download: function download(part, nombre) {
			var _this = this;

			this.$http.post('webmail/php/api/get-adjunto.php', {
				email: this.email,
				buzon: this.buzonActivo.Path,
				numero: this.numero,
				part: part
			}, {
				responseType: 'blob',
				headers: {
					'Content-type': 'application/json',
					'Accept': 'application/x-binary'
				}
			}).then(function (res) {
				var url = URL.createObjectURL(res.data);
				var a = _this.$refs.descarga;
				a.name = nombre;
				a.href = url;
				a.download = nombre;
				a.click();
			}).catch(function (e) {
				console.error(e);
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	})
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['buzones'],
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
		buzonesAnidados: 'webmail/buzonesAnidados'
	}), {
		listadoBuzones: function listadoBuzones() {
			var buzones = [];
			console.log(this.buzonesAnidados);
			var desplegar = function desplegar(arr, nivel) {
				arr.forEach(function (b) {
					buzones.push({
						Path: b.Path,
						Nombre: b.Nombre,
						Nivel: nivel,
						Icono: b.Icono
					});

					if (b.Buzones.length > 0) {
						desplegar(b.Buzones, nivel + 1);
					}
				});
			};
			desplegar(this.buzonesAnidados, 1);
			return buzones;
		}
	}),
	methods: {
		seleccionar: function seleccionar(buzon) {
			var _this = this;

			this.$store.commit('alertas/confirm', {
				titulo: 'Mover',
				mensaje: '\xBFQuieres mover los mensajes al buz\xF3n "' + buzon.Nombre + '"?',
				callback: function callback(acepta) {
					if (acepta) {
						_this.$emit('seleccion', buzon);
						_this.cerrar();
					}
				}
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			destinatarios: [{
				email: '',
				tipo: 'Para'
			}],
			cuerpo: null,
			configuracionEditor: {
				menubar: false,
				theme: 'modern',
				plugins: ['advlist autolink lists link image charmap print preview anchor textcolor', 'searchreplace visualblocks code fullscreen', 'insertdatetime image media table contextmenu paste code help wordcount paste'],
				toolbar: 'insert paste | undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat',
				paste_as_text: true,
				table_default_attributes: {
					'border': '1'
				},
				table_default_styles: {
					'border-collapsed': 'collapse',
					'width': '100%'
				},
				table_responsive_width: true,
				content_style: '\n\t\t\t\t\ttable {width: 100%;border-spacing: 0;border-collapse: separate;border: 1px solid #aaa;}\n\t\t\t\t\ttable tr:nth-child(even) {background-color: #fafafa;}\n\t\t\t\t\ttable td, table th {border: 1px solid #aaa; border-collapse:collapse;padding: 5px;}\n\t\t\t\t',
				image_upload_tab: true,
				images_upload_url: '/src/modulos/webmail/php/api/upload-imagen.php',
				height: 300
			}
		};
	},

	methods: {
		nuevoDestinatario: function nuevoDestinatario() {
			this.destinatarios.push({
				email: '',
				tipo: 'Para'
			});
		},
		cerrar: function cerrar() {
			this.$emit('cerrar');
		}
	}
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_filters__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_currency_filter__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_currency_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_currency_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_touch__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_main_vue__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_vue_components_input_query_input_query__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_vue_components_input_query_location_input_query__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_vue_components_seleccion_usuario_seleccion_usuario_js__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_vue_store_stores__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_the_mask__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_cropper_vue_cropper__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuejs_datepicker__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__xkeshi_vue_qrcode__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__xkeshi_vue_qrcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__xkeshi_vue_qrcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_mce__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_mce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_mce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_v_calendar__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_v_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_v_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modal_modal__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_menu_superior_menu_superior__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__config_charts__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuejs_datepicker_dist_locale__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_signature__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_signature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_signature__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_router__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_uuid__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_main_404_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_avatar__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_imprimir_imprimir_vue__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__libs_filtroTamano__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__libs_round__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__libs_filtroHora__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__libs_download__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__libs_swFichar__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_chart_js__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_hchs_vue_charts__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_hchs_vue_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_hchs_vue_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_lodash__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__node_modules_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__node_modules_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__node_modules_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__node_modules_font_awesome_css_font_awesome_min_css__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__node_modules_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__node_modules_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__modulos_js__ = __webpack_require__(894);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import { rutas } from './router'


















// import VueCharts from 'vue-chartjs'



















// Bootstrap

// import './assets/bootstrap.min.css'


// IMPORTAMOS LOS FICHEROS DE RUTAS DE TODOS LOS MÓDULOS
__WEBPACK_IMPORTED_MODULE_24_vue_routes_generator___default.a.route('/main', {
	component: __WEBPACK_IMPORTED_MODULE_7__components_main_main_vue__["a" /* default */]
});
// eslint-disable-next-line


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_24_vue_routes_generator___default.a.route('/main').child('*', {
	name: 'Error sección 404',
	component: __WEBPACK_IMPORTED_MODULE_27__components_main_404_vue__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_24_vue_routes_generator___default.a.route('/', {
	redirect: '/main'
});
__WEBPACK_IMPORTED_MODULE_24_vue_routes_generator___default.a.route('*', {
	name: 'Error 404',
	component: __WEBPACK_IMPORTED_MODULE_27__components_main_404_vue__["a" /* default */]
});
var r = __WEBPACK_IMPORTED_MODULE_24_vue_routes_generator___default.a.export();
var miRouter = new __WEBPACK_IMPORTED_MODULE_25_vue_router__["a" /* default */]({
	routes: r
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue_signature___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_touch___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_filters___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_currency_filter___default.a, {
	symbol: '€',
	thousandsSeparator: '.',
	fractionCount: 2,
	fractionSeparator: ',',
	symbolPosition: 'back',
	symbolSpacing: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__core_vue_components_input_query_input_query__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__core_vue_components_input_query_location_input_query__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__core_vue_components_seleccion_usuario_seleccion_usuario_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__components_cropper_vue_cropper__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_mce___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30__libs_filtroTamano__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32__libs_filtroHora__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_31__libs_round__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_33__libs_download__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_34__libs_swFichar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('modal', __WEBPACK_IMPORTED_MODULE_19__components_modal_modal__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('menu-superior', __WEBPACK_IMPORTED_MODULE_20__components_menu_superior_menu_superior__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21__config_charts__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(window.VueCharts);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_v_calendar___default.a, {
	componentPrefix: 'vc',
	locale: 'es'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('qrcode', __WEBPACK_IMPORTED_MODULE_16__xkeshi_vue_qrcode___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('datepicker', __WEBPACK_IMPORTED_MODULE_14_vuejs_datepicker__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('downloadExcel', __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('avatar', __WEBPACK_IMPORTED_MODULE_28__components_common_avatar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('imprimir', __WEBPACK_IMPORTED_MODULE_29__components_imprimir_imprimir_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$error = function (titulo, mensaje) {
	if (!mensaje) {
		titulo = 'Error';
		mensaje = titulo;
	}
	__WEBPACK_IMPORTED_MODULE_11__core_vue_store_stores__["a" /* default */].commit('alertas/error', {
		titulo: titulo,
		mensaje: mensaje
	});
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$alert = function (titulo, mensaje) {
	if (!mensaje) {
		titulo = 'Alerta';
		mensaje = titulo;
	}
	__WEBPACK_IMPORTED_MODULE_11__core_vue_store_stores__["a" /* default */].commit('alertas/alert', {
		titulo: titulo,
		mensaje: mensaje
	});
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$confirm = function (titulo, mensaje, callback) {
	__WEBPACK_IMPORTED_MODULE_11__core_vue_store_stores__["a" /* default */].commit('alertas/confirm', {
		titulo: titulo,
		mensaje: mensaje,
		callback: callback
	});
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$dateLang = __WEBPACK_IMPORTED_MODULE_22_vuejs_datepicker_dist_locale__["es"];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$responseError = function (e) {
	var error = e && e.response && e.response.data && e.response.data.error ? e.response.data.error : 'Error desconocido';
	__WEBPACK_IMPORTED_MODULE_11__core_vue_store_stores__["a" /* default */].commit('alertas/error', {
		titulo: 'Error',
		mensaje: error
	});
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$uuid = {
	generate: __WEBPACK_IMPORTED_MODULE_26_uuid__["a" /* v4 */],
	validate: __WEBPACK_IMPORTED_MODULE_26_uuid__["b" /* validate */]

	/* eslint-disable no-new */
};new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#sip-app',
	router: miRouter,
	store: __WEBPACK_IMPORTED_MODULE_11__core_vue_store_stores__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 691 */,
/* 692 */,
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04fc69e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(747);
function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04fc69e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alertas_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a7f18d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_alertas_vue__ = __webpack_require__(715);
function injectStyle (ssrContext) {
  __webpack_require__(714)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a7f18d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alertas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a7f18d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_alertas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.actual !== null)?_c('div',{attrs:{"id":"contieneAlerta"}},[_c('div',[_c('div',[_c('div',{staticClass:"card",staticStyle:{"min-width":"300px"}},[_c('div',{staticClass:"card-header",class:_vm.actual.claseCabecera},[_vm._v(_vm._s(_vm.actual.titulo))]),(_vm.actual.tipo === 'error')?_c('div',{staticClass:"card-body bg-light text-center"},[_c('span',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"font-size":"3em","color":"#BBBBBB"}})]):_vm._e(),(_vm.actual.mensaje)?_c('div',{staticClass:"card-body text-left",domProps:{"innerHTML":_vm._s('<p>' +  _vm.actual.mensaje.replace(/\n/g, '</p><p>') + '</p>')}}):_vm._e(),_c('div',{staticClass:"card-footer"},_vm._l((_vm.actual.buttons),function(b,index){return _c('button',{key:b.titulo,ref:'boton-' + index,refInFor:true,staticClass:"m-1",class:b.clase,on:{"click":function($event){return _vm.cerrar(b.valor)}}},[(b.icono)?_c('span',{class:b.icono,staticStyle:{"margin-right":"3px"}}):_vm._e(),_vm._v(_vm._s(b.titulo))])}),0)])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',{staticStyle:{"max-width":"400px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-warning text-center"},[_vm._v("\n\t\t\t\t\tCambio de contraseña\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"card-body text-left"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Contraseña antigua")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.passwordAnterior),expression:"form.passwordAnterior"}],staticClass:"form-control form-control-sm",attrs:{"type":"password"},domProps:{"value":(_vm.form.passwordAnterior)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "passwordAnterior", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Nueva contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.passwordNueva1),expression:"form.passwordNueva1"}],staticClass:"form-control form-control-sm",attrs:{"type":"password"},domProps:{"value":(_vm.form.passwordNueva1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "passwordNueva1", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Repítela")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.passwordNueva2),expression:"form.passwordNueva2"}],staticClass:"form-control form-control-sm",attrs:{"type":"password"},domProps:{"value":(_vm.form.passwordNueva2)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.cambiar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "passwordNueva2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.cambiar()}}},[_c('span',{staticClass:"fa fa-lock mr-1"}),_vm._v("\n\t\t\t\t\t\tCambiar\n\t\t\t\t\t")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_c('span',{staticClass:"fa fa-info-circle mr-1"}),_vm._v("\n\t\t\t\t\t\tEs necesario que actualices tu contraseña\n\t\t\t\t\t")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bloqueo_vue__ = __webpack_require__(117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16935d90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bloqueo_vue__ = __webpack_require__(737);
function injectStyle (ssrContext) {
  __webpack_require__(736)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16935d90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bloqueo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16935d90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bloqueo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-login"},[_c('div',{staticClass:"fondo"}),_vm._v(" "),_c('div',{staticClass:"contenedor"},[_c('div',[_c('div',{staticClass:"card",staticStyle:{"background-color":"rgba(255,255,255,0)","border":"none"}},[_c('div',{staticClass:"card-body text-center"},[_c('img',{staticClass:"rounded-circle mb-3",staticStyle:{"width":"150px","height":"150px"},attrs:{"src":_vm.usuario.avatar}}),_vm._v(" "),_c('h5',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.usuario.nombre)+" "+_vm._s(_vm.usuario.apellidos))])]),_vm._v(" "),_c('div',{staticClass:"card-body text-center"},[_c('div',{staticClass:"input-group input-group-lg"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"entraPass",staticClass:"form-control",attrs:{"autocomplete":_vm.strNow,"type":"password","placeholder":"Contraseña"},domProps:{"value":(_vm.password)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.desbloquear()},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.desbloquear()}}},[_c('span',{staticClass:"fa fa-unlock"})])])]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.logout()}}},[_c('span',{staticClass:"fa mr-2 fa-sign-out"}),_vm._v("\n\t\t\t\t\t\t\tCerrar sesión\n\t\t\t\t\t\t")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wrapper_vue__ = __webpack_require__(118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92b5dcf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_wrapper_vue__ = __webpack_require__(743);
function injectStyle (ssrContext) {
  __webpack_require__(739)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-92b5dcf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92b5dcf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_wrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toast_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_220cacc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_toast_vue__ = __webpack_require__(742);
function injectStyle (ssrContext) {
  __webpack_require__(741)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-220cacc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toast_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_220cacc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_toast_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast p-3",class:(_vm.active) ? 'active' : '',style:(_vm.top),on:{"click":_vm.close}},[(!_vm.t.icon)?_c('div',[_c('h5',[_c('b',[_vm._v(_vm._s(_vm.t.titulo))])]),_c('span',[_vm._v(_vm._s(_vm.t.mensaje))])]):_vm._e(),(_vm.t.icon)?_c('div',{staticStyle:{"display":"table-row"}},[_c('div',{staticStyle:{"display":"table-cell","width":"40px","vertical-align":"middle","font-size":"2em"}},[_c('span',{class:_vm.t.icon})]),_c('div',{staticStyle:{"display":"table-cell","vertical-align":"middle"}},[_c('h5',[_c('b',[_vm._v(_vm._s(_vm.t.titulo))])]),_c('span',[_vm._v(_vm._s(_vm.t.mensaje))])])]):_vm._e(),(_vm.t.type === 'progress')?_c('div',{staticClass:"progreso",style:(_vm.estiloProgreso)}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.toasts),function(t){return _c('toast',{key:t.id,ref:'toast-' + t.id,refInFor:true,staticClass:"cajaToast",class:t.style,attrs:{"t":t,"top":_vm.tops[t.id]}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextual_vue__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e040a24c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contextual_vue__ = __webpack_require__(746);
function injectStyle (ssrContext) {
  __webpack_require__(745)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e040a24c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contextual_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e040a24c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contextual_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activo)?_c('div',{staticClass:"fondoTransparente",on:{"click":_vm.cerrar}},[_c('div',{staticClass:"contextual",style:(_vm.menu.style)},[(_vm.menu.titulo)?_c('div',{staticClass:"titulo bg-info text-white"},[_vm._v(_vm._s(_vm.menu.titulo))]):_vm._e(),_c('div',{staticClass:"contieneItems"},_vm._l((_vm.menu.items),function(item){return _c('div',{key:item.texto,staticClass:"p-2",class:(!item.activo) ? 'disabled' : 'active',staticStyle:{"cursor":"default"},on:{"click":function($event){return _vm.clickItem(item)}}},[(item.icono)?_c('span',{staticClass:"mr-2",class:item.icono}):_vm._e(),_vm._v(_vm._s(item.texto))])}),0)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('toasts',{staticStyle:{"z-index":"2001"}}),_c('alertas',{staticStyle:{"z-index":"2002"}}),_c('transition',{attrs:{"name":"esperar"}},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.sesionBloqueada),expression:"!sesionBloqueada"}],staticStyle:{"z-index":"1"}})],1),_c('contextual',{staticStyle:{"z-index":"2003"}}),(_vm.cambiarPass)?_c('cambio-pass'):_vm._e(),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.sesionBloqueada)?_c('bloqueo',{staticStyle:{"z-index":"2000"},attrs:{"usuario":_vm.sesionBloqueada}}):_vm._e()],1),(_vm.verTutorialNotificaciones)?_c('modal',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Atención")]),_c('h5',{staticClass:"card-body bg-light"},[_vm._v("Debes aceptar las notificaciones de este sitio web")]),_c('div',[_c('img',{attrs:{"src":"/src/modulos/core/static/notificaciones.gif","title":"Notificaciones"}})])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 122,
	"./af.js": 122,
	"./ar": 123,
	"./ar-dz": 124,
	"./ar-dz.js": 124,
	"./ar-kw": 125,
	"./ar-kw.js": 125,
	"./ar-ly": 126,
	"./ar-ly.js": 126,
	"./ar-ma": 127,
	"./ar-ma.js": 127,
	"./ar-sa": 128,
	"./ar-sa.js": 128,
	"./ar-tn": 129,
	"./ar-tn.js": 129,
	"./ar.js": 123,
	"./az": 130,
	"./az.js": 130,
	"./be": 131,
	"./be.js": 131,
	"./bg": 132,
	"./bg.js": 132,
	"./bm": 133,
	"./bm.js": 133,
	"./bn": 134,
	"./bn.js": 134,
	"./bo": 135,
	"./bo.js": 135,
	"./br": 136,
	"./br.js": 136,
	"./bs": 137,
	"./bs.js": 137,
	"./ca": 138,
	"./ca.js": 138,
	"./cs": 139,
	"./cs.js": 139,
	"./cv": 140,
	"./cv.js": 140,
	"./cy": 141,
	"./cy.js": 141,
	"./da": 142,
	"./da.js": 142,
	"./de": 143,
	"./de-at": 144,
	"./de-at.js": 144,
	"./de-ch": 145,
	"./de-ch.js": 145,
	"./de.js": 143,
	"./dv": 146,
	"./dv.js": 146,
	"./el": 147,
	"./el.js": 147,
	"./en-SG": 148,
	"./en-SG.js": 148,
	"./en-au": 149,
	"./en-au.js": 149,
	"./en-ca": 150,
	"./en-ca.js": 150,
	"./en-gb": 151,
	"./en-gb.js": 151,
	"./en-ie": 152,
	"./en-ie.js": 152,
	"./en-il": 153,
	"./en-il.js": 153,
	"./en-nz": 154,
	"./en-nz.js": 154,
	"./eo": 155,
	"./eo.js": 155,
	"./es": 156,
	"./es-do": 157,
	"./es-do.js": 157,
	"./es-us": 158,
	"./es-us.js": 158,
	"./es.js": 156,
	"./et": 159,
	"./et.js": 159,
	"./eu": 160,
	"./eu.js": 160,
	"./fa": 161,
	"./fa.js": 161,
	"./fi": 162,
	"./fi.js": 162,
	"./fo": 163,
	"./fo.js": 163,
	"./fr": 164,
	"./fr-ca": 165,
	"./fr-ca.js": 165,
	"./fr-ch": 166,
	"./fr-ch.js": 166,
	"./fr.js": 164,
	"./fy": 167,
	"./fy.js": 167,
	"./ga": 168,
	"./ga.js": 168,
	"./gd": 169,
	"./gd.js": 169,
	"./gl": 170,
	"./gl.js": 170,
	"./gom-latn": 171,
	"./gom-latn.js": 171,
	"./gu": 172,
	"./gu.js": 172,
	"./he": 173,
	"./he.js": 173,
	"./hi": 174,
	"./hi.js": 174,
	"./hr": 175,
	"./hr.js": 175,
	"./hu": 176,
	"./hu.js": 176,
	"./hy-am": 177,
	"./hy-am.js": 177,
	"./id": 178,
	"./id.js": 178,
	"./is": 179,
	"./is.js": 179,
	"./it": 180,
	"./it-ch": 181,
	"./it-ch.js": 181,
	"./it.js": 180,
	"./ja": 182,
	"./ja.js": 182,
	"./jv": 183,
	"./jv.js": 183,
	"./ka": 184,
	"./ka.js": 184,
	"./kk": 185,
	"./kk.js": 185,
	"./km": 186,
	"./km.js": 186,
	"./kn": 187,
	"./kn.js": 187,
	"./ko": 188,
	"./ko.js": 188,
	"./ku": 189,
	"./ku.js": 189,
	"./ky": 190,
	"./ky.js": 190,
	"./lb": 191,
	"./lb.js": 191,
	"./lo": 192,
	"./lo.js": 192,
	"./lt": 193,
	"./lt.js": 193,
	"./lv": 194,
	"./lv.js": 194,
	"./me": 195,
	"./me.js": 195,
	"./mi": 196,
	"./mi.js": 196,
	"./mk": 197,
	"./mk.js": 197,
	"./ml": 198,
	"./ml.js": 198,
	"./mn": 199,
	"./mn.js": 199,
	"./mr": 200,
	"./mr.js": 200,
	"./ms": 201,
	"./ms-my": 202,
	"./ms-my.js": 202,
	"./ms.js": 201,
	"./mt": 203,
	"./mt.js": 203,
	"./my": 204,
	"./my.js": 204,
	"./nb": 205,
	"./nb.js": 205,
	"./ne": 206,
	"./ne.js": 206,
	"./nl": 207,
	"./nl-be": 208,
	"./nl-be.js": 208,
	"./nl.js": 207,
	"./nn": 209,
	"./nn.js": 209,
	"./pa-in": 210,
	"./pa-in.js": 210,
	"./pl": 211,
	"./pl.js": 211,
	"./pt": 212,
	"./pt-br": 213,
	"./pt-br.js": 213,
	"./pt.js": 212,
	"./ro": 214,
	"./ro.js": 214,
	"./ru": 215,
	"./ru.js": 215,
	"./sd": 216,
	"./sd.js": 216,
	"./se": 217,
	"./se.js": 217,
	"./si": 218,
	"./si.js": 218,
	"./sk": 219,
	"./sk.js": 219,
	"./sl": 220,
	"./sl.js": 220,
	"./sq": 221,
	"./sq.js": 221,
	"./sr": 222,
	"./sr-cyrl": 223,
	"./sr-cyrl.js": 223,
	"./sr.js": 222,
	"./ss": 224,
	"./ss.js": 224,
	"./sv": 225,
	"./sv.js": 225,
	"./sw": 226,
	"./sw.js": 226,
	"./ta": 227,
	"./ta.js": 227,
	"./te": 228,
	"./te.js": 228,
	"./tet": 229,
	"./tet.js": 229,
	"./tg": 230,
	"./tg.js": 230,
	"./th": 231,
	"./th.js": 231,
	"./tl-ph": 232,
	"./tl-ph.js": 232,
	"./tlh": 233,
	"./tlh.js": 233,
	"./tr": 234,
	"./tr.js": 234,
	"./tzl": 235,
	"./tzl.js": 235,
	"./tzm": 236,
	"./tzm-latn": 237,
	"./tzm-latn.js": 237,
	"./tzm.js": 236,
	"./ug-cn": 238,
	"./ug-cn.js": 238,
	"./uk": 239,
	"./uk.js": 239,
	"./ur": 240,
	"./ur.js": 240,
	"./uz": 241,
	"./uz-latn": 242,
	"./uz-latn.js": 242,
	"./uz.js": 241,
	"./vi": 243,
	"./vi.js": 243,
	"./x-pseudo": 244,
	"./x-pseudo.js": 244,
	"./yo": 245,
	"./yo.js": 245,
	"./zh-cn": 246,
	"./zh-cn.js": 246,
	"./zh-hk": 247,
	"./zh-hk.js": 247,
	"./zh-tw": 248,
	"./zh-tw.js": 248
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752;

/***/ }),
/* 753 */,
/* 754 */,
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3bdbf96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(779);
function injectStyle (ssrContext) {
  __webpack_require__(756)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c3bdbf96"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3bdbf96_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fondoUpdate",class:_vm.mostrar ? 'show' : ''}),_c('div',{staticClass:"cajaUpdate",class:_vm.mostrar ? 'show' : (_vm.ocultar) ? 'hide' : ''},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body bg-light",staticStyle:{"border-top":"1px solid #e0e0e0"}},[_c('div',{staticClass:"filaVersion",staticStyle:{"color":"#999999"}},[_vm._m(1),_c('div',{staticClass:"version"},[_c('h5',[_c('b',[_vm._v(_vm._s(_vm.actual))])])])]),_c('div',{staticClass:"filaVersion"},[_vm._m(2),_c('div',{staticClass:"version"},[_c('h5',[_c('b',[_vm._v(_vm._s(_vm.version))])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"m-2 btn btn-primary",on:{"click":function($event){return _vm.actualizar()}}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Actualizar")]),_c('button',{staticClass:"m-2 btn btn-danger",attrs:{"disabled":_vm.pospuesto},on:{"click":function($event){return _vm.posponer()}}},[_c('span',{staticClass:"fa fa-clock-o mr-2"}),_vm._v("Posponer")]),(!_vm.pospuesto)?_c('p',[_vm._m(3)]):_c('p',[_c('i',[_vm._v("Ya has pospuesto antes la actualización")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body text-center"},[_c('img',{staticStyle:{"height":"35px","margin-bottom":"15px"},attrs:{"src":"/static/recursos/logo_sip.svg","alt":""}}),_c('h5',[_c('b',[_vm._v("Actualización disponible")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nombre"},[_c('h5',[_c('b',[_vm._v("Versión actual")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nombre"},[_c('h5',[_c('b',[_vm._v("Nueva versión")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',[_c('span',[_vm._v("Solo podrás posponer "),_c('b',[_vm._v("una vez")]),_vm._v(" la actualización.")]),_c('br'),_c('span',[_vm._v("Tendrás "),_c('b',[_vm._v("5 minutos")]),_vm._v(" hasta el siguiente aviso.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e28f56_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__(763);
function injectStyle (ssrContext) {
  __webpack_require__(760)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45e28f56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e28f56_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mostrar)?_c('div',{staticClass:"cat-menu",class:(_vm.activo) ? 'active' : ''},[_c('div',{staticClass:"item-menu",class:(_vm.item.tipo === 'categoria') ? 'categoria' : '',on:{"click":function($event){return _vm.clica(_vm.item)}}},[_c('div',[_c('span',{class:_vm.item.icono})]),_c('div',[_c('span',{class:(_vm.item.items && _vm.item.items.length > 0) ? 'font-weight-bold' : ''},[_vm._v(_vm._s(_vm.item.nombre))]),(_vm.item.items && _vm.item.items.length > 0)?_c('span',{staticClass:"fa pull-right mr-2 mt-1",class:(_vm.activo) ? 'fa-caret-down' : 'fa-caret-left'}):_vm._e()]),_c('div',[_c('span',{class:_vm.item.icono})])]),_vm._l((_vm.item.items),function(it){return _c('menu-item',{key:it.nombre,attrs:{"item":it}})})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.usuario.ID)?_c('div',[_c('div',{staticClass:"menuppal p-2 m-0 text-center"},[_c('img',{staticClass:"rounded-circle mb-2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":_vm.usuario.avatar,"alt":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.usuario.nombre))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group mt-2"},[(_vm.permisos.gestion_jornada_acceder)?_c('button',{staticClass:"btn btn-light",attrs:{"title":"Fichar"},on:{"click":function($event){return _vm.fichar()}}},[_c('span',{staticClass:"fa fa-w fa-address-card"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-light",attrs:{"title":"Mi perfil de usuario"},on:{"click":function($event){return _vm.verPerfil()}}},[_c('span',{staticClass:"fa fa-w fa-user"})]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-light",attrs:{"to":"/main/panel-control","title":"Ajustes"}},[_c('span',{staticClass:"fa fa-w fa-gear"})]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-light",attrs:{"to":"/main","title":"Muro"}},[_c('span',{staticClass:"fa fa-w fa-home"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",attrs:{"title":"Bloquear sesión"},on:{"click":function($event){return _vm.lock()}}},[_c('span',{staticClass:"fa fa-w fa-lock"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"title":"Cerrar sesión"},on:{"click":function($event){return _vm.logout()}}},[_c('span',{staticClass:"fa fa-w fa-sign-out"})])],1),_vm._v(" "),(_vm.externo)?_c('div',{staticClass:"mt-2 p-3 bg-danger text-white",staticStyle:{"margin-left":"-6px","margin-right":"-6px","margin-bottom":"-6px"}},[_c('span',{staticClass:"fa fa-exclamation-circle mr-2"}),_c('b',[_vm._v("Acceso externo")]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t"+_vm._s(_vm.ip)+"\n\t\t")]):_vm._e(),_vm._v(" "),(!_vm.externo)?_c('div',{staticClass:"mt-2 p-3 bg-success text-white",staticStyle:{"margin-left":"-6px","margin-right":"-6px","margin-bottom":"-6px"}},[_c('span',{staticClass:"fa fa-lock mr-2"}),_c('b',[_vm._v("Acceso seguro")]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t"+_vm._s(_vm.ip)+"\n\t\t")]):_vm._e()]),_vm._v(" "),_vm._l((_vm.menuItems),function(item){return _c('menu-item',{key:item.nombre,attrs:{"item":item}})})],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mi_perfil_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a016a564_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mi_perfil_vue__ = __webpack_require__(767);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mi_perfil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a016a564_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mi_perfil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crop_avatar_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef945d4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_crop_avatar_vue__ = __webpack_require__(766);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crop_avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef945d4a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_crop_avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("\n\t\t\t\t\tSelecciona imagen\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"position":"relative","display":"block"}},[_c('vue-cropper',{on:{"img":function($event){return _vm.setImg($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"card-footer"},[(_vm.url)?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.confirmar()}}},[_vm._v("Aceptar")]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_vm._v("\n\t\t\t\t\t\t\tMi perfil de usuario\n\t\t\t\t\t\t")]),_vm._v(" "),(_vm.usu.fecha_expiracion_cuenta)?_c('div',{staticClass:"col text-right text-danger"},[_c('strong',[_c('span',{staticClass:"fa fa-calendar mr-1"}),_vm._v("\n\t\t\t\t\t\t\t\tCaduca: "+_vm._s(_vm._f("moment")(_vm.usu.fecha_expiracion_cuenta,'DD-MM-YYYY'))+"\n\t\t\t\t\t\t\t")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pr-3"},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 text-center",on:{"mouseover":function($event){_vm.muestraBtnAvatar = true},"mouseout":function($event){_vm.muestraBtnAvatar = false}}},[_c('img',{staticClass:"rounded-circle mt-3",staticStyle:{"width":"200px","height":"200px","border":"1px solid #e0e0e0","box-shadow":"0 0 20px rgba(0,0,0,0.2)"},attrs:{"src":_vm.avatar}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","display":"block","left":"0","right":"0","bottom":"0"}},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.nuevoAvatar = true}}},[_c('span',{staticClass:"fa fa-photo mr-1"}),_vm._v("\n\t\t\t\t\t\t\t\t\tCambiar\n\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-8 col-lg-8 col-xl-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usu.nombre),expression:"usu.nombre"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.usu.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usu, "nombre", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Apellidos")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usu.apellidos),expression:"usu.apellidos"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.usu.apellidos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usu, "apellidos", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de nacimiento")]),_vm._v(" "),_c('datepicker',{attrs:{"input-class":"form-control form-control-sm","monday-first":true,"language":_vm.$dateLang,"disabled":!_vm.permisos.core_perfil_set_nacimiento},model:{value:(_vm.usu.fecha_nacimiento),callback:function ($$v) {_vm.$set(_vm.usu, "fecha_nacimiento", $$v)},expression:"usu.fecha_nacimiento"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-center"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Sexo")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.usu.sexo === 'mujer') ? 'btn-primary' : '',on:{"click":function($event){_vm.usu.sexo = 'mujer'}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tMujer\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.usu.sexo === 'hombre') ? 'btn-primary' : '',on:{"click":function($event){_vm.usu.sexo = 'hombre'}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tHombre\n\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.usu.sexo === 'otro') ? 'btn-primary' : '',on:{"click":function($event){_vm.usu.sexo = 'otro'}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tOtros\n\t\t\t\t\t\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Teléfono")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usu.telefono),expression:"usu.telefono"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.usu.telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usu, "telefono", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usu.email),expression:"usu.email"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.usu.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usu, "email", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-info",on:{"click":function($event){return _vm.guardarDatos()}}},[_c('span',{staticClass:"fa fa-save mr-1"}),_vm._v("\n\t\t\t\t\t\t\tGuardar cambios\n\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._m(1),_vm._v(" "),_c('b',[_vm._v("Cambio de contraseña")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass.passwordAnterior),expression:"pass.passwordAnterior"}],staticClass:"form-control form-control-sm",attrs:{"type":"password","placeholder":"Contraseña actual"},domProps:{"value":(_vm.pass.passwordAnterior)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pass, "passwordAnterior", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass.passwordNueva1),expression:"pass.passwordNueva1"}],staticClass:"form-control form-control-sm",attrs:{"type":"password","placeholder":"Nueva contraseña"},domProps:{"value":(_vm.pass.passwordNueva1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pass, "passwordNueva1", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass.passwordNueva2),expression:"pass.passwordNueva2"}],staticClass:"form-control form-control-sm",attrs:{"type":"password","placeholder":"Nueva contraseña (repítela)"},domProps:{"value":(_vm.pass.passwordNueva2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.pass, "passwordNueva2", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('button',{staticClass:"btn btn-sm btn-warning btn-block",on:{"click":function($event){return _vm.changePassword()}}},[_c('span',{staticClass:"fa fa-lock mr-1"}),_vm._v("\n\t\t\t\t\t\t\t\tCambiar contraseña\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"},[(!_vm.usu.otps && !_vm.configOTPS)?_c('div',{staticClass:"alert alert-warning"},[_vm._m(5),_vm._v(" "),_c('p',[_vm._v("Por el momento no tienes activada la verificación en dos pasos.")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){return _vm.getOTPSecret()}}},[_vm._v("Configurar")])]):_vm._e(),_vm._v(" "),(!_vm.usu.otps && _vm.configOTPS)?_c('div',{staticClass:"alert alert-info text-center"},[_c('h6',[_vm._v("Escanea el código con la app")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.configOTPS,"alt":""}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b',[_vm._v("Ahora introduce el código generado")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.verificaToken),expression:"verificaToken"}],staticClass:"text-center form-control form-control-sm",attrs:{"type":"text","placeholder":"XXXXXX"},domProps:{"value":(_vm.verificaToken)},on:{"input":function($event){if($event.target.composing){ return; }_vm.verificaToken=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input group-btn"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.verificarToken()}}},[_c('span',{staticClass:"fa fa-check"})])])])]):_vm._e(),_vm._v(" "),(_vm.usu.otps)?_c('div',{staticClass:"alert alert-success"},[_vm._m(7),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\tYa tienes configurado un doble factor de autenticación.\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-primary btn-block",on:{"click":function($event){return _vm.getOTPSecret()}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tConfigurar otro\n\t\t\t\t\t\t\t\t")])]):_vm._e()])])])])])]),_vm._v(" "),(_vm.nuevoAvatar)?_c('set-avatar',{on:{"cerrar":function($event){_vm.nuevoAvatar = false},"img":function($event){return _vm.setNuevoAvatar($event)}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('span',{staticClass:"fa fa-user mr-1"}),_vm._v("\n\t\t\t\t\t\tInformación básica\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('span',{staticClass:"fa fa-lock mr-1"}),_vm._v("\n\t\t\t\t\t\tSeguridad de la cuenta\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"alert alert-info"},[_c('span',{staticClass:"fa fa-info-circle mr-1"}),_vm._v("\n\t\t\t\t\t\tSi quieres cambiar tu contraseña debes escribir tu contraseña actual, y luego la nueva dos veces\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('b',[_vm._v("Autenticación de doble factor")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-6 col-md-8 col-lg-8 col-xl-8"},[_c('div',{staticClass:"alert alert-danger"},[_c('p',{staticStyle:{"text-align":"justify"}},[_c('span',{staticClass:"fa fa-info-circle mr-1"}),_vm._v("\n\t\t\t\t\t\t\t\t\tLa autenticación de doble factor añade otra capa más de seguridad a tu cuenta de usuario.\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("\n\t\t\t\t\t\t\t\t\tDebido a la información que se maneja en el sistema, "),_c('b',[_vm._v("es necesario tenerla activada")]),_vm._v(" si quieres acceder\n\t\t\t\t\t\t\t\t\tal SIP desde el exterior de la empresa. Cuando el acceso sea desde la red interna, no se te solicitará.\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("\n\t\t\t\t\t\t\t\t\tPara poder hacer uso de esta funcionalidad, es necesario que instales en tu dispositivo móvil alguna aplicación\n\t\t\t\t\t\t\t\t\tcapaz de generar códigos de un solo uso basados en el tiempo (OTP: One Time Password).\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"justify"}},[_vm._v("\n\t\t\t\t\t\t\t\t\tHay muchas gratuítas en las tiendas de aplicaciones, tanto de Apple con de Android. Algunas de las más usadas y confiables son:\n\t\t\t\t\t\t\t\t\t"),_c('ul',[_c('li',[_c('b',[_vm._v("Latch: ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.elevenpaths.android.latch","target":"_blank"}},[_vm._v("Android")]),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t/\n\t\t\t\t\t\t\t\t\t\t\t\t"),_c('a',{attrs:{"href":"https://itunes.apple.com/es/app/latch-by-elevenpaths/id744999016?mt=8","target":"_blank"}},[_vm._v("Apple")])]),_vm._v(" "),_c('li',[_c('b',[_vm._v("Google authenticator: ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2","target":"_blank"}},[_vm._v("Android")]),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t/\n\t\t\t\t\t\t\t\t\t\t\t\t"),_c('a',{attrs:{"href":"https://itunes.apple.com/es/app/google-authenticator/id388497605?mt=8","target":"_blank"}},[_vm._v("Apple")])]),_vm._v(" "),_c('li',[_c('b',[_vm._v("LastPass authenticator: ")]),_vm._v(" "),_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.lastpass.authenticator","target":"_blank"}},[_vm._v("Android")]),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t/\n\t\t\t\t\t\t\t\t\t\t\t\t"),_c('a',{attrs:{"href":"https://itunes.apple.com/es/app/lastpass-authenticator/id1079110004?mt=8","target":"_blank"}},[_vm._v("Apple")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"fa fa-unlock m-2",staticStyle:{"font-size":"3em"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("para iniciar el proceso de configuración haz click en el botón "),_c('b',[_vm._v("\"Configurar\"")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('span',{staticClass:"fa fa-check m-2",staticStyle:{"font-size":"3em"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\tSi necesitas cambiarlo pulsa en "),_c('b',[_vm._v("Configurar otro")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topbar_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_726b7550_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_topbar_vue__ = __webpack_require__(776);
function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-726b7550"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_726b7550_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_topbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee75b9d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__ = __webpack_require__(775);
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee75b9d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee75b9d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificacion_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3494610c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_notificacion_vue__ = __webpack_require__(774);
function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3494610c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3494610c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_notificacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notificacion",class:_vm.clase,style:((_vm.notificacion.URI) ? {'cursor' : 'pointer'} : {}),on:{"click":function($event){return _vm.go()}}},[(_vm.notificacion.Imagen)?_c('div',{staticClass:"imagen"},[_c('div',{staticClass:"imagenCuadrada",style:({backgroundImage: 'url(' + _vm.notificacion.Imagen + ')'})})]):(_vm.notificacion.Icono)?_c('div',{staticClass:"icono"},[_c('span',{staticClass:"fa",class:_vm.notificacion.Icono})]):_c('div',{staticClass:"icono"},[_c('span',{staticClass:"fa fa-bell"})]),_c('div',{staticClass:"contenido"},[_c('div',{staticClass:"titulo"},[_vm._v(_vm._s(_vm.notificacion.Titulo))]),_c('div',{staticClass:"descripcion"},[_vm._v(_vm._s(_vm.notificacion.Descripcion))]),_c('div',{staticClass:"fecha"},[_vm._v(_vm._s(_vm._f("moment")(_vm.notificacion.FechaCreacion,'DD-MM-YYYY HH:mm:ss')))])]),_c('div',{staticClass:"acciones"},[_c('div',{on:{"click":function($event){return _vm.descartar($event)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left listado",staticStyle:{"cursor":"default"}},[_c('div',{staticClass:"arrow-up"}),_c('div',{staticClass:"cabecera"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('span',{staticClass:"fa fa-bell mr-2"}),_vm._v("Notificaciones ("+_vm._s(_vm.nuevas.length)+")")]),_c('div',{staticClass:"col text-right"},[_c('span',{staticClass:"txtEliminarTodas",on:{"click":_vm.eliminarTodas}},[_vm._v("Eliminar todas")])])])]),_vm._l((_vm.listadoNotificaciones),function(notificacion,i){return _c('Notificacion',{key:notificacion.NotificacionID,class:(notificacion.FechaDescartada) ? 'cerrada' : '',attrs:{"notificacion":notificacion,"index":i},on:{"descartar":function($event){return _vm.descartar($event)},"cerrar":_vm.cerrar}})}),(_vm.listadoNotificaciones.length === 0)?_c('div',{staticClass:"noNoti"},[_c('span',{staticClass:"fa fa-bell-slash"}),_c('div',[_vm._v("No tienes notificaciones")])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:(_vm.dev) ? 'dev' : ''},[_c('div',{ref:"sidetop",staticClass:"sideTop"},[_c('div',{ref:"menuToggle",staticClass:"menuToggle"},[_c('img',{staticStyle:{"margin":"5px","margin-left":"10px","height":"40px"},attrs:{"src":"/static/recursos/menu.svg"},on:{"click":_vm.toggleMenu}})]),_c('div',{ref:"capaLogo",staticClass:"topLogo"},[(!_vm.dev)?_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"/static/recursos/logo_sip_white.svg","alt":""}}):_c('img',{staticStyle:{"margin-left":"15px","height":"30px"},attrs:{"src":"/static/recursos/logo_sip_white_devel.svg","alt":""}}),_c('div',{staticStyle:{"font-size":"0.9em","color":"white","vertical-align":"bottom"}},[_c('b',[_vm._v("v."+_vm._s(_vm.version))])])])]),_c('div',{staticClass:"globalMenu"},[_c('div',{ref:"capamenu",staticClass:"menu",style:(_vm.estilo)},_vm._l((_vm.menu),function(item){return _c('div',{staticClass:"item",class:(item.activo) ? 'active' : '',on:{"click":function($event){return _vm.clickItem(item)}}},[_c('div',{staticClass:"span",class:item.icono,staticStyle:{"font-size":"1.2em"}}),_c('div',[_vm._v(_vm._s(item.nombre))])])}),0),_c('div',{ref:"capaiconos",staticClass:"iconos",class:(_vm.notificacionesNuevas.length > 0) ? 'activo' : ''},[_c('div',{staticStyle:{"position":"relative"},on:{"click":function($event){_vm.verNotificaciones = !_vm.verNotificaciones}}},[_c('audio',{ref:"notificacion",staticStyle:{"display":"none"},attrs:{"src":"/src/modulos/core/static/notificacion.mp3"}}),_c('span',{staticClass:"fa",class:(_vm.notificaciones.length > 0) ? 'fa-bell' : 'fa-bell-slash',staticStyle:{"cursor":"pointer"}}),(_vm.notificacionesNuevas.length > 0)?_c('div',{staticClass:"badge badge-danger contadorNotis"},[_vm._v(_vm._s(_vm.notificacionesNuevas.length))]):_vm._e(),(_vm.verNotificaciones)?_c('ListadoNotificaciones',{staticClass:"listadoNotificaciones",on:{"cerrar":function($event){_vm.verNotificaciones = false}}}):_vm._e()],1)])]),(_vm.SIP_VERSION !== _vm.version && _vm.version !== null)?_c('Update',{attrs:{"version":_vm.version,"actual":_vm.SIP_VERSION,"pospuesto":_vm.updatePospuesto},on:{"posponer":function($event){return _vm.posponerUpdate()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tipoMovimiento)?_c('modal',{attrs:{"max-width":550}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Registrar jornada"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-danger text-white m-0 p-0"},[_c('div',{staticClass:"text-center tipoMovimiento"},[_vm._v(_vm._s(_vm.tipoMovimiento))])]),(_vm.ultimoRegistro)?_c('div',{staticClass:"card-body bg-light"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("La entrada se fichó el "+_vm._s(_vm.ultimoRegistro.FechaInicioJornada))]):_vm._e(),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-2"},[_c('div',{staticClass:"input-group input-group-lg"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-calendar fa-w"})])]),_c('input',{staticClass:"form-control",attrs:{"disabled":true},domProps:{"value":_vm.fecha}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-2"},[_c('div',{staticClass:"input-group input-group-lg"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-clock-o fa-w"})])]),(_vm.hora === null)?_c('input',{staticClass:"form-control",attrs:{"disabled":"true"},domProps:{"value":_vm.ahora}}):_vm._e(),(_vm.hora !== null)?_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.hora),expression:"hora"}],staticClass:"form-control",attrs:{"type":"time","size":"5","placeholder":"HH:MM"},domProps:{"value":(_vm.hora)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hora=$event.target.value}}}):_vm._e(),_c('div',{staticClass:"input-group-append"},[(_vm.hora !== null)?_c('button',{staticClass:"btn btn-primary",attrs:{"title":"Establece la fecha y la hora actual"},on:{"click":function($event){return _vm.setAhora(true)}}},[_c('span',{staticClass:"fa fa-clock-o"})]):_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.setAhora(false)}}},[_c('span',{staticClass:"fa fa-edit"})])])])])])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Comentarios (opcional)")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comentarios),expression:"comentarios"}],staticClass:"form-control",domProps:{"value":(_vm.comentarios)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comentarios=$event.target.value}}})]),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Fichar")])])]),_c('div',{attrs:{"id":"mapaFichar"}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.usuario.ID)?_c('div',[_c('nav',[_c('topbar',{attrs:{"id":"maintop","nombre":_vm.nombreSeccion},on:{"togglemenu":function($event){_vm.verMenu = !_vm.verMenu}}})],1),_vm._v(" "),_c('aside',{staticClass:"bg-light text-dark",class:(_vm.verMenu) ? 'active' : '',attrs:{"id":"mainside"}},[_c('button',{staticClass:"btn btn-sm btn-warning hideMenu",on:{"click":function($event){_vm.verMenu = !_vm.verMenu}}},[_c('span',{staticClass:"fa fa-bars"})]),_vm._v(" "),_c('sidebar',{on:{"verperfil":function($event){_vm.verPerfil = true},"fichar":_vm.fichar}})],1),_vm._v(" "),_c('section',{style:(_vm.estiloMain),attrs:{"id":"mainmain"}},[_c('router-view',{staticClass:"text-left"},[_vm._v("Contenido")])],1),_vm._v(" "),(_vm.verPerfil)?_c('mi-perfil',{on:{"cerrar":function($event){_vm.verPerfil = false}}}):_vm._e(),_vm._v(" "),(_vm.fichando)?_c('fichar',{on:{"cerrar":function($event){_vm.fichando = null}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input_query_cmp_vue__ = __webpack_require__(781);

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue, opcions) {
		Vue.component('input-query', __WEBPACK_IMPORTED_MODULE_0__input_query_cmp_vue__["a" /* default */]);
	}
});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_query_cmp_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb6e64f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_query_cmp_vue__ = __webpack_require__(783);
function injectStyle (ssrContext) {
  __webpack_require__(782)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_query_cmp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb6e64f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_query_cmp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.inputClass,staticStyle:{"margin":"0","padding":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cadena),expression:"cadena"}],ref:"inp",class:_vm.inputClass,staticStyle:{"border":"0"},attrs:{"type":"text","disabled":_vm.disabled,"realtime":_vm.realtime,"placeholder":_vm.placeholder},domProps:{"value":(_vm.cadena)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.abajo()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.arriba()},function($event){return _vm.teclaPulsada($event)}],"input":function($event){if($event.target.composing){ return; }_vm.cadena=$event.target.value}}}),_vm._v(" "),(_vm.resultados.length > 0)?_c('div',{ref:"caja",staticClass:"caja",style:(_vm.estiloCaja),attrs:{"id":"caja-query"}},[_c('table',{staticStyle:{"width":"100%","margin":"0"}},[_c('tbody',_vm._l((_vm.resultados),function(resultado,index){return _c('tr',{ref:"resultado",refInFor:true},[_c('td',{class:_vm.getClase(resultado),on:{"click":function($event){return _vm.seleccionar(resultado)},"mouseover":function($event){_vm.preseleccionado = resultado}}},[(resultado.icono)?_c('span',{staticClass:"mr-2",class:resultado.icono}):_vm._e(),_vm._v("\n\t\t\t\t\t\t"+_vm._s(resultado.texto)+"\n\t\t\t\t\t")])])}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input_query_location_vue__ = __webpack_require__(785);

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue, opcions) {
		Vue.component('input-query-location', __WEBPACK_IMPORTED_MODULE_0__input_query_location_vue__["a" /* default */]);
	}
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_query_location_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_409783b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_query_location_vue__ = __webpack_require__(787);
function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_input_query_location_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_409783b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_input_query_location_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.inputClass,staticStyle:{"margin":"0","padding":"0"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cadena),expression:"cadena"}],ref:"inp",class:_vm.inputClass,staticStyle:{"border":"0"},attrs:{"type":"text","disabled":_vm.disabled,"realtime":_vm.realtime,"placeholder":_vm.placeholder},domProps:{"value":(_vm.cadena)},on:{"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.abajo()},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.stopPropagation();if($event.target !== $event.currentTarget){ return null; }return _vm.arriba()},function($event){return _vm.teclaPulsada($event)}],"input":function($event){if($event.target.composing){ return; }_vm.cadena=$event.target.value}}}),_vm._v(" "),(_vm.resultados.length > 0)?_c('div',{ref:"caja",staticClass:"caja",style:(_vm.estiloCaja),attrs:{"id":"caja-query"}},[_c('table',{staticStyle:{"width":"100%","margin":"0"}},[_c('tbody',_vm._l((_vm.resultados),function(resultado,index){return _c('tr',{ref:"resultado",refInFor:true},[_c('td',{staticClass:"text-center",staticStyle:{"min-width":"40px"}},[_c('img',{staticStyle:{"width":"20px"},attrs:{"src":resultado.icon}})]),_vm._v(" "),_c('td',{class:_vm.getClase(resultado),on:{"click":function($event){return _vm.seleccionar(resultado)},"mouseover":function($event){_vm.preseleccionado = resultado}}},[(resultado.icono)?_c('span',{staticClass:"mr-2",class:resultado.icono}):_vm._e(),_vm._v("\n\t\t\t\t\t\t"+_vm._s(resultado.formatted_address)+"\n\t\t\t\t\t")])])}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__seleccion_usuario_vue__ = __webpack_require__(789);


/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		Vue.component('seleccion-usuario', __WEBPACK_IMPORTED_MODULE_0__seleccion_usuario_vue__["a" /* default */]);
	}
});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccion_usuario_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc33f2da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_seleccion_usuario_vue__ = __webpack_require__(790);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccion_usuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc33f2da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_seleccion_usuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.UsuarioID)?_c('div',{staticClass:"input-group"},[_vm._m(0),_c('input-query',{attrs:{"inputClass":"form-control form-control-sm","url":"/core/php/api/usuarios/query.php","realtime":true},on:{"selected":_vm.seleccionaUsuario}})],1):_c('div',{staticClass:"input-group"},[_vm._m(1),_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":true},domProps:{"value":_vm.UsuarioNombre}}),(!_vm.readonly)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.quitar}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		infoUsuario: {
			ID: null,
			nombre: null,
			apellidos: null,
			avatar: null,
			tipo: null
		},
		activa: null,
		externo: null,
		requiere2fa: null,
		direccionIP: null,
		cambioPass: false,
		bloqueado: false,
		afterLoginPath: null
	},
	getters: {
		usuario: function usuario(state) {
			return state.infoUsuario;
		},
		ip: function ip(state) {
			return state.direccionIP;
		},
		haySesion: function haySesion(state) {
			return state.activa;
		},
		cambiarPass: function cambiarPass(state) {
			return state.cambioPass;
		},
		externo: function externo(state) {
			return state.externo;
		},
		requiere2fa: function requiere2fa(state) {
			return state.requiere2fa;
		},
		sesionBloqueada: function sesionBloqueada(state) {
			return state.bloqueado;
		},
		afterLoginPath: function afterLoginPath(state) {
			return state.afterLoginPath;
		}
	},
	mutations: {
		setUsuario: function setUsuario(state, payload) {
			state.infoUsuario = {
				ID: payload.usuario.ID,
				nombre: payload.usuario.nombre,
				apellidos: payload.usuario.apellidos,
				avatar: payload.usuario.avatar,
				tipo: payload.usuario.tipo
			};

			state.activa = true;
			state.externo = payload.externo;
			state.requiere2fa = payload.requiere2fa;
			state.direccionIP = payload.ip;
		},
		setCambioPass: function setCambioPass(state, payload) {
			state.cambioPass = payload;
		},
		setBloqueado: function setBloqueado(state, payload) {
			state.bloqueado = payload;
		},
		setActiva: function setActiva(state, payload) {
			state.activa = payload;
		},
		sesionFuera: function sesionFuera(state, _ref) {
			var externo = _ref.externo,
			    requiere2fa = _ref.requiere2fa;

			state.infoUsuario = {
				ID: null,
				nombre: null,
				apellidos: null,
				avatar: null,
				tipo: null
			};

			state.activa = false;
			state.bloqueado = false;
			state.externo = externo;
			state.requiere2fa = requiere2fa;
		},
		SET_AFTER_LOGIN: function SET_AFTER_LOGIN(state, path) {
			state.afterLoginPath = path;
		}
	},
	actions: {
		login: function login(context, payload) {
			var _this = this;

			var datos = {
				usuario: payload.usuario,
				password: payload.password,
				token: payload.token,
				recordarme: payload.recordarme
			};

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('core/php/api/sesion/login.php', datos).then(function (res) {
				if (res) {
					if (res.data && res.data.cambiarpass) {
						context.commit('setCambioPass', true);
					} else {
						context.commit('setCambioPass', false);
						context.commit('setUsuario', res.data);
					}
				}
			}).catch(function (e) {
				_this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
				context.commit('sesionFuera');
			});
		},
		logout: function logout(context) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('core/php/api/sesion/logout.php').then(function (res) {
				context.commit('SET_AFTER_LOGIN', null);
				context.commit('sesionFuera');
			}).catch(function (e) {
				console.log(e);
				console.error('Error cerrando sesión');
				context.commit('sesionFuera');
			});
		},
		getSesion: function getSesion(context) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('core/php/api/sesion/get.php').then(function (res) {
				if (res.data && res.data.cambiarpass) {
					context.commit('setCambioPass', true);
					context.commit('setActiva', true);
					return;
				} else if (res.data && res.data.inactivo) {
					context.commit('setBloqueado', res.data.usuario);
					context.commit('setActiva', true);
					return;
				}
				context.commit('setBloqueado', false);
				context.commit('setCambioPass', false);
				context.commit('setUsuario', res.data);
			}).catch(function (e) {
				if (e.response) {
					context.commit('sesionFuera', { externo: e.response.data.externo, requiere2fa: e.response.data.requiere2fa });
				}
			});
		},
		lock: function lock(context, payload) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('core/php/api/sesion/bloquear.php').then(function (res) {
				// recibimos el usuario
				context.commit('setBloqueado', res.data.usuario);
			}).catch(function (e) {
				_this2.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Contraseña incorrecta'
				});
			});
		},
		doDesbloquear: function doDesbloquear(context, payload) {
			var _this3 = this;

			var datos = {
				password: payload
			};
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('core/php/api/sesion/desbloquear.php', datos).then(function (res) {
				// recibimos el usuario
				context.commit('setBloqueado', false);
				context.commit('setActiva', true);
				context.commit('setUsuario', res.data);
			}).catch(function (e) {
				_this3.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Contraseña incorrecta'
				});
			});
		}
	}
});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		alertas: []
	},

	getters: {
		actual: function actual(state) {
			if (state.alertas.length === 0) {
				return null;
			}

			return state.alertas[0];
		}
	},

	mutations: {
		nueva: function nueva(state, payload) {
			if (!Array.isArray(payload.buttons)) {
				payload.buttons = [];
			}

			if (payload.buttons.length === 0) {
				payload.buttons.push({
					titulo: 'Aceptar',
					clase: 'btn btn-sm btn-primary',
					icono: 'fa fa-check',
					valor: null
				});
			}
			state.alertas.push(payload);
		},
		alert: function alert(state, payload) {
			if (!Array.isArray(payload.buttons)) {
				payload.buttons = [];
			}

			if (payload.buttons.length === 0) {
				payload.buttons.push({
					titulo: 'Aceptar',
					clase: 'btn btn-sm btn-primary',
					icono: 'fa fa-check',
					valor: null
				});
			}
			payload.claseCabecera = '';
			payload.tipo = 'alerta';
			state.alertas.push(payload);
		},
		error: function error(state, payload) {
			if (!Array.isArray(payload.buttons)) {
				payload.buttons = [];
			}

			if (payload.buttons.length === 0) {
				payload.buttons.push({
					titulo: 'Aceptar',
					clase: 'btn btn-sm btn-primary',
					icono: 'fa fa-check',
					valor: null
				});
			}
			payload.claseCabecera = 'bg-danger text-white';
			payload.tipo = 'error';
			state.alertas.push(payload);
		},
		confirm: function confirm(state, payload) {
			if (!Array.isArray(payload.buttons) || payload.buttons.length === 0) {
				payload.buttons = [{
					titulo: 'Aceptar',
					clase: 'btn btn-sm btn-primary',
					icono: 'fa fa-check',
					valor: true
				}, {
					titulo: 'Cancelar',
					clase: 'btn btn-sm btn-danger',
					icono: 'fa fa-ban',
					valor: false
				}];
			}

			state.alertas.push(payload);
		},
		cerrar: function cerrar(state) {
			state.alertas.splice(0, 1);
		}
	}
});

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		permisos: {}
	},
	getters: {
		permisos: function permisos(state) {
			return state.permisos;
		}
	},
	mutations: {
		setPermisos: function setPermisos(state, payload) {
			state.permisos = payload.permisos;
		}
	},
	actions: {
		getPermisos: function getPermisos(context) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/core/php/api/perfil/get-todos-permisos.php').then(function (res) {
				context.commit('setPermisos', res.data);
			}).catch(function (e) {
				if (e.message && e.message.code === 423) {
					return;
				}
				_this.commit('toast/danger', {
					titulo: 'Error obteniendo los permisos',
					mensaje: e.response && e.response.data && e.response.data.error ? e.response.data.error : ''
				});
			});
		}
	}
});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		listadoToasts: [],
		id: 0
	},

	getters: {
		toasts: function toasts(state) {
			return state.listadoToasts;
		}
	},

	mutations: {
		// Marca el toast para eliminarse
		close: function close(state, id) {
			for (var i = 0; i < state.listadoToasts.length; i++) {
				if (state.listadoToasts[i].id === id) {
					state.listadoToasts[i].close = true;
				}
			}
		},


		/**
   * Creamos una notificación de progreso que podremos modificar y actualizar
   * @param {*} state
   * @param {*} payload
   */
		progress: function progress(state, payload) {
			if (!payload.id) {
				return;
			}

			payload.type = 'progress';
			payload.timeout = null;
			payload.closable = false;
			payload.icon = !payload.icon ? 'fa fa-check' : payload.icon;
			payload.style = 'bg-success text-white';

			// Buscamos si existe
			for (var i = 0; i < state.listadoToasts.length; i++) {
				if (state.listadoToasts[i].id === payload.id) {
					__WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state.listadoToasts, i, payload);
					return;
				}
			}
			state.listadoToasts.push(payload);
		},


		// Elimina definitivamente el toast del DOM
		delete: function _delete(state, id) {
			for (var i = 0; i < state.listadoToasts.length; i++) {
				if (state.listadoToasts[i].id === id) {
					state.listadoToasts.splice(i, 1);
					return;
				}
			}
		},
		success: function success(state, payload) {
			payload.id = ++state.id;
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10;
			}
			payload.closable = typeof payload.closable === 'boolean' ? payload.closable : true;
			payload.icon = !payload.icon ? 'fa fa-check' : payload.icon;
			payload.style = 'bg-success text-white';
			state.listadoToasts.push(payload);
		},
		danger: function danger(state, payload) {
			payload.id = ++state.id;
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10;
			}
			payload.closable = typeof payload.closable === 'boolean' ? payload.closable : true;
			payload.icon = !payload.icon ? 'fa fa-ban' : payload.icon;
			payload.style = 'bg-danger text-white';
			state.listadoToasts.push(payload);
		},
		warning: function warning(state, payload) {
			payload.id = ++state.id;
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10;
			}
			payload.closable = typeof payload.closable === 'boolean' ? payload.closable : true;
			payload.style = 'bg-warning';
			payload.icon = !payload.icon ? 'fa fa-exclamation-triangle' : payload.icon;
			state.listadoToasts.push(payload);
		},
		light: function light(state, payload) {
			payload.id = ++state.id;
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10;
			}
			payload.closable = typeof payload.closable === 'boolean' ? payload.closable : true;
			payload.style = 'bg-light text-dark';
			payload.icon = !payload.icon ? 'fa fa-info-circle' : payload.icon;
			state.listadoToasts.push(payload);
		},
		dark: function dark(state, payload) {
			payload.id = ++state.id;
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10;
			}
			payload.closable = typeof payload.closable === 'boolean' ? payload.closable : true;
			payload.style = 'bg-dark text-white';
			payload.icon = !payload.icon ? 'fa fa-info-circle' : payload.icon;
			state.listadoToasts.push(payload);
		},
		info: function info(state, payload) {
			payload.id = ++state.id;
			if (!payload.timeout || typeof payload.timeout !== 'number') {
				payload.timeout = 10;
			}
			payload.closable = typeof payload.closable === 'boolean' ? payload.closable : true;
			payload.icon = !payload.icon ? 'fa fa-info-circle' : payload.icon;
			payload.style = 'bg-info text-white';
			state.listadoToasts.push(payload);
		}
	}
});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		menuActivo: {
			evento: null,
			titulo: null,
			style: {},
			items: []
		},
		estaActivo: false
	},

	getters: {
		menu: function menu(state) {
			if (!state.estaActivo) {
				return null;
			}

			return state.menuActivo;
		},
		activo: function activo(state) {
			return state.estaActivo;
		}
	},

	mutations: {
		mostrar: function mostrar(state, payload) {
			if (!Array.isArray(payload.items) || payload.items.length === 0) {
				return;
			}

			if (!payload.evento) {
				return;
			}

			// Calculamos estilo
			state.menuActivo.style = {
				top: payload.evento.clientY + 'px',
				left: payload.evento.clientX + 'px'
			};

			state.menuActivo.evento = payload.evento;
			state.menuActivo.titulo = typeof payload.titulo === 'string' && payload.titulo.trim().length > 0 ? payload.titulo : null;
			state.menuActivo.items = payload.items.map(function (item) {
				var a = {};
				if (!item.texto) {
					return null;
				}

				if (!item.callback) {
					return null;
				}

				a.texto = item.texto;
				a.activo = typeof item.activo === 'boolean' ? item.activo : false;
				a.callback = item.callback;
				a.icono = typeof item.icono === 'string' && item.icono.trim().length > 0 ? item.icono : null;
				return a;
			});

			if (state.menuActivo.items.length === 0) {
				return;
			}
			state.estaActivo = true;
		},
		cerrar: function cerrar(state) {
			state.estaActivo = false;
		}
	}
});

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		listado: []
	},
	getters: {
		listado: function listado(state) {
			var arr = [].concat(state.listado);
			return arr.sort(function (a, b) {
				if (a.FechaCreacion > b.FechaCreacion) {
					return -1;
				} else if (a.FechaCreacion < b.FechaCreacion) {
					return 1;
				}
				return 0;
			});
		},
		nuevas: function nuevas(state) {
			return state.listado.filter(function (noti) {
				if (!noti.FechaMostrada) {
					return true;
				}
				return false;
			});
		}
	},
	mutations: {
		ADD: function ADD(state, payload) {
			for (var i = 0; i < state.listado.length; i++) {
				if (state.listado[i].NotificacionID === payload.NotificacionID) {
					__WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.listado, i, payload); // Actualizamos
					return;
				}
			}

			state.listado.splice(0, 0, payload);
		},
		DEL: function DEL(state, payload) {
			state.listado = state.listado.filter(function (n) {
				return n.NotificacionID !== payload;
			});
		},
		DEL_TODAS: function DEL_TODAS(state) {
			state.listado = [];
		},
		LEIDAS: function LEIDAS(state) {
			for (var i = 0; i < state.listado.length; i++) {
				if (!state.listado[i].FechaMostrada) {
					state.listado[i].FechaMostrada = Math.floor(new Date().getTime() / 1000);
					__WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.listado, i, state.listado[i]);
				}
			}
		}
	},
	actions: {
		get: function get(context) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('core/php/api/notificaciones/getNotificaciones.php').then(function (res) {
				if (res && res.data) {
					res.data.forEach(function (noti) {
						context.commit('ADD', noti);
					});
				}
				context.dispatch('poll');
			}).catch(function (e) {
				console.error(e);
			});
		},
		poll: function poll(context) {
			var LastID = context.state.listado.reduce(function (acc, item) {
				acc = acc === null || acc < item.NotificacionID ? item.NotificacionID : acc;
				return acc;
			}, null);
			var ajax = new XMLHttpRequest();
			ajax.open('GET', 'src/modulos/core/php/api/notificaciones/polling_notificaciones.php?LastID=' + LastID, true);
			ajax.onreadystatechange = function () {
				if (ajax.readyState === 4) {
					if (ajax.status === 200) {
						var res = JSON.parse(ajax.responseText);
						res.forEach(function (noti) {
							context.commit('ADD', noti);
						});
						context.dispatch('poll');
					} else {
						console.error(ajax.response);
						window.setTimeout(function () {
							context.dispatch('poll');
						}, 30000);
					}
				}
			};
			ajax.send();
		},
		del: function del(context, NotificacionID) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('core/php/api/notificaciones/descartar.php?NotificacionID=' + NotificacionID).then(function (res) {
				context.commit('DEL', NotificacionID);
			}).catch(function (e) {
				console.log(e);
				console.error('Error descartando la notificación');
			});
		},
		delTodas: function delTodas(context) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('core/php/api/notificaciones/descartarTodas.php').then(function () {
				context.commit('DEL_TODAS');
			}).catch(function (e) {
				console.log(e);
			});
		},
		leidas: function leidas(context) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('core/php/api/notificaciones/leidas.php', { ids: context.state.listado.map(function (l) {
					return l.NotificacionID;
				}) }).then(function (res) {
				context.commit('LEIDAS');
			}).catch(function (e) {
				console.log(e);
				console.error('Error descartando la notificación');
			});
		}
	}
});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		titulo: null,
		menuItems: [],
		topIcons: []
	},

	getters: {
		menu: function menu(state) {
			return state.menuItems;
		},
		iconos: function iconos(state) {
			return state.topIcons;
		},
		titulo: function titulo(state) {
			return state.titulo;
		}
	},

	mutations: {
		setTitulo: function setTitulo(state, payload) {
			state.titulo = payload;
		},
		clearMenu: function clearMenu(state) {
			state.menuItems = [];
		},
		setMenu: function setMenu(state, payload) {
			window.setTimeout(function () {
				state.menuItems = payload;
			}, 100);
		},
		addMenu: function addMenu(state, payload) {
			window.setTimeout(function () {
				state.menuItems.push(payload);
			}, 130);
		},
		delMenu: function delMenu(state, id) {
			state.menuItems = state.menuItems.filter(function (a) {
				return a.id !== id;
			});
		},
		setMenuActivo: function setMenuActivo(state, payload) {
			if (typeof payload === 'string') {
				payload = {
					nombre: payload
				};
			}
			state.menuItems = state.menuItems.map(function (menu) {
				menu.activo = menu.nombre === payload.nombre;
				return menu;
			});
		},
		setIcons: function setIcons(state, payload) {
			// El último icono siempre es la campana
			state.topIcons = payload;
		}
	}
});

/***/ }),
/* 798 */,
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue, options) {
		Vue.component('vueCropper', {
			template: '<div style="position:relative;display:block;"><input type="file" @change="selectFile"/> <div v-if="cropping" ref="cropperdiv" :style="cropperDivStyle"><canvas ref="canvas" :width="canvasWidth" :height="canvasHeight" @mousemove="moveMouse" @mousedown="startDrag" @mouseup="stopDrag" @dragover="stopDrag"></canvas></div><img style="display:none;" v-bind:src="croppedImage" :style="roundCorners"/></div>',
			data: function data() {
				return {
					cropperDivWidth: '100%', // this can be anything passed to css width
					cropperDivHeight: false, // this should be either false or number (in pixels)
					cropperDivMaxHeight: 600, // this should be either false or number (in pixels). Must be number if cropperDivHeight is false
					cropping: false,
					image: false,
					imageWidth: 0,
					imageHeight: 0,
					canvasWidth: 300,
					canvasHeight: 300,
					ctx: false,
					mainStroke: 'rgba(255,255,255,0.99)', // color of the line around cropping area. Set to rgba(0,0,0,0) for no line
					lineDash: [5, 3], // dash style of line around cropping area, set to empty array for solid line ([])
					overlayStyle: 'rgba(0,0,0,0.4)', // overlay around cropped area
					fillStyle: 'rgba(0,0,0,0.7)', // corner handles style, fill
					strokeStyle: 'rgba(255,255,255,0.7)', // corner handles style, stroke
					hoverFillStyle: 'rgba(255,255,255,0.4)', // corner handles style, fill on hover
					hoverStrokeStyle: 'white', // corner handles style, stroke on hover
					x: 20,
					y: 20,
					w: 200,
					h: 200, // initial cropping values, x, y, width, height
					markerSize: 20,
					deltaX: 0,
					deltaY: 0,
					dragged: false,
					aspectRatio: 1, // aspect ratio of the cropping area. false for non locked ratio, or number for locked
					croppedWidth: 400, // desired width of cropped image
					croppedHeight: 400, // desired height of cropped image. If width/height is not equal to aspect ratio, final image will be distorted
					minWidth: 10, // minimal cropping area width
					minHeight: 10, // minimal cropping area height
					croppedImage: false,
					circle: true // for cropping round images. If set to true, it will change aspect ratio of cropping area to 1. CroppedWidth and croppedHeight should be equal, otherwise strange effects will occur
				};
			},
			computed: {
				cropperDivStyle: function cropperDivStyle() {
					return {
						width: this.cropperDivWidth,
						height: this.cropperHeight + 'px',
						textAlign: 'center'
					};
				},
				cropperHeight: function cropperHeight() {
					return this.cropperDivHeight ? this.cropperDivHeight : this.cropperDivMaxHeight;
				},
				cropperWidth: function cropperWidth() {
					return this.cropping && this.$refs.cropperdiv.offsetWidth;
				},
				cropperDivRatio: function cropperDivRatio() {
					return this.cropperWidth / this.cropperHeight;
				},
				imageRatio: function imageRatio() {
					return this.imageWidth / this.imageHeight;
				},
				markers: function markers() {
					return {
						nw: {
							x: this.x - this.markerSize / 2,
							y: this.y - this.markerSize / 2
						},
						ne: {
							x: this.x + this.w - this.markerSize / 2,
							y: this.y - this.markerSize / 2
						},
						sw: {
							x: this.x - this.markerSize / 2,
							y: this.y + this.h - this.markerSize / 2
						},
						se: {
							x: this.x + this.w - this.markerSize / 2,
							y: this.y + this.h - this.markerSize / 2
						}
					};
				},
				cw: function cw() {
					return this.croppedWidth || this.w;
				},
				ch: function ch() {
					return this.croppedHeight || this.h;
				},
				roundCorners: function roundCorners() {
					if (this.circle) {
						return {
							borderRadius: '100%'
						};
					} else return false;
				}
			},
			methods: {
				selectFile: function selectFile(evt) {
					var file = evt.currentTarget.files[0];
					var reader = new FileReader();
					var cropper = this;
					reader.onload = function (evt) {
						cropper.cropping = true;
						if (cropper.circle) {
							cropper.aspectRatio = 1;
							cropper.h = cropper.w;
						}
						var image = new Image();
						image.src = evt.target.result;
						image.onload = function () {
							cropper.image = image;
							cropper.drawing = true;
							cropper.imageWidth = image.width;
							cropper.imageHeight = image.height;
							cropper.canvasWidth = cropper.cropperWidth;
							cropper.canvasHeight = cropper.cropperHeight;
							if (cropper.imageRatio < cropper.cropperDivRatio) {
								cropper.canvasWidth = cropper.canvasHeight * cropper.imageRatio;
							}
							if (cropper.imageRatio > cropper.cropperDivRatio) {
								cropper.canvasHeight = cropper.canvasWidth / cropper.imageRatio;
							}

							Vue.nextTick(function () {
								var canvas = cropper.$refs.canvas;
								cropper.ctx = canvas.getContext('2d');
								cropper.ctx.drawImage(cropper.image, 0, 0, cropper.canvasWidth, cropper.canvasHeight);
							});
						};
					};
					reader.readAsDataURL(file);
				},
				moveMouse: function moveMouse(event) {
					if (event === undefined) return false;
					// var doc = document.documentElement

					var x = event.offsetX;
					var y = event.offsetY;

					var ctx = this.ctx;

					// draw the image
					ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
					ctx.drawImage(this.image, 0, 0, this.canvasWidth, this.canvasHeight);

					// update coords
					if (this.dragged) this.updateCoords(x, y);

					// draw crop area and handles
					this.drawSelection(ctx, x, y);

					// crop image
					var scaleX = this.imageWidth / this.canvasWidth;
					var scaleY = this.imageHeight / this.canvasHeight;
					var resultCanvas = document.createElement('canvas');
					resultCanvas.width = this.cw;
					resultCanvas.height = this.ch;
					resultCanvas.getContext('2d').drawImage(this.image, this.x * scaleX, this.y * scaleY, this.w * scaleX, this.h * scaleY, 0, 0, this.cw, this.ch);
					this.croppedImage = resultCanvas.toDataURL();

					this.$emit('img', this.croppedImage);
				},
				drawSelection: function drawSelection(ctx, x, y) {
					this.drawOverlay(ctx);
					this.$refs.canvas.style.cursor = 'default';

					ctx.beginPath();
					if (!this.circle) {
						ctx.rect(this.x, this.y, this.w, this.h);
					} else {
						ctx.arc(this.x + this.w / 2, this.y + this.h / 2, this.w / 2, 0, 2 * Math.PI);
					}
					if (ctx.isPointInPath(x, y)) {
						this.$refs.canvas.style.cursor = 'move';
					}

					ctx.setLineDash(this.lineDash);
					ctx.strokeStyle = this.mainStroke;
					ctx.stroke();
					ctx.setLineDash([]);

					for (var p in this.markers) {
						var rectangle = this.markers[p];
						ctx.beginPath();
						ctx.rect(rectangle.x, rectangle.y, this.markerSize, this.markerSize);
						ctx.fillStyle = this.fillStyle;
						ctx.strokeStyle = this.strokeStyle;
						if (ctx.isPointInPath(x, y)) {
							ctx.fillStyle = this.hoverFillStyle;
							ctx.strokeStyle = this.hoverStrokeStyle;
							this.$refs.canvas.style.cursor = p + '-resize';
						}
						ctx.fill();
						ctx.stroke();
					}
				},
				drawOverlay: function drawOverlay(ctx) {
					ctx.fillStyle = this.overlayStyle;
					ctx.fillRect(0, 0, this.canvasWidth, this.y);
					ctx.fillRect(0, this.y, this.x, this.h);
					ctx.fillRect(this.x + this.w, this.y, this.canvasWidth - (this.x + this.w), this.h);
					ctx.fillRect(0, this.y + this.h, this.canvasWidth, this.canvasHeight - (this.y + this.h));
					if (this.circle) {
						ctx.beginPath();
						ctx.arc(this.x + this.w / 2, this.y + this.h / 2, this.w / 2, Math.PI, 1.5 * Math.PI);
						ctx.lineTo(this.x, this.y);
						ctx.closePath();
						ctx.fill();
						ctx.beginPath();
						ctx.arc(this.x + this.w / 2, this.y + this.h / 2, this.w / 2, 1.5 * Math.PI, 2 * Math.PI);
						ctx.lineTo(this.x + this.w, this.y);
						ctx.closePath();
						ctx.fill();
						ctx.beginPath();
						ctx.arc(this.x + this.w / 2, this.y + this.h / 2, this.w / 2, 0, 0.5 * Math.PI);
						ctx.lineTo(this.x + this.w, this.y + this.h);
						ctx.closePath();
						ctx.fill();
						ctx.beginPath();
						ctx.arc(this.x + this.w / 2, this.y + this.h / 2, this.w / 2, 0.5 * Math.PI, Math.PI);
						ctx.lineTo(this.x, this.y + this.h);
						ctx.closePath();
						ctx.fill();
					}
				},
				startDrag: function startDrag(event) {
					// var doc = document.documentElement
					// var scrollLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0)
					// var scrollTop = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)

					var x = event.offsetX;
					var y = event.offsetY;

					var ctx = this.ctx;

					for (var p in this.markers) {
						var rectangle = this.markers[p];
						ctx.beginPath();
						ctx.rect(rectangle.x, rectangle.y, this.markerSize, this.markerSize);
						if (ctx.isPointInPath(x, y)) {
							this.dragged = p;
							this.deltaX = x - rectangle.x;
							this.deltaY = y - rectangle.y;
							return;
						}
					}
					ctx.beginPath();
					if (!this.circle) {
						ctx.rect(this.x, this.y, this.w, this.h);
					} else {
						ctx.arc(this.x + this.w / 2, this.y + this.h / 2, this.w / 2, 0, 2 * Math.PI);
					}

					if (ctx.isPointInPath(x, y)) {
						this.dragged = 'all';
						this.deltaX = x - this.x;
						this.deltaY = y - this.y;
					}
				},
				stopDrag: function stopDrag() {
					this.dragged = false;
					this.deltaX = 0;
					this.deltaY = 0;
				},
				updateCoords: function updateCoords(x, y) {
					var newX, newY, newW, newH;
					if (this.dragged === 'all') {
						newX = x - this.deltaX;
						newY = y - this.deltaY;
						newW = this.w;
						newH = this.h;
					} else {
						var ox = this.dragged[1] === 'w' ? 'e' : 'w';
						var oy = this.dragged[0] === 'n' ? 's' : 'n';
						var oppositeIdx = oy + ox;
						if (ox === 'e') {
							newX = x - this.deltaX + this.markerSize / 2;
							newW = this.markers[oppositeIdx].x - newX + this.markerSize / 2;
						} else {
							newX = this.x;
							newW = x - this.deltaX - this.markers[oppositeIdx].x;
						}
						if (oy === 's') {
							newY = y - this.deltaY + this.markerSize / 2;
							newH = this.markers[oppositeIdx].y - newY + this.markerSize / 2;
						} else {
							newY = this.y;
							newH = y - this.deltaY - this.markers[oppositeIdx].y;
						}
					}

					if (this.aspectRatio) {
						newH = newW / this.aspectRatio;
					}

					if (newX < 0) newX = 0;
					if (newY < 0) newY = 0;
					if (newX + newW > this.canvasWidth) {
						newW = this.canvasWidth - newX;
						if (this.aspectRatio) {
							newH = newW / this.aspectRatio;
						}
					}
					if (newY + newH > this.canvasHeight) {
						newH = this.canvasHeight - newY;
						if (this.aspectRatio) {
							newW = newH * this.aspectRatio;
						}
					}
					if (newW < this.minWidth) {
						newW = this.minWidth;
						newH = newW / this.aspectRatio;
					}
					if (newH < this.minHeight) {
						newH = this.minHeight;
						newW = newH * this.aspectRatio;
					}

					this.x = newX;
					this.y = newY;
					this.w = newW;
					this.h = newH;
				}
			}
		});
	}
});

/***/ }),
/* 800 */,
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7a1a956c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__(803);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7a1a956c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 802 */,
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.id_name},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v("\n\t\t"+_vm._s(_vm.button_text)+"\n\t")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22312be8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__(809);
function injectStyle (ssrContext) {
  __webpack_require__(808)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22312be8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"fondoModal"}},[_c('div',[_c('div',{style:({'max-width' : _vm.ancho, 'margin-top': _vm.arriba})},[_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_superior_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8afaed4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_superior_vue__ = __webpack_require__(812);
function injectStyle (ssrContext) {
  __webpack_require__(811)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8afaed4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_superior_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8afaed4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_superior_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('ul',_vm._l((_vm.menu),function(item){return _c('li',{key:item.url,class:(_vm.$route.path === item.url || item.activo) ? 'active' : '',on:{"click":function($event){return _vm.irSeccion(item)}}},[_c('span',{class:item.icono}),_c('div',{staticClass:"titulo"},[_vm._v(_vm._s(item.nombre))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bubble__ = __webpack_require__(814);

/* harmony default export */ __webpack_exports__["a"] = (function (Vue, options) {
	Vue.component('chartjs-bubble', __WEBPACK_IMPORTED_MODULE_0__bubble__["a" /* default */]);
});

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bubble_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bubble_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 272,
	"./af.js": 272,
	"./ar": 273,
	"./ar-dz": 274,
	"./ar-dz.js": 274,
	"./ar-kw": 275,
	"./ar-kw.js": 275,
	"./ar-ly": 276,
	"./ar-ly.js": 276,
	"./ar-ma": 277,
	"./ar-ma.js": 277,
	"./ar-sa": 278,
	"./ar-sa.js": 278,
	"./ar-tn": 279,
	"./ar-tn.js": 279,
	"./ar.js": 273,
	"./az": 280,
	"./az.js": 280,
	"./be": 281,
	"./be.js": 281,
	"./bg": 282,
	"./bg.js": 282,
	"./bn": 283,
	"./bn.js": 283,
	"./bo": 284,
	"./bo.js": 284,
	"./br": 285,
	"./br.js": 285,
	"./bs": 286,
	"./bs.js": 286,
	"./ca": 287,
	"./ca.js": 287,
	"./cs": 288,
	"./cs.js": 288,
	"./cv": 289,
	"./cv.js": 289,
	"./cy": 290,
	"./cy.js": 290,
	"./da": 291,
	"./da.js": 291,
	"./de": 292,
	"./de-at": 293,
	"./de-at.js": 293,
	"./de-ch": 294,
	"./de-ch.js": 294,
	"./de.js": 292,
	"./dv": 295,
	"./dv.js": 295,
	"./el": 296,
	"./el.js": 296,
	"./en-au": 297,
	"./en-au.js": 297,
	"./en-ca": 298,
	"./en-ca.js": 298,
	"./en-gb": 299,
	"./en-gb.js": 299,
	"./en-ie": 300,
	"./en-ie.js": 300,
	"./en-nz": 301,
	"./en-nz.js": 301,
	"./eo": 302,
	"./eo.js": 302,
	"./es": 303,
	"./es-do": 304,
	"./es-do.js": 304,
	"./es.js": 303,
	"./et": 305,
	"./et.js": 305,
	"./eu": 306,
	"./eu.js": 306,
	"./fa": 307,
	"./fa.js": 307,
	"./fi": 308,
	"./fi.js": 308,
	"./fo": 309,
	"./fo.js": 309,
	"./fr": 310,
	"./fr-ca": 311,
	"./fr-ca.js": 311,
	"./fr-ch": 312,
	"./fr-ch.js": 312,
	"./fr.js": 310,
	"./fy": 313,
	"./fy.js": 313,
	"./gd": 314,
	"./gd.js": 314,
	"./gl": 315,
	"./gl.js": 315,
	"./gom-latn": 316,
	"./gom-latn.js": 316,
	"./he": 317,
	"./he.js": 317,
	"./hi": 318,
	"./hi.js": 318,
	"./hr": 319,
	"./hr.js": 319,
	"./hu": 320,
	"./hu.js": 320,
	"./hy-am": 321,
	"./hy-am.js": 321,
	"./id": 322,
	"./id.js": 322,
	"./is": 323,
	"./is.js": 323,
	"./it": 324,
	"./it.js": 324,
	"./ja": 325,
	"./ja.js": 325,
	"./jv": 326,
	"./jv.js": 326,
	"./ka": 327,
	"./ka.js": 327,
	"./kk": 328,
	"./kk.js": 328,
	"./km": 329,
	"./km.js": 329,
	"./kn": 330,
	"./kn.js": 330,
	"./ko": 331,
	"./ko.js": 331,
	"./ky": 332,
	"./ky.js": 332,
	"./lb": 333,
	"./lb.js": 333,
	"./lo": 334,
	"./lo.js": 334,
	"./lt": 335,
	"./lt.js": 335,
	"./lv": 336,
	"./lv.js": 336,
	"./me": 337,
	"./me.js": 337,
	"./mi": 338,
	"./mi.js": 338,
	"./mk": 339,
	"./mk.js": 339,
	"./ml": 340,
	"./ml.js": 340,
	"./mr": 341,
	"./mr.js": 341,
	"./ms": 342,
	"./ms-my": 343,
	"./ms-my.js": 343,
	"./ms.js": 342,
	"./my": 344,
	"./my.js": 344,
	"./nb": 345,
	"./nb.js": 345,
	"./ne": 346,
	"./ne.js": 346,
	"./nl": 347,
	"./nl-be": 348,
	"./nl-be.js": 348,
	"./nl.js": 347,
	"./nn": 349,
	"./nn.js": 349,
	"./pa-in": 350,
	"./pa-in.js": 350,
	"./pl": 351,
	"./pl.js": 351,
	"./pt": 352,
	"./pt-br": 353,
	"./pt-br.js": 353,
	"./pt.js": 352,
	"./ro": 354,
	"./ro.js": 354,
	"./ru": 355,
	"./ru.js": 355,
	"./sd": 356,
	"./sd.js": 356,
	"./se": 357,
	"./se.js": 357,
	"./si": 358,
	"./si.js": 358,
	"./sk": 359,
	"./sk.js": 359,
	"./sl": 360,
	"./sl.js": 360,
	"./sq": 361,
	"./sq.js": 361,
	"./sr": 362,
	"./sr-cyrl": 363,
	"./sr-cyrl.js": 363,
	"./sr.js": 362,
	"./ss": 364,
	"./ss.js": 364,
	"./sv": 365,
	"./sv.js": 365,
	"./sw": 366,
	"./sw.js": 366,
	"./ta": 367,
	"./ta.js": 367,
	"./te": 368,
	"./te.js": 368,
	"./tet": 369,
	"./tet.js": 369,
	"./th": 370,
	"./th.js": 370,
	"./tl-ph": 371,
	"./tl-ph.js": 371,
	"./tlh": 372,
	"./tlh.js": 372,
	"./tr": 373,
	"./tr.js": 373,
	"./tzl": 374,
	"./tzl.js": 374,
	"./tzm": 375,
	"./tzm-latn": 376,
	"./tzm-latn.js": 376,
	"./tzm.js": 375,
	"./uk": 377,
	"./uk.js": 377,
	"./ur": 378,
	"./ur.js": 378,
	"./uz": 379,
	"./uz-latn": 380,
	"./uz-latn.js": 380,
	"./uz.js": 379,
	"./vi": 381,
	"./vi.js": 381,
	"./x-pseudo": 382,
	"./x-pseudo.js": 382,
	"./yo": 383,
	"./yo.js": 383,
	"./zh-cn": 384,
	"./zh-cn.js": 384,
	"./zh-hk": 385,
	"./zh-hk.js": 385,
	"./zh-tw": 386,
	"./zh-tw.js": 386
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 847;

/***/ }),
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c374969_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(879);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c374969_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"mt-5 text-danger",staticStyle:{"font-size":"10em","font-weight":"bolder"}},[_vm._v("\n\t\t404\n\t")]),_vm._v(" "),_c('h3',{staticClass:"text-danger"},[_vm._v("\n\t\tLa página que buscas no se encuentra\n\t")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abc36dee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_avatar_vue__ = __webpack_require__(881);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abc36dee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ruta)?_c('img',{staticClass:"rounded-circle",style:(_vm.estilo),attrs:{"src":_vm.ruta}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imprimir_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb717392_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_imprimir_vue__ = __webpack_require__(884);
function injectStyle (ssrContext) {
  __webpack_require__(883)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eb717392"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imprimir_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb717392_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_imprimir_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":300}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info"},[_c('span',{staticClass:"fa fa-print mr-2"}),_vm._v("Menú de impresión"),_c('button',{staticClass:"close",on:{"click":function($event){return _vm.cerrar()}}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Impresora")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.impresion.ImpresoraID),expression:"impresion.ImpresoraID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.impresion, "ImpresoraID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.impresoras),function(impresora,i){return _c('option',{key:i+1,domProps:{"value":i+1}},[_vm._v(_vm._s(impresora))])}),0)])]),_c('hr'),_c('b',[_vm._v("Opciones")]),_c('div',{staticClass:"opciones"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.impresion.Color),expression:"impresion.Color"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.impresion.Color)?_vm._i(_vm.impresion.Color,null)>-1:(_vm.impresion.Color)},on:{"change":function($event){var $$a=_vm.impresion.Color,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.impresion, "Color", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.impresion, "Color", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.impresion, "Color", $$c)}}}}),_vm._v("Color")]),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.impresion.DobleCara),expression:"impresion.DobleCara"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.impresion.DobleCara)?_vm._i(_vm.impresion.DobleCara,null)>-1:(_vm.impresion.DobleCara)},on:{"change":function($event){var $$a=_vm.impresion.DobleCara,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.impresion, "DobleCara", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.impresion, "DobleCara", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.impresion, "DobleCara", $$c)}}}}),_vm._v("Doble cara")]),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.impresion.Collate),expression:"impresion.Collate"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.impresion.Collate)?_vm._i(_vm.impresion.Collate,null)>-1:(_vm.impresion.Collate)},on:{"change":function($event){var $$a=_vm.impresion.Collate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.impresion, "Collate", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.impresion, "Collate", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.impresion, "Collate", $$c)}}}}),_vm._v("Agrupar")]),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.impresion.Landscape),expression:"impresion.Landscape"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.impresion.Landscape)?_vm._i(_vm.impresion.Landscape,null)>-1:(_vm.impresion.Landscape)},on:{"change":function($event){var $$a=_vm.impresion.Landscape,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.impresion, "Landscape", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.impresion, "Landscape", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.impresion, "Landscape", $$c)}}}}),_vm._v("Horizontal")])]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Nº copias")])]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.impresion.Copias),expression:"impresion.Copias",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"placeholder":"1"},domProps:{"value":(_vm.impresion.Copias)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.impresion, "Copias", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"disabled":!_vm.impresion.ImpresoraID},on:{"click":_vm.imprimir}},[_c('span',{staticClass:"fa fa-print mr-2"}),_vm._v("Imprimir")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		Vue.filter('tamano', function (tamano) {
			if (!tamano) {
				return '0 kB';
			}

			var bytes = tamano;
			var si = true;
			var thresh = si ? 1000 : 1024;
			if (Math.abs(bytes) < thresh) {
				return bytes + ' B';
			}
			var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
			var u = -1;
			do {
				bytes /= thresh;
				++u;
			} while (Math.abs(bytes) >= thresh && u < units.length - 1);
			return bytes.toFixed(1) + ' ' + units[u];
		});
	}
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		Vue.filter('round', function (numero, decimales) {
			decimales = typeof decimales !== 'number' ? 2 : decimales;
			var absoluto = Math.round(numero * Math.pow(10, decimales));
			return absoluto / Math.pow(10, decimales);
		});
	}
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		// Filtro para pasar de segundos a horas
		Vue.filter('hora', function (segundosEntrada) {
			// Obtenemos el valor absoluto
			var sec = Math.abs(segundosEntrada);
			var horas = void 0,
			    minutos = void 0,
			    segundos = void 0;
			horas = Math.floor(sec / 3600);
			minutos = Math.floor(sec % 3600 / 60);
			segundos = Math.floor(sec % 60);

			horas = horas < 10 ? '0' + horas.toString() : horas.toString();
			minutos = minutos < 10 ? '0' + minutos.toString() : minutos.toString();
			segundos = segundos < 10 ? '0' + segundos.toString() : segundos.toString();

			var signo = segundosEntrada < 0 ? '-' : '';
			return signo + '' + horas + ':' + minutos + ':' + segundos;
		});

		/**
   * Devuelve la fecha en formato AAAA-MM-DD a partir de los segundos
   */
		Vue.filter('fecha', function (segundos) {
			var fecha = new Date(segundos * 1000);
			var ano = fecha.getUTCFullYear().toString();
			var mes = fecha.getUTCMonth() + 1;
			var dia = fecha.getUTCDate();
			mes = mes - 10 ? '0' + mes.toString() : mes.toString();
			dia = dia - 10 ? '0' + dia.toString() : dia.toString();
			return ano + '-' + mes + '-' + dia;
		});

		/**
   * Transforma una fecha en formato AAAA-MM-DD o una hora en formato HH:MM:SS
   * a segundos
   */
		Vue.filter('segundos', function (cadena) {
			var expHora = /^-?\d{2}:\d{2}(:\d{2})?$/;
			var expFecha = /^\d{4}-\d{2}-\d{2}$/;

			if (expHora.test(cadena)) {
				// Es una hora
				var positivo = 1;
				if (cadena[0] === '-') {
					positivo = -1;
					cadena.splice(0, 1);
				}
				var arr = cadena.split(':');
				var sec = arr.length === 3 ? parseInt(arr[2], 10) : 0;
				var segundos = parseInt(arr[0], 10) * 3600 + parseInt(arr[1], 10) * 60 + sec;
				return segundos * positivo;
			} else if (expFecha.test(cadena)) {
				// Es una fecha
				var _arr = cadena.split('-');
				var ano = parseInt(_arr[0], 10);
				var mes = parseInt(_arr[1], 10) - 1;
				var dia = parseInt(_arr[2], 10);
				var fecha = new Date(ano, mes, dia, 0, 0, 0, 0);
				return Math.floor(fecha.getTime() / 1000);
			} else {
				return null;
			}
		});
	}
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _this = this;


/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		Vue.prototype.download = function (url, postData, nombreFichero, callback) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default()({
				url: url,
				method: 'POST',
				data: postData,
				responseType: 'blob',
				headers: {
					'Content-type': 'application/json',
					'Accept': 'application/x-binary'
				}
			}).then(function (res) {
				var a = document.createElement('a');
				var extension = /\./.test(nombreFichero) ? nombreFichero.split('.').splice(-1, 1)[0] : 'pdf';
				var file = void 0;
				if (!extension) {
					file = new Blob([res.data], { type: 'application/pdf' });
				} else {
					file = new Blob([res.data], { type: 'application/octet-stream' });
				}
				var url = URL.createObjectURL(file);
				a.name = nombreFichero;
				a.href = url;
				a.download = nombreFichero;
				document.body.appendChild(a);
				a.click();
				window.setTimeout(function () {
					document.body.removeChild(a);
					if (callback) {
						try {
							callback();
						} catch (e) {
							console.error(e);
						}
					}
				}, 3000);
			}).catch(function (e) {
				_this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		};
	}
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		if ('serviceWorker' in navigator) {
			window.addEventListener('load', function () {
				navigator.serviceWorker.register('/src/modulos/core/static/notificaciones.js').then(function (reg) {
					console.log('Se ha registrado el servicio correctamente');
					reg.update();
				}, function (err) {
					console.log(err);
					console.error('Error registrando el componente');
				});
			});
		}
	}
});

/***/ }),
/* 890 */,
/* 891 */,
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_modulos_agenda_comercial_vue_index_js__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_modulos_auditor_vue_index_js__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_modulos_consultas_facturacion_vue_index_js__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_modulos_control_emisoras_vue_index_js__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_modulos_core_vue_index_js__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_modulos_descargar_copion_vue_index_js__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_modulos_descargar_xframe_vue_index_js__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_modulos_escaletas_vue_index_js__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_modulos_eventos_vue_index_js__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_modulos_facturacion_cobros_vue_index_js__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_modulos_galerias_vue_index_js__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_modulos_gestion_anunciantes_vue_index_js__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_modulos_gestion_clientes_vue_index_js__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_modulos_gestion_cuentas_email_vue_index_js__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_modulos_gestion_egm_vue_index_js__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_modulos_gestion_emisoras_vue_index_js__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_modulos_gestion_grupos_vue_index_js__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_modulos_gestion_horaria_vue_index_js__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_modulos_gestion_jornada_vue_index_js__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_modulos_gestion_permisos_vue_index_js__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_modulos_gestion_tarifas_vue_index_js__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__src_modulos_gestion_usuarios_vue_index_js__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__src_modulos_invitaciones_vue_index_js__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_modulos_libreta_direcciones_vue_index_js__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__src_modulos_mis_contratos_vue_index_js__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__src_modulos_muro_vue_index_js__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__src_modulos_objetivos_agentes_vue_index_js__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__src_modulos_organizar_emisoras_vue_index_js__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__src_modulos_produccion_vue_index_js__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__src_modulos_produccion_audiovisual_vue_index_js__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__src_modulos_radiacion_vue_index_js__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__src_modulos_redaccion_vue_index_js__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_modulos_solicitudes_vue_index_js__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__src_modulos_subir_cunas_vue_index_js__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__src_modulos_subir_xframe_vue_index_js__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__src_modulos_webmail_vue_index_js__ = __webpack_require__(1588);





































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1__src_modulos_agenda_comercial_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__src_modulos_auditor_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__src_modulos_consultas_facturacion_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__src_modulos_control_emisoras_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__src_modulos_core_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__src_modulos_descargar_copion_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__src_modulos_descargar_xframe_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__src_modulos_escaletas_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__src_modulos_eventos_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__src_modulos_facturacion_cobros_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__src_modulos_galerias_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__src_modulos_gestion_anunciantes_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__src_modulos_gestion_clientes_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14__src_modulos_gestion_cuentas_email_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15__src_modulos_gestion_egm_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16__src_modulos_gestion_emisoras_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17__src_modulos_gestion_grupos_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18__src_modulos_gestion_horaria_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19__src_modulos_gestion_jornada_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20__src_modulos_gestion_permisos_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21__src_modulos_gestion_tarifas_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22__src_modulos_gestion_usuarios_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23__src_modulos_invitaciones_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24__src_modulos_libreta_direcciones_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25__src_modulos_mis_contratos_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26__src_modulos_muro_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27__src_modulos_objetivos_agentes_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28__src_modulos_organizar_emisoras_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29__src_modulos_produccion_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30__src_modulos_produccion_audiovisual_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_31__src_modulos_radiacion_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32__src_modulos_redaccion_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_33__src_modulos_solicitudes_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_34__src_modulos_subir_cunas_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_35__src_modulos_subir_xframe_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_36__src_modulos_webmail_vue_index_js__["a" /* default */])
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.SIP_VERSION = '1.13.1'

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_vue__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__componentes_listados_listados__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__componentes_calendario_calendario__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__componentes_propuestas_listado_propuestas__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__componentes_estadisticas_estadisticas__ = __webpack_require__(920);








/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('agenda-comercial', {
			name: 'Agenda comercial',
			component: __WEBPACK_IMPORTED_MODULE_1__app_vue__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('agenda-comercial').child('listados', {
			name: 'Listados',
			component: __WEBPACK_IMPORTED_MODULE_2__componentes_listados_listados__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('agenda-comercial').child('listados/:id', {
			name: 'Detalle de entrada',
			component: __WEBPACK_IMPORTED_MODULE_2__componentes_listados_listados__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('agenda-comercial').child('calendario', {
			name: 'Calendario',
			component: __WEBPACK_IMPORTED_MODULE_3__componentes_calendario_calendario__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('agenda-comercial').child('propuestas', {
			name: 'Propuestas',
			component: __WEBPACK_IMPORTED_MODULE_4__componentes_propuestas_listado_propuestas__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('agenda-comercial').child('estadisticas', {
			name: 'Estadísticas',
			component: __WEBPACK_IMPORTED_MODULE_5__componentes_estadisticas_estadisticas__["a" /* default */]
		});
	}
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f23727a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(898);
function injectStyle (ssrContext) {
  __webpack_require__(897)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f23727a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f23727a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"menuAgenda bg-dark text-white"},[_c('ul',[_c('li',{class:(_vm.seccion === 'listados') ? 'active' : '',on:{"click":function($event){return _vm.go('listados')}}},[_c('span',{staticClass:"fa fa-list mb-1",staticStyle:{"font-size":"1.5em"}}),_c('br'),_vm._v("Agenda")]),_c('li',{class:(_vm.seccion === 'calendario') ? 'active' : '',on:{"click":function($event){return _vm.go('calendario')}}},[_c('span',{staticClass:"fa fa-calendar mb-1",staticStyle:{"font-size":"1.5em"}}),_c('br'),_vm._v("Calendario")]),_c('li',{class:(_vm.seccion === 'propuestas') ? 'active' : '',on:{"click":function($event){return _vm.go('propuestas')}}},[_c('span',{staticClass:"fa fa-money mb-1",staticStyle:{"font-size":"1.5em"}}),_c('br'),_vm._v("Propuestas")]),_c('li',{class:(_vm.seccion === 'estadisticas') ? 'active' : '',on:{"click":function($event){return _vm.go('estadisticas')}}},[_c('span',{staticClass:"fa fa-bar-chart mb-1",staticStyle:{"font-size":"1.5em"}}),_c('br'),_vm._v("Estadísticas")])])]),_c('router-view',{staticStyle:{"margin-top":"60px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listados_vue__ = __webpack_require__(394);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a169f8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listados_vue__ = __webpack_require__(906);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a169f8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 900 */,
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_vm._v("Propuestas comerciales"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('h4',[_c('span',{staticClass:"fa fa-info mr-2"}),_vm._v("Información de la propuesta")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),(!_vm.propuesta.usuario_ID)?_c('input-query',{attrs:{"realtime":true,"url":"/agenda-comercial/php/api/busca-agentes.php","input-class":"form-control form-control-sm"},on:{"selected":function($event){return _vm.ponAgente($event)}}}):_vm._e(),(_vm.propuesta.usuario_ID)?_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.propuesta.usuarioInfo}}),(_vm.editable && _vm.permisos.agenda_comercial_crear_todos)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.quitarAgente}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()]):_vm._e()],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Empresa")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.propuesta.empresa_ID),expression:"propuesta.empresa_ID"}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.editable},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.propuesta, "empresa_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoEmpresas),function(empresa){return _c('option',{key:empresa.ID_empresa,domProps:{"value":empresa.ID_empresa}},[_vm._v(_vm._s(empresa.nombreFiscal))])})],2)])])]),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cliente")]),(!_vm.propuesta.cliente_ID)?_c('input-query',{attrs:{"disabled":!_vm.propuesta.usuario_ID,"realtime":true,"url":'/agenda-comercial/php/api/busca-clientes.php?agente=' + _vm.propuesta.usuario_ID,"input-class":"form-control form-control-sm"},on:{"selected":function($event){return _vm.ponCliente($event)}}}):_vm._e(),(_vm.propuesta.cliente_ID)?_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.propuesta.clienteInfo}}),(!_vm.idCliente && _vm.editable)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.quitarCliente}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()]):_vm._e()],1)])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Título")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propuesta.titulo),expression:"propuesta.titulo"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable},domProps:{"value":(_vm.propuesta.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propuesta, "titulo", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descripción")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.propuesta.descripcion),expression:"propuesta.descripcion"}],staticClass:"form-control",attrs:{"rows":"4","disabled":!_vm.editable},domProps:{"value":(_vm.propuesta.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propuesta, "descripcion", $event.target.value)}}})])]),_c('div',{staticClass:"card-body bg-light"},[_c('h4',[_c('span',{staticClass:"fa fa-money mr-2"}),_vm._v("Productos"),(_vm.editable)?_c('button',{staticClass:"btn btn-sm btn-primary pull-right",on:{"click":_vm.nuevaLinea}},[_c('span',{staticClass:"fa fa-plus"})]):_vm._e()]),_c('div',{staticClass:"lineasContainer"},[(_vm.propuesta.lineas.length > 0)?_c('div',{staticClass:"linea"},[_c('div',{staticClass:"descripcion"},[_vm._v("Descripción / Producto")]),_c('div',[_vm._v("Cantidad")]),_c('div',[_vm._v("Descuento")]),_c('div',[_vm._v("P. unitario")]),_c('div',[_vm._v("Bruto")]),_c('div',[_vm._v("Forzado")]),_c('div',[_vm._v("Total")]),(_vm.editable)?_c('div',{staticStyle:{"max-width":"30px","min-width":"20px"}}):_vm._e()]):_vm._e(),_vm._l((_vm.propuesta.lineas),function(linea,index){return _c('div',{key:linea.ID_linea,staticClass:"linea"},[_c('div',{staticClass:"descripcion"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn btn-sm",class:(linea.tipo === 'tarifa') ? 'btn-primary' : '',attrs:{"disabled":!_vm.editable,"title":"Tarifa"},on:{"click":function($event){return _vm.setTipo(_vm.propuesta.lineas[index], 'tarifa')}}},[_c('span',{staticClass:"fa fa-list"})]),_c('button',{staticClass:"btn btn-sm",class:(linea.tipo === 'concepto') ? 'btn-primary' : '',attrs:{"disabled":!_vm.editable,"title":"Concepto"},on:{"click":function($event){return _vm.setTipo(_vm.propuesta.lineas[index], 'concepto')}}},[_c('span',{staticClass:"fa fa-edit"})])]),(linea.tipo === 'concepto')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(linea.concepto),expression:"linea.concepto"}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.editable,"placeholder":"Escribe un concepto"},domProps:{"value":(linea.concepto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(linea, "concepto", $event.target.value)}}}):_vm._e(),(linea.tipo === 'tarifa' && linea.tarifa_ID === null)?_c('input-query',{attrs:{"placeholder":"Busca la tarifa","realtime":true,"url":"/agenda-comercial/php/api/busca-productos.php","input-class":"form-control form-control-sm"},on:{"selected":function($event){return _vm.seleccionaTarifa(_vm.propuesta.lineas[index], $event)}}}):_vm._e(),(linea.tarifa_ID !== null)?_c('input',{staticClass:"form-control form-control-sm",attrs:{"placeholder":"Concepto","disabled":"true"},domProps:{"value":linea.concepto}}):_vm._e(),(linea.tarifa_ID && _vm.editable)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.quitarTarifa(_vm.propuesta.lineas[index])}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()],1)]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.propuesta.lineas[index].cantidad),expression:"propuesta.lineas[index].cantidad",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.editable || !linea.concepto,"type":"number","placeholder":"0"},domProps:{"value":(_vm.propuesta.lineas[index].cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propuesta.lineas[index], "cantidad", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.propuesta.lineas[index].descuento),expression:"propuesta.lineas[index].descuento",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":(linea.forzado > 0 || linea.forzado < 0 || !_vm.editable || !linea.concepto),"type":"number","placeholder":"0"},domProps:{"value":(_vm.propuesta.lineas[index].descuento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propuesta.lineas[index], "descuento", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.propuesta.lineas[index].precio_unitario),expression:"propuesta.lineas[index].precio_unitario",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"type":"number","placeholder":"0","disabled":linea.tipo === 'tarifa' || !_vm.editable || !linea.concepto},domProps:{"value":(_vm.propuesta.lineas[index].precio_unitario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propuesta.lineas[index], "precio_unitario", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.propuesta.lineas[index].precio_unitario * _vm.propuesta.lineas[index].cantidad),expression:"propuesta.lineas[index].precio_unitario * propuesta.lineas[index].cantidad",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":true,"type":"number","placeholder":"0"},domProps:{"value":(_vm.propuesta.lineas[index].precio_unitario * _vm.propuesta.lineas[index].cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propuesta.lineas[index].precio_unitario * _vm.propuesta.lineas[index], "cantidad", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.propuesta.lineas[index].forzado),expression:"propuesta.lineas[index].forzado",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.editable || !linea.concepto,"type":"number","placeholder":"0"},domProps:{"value":(_vm.propuesta.lineas[index].forzado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propuesta.lineas[index], "forzado", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('div',[_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"true"},domProps:{"value":_vm.getTotal(_vm.propuesta.lineas[index])}})]),(_vm.editable)?_c('div',{staticStyle:{"max-width":"30px","min-width":"20px","text-align":"right"}},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitarLinea(linea.ID_linea)}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()])})],2)]),(_vm.propuesta.lineas.length > 0)?_c('div',{staticClass:"card-body"},[_c('h4',[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Modificaciónes finales (opcionales)")]),_c('div',{staticClass:"alert alert-info"},[_vm._v("Rellena estos cambos "),_c('b',[_vm._v("solamente")]),_vm._v(" si quieres alterar el precio final. Si se va a quedar como está no los modifiques.")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Descuento global")])]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.propuesta.descuento),expression:"propuesta.descuento",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":(_vm.propuesta.forzado > 0 || _vm.propuesta.forzado < 0 || !_vm.editable)},domProps:{"value":(_vm.propuesta.descuento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propuesta, "descuento", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("%")])])])])])]):_vm._e(),_c('div',{staticClass:"card-body text-right"},[_c('h3',{staticClass:"text-danger"},[_vm._v("Total propuesta: "+_vm._s(_vm._f("currency")(_vm.totalPropuesta,'€')))])]),_c('div',{staticClass:"card-footer"},[(_vm.editable && _vm.formValido)?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")]):_vm._e(),(_vm.propuesta.ID_propuesta)?_c('button',{staticClass:"btn btn-warning ml-2",on:{"click":_vm.descargar}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("Descargar")]):_vm._e(),_c('a',{ref:"linkDescarga",staticClass:"btn btn-warning",staticStyle:{"display":"none"},attrs:{"download":"Propuesta.pdf","href":'/src/modulos/agenda-comercial/php/api/get-propuesta-pdf.php?ID_propuesta=' + _vm.propuesta.ID_propuesta}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("Descargar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancelar_vue__ = __webpack_require__(399);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7d481e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_cancelar_vue__ = __webpack_require__(904);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancelar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a7d481e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_cancelar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":"400"}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_c('span',{staticClass:"fa fa-ban mr-2"}),_vm._v("Cita cancelada"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('h5',[_vm._v("Datos de la cancelación")]),_c('hr'),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("¿Quien ha cancelado la cita?")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.form.quien_cancela === 'cliente') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setQuien('cliente')}}},[_vm._v("Cliente")]),_c('button',{staticClass:"btn",class:(_vm.form.quien_cancela === 'agente') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setQuien('agente')}}},[_vm._v("Agente")])])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Motivos de la cancelación")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.motivos_cancelacion),expression:"form.motivos_cancelacion"}],staticClass:"form-control",attrs:{"placeholder":"Por favor especifica los motivos por los que se ha cancelado la cita","rows":"4"},domProps:{"value":(_vm.form.motivos_cancelacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "motivos_cancelacion", $event.target.value)}}})])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.cancelar}},[_c('span',{staticClass:"fa fa-ban mr-2"}),_vm._v("Registrar cancelación")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.registro)?_c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header",class:(_vm.registro.cancelada) ? 'bg-danger text-white' : ''},[(!_vm.registro.cancelada)?_c('span',[_c('i',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editor")]):_c('span',[_c('i',{staticClass:"fa fa-exclamation mr-2"}),_vm._v("Esta cita fue cancelada")]),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('h4',[_c('i',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Datos básicos"),(_vm.registro.fecha_registro)?_c('small',{staticClass:"ml-3"},[_vm._v("(Fecha de registro: "+_vm._s(_vm._f("moment")(_vm.registro.fecha_registro,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.registro.fecha_registro,'HH:mm:ss'))+")")]):_vm._e()]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.registro.gestion === 0) ? 'btn-primary' : '',on:{"click":function($event){_vm.registro.gestion = 0}}},[_vm._v("Contacto cliente")]),_c('button',{staticClass:"btn",class:(_vm.registro.gestion === 1) ? 'btn-primary' : '',on:{"click":function($event){_vm.registro.gestion = 1}}},[_vm._v("Gestión interna")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-user"})])]),(!_vm.registro.usuario_ID)?_c('input-query',{attrs:{"url":"/agenda-comercial/php/api/busca-agentes.php","realtime":true,"placeholder":"Selecciona agente","input-class":"form-control form-control-sm"},on:{"selected":function($event){return _vm.seleccionaAgente($event)}}}):_vm._e(),(_vm.registro.usuario_ID)?_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.registro.usuarioNombre}}):_vm._e(),(_vm.registro.usuario_ID && _vm.editable)?_c('div',{staticClass:"input-group-append"},[(_vm.permisos.agenda_comercial_crear_todos)?_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":_vm.quitarAgente}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()]):_vm._e()],1)])]),(!_vm.registro.gestion)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cliente")]),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('i',{staticClass:"fa fa-building"})])]),(!_vm.registro.cliente_ID)?_c('input-query',{ref:"inpCliente",attrs:{"disabled":!_vm.registro.usuario_ID,"url":'/agenda-comercial/php/api/busca-clientes.php?agente=' + _vm.registro.usuario_ID,"realtime":true,"placeholder":"Selecciona cliente","input-class":"form-control form-control-sm"},on:{"selected":function($event){return _vm.seleccionaCliente($event)}}}):_vm._e(),(_vm.registro.cliente_ID)?_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.registro.clienteNombre}}):_vm._e(),(_vm.registro.cliente_ID && _vm.editable)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":_vm.quitarCliente}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()],1)])]):_vm._e()]),(_vm.registro.usuario_ID && (_vm.registro.cliente_ID || _vm.registro.gestion === 1))?_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xl-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Día")]),(_vm.editable)?_c('datepicker',{attrs:{"language":_vm.$dateLang,"monday-first":true,"bootstrap-styling":true,"input-class":"form-control form-control-sm","placeholder":"Fecha"},model:{value:(_vm.registro.fechaContacto),callback:function ($$v) {_vm.$set(_vm.registro, "fechaContacto", $$v)},expression:"registro.fechaContacto"}}):_vm._e(),(!_vm.editable)?_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.$moment(_vm.registro.fechaContacto).format('D MMM YYYY')}}):_vm._e()],1)]),_c('div',{staticClass:"col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hora de inicio")]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.registro.horaIni),expression:"registro.horaIni"}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.editable},domProps:{"value":(_vm.registro.horaIni)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "horaIni", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hora de fin")]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.registro.horaFin),expression:"registro.horaFin"}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.editable},domProps:{"value":(_vm.registro.horaFin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "horaFin", $event.target.value)}}})])])])]),(_vm.registro.gestion === 0)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-xl-6 col-xl-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de contacto")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.tipo_contacto_ID),expression:"registro.tipo_contacto_ID"}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.editable},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.registro, "tipo_contacto_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoTipos),function(tipo){return _c('option',{key:tipo.ID_tipo,domProps:{"value":tipo.ID_tipo}},[_vm._v(_vm._s(tipo.nombre))])})],2)])]),_c('div',{staticClass:"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Objetivo del contacto")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.objetivo_contacto_ID),expression:"registro.objetivo_contacto_ID"}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.editable},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.registro, "objetivo_contacto_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoObjetivos),function(objetivo){return _c('option',{key:objetivo.ID_objetivo,domProps:{"value":objetivo.ID_objetivo}},[_vm._v(_vm._s(objetivo.nombre))])})],2)])])])]):_vm._e()]):_vm._e()]),(_vm.registro.ID_entrada && _vm.registro.gestion === 0)?_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h4',[_c('i',{staticClass:"fa fa-money mr-2"}),_vm._v("Propuestas")])]),(!_vm.registro.fecha_cierre_informe)?_c('div',{staticClass:"col text-right"},[_c('div',{staticClass:"input-group input-group-sm text-left"},[_c('input-query',{attrs:{"placeholder":"Busca una propuesta para asignar o copiar","inputClass":"form-control form-control-sm","url":'/agenda-comercial/php/api/query-propuestas.php?ID_cliente=' + _vm.registro.cliente_ID,"realtime":true},on:{"selected":function($event){return _vm.asignaPropuesta($event.datos)}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary btn-sm pull-right",on:{"click":function($event){_vm.verEditorPropuestas = true}}},[_vm._v("Nueva")])])],1)]):_vm._e()])]):_vm._e(),(_vm.registro.ID_entrada && _vm.registro.propuestas.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped"},[_c('thead',{staticClass:"bg-warning"},[_c('tr',[_c('th',[_vm._v("Título propuesta")]),_c('th',[_vm._v("Importe")]),_c('th',[_vm._v("¿Presentada?")]),_c('th',[_vm._v("Estado")]),_c('th')])]),_c('tbody',_vm._l((_vm.registro.propuestas),function(p){return _c('tr',{key:p.ID_propuesta},[_c('td',[_c('span',{staticClass:"fa fa-caret-right mr-2"}),_vm._v(_vm._s(p.titulo))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(p.importe,'€')))]),_c('td',[(p.fecha_presentada)?_c('span',[_vm._v("Presentada"),(p.entrada_ID_presentada === _vm.registro.ID_entrada)?_c('div',{staticStyle:{"opacity":"0.7"}},[_vm._v("hoy")]):_c('div',{staticStyle:{"opacity":"0.7"}},[_vm._v(_vm._s(_vm._f("moment")(p.fecha_presentada,'DD-MM-YYYY')))])]):(!_vm.registro.fecha_cierre_informe && new Date().getTime() / 1000 > _vm.registro.fecha_fin_contacto)?_c('span',[_c('button',{staticClass:"btn btn-warning btn-sm",on:{"click":function($event){return _vm.setPresentada(p.ID_propuesta)}}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("La he presentado")])]):_c('span',[_vm._v("No presentada")])]),_c('td',[(p.decision === 'aprobada')?_c('span',[_vm._v("Aprobada"),_c('br'),_c('span',{staticStyle:{"opacity":"0.7"}},[_vm._v(_vm._s(_vm._f("moment")(p.fecha_decision,'DD-MM-YYYY')))])]):(p.decision === 'rechazada')?_c('span',[_vm._v("Rechazada"),_c('br'),_c('span',{staticStyle:{"opacity":"0.7"}},[_vm._v(_vm._s(_vm._f("moment")(p.fecha_decision,'DD-MM-YYYY')))])]):(!p.decision && p.fecha_presentada && !_vm.registro.fecha_cierre_informe)?_c('span',[_c('button',{staticClass:"btn btn-sm btn-primary m-1",on:{"click":function($event){return _vm.setDecision(p.ID_propuesta, 'aprobada')}}},[_vm._v("Aprobar")]),_c('button',{staticClass:"btn btn-sm btn-danger m-1",on:{"click":function($event){return _vm.setDecision(p.ID_propuesta, 'rechazada')}}},[_vm._v("Rechazar")])]):_c('span',[_vm._v("Pendiente")])]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.detallePropuesta = p.ID_propuesta}}},[_c('span',{staticClass:"fa fa-eye"})]),(!p.fecha_presentada && !_vm.registro.fecha_cierre_informe)?_c('button',{staticClass:"btn btn-sm btn-danger m-1",on:{"click":function($event){return _vm.desasignaPropuesta(p.ID_propuesta)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()])])}),0)])]):_vm._e(),(_vm.registro.usuario_ID && (_vm.registro.cliente_ID || _vm.registro.gestion === 1))?_c('div',{staticClass:"card-body"},[_c('h4',[_c('i',{staticClass:"fa fa-comments mr-2"}),_vm._v("Comentarios"),(_vm.registro.gestion === 0)?_c('span',[_vm._v("previos")]):_vm._e()]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.comentarios_previos),expression:"registro.comentarios_previos"}],staticClass:"form-control form-control-sm",attrs:{"rows":"6","disabled":!_vm.editable},domProps:{"value":(_vm.registro.comentarios_previos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "comentarios_previos", $event.target.value)}}}),_c('div',{staticClass:"mt-4"},[_c('h4',[_c('i',{staticClass:"fa fa-comments mr-2"}),_vm._v("Comentarios finales")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.comentarios_finales),expression:"registro.comentarios_finales"}],staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.registro.fecha_cierre_informe,"rows":"6"},domProps:{"value":(_vm.registro.comentarios_finales)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "comentarios_finales", $event.target.value)}}})])]):_vm._e(),_c('div',{staticClass:"card-footer"},[(_vm.formValido && _vm.editable)?_c('button',{staticClass:"btn btn-primary btn-sm m-2",on:{"click":_vm.guardar}},[_c('i',{staticClass:"fa fa-trash mr-2"}),_vm._v("Guardar")]):_vm._e(),(_vm.registro.ID_entrada && _vm.editable)?_c('button',{staticClass:"btn btn-danger btn-sm m-2",on:{"click":_vm.eliminar}},[_c('i',{staticClass:"fa fa-save mr-2"}),_vm._v("Eliminar")]):_vm._e(),(_vm.registro.gestion === 0 && _vm.citaPasada && !_vm.registro.fecha_cierre_informe)?_c('button',{staticClass:"btn btn-warning btn-sm m-2",on:{"click":_vm.finalizar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Finalizar informe")]):_vm._e(),(_vm.registro.gestion === 0 && _vm.registro.ID_entrada && !_vm.registro.fecha_cierre_informe && !_vm.accionesPropuestas)?_c('button',{staticClass:"btn btn-danger btn-sm m-2",on:{"click":function($event){_vm.cancelando = true}}},[_c('span',{staticClass:"fa fa-close mr-2"}),_vm._v("Cita cancelada")]):_vm._e()])]),(_vm.verEditorPropuestas)?_c('propuesta',{attrs:{"copiar":_vm.copiarPropuesta,"id-agente":_vm.registro.usuario_ID,"id-cliente":_vm.registro.cliente_ID},on:{"cerrar":function($event){_vm.verEditorPropuestas = false},"saved":function($event){return _vm.asignaPropuesta($event)}}}):_vm._e(),(_vm.detallePropuesta)?_c('propuesta',{attrs:{"id-propuesta":_vm.detallePropuesta},on:{"cerrar":function($event){_vm.detallePropuesta = null}}}):_vm._e(),(_vm.cancelando)?_c('cancelar-cita',{attrs:{"id-entrada":_vm.registro.ID_entrada},on:{"cerrar":function($event){_vm.cancelando = false},"cancelada":_vm.citaCancelada}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),(_vm.permisos.agenda_comercial_consultar_todos)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.usuario),expression:"filtro.usuario"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.usuario)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "usuario", $event.target.value)}}}):_vm._e(),(!_vm.permisos.agenda_comercial_consultar_todos)?_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"true"},domProps:{"value":_vm.usuario.nombre + ' ' + _vm.usuario.apellidos}}):_vm._e()]),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_vm._v("Cliente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cliente),expression:"filtro.cliente"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.cliente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cliente", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha inicio")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"monday-first":true,"language":_vm.$dateLang,"bootstrap-styling":true,"input-class":"form-control form-control-sm"},on:{"closed":_vm.buscar},model:{value:(_vm.filtro.fechaIni),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaIni", $$v)},expression:"filtro.fechaIni"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.borraFechaIni()}}},[_c('span',{staticClass:"fa fa-trash"})])])],1)]),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_vm._v("Fecha fin")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"monday-first":true,"language":_vm.$dateLang,"bootstrap-styling":true,"input-class":"form-control form-control-sm"},on:{"closed":_vm.buscar},model:{value:(_vm.filtro.fechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaFin", $$v)},expression:"filtro.fechaFin"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.borraFechaFin()}}},[_c('span',{staticClass:"fa fa-trash"})])])],1)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de entrada")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.tipo === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.tipo === 'gestion') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo('gestion')}}},[_vm._v("Gestión interna")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.tipo === 'cliente') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo('cliente')}}},[_vm._v("Contacto cliente")])])]),(_vm.filtro.tipo !== 'gestion')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.estado === null) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.estado = null}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.estado === 'porvenir') ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.estado = 'porvenir'}}},[_vm._v("Por venir")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.estado === 'sinfinalizar') ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.estado = 'sinfinalizar'}}},[_vm._v("Pte. finalizar")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.estado === 'finalizado') ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.estado = 'finalizado'}}},[_vm._v("Finalizado")])])]):_vm._e()]),(_vm.filtro.tipo !== 'gestion')?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de contacto")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.tipoContacto),expression:"filtro.tipoContacto"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "tipoContacto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Todos")]),_vm._l((_vm.tiposContacto),function(tipo){return _c('option',{key:tipo.ID_tipo,domProps:{"value":tipo.ID_tipo}},[_vm._v(_vm._s(tipo.nombre))])})],2)]),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_vm._v("Objetivo de contacto")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.objetivo),expression:"filtro.objetivo"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "objetivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Todos")]),_vm._l((_vm.objetivosContacto),function(objetivo){return _c('option',{key:objetivo.ID_objetivo,domProps:{"value":objetivo.ID_objetivo}},[_vm._v(_vm._s(objetivo.nombre))])})],2)])]):_vm._e()])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary mr-2",on:{"click":_vm.buscar}},[_c('i',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":_vm.nuevoRegistro}},[_c('i',{staticClass:"fa fa-edit mr-2"}),_vm._v("Nueva entrada")])])]),_c('div',{staticClass:"card mt-4"},[_vm._m(1),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-condensed mb-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.listadoEntradas),function(entrada){return _c('tr',{key:entrada.ID_entrada,class:entrada.clase,style:(entrada.estilo)},[_c('td',[_c('span',[_vm._v(_vm._s(_vm._f("moment")(new Date(entrada.fecha_inicio_contacto * 1000),'D-M-YYYY H:mm')))]),(entrada.cancelada)?_c('div',{staticClass:"text-danger"},[_c('b',[_vm._v("CANCELADA")])]):_vm._e()]),_c('td',[_vm._v(_vm._s(entrada.usuarioNombre))]),_c('td',[_vm._v(_vm._s(entrada.clienteNombre))]),_c('td',[_vm._v(_vm._s(entrada.tipoContacto))]),_c('td',[_vm._v(_vm._s(entrada.objetivo))]),_c('td',[(entrada.importe)?_c('span',[_vm._v(_vm._s(_vm._f("currency")(entrada.importe,'€')))]):_vm._e()]),_c('td',[(entrada.importeFirmado)?_c('span',[_vm._v(_vm._s(_vm._f("currency")(entrada.importeFirmado,'€')))]):_vm._e()]),_c('td',[(entrada.comentarios_finales)?_c('span',[_vm._v(_vm._s(entrada.comentarios_finales))]):_c('span',[_vm._v(_vm._s(entrada.comentarios_previos))])]),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.editarEntrada(entrada)}}},[_c('span',{staticClass:"fa fa-edit"})])])])}),0)])])]),(_vm.editar)?_c('editor',{attrs:{"id-registro":_vm.editar},on:{"cerrar":function($event){return _vm.$router.push('/main/agenda-comercial/listados')},"saved":_vm.buscar}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('i',{staticClass:"mr-2 fa fa-search"}),_vm._v("Búsqueda")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('i',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Tipo contacto")]),_c('th',[_vm._v("Carácter")]),_c('th',[_vm._v("Importe presentado")]),_c('th',[_vm._v("Importe firmado")]),_c('th',[_vm._v("Comentarios")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendario_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589cf4cc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendario_vue__ = __webpack_require__(917);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589cf4cc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mes_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a463f7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mes_vue__ = __webpack_require__(910);
function injectStyle (ssrContext) {
  __webpack_require__(909)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65a463f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a463f7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',[_c('td',{staticClass:"text-center p-1 numSemana"},[_vm._v("Semana")]),_vm._l((_vm.diasSemana),function(dia){return _c('td',{key:dia,staticClass:"text-center p-1"},[_vm._v(_vm._s(dia))])})],2)]),_c('tbody',_vm._l((_vm.getSemanas),function(semana){return _c('tr',{key:semana.numero},[_c('td',{staticClass:"numSemana",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verSemana(semana.dias[0].dia)}}},[_vm._v(_vm._s(semana.numero))]),_vm._l((semana.dias),function(dia){return _c('v-touch',{key:dia.dia.getTime(),staticClass:"diaMes",style:(_vm.estiloDia(dia.dia)),attrs:{"tag":"td"},on:{"dblclick":function($event){return _vm.crearEntrada(dia.dia)},"press":function($event){return _vm.crearEntrada(dia.dia)}}},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verDia(dia.dia)}}},[_vm._v(_vm._s(dia.dia.getDate()))]),(dia.dia.toLocaleDateString() === new Date().toLocaleDateString())?_c('span',[_vm._v(" (Hoy)")]):_vm._e(),_vm._l((dia.eventos),function(evento){return _c('div',{key:evento.ID_evento,staticClass:"evento",style:(_vm.estiloEvento(dia.dia, evento)),on:{"click":function($event){return _vm.verEntrada(evento)}}},[_vm._v(_vm._s(_vm._f("moment")(evento.fechaIni,'HH:mm'))+" - "+_vm._s(evento.usuarioNombre)+" - "+_vm._s(evento.clienteNombre))])})],2)})],2)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_semana_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3701aa68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_semana_vue__ = __webpack_require__(916);
function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_semana_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3701aa68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_semana_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_evento_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28899d82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_evento_vue__ = __webpack_require__(915);
function injectStyle (ssrContext) {
  __webpack_require__(914)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_evento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28899d82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_evento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 914 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.datos)?_c('div',{style:(_vm.estiloSup),attrs:{"title":_vm.$moment(_vm.datos.evento.fechaIni).format('HH:mm') + ' ' + _vm.datos.evento.usuarioNombre + ' - ' + _vm.datos.evento.clienteNombre,"draggable":"true","id":_vm.datos.evento.ID_entrada},on:{"click":function($event){return _vm.verEntrada($event, _vm.datos.evento)},"dragstart":_vm.test}},[_c('div',{style:(_vm.estilo)},[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm._f("moment")(_vm.datos.evento.fechaIni,'HH:mm'))+" - "+_vm._s(_vm._f("moment")(_vm.datos.evento.fechaFin,'HH:mm')))]),_vm._v(_vm._s(_vm.datos.evento.usuarioNombre)+" - "),(_vm.datos.evento.gestion === 0)?_c('span',[_vm._v(_vm._s(_vm.datos.evento.clienteNombre)+" ")]):_c('span',[_vm._v("Gestión interna"),_c('br'),_c('b',[_vm._v(_vm._s(_vm.datos.evento.comentarios_previos))])]),_c('div',{staticClass:"barras bottom",on:{"mousedown":function($event){return _vm.captura($event)},"mouseup":function($event){return _vm.libera($event)},"click":_vm.stopProp}},[_c('span',{staticClass:"fa fa-bars"})])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"calendario"},[_c('div',{staticClass:"calendarioTop"},[_c('div',{staticClass:"calendarioTopBlanco"},[_c('span',{staticClass:"fa",class:(_vm.horaInicio === 0) ? 'fa-caret-up' : 'fa-caret-down',staticStyle:{"flex":"1 1","font-size":"2em","text-align":"center","cursor":"pointer"},on:{"click":_vm.toggleHoras}})]),_c('div',{staticClass:"calendarioTopDias"},[_c('div',{staticClass:"calendarioTopDiasDias"},_vm._l((_vm.getDias),function(dia){return _c('div',{key:dia.titulo,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verDia(dia.fecha)}}},[_vm._v(_vm._s(dia.fecha.getDate())+" - "+_vm._s(dia.titulo))])}),0)])]),_c('div',{staticClass:"calendarioHoras"},[_c('div',{ref:"colHoras",staticClass:"calendarioHorasHoraCol"},_vm._l((new Array(24)),function(hora,index){return (index >= _vm.horaInicio)?_c('div',{key:hora,staticClass:"calendarioHora"},[_vm._v(_vm._s(index)+":00")]):_vm._e()}),0),_vm._l((_vm.getDias),function(dia){return _c('div',{key:dia.titulo,staticClass:"calendarioDiaCol",on:{"drop":_vm.droped,"dragover":_vm.overDrag,"dragleave":_vm.leaveDrag}},[_c('div',{key:dia.titulo,staticClass:"capaEventosDia",attrs:{"id":dia.fecha.getTime()}},_vm._l((_vm.eventosUnDia(dia)),function(evento,index){return _c('evento',{key:evento.evento.ID_entrada,staticClass:"eventoCalendario",style:(evento.style),attrs:{"draggable":true,"evento":evento,"alto":_vm.altoDia},on:{"update:evento":function($event){evento=$event},"ver":function($event){return _vm.verEntrada($event)},"actualizar":_vm.actualizar}})}),1),_vm._l((new Array(24)),function(hora,index){return (index >= _vm.horaInicio)?_c('div',{key:index,staticClass:"calendarioDiaIntervalo"},[_c('v-touch',{staticClass:"mediaHoraClass",attrs:{"tag":"div","id":dia.fecha.getTime() + '-' + index + '-0'},on:{"dblclick":function($event){return _vm.nuevaEntrada(index, 1, dia.fecha)},"press":function($event){return _vm.nuevaEntrada(index, 1, dia.fecha)}}}),_c('v-touch',{staticClass:"mediaHoraClass",attrs:{"tag":"div","id":dia.fecha.getTime() + '-' + index + '-15'},on:{"dblclick":function($event){return _vm.nuevaEntrada(index, 2, dia.fecha)},"press":function($event){return _vm.nuevaEntrada(index, 2, dia.fecha)}}}),_c('v-touch',{staticClass:"mediaHoraClass",attrs:{"tag":"div","id":dia.fecha.getTime() + '-' + index + '-30'},on:{"dblclick":function($event){return _vm.nuevaEntrada(index, 3, dia.fecha)},"press":function($event){return _vm.nuevaEntrada(index, 3, dia.fecha)}}}),_c('v-touch',{staticClass:"mediaHoraClass",attrs:{"tag":"div","id":dia.fecha.getTime() + '-' + index + '-45'},on:{"dblclick":function($event){return _vm.nuevaEntrada(index, 4, dia.fecha)},"press":function($event){return _vm.nuevaEntrada(index, 4, dia.fecha)}}})],1):_vm._e()})],2)})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pt-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.anterior()}}},[_c('span',{staticClass:"fa fa-caret-left mr-2"})]),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.siguiente()}}},[_c('span',{staticClass:"fa fa-caret-right ml-2"})])]),(!_vm.filtro.usuario_ID && _vm.permisos.agenda_comercial_consultar_todos)?_c('input-query',{attrs:{"placeholder":"Filtra por usuario","url":"/agenda-comercial/php/api/busca-agentes.php","realtime":true,"inputClass":"form-control"},on:{"selected":function($event){return _vm.seleccionaUsuario($event)}}}):_vm._e(),(_vm.filtro.usuario_ID)?_c('input',{staticClass:"form-control",attrs:{"disabled":"true"},domProps:{"value":_vm.usuarioNombre}}):_vm._e(),(_vm.filtro.usuario_ID)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitaUsuario}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()],1)]),_c('div',{staticClass:"col text-center"},[(_vm.vista === 'mes')?_c('div',[_c('h5',[_c('b',[_vm._v(_vm._s(_vm.meses[_vm.fecha.getMonth()])+", "+_vm._s(_vm.fecha.getFullYear()))])])]):_vm._e(),(_vm.vista === 'semana')?_c('div',[_c('h5',[_c('b',[_vm._v(_vm._s(_vm._f("moment")(_vm.fechaInicioSemana,'DD-MM-YYYY'))+" a "+_vm._s(_vm._f("moment")(new Date(_vm.fechaInicioSemana.getTime() + 518400000),'DD-MM-YYYY')))])])]):_vm._e(),(_vm.vista === 'dia')?_c('div',[_c('h5',[_c('b',[_vm._v(_vm._s(_vm._f("moment")(_vm.fecha,'DD-MM-YYYY')))])])]):_vm._e()]),_c('div',{staticClass:"col text-right"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.vista === 'mes') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setVista('mes')}}},[_vm._v("Mes")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.vista === 'semana') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setVista('semana')}}},[_vm._v("Semana")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.vista === 'dia') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setVista('dia')}}},[_vm._v("Día")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.vista === 'agenda') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setVista('agenda')}}},[_vm._v("Agenda")])])])])]),(_vm.vista === 'mes')?_c('vista-mes',{attrs:{"entradas":_vm.entradas,"fecha":_vm.fecha},on:{"actualizar":_vm.getEventos,"editar":function($event){return _vm.abreEditor($event)},"update:fecha":function($event){_vm.fecha=$event},"verSemana":function($event){return _vm.verSemana($event)},"verDia":function($event){return _vm.verDia($event)}}}):_vm._e(),(_vm.vista === 'semana')?_c('vista-semana',{attrs:{"entradas":_vm.entradas,"fecha":_vm.fecha},on:{"actualizar":_vm.getEventos,"editar":function($event){return _vm.abreEditor($event)},"verDia":function($event){return _vm.verDia($event)},"update:fecha":function($event){_vm.fecha=$event}}}):_vm._e(),(_vm.vista === 'dia')?_c('vista-semana',{attrs:{"entradas":_vm.entradas,"fecha":_vm.fecha,"dias":1},on:{"actualizar":_vm.getEventos,"editar":function($event){return _vm.abreEditor($event)},"verDia":function($event){return _vm.verDia($event)},"update:fecha":function($event){_vm.fecha=$event}}}):_vm._e(),(_vm.editor.ID_entrada)?_c('editor-entradas',{attrs:{"id-registro":_vm.editor.ID_entrada,"fecha":_vm.editor.fecha,"hora":_vm.editor.hora},on:{"saved":_vm.getEventos,"cerrar":_vm.cerrarEditor}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_propuestas_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf59054_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_propuestas_vue__ = __webpack_require__(919);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_propuestas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf59054_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_propuestas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[(_vm.permisos.agenda_comercial_consultar_todos)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Usuario")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.usuario),expression:"filtro.usuario"}],staticClass:"form-control",attrs:{"placeholder":"Usuario que la crea"},domProps:{"value":(_vm.filtro.usuario)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "usuario", $event.target.value)}}})]):_vm._e(),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cliente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cliente),expression:"filtro.cliente"}],staticClass:"form-control",attrs:{"placeholder":"Escribe el cliente al que se le presenta"},domProps:{"value":(_vm.filtro.cliente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cliente", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Título")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.titulo),expression:"filtro.titulo"}],staticClass:"form-control",attrs:{"placeholder":"Escribe el título por el que buscar"},domProps:{"value":(_vm.filtro.titulo)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "titulo", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Desde")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"language":_vm.$dateLang,"bootstrap-styling":true,"monday-first":true},on:{"closed":_vm.buscar},model:{value:(_vm.filtro.fechaIni),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaIni", $$v)},expression:"filtro.fechaIni"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.delFechaIni}},[_c('span',{staticClass:"fa fa-trash"})])])],1)])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hasta")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"language":_vm.$dateLang,"bootstrap-styling":true,"monday-first":true},on:{"closed":_vm.buscar},model:{value:(_vm.filtro.fechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaFin", $$v)},expression:"filtro.fechaFin"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.delFechaFin}},[_c('span',{staticClass:"fa fa-trash"})])])],1)])])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.tipo === 'todas') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo('todas')}}},[_vm._v("Todas")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.tipo === 'personalizadas') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo('personalizadas')}}},[_vm._v("Personalizadas")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.tipo === 'plantillas') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo('plantillas')}}},[_vm._v("Plantillas")])])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.estado === 'todas') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('todas')}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.estado === 'presentadas') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('presentadas')}}},[_vm._v("Presentadas")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.estado === 'aprobadas') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('aprobadas')}}},[_vm._v("Aprobadas")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.estado === 'rechazadas') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('rechazadas')}}},[_vm._v("Rechazadas")])])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-sm btn-warning ml-2",on:{"click":_vm.nuevaPropuesta}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Nueva propuesta")])])]),(_vm.ID_propuesta)?_c('editor-propuesta',{attrs:{"id-propuesta":_vm.ID_propuesta,"id-agente":_vm.usuario.ID},on:{"cerrar":function($event){_vm.ID_propuesta = null}}}):_vm._e(),_c('div',{staticClass:"card mt-2"},[_vm._m(1),_c('div',{staticClass:"table-responsive mb-0"},[_c('table',{staticClass:"table table-striped mb-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.listado),function(propuesta){return _c('tr',{key:propuesta.ID_propuesta},[_c('td',[_vm._v(_vm._s(propuesta.usuarioInfo))]),_c('td',[_vm._v(_vm._s(propuesta.empresaNombreFiscal))]),_c('td',[_vm._v(_vm._s(propuesta.clienteInfo))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(propuesta.fecha_creada,'DD-MM-YYYY')))]),_c('td',[_vm._v(_vm._s(propuesta.titulo))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(propuesta.importe,'€')))]),_c('td',[(propuesta.fecha_rechazada)?_c('span',[_vm._v("Rechazada")]):(propuesta.fecha_decision)?_c('span',[(propuesta.decision === 'aprobada')?_c('span',{staticClass:"text-success"},[_vm._v("Aprobada")]):_c('span',{staticClass:"text-danger"},[_vm._v("Rechazada")])]):(propuesta.fecha_presentada)?_c('span',[_vm._v("Presentada")]):_c('span',[_vm._v("No presentada")])]),_c('td',[(!propuesta.decision && propuesta.fecha_presentada && propuesta.entrada_ID_asociada)?_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-success btn-sm",on:{"click":function($event){return _vm.aprobar(propuesta)}}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Aprobada")]),_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.rechazar(propuesta)}}},[_c('span',{staticClass:"fa fa-ban mr-2"}),_vm._v("Rechazada")])]):_vm._e()]),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.ID_propuesta = propuesta.ID_propuesta}}},[_c('span',{staticClass:"fa fa-eye"})])])])}),0)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar propuestas")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Usuario")]),_c('th',[_vm._v("Empresa")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Tiulo")]),_c('th',[_vm._v("Importe")]),_c('th',[_vm._v("Estado")]),_c('th',[_vm._v("Resultado")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_estadisticas_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03922fad_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_estadisticas_vue__ = __webpack_require__(921);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_estadisticas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03922fad_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_estadisticas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card mb-3"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[(_vm.permisos.agenda_comercial_consultar_todos)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),(!_vm.form.usuario_ID)?_c('input-query',{attrs:{"inputClass":"form-control","url":"/agenda-comercial/php/api/busca-agentes.php","realtime":true},on:{"selected":function($event){return _vm.setAgente($event)}}}):_vm._e(),(_vm.form.usuario_ID)?_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"true"},domProps:{"value":_vm.nombreUsuario}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.form.usuario_ID = null}}},[_c('span',{staticClass:"fa fa-trash"})])])]):_vm._e()],1):_vm._e(),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Desde")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"monday-first":true,"bootstrap-styling":true,"language":_vm.$dateLang},model:{value:(_vm.form.fechaIni),callback:function ($$v) {_vm.$set(_vm.form, "fechaIni", $$v)},expression:"form.fechaIni"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.form.fechaIni = null}}},[_c('span',{staticClass:"fa fa-trash"})])])],1)])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hasta")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"monday-first":true,"bootstrap-styling":true,"language":_vm.$dateLang},model:{value:(_vm.form.fechaFin),callback:function ($$v) {_vm.$set(_vm.form, "fechaFin", $$v)},expression:"form.fechaFin"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.form.fechaFin = null}}},[_c('span',{staticClass:"fa fa-trash"})])])],1)])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Añade clientes")]),_c('input-query',{attrs:{"inputClass":"form-control","url":"/agenda-comercial/php/api/busca-clientes.php","realtime":true},on:{"selected":function($event){return _vm.addCliente($event)}}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[(_vm.form.clientes.length > 0)?_c('table',{staticClass:"table table-striped table-bordered"},[_c('tbody',_vm._l((_vm.form.clientes),function(cliente){return _c('tr',{key:cliente.ID},[_c('td',[_vm._v(_vm._s(cliente.cliente))]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaCliente(cliente.ID)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)]):_vm._e()])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])])]),_c('div',{staticClass:"row mb-3"},[(_vm.resultados.visitasObjetivo)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Visitas por objetivo")]),_c('div',{staticClass:"card-body"},[_c('chartjs-pie',{attrs:{"beginatzero":true,"label":"Visitas por objetivo","height":200,"labels":_vm.resultados.visitasObjetivo.labels,"data":_vm.resultados.visitasObjetivo.valores,"datalabel":"Visitas por objetivo","option":_vm.opcionesPie}})],1)])]):_vm._e(),(_vm.resultados.visitasTipo)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Visitas por tipo")]),_c('div',{staticClass:"card-body"},[_c('chartjs-pie',{attrs:{"beginatzero":true,"label":"Visitas por tipo","height":200,"labels":_vm.resultados.visitasTipo.labels,"data":_vm.resultados.visitasTipo.valores,"datalabel":"Visitas por tipo","option":_vm.opcionesPie}})],1)])]):_vm._e(),(_vm.resultados.visitasCanceladas)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Visitas realizadas v/s canceladas")]),_c('div',{staticClass:"card-body"},[_c('chartjs-pie',{attrs:{"beginatzero":true,"label":"Visitas canceladas","height":200,"labels":_vm.resultados.visitasCanceladas.labels,"data":_vm.resultados.visitasCanceladas.valores,"datalabel":"Visitas canceladas","option":_vm.opcionesPie}})],1)])]):_vm._e(),(_vm.resultados.propuestasRechazadas)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Propuestas aprobadas v/s rechazadas")]),_c('div',{staticClass:"card-body"},[_c('chartjs-pie',{attrs:{"beginatzero":true,"label":"Propuestas aprobadas","height":200,"labels":_vm.resultados.propuestasRechazadas.labels,"data":_vm.resultados.propuestasRechazadas.valores,"datalabel":"Propuestas aprobadas","option":_vm.opcionesPie}})],1)])]):_vm._e()]),_c('div',{staticClass:"row mb-3"},[(_vm.resultados.visitasDiaSemana)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_vm._v("Visitas por dia de la semana")]),_c('div',{staticClass:"card-body"},[_c('chartjs-bar',{attrs:{"beginatzero":true,"label":"Visitas por dia de la semana","height":200,"labels":_vm.resultados.visitasDiaSemana.labels,"data":_vm.resultados.visitasDiaSemana.valores,"datalabel":"Visitas por dia de la semana"}})],1)])]):_vm._e(),(_vm.resultados.visitasHoras)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_vm._v("Visitas por horas")]),_c('div',{staticClass:"card-body"},[_c('chartjs-bar',{attrs:{"beginatzero":true,"label":"Visitas por horas","height":200,"labels":_vm.resultados.visitasHoras.labels,"data":_vm.resultados.visitasHoras.valores,"datalabel":"Visitas por horas"}})],1)])]):_vm._e(),(_vm.resultados.visitasHorasSemana)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_vm._v("Visitas por día de la semana y hora")]),_c('div',{staticClass:"card-body"},[_c('chartjs-bubble',{attrs:{"data":_vm.resultados.visitasHorasSemana,"options":_vm.opcionesBubble}})],1)])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Filtrar estadísticas")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__componentes_buscador_buscador__ = __webpack_require__(925);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('auditor', {
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */],
			redirect: '/main/auditor/buscador'
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('auditor').child('buscador', {
			component: __WEBPACK_IMPORTED_MODULE_2__componentes_buscador_buscador__["a" /* default */],
			name: 'Buscador de emisiones'
		});
	}
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fc6c9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(924);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fc6c9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscador_vue__ = __webpack_require__(406);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92e0c554_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscador_vue__ = __webpack_require__(926);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92e0c554_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha de inicio")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"input-class":"form-control","monday-first":true,"language":_vm.$dateLang},model:{value:(_vm.filtro.FechaInicio),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaInicio", $$v)},expression:"filtro.FechaInicio"}})],1),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha de fin")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"input-class":"form-control","monday-first":true,"language":_vm.$dateLang},model:{value:(_vm.filtro.FechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaFin", $$v)},expression:"filtro.FechaFin"}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),(_vm.permisos.auditor_verTodos && !_vm.filtro.AgenteID)?_c('input-query',{attrs:{"input-class":"form-control","url":"auditor/php/api/query-agentes.php","realtime":true},on:{"selected":function($event){return _vm.setAgente($event)}}}):(_vm.filtro.AgenteID)?_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.agenteNombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarAgente}},[_c('span',{staticClass:"fa fa-trash"})])])]):_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.usuario.nombre + ' ' + _vm.usuario.apellidos}})],1),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Soporte(s)")]),_c('input-query',{staticClass:"form-control",attrs:{"input-class":"form-control","url":"/auditor/php/api/query-soportes.php","realtime":true},on:{"selected":function($event){return _vm.setSoporte($event)}}})],1),_c('div',_vm._l((_vm.filtro.Soportes),function(sop){return _c('button',{key:sop.ID_soporte,staticClass:"btn btn-sm btn-danger m-2",on:{"click":function($event){return _vm.quitarSoporte(sop)}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v(_vm._s(sop.soporte))])}),0)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cliente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.ClienteNombre),expression:"filtro.ClienteNombre"}],staticClass:"form-control",domProps:{"value":(_vm.filtro.ClienteNombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "ClienteNombre", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Anunciante")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.AnuncianteNombre),expression:"filtro.AnuncianteNombre"}],staticClass:"form-control",domProps:{"value":(_vm.filtro.AnuncianteNombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "AnuncianteNombre", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Contrato")]),(!_vm.filtro.ContratoID)?_c('input-query',{attrs:{"url":"/auditor/php/api/query-contratos.php","input-class":"form-control","realtime":true},on:{"selected":function($event){return _vm.setContrato($event)}}}):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.contratoTitulo}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarContrato}},[_c('span',{staticClass:"fa fa-trash"})])])])],1),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Facturado a")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.DestinoID),expression:"filtro.DestinoID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "DestinoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Todos")]),_vm._l((_vm.listadoDestinos),function(destino){return _c('option',{key:destino.ID_destino,domProps:{"value":destino.ID_destino}},[_vm._v(_vm._s(destino.texto))])})],2)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Intermediario")]),(!_vm.filtro.IntermediarioID)?_c('input-query',{attrs:{"url":"/auditor/php/api/query-intermediarios.php","input-class":"form-control","realtime":true},on:{"selected":function($event){return _vm.setIntermediario($event)}}}):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.intermediarioNombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarIntermediario}},[_c('span',{staticClass:"fa fa-trash"})])])])],1),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agrupado")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.CampoAgrupado),expression:"filtro.CampoAgrupado"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "CampoAgrupado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Sin agrupar")]),_vm._l((_vm.listadoCampos),function(campo){return _c('option',{key:campo.campo,domProps:{"value":campo.campo}},[_vm._v(_vm._s(campo.descripcion))])})],2)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descripcion fichero / Matrícula")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Descripcion),expression:"filtro.Descripcion"}],staticClass:"form-control",domProps:{"value":(_vm.filtro.Descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Descripcion", $event.target.value)}}})])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-success ml-2",attrs:{"disabled":_vm.filtro.CampoAgrupado !== 'FicheroMatricula' || !_vm.filtro.FechaInicio || !_vm.filtro.FechaFin},on:{"click":function($event){return _vm.descargarFicheros()}}},[_c('span',{staticClass:"fa fa-download mr-2"}),_c('span',[_vm._v("Descargar cuñas")])]),(_vm.resultados.length > 0)?_c('download-excel',{staticClass:"btn btn-warning ml-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"meta":_vm.json_meta,"name":"filename.xls"}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("XLS")]):_vm._e()],1)]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_c('div',{staticClass:"row"},[_vm._m(1),(_vm.paginas > 1)?_c('div',{staticClass:"col text-right"},[_c('div',{staticStyle:{"position":"relative","display":"inline-block"}},[_c('ul',{staticClass:"pagination justify-content-end pagination-sm"},_vm._l((_vm.botonesPagina),function(p){return _c('li',{staticClass:"page-item",class:(_vm.pagina === p.pagina) ? 'active' : ''},[(p.activa)?_c('span',{staticClass:"page-link",on:{"click":function($event){return _vm.verPagina(p.pagina)}}},[_vm._v(_vm._s(p.pagina + 1))]):_c('span',{staticClass:"page-link disabled"},[_vm._v(_vm._s(p.pagina))])])}),0)]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.saltarPagina),expression:"saltarPagina",modifiers:{"number":true}}],staticClass:"form-control form-control-sm ml-2",staticStyle:{"position":"relative","display":"inline-block","width":"50px"},attrs:{"placeholder":"Pág"},domProps:{"value":(_vm.saltarPagina)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.verPagina(_vm.saltarPagina - 1)},"input":function($event){if($event.target.composing){ return; }_vm.saltarPagina=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]):_vm._e()])]),_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[(_vm.columnasOcultas.indexOf('AnuncianteNombre') < 0)?_c('th',[_vm._v("Anunciante")]):_vm._e(),(_vm.columnasOcultas.indexOf('ClienteNombre') < 0)?_c('th',[_vm._v("Cliente")]):_vm._e(),(_vm.columnasOcultas.indexOf('SoporteNombre') < 0)?_c('th',[_vm._v("Soporte")]):_vm._e(),(_vm.columnasOcultas.indexOf('FechaEmision') < 0)?_c('th',[_vm._v("Fecha emisión")]):_vm._e(),(_vm.columnasOcultas.indexOf('ContratoTitulo') < 0)?_c('th',[_vm._v("Contrato")]):_vm._e(),(_vm.columnasOcultas.indexOf('ProduccionTitulo') < 0)?_c('th',[_vm._v("Campaña")]):_vm._e(),(_vm.columnasOcultas.indexOf('FicheroNombre') < 0)?_c('th',[_vm._v("Fichero")]):_vm._e(),(_vm.columnasOcultas.indexOf('FicheroMatricula') < 0)?_c('th',[_vm._v("Matrícula")]):_vm._e(),(_vm.columnasOcultas.indexOf('AgenteNombre') < 0)?_c('th',[_vm._v("Agente")]):_vm._e(),(_vm.resultadosAgrupados)?_c('th',[_vm._v("Total emisiones")]):_vm._e()])]),_c('tbody',_vm._l((_vm.paginaActual),function(emision){return _c('tr',{key:emision.EmisionID},[(_vm.columnasOcultas.indexOf('AnuncianteNombre') < 0)?_c('td',[_vm._v(_vm._s(emision.AnuncianteNombre))]):_vm._e(),(_vm.columnasOcultas.indexOf('ClienteNombre') < 0)?_c('td',[_vm._v(_vm._s(emision.ClienteNombre))]):_vm._e(),(_vm.columnasOcultas.indexOf('SoporteNombre') < 0)?_c('td',[_vm._v(_vm._s(emision.SoporteNombre))]):_vm._e(),(_vm.columnasOcultas.indexOf('FechaEmision') < 0)?_c('td',[_vm._v(_vm._s(emision.FechaEmision))]):_vm._e(),(_vm.columnasOcultas.indexOf('ContratoTitulo') < 0)?_c('td',[_vm._v(_vm._s(emision.ContratoTitulo))]):_vm._e(),(_vm.columnasOcultas.indexOf('ProduccionTitulo') < 0)?_c('td',[_c('div',[_vm._v(_vm._s(emision.ProduccionTitulo))]),_c('div',{staticStyle:{"opacity":"0.7"}},[_vm._v(_vm._s(emision.TareaTitulo))])]):_vm._e(),(_vm.columnasOcultas.indexOf('FicheroNombre') < 0)?_c('td',[_vm._v(_vm._s(emision.FicheroNombre))]):_vm._e(),(_vm.columnasOcultas.indexOf('FicheroMatricula') < 0)?_c('td',[_vm._v(_vm._s(emision.FicheroMatricula))]):_vm._e(),(_vm.columnasOcultas.indexOf('AgenteNombre') < 0)?_c('td',[_vm._v(_vm._s(emision.AgenteNombre))]):_vm._e(),(_vm.resultadosAgrupados)?_c('td',[_vm._v(_vm._s(emision.EmisionesTotales)+" emisiones")]):_vm._e()])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Auditor de emisiones")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_porAgente_main__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_porMeses_main__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_porClientes_main__ = __webpack_require__(989);





/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('facturacion', {
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('facturacion').child('porAgente', {
			name: 'Consultas por agente',
			component: __WEBPACK_IMPORTED_MODULE_2__components_porAgente_main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('facturacion').child('porMeses', {
			name: 'Consultas por meses',
			component: __WEBPACK_IMPORTED_MODULE_3__components_porMeses_main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('facturacion').child('porClientes', {
			name: 'Consultas por clientes',
			component: __WEBPACK_IMPORTED_MODULE_4__components_porClientes_main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('facturacion').child('', {
			redirect: '/main/facturacion/porAgente'
		});
	}
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623f4786_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(930);
function injectStyle (ssrContext) {
  __webpack_require__(929)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-623f4786"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623f4786_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae02c50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(986);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae02c50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var uri = 'consultas-facturacion/php/api/';

var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(uri + url);
};

var post = function post(url, data) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(uri + url, data);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getCamposFormulario: function getCamposFormulario() {
		return get('porAgente/get-formulario.php');
	},
	getAgentesActivos: function getAgentesActivos() {
		return get('porAgente/get-agentes-activos.php');
	},
	consultarPorAgentes: function consultarPorAgentes(datos) {
		var filtro = _.clone(datos);

		filtro.fecha_ini = filtro.fecha_ini === null ? null : Math.floor(filtro.fecha_ini.getTime() / 1000);
		filtro.fecha_fin = filtro.fecha_fin === null ? null : Math.floor(filtro.fecha_fin.getTime() / 1000);
		return post('porAgente/consultar.php', filtro);
	}
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_graficosTotales_vue__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_499de390_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_graficosTotales_vue__ = __webpack_require__(982);
function injectStyle (ssrContext) {
  __webpack_require__(934)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-499de390"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_graficosTotales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_499de390_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_graficosTotales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.datos.tipo === 'barras')?[_c('chartjs-bar',{attrs:{"beginatzero":true,"label":_vm.datos.titulo,"height":200,"labels":_vm.datos.labels,"datasets":_vm.datos.datasets}})]:_vm._e(),_vm._v(" "),(_vm.datos.tipo === 'lineas')?[_c('chartjs-line',{attrs:{"beginatzero":true,"label":_vm.datos.titulo,"height":200,"labels":_vm.datos.labels,"datasets":_vm.datos.datasets}})]:_vm._e(),_vm._v(" "),(_vm.datos.tipo === 'queso')?[_c('chartjs-pie',{attrs:{"option":{},"datalabel":_vm.datos.titulo,"height":200,"labels":_vm.datos.labels,"data":_vm.datos.data}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-condensed"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_vm._l((_vm.datos.datasets),function(set){return _c('th',{key:set.label},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(set.label)+"\n\t\t\t\t\t")])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.datos.labels),function(label,indexLabel){return _c('tr',{key:label},[_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(label)+"\n\t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.datos.datasets),function(set,indexSet){return _c('td',{key:indexSet+'_'+set.label},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(set.data[indexLabel],''))+" €\n\t\t\t\t\t")])})],2)}),0)])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_contrato_vue__ = __webpack_require__(418);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26df5f25_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_contrato_vue__ = __webpack_require__(973);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_contrato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26df5f25_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_contrato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_datos_cliente_vue__ = __webpack_require__(419);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d97a12e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_datos_cliente_vue__ = __webpack_require__(972);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_datos_cliente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d97a12e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_datos_cliente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":500}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info"},[_vm._v("Datos del cliente"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Cliente")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.NombreCliente),expression:"datos.NombreCliente"}],staticClass:"form-control",attrs:{"placeholder":"Nombre del cliente","disabled":!_vm.permisos['contratos_editaNombreCliente']},domProps:{"value":(_vm.datos.NombreCliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "NombreCliente", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("CIF")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.CIF),expression:"datos.CIF"}],staticClass:"form-control",attrs:{"placeholder":"CIF del cliente"},domProps:{"value":(_vm.datos.CIF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "CIF", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("IBAN")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.IBAN),expression:"datos.IBAN"}],staticClass:"form-control",attrs:{"placeholder":"IBAN del cliente","disabled":!_vm.contrato.NecesarioIBAN},domProps:{"value":(_vm.datos.IBAN)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "IBAN", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Representante")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.Representante),expression:"datos.Representante"}],staticClass:"form-control",attrs:{"placeholder":"Representante del cliente"},domProps:{"value":(_vm.datos.Representante)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "Representante", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Telefono")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.Telefono),expression:"datos.Telefono"}],staticClass:"form-control",attrs:{"placeholder":"Telefono del cliente"},domProps:{"value":(_vm.datos.Telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "Telefono", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Email")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.Email),expression:"datos.Email"}],staticClass:"form-control",attrs:{"placeholder":"Email del cliente"},domProps:{"value":(_vm.datos.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "Email", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Direccion")])]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.Direccion),expression:"datos.Direccion"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":"Direccion del cliente"},domProps:{"value":(_vm.datos.Direccion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "Direccion", $event.target.value)}}})])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.actualizar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Actualizar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body bg-light"},[_c('h2',[_c('span',{staticClass:"fa fa-quote-right mr-4"}),_vm._v(_vm._s(_vm.contrato.Titulo))])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-light"},[_c('b',[_c('span',{staticClass:"fa fa-file mr-2"}),_vm._v("Contrato nº "+_vm._s(_vm.contrato.ContratoOriginal)+" / "+_vm._s(_vm.contrato.ContratoID))])]),_c('div',{staticClass:"card-body",staticStyle:{"line-height":"20px"}},[_c('h4',[_c('b',[_vm._v(_vm._s(_vm.contrato.EmpresaNombre))])]),_c('div',{staticClass:"mt-3"},[_vm._v("CIF: "),_c('b',[_vm._v(_vm._s(_vm.contrato.EmpresaCIF))])]),_c('div',[_vm._v("Teléfono: "),_c('b',[_vm._v(_vm._s(_vm.contrato.EmpresaTelefono))])]),_c('div',[_vm._v("Fax: "),_c('b',[_vm._v(_vm._s(_vm.contrato.EmpresaFax))])]),_c('div',[_vm._v("Email: "),_c('b',[_vm._v(_vm._s(_vm.contrato.EmpresaEmail))])]),_c('div',[_vm._v("Dirección: "),_c('b',[_vm._v(_vm._s(_vm.contrato.EmpresaDireccion))])])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('div',{staticClass:"row"},[_vm._m(1),_c('div',{staticClass:"col text-right"},[(_vm.permisoEditarCliente)?_c('button',{staticClass:"btn btn-sm btn-dark",on:{"click":function($event){_vm.verEditor = true}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editar datos del cliente")]):_vm._e()])])]),_c('div',{staticClass:"card-body",staticStyle:{"line-height":"20px"}},[_c('h4',[_c('b',[_vm._v(_vm._s(_vm.contrato.cliente.NombreCliente))])]),_c('div',{staticClass:"mt-3"},[_vm._v("CIF: "),_c('b',[_vm._v(_vm._s(_vm.contrato.cliente.CIF))])]),_c('div',[_vm._v("Representante: "),_c('b',[_vm._v(_vm._s(_vm.contrato.cliente.Representante))])]),_c('div',[_vm._v("Teléfono: "),_c('b',[_vm._v(_vm._s(_vm.contrato.cliente.Telefono))])]),_c('div',[_vm._v("Email: "),_c('b',[_vm._v(_vm._s(_vm.contrato.cliente.Email))])]),_c('div',[_vm._v("Dirección: "),_c('b',[_vm._v(_vm._s(_vm.contrato.cliente.Direccion))])])])])])])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-between"}},[_c('div',{staticClass:"p-3"},[_c('b',[_vm._v("Fecha de inicio")]),_c('br'),_vm._v(_vm._s(_vm._f("moment")(_vm.contrato.FechaInicio,'DD-MM-YYYY')))]),_c('div',{staticClass:"p-3"},[_c('b',[_vm._v("Fecha de finalización")]),_c('br'),_vm._v(_vm._s(_vm._f("moment")(_vm.contrato.FechaFin,'DD-MM-YYYY')))]),_c('div',{staticClass:"p-3"},[_c('b',[_vm._v("Tipo de contrato")]),_c('br'),_vm._v(_vm._s(_vm.contrato.TipoNombre))]),_c('div',{staticClass:"p-3"},[_c('b',[_vm._v("Evento")]),_c('br'),_vm._v(_vm._s(_vm.contrato.EventoNombre || 'Ninguno'))]),_c('div',{staticClass:"p-3"},[_c('b',[_vm._v("Partida")]),_c('br'),_vm._v(_vm._s(_vm.contrato.PartidaNombre || 'Ninguno'))]),_c('div',{staticClass:"p-3"},[_c('b',[_vm._v("Intermediario")]),_c('br'),_vm._v(_vm._s(_vm.contrato.IntermediarioNombre || 'Ninguno'))])])])]),_vm._m(2),_c('div',{staticClass:"card"},[_c('table',{staticClass:"table table-striped m-0"},[_vm._m(3),_c('tbody',_vm._l((_vm.contrato.lineas),function(linea){return _c('tr',[_c('td',[(!linea.ArticuloID)?_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(linea.CatalogoNombre)+" -")]):_vm._e(),_c('span',[_vm._v(_vm._s(linea.Concepto))]),(linea.Unidades > 1)?_c('div',{staticStyle:{"display":"block","position":"relative"}},[_c('i',[_vm._v(_vm._s(linea.Unidades)+" unidades")])]):_vm._e()]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(linea.ImporteUnitario)))]),_c('td',[_vm._v(_vm._s(linea.Cantidad))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(linea.ImporteBruto)))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(linea.Descuento,'%')))]),_c('td',[(linea.Impuestos)?_c('span',[_vm._v(_vm._s(_vm._f("currency")(linea.ImpuestosNombre - linea.Impuestos,'%')))]):_c('span',[_vm._v("-")])]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(linea.ImporteNeto)))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(linea.ImporteTotal)))])])}),0)])]),_c('div',{staticClass:"mt-2 mb-4 text-right",staticStyle:{"text-align":"right"}},[_c('div',{staticClass:"text-left mr-3",staticStyle:{"position":"relative","display":"inline-block","max-width":"400px","vertical-align":"top"}},[_c('table',{staticClass:"table table-striped",staticStyle:{"min-width":"200px","max-width":"400px","border":"1px solid #e0e0e0"}},[_vm._m(4),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.contrato.Comentarios))])])])])]),_c('div',{staticClass:"text-left mr-3",staticStyle:{"position":"relative","display":"inline-block","max-width":"400px","vertical-align":"top"}},[_c('table',{staticClass:"table table-striped",staticStyle:{"min-width":"200px","max-width":"400px","border":"1px solid #e0e0e0"}},[_vm._m(5),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.contrato.FormaDePago))])]),(_vm.contrato.cliente.IBAN)?_c('tr',[_c('td',[_c('b',[_vm._v("IBAN:")]),_vm._v(" "+_vm._s(_vm.contrato.cliente.IBAN))])]):_vm._e()])])]),_c('div',{staticClass:"text-left",staticStyle:{"position":"relative","display":"inline-block","max-width":"400px","vertical-align":"top"}},[_c('table',{staticClass:"table table-striped",staticStyle:{"max-width":"400px","border":"1px solid #e0e0e0"}},[_vm._m(6),_c('tbody',[_c('tr',{staticClass:"text-right"},[_c('td',[_vm._v("Bruto")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.contrato.ImporteBruto)))])]),(_vm.contrato.DescuentoCadenaValor)?_c('tr',{staticClass:"text-right"},[_c('td',[_vm._v("Dto cad. valor")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.contrato.DescuentoCadenaValor,'%')))])]):_vm._e(),(_vm.contrato.DescuentoComercial)?_c('tr',{staticClass:"text-right"},[_c('td',[_vm._v("Descuento comercial")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.contrato.DescuentoComercial,'%')))])]):_vm._e(),_c('tr',{staticClass:"text-right"},[_c('td',[_vm._v("Neto")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.contrato.ImporteNeto)))])]),_c('tr',{staticClass:"text-right"}),_c('tr',{staticClass:"text-right"},[_c('td',[_vm._v("Impuestos")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.contrato.ImporteTotal - _vm.contrato.ImporteNeto)))])]),_c('tr',{staticClass:"bg-warning text-right",staticStyle:{"font-size":"1.3em"}},[_vm._m(7),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.contrato.ImporteTotal)))])])])])])])]),_vm._m(8),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Plan de facturación")]),_c('table',{staticClass:"table-striped table m-0"},[_vm._m(9),_c('tbody',_vm._l((_vm.contrato.facturacion),function(fac,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(fac.FechaFactura,'DD-MM-YYYY')))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(fac.ImporteNeto)))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(fac.ImporteTotal)))]),_c('td',[(fac.ReciboPagadaID)?_c('span',{staticClass:"fa fa-check"}):_vm._e()])])}),0)])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_vm._v("Plan de pagos")]),_c('table',{staticClass:"table-striped table m-0"},[_vm._m(10),_c('tbody',_vm._l((_vm.contrato.recibos),function(rec,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(rec.FechaVencimiento,'DD-MM-YYYY')))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(rec.ImporteTotal)))]),_c('td',[(rec.Estado === 'Pagado')?_c('span',{staticClass:"badge badge-succes p-2"},[_vm._v("Pagado")]):_c('span',{staticClass:"badge badge-warning p-2"},[_vm._v("Pendiente")])])])}),0)])])])]),(_vm.verEditor)?_c('EditorCliente',{attrs:{"contrato":_vm.contrato},on:{"actualizar":function($event){_vm.contrato.cliente = $event},"cerrar":function($event){_vm.verEditor=false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-file mr-2"}),_vm._v("Contrato")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-left"},[_c('b',[_c('span',{staticClass:"fa fa-building mr-2"}),_vm._v("Cliente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mb-2"},[_c('h3',[_vm._v("Servicios contratados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Concepto")]),_c('th',[_vm._v("Importe unitario")]),_c('th',[_vm._v("Cantidad")]),_c('th',[_vm._v("Bruto")]),_c('th',[_vm._v("Descuento")]),_c('th',[_vm._v("Impuestos")]),_c('th',[_vm._v("Neto")]),_c('th',[_vm._v("Total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"bg-dark text-white"},[_c('th',[_c('span',{staticClass:"fa fa-comments mr-2"}),_c('b',[_vm._v("Comentarios")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"bg-warning text-dark"},[_c('th',[_c('span',{staticClass:"fa fa-money mr-2"}),_c('b',[_vm._v("Forma de pago")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"bg-danger text-white"},[_c('th',{attrs:{"colspan":"2"}},[_c('span',{staticClass:"fa fa-calculator mr-2"}),_c('b',[_vm._v("Totales")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("TOTAL")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mb-2"},[_c('h3',[_vm._v("Facturación y pagos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha de emisión")]),_c('th',[_vm._v("Importe neto")]),_c('th',[_vm._v("Importe con impuestos")]),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha de vencimiento")]),_c('th',[_vm._v("Importe")]),_c('th',[_vm._v("Estado")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalFirma_vue__ = __webpack_require__(420);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bccc1be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modalFirma_vue__ = __webpack_require__(980);
function injectStyle (ssrContext) {
  __webpack_require__(975)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bccc1be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalFirma_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bccc1be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modalFirma_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_firmar_vue__ = __webpack_require__(421);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e84c930_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_firmar_vue__ = __webpack_require__(978);
function injectStyle (ssrContext) {
  __webpack_require__(977)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e84c930"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_firmar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e84c930_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_firmar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas"},[_vm._v("Lo siento, pero tu navegador no soporta esta función")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 979 */
/***/ (function(module, exports) {

var NifType = {
	'A': 'Sociedad Anónima',
	'B': 'Sociedad de Responsabilidad Limitada',
	'C': 'Sociedad Colectiva',
	'D': 'Sociedad Comanditaria',
	'E': 'Comunidad de Bienes',
	'F': 'Sociedad Cooperativa',
	'G': 'Asociación o Fundación',
	'H': 'Comunidad de Propietarios en Régimen de Propiedad Horizontal',
	'J': 'Sociedad Civil, con o sin Personalidad Jurídica',
	'K': 'Español menor de 14 años',
	'L': 'Español residente en el extranjero sin DNI',
	'M': 'NIF que otorga la Agencia Tributaria a extranjeros que no tienen NIE',
	'N': 'Entidad Extranjera',
	'P': 'Corporación Local',
	'Q': 'Organismo Autónomo, Estatal o no, o Asimilado, o Congregación o Institución Religiosa',
	'R': 'Congregación o Institución Religiosa (desde 2008, ORDEN EHA/451/2008)',
	'S': 'Órgano de la Administración General del Estado o de las Comunidades Autónomas',
	'U': 'Unión Temporal de Empresas',
	'V': 'Sociedad Agraria de Transformación',
	'W': 'Establecimiento permanente de entidad no residente en España',
	'X': 'Extranjero identificado por la Policía con un número de identidad de extranjero, NIE, asignado hasta el 15 de julio de 2008',
	'Y': 'Extranjero identificado por la Policía con un NIE, asignado desde el 16 de julio de 2008 (Orden INT/2058/2008, BOE del 15 de julio)',
	'Z': 'Letra reservada para cuando se agoten los "Y" para Extranjeros identificados por la Policía con un NIE'
};
var CifProv = {
	'00': 'No Residente',
	'01': 'Álava',
	'02': 'Albacete',
	'03': 'Alicante',
	'53': 'Alicante',
	'54': 'Alicante',
	'04': 'Almería',
	'05': 'Ávila',
	'06': 'Badajoz',
	'07': 'Islas Baleares',
	'57': 'Islas Baleares',
	'08': 'Barcelona',
	'58': 'Barcelona',
	'59': 'Barcelona',
	'60': 'Barcelona',
	'61': 'Barcelona',
	'62': 'Barcelona',
	'63': 'Barcelona',
	'64': 'Barcelona',
	'65': 'Barcelona',
	'66': 'Barcelona',
	'68': 'Barcelona',
	'09': 'Burgos',
	'10': 'Cáceres',
	'11': 'Cádiz',
	'72': 'Cádiz',
	'12': 'Castellón',
	'13': 'Ciudad Real',
	'14': 'Córdoba',
	'56': 'Córdoba',
	'15': 'La Coruña',
	'70': 'La Coruña',
	'16': 'Cuenca',
	'17': 'Gerona',
	'55': 'Gerona',
	'67': 'Gerona',
	'18': 'Granada',
	'19': 'Guadalajara',
	'20': 'Guipúzcoa',
	'75': 'Guipúzcoa',
	'21': 'Huelva',
	'22': 'Huesca',
	'23': 'Jaén',
	'24': 'León',
	'25': 'Lérida',
	'26': 'La Rioja',
	'27': 'Lugo',
	'28': 'Madrid',
	'78': 'Madrid',
	'79': 'Madrid',
	'80': 'Madrid',
	'81': 'Madrid',
	'82': 'Madrid',
	'83': 'Madrid',
	'84': 'Madrid',
	'85': 'Madrid',
	'86': 'Madrid',
	'87': 'Madrid',
	'29': 'Málaga',
	'92': 'Málaga',
	'93': 'Málaga',
	'30': 'Murcia',
	'73': 'Murcia',
	'31': 'Navarra',
	'71': 'Navarra',
	'32': 'Orense',
	'33': 'Asturias',
	'74': 'Asturias',
	'34': 'Palencia',
	'35': 'Las Palmas',
	'76': 'Las Palmas',
	'36': 'Pontevedra',
	'94': 'Pontevedra',
	'37': 'Salamanca',
	'38': 'Santa Cruz de Tenerife',
	'39': 'Cantabria',
	'40': 'Segovia',
	'41': 'Sevilla',
	'90': 'Sevilla',
	'91': 'Sevilla',
	'42': 'Soria',
	'43': 'Tarragona',
	'77': 'Tarragona',
	'44': 'Teruel',
	'45': 'Toledo',
	'46': 'Valencia',
	'96': 'Valencia',
	'97': 'Valencia',
	'98': 'Valencia',
	'47': 'Valladolid',
	'48': 'Vizcaya',
	'95': 'Vizcaya',
	'49': 'Zamora',
	'50': 'Zaragoza',
	'99': 'Zaragoza',
	'51': 'Ceuta',
	'52': 'Melilla'
};

module.exports = function (nif) {
	nif = nif.toUpperCase().replace(/[\s-]+/g, '');
	if (/^(\d|[XYZ])\d{7}[A-Z]$/.test(nif)) {
		var num = nif.match(/\d+/);
		num = (nif[0] !== 'Z' ? nif[0] !== 'Y' ? 0 : 1 : 2) + num;
		if (nif[8] === 'TRWAGMYFPDXBNJZSQVHLCKE'[num % 23]) {
			return (/^\d/.test(nif) ? 'DNI' : 'NIE: ' + NifType[nif[0]]
			);
		}
	} else if (/^[ABCDEFGHJKLMNPQRSUVW]\d{7}[\dA-J]$/.test(nif)) {
		for (var sum = 0, i = 1; i < 8; ++i) {
			var _num = nif[i] << i % 2;
			var uni = _num % 10;
			sum += (_num - uni) / 10 + uni;
		}
		var c = (10 - sum % 10) % 10;
		if (nif[8] === c || nif[8] === 'JABCDEFGHI'[c]) {
			var out = /^[KLM]/.test(nif) ? 'ESP' : 'CIF (' + CifProv[nif.substr(1, 2)] + ')';
			return out + ': ' + NifType[nif[0]];
		}
	}
	return false;
};

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contrato)?_c('modal',{attrs:{"max-width":800}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Firmar contrato"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),(_vm.fase === 1)?_c('div',{staticClass:"card-body"},[_c('h4',[_vm._v("Cláusulas")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.contrato.EmpresaTextoContratos)}})]):_vm._e(),(_vm.fase === 2)?_c('div',{staticClass:"card-body"},[_c('h4',[_vm._v("Protección de datos")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.contrato.EmpresaProteccionDeDatos)}})]):_vm._e(),(_vm.fase === 3)?_c('div',{staticClass:"card-body text-center"},[_c('div',{staticClass:"text-left",staticStyle:{"max-width":"350px","display":"inline-block"}},[_c('h5',[_vm._v("En representación de "),_c('b',[_vm._v(_vm._s(_vm.contrato.ClienteNombre))])]),_c('Firma',{ref:"firma",on:{"firma":function($event){return _vm.setFirma($event)}}}),_c('br'),_c('b',[_vm._v(_vm._s(_vm.contrato.ClienteRepresentante))]),_c('div',{staticStyle:{"text-align":"center","position":"relative","display":"block"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("DNI")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.DNI),expression:"DNI"}],staticClass:"form-control",class:(_vm.DNIValido) ? '' : 'has-error',attrs:{"placeholder":"XXXXXXXXXX"},domProps:{"value":(_vm.DNI)},on:{"input":function($event){if($event.target.composing){ return; }_vm.DNI=$event.target.value}}}),(!_vm.DNIValido)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger"},[_c('span',{staticClass:"fa fa-exclamation-triangle"})])]):_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-success"},[_c('span',{staticClass:"fa fa-check"})])])])])],1)]):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[(_vm.fase > 1)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.anterior()}}},[_c('span',{staticClass:"fa fa-caret-left mr-2"}),_vm._v("Anterior")]):_vm._e()]),(_vm.fase === 3)?_c('div',{staticClass:"col text-center"},[_c('button',{staticClass:"btn btn-warning",attrs:{"disabled":_vm.firmando || !_vm.DNIValido},on:{"click":function($event){return _vm.firmar()}}},[(!_vm.firmando)?_c('span',[_c('span',{staticClass:"fa fa-pencil mr-2"}),_vm._v("Firmar")]):_c('span',[_c('span',{staticClass:"fa fa-clock-o mr-2"}),_vm._v("Firmando")])])]):_vm._e(),_c('div',{staticClass:"col text-right"},[(_vm.fase < 3)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.siguiente()}}},[_vm._v("Siguiente"),_c('span',{staticClass:"fa fa-caret-right ml-2"})]):_vm._e(),(_vm.fase === 3)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.reset()}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Borrar firma")]):_vm._e()])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contrato)?_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3"},[(_vm.contrato.FechaEliminado)?_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-body bg-danger text-white"},[_c('span',{staticClass:"fa fa-trash mr-2 float-right",staticStyle:{"font-size":"4.5em","opacity":"0.3"}}),_vm._m(0),_vm._v("Eliminado por "+_vm._s(_vm.contrato.UsuarioEliminadoNombre)),_c('br'),_vm._v("el "+_vm._s(_vm._f("moment")(_vm.contrato.FechaEliminado,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.contrato.FechaEliminado,'hh:mm:ss')))]),(_vm.finalizado && !_vm.contrato.FechaEliminado)?_c('div',{staticClass:"card-body bg-success text-white"},[_c('span',{staticClass:"fa fa-check mr-2 float-right",staticStyle:{"font-size":"4.5em","opacity":"0.3"}}),_vm._m(1)]):_vm._e()]):_vm._e(),_c('div',{staticClass:"card"},[_vm._m(2),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticStyle:{"display":"table-row"}},[_c('div',{staticClass:"text-center",staticStyle:{"display":"table-cell","width":"50px"}},[_c('avatar',{attrs:{"usuario":_vm.contrato.AgenteID,"avatar":_vm.contrato.AgenteAvatar,"width":70}})],1),_c('div',{staticClass:"text-left p-2",staticStyle:{"display":"table-cell","vertical-align":"middle","font-size":"1.3em","font-weight":"bold"}},[_c('span',{staticClass:"text-danger"},[_vm._v("Agente")]),_c('br'),_vm._v(_vm._s(_vm.contrato.AgenteNombre))])])]),_vm._m(3),_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Fecha de creación")]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.contrato.FechaCreacion,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.contrato.FechaCreacion,'HH:mm:ss')))])]),_c('tr',[_c('td',[_vm._v("Creado por")]),_c('td',[_vm._v(_vm._s(_vm.contrato.UsuarioNombre))])]),(!_vm.contrato.FechaModificacion)?_c('tr',[_c('td',[_vm._v("Fase candidato")]),_c('td',[(_vm.contrato.FechaCandidato)?_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.contrato.FechaCandidato,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.contrato.FechaCandidato,'hh:mm:ss'))),_c('br'),_vm._v(_vm._s(_vm.contrato.UsuarioCandidatoNombre))]):_c('span',[(_vm.contrato.AgenteID === _vm.usuario.ID || _vm.permisos.contratos_crearAjenos)?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.setCandidato}},[_vm._v("Convertir en candidato")]):_vm._e()])])]):_c('tr',{staticClass:"text-danger"},[_c('td',[_vm._v("Contrato descartado")]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.contrato.FechaModificacion,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.contrato.FechaModificacion,'hh:mm:ss')))])]),(_vm.contrato.Estado === 'Candidato' && !_vm.hayFirma && _vm.permisos.contratos_firmaManuscrita)?_c('tr',{staticClass:"bg-warning"},[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('span',{staticClass:"fa fa-edit",staticStyle:{"font-size":"2em"}}),_c('p',[_vm._v("Firmar digitalmente")]),_c('button',{staticClass:"btn btn-sm btn-dark",on:{"click":_vm.firmar}},[_c('span',{staticClass:"fa fa-pencil mr-2"}),_vm._v("Firmar")])])]):_vm._e(),(!_vm.contrato.FechaAprobado && !_vm.contrato.FechaRechazado && _vm.contrato.FechaCandidato && _vm.permisos.contratos_aprobar && _vm.hayFirma)?_c('tr',[_c('td'),_c('td',[_c('button',{staticClass:"btn btn-sm btn-success m-1",on:{"click":_vm.setAprobado}},[_vm._v("Aprobar")]),_c('button',{staticClass:"btn btn-sm btn-danger m-1",on:{"click":_vm.setRechazado}},[_vm._v("Rechazar")])])]):_vm._e(),(!_vm.hayFirma && _vm.contrato.Estado === 'Candidato')?_c('tr',[_c('td',{staticClass:"bg-danger text-white text-center",attrs:{"colspan":"2"}},[_c('span',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"font-size":"2em"}}),_c('p',[_vm._v("Adjuntar contrato firmado en pdf")]),(!_vm.hayFirma && _vm.contrato.Estado === 'Candidato')?_c('button',{staticClass:"btn btn-sm btn-dark",on:{"click":function($event){return _vm.upload(true)}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Subir firma")]):_vm._e()])]):_vm._e(),(_vm.contrato.FechaAprobado)?_c('tr',{staticClass:"text-success"},[_c('td',[_vm._v("Aprobado")]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.contrato.FechaAprobado,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.contrato.FechaAprobado,'hh:mm:ss'))),_c('br'),_vm._v(_vm._s(_vm.contrato.UsuarioAprobadoNombre))])]):_vm._e(),(_vm.contrato.FechaRechazado)?_c('tr',{staticClass:"text-danger"},[_c('td',[_vm._v("Rechazado")]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(_vm.contrato.FechaRechazado,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.contrato.FechaRechazado,'hh:mm:ss'))),_c('br'),_vm._v(_vm._s(_vm.contrato.UsuarioRechazadoNombre))])]):_vm._e(),(_vm.contrato.FechaBloqueado)?_c('tr',{staticClass:"text-danger"},[_c('td',[_vm._v("Bloqueado")]),_c('td',[_c('p',[_vm._v("Este contrato está bloqueado por "),_c('b',[_vm._v(_vm._s(_vm.contrato.UsuarioBloqueaNombre))]),_vm._v(" debido a un traspaso de cartera.")]),_vm._m(4)])]):_vm._e()])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary m-1",on:{"click":function($event){_vm.imprimir = true}}},[_c('span',{staticClass:"fa fa-print"})]),_c('a',{ref:"linkDescarga",staticClass:"btn btn-warning m-1",attrs:{"download":"Contrato.pdf","href":'/src/modulos/mis-contratos/php/api/get-pdf-contrato.php?ContratoID=' + _vm.contrato.ContratoID}},[_c('span',{staticClass:"fa fa-file-pdf-o"})]),(!_vm.contrato.FechaBloqueado)?_c('button',{staticClass:"btn btn-warning m-1",on:{"click":_vm.editar}},[_c('span',{staticClass:"fa fa-edit"})]):_vm._e(),(_vm.eliminable)?_c('button',{staticClass:"btn btn-danger m-1",on:{"click":_vm.setEliminado}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()])]),_c('div',{staticClass:"card mt-3"},[_vm._m(5),_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.contrato.ficheros),function(fichero){return _c('tr',{key:fichero.FicheroID,class:(fichero.EsContratoFirmado) ? 'bg-warning' : ''},[_c('td',{staticClass:"p-1 pl-2",staticStyle:{"vertical-align":"middle"}},[(fichero.EsContratoFirmado)?_c('span',{staticClass:"fa fa-edit mr-2"}):_vm._e(),_c('div',{staticClass:"truncate-text",attrs:{"title":fichero.Nombre}},[_vm._v(_vm._s(fichero.Nombre))]),_c('span',{staticClass:"ml-2",staticStyle:{"opacity":"0.5"}},[_vm._v(_vm._s(_vm._f("tamano")(fichero.Tamano)))])]),_c('td',{staticClass:"p-1"},[(fichero.Extension.toLowerCase() === 'pdf')?_c('a',{staticClass:"btn m-1 btn-sm btn-primary",attrs:{"target":"_blank","href":'/src/modulos/mis-contratos/php/api/ficheroVer.php?FicheroID=' + fichero.FicheroID}},[_c('span',{staticClass:"fa fa-eye"})]):_vm._e(),(fichero.Extension.toLowerCase() !== 'pdf')?_c('a',{staticClass:"btn m-1 btn-sm btn-success",attrs:{"target":"_blank","href":'/src/modulos/mis-contratos/php/api/ficheroDownload.php?FicheroID=' + fichero.FicheroID}},[_c('span',{staticClass:"fa fa-download"})]):_vm._e(),(_vm.permisoBorrarFichero(fichero))?_c('button',{staticClass:"btn m-1 btn-sm btn-danger",on:{"click":function($event){return _vm.eliminarFichero(fichero)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()])])}),0)]),(!_vm.contrato.ficheros || _vm.contrato.ficheros.length === 0)?_c('div',{staticClass:"card-body text-center"},[_c('h4',[_vm._v("No hay ficheros")])]):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.upload(false)}}},[_c('span',{staticClass:"fa fa-upload mr-2"}),_vm._v("Subir fichero")])]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.upload(true)}}},[_c('span',{staticClass:"fa fa-upload mr-2"}),_vm._v("Subir otra firma")])])])])]),_c('div',{staticClass:"card mt-3"},[_vm._m(6),_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.contrato.historico),function(edicion){return _c('tr',{key:edicion.ContratoID,class:(_vm.ContratoID === edicion.ContratoID) ? 'bg-dark text-white' : ''},[_c('td',[_vm._v(_vm._s(edicion.UsuarioNombre))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(edicion.FechaCreacion,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(edicion.FechaCreacion,'HH:mm:ss')))]),_c('td',[_c('router-link',{staticClass:"btn btn-primary btn-sm",attrs:{"to":'/main/contratos/listado/' + edicion.ContratoID}},[_c('span',{staticClass:"fa fa-eye"})])],1)])}),0)])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9"},[_c('detalles-contrato',{attrs:{"contrato":_vm.contrato},on:{"actualizar":_vm.getContrato}})],1)]),(_vm.imprimir)?_c('imprimir',{attrs:{"color":true,"dobleCara":true,"impresora":"Comercial"},on:{"cerrar":function($event){_vm.imprimir = null},"imprimir":function($event){return _vm.goImprimir($event)}}}):_vm._e(),(_vm.verFirma)?_c('firmar',{attrs:{"contrato":_vm.contrato},on:{"cerrar":function($event){_vm.verFirma = false},"firmado":function($event){return _vm.contratoFirmado()}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('b',[_vm._v("Contrato eliminado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('b',[_vm._v("Contrato finalizado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-info mr-2"}),_vm._v("Información")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_c('b',[_vm._v("Datos generales")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("No se podrá modificar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Ficheros")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Historial de ediciones")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Gráficos"),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"nav nav-tabs"},[(_vm.graficoReal)?_c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'real') ? 'active' : '',on:{"click":function($event){return _vm.setSeccion('real')}}},[_vm._v("Real")])]):_vm._e(),(_vm.graficoAcumulado)?_c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'acumulado') ? 'active' : '',on:{"click":function($event){return _vm.setSeccion('acumulado')}}},[_vm._v("Acumulado")])]):_vm._e(),(_vm.graficoTotal)?_c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'total') ? 'active' : '',on:{"click":function($event){return _vm.setSeccion('total')}}},[_vm._v("Total")])]):_vm._e(),(_vm.listadoContratos)?_c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'contratos') ? 'active' : '',on:{"click":function($event){return _vm.setSeccion('contratos')}}},[_vm._v("Contratos")])]):_vm._e()])]),_c('div',[(_vm.seccion === 'real')?_c('representar',{attrs:{"datos":_vm.graficoReal}}):_vm._e(),(_vm.seccion === 'acumulado')?_c('representar',{attrs:{"datos":_vm.graficoAcumulado}}):_vm._e(),(_vm.seccion === 'total')?_c('representar',{attrs:{"datos":_vm.graficoTotal}}):_vm._e()],1),_c('div',[(_vm.seccion === 'real')?_c('div',[_c('h4',[_vm._v("Real")]),(_vm.datosReal)?_c('representar',{attrs:{"datos":_vm.datosReal}}):_vm._e()],1):_vm._e(),(_vm.seccion === 'acumulado')?_c('div',[_c('h4',[_vm._v("Real acumulado")]),(_vm.datosRealAcumulado)?_c('representar',{attrs:{"datos":_vm.datosRealAcumulado}}):_vm._e()],1):_vm._e(),(_vm.seccion === 'total')?_c('div',[_c('h4',[_vm._v("Total anual")]),(_vm.datosRealTotal)?_c('representar',{attrs:{"datos":_vm.datosRealTotal}}):_vm._e()],1):_vm._e(),(_vm.seccion === 'contratos')?_c('div',{staticClass:"table-responsive text-left"},[_c('download-excel',{staticClass:"m-2 btn btn-warning btn-sm",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"meta":_vm.json_meta,"name":"informe.xls"}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("XLS")]),_c('table',{staticClass:"table table-striped table-condensed"},[_vm._m(0),_c('tbody',_vm._l((_vm.listadoContratos),function(linea){return _c('tr',{key:linea.contratoId + '' + linea.fecha.getMonth() + '' + linea.soporteNombre + '' + linea.facturacionId},[_c('td',[_vm._v(_vm._s(_vm.meses[linea.fecha.getMonth()])+", "+_vm._s(linea.fecha.getFullYear()))]),_c('td',[_vm._v(_vm._s(linea.soporteNombre))]),_c('td',[_vm._v(_vm._s(linea.clienteNombre))]),_c('td',[_vm._v(_vm._s(linea.agenteNombre))]),_c('td',{staticClass:"contrato",on:{"click":function($event){_vm.ContratoID = linea.contratoId}}},[_vm._v(_vm._s(linea.contratoTitulo))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(linea.importe)))])])}),0),_c('tbody',[_c('tr',{staticClass:"bg-dark text-white"},[_vm._m(1),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(_vm.sumaFacturacion)))])])])])],1):_vm._e()])])])]),(_vm.ContratoID)?_c('modal',{attrs:{"max-width":1600,"top":10}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('button',{staticClass:"close",on:{"click":function($event){_vm.ContratoID=null}}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('VisorContrato',{attrs:{"ContratoID":_vm.ContratoID}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Mes")]),_c('th',[_vm._v("Soporte")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("Contrato")]),_c('th',{staticClass:"text-right"},[_vm._v("Importe")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right",attrs:{"colspan":"5"}},[_c('b',[_vm._v("Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_graficoDetalle_vue__ = __webpack_require__(422);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27010712_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_graficoDetalle_vue__ = __webpack_require__(985);
function injectStyle (ssrContext) {
  __webpack_require__(984)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27010712"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_graficoDetalle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27010712_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_graficoDetalle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.datos.campo.nombre)+" ("+_vm._s(_vm.datos.agente.info.nombre)+") - "+_vm._s(_vm.datos.dimension)),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"mt-2"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'real') ? 'active' : '',on:{"click":function($event){return _vm.setSeccion('real')}}},[_vm._v("Real")])]),_c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'acumulado') ? 'active' : '',on:{"click":function($event){return _vm.setSeccion('acumulado')}}},[_vm._v("Acumulado")])]),_c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'total') ? 'active' : '',on:{"click":function($event){return _vm.setSeccion('total')}}},[_vm._v("Total")])]),_c('li',{staticClass:"nav-item",staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'contratos') ? 'active' : '',on:{"click":function($event){return _vm.setSeccion('contratos')}}},[_vm._v("Contratos")])])])]),_c('div',[(_vm.seccion === 'real')?_c('div',[_c('h4',[_vm._v("Real")]),(_vm.datosReal)?_c('representar',{attrs:{"datos":_vm.datosReal}}):_vm._e()],1):_vm._e(),(_vm.seccion === 'acumulado')?_c('div',[_c('h4',[_vm._v("Real acumulado")]),(_vm.datosRealAcumulado)?_c('representar',{attrs:{"datos":_vm.datosRealAcumulado}}):_vm._e()],1):_vm._e(),(_vm.seccion === 'total')?_c('div',[_c('h4',[_vm._v("Total anual")]),(_vm.datosRealTotal)?_c('representar',{attrs:{"datos":_vm.datosRealTotal}}):_vm._e()],1):_vm._e(),(_vm.seccion === 'contratos')?_c('div',{staticClass:"table-responsive text-left"},[_c('download-excel',{staticClass:"m-2 btn btn-warning btn-sm",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"meta":_vm.json_meta,"name":"informe.xls"}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("XLS")]),_c('table',{staticClass:"table table-striped table-condensed"},[_vm._m(0),_c('tbody',_vm._l((_vm.lineasFacturacion),function(linea){return _c('tr',{key:linea.ID_contrato},[_c('td',[_vm._v(_vm._s(_vm.meses[linea.fecha.getMonth()])+", "+_vm._s(linea.fecha.getFullYear()))]),_c('td',[_vm._v(_vm._s(linea.soporteNombre))]),_c('td',[_vm._v(_vm._s(linea.clienteNombre))]),_c('td',[_vm._v(_vm._s(linea.agenteNombre))]),_c('td',{staticClass:"contrato",on:{"click":function($event){_vm.ContratoID = linea.contratoId}}},[_vm._v(_vm._s(linea.contratoTitulo))]),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(linea.importe,''))+" €")])])}),0),_c('tbody',[_c('tr',{staticClass:"bg-dark text-white"},[_vm._m(1),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(_vm.sumaFacturacion,''))+" €")])])])])],1):_vm._e()])])])]),(_vm.ContratoID)?_c('modal',{attrs:{"max-width":1600,"top":10}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('button',{staticClass:"close",on:{"click":function($event){_vm.ContratoID=null}}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('VisorContrato',{attrs:{"ContratoID":_vm.ContratoID}})],1)])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Mes")]),_c('th',[_vm._v("Soporte")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("Contrato")]),_c('th',{staticClass:"text-right"},[_vm._v("Importe")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right",attrs:{"colspan":"5"}},[_c('b',[_vm._v("Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("\n\t\t\tOpciones de filtrado\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.permisos.facturacion_consultar_todos)?_c('div',{staticClass:"mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('h6',[_vm._v("Agente")]),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm"},[_c('input-query',{attrs:{"url":"consultas-facturacion/php/api/porAgente/query-agentes.php","realtime":true,"input-class":"form-control form-control-sm m-0 p-0"},on:{"selected":function($event){return _vm.otroAgente($event)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.getActivos()}}},[_c('span',{staticClass:"fa fa-users"})])])],1),_vm._v(" "),(_vm.filtro.agentes.length > 0)?_c('div',{staticClass:"bg-light p-1 m-1",staticStyle:{"position":"relative","display":"block"}},_vm._l((_vm.filtro.agentes),function(agente){return _c('button',{key:agente.ID,staticClass:"m-1 btn btn-sm btn-warning",on:{"click":function($event){return _vm.quitaAgente(agente.ID)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(agente.nombre)+"\n\t\t\t\t\t\t")])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt-1"},[_c('button',{staticClass:"m-1 btn btn-sm",class:(_vm.filtro.verTodosAgentes) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.verTodosAgentes = !_vm.filtro.verTodosAgentes}}},[_vm._v("Todos sumados")]),_vm._v(" "),_c('button',{staticClass:"m-1 btn btn-sm",class:(_vm.filtro.verSinAgente) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.verSinAgente = !_vm.filtro.verSinAgente}}},[_vm._v("Sin agente")])])]):_vm._e(),_vm._v(" "),(!_vm.permisos.facturacion_consultar_todos)?_c('div',{staticClass:"mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('H6',[_vm._v("Agente")]),_vm._v(" "),_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"50px","height":"50px","vertical-align":"middle","margin-right":"10px"},attrs:{"src":_vm.usuario.avatar,"alt":""}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.usuario.nombre)+" "+_vm._s(_vm.usuario.apellidos))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('h6',[_vm._v("Intérvalo de fechas")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('datepicker',{attrs:{"format":"MMMM, yyyy","placeholder":"Inicio","monday-first":true,"language":_vm.$dateLang,"input-class":"form-control form-control-sm","minimum-view":"month"},model:{value:(_vm.filtro.fecha_ini),callback:function ($$v) {_vm.$set(_vm.filtro, "fecha_ini", $$v)},expression:"filtro.fecha_ini"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('datepicker',{attrs:{"format":"MMMM, yyyy","placeholder":"Fin","monday-first":true,"language":_vm.$dateLang,"input-class":"form-control form-control-sm","minimum-view":"month"},model:{value:(_vm.filtro.fecha_fin),callback:function ($$v) {_vm.$set(_vm.filtro, "fecha_fin", $$v)},expression:"filtro.fecha_fin"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('label',{attrs:{"for":""}},[_vm._v("Título del contrato")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.titulo),expression:"filtro.titulo"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.filtro.titulo)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.consultar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "titulo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('h6',[_vm._v("Soportes")]),_vm._v(" "),_vm._l((_vm.listadoSoportes),function(soporte){return _c('button',{key:soporte.ID_soporte,staticClass:"m-1 btn btn-sm",class:(_vm.filtro.soportes.indexOf(soporte.ID_soporte) >= 0) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.toggleSoporte(soporte.ID_soporte)}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(soporte.soporte)+"\n\t\t\t\t\t")])})],2),_vm._v(" "),_c('div',{staticClass:"mb-2 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('h6',[_vm._v("Campos")]),_vm._v(" "),_vm._l((_vm.listadoCampos),function(campo){return _c('button',{key:campo.ID,staticClass:"m-1 btn btn-sm",class:(_vm.filtro.campos.indexOf(campo.ID) >= 0) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.toggleCampo(campo.ID)}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(campo.nombre)+"\n\t\t\t\t\t")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"border-top":"10px solid #e0e0e0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('h6',[_vm._v("Partidas")]),_vm._v(" "),_c('table',{staticClass:"table table-condensed",staticStyle:{"border":"1px solid #e0e0e0"}},[_c('tbody',_vm._l((_vm.filtro.partidas),function(partida,index){return _c('tr',{key:partida.ID_destino},[_c('td',{staticClass:"p-0 pl-2",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(partida.titulo))]),_vm._v(" "),_c('td',{staticClass:"p-0 text-right"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.partidas[index].d) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.partidas[index].d = !_vm.filtro.partidas[index].d}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tD\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.partidas[index].c) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.partidas[index].c = !_vm.filtro.partidas[index].c}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tC\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.partidas[index].r) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.partidas[index].r = !_vm.filtro.partidas[index].r}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tR\n\t\t\t\t\t\t\t\t\t\t")])])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('h6',[_vm._v("Facturado a:")]),_vm._v(" "),_c('div',_vm._l((_vm.listadoDestinos),function(destino){return _c('button',{key:destino.DestinoID,staticClass:"m-1 btn btn-sm",class:(_vm.filtro.destinos.indexOf(destino.DestinoID) >= 0) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleDestino(destino.DestinoID)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(destino.Nombre)+"\n\t\t\t\t\t\t")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('h6',[_vm._v("Eventos")]),_vm._v(" "),_c('table',{staticClass:"table table-condensed",staticStyle:{"border":"1px solid #e0e0e0"}},[_c('tbody',_vm._l((_vm.filtro.eventos),function(evento,index){return _c('tr',{key:evento.ID},[_c('td',{staticClass:"p-0 pl-2",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(evento.nombre))]),_vm._v(" "),_c('td',{staticClass:"p-0 text-right"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.eventos[index].d) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.eventos[index].d = !_vm.filtro.eventos[index].d}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tD\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.eventos[index].c) ? 'btn-primary' : '',attrs:{"disabled":_vm.filtro.eventos[index].c === null},on:{"click":function($event){_vm.filtro.eventos[index].c = !_vm.filtro.eventos[index].c}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tC\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.eventos[index].r) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.eventos[index].r = !_vm.filtro.eventos[index].r}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tR\n\t\t\t\t\t\t\t\t\t\t")])])])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.consultar()}}},[_c('span',{staticClass:"fa fa-search mr-1"}),_vm._v("\n\t\t\t\tConsultar\n\t\t\t")])])]),_vm._v(" "),(_vm.resultados !== null)?_c('div',{staticClass:"m-2"},_vm._l((_vm.resultados.agentes),function(agente){return _c('div',{key:agente.info.agenteId,staticClass:"card mb-3"},[_c('div',{staticClass:"card-header bg-info text-white",staticStyle:{"font-size":"1.2em","font-weight":"bold"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-user mr-1"}),_vm._v("\n\t\t\t\t\t\t"+_vm._s(agente.info.nombre)+"\n\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"m-0 table table-condensed table-striped"},[_c('thead',{staticClass:"bg-light"},[_c('tr',[_c('td',{staticClass:"bg-dark"}),_vm._v(" "),(_vm.resultados.soportes)?_vm._l((_vm.resultados.soportes),function(soporte){return _c('td',{key:'sop_' + soporte.id,staticClass:"text-right"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(soporte.nombre)+"\n\t\t\t\t\t\t\t\t")])}):_vm._e(),_vm._v(" "),(_vm.resultados.eventos && _vm.resultados.eventos.c)?_vm._l((_vm.resultados.eventos.c),function(evento){return _c('td',{key:'ev_'+evento.id,staticClass:"text-right"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(evento.titulo)+"\n\t\t\t\t\t\t\t\t")])}):_vm._e(),_vm._v(" "),(_vm.resultados.partidas && _vm.resultados.partidas.c)?_vm._l((_vm.resultados.partidas.c),function(partida){return _c('td',{key:'par_'+partida.id,staticClass:"text-right"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(partida.titulo)+"\n\t\t\t\t\t\t\t\t")])}):_vm._e(),_vm._v(" "),(_vm.resultados.totales)?_vm._l((_vm.resultados.totales),function(total){return _c('td',{key:'tot_' + total.nombre,staticClass:"text-right bg-danger text-white"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(total.nombre)+"\n\t\t\t\t\t\t\t\t")])}):_vm._e()],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.resultados.campos),function(campo){return _c('tr',{key:campo.id},[_c('td',{staticClass:"text-right bg-dark text-white"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(campo.nombre)+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),(_vm.resultados.soportes)?_vm._l((_vm.resultados.soportes),function(soporte){return _c('td',{key:agente.info.agenteId+'_'+campo.id+'_sop_'+soporte.id,staticClass:"text-right",class:(campo.id.match(/^(cobertura|cobertura_acum)$/)) ? 'bg-warning' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verDetalles(agente, campo, agente.campos[campo.id].datos.soportes[soporte.id].facturacion, soporte.nombre)}}},[(campo.id.match(/^(cobertura|cobertura_acum)$/))?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(agente.campos[campo.id].datos.soportes[soporte.id].importe,'%'))+"\n\t\t\t\t\t\t\t\t\t\t")]):_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(agente.campos[campo.id].datos.soportes[soporte.id].importe))+"\n\t\t\t\t\t\t\t\t\t\t")])])}):_vm._e(),_vm._v(" "),(_vm.resultados.eventos)?_vm._l((_vm.resultados.eventos.c),function(evento){return _c('td',{key:agente.info.agenteId+'_'+campo.id+'_ev_'+evento.id,staticClass:"text-right",class:(campo.id.match(/^(cobertura|cobertura_acum)$/)) ? 'bg-warning' : 'bg-info text-white',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verDetalles(agente, campo, agente.campos[campo.id].datos.eventos[evento.id].facturacion, 'Eventos')}}},[(campo.id.match(/^(cobertura|cobertura_acum)$/))?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(agente.campos[campo.id].datos.eventos[evento.id].importe,'%'))+"\n\t\t\t\t\t\t\t\t\t\t")]):_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(agente.campos[campo.id].datos.eventos[evento.id].importe))+"\n\t\t\t\t\t\t\t\t\t\t")])])}):_vm._e(),_vm._v(" "),(_vm.resultados.partidas && _vm.resultados.partidas.c)?_vm._l((_vm.resultados.partidas.c),function(partida){return _c('td',{key:agente.info.agenteId+'_'+campo.id+'_par_'+partida.id,staticClass:"text-right",class:(campo.id.match(/^(cobertura|cobertura_acum)$/)) ? 'bg-warning' : 'bg-info text-white',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verDetalles(agente, campo, agente.campos[campo.id].datos.partidas[partida.id].facturacion, partida.titulo)}}},[(campo.id.match(/^(cobertura|cobertura_acum)$/))?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(agente.campos[campo.id].datos.partidas[partida.id].importe,'%'))+"\n\t\t\t\t\t\t\t\t\t\t")]):_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(agente.campos[campo.id].datos.partidas[partida.id].importe))+"\n\t\t\t\t\t\t\t\t\t\t")])])}):_vm._e(),_vm._v(" "),(_vm.resultados.totales)?_vm._l((_vm.resultados.totales),function(total){return _c('td',{key:agente.info.agenteId+'_'+campo.id+'_tot_'+total.nombre,staticClass:"text-right bg-danger text-white",style:((campo.id === 'real') ? {cursor: 'pointer'} : {}),on:{"click":function($event){return _vm.verGraficos(agente, campo)}}},[(campo.id.match(/^(cobertura|cobertura_acum)$/))?_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(agente.totales[total.nombre].datos.campos[campo.id].importe,'%'))+"\n\t\t\t\t\t\t\t\t\t\t")]):_c('span',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(agente.totales[total.nombre].datos.campos[campo.id].importe))+"\n\t\t\t\t\t\t\t\t\t\t")])])}):_vm._e()],2)}),0)])])])}),0):_vm._e(),_vm._v(" "),(_vm.grafico)?_c('graficos-totales',{attrs:{"datos":_vm.grafico},on:{"cerrar":function($event){_vm.grafico = null}}}):_vm._e(),_vm._v(" "),(_vm.detalles)?_c('graficos-detalles',{attrs:{"datos":_vm.detalles},on:{"cerrar":function($event){_vm.detalles = null}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190d8161_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(988);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190d8161_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Por meses")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(423);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d191a67e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1001);
function injectStyle (ssrContext) {
  __webpack_require__(990)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d191a67e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d191a67e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var uri = 'consultas-facturacion/php/api/porClientes/';

var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(uri + url);
};

var post = function post(url, datos) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(uri + url, datos);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getFormulario: function getFormulario() {
		return get('get-formulario.php');
	},
	consultar: function consultar(datos) {
		var filtro = _.clone(datos);
		if (filtro.tipoFecha === 'intervalo') {
			filtro.fecha_ini = Math.floor(datos.fecha_ini.getTime() / 1000);
			filtro.fecha_fin = Math.floor(datos.fecha_fin.getTime() / 1000);
		} else {
			filtro.fecha_ini = new Date(datos.fecha_ini.getTime());
			filtro.fecha_ini.setMonth(0);
			filtro.fecha_ini.setDate(1);
			filtro.fecha_ini.setHours(0);
			filtro.fecha_ini.setMinutes(0);
			filtro.fecha_ini.setSeconds(0);
			filtro.fecha_ini.setMilliseconds(0);
			filtro.fecha_ini = Math.floor(filtro.fecha_ini.getTime() / 1000);

			filtro.fecha_fin = new Date(datos.fecha_fin.getTime());
			filtro.fecha_fin.setMonth(11);
			filtro.fecha_fin.setDate(31);
			filtro.fecha_fin.setHours(23);
			filtro.fecha_fin.setMinutes(59);
			filtro.fecha_fin.setSeconds(59);
			filtro.fecha_fin.setMilliseconds(999);
			filtro.fecha_fin = Math.floor(datos.fecha_fin.getTime() / 1000);
		}
		return post('consultar.php', filtro);
	}
});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',{staticStyle:{"max-width":"1000px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.cliente)+" - "+_vm._s(_vm.tipo)+"\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-3"},[_c('table',{staticClass:"table table-condensed table-striped text-right"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.meses),function(importe,mes){return (importe.importe !== 0)?_c('tr',{key:mes},[_c('td',{staticClass:"text-left"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.getMes(mes))+"\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(importe.importe,''))+" €\n\t\t\t\t\t\t\t\t\t")])]):_vm._e()}),0),_vm._v(" "),_c('tbody',{staticClass:"bg-dark text-white"},[_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("TOTAL:")]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.importeTotal,''))+" €")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9"},[_c('chartjs-bar',{attrs:{"datalabel":'Facturación ' + _vm.cliente,"height":200,"labels":_vm.labelMeses,"data":_vm.chartData}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("Mes")]),_vm._v(" "),_c('th',[_vm._v("Importe")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaIntervalo_vue__ = __webpack_require__(426);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d637d44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tablaIntervalo_vue__ = __webpack_require__(995);
function injectStyle (ssrContext) {
  __webpack_require__(994)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d637d44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaIntervalo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d637d44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tablaIntervalo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.resultados && _vm.resultados.clientes.length > 0)?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Resultados"),_c('download-excel',{staticClass:"btn btn-warning btn-sm",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"meta":_vm.json_meta,"name":"informe.xls"}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("XLS")])],1),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-condensed text-right"},[_c('thead',[_c('tr',{staticClass:"bg-dark text-white"},[_c('th',{on:{"click":function($event){return _vm.ordenar('nombre', 'nombre')}}},[_vm._v("Cliente"),(_vm.orden.tipo === 'nombre')?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()]),_vm._l((_vm.resultados.campos),function(campo){return _c('th',{key:campo.campo,on:{"click":function($event){return _vm.ordenar('campo', campo.campo)}}},[_vm._v(_vm._s(campo.nombre)),(_vm.orden.tipo === 'campo' && _vm.orden.campo === campo.campo)?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()])}),(_vm.resultados.clientes[0].soportes && _vm.resultados.clientes[0].soportes.length > 0)?_vm._l((_vm.resultados.clientes[0].soportes),function(soporte,i){return _c('th',{key:soporte.ID_soporte,on:{"click":function($event){return _vm.ordenar('soporte', i)}}},[_vm._v(_vm._s(soporte.nombre)),(_vm.orden.tipo === 'soporte' && _vm.orden.campo === i)?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()])}):_vm._e(),(_vm.resultados.clientes[0].eventos)?[_c('th',{on:{"click":function($event){return _vm.ordenar('eventos', 'eventos')}}},[_vm._v("Eventos")]),(_vm.orden.tipo === 'eventos')?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()]:_vm._e(),(_vm.resultados.clientes[0].partidas && _vm.resultados.clientes[0].partidas.length > 0)?_vm._l((_vm.resultados.clientes[0].partidas),function(partida,i){return _c('th',{key:partida.ID,on:{"click":function($event){return _vm.ordenar('partida', i)}}},[_vm._v(_vm._s(partida.nombre)),(_vm.orden.tipo === 'partida' && _vm.orden.campo === i)?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()])}):_vm._e()],2)]),_c('tbody',_vm._l((_vm.resultadosClientes),function(cliente){return _c('tr',{key:cliente.ID_cliente},[_c('td',[_vm._v(_vm._s(cliente.nombre))]),_vm._l((cliente.campos),function(campo,id){return _c('td',{key:campo.campo,staticClass:"importe",on:{"click":function($event){return _vm.verDetalles(cliente.nombre, campo.meses, campo.nombre)}}},[_vm._v(_vm._s(_vm._f("currency")(campo.importe,''))),(id === 'cobertura')?_c('span',[_vm._v("%")]):_vm._e(),(id !== 'cobertura')?_c('span',[_vm._v("€")]):_vm._e()])}),(cliente.soportes && cliente.soportes.length > 0)?_vm._l((cliente.soportes),function(soporte){return _c('td',{key:soporte.ID_soporte,staticClass:"importe",on:{"click":function($event){return _vm.verDetallesSoporte(cliente.nombre, soporte.meses, 'Soporte: ' + soporte.nombre)}}},[_vm._v(_vm._s(_vm._f("currency")(soporte.total.real,''))+" €")])}):_vm._e(),(cliente.eventos)?[_c('td',{staticClass:"importe",on:{"click":function($event){return _vm.verDetalles(cliente.nombre, cliente.eventos.meses, 'Eventos')}}},[_vm._v(_vm._s(_vm._f("currency")(cliente.eventos.importe,''))+" €")])]:_vm._e(),(cliente.partidas && cliente.partidas.length > 0)?_vm._l((cliente.partidas),function(partida){return _c('td',{key:partida.ID,staticClass:"importe",on:{"click":function($event){return _vm.verDetalles(cliente.nombre, partida.meses, 'Partida: ' + partida.nombre)}}},[_vm._v(_vm._s(_vm._f("currency")(partida.importe,''))+" €")])}):_vm._e()],2)}),0)])])])]):_vm._e(),(_vm.detalles)?_c('detalles-meses',{attrs:{"meses":_vm.detalles.meses,"cliente":_vm.detalles.cliente,"tipo":_vm.detalles.tipo},on:{"cerrar":function($event){_vm.detalles = null}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaComparativa_vue__ = __webpack_require__(427);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cddcf67_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tablaComparativa_vue__ = __webpack_require__(1000);
function injectStyle (ssrContext) {
  __webpack_require__(997)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cddcf67"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablaComparativa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cddcf67_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tablaComparativa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verDetallesComparados_vue__ = __webpack_require__(428);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac422ddc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verDetallesComparados_vue__ = __webpack_require__(999);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_verDetallesComparados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac422ddc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_verDetallesComparados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',{staticStyle:{"max-width":"1400px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.cliente)+" - "+_vm._s(_vm.tipo)+"\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-3"},[_c('table',{staticClass:"table table-condensed table-striped text-right"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("Mes")]),_vm._v(" "),_vm._l((_vm.anos),function(ano){return _c('th',{key:ano.ano},[_vm._v(_vm._s(ano.ano))])})],2)]),_vm._v(" "),_c('tbody',_vm._l((new Array(12).fill(0)),function(val,mes){return _c('tr',{key:mes},[_c('td',{staticClass:"text-left"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.getMes(mes))+"\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.anos),function(ano){return _c('td',{key:mes + '-' + ano.ano},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm._f("currency")(ano.meses[mes],''))+" €\n\t\t\t\t\t\t\t\t\t")])})],2)}),0),_vm._v(" "),_c('tbody',{staticClass:"bg-dark text-white"},[_c('tr',[_c('td',{staticClass:"text-left"},[_vm._v("TOTAL:")]),_vm._v(" "),_c('td',{attrs:{"colspan":_vm.anos.length}},[_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.importeTotal,''))+" €")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9"},[_c('chartjs-line',{attrs:{"datalabel":'Facturación ' + _vm.cliente,"height":200,"labels":_vm.labelMeses,"datasets":_vm.chartData}})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.resultados && _vm.resultados.clientes.length > 0)?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Resultados"),_c('download-excel',{staticClass:"btn btn-warning btn-sm ml-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"meta":_vm.json_meta,"name":"informe.xls"}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("XLS")])],1),_c('div',{staticClass:"table"},[_c('table',{staticClass:"table table-striped table-condensed text-right"},[_c('thead',[_c('tr',{staticClass:"bg-dark text-white"},[_c('th',{staticStyle:{"vertical-align":"top"},attrs:{"rowspan":"2"},on:{"click":function($event){return _vm.ordenar('nombre', 'nombre')}}},[_vm._v("Cliente"),(_vm.orden.tipo === 'nombre')?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()]),_vm._l((_vm.resultados.campos),function(campo){return _c('th',{key:campo.campo,staticClass:"text-center",attrs:{"colspan":_vm.anos.length},on:{"click":function($event){return _vm.ordenar('campo', campo.campo)}}},[_vm._v(_vm._s(campo.nombre)),(_vm.orden.tipo === 'campo' && _vm.orden.campo === campo.campo)?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()])}),(_vm.resultados.clientes[0].soportes && _vm.resultados.clientes[0].soportes.length > 0)?_vm._l((_vm.resultados.clientes[0].soportes),function(soporte,i){return _c('th',{key:soporte.ID_soporte,staticClass:"text-center",attrs:{"colspan":_vm.anos.length},on:{"click":function($event){return _vm.ordenar('soporte', i)}}},[_vm._v(_vm._s(soporte.nombre)),(_vm.orden.tipo === 'soporte' && _vm.orden.campo === i)?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()])}):_vm._e(),(_vm.resultados.clientes[0].eventos)?[_c('th',{staticClass:"text-center",attrs:{"colspan":_vm.anos.length},on:{"click":function($event){return _vm.ordenar('eventos', 'eventos')}}},[_vm._v("Eventos")]),(_vm.orden.tipo === 'eventos')?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()]:_vm._e(),(_vm.resultados.clientes[0].partidas && _vm.resultados.clientes[0].partidas.length > 0)?_vm._l((_vm.resultados.clientes[0].partidas),function(partida,i){return _c('th',{key:partida.ID,staticClass:"text-center",attrs:{"colspan":_vm.anos.length},on:{"click":function($event){return _vm.ordenar('partida', i)}}},[_vm._v(_vm._s(partida.nombre)),(_vm.orden.tipo === 'partida' && _vm.orden.campo === i)?_c('span',{staticClass:"fa ml-2",class:(_vm.orden.sentido === 1) ? 'fa-caret-up' : 'fa-caret-down'}):_vm._e()])}):_vm._e()],2),_c('tr',{staticClass:"bg-light"},[_vm._l((_vm.resultados.campos),function(campo){return _vm._l((_vm.anos),function(ano){return _c('th',{key:campo.campo + '-' + ano},[_vm._v(_vm._s(ano))])})}),_vm._l((_vm.resultados.clientes[0].soportes),function(soporte){return _vm._l((_vm.anos),function(ano){return _c('th',{key:soporte.ID_soporte + '-' + ano,staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(ano))])})}),(_vm.resultados.clientes[0].eventos)?_vm._l((_vm.anos),function(ano){return _c('th',{key:'eventos-' + ano},[_vm._v(_vm._s(ano))])}):_vm._e(),_vm._l((_vm.resultados.clientes[0].partidas),function(partida){return (_vm.resultados.clientes[0].partidas)?_vm._l((_vm.anos),function(ano){return _c('th',{key:partida.nombre + '-' + ano},[_vm._v(_vm._s(ano))])}):_vm._e()})],2)]),_c('tbody',_vm._l((_vm.resultadosClientes),function(cliente){return _c('tr',{key:cliente.ID_cliente},[_c('td',[_vm._v(_vm._s(cliente.nombre))]),_vm._l((cliente.campos),function(campo,id){return _vm._l((campo.anos),function(ano,a){return _c('td',{key:campo.nombre + 'res-' + a,staticClass:"importe",style:(a === campo.anos.length - 1 ? {borderRight: '1px solid #aaaaaa'} : {}),on:{"click":function($event){return _vm.verDetalles(cliente.nombre, campo.anos, campo.nombre)}}},[_vm._v(_vm._s(_vm._f("currency")(ano.importe,''))),(id === 'cobertura')?_c('span',[_vm._v("%")]):_vm._e(),(id !== 'cobertura')?_c('span',[_vm._v("€")]):_vm._e()])})}),_vm._l((cliente.soportes),function(soporte){return (cliente.soportes)?_vm._l((soporte.anos),function(ano,a){return _c('td',{key:soporte.ID_soporte + 'res-' + a,staticClass:"importe",style:(a === soporte.anos.length - 1 ? {borderRight: '1px solid #aaaaaa'} : {}),on:{"click":function($event){return _vm.verDetallesSoporte(cliente.nombre, soporte.anos, 'Soporte: ' + soporte.nombre)}}},[_vm._v(_vm._s(_vm._f("currency")(ano.importe,''))+" €")])}):_vm._e()}),(cliente.eventos)?_vm._l((cliente.eventos.anos),function(ano,a){return _c('td',{key:'eventosres-' + a,staticClass:"importe",style:(a === cliente.eventos.anos.length - 1 ? {borderRight: '1px solid #aaaaaa'} : {}),on:{"click":function($event){return _vm.verDetalles(cliente.nombre, cliente.eventos.anos, 'Eventos')}}},[_vm._v(_vm._s(_vm._f("currency")(ano.importe,''))+" €")])}):_vm._e(),_vm._l((cliente.partidas),function(partida){return (cliente.partidas)?_vm._l((partida.anos),function(ano,a){return _c('td',{key:'partidas' + partida.ID_partida + '-' + a,staticClass:"importe",style:(a === partida.anos.length - 1 ? {borderRight: '1px solid #aaaaaa'} : {}),on:{"click":function($event){return _vm.verDetalles(cliente.nombre, partida.anos, 'Partida: ' + partida.nombre)}}},[_vm._v(_vm._s(_vm._f("currency")(ano.importe,''))+" €")])}):_vm._e()})],2)}),0)])])])]):_vm._e(),(_vm.detalles)?_c('detalles-meses',{attrs:{"anos":_vm.detalles.anos,"cliente":_vm.detalles.cliente,"tipo":_vm.detalles.tipo},on:{"cerrar":function($event){_vm.detalles = null}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Opciones de filtrado")]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8"},[_c('h6',[_vm._v("Filtro temporal")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.tipoFecha),expression:"filtro.tipoFecha"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "tipoFecha", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.resultados = null}]}},[_c('option',{attrs:{"value":"intervalo"}},[_vm._v("Intérvalo de fechas")]),_c('option',{attrs:{"value":"anos"}},[_vm._v("Comparativa años")])])]),_c('div',{staticClass:"col"},[_c('datepicker',{attrs:{"format":(_vm.filtro.tipoFecha === 'intervalo') ? 'MMMM, yyyy' : 'yyyy',"placeholder":"Fecha inicio","monday-first":true,"language":_vm.$dateLang,"input-class":"form-control","minimum-view":(_vm.filtro.tipoFecha === 'intervalo') ? 'month' : 'year'},model:{value:(_vm.filtro.fecha_ini),callback:function ($$v) {_vm.$set(_vm.filtro, "fecha_ini", $$v)},expression:"filtro.fecha_ini"}})],1),_c('div',{staticClass:"col"},[_c('datepicker',{attrs:{"format":(_vm.filtro.tipoFecha === 'intervalo') ? 'MMMM, yyyy' : 'yyyy',"placeholder":"Fecha inicio","monday-first":true,"language":_vm.$dateLang,"input-class":"form-control","minimum-view":(_vm.filtro.tipoFecha === 'intervalo') ? 'month' : 'year'},model:{value:(_vm.filtro.fecha_fin),callback:function ($$v) {_vm.$set(_vm.filtro, "fecha_fin", $$v)},expression:"filtro.fecha_fin"}})],1)]),_c('br'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.permisos.facturacion_consultar_todos)?_c('div',[_c('h6',[_vm._v("Añadir clientes por agente")]),_c('input-query',{staticClass:"form-control form-control-sm p-0",attrs:{"placeholder":"Busca un agente","input-class":"form-control form-control-sm m-0","realtime":true,"url":"consultas-facturacion/php/api/porClientes/query-agentes.php"},on:{"selected":function($event){return _vm.porAjente($event)}}})],1):_vm._e(),(!_vm.permisos.facturacion_consultar_todos && !_vm.filtro.clientesAgente)?_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.toggleMisClientes()}}},[_c('span',{staticClass:"fa fa-plus"})])]),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":"true","value":"Añadir todos mis clientes"}})]):_vm._e(),(_vm.filtro.clientesAgente !== null)?_c('div',{staticClass:"mt-2 alert alert-info"},[_c('span',{staticClass:"fa fa-info mr-2"}),_vm._v("La consulta se limitará los clientes de "),_c('b',[_vm._v(_vm._s(_vm.filtro.clientesAgente.nombre)+" "+_vm._s(_vm.filtro.clientesAgente.apellidos))]),_c('button',{staticClass:"btn btn-sm btn-danger ml-3",on:{"click":function($event){_vm.filtro.clientesAgente = null}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()]),_c('div',{staticClass:"col"},[_c('h6',[_vm._v("Añadir clientes uno a uno")]),_c('input-query',{staticClass:"form-control form-control-sm p-0",attrs:{"placeholder":"Busca el cliente","input-class":"form-control form-control-sm m-0","realtime":true,"url":"consultas-facturacion/php/api/porClientes/query-clientes.php"},on:{"selected":function($event){return _vm.ponCliente($event)}}})],1)]),(_vm.filtro.clientes.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"m-0 mt-2 table table-condensed table-striped",staticStyle:{"border":"1px solid #e0e0e0"}},[_c('thead',{staticClass:"bg-warning"},[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.filtro.clientes.length)+" clientes seleccionados")])])]),_c('tbody',_vm._l((_vm.filtro.clientes),function(cliente){return _c('tr',{key:cliente.ID},[_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(cliente.cliente))]),_c('td',{staticClass:"p-1 text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaCliente(cliente.ID)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])]):_vm._e(),_c('div',{staticClass:"input-group mt-2",staticStyle:{"max-width":"300px"}},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn",class:(_vm.filtro.soloPositivos) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.soloPositivos = !_vm.filtro.soloPositivos}}},[_c('span',{staticClass:"fa fa-check"})])]),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":"true","value":"Solo clientes con facturación"}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('h6',[_vm._v("Soportes")]),_c('div',_vm._l((_vm.listadoSoportes),function(soporte){return _c('button',{key:soporte.ID_soporte,staticClass:"m-1 btn btn-sm",class:(_vm.filtro.soportes.indexOf(soporte.ID_soporte) >= 0) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleSoporte(soporte.ID_soporte)}}},[_vm._v(_vm._s(soporte.soporte))])}),0),_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h6',[_vm._v("Partidas")]),_c('div',_vm._l((_vm.listadoPartidas),function(partida){return _c('button',{key:partida.ID_partida,staticClass:"m-1 btn btn-sm",class:(_vm.filtro.partidas.indexOf(partida.ID_partida) >= 0) ? 'btn-primary' : '',on:{"click":function($event){return _vm.togglePartida(partida.ID_partida)}}},[_vm._v(_vm._s(partida.titulo))])}),0)]),_c('div',{staticClass:"col"},[_c('h6',[_vm._v("Eventos")]),_c('div',[_c('button',{staticClass:"m-1 btn btn-sm",class:(_vm.filtro.verEventos) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.verEventos = !_vm.filtro.verEventos}}},[_vm._v("Ver eventos")])])])]),_c('hr'),_c('h6',[_vm._v("Campos")]),_c('div',_vm._l((_vm.listadoCampos),function(campo){return _c('button',{key:campo.ID,staticClass:"btn btn-sm m-1",class:(_vm.filtro.campos.indexOf(campo.ID) >= 0) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.toggleCampo(campo.ID)}}},[_vm._v(_vm._s(campo.nombre))])}),0)])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.consultar()}}},[_c('span',{staticClass:"fa fa-search mr-1"}),_vm._v("Consultar")])])]),(_vm.filtro.tipoFecha === 'intervalo')?_c('TablaIntervalo',{attrs:{"resultados":_vm.resultados}}):_vm._e(),(_vm.filtro.tipoFecha === 'anos')?_c('TablaComparativa',{attrs:{"resultados":_vm.resultados}}):_vm._e(),(_vm.resultados === false)?_c('div',{staticClass:"text-center mt-2"},[_vm._m(0)]):_vm._e(),(_vm.detalles)?_c('detalles-meses',{attrs:{"meses":_vm.detalles.meses,"cliente":_vm.detalles.cliente,"tipo":_vm.detalles.tipo},on:{"cerrar":function($event){_vm.detalles = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_vm._v("Sin resultados")]),_c('div',{staticClass:"card-body"},[_c('h1',[_c('span',{staticClass:"fa fa-exclamation-triangle"})]),_c('h4',[_vm._v("Tu búsqueda no ha obtenido resultados")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mapa_mapa__ = __webpack_require__(1005);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('control-emisoras', {
			name: 'Control de emisoras',
			component: __WEBPACK_IMPORTED_MODULE_1__Main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('control-emisoras').child('mapa', {
			name: 'Mapa de cobertura',
			component: __WEBPACK_IMPORTED_MODULE_2__components_mapa_mapa__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('control-emisoras').child('', {
			name: 'Registros de control de emisoras',
			component: __WEBPACK_IMPORTED_MODULE_2__components_mapa_mapa__["a" /* default */]
		});
	}
});

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(429);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cde11fea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1004);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cde11fea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapa_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212786f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mapa_vue__ = __webpack_require__(1007);
function injectStyle (ssrContext) {
  __webpack_require__(1006)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-212786f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_212786f4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mapa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"contenedor",staticClass:"contenedor",style:({height: _vm.alto + 'px'})},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('div',{staticClass:"input-group mb-2"},[_vm._m(0),(!_vm.emisora)?_c('input-query',{attrs:{"realtime":true,"url":"control-emisoras/php/api/queryEmisora.php","input-class":"form-control","placeholder":"Selecciona una emisora"},on:{"selected":function($event){return _vm.seleccionaEmisora($event)}}}):_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.emisora.Nombre}}),(_vm.emisora)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarEmisora}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()],1)]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group"},[_vm._m(1),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filtro.CoberturaMinima),expression:"filtro.CoberturaMinima",modifiers:{"number":true}}],staticClass:"form-control",domProps:{"value":(_vm.filtro.CoberturaMinima)},on:{"keypress":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getCoberturas($event)},_vm.limpiarMapa],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "CoberturaMinima", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._m(2),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filtro.CoberturaMaxima),expression:"filtro.CoberturaMaxima",modifiers:{"number":true}}],staticClass:"form-control",domProps:{"value":(_vm.filtro.CoberturaMaxima)},on:{"keypress":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getCoberturas($event)},_vm.limpiarMapa],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "CoberturaMaxima", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getCoberturas()}}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])])])])]),_c('div',{attrs:{"id":"map"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Emisora")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Cobertura mínima")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Cobertura máxima")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_login_login__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_password_restore_password_restore_vue__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__muro_vue_main__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_panel_control_panel_vue__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_panel_control_menu_vue__ = __webpack_require__(1057);




// import Dashboard from './components/dashboard/dashboard.vue'




/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/password-restore', {
			name: 'Restaurar contraseña',
			component: __WEBPACK_IMPORTED_MODULE_2__components_password_restore_password_restore_vue__["a" /* default */]
		});
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('', {
			name: 'Inicio',
			component: __WEBPACK_IMPORTED_MODULE_3__muro_vue_main__["a" /* default */]
		});
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control', {
			component: __WEBPACK_IMPORTED_MODULE_4__components_panel_control_panel_vue__["a" /* default */]
		});
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('', {
			name: 'Panel de control',
			component: __WEBPACK_IMPORTED_MODULE_5__components_panel_control_menu_vue__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/login', {
			name: 'Login',
			component: __WEBPACK_IMPORTED_MODULE_1__components_login_login__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/password-restore/:idUsuario/:token', {
			component: __WEBPACK_IMPORTED_MODULE_2__components_password_restore_password_restore_vue__["a" /* default */],
			name: 'Restaurar contraseña'
		});

		Vue.prototype.round = function (numero, precision) {
			if (typeof numero !== 'number') {
				return NaN;
			}

			precision = typeof precision !== 'number' || precision < 0 ? 2 : precision;

			var nuevo = parseInt(Math.round(numero * Math.pow(10, precision)));
			return nuevo / Math.pow(10, precision);
		};
	}
});

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(431);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b874e85_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(1013);
function injectStyle (ssrContext) {
  __webpack_require__(1010)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b874e85"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b874e85_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_restore_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20090a24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_restore_vue__ = __webpack_require__(1012);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_restore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20090a24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_restore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal",staticStyle:{"background-color":"rgba(255,255,255,0.3)"}},[_c('div',[_c('div',{staticStyle:{"max-width":"400px","margin-top":"200px"}},[_c('div',{staticClass:"card text-left",staticStyle:{"background-color":"rgba(255,255,255,0.4) !important"}},[_c('div',{staticClass:"card-body"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.usuario),expression:"form.usuario"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.usuario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "usuario", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-primary",staticStyle:{"width":"30px"},on:{"click":_vm.iniciar}},[_c('span',{staticClass:"fa fa-unlock"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.cerrar}},[_c('span',{staticClass:"fa fa-close"})])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","display":"block","text-align":"center","margin-bottom":"20px"}},[_c('h5',[_vm._v("\n\t\t\t\t\t\t\tReestablecer contraseña\n\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Usuario")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-login"},[_c('div',{staticClass:"fondo"}),_vm._v(" "),(_vm.fase === 'login')?_c('div',{staticClass:"contenedor"},[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card text-left",staticStyle:{"border-radius":"5px","background-color":"rgba(255,255,255,0.4)"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group mb-4"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.usuario),expression:"form.usuario"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Usuario","autocomplete":_vm.strNow},domProps:{"value":(_vm.form.usuario)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "usuario", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group mb-4"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","autocomplete":_vm.strNow},domProps:{"value":(_vm.form.password)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.recordar),expression:"form.recordar"}],staticStyle:{"vertical-align":"middle !important","width":"20px"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.recordar)?_vm._i(_vm.form.recordar,null)>-1:(_vm.form.recordar)},on:{"change":function($event){var $$a=_vm.form.recordar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "recordar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "recordar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "recordar", $$c)}}}}),_vm._v(" "),(_vm.require2fa)?_c('span',[_vm._v("Confiar en este equipo y recordare")]):_c('span',[_vm._v("Recordarme durante 15 días")])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('b',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.fase = 'restorepass'}}},[_vm._v("Reestablecer contraseña")])])])]),_vm._v(" "),(_vm.requiere2fa !== false)?_c('div',{staticClass:"card-body bg-danger text-white"},[_c('h4',[_vm._v("Doble factor de autenticación")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.token),expression:"form.token"}],staticClass:"form-control text-center",attrs:{"type":"text","placeholder":"XXXXXX"},domProps:{"value":(_vm.form.token)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "token", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body text-center"},[_c('button',{staticClass:"btn btn-lg btn-block btn-warning",on:{"click":function($event){return _vm.login()}}},[_vm._m(3),_vm._v("\n\t\t\t\t\t\tEntrar\n\t\t\t\t\t")])])])])]):_vm._e(),_vm._v(" "),(_vm.fase === 'cambiopass')?_c('cambio-pass'):_vm._e(),_vm._v(" "),(_vm.fase === 'restorepass')?_c('restore-pass',{on:{"cerrar":function($event){_vm.fase = 'login'}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('img',{staticStyle:{"height":"60px","margin-bottom":"15px"},attrs:{"src":"/static/recursos/logo_sip.svg","alt":"logo"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-lock"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-sign-in mr-2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_password_restore_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d6dce6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_restore_vue__ = __webpack_require__(1016);
function injectStyle (ssrContext) {
  __webpack_require__(1015)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d6dce6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_password_restore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d6dce6e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_password_restore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-login"},[_c('div',{staticClass:"contenedor"},[_c('div',[_c('div',{staticClass:"card text-left",staticStyle:{"border-radius":"5px","box-shadow":"0 0 40px rgba(0,0,0,0.2)"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"input-group mb-4"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Contraseña"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password2),expression:"form.password2"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Repítela"},domProps:{"value":(_vm.form.password2)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.cambiar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-warning btn-block",on:{"click":_vm.cambiar}},[_vm._v("\n\t\t\t\t\t\tCambiar\n\t\t\t\t\t")])])]),_vm._v(" "),_vm._m(3)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-danger text-white"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left pt-2"},[_c('span',{staticStyle:{"font-size":"1.4em"}},[_c('span',{staticClass:"fa fa-lock mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tRestaurar contraseña\n\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('img',{staticStyle:{"height":"40px"},attrs:{"src":"/static/recursos/logo_sip_white.svg","alt":"logo"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-lock"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger text-left mt-2"},[_c('b',{staticStyle:{"font-size":"1.2em","text-transform":"uppercase"}},[_vm._v("Atención")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\tEste sitio está reservado única y exclusivamente para el "),_c('b',[_vm._v("personal de Radio Castellón S.A.")]),_vm._v(" Si no estás autorizado a entrar, debes\n\t\t\t\t\tabandonar inmediatamente esta página.\n\t\t\t\t")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuevaPublicacion_vue__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d178058_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nuevaPublicacion_vue__ = __webpack_require__(1025);
function injectStyle (ssrContext) {
  __webpack_require__(1019)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d178058"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuevaPublicacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d178058_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nuevaPublicacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editorEncuesta_vue__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27230773_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editorEncuesta_vue__ = __webpack_require__(1021);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editorEncuesta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27230773_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editorEncuesta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-upload mr-2"}),_vm._v("Encuesta"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Título de la encuesta")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editor.Titulo),expression:"editor.Titulo"}],staticClass:"form-control",domProps:{"value":(_vm.editor.Titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editor, "Titulo", $event.target.value)}}})])]),_c('div',{staticClass:"card-body bg-light"},[_c('p',[_c('b',[_vm._v("Opciones")])]),_vm._l((_vm.editor.Opciones),function(opcion,i){return _c('div',{key:i,staticClass:"input-group mb-2"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v(_vm._s(i + 1))])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editor.Opciones[i]),expression:"editor.Opciones[i]"}],staticClass:"form-control",attrs:{"placeholder":"Escribe el valor aquí"},domProps:{"value":(_vm.editor.Opciones[i])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editor.Opciones, i, $event.target.value)}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.quitarOpcion(i)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),_c('button',{staticClass:"btn btn-sm btn-primary m-3",on:{"click":_vm.nuevaOpcion}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nueva opción")])],2),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.encuestaValida},on:{"click":_vm.guardar}},[_vm._v("Guardar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscarGifs_vue__ = __webpack_require__(438);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f165ab84_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscarGifs_vue__ = __webpack_require__(1024);
function injectStyle (ssrContext) {
  __webpack_require__(1023)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f165ab84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscarGifs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f165ab84_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscarGifs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Buscar gifs"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cadena),expression:"cadena"}],staticClass:"form-control",domProps:{"value":(_vm.cadena)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.cadena=$event.target.value}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search"})])])]),_c('div',{staticClass:"text-right mt-2"},[_c('a',{staticStyle:{"opacity":"0.5","cursor":"pointer"},attrs:{"target":"_blank","href":"https://www.giphy.com"}},[_vm._v("Powered by GIPHY")])])]),_c('div',{staticClass:"card-body"},_vm._l((_vm.resultados),function(gif,i){return _c('div',{key:i,staticClass:"gif",staticStyle:{"vertical-align":"top"}},[_c('img',{staticStyle:{"position":"relative","display":"block","width":"100%"},attrs:{"src":gif.images.downsized_large.url},on:{"click":function($event){return _vm.adjuntar(gif)}}})])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.abrir_publicar)?_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('button',{staticClass:"close",on:{"click":function($event){return _vm.$emit('cerrar')}}},[_c('span',{staticClass:"fa fa-close"})]),_vm._m(0),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nueva.Mensaje),expression:"nueva.Mensaje"}],staticClass:"form-control",attrs:{"placeholder":"En que estás pensando..."},domProps:{"value":(_vm.nueva.Mensaje)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.nueva, "Mensaje", $event.target.value)},_vm.analizarMensaje]}})]),_c('div',{staticClass:"card-body bg-light"},[_c('h5',[_vm._v("Adjuntar")]),_c('button',{staticClass:"btn btn-sm m-2",on:{"click":function($event){return _vm.adjuntar()}}},[_c('span',{staticClass:"fa fa-upload mr-2"}),_vm._v("Archivos")]),_c('button',{staticClass:"btn btn-sm m-2",on:{"click":function($event){_vm.editarEncuesta = true}}},[_c('span',{staticClass:"fa fa-bar-chart mr-2"}),_vm._v("Encuesta")]),_c('button',{staticClass:"btn btn-sm m-2",on:{"click":function($event){_vm.panelGifs = true}}},[_c('span',{staticClass:"fa fa-gift mr-2"}),_vm._v("Gif")])]),(_vm.nueva.Encuestas && _vm.nueva.Encuestas.length > 0)?_c('table',{staticClass:"table table-striped m-0"},[_vm._m(1),_c('tbody',_vm._l((_vm.nueva.Encuestas),function(encuesta,i){return _c('tr',{key:i},[_c('td',{on:{"click":function($event){_vm.editarEncuesta = encuesta}}},[_vm._v(_vm._s(encuesta.Titulo)+" ("+_vm._s(encuesta.Opciones.length)+" opciones)")]),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"fa fa-trash text-danger",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.delEncuesta(i)}}})])])}),0)]):_vm._e(),(_vm.nueva.Gifs && _vm.nueva.Gifs.length > 0)?_c('table',{staticClass:"table table-striped m-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.nueva.Gifs),function(gif,i){return _c('tr',{key:i},[_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.eliminarGif(i)}}},[_c('img',{staticStyle:{"position":"relative","width":"100%"},attrs:{"src":gif.images.downsized_large.url}})])])}),0)]):_vm._e(),(_vm.nueva.Archivos && _vm.nueva.Archivos.length > 0)?_c('table',{staticClass:"table table-striped m-0"},[_vm._m(3),_c('tbody',_vm._l((_vm.nueva.Archivos),function(archivo,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(archivo.name))]),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"fa fa-trash text-danger",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.eliminarArchivo(i)}}})])])}),0)]):_vm._e(),(_vm.nueva.Youtube && _vm.nueva.Youtube.length > 0)?_c('div',{staticClass:"p-1 bg-dark text-white"},[_vm._m(4)]):_vm._e(),(_vm.nueva.Youtube && _vm.nueva.Youtube.length > 0)?_c('div',{staticClass:"card-body"},_vm._l((_vm.nueva.Youtube),function(id){return _c('div',{key:id,staticClass:"youtubeCaption",on:{"click":function($event){return _vm.quitarVideo(id)},"mouseover":function($event){_vm.videoOver = id},"mouseleave":function($event){_vm.videoOver = null}}},[_c('div',{staticClass:"papelera text-danger",class:(_vm.videoOver === id) ? 'active' : ''},[_c('span',{staticClass:"fa fa-trash"})]),_c('img',{staticStyle:{"width":"80px"},attrs:{"src":'https://img.youtube.com/vi/' + id + '/0.jpg'}})])}),0):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.formValido},on:{"click":function($event){return _vm.publicar()}}},[_c('span',{staticClass:"fa fa-paper-plane mr-2"}),_vm._v("Publicar")])]),(_vm.editarEncuesta)?_c('EditorEncuesta',{attrs:{"encuesta":_vm.editarEncuesta},on:{"cerrar":function($event){_vm.editarEncuesta = false},"updated":function($event){return _vm.addEncuesta($event)}}}):_vm._e(),(_vm.panelGifs)?_c('BuscarGifs',{on:{"cerrar":function($event){_vm.panelGifs = false},"adjuntar":function($event){return _vm.nueva.Gifs.push($event)}}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',[_c('b',[_vm._v("Publicar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('span',{staticClass:"fa fa-file mr-2"}),_vm._v("Encuestas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('span',{staticClass:"fa fa-file mr-2"}),_vm._v("Gifs")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('span',{staticClass:"fa fa-file mr-2"}),_vm._v("Archivos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',{staticClass:"ml-2"},[_c('span',{staticClass:"fa fa-youtube mr-2"}),_vm._v("Vídeos de youtube")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenidoMultimedia_vue__ = __webpack_require__(441);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47e3deb5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenidoMultimedia_vue__ = __webpack_require__(1029);
function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47e3deb5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenidoMultimedia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47e3deb5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenidoMultimedia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imagenes.length > 0)?_c('div',{ref:"contenedor",staticClass:"contenedor"},[_c('div',{staticClass:"imagen",style:(_vm.estiloWrapper)},_vm._l((_vm.imagenes),function(contenido){return _c('div',{key:contenido.ArchivoID,staticClass:"capaMultimedia",style:({width: _vm.anchoContainer + 'px'})},[(contenido.Tipo === 'imagen')?_c('div',{staticClass:"capaImagen",style:(contenido.estilo)}):_vm._e(),(contenido.Tipo === 'video')?_c('div',{staticClass:"capaVideo",style:(contenido.estilo)},[_c('video',{style:(contenido.estilo),attrs:{"src":contenido.src,"controls":"true"}})]):_vm._e(),(contenido.Tipo === 'youtube')?_c('iframe',{attrs:{"width":"100%","height":"400","src":'https://www.youtube-nocookie.com/embed/' + contenido.YoutubeID,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":"allowfullscreen"}}):_vm._e()])}),0),(_vm.imagenes.length > 1)?_c('div',{staticClass:"capaPuntos"},[_c('div',{staticClass:"text-center"},_vm._l((_vm.imagenes),function(imagen,ind){return _c('span',{key:imagen.ArchivoID,staticClass:"m-2 punto",class:(_vm.i === ind) ? 'active' : '',staticStyle:{"cursor":"pointer","color":"white","font-size":"1.4em"},on:{"click":function($event){return _vm.verImagen(ind)}}},[_c('span',{staticClass:"fa fa-circle"})])}),0)]):_vm._e(),(_vm.imagenes.length > 1)?_c('div',{staticClass:"capaFlecha siguiente",on:{"click":function($event){return _vm.siguiente()}}},[_c('span',{staticClass:"fa fa-arrow-right"})]):_vm._e(),(_vm.imagenes.length > 1)?_c('div',{staticClass:"capaFlecha anterior",on:{"click":function($event){return _vm.anterior()}}},[_c('span',{staticClass:"fa fa-arrow-left"})]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenidoEncuesta_vue__ = __webpack_require__(442);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6d7682_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenidoEncuesta_vue__ = __webpack_require__(1032);
function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab6d7682"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenidoEncuesta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab6d7682_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenidoEncuesta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"encuesta"},[(_vm.datos.HasVotado)?_c('div',[_c('div',{staticClass:"tituloEncuesta text-dark"},[_vm._v(_vm._s(_vm.datos.Titulo))]),_c('chartjs-bar',{attrs:{"beginatzero":true,"title":{display: true, text: _vm.datos.Titulo},"label":_vm.datos.Titulo,"legend":{display: false},"height":100,"labels":_vm.labels,"data":_vm.data,"datalabel":_vm.datos.Titulo}})],1):_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"tituloEncuesta text-dark"},[_vm._v(_vm._s(_vm.datos.Titulo))]),_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.datos.Opciones),function(opcion,i){return _c('tr',{key:opcion.OpcionID},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(i + 1)+" - "+_vm._s(opcion.Titulo))]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.votar(opcion)}}},[_vm._v("Votar")])])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenidoArchivo_vue__ = __webpack_require__(443);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d214db3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenidoArchivo_vue__ = __webpack_require__(1035);
function injectStyle (ssrContext) {
  __webpack_require__(1034)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d214db3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenidoArchivo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d214db3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenidoArchivo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contenedor bg-light"},[_c('div',{staticClass:"titulo"},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("Archivos adjuntos ("+_vm._s(_vm.datos.Archivos.length)+")"),_c('button',{staticClass:"btn btn-sm btn-primary ml-3",on:{"click":function($event){_vm.verTodos = !_vm.verTodos}}},[_c('span',{staticClass:"mr-2 fa",class:(_vm.verTodos) ? 'fa-caret-up' : 'fa-caret-down'}),(_vm.verTodos)?_c('span',[_vm._v("Ocultar")]):_c('span',[_vm._v("Mostrar")])])]),(_vm.verTodos)?_c('div',_vm._l((_vm.datos.Archivos),function(archivo){return _c('div',{staticClass:"fichero",on:{"click":function($event){return _vm.download(archivo)}}},[_c('div',{staticClass:"icono"},[_c('span',{class:(archivo.Icono) ? archivo.Icono : 'fa fa-file'})]),_c('div',{staticClass:"nombre"},[_vm._v(_vm._s(archivo.Nombre))]),_c('div',{staticClass:"tamano"},[_vm._v(_vm._s(archivo.Tamano))])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comentarios_vue__ = __webpack_require__(444);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a138113_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_comentarios_vue__ = __webpack_require__(1038);
function injectStyle (ssrContext) {
  __webpack_require__(1037)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a138113"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comentarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a138113_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_comentarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comentarios"},[_vm._m(0),_vm._l((_vm.comentarios),function(coment){return _c('div',{key:coment.ComentarioID,staticClass:"comentario"},[_c('div',{staticClass:"cabecera"},[_c('div',{staticClass:"usuario"},[_vm._v(_vm._s(coment.UsuarioNombre))]),_c('div',{staticClass:"fecha"},[_vm._v(_vm._s(_vm._f("moment")(coment.FechaComentarioUnix,'D-M-Y'))+" a las "+_vm._s(_vm._f("moment")(coment.FechaComentarioUnix,'HH:mm:ss')))])]),_c('div',{staticClass:"texto"},[_vm._v(_vm._s(coment.Comentario))])])}),(_vm.hayMas)?_c('div',{staticClass:"bg-dark text-white"},[_c('span',{staticClass:"verTodos",on:{"click":function($event){_vm.verTodos = !_vm.verTodos}}},[_c('span',{staticClass:"fa fa-caret-down mr-2"}),_vm._v("Ver todos los comentarios")])]):_vm._e(),_c('div',{staticClass:"formulario"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Comentario),expression:"Comentario"}],staticClass:"form-control",staticStyle:{"border-radius":"0","border":"0","border-top":"1px solid #e0e0e0"},attrs:{"placeholder":"Comenta..."},domProps:{"value":(_vm.Comentario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Comentario=$event.target.value}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"disabled":!_vm.Comentario},on:{"click":function($event){return _vm.comentar()}}},[_c('span',{staticClass:"fa fa-send mr-2"}),_vm._v("Comentar")])])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titular"},[_c('span',{staticClass:"fa fa-comments mr-2"}),_vm._v("Comentarios")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publicacion"},[_c('div',{staticClass:"cabecera"},[_c('div',{staticClass:"avatar"},[_c('img',{attrs:{"src":'/src/modulos/core/php/api/perfil/avatar.php?avatar='+ _vm.publicacion.UsuarioAvatar}})]),_c('div',{staticClass:"nombre"},[_vm._v(_vm._s(_vm.publicacion.UsuarioNombre))]),_c('div',{staticClass:"fecha"},[_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.publicacion.FechaPublicacionUnix,'D-M-Y'))+" a las "+_vm._s(_vm._f("moment")(_vm.publicacion.FechaPublicacionUnix,'H:m:s')))]),(_vm.publicacion.MantenerArriba)?_c('span',{staticClass:"fa fa-thumb-tack ml-3 mr-3"}):_vm._e(),_c('span',{staticClass:"pl-3 pr-3",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.verMenu = !_vm.verMenu}}},[_c('span',{staticClass:"fa fa-ellipsis-v"})]),(_vm.verMenu)?_c('div',{staticClass:"fondoTransparente",on:{"click":function($event){_vm.verMenu = false}}}):_vm._e(),_c('transition',{attrs:{"name":"aparecer"}},[(_vm.verMenu)?_c('div',{staticClass:"menuContextual"},[_c('table',{staticClass:"table table-hover m-0"},[_c('tbody',[(_vm.permisos.muro_pinear_publicaciones)?_c('tr',{on:{"click":function($event){return _vm.togglePin()}}},[_c('td',[_c('span',{staticClass:"fa fa-thumb-tack"})]),_c('td',[_vm._v("Fijar arriba")])]):_vm._e(),(_vm.permisos.muro_modificar_todas || _vm.publicacion.UsuarioID === _vm.usuario.ID)?_c('tr',{on:{"click":function($event){return _vm.eliminar()}}},[_c('td',[_c('span',{staticClass:"fa fa-trash"})]),_c('td',[_vm._v("Eliminar")])]):_vm._e()])])]):_vm._e()])],1)]),_c('div',{staticClass:"contenido"},[(_vm.publicacion.Mensaje)?_c('div',{staticClass:"comentario"},[_c('span',{staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.publicacion.Mensaje))])]):_vm._e(),_c('contenido-multimedia',{attrs:{"datos":_vm.publicacion}}),_vm._l((_vm.publicacion.Encuestas),function(encuesta){return _c('contenido-encuesta',{key:encuesta.EncuestaID,attrs:{"datos":encuesta,"publicacionID":_vm.publicacion.PublicacionID}})}),(_vm.publicacion.Archivos.length > 0)?_c('contenido-archivo',{attrs:{"datos":_vm.publicacion}}):_vm._e()],2),_c('div',{staticClass:"reacciones"},[_c('div',{staticClass:"m-4",on:{"mouseover":function($event){return _vm.over('like')},"mouseleave":function($event){return _vm.leave('like')},"click":function($event){return _vm.reaccionar('like')}}},[_c('span',{staticClass:"reaccion fa",class:_vm.claseLike}),(_vm.numLikes > 0)?_c('span',[_vm._v("("+_vm._s(_vm.numLikes)+")")]):_vm._e()]),_c('div',{staticClass:"m-4",on:{"mouseover":function($event){return _vm.over('dislike')},"mouseleave":function($event){return _vm.leave('dislike')},"click":function($event){return _vm.reaccionar('dislike')}}},[_c('span',{staticClass:"reaccion fa",class:_vm.claseDislike}),(_vm.numDislikes > 0)?_c('span',[_vm._v("("+_vm._s(_vm.numDislikes)+")")]):_vm._e()]),_c('div',{staticClass:"m-4",on:{"mouseover":function($event){return _vm.over('comments')},"mouseleave":function($event){return _vm.leave('comments')}}},[_c('span',{staticClass:"reaccion fa",class:_vm.claseComments}),(_vm.publicacion.Comentarios.length > 0)?_c('span',[_vm._v("("+_vm._s(_vm.publicacion.Comentarios.length)+")")]):_vm._e()])]),_c('comentarios',{attrs:{"datos":_vm.publicacion}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPublicacion_vue__ = __webpack_require__(445);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e5a0c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modalPublicacion_vue__ = __webpack_require__(1041);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalPublicacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1e5a0c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modalPublicacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info"},[_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),(_vm.publicacion)?_c('Publicacion',{attrs:{"publicacion":_vm.publicacion}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alertas_del_dia_vue__ = __webpack_require__(446);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d8115ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_alertas_del_dia_vue__ = __webpack_require__(1044);
function injectStyle (ssrContext) {
  __webpack_require__(1043)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d8115ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alertas_del_dia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d8115ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_alertas_del_dia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alertas.length > 0)?_c('div',{staticClass:"contiene-alertas-del-dia"},_vm._l((_vm.alertas),function(alerta){return _c('div',{key:alerta.id,staticClass:"alerta-del-dia"},[_c('div',{staticClass:"icono blink_me"},[_c('span',{class:alerta.Icono})]),_c('div',{staticClass:"contenido-alerta"},[_c('span',{staticClass:"titulo-alerta"},[_vm._v(_vm._s(alerta.Titulo))]),_c('span',{staticClass:"descripcion-alerta"},[_vm._v(_vm._s(alerta.Descripcion))])])])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendario_vue__ = __webpack_require__(447);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04680bf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendario_vue__ = __webpack_require__(1053);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04680bf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
	getEventos: function getEventos(ano, mes) {
		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('muro/php/lib/eventos/getEventos.php?ano=' + ano + '&mes=' + mes).then(function (res) {
				var eventos = res.data.map(function (e) {
					var evento = {
						key: e.EventoID,
						dates: {
							start: new Date(e.FechaInicioUnix * 1000),
							end: new Date(e.FechaFinUnix * 1000)
						}
					};

					if (e.Titulo) {
						evento.popover = {};
						evento.popover.label = e.Titulo;
					}

					if (e.Tipo === 'Punto') {
						evento.dot = e.Color;
					} else if (e.Tipo === 'Linea') {
						evento.bar = e.Color;
					} else {
						evento.highlight = { color: e.Color, fillMode: 'none' };
					}

					return evento;
				});
				resolve(eventos);
			}).catch(function (e) {
				console.error(e);
				reject(e.response.data.error);
			});
		});
	}
});

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEvent_vue__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f689a7c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_addEvent_vue__ = __webpack_require__(1052);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f689a7c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_addEvent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_today_vue__ = __webpack_require__(449);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_584c0d82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_today_vue__ = __webpack_require__(1051);
function injectStyle (ssrContext) {
  __webpack_require__(1050)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_today_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_584c0d82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_today_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[(_vm.today==_vm.popoverDate)?_c('h2',[_vm._v("Eventos de hoy")]):_c('h2',[_vm._v("Eventos de "+_vm._s(_vm.popoverDate))])]),_c('div',{staticClass:"card-body"},[(_vm.events.length == 0)?_c('p',[_vm._v("No hay eventos hoy")]):_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.events),function(event){return _c('tr',[_c('td',{style:({'background-color': event.color})}),_c('td',[_vm._v(_vm._s(event.startHour)+" - "+_vm._s(event.endHour))]),_c('td',[_vm._v(_vm._s(event.title))]),_c('td',[_vm._v(_vm._s(event.description))]),_c('td',[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.edit(event)}}},[_c('span',{staticClass:"fa fa-edit"})])]),_c('td',[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.remove(event)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.addingEvent && !_vm.editingEvent)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.addingEvent=true}}},[_vm._v("Añadir evento")]):_vm._e(),(_vm.addingEvent || _vm.editingEvent)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[(_vm.addingEvent)?_c('h5',[_vm._v("Añadir evento para el día "+_vm._s(_vm.popoverDate))]):_vm._e(),(_vm.editingEvent)?_c('h5',[_vm._v("Editar el evento "+_vm._s(_vm.event.title))]):_vm._e()]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Título")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.event.title),expression:"event.title"}],staticClass:"form-control",attrs:{"id":"title","placeholder":"Nombra el evento","rows":"1","required":"required"},domProps:{"value":(_vm.event.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.event, "title", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"description"}},[_vm._v("Descripción")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.event.description),expression:"event.description"}],staticClass:"form-control",attrs:{"id":"description","placeholder":"Descripción","required":"required"},domProps:{"value":(_vm.event.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.event, "description", $event.target.value)}}})]),_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"startHour"}},[_vm._v("Desde  ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.event.startHour),expression:"event.startHour"}],staticClass:"form-control",attrs:{"type":"time","id":"startHour","required":"required"},domProps:{"value":(_vm.event.startHour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.event, "startHour", $event.target.value)}}})]),_c('span',[_vm._v("  ")]),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"endHour"}},[_vm._v("Hasta  ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.event.endHour),expression:"event.endHour"}],staticClass:"form-control",attrs:{"type":"time","id":"endHour","required":"required"},domProps:{"value":(_vm.event.endHour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.event, "endHour", $event.target.value)}}})])]),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"color"}},[_vm._v("Elige el color")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.event.color),expression:"event.color"}],staticClass:"form-control",attrs:{"id":"color"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.event, "color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.colors),function(color){return _c('option',{key:color,style:({ backgroundColor: color }),domProps:{"value":color}},[_vm._v(_vm._s(color))])}),0)])]),_c('div',{staticClass:"card-body bg-light"},[(_vm.addingEvent)?_c('button',{staticClass:"btn btn-info",attrs:{"disabled":!_vm.event.title || !_vm.event.description},on:{"click":_vm.addEvent}},[_vm._v("Guardar")]):_vm._e(),(_vm.editingEvent)?_c('button',{staticClass:"btn btn-info",attrs:{"disabled":!_vm.event.title || !_vm.event.description},on:{"click":_vm.editEvent}},[_vm._v("Guardar edición")]):_vm._e(),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.cancel}},[_vm._v("Cancelar")]),_c('br')])]):_vm._e(),_c('br'),_c('TodayEvents',{ref:"tEvents",attrs:{"popoverDate":_vm.popoverDate},on:{"edit":_vm.editedEvent,"remove":_vm.removeEvent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_c('vc-calendar',{ref:"calendar",attrs:{"is-expanded":"is-expanded","attributes":_vm.fechasCalendario,"firstDayOfWeek":2},on:{"update:from-page":function($event){return _vm.getEventos(_vm.mesAno=$event)},"dayclick":function($event){return _vm.setPopover($event.id)}}}),_c('button',{attrs:{"type":"button"},on:{"click":_vm.moveToday}},[_vm._v("Hoy")])],1),_c('br'),_c('AddEvent',{ref:"addEvent",attrs:{"popoverDate":_vm.popoverDate},on:{"updateEvents":function($event){return _vm.getEventos(_vm.mesAno)}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v("Próximos eventos")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8"},[_c('AlertasDelDia'),(!_vm.abrir_publicar)?_c('button',{staticClass:"btn btn-primary mb-3",on:{"click":function($event){_vm.abrir_publicar=true}}},[_c('span',{staticClass:"fa fa-paper-plane mr-2"}),_vm._v("Nueva publicación")]):_vm._e(),_c('nuevaPublicacion',{attrs:{"abrir_publicar":_vm.abrir_publicar},on:{"cerrar":function($event){_vm.abrir_publicar=false},"cerrarPublicar":function($event){_vm.abrir_publicar = false}}}),_c('div',{staticClass:"scrolling-container"},_vm._l((_vm.publicaciones),function(publicacion){return _c('publicacion',{key:publicacion.PublicacionID,attrs:{"publicacion":publicacion},on:{"actualizar":function($event){return _vm.actualizaPublicacion(publicacion.PublicacionID)}}})}),1)],1),(_vm.$route.params.id)?_c('ModalPublicacion',{attrs:{"PublicacionID":_vm.$route.params.id}}):_vm._e(),_c('div',{staticClass:"col-lg-4"},[_c('Calendario')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f4c8d8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_panel_vue__ = __webpack_require__(1056);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f4c8d8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__(450);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef62d2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__ = __webpack_require__(1059);
function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ef62d2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef62d2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},_vm._l((_vm.listadoItems),function(cat){return _c('div',{key:cat.nombre,staticClass:"itemCategoria"},[_c('div',{staticClass:"card mb-4"},[_c('div',{staticClass:"card-header bg-warning text-white"},[_c('span',{staticClass:"mr-2",class:cat.icono}),_vm._v(_vm._s(cat.nombre))]),_c('div',{staticClass:"card-body"},_vm._l((cat.items),function(item){return _c('div',{key:item.path,staticClass:"itemPanel text-info",on:{"click":function($event){return _vm.go(item.path)}}},[_c('span',{class:item.icono,staticStyle:{"font-size":"5em"}}),_c('br'),_c('b',[_vm._v(_vm._s(item.nombre))])])}),0)])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_vue__ = __webpack_require__(1061);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('descargar-copion', {
			name: 'Descargar del copión',
			component: __WEBPACK_IMPORTED_MODULE_1__app_vue__["a" /* default */]
		});
	}
});

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(451);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51af753e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(1064);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51af753e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programador_vue__ = __webpack_require__(453);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5744f3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_programador_vue__ = __webpack_require__(1063);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5744f3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_programador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',{staticStyle:{"max-width":"500px"}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-hourglass-start mr-2"}),_vm._v("\n\t\t\t\t\tProgramador\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.EmisoraID),expression:"form.EmisoraID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "EmisoraID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoEmisoras),function(emisora){return _c('option',{key:emisora.EmisoraID,domProps:{"value":emisora.EmisoraID}},[_vm._v(_vm._s(emisora.Nombre))])}),0)]),_vm._v(" "),(_vm.form.EmisoraID)?_c('div',[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('button',{staticClass:"btn",class:(!_vm.form.diferida && !_vm.form.periodica) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setAhora()}}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tInstantánea\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn",class:(_vm.form.diferida) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setDiferida()}}},[_c('span',{staticClass:"fa fa-clock-o mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tDiferida\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn",class:(_vm.form.periodica) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setProgramado()}}},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tPeriodica\n\t\t\t\t\t\t\t")])])]):_vm._e()]),_vm._v(" "),(_vm.form.EmisoraID)?_c('div',{staticClass:"card-body"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.titulo),expression:"form.titulo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Escribe un título, por ejemplo: Hoy por Hoy Castellón"},domProps:{"value":(_vm.form.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "titulo", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(!_vm.form.publica) ? 'btn-danger' : 'btn-default',on:{"click":function($event){_vm.form.publica = false}}},[_c('span',{staticClass:"fa fa-lock mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tPrivada\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn",class:(_vm.form.publica) ? 'btn-success' : 'btn-default',on:{"click":function($event){_vm.form.publica = true}}},[_c('span',{staticClass:"fa fa-unlock mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tPública\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[(!_vm.form.periodica && !_vm.form.diferida)?_c('div',{staticClass:"col"},[_c('b',[_vm._v("Dia")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled-dates":{from: new Date(new Date().getTime())},"monday-first":true,"language":_vm.$dateLang,"bootstrap-styling":true},model:{value:(_vm.form.fecha),callback:function ($$v) {_vm.$set(_vm.form, "fecha", $$v)},expression:"form.fecha"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b',[_vm._v("Hora de comienzo")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.form.horaIni),expression:"form.horaIni"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"HH:MM"},domProps:{"value":(_vm.form.horaIni)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "horaIni", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b',[_vm._v("Hora de fin")]),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.form.horaFin),expression:"form.horaFin"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"HH:MM"},domProps:{"value":(_vm.form.horaFin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "horaFin", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"mt-3 text-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.notificaEmail),expression:"form.notificaEmail"}],attrs:{"type":"checkbox","id":"chavisardiferido"},domProps:{"checked":Array.isArray(_vm.form.notificaEmail)?_vm._i(_vm.form.notificaEmail,null)>-1:(_vm.form.notificaEmail)},on:{"change":function($event){var $$a=_vm.form.notificaEmail,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "notificaEmail", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "notificaEmail", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "notificaEmail", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"chavisardiferido"}},[_vm._v("Avisarme por e-mail cuando esté lista")])])]):_vm._e(),_vm._v(" "),(_vm.form.diferida && _vm.form.EmisoraID)?_c('div',{staticClass:"card-body"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col"},[_c('b',[_vm._v("Descargar el día")]),_vm._v(" "),_c('datepicker',{staticClass:"mt-1",attrs:{"disabled-dates":{to: new Date(new Date().getTime() - 86400000)},"monday-first":true,"language":_vm.$dateLang,"bootstrap-styling":true},model:{value:(_vm.form.diferida.fecha),callback:function ($$v) {_vm.$set(_vm.form.diferida, "fecha", $$v)},expression:"form.diferida.fecha"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.form.periodica && _vm.form.EmisoraID)?_c('div',{staticClass:"card-body"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b',[_vm._v("Día de inicio")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled-dates":{to: new Date(new Date().getTime() - 86400000)},"monday-first":true,"language":_vm.$dateLang,"bootstrap-styling":true},model:{value:(_vm.form.periodica.fechaIni),callback:function ($$v) {_vm.$set(_vm.form.periodica, "fechaIni", $$v)},expression:"form.periodica.fechaIni"}})],1),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b',[_vm._v("Día de fin")]),_vm._v(" "),_c('datepicker',{attrs:{"monday-first":true,"language":_vm.$dateLang,"bootstrap-styling":true,"placeholder":"Opcional"},model:{value:(_vm.form.periodica.fechaFin),callback:function ($$v) {_vm.$set(_vm.form.periodica, "fechaFin", $$v)},expression:"form.periodica.fechaFin"}})],1)]),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b',[_vm._v("Días de la semana")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.diasSem),function(dia,index){return _c('button',{key:'dia_' + index,staticClass:"btn btn-sm mr-1",class:(_vm.form.periodica.dias.search((index + 1)) >= 0) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleDiaProgramado(index + 1)}}},[_vm._v(_vm._s(dia)+"\n\t\t\t\t\t\t")])})],2)]):_vm._e(),_vm._v(" "),(_vm.form.horaIni && _vm.form.horaFin && _vm.form.EmisoraID)?_c('div',{staticClass:"card-footer bg-dark text-white"},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.programar()}}},[(!_vm.form.diferido && !_vm.form.periodica)?_c('div',[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("\n\t\t\t\t\t\t\tDescargar\n\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.form.diferido || _vm.form.periodica)?_c('div',[_c('span',{staticClass:"fa mr-2",class:(_vm.form.diferido) ? 'fa-clock-o' : 'fa-calendar'}),_vm._v("\n\t\t\t\t\t\t\tProgramar\n\t\t\t\t\t\t")]):_vm._e()])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body bg-light"},[_c('p',[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("\n\t\t\t\t\t\tEste es el programador de descargas del copión. Puedes seleccionar un intérvalo de tiempo y automáticamente\n\t\t\t\t\t\tse generará un fichero de audio con la grabación.\n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\t\tTambién puedes programar el momento en el que se debe generar ese fichero (por ejemplo porque quieras que automáticamente se genere\n\t\t\t\t\t\tuna copia de un programa que todavía no se ha emitido)\n\t\t\t\t\t")]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t\t\t\tA su vez también puedes crear tareas periódicas para que se ejecuten en los días que necesites. Sin embargo por motivos de seguridad\n\t\t\t\t\t\ty estabilidad del servidor, "),_c('b',[_vm._v("solo será posible crear como máximo 5 tareas periódicas por usuario")]),_vm._v(".\n\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('b',[_c('span',{staticClass:"fa fa-gear mr-2"}),_vm._v("\n\t\t\t\t\t\t\tEmisora\n\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"mt-3"},[_c('b',[_c('span',{staticClass:"fa fa-gear mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tTipo de descarga\n\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('b',[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("\n\t\t\t\t\t\t\tDetalles\n\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('span',{staticClass:"fa fa-clock-o"}),_vm._v(" "),_c('b',[_vm._v("Descarga en diferido")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v(" "),_c('b',[_vm._v("Descarga periódica")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-dark btn-sm",on:{"click":function($event){return _vm.nueva()}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tNueva descarga\n\t\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-condensed m-0"},[_c('tbody',_vm._l((_vm.listadoProgramaciones),function(prog){return _c('tr',{key:prog.ID_programacion},[_c('td',{staticStyle:{"width":"100px","vertical-align":"middle","text-align":"center"}},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":'/src/modulos/gestion-emisoras/php/api/emisoras/ver-logo.php?logotipo=' + prog.EmisoraLogo,"title":prog.EmisoraNombre}})]),_vm._v(" "),_c('td',{staticStyle:{"width":"30px","font-size":"2em"}},[_c('span',{staticClass:"fa",class:(prog.tipo === 'diferida') ? 'fa-clock-o' : 'fa-calendar'})]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(prog.titulo))]),_vm._v(" "),_c('i',{staticStyle:{"color":"#888888"}},[_vm._v("(de "+_vm._s(prog.horaIni)+" a "+_vm._s(prog.horaFin)+")")]),_vm._v(" "),_c('br'),_vm._v(" "),(prog.tipo === 'diferida')?_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t\tEl próximo "+_vm._s(new Date(prog.diferida.fecha).toLocaleDateString())+" a las "+_vm._s(prog.diferida.hora)+"\n\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(prog.tipo === 'periodica')?_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t\t\tTodos los "+_vm._s(_vm.getDiasBonitos(prog.periodica.dias))+"\n\t\t\t\t\t\t\t\t\t\tdesde el "+_vm._s(new Date(prog.periodica.fechaIni).toLocaleDateString())+"\n\t\t\t\t\t\t\t\t\t\t"),(prog.periodica.fechaFin)?_c('span',[_vm._v("hasta el "+_vm._s(new Date(prog.periodica.fechaFin).toLocaleDateString()))]):_vm._e(),_vm._v("\n\t\t\t\t\t\t\t\t\t\ta las "+_vm._s(prog.periodica.hora)+"\n\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-size":"0.9em","opacity":"0.7"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tCreado por "+_vm._s(prog.usuario.nombre)+" "+_vm._s(prog.usuario.apellidos)+"\n\t\t\t\t\t\t\t\t\t\t"),(_vm.usuario.ID !== prog.usuario.ID)?_c('span',[_vm._v("con ámbito público")]):_vm._e()])]),_vm._v(" "),_c('td',{staticStyle:{"width":"80px","text-align":"center","vertical-align":"middle"}},[(_vm.usuario.ID === prog.usuario.ID)?_c('div',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.programacion = prog}}},[_c('span',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.eliminarPrograma(prog)}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()])])}),0)])]),_vm._v(" "),(_vm.listadoProgramaciones.length === 0)?_c('div',{staticClass:"card-body text-center text-danger"},[_c('span',{staticClass:"fa fa-info-circle",staticStyle:{"font-size":"3em"}}),_vm._v(" "),_c('h3',[_vm._v("No hay programaciones activas")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-condensed m-0"},[_c('tbody',_vm._l((_vm.listadoFicheros),function(fichero){return _c('tr',{key:fichero.ID_fichero},[_c('td',{staticStyle:{"width":"100px","vertical-align":"middle","text-align":"center"}},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":'/src/modulos/gestion-emisoras/php/api/emisoras/ver-logo.php?logotipo=' + fichero.EmisoraLogo}})]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(fichero.titulo)+" - "+_vm._s(fichero.programacion.horaIni)+" a "+_vm._s(fichero.programacion.horaFin))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"#999999","font-style":"italic"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tGenerado: "+_vm._s(fichero.fechaGenerado)+" a las "+_vm._s(fichero.horaGenerado)+"\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('td',{staticStyle:{"width":"40px","text-align":"center","vertical-align":"middle"}},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.descargar(fichero.ID_descarga)}}},[_c('span',{staticClass:"fa fa-download"})])])])}),0)])])])])]),_vm._v(" "),(_vm.programacion)?_c('programador-copion',{attrs:{"data":_vm.programacion},on:{"cerrar":function($event){return _vm.cierraProgramacion()}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v("\n\t\t\t\t\t\t\tProgramaciones activas\n\t\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-copy mr-2"}),_vm._v("\n\t\t\t\t\tFicheros generados\n\t\t\t\t")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(1066);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('descargar-xframe', {
			name: 'Descargar del XFrame',
			component: __WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]
		});
	}
});

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(454);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c04524e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1069);
function injectStyle (ssrContext) {
  __webpack_require__(1067)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c04524e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var uri = 'descargar-xframe/php/';

var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(uri + url);
};

var post = function post(url, datos) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(uri + url, datos);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getBuzones: function getBuzones() {
		return get('listado-buzones.php');
	},
	buscar: function buscar(filtro) {
		var datos = _.clone(filtro);
		datos.fecha = !filtro.fecha ? null : filtro.fecha.toLocaleDateString();
		return post('buscar.php', datos);
	}
});

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Título")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.nombre),expression:"filtro.nombre"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Buscar por título"},domProps:{"value":(_vm.filtro.nombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "nombre", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha de creación")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{style:({ cursor: 'pointer' }),attrs:{"monday-first":true,"bootstrap-styling":true,"format":"dd-MM-yyyy","highlighted":{ dates: [new Date()] },"placeholder":"DD-MM-YYYY"},model:{value:(_vm.filtro.fecha),callback:function ($$v) {_vm.$set(_vm.filtro, "fecha", $$v)},expression:"filtro.fecha"}}),_c('div',{staticClass:"input-group-append"},[(_vm.filtro.fecha)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.filtro.fecha = null}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()])],1)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Buzón")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.buzon),expression:"filtro.buzon"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "buzon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona un buzón")]),_vm._l((_vm.listadoBuzones),function(buzon){return _c('option',{key:buzon.ID,domProps:{"value":buzon.ID}},[_vm._v(_vm._s(buzon.titulo))])})],2)])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary mr-2",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])])]),_c('div',{staticClass:"card mt-3"},[_vm._m(1),(_vm.listadoFicheros.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped m-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.listadoFicheros),function(fichero){return _c('tr',{key:fichero.ID},[_c('td',[_vm._v(_vm._s(fichero.buzon))]),_c('td',[_vm._v(_vm._s(fichero.nombre))]),_c('td',[_vm._v(_vm._s(new Date((fichero.duracion - 3600) * 1000).toLocaleTimeString()))]),_c('td',[_vm._v(_vm._s(fichero.Fecha)+" a las "+_vm._s(fichero.Hora))]),_c('td',[_c('a',{staticClass:"btn btn-primary",attrs:{"href":'/src/modulos/descargar-xframe/php/descargar.php?ID=' + fichero.ID,"target":"_blank"}},[_c('span',{staticClass:"fa fa-download"})])])])}),0)])]):_vm._e(),(_vm.listadoFicheros.length === 0)?_c('div',{staticClass:"text-center pt-4 pb-4"},[_c('h3',[_vm._v("No hay resultados")])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Búsqueda de ficheros")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Buzón")]),_c('th',[_vm._v("Nombre")]),_c('th',[_vm._v("Duración")]),_c('th',[_vm._v("Fecha")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_editor_editor__ = __webpack_require__(1073);




/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('escaletas', {
			name: 'Escaletas',
			component: __WEBPACK_IMPORTED_MODULE_1__Main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('escaletas').child('', {
			name: 'Editor de escaletas',
			component: __WEBPACK_IMPORTED_MODULE_2__components_editor_editor__["a" /* default */]
		});
	}
});

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5803be0b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1072);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5803be0b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(455);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fd399d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1077);
function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fd399d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_telefono_vue__ = __webpack_require__(456);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294b4da3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_telefono_vue__ = __webpack_require__(1076);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_telefono_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294b4da3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_telefono_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-1"},[_c('div',{staticClass:"input-group"},[_vm._m(0),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nom),expression:"nom"}],staticClass:"form-control",attrs:{"placeholder":"Nombre"},domProps:{"value":(_vm.nom)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nom=$event.target.value}}}),_vm._m(1),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tel),expression:"tel"},{name:"mask",rawName:"v-mask",value:('#### ### ## ## ##'),expression:"'#### ### ## ## ##'"}],staticClass:"form-control",domProps:{"value":(_vm.tel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tel=$event.target.value}}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-phone"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_c('div',{staticClass:"card mt-2"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Contenido de la escaleta - TÉCNICA"),_c('button',{staticClass:"close",on:{"click":function($event){return _vm.nuevaLinea()}}},[_c('span',{staticClass:"fa fa-plus"})])]),_c('table',{staticClass:"table table-striped m-0"},[_vm._m(1),_c('tbody',_vm._l((_vm.Escaleta.Lineas),function(linea,i){return _c('tr',{key:i},[_c('td',{staticClass:"celdaNum"},[_vm._v(_vm._s((i + 1)))]),_c('td',{staticClass:"celdaHora"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.Escaleta.Lineas[i].Hora),expression:"Escaleta.Lineas[i].Hora"}],staticClass:"form-control",domProps:{"value":(_vm.Escaleta.Lineas[i].Hora)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Escaleta.Lineas[i], "Hora", $event.target.value)}}})]),_c('td',{staticClass:"celdaDuracion"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.Escaleta.Lineas[i].Duracion),expression:"Escaleta.Lineas[i].Duracion"}],staticClass:"form-control",domProps:{"value":(_vm.Escaleta.Lineas[i].Duracion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Escaleta.Lineas[i], "Duracion", $event.target.value)}}})]),_c('td',[_vm._l((linea.Contenido),function(item,c){return _c('div',{key:i + '-cont-' + c,staticClass:"mb-1"},[(item.tipo === 'comentario')?_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"Aquí tu comentario"}}):_vm._e()])}),_c('span',{staticClass:"fa fa-edit m-2",staticStyle:{"cursor":"pointer"},attrs:{"title":"Agregar comentario"},on:{"click":function($event){return _vm.nuevoComentario(_vm.Escaleta.Lineas[i].Contenido)}}}),_c('span',{staticClass:"fa fa-file-o m-2",staticStyle:{"cursor":"pointer"},attrs:{"title":"Vincular noticia"}})],2),_c('td',[_vm._l((linea.NotasTecnicas),function(item,c){return _c('div',{key:i + '-cont-' + c,staticClass:"mb-1"},[(item.tipo === 'comentario')?_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"Aquí tu comentario"}}):_vm._e(),(item.tipo === 'telefono')?_c('Telefono',{attrs:{"telefono":_vm.Escaleta.Lineas[i].NotasTecnicas[c].telefono,"nombre":_vm.Escaleta.Lineas[i].NotasTecnicas[c].nombre},on:{"update:telefono":function($event){return _vm.$set(_vm.Escaleta.Lineas[i].NotasTecnicas[c], "telefono", $event)},"update:nombre":function($event){return _vm.$set(_vm.Escaleta.Lineas[i].NotasTecnicas[c], "nombre", $event)}}}):_vm._e()],1)}),_c('span',{staticClass:"fa fa-edit m-2",staticStyle:{"cursor":"pointer"},attrs:{"title":"Agregar comentario"},on:{"click":function($event){return _vm.nuevoComentario(_vm.Escaleta.Lineas[i].NotasTecnicas)}}}),_c('span',{staticClass:"fa fa-volume-up m-2",staticStyle:{"cursor":"pointer"},attrs:{"title":"Agregar corte de audio"}}),_c('span',{staticClass:"fa fa-phone m-2",staticStyle:{"cursor":"pointer"},attrs:{"title":"Agregar teléfono"},on:{"click":function($event){return _vm.nuevoTelefono(_vm.Escaleta.Lineas[i].NotasTecnicas)}}})],2),_c('th',{staticClass:"celdaBoton"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.Escaleta.Lineas.splice(i, 1)}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Quitar")])])])}),0)]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.nuevaLinea()}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nueva línea")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Información")]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Programa")])]),_c('select',{staticClass:"form-control"})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Día")])]),_c('select',{staticClass:"form-control"})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Estilo de escaleta")])]),_c('select',{staticClass:"form-control"})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Importar desde")])]),_c('select',{staticClass:"form-control"})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"celdaNum"},[_vm._v("#")]),_c('th',{staticClass:"celdaHora"},[_vm._v("Hora")]),_c('th',{staticClass:"celdaDuracion"},[_vm._v("Duración")]),_c('th',[_vm._v("Contenido")]),_c('th',[_vm._v("Notas técnicas")]),_c('th',{staticClass:"celdaBoton"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listado_listado__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_editor_editor_vue__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_visualizar_visualizar_vue__ = __webpack_require__(1089);






/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('eventos', {
			name: 'Eventos',
			component: __WEBPACK_IMPORTED_MODULE_1__Main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('eventos').child('', {
			name: 'Listado de eventos',
			component: __WEBPACK_IMPORTED_MODULE_2__components_listado_listado__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('eventos').child('editor', {
			name: 'Nuevo evento',
			component: __WEBPACK_IMPORTED_MODULE_3__components_editor_editor_vue__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('eventos').child('editor/:id', {
			name: 'Editar evento',
			component: __WEBPACK_IMPORTED_MODULE_3__components_editor_editor_vue__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('eventos').child('ver/:id', {
			name: 'Visualizar evento',
			component: __WEBPACK_IMPORTED_MODULE_4__components_visualizar_visualizar_vue__["a" /* default */]
		});
	}
});

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f96e06a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1080);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f96e06a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__ = __webpack_require__(457);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abad3e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__ = __webpack_require__(1083);
function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7abad3e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Texto")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cadena),expression:"filtro.cadena"}],staticClass:"form-control",attrs:{"placeholder":"Busca por texto"},domProps:{"value":(_vm.filtro.cadena)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cadena", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha inicio")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"monday-first":true,"bootstrap-styling":true,"input-class":"form-control","placeholder":"Selecciona"},on:{"input":_vm.buscar},model:{value:(_vm.filtro.FechaInicio),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaInicio", $$v)},expression:"filtro.FechaInicio"}}),_c('div',{staticClass:"input-group-append"},[(_vm.filtro.FechaInicio)?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarFechaInicio}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()])],1)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha fin")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"monday-first":true,"bootstrap-styling":true,"input-class":"form-control","placeholder":"Selecciona"},on:{"input":_vm.buscar},model:{value:(_vm.filtro.FechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaFin", $$v)},expression:"filtro.FechaFin"}}),_c('div',{staticClass:"input-group-append"},[(_vm.filtro.FechaFin)?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarFechaFin}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()])],1)])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary mr-2",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.nuevo}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nuevo evento")])])]),_c('div',{staticClass:"card mt-3"},[_vm._m(1),_c('table',{staticClass:"table table-striped m-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.resultadosFiltrados),function(evento){return _c('tr',{key:evento.EventoID},[_c('td',[_vm._v(_vm._s(evento.EventoID))]),_c('td',[_vm._v(_vm._s(evento.Titulo))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(evento.FechaInicioEvento,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(evento.FechaInicioEvento,'H:mm')))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(evento.FechaFinEvento,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(evento.FechaFinEvento,'H:mm')))]),_c('td',{staticClass:"text-white",class:(evento.Activo) ? 'bg-success' : 'bg-danger'},[(evento.Activo)?_c('span',[_vm._v("Activo")]):_c('span',[_vm._v("Inactivo")])]),_c('td',[_vm._v(_vm._s(evento.Asistentes)+" asistentes")]),_c('td',[_c('button',{staticClass:"m-1 btn btn-sm btn-dark",on:{"click":function($event){return _vm.$router.push('/main/eventos/ver/' + evento.EventoID)}}},[_c('span',{staticClass:"fa fa-home mr-2"}),_vm._v("Acceder")]),_c('button',{staticClass:"m-1 btn btn-sm btn-warning",on:{"click":function($event){return _vm.editar(evento)}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editar")]),_c('button',{staticClass:"m-1 btn btn-sm btn-primary",on:{"click":function($event){return _vm.promocionar(evento)}}},[_c('span',{staticClass:"fa fa-envelope mr-2"}),_vm._v("Promocionar")]),_c('button',{staticClass:"m-1 btn btn-sm btn-danger",on:{"click":function($event){return _vm.eliminar(evento.EventoID)}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")]),_c('a',{staticClass:"m-1 btn btn-sm btn-success",attrs:{"href":'https://eventos.radiocastellon.com/#/' + evento.PublicID,"target":"_blank"}},[_c('span',{staticClass:"fa fa-external-link"})])])])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Búsqueda de eventos")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Título")]),_c('th',[_vm._v("Inicio")]),_c('th',[_vm._v("Fin")]),_c('th',[_vm._v("Activo")]),_c('th',[_vm._v("Asistentes")]),_c('th',[_vm._v("Opciones")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(458);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76311f8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1088);
function injectStyle (ssrContext) {
  __webpack_require__(1085)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76311f8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76311f8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vistaPrevia_vue__ = __webpack_require__(459);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48476e24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_vistaPrevia_vue__ = __webpack_require__(1087);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vistaPrevia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48476e24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_vistaPrevia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-picture mr-2"}),_vm._v("Vista previa"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":'/src/modulos/eventos/php/api/getImagen.php?imagen=' + _vm.evento[_vm.tipo]}}),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar imagen")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(!_vm.evento.EventoID)?_c('div',[_c('h1',[_vm._v("Evento no encontrado")])]):_c('div',[(_vm.evento.ImagenCabecera)?_c('div',{staticClass:"mb-2"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":'/src/modulos/eventos/php/api/getImagen.php?imagen=' + _vm.evento.ImagenCabecera}})]):_vm._e(),(_vm.evento.PublicID)?_c('div',{ref:"cabecera",staticClass:"mb-2"},[_c('button',{staticClass:"m-1 btn btn-warning",on:{"click":function($event){return _vm.upload('cabecera')}}},[_c('span',{staticClass:"fa fa-photo mr-2"}),_vm._v("Cambiar imagen de cabecera")]),_c('button',{staticClass:"m-1 btn btn-warning",on:{"click":function($event){return _vm.upload('invitacion')}}},[_c('span',{staticClass:"fa fa-photo mr-2"}),_vm._v("Cambiar imagen de invitación")]),_c('button',{staticClass:"m-1 btn btn-warning",on:{"click":function($event){return _vm.upload('cartel')}}},[_c('span',{staticClass:"fa fa-photo mr-2"}),_vm._v("Cambiar imagen del cartel")])]):_vm._e(),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('p',[(_vm.evento.ImagenInvitacion)?_c('button',{staticClass:"m-1 btn btn-primary",on:{"click":function($event){return _vm.verImagen('ImagenInvitacion')}}},[_c('span',{staticClass:"fa fa-photo mr-2"}),_vm._v("Ver diseño de invitación")]):_vm._e(),(_vm.evento.ImagenCartel)?_c('button',{staticClass:"m-1 btn btn-primary",on:{"click":function($event){return _vm.verImagen('ImagenCartel')}}},[_c('span',{staticClass:"fa fa-photo mr-2"}),_vm._v("Ver diseño del cartel")]):_vm._e()]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Título del evento")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.evento.Titulo),expression:"evento.Titulo"}],staticClass:"form-control form-control-lg",domProps:{"value":(_vm.evento.Titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.evento, "Titulo", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descripción del evento")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.evento.Descripcion),expression:"evento.Descripcion"}],staticClass:"form-control",attrs:{"rows":"5"},domProps:{"value":(_vm.evento.Descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.evento, "Descripcion", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Lugar del evento")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.evento.Lugar),expression:"evento.Lugar"}],staticClass:"form-control",domProps:{"value":(_vm.evento.Lugar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.evento, "Lugar", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha y hora de inicio del evento")]),_c('div',{staticClass:"input-group"},[_vm._m(1),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##-##-####'),expression:"'##-##-####'"},{name:"model",rawName:"v-model",value:(_vm.FechaInicio),expression:"FechaInicio"}],staticClass:"form-control",domProps:{"value":(_vm.FechaInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.FechaInicio=$event.target.value}}}),_vm._m(2),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.HoraInicio),expression:"HoraInicio"}],staticClass:"form-control",domProps:{"value":(_vm.HoraInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.HoraInicio=$event.target.value}}})])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha y hora de fin del evento")]),_c('div',{staticClass:"input-group"},[_vm._m(3),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##-##-####'),expression:"'##-##-####'"},{name:"model",rawName:"v-model",value:(_vm.FechaFin),expression:"FechaFin"}],staticClass:"form-control",domProps:{"value":(_vm.FechaFin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.FechaFin=$event.target.value}}}),_vm._m(4),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.HoraFin),expression:"HoraFin"}],staticClass:"form-control",domProps:{"value":(_vm.HoraFin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.HoraFin=$event.target.value}}})])])]),(_vm.evento.PublicID)?_c('div',{staticClass:"card-body bg-light"},[_c('h4',[_c('b',[_vm._v("ID público:")]),_vm._v(" "+_vm._s(_vm.evento.PublicID))])]):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_vm._m(5),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nº máximo de asistentes")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.evento.MaximoInscripciones),expression:"evento.MaximoInscripciones"}],staticClass:"form-control",attrs:{"placeholder":"En blanco no hay límite"},domProps:{"value":(_vm.evento.MaximoInscripciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.evento, "MaximoInscripciones", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nº máximo de asistentes por registro")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.evento.MaximoInscritosEmail),expression:"evento.MaximoInscritosEmail"}],staticClass:"form-control",attrs:{"placeholder":"En blanco no hay límite"},domProps:{"value":(_vm.evento.MaximoInscritosEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.evento, "MaximoInscritosEmail", $event.target.value)}}})])])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de registro")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.evento.SoloInvitacion) ? '' : 'btn-primary',on:{"click":function($event){_vm.evento.SoloInvitacion = false}}},[_vm._v("Abierto")]),_c('button',{staticClass:"btn",class:(_vm.evento.SoloInvitacion) ? 'btn-primary' : '',on:{"click":function($event){_vm.evento.SoloInvitacion = true}}},[_vm._v("Solo con invitación")])])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha y hora de inicio de inscripciones")]),_c('div',{staticClass:"input-group"},[_vm._m(6),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##-##-####'),expression:"'##-##-####'"},{name:"model",rawName:"v-model",value:(_vm.FechaInicioInscripciones),expression:"FechaInicioInscripciones"}],staticClass:"form-control",domProps:{"value":(_vm.FechaInicioInscripciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.FechaInicioInscripciones=$event.target.value}}}),_vm._m(7),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.HoraInicioInscripciones),expression:"HoraInicioInscripciones"}],staticClass:"form-control",domProps:{"value":(_vm.HoraInicioInscripciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.HoraInicioInscripciones=$event.target.value}}})])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha y hora de fin de inscripciones")]),_c('div',{staticClass:"input-group"},[_vm._m(8),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##-##-####'),expression:"'##-##-####'"},{name:"model",rawName:"v-model",value:(_vm.FechaFinInscripciones),expression:"FechaFinInscripciones"}],staticClass:"form-control",domProps:{"value":(_vm.FechaFinInscripciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.FechaFinInscripciones=$event.target.value}}}),_vm._m(9),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.HoraFinInscripciones),expression:"HoraFinInscripciones"}],staticClass:"form-control",domProps:{"value":(_vm.HoraFinInscripciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.HoraFinInscripciones=$event.target.value}}})])])]),_c('div',{staticClass:"card-body bg-light"},[_c('h5',[_vm._v("LOPD")]),_c('vue-mce',{staticClass:"editor",attrs:{"config":_vm.configuracionEditor},model:{value:(_vm.evento.LOPD),callback:function ($$v) {_vm.$set(_vm.evento, "LOPD", $$v)},expression:"evento.LOPD"}})],1)])])])]),(_vm.preview)?_c('VistaPrevia',{attrs:{"tipo":_vm.preview,"evento":_vm.evento},on:{"update:evento":function($event){_vm.evento=$event},"cerrar":function($event){_vm.preview=null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-info mr-2"}),_vm._v("Información básica")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Fecha")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Hora")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Fecha")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Hora")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-group mr-2"}),_vm._v("Asistentes")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Fecha")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Hora")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Fecha")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Hora")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visualizar_vue__ = __webpack_require__(460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7480a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visualizar_vue__ = __webpack_require__(1093);
function injectStyle (ssrContext) {
  __webpack_require__(1090)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c7480a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visualizar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7480a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visualizar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insertar_vue__ = __webpack_require__(461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a10592_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_insertar_vue__ = __webpack_require__(1092);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insertar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a10592_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_insertar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Insertar registro"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"mt-3 text-info"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Información")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Empresa")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.Empresa),expression:"registro.Empresa"}],staticClass:"form-control",attrs:{"placeholder":"Nombre de la empresa"},domProps:{"value":(_vm.registro.Empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "Empresa", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("E-mail")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.Email),expression:"registro.Email"}],staticClass:"form-control",attrs:{"placeholder":"Email de contacto"},domProps:{"value":(_vm.registro.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "Email", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Teléfono")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.Telefono),expression:"registro.Telefono"}],staticClass:"form-control",attrs:{"placeholder":"Teléfono de contacto"},domProps:{"value":(_vm.registro.Telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "Telefono", $event.target.value)}}})])])]),_c('h3',{staticClass:"mt-3 text-info"},[_c('span',{staticClass:"fa fa-group mr-2"}),_vm._v("Asistentes")])]),_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.registro.asistentes),function(asistente,i){return _c('tr',{key:asistente.AsistenteID},[_c('td',{staticStyle:{"width":"25px","text-align":"center","vertical-align":"middle"}},[_c('span',{staticClass:"fa fa-user"})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.asistentes[i].Nombre),expression:"registro.asistentes[i].Nombre"}],staticClass:"form-control",attrs:{"placeholder":"Nombre"},domProps:{"value":(_vm.registro.asistentes[i].Nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro.asistentes[i], "Nombre", $event.target.value)}}})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.asistentes[i].Apellidos),expression:"registro.asistentes[i].Apellidos"}],staticClass:"form-control",attrs:{"placeholder":"Apellidos"},domProps:{"value":(_vm.registro.asistentes[i].Apellidos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro.asistentes[i], "Apellidos", $event.target.value)}}})]),_c('td',{staticStyle:{"width":"35px","text-align":"center","vertical-align":"middle"}},[(i > 0)?_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.delAsistente(i)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()])])}),0)]),_c('div',{staticClass:"card-body"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addAsistente}},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Añadir asistente")])]),_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"mt-3 mb-3 text-info"},[_c('span',{staticClass:"fa fa-rss mr-2"}),_vm._v("Como supo del evento")]),_vm._l((_vm.listadoOpcionesEnterado),function(opcion,i){return _c('div',{key:i},[_c('label',[_c('input',{staticClass:"mr-3",attrs:{"type":"checkbox"},domProps:{"checked":_vm.registro.enteradoPor.indexOf(opcion) >= 0},on:{"change":function($event){return _vm.setEnterado(opcion, $event)}}}),_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(opcion))])])])}),(_vm.registro.enteradoPor.indexOf('Otra') >= 0)?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.enteradoPorOtros),expression:"registro.enteradoPorOtros"}],staticClass:"form-control pl-4",attrs:{"placeholder":"Por favor explica donde..."},domProps:{"value":(_vm.registro.enteradoPorOtros)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "enteradoPorOtros", $event.target.value)}}}):_vm._e()],2),_c('div',{staticClass:"card-body"},[_c('h3',{staticClass:"mb-3 text-info"},[_c('span',{staticClass:"fa fa-gavel mr-2"}),_vm._v("Protección de datos y comunicaciones")]),_c('div',{staticClass:"alert alert-warning"},[_c('span',{staticClass:"fa fa-exclamation-circle mr-2"}),_c('b',{staticClass:"mr-1"},[_vm._v("LOPD:")]),_vm._v("Al no ser un registro a través del formulario online. Es preciso preguntar al usuario si acepta el tratamiento de los datos que aparece en la política de privacidad,\n así como si quiere recibir comunicaciones futuras")]),_c('label',{staticStyle:{"cursor":"pointer"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.AceptaComunicaciones),expression:"registro.AceptaComunicaciones"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.registro.AceptaComunicaciones)?_vm._i(_vm.registro.AceptaComunicaciones,null)>-1:(_vm.registro.AceptaComunicaciones)},on:{"change":function($event){var $$a=_vm.registro.AceptaComunicaciones,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.registro, "AceptaComunicaciones", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.registro, "AceptaComunicaciones", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.registro, "AceptaComunicaciones", $$c)}}}}),_vm._v("La empresa que se registra me ha dado el consentimiento para recibir futuras comunicaciones por e-mail")])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary mr-3",on:{"click":_vm.insertar}},[_c('span',{staticClass:"fa fa-send mr-2"}),_vm._v("Guardar empresa")]),(_vm.InscritoID)?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar empresa")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.evento)?_c('div',{staticClass:"container-fluid"},[(_vm.evento.ImagenCabecera)?_c('div',{staticClass:"mb-2"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":'/src/modulos/eventos/php/api/getImagen.php?imagen=' + _vm.evento.ImagenCabecera}})]):_vm._e(),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body bg-warning text-center"},[_c('h3',[_vm._v(_vm._s(_vm.evento.Titulo))])]),_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',[_vm._m(0),_c('tr',[_vm._m(1),_c('td',[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v(_vm._s(_vm._f("moment")(_vm.evento.FechaInicioEvento,'DD-MM-YYYY'))),_c('span',{staticClass:"fa fa-clock-o ml-4 mr-2"}),_vm._v(_vm._s(_vm._f("moment")(_vm.evento.FechaInicioEvento,'HH:mm')))])]),_c('tr',[_vm._m(2),_c('td',[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v(_vm._s(_vm._f("moment")(_vm.evento.FechaFinEvento,'DD-MM-YYYY'))),_c('span',{staticClass:"fa fa-clock-o ml-4 mr-2"}),_vm._v(_vm._s(_vm._f("moment")(_vm.evento.FechaFinEvento,'HH:mm')))])]),_vm._m(3),_c('tr',[_vm._m(4),_c('td',[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v(_vm._s(_vm._f("moment")(_vm.evento.FechaInicioInscripciones,'DD-MM-YYYY'))),_c('span',{staticClass:"fa fa-clock-o ml-4 mr-2"}),_vm._v(_vm._s(_vm._f("moment")(_vm.evento.FechaInicioInscripciones,'HH:mm')))])]),_c('tr',[_vm._m(5),_c('td',[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v(_vm._s(_vm._f("moment")(_vm.evento.FechaFinInscripciones,'DD-MM-YYYY'))),_c('span',{staticClass:"fa fa-clock-o ml-4 mr-2"}),_vm._v(_vm._s(_vm._f("moment")(_vm.evento.FechaFinInscripciones,'HH:mm')))])]),_c('tr',[_vm._m(6),_c('td',[_vm._v(_vm._s(_vm.inscritos.reduce(function (acum, ins) {return acum + ins.numeroAsistentes}, 0))+" inscritos")])]),_c('tr',[_vm._m(7),_c('td',[_vm._v(_vm._s(_vm.asistentesConfirmados)+" asistentes")])]),_vm._m(8),_c('tr',[_vm._m(9),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.importes.ImportePagado,''))+" €")])]),_c('tr',[_vm._m(10),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.importes.ImporteComision,''))+" €")])]),_c('tr',[_vm._m(11),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.importes.ImportePercibido,''))+" €")])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"mr-2 btn btn-primary",on:{"click":function($event){_vm.insertando = _vm.evento.EventoID}}},[_c('span',{staticClass:"fa fa-building mr-2"}),_vm._v("Registrar empresa")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-9"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Asistentes"),(_vm.listadoAsistentes.length > 0)?_c('download-excel',{staticClass:"ml-3 btn btn-warning ml-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"meta":_vm.json_meta,"name":"asistentes.xls"}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("XLS")]):_vm._e()],1),_c('div',{staticClass:"col text-right"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(12),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cadena),expression:"filtro.cadena"}],staticClass:"form-control",attrs:{"placeholder":"Buscar por nombre o empresa"},domProps:{"value":(_vm.filtro.cadena)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cadena", $event.target.value)}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(_vm.filtro.soloConfirmados) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.soloConfirmados = !_vm.filtro.soloConfirmados}}},[_c('span',{staticClass:"fa fa-check"})])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(_vm.filtro.soloPagados) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.soloPagados = !_vm.filtro.soloPagados}}},[_c('span',{staticClass:"fa fa-euro"})])])])])])])]),_c('table',{staticClass:"m-0 table table-striped",staticStyle:{"background-color":"white"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.ordenar('ID')}}},[_c('span',[_vm._v("ID")]),(_vm.sort.campo === 'ID')?_c('span',{staticClass:"ml-2"},[_c('span',{staticClass:"fa",class:(_vm.sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.ordenar('Nombre')}}},[_c('span',[_vm._v("Nombre")]),(_vm.sort.campo === 'Nombre')?_c('span',{staticClass:"ml-2"},[_c('span',{staticClass:"fa",class:(_vm.sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.ordenar('Empresa')}}},[_c('span',[_vm._v("Empresa")]),(_vm.sort.campo === 'Empresa')?_c('span',{staticClass:"ml-2"},[_c('span',{staticClass:"fa",class:(_vm.sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.ordenar('Email')}}},[_c('span',[_vm._v("E-mail")]),(_vm.sort.campo === 'Email')?_c('span',{staticClass:"ml-2"},[_c('span',{staticClass:"fa",class:(_vm.sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.ordenar('Telefono')}}},[_c('span',[_vm._v("Teléfono")]),(_vm.sort.campo === 'Telefono')?_c('span',{staticClass:"ml-2"},[_c('span',{staticClass:"fa",class:(_vm.sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.ordenar('FechaInscrito')}}},[_c('span',[_vm._v("Fecha ins.")]),(_vm.sort.campo === 'FechaInscrito')?_c('span',{staticClass:"ml-2"},[_c('span',{staticClass:"fa",class:(_vm.sort.orden > 0) ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th'),_c('th')])]),_c('tbody',_vm._l((_vm.listadoAsistentes),function(asis){return _c('tr',{key:asis.AsistenteID,staticClass:"empresa",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.editarRegistro(asis.InscritoID)}}},[_c('td',[_vm._v(_vm._s(asis.InscritoID)+"."+_vm._s(asis.AsistenteID))]),_c('td',[_vm._v(_vm._s(asis.Nombre))]),_c('td',[_vm._v(" "+_vm._s(asis.Empresa)),(asis.NumeroAsistentes)?_c('div',{staticStyle:{"opacity":"0.6"}},[_vm._v(_vm._s(asis.NumeroAsistentes)+" asistentes")]):_vm._e()]),_c('td',[_vm._v(_vm._s(asis.Email))]),_c('td',[_vm._v(_vm._s(asis.Telefono))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(asis.FechaInscrito,'DD-MM-YYYY hh:mm')))]),_c('td',{staticClass:"text-right"},[(!asis.Asiste && asis.AsistenteID)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"title":"Asiste"},on:{"click":function($event){return _vm.asiste(asis.AsistenteID, $event)}}},[_c('span',{staticClass:"fa fa-check"})]):_vm._e(),(asis.Asiste && asis.AsistenteID)?_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"title":"No ha asistido"},on:{"click":function($event){return _vm.noAsiste(asis.AsistenteID, $event)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()]),_c('td',{staticClass:"text-right",on:{"click":function($event){return _vm.verDetallesPago($event, asis)}}},[(asis.AnulacionID)?_c('button',{staticClass:"btn btn-sm btn-block btn-warning ml-2"},[_c('span',{staticClass:"fa fa-euro mr-2"}),_vm._v("Anulado "+_vm._s(_vm._f("currency")(asis.ImportePagado,''))+" €")]):(asis.CaptureID)?_c('button',{staticClass:"btn btn-sm btn-block btn-success ml-2"},[_c('span',{staticClass:"fa fa-euro mr-2"}),_vm._v("Pagado "+_vm._s(_vm._f("currency")(asis.ImportePagado,''))+" €")]):_c('button',{staticClass:"btn btn-sm btn-block btn-danger"},[_vm._v("Pago pendiente")])])])}),0)])])]),(_vm.insertando)?_c('Insertar',{attrs:{"EventoID":_vm.insertando,"InscritoID":_vm.InscritoID},on:{"cerrar":_vm.cierraEditor,"actualizar":function($event){return _vm.getEvento(_vm.$route.params.id)}}}):_vm._e(),(_vm.detallesPago)?_c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-euro mr-2"}),_vm._v("Detalles del pago"),_c('button',{staticClass:"close",on:{"click":function($event){_vm.detallesPago = null}}},[_vm._v("×")])]),_c('table',{staticClass:"table table-striped"},[_c('tbody',[(_vm.detallesPago.AnulacionID)?_c('tr',{staticClass:"bg-warning"},[_c('td',{staticClass:"text-center",staticStyle:{"font-size":"1.5em","font-weight":"bold"},attrs:{"colspan":"2"}},[_c('span',{staticClass:"fa fa-ban"}),_c('br'),_vm._v("Incripción anulada e importe devuelto")])]):(!_vm.detallesPago.CaptureID)?_c('tr',{staticClass:"bg-warning"},[_c('td',{staticClass:"text-center",staticStyle:{"font-size":"1.5em","font-weight":"bold"},attrs:{"colspan":"2"}},[_c('span',{staticClass:"fa fa-exclamation-triangle"}),_c('br'),_vm._v("Pago no completado")])]):_vm._e(),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Fecha pagado")]),_c('td',[_vm._v(_vm._s(_vm.detallesPago.FechaPagado))])]),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Importe")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.detallesPago.ImportePagado,''))+" €")])]),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Importe comisión")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.detallesPago.ImporteComision,''))+" €")])]),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Importe percibido")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.detallesPago.ImportePercibido,''))+" €")])]),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("OrderID")]),_c('td',[_vm._v(_vm._s(_vm.detallesPago.OrderID))])]),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("CaptureID")]),_c('td',[_vm._v(_vm._s(_vm.detallesPago.CaptureID))])]),(_vm.detallesPago.AnulacionID)?_c('tr',{staticClass:"bg-danger text-white"},[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("ID anulación")]),_c('td',[_vm._v(_vm._s(_vm.detallesPago.AnulacionID)+"\t")])]):_vm._e()])])])]):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"bg-dark text-white",attrs:{"colspan":"2"}},[_c('h5',[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Detalles")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Inicio:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Fin:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"bg-dark text-white",attrs:{"colspan":"2"}},[_c('h5',[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Inscripciones")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Inicio:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Fin:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Inscritos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Asistentes confirmados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"bg-dark text-white",attrs:{"colspan":"2"}},[_c('h5',[_c('span',{staticClass:"fa fa-euro mr-2"}),_vm._v("Pagos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Importe pagado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Importe comisión")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Importe percibido")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cobros_index__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_comisiones_index__ = __webpack_require__(1116);




/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('cobros', {
			name: 'Gestión de cobros y recibos',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('cobros').child('cobros', {
			name: 'Gestión de cobros',
			component: __WEBPACK_IMPORTED_MODULE_2__components_cobros_index__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('cobros').child('comisiones', {
			name: 'Gestión de comisiones',
			component: __WEBPACK_IMPORTED_MODULE_3__components_comisiones_index__["a" /* default */]
		});
	}
});

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(462);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69cbf48a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1096);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69cbf48a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{staticClass:"container-fluid"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(463);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0910a8c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1115);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0910a8c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__ = __webpack_require__(464);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_024aa588_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__ = __webpack_require__(1110);
function injectStyle (ssrContext) {
  __webpack_require__(1099)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-024aa588"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_024aa588_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_datos_facturacion_vue__ = __webpack_require__(466);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1c5ead_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_datos_facturacion_vue__ = __webpack_require__(1102);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_datos_facturacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1c5ead_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_datos_facturacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Forma de pago habitual")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.facturacion.forma_de_pago_ID),expression:"cliente.facturacion.forma_de_pago_ID"}],staticClass:"form-control",attrs:{"disabled":!_vm.permisoEditar},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cliente.facturacion, "forma_de_pago_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.formasPago),function(forma){return _c('option',{key:forma.ID,domProps:{"value":forma.ID}},[_vm._v(_vm._s(forma.nombre))])})],2)]),_c('div',{staticClass:"form-group",staticStyle:{"display":"none"}},[_c('label',[_vm._v("Día de cobro")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.facturacion.dia_cobro),expression:"cliente.facturacion.dia_cobro"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cliente.facturacion, "dia_cobro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}}),_vm._l((new Array(31)),function(dia,index){return _c('option',{key:dia,domProps:{"value":index + 1}},[_vm._v(_vm._s((index + 1)))])})],2)])]),_c('div',{staticClass:"col-sm-2",staticStyle:{"text-align":"center"}},[(_vm.cliente.facturacion.forma_de_pago_ID)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de cuenta")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.cliente.facturacion.tipoCuenta === 'cc') ? 'btn-primary' : 'btn-default',attrs:{"disabled":!_vm.permisoEditar},on:{"click":function($event){return _vm.setTipoCuenta('cc')}}},[_vm._v("C.C.")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.cliente.facturacion.tipoCuenta === 'iban') ? 'btn-primary' : 'btn-default',attrs:{"disabled":!_vm.permisoEditar},on:{"click":function($event){return _vm.setTipoCuenta('iban')}}},[_vm._v("IBAN")])])]):_vm._e()]),_c('div',{staticClass:"col-sm-5"},[(_vm.cliente.facturacion.tipoCuenta && _vm.cliente.facturacion.forma_de_pago_ID)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nº de cuenta")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.facturacion.cuenta),expression:"cliente.facturacion.cuenta"},{name:"mask",rawName:"v-mask",value:(_vm.mascaras[_vm.cliente.facturacion.tipoCuenta]),expression:"mascaras[cliente.facturacion.tipoCuenta]"}],staticClass:"form-control",attrs:{"type":"text","disabled":!_vm.cliente.facturacion.tipoCuenta || !_vm.permisoEditar},domProps:{"value":(_vm.cliente.facturacion.cuenta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente.facturacion, "cuenta", $event.target.value)}}})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contacto_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b1a68d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contacto_vue__ = __webpack_require__(1104);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contacto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b1a68d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contacto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6"},[_c('div',[_c('div',{staticClass:"card card-success mb-2"},[_c('div',{staticClass:"card-body bg-light"},[_c('b',[_vm._v("Representante o persona de contacto")]),_c('div',{staticClass:"input-group mt-2"},[_vm._m(0),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.nombre),expression:"cliente.nombre"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre y apellidos","disabled":!_vm.permisoEditar},domProps:{"value":(_vm.cliente.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "nombre", $event.target.value)}}})])])]),_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-body"},[_c('b',[_vm._v("Dirección")]),(_vm.cliente.place_id)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.cliente.direccion.direccion_formateada))]),_c('div',{staticClass:"form-group"},[_vm._m(1),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.direccion.indicaciones),expression:"cliente.direccion.indicaciones"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"Ej: 2º planta, puerta B"},domProps:{"value":(_vm.cliente.direccion.indicaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente.direccion, "indicaciones", $event.target.value)}}})]),(_vm.permisoEditar)?_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.modificarDireccion()}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Modificar")])]):_vm._e()]):_c('div',[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.campoGoogle),expression:"campoGoogle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Busca en google por nombre o dirección"},domProps:{"value":(_vm.campoGoogle)},on:{"keypress":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscaEnGoogle($event)},function($event){_vm.buscadoGoogle = false}],"input":function($event){if($event.target.composing){ return; }_vm.campoGoogle=$event.target.value}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscaEnGoogle}},[_c('span',{staticClass:"fa fa-search"})])])]),_c('div',{staticClass:"mt-2",staticStyle:{"font-size":"0.8em"}},[(_vm.cliente.direccion.indicaciones)?_c('i',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.campoGoogle = _vm.cliente.direccion.indicaciones}}},[_c('u',[_vm._v("Sugerencia:")]),_vm._v(" "+_vm._s(_vm.cliente.direccion.indicaciones))]):(_vm.cliente.direccion.direccion)?_c('i',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.campoGoogle = _vm.cliente.direccion.direccion}}},[_c('u',[_vm._v("Sugerencia:")]),_vm._v(" "+_vm._s(_vm.cliente.direccion.direccion))]):(_vm.cliente.direccion.direccion_formateada)?_c('i',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.campoGoogle = _vm.cliente.direccion.direccion_formateada}}},[_c('u',[_vm._v("Sugerencia:")]),_vm._v(" "+_vm._s(_vm.cliente.direccion.direccion_formateada))]):_c('i',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.campoGoogle = _vm.parseaDireccion(_vm.cliente.direccion)}}},[_c('u',[_vm._v("Sugerencia:")]),_vm._v(" "+_vm._s(_vm.parseaDireccion(_vm.cliente.direccion)))])])])])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('b',[_vm._v("Teléfono(s) | E-mail(s)")]),_vm._l((_vm.cliente.telefonos),function(tel,index){return _c('div',{key:'tel' + index,staticClass:"input-group input-group-sm",staticStyle:{"margin-top":"5px"}},[_vm._m(2,true),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.telefonos[index].telefono),expression:"cliente.telefonos[index].telefono"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Teléfono","disabled":!_vm.permisoEditar},domProps:{"value":(_vm.cliente.telefonos[index].telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente.telefonos[index], "telefono", $event.target.value)}}}),(_vm.permisoEditar)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.quitaTel(index)}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()])}),_vm._l((_vm.cliente.emails),function(tel,index){return _c('div',{key:'email' + index,staticClass:"input-group input-group-sm",staticStyle:{"margin-top":"5px"}},[_vm._m(3,true),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.emails[index].email),expression:"cliente.emails[index].email"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"E-mail","disabled":!_vm.permisoEditar},domProps:{"value":(_vm.cliente.emails[index].email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente.emails[index], "email", $event.target.value)}}}),(_vm.permisoEditar)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.quitaEmail(index)}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()])})],2),(_vm.permisoEditar)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"m-1 btn btn-sm btn-success",on:{"click":function($event){return _vm.addTel()}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Teléfono")]),_c('button',{staticClass:"m-1 btn btn-sm btn-success",on:{"click":function($event){return _vm.addEmail()}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("E-mail")])]):_vm._e()])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6"},[(!_vm.cliente.place_id)?_c('div',[(_vm.resultadosGoogle.length > 0)?_c('div',[_c('img',{staticStyle:{"position":"absolute","display":"block","top":"0px","right":"15px"},attrs:{"src":__webpack_require__(1105)}}),_c('b',[_vm._v("Selecciona un elemento")]),_c('table',{staticClass:"table table-striped mt-3"},[_c('tbody',_vm._l((_vm.resultadosGoogle),function(direccion){return _c('tr',{key:direccion.place_id},[_c('td',[(direccion.name)?_c('div',[_c('b',[_vm._v(_vm._s(direccion.name))])]):_vm._e(),_c('span',[_vm._v(_vm._s(direccion.formatted_address))])]),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.seleccionaPlace(direccion.place_id)}}},[_c('span',{staticClass:"fa fa-check"})])])])}),0)])]):(!_vm.buscadoGoogle)?_c('div',{staticClass:"text-center"},[_vm._m(4)]):_c('div',{staticClass:"text-center"},[_vm._m(5)])]):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cliente.place_id),expression:"cliente.place_id"}],attrs:{"id":"map"}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"mt-2"},[_c('b',[_vm._v("Anotaciones extra")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text fa fa-w fa-phone"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text fa fa-w fa-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"text-info",staticStyle:{"margin-top":"100px"}},[_c('span',{staticClass:"fa fa-search"}),_c('br'),_vm._v("Realiza una búsqueda")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"text-danger",staticStyle:{"margin-top":"100px"}},[_c('span',{staticClass:"fa fa-search"}),_c('br'),_vm._v("Sin resultados")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bitacora_vue__ = __webpack_require__(468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc96dfe0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_bitacora_vue__ = __webpack_require__(1108);
function injectStyle (ssrContext) {
  __webpack_require__(1107)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc96dfe0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bitacora_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc96dfe0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_bitacora_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-striped m-0"},[_vm._m(0),_c('tbody',_vm._l((_vm.cliente.bitacora),function(bitacora){return _c('tr',{key:bitacora.BitacoraID},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(bitacora.FechaBitacora,'DD-MM-YYYY H:mm')))]),_c('td',[_vm._v(_vm._s(bitacora.UsuarioNombre))]),_c('td',[_vm._v(_vm._s(bitacora.Titulo))]),_c('td',[_vm._v(_vm._s(bitacora.Descripcion))]),_c('td',{staticClass:"text-right"},[(bitacora.URI)?_c('a',{staticClass:"btn btn-sm btn-primary",attrs:{"href":'#' + bitacora.URI,"target":"_blank"}},[_c('span',{staticClass:"fa fa-eye"})]):_vm._e()])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Usuario")]),_c('th',[_vm._v("Titulo")]),_c('th',[_vm._v("Descripción")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cliente)?_c('modal',{attrs:{"max-width":1200}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v(_vm._s(_vm.cliente.cliente || 'Nuevo cliente')),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light",staticStyle:{"border-bottom":"1px solid #e0e0e0","box-shadow":"0 2px 2px rgba(0,0,0,0.1)"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3",staticStyle:{"margin-bottom":"15px"}},[(!_vm.cliente.agente.ID)?_c('div',{staticClass:"input-group input-group-sm has-error"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Agente")]),_c('input-query',{attrs:{"input-class":"form-control-sm form-control","realtime":true,"url":"gestion-clientes/php/api/buscaAgente.php","placeholder":"Selecciona el agente"},on:{"selected":function($event){return _vm.setAgente($event)}}})],1)]):_vm._e(),(_vm.cliente.agente.ID)?_c('ul',{staticClass:"capaAgente"},[_c('li',[_c('img',{staticStyle:{"width":"50px","height":"50px","border-radius":"25px"},attrs:{"src":_vm.cliente.agente.avatar,"alt":""}})]),_c('li',[_c('b',[_vm._v("Agente:")]),_c('br'),_vm._v(_vm._s(_vm.cliente.agente.nombre)),(_vm.permisoEditar)?_c('span',{staticClass:"ml-2 text-danger",staticStyle:{"cursor":"pointer","text-decoration":"underline"},on:{"click":function($event){return _vm.setAgente(null)}}},[_vm._v("(Cambiar)")]):_vm._e()])]):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-8 col-lg-9"},[_c('div',{staticClass:"input-group input-group-sm",class:!_vm.cliente.cliente ? 'has-error' : 'has-success'},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Nombre Fiscal")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.cliente),expression:"cliente.cliente"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre del cliente","disabled":!_vm.permisoEditar},domProps:{"value":(_vm.cliente.cliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "cliente", $event.target.value)}}}),_c('div',{staticClass:"input-group-prepend input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Nombre Comercial")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.nombre_comercial),expression:"cliente.nombre_comercial"}],staticClass:"form-control",attrs:{"type":"text","disabled":!_vm.permisoEditar},domProps:{"value":(_vm.cliente.nombre_comercial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "nombre_comercial", $event.target.value)}}})]),_c('div',{staticClass:"input-group input-group-sm mt-2"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("CIF")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente.CIF),expression:"cliente.CIF"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"X12345678","disabled":!_vm.permisoEditar},domProps:{"value":(_vm.cliente.CIF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cliente, "CIF", $event.target.value)}}})])])])]),_c('ul',{staticClass:"nav nav-tabs mt-2 ml-1 mr-1"},[_c('li',{staticClass:"nav-items"},[_c('a',{staticClass:"nav-link",class:_vm.seccion === 'contacto' ? 'active' : '',on:{"click":function($event){_vm.seccion = 'contacto'}}},[_vm._v("Contacto")])]),_c('li',{staticClass:"nav-items"},[_c('a',{staticClass:"nav-link",class:_vm.seccion === 'facturacion' ? 'active' : '',on:{"click":function($event){_vm.seccion = 'facturacion'}}},[_vm._v("Datos bancarios")])]),_c('li',{staticClass:"nav-items"},[_c('a',{staticClass:"nav-link",class:_vm.seccion === 'bitacora' ? 'active' : '',on:{"click":function($event){_vm.seccion = 'bitacora'}}},[_vm._v("Bitácora")])])]),(_vm.seccion === 'facturacion')?_c('DatosFacturacion',{attrs:{"cliente":_vm.cliente,"formasPago":_vm.formasPago,"permisoEditar":_vm.permisoEditar}}):_vm._e(),(_vm.seccion === 'contacto')?_c('DatosContacto',{attrs:{"cliente":_vm.cliente,"permisoEditar":_vm.permisoEditar}}):_vm._e(),(_vm.seccion === 'bitacora')?_c('Bitacora',{attrs:{"cliente":_vm.cliente}}):_vm._e(),(_vm.permisoEditar)?_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"disabled":!_vm.clienteCorrecto},on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")]),(!_vm.clienteCorrecto)?_c('span',{staticClass:"ml-3 text-danger"},[_c('b',[_vm._v("Error:")]),_vm._v(" "+_vm._s(_vm.error))]):_vm._e()]),_c('div',{staticClass:"col text-right"},[(_vm.cliente.ID && _vm.cliente.comercial)?_c('button',{staticClass:"mr-1 btn btn-sm btn-success",on:{"click":function($event){return _vm.liberar()}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Liberar")]):_vm._e(),(_vm.cliente.ID)?_c('button',{staticClass:"mr-1 btn btn-sm btn-warning",on:{"click":function($event){return _vm.cerrado()}}},[(_vm.cliente.activo)?_c('span',[_c('span',{staticClass:"fa fa-trash mr-2"}),_c('span',[_vm._v("Ha cerrado")])]):_c('span',[_c('span',{staticClass:"fa fa-check mr-2"}),_c('span',[_vm._v("Ha reabierto")])])]):_vm._e(),(_vm.cliente.ID)?_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.eliminar()}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")]):_vm._e()])])]):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-condensed table-striped m-0"},[_c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('ContratoID')}}},[_vm._v("Contrato"),(_vm.order === 'ContratoID')?_c('div',{staticClass:"ml-2",staticStyle:{"position":"relative","display":"inline-block"}},[_c('span',{staticClass:"fa",class:(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'})]):_vm._e()]),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('FechaVencimiento')}}},[_vm._v("Vencimiento"),(_vm.order === 'FechaVencimiento')?_c('div',{staticClass:"ml-2",staticStyle:{"position":"relative","display":"inline-block"}},[_c('span',{staticClass:"fa",class:(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'})]):_vm._e()]),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('ClienteNombre')}}},[_vm._v("Cliente"),(_vm.order === 'ClienteNombre')?_c('div',{staticClass:"ml-2",staticStyle:{"position":"relative","display":"inline-block"}},[_c('span',{staticClass:"fa",class:(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'})]):_vm._e()]),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('AgenteNombre')}}},[_vm._v("Agente"),(_vm.order === 'AgenteNombre')?_c('div',{staticClass:"ml-2",staticStyle:{"position":"relative","display":"inline-block"}},[_c('span',{staticClass:"fa",class:(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'})]):_vm._e()]),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('Importe')}}},[_vm._v("Importe"),(_vm.order === 'Importe')?_c('div',{staticClass:"ml-2",staticStyle:{"position":"relative","display":"inline-block"}},[_c('span',{staticClass:"fa",class:(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'})]):_vm._e()]),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('Importe')}}},[_vm._v("Forma de pago"),(_vm.order === 'FormaDePago')?_c('div',{staticClass:"ml-2",staticStyle:{"position":"relative","display":"inline-block"}},[_c('span',{staticClass:"fa",class:(this.direccion === 'desc') ? 'fa-caret-down' : 'fa-caret-up'})]):_vm._e()]),_c('td',[_vm._v("Estado")]),_c('td')])]),_c('tbody',_vm._l((_vm.resultadosProcesados),function(r){return _c('tr',{key:r.ID_cobro},[_c('td',[_c('span',{staticClass:"tituloContrato",on:{"click":function($event){_vm.ContratoID=r.ContratoID}}},[_vm._v(_vm._s(r.ContratoID)+" / "+_vm._s(r.ContratoTitulo))])]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(new Date(parseInt(r.FechaVencimiento) * 1000),'DD-MM-YYYY')))]),_c('td',[_c('span',{staticClass:"tituloCliente",on:{"click":function($event){_vm.ClienteID = r.ClienteID}}},[_vm._v(_vm._s(r.ClienteNombre))])]),_c('td',[_vm._v(_vm._s(r.AgenteNombre))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(r.ImporteTotal,''))+" €")]),_c('td',[_vm._v(_vm._s(r.FormaDePago))]),_c('td',{staticStyle:{"font-size":"1.2em"}},[(r.Estado === 'Pagado')?_c('span',[_c('div',{staticClass:"badge badge-success p-2"},[_vm._v("Pagado")])]):_c('span',[_c('div',{staticClass:"badge badge-danger p-2"},[_vm._v("Pendiente")])])]),_c('td',{staticClass:"text-right"},[(_vm.permisos.cobros_crearCobros || r.Estado !== 'Pendiente')?_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.verCobro(r)}}},[(r.Estado === 'Pendiente')?_c('span',{staticClass:"fa fa-edit"}):_c('span',{staticClass:"fa fa-file-o"})]):_vm._e()])])}),0)]),_c('div',{staticClass:"card-body bg-dark text-white"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col"},[_c('b',[_vm._v("Importe cobrado:")]),_c('br'),_c('span',{staticStyle:{"font-size":"2em"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.totalPagado,''))+" €")])]),_c('div',{staticClass:"col"},[_c('b',[_vm._v("Importe Pendiente:")]),_c('br'),_c('span',{staticStyle:{"font-size":"2em"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.totalPendiente,''))+" €")])])])])])]),(_vm.ContratoID)?_c('modal',{attrs:{"max-width":1600,"top":10}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('button',{staticClass:"close",on:{"click":function($event){_vm.ContratoID=null}}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('VisorContrato',{attrs:{"ContratoID":_vm.ContratoID}})],1)])]):_vm._e(),(_vm.ClienteID)?_c('EditarCliente',{attrs:{"id-cliente":_vm.ClienteID},on:{"cerrar":function($event){_vm.ClienteID = null}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscador_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_966a5150_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscador_vue__ = __webpack_require__(1112);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_966a5150_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3"},[(_vm.permisos.cobros_verTodosCobros)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.AgenteNombre),expression:"form.AgenteNombre"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.form.AgenteNombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "AgenteNombre", $event.target.value)}}})]):_vm._e(),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cliente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ClienteNombre),expression:"form.ClienteNombre"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.form.ClienteNombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "ClienteNombre", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha inicio")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"minimum-view":"month","input-class":"form-control form-control-sm","format":"MMMM, yyyy","maximum-view":"year","language":_vm.$dateLang},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":_vm.buscar},model:{value:(_vm.form.FechaIni),callback:function ($$v) {_vm.$set(_vm.form, "FechaIni", $$v)},expression:"form.FechaIni"}}),_c('div',{staticClass:"input-group-append",on:{"click":_vm.quitarFechaIni}},[_vm._m(1)])],1)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha fin")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"minimum-view":"month","input-class":"form-control form-control-sm","format":"MMMM, yyyy","maximum-view":"year","language":_vm.$dateLang},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":_vm.buscar},model:{value:(_vm.form.FechaFin),callback:function ($$v) {_vm.$set(_vm.form, "FechaFin", $$v)},expression:"form.FechaFin"}}),_c('div',{staticClass:"input-group-append",on:{"click":_vm.quitarFechaFin}},[_vm._m(2)])],1)])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Contrato")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.contrato),expression:"form.contrato"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.form.contrato)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "contrato", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Usuario registra")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.usuario),expression:"form.usuario"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.form.usuario)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "usuario", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.form.estado === null) ? 'btn-primary' : '',on:{"click":function($event){_vm.form.estado = null}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:(_vm.form.estado === 'Pendiente') ? 'btn-primary' : '',on:{"click":function($event){_vm.form.estado = 'Pendiente'}}},[_vm._v("Pendientes")]),_c('button',{staticClass:"btn",class:(_vm.form.estado === 'Pagado') ? 'btn-primary' : '',on:{"click":function($event){_vm.form.estado = 'Pagado'}}},[_vm._v("Pagados")])])])])])]),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-primary btn-sm m-1",on:{"click":function($event){return _vm.buscar()}}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('download-excel',{staticClass:"btn btn-warning btn-sm m-1",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"meta":_vm.json_meta,"name":"filename.xls"}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("XLS")])],1),_c('div',{staticClass:"col text-right"},[(_vm.permisos.cobros_crearCobros)?_c('button',{staticClass:"btn btn-success btn-sm",on:{"click":function($event){return _vm.nuevo()}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nuevo cobro")]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-light"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar cobros")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger btn-sm"},[_c('span',{staticClass:"fa fa-trash"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger btn-sm"},[_c('span',{staticClass:"fa fa-trash"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_nuevo_vue__ = __webpack_require__(471);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed978eb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_nuevo_vue__ = __webpack_require__(1114);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_nuevo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed978eb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_nuevo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.recibo)?_c('modal',{attrs:{"max-width":500}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_c('span',{staticClass:"fa fa-money mr-2"}),_vm._v("Recibo"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),(_vm.recibo.Estado === 'Pendiente')?_c('div',{staticClass:"alert alert-danger m-0"},[_c('span',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("Este recibo está pendiente")]):_c('div',{staticClass:"alert alert-success m-0"},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Este recibo está pagado")]),_c('div',{staticClass:"card-body bg-light"},[_c('div',[_c('b',[_c('span',{staticClass:"fa fa-building mr-2"}),_vm._v("Empresa")]),_c('div',{staticClass:"input-group mt-1"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.recibo.EmpresaID),expression:"recibo.EmpresaID"}],staticClass:"form-control",attrs:{"disabled":_vm.reciboContrato},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.recibo, "EmpresaID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoEmpresas),function(empresa){return _c('option',{key:empresa.ID_empresa,domProps:{"value":empresa.ID_empresa}},[_vm._v(_vm._s(empresa.nombreFiscal))])})],2)])]),_c('div',{staticClass:"mt-2"},[_c('b',[_c('span',{staticClass:"fa fa-building mr-2"}),_vm._v("Cliente")]),_c('div',{staticClass:"input-group mt-1"},[(_vm.recibo.ClienteID)?_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.recibo.ClienteNombre}}):_vm._e(),(!_vm.reciboContrato && !_vm.recibo.ClienteID)?_c('input-query',{attrs:{"realtime":true,"url":"/facturacion-cobros/php/api/query-clientes.php","input-class":"form-control","placeholder":"Busca y selecciona un cliente"},on:{"selected":function($event){return _vm.seleccionaCliente($event)}}}):_vm._e(),(!_vm.reciboContrato && _vm.recibo.ClienteID)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarCliente}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()],1)]),_c('div',{staticClass:"mt-2"},[_c('b',[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Agente")]),_c('div',{staticClass:"input-group mt-1"},[(_vm.recibo.AgenteID)?_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.recibo.AgenteNombre}}):_vm._e(),(!_vm.reciboContrato && !_vm.recibo.AgenteID)?_c('input-query',{attrs:{"realtime":true,"url":"/facturacion-cobros/php/api/query-agentes.php","input-class":"form-control","placeholder":"Busca y selecciona un agente"},on:{"selected":function($event){return _vm.seleccionaAgente($event)}}}):_vm._e(),(!_vm.reciboContrato && _vm.recibo.AgenteID)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarAgente}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e(),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Comisión")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.recibo.ComisionAgente),expression:"recibo.ComisionAgente"}],staticClass:"form-control",attrs:{"disabled":_vm.recibo.Estado !== 'Pendiente'},domProps:{"value":(_vm.recibo.ComisionAgente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.recibo, "ComisionAgente", $event.target.value)}}}),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("%")])])],1)])]),_c('div',{staticClass:"card-body"},[_c('h4',[_c('b',[_c('span',{staticClass:"fa fa-money-mr-2"}),_vm._v("Detalles del recibo")])]),_c('div',{staticClass:"row mt-2 mb-2 text-dark text-center bg-light pt-3 pb-3",staticStyle:{"border-top":"1px solid #e0e0e0","border-bottom":"1px solid #e0e0e0","box-shadow":"0 2px 5px rgba(0,0,0,0.07)"}},[_c('div',{staticClass:"col"},[_vm._v("Fecha de vencimiento"),_c('br'),_c('b',[_vm._v(_vm._s(_vm._f("moment")(_vm.recibo.FechaVencimiento,'DD-MM-YYYY')))])]),_c('div',{staticClass:"col"},[_vm._v("Fecha de cobro"),_c('br'),_c('b',[_vm._v(_vm._s(_vm._f("moment")(_vm.recibo.FechaPagado || new Date(),'DD-MM-YYYY')))])]),(_vm.recibo.Estado === 'Pendiente' && _vm.recibo.ContratoID)?_c('div',{staticClass:"col"},[_vm._v("Importe del recibo"),_c('br'),_c('div',{staticStyle:{"cursor":"pointer","font-weight":"bolder"},on:{"click":_vm.asignaImporteDefinido}},[_vm._v(_vm._s(_vm._f("currency")(_vm.recibo.ImporteTotal,''))+" €"),_c('button',{staticClass:"btn btn-sm btn-primary ml-3",staticStyle:{"width":"15px","height":"15px","line-height":"0","text-align":"center","padding":"0"}},[_c('span',{staticClass:"fa fa-caret-down"})])])]):_vm._e()]),_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Importe pagado")])]),_c('div',{staticClass:"input-group"},[(_vm.recibo.Estado === 'Pendiente')?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.recibo.ImportePagadoRecibo),expression:"recibo.ImportePagadoRecibo",modifiers:{"number":true}}],ref:"importe",staticClass:"form-control",staticStyle:{"font-size":"3em","text-align":"right"},attrs:{"disabled":_vm.recibo.Estado === 'Pagado',"placeholder":"0"},domProps:{"value":(_vm.recibo.ImportePagadoRecibo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.recibo, "ImportePagadoRecibo", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}):_c('input',{ref:"importe",staticClass:"form-control",staticStyle:{"font-size":"3em","text-align":"right"},attrs:{"disabled":true,"placeholder":"0"},domProps:{"value":_vm._f("currency")(_vm.recibo.ImporteTotal,'') + ' €'}}),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text",staticStyle:{"font-size":"3em"}},[_vm._v("€")])])])]),(_vm.recibo.ReciboID !== _vm.recibo.PrimerReciboSinPagar && _vm.recibo.Estado === 'Pendiente' && _vm.recibo.ContratoID)?_c('div',{staticClass:"alert alert-warning mt-3 mb-3"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Este no es el primer recibo del contrato pendiente de pago. Al pulsar sobre el botón de \"Cobrar\", el sistema primero saldará el importe de los recibos pendientes anteriores a este.")]):_vm._e()]),(_vm.recibo.Estado === 'Pendiente' && _vm.recibo.ContratoID)?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Importe pendiente del contrato")])]),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",staticStyle:{"font-size":"3em","text-align":"right"},attrs:{"disabled":"disabled"},domProps:{"value":_vm.round(_vm.recibo.ContratoImporteTotal - _vm.recibo.ImportePagadoContrato - _vm.recibo.ImportePagadoRecibo)}}),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text",staticStyle:{"font-size":"3em"}},[_vm._v("€")])])])])]):_vm._e(),(_vm.recibo.Estado === 'Pendiente')?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Forma de pago")])]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.recibo.FormaDePagoID),expression:"recibo.FormaDePagoID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.recibo, "FormaDePagoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoFormasDePago),function(forma){return _c('option',{key:forma.ID_forma_de_pago,domProps:{"value":forma.ID_forma_de_pago}},[_vm._v(_vm._s(forma.nombre))])})],2)])]):_vm._e(),(_vm.recibo.Estado === 'Pendiente' && _vm.necesarioIBAN)?_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("IBAN")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.recibo.IBAN),expression:"recibo.IBAN"}],staticClass:"form-control",attrs:{"placeholder":"IBAN"},domProps:{"value":(_vm.recibo.IBAN)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.recibo, "IBAN", $event.target.value)}}})])]):_vm._e()]),_c('div',{staticClass:"card-footer"},[(_vm.recibo.Estado === 'Pagado')?_c('button',{staticClass:"mr-2 btn btn-primary"},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("Descargar recibo")]):_vm._e(),(_vm.recibo.Estado === 'Pendiente')?_c('button',{staticClass:"mr-2 btn btn-danger",on:{"click":_vm.cobrar}},[_c('span',{staticClass:"fa fa-money mr-2"}),_vm._v("Cobrar")]):_vm._e()])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('buscador',{attrs:{"form":_vm.filtro,"resultados":_vm.resultados},on:{"nuevo":function($event){return _vm.nuevoRecibo()},"buscar":function($event){return _vm.buscar()},"descargar":function($event){return _vm.descargar($event)}}}),_c('listado-resultados',{attrs:{"resultados":_vm.resultados},on:{"ver":function($event){return _vm.editar($event)},"eliminar":function($event){return _vm.elimina($event)}}}),(_vm.idRecibo)?_c('editor',{attrs:{"id-recibo":_vm.idRecibo},on:{"cerrar":function($event){_vm.idRecibo = null},"actualizar":function($event){return _vm.buscar()}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(473);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4051e024_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1123);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4051e024_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filtro_vue__ = __webpack_require__(474);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507714a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_filtro_vue__ = __webpack_require__(1120);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filtro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507714a6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_filtro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editarPago_vue__ = __webpack_require__(475);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eb412b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editarPago_vue__ = __webpack_require__(1119);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editarPago_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5eb412b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editarPago_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-money mr-2"}),_vm._v("Pago de comisiones"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Agente")])]),(!_vm.datos.AgenteID && _vm.editable)?_c('input-query',{attrs:{"realtime":true,"url":"/facturacion-cobros/php/api/buscaAgentes.php","input-class":"form-control"},on:{"selected":function($event){return _vm.seleccionaAgente($event)}}}):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.datos.AgenteNombre}}),(_vm.editable)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarAgente}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()])],1)]),(_vm.comisionesPendientes !== null && _vm.comisionesPendientes.length > 0)?_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Comisión")]),_c('th',{staticClass:"text-right"},[_c('input',{ref:"todasComisiones",attrs:{"type":"checkbox"},on:{"click":function($event){return _vm.seleccionaTodos($event)}}})])])]),_c('tbody',_vm._l((_vm.comisionesPendientes),function(comision){return _c('tr',{key:comision.ComisionID,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.toggleComision(comision, $event)}}},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(comision.FechaGenerada,'DD-MM-YYYY')))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(comision.ImporteComision,''))+" €")]),_c('td',{staticClass:"text-right"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.datos.ComisionesID.indexOf(comision.ComisionID) >= 0},on:{"click":function($event){return _vm.toggleComision(comision, $event)}}})])])}),0)]):_vm._e(),(_vm.datos.ComisionesID.length > 0)?_c('div',{staticClass:"card-body bg-light"},[_c('h2',{staticClass:"text-danger"},[_c('b',[_vm._v("Importe: "+_vm._s(_vm._f("currency")(_vm.importePago,''))+" €")])])]):_vm._e(),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Fecha")])]),(_vm.editable)?_c('datepicker',{attrs:{"monday-first":true,"bootstrap-styling":true,"language":_vm.$dateLang,"inputClass":"form-control"},model:{value:(_vm.datos.FechaPagado),callback:function ($$v) {_vm.$set(_vm.datos, "FechaPagado", $$v)},expression:"datos.FechaPagado"}}):_c('div',[_vm._v(_vm._s(_vm._f("moment")(_vm.datos.FechaPagado,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.datos.FechaPagado,'HH:mm:ss')))])],1)]),_c('div',{staticClass:"card-body bg-dark text-white"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Usuario responsable")])]),_c('h3',[_vm._v(_vm._s(_vm.datos.UsuarioNombre))])])]),(_vm.editable)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.pagar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Pagar")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.permisos.cobros_verTodasLasComisiones)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.AgenteNombre),expression:"filtro.AgenteNombre"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.AgenteNombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "AgenteNombre", $event.target.value)}}})])]):_vm._e(),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Desde el mes")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"input-class":"form-control form-control-sm","minimum-view":"month","format":"MMMM, yyyy","language":_vm.$dateLang},on:{"input":_vm.buscar},model:{value:(_vm.filtro.Mes),callback:function ($$v) {_vm.$set(_vm.filtro, "Mes", $$v)},expression:"filtro.Mes"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.quitarFecha}},[_c('span',{staticClass:"fa fa-trash"})])])],1)])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.Estado === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.Estado === 'Pagado') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('Pagado')}}},[_vm._v("Pagadas")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.Estado === 'Pendiente') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('Pendiente')}}},[_vm._v("Pendientes")])])])]),_vm._m(1)])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm m-1 btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-sm m-1 btn-warning",on:{"click":function($event){_vm.editarComision = 'nueva'}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Pagar comisión")])]),(_vm.editarComision)?_c('Comision',{attrs:{"ComisionID":_vm.editarComision},on:{"cerrar":function($event){_vm.editarComision = null},"actualizar":_vm.buscar}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-filter mr-2"}),_vm._v("Filtrar")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Contratos")]),_c('br'),_c('label',[_c('input',{staticClass:"mr-3",attrs:{"type":"checkbox"}}),_vm._v("Mostrar solo recibos de contratos totalmente pagados")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__ = __webpack_require__(476);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f052de6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__ = __webpack_require__(1122);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f052de6a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div mt-3"},[(_vm.resultados && _vm.resultados.length > 0)?_c('table',{staticClass:"table table-striped"},[_vm._m(0),_c('tbody',_vm._l((_vm.resultados),function(linea){return _c('tr',{key:linea.ComisionID},[_c('td',[_vm._v(_vm._s(_vm._f("moment")(linea.FechaGenerada,'DD-MM-YYYY')))]),_c('td',[_vm._v(_vm._s(linea.ClienteNombre))]),_c('td',[_vm._v(_vm._s(linea.ContratoTitulo))]),_c('td',[_vm._v(_vm._s(linea.FacturacionID))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(linea.ImporteNeto,''))+" €")]),_c('td',[_vm._v(_vm._s(linea.AgenteNombre))]),_c('td',[_vm._v(_vm._s(linea.Comision)+" %")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(linea.ImporteComision,''))+" €")]),_c('td',[(linea.FechaPagada)?_c('span',[_vm._v("Pagada")]):_c('span',[_vm._v("Pendiente")])])])}),0),_c('tbody',[_c('tr',{staticClass:"bg-dark text-white"},[_c('td',{staticClass:"text-center",staticStyle:{"font-size":"1.5em"},attrs:{"colspan":"3"}},[_c('b',[_vm._v("Comisiones generadas")]),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.importeComisiones,''))+" €")]),_c('td',{staticClass:"text-center",staticStyle:{"font-size":"1.5em"},attrs:{"colspan":"3"}},[_c('b',[_vm._v("Comisiones pagadas")]),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.importePagado,''))+" €")]),_c('td',{staticClass:"text-center",staticStyle:{"font-size":"1.5em"},attrs:{"colspan":"4"}},[_c('b',[_vm._v("Comisiones pendientes")]),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.importePendiente,''))+" €")])])])]):_c('div',{staticClass:"div text-dark text-center mt-3 p-5"},[_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Fecha generada")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Contrato")]),_c('th',[_vm._v("ID Factura")]),_c('th',[_vm._v("Importe neto factura")]),_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("% Comisión")]),_c('th',[_vm._v("Importe comisión")]),_c('th',[_vm._v("Estado")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('span',{staticClass:"fa fa-ban"}),_c('br'),_vm._v("No hay resultados")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filtro',{attrs:{"filtro":_vm.filtro},on:{"buscar":_vm.buscarComisiones}}),_c('resultados',{attrs:{"resultados":_vm.resultados}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__galerias_vue__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__componentes_visor_galerias_visor_galeria__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__componentes_listado_galerias_listado_galerias_vue__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__componentes_buscador_vista_buscador__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_vue_store_stores__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(1143);








/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('galerias', {
			name: 'Galerías',
			component: __WEBPACK_IMPORTED_MODULE_1__galerias_vue__["a" /* default */]
		});
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('galerias').child('', {
			name: 'Principal',
			component: __WEBPACK_IMPORTED_MODULE_3__componentes_listado_galerias_listado_galerias_vue__["a" /* default */]
		});
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('galerias').child('buscador', {
			name: 'Buscador',
			component: __WEBPACK_IMPORTED_MODULE_4__componentes_buscador_vista_buscador__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('galerias').child(':id', {
			name: 'Visor de galería',
			component: __WEBPACK_IMPORTED_MODULE_2__componentes_visor_galerias_visor_galeria__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_5__core_vue_store_stores__["a" /* default */].registerModule(['galerias'], __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */]);
	}
});

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_galerias_vue__ = __webpack_require__(477);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a1aac4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_galerias_vue__ = __webpack_require__(1136);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_galerias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a1aac4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_galerias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('modal',{staticStyle:{"overflow":"hidden"},attrs:{"max-width":3000}},[_c('div',{staticClass:"btnCerrar",on:{"click":_vm.cerrar}},[_vm._v("×")]),_c('div',{ref:"contenido",staticClass:"capaContenido"},[_c('div',{staticClass:"flechaIzquierda"},[_c('span',{staticClass:"fa fa-caret-left",on:{"click":_vm.anterior}})]),_c('div',{staticClass:"flechaDerecha"},[_c('span',{staticClass:"fa fa-caret-right",on:{"click":_vm.siguiente}})]),(_vm.item.Tipo === 'Foto')?_c('div',[_c('div',{staticClass:"item",style:(_vm.estilo)},[_c('img',{style:(_vm.estiloImg),attrs:{"src":'src/modulos/galerias/php/api/hd.php?ItemID=' + this.item.ItemID}})])]):_c('div',[_c('video',{style:(_vm.estilo),attrs:{"autoplay":"true","controls":"true","src":'src/modulos/galerias/php/api/play.php?ItemID=' + _vm.item.ItemID}})])]),_c('div',{staticClass:"capaInformacion p-2 pt-3"},[_c('h3',[_vm._v("Información")]),_c('div',{staticClass:"text-left",staticStyle:{"margin-top":"30px","font-size":"1.2em"}},[_c('h3',[_c('small',[_c('b',[_vm._v(_vm._s(_vm.item.titulo || 'Sin título'))]),_c('br')])]),_c('h4',[_c('small',[_vm._v(_vm._s(_vm.item.GaleriaNombre))])]),_c('p',{staticClass:"text-dark mt-4"},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Usuario"),_c('br'),_c('span',{staticStyle:{"color":"#777777"}},[_vm._v(_vm._s(_vm.item.UsuarioNombre))])]),_c('p',{staticClass:"text-dark"},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v("Fecha de subida"),_c('br'),_c('span',{staticStyle:{"color":"#777777"}},[_vm._v(_vm._s(_vm.item.FechaSubido))])]),_c('p',{staticClass:"text-dark"},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Tamaño"),_c('br'),_c('span',{staticStyle:{"color":"#777777"}},[_vm._v(_vm._s(_vm.tamano))])]),_c('p',{staticClass:"text-dark"},[_c('span',{staticClass:"fa fa-image mr-2"}),_vm._v("Dimensiones"),_c('br'),_c('span',{staticStyle:{"color":"#777777"}},[_vm._v(_vm._s(_vm.item.Ancho)+" x "+_vm._s(_vm.item.Alto))])]),(_vm.galeria.Escritura)?_c('p',{staticClass:"text-center"}):_vm._e(),_c('div',{staticClass:"btn-group text-center"},[(_vm.galeria.Escritura)?_c('button',{staticClass:"btn btn-warning",on:{"click":_vm.setPortada}},[_c('span',{staticClass:"fa fa-image mr-2"}),_vm._v("Definir portada")]):_vm._e(),_c('a',{staticClass:"btn btn-success",attrs:{"target":"_blank","href":'/src/modulos/galerias/php/api/download.php?ItemID=' + _vm.itemId}},[_c('span',{staticClass:"fa fa-download"})]),(_vm.galeria.Escritura)?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()]),_c('p'),_c('div',{staticClass:"bg-light",staticStyle:{"margin":"-5px","margin-bottom":"15px","border-top":"1px solid #e0e0e0","border-bottom":"1px solid #e0e0e0","padding":"2px","padding-top":"10px"}},[_c('h4',[_c('span',{staticClass:"fa fa-users mr-2"}),_vm._v("Personas")])]),(_vm.galeria.Escritura)?_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])]),_c('input-query',{staticClass:"form-control",attrs:{"input-class":"form-control","realtime":true,"url":"galerias/php/api/query-personas.php","placeholder":"Busca o crea una persona"},on:{"selected":function($event){return _vm.setPersona($event)}}})],1):_vm._e(),_c('div',{staticClass:"mt-3"},[(_vm.item.personas.length === 0)?_c('p',{staticClass:"text-center text-danger"},[_vm._v("No hay personas")]):_vm._e(),(_vm.item.personas.length > 0)?_c('table',{staticClass:"table table-condensed table-striped"},[_c('tbody',_vm._l((_vm.item.personas),function(persona){return _c('tr',{key:persona.PersonaID},[_c('td',{staticClass:"text-center",staticStyle:{"width":"25px"}},[_c('span',{staticClass:"fa fa-user"})]),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(persona.Nombre)+" "+_vm._s(persona.Apellidos))]),_c('td',{staticClass:"text-right",staticStyle:{"width":"40px"}},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.delPersona(persona)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)]):_vm._e()]),_c('div',{staticClass:"bg-light",staticStyle:{"margin":"-5px","margin-bottom":"15px","margin-top":"15px","border-top":"1px solid #e0e0e0","border-bottom":"1px solid #e0e0e0","padding":"2px","padding-top":"10px"}},[_c('h4',[_c('span',{staticClass:"fa fa-tags mr-2"}),_vm._v("Etiquetas")])]),(_vm.galeria.Escritura)?_c('div',{staticClass:"input-group mt-3 mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-tag"})])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.etiqueta),expression:"etiqueta"}],staticClass:"form-control",attrs:{"placeholder":"Añade etiquetas"},domProps:{"value":(_vm.etiqueta)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.setEtiqueta($event)},"input":function($event){if($event.target.composing){ return; }_vm.etiqueta=$event.target.value}}})]):_vm._e(),_vm._l((_vm.item.etiquetas),function(tag){return _c('div',{key:tag.Etiqueta,staticClass:"btn btn-danger btn-sm m-1",on:{"click":function($event){return _vm.delEtiqueta(tag.Etiqueta)}}},[_vm._v(_vm._s(tag.Etiqueta)),(_vm.galeria.Escritura)?_c('span',{staticClass:"ml-2 fa fa-trash"}):_vm._e()])}),(_vm.item.etiquetas.length === 0)?_c('div',{staticClass:"text-center"},[_vm._v("No hay etiquetas")]):_vm._e(),_c('div',{staticClass:"mt-4",staticStyle:{"color":"#777777"}},[_vm._v("Heredadas de la galería")]),_vm._l((_vm.galeria.etiquetas),function(tag){return _c('div',{key:tag,staticClass:"btn btn-danger btn-sm m-1"},[_vm._v(_vm._s(tag))])})],2)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":800}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-folder-open mr-2"}),_vm._v("Galería"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[(!_vm.galeria.UsuarioID)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Usuario")]),_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.usuario.nombre + ' ' + _vm.usuario.apellidos}})]):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Usuario")]),_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.galeria.UsuarioNombre}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.galeria.Nombre),expression:"galeria.Nombre"}],staticClass:"form-control",domProps:{"value":(_vm.galeria.Nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.galeria, "Nombre", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descripcion")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.galeria.Descripcion),expression:"galeria.Descripcion"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.galeria.Descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.galeria, "Descripcion", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"monday-first":true,"language":_vm.$dateLang},model:{value:(_vm.galeria.FechaGaleria),callback:function ($$v) {_vm.$set(_vm.galeria, "FechaGaleria", $$v)},expression:"galeria.FechaGaleria"}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Permitir por defecto")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.galeria.AccesoDefecto) ? 'btn-primary' : '',on:{"click":function($event){_vm.galeria.AccesoDefecto = !_vm.galeria.AccesoDefecto}}},[_vm._v("Acceso")]),_c('button',{staticClass:"btn",class:(_vm.galeria.EscrituraDefecto) ? 'btn-primary' : '',on:{"click":function($event){_vm.galeria.EscrituraDefecto = !_vm.galeria.EscrituraDefecto}}},[_vm._v("Escritura")])])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Permisos")]),_c('input-query',{attrs:{"realtime":true,"inputClass":"form-control","placeholder":"Buscar un usuario o grupo","url":"galerias/php/api/query-usuarios-grupos.php"},on:{"selected":function($event){return _vm.seleccionaPermiso($event)}}})],1),_c('table',{staticClass:"table table-condensed mt-2"},_vm._l((_vm.galeria.permisos),function(permiso,i){return _c('tr',{key:permiso.PermisoID},[_c('td',[_c('span',{staticClass:"fa",class:(permiso.GrupoID) ? 'fa-users' : 'fa-user'})]),_c('td',[(permiso.GrupoID)?_c('span',[_vm._v(_vm._s(permiso.GrupoNombre))]):_c('span',[_vm._v(_vm._s(permiso.UsuarioNombre))])]),_c('td',[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(permiso.Acceso) ? 'btn-success' : '',on:{"click":function($event){_vm.galeria.permisos[i].Acceso = !permiso.Acceso}}},[_vm._v("Acceso")]),_c('button',{staticClass:"btn btn-sm",class:(permiso.Escritura) ? 'btn-success' : '',on:{"click":function($event){_vm.galeria.permisos[i].Escritura = !permiso.Escritura}}},[_vm._v("Escritura")]),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaPermiso(permiso.PermisoID)}}},[_c('span',{staticClass:"fa fa-trash"})])])])])}),0)])])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Etiquetas")]),_c('input-query',{attrs:{"inputClass":"form-control","realtime":true,"url":"galerias/php/api/query-etiquetas.php","placeholder":"Buscar o crea una nueva etiqueta"},on:{"selected":function($event){return _vm.addEtiqueta($event)}}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"contieneEtiquetas"},_vm._l((_vm.galeria.etiquetas),function(eti){return _c('button',{staticClass:"btn btn-danger m-2",on:{"click":function($event){return _vm.quitarEtiqueta(eti)}}},[_vm._v(_vm._s(eti)),_c('span',{staticClass:"fa fa-trash ml-2"})])}),0)])])]),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])]),(_vm.galeria.GaleriaID)?_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar galería")])]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",style:({cursor: 'pointer', width: _vm.miAncho + 'px', margin: _vm.miMargen + 'px', 'background-image': 'url(src/modulos/galerias/php/api/thumb.php?ItemID=' + _vm.item.ItemID + ')'}),on:{"click":_vm.selecciona}},[(_vm.item.Tipo === 'Video')?_c('span',{staticClass:"fa fa-caret-right playBtn"}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"contenedor"},[(_vm.galeria)?_c('div',[_vm._l((_vm.galeria.items),function(item,i){return _c('mini-item',{key:item.ItemID,attrs:{"item":item,"ancho":_vm.anchoEfectivo,"margen":_vm.margen},on:{"selecciona":function($event){return _vm.selecciona($event)}}})}),(_vm.galeria.items.length === 0)?_c('div',{staticClass:"text-center text-danger"},[_vm._m(0)]):_vm._e(),_c('a',{ref:"download",staticStyle:{"display":"none"},attrs:{"target":"_blank","href":'/src/modulos/galerias/php/api/download-galeria.php?GaleriaID=' + _vm.galeria.GaleriaID}})],2):_vm._e(),(_vm.item)?_c('visor-item',{attrs:{"item-id":_vm.item,"listado":_vm.listado},on:{"cerrar":function($event){_vm.item = null},"update:itemId":function($event){_vm.item=$event},"update:item-id":function($event){_vm.item=$event}}}):_vm._e(),_c('input',{ref:"uploader",staticStyle:{"display":"none"},attrs:{"type":"file","multiple":"true","accept":".mp4,.jpg,.png"}}),(_vm.editarGaleria)?_c('modal-galeria',{attrs:{"id-galeria":_vm.editarGaleria},on:{"cerrar":function($event){_vm.editarGaleria = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span',{staticClass:"fa fa-exclamation"}),_c('br'),_vm._v("No hay elementos en esta galería")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_buscador_vue__ = __webpack_require__(485);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_588e61ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_buscador_vue__ = __webpack_require__(1133);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_buscador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_588e61ac_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_buscador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscador"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cadena de texto")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cadena),expression:"filtro.cadena"}],staticClass:"form-control",attrs:{"placeholder":"Etiqueta / descripción / nombre..."},domProps:{"value":(_vm.filtro.cadena)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cadena", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de elementos")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.tipo === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:(_vm.filtro.tipo === 'galerias') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo('galerias')}}},[_vm._v("Galerias")]),_c('button',{staticClass:"btn",class:(_vm.filtro.tipo === 'items') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo('items')}}},[_vm._v("Ficheros")])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestion_etiquetas_vue__ = __webpack_require__(486);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0782a866_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_gestion_etiquetas_vue__ = __webpack_require__(1135);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestion_etiquetas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0782a866_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_gestion_etiquetas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card",staticStyle:{"text-align":"left"}},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-tag mr-2"}),_vm._v("Gestión de etiquetas"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Busca una etiqueta")]),_c('input-query',{attrs:{"inputClass":"form-control","realtime":true,"url":"galerias/php/api/query-personas.php"},on:{"selected":function($event){return _vm.seleccionada($event)}}})],1)]),(_vm.persona)?_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.persona.Nombre),expression:"persona.Nombre"}],staticClass:"form-control",attrs:{"placeholder":"Nombre"},domProps:{"value":(_vm.persona.Nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.persona, "Nombre", $event.target.value)}}})])]):_vm._e(),(_vm.persona)?_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('nav',{staticStyle:{"position":"absolute","display":"block","top":"0px","left":"0","right":"0","padding":"10px"},attrs:{"aria-label":"breadcrumb"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('ol',{staticClass:"breadcrumb",staticStyle:{"background-color":"transparent !important"}},[_c('li',{staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":"/main/galerias"}},[_c('span',{staticClass:"fa fa-home mr-2"}),_vm._v("Galerias")])],1),(_vm.galeria)?_c('li',{staticClass:"breadcrumb-item"},[_vm._v(_vm._s(_vm.galeria.Nombre)),_c('span',{staticStyle:{"color":"#777777"}},[_vm._v(" "+_vm._s(_vm._f("moment")(_vm.galeria.FechaGaleriaUnix,'DD-MMM-YYYY')))])]):_vm._e(),(!_vm.galeria && _vm.$route.name === 'buscador')?_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Buscador")])]):_vm._e()])]),_c('div',{staticClass:"col",staticStyle:{"max-width":"300px"}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cadena),expression:"cadena"}],staticClass:"form-control",attrs:{"placeholder":"Buscar cadena"},domProps:{"value":(_vm.cadena)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.doSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.cadena=$event.target.value}}}),_vm._m(0)])])])]),_c('router-view',{staticStyle:{"position":"absolute","display":"block","top":"50px","left":"0","right":"0","padding":"10px","bottom":"0","overflow":"auto"}}),(_vm.buscar)?_c('modal-buscador',{on:{"cerrar":function($event){_vm.buscar = false}}}):_vm._e(),(_vm.gestionEtiquetas)?_c('gestion-etiquetas',{on:{"cerrar":function($event){_vm.gestionEtiquetas = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary"},[_c('span',{staticClass:"fa fa-search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_galerias_vue__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_442787d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_galerias_vue__ = __webpack_require__(1140);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_galerias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_442787d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_galerias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listo)?_c('div',{staticClass:"item",style:({cursor: 'pointer', 'background-image': 'url(' + _vm.portada + ')'}),on:{"click":function($event){return _vm.$emit('selecciona', _vm.datos.GaleriaID)}}},[_c('div',{staticClass:"tituloGaleria"},[_vm._v(_vm._s(_vm.datos.Nombre)),_c('br'),_c('span',{staticStyle:{"color":"#666666"}},[_vm._v(_vm._s(_vm._f("moment")(_vm.datos.FechaUnix,'DD-MMM-Y')))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.galerias),function(galeria,i){return _c('mini-galeria',{key:galeria.GaleriaID,attrs:{"galeria":galeria},on:{"selecciona":function($event){return _vm.selecciona($event)}}})}),(_vm.editarGaleria)?_c('modal-galeria',{attrs:{"id-galeria":_vm.editarGaleria},on:{"cerrar":function($event){_vm.editarGaleria = null}}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vista_buscador_vue__ = __webpack_require__(489);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d5cb5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_vista_buscador_vue__ = __webpack_require__(1142);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vista_buscador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96d5cb5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_vista_buscador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.resultados.galerias.length > 0)?_c('div',[_c('h3',{staticClass:"font-primary"},[_c('span',{staticClass:"fa fa-folder mr-3"}),_vm._v("Galerías encontradas ("+_vm._s(_vm.resultados.galerias.length)+")")]),_vm._l((_vm.resultados.galerias),function(galeria){return _c('mini-galeria',{key:galeria.GaleriaID,attrs:{"galeria":galeria},on:{"selecciona":function($event){return _vm.verGaleria(galeria.GaleriaID)}}})})],2):_vm._e(),(_vm.resultados.items.length > 0)?_c('div',[_c('h3',{staticClass:"font-primary"},[_c('span',{staticClass:"fa fa-image mr-3"}),_vm._v("Ficheros encontrados ("+_vm._s(_vm.resultados.items.length)+")")]),_vm._l((_vm.resultados.items),function(item){return _c('mini-item',{key:item.ItemID,attrs:{"item":item},on:{"selecciona":function($event){_vm.verItem = item.ItemID}}})})],2):_vm._e(),(_vm.verItem)?_c('visor-item',{attrs:{"item-id":_vm.verItem,"listado":_vm.listado},on:{"cerrar":function($event){_vm.verItem = null},"update:itemId":function($event){_vm.verItem=$event},"update:item-id":function($event){_vm.verItem=$event}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);


/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		buscador: {
			galerias: [],
			items: []
		},
		galeria: null,
		cola: [],
		subiendo: null,
		progressId: null,
		colaSubidos: 0
	},
	getters: {
		buscador: function buscador(state) {
			return state.buscador;
		},
		galeria: function galeria(state) {
			return state.galeria;
		}
	},
	mutations: {
		SET_ENCONTRADOS: function SET_ENCONTRADOS(state, payload) {
			state.buscador.galerias = payload.galerias;
			state.buscador.items = payload.items;
		},
		ADD_COLA: function ADD_COLA(state, payload) {
			state.cola.push(payload);

			// Hay que procesar la cola
			this.dispatch('galerias/procesarCola');
		},
		VACIA_COLA: function VACIA_COLA(state) {
			state.cola = [];
		},
		SET_GALERIA: function SET_GALERIA(state, payload) {
			state.galeria = payload;
		},
		DEL_ITEM: function DEL_ITEM(state, ItemID) {
			for (var i = state.galeria.items.length - 1; i >= 0; i--) {
				if (state.galeria.items[i].ItemID === ItemID) {
					state.galeria.items.splice(i, 1);
				}
			}
		},
		SET_ITEM: function SET_ITEM(state, item) {
			for (var i = 0; i < state.galeria.items.length; i++) {
				if (state.galeria.items[i].ItemID === item.ItemID) {
					__WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.galeria.items, i, item);
				}
			}
		},
		SUMA_SUBIDOS: function SUMA_SUBIDOS(state) {
			state.colaSubidos = state.colaSubidos + 1;
		},
		RESET_SUBIDOS: function RESET_SUBIDOS(state) {
			state.colaSubidos = 0;
		}
	},
	actions: {
		buscar: function buscar(context, payload) {
			var _this = this;

			// PRIMERO BORRAMOS LOS RESULTADOS ANTERIORES
			context.commit('SET_ENCONTRADOS', { galerias: [], items: [] });

			// AHORA BUSCAMOS
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('galerias/php/api/buscador.php', payload).then(function (res) {
				context.commit('SET_ENCONTRADOS', res.data);
			}).catch(function (e) {
				_this.commit('toast/danger', {
					titulo: 'Error',
					mensaje: 'Error en la búsqueda'
				});
			});
		},
		procesarCola: function procesarCola(context) {
			var _this2 = this;

			if (context.state.subiendo) {
				return;
			}
			if (context.state.cola.length > context.state.colaSubidos) {
				if (!context.state.progressId) {
					context.state.progressId = 'progress' + new Date().getTime().toString();

					var progreso = {
						id: context.state.progressId,
						titulo: 'Subida de ficheros',
						mensaje: 'Subiendo ' + (context.state.colaSubidos + 1) + ' de ' + context.state.cola.length + ' ficheros',
						progress: Math.round(context.state.colaSubidos * 100 / context.state.cola.length)
					};

					this.commit('toast/progress', progreso);
				}

				context.state.subiendo = context.state.cola[context.state.colaSubidos];

				var ajax = new XMLHttpRequest();
				ajax.open('POST', 'src/modulos/galerias/php/api/upload.php?GaleriaID=' + context.state.subiendo.GaleriaID);
				ajax.responseType = 'json';
				ajax.onreadystatechange = function (ev) {
					if (ajax.readyState === 4) {
						context.commit('SUMA_SUBIDOS');
						if (ajax.status !== 200) {
							_this2.commit('toast/danger', {
								titulo: 'Error',
								mensaje: 'Error realizando el upload'
							});
						} else {
							if (context.state.galeria && context.state.galeria.GaleriaID === ajax.response.galeria.GaleriaID) {
								context.commit('SET_GALERIA', ajax.response.galeria);
							}
						}
						var _progreso = {
							id: context.state.progressId,
							titulo: 'Subida de ficheros',
							mensaje: 'Subiendo ' + (context.state.colaSubidos + 1) + ' de ' + context.state.cola.length + ' ficheros',
							progress: Math.round(context.state.colaSubidos * 100 / context.state.cola.length)
						};

						_this2.commit('toast/progress', _progreso);
						context.state.subiendo = null;
						context.dispatch('procesarCola');
					}
				};

				ajax.upload.onprogress = function (ev) {
					if (ev.lengthComputable) {
						var total = ev.total;
						var loaded = ev.loaded;
						var porcentaje = Math.round(loaded * 100 / total);

						// Intervalos
						var intervalo = Math.round(100 / context.state.cola.length);
						var progresoPequeno = Math.round(intervalo * porcentaje / 100);

						var _progreso2 = {
							id: context.state.progressId,
							titulo: 'Subida de ficheros',
							mensaje: 'Subiendo ' + (context.state.colaSubidos + 1) + ' de ' + context.state.cola.length + ' ficheros',
							progress: Math.round(context.state.colaSubidos * 100 / context.state.cola.length + progresoPequeno)
						};

						_this2.commit('toast/progress', _progreso2);
					}
				};
				var form = new FormData();
				form.append('fichero[]', context.state.subiendo.fichero);
				ajax.send(form);
			} else {
				if (context.state.progressId) {
					var _progreso3 = {
						id: context.state.progressId,
						titulo: 'Subida de ficheros',
						mensaje: 'Subidos ' + context.state.cola.length + ' ficheros',
						progress: 100,
						closed: true,
						active: false
					};

					this.commit('toast/progress', _progreso3);

					window.setTimeout(function () {
						console.log('Cerrando');
						_this2.commit('toast/delete', context.state.progressId);
						context.state.progressId = null;
					}, 300);
					context.commit('RESET_SUBIDOS');
					context.commit('VACIA_COLA');
				}
			}
		}
	}
});

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1145);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('anunciantes', {
			name: 'Gestión de anunciantes',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});
	}
});

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(490);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19024591_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1153);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19024591_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__ = __webpack_require__(491);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a9ad336_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__ = __webpack_require__(1152);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a9ad336_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_filtro_vue__ = __webpack_require__(492);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7033dfef_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listado_filtro_vue__ = __webpack_require__(1148);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_filtro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7033dfef_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listado_filtro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-left"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3 col-lg-3"},[(_vm.permisos.anunciantes_verTodos)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Agente")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.agente),expression:"filtro.agente"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"Busca por agente"},domProps:{"value":(_vm.filtro.agente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "agente", $event.target.value)}}})]):_vm._e(),_vm._v(" "),(!_vm.permisos.anunciantes_verTodos)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Agente")]),_vm._v(" "),_c('input',{staticClass:"form-control input-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.usuario.nombre}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Anunciante")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.nombre),expression:"filtro.nombre"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"Busca por nombre"},domProps:{"value":(_vm.filtro.nombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "nombre", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Activo")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.activo === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.activo = null}}},[_vm._v("Todos")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.activo === true) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.activo = true}}},[_vm._v("Activo")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.activo === false) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.activo = false}}},[_vm._v("Inactivo")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Límite de resultados")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.max === 50) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.max = 50}}},[_vm._v("50")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.max === 250) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.max = 250}}},[_vm._v("250")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.max === 500) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.max = 500}}},[_vm._v("500")])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.buscar()}}},[_vm._v("\n\t\t\tBuscar\n\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.nuevo()}}},[_vm._v("\n\t\t\tNuevo\n\t\t")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-info card-header text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("\n\t\tBúsqueda de anunciantes\n\t")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b309196c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1151);
function injectStyle (ssrContext) {
  __webpack_require__(1150)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b309196c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.anunciante)?_c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("\n\t\t\t\t\tEditando: "+_vm._s(_vm.anunciante.nombre || 'Nuevo anunciante')+"\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#f0f0f0","padding":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6",staticStyle:{"margin-bottom":"15px"}},[(!_vm.anunciante.agente.ID)?_c('div',{staticClass:"input-group input-group-sm has-error"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("\n\t\t\t\t\t\t\t\t\tAgente\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('input-query',{attrs:{"input-class":"form-control form-control-sm","realtime":true,"url":"gestion-anunciantes/php/api/buscaAgente.php","placeholder":"Selecciona el agente"},on:{"selected":function($event){return _vm.setAgente($event)}}})],1):_vm._e(),_vm._v(" "),(_vm.anunciante.agente.ID)?_c('div',{staticStyle:{"position":"relative","display":"block"}},[_c('img',{staticStyle:{"vertical-align":"middle","margin":"5px","width":"50px","height":"50px","border-radius":"25px"},attrs:{"src":_vm.anunciante.agente.avatar,"alt":""}}),_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.anunciante.agente.nombre)+"\n\t\t\t\t\t\t\t\t"),(_vm.permisos.anunciantes_crearTodos)?_c('button',{staticClass:"btn btn-sm btn-danger",staticStyle:{"position":"absolute","display":"block","right":"10px","top":"15px"},on:{"click":function($event){return _vm.setAgente(null)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6"},[_c('div',{staticClass:"input-group input-group-sm",class:(!_vm.anunciante.nombre) ? 'has-error' : 'has-success'},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.anunciante.nombre),expression:"anunciante.nombre"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Nombre del anunciante"},domProps:{"value":(_vm.anunciante.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.anunciante, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm mt-2"},[_vm._m(1),_vm._v(" "),_c('input-query',{attrs:{"placeholder":"Asigna una o más categorías (escribe % para un listado completo)","url":"gestion-anunciantes/php/api/buscaCategoria.php","realtime":true,"inputClass":"form-control form-control-sm"},on:{"selected":function($event){return _vm.addCategoria($event)}}})],1),_vm._v(" "),(_vm.anunciante.categorias.length > 0)?_c('ul',{staticClass:"listaCategorias"},_vm._l((_vm.anunciante.categorias),function(cat){return _c('li',[_c('span',[_c('span',{staticClass:"fa fa-tag mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(cat.CodigoSector)+" "+_vm._s(cat.SectorDescripcion)+" > "+_vm._s(cat.CodigoCategoria)+" "+_vm._s(cat.CategoriaDescripcion)+"\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.delCategoria(cat.CategoriaID)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"text-info",staticStyle:{"font-size":"1.5em","font-weight":"bold"}},[_vm._v("\n\t\t\t\t\t\tDatos de contacto\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6"},[_vm._l((_vm.anunciante.direcciones),function(direccion,index){return _c('div',{key:index,staticClass:"card mb-2"},[_c('div',{staticClass:"card-body"},[_c('b',[_vm._v("Dirección")]),_vm._v(" "),(_vm.anunciante.direcciones.length > 1)?_c('button',{staticClass:"pull-right btn btn-sm btn-danger",on:{"click":function($event){return _vm.anunciante.direcciones.splice(index, 1)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(2,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.pais),expression:"direccion.pais"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"País"},domProps:{"value":(direccion.pais)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "pais", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(3,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.region),expression:"direccion.region"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"Comunidad"},domProps:{"value":(direccion.region)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "region", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(4,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.provincia),expression:"direccion.provincia"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"Provincia"},domProps:{"value":(direccion.provincia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "provincia", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(5,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.localidad),expression:"direccion.localidad"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"Localidad"},domProps:{"value":(direccion.localidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "localidad", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(6,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.via),expression:"direccion.via"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"Calle Mayor"},domProps:{"value":(direccion.via)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "via", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(7,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.cp),expression:"direccion.cp"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"C.P."},domProps:{"value":(direccion.cp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "cp", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(8,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.numero),expression:"direccion.numero"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"nº"},domProps:{"value":(direccion.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "numero", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(9,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.esc),expression:"direccion.esc"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"esc"},domProps:{"value":(direccion.esc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "esc", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(10,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.piso),expression:"direccion.piso"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(direccion.piso)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "piso", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(11,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.puerta),expression:"direccion.puerta"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(direccion.puerta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "puerta", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('label',{attrs:{"for":""}},[_vm._v("Indicaciones extra")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(direccion.indicaciones),expression:"direccion.indicaciones"}],staticClass:"form-control",attrs:{"name":"","rows":"5"},domProps:{"value":(direccion.indicaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "indicaciones", $event.target.value)}}})])])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success mt-2",on:{"click":_vm.addDireccion}},[_c('span',{staticClass:"fa fa-plus"}),_vm._v("\n\t\t\t\t\t\t\t\tAñadir dirección\n\t\t\t\t\t\t\t")])],2),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6"},[_c('div',{staticClass:"card card-success"},[_c('div',{staticClass:"card-body"},[_c('b',[_vm._v("Teléfono(s) | E-mail(s)")]),_vm._v(" "),_vm._l((_vm.anunciante.telefonos),function(tel,index){return _c('div',{key:index,staticClass:"input-group input-group-sm",staticStyle:{"margin-top":"5px"}},[_vm._m(12,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.anunciante.telefonos[index].telefono),expression:"anunciante.telefonos[index].telefono"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"Teléfono"},domProps:{"value":(_vm.anunciante.telefonos[index].telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.anunciante.telefonos[index], "telefono", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.quitaTel(index)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),_vm._v(" "),_vm._l((_vm.anunciante.emails),function(tel,index){return _c('div',{key:index,staticClass:"input-group input-group-sm",staticStyle:{"margin-top":"5px"}},[_vm._m(13,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.anunciante.emails[index].email),expression:"anunciante.emails[index].email"}],staticClass:"form-control input-sm",attrs:{"type":"text","placeholder":"E-mail"},domProps:{"value":(_vm.anunciante.emails[index].email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.anunciante.emails[index], "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.quitaEmail(index)}}},[_c('span',{staticClass:"fa fa-trash"})])])])})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-success",on:{"click":function($event){return _vm.addTel()}}},[_c('span',{staticClass:"fa fa-plus"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tTeléfono\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success",on:{"click":function($event){return _vm.addEmail()}}},[_c('span',{staticClass:"fa fa-plus"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tE-mail\n\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"card card-info mt-2"},[_vm._m(14),_vm._v(" "),(_vm.anunciante.ficheros.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-condensed"},[_vm._m(15),_vm._v(" "),_c('tbody',_vm._l((_vm.anunciante.ficheros),function(fichero){return _c('tr',{key:fichero.nombre},[_c('td',[_vm._v(_vm._s(fichero.nombre))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Math.round(fichero.tamano / 1024))+" kb")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.descargar(fichero.ID_fichero)}}},[_c('span',{staticClass:"fa fa-download"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitarFichero(fichero.ID_fichero)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-success",on:{"click":_vm.doUpload}},[_c('span',{staticClass:"fa fa-upload"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tSubir ficheros\n\t\t\t\t\t\t\t\t\t")])])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.guardar}},[_vm._v("\n\t\t\t\t\t\tGuardar\n\t\t\t\t\t")])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tAnunciante\n\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Categoría")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tPaís\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tComunidad\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tProvincia\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tLocalidad\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tVía\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tC.P.\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tNº\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tEsc\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tPiso\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tPuerta\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text fa fa-phone"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text fa fa-w fa-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('b',[_vm._v("Ficheros")]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tAquí puedes ajuntar todos los ficheros que sean relevantes para la ficha del anunciante, tales como logotipos, sintonías propias, voces insitucionales personalizadas, etc.\n\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td',[_vm._v("Nombre")]),_vm._v(" "),_c('td',[_vm._v("Tamaño")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"fa fa-gear"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('listado-filtro',{attrs:{"filtro":_vm.filtro},on:{"buscar":_vm.buscar,"nuevo":function($event){_vm.idAnunciante = 'nuevo'}}}),_vm._v(" "),(_vm.resultados.length > 0)?_c('div',{staticClass:"card text-left mt-3"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t"+_vm._s(_vm.resultados.length)+" resultados\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"table-responsive text-left"},[_c('table',{staticClass:"table table-striped table-condensed"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.resultados),function(anunciante){return _c('tr',{key:anunciante.ID_anunciante},[_c('td',[_vm._v(_vm._s(anunciante.ID_anunciante))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(anunciante.agenteNombre))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(anunciante.nombre))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(anunciante.campanas))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.idAnunciante = anunciante.ID_anunciante}}},[_c('span',{staticClass:"fa fa-eye"})])])])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.resultados.length === 0)?_c('div',{staticClass:"mt-3 text-danger",staticStyle:{"text-align":"center","padding-top":"20px","font-size":"2em","font-weight":"bold"}},[_c('span',{staticClass:"fa fa-ban"}),_vm._v(" "),_c('br'),_vm._v("\n\t\tNo hay resultados\n\t")]):_vm._e(),_vm._v(" "),(_vm.idAnunciante)?_c('editor-anunciante',{attrs:{"id-anunciante":_vm.idAnunciante},on:{"cerrar":function($event){_vm.idAnunciante = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("Agente")]),_vm._v(" "),_c('th',[_vm._v("Anunciante")]),_vm._v(" "),_c('th',[_vm._v("Campañas")]),_vm._v(" "),_c('th',[_vm._v("Opciones")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listado')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_traspaso_cartera_traspaso_cartera_component_vue__ = __webpack_require__(1162);




/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('clientes', {
			name: 'Gestión de clientes',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('clientes/traspaso-cartera', {
			name: 'Traspaso de cartera',
			component: __WEBPACK_IMPORTED_MODULE_2__components_traspaso_cartera_traspaso_cartera_component_vue__["a" /* default */]
		});
	}
});

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(495);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f602b42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1161);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f602b42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__ = __webpack_require__(496);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352f3958_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__ = __webpack_require__(1160);
function injectStyle (ssrContext) {
  __webpack_require__(1157)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-352f3958"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_352f3958_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_filtro_vue__ = __webpack_require__(497);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276e58c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_filtro_vue__ = __webpack_require__(1159);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_filtro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276e58c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_filtro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Búsqueda de clientes")]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3 col-lg-3"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('label',[_vm._v("Agente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.agente),expression:"filtro.agente"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Busca por agente"},domProps:{"value":(_vm.filtro.agente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "agente", $event.target.value)}}})]),(!_vm.permisos.clientes_verTodos)?_c('div',{staticClass:"form-group form-group-sm"},[_c('label',[_vm._v("Agente")]),_c('input',{staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":"disabled"},domProps:{"value":_vm.usuario.nombre}})]):_vm._e(),_c('div',{staticClass:"form-group form-group-sm"},[_c('label',[_vm._v("Nombre/CIF")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.nombre),expression:"filtro.nombre"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Busca por nombre o CIF"},domProps:{"value":(_vm.filtro.nombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "nombre", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3 col-lg-3"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('label',[_vm._v("Activo")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.activo === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.activo = null}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.activo === true) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.activo = true}}},[_vm._v("Activo")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.activo === false) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.activo = false}}},[_vm._v("Inactivo")])])]),_c('div',{staticClass:"form-group form-group-sm"},[_c('label',[_vm._v("Asignado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.asignado === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.asignado = null}}},[_vm._v("Ambos")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.asignado === true) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.asignado = true}}},[_vm._v("Sí")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.asignado === false) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.asignado = false}}},[_vm._v("No")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-3 col-lg-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('label',[_vm._v("Semáforo contratos")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.semaforoContratos === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.semaforoContratos = null}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.semaforoContratos === 'verde') ? 'btn-success' : 'btn-default',on:{"click":function($event){_vm.filtro.semaforoContratos = 'verde'}}},[_vm._v("Verde")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.semaforoContratos === 'naranja') ? 'btn-warning' : 'btn-default',on:{"click":function($event){_vm.filtro.semaforoContratos = 'naranja'}}},[_vm._v("Naranja")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.semaforoContratos === 'rojo') ? 'btn-danger' : 'btn-default',on:{"click":function($event){_vm.filtro.semaforoContratos = 'rojo'}}},[_vm._v("Rojo")])])])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('label',[_vm._v("Semáforo propuestas")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.semaforoPropuestas === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.semaforoPropuestas = null}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.semaforoPropuestas === 'verde') ? 'btn-success' : 'btn-default',on:{"click":function($event){_vm.filtro.semaforoPropuestas = 'verde'}}},[_vm._v("Verde")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.semaforoPropuestas === 'naranja') ? 'btn-warning' : 'btn-default',on:{"click":function($event){_vm.filtro.semaforoPropuestas = 'naranja'}}},[_vm._v("Naranja")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.semaforoPropuestas === 'rojo') ? 'btn-danger' : 'btn-default',on:{"click":function($event){_vm.filtro.semaforoPropuestas = 'rojo'}}},[_vm._v("Rojo")])])])])]),_c('div',{staticClass:"form-group form-group-sm"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('label',[_vm._v("Con facturación")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.facturacion === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.facturacion = null}}},[_vm._v("Ambas")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.facturacion === true) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.facturacion = true}}},[_vm._v("Sí")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.facturacion === false) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.facturacion = false}}},[_vm._v("No")])])]),(_vm.permisos.clientes_crearTodos)?_c('div',{staticClass:"col"},[_c('label',[_vm._v("Geolocalizados")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.Google === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.Google = null}}},[_vm._v("Ambos")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.Google === '1') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.Google = '1'}}},[_vm._v("Sí")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.Google === '0') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.Google = '0'}}},[_vm._v("No")])])]):_vm._e()])])]),_c('div',{staticClass:"col-xs-12col-sm-6col-md-3col-lg-3"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('label',[_vm._v("Límite de resultados")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.max === 50) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.max = 50}}},[_vm._v("50")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.max === 250) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.max = 250}}},[_vm._v("250")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.max === 500) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.max = 500}}},[_vm._v("500")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.max === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.max = null}}},[_vm._v("Sin límite")])])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Ordenar resultados")]),_c('div',{staticClass:"input-group inout-group-sm"},[_vm._m(0),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.ordenarCampo),expression:"filtro.ordenarCampo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "ordenarCampo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoCampos),function(campo){return _c('option',{key:campo.campo,domProps:{"value":campo.campo}},[_vm._v(_vm._s(campo.nombre))])}),0),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.ordenarOrden === 'ASC') ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.ordenarOrden = 'ASC'}}},[_c('span',{staticClass:"fa fa-caret-up"})])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.filtro.ordenarOrden === 'DESC') ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.ordenarOrden = 'DESC'}}},[_c('span',{staticClass:"fa fa-caret-down"})])])])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary mr-2",on:{"click":function($event){return _vm.buscar()}}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.nuevo()}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Nuevo")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Campo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('listado-filtro',{attrs:{"filtro":_vm.filtro},on:{"buscar":_vm.buscar,"nuevo":function($event){_vm.idCliente = 'nuevo'}}}),(_vm.resultados.length > 0)?_c('div',{staticClass:"card text-left mt-2"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v(_vm._s(_vm.resultados.length)+" resultados")]),_c('div',{staticClass:"table-responsive text-left"},[_c('table',{staticClass:"table table-striped table-condensed m-0"},[_vm._m(0),_c('tbody',_vm._l((_vm.resultados),function(cliente){return _c('tr',{key:cliente.ID_cliente},[_c('td',[_vm._v(_vm._s(cliente.ID))]),_c('td',[(cliente.agenteID)?_c('span',[_vm._v(_vm._s(cliente.agenteNombre))]):_c('span',{staticClass:"text-danger"},[_c('span',{staticClass:"fa fa-user-times"})])]),_c('td',{class:!cliente.activo ? 'text-danger' : ''},[(!cliente.activo)?_c('span',{staticClass:"text-danger mr-2"},[_c('div',{staticClass:"fa fa-window-close-o"})]):_vm._e(),_c('span',[_vm._v(_vm._s(cliente.cliente))]),(cliente.nombre_comercial)?_c('span',{staticClass:"ml-2 text-primary"},[_vm._v("("+_vm._s(cliente.nombre_comercial)+")")]):_vm._e()]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(cliente.fecha_creacion,'DD-MM-YYYY')))]),_c('td',[_vm._v(_vm._s(cliente.CIF))]),(cliente.agenteID === _vm.usuario.ID || _vm.permisos.clientes_verTodos)?_c('td',[_vm._v(_vm._s(_vm._f("currency")(cliente.importe_facturado,'€')))]):_c('td'),_c('td',{class:cliente.color},[(typeof cliente.dias_sin_campana === 'number' && (cliente.agenteID === _vm.usuario.ID || _vm.permisos.clientes_verTodos))?_c('span',[_vm._v(_vm._s(cliente.dias_sin_campana)+" días")]):_c('span',{staticStyle:{"opacity":"0.4"}},[_vm._v("Nunca")])]),_c('td',{class:cliente.colorPropuesta},[(typeof cliente.dias_sin_contacto === 'number' && (cliente.agenteID === _vm.usuario.ID || _vm.permisos.clientes_verTodos))?_c('span',[_vm._v(_vm._s(cliente.dias_sin_contacto)+" días")]):_c('span',{staticStyle:{"opacity":"0.4"}},[_vm._v("Nunca")])]),_c('td',[(cliente.agenteID === _vm.usuario.ID || _vm.permisos.clientes_verTodos)?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.idCliente = cliente.ID}}},[_c('span',{staticClass:"fa fa-eye"})]):_vm._e()])])}),0)])])]):_vm._e(),(_vm.resultados.length === 0)?_c('div',{staticClass:"text-danger",staticStyle:{"text-align":"center","padding-top":"20px","font-size":"2em","font-weight":"bold"}},[_c('span',{staticClass:"fa fa-ban"}),_c('br'),_vm._v("No hay resultados")]):_vm._e(),(_vm.idCliente)?_c('editor-cliente',{attrs:{"id-cliente":_vm.idCliente},on:{"cerrar":function($event){return _vm.cierraEditor()}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Creación")]),_c('th',[_vm._v("CIF")]),_c('th',[_vm._v("Facturado")]),_c('th',[_vm._v("Semáforo contratos")]),_c('th',[_vm._v("Semáforo propuestas")]),_c('th',[_vm._v("Opciones")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('listado')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_traspaso_cartera_component_vue__ = __webpack_require__(498);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa87982_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_traspaso_cartera_component_vue__ = __webpack_require__(1167);
function injectStyle (ssrContext) {
  __webpack_require__(1163)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1aa87982"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_traspaso_cartera_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aa87982_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_traspaso_cartera_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccion_agente_component_vue__ = __webpack_require__(499);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d825e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_seleccion_agente_component_vue__ = __webpack_require__(1166);
function injectStyle (ssrContext) {
  __webpack_require__(1165)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccion_agente_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d825e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_seleccion_agente_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info",staticStyle:{"color":"white"}},[_c('span',{staticClass:"fa fa-gear mr-2"}),_c('span',[_vm._v("Configura el traspaso")]),_c('span',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Selecciona el agente de destino")])]),(!_vm.datos.AgenteID)?_c('input-query',{attrs:{"inputClass":"form-control","placeholder":"Nombre","realtime":true,"url":"gestion-clientes/php/api/buscaAgente.php"},on:{"selected":_vm.seleccionaAgente}}):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"true"},domProps:{"value":_vm.AgenteNombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.datos.AgenteID = null}}},[_c('span',{staticClass:"fa fa-trash"})])])])],1)]),(_vm.datos.AgenteID)?_c('div',{staticClass:"card-body bg-light"},[_c('div',[_c('b',[_vm._v("¿Migrar contratos, facturación y cobros?")])]),_c('div',{staticClass:"input-group mt-2"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.contratos),expression:"datos.contratos"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.datos.contratos)?_vm._i(_vm.datos.contratos,null)>-1:(_vm.datos.contratos)},on:{"change":function($event){var $$a=_vm.datos.contratos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.datos, "contratos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.datos, "contratos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.datos, "contratos", $$c)}}}})])]),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Desde")])]),_c('vc-date-picker',{staticClass:"form-control",attrs:{"disabled":!_vm.datos.contratos,"input-props":{
						placeholder: 'Desde la fecha',
						class: 'inputFecha',
						readonly: true,
						masks: {
							input: "['MMM, YYYY']"
						}
					},"masks":{
						input: ['MMM YYYY']
					}},model:{value:(_vm.datos.FechaInicioContratos),callback:function ($$v) {_vm.$set(_vm.datos, "FechaInicioContratos", $$v)},expression:"datos.FechaInicioContratos"}})],1)]):_vm._e(),(_vm.datos.AgenteID)?_c('div',{staticClass:"card-body bg-light"},[_c('div',[_c('b',[_vm._v("¿Migrar anunciantes relacionados?")])]),_c('div',{staticClass:"input-group mt-2"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.anunciantes),expression:"datos.anunciantes"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.datos.anunciantes)?_vm._i(_vm.datos.anunciantes,null)>-1:(_vm.datos.anunciantes)},on:{"change":function($event){var $$a=_vm.datos.anunciantes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.datos, "anunciantes", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.datos, "anunciantes", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.datos, "anunciantes", $$c)}}}})])]),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Sí")])])])]):_vm._e(),(_vm.datos.AgenteID)?_c('div',{staticClass:"card-body bg-light"},[_c('div',[_c('b',[_vm._v("¿Migrar producciones relacionadas?")])]),_c('div',{staticClass:"input-group mt-2"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.producciones),expression:"datos.producciones"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.datos.producciones)?_vm._i(_vm.datos.producciones,null)>-1:(_vm.datos.producciones)},on:{"change":function($event){var $$a=_vm.datos.producciones,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.datos, "producciones", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.datos, "producciones", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.datos, "producciones", $$c)}}}})])]),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Desde")])]),_c('vc-date-picker',{staticClass:"form-control",attrs:{"disabled":!_vm.datos.contratos,"input-props":{
						placeholder: 'Desde la fecha',
						class: 'inputFecha',
						readonly: true,
						masks: {
							input: "['MMM, YYYY']"
						}
					},"masks":{
						input: ['MMM YYYY']
					}},model:{value:(_vm.datos.FechaInicioProducciones),callback:function ($$v) {_vm.$set(_vm.datos, "FechaInicioProducciones", $$v)},expression:"datos.FechaInicioProducciones"}})],1)]):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.asignar}},[_vm._v("Asignar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.nombre),expression:"filtro.nombre"}],staticClass:"form-control",attrs:{"placeholder":"Buscar por nombre de cliente"},domProps:{"value":(_vm.filtro.nombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "nombre", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.agente),expression:"filtro.agente"}],staticClass:"form-control",attrs:{"placeholder":"Buscar por nombre del agente"},domProps:{"value":(_vm.filtro.agente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "agente", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Semáforo")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:_vm.filtro.semaforo === '' ? 'btn-primary' : '',on:{"click":function($event){return _vm.setSemaforo('')}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:_vm.filtro.semaforo === 'verde' ? 'btn-success' : 'verde',on:{"click":function($event){return _vm.setSemaforo('verde')}}},[_vm._v("Verde")]),_c('button',{staticClass:"btn",class:_vm.filtro.semaforo === 'naranja' ? 'btn-warning' : 'naranja',on:{"click":function($event){return _vm.setSemaforo('naranja')}}},[_vm._v("Naranja")]),_c('button',{staticClass:"btn",class:_vm.filtro.semaforo === 'rojo' ? 'btn-danger' : 'rojo',on:{"click":function($event){return _vm.setSemaforo('rojo')}}},[_vm._v("Rojo")])])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])])]),_c('div',{staticClass:"card mt-2"},[_vm._m(1),_c('table',{staticClass:"table table-hover m-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.resultados),function(cliente){return _c('tr',{key:cliente.ID,staticClass:"cliente",class:_vm.seleccionados.indexOf(cliente.ID) >= 0 ? 'seleccionado' : '',on:{"click":function($event){return _vm.toggleCliente(cliente.ID)}}},[_c('td',[_vm._v(_vm._s(cliente.ID))]),_c('td',[_c('div',[_vm._v(_vm._s(cliente.cliente))]),_c('div',{staticStyle:{"opacity":"0.5"}},[_vm._v(_vm._s(cliente.nombre_comercial))])]),_c('td',[_vm._v(_vm._s(cliente.agenteNombre))]),_c('td',[_vm._v(_vm._s(cliente.dias_sin_firmar)+" días")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(cliente.importe_facturado,''))+" €")])])}),0)])]),_c('div',{staticClass:"capaAccion",class:_vm.seleccionados.length > 0 ? 'active' : ''},[_c('button',{staticClass:"btn-lg btn btn-primary",on:{"click":function($event){_vm.traspasar = true}}},[_vm._v("Traspasar "+_vm._s(_vm.seleccionados.length)+" clientes")])]),(_vm.traspasar)?_c('SeleccionAgente',{attrs:{"clientes":_vm.seleccionados},on:{"cerrar":function($event){_vm.traspasar = false},"traspasado":_vm.buscar}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar clientes")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Clientes")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("Semáforo")]),_c('th',[_vm._v("Facturación")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(1169);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('gestion-cuentas-email', {
			name: 'Gestión de cuentas de e-mail',
			component: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */]
		});
	}
});

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(500);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20396045_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(1174);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20396045_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_cuentas_vue__ = __webpack_require__(501);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02934daa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_cuentas_vue__ = __webpack_require__(1171);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_cuentas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02934daa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_cuentas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cuenta)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Editor de cuentas")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h4',[_vm._v("Datos generales")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Cuenta")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cuenta.cuenta),expression:"cuenta.cuenta"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"nombre"},domProps:{"value":(_vm.cuenta.cuenta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cuenta, "cuenta", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Dominio")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cuenta.dominio_id),expression:"cuenta.dominio_id"}],staticClass:"form-control form-control-sm",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.cuenta, "dominio_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoDominios),function(dominio){return _c('option',{key:dominio.id,domProps:{"value":dominio.id}},[_vm._v(_vm._s(dominio.dominio))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Cuota")]),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cuenta.quota_gb),expression:"cuenta.quota_gb"}],staticClass:"form-control form-control-sm",attrs:{"type":"number"},domProps:{"value":(_vm.cuenta.quota_gb)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cuenta, "quota_gb", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Usuario asignado")]),_vm._v(" "),(!_vm.cuenta.usuario)?_c('input-query',{attrs:{"url":"gestion-cuentas-email/php/queryUsuarios.php","input-class":"form-control form-control-sm","realtime":true,"placeholder":"Asigna un usuario"},on:{"selected":function($event){return _vm.setUsuario($event)}}}):_vm._e(),_vm._v(" "),(_vm.cuenta.usuario)?_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{staticClass:"form-control",attrs:{"disabled":""},domProps:{"value":_vm.cuenta.usuario.nombre + ' ' + _vm.cuenta.usuario.apellidos}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitaUsuario}},[_c('span',{staticClass:"fa fa-trash"})])])]):_vm._e()],1)])])]),_vm._v(" "),(_vm.cuenta.id)?_c('div',{staticClass:"card-body bg-light"},[_c('h4',[_vm._v("Tokens de acceso")])]):_vm._e(),_vm._v(" "),(_vm.cuenta.id)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-condensed table-striped m-0"},[_c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',{staticStyle:{"vertical-align":"middle"}},[_vm._v("Nombre")]),_vm._v(" "),_c('th',{staticStyle:{"vertical-align":"middle"}},[_vm._v("Fecha de creación")]),_vm._v(" "),_c('th',{staticStyle:{"vertical-align":"middle"}},[_vm._v("Último acceso")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.creandoToken = true}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n\t\t\t\t\t\t\tNuevo\n\t\t\t\t\t\t")])])])]),_vm._v(" "),(_vm.creandoToken)?_c('thead',{staticClass:"bg-light"},[_c('tr',[_c('th',{attrs:{"colspan":"4"}},[_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.token.nombre),expression:"token.nombre"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Escribe un nombre"},domProps:{"value":(_vm.token.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.token, "nombre", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.nuevoToken}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\tCrear\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.cancelarCrearToken}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t\t\t")])])])])])]):_vm._e(),_vm._v(" "),_c('tbody',_vm._l((_vm.cuenta.tokens),function(token){return _c('tr',{key:token.id},[_c('td',[_vm._v(_vm._s(token.nombre))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(new Date(token.fecha_creacion * 1000).toLocaleDateString()))]),_vm._v(" "),_c('td',[(token.fecha_acceso)?_c('span',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(new Date(token.fecha_acceso * 1000).toLocaleDateString())+"\n\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(!token.fecha_acceso)?_c('span',[_vm._v("\n\t\t\t\t\t\t\tNunca\n\t\t\t\t\t\t")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.delToken(token.id)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])]):_vm._e(),_vm._v(" "),(_vm.formValido)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("\n\t\t\tGuardar\n\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("\n\t\t\tEliminar cuenta\n\t\t")])]):_vm._e()]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Gb")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_alias_vue__ = __webpack_require__(502);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f39550e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_alias_vue__ = __webpack_require__(1173);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_alias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f39550e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_alias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Editor de alias")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[(_vm.alias === 'nuevo')?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n\t\t\tPara crear un nuevo alias es necesario que introduzcas los datos del origen y al menos un destino\n\t\t")]):_vm._e(),_vm._v(" "),_c('h4',[_vm._v("Origen")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(!_vm.editarOrigen)?_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.alias.cuenta),expression:"alias.cuenta"}],staticClass:"form-control",attrs:{"type":"text","disabled":"true"},domProps:{"value":(_vm.alias.cuenta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.alias, "cuenta", $event.target.value)}}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.alias.dominio),expression:"alias.dominio"}],staticClass:"form-control",attrs:{"name":"","id":"","disabled":"true"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.alias, "dominio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoDominios),function(dominio){return _c('option',{key:dominio.id,domProps:{"value":dominio.id}},[_vm._v(_vm._s(dominio.dominio))])}),0),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.cambiarOrigen}},[_c('span',{staticClass:"fa fa-edit"})])])]):_vm._e(),_vm._v(" "),(_vm.editarOrigen)?_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.cuentaNew),expression:"datos.cuentaNew"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.datos.cuentaNew)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "cuentaNew", $event.target.value)}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.dominioNew),expression:"datos.dominioNew"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.datos, "dominioNew", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoDominios),function(dominio){return _c('option',{key:dominio.id,domProps:{"value":dominio.id}},[_vm._v(_vm._s(dominio.dominio))])}),0),_vm._v(" "),(_vm.alias !== 'nuevo')?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.editarOrigen = false}}},[_c('span',{staticClass:"fa fa-close mr-2"}),_vm._v("\n\t\t\t\t\t\tCancelar\n\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.cambiarOrigen}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("\n\t\t\t\t\t\tActualizar\n\t\t\t\t\t")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.alias !== 'nuevo')?_c('div',{staticClass:"text-right mt-3"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("\n\t\t\t\t\tEliminar alias por completo\n\t\t\t\t")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[(_vm.alias !== 'nuevo')?_c('h4',[_vm._v("Destinos")]):_vm._e(),_vm._v(" "),(_vm.alias === 'nuevo')?_c('h4',[_vm._v("Destino")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[(!_vm.nuevo)?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.nuevoDestino}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n\t\t\t\t\tNuevo\n\t\t\t\t")]):_vm._e()])]),_vm._v(" "),(_vm.nuevo)?_c('div',{staticClass:"input-group input-group-sm mt-2 mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nuevo.cuenta),expression:"nuevo.cuenta"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"cuenta"},domProps:{"value":(_vm.nuevo.cuenta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.nuevo, "cuenta", $event.target.value)}}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.nuevo.dominio_destino),expression:"nuevo.dominio_destino"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.nuevo, "dominio_destino", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoDominios),function(dominio){return _c('option',{key:dominio.id,domProps:{"value":dominio.id}},[_vm._v(_vm._s(dominio.dominio))])}),0),_vm._v(" "),(_vm.alias !== 'nuevo')?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.addDestino}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("\n\t\t\t\t\tGuardar\n\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.nuevo = null}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((_vm.cuentas),function(cuenta){return _c('div',{key:cuenta.email,staticClass:"input-group input-group-sm mb-2"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":"true"},domProps:{"value":cuenta.destino}}),_vm._v(" "),_vm._m(3,true),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(cuenta.dominio_destino),expression:"cuenta.dominio_destino"}],staticClass:"form-control",attrs:{"name":"","id":"","disabled":"true"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(cuenta, "dominio_destino", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoDominios),function(dominio){return _c('option',{key:dominio.id,domProps:{"value":dominio.id}},[_vm._v(_vm._s(dominio.dominio))])}),0),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.eliminarDestino(cuenta)}}},[_c('span',{staticClass:"fa fa-trash"})])])])})],2),_vm._v(" "),(_vm.alias === 'nuevo')?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.crear}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("\n\t\t\tCrear alias\n\t\t")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("@")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("@")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("@")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("@")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Listado")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"m-0 table table-condensed table-striped"},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"3"}},[_c('button',{staticClass:"btn btn-sm",class:(_vm.tipo === 'cuentas') ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setTipo('cuentas')}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tCuentas\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.tipo === 'alias') ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setTipo('alias')}}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tAlias\n\t\t\t\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"3"}},[(_vm.tipo === 'cuentas')?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.nuevaCuenta}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tNueva cuenta\n\t\t\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.tipo === 'alias')?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.nuevoAlias}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tNuevo alias\n\t\t\t\t\t\t\t\t\t")]):_vm._e()])])]),_vm._v(" "),(_vm.tipo === 'cuentas')?_c('tbody',_vm._l((_vm.listadoCuentas),function(cuenta){return _c('tr',{key:cuenta.cuenta+cuenta.dominio_id},[_vm._m(0,true),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(cuenta.email)+"\n\t\t\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),(cuenta.usuario)?_c('span',{staticStyle:{"opacity":"0.6"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tAsignada a "),_c('b',[_vm._v(_vm._s(cuenta.usuario.nombre)+" "+_vm._s(cuenta.usuario.apellidos))])]):_vm._e(),_vm._v(" "),(!cuenta.usuario)?_c('span',{staticStyle:{"opacity":"0.6"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tNo asignada a nadie\n\t\t\t\t\t\t\t\t\t")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"vertical-align":"middle"}},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.editarCuenta(cuenta.id)}}},[_c('span',{staticClass:"fa fa-edit"})])])])}),0):_vm._e(),_vm._v(" "),(_vm.tipo === 'alias')?_c('tbody',_vm._l((_vm.listadoAlias),function(alias){return _c('tr',{key:alias.aliasOrigen},[_vm._m(1,true),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(alias.aliasOrigen)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"vertical-align":"middle"}},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.editarAlias(alias)}}},[_c('span',{staticClass:"fa fa-edit"})])])])}),0):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[(_vm.cuenta)?_c('editor-cuenta',{attrs:{"id-cuenta":_vm.cuenta},on:{"update":function($event){return _vm.getCuentas()}}}):_vm._e(),_vm._v(" "),(_vm.editandoAlias)?_c('editor-alias',{attrs:{"alias":_vm.editandoAlias},on:{"update:alias":function($event){_vm.editandoAlias=$event},"update":function($event){return _vm.getAlias()}}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"vertical-align":"middle","width":"30px","text-align":"center"}},[_c('span',{staticClass:"fa fa-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"vertical-align":"middle","width":"30px","text-align":"center"}},[_c('span',{staticClass:"fa fa-reply-all"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(1176);


/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('gestion-egm', {
			name: 'Gestión de EGM',
			component: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */]
		});
	}
});

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(503);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e035ca7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(1181);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e035ca7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestion_ediciones_vue__ = __webpack_require__(504);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a096d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_gestion_ediciones_vue__ = __webpack_require__(1180);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestion_ediciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08a096d7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_gestion_ediciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nueva_emisora_vue__ = __webpack_require__(505);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03de5c99_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nueva_emisora_vue__ = __webpack_require__(1179);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nueva_emisora_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03de5c99_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nueva_emisora_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.emisora)?_c('modal',{attrs:{"max-width":"400"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editar emisora"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emisora.nombre),expression:"emisora.nombre"}],staticClass:"form-control",attrs:{"placeholder":"Escribe el nomre"},domProps:{"value":(_vm.emisora.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.emisora, "nombre", $event.target.value)}}})])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v("Ediciones de EGM"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{staticClass:"card-body bg-light"},[_c('h4',[_c('b',[_vm._v("Dimensión de los datos")])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_c('b',[_vm._v("Selecciona edición")])]),_c('datepicker',{attrs:{"minimum-view":"month","language":_vm.$dateLang,"bootstrap-styling":true,"format":"MMMM, yyyy","disabled-dates":_vm.ignoraFechas},on:{"closed":_vm.setEdicion},model:{value:(_vm.edicion.fecha),callback:function ($$v) {_vm.$set(_vm.edicion, "fecha", $$v)},expression:"edicion.fecha"}})],1)]),(_vm.edicion.fecha)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_c('b',[_vm._v("Selecciona la emisora")])]),(!_vm.edicion.emisora_ID)?_c('div',{staticClass:"input-group"},[_c('input-query',{attrs:{"url":"gestion-egm/php/api/query-emisoras.php","realtime":true,"input-class":"form-control"},on:{"selected":function($event){return _vm.seleccionaEmisora($event)}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.idEmisora = 'nueva'}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nueva")])])],1):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"true"},domProps:{"value":_vm.edicion.emisoraInfo.nombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.edicion.emisora_ID = null}}},[_c('span',{staticClass:"fa fa-trash"})])])])])]):_vm._e()])]),(_vm.edicion.emisora_ID)?_c('div',{staticClass:"card-body bg-light"},[_c('h4',[_c('b',[_vm._v("Audiencia total (en miles)")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.edicion.oyentes),expression:"edicion.oyentes"}],staticClass:"form-control",domProps:{"value":(_vm.edicion.oyentes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.edicion, "oyentes", $event.target.value)}}})]):_vm._e(),(_vm.edicion.emisora_ID)?_c('div',{staticClass:"card-body"},[_c('h4',[_c('b',[_vm._v("Audiencia por horas (en miles)")])]),_c('div',{staticClass:"row"},_vm._l((_vm.edicion.horas),function(h){return _c('div',{key:h.hora,staticClass:"col-xs-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 p-1"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text",staticStyle:{"width":"70px"}},[_vm._v(_vm._s(h.hora)+":00")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.edicion.horas[h.hora].oyentes),expression:"edicion.horas[h.hora].oyentes"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.edicion.horas[h.hora].oyentes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.edicion.horas[h.hora], "oyentes", $event.target.value)}}})])])}),0)]):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])]),(_vm.idEmisora)?_c('editor-emisora',{attrs:{"id-emisora":_vm.idEmisora},on:{"cerrar":function($event){_vm.idEmisora = null}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Emisoras")]),_c('input-query',{attrs:{"url":"gestion-egm/php/api/query-emisoras.php","realtime":true,"placeholder":"Añade emisoras","input-class":"form-control"},on:{"selected":function($event){return _vm.ponEmisora($event)}}}),(_vm.filtro.emisoras.length === 0)?_c('div',{staticClass:"alert alert-info mt-2"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Si no añades ninguna emisora se consultarán todas las que contengan datos")]):_vm._e()],1),(_vm.filtro.emisoras.length > 0)?_c('table',{staticClass:"table table-striped mt-2 mb-2"},[_c('tbody',_vm._l((_vm.filtro.emisoras),function(emisora){return _c('tr',{key:emisora.ID_emisora},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(emisora.nombre))]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.quitaEmisora(emisora)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)]):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[(_vm.filtro.tipo === 'general')?_c('label',{attrs:{"for":""}},[_vm._v("Fecha de inicio")]):_c('label',[_vm._v("Fecha")]),_c('datepicker',{attrs:{"monday-first":true,"language":_vm.$dateLang,"bootstrap-styling":true,"minimum-view":"month","typeable":false,"format":"MMMM, yyyy","disabled-dates":_vm.ignoraFechas},model:{value:(_vm.filtro.fechaIni),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaIni", $$v)},expression:"filtro.fechaIni"}})],1),(_vm.filtro.tipo === 'general')?_c('hr'):_vm._e(),(_vm.filtro.tipo === 'general')?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de fin")]),_c('datepicker',{attrs:{"monday-first":true,"language":_vm.$dateLang,"bootstrap-styling":true,"minimum-view":"month","typeable":false,"format":"MMMM, yyyy","disabled-dates":_vm.ignoraFechas},model:{value:(_vm.filtro.fechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaFin", $$v)},expression:"filtro.fechaFin"}})],1):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Tipo de informe")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.tipo === 'general') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.tipo = 'general'}}},[_vm._v("General")]),_c('button',{staticClass:"btn",class:(_vm.filtro.tipo === 'horario') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.tipo = 'horario'}}},[_vm._v("Horario")])]),_c('hr'),_c('label',{attrs:{"for":""}},[_vm._v("Incluír")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.incluirTablas) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.incluirTablas = !_vm.filtro.incluirTablas}}},[_vm._v("Tablas")]),_c('button',{staticClass:"btn",class:(_vm.filtro.incluirGraficas) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.incluirGraficas = !_vm.filtro.incluirGraficas}}},[_vm._v("Gráficas")])])])])])]),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.consultar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Consultar")])]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.gestionEdiciones = true}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Gestionar ediciones")])])])])]),_c('div',{staticClass:"card mt-3"},[_vm._m(1),(_vm.resultados.porHoras)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.filtro.incluirGraficas)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3"},[(_vm.resultados.porHoras)?_c('chartjs-line',{attrs:{"beginatzero":true,"label":"Audiencia por horas","labels":_vm.resultados.porHoras.labels,"datasets":_vm.resultados.porHoras.datasets}}):_vm._e()],1):_vm._e(),(_vm.filtro.incluirTablas)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Hora")]),_vm._l((_vm.resultados.porHoras.datasets),function(emisora){return _c('th',[_vm._v(_vm._s(emisora.label))])})],2)]),_c('tbody',_vm._l((_vm.resultados.porHoras.labels),function(hora,i){return _c('tr',[_c('td',[_vm._v(_vm._s(hora))]),_vm._l((_vm.resultados.porHoras.datasets),function(emi){return _c('td',[_vm._v(_vm._s(emi.data[i]))])})],2)}),0)])])]):_vm._e()])]):_vm._e(),(_vm.resultados.general)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[(_vm.filtro.incluirGraficas)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3"},[(_vm.resultados.general && _vm.resultados.general.labels.length > 1)?_c('chartjs-line',{attrs:{"beginatzero":true,"label":"Audiencia por horas","labels":_vm.resultados.general.labels,"datasets":_vm.resultados.general.datasets}}):_vm._e(),(_vm.resultados.general && _vm.resultados.general.labels.length === 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('chartjs-bar',{attrs:{"beginatzero":true,"label":"Audiencia por horas","labels":_vm.resultados.general.labels,"datasets":_vm.resultados.general.datasets}})],1),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('chartjs-pie',{attrs:{"beginatzero":true,"label":"EGM","height":200,"labels":_vm.datosQuesito.labels,"datasets":[{data: _vm.datosQuesito.data, backgroundColor: _vm.datosQuesito.options.backgroundColor}],"backgroundcolor":_vm.datosQuesito.options.backgroundColor,"datalabel":"EGM","option":_vm.datosQuesito.options}})],1)]):_vm._e()],1):_vm._e(),(_vm.filtro.incluirTablas)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Hora")]),_vm._l((_vm.resultados.general.datasets),function(emisora){return _c('th',[_vm._v(_vm._s(emisora.label))])})],2)]),_c('tbody',_vm._l((_vm.resultados.general.labels),function(hora,i){return _c('tr',[_c('td',[_vm._v(_vm._s(hora))]),_vm._l((_vm.resultados.general.datasets),function(emi){return _c('td',[_vm._v(_vm._s(emi.data[i]))])})],2)}),0)])])]):_vm._e()])]):_vm._e()]),(_vm.gestionEdiciones)?_c('gestion-ediciones',{on:{"cerrar":function($event){_vm.gestionEdiciones = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Consultas")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-light"},[_c('span',{staticClass:"fa fa-pie-chart mr-2"}),_vm._v("Resultados")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_vue__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__componentes_bloques_bloques__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__componentes_emisoras_emisoras__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__componentes_contenidos_contenidos__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__componentes_programas_programas__ = __webpack_require__(1202);







/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('gestion-emisoras', {
			name: 'Gestión de emisiones',
			component: __WEBPACK_IMPORTED_MODULE_1__index_vue__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('gestion-emisoras').child('emisoras', {
			name: 'Gestión de emisoras',
			component: __WEBPACK_IMPORTED_MODULE_3__componentes_emisoras_emisoras__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('gestion-emisoras').child('bloques', {
			name: 'Gestión de bloques',
			component: __WEBPACK_IMPORTED_MODULE_2__componentes_bloques_bloques__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('gestion-emisoras').child('contenidos', {
			name: 'Gestión de contenidos',
			component: __WEBPACK_IMPORTED_MODULE_4__componentes_contenidos_contenidos__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('gestion-emisoras').child('programas', {
			name: 'Gestión de programas',
			component: __WEBPACK_IMPORTED_MODULE_5__componentes_programas_programas__["a" /* default */]
		});
	}
});

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(506);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55337d1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1184);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55337d1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('menu-superior',{attrs:{"menu":_vm.menu}}),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bloques_vue__ = __webpack_require__(507);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686bdd5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_bloques_vue__ = __webpack_require__(1192);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bloques_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686bdd5e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_bloques_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generador_bloques_vue__ = __webpack_require__(508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c57b3bba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_generador_bloques_vue__ = __webpack_require__(1189);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_generador_bloques_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c57b3bba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_generador_bloques_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"btn-group m-2"},[_c('button',{staticClass:"btn",class:(_vm.filtroTodosDias) ? 'btn-primary' : '',on:{"click":_vm.toggleTodosDias}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:(_vm.filtroEntreSemana) ? 'btn-primary' : '',on:{"click":_vm.toggleEntreSemana}},[_vm._v("Entre semana")]),_c('button',{staticClass:"btn",class:(_vm.filtroSyV) ? 'btn-primary' : '',on:{"click":_vm.toggleFinde}},[_vm._v("Fin de semana")])]),_c('br'),_c('div',{staticClass:"btn-group m-2"},_vm._l((Array(7)),function(d,i){return _c('button',{staticClass:"btn",class:(_vm.misDias.indexOf(i) >= 0) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleDiaFiltro(i)}}},[_vm._v(_vm._s(_vm.diasSTR[i]))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"1px solid #f0f0f0","padding":"10px"}},[_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-header bg-info text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.verMenu = !_vm.verMenu}}},[_c('b',[_vm._v("Selección rápida")]),_c('button',{staticClass:"close",on:{"click":function($event){_vm.verMenu = !_vm.verMenu}}},[(!_vm.verMenu)?_c('span',{staticClass:"fa fa-caret-down"}):_vm._e(),(_vm.verMenu)?_c('span',{staticClass:"fa fa-caret-up"}):_vm._e()])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.verMenu),expression:"verMenu"}],staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Desde")]),_c('datepicker',{attrs:{"monday-first":true,"bootstrap-styling":true,"language":_vm.$dateLang},model:{value:(_vm.filtro.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.filtro, "fecha_inicio", $$v)},expression:"filtro.fecha_inicio"}})],1)]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hasta")]),_c('datepicker',{attrs:{"monday-first":true,"bootstrap-styling":true,"language":_vm.$dateLang},model:{value:(_vm.filtro.fecha_fin),callback:function ($$v) {_vm.$set(_vm.filtro, "fecha_fin", $$v)},expression:"filtro.fecha_fin"}})],1)])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('select-dias',{attrs:{"dias":_vm.filtro.dias_semana},on:{"update:dias":function($event){return _vm.$set(_vm.filtro, "dias_semana", $event)}}})],1),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Excluír festivos")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.excluir.indexOf('local') < 0) ? '' : 'btn-primary',on:{"click":function($event){return _vm.toggleExcluir('local')}}},[_vm._v("Locales")]),_c('button',{staticClass:"btn",class:(_vm.filtro.excluir.indexOf('comunidad') < 0) ? '' : 'btn-primary',on:{"click":function($event){return _vm.toggleExcluir('comunidad')}}},[_vm._v("Regionales")]),_c('button',{staticClass:"btn",class:(_vm.filtro.excluir.indexOf('nacional') < 0) ? '' : 'btn-primary',on:{"click":function($event){return _vm.toggleExcluir('nacional')}}},[_vm._v("Nacionales")])])])])])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.verMenu),expression:"verMenu"}],staticClass:"card-footer"},[_c('button',{staticClass:"m-1 btn btn-warning",on:{"click":_vm.seleccionar}},[_c('span',{staticClass:"fa fa-check"}),_vm._v("Seleccionar")]),_c('button',{staticClass:"m-1 btn btn-danger",on:{"click":_vm.quitar}},[_c('span',{staticClass:"fa fa-trash"}),_vm._v("Quitar")])])]),_c('div',{staticClass:"text-center p-3"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.setAno(_vm.anoActual - 1)}}},[_c('span',{staticClass:"fa fa-caret-left"})])]),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v(_vm._s(_vm.anoActual))])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.setAno(_vm.anoActual + 1)}}},[_c('span',{staticClass:"fa fa-caret-right"})])])])]),_c('div',{staticClass:"row"},_vm._l((_vm.listadoMeses),function(mes){return _c('div',{key:mes.nombre,staticClass:"col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"},[_c('table',{staticClass:"table table-condensed table-bordered"},[_c('thead',[_c('tr',{staticClass:"bg-dark text-white"},[_c('th',{staticStyle:{"text-align":"ceneter"},attrs:{"colspan":"7"}},[_vm._v(_vm._s(mes.nombre))])]),_c('tr',_vm._l((Array(7)),function(d,i){return _c('th',{key:mes.nombre + ' - ' + i,staticStyle:{"padding":"1px","text-align":"center"}},[_vm._v(_vm._s(_vm.semana[i]))])}),0),_vm._l((mes.semanas),function(semana){return _c('tr',_vm._l((semana),function(dia){return _c('td',{key:dia.fecha.getTime(),class:(_vm.miSeleccion.indexOf(dia.fecha.getTime()) >= 0) ? 'bg-warning' : '',staticStyle:{"text-align":"center","padding":"1px"},style:((dia.activo) ? {cursor: 'pointer'} : {}),on:{"click":function($event){return _vm.toggleDia(dia)}}},[(dia.activo)?_c('span',[_vm._v(_vm._s(dia.fecha.getDate()))]):_vm._e(),(!dia.activo)?_c('span',{staticStyle:{"opacity":"0.3"}},[_vm._v(_vm._s(dia.fecha.getDate()))]):_vm._e()])}),0)})],2)])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bloque)?_c('modal',{attrs:{"max-width":1600}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Editor de bloques"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Emisora")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.bloque.emisora_ID),expression:"bloque.emisora_ID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.bloque, "emisora_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona emisora")]),_vm._l((_vm.listadoEmisoras),function(emisora){return _c('option',{key:emisora.ID_emisora,domProps:{"value":emisora.ID_emisora}},[_vm._v(_vm._s(emisora.nombre))])})],2)]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_vm._v("Bloques"),_c('button',{staticClass:"pull-right btn btn-sm btn-warning",on:{"click":_vm.nuevaHora}},[_c('span',{staticClass:"fa fa-plus"})])]),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped m-0"},[(_vm.bloque.horas.length > 0)?_c('thead',[_c('tr',[_c('th',[_vm._v("Hora ini")]),_c('th',[_vm._v("Hora fin")]),_c('th',[_vm._v("Bloque")]),_c('th',[_vm._v("Disparo")]),_c('th',[_vm._v("Ventana")]),_c('th',[_vm._v("Max. ins")]),_c('th')])]):_vm._e(),_c('tbody',_vm._l((_vm.bloque.horas),function(hora,i){return _c('tr',{key:hora.id},[_c('td',[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"},{name:"model",rawName:"v-model",value:(_vm.bloque.horas[i].hora_inicio),expression:"bloque.horas[i].hora_inicio"}],staticClass:"form-control",attrs:{"placeholder":"HH:MM:SS"},domProps:{"value":(_vm.bloque.horas[i].hora_inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bloque.horas[i], "hora_inicio", $event.target.value)}}})]),_c('td',[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"},{name:"model",rawName:"v-model",value:(_vm.bloque.horas[i].hora_fin),expression:"bloque.horas[i].hora_fin"}],staticClass:"form-control",attrs:{"placeholder":"HH:MM:SS"},domProps:{"value":(_vm.bloque.horas[i].hora_fin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bloque.horas[i], "hora_fin", $event.target.value)}}})]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(hora.tipo_bloque),expression:"hora.tipo_bloque"}],staticClass:"form-control",attrs:{"title":"Tipo de bloque"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(hora, "tipo_bloque", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Tipo de bloque")]),_c('option',{attrs:{"value":"automatico"}},[_vm._v("Automático")]),_c('option',{attrs:{"value":"manual"}},[_vm._v("Manual")])])]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(hora.tipo_disparo),expression:"hora.tipo_disparo"}],staticClass:"form-control",attrs:{"title":"Tipo de bloque"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(hora, "tipo_disparo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Tipo de disparo")]),_c('option',{attrs:{"value":"horario"}},[_vm._v("Horario")]),_c('option',{attrs:{"value":"contacto"}},[_vm._v("Contacto impulsos")]),_c('option',{attrs:{"value":"manual"}},[_vm._v("Manual")])])]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(hora.ventana),expression:"hora.ventana",modifiers:{"number":true}},{name:"mask",rawName:"v-mask",value:('##'),expression:"'##'"}],staticClass:"form-control",attrs:{"placeholder":"15"},domProps:{"value":(hora.ventana)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(hora, "ventana", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(hora.max_inserciones),expression:"hora.max_inserciones",modifiers:{"number":true}},{name:"mask",rawName:"v-mask",value:('##'),expression:"'##'"}],staticClass:"form-control",attrs:{"placeholder":"Ilimitado"},domProps:{"value":(hora.max_inserciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(hora, "max_inserciones", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.quitaHora(hora.id)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0),(_vm.bloque.horas.length === 0)?_c('tbody',[_c('tr',{staticClass:"bg-white"},[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[(_vm.bloque.horas.length === 0)?_c('div',{staticClass:"alert alert-warning text-center"},[_vm._v("No hay horas añadidas, pulsa el botón para crearlas")]):_vm._e()])])]):_vm._e()])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('calendario-anual',{attrs:{"seleccion":_vm.bloque.dias,"from":_vm.fechaCertificada},on:{"update:seleccion":function($event){return _vm.$set(_vm.bloque, "dias", $event)}}})],1)])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_bloque_vue__ = __webpack_require__(511);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a0b3390_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_bloque_vue__ = __webpack_require__(1191);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_bloque_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a0b3390_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_bloque_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning text-dark"},[_c('span',{staticClass:"fa fa-braille mr-2"}),_vm._v("Bloque publicitario"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"alert alert-info"},[_vm._v("Tan solo podrás editar el intérvalo de tiempo de este bloque en este día.\nNo podrás moverlo de día, para ello deberás editar bloques en masa o generar nuevos")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Horario")]),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("De")])]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"},{name:"model",rawName:"v-model",value:(_vm.bloque.hora_inicio),expression:"bloque.hora_inicio"}],staticClass:"form-control",attrs:{"placeholder":"##:##:###"},domProps:{"value":(_vm.bloque.hora_inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bloque, "hora_inicio", $event.target.value)}}}),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("a")])]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"},{name:"model",rawName:"v-model",value:(_vm.bloque.hora_fin),expression:"bloque.hora_fin"}],staticClass:"input-group-append form-control",attrs:{"placeholder":"##:##:###"},domProps:{"value":(_vm.bloque.hora_fin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bloque, "hora_fin", $event.target.value)}}})])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Emisora")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.emisora),expression:"filtro.emisora"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "emisora", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.buscar]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoEmisoras),function(emisora){return _c('option',{key:emisora.ID_emisora,domProps:{"value":emisora.ID_emisora}},[_vm._v(_vm._s(emisora.nombre))])})],2)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Día")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"language":_vm.$dateLang,"monday-first":true,"inline":true},on:{"input":function($event){return _vm.buscar()}},model:{value:(_vm.filtro.dia),callback:function ($$v) {_vm.$set(_vm.filtro, "dia", $$v)},expression:"filtro.dia"}})],1)]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-warning m-1",on:{"click":_vm.nuevoBloque}},[_c('span',{staticClass:"fa fa-gear mr-2"}),_vm._v("Generar")]),_c('button',{staticClass:"btn btn-danger m-1",on:{"click":_vm.nuevoBloque}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")]),(_vm.filtro.emisora && _vm.filtro.dia)?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.clonar}},[_c('span',{staticClass:"fa fa-sitemap mr-2"}),_vm._v("Clonar")]):_vm._e()])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8"},[_c('div',{staticClass:"card"},[_vm._m(1),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped m-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.listadoBloques),function(bloque){return _c('tr',{key:bloque.ID_bloque},[_c('td',{staticClass:"p-0 pl-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(bloque.emisoraNombre))]),_c('td',{staticClass:"p-0",staticStyle:{"vertical-align":"middle"}},[_c('span',[_vm._v(_vm._s(_vm._f("moment")(bloque.diaUnix,'DD-MM-YYYY')))])]),_c('td',{staticClass:"p-0",staticStyle:{"vertical-align":"middle"}},[_c('span',[_vm._v(_vm._s(bloque.hora_inicio))]),_c('br'),_c('span',[_vm._v(_vm._s(bloque.hora_fin))])]),_c('td',{staticClass:"p-0",staticStyle:{"vertical-align":"middle"}},[_c('span',[_vm._v(_vm._s(bloque.duracion))])]),_c('td',{staticClass:"p-0",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(bloque.nombre))]),_c('td',{staticClass:"p-0",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(bloque.programaNombre))]),_c('td',{staticClass:"p-0 text-right pr-1",staticStyle:{"vertical-align":"middle"}},[_c('button',{staticClass:"mr-1 btn btn-primary",on:{"click":function($event){return _vm.editar(bloque)}}},[_c('span',{staticClass:"fa fa-edit"})]),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.eliminar(bloque)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])]),(_vm.listadoBloques.length === 0)?_c('div',{staticClass:"card-body text-center p-4"},[_vm._m(3)]):_vm._e()])])]),(_vm.generarBloques)?_c('generador-bloques',{attrs:{"plantilla":_vm.plantillaDia},on:{"cerrar":function($event){_vm.generarBloques = null}}}):_vm._e(),(_vm.editarBloque)?_c('editor-bloque',{attrs:{"bloque":_vm.editarBloque},on:{"cerrar":function($event){_vm.editarBloque = null},"guardado":_vm.buscar}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Búsqueda de bloques")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Emisora")]),_c('th',[_vm._v("Día")]),_c('th',[_vm._v("Horas")]),_c('th',[_vm._v("Duración")]),_c('th',[_vm._v("Nombre")]),_c('th',[_vm._v("Programa")]),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"text-danger"},[_c('span',{staticClass:"fa fa-info-circle",staticStyle:{"font-size":"2em"}}),_c('br'),_vm._v("No hay bloques con este criterio")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emisoras_vue__ = __webpack_require__(512);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4b23f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_emisoras_vue__ = __webpack_require__(1196);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emisoras_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab4b23f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_emisoras_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agrega_buzon_vue__ = __webpack_require__(513);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f4bcca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_agrega_buzon_vue__ = __webpack_require__(1195);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agrega_buzon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43f4bcca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_agrega_buzon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-cube mr-2"}),_vm._v("Agregar buzón"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"alert alert-warning"},[_c('b',[_vm._v("Agregar un buzón")]),_c('p',[_vm._v("Para agregar este buzón es necesario que especifiques el tipo de contenido que hay en él")])]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo_ID),expression:"tipo_ID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipo_ID=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona un tipo de contenido")]),_vm._l((_vm.listadoTipos),function(tipo){return _c('option',{key:tipo.ID_tipo,domProps:{"value":tipo.ID_tipo}},[_vm._v(_vm._s(tipo.nombre))])})],2)]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.asignar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Asignar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":_vm.nuevaEmisora}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nueva")])])])]),_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.listadoEmisoras),function(emisora){return _c('tr',{key:emisora.ID_emisora,class:(emisora.activa) ? '' : 'text-danger',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.editarEmisora(emisora)}}},[_vm._m(1,true),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(emisora.nombre))]),_c('td',{staticClass:"text-right"},[(!emisora.activa)?_c('div',{staticClass:"badge badge-danger"},[_vm._v("Inactiva")]):_vm._e()])])}),0)]),(_vm.listadoEmisoras.length === 0)?_c('div',{staticClass:"card-body text-center"},[_vm._m(2)]):_vm._e()])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8"},[(_vm.emisora)?_c('div',{staticClass:"card"},[_vm._m(3),_c('div',{staticClass:"card-body"},[_vm._m(4),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 text-center",on:{"mouseover":function($event){_vm.verBtnLogotipo = true},"mouseout":function($event){_vm.verBtnLogotipo = false}}},[(!_vm.emisora.logotipo)?_c('img',{staticStyle:{"width":"110px","height":"110px","margin":"10px","opacity":"0.5"},attrs:{"src":__webpack_require__(1197)}}):_vm._e(),(_vm.emisora.logotipo)?_c('img',{staticStyle:{"width":"100%","height":"auto","margin":"10px"},attrs:{"src":_vm.emisora.logotipo}}):_vm._e(),_c('br'),(_vm.emisora.ID_emisora)?_c('button',{staticClass:"btn btn-warning",on:{"click":_vm.subirLogotipo}},[_c('span',{staticClass:"fa fa-upload mr-2"}),_vm._v("Actualizar logotipo")]):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre de la emisora")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emisora.nombre),expression:"emisora.nombre"}],staticClass:"form-control",domProps:{"value":(_vm.emisora.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.emisora, "nombre", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("ID XFrame")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.emisora.xframe_ID),expression:"emisora.xframe_ID",modifiers:{"number":true}}],staticClass:"form-control",domProps:{"value":(_vm.emisora.xframe_ID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.emisora, "xframe_ID", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descripción")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.emisora.descripcion),expression:"emisora.descripcion"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.emisora.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.emisora, "descripcion", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.emisora.activa) ? 'btn-success' : '',on:{"click":function($event){_vm.emisora.activa = !_vm.emisora.activa}}},[_vm._v("Activa")]),_c('button',{staticClass:"btn",class:(!_vm.emisora.activa) ? 'btn-danger' : '',on:{"click":function($event){_vm.emisora.activa = !_vm.emisora.activa}}},[_vm._v("Inactiva")])])])])])]),_c('div',{staticClass:"card-body bg-light"},[_vm._m(5),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_vm._m(6),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"input-group"},[_vm._m(7),_c('input-query',{attrs:{"input-class":"form-control","placeholder":"Busca un buzón para asociarlo","realtime":false,"url":"gestion-emisoras/php/api/emisoras/query-buzones.php"},on:{"selected":_vm.seleccionaBuzon}})],1)])])]),_vm._m(8)])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardarEmisora}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])]):_vm._e(),(_vm.relleno)?_c('agregar-buzon',{attrs:{"id-relleno":"relleno.ID_relleno","id-buzon":"relleno.BuzonID","nombre-buzon":"relleno.nombre_buzon"},on:{"cerrar":function($event){_vm.relleno = null}}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-podcast mr-2"}),_vm._v("Emisoras")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"width":"40px","text-align":"center"}},[_c('span',{staticClass:"fa fa-podcast"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"text-danger"},[_c('span',{staticClass:"fa fa-info-circle"}),_c('br'),_vm._v("No hay emisoras")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editor de emisoras")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Información de identificación")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('span',{staticClass:"fa fa-braille mr-2"}),_vm._v("Parámetros de programación")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-white"},[_c('b',[_vm._v("Buzones asociados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-white"},[_c('b',[_vm._v("Prioridad de colocación")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNTAgNTAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUwIDUwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Y2lyY2xlIHN0eWxlPSJmaWxsOiNFRDhBMTk7IiBjeD0iMjUiIGN5PSIyNSIgcj0iMjUiLz4NCjxsaW5lIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwOyIgeDE9IjM4IiB5MT0iMjUiIHgyPSIxMiIgeTI9IjI1Ii8+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenidos_vue__ = __webpack_require__(514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4846aa58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenidos_vue__ = __webpack_require__(1201);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenidos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4846aa58_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenidos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_contenidos_vue__ = __webpack_require__(515);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8eba1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_contenidos_vue__ = __webpack_require__(1200);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_contenidos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8eba1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_contenidos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editor de contenidos"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Emisora")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contenido.emisora_ID),expression:"contenido.emisora_ID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contenido, "emisora_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Genérico")]),_vm._l((_vm.listadoEmisoras),function(emisora){return _c('option',{key:emisora.ID_emisora,domProps:{"value":emisora.ID_emisora}},[_vm._v(_vm._s(emisora.nombre))])})],2)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contenido.nombre),expression:"contenido.nombre"}],staticClass:"form-control",domProps:{"value":(_vm.contenido.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contenido, "nombre", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Horario")]),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("De")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contenido.hora_inicio),expression:"contenido.hora_inicio"},{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"}],staticClass:"form-control",attrs:{"placeholder":"HH:MM:SS"},domProps:{"value":(_vm.contenido.hora_inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contenido, "hora_inicio", $event.target.value)}}}),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("a")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contenido.hora_fin),expression:"contenido.hora_fin"},{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"}],staticClass:"form-control input-group-append",attrs:{"placeholder":"HH:MM:SS"},domProps:{"value":(_vm.contenido.hora_fin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contenido, "hora_fin", $event.target.value)}}})])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Días de la semana")]),_c('br'),_c('div',{staticClass:"btn-group"},_vm._l((Array(7)),function(d,i){return _c('button',{staticClass:"btn",class:(_vm.contenido.dias_semana.indexOf(i) < 0) ? '' : 'btn-primary',on:{"click":function($event){return _vm.toggleDia(i)}}},[_vm._v(_vm._s(_vm.dias[i]))])}),0)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.contenido.activo) ? 'btn-success' : '',on:{"click":function($event){_vm.contenido.activo = true}}},[_vm._v("Activo")]),_c('button',{staticClass:"btn",class:(!_vm.contenido.activo) ? 'btn-danger' : '',on:{"click":function($event){_vm.contenido.activo = false}}},[_vm._v("Inactivo")])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Emisora")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.emisora_ID),expression:"filtro.emisora_ID"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "emisora_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.buscar]}},[_c('option',{domProps:{"value":null}},[_vm._v("Genéricos")]),_vm._l((_vm.listadoEmisoras),function(emisora){return _c('option',{key:emisora.ID_emisora,domProps:{"value":emisora.ID_emisora}},[_vm._v(_vm._s(emisora.nombre))])})],2)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.nombre),expression:"filtro.nombre"}],staticClass:"form-control",domProps:{"value":(_vm.filtro.nombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "nombre", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.activo === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.filtraEstado(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:(_vm.filtro.activo === true) ? 'btn-success' : '',on:{"click":function($event){return _vm.filtraEstado(true)}}},[_vm._v("Activos")]),_c('button',{staticClass:"btn",class:(_vm.filtro.activo === false) ? 'btn-danger' : '',on:{"click":function($event){return _vm.filtraEstado(false)}}},[_vm._v("Inactivos")])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.nuevo}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nuevo")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-8 col-lg-9 col-xl-9"},[_c('div',{staticClass:"card"},[_vm._m(1),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped m-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.listadoContenidos),function(c){return _c('tr',{key:c.ID_contenido},[_c('td',{staticClass:"p-1 pl-3",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(c.nombre))]),_c('td',{staticClass:"p-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(c.hora_inicio)+" - "+_vm._s(c.hora_fin))]),_c('td',{staticClass:"p-1",staticStyle:{"vertical-align":"middle"}},_vm._l((c.dias_semana),function(d){return _c('span',{staticClass:"m-1"},[_vm._v(_vm._s(_vm.dias[d]))])}),0),_c('td',{staticClass:"p-1 pr-3 text-right",staticStyle:{"vertical-align":"middle"}},[_c('button',{staticClass:"btn btn-primary m-1",on:{"click":function($event){_vm.ID_contenido = c.ID_contenido}}},[_c('span',{staticClass:"fa fa-edit"})]),_c('button',{staticClass:"btn btn-danger m-1",on:{"click":function($event){return _vm.del(c.ID_contenido)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0),(_vm.listadoContenidos.length === 0)?_c('tbody',[_vm._m(3)]):_vm._e()])])])])]),(_vm.ID_contenido)?_c('editor-contenidos',{attrs:{"id-contenido":_vm.ID_contenido},on:{"cerrar":_vm.cierraEditor}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-cubes mr-2"}),_vm._v("Contenidos")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Listado de contenidos")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Nombre")]),_c('th',[_vm._v("Horas")]),_c('th',[_vm._v("Días de la semana")]),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-danger p-4 text-center",attrs:{"colspan":"4"}},[_c('span',{staticClass:"fa fa-info-circle m-3",staticStyle:{"font-size":"3em"}}),_c('br'),_c('h3',[_vm._v("No hay contenidos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programas_vue__ = __webpack_require__(516);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f937b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_programas_vue__ = __webpack_require__(1207);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13f937b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_programas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_programas_vue__ = __webpack_require__(517);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43700018_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_programas_vue__ = __webpack_require__(1206);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_programas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43700018_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_programas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selecciona_estrategia_vue__ = __webpack_require__(518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2700e21e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_selecciona_estrategia_vue__ = __webpack_require__(1205);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selecciona_estrategia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2700e21e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_selecciona_estrategia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_c('span',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("Programas en conflicto")]),_c('div',{staticClass:"card-body bg-light"},[_c('p',[_vm._v(" Se han detectado programas en conflicto. Esto quiere decir que hay programas que coinciden en día y hora con los que \nestás tratando de crear.")]),_c('p',[_vm._v("Debes definir una "),_c('b',[_vm._v("estrategia a seguir")])])]),_c('div',{staticClass:"card-body",style:((_vm.estrategia === 'sobreescribir') ? {} : {opacity:0.6})},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Sobreescribir")])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(_vm.estrategia === 'sobreescribir') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstrategia('sobreescribir')}}},[_c('span',{staticClass:"fa fa-check"})])])]),_c('p',[_vm._v("La estrategia de "),_c('b',[_vm._v("sobreescribir")]),_vm._v(" eliminará los programas en conflicto en los días seleccionados."),_c('br'),_vm._v("Como consecuencia los bloques programados dentro de esas horas quedarán \"huérfanos\" temporalmente \nhasta que crees un programa que los agrupe en ese horario")])]),_c('div',{staticClass:"card-body",style:((_vm.estrategia === 'saltar') ? {} : {opacity:0.6})},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Saltar")])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(_vm.estrategia === 'saltar') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstrategia('saltar')}}},[_c('span',{staticClass:"fa fa-check"})])])]),_c('p',[_vm._v("La estrategia de "),_c('b',[_vm._v("saltar")]),_vm._v(" no tocará los programas que coincidan."),_c('br'),_vm._v("Como consecuencia de esto no se crearán los nuevos programas en los días que coincidan.")])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"mr-2 btn btn-primary",on:{"click":_vm.continuar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Continuar")]),_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.cancelar}},[_c('span',{staticClass:"fa fa-ban mr-2"}),_vm._v("Cancelar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":1024}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editor de programas"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Emisora")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.programa.emisora_ID),expression:"programa.emisora_ID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.programa, "emisora_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoEmisoras),function(emisora){return _c('option',{key:emisora.ID_emisora,domProps:{"value":emisora.ID_emisora}},[_vm._v(_vm._s(emisora.nombre))])})],2)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.programa.nombre),expression:"programa.nombre"}],staticClass:"form-control",domProps:{"value":(_vm.programa.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.programa, "nombre", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Intérvalo")]),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("De")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.programa.hora_inicio),expression:"programa.hora_inicio"},{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"}],staticClass:"form-control",attrs:{"placeholder":"HH:MM:SS"},domProps:{"value":(_vm.programa.hora_inicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.programa, "hora_inicio", $event.target.value)}}}),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("a")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.programa.hora_fin),expression:"programa.hora_fin"},{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"}],staticClass:"form-control",attrs:{"placeholder":"HH:MM:SS"},domProps:{"value":(_vm.programa.hora_fin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.programa, "hora_fin", $event.target.value)}}})])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9"},[_c('calendario-anual',{attrs:{"seleccion":_vm.programa.dias,"ano":_vm.ano,"from":new Date()},on:{"update:seleccion":function($event){return _vm.$set(_vm.programa, "dias", $event)}}})],1)])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])]),(_vm.seleccionarEstrategia)?_c('selecciona-estrategia',{attrs:{"estrategia":_vm.programa.estrategia},on:{"update:estrategia":function($event){return _vm.$set(_vm.programa, "estrategia", $event)},"cerrar":function($event){_vm.seleccionarEstrategia = null},"continuar":_vm.guardar}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Emisora")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.emisora_ID),expression:"filtro.emisora_ID"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "emisora_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.buscar]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoEmisoras),function(emisora){return _c('option',{key:emisora.ID_emisora,domProps:{"value":emisora.ID_emisora}},[_vm._v(_vm._s(emisora.nombre))])})],2)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Día")]),_c('datepicker',{attrs:{"inline":true,"language":_vm.$dateLang,"monday-first":true},on:{"input":_vm.buscar},model:{value:(_vm.filtro.dia),callback:function ($$v) {_vm.$set(_vm.filtro, "dia", $$v)},expression:"filtro.dia"}})],1)]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary m-1",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-warning m-1",on:{"click":_vm.nuevo}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nuevo")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9"},[_c('div',{staticClass:"card"},[_vm._m(1),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped mb-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.listadoProgramas),function(programa){return _c('tr',{key:programa.ID_programa},[_c('td',{staticClass:"p-1 pl-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(programa.ID_programa))]),_c('td',{staticClass:"p-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(programa.emisoraNombre))]),_c('td',{staticClass:"p-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(programa.dia))]),_c('td',{staticClass:"p-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(programa.hora_inicio))]),_c('td',{staticClass:"p-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(programa.hora_fin))]),_c('td',{staticClass:"p-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(programa.nombre))]),_c('td',{staticClass:"p-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(programa.bloques)+" bloques")]),_c('td',{staticClass:"p-1",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(programa.lineas)+" cuñas")])])}),0)])])])])]),(_vm.ID_programa)?_c('editor-programas',{attrs:{"id-programa":":ID_programa"},on:{"cerrar":function($event){_vm.ID_programa = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscador de programas")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Emisora")]),_c('th',[_vm._v("Día")]),_c('th',[_vm._v("Hora inicio")]),_c('th',[_vm._v("Hora fin")]),_c('th',[_vm._v("Nombre")]),_c('th',[_vm._v("Bloques")]),_c('th',[_vm._v("Inserciones")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(1209);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('grupos-usuario', {
			name: 'Gestión de grupos de usuario',
			component: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */]
		});
	}
});

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26c23944_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(1211);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26c23944_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var uri = 'gestion-grupos/php/';

var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(uri + url);
};

var post = function post(url, datos) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(uri + url, datos);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getListado: function getListado() {
		return get('listado-grupos.php');
	},
	getGrupo: function getGrupo(idGrupo) {
		return get('get-grupo.php?ID_grupo=' + idGrupo);
	},
	setGrupo: function setGrupo(datos) {
		var form = _.clone(datos);
		form.usuarios = [];
		for (var i = 0; i < datos.usuarios.length; i++) {
			form.usuarios.push(datos.usuarios[i].ID);
		}
		return post('set-grupo.php', form);
	},
	delGrupo: function delGrupo(idGrupo) {
		var datos = {
			ID_grupo: idGrupo
		};
		return post('del-grupo.php', datos);
	}
});

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.nuevo()}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tNuevo\n\t\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.listadoGrupos),function(grupo){return _c('tr',{key:grupo.ID_grupo},[_vm._m(1,true),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getGrupo(grupo.ID_grupo)}}},[_vm._v(_vm._s(grupo.nombre))]),_vm._v(" "),_c('td',{staticStyle:{"width":"40px","text-align":"center"}},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.eliminar(grupo.ID_grupo)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])])])]),_vm._v(" "),(_vm.grupo)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-warning"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_vm._v("\n\t\t\t\t\t\t\tDetalles del grupo\n\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-dark",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre del grupo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.grupo.nombre),expression:"grupo.nombre"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre del grupo"},domProps:{"value":(_vm.grupo.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.grupo, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Descripción")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.grupo.descripcion),expression:"grupo.descripcion"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":"Puedes añadir una descripción de este grupo"},domProps:{"value":(_vm.grupo.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.grupo, "descripcion", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},[_vm._m(2),_vm._v(" "),_c('input-query',{attrs:{"placeholder":"Busca un usuario para añadirlo","url":"gestion-grupos/php/busca-usuarios.php","realtime":true,"input-class":"form-control"},on:{"selected":function($event){return _vm.addUsuario($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-condensed m-0"},[_c('tbody',_vm._l((_vm.grupo.usuarios),function(usuario,index){return _c('tr',{key:usuario.ID_usuario},[_vm._m(3,true),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(usuario.nombre)+" "+_vm._s(usuario.apellidos)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticStyle:{"width":"40px","text-align":"center"}},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.grupo.usuarios.splice(index, 1)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0),_vm._v(" "),(_vm.grupo.usuarios.length === 0)?_c('tbody',[_vm._m(4)]):_vm._e()])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-users mr-2"}),_vm._v("\n\t\t\t\t\t\t\tListado de grupos\n\t\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"width":"40px","text-align":"center"}},[_c('span',{staticClass:"fa fa-users"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('b',[_vm._v("Miembros del grupo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"width":"40px","text-align":"center"}},[_c('span',{staticClass:"fa fa-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"bg-danger text-white"},[_c('td',{staticClass:"p-3",staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"fa fa-info",staticStyle:{"font-size":"3em"}}),_vm._v(" "),_c('h5',[_c('b',[_vm._v("Este grupo no tiene miembros")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listado_listado__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usuario_usuario__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_editor__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__estadisticas_estadisticas__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__equipos_equipos__ = __webpack_require__(1230);








/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('horas-extra', {
			name: 'Gestión horaria',
			component: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('horas-extra').child('listado', {
			name: 'Listados',
			component: __WEBPACK_IMPORTED_MODULE_2__listado_listado__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('horas-extra').child('editor/:id', {
			name: 'Registrar',
			component: __WEBPACK_IMPORTED_MODULE_4__editor_editor__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('horas-extra').child('usuario/:id', {
			name: 'Mis horas',
			component: __WEBPACK_IMPORTED_MODULE_3__usuario_usuario__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('horas-extra').child('equipos', {
			name: 'Gestión de equipos',
			component: __WEBPACK_IMPORTED_MODULE_6__equipos_equipos__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('horas-extra').child('estadisticas', {
			name: 'Estadísticas',
			component: __WEBPACK_IMPORTED_MODULE_5__estadisticas_estadisticas__["a" /* default */]
		});
	}
});

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469fd610_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__(1214);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469fd610_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__ = __webpack_require__(521);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53173f7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__ = __webpack_require__(1221);
function injectStyle (ssrContext) {
  __webpack_require__(1216)
  __webpack_require__(1217)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53173f7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53173f7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalleUsuario_vue__ = __webpack_require__(522);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ab3ae8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalleUsuario_vue__ = __webpack_require__(1220);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalleUsuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41ab3ae8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalleUsuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.usuario)?_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v(_vm._s(_vm.usuario.nombre)+" "+_vm._s(_vm.usuario.apellidos)),(!_vm.card)?_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")]):_vm._e()]),_c('div',{staticClass:"card-body text-center"},[_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"200px","height":"200px"},attrs:{"src":_vm.usuario.avatar}}),_c('p'),_c('h3',[_vm._v("Acumuladas"),_c('br'),_c('b',[_vm._v(_vm._s(_vm.horas.acumula)+" horas")])]),_c('p'),_c('p'),_c('h3',[_vm._v("Consumidas"),_c('br'),_c('b',[_vm._v(_vm._s(_vm.horas.consume)+" horas")])]),_c('p')]),_c('div',{staticClass:"card-body bg-light text-center"},[(_vm.horas.resto !== 0)?_c('h3',[(_vm.horas.resto < 0)?_c('span',[_vm._v("Debe"),_c('br'),_vm._v(_vm._s(_vm.horas.resto * (-1))+" horas")]):_c('span',[_vm._v(_vm._s(_vm.horas.resto)+" horas"),_c('br'),_c('span',[_vm._v("para consumir")])])]):_c('h3',[_vm._v("Nada pendiente")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":300}},[_c('Detalle',{attrs:{"idUsuario":_vm.idUsuario},on:{"cerrar":function($event){return _vm.$emit('cerrar')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Registro de mis horas")]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Filtra por usuario")]),(!_vm.filtro.usuario_ID)?_c('input-query',{attrs:{"realtime":true,"url":"gestion-horaria/php/api/query-usuarios.php","inputClass":"form-control","placeholder":"Buscar por nombre"},on:{"selected":function($event){return _vm.seleccionarUsuario($event)}}}):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.filtro.usuarioNombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarUsuario}},[_c('span',{staticClass:"fa fa-trash"})])])])],1),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_vm._v("Filtra por palabras")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.descripcion),expression:"filtro.descripcion"}],staticClass:"form-control",domProps:{"value":(_vm.filtro.descripcion)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "descripcion", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha de inicio")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"language":_vm.$dateLang},on:{"selected":function($event){return _vm.buscar()}},model:{value:(_vm.filtro.fechaInicio),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaInicio", $$v)},expression:"filtro.fechaInicio"}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha de fin")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"language":_vm.$dateLang},on:{"selected":function($event){return _vm.buscar()}},model:{value:(_vm.filtro.fechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaFin", $$v)},expression:"filtro.fechaFin"}})],1)])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de registro")]),_c('div',[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.tipo_registro === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoRegistro(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:(_vm.filtro.tipo_registro === 'acumula') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoRegistro('acumula')}}},[_vm._v("Acumula")]),_c('button',{staticClass:"btn",class:(_vm.filtro.tipo_registro === 'consume') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoRegistro('consume')}}},[_vm._v("Consume")])])])]),_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Estado")]),_c('div',[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.estado === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:(_vm.filtro.estado === 'validado') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('validado')}}},[_vm._v("Validados")]),_c('button',{staticClass:"btn",class:(_vm.filtro.estado === 'novalidado') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('novalidado')}}},[_vm._v("Sin validar")])])])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])])]),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-2"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('table',{staticClass:"table table-striped m-0"},[_vm._m(1),_c('tbody',_vm._l((_vm.listadoEmpleados),function(empleado){return _c('tr',{key:empleado.ID},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(empleado.nombre)+" "+_vm._s(empleado.apellidos))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(empleado.horas))])])}),0)])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-8 col-lg-9 col-xl-10"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados"),(_vm.filtro.usuario_ID && _vm.num_sin_validar > 0)?_c('button',{staticClass:"btn btn-danger pull-right",on:{"click":_vm.validarTodo}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Validar Todo")]):_vm._e()])])]),_c('table',{staticClass:"table table-striped"},[_vm._m(2),_c('tbody',_vm._l((_vm.registros),function(registro){return _c('tr',{key:registro.ID_registro},[_c('td',[_vm._v(_vm._s(registro.ID_registro))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(registro.fechaUnix,'DD-MM-YYYY')))]),_c('td',{staticClass:"celdaUsuario",on:{"click":function($event){return _vm.detalleUsuario(registro.usuario_ID)}}},[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v(_vm._s(registro.usuarioNombre))])]),_c('td',{staticClass:"text-center"},[(registro.tipo_registro === 'acumula')?_c('span',[_vm._v("+"+_vm._s(registro.horasRaw))]):_vm._e()]),_c('td',{staticClass:"text-center"},[(registro.tipo_registro === 'consume')?_c('span',[_vm._v(_vm._s(registro.horasRaw))]):_vm._e()]),_c('td',[_vm._v(_vm._s(registro.descripcion))]),_c('td',[(registro.aprobado)?_c('div',[_c('div',[_vm._v(_vm._s(registro.validadorNombre))]),_c('div',{staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(registro.aprobado))])]):_c('div',[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.validar(registro)}}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Validar")])])]),_c('td',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.verRegistro(registro)}}},[_c('span',{staticClass:"fa fa-eye mr-2"}),_vm._v("Ver")])]),_c('td',[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.eliminar(registro)}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")])])])}),0)])])])]),(_vm.detalle)?_c('detalle-usuario',{attrs:{"id-usuario":_vm.detalle},on:{"cerrar":function($event){_vm.detalle = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-users mr-2"}),_vm._v("Resúmen")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Empleado")]),_c('th',[_vm._v("Horas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v("Fecha")]),_c('th',[_vm._v("Usuario")]),_c('th',[_vm._v("Acumula")]),_c('th',[_vm._v("Consume")]),_c('th',[_vm._v("Descripcion")]),_c('th',[_vm._v("Aprueba")]),_c('th',[_vm._v("Detalles")]),_c('th',[_vm._v("Eliminar")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_vue__ = __webpack_require__(525);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46908a86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_usuario_vue__ = __webpack_require__(1224);
function injectStyle (ssrContext) {
  __webpack_require__(1223)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46908a86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_usuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-2"},[(_vm.usuario)?_c('Detalle',{attrs:{"idUsuario":_vm.usuario.ID,"card":true}}):_vm._e()],1),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-8 col-lg-9 col-xl-10"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Registro de mis horas")]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Filtra por palabras")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.descripcion),expression:"filtro.descripcion"}],staticClass:"form-control",domProps:{"value":(_vm.filtro.descripcion)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "descripcion", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha de inicio")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"language":_vm.$dateLang},on:{"selected":_vm.buscar},model:{value:(_vm.filtro.fechaInicio),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaInicio", $$v)},expression:"filtro.fechaInicio"}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha de fin")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"language":_vm.$dateLang},on:{"selected":_vm.buscar},model:{value:(_vm.filtro.fechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaFin", $$v)},expression:"filtro.fechaFin"}})],1)])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de registro")]),_c('div',[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.tipo_registro === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoRegistro(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:(_vm.filtro.tipo_registro === 'acumula') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoRegistro('acumula')}}},[_vm._v("Acumula")]),_c('button',{staticClass:"btn",class:(_vm.filtro.tipo_registro === 'consume') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoRegistro('consume')}}},[_vm._v("Consume")])])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('div',[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.estado === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:(_vm.filtro.estado === 'validado') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('validado')}}},[_vm._v("Validados")]),_c('button',{staticClass:"btn",class:(_vm.filtro.estado === 'novalidado') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado('novalidado')}}},[_vm._v("Sin validar")])])])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])])]),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('div',{staticClass:"row"},[_vm._m(0),(_vm.resumen)?_c('div',{staticClass:"col text-right"},[(_vm.resumen.horas > 0)?_c('b',[_vm._v("Tienes "+_vm._s(_vm.resumen.horas)+" horas para consumir")]):_c('b',[_vm._v("Debes "+_vm._s(_vm.resumen.horas)+" horas")])]):_vm._e()])]),_c('table',{staticClass:"table table-striped"},[_vm._m(1),_c('tbody',_vm._l((_vm.registros),function(registro){return _c('tr',{key:registro.ID_registro,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verRegistro(registro)}}},[_c('td',[_vm._v(_vm._s(registro.ID_registro))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(registro.fechaUnix,'DD-MM-YYYY')))]),_c('td',{staticClass:"text-center"},[(registro.tipo_registro === 'acumula')?_c('span',[_vm._v("+"+_vm._s(registro.horasRaw))]):_vm._e()]),_c('td',{staticClass:"text-center"},[(registro.tipo_registro === 'consume')?_c('span',[_vm._v(_vm._s(registro.horasRaw))]):_vm._e()]),_c('td',[_vm._v(_vm._s(registro.descripcion))]),_c('td',[_c('div',[_vm._v(_vm._s(registro.validadorNombre))]),_c('div',{staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(registro.aprobado))])]),_c('td',[(!registro.aprobado)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){$event.stopPropagation();return _vm.eliminar(registro)}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")]):_vm._e()])])}),0)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v("Fecha")]),_c('th',[_vm._v("Acumula")]),_c('th',[_vm._v("Consume")]),_c('th',[_vm._v("Descripcion")]),_c('th',[_vm._v("Aprobado por")]),_c('th',[_vm._v("Eliminar")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(526);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c65c393_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1227);
function injectStyle (ssrContext) {
  __webpack_require__(1226)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c65c393_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[(_vm.soyLider)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Selecciona el Usuario")]),(!_vm.registro.usuario_ID)?_c('input-query',{attrs:{"input-class":"form-control","placeholder":"Buscar por nombre","url":"gestion-horaria/php/api/query-usuarios.php","realtime":true},on:{"selected":function($event){return _vm.seleccionaUsuario($event)}}}):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.registro.usuarioNombre}}),(_vm.editable)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.quitarUsuario}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()])],1):_c('div',[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.usuario.nombre + ' ' + _vm.usuario.apellidos}})])])])]),_c('div',{staticClass:"card mt-3"},[_vm._m(1),(_vm.historico.length > 0)?_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.historico),function(item){return _c('tr',{key:item.ID_registro,class:(_vm.registro.ID_registro === item.ID_registro) ? 'bg-info text-white' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$router.push('/main/horas-extra/editor/' + item.ID_registro)}}},[_c('td',[_vm._v(_vm._s(item.fecha_registro))]),_c('td',[_vm._v(_vm._s(item.autorNombre))])])}),0)]):_vm._e()])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8"},[_c('div',{staticClass:"card"},[_vm._m(2),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha del registro")]),(_vm.editable)?_c('datepicker',{attrs:{"placeholder":"Selecciona","bootstrap-styling":true,"monday-first":true,"language":_vm.$dateLang},model:{value:(_vm.registro.fecha),callback:function ($$v) {_vm.$set(_vm.registro, "fecha", $$v)},expression:"registro.fecha"}}):_vm._e(),(!_vm.editable)?_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.registro.fecha}}):_vm._e()],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nº de horas")]),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.registro.horasRaw),expression:"registro.horasRaw",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","disabled":!_vm.editable,"placeholder":"0"},domProps:{"value":(_vm.registro.horasRaw)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "horasRaw", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(_vm.registro.tipo_registro === 'consume') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo('consume')}}},[_vm._v("Consumidas")])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(_vm.registro.tipo_registro === 'acumula') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo('acumula')}}},[_vm._v("Acumuladas")])])])])])]),_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Descripción")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.descripcion),expression:"registro.descripcion"}],staticClass:"form-control",attrs:{"rows":"5","disabled":!_vm.editable,"placeholder":"Describe brevemente en qué se acumulan o consumen las horas"},domProps:{"value":(_vm.registro.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "descripcion", $event.target.value)}}})])]),_c('div',{staticClass:"card-footer"},[(!_vm.registro.aprobado || _vm.soyLider)?_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.formOk || !_vm.esUltimo},on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")]):_vm._e(),(_vm.registro.aprobado && !_vm.soyLider)?_c('button',{staticClass:"btn btn-danger",attrs:{"disabled":"disabled"}},[_vm._v("Este registro ya está aprobado, solo lo puede modificar tu jefe de equipo")]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Usuario")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Histórico de modificaciones")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Detalles")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc5722f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_estadisticas_vue__ = __webpack_require__(1229);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc5722f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_estadisticas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Estadísticas")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equipos_vue__ = __webpack_require__(527);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c423700_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_equipos_vue__ = __webpack_require__(1231);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equipos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c423700_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_equipos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-5"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-group mr-2"}),_vm._v("Equipos"),_c('button',{staticClass:"float-right btn btn-sm btn-warning",on:{"click":_vm.nuevo}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nuevo equipo")])]),_c('table',{staticClass:"table table-striped m-0"},[_vm._m(1),_c('tbody',_vm._l((_vm.listadoEquipos),function(equipo){return _c('tr',{key:equipo.ID_equipo},[_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(equipo.ID_equipo))]),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(equipo.nombre))]),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.muestraLideres(equipo.lideres)))]),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(equipo.miembros.length))]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger m-2",on:{"click":function($event){return _vm.delEquipo(equipo.ID_equipo)}}},[_c('span',{staticClass:"fa fa-trash"})]),_c('button',{staticClass:"btn btn-sm btn-primary m-2",on:{"click":function($event){return _vm.getEquipo(equipo.ID_equipo)}}},[_c('span',{staticClass:"fa fa-edit"})])])])}),0)])])]),(_vm.editando)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-group mr-2"}),_vm._v(_vm._s(_vm.equipo.nombre))]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.equipo.nombre),expression:"equipo.nombre"}],staticClass:"form-control",attrs:{"placeholder":"Escribe un nombre"},domProps:{"value":(_vm.equipo.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.equipo, "nombre", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_vm._m(3),_c('input-query',{staticClass:"form-control",attrs:{"inputClass":"form-control","placeholder":"Busca y añade miembros","url":"gestion-horaria/php/api/query-usuarios.php","realtime":true},on:{"selected":function($event){return _vm.nuevoLider($event)}}})],1),_c('table',{staticClass:"table m-0"},_vm._l((_vm.equipo.lideres),function(lider){return _c('tr',{key:lider.LiderID},[_c('td',[_vm._v(_vm._s(lider.LiderNombre))]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaLider(lider.LiderID)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"form-group"},[_vm._m(4),_c('input-query',{staticClass:"form-control",attrs:{"inputClass":"form-control","placeholder":"Busca y añade miembros","url":"gestion-horaria/php/api/query-usuarios.php","realtime":true},on:{"selected":function($event){return _vm.nuevoMiembro($event)}}})],1),_c('table',{staticClass:"table m-0"},_vm._l((_vm.equipo.miembros),function(miembro){return _c('tr',{key:miembro.UsuarioID},[_c('td',[_vm._v(_vm._s(miembro.UsuarioNombre))]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaMiembro(miembro.UsuarioID)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary m-2",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")]),_c('button',{staticClass:"btn btn-sm btn-danger m-2",on:{"click":function($event){_vm.editando = false}}},[_c('span',{staticClass:"fa fa-times mr-2"}),_vm._v("Cancelar")])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-3"},[_c('div',{staticClass:"alert alert-info"},[_c('p',[_c('b',[_vm._v("Gestión de equipos")])]),_c('p',[_vm._v("Desde aquí puedes gestionar los equipos y sus líderes. Un líder de equipo es el encargado de validar los registros horarios de sus miembros")]),_c('p',[_vm._v("Los usuarios que no pertenezcan a ningún equipo (como miembros) serán validados automáticamente")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Nombre")]),_c('th',[_vm._v("Líderes")]),_c('th',[_vm._v("Miembros")]),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Nombre del equipo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Líderes del equipo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Miembros del equipo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listados_listados__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_informes_informes__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vacaciones_visualizar__ = __webpack_require__(1256);






/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('gestion-jornada', {
			name: 'Gestión de jornada',
			component: __WEBPACK_IMPORTED_MODULE_1__main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('gestion-jornada').child('registros', {
			name: 'Listado de jornadas',
			component: __WEBPACK_IMPORTED_MODULE_2__components_listados_listados__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('gestion-jornada').child('informes', {
			name: 'Informes de jornadas',
			component: __WEBPACK_IMPORTED_MODULE_3__components_informes_informes__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('vacaciones', {
			name: 'Vacaciones',
			component: __WEBPACK_IMPORTED_MODULE_4__components_vacaciones_visualizar__["a" /* default */]
		});
	}
});

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2c73262_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1239);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2c73262_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_vm._v("Editor de registros"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Tipo de jornada")])]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.Naturaleza),expression:"registro.Naturaleza"}],staticClass:"form-control form-control-lg",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.registro, "Naturaleza", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_c('option',{attrs:{"value":"Trabajo"}},[_vm._v("Trabajo")]),_c('option',{attrs:{"value":"Libre"}},[_vm._v("Libre")]),_c('option',{attrs:{"value":"Falta"}},[_vm._v("Falta justificada")])])])]),(_vm.registro.Naturaleza === 'Libre')?_c('div',{staticClass:"card-body",staticStyle:{"background-color":"#d2f2d4"}},[_c('span',{staticClass:"fa fa-info-circle mr-2",staticStyle:{"font-size":"2em","vertical-align":"middle"}}),_vm._v("Vas a registrar una jornada de libranza. Debes tener en cuenta que la unidad mínima son las horas, por lo que no podrás registrar intérvalos que no sean horas exactas")]):(_vm.registro.Naturaleza === 'Trabajo')?_c('div',{staticClass:"card-body",staticStyle:{"background-color":"#ead3d3"}},[_c('span',{staticClass:"fa fa-info-circle mr-2",staticStyle:{"font-size":"2em","vertical-align":"middle"}}),_vm._v("Vas a registrar una jornada laboral. Debes introducir la hora de entrada y la de salida más exactas posible.")]):(_vm.registro.Naturaleza === 'Falta')?_c('div',{staticClass:"card-body",staticStyle:{"background-color":"#d3abab"}},[_c('span',{staticClass:"fa fa-info-circle mr-2",staticStyle:{"font-size":"2em","vertical-align":"middle"}}),_vm._v("Vas a registrar una falta justificada. Estas solo son válidas dentro de la jornada de trabajo habitual. En caso de tener un justificante adjúntalo")]):_vm._e(),(_vm.registro.Naturaleza)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('span',{staticClass:"fa fa-sign-in mr-2"}),_c('b',[_vm._v("Entrada")])]),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-calendar"})])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.FechaEntrada),expression:"registro.FechaEntrada"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.registro.FechaEntrada)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "FechaEntrada", $event.target.value)}}}),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-clock-o"})])]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.registro.HoraEntrada),expression:"registro.HoraEntrada"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.registro.HoraEntrada)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "HoraEntrada", $event.target.value)}}})])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('span',{staticClass:"fa fa-sign-out mr-2"}),_c('b',[_vm._v("Salida")])]),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-calendar"})])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.FechaSalida),expression:"registro.FechaSalida"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.registro.FechaSalida)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "FechaSalida", $event.target.value)}}}),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-clock-o"})])]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.registro.HoraSalida),expression:"registro.HoraSalida"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.registro.HoraSalida)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "HoraSalida", $event.target.value)}}})])])])]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Comentarios")])]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.registro.Comentarios),expression:"registro.Comentarios"}],staticClass:"form-control",attrs:{"placeholder":"Opcional"},domProps:{"value":(_vm.registro.Comentarios)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.registro, "Comentarios", $event.target.value)}}})])]):_vm._e(),(_vm.registro.Naturaleza === 'Falta')?_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('b',[_vm._v("Justificantes")]),_c('br'),_c('button',{staticClass:"btn btn-primary mt-2",on:{"click":function($event){return _vm.adjuntar()}}},[_c('span',{staticClass:"fa fa-file-o mr-2"}),_vm._v("Adjuntar justificante")])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},_vm._l((_vm.ficheros),function(f){return _c('div',{key:f.name,staticClass:"input-group input-group-sm mb-2"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text bg-dark text-white"},[_c('span',{staticClass:"fa fa-file-o"})])]),_c('input',{staticClass:"form-control",attrs:{"disabled":"true"},domProps:{"value":f.name}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaFichero(f)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])]):_vm._e(),(_vm.registro.Naturaleza)?_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])]),_c('div',{staticClass:"col text-right"},[(_vm.registro.RegistroID)?_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")]):_vm._e()])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.editor)?_c('Editor',{on:{"cerrar":function($event){_vm.editor = null}}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listados_vue__ = __webpack_require__(530);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c610bf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listados_vue__ = __webpack_require__(1251);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45c610bf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formulario_vue__ = __webpack_require__(531);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e77f598_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_formulario_vue__ = __webpack_require__(1242);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formulario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e77f598_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_formulario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Usuario")]),(!_vm.permisos.gestion_jornada_verTodos)?_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.usuario.nombre + ' ' + _vm.usuario.apellidos}}):(_vm.permisos.gestion_jornada_verTodos && !_vm.filtro.UsuarioID)?_c('input-query',{attrs:{"realtime":true,"url":"gestion-jornada/php/api/queryUsuarios.php","inputClass":"form-control form-control-sm"},on:{"selected":function($event){return _vm.seleccionaUsuario($event)}}}):_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.UsuarioNombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){_vm.filtro.UsuarioID = null}}},[_c('span',{staticClass:"fa fa-trash"})])])])],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mes")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"minimum-view":"month","format":"MMMM, yyyy","language":_vm.$dateLang},model:{value:(_vm.fecha),callback:function ($$v) {_vm.fecha=$$v},expression:"fecha"}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de jornada")]),_c('br'),_c('div',{staticClass:"btn-group"},_vm._l((_vm.TiposJornada),function(tipo){return _c('button',{key:tipo,staticClass:"btn btn-sm",class:(_vm.filtro.tipoJornada === tipo) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipo(tipo)}}},[_vm._v(_vm._s(tipo))])}),0)])]),(_vm.resultados.length > 0)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Vista")]),_c('br'),_c('div',{staticClass:"btn-group"},_vm._l((_vm.TiposVista),function(tipo){return _c('button',{key:tipo,staticClass:"btn btn-sm",class:(_vm.filtro.vista === tipo) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.vista = tipo}}},[_vm._v(_vm._s(tipo))])}),0)])]):_vm._e()])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-filter mr-2"}),_vm._v("Buscador")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__ = __webpack_require__(532);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_930be594_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__ = __webpack_require__(1247);
function injectStyle (ssrContext) {
  __webpack_require__(1244)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-930be594"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_930be594_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.registro)?_c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-info circle mr-2"}),_vm._v("Detalles del registro"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v(_vm._s(_vm.registro.UsuarioNombre))])]),_c('div',{staticClass:"col text-right"},[_c('h3',[_vm._v(_vm._s(_vm.registro.Naturaleza))])])])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"},[_c('h5',[_c('span',{staticClass:"fa fa-sign-in mr-2"}),_vm._v("Entrada")]),_c('table',{staticClass:"tabla"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"categoria"},[_vm._v("Hora inicio jornada")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.FechaInicioJornada))])]),_c('tr',[_c('td',{staticClass:"categoria",class:_vm.registro.FechaInicioJornada === _vm.registro.FechaRegistroEntrada ? '' : 'text-danger',staticStyle:{"width":"80px"}},[_vm._v("Hora en que se ficha")]),_c('td',{staticClass:"valor",class:_vm.registro.FechaInicioJornada === _vm.registro.FechaRegistroEntrada ? '' : 'text-danger'},[_vm._v(_vm._s(_vm.registro.FechaRegistroEntrada))])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Dispositivo")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.TipoRegistroEntrada))])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Ubicación")]),_c('td',{staticClass:"valor"},[(_vm.registro.IPLocalEntrada)?_c('span',[_vm._v("Trabajo")]):_c('span',[_vm._v("Externa")])])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("IP")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.IPEntrada))])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Geolocalizado")]),_c('td',{staticClass:"valor"},[(_vm.registro.LatitudEntrada && _vm.registro.LongitudEntrada)?_c('span',[_vm._v("Sí")]):_c('span',[_vm._v("No")])])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Usuario que registra")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.UsuarioRegistraEntradaNombre))])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Comentarios")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.ComentariosEntrada))])])])]),(_vm.registro.LatitudEntrada && _vm.registro.LongitudEntrada)?_c('div',{attrs:{"id":"mapaEntrada"}}):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"text-right"},[_c('h5',[_vm._v("Salida"),_c('span',{staticClass:"fa fa-sign-out ml-2"})])]),_c('table',{staticClass:"tabla"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"categoria"},[_vm._v("Hora fin jornada")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.FechaFinJornada))])]),_c('tr',[_c('td',{staticClass:"categoria",class:_vm.registro.FechaFinJornada === _vm.registro.FechaRegistroSalida ? '' : 'text-danger',staticStyle:{"width":"80px"}},[_vm._v("Hora en que se ficha")]),_c('td',{staticClass:"valor",class:_vm.registro.FechaFinJornada === _vm.registro.FechaRegistroSalida ? '' : 'text-danger'},[_vm._v(_vm._s(_vm.registro.FechaRegistroSalida))])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Dispositivo")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.TipoRegistroSalida))])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Ubicación")]),_c('td',{staticClass:"valor"},[(_vm.registro.IPLocalSalida)?_c('span',[_vm._v("Trabajo")]):_c('span',[_vm._v("Externa")])])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("IP")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.IPSalida))])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Geolocalizado")]),_c('td',{staticClass:"valor"},[(_vm.registro.LatitudSalida && _vm.registro.LongitudSalida)?_c('span',[_vm._v("Sí")]):_c('span',[_vm._v("No")])])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Usuario que registra")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.UsuarioRegistraSalidaNombre))])]),_c('tr',[_c('td',{staticClass:"categoria",staticStyle:{"width":"80px"}},[_vm._v("Comentarios")]),_c('td',{staticClass:"valor"},[_vm._v(_vm._s(_vm.registro.ComentariosSalida))])])])]),(_vm.registro.LatitudSalida && _vm.registro.LongitudSalida)?_c('div',{attrs:{"id":"mapaSalida"}}):_vm._e()])])]),_c('div',{staticClass:"card-body bg-light text-center"},[_c('h4',[_c('span',{staticClass:"fa fa-clock-o",staticStyle:{"font-size":"2em"}}),_c('br'),_vm._v("Tiempo total"),_c('br'),_c('b',[_vm._v(_vm._s(_vm._f("hora")(_vm.registro.FechaFinJornadaUnix - _vm.registro.FechaInicioJornadaUnix)))])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.resumen && _vm.resumenSemana)?_c('div',{staticClass:"row"},[(_vm.resumenSemana)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"card mt-2"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_vm._m(1),_c('b',[_vm._v("Jornada total")]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumenSemana.Jornada)))]),_c('div',{staticClass:"col text-center"},[_vm._m(2),_c('b',[_vm._v("Trabajado")]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumenSemana.Total)))]),_c('div',{staticClass:"col text-center"},[_vm._m(3),_c('b',[_vm._v("Falta justificada")]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumenSemana.Falta)))]),_c('div',{staticClass:"col text-center"},[_vm._m(4),_c('b',[(_vm.resumenSemana.SinTrabajar < 0)?_c('span',[_vm._v("Pendientes")]):_c('span',[_vm._v("Extras")])]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumenSemana.SinTrabajar)))]),_c('div',{staticClass:"col text-center"},[_vm._m(5),_c('b',[_vm._v("Nocturnas")]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumenSemana.Nocturna)))]),_c('div',{staticClass:"col text-center"},[_vm._m(6),_c('b',[_vm._v("Festivas")]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumenSemana.Festivo)))]),_c('div',{staticClass:"col text-center"},[_vm._m(7),_c('b',[_vm._v("Debes")]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumenSemana.Deuda)))]),_c('div',{staticClass:"col text-center"},[_vm._m(8),_c('b',[_vm._v("Te deben")]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumenSemana.Acumulados)))])])])])]):_vm._e(),(_vm.resumen)?_c('div',{staticClass:"col"},[_c('div',{staticClass:"card mt-2"},[_vm._m(9),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_vm._m(10),_c('b',[_vm._v("Jornada total")]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumen.Jornada)))]),_c('div',{staticClass:"col text-center"},[_vm._m(11),_c('b',[_vm._v("Trabajado")]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumen.Total)))]),_c('div',{staticClass:"col text-center"},[_vm._m(12),_c('b',[(_vm.resumen.SinTrabajar < 0)?_c('span',[_vm._v("Pendientes")]):_c('span',[_vm._v("Extras")])]),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumen.SinTrabajar)))]),_c('div',{staticClass:"col text-center"},[_vm._m(13),_c('b',[_vm._v("Acumulado")]),_c('span',{staticClass:"fa fa-info-circle ml-2 text-info",attrs:{"title":"Cálculo basado en el intérvalo de fechas dado"}}),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumen.Acumulados)))]),_c('div',{staticClass:"col text-center"},[_vm._m(14),_c('b',[_vm._v("Consumido")]),_c('span',{staticClass:"fa fa-info-circle ml-2 text-info",attrs:{"title":"Cálculo basado en el intérvalo de fechas dado"}}),_c('br'),_vm._v(_vm._s(_vm._f("hora")(_vm.resumen.Consumidos)))]),_c('div',{staticClass:"col text-center",class:_vm.resumen.Acumulados - _vm.resumen.Consumidos < 0 ? 'text-danger' : 'text-success'},[_vm._m(15),_c('b',[_vm._v("Pendiente por consumir")]),_c('br'),_c('span',[_vm._v(_vm._s(_vm._f("hora")(_vm.resumen.Acumulados - _vm.resumen.Consumidos)))])])])])])]):_vm._e()]):_vm._e(),_c('div',{staticClass:"mt-3 card"},[_vm._m(16),_c('table',{staticClass:"table table-striped m-0"},[_vm._m(17),_c('tbody',[_vm._l((_vm.agrupados),function(registro){return _c('tr',{key:registro.RegistroID,class:_vm.getClase(registro)},[_c('td',[_vm._v(_vm._s(registro.RegistroID))]),_c('td',[_c('div',[_vm._v(_vm._s(registro.UsuarioNombre))]),(registro.FechaFinJornada && registro.FechaFinJornada - registro.FechaInicioJornada > 43200)?_c('div',{attrs:{"title":"Jornada de 12 horas o más"}},[_vm._m(18,true)]):_vm._e()]),_c('th',[_c('span',{class:registro.Naturaleza},[_vm._v(_vm._s(registro.Naturaleza))])]),_c('td',[(registro.FechaInicioJornada)?_c('span',[(!registro.IPLocalEntrada)?_c('span',{staticClass:"fa fa-map fa-w mr-2",attrs:{"title":"Registrado fuera de la oficina"}}):_c('span',{staticClass:"fa fa-building fa-w mr-2",attrs:{"title":"Registrado en la oficina"}}),_c('span',{class:registro.FechaInicioJornada === registro.FechaRegistroEntrada ? '' : 'text-danger'},[_vm._v(_vm._s(_vm._f("moment")(registro.FechaInicioJornada,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(registro.FechaInicioJornada,'HH:mm:ss')))])]):_vm._e()]),_c('td',[(registro.FechaFinJornada)?_c('span',[(!registro.IPLocalSalida)?_c('span',{staticClass:"fa fa-map fa-w mr-2",attrs:{"title":"Registrado fuera de la oficina"}}):_c('span',{staticClass:"fa fa-building fa-w mr-2",attrs:{"title":"Registrado en la oficina"}}),_c('span',{class:registro.FechaFinJornada === registro.FechaRegistroSalida ? '' : 'text-danger'},[_vm._v(_vm._s(_vm._f("moment")(registro.FechaFinJornada,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(registro.FechaFinJornada,'HH:mm:ss')))])]):_c('span',{staticClass:"jornadaActiva"},[_vm._v("Jornada activa")])]),_c('td',[(registro.FechaFinJornada)?_c('span',[_vm._v(_vm._s(_vm._f("hora")(registro.Total)))]):_vm._e()]),_c('td',[(registro.FechaFinJornada)?_c('div',{staticClass:"desglose"},_vm._l((registro.Desglose),function(d,di){return _c('div',{key:di},[_c('span',{staticClass:"nombre"},[_vm._v(_vm._s(d.TipoJornada))]),_c('span',{staticClass:"total"},[_vm._v(_vm._s(_vm._f("hora")(d.Total)))]),(d.Acumulado > 0)?_c('span',{staticClass:"acumulado"},[_vm._v(_vm._s(_vm._f("hora")(d.Acumulado)))]):(d.Acumulado < 0)?_c('span',{staticClass:"acumulado"},[_vm._v("-"+_vm._s(_vm._f("hora")(d.Acumulado * -1)))]):_vm._e()])}),0):_vm._e()]),_c('td',{staticClass:"text-right"},[(registro.FechaFinJornada && registro.Naturaleza !== 'Vacaciones')?_c('div',[_c('button',{staticClass:"m-2 btn btn-sm btn-warning",on:{"click":function($event){_vm.verDetalle = registro.RegistroID}}},[_c('span',{staticClass:"fa fa-eye"})]),(_vm.permiteEditar(registro))?_c('button',{staticClass:"m-2 btn btn-sm btn-primary",on:{"click":function($event){_vm.editar = registro.RegistroID}}},[_c('span',{staticClass:"fa fa-edit"})]):_c('span',{staticClass:"m-2"},[_c('span',{staticClass:"fa fa-lock"})])]):(registro.Naturaleza !== 'Vacaciones')?_c('div',[_c('button',{staticClass:"btn btn-warning btn-sm",on:{"click":function($event){_vm.fichando = true}}},[_c('span',{staticClass:"fa fa-address-card mr-2"}),_vm._v("Fichar salida")])]):_vm._e()])])}),(!_vm.registros || _vm.registros.length === 0)?_c('tr',[_vm._m(19)]):_vm._e()],2)])]),(_vm.editar)?_c('Editor',{attrs:{"RegistroID":_vm.editar},on:{"cerrar":function($event){return _vm.cerrarEditor()}}}):_vm._e(),(_vm.verDetalle)?_c('Detalle',{attrs:{"RegistroID":_vm.verDetalle},on:{"cerrar":function($event){_vm.verDetalle = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_c('b',[_vm._v("Detalles de esta semana")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-briefcase"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-briefcase"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-briefcase"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-briefcase"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-hourglass"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-hourglass-end"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-hourglass-end"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-hourglass-end"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-filter mr-2"}),_c('b',[_vm._v("Estadísticas del intérvalo buscado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-briefcase"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-briefcase"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-briefcase"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-hourglass"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-hourglass-end"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"fa fa-hourglass-start"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Empleado")]),_c('th',[_vm._v("Naturaleza")]),_c('th',[_vm._v("Entrada")]),_c('th',[_vm._v("Salida")]),_c('th',[_vm._v("Horas")]),_c('th',[_vm._v("Tipos de hora")]),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('span',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("INCIDENCIA")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"p-3 text-center",attrs:{"colspan":"8"}},[_c('h3',{staticClass:"text-danger"},[_c('span',{staticClass:"fa fa-info-circle",staticStyle:{"font-size":"3em"}}),_c('br'),_vm._v("No hay registros")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_dias_vue__ = __webpack_require__(535);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e01fcc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_dias_vue__ = __webpack_require__(1250);
function injectStyle (ssrContext) {
  __webpack_require__(1249)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69e01fcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_dias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e01fcc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_dias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-3 card"},[_vm._m(0),_c('table',{staticClass:"table table-striped m-0"},[_vm._m(1),_c('tbody',[_vm._l((_vm.agrupados),function(registro){return _c('tr',{key:registro.RegistroID,class:_vm.getClase(registro)},[_c('td',[_vm._v(_vm._s(registro.Dia))]),_c('td',[_c('div',[_vm._v(_vm._s(registro.UsuarioNombre))])]),_c('td',[_vm._l((registro.registros),function(reg){return _c('div',{key:reg.RegistroID,staticClass:"registroHora"},[_c('div',[_vm._v(_vm._s(_vm._f("moment")(reg.FechaInicioJornada,'HH:mm:ss')))]),_c('div',[_vm._v("-")]),_c('div',[_vm._v(_vm._s(_vm._f("moment")(reg.FechaFinJornada,'HH:mm:ss')))])])}),(registro.FechaFinJornada && registro.FechaFinJornada - registro.FechaInicioJornada > 43200)?_c('div',{attrs:{"title":"Jornada de 12 horas o más"}},[_vm._m(2,true)]):_vm._e()],2),_c('td',[_c('span',[_vm._v(_vm._s(_vm._f("hora")(registro.Total)))])]),_c('td',[(registro.desgloses.length > 0)?_c('div',{staticClass:"desglose"},_vm._l((registro.desgloses),function(d,di){return _c('div',{key:di},[_c('span',{staticClass:"nombre"},[_vm._v(_vm._s(d.TipoJornada))]),_c('span',{staticClass:"total"},[_vm._v(_vm._s(_vm._f("hora")(d.Total)))]),(d.Acumulado > 0)?_c('span',{staticClass:"acumulado"},[_vm._v(_vm._s(_vm._f("hora")(d.Acumulado)))]):(d.Acumulado < 0)?_c('span',{staticClass:"acumulado"},[_vm._v("-"+_vm._s(_vm._f("hora")(d.Acumulado * -1)))]):_vm._e()])}),0):_vm._e()]),_c('td',{staticClass:"text-right"})])}),(!_vm.registros || _vm.registros.length === 0)?_c('tr',[_vm._m(3)]):_vm._e()],2)])]),(_vm.editar)?_c('Editor',{attrs:{"RegistroID":_vm.editar},on:{"cerrar":function($event){return _vm.cerrarEditor()}}}):_vm._e(),(_vm.verDetalle)?_c('Detalle',{attrs:{"RegistroID":_vm.verDetalle},on:{"cerrar":function($event){_vm.verDetalle = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Dia")]),_c('th',[_vm._v("Empleado")]),_c('th',[_vm._v("Registros")]),_c('th',[_vm._v("Horas")]),_c('th',[_vm._v("Tipos de hora")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('span',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("INCIDENCIA")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"p-3 text-center",attrs:{"colspan":"8"}},[_c('h3',{staticClass:"text-danger"},[_c('span',{staticClass:"fa fa-info-circle",staticStyle:{"font-size":"3em"}}),_c('br'),_vm._v("No hay registros")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('Formulario',{attrs:{"filtro":_vm.filtro,"resultados":_vm.registros},on:{"buscar":function($event){return _vm.buscar()},"nuevo":_vm.nuevo}}),(_vm.filtro.vista === 'Normal')?_c('Resultados',{attrs:{"registros":_vm.registros,"resumen":_vm.resumen,"resumenSemana":_vm.resumenSemana},on:{"buscar":_vm.buscar}}):(_vm.filtro.vista === 'Agrupada')?_c('ResultadosDias',{attrs:{"registros":_vm.registros,"resumen":_vm.resumen,"resumenSemana":_vm.resumenSemana},on:{"buscar":_vm.buscar}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informes_vue__ = __webpack_require__(536);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d4c75c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_informes_vue__ = __webpack_require__(1255);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d4c75c7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_informes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cierre_vue__ = __webpack_require__(537);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cc6afa4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_cierre_vue__ = __webpack_require__(1254);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cierre_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cc6afa4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_cierre_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Cierre de mes"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"alert alert-warning"},[_c('b',[_vm._v("Importante")]),_vm._v(": Antes de proceder al cierre del mes, asegúrate de que todos los registros son correctos y están completos, ya que una vez se cierre, ya no podrán modificarse registros ni añadir nuevos")]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Usuario")])]),(!_vm.cierre.UsuarioID)?_c('input-query',{staticClass:"form-control",attrs:{"inputClass":"form-control","placeholder":"Busca un usuario","realtime":true,"url":"gestion-jornada/php/api/queryUsuarios.php"},on:{"selected":function($event){return _vm.setUsuario($event)}}}):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"true"},domProps:{"value":_vm.UsuarioNombre}}),(_vm.permisos.gestion_jornada_editarTodos)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.cierre.UsuarioID = null}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()])],1),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Mes")])]),_c('datepicker',{attrs:{"bootstrap-styling":true,"minimum-view":"month","format":"MMMM, yyyy","language":_vm.$dateLang},model:{value:(_vm.fecha),callback:function ($$v) {_vm.fecha=$$v},expression:"fecha"}})],1)]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.cerrarMes()}}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Cerrar mes")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_c('seleccion-usuario',{attrs:{"readonly":!_vm.permisos.gestion_jornada_verTodos},model:{value:(_vm.filtro.UsuarioID),callback:function ($$v) {_vm.$set(_vm.filtro, "UsuarioID", $$v)},expression:"filtro.UsuarioID"}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_c('datepicker',{attrs:{"inputClass":"form-control form-control-sm","bootstrap-styling":true,"minimum-view":"month","format":"MMMM, yyyy","language":_vm.$dateLang},model:{value:(_vm.fecha),callback:function ($$v) {_vm.fecha=$$v},expression:"fecha"}})],1)])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary mr-2",on:{"click":function($event){return _vm.buscar()}}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.cerrarMes()}}},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v("Cerrar mes")])])]),_c('div',{staticClass:"card mt-3"},[_vm._m(3),(_vm.cierres.length > 0)?_c('table',{staticClass:"table table-striped m-0"},[_vm._m(4),_c('tbody',_vm._l((_vm.cierres),function(cierre){return _c('tr',{key:cierre.CierreID},[_c('td',[_vm._v(_vm._s(cierre.UsuarioNombre))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(cierre.MesUnix,'MMMM, YYYY')))]),_c('td',[_vm._v(_vm._s(_vm._f("hora")(cierre.SegundosTrabajados + cierre.SegundosNoTrabajados)))]),_c('td',[_vm._v(_vm._s(_vm._f("hora")(cierre.SegundosTrabajados)))]),_c('td',[_vm._v(_vm._s(_vm._f("hora")(cierre.SegundosExtra)))]),_c('td',[_vm._v(_vm._s(_vm._f("hora")(cierre.SegundosNocturnos)))]),_c('td',[_vm._v(_vm._s(_vm._f("hora")(cierre.SegundosFestivos)))]),_c('td',[_vm._v(_vm._s(_vm._f("hora")(cierre.Falta)))]),_c('td',[_vm._v(_vm._s(_vm._f("hora")(cierre.Libre)))]),_c('td',[_vm._v(_vm._s(cierre.Vacaciones)+" días")]),_c('td',[(_vm.permisos.gestion_jornada_editarTodos)?_c('button',{staticClass:"btn btn-sm btn-danger mr-2",attrs:{"title":"Revertir cierre"},on:{"click":function($event){return _vm.revertirCierre(cierre)}}},[_c('span',{staticClass:"fa fa-undo"})]):_vm._e(),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.getPDF(cierre)}}},[_c('span',{staticClass:"fa fa-file-pdf-o"})])])])}),0)]):_c('div',{staticClass:"card-body text-center"},[_c('h2',[_vm._v("No hay datos")])])]),(_vm.cerrandoMes)?_c('Cierre',{on:{"cerrar":function($event){return _vm.cerrarMes()}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Filtro")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Usuario")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Mes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-table mr-2"}),_vm._v("Informes")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Usuario")]),_c('th',[_vm._v("Mes")]),_c('th',[_vm._v("Total jornada")]),_c('th',[_vm._v("Horas trabajadas")]),_c('th',[_vm._v("Extras")]),_c('th',[_vm._v("Nocturnas")]),_c('th',[_vm._v("Festivas")]),_c('th',[_vm._v("Faltas justificadas")]),_c('th',[_vm._v("Horas libradas")]),_c('th',[_vm._v("Vacaciones")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visualizar_vue__ = __webpack_require__(538);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377296de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visualizar_vue__ = __webpack_require__(1260);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visualizar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_377296de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visualizar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__ = __webpack_require__(539);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11bbbcda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__ = __webpack_require__(1259);
function injectStyle (ssrContext) {
  __webpack_require__(1258)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11bbbcda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11bbbcda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.empleados)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3"},[(_vm.validacionesPendientes && _vm.permisos.gestion_jornada_aprobar_vacaciones)?_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"alert alert-warning m-0"},[_vm._v("Hola "+_vm._s(_vm.usuario.nombre)+". Hay días pendientes de validar. Por favor atiéndelos cuanto antes para que se hagan efectivos.")]),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-block",class:_vm.aprobando ? 'btn-success': '',on:{"click":function($event){return _vm.toggleAccion('aprobar')}}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Trabajar en ello")])])])])]):_vm._e(),_c('div',{staticClass:"card"},[_c('table',{staticClass:"table table-striped m-0"},[_vm._m(0),_c('tbody',_vm._l((_vm.empleados),function(usuario){return _c('tr',{key:usuario.UsuarioID},[_c('td',[_vm._v(_vm._s(usuario.UsuarioNombre))]),_c('td',[_vm._v(_vm._s(_vm.cuentaUsuario(usuario))+" / 23 días")])])}),0)])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-9"},_vm._l((_vm.meses),function(mes){return _c('table',{key:mes.mes,staticClass:"tabla mb-3"},[_c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',{staticClass:"text-left pl-3"},[_vm._v(_vm._s(mes.mes))]),_vm._l((mes.dias),function(dia){return _c('th',{key:mes.mes + '-' + dia.dia},[_vm._v(_vm._s(dia.dia))])})],2),_c('tr',{staticStyle:{"background-color":"#888888 !important"}},[_c('th',{staticClass:"text-left pl-3"},[_vm._v("Usuario/a")]),_vm._l((mes.dias),function(dia){return _c('th',{key:mes.mes + '-' + dia.id},[_vm._v(_vm._s(dia.diaSem))])})],2)]),_c('tbody',_vm._l((_vm.empleados),function(empleado){return _c('tr',{key:empleado.UsuarioID},[_c('td',{staticClass:"text-left pl-3"},[_vm._v(_vm._s(_vm.cuentaUsuario(empleado))+" / 23 - "+_vm._s(empleado.UsuarioNombre))]),_vm._l((mes.dias),function(dia){return _c('td',{key:dia.id,class:dia.festivo ? 'festivo' : _vm.diasJornada(dia, empleado) ? 'disabled' : _vm.claseDia(dia.id, empleado),attrs:{"title":_vm.getTitulo(dia.id, empleado)},on:{"click":function($event){return _vm.toggleDia(dia, empleado)}}},[_c('span',{class:_vm.iconoDia(dia.id, empleado)})])})],2)}),0)])}),0)]),_c('div',{staticStyle:{"position":"relative","display":"inline-block","height":"100px"}}),_c('div',{staticClass:"aplicaCambios",class:_vm.form.quitar.length > 0 || _vm.form.agregar.length > 0 ? 'activoCambios' : ''},[_c('div',{staticStyle:{"position":"relative","display":"inline-block","vertical-align":"middle","margin":"10px"}},[(_vm.form.agregar.length > 0)?_c('div',[_c('span',{staticClass:"mr-2"},[_vm._v("Añadir")]),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.form.agregar.length)+" días")])]):_vm._e(),(_vm.form.quitar.length > 0)?_c('div',[_c('span',{staticClass:"mr-2"},[_vm._v("Quitar")]),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.form.quitar.length)+" días")])]):_vm._e()]),_c('div',{staticStyle:{"position":"relative","display":"inline-block","vertical-align":"middle","margin":"10px"}},[_c('button',{staticClass:"btn btn-large btn-primary",attrs:{"disabled":_vm.cargandoGuardar},on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-check mr-2",class:_vm.cargandoGuardar ? 'fa-spinner fa-spin' : 'fa-check'}),_vm._v(_vm._s(_vm.cargandoGuardar ? 'Enviando...' : 'Solicitar cambios'))])])]),_c('div',{staticClass:"aplicaValidacion",class:_vm.validacion.rechazar.length > 0 || _vm.validacion.aprobar.length > 0 ? 'activoCambios' : ''},[_c('div',{staticStyle:{"position":"relative","display":"inline-block","vertical-align":"middle","margin":"10px"}},[(_vm.validacion.aprobar.length > 0)?_c('div',[_c('span',{staticClass:"mr-2"},[_vm._v("Aprobar")]),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.validacion.aprobar.length)+" días")])]):_vm._e(),(_vm.validacion.rechazar.length > 0)?_c('div',[_c('span',{staticClass:"mr-2"},[_vm._v("Rechazar")]),_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.validacion.rechazar.length)+" días")])]):_vm._e()]),_c('div',{staticStyle:{"position":"relative","display":"inline-block","vertical-align":"middle","margin":"10px"}},[_c('button',{staticClass:"btn btn-large btn-primary",on:{"click":function($event){return _vm.validar()}}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Validar cambios")])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Empleado")]),_c('th',[_vm._v("Días")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-footer"},[_c('div',{staticStyle:{"max-width":"120px","display":"inline-block"}},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(1),_c('div',{staticClass:"input-group-prepend input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.cambiaAno(-1)}}},[_c('span',{staticClass:"fa fa-caret-left"})])]),_c('input',{staticClass:"form-control text-center",attrs:{"disabled":true},domProps:{"value":this.filtro.ano}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.cambiaAno(1)}}},[_c('span',{staticClass:"fa fa-caret-right"})])])])])])]),_c('Resultados',{staticClass:"mt-2",attrs:{"ano":this.filtro.ano,"empleados":_vm.empleados,"festivos":_vm.festivos},on:{"buscar":function($event){return _vm.buscar()}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-plane mr-2"}),_vm._v("Vacaciones")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Año")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1262);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('permisos', {
			name: 'Gestión de permisos',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});
	}
});

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ec061aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1264);
function injectStyle (ssrContext) {
  __webpack_require__(1263)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ec061aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ec061aa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("\n\t\t\t\t\tSelecciona un permiso\n\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.listadoPermisos),function(modulo){return _c('table',{key:modulo.nombre,staticClass:"m-0 table table-condensed table-striped"},[_c('thead',{class:(_vm.mod === modulo.nombre) ? 'bg-dark text-white' : 'bg-light'},[_c('tr',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.cambiaModulo(modulo)}}},[_vm._m(0,true),_vm._v(" "),_c('th',[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(modulo.nombre)+"\n\t\t\t\t\t\t\t")])])]),_vm._v(" "),(_vm.mod === modulo.nombre)?_c('tbody',_vm._l((modulo.items),function(item){return _c('tr',{key:item.permiso,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getPermiso(item.nombre)}}},[_vm._m(1,true),_vm._v(" "),_c('td',{class:(_vm.permiso !== null && _vm.permiso.nombre === item.nombre) ? 'bg-info text-white' : ''},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(item.descripcion)+"\n\t\t\t\t\t\t\t")])])}),0):_vm._e()])})],2)]),_vm._v(" "),(_vm.permiso !== null)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_vm._v("\n\t\t\t\t\tDetalles del permiso\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},[_c('h4',[_c('b',[_vm._v(_vm._s(_vm.mod))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.permiso.descripcion))])])]),_vm._v(" "),_c('div',{staticClass:"card-body row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('b',[_vm._v("Permiso por grupos")]),_vm._v(" "),_c('input-query',{staticClass:"form-control p-0",attrs:{"input-class":"form-control","placeholder":"Busca y añade un grupo","url":"gestion-permisos/php/buscaGrupos.php","realtime":true},on:{"selected":function($event){return _vm.ponGrupo($event)}}}),_vm._v(" "),_c('table',{staticClass:"table table-condensed table-striped mt-2"},[_c('tbody',_vm._l((_vm.permiso.grupos),function(grupo,index){return _c('tr',{key:grupo.grupo_ID},[_vm._m(2,true),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(grupo.nombre)+"\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticStyle:{"width":"120px","text-align":"right"}},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(grupo.permitido) ? 'btn-success' : 'btn-light',on:{"click":function($event){grupo.permitido = true}}},[_c('span',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(grupo.permitido) ? 'btn-light' : 'btn-danger',on:{"click":function($event){grupo.permitido = false}}},[_c('span',{staticClass:"fa fa-ban"})])]),_vm._v(" "),_c('button',{staticClass:"ml-2 btn btn-sm btn-warning",on:{"click":function($event){return _vm.permiso.grupos.splice(index, 1)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('b',[_vm._v("Permiso por usuarios")]),_vm._v(" "),_c('input-query',{staticClass:"form-control p-0",attrs:{"input-class":"form-control","placeholder":"Busca y añade un usuario","url":"gestion-permisos/php/buscaUsuarios.php","realtime":true},on:{"selected":function($event){return _vm.ponUsuario($event)}}}),_vm._v(" "),_c('table',{staticClass:"table table-condensed table-striped mt-2"},[_c('tbody',_vm._l((_vm.permiso.usuarios),function(usuario,index){return _c('tr',{key:usuario.grupo_ID},[_vm._m(3,true),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(usuario.nombre)+" "+_vm._s(usuario.apellidos)+"\n\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticStyle:{"width":"120px","text-align":"right"}},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(usuario.permitido) ? 'btn-success' : 'btn-light',on:{"click":function($event){usuario.permitido = true}}},[_c('span',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(usuario.permitido) ? 'btn-light' : 'btn-danger',on:{"click":function($event){usuario.permitido = false}}},[_c('span',{staticClass:"fa fa-ban"})])]),_vm._v(" "),_c('button',{staticClass:"ml-2 btn btn-sm btn-warning",on:{"click":function($event){return _vm.permiso.usuarios.splice(index, 1)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])],1)]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("\n\t\t\t\t\t\tGuardar\n\t\t\t\t\t")])])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticStyle:{"width":"30px"}},[_c('span',{staticClass:"fa fa-gear"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"bg-dark text-white",staticStyle:{"width":"30px"}},[_c('span',{staticClass:"fa fa-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"width":"30px"}},[_c('span',{staticClass:"fa fa-users"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"width":"30px"}},[_c('span',{staticClass:"fa fa-user"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main__ = __webpack_require__(1266);


/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('gestion-tarifas', {
			name: 'Gestión de tarifas',
			component: __WEBPACK_IMPORTED_MODULE_1__Main__["a" /* default */]
		});
	}
});

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(541);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390f7fa6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1269);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_390f7fa6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuevoProducto_vue__ = __webpack_require__(542);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f58f380a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nuevoProducto_vue__ = __webpack_require__(1268);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nuevoProducto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f58f380a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_nuevoProducto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":200}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-info mr-2"}),_vm._v("Nuevo producto"),_c('button',{staticClass:"close",on:{"click":function($event){return _vm.$emit('cerrar')}}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Nombre del producto")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}})])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.crear}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Crear")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filtro.ano),expression:"filtro.ano",modifiers:{"number":true}}],staticClass:"form-control",domProps:{"value":(_vm.filtro.ano)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "ano", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.SoporteID),expression:"filtro.SoporteID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "SoporteID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoSoportes),function(soporte){return _c('option',{key:soporte.ID_soporte,domProps:{"value":soporte.ID_soporte}},[_vm._v(_vm._s(soporte.soporte))])}),0)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.ProductoID),expression:"filtro.ProductoID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "ProductoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoProductos),function(producto){return _c('option',{key:producto.ID_producto,domProps:{"value":producto.ID_producto}},[_vm._v(_vm._s(producto.nombre))])}),0)])])])])])]),(_vm.formValido)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v(_vm._s(_vm.tituloTarifas))]),_c('table',{staticClass:"table table-striped m-0"},[_vm._m(4),(_vm.tarifas && _vm.tarifas.length > 0)?_c('tbody',_vm._l((_vm.tarifas),function(tarifa){return _c('tr',{key:tarifa.ID_tarifa},[_c('th',[_vm._v(_vm._s(tarifa.ID_tarifa))]),_c('th',[(!_vm.editando || _vm.editando.ID_tarifa !== tarifa.ID_tarifa)?_c('div',[_vm._v(_vm._s(tarifa.duracion))]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.editando.duracion),expression:"editando.duracion",modifiers:{"number":true}}],staticClass:"form-control",domProps:{"value":(_vm.editando.duracion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editando, "duracion", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_c('th',[(tarifa.duracion === 1)?_c('span',{staticClass:"fa fa-check"}):_c('span',{staticClass:"fa fa-ban"})]),_c('th',[(!_vm.editando || _vm.editando.ID_tarifa !== tarifa.ID_tarifa)?_c('div',[_vm._v(_vm._s(tarifa.unidades))]):_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.editando.unidades),expression:"editando.unidades"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.editando, "unidades", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"segundos"}},[_vm._v("Segundos")]),_c('option',{attrs:{"value":"minutos"}},[_vm._v("Minutos")])])])]),_c('th',[(!_vm.editando || _vm.editando.ID_tarifa !== tarifa.ID_tarifa)?_c('div',[_vm._v(_vm._s(_vm._f("currency")(tarifa.precio,''))+" €")]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.editando.precio),expression:"editando.precio",modifiers:{"number":true}}],staticClass:"form-control",domProps:{"value":(_vm.editando.precio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.editando, "precio", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_c('th',[(!_vm.editando)?_c('div',[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.editando = tarifa}}},[_c('span',{staticClass:"fa fa-edit"})])]):_vm._e(),(_vm.editando && _vm.editando.ID_tarifa === tarifa.ID_tarifa)?_c('div',[_c('button',{staticClass:"btn btn-sm btn-primary mr-3",on:{"click":function($event){return _vm.setTarifa()}}},[_c('span',{staticClass:"fa fa-save"})]),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.cancelarEdicion}},[_c('span',{staticClass:"fa fa-close"})])]):_vm._e()])])}),0):_vm._e()]),(!_vm.editando)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.nuevaTarifa}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Añadir")])]):_vm._e()])]):_vm._e()]),(_vm.nuevoProducto)?_c('nuevo-producto',{attrs:{"producto":_vm.nuevoProducto},on:{"cerrar":function($event){_vm.nuevoProducto = null},"nuevo":function($event){return _vm.productoCreado($event)}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-filter mr-2"}),_vm._v("Selecciona")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Año")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Soporte")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Producto")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Duración")]),_c('th',[_vm._v("Unitario")]),_c('th',[_vm._v("Unidades")]),_c('th',[_vm._v("Precio")]),_c('th',[_vm._v("Modificar")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1271);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('panel-control').child('usuarios', {
			name: 'Gestión de usuarios',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});
	}
});

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fff3235_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1288);
function injectStyle (ssrContext) {
  __webpack_require__(1272)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fff3235"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fff3235_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(544);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623c3919_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1287);
function injectStyle (ssrContext) {
  __webpack_require__(1274)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623c3919_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dbc1b1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_general_vue__ = __webpack_require__(1277);
function injectStyle (ssrContext) {
  __webpack_require__(1276)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_general_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dbc1b1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_general_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div"},[_c('h4',[_vm._v("Información de contacto")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.telefono),expression:"usuario.telefono"}],staticClass:"form-control",attrs:{"type":"tel"},domProps:{"value":(_vm.usuario.telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "telefono", $event.target.value)}}})])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.email),expression:"usuario.email"}],staticClass:"form-control",attrs:{"type":"email"},domProps:{"value":(_vm.usuario.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "email", $event.target.value)}}})])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Pushover user key")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.pushover),expression:"usuario.pushover"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.usuario.pushover)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "pushover", $event.target.value)}}})])])]),_c('hr'),_c('h4',[_vm._v("Detalles de acceso")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.usuario),expression:"usuario.usuario"}],staticClass:"form-control",attrs:{"type":"text","disabled":"","placeholder":"Se generará automáticamente"},domProps:{"value":(_vm.usuario.usuario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "usuario", $event.target.value)}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(_vm.usuario.admin) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.usuario.admin = !_vm.usuario.admin}}},[_vm._v("Admin")])])])])]),_c('div',{staticClass:"col"},[_vm._m(3),_c('div',{staticClass:"input-group input-group-sm"},[_c('datepicker',{attrs:{"monday-first":true,"language":_vm.$dateLang,"format":"dd-MM-yyyy","bootstrap-styling":true,"placeholder":"DD-MM-YYYY"},model:{value:(_vm.usuario.fecha_expiracion_cuenta),callback:function ($$v) {_vm.$set(_vm.usuario, "fecha_expiracion_cuenta", $$v)},expression:"usuario.fecha_expiracion_cuenta"}}),(_vm.usuario.fecha_expiracion_cuenta <= new Date())?_c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text bg-danger text-white"},[_vm._v("Caducada")])]):_vm._e()],1)])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_vm._m(4),_c('button',{staticClass:"btn btn-block btn-danger",on:{"click":function($event){return _vm.resetPassword()}}},[_vm._v("Generar nuevo password")])]),_c('hr'),_c('b',[_vm._v("2º factor de autenticación")]),_c('br'),(_vm.usuario.otps === 'ok')?_c('div',{staticClass:"mt-3 alert alert-info"},[_c('b',[_vm._v("Activado")]),_c('br'),_vm._v("Este usuario tiene un segundo factor de autentificación activado."),_c('hr'),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaOTP()}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")])]):_vm._e(),(_vm.usuario.otps !== 'ok')?_c('div',{staticClass:"mt-3 alert alert-danger"},[_c('b',[_vm._v("No activado")]),_c('br'),_vm._v("Este usuario no tiene activado un segundo factor de autentificación. Por este motivo no podrá\nacceder al SIP desde el exterior de la empresa")]):_vm._e()]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_vm._m(5),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.periodo_password),expression:"usuario.periodo_password"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.usuario.periodo_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "periodo_password", $event.target.value)}}}),_vm._m(6)])]),_c('div',{staticClass:"form-group"},[_vm._m(7),_c('datepicker',{attrs:{"monday-first":true,"language":_vm.$dateLang,"format":"dd-MM-yyyy","bootstrap-styling":true,"placeholder":"DD-MM-YYYY"},model:{value:(_vm.usuario.caduca_password),callback:function ($$v) {_vm.$set(_vm.usuario, "caduca_password", $$v)},expression:"usuario.caduca_password"}})],1)])]),_c('div',{staticClass:"text-right mt-2"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar cambios")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Teléfono")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Usuario")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Caducidad de la cuenta")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Periodo validez password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("días")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Póximo cambio de password")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_extras_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e8ae57_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_extras_vue__ = __webpack_require__(1279);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_extras_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e8ae57_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_extras_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._l((_vm.usuario.extras),function(extra,index){return _c('div',{key:'extra_' + index,staticClass:"row mb-2"},[_c('div',{staticClass:"col"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(extra.clave),expression:"extra.clave"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(extra, "clave", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.tipos),function(tipo){return _c('option',{key:tipo,domProps:{"value":tipo}},[_vm._v(_vm._s(tipo))])}),0)]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(extra.valor),expression:"extra.valor"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Valor"},domProps:{"value":(extra.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(extra, "valor", $event.target.value)}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitarExtra(index)}}},[_c('span',{staticClass:"fa fa-trash"})])])])])])}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-sm mt-2 btn-warning",on:{"click":function($event){return _vm.nuevoExtra()}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Añadir")])]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm mt-2 btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar extras")])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_vm._v("En este apartado de extras es posible almacenar información en formato \"Tipo -> valor\" relacionada con el usuario."),_c('br'),_vm._v("Por ejemplo: Huella entrada: 01")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_horario_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2364848_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_horario_vue__ = __webpack_require__(1282);
function injectStyle (ssrContext) {
  __webpack_require__(1281)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d2364848"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_horario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2364848_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_horario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"alert alert-warning"},[_vm._v("Aquí puedes definir el horario habitual de cada empleado, así como su jornada semanal")]),_c('table',{staticClass:"table table-condensed"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Día")]),_c('th',[_vm._v("Hora entrada")]),_c('th',[_vm._v("Hora salida")]),_c('th',{staticClass:"text-center",staticStyle:{"width":"30px"}},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.nuevoHorario}},[_c('span',{staticClass:"fa fa-plus"})])])])]),_c('tbody',_vm._l((_vm.usuario.horario),function(h,i){return _c('tr',{key:h.HorarioID},[_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.horario[i].DiaSemana),expression:"usuario.horario[i].DiaSemana"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.usuario.horario[i], "DiaSemana", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.dias),function(dia){return _c('option',{key:dia,domProps:{"value":dia}},[_vm._v(_vm._s(dia))])}),0)]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.horario[i].HoraEntrada),expression:"usuario.horario[i].HoraEntrada"}],staticClass:"form-control form-control-sm",attrs:{"type":"time"},domProps:{"value":(_vm.usuario.horario[i].HoraEntrada)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario.horario[i], "HoraEntrada", $event.target.value)}}})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.horario[i].HoraSalida),expression:"usuario.horario[i].HoraSalida"}],staticClass:"form-control form-control-sm",attrs:{"type":"time"},domProps:{"value":(_vm.usuario.horario[i].HoraSalida)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario.horario[i], "HoraSalida", $event.target.value)}}})]),_c('td',{staticClass:"text-center",staticStyle:{"width":"30px"}},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitar(h.HorarioID)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)]),_c('div',{staticClass:"text-right"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"mr-2"},[_vm._v("Jornada semanal")]),_c('b',[_vm._v(_vm._s(_vm._f("hora")(_vm.jornadaSemanal)))]),_c('span',{staticClass:"ml-2"},[_vm._v("horas ")])])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.guardarHorario()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar horario")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emails_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d7671c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_emails_vue__ = __webpack_require__(1284);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d7671c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_emails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('b',[_vm._v("E-mails")]),_vm._l((_vm.emails),function(email,index){return _c('div',{key:'email_' + index,staticClass:"mt-2"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(email.cuenta),expression:"email.cuenta"}],staticClass:"form-control",attrs:{"type":"email","placeholder":"usuario"},domProps:{"value":(email.cuenta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(email, "cuenta", $event.target.value)}}}),_vm._m(1,true),_c('select',{directives:[{name:"model",rawName:"v-model",value:(email.dominio_id),expression:"email.dominio_id"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(email, "dominio_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.dominios),function(dominio){return _c('option',{key:dominio.id,domProps:{"value":dominio.id}},[_vm._v(_vm._s(dominio.dominio))])}),0),_vm._m(2,true),_c('input',{directives:[{name:"model",rawName:"v-model",value:(email.cuota),expression:"email.cuota"}],staticClass:"form-control",staticStyle:{"max-width":"60px !important"},attrs:{"type":"number","placeholder":"XX"},domProps:{"value":(email.cuota)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(email, "cuota", $event.target.value)}}}),_vm._m(3,true),_c('div',{staticClass:"input-group-append",on:{"click":function($event){return _vm.emails.splice(index, 1)}}},[_vm._m(4,true)])])])}),(_vm.emails.length === 0)?_c('div',{staticClass:"text-center alert alert-danger mt-2"},[_c('span',{staticClass:"fa fa-ban",staticStyle:{"font-size":"2em"}}),_c('br'),_vm._m(5)]):_vm._e(),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-sm btn-primary mt-2 mb-2",on:{"click":function($event){return _vm.nuevoEmail()}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Añadir")])]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-success mt-2 mb-2",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])]),_c('hr'),_c('b',[_vm._v("Alias")]),_c('div',{staticClass:"alert alert-warning mt-2"},[_vm._v("Desde aquí tan solo puedes ver los alias en los que están incluídas las direcciones de este usuario. Para editarlos debes irte a la herramienta de gestión\nde cuentas de correo en el panel de control.")]),_vm._l((_vm.aliases),function(alias){return _c('div',{key:alias.origen,staticClass:"mt-2"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"","readonly":"readonly"},domProps:{"value":alias.origen}}),_vm._m(6,true),_c('input',{staticClass:"form-control",attrs:{"type":"email","placeholder":"","readonly":"readonly"},domProps:{"value":alias.destino}})])])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_vm._v("Aquí puedes configurar las direcciones de correo electrónico "),_c('b',[_vm._v("corporativos")]),_vm._v(" de este usuario.\nPuedes añadir tantas direcciones como consideres oportuno. Pero ten en cuenta que también "),_c('b',[_vm._v("puedes hacer uso de\nlos alias")]),_vm._v(" para \"simular\" varias direcciones de correo.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("@")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Cuota")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text"},[_vm._v("Gb")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-danger"},[_c('span',{staticClass:"fa fa-trash"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('b',[_vm._v("Este usuario no tiene direcciones de e-mail")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('span',{staticClass:"input-group-text fa fa-arrow-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crop_avatar_vue__ = __webpack_require__(549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be7a5ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crop_avatar_vue__ = __webpack_require__(1286);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crop_avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be7a5ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_crop_avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Selecciona imagen"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{staticClass:"card-body",staticStyle:{"position":"relative","display":"block"}},[_c('vue-cropper',{on:{"img":function($event){return _vm.setImg($event)}}})],1),_c('div',{staticClass:"card-footer"},[(_vm.url)?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.confirmar()}}},[_vm._v("Aceptar")]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.usuario)?_c('modal',{attrs:{"max-width":1200}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Editor de usuario"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{staticClass:"card-body pt-0 row pb-0"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 bg-light text-center p-4",staticStyle:{"border-right":"1px solid #e0e0e0"}},[_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"90px","height":"90px"},attrs:{"src":_vm.avatar,"alt":"avatar"}}),_c('br'),_c('button',{staticClass:"btn btn-sm btn-primary mt-3",on:{"click":function($event){_vm.nuevoAvatar = true}}},[_c('span',{staticClass:"fa fa-photo mr-2"}),_vm._v("Cambiar")]),_c('hr'),_c('div',{staticClass:"text-left"},[_c('h5',[_vm._v("Datos personales")]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Nombre")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.nombre),expression:"usuario.nombre"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre","required":"required"},domProps:{"value":(_vm.usuario.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "nombre", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Apellidos")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.apellidos),expression:"usuario.apellidos"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Apellidos","required":"required"},domProps:{"value":(_vm.usuario.apellidos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "apellidos", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("DNI")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.DNI),expression:"usuario.DNI"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"12345678A","required":"required"},domProps:{"value":(_vm.usuario.DNI)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuario, "DNI", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Fecha de nacimiento")])]),_c('datepicker',{attrs:{"monday-first":true,"language":_vm.$dateLang,"format":"dd-MM-yyyy","bootstrap-styling":true,"placeholder":"DD-MM-YYYY"},model:{value:(_vm.usuario.fecha_nacimiento),callback:function ($$v) {_vm.$set(_vm.usuario, "fecha_nacimiento", $$v)},expression:"usuario.fecha_nacimiento"}})],1),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Género")])]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.usuario.sexo === 'hombre') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.usuario.sexo = 'hombre'}}},[_vm._v("Hombre")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.usuario.sexo === 'mujer') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.usuario.sexo = 'mujer'}}},[_vm._v("Mujer")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.usuario.sexo === 'otro') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.usuario.sexo = 'otro'}}},[_vm._v("Otro")])])]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Empresa")])]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.empresa_ID),expression:"usuario.empresa_ID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.usuario, "empresa_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"disabled"},domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoEmpresas),function(empresa){return _c('option',{key:empresa.ID_empresa,domProps:{"value":empresa.ID_empresa}},[_vm._v(_vm._s(empresa.NombreFiscal))])})],2)]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Categoría")])]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario.tipo),expression:"usuario.tipo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.usuario, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"disabled"},domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoCategorias),function(cat){return _c('option',{key:cat,domProps:{"value":cat}},[_vm._v(_vm._s(cat))])})],2)])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8 text-left p-4"},[_c('ul',{staticClass:"nav nav-tabs mt-1 mb-3"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'general') ? 'active' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.seccion = 'general'}}},[_c('span',{staticClass:"fa fa-info-circle fa-w mr-2"}),_vm._v("General")])]),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'emails') ? 'active' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.seccion = 'emails'}}},[_c('span',{staticClass:"fa fa-envelope fa-w mr-2"}),_vm._v("Emails")])]),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'extras') ? 'active' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.seccion = 'extras'}}},[_c('span',{staticClass:"fa fa-w fa-star mr-2"}),_vm._v("Extras")])]),(_vm.usuario.ID)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:(_vm.seccion === 'horario') ? 'active' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.seccion = 'horario'}}},[_c('span',{staticClass:"fa fa-w fa-calendar mr-2"}),_vm._v("Horario")])]):_vm._e()]),(_vm.seccion === 'extras')?_c('usuario-extras',{attrs:{"usuario":_vm.usuario},on:{"update:usuario":function($event){_vm.usuario=$event}}}):_vm._e(),(_vm.seccion === 'emails')?_c('emails',{attrs:{"usuario":_vm.usuario}}):_vm._e(),(_vm.seccion === 'general')?_c('general',{attrs:{"usuario":_vm.usuario},on:{"update:usuario":function($event){_vm.usuario=$event}}}):_vm._e(),(_vm.seccion === 'horario')?_c('horario',{attrs:{"usuario":_vm.usuario}}):_vm._e()],1)])]),(_vm.nuevoAvatar)?_c('crop-avatar',{on:{"cerrar":function($event){_vm.nuevoAvatar = false},"img":function($event){return _vm.setNuevoAvatar($event)}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre/apellidos")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.nombre),expression:"filtro.nombre"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Busca por nombre o apellidos"},domProps:{"value":(_vm.filtro.nombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "nombre", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Grupo")]),_c('br'),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.grupo),expression:"filtro.grupo"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "grupo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.setGrupo(_vm.filtro.grupo)}]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.grupos),function(grupo){return _c('option',{key:grupo.nombre,domProps:{"value":grupo.nombre}},[_vm._v(_vm._s(grupo.nombre))])})],2)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sexo")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.sexo === 'hombre') ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setSexo('hombre')}}},[_vm._v("Hombre")]),_c('button',{staticClass:"btn",class:(_vm.filtro.sexo === 'mujer') ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setSexo('mujer')}}},[_vm._v("Mujer")]),_c('button',{staticClass:"btn",class:(_vm.filtro.sexo === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setSexo(null)}}},[_vm._v("Cualquiera")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.activo === true) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setActivo(true)}}},[_vm._v("Activo")]),_c('button',{staticClass:"btn",class:(_vm.filtro.activo === false) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setActivo(false)}}},[_vm._v("Inactivo")]),_c('button',{staticClass:"btn",class:(_vm.filtro.activo === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setActivo(null)}}},[_vm._v("Cualquiera")])])])])])]),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.buscar()}}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.editar = 'nuevo'}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Nuevo")])])])])]),_c('div',{staticClass:"card mt-2"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-condensed table-striped m-0 text-left"},[_vm._m(1),_c('tbody',_vm._l((_vm.listadoUsuarios),function(usuario){return _c('tr',{key:usuario.ID,class:(!usuario.activo) ? 'inactivo' : ''},[_c('td',{staticStyle:{"width":"80px","vertical-align":"middle"}},[_vm._v(_vm._s(usuario.ID))]),_c('td',{staticStyle:{"vertical-align":"middle"}},[(usuario.avatar)?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"50px","height":"50px"},attrs:{"src":usuario.avatar}}):_vm._e()]),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(usuario.usuario))]),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(usuario.nombre)+" "+_vm._s(usuario.apellidos))]),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(usuario.sexo))]),_c('td',{staticStyle:{"font-size":"2em","vertical-align":"middle"}},[(!usuario.activo)?_c('span',{staticClass:"fa fa-ban"}):_vm._e(),(usuario.activo)?_c('span',{staticClass:"fa fa-check"}):_vm._e()]),_c('td',{staticClass:"text-center",staticStyle:{"width":"60px","vertical-align":"middle"}},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){_vm.editar = usuario.ID}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editar")])])])}),0),(_vm.listadoUsuarios.length === 0)?_c('tbody',[_vm._m(2)]):_vm._e()])])]),(_vm.editar)?_c('editor-usuario',{attrs:{"idusuario":_vm.editar},on:{"cerrar":function($event){_vm.editar = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Filtrar usuarios")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Avatar")]),_c('th',[_vm._v("Usuario")]),_c('th',[_vm._v("Nombre")]),_c('th',[_vm._v("Sexo")]),_c('th',[_vm._v("Estado")]),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-center pt-3 pb-3",staticStyle:{"background-color":"white"},attrs:{"colspan":"7"}},[_c('h3',[_vm._v("No hay resultados")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(1290);


// Exportamos
/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('invitaciones', {
			name: 'Gestión de invitaciones',
			component: __WEBPACK_IMPORTED_MODULE_1__main__["a" /* default */]
		});
	}
});

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52edae8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1307);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52edae8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(551);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68dbf7da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1306);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68dbf7da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filtro_vue__ = __webpack_require__(552);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bde8d4f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_filtro_vue__ = __webpack_require__(1298);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filtro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bde8d4f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_filtro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asiento_vue__ = __webpack_require__(555);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c4feb4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_asiento_vue__ = __webpack_require__(1296);
function injectStyle (ssrContext) {
  __webpack_require__(1295)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c4feb4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asiento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c4feb4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_asiento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.clase,style:(_vm.estilo),attrs:{"title":_vm.titulo},on:{"click":function($event){return _vm.haceClick()}}},[_vm._v(_vm._s(_vm.asiento.Numero))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"maxWidth":960}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Recinto"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light",staticStyle:{"border-bottom":"1px solid #e0e0e0"}},[_c('div',{staticClass:"detallesSeleccion"},[(_vm.objetivo)?_c('div',[_c('b',[_vm._v("Objetivo")]),_vm._v(" "+_vm._s(_vm.objetivo))]):_vm._e(),(_vm.objetivo)?_c('div',[_c('b',[_vm._v("Seleccionados")]),_vm._v(" "+_vm._s(_vm.seleccion.length))]):_vm._e(),(_vm.objetivo)?_c('div',[_c('b',[_vm._v("Pendientes")]),_vm._v(" "+_vm._s(_vm.objetivo - _vm.seleccion.length))]):_vm._e(),_c('div',[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cadena),expression:"cadena"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"Búsqueda"},domProps:{"value":(_vm.cadena)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cadena=$event.target.value}}})])])]),_c('div',{staticClass:"detallesSeleccion max"},[_c('div',[_vm._v("Capacidad recinto"),_c('br'),_c('b',[_vm._v(_vm._s(_vm.capacidad))])]),_c('div',[_vm._v("Ocupación"),_c('br'),_c('b',[_vm._v(_vm._s(_vm.ocupadas)+" ("+_vm._s(_vm._f("round")(_vm.ocupadas * 100 / _vm.capacidad,2))+" %)")])]),_c('div',[_vm._v("Libres"),_c('br'),_c('b',[_vm._v(_vm._s(_vm.capacidad - _vm.ocupadas))])])])]),(_vm.evento && _vm.ocupacion && _vm.evento.RecintoID)?_c('div',{staticClass:"card-body"},_vm._l((_vm.filas),function(zona,z){return _c('div',{key:'zona-' + z,staticClass:"zona"},[_c('div',{staticClass:"tituloZona"},[_c('span',[_vm._v(_vm._s(zona.nombre))]),_c('span',{staticClass:"ocupacion"},[_vm._v(_vm._s(zona.asientosOcupados)+" de "+_vm._s(zona.asientosTotal)+" localidades ocupadas. "),_c('b',[_vm._v(_vm._s(zona.asientosTotal - zona.asientosOcupados)+" libres")])]),_c('div',{staticClass:"pull-right",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.toggleZona(zona.ZonaID)}}},[(_vm.zonaActiva(zona.ZonaID))?_c('span',{staticStyle:{"color":"red"}},[_vm._v("Ocultar")]):_c('span',{staticStyle:{"color":"green"}},[_vm._v("Mostrar")])])]),_vm._l((zona.filas),function(fila){return (_vm.zonaActiva(zona.ZonaID))?_c('div',{key:fila.Numero,staticClass:"fila"},[_c('div',{staticClass:"numero"},[_vm._v(_vm._s(fila.Nombre))]),_vm._l((fila.Asientos),function(asiento,i){return _c('Asiento',{key:fila.Numero + '-' + asiento.Numero + '' + i,staticClass:"asi",attrs:{"asiento":asiento,"cadena":_vm.cadena},on:{"pulsado":function($event){return _vm.doClick(asiento)}}})})],2):_vm._e()})],2)}),0):(_vm.evento && !_vm.evento.RecintoID)?_c('div',{staticClass:"card-body bg-danger text-white"},[_c('h2',[_vm._v("Este evento no tiene recinto asignado")])]):_c('div',{staticClass:"card-body text-center"},[_c('h2',[_vm._v("Cargando")])]),(_vm.evento && _vm.evento.RecintoID && _vm.objetivo)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.seleccion.length !== _vm.objetivo},on:{"click":_vm.confirmar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Confirmar")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Evento")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.EventoID),expression:"filtro.EventoID"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "EventoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.getGrupos]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoEventos),function(evento){return _c('option',{key:evento.EventoID,domProps:{"value":evento.EventoID}},[_vm._v(_vm._s(evento.Nombre))])})],2)])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Grupo")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.GrupoID),expression:"filtro.GrupoID"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "GrupoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.$emit('buscar')}]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoGrupos),function(grupo){return _c('option',{key:grupo.GrupoID,domProps:{"value":grupo.GrupoID}},[_vm._v(_vm._s(grupo.Nombre))])})],2)])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Nombre),expression:"filtro.Nombre"}],staticClass:"form-control",attrs:{"placeholder":"Buscar por nombre"},domProps:{"value":(_vm.filtro.Nombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('buscar')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Nombre", $event.target.value)}}})]),_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Localización")]),_c('br'),_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(1),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Fila),expression:"filtro.Fila"}],staticClass:"form-control",attrs:{"placeholder":"Fila"},domProps:{"value":(_vm.filtro.Fila)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('buscar')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Fila", $event.target.value)}}}),_vm._m(2),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Asiento),expression:"filtro.Asiento"}],staticClass:"form-control",attrs:{"placeholder":"Asiento"},domProps:{"value":(_vm.filtro.Asiento)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('buscar')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Asiento", $event.target.value)}}})])])])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Usuario que gestiona")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Usuario),expression:"filtro.Usuario"}],staticClass:"form-control",attrs:{"placeholder":"Nombre del usuario"},domProps:{"value":(_vm.filtro.Usuario)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('buscar')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Usuario", $event.target.value)}}})]),_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado localización")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:_vm.filtro.Localizacion === null ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setLocalizacion(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn btn-sm",class:_vm.filtro.Localizacion === 'Con' ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setLocalizacion('Con')}}},[_vm._v("Asignada")]),_c('button',{staticClass:"btn btn-sm",class:_vm.filtro.Localizacion === 'Sin' ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setLocalizacion('Sin')}}},[_vm._v("Sin asignar")])])])])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Categoria")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.VIP === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setVIP(null)}}},[_vm._v("Todos")]),_c('button',{staticClass:"btn",class:(_vm.filtro.VIP === true) ? 'btn-warning' : '',on:{"click":function($event){return _vm.setVIP(true)}}},[_vm._v("VIP")]),_c('button',{staticClass:"btn",class:(_vm.filtro.VIP === false) ? 'btn-danger' : '',on:{"click":function($event){return _vm.setVIP(false)}}},[_vm._v("No VIP")])])])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.Estados['No Avisado']) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleEstado('No Avisado')}}},[_vm._v("No avisado")]),_c('button',{staticClass:"btn",class:(_vm.filtro.Estados.Pendiente) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleEstado('Pendiente')}}},[_vm._v("Pendiente")]),_c('button',{staticClass:"btn",class:(_vm.filtro.Estados.Entregado) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleEstado('Entregado')}}},[_vm._v("Entregada")]),_c('button',{staticClass:"btn",class:(_vm.filtro.Estados.Confirmado) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleEstado('Confirmado')}}},[_vm._v("Confirmado")]),_c('button',{staticClass:"btn",class:(_vm.filtro.Estados.Denegado) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleEstado('Denegado')}}},[_vm._v("Denegado")])])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary mr-2",on:{"click":function($event){return _vm.$emit('buscar')}}},[_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-success mr-2",on:{"click":function($event){return _vm.$emit('nuevo')}}},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Nuevo invitado")]),(_vm.filtro.EventoID)?_c('button',{staticClass:"btn btn-warning",on:{"click":_vm.verRecinto}},[_c('span',{staticClass:"fa fa-eye mr-2"}),_vm._v("Ver recinto")]):_vm._e()]),(_vm.RecintoEventoID)?_c('VerRecinto',{attrs:{"EventoID":_vm.RecintoEventoID},on:{"cerrar":function($event){_vm.RecintoEventoID = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Búsqueda")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("F")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("A")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__ = __webpack_require__(556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58f2b54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__ = __webpack_require__(1300);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d58f2b54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col text-right"},[_c('div',{staticClass:"btn-group"},[_c('download-excel',{staticClass:"btn btn-warning btn-sm",attrs:{"data":_vm.listadoXLS,"fields":_vm.json_fields,"meta":_vm.json_meta,"name":"invitados.xls"}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("XLS")]),_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.$emit('descargar')}}},[_c('span',{staticClass:"fa fa-file-pdf-o mr-2"}),_vm._v("PDF")])],1)])])]),_c('table',{staticClass:"table table-striped m-0"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('GrupoNombre')}}},[_vm._v("Grupo"),(_vm.orden.OrdenColumna === 'GrupoNombre')?_c('span',[_c('span',{staticClass:"ml-3 fa",class:(_vm.orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('Nombre')}}},[_vm._v("Nombre"),(_vm.orden.OrdenColumna === 'Nombre')?_c('span',[_c('span',{staticClass:"ml-3 fa",class:(_vm.orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('Estado')}}},[_vm._v("Estado"),(_vm.orden.OrdenColumna === 'Estado')?_c('span',[_c('span',{staticClass:"ml-3 fa",class:(_vm.orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('UsuarioNombre')}}},[_vm._v("Gestiona"),(_vm.orden.OrdenColumna === 'UsuarioNombre')?_c('span',[_c('span',{staticClass:"ml-3 fa",class:(_vm.orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('Asistentes')}}},[_vm._v("Asistentes"),(_vm.orden.OrdenColumna === 'Asistentes')?_c('span',[_c('span',{staticClass:"ml-3 fa",class:(_vm.orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('Localidades')}}},[_vm._v("Localidades"),(_vm.orden.OrdenColumna === 'Localidades')?_c('span',[_c('span',{staticClass:"ml-3 fa",class:(_vm.orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrden('Anotaciones')}}},[_vm._v("Anotaciones"),(_vm.orden.OrdenColumna === 'Anotaciones')?_c('span',[_c('span',{staticClass:"ml-3 fa",class:(_vm.orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'})]):_vm._e()]),_c('th')])]),_c('tbody',_vm._l((_vm.listado),function(invitado){return _c('tr',{key:invitado.InvitadoID,class:_vm.estiloInvitado(invitado)},[_c('td',[_vm._v(_vm._s(invitado.GrupoNombre))]),_c('td',[(invitado.VIP)?_c('b',{staticClass:"mr-3"},[_c('span',{staticClass:"fa fa-star"})]):_vm._e(),_vm._v(_vm._s(invitado.Nombre))]),_c('td',[_vm._v(_vm._s(invitado.Estado))]),_c('td',[_c('div',[_vm._v(_vm._s(invitado.UsuarioOriginalNombre))]),(invitado.UsuarioID !== invitado.UsuarioOriginalID)?_c('div',{staticStyle:{"opacity":"0.5","font-style":"italic"}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v(_vm._s(invitado.UsuarioNombre))]):_vm._e()]),_c('td',[_vm._v(_vm._s(invitado.Asistentes)),(invitado.VIP)?_c('span',{staticClass:"ml-2"},[_vm._v("("+_vm._s(invitado.VIP)+" VIP)")]):_vm._e()]),_c('td',_vm._l((invitado.Localidades),function(loc){return _c('div',{key:loc.Fila+'-'+loc.Asiento},[_c('span',[_vm._v(_vm._s(loc.FilaNombre)+": A"+_vm._s(loc.Asiento))])])}),0),_c('td',[_vm._v(_vm._s(invitado.Anotaciones))]),_c('td',[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.$emit('editar', invitado)}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editar")])])])}),0)]),_c('div',{staticClass:"card-body bg-dark text-white"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"2em"}},[_vm._v(_vm._s(_vm.listado.length)),_c('br'),_vm._v("invitados")])]),_c('div',{staticClass:"col text-center"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"2em"}},[_vm._v(_vm._s(_vm.sumaAsistentes)),_c('br'),_vm._v("asistentes")])]),_c('div',{staticClass:"col text-center"},[_c('span',{staticStyle:{"font-weight":"bold","font-size":"2em"}},[_vm._v(_vm._s(_vm.sumaVIPS)),_c('br'),_vm._v("VIPs")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(557);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1061f617_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1305);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1061f617_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localidades_vue__ = __webpack_require__(558);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d89c882_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_localidades_vue__ = __webpack_require__(1304);
function injectStyle (ssrContext) {
  __webpack_require__(1303)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d89c882"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_localidades_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d89c882_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_localidades_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',[_vm._v("Localidades")]),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_c('th',[_vm._v("Fila")]),_c('th',[_vm._v("Asiento")]),_c('th',[_vm._v("Nombre")]),_c('th',[_vm._v("Comentarios")]),_c('th',[_c('span',{staticClass:"fa fa-trash"})])])]),_c('tbody',_vm._l((_vm.invitado.Localidades),function(localidad,l){return _c('tr',{class:!localidad.Fila || !localidad.Asiento ? 'incompleta' : ''},[_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(l + 1))]),_c('td',{staticClass:"p-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitado.Localidades[l].Fila),expression:"invitado.Localidades[l].Fila"}],staticClass:"form-control form-control-sm",attrs:{"size":"5","disabled":true},domProps:{"value":(_vm.invitado.Localidades[l].Fila)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invitado.Localidades[l], "Fila", $event.target.value)}}})]),_c('td',{staticClass:"p-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitado.Localidades[l].Asiento),expression:"invitado.Localidades[l].Asiento"}],staticClass:"form-control form-control-sm",attrs:{"size":"5","disabled":true},domProps:{"value":(_vm.invitado.Localidades[l].Asiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invitado.Localidades[l], "Asiento", $event.target.value)}}})]),_c('td',{staticClass:"p-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitado.Localidades[l].Nombre),expression:"invitado.Localidades[l].Nombre"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"Opcional"},domProps:{"value":(_vm.invitado.Localidades[l].Nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invitado.Localidades[l], "Nombre", $event.target.value)}}})]),_c('td',{staticClass:"p-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitado.Localidades[l].Comentarios),expression:"invitado.Localidades[l].Comentarios"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"Opcional"},domProps:{"value":(_vm.invitado.Localidades[l].Comentarios)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invitado.Localidades[l], "Comentarios", $event.target.value)}}})]),_c('td',{staticClass:"p-1"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.borrar(l)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)]),(_vm.duplicados)?_c('div',{staticClass:"card-body bg-danger text-white"},[_c('span',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("Hay "+_vm._s(_vm.duplicados)+" asientos asignados a personas diferentes")]):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-warning btn-sm",on:{"click":function($event){_vm.mostrarRecinto = true}}},[_c('span',{staticClass:"fa fa-eye mr-2"}),_vm._v("En el mapa")])]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.cerrar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Confirmar")])])])])]),(_vm.mostrarRecinto)?_c('VerRecinto',{attrs:{"EventoID":_vm.invitado.EventoID,"objetivo":_vm.invitado.Localidades.length,"asientos":_vm.invitado.Localidades},on:{"cerrar":function($event){_vm.mostrarRecinto = false},"confirmar":function($event){return _vm.aplicarLocalizaciones($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.invitado)?_c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning text-dark"},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Invitado"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),(_vm.eventoCerrado)?_c('div',{staticClass:"alert alert-danger text-center"},[_c('span',{staticClass:"fa fa-ban"}),_c('br'),_vm._v("Este evento está cerrado")]):_vm._e(),_c('div',{staticClass:"card-body"},[(!_vm.eventoCerrado)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Evento")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitado.EventoID),expression:"invitado.EventoID"}],staticClass:"form-control",attrs:{"disabled":_vm.eventoCerrado},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invitado, "EventoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.getGrupos]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoEventos),function(evento){return _c('option',{key:evento.EventoID,domProps:{"value":evento.EventoID}},[_vm._v(_vm._s(evento.Nombre))])})],2)]):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Evento")]),_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.invitado.EventoNombre}})]),_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Grupo")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitado.GrupoID),expression:"invitado.GrupoID"}],staticClass:"form-control",attrs:{"disabled":_vm.eventoCerrado},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invitado, "GrupoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoGrupos),function(grupo){return _c('option',{key:grupo.GrupoID,domProps:{"value":grupo.GrupoID}},[_vm._v(_vm._s(grupo.Nombre))])})],2)]),_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Nombre")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitado.Nombre),expression:"invitado.Nombre"}],staticClass:"form-control",attrs:{"placeholder":"Nombre y apellidos","disabled":_vm.eventoCerrado},domProps:{"value":(_vm.invitado.Nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invitado, "Nombre", $event.target.value)}}})]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Asistentes")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.invitado.Asistentes),expression:"invitado.Asistentes",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"disabled":_vm.eventoCerrado},domProps:{"value":(_vm.invitado.Asistentes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invitado, "Asistentes", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Localidad(es)")]),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",class:_vm.localidadesCompletas != _vm.invitado.Asistentes ? 'bg-danger text-white' : 'bg-success text-white',attrs:{"disabled":true},domProps:{"value":_vm.localidadesCompletas != _vm.invitado.Asistentes ? _vm.invitado.Asistentes - _vm.localidadesCompletas + ' Pendientes' : 'Completas'}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",on:{"click":function($event){_vm.editarLocalidades = true}}},[_c('span',{staticClass:"fa fa-edit"})])])])])])]),_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Gestiona")]),_c('br'),(!_vm.invitado.UsuarioOriginalNombre)?_c('b',[_vm._v(_vm._s(_vm.usuario.nombre)+" "+_vm._s(_vm.usuario.apellidos))]):_c('b',[_vm._v(_vm._s(_vm.invitado.UsuarioOriginalNombre))])]),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitado.Estado),expression:"invitado.Estado"}],staticClass:"form-control",attrs:{"disabled":_vm.eventoCerrado},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.invitado, "Estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoEstados),function(estado){return _c('option',{key:estado,domProps:{"value":estado}},[_vm._v(_vm._s(estado))])}),0)])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Personas VIP")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.invitado.VIP),expression:"invitado.VIP",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"placeholder":"0"},domProps:{"value":(_vm.invitado.VIP)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invitado, "VIP", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])])]),_c('div',{staticClass:"form-group mt-3"},[_c('label',[_vm._v("Anotaciones")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.invitado.Anotaciones),expression:"invitado.Anotaciones"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":"Anotaciones","disabled":_vm.eventoCerrado},domProps:{"value":(_vm.invitado.Anotaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.invitado, "Anotaciones", $event.target.value)}}})])]),(!_vm.eventoCerrado)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])]):_vm._e()]),(_vm.editarLocalidades)?_c('EditorLocalidades',{attrs:{"invitado":_vm.invitado},on:{"cerrar":function($event){_vm.editarLocalidades = false}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('filtro',{attrs:{"filtro":_vm.filtro},on:{"buscar":_vm.buscar,"nuevo":function($event){_vm.editar = 'nuevo'}}}),_c('resultados',{staticClass:"mt-3",attrs:{"orden":_vm.orden,"resultados":_vm.resultados},on:{"editar":function($event){return _vm.editarInvitado($event)},"descargar":_vm.descargar}}),(_vm.editar)?_c('editor',{attrs:{"invitado-id":_vm.editar},on:{"cerrar":_vm.cerrarEditor,"guardado":_vm.guardado}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('buscador')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1309);


// Exportamos
/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('libreta', {
			name: 'Gestión de libretas',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});
	}
});

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa868cce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1321);
function injectStyle (ssrContext) {
  __webpack_require__(1310)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa868cce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa868cce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactos_vue__ = __webpack_require__(560);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8abf9d10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactos_vue__ = __webpack_require__(1320);
function injectStyle (ssrContext) {
  __webpack_require__(1312)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8abf9d10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contactos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8abf9d10_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contactos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_contacto_vue__ = __webpack_require__(561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_478efb08_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_contacto_vue__ = __webpack_require__(1314);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_contacto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_478efb08_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_contacto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contacto !== null)?_c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\tEditor de contactos\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body pt-0 pb-0"},[_c('div',{staticClass:"row mt-0 mb-0"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 text-center pt-2 pb-4"},[_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"150px","height":"150px"},attrs:{"src":_vm.avatar,"alt":"avatar"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-group mt-2"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contacto.nombre),expression:"contacto.nombre"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre"},domProps:{"value":(_vm.contacto.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contacto, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"input-group mt-2"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contacto.apellidos),expression:"contacto.apellidos"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Apellidos"},domProps:{"value":(_vm.contacto.apellidos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contacto, "apellidos", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"btn-group mt-2"},[_c('button',{staticClass:"btn",class:(_vm.contacto.genero === 'hombre') ? 'btn-primary' : '',on:{"click":function($event){_vm.contacto.genero = 'hombre'}}},[_c('span',{staticClass:"fa fa-male mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\tHombre\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn",class:(_vm.contacto.genero === 'mujer') ? 'btn-primary' : '',on:{"click":function($event){_vm.contacto.genero = 'mujer'}}},[_c('span',{staticClass:"fa fa-female mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\tMujer\n\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"form-group mt-2 text-left"},[_vm._m(3),_vm._v(" "),_c('datepicker',{attrs:{"monday-first":true,"language":_vm.$dateLang,"input-class":"form-control"},model:{value:(_vm.contacto.nacimiento),callback:function ($$v) {_vm.$set(_vm.contacto, "nacimiento", $$v)},expression:"contacto.nacimiento"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('b',[_vm._v("Libreta(s):")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){return _vm.seleccionaLibreta($event)}}},[_c('option',{attrs:{"value":"null"}},[_vm._v("Selecciona la(s) libreta(s)")]),_vm._v(" "),_vm._l((_vm.listadoLibretas),function(libreta){return _c('option',{key:libreta.ID_libreta,domProps:{"value":libreta.ID_libreta}},[_vm._v(_vm._s(libreta.nombre))])})],2),_vm._v(" "),_c('div',{staticClass:"mt-2"},_vm._l((_vm.contacto.libretas),function(libreta){return _c('button',{key:libreta.ID_libreta,staticClass:"btn btn-primary btn-sm m-2",on:{"click":function($event){return _vm.quitaLibreta(libreta.ID_libreta)}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(libreta.nombre)+"\n\t\t\t\t\t\t\t\t\t")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left bg-light pt-2 pb-2"},[_c('div',{staticClass:"card mb-3"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"card-body"},_vm._l((_vm.contacto.organizaciones),function(org,index){return _c('div',{key:index+'_'+org.ID_organizacion,staticClass:"row mt-2"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2"},[_c('div',{staticClass:"input-group"},[_vm._m(5,true),_vm._v(" "),(org.ID_organizacion === null)?_c('input-query',{staticClass:"form-control",attrs:{"input-class":"form-control m-0","url":"libreta-direcciones/php/buscaOrganizaciones.php","realtime":true},on:{"selected":function($event){return _vm.setOrganizacion(index, $event)}}}):_vm._e(),_vm._v(" "),(org.ID_organizacion !== null)?_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":"true"},domProps:{"value":org.nombre}}):_vm._e(),_vm._v(" "),(org.ID_organizacion)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){org.ID_organizacion = null}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2"},[_c('div',{staticClass:"input-group"},[_vm._m(6,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(org.cargo),expression:"org.cargo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Cargo"},domProps:{"value":(org.cargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(org, "cargo", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.contacto.organizaciones.splice(index, 1)}}},[_c('span',{staticClass:"fa fa-trash"})])])])])])}),0),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.nuevaOrganizacion()}}},[_c('span',{staticClass:"fa fa-building mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tAñadir organización\n\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"card mb-3"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"card-body"},_vm._l((_vm.contacto.telefonos),function(telefono){return _c('div',{key:telefono.ID_telefono,staticClass:"input-group mt-2"},[_vm._m(8,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(telefono.telefono),expression:"telefono.telefono"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"XXX XXX XXX"},domProps:{"value":(telefono.telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(telefono, "telefono", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append",on:{"click":function($event){return _vm.quitaTelefono(telefono)}}},[_vm._m(9,true)])])}),0),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.nuevoTelefono()}}},[_c('span',{staticClass:"fa fa-w fa-phone mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tAñadir teléfono\n\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"card mb-3"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"card-body"},_vm._l((_vm.contacto.emails),function(email){return _c('div',{key:email.ID_email,staticClass:"input-group mt-2"},[_vm._m(11,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(email.email),expression:"email.email"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"alguien@algo"},domProps:{"value":(email.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(email, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append",on:{"click":function($event){return _vm.quitaEmail(email)}}},[_vm._m(12,true)])])}),0),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.nuevoEmail()}}},[_c('span',{staticClass:"fa fa-w fa-envelope mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tAñadir email\n\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"card mb-3"},[_vm._m(13),_vm._v(" "),_vm._l((_vm.contacto.direcciones),function(direccion,index){return _c('div',{key:direccion.ID_direccion,staticClass:"card-body",class:(index % 2 === 0) ? 'bg-light' : ''},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("País")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.pais),expression:"direccion.pais"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"País"},domProps:{"value":(direccion.pais)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "pais", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Comunidad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.comunidad),expression:"direccion.comunidad"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Comunidad"},domProps:{"value":(direccion.comunidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "comunidad", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Localidad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.localidad),expression:"direccion.localidad"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Localidad"},domProps:{"value":(direccion.localidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "localidad", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm mt-2 mb-2"},[_vm._m(14,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.calle),expression:"direccion.calle"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre de la calle"},domProps:{"value":(direccion.calle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "calle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"mb-2 col-xs-12 col-sm-6 col-md-5 col-lg-3 col-xl-3"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(15,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.cp),expression:"direccion.cp"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(direccion.cp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "cp", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-2 col-xs-12 col-sm-6 col-md-3 col-lg-2 col-xl-2"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(16,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.numero),expression:"direccion.numero"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(direccion.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "numero", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-2 col-xs-12 col-sm-6 col-md-4 col-lg-2 col-xl-2"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(17,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.portal),expression:"direccion.portal"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(direccion.portal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "portal", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-2 col-xs-12 col-sm-6 col-md-6 col-lg-2 col-xl-2"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(18,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.piso),expression:"direccion.piso"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(direccion.piso)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "piso", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"mb-2 col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(19,true),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(direccion.puerta),expression:"direccion.puerta"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(direccion.puerta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "puerta", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Comentarios")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(direccion.comentarios),expression:"direccion.comentarios"}],staticClass:"form-control",attrs:{"name":"comentarios","id":"","rows":"5"},domProps:{"value":(direccion.comentarios)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(direccion, "comentarios", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.quitarDireccion(direccion)}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tQuitar\n\t\t\t\t\t\t\t\t\t")])])}),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.nuevaDireccion()}}},[_c('span',{staticClass:"fa fa-w fa-map mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tAñadir dirección\n\t\t\t\t\t\t\t\t\t")])])],2)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-w fa-save mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t")]),_vm._v(" "),(_vm.contacto.ID_registro)?_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.eliminar()}}},[_c('span',{staticClass:"fa fa-w fa-trash mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\tEliminar\n\t\t\t\t\t\t\t")]):_vm._e()])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-2 mb-2"},[_c('button',{staticClass:"btn btn-sm btn-primary"},[_c('span',{staticClass:"fa fa-photo mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\tSubir foto\n\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-w fa-edit"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-w fa-edit"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":""}},[_c('b',[_vm._v("Fecha de nacimiento")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-building mr-2"}),_vm._v(" "),_c('b',[_vm._v("Organizaciónes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-w fa-building"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-w fa-suitcase"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-phone mr-2"}),_vm._v(" "),_c('b',[_vm._v("Teléfonos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-w fa-phone"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger"},[_c('span',{staticClass:"fa fa-w fa-trash"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-phone mr-2"}),_vm._v(" "),_c('b',[_vm._v("E-mails")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-w fa-envelope"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger"},[_c('span',{staticClass:"fa fa-w fa-trash"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-map mr-2"}),_vm._v(" "),_c('b',[_vm._v("Direcciones")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tVía\n\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tC.P.\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tNº\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tEsc\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tPiso\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tPuerta\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_registro_vue__ = __webpack_require__(562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9b45f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_registro_vue__ = __webpack_require__(1316);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_registro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9b45f8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_registro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.registro !== null)?_c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\tDetalles\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row p-0",staticStyle:{"margin-top":"-15px"}},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12-col-lg-4 col-xl-3 pt-2 text-left"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"110px","height":"110px"},attrs:{"src":_vm.avatar}}),_vm._v(" "),_c('div',{staticClass:"mt-2"},[_c('h4',[_vm._v(_vm._s(_vm.registro.nombre)+" "+_vm._s(_vm.registro.apellidos))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b',[_vm._v("Aparece en las libretas:")]),_vm._v(" "),_vm._l((_vm.registro.libretas),function(libreta){return _c('div',{key:libreta.ID_libreta,staticClass:"text-info mt-2",staticStyle:{"font-weight":"bold"}},[_c('span',{staticClass:"fa fa-address-book mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(libreta.nombre)+"\n\t\t\t\t\t\t\t")])})],2),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12-col-lg-8 col-xl-9 bg-light pt-2 pb-2 text-left"},[(_vm.registro.organizaciones.length > 0)?_c('div',{staticClass:"card mb-3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},_vm._l((_vm.registro.organizaciones),function(org){return _c('div',{key:org.ID_organizacion},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(org.cargo)+" en "+_vm._s(org.nombre)+"\n\t\t\t\t\t\t\t\t\t")])}),0)]):_vm._e(),_vm._v(" "),(_vm.registro.telefonos.length > 0)?_c('div',{staticClass:"card mb-3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},_vm._l((_vm.registro.telefonos),function(tel){return _c('div',{key:tel.ID_telefono,staticClass:"mb-2"},[_c('span',{staticClass:"fa fa-phone mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(tel.telefono)+"\n\t\t\t\t\t\t\t\t\t")])}),0)]):_vm._e(),_vm._v(" "),(_vm.registro.emails.length > 0)?_c('div',{staticClass:"card mb-3"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-body"},_vm._l((_vm.registro.emails),function(email){return _c('div',{key:email.ID_email,staticClass:"mb-2"},[_c('span',{staticClass:"fa fa-envelope mr-2"}),_vm._v(" "),_c('a',{attrs:{"href":'mailto:' + email.email}},[_vm._v(_vm._s(email.email))])])}),0)]):_vm._e(),_vm._v(" "),(_vm.registro.direcciones.length > 0)?_c('div',{staticClass:"card mb-3"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-body"},_vm._l((_vm.registro.direcciones),function(direccion,index){return _c('div',{key:direccion.ID_direccion,staticClass:"mb-4"},[_c('h3',[_vm._v("Dirección #"+_vm._s((index + 1)))]),_vm._v("\n\t\t\t\t\t\t\t\t\t\t"+_vm._s(direccion.tipo)+". "+_vm._s(direccion.calle)+", nº "+_vm._s(direccion.numero || 'N/D')+".\n\t\t\t\t\t\t\t\t\t\t"),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t\tC.P. "+_vm._s(direccion.cp)+" - "+_vm._s(direccion.localidad)+" "+_vm._s(direccion.provincia)+"\n\t\t\t\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(direccion.comunidad)+" ("+_vm._s(direccion.pais)+")")])])}),0)]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.editar()}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("\n\t\t\t\t\t\tEditar\n\t\t\t\t\t")])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-building mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\tOrganización\n\t\t\t\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-phone mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\tTeléfonos\n\t\t\t\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-envelope mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\tE-mails\n\t\t\t\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-map mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\tDirecciones\n\t\t\t\t\t\t\t\t")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestion_libretas_vue__ = __webpack_require__(563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff997aea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gestion_libretas_vue__ = __webpack_require__(1319);
function injectStyle (ssrContext) {
  __webpack_require__(1318)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff997aea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestion_libretas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff997aea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gestion_libretas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white text-left"},[_vm._v("\n\t\t\t\t\tGestión de libretas\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body pt-0 pb-0"},[_c('div',{staticClass:"row p-0"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 p-0 text-left",staticStyle:{"border-right":"1px solid #e0e0e0"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-condensed table-striped m-0"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.listadoLibretas),function(libreta){return _c('tr',{key:libreta.ID_libreta,class:(_vm.ID_libreta === libreta.ID_libreta) ? 'activa fila' : 'fila',on:{"click":function($event){return _vm.setLibreta(libreta.ID_libreta)}}},[_c('td',[_c('span',{staticClass:"fa fa-address-book mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(libreta.nombre)+"\n\t\t\t\t\t\t\t\t\t\t\t")])])}),0)])])]),_vm._v(" "),(_vm.libreta)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 bg-light p-3 text-left"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.libreta.nombre),expression:"libreta.nombre"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.libreta.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.libreta, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Descripción")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.libreta.descripcion),expression:"libreta.descripcion"}],staticClass:"form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.libreta.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.libreta, "descripcion", $event.target.value)}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('table',{staticClass:"table table-condensed bg-white table-striped",staticStyle:{"border":"1px solid #e0e0e0"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('input-query',{staticClass:"form-control",attrs:{"input-class":"form-control","realtime":true,"url":"libreta-direcciones/php/buscaUsuariosGrupos.php","placeholder":"Busca un usuario o un grupo"},on:{"selected":function($event){return _vm.nuevoPermiso($event)}}})],1)])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.listadoPermisos),function(permiso){return _c('tr',{key:permiso.tipo+'_'+permiso.ID},[_c('td',[_c('span',{staticClass:"fa fa-w mr-2",class:(permiso.tipo === 'grupo') ? 'fa-users' : 'fa-user'}),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(permiso.nombre)+"\n\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(permiso.escritura) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.toggleEscritura(permiso.tipo, permiso.ID)}}},[_c('span',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaPermiso(permiso.tipo, permiso.ID)}}},[_c('span',{staticClass:"fa fa-trash"})])])])])}),0)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tGuardar\n\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-block btn-danger",on:{"click":function($event){return _vm.eliminar()}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tEliminar\n\t\t\t\t\t\t\t\t\t")])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.nueva()}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("\n\t\t\t\t\t\tNueva libreta\n\t\t\t\t\t")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Selecciona libreta")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('b',[_vm._v("Información básica")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('b',[_vm._v("Permisos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("\n\t\t\tBuscar contactos\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('b',[_vm._v("Nombre/apellidos/teléfono/email")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.nombre),expression:"filtro.nombre"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nombre del contacto a buscar"},domProps:{"value":(_vm.filtro.nombre)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "nombre", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b',[_vm._v("Cargo")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cargo),expression:"filtro.cargo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Cargo que ostenta"},domProps:{"value":(_vm.filtro.cargo)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cargo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('b',[_vm._v("Organización")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.organizacion),expression:"filtro.organizacion"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Organización a la que pertenece"},domProps:{"value":(_vm.filtro.organizacion)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "organizacion", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('b',[_vm._v("Libreta")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(3),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.ID_libreta),expression:"filtro.ID_libreta"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "ID_libreta", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.buscar()}]}},[_c('option',{domProps:{"value":null}},[_vm._v("En todas las libretas")]),_vm._v(" "),_vm._l((_vm.listadoLibretas),function(libreta){return _c('option',{key:libreta.ID_libreta,domProps:{"value":libreta.ID_libreta}},[_vm._v(_vm._s(libreta.nombre))])})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},[_c('b',[_vm._v("Ordenación")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.filtro.ordenar),function(dimension,index){return _c('div',{key:dimension.id,staticClass:"capaOrdenacion"},[_c('div',{staticClass:"input-group"},[(index > 0)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.filtro.ordenar.splice(index, 1)}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.ordenar[index].campo),expression:"filtro.ordenar[index].campo"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro.ordenar[index], "campo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}}),_vm._v(" "),_vm._l((_vm.listadoCamposOrdena),function(campo){return _c('option',{key:campo.campo,domProps:{"value":campo.campo}},[_vm._v(_vm._s(campo.nombre))])})],2),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(dimension.tipo === 'asc') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.ordenar[index].tipo = 'asc'}}},[_vm._v("\n\t\t\t\t\t\t\tASC\n\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn",class:(dimension.tipo === 'desc') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.filtro.ordenar[index].tipo = 'desc'}}},[_vm._v("\n\t\t\t\t\t\t\tDESC\n\t\t\t\t\t\t")]),_vm._v(" "),(index === _vm.filtro.ordenar.length - 1)?_c('button',{staticClass:"ml-3 btn btn-warning",on:{"click":function($event){return _vm.filtro.ordenar.push({tipo: 'asc', campo: 'nombre'})}}},[_c('span',{staticClass:"fa fa-plus"})]):_vm._e()])])])})],2),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.buscar()}}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("\n\t\t\t\t\t\tBuscar\n\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.nuevoContacto()}}},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("\n\t\t\t\t\t\tNuevo contacto\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-info",on:{"click":function($event){_vm.gestion_libretas = true}}},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("\n\t\t\t\t\t\tGestionar libretas\n\t\t\t\t\t")])])])])]),_vm._v(" "),(_vm.contacto)?_c('editor-contacto',{attrs:{"datos":_vm.contacto},on:{"cerrar":function($event){_vm.contacto = null}}}):_vm._e(),_vm._v(" "),(_vm.detalles)?_c('detalles-registro',{attrs:{"idregistro":_vm.detalles},on:{"cerrar":function($event){_vm.detalles = null},"editar":function($event){return _vm.editar($event)}}}):_vm._e(),_vm._v(" "),(_vm.gestion_libretas)?_c('gestion-libretas',{on:{"cerrar":function($event){_vm.gestion_libretas = false}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card mt-2"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("\n\t\t\tResutados\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-condensed table-striped m-0"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.resultados),function(registro){return _c('tr',{key:registro.ID_registro},[_c('td',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(registro.nombre)+"\n\t\t\t\t\t\t\t"+_vm._s(registro.apellidos)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',_vm._l((registro.organizaciones),function(org){return _c('div',{key:org.ID_organizacion},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(org.cargo)+" en "+_vm._s(org.nombre)+"\n\t\t\t\t\t\t\t")])}),0),_vm._v(" "),_c('td',[(registro.telefonos.length > 0)?_c('div',[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(registro.telefonos[0].telefono)+"\n\t\t\t\t\t\t\t")]):_vm._e()]),_vm._v(" "),_c('td',[(registro.emails.length > 0)?_c('div',[_c('a',{attrs:{"href":'mailto:'+registro.emails[0].email}},[_vm._v(_vm._s(registro.emails[0].email))])]):_vm._e()]),_vm._v(" "),_c('td',_vm._l((registro.libretas),function(libreta){return _c('div',{key:libreta.ID_libreta},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(libreta.nombre)+"\n\t\t\t\t\t\t\t")])}),0),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.detalles = registro.ID_registro}}},[_c('span',{staticClass:"fa fa-eye"})])])])}),0)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-list"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Nombre")]),_vm._v(" "),_c('th',[_vm._v("Organización")]),_vm._v(" "),_c('th',[_vm._v("Teléfono")]),_vm._v(" "),_c('th',[_vm._v("E-mail")]),_vm._v(" "),_c('th',[_vm._v("Libreta(s)")]),_vm._v(" "),_c('th',[_vm._v("Opciones")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('seccion-contactos')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listado_index__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contrato_index__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_visor_contrato_visor_contrato__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_vue_store_stores__ = __webpack_require__(32);








/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_6__core_vue_store_stores__["a" /* default */].registerModule('mis-contratos', __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]);
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('contratos', {
			name: 'Contratos',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('contratos').child('listado', {
			name: 'Listado de contratos',
			component: __WEBPACK_IMPORTED_MODULE_2__components_listado_index__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('contratos').child('listado/:id', {
			name: 'Detalle del contrato',
			component: __WEBPACK_IMPORTED_MODULE_2__components_listado_index__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('contratos').child('editar', {
			name: 'Editor de contratos',
			component: __WEBPACK_IMPORTED_MODULE_3__components_contrato_index__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('contratos').child('ver', {
			name: 'Visor de contratos',
			component: __WEBPACK_IMPORTED_MODULE_4__components_visor_contrato_visor_contrato__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('contratos').child('ver').child(':id', {
			name: 'Visor de contratos',
			component: __WEBPACK_IMPORTED_MODULE_4__components_visor_contrato_visor_contrato__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('contratos').child('editar').child(':id', {
			name: 'Editor de contratos',
			component: __WEBPACK_IMPORTED_MODULE_3__components_contrato_index__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('contratos').child('editar').child(':id', {
			name: 'Editor de contratos',
			component: __WEBPACK_IMPORTED_MODULE_3__components_contrato_index__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('contratos').child('editar').child(':id').child(':vista', {
			name: 'Editor de contratos (detalles)',
			component: __WEBPACK_IMPORTED_MODULE_3__components_contrato_index__["a" /* default */]
		});
	}
});

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(564);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec66e16a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1336);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec66e16a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39de6a5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1332);
function injectStyle (ssrContext) {
  __webpack_require__(1326)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39de6a5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editar_facturacion_vue__ = __webpack_require__(568);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9e0d578_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editar_facturacion_vue__ = __webpack_require__(1329);
function injectStyle (ssrContext) {
  __webpack_require__(1328)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editar_facturacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9e0d578_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editar_facturacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[(_vm.datos.tipo === 'radio')?_c('span',[_vm._v(_vm._s(_vm.datos.linea.descripcion))]):_vm._e(),(_vm.datos.tipo === 'otros')?_c('span',[_vm._v(_vm._s(_vm.datos.linea.concepto))]):_vm._e(),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{staticClass:"row",staticStyle:{"padding":"0","margin":"0"}},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6 fondoGris"},[_c('h2',{staticClass:"mt-3 text-info"},[_vm._v("Total")]),_c('h1',{staticClass:"text-info",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.importeTotal,'€')))]),_c('h2',{staticClass:"mt-3 text-danger"},[_vm._v("Pendiente")]),_c('h1',{staticClass:"text-danger",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.importePendiente,'€')))]),_c('hr'),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Día de cobro")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.diaFactura),expression:"diaFactura"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.diaFactura=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.cambiaDia()}]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((Array(31)),function(dia,index){return _c('option',{key:index,domProps:{"value":index + 1}},[_vm._v(_vm._s((index + 1)))])})],2)]),_c('p',{staticClass:"text-right"}),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.reset()}}},[_vm._v("Reset")]),_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.distribuir()}}},[_vm._v("Distribuír")])]),_c('p')]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"calendario"}},[_vm._v("Activa un año")]),_c('br'),_c('div',{staticClass:"btn-group"},_vm._l((_vm.listadoAnos),function(ano){return _c('button',{class:_vm.claseAno(ano),attrs:{"type":"button","disabled":!_vm.anoActivo(ano)},on:{"click":function($event){return _vm.toggleAno(ano)}}},[_vm._v(_vm._s(ano))])}),0)]),_c('table',{staticClass:"table table-striped"},[_c('tbody',_vm._l((_vm.anosActivos),function(ano){return _c('tr',[_c('td',[_c('b',[_vm._v(_vm._s(ano))]),_c('br'),_vm._l(([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),function(mes){return _c('button',{class:_vm.getClaseMes(ano, mes),attrs:{"type":"button","disabled":_vm.mesCerrado(ano, mes)},on:{"click":function($event){return _vm.toggleMes(ano, mes)}}},[_vm._v(_vm._s(_vm.meses[mes]))])})],2)])}),0)]),(_vm.datos.linea.pagos.length > 0)?_c('table',{staticClass:"table table-striped"},[_vm._m(0),_c('tbody',_vm._l((_vm.datos.linea.pagos),function(pago,index){return _c('tr',[_c('td',[_vm._v(_vm._s(pago.dia)+" de "+_vm._s(_vm.meses[pago.mes])+" de "+_vm._s(pago.ano))]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(pago.importe),expression:"pago.importe",modifiers:{"number":true}}],staticClass:"form-control input-sm",attrs:{"type":"number","disabled":_vm.mesCerrado(pago.ano, pago.mes)},domProps:{"value":(pago.importe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(pago, "importe", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',[_c('button',{staticClass:"btn btn-xs btn-danger",attrs:{"type":"button","disabled":_vm.mesCerrado(pago.ano, pago.mes)},on:{"click":function($event){return _vm.datos.linea.pagos.splice(index, 1)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)]):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Importe")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_repartirImportes_vue__ = __webpack_require__(569);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f03c1cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_repartirImportes_vue__ = __webpack_require__(1331);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_repartirImportes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f03c1cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_repartirImportes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("\n\t\t\t\t\tRepartir todos los importes\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},_vm._l((_vm.listaAnos),function(ano){return _c('div',{key:ano,staticClass:"col text-center"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-light"},[_c('b',[_vm._v(_vm._s(ano))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},_vm._l((_vm.listaMeses),function(mes){return _c('div',{key:mes,staticClass:"col-4"},[_c('button',{staticClass:"btn btn-block btn-sm m-1",class:_vm.claseMes(ano, mes),attrs:{"disabled":ano < _vm.cerrado.ano || (ano === _vm.cerrado.ano && mes <= _vm.cerrado.mes)},on:{"click":function($event){return _vm.toggleMes(ano, mes)}}},[_vm._v(_vm._s(_vm.meses[mes]))])])}),0)])])])}),0),_vm._v(" "),_c('div',{staticClass:"form-group mt-2"},[_c('label',{attrs:{"for":""}},[_vm._v("Día de cobro")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.diaFactura),expression:"diaFactura"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.diaFactura=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._v(" "),_vm._l((Array(31)),function(dia,index){return _c('option',{key:index + 1,domProps:{"value":index + 1}},[_vm._v(_vm._s(index + 1))])})],2)])]),_vm._v(" "),(_vm.mesesSeleccionados.length > 0 && _vm.diaFactura)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.repartir()}}},[_vm._v("Distribuír todos")])]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header",class:(_vm.sinAgente) ? 'bg-danger text-white' : ''},[_vm._v("Editor de contratos"),(_vm.sinAgente)?_c('span',{staticStyle:{"font-weight":"bolder"}},[_c('span',{staticClass:"fa fa-exclamation-triangle ml-2 mr-2"}),_vm._v("Contrato sin agente")]):_vm._e(),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{staticClass:"filaGris"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-4 col-lg-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),(_vm.permisos.contratos_crearAjenos)?_c('div',{staticClass:"input-group"},[_vm._m(0),(!_vm.contrato.agente && !_vm.sinAgente)?_c('input-query',{attrs:{"placeholder":"Busca por agente","input-class":"form-control","realtime":true,"url":"mis-contratos/php/api/buscaAgente.php"},on:{"selected":function($event){return _vm.seleccionaAgente($event)}}}):_vm._e(),(_vm.contrato.agente)?_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.contrato.nombreAgente}}):_vm._e(),(_vm.contrato.agente && !_vm.contrato.antiguo)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-xs btn-danger",on:{"click":function($event){return _vm.cambiaAgente()}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e(),(_vm.sinAgente)?_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":"","value":"Contrato sin agente"}}):_vm._e(),(_vm.permisos.contratos_crearContratosSinAgente)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:(_vm.sinAgente) ? 'btn-danger' : 'btn-success',on:{"click":function($event){_vm.sinAgente = !_vm.sinAgente}}},[(!_vm.sinAgente)?_c('span',{staticClass:"fa fa-toggle-on"}):_vm._e(),(_vm.sinAgente)?_c('span',{staticClass:"fa fa-toggle-off"}):_vm._e()])]):_vm._e()],1):_vm._e(),(!_vm.permisos.contratos_crearAjenos)?_c('input',{staticClass:"form-control-sm form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.usuario.nombre}}):_vm._e()])]),_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-4 col-lg-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cliente")]),_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(1),(!_vm.contrato.cliente)?_c('input-query',{attrs:{"disabled":!_vm.contrato.agente && !_vm.sinAgente,"placeholder":"Busca por cliente","input-class":"form-control","realtime":true,"url":'mis-contratos/php/api/buscaCliente.php?agente=' + _vm.contrato.agente},on:{"selected":function($event){return _vm.seleccionaCliente($event)}}}):_vm._e(),(_vm.contrato.cliente)?_c('input',{staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.contrato.nombreCliente}}):_vm._e(),(_vm.contrato.cliente && !_vm.contrato.antiguo)?_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-xs btn-danger",on:{"click":function($event){return _vm.cambiaCliente()}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()],1)])]),_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-4 col-lg-4"},[_c('div',{staticClass:"form-group form-group-sm"},[_c('label',[_vm._v("Facturar a ")]),(!_vm.contrato.destino)?_c('select',{staticClass:"form-control form-control-sm",on:{"change":function($event){return _vm.setDestino($event)}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoDestinos),function(destino){return _c('option',{domProps:{"value":destino.ID_destino}},[_vm._v(_vm._s(destino.nombre))])})],2):_vm._e(),(_vm.contrato.destino)?_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.contrato.nombreDestino}}),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){_vm.contrato.destino = null}}},[_c('span',{staticClass:"fa fa-trash"})])])]):_vm._e()])])])]),(_vm.contrato.cliente && _vm.contrato.destino)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-3 col-md-3 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Título de la campaña")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.titulo),expression:"contrato.titulo"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","name":"","disabled":_vm.contrato.antiguo},domProps:{"value":(_vm.contrato.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato, "titulo", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-3 col-md-3 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de inicio")]),_c('datepicker',{attrs:{"input-class":"form-control form-control-sm","language":_vm.$dateLang,"monday-first":true,"disabled-picker":_vm.contrato.antiguo},model:{value:(_vm.contrato.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.contrato, "fecha_inicio", $$v)},expression:"contrato.fecha_inicio"}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-3 col-md-3 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de finalización")]),_c('datepicker',{attrs:{"input-class":"form-control form-control-sm","language":_vm.$dateLang,"monday-first":true,"disabled-picker":_vm.contrato.antiguo},model:{value:(_vm.contrato.fecha_fin),callback:function ($$v) {_vm.$set(_vm.contrato, "fecha_fin", $$v)},expression:"contrato.fecha_fin"}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-3 col-md-3 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Descuento global")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.contrato.dto_global),expression:"contrato.dto_global",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"type":"number","placeholder":"0"},domProps:{"value":(_vm.contrato.dto_global)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato, "dto_global", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])])]),_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-4 col-lg-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Partida")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.partida),expression:"contrato.partida"}],staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.contrato.antiguo},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contrato, "partida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona una partida")]),_vm._l((_vm.listadoPartidas),function(partida){return _c('option',{domProps:{"value":partida.ID_partida}},[_vm._v(_vm._s(partida.titulo))])})],2)])]),_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-4 col-lg-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Evento")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.evento),expression:"contrato.evento"}],staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.contrato.antiguo},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contrato, "evento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona un evento")]),_vm._l((_vm.listadoEventos),function(evento){return _c('option',{domProps:{"value":evento.ID_evento}},[_vm._v(_vm._s(evento.titulo))])})],2)])]),_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-4 col-lg-4"},[(_vm.permisos.contratos_seleccionarIntermediarios)?_c('div',[_c('div',{staticClass:"form-group from-group-sm"},[_c('label',{attrs:{"for":""}},[_vm._v("Intermediario")]),(!_vm.creandoIntermediario && !_vm.contrato.intermediario)?_c('div',{staticClass:"input-group"},[_c('input-query',{attrs:{"placeholder":"Busca un intermediario","input-class":"form-control form-control-sm","realtime":true,"url":'mis-contratos/php/api/buscaIntermediario.php'},on:{"selected":function($event){return _vm.seleccionaIntermediario($event)}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.creandoIntermediario = true}}},[_c('span',{staticClass:"fa fa-plus"})])])],1):_vm._e(),(_vm.creandoIntermediario)?_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nuevoIntermediario),expression:"nuevoIntermediario"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Escribe el nombre y pulsa intro"},domProps:{"value":(_vm.nuevoIntermediario)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.crearIntermediario()},"input":function($event){if($event.target.composing){ return; }_vm.nuevoIntermediario=$event.target.value}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){_vm.creandoIntermediario = false}}},[_c('span',{staticClass:"fa fa-close"})])])]):_vm._e(),(_vm.contrato.intermediario)?_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.intermediarioNombre),expression:"contrato.intermediarioNombre"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.contrato.intermediarioNombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato, "intermediarioNombre", $event.target.value)}}}),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){_vm.contrato.intermediario = null}}},[_c('span',{staticClass:"fa fa-trash"})])])]):_vm._e()])]):_vm._e()])])]):_vm._e(),(_vm.contrato.cliente && !_vm.contrato.antiguo && _vm.contrato.destino)?_c('div',{staticClass:"alert alert-info",staticStyle:{"border-radius":"0"}},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.nuevaLinea()}}},[_c('span',{staticClass:"fa fa-plus"})])]),_c('b',[_vm._v("Añade los productos")]),_c('br'),_vm._v("A continuación puedes añadir los productos que va a contratar el cliente")]):_vm._e(),_c('div',{staticClass:"contieneLineasTarifas"},[(_vm.contrato.lineas.length > 0)?_c('div',{staticClass:"lineaTarifa"},[_c('div',{staticClass:"celdaDescripcion"},[_vm._v("Descripción")]),_c('div',{staticClass:"celdaCantidad"},[_vm._v("Cantidad")]),_c('div',{staticClass:"celdaDto"},[_vm._v("Descuento")]),_c('div',{staticClass:"celdaForzado"},[_vm._v("P. trucado")]),_c('div',{staticClass:"celdaImporte"},[_vm._v("Importe")]),_c('div',{staticClass:"celdaDistribuir"})]):_vm._e(),_vm._l((_vm.contrato.lineas),function(linea,index){return _c('div',{staticClass:"lineaTarifa"},[_c('div',{staticClass:"celdaDescripcion"},[(!linea.tarifa)?_c('input-query',{attrs:{"url":"/mis-contratos/php/api/busca-productos.php","realtime":true,"inputClass":"form-control"},on:{"selected":function($event){return _vm.seleccionaTarifaNueva(_vm.contrato.lineas[index], $event)}}}):_vm._e(),(linea.tarifa)?_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":"true"},domProps:{"value":linea.descripcion}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.contrato.lineas[index].tarifa = null}}},[_c('span',{staticClass:"fa fa-trash"})])])]):_vm._e()],1),_c('div',{staticClass:"celdaCantidad"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.lineas[index].cantidad),expression:"contrato.lineas[index].cantidad"}],staticClass:"form-control",attrs:{"disabled":!linea.tarifa},domProps:{"value":(_vm.contrato.lineas[index].cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.lineas[index], "cantidad", $event.target.value)}}})]),_c('div',{staticClass:"celdaDto"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.lineas[index].descuento),expression:"contrato.lineas[index].descuento"}],staticClass:"form-control",attrs:{"disabled":!linea.tarifa},domProps:{"value":(_vm.contrato.lineas[index].descuento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.lineas[index], "descuento", $event.target.value)}}})]),_c('div',{staticClass:"celdaForzado"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.lineas[index].precio_trucado),expression:"contrato.lineas[index].precio_trucado"}],staticClass:"form-control",attrs:{"disabled":!linea.tarifa || !linea.cantidad},domProps:{"value":(_vm.contrato.lineas[index].precio_trucado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.lineas[index], "precio_trucado", $event.target.value)}}})]),_c('div',{staticClass:"celdaImporte"},[_vm._v(_vm._s(_vm._f("currency")(_vm.getImporte(linea),'€')))]),_c('div',{staticClass:"celdaDistribuir"},[(!_vm.contrato.antiguo)?_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.abrirFacturacion('radio', linea)}}},[_vm._v(_vm._s(_vm._f("currency")(_vm.calculaPagos(linea),'€')))]),_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.quitaLinea(index, linea)}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()])])})],2),(_vm.contrato.cliente && !_vm.contrato.antiguo && _vm.contrato.destino)?_c('div',{staticClass:"alert alert-success",staticStyle:{"border-radius":"0"}},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.nuevoConcepto()}}},[_c('span',{staticClass:"fa fa-plus"})])]),_c('b',[_vm._v("Otros conceptos")]),_c('br'),_vm._v("Puedes añadir otro tipo de conceptos, como recargo por producción, fijación horaria, etc.")]):_vm._e(),(_vm.contrato.lineasConceptos.length > 0 && _vm.contrato.cliente && !_vm.contrato.antiguo && _vm.contrato.destino)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped"},[_vm._m(2),_c('tbody',_vm._l((_vm.contrato.lineasConceptos),function(item,index){return _c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.concepto),expression:"item.concepto"}],staticClass:"form-control-sm form-control",attrs:{"type":"text","placeholder":"Fijación horaria"},domProps:{"value":(item.concepto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "concepto", $event.target.value)}}})]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.lineasConceptos[index].soporte),expression:"contrato.lineasConceptos[index].soporte"}],staticClass:"form-control form-control-sm",attrs:{"disabled":!item.concepto,"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contrato.lineasConceptos[index], "soporte", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoSoportes),function(soporte){return _c('option',{domProps:{"value":soporte.ID_soporte}},[_vm._v(_vm._s(soporte.soporte))])})],2)]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.precio_unitario),expression:"item.precio_unitario"}],staticClass:"form-control-sm form-control",attrs:{"disabled":!item.soporte,"type":"number","placeholder":"60"},domProps:{"value":(item.precio_unitario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "precio_unitario", $event.target.value)}}})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.cantidad),expression:"item.cantidad"}],staticClass:"form-control-sm form-control",attrs:{"disabled":!item.precio_unitario,"type":"number","placeholder":"1"},domProps:{"value":(item.cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "cantidad", $event.target.value)}}})]),_c('td',[(!item.precio_trucado)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.descuento),expression:"item.descuento"}],staticClass:"form-control-sm form-control",attrs:{"disabled":!item.cantidad,"type":"number","placeholder":"20"},domProps:{"value":(item.descuento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "descuento", $event.target.value)}}}):_vm._e(),(item.precio_trucado)?_c('input',{staticClass:"form-control-sm form-control",attrs:{"disabled":"","type":"number","placeholder":"20"},domProps:{"value":_vm.calculaDescuentoConcepto(item)}}):_vm._e()]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.precio_trucado),expression:"item.precio_trucado"}],staticClass:"form-control-sm form-control",attrs:{"disabled":!item.cantidad,"type":"number"},domProps:{"value":(item.precio_trucado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "precio_trucado", $event.target.value)}}})]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.getImporteConcepto(item),'€')))]),_c('td',{staticStyle:{"min-width":"150px"}},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.abrirFacturacion('otros', item)}}},[_vm._v(_vm._s(_vm._f("currency")(_vm.calculaPagos(item),'€')))]),_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.quitaLinea(index, item)}}},[_c('span',{staticClass:"fa fa-trash"})])])])])}),0)])]):_vm._e(),(_vm.contrato.cliente && !_vm.contrato.antiguo && _vm.contrato.destino)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"Comentarios"}},[_vm._v("Comentarios")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.comentarios),expression:"contrato.comentarios"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":"Escribe los comentarios que consideres necesarios"},domProps:{"value":(_vm.contrato.comentarios)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato, "comentarios", $event.target.value)}}})])]):_vm._e(),(_vm.contrato.cliente && _vm.contrato.antiguo && _vm.contrato.destino)?_c('div',{staticClass:"alert alert-info",staticStyle:{"border-radius":"0"}},[_c('b',[_vm._v("Contrato antiguo")]),_c('p',[_vm._v("A continuación tienes el desglose de pagos.")]),_c('p',[_vm._v("Este es un contrato creado con la herramienta anterior, por lo que no es posible obtener un desglose por líneas.")]),_c('p',[_vm._v("En su lugar te mostramos un detalle de los pagos por soporte y mes")])]):_vm._e(),(_vm.contrato.antiguo)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped"},[_vm._m(3),_c('tbody',_vm._l((_vm.contrato.pagosAntiguos),function(pago){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.meses[pago.mes])+" de "+_vm._s(pago.ano))]),_c('td',[_vm._v(_vm._s(pago.nombreSoporte))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(pago.importe,'€')))])])}),0)])]):_vm._e(),_c('div',{staticClass:"card-footer"},[(_vm.contratoValido && !_vm.contrato.antiguo)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.guardar()}}},[_vm._v("Guardar")]):_vm._e(),(!_vm.contratoValido && !_vm.contrato.antiguo)?_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button","disabled":""}},[_vm._v("Faltan cantidades por facturar")]):_vm._e(),(!_vm.contrato.antiguo && _vm.contrato.destino)?_c('button',{staticClass:"btn btn-sm btn-dark",on:{"click":function($event){return _vm.setRepartirTodo()}}},[_vm._v("Repartir todo")]):_vm._e(),(_vm.contrato.antiguo)?_c('button',{staticClass:"btn btn-info btn-sm",attrs:{"disabled":""}},[_vm._v("Los contratos antiguos no se pueden editar")]):_vm._e()])])]),(_vm.facturacion)?_c('editar-facturacion',{attrs:{"datos":_vm.facturacion,"cliente":_vm.infoCliente},on:{"cerrar":function($event){return _vm.cerrarFacturacion()}}}):_vm._e()],1),(_vm.verRepartirTodo)?_c('repartir-todos',{attrs:{"contrato":_vm.contrato,"cliente":_vm.infoCliente},on:{"update:contrato":function($event){_vm.contrato=$event},"cerrar":function($event){_vm.verRepartirTodo = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text fa fa-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text fa fa-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Concepto")]),_c('th',[_vm._v("Soporte")]),_c('th',[_vm._v("Importe")]),_c('th',[_vm._v("Cantidad")]),_c('th',[_vm._v("Dto")]),_c('th',[_vm._v("Forzado")]),_c('th',[_vm._v("Total")]),_c('th',[_vm._v("Pendiente")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Soporte")]),_c('th',[_vm._v("Importe")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_descargar_vue__ = __webpack_require__(570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bfcb608_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_descargar_vue__ = __webpack_require__(1334);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_descargar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bfcb608_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_descargar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":300}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header text-left"},[_c('span',{staticClass:"fa fa-building mr-2"}),_vm._v("Selecciona empresa"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('table',{staticClass:"table table-striped"},[_c('tbody',_vm._l((_vm.listadoEmpresas),function(empresa){return _c('tr',{key:empresa.ID_empresa},[_c('td',[_vm._v(_vm._s(empresa.nombreFiscal))]),_c('td',[_c('a',{staticClass:"btn btn-primary",attrs:{"download":"contrato.pdf","href":'/src/modulos/mis-contratos/php/api/get-contrato-vacio.php?EmpresaID=' + empresa.ID_empresa}},[_c('span',{staticClass:"fa fa-download"})])])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid text-left"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[(_vm.permisos.contratos_verTodos)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agente"}},[_vm._v("Agente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.agente),expression:"filtro.agente"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","name":"agente","placeholder":"Escribe el nombre del agente"},domProps:{"value":(_vm.filtro.agente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "agente", $event.target.value)}}})]):_vm._e(),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agente"}},[_vm._v("Cliente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cliente),expression:"filtro.cliente"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","name":"agente","placeholder":"Escribe el nombre del cliente"},domProps:{"value":(_vm.filtro.cliente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cliente", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"facturado_a"}},[_vm._v("Facturado a")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.destino),expression:"filtro.destino"}],staticClass:"form-control form-control-sm",attrs:{"id":"facturado_a"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "destino", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.buscar()}]}},[_c('option',{domProps:{"value":null}},[_vm._v("Todos")]),_vm._l((_vm.listadoDestinos),function(destino){return _c('option',{domProps:{"value":destino.ID_destino}},[_vm._v(_vm._s(destino.nombre))])})],2)])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"form-group",staticStyle:{"position":"relative"}},[_c('label',{attrs:{"for":"agente"}},[_vm._v("Desde")]),_c('datepicker',{attrs:{"clear-button":true,"placeholder":"DD-MM-YYYY","monday-first":true,"input-class":"form-control form-control-sm","language":_vm.$dateLang},on:{"selected":function($event){return _vm.buscar()}},model:{value:(_vm.filtro.fechaIni),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaIni", $$v)},expression:"filtro.fechaIni"}})],1),_c('div',{staticClass:"form-group",staticStyle:{"position":"relative"}},[_c('label',{attrs:{"for":"agente"}},[_vm._v("Hasta")]),_c('datepicker',{attrs:{"clear-button":true,"placeholder":"DD-MM-YYYY","monday-first":true,"input-class":"form-control form-control-sm","language":_vm.$dateLang},on:{"selected":function($event){return _vm.buscar()}},model:{value:(_vm.filtro.fechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaFin", $$v)},expression:"filtro.fechaFin"}})],1),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Intermediario")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.intermediario),expression:"filtro.intermediario"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Escriba el nombre del intermediario"},domProps:{"value":(_vm.filtro.intermediario)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "intermediario", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agente"}},[_vm._v("Evento")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.evento),expression:"filtro.evento"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","name":"agente","placeholder":"Escribe el evento"},domProps:{"value":(_vm.filtro.evento)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "evento", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agente"}},[_vm._v("Partida")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.partida),expression:"filtro.partida"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","name":"agente","placeholder":"Escribe la partida"},domProps:{"value":(_vm.filtro.partida)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "partida", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agente"}},[_vm._v("Título")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.titulo),expression:"filtro.titulo"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","name":"titulo","placeholder":"Escribe el título"},domProps:{"value":(_vm.filtro.titulo)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "titulo", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agente"}},[_vm._v("Destino")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.destino),expression:"filtro.destino"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","name":"destino","placeholder":"Escribe el destino"},domProps:{"value":(_vm.filtro.destino)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "destino", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"agente"}},[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{class:_vm.claseBtnEstado(null),attrs:{"type":"button"},on:{"click":function($event){return _vm.setEstado(null)}}},[_vm._v("Todos")]),_c('button',{class:_vm.claseBtnEstado('Borrador'),attrs:{"type":"button"},on:{"click":function($event){return _vm.setEstado('Borrador')}}},[_vm._v("Borrador")]),_c('button',{class:_vm.claseBtnEstado('Candidato'),attrs:{"type":"button"},on:{"click":function($event){return _vm.setEstado('Candidato')}}},[_vm._v("Candidatos")]),_c('button',{class:_vm.claseBtnEstado('Aprobado'),attrs:{"type":"button"},on:{"click":function($event){return _vm.setEstado('Aprobado')}}},[_vm._v("Aprobados")]),_c('button',{class:_vm.claseBtnEstado('Eliminado'),attrs:{"type":"button"},on:{"click":function($event){return _vm.setEstado('Eliminado')}}},[_vm._v("Eliminados")])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Límite de resultados")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{class:(_vm.filtro.max === 50) ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-default',on:{"click":function($event){return _vm.setLimite('50')}}},[_vm._v("50")]),_c('button',{class:(_vm.filtro.max === 100) ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-default',on:{"click":function($event){return _vm.setLimite('100')}}},[_vm._v("100")]),_c('button',{class:(_vm.filtro.max === 500) ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-default',on:{"click":function($event){return _vm.setLimite('500')}}},[_vm._v("500")])])])])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn-sm m-1 btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.buscar()}}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn-sm m-1 btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.reset()}}},[_c('span',{staticClass:"fa fa-refresh mr-2"}),_vm._v("Reset")]),_c('button',{staticClass:"btn-sm m-1 btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.goEditarContrato('nuevo')}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Nuevo contrato")]),_c('button',{staticClass:"btn-sm m-1 btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){_vm.verDescargaVacio = true}}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("Descargar contrato vacío")])])]),_c('div',{staticClass:"card mt-2"},[_c('div',{staticClass:"card-header"},[_vm._v("Resultados ("+_vm._s(_vm.listadoContratos.length)+" contratos)")]),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-condensed table-striped m-0"},[_c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Empresa")]),_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Título")]),(_vm.hayEventos)?_c('th',[_vm._v("Evento(s)")]):_vm._e(),(_vm.hayPartidas)?_c('th',[_vm._v("Partida(s)")]):_vm._e(),_c('th',[_vm._v("Tipo")]),_c('th',[_vm._v("Facturado a")]),_c('th',[_vm._v("Importe")]),_c('th',[_vm._v("Estado")]),_c('th')])]),_c('tbody',[_vm._l((_vm.listadoFiltrado),function(contrato){return _c('tr',{class:_vm.claseContrato(contrato),attrs:{"track-by":"$index"}},[_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(contrato.ContratoID))]),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(contrato.EmpresaNombre))]),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(_vm._f("moment")(contrato.FechaCreacion,'DD-MM-YYYY')))]),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(contrato.AgenteNombre))]),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(contrato.ClienteNombre)),(contrato.IntermediarioNombre)?_c('div',[_c('span',{staticStyle:{"color":"#888888"}},[_vm._v(_vm._s(contrato.IntermediarioNombre))])]):_vm._e()]),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(contrato.Titulo))]),(_vm.hayEventos)?_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(contrato.EventoNombre))]):_vm._e(),(_vm.hayPartidas)?_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(contrato.PartidaNombre))]):_vm._e(),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(contrato.TipoNombre))]),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(contrato.EmpresaNombre))]),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(_vm._f("currency")(contrato.Importe)))]),_c('td',{staticClass:"p-1",style:(_vm.claseCeldaEstado(contrato))},[_vm._v(_vm._s(contrato.Estado))]),_c('td',{staticClass:"p-1 text-center"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.ver(contrato.ContratoID)}}},[_c('span',{staticClass:"fa fa-eye"})])])])}),(_vm.listadoContratos.length > 0)?_c('tr',{staticClass:"bg-danger",staticStyle:{"color":"white","font-weight":"bold"}},[_c('td',{staticClass:"p-1"}),_c('td',{staticClass:"p-1"}),_c('td',{staticClass:"p-1"}),_c('td',{staticClass:"p-1"}),_c('td',{staticClass:"p-1"}),_c('td',{staticClass:"p-1"}),(_vm.hayEventos)?_c('td',{staticClass:"p-1"}):_vm._e(),(_vm.hayPartidas)?_c('td',{staticClass:"p-1"}):_vm._e(),_c('td',{staticClass:"p-1"}),_c('td',{staticClass:"p-1",staticStyle:{"text-align":"right"}},[_vm._v("Total:")]),_c('td',{staticClass:"p-1",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.compTotalImporteAprobados,'€')))]),_c('td',{staticClass:"p-1"}),_c('td',{staticClass:"p-1"})]):_vm._e()],2)])])]),(_vm.$route.params.id)?_c('modal',{attrs:{"max-width":1600,"top":10}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('button',{staticClass:"close",on:{"click":function($event){return _vm.$router.push('/main/contratos/listado')}}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('detalle-contrato',{attrs:{"ContratoID":_vm.$route.params.id}})],1)])]):_vm._e(),(_vm.editarContrato)?_c('editor-contrato',{attrs:{"id-contrato":_vm.editarContrato},on:{"cerrar":function($event){return _vm.cerrarEditor()}}}):_vm._e(),(_vm.verDescargaVacio)?_c('modal-descarga',{on:{"cerrar":function($event){_vm.verDescargaVacio = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Búsqueda de contratos")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(571);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f14f98be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1358);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f14f98be_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_vue__ = __webpack_require__(572);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0c0a83c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_vue__ = __webpack_require__(1352);
function injectStyle (ssrContext) {
  __webpack_require__(1339)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0c0a83c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0c0a83c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linea_contrato_vue__ = __webpack_require__(573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1436e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_linea_contrato_vue__ = __webpack_require__(1342);
function injectStyle (ssrContext) {
  __webpack_require__(1341)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e1436e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_linea_contrato_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1436e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_linea_contrato_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"p-0 producto"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.value.Tipo !== 'Articulo') ? 'btn-primary': '',attrs:{"title":"Otros"},on:{"click":function($event){return _vm.setTipo('Otros')}}},[_c('span',{staticClass:"fa fa-shopping-basket"})]),_c('button',{staticClass:"btn btn-sm",class:(_vm.value.Tipo === 'Articulo') ? 'btn-primary': '',attrs:{"title":"Artículo"},on:{"click":function($event){return _vm.setTipo('Articulo')}}},[_c('span',{staticClass:"fa fa-search"})])]),(_vm.value.Tipo === 'Otros' || _vm.value.ArticuloID)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.Concepto),expression:"value.Concepto"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"Concepto","disabled":_vm.value.ArticuloID},domProps:{"value":(_vm.value.Concepto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "Concepto", $event.target.value)}}}):_vm._e(),(_vm.value.Tipo === 'Articulo' && !_vm.value.ArticuloID)?_c('input-query',{attrs:{"input-class":"form-control form-control-sm","url":"/mis-contratos/php/api/busca-articulos.php","realtime":true},on:{"selected":function($event){return _vm.seleccionaTarifa($event)}}}):_vm._e(),(_vm.value.ArticuloID)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.quitarTarifa}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e(),(_vm.value.Tipo === 'Otros')?_c('div',{staticClass:"input-group-append"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.CatalogoID),expression:"value.CatalogoID"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.value, "CatalogoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":false}},[_vm._v("Selecciona soporte")]),_c('option',{domProps:{"value":null}},[_vm._v("Sin soporte asignado")]),_vm._l((_vm.listadoDestinos),function(destino){return _c('option',{key:destino.CatalogoID,domProps:{"value":destino.CatalogoID}},[_vm._v(_vm._s(destino.Nombre))])})],2)]):_vm._e()],1)]),_c('td',{staticClass:"p-0"},[(_vm.value.Tipo === 'Articulo')?_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":true},domProps:{"value":_vm.value.ImporteUnitario}}):_vm._e(),(_vm.value.Tipo === 'Otros')?_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.value.ImporteUnitario),expression:"value.ImporteUnitario",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.seleccionValida},domProps:{"value":(_vm.value.ImporteUnitario)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "ImporteUnitario", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}):_vm._e()]),_c('td',{staticClass:"p-0"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.value.Unidades),expression:"value.Unidades",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.value.ArticuloUnitario},domProps:{"value":(_vm.value.Unidades)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "Unidades", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-0"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.value.Cantidad),expression:"value.Cantidad",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":!_vm.seleccionValida},domProps:{"value":(_vm.value.Cantidad)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "Cantidad", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-0"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.descuento),expression:"descuento",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.descuento)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.descuento=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-0"},[_c('select',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.value.ImpuestosID),expression:"value.ImpuestosID",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return _vm._n(val)}); _vm.$set(_vm.value, "ImpuestosID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.cambiaImpuestos]}},[_c('option',{domProps:{"value":null}},[_vm._v("-")]),_vm._l((_vm.listadoImpuestos),function(imp){return _c('option',{key:imp.ID_impuesto,domProps:{"value":imp.ID_impuesto}},[_vm._v(_vm._s(imp.nombre)+" - "+_vm._s(imp.valor)+" %")])})],2)]),_c('td',{staticClass:"p-0"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.value.ImporteBruto),expression:"value.ImporteBruto",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":(_vm.value.ImporteBruto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "ImporteBruto", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-0"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.value.ImporteNeto),expression:"value.ImporteNeto",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.value.ImporteNeto)},on:{"keyup":_vm.calculaDescuento,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "ImporteNeto", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-0"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.value.ImporteTotal),expression:"value.ImporteTotal",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"disabled":true},domProps:{"value":(_vm.value.ImporteTotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.value, "ImporteTotal", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-0 text-right",staticStyle:{"max-width":"60px","text-align":"center"}},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.$emit('eliminar', _vm.value)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cobros_vue__ = __webpack_require__(574);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fce8b14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_cobros_vue__ = __webpack_require__(1344);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cobros_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fce8b14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_cobros_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-success text-white"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_vm._v("Cobros")]),_c('div',{staticClass:"col text-right"},[_c('b',[_vm._v("Total: "+_vm._s(_vm._f("currency")(_vm.importe,''))+" €")])])])]),_c('table',{staticClass:"table table-striped m-0"},[_vm._m(0),_c('tbody',_vm._l((_vm.contrato.recibos),function(recibo,i){return _c('tr',{key:recibo.ReciboID},[_c('td',[_c('datepicker',{attrs:{"monday-first":true,"bootstrap-styling":true,"disabledDates":_vm.MesesBloqueados,"disabled":(recibo.Estado === 'Pagado')},on:{"input":function($event){return _vm.setFechaEmision(recibo)}},model:{value:(_vm.contrato.recibos[i].FechaVencimiento),callback:function ($$v) {_vm.$set(_vm.contrato.recibos[i], "FechaVencimiento", $$v)},expression:"contrato.recibos[i].FechaVencimiento"}})],1),_c('td',[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm._f("moment")(recibo.FechaEmision,'DD MMM YYYY')}})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.contrato.recibos[i].ImporteTotal),expression:"contrato.recibos[i].ImporteTotal",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"placeholder":"Importe","disabled":(recibo.Estado === 'Pagado')},domProps:{"value":(_vm.contrato.recibos[i].ImporteTotal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.recibos[i], "ImporteTotal", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"text-right"},[(recibo.Estado === 'Pendiente')?_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){return _vm.quitar(recibo)}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Quitar")]):_vm._e()])])}),0),_c('tbody',[_c('tr',{staticClass:"bg-white"},[_c('td'),_c('td'),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.ImportePendiente))+" pendiente")])]),_c('td')])])]),(_vm.variosPorMes)?_c('div',{staticClass:"card-body"},[_vm._m(1)]):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.nuevo}},[_vm._v("Nuevo")]),_c('button',{staticClass:"btn btn-warning ml-2",on:{"click":_vm.repartir}},[_vm._v("Repartir")]),_c('button',{staticClass:"btn btn-dark ml-2",attrs:{"disabled":!_vm.facturacionValida},on:{"click":_vm.aplicarFormaDePago}},[_vm._v("Aplicar forma de pago"),(!_vm.facturacionValida)?_c('spana',{staticClass:"ml-2"},[_vm._v("(facturación incorrecta)")]):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha de vencimiento")]),_c('th',[_vm._v("Fecha de emisión")]),_c('th',[_vm._v("Importe")]),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_c('span',{staticClass:"fa fa-exclamation-triangle mr-2"}),_c('b',[_vm._v("Atención")]),_vm._v(": has fijado más de un cobro por mes. Normalmente ocurre por error al seleccionar la fecha. No obstante si estás seguro/a de lo que haces puedes continuar")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_facturacion_vue__ = __webpack_require__(575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7311e358_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_facturacion_vue__ = __webpack_require__(1346);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_facturacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7311e358_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_facturacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('div',{staticClass:"row"}),_c('div',{staticClass:"col text-left"},[_vm._v("Facturación")]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm",class:_vm.FacturacionEnNeto ? 'btn-dark' : '',on:{"click":function($event){_vm.FacturacionEnNeto = !_vm.FacturacionEnNeto}}},[_vm._v("Trabajar en neto")])])]),_c('table',{staticClass:"table table-striped m-0"},[_c('thead'),_vm._m(0),_c('tbody'),_vm._l((_vm.contrato.facturacion),function(linea,i){return _c('tr',{key:linea.FacturacionID},[_c('td',[_c('datepicker',{ref:'picker' + linea.FacturacionID,refInFor:true,attrs:{"monday-first":true,"id":'fecha' + linea.FacturacionID,"name":'fecha' + linea.FacturacionID,"bootstrap-styling":true,"disabledDates":_vm.MesesBloqueados,"minimum-view":"month","disabled":!_vm.editable(linea),"language":_vm.$dateLang},on:{"input":function($event){return _vm.seleccionaFecha(linea, $event)}},model:{value:(_vm.contrato.facturacion[i].FechaFactura),callback:function ($$v) {_vm.$set(_vm.contrato.facturacion[i], "FechaFactura", $$v)},expression:"contrato.facturacion[i].FechaFactura"}})],1),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.contrato.facturacion[i].ImporteTotal),expression:"contrato.facturacion[i].ImporteTotal",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"disabled":!_vm.editable(linea) || _vm.FacturacionEnNeto,"placeholder":"Importe total"},domProps:{"value":(_vm.contrato.facturacion[i].ImporteTotal)},on:{"keyup":function($event){return _vm.calculaImporteTotal()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.facturacion[i], "ImporteTotal", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.facturacion[i].ImporteNeto),expression:"contrato.facturacion[i].ImporteNeto"}],staticClass:"form-control",attrs:{"disabled":!_vm.editable(linea) || !_vm.FacturacionEnNeto,"placeholder":"Importe neto"},domProps:{"value":(_vm.contrato.facturacion[i].ImporteNeto)},on:{"keyup":function($event){return _vm.calculaImporteTotal()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.facturacion[i], "ImporteNeto", $event.target.value)}}})]),_c('td',{staticClass:"text-right"},[(_vm.editable(linea))?_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){return _vm.quitar(linea)}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Quitar")]):_vm._e(),(linea.FechaPagada)?_c('div',{staticClass:"alert p-1 m-0 text-center alert-primary"},[_vm._v("Factura pagada")]):_vm._e()])])}),_c('tbody',[_c('tr',{staticClass:"bg-white"},[_c('td'),_c('td',[(!_vm.FacturacionEnNeto)?_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.ImportePendiente))+" pendiente total")]):_vm._e()]),_c('td',[(_vm.FacturacionEnNeto)?_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.ImportePendienteNeto))+" pendiente neto")]):_vm._e()]),_c('td')])])],2),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.nuevo}},[_vm._v("Nuevo")]),(!_vm.FacturacionEnNeto)?_c('button',{staticClass:"btn btn-warning ml-2",on:{"click":_vm.repartirTotal}},[_vm._v("Repartir total")]):_c('button',{staticClass:"btn btn-warning ml-2",on:{"click":_vm.repartirNeto}},[_vm._v("Repartir neto")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Fecha de factura")]),_c('th',[_vm._v("Importe con impuestos")]),_c('th',[_vm._v("Importe neto")]),_c('th')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comentarios_vue__ = __webpack_require__(576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_409e9560_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_comentarios_vue__ = __webpack_require__(1348);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comentarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_409e9560_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_comentarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.Comentarios),expression:"contrato.Comentarios"}],staticClass:"form-control",attrs:{"rows":"5","placeholder":"Escribe aquí unos comentarios"},domProps:{"value":(_vm.contrato.Comentarios)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato, "Comentarios", $event.target.value)}}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-success text-white"},[_c('span',{staticClass:"fa fa-comments mr-2"}),_vm._v("Comentarios")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccionaDatos_vue__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6080c6cd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_seleccionaDatos_vue__ = __webpack_require__(1351);
function injectStyle (ssrContext) {
  __webpack_require__(1350)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6080c6cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccionaDatos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6080c6cd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_seleccionaDatos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cliente)?_c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info"},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Datos del cliente"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"alert alert-info"},[_c('b',[_vm._v("Debes seleccionar la información a importar")])])]),(_vm.cliente.telefonos.length > 1)?_c('table',{staticClass:"m-0 table table-hover"},[_c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Teléfono")])])]),_c('tbody',_vm._l((_vm.cliente.telefonos),function(telefono,i){return _c('tr',{key:i},[_c('td',{staticClass:"opcion",class:(_vm.telefonoSeleccionado === i) ? 'bg-success text-white' : '',on:{"click":function($event){return _vm.asignar('Telefono', telefono.telefono, i)}}},[_c('span',{staticClass:"fa fa-phone mr-2"}),_vm._v(_vm._s(telefono.telefono))])])}),0)]):_vm._e(),(_vm.cliente.emails.length > 1)?_c('table',{staticClass:"m-0 table table-hover"},[_c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("E-mail")])])]),_c('tbody',_vm._l((_vm.cliente.emails),function(email,i){return _c('tr',{key:i},[_c('td',{staticClass:"opcion",class:(_vm.emailSeleccionado === i) ? 'bg-success text-white' : '',on:{"click":function($event){return _vm.asignar('Email', email.email, i)}}},[_c('span',{staticClass:"fa fa-envelope mr-2"}),_vm._v(_vm._s(email.email))])])}),0)]):_vm._e(),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.cerrar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Listo")])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Empresa")]),_c('div',{staticClass:"input-group"},[_vm._m(1),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.EmpresaID),expression:"contrato.EmpresaID"}],staticClass:"form-control",class:(_vm.campoFallo === 'empresa') ? 'error' : '',on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contrato, "EmpresaID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona una empresa")]),_vm._l((_vm.listadoEmpresas),function(empresa){return _c('option',{key:empresa.ID_empresa,domProps:{"value":empresa.ID_empresa}},[_vm._v(_vm._s(empresa.nombreFiscal))])})],2)])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),_c('div',{staticClass:"input-group"},[_vm._m(2),(!_vm.contrato.AgenteID)?_c('input-query',{attrs:{"input-class":(_vm.campoFallo === 'agente') ? 'error form-control' : 'form-control',"placeholder":"Busca un agente","realtime":true,"url":"mis-contratos/php/api/buscaAgente.php"},on:{"selected":function($event){return _vm.setAgente($event)}}}):_vm._e(),(_vm.contrato.AgenteID)?_c('input',{staticClass:"form-control",attrs:{"disabled":true},domProps:{"value":_vm.contrato.AgenteNombre}}):_vm._e(),(_vm.contrato.AgenteID)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.quitarAgente()}}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e()],1)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cliente")]),_c('div',{staticClass:"input-group"},[_vm._m(3),(!_vm.contrato.ClienteID)?_c('input-query',{attrs:{"input-class":(_vm.campoFallo === 'cliente') ? 'error form-control' : 'form-control',"placeholder":"Busca un cliente","realtime":true,"url":'mis-contratos/php/api/buscaCliente.php?agente=' + _vm.contrato.AgenteID},on:{"selected":function($event){return _vm.setCliente($event)}}}):_vm._e(),(_vm.contrato.ClienteID)?_c('input',{staticClass:"form-control",attrs:{"disabled":true},domProps:{"value":_vm.contrato.ClienteNombre}}):_vm._e(),(_vm.contrato.ClienteID)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.quitarCliente()}}},[_c('span',{staticClass:"fa fa-trash"})]),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.editaCliente = _vm.contrato.ClienteID}}},[_c('span',{staticClass:"fa fa-edit"})])]):_vm._e()],1)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Forma de pago")]),_c('div',{staticClass:"input-group"},[_vm._m(4),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.FormaDePagoID),expression:"contrato.FormaDePagoID"}],staticClass:"form-control",class:(_vm.campoFallo === 'formaDePago') ? 'error' : '',on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contrato, "FormaDePagoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoFormasDePago),function(forma){return _c('option',{key:forma.ID_forma_de_pago,domProps:{"value":forma.ID_forma_de_pago}},[_vm._v(_vm._s(forma.nombre))])})],2)])])])])]),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"div",staticStyle:{"position":"relative","display":"inline-block","width":"200px"}},[_c('div',{staticClass:"input-group"},[_vm._m(5),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-warning"},[_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.importeBruto)))])])])])]),_c('div',{staticClass:"div",staticStyle:{"position":"relative","display":"inline-block","width":"200px"}},[_c('div',{staticClass:"input-group"},[_vm._m(6),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-warning"},[_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.importeNeto)))])])])])]),_c('div',{staticClass:"div",staticStyle:{"position":"relative","display":"inline-block","width":"200px"}},[_c('div',{staticClass:"input-group"},[_vm._m(7),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-warning"},[_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.importeTotal)))])])])])]),_c('div',{staticClass:"div",staticStyle:{"position":"relative","display":"inline-block","width":"200px"}},[_c('div',{staticClass:"input-group"},[_vm._m(8),_c('div',{staticClass:"input-group-append"},[(_vm.contratoValido)?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save"})]):_c('button',{staticClass:"btn btn-danger"},[_c('b',[_vm._v("Faltan datos")])])])])])])]),(!_vm.contratoValido)?_c('div',{staticClass:"card mt-2"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_c('b',[_vm._v("ERROR:")]),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.falloForm))])])]):_vm._e(),(_vm.fase1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-12 mt-2"},[_c('div',{staticClass:"card"},[_vm._m(9),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Título del contrato")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.Titulo),expression:"contrato.Titulo"}],staticClass:"form-control form-control-sm",class:(_vm.campoFallo === 'titulo') ? 'error' : '',domProps:{"value":(_vm.contrato.Titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato, "Titulo", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha de inicio")]),_c('datepicker',{class:(_vm.campoFallo === 'fechaIni') ? 'error' : '',attrs:{"bootstrap-styling":true,"monday-first":true,"placeholder":"Selecciona fecha","disabled-dates":{to: new Date(new Date().getTime() - 86400000)},"input-class":(_vm.campoFallo === 'fechaIni') ? 'error' : '',"language":_vm.$dateLang},model:{value:(_vm.contrato.FechaInicio),callback:function ($$v) {_vm.$set(_vm.contrato, "FechaInicio", $$v)},expression:"contrato.FechaInicio"}})],1),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha de fin")]),_c('datepicker',{class:(_vm.campoFallo === 'fechaFin') ? 'error' : '',attrs:{"bootstrap-styling":true,"monday-first":true,"placeholder":"Selecciona fecha","disabled":!_vm.contrato.FechaInicio,"disabled-dates":{to: _vm.contrato.FechaInicio}},model:{value:(_vm.contrato.FechaFin),callback:function ($$v) {_vm.$set(_vm.contrato, "FechaFin", $$v)},expression:"contrato.FechaFin"}})],1)]),_c('div',{staticClass:"card-body bg-warning"},[_c('div',{staticClass:"form-group"},[_vm._m(10),(!_vm.contrato.AnuncianteID)?_c('input-query',{attrs:{"input-class":(_vm.campoFallo === 'anunciante') ? 'error form-control' : 'form-control',"placeholder":"Asigna un anunciante","url":"gestion-anunciantes/php/api/query.php","realtime":true},on:{"selected":function($event){return _vm.asignaAnunciante($event)}}}):_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"text-primary"},[_c('b',[_vm._v(_vm._s(_vm.contrato.AnuncianteNombre))])]),_c('div',{staticStyle:{"position":"relative","display":"block","text-align":"center","width":"100%","margin-top":"10px"}},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.contrato.AnuncianteID = null}}},[_c('span',[_vm._v("Quitar")]),_c('span',{staticClass:"ml-2"},[_c('div',{staticClass:"fa fa-trash"})])])])])],1)])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-12 mt-2"},[_c('div',{staticClass:"card"},[_vm._m(11),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de contrato")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.TipoID),expression:"contrato.TipoID"}],staticClass:"form-control form-control-sm",class:(_vm.campoFallo === 'tipo') ? 'error' : '',on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contrato, "TipoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.cambiaTipo]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoTipos),function(tipo){return _c('option',{key:tipo.TipoID,domProps:{"value":tipo.TipoID}},[_vm._v(_vm._s(tipo.Nombre))])})],2)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Destino")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.DestinoID),expression:"contrato.DestinoID"}],staticClass:"form-control form-control-sm",class:(_vm.campoFallo === 'destino') ? 'error' : '',on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contrato, "DestinoID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.cambiaDestino]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoDestinos),function(destino){return _c('option',{key:destino.DestinoID,domProps:{"value":destino.DestinoID}},[_vm._v(_vm._s(destino.Nombre))])})],2)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Partida")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.PartidaID),expression:"contrato.PartidaID"}],staticClass:"form-control form-control-sm",class:(_vm.campoFallo === 'partida') ? 'error' : '',on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contrato, "PartidaID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.cambiaPartida]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoPartidas),function(partida){return _c('option',{key:partida.PartidaID,domProps:{"value":partida.PartidaID}},[_vm._v(_vm._s(partida.Nombre))])})],2)]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Evento")]),(!_vm.contrato.EventoID)?_c('div',{staticClass:"input-group"},[_c('input-query',{attrs:{"input-class":"form-control form-control-sm","url":"/mis-contratos/php/api/query-eventos.php","realtime":true,"placeholder":"Asocia un evento"},on:{"selected":function($event){return _vm.seleccionaEvento($event)}}})],1):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.contrato.EventoNombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.quitarEvento}},[_c('span',{staticClass:"fa fa-trash"})])])])]),(_vm.permisos.contratos_seleccionarIntermediarios)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Intermediario")]),_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(12),(!_vm.contrato.IntermediarioID)?_c('input-query',{attrs:{"input-class":"form-control form-control-sm","realtime":true,"url":"/mis-contratos/php/api/buscaIntermediario.php"},on:{"selected":function($event){return _vm.setIntermediario($event)}}}):_vm._e(),(_vm.contrato.IntermediarioID)?_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":true},domProps:{"value":_vm.contrato.IntermediarioNombre}}):_vm._e(),(_vm.contrato.IntermediarioID)?_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.quitarIntermediario}},[_c('span',{staticClass:"fa fa-trash"})])]):_vm._e(),(!_vm.contrato.IntermediarioID)?_c('div',{staticClass:"input-group-append"},[_vm._m(13)]):_vm._e()],1)]):_vm._e()])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-12 mt-2"},[_c('div',{staticClass:"card"},[_vm._m(14),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descuento cadena de valor")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.contrato.DescuentoCadenaValor),expression:"contrato.DescuentoCadenaValor",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Opcional"},domProps:{"value":(_vm.contrato.DescuentoCadenaValor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato, "DescuentoCadenaValor", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descuento comercial")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.contrato.DescuentoComercial),expression:"contrato.DescuentoComercial",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Opcional"},domProps:{"value":(_vm.contrato.DescuentoComercial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato, "DescuentoComercial", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])])])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 mt-2"},[_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_c('div',{staticClass:"row"},[_vm._m(15),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":_vm.importarDatosCliente}},[_c('span',{staticClass:"fa fa-download mr-2"}),_vm._v("Importar de la ficha del cliente")])])])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cliente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.cliente.NombreCliente),expression:"contrato.cliente.NombreCliente"}],staticClass:"form-control form-control-sm",class:(_vm.campoFallo === 'clienteNombre') ? 'error' : '',attrs:{"placeholder":"Nombre del cliente"},domProps:{"value":(_vm.contrato.cliente.NombreCliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.cliente, "NombreCliente", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("CIF")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.cliente.CIF),expression:"contrato.cliente.CIF"}],staticClass:"form-control form-control-sm",class:(_vm.campoFallo === 'clienteCIF') ? 'error' : '',attrs:{"placeholder":"X1234567"},domProps:{"value":(_vm.contrato.cliente.CIF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.cliente, "CIF", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Representante")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.cliente.Representante),expression:"contrato.cliente.Representante"}],staticClass:"form-control form-control-sm",class:(_vm.campoFallo === 'clienteRepresentante') ? 'error' : '',attrs:{"placeholder":"Nombre del representante"},domProps:{"value":(_vm.contrato.cliente.Representante)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.cliente, "Representante", $event.target.value)}}})]),(_vm.necesitaIBAN)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("IBAN")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.cliente.IBAN),expression:"contrato.cliente.IBAN"}],staticClass:"form-control form-control-sm",class:(_vm.campoFallo === 'clienteIBAN') ? 'error' : '',attrs:{"placeholder":"ESXX XXXX XXXX XXXX XXXX"},domProps:{"value":(_vm.contrato.cliente.IBAN)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.cliente, "IBAN", $event.target.value)}}})]):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Teléfono")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.cliente.Telefono),expression:"contrato.cliente.Telefono"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"Teléfono de contacto"},domProps:{"value":(_vm.contrato.cliente.Telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.cliente, "Telefono", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("E-mail")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.cliente.Email),expression:"contrato.cliente.Email"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"Nombre del cliente"},domProps:{"value":(_vm.contrato.cliente.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.cliente, "Email", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Dirección")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.contrato.cliente.Direccion),expression:"contrato.cliente.Direccion"}],staticClass:"form-control form-control-sm",attrs:{"rows":"5","placeholder":"Dirección postal"},domProps:{"value":(_vm.contrato.cliente.Direccion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contrato.cliente, "Direccion", $event.target.value)}}})])])])])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(16),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.nuevaLineaContrato}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Nueva")])])])]),(_vm.contrato.lineas.length === 0)?_c('div',{staticClass:"card-body"},[_vm._m(17)]):_c('table',{staticClass:"table m-0"},[_vm._m(18),_c('tbody',_vm._l((_vm.contrato.lineas),function(linea,index){return _c('linea-contrato',{key:linea.LineaID,attrs:{"idx":index,"dto-cad-valor":_vm.contrato.DescuentoCadenaValor,"dto-comercial":_vm.contrato.DescuentoComercial},on:{"eliminar":function($event){return _vm.quitarLinea(linea)}},model:{value:(_vm.contrato.lineas[index]),callback:function ($$v) {_vm.$set(_vm.contrato.lineas, index, $$v)},expression:"contrato.lineas[index]"}})}),1)]),(_vm.contrato.lineas.length > 0)?_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"div",staticStyle:{"position":"relative","display":"inline-block","width":"200px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn",class:(_vm.verCapa === 'facturacion') ? 'btn-primary' : '',on:{"click":function($event){_vm.verCapa = 'facturacion'}}},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v("Facturación")])]),_c('div',{staticClass:"input-group-append"},[(!_vm.facturacionValida)?_c('div',{staticClass:"input-group-text bg-danger text-white"},[_c('span',{staticClass:"fa fa-ban"})]):_c('div',{staticClass:"input-group-text bg-success text-white"},[_c('span',{staticClass:"fa fa-check"})])])])]),_c('div',{staticClass:"div",staticStyle:{"position":"relative","display":"inline-block","width":"200px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn",class:(_vm.verCapa === 'cobros') ? 'btn-primary' : '',on:{"click":function($event){_vm.verCapa = 'cobros'}}},[_c('span',{staticClass:"fa fa-money mr-2"}),_vm._v("Cobros")])]),_c('div',{staticClass:"input-group-append"},[(!_vm.recibosValidos)?_c('div',{staticClass:"input-group-text bg-danger text-white"},[_c('span',{staticClass:"fa fa-ban"})]):_c('div',{staticClass:"input-group-text bg-success text-white"},[_c('span',{staticClass:"fa fa-check"})])])])]),_c('div',{staticClass:"div",staticStyle:{"position":"relative","display":"inline-block","width":"200px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn",class:(_vm.verCapa === 'comentarios') ? 'btn-primary' : '',on:{"click":function($event){_vm.verCapa = 'comentarios'}}},[_c('span',{staticClass:"fa fa-comments mr-2"}),_vm._v("Comentarios")])]),_c('div',{staticClass:"input-group-append"},[(!_vm.contrato.Comentarios)?_c('div',{staticClass:"input-group-text bg-danger text-white"},[_c('span',{staticClass:"fa fa-ban"})]):_c('div',{staticClass:"input-group-text bg-success text-white"},[_c('span',{staticClass:"fa fa-check"})])])])])])])]):_vm._e()]),(_vm.verCapa === 'cobros')?_c('cobros',{staticClass:"mt-2",attrs:{"contrato":_vm.contrato,"importe":_vm.importeTotal,"facturacionValida":_vm.facturacionValida},on:{"update:contrato":function($event){_vm.contrato=$event}}}):_vm._e(),(_vm.verCapa === 'facturacion')?_c('facturacion',{staticClass:"mt-2",attrs:{"contrato":_vm.contrato,"importe":_vm.importeTotal,"dia-facturacion":_vm.diaFacturacion,"importeNeto":_vm.importeNeto},on:{"update:contrato":function($event){_vm.contrato=$event}}}):_vm._e(),(_vm.verCapa === 'comentarios')?_c('comentarios',{staticClass:"mt-2",attrs:{"contrato":_vm.contrato},on:{"update:contrato":function($event){_vm.contrato=$event}}}):_vm._e()],1)]):_vm._e(),(_vm.modalCliente)?_c('selecciona-datos-cliente',{attrs:{"ClienteID":_vm.modalCliente},on:{"cerrar":function($event){_vm.modalCliente = null},"asociar":function($event){return _vm.asociarDatoCliente($event)}}}):_vm._e(),(_vm.editaCliente)?_c('editar-cliente',{attrs:{"id-cliente":_vm.editaCliente},on:{"cerrar":_vm.cerrarEditorCliente}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Información general")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-building"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-address-card"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-money"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Bruto")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Neto")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Guardar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Detalles del contrato")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Anunciante asociado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Destinos")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-users"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-warning"},[_c('span',{staticClass:"fa fa-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-percent mr-2"}),_vm._v("Descuentos")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-user mr-2"}),_vm._v("Datos del cliente")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col text-left"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Líneas del contrato")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning"},[_vm._v("Este contrato no tiene líneas. Pulsa sobre el botón "),_c('b',[_vm._v("Nueva")]),_vm._v(" para crear nuevas")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}},[_vm._v("Producto")]),_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}},[_vm._v("P. unit.")]),_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}},[_vm._v("Unidades")]),_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}},[_vm._v("Cant")]),_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}},[_vm._v("Dto.")]),_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}},[_vm._v("Imp.")]),_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}},[_vm._v("Bruto")]),_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}},[_vm._v("Neto")]),_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}},[_vm._v("Total")]),_c('th',{staticClass:"th-lg p-1",staticStyle:{"border":"0 !important"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiacion_vue__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510e4bfe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_radiacion_vue__ = __webpack_require__(1357);
function injectStyle (ssrContext) {
  __webpack_require__(1354)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-510e4bfe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510e4bfe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_radiacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colocacion_vue__ = __webpack_require__(579);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fc6ee9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_colocacion_vue__ = __webpack_require__(1356);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_colocacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fc6ee9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_colocacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linea)?_c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-puzzle-piece mr-2"}),_vm._v("Colocación"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light text-center"},[_c('div',{staticClass:"alert alert-success text-left"},[_c('b',[_c('span',{staticClass:"fa fa-puzzle-piece mr-2"}),_vm._v("Tipo de colocación")]),_c('p',[_vm._v("Debes definir el tipo de colocación que vas a emplear:"),_c('ul',[_c('li',[_c('b',[_vm._v("Por programa:")]),_vm._v(" Los originales siempre se colocarán dentro del programa seleccionado")]),_c('li',[_c('b',[_vm._v("Por contenido:")]),_vm._v(" Los originales siempre se colocación dentro de los contenidos seleccionados")]),_c('li',[_c('b',[_vm._v("Manual:")]),_vm._v(" Debes definir un intérvalo de días de la semana y horas para colocar los originales")])])])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de colocación")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.linea.tipoColocacion === 'programa') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoColocacion('programa')}}},[_vm._v("Programa")]),_c('button',{staticClass:"btn",class:(_vm.linea.tipoColocacion === 'contenido') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoColocacion('contenido')}}},[_vm._v("Contenido")]),_c('button',{staticClass:"btn",class:(_vm.linea.tipoColocacion === 'manual') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoColocacion('manual')}}},[_vm._v("Manual")])])])]),(_vm.linea.tipoColocacion === 'programa')?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Selecciona un programa")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.linea.programa_ID),expression:"linea.programa_ID"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.linea, "programa_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoProgramas),function(programa){return _c('option',{key:programa.ID_programa,domProps:{"value":programa.ID_programa}},[_vm._v(_vm._s(programa.nombre))])})],2)])]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-body p-0"},[_c('div',{staticClass:"caja-herramientas"},[_c('div',{class:(_vm.opciones.activoColocacion) ? '' : 'disabled',on:{"click":function($event){_vm.ver = 'colocacion'}}},[_c('span',{staticClass:"fa fa-puzzle-piece"}),_c('div',[_vm._v("Colocación")])]),_c('div',{class:(_vm.opciones.activoInsertar) ? '' : 'disabled'},[_c('span',{staticClass:"fa fa-plus-square"}),_c('div',[_vm._v("Insertar Originales")])]),_c('div',{class:(_vm.opciones.activoRotacionV) ? '' : 'disabled'},[_c('span',{staticClass:"fa fa-arrows-v"}),_c('div',[_vm._v("Rotación vertical")])]),_c('div',{class:(_vm.opciones.activoRotacionH) ? '' : 'disabled'},[_c('span',{staticClass:"fa fa-arrows-h"}),_c('div',[_vm._v("Rotación horizontal")])]),_c('div',{class:(_vm.opciones.activoAnulaIns) ? '' : 'disabled'},[_c('span',{staticClass:"fa fa-calendar-times-o"}),_c('div',[_vm._v("Anular inserciones")])]),_c('div',{class:(_vm.opciones.activoRecuperaIns) ? '' : 'disabled'},[_c('span',{staticClass:"fa fa-calendar-plus-o"}),_c('div',[_vm._v("Recuperar inserciones")])]),_c('div',{class:(_vm.opciones.activoModVarias) ? '' : 'disabled'},[_c('span',{staticClass:"fa fa-gears"}),_c('div',[_vm._v("Modificar varias")])])])])]),_c('div',{staticClass:"radiacion bg-info text-white"},[_c('div',[_vm._v("Línea")]),_vm._l((_vm.dias),function(dia){return _c('div',{key:dia.getTime(),staticClass:"dia"},[_vm._v(_vm._s(dia.getDate()))])})],2),_vm._l((_vm.contrato.lineas),function(linea){return (linea.tipo === 'radio')?_c('div',{staticClass:"radiacion",class:(_vm.lineaSeleccionada === linea.ID_linea) ? 'bg-warning' : ''},[_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.seleccionaLinea(linea)}}},[_c('span',{staticClass:"badge badge-danger mr-2",staticStyle:{"font-size":"1em"}},[_vm._v(_vm._s(linea.ID_linea))]),_vm._v(_vm._s(linea.producto)),_c('span',{staticClass:"badge badge-info ml-2"},[_vm._v("0/"+_vm._s(linea.cantidad)+" inserciones")])]),_vm._l((_vm.dias),function(dia){return _c('div',{key:linea.ID_linea + '-' + dia.getTime(),staticClass:"dia",class:(dia < _vm.contrato.fecha_inicio || dia > _vm.contrato.fecha_fin) ? 'dia-inactivo' : 'dia-activo'})})],2):_vm._e()}),_c('nav',{staticClass:"mt-3"},[_c('ul',{staticClass:"pagination"},_vm._l((_vm.meses),function(mes){return _c('li',{key:mes.getTime(),staticClass:"page-item",class:(_vm.mesActivo === mes) ? 'active' : '',on:{"click":function($event){_vm.mesActivo = mes}}},[_c('a',{staticClass:"page-link"},[_c('span',[_vm._v(_vm._s(_vm.nombreMes[mes.getMonth()]))]),(_vm.variosAnos)?_c('span',[_vm._v(", "+_vm._s(mes.getFullYear()))]):_vm._e()])])}),0)]),(_vm.lineaSeleccionada && _vm.ver === 'colocacion')?_c('colocacion',{attrs:{"linea-contrato":_vm.lineaSeleccionada},on:{"update:lineaContrato":function($event){_vm.lineaSeleccionada=$event},"update:linea-contrato":function($event){_vm.lineaSeleccionada=$event},"cerrar":function($event){_vm.ver = ''}}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contrato)?_c('div',[_c('div',{staticClass:"container-fluid"},[_c('detalles-contrato',{directives:[{name:"show",rawName:"v-show",value:(_vm.vista === 'detalles'),expression:"vista === 'detalles'"}],attrs:{"contrato":_vm.contrato},on:{"update:contrato":function($event){_vm.contrato=$event}}}),(_vm.mostrarRadiacion)?_c('radiacion-contrato',{directives:[{name:"show",rawName:"v-show",value:(_vm.vista === 'radiacion'),expression:"vista === 'radiacion'"}],attrs:{"contrato":_vm.contrato},on:{"update:contrato":function($event){_vm.contrato=$event}}}):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		contratos: [],
		contratoActual: null,
		filtro: {
			agente: null,
			cliente: null,
			fecha_inicio: null,
			fecha_fin: null,
			importe_min: null,
			importe_max: null,
			estado: null,
			descripcion: null
		}
	},
	getters: {
		filtro: function filtro(state) {
			return {
				agente: state.agente,
				cliente: state.cliente,
				fecha_inicio: state.fecha_inicio ? new Date(state.fecha_inicio * 1000) : null,
				fecha_fin: state.fecha_fin ? new Date(state.fecha_fin * 1000) : null,
				importe_min: state.importe_min,
				importe_max: state.importe_max,
				estado: state.estado,
				descripcion: state.descripcion
			};
		},
		contratoActual: function contratoActual(state) {
			return state.contratoActual;
		}
	},
	mutations: {
		SET_FILTRO: function SET_FILTRO(state, data) {
			state.filtro = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.filtro, data);
		},
		SET_CONTRATO_ACTUAL: function SET_CONTRATO_ACTUAL(state, data) {
			state.contratoActual = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.contrato, data);
		}
	},
	actions: {
		getContrato: function getContrato(context, idContrato) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('mis-contratos/php/api/get-contrato.php?ID_contrato=' + idContrato).then(function (res) {
				context.commit('SET_CONTRATO_ACTUAL', res.data.contrato);
			}).catch(function (e) {
				_this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error obteniendo el contrato'
				});
			});
		},

		/**
   * Crearemos un nuevo contrato en fase de edición
   * @param {} context
   */
		nuevoContrato: function nuevoContrato(context) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('mis-contratos/php/api/contrato/nuevo-contrato.php').then(function (res) {
				context.commit('SET_CONTRATO_ACTUAL', res.data.contrato);
			}).catch(function (e) {
				_this2.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error creando el contrato'
				});
			});
		}
	}
});

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_vue_store_stores__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__componentes_alertas_gestion_alertas__ = __webpack_require__(1362);






/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('muro', {
			name: 'Muro',
			component: __WEBPACK_IMPORTED_MODULE_1__main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_2__core_vue_store_stores__["a" /* default */].registerModule(['muro'], __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */]);

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('muro/:id', {
			name: 'Entrada del muro',
			component: __WEBPACK_IMPORTED_MODULE_1__main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('gestion-alertas', {
			name: 'Gestión de alertas',
			component: __WEBPACK_IMPORTED_MODULE_4__componentes_alertas_gestion_alertas__["a" /* default */]
		});
	}
});

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		publicaciones: []
	},
	getters: {
		publicaciones: function publicaciones(state) {
			return state.publicaciones;
		}
	},
	mutations: {
		SET_PUBLICACIONES: function SET_PUBLICACIONES(state, payload) {
			state.publicaciones = payload;
		},
		APPEND_PUBLICACIONES: function APPEND_PUBLICACIONES(state, payload) {
			state.publicaciones = state.publicaciones.concat(payload);
		},
		ADD_PUBLICACION: function ADD_PUBLICACION(state, payload) {
			state.publicaciones.splice(0, 0, payload);
		},
		UPDATE_PUBLICACION: function UPDATE_PUBLICACION(state, payload) {
			state.publicaciones = state.publicaciones.map(function (pub) {
				if (pub.PublicacionID === payload.PublicacionID) {
					pub = payload;
				}
				return pub;
			});
		},
		DELETE_PUBLICACION: function DELETE_PUBLICACION(state, payload) {
			state.publicaciones = state.publicaciones.filter(function (pub) {
				return pub.PublicacionID !== payload.PublicacionID;
			});
		}
	},
	actions: {
		recargar: function recargar(context) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('muro/php/api/getPublicaciones.php').then(function (res) {
				context.commit('SET_PUBLICACIONES', res.data);
			}).catch(function (e) {
				console.error(e);
			});
		},
		actualizarPublicacion: function actualizarPublicacion(context, PublicacionID) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('muro/php/api/getPublicacion.php?PublicacionID=' + PublicacionID).then(function (res) {
				context.commit('UPDATE_PUBLICACION', res.data);
			}).catch(function (e) {
				console.error(e);
			});
		},
		getPublicaciones: function getPublicaciones(context, LastID) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('muro/php/api/getPublicaciones.php', { lastID: LastID }).then(function (res) {
				context.commit('APPEND_PUBLICACIONES', res.data);
			}).catch(function (e) {
				console.error(e.response.data.error);
			});
		},
		delPublicacion: function delPublicacion(context, PublicacionID) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('muro/php/api/delPublicacion.php', { PublicacionID: PublicacionID }).then(function () {
				context.commit('DELETE_PUBLICACION', { PublicacionID: PublicacionID });
			}).catch(function (e) {
				console.error(e.response.data.error);
			});
		}
	}
});

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestion_alertas_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85593caa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_gestion_alertas_vue__ = __webpack_require__(1367);
function injectStyle (ssrContext) {
  __webpack_require__(1363)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85593caa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestion_alertas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85593caa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_gestion_alertas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccion_icono_vue__ = __webpack_require__(581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54eed752_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_seleccion_icono_vue__ = __webpack_require__(1366);
function injectStyle (ssrContext) {
  __webpack_require__(1365)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54eed752"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_seleccion_icono_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54eed752_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_seleccion_icono_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":600}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',[_vm._v("Selecciona icono")]),_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("×")])]),_c('div',{staticClass:"card-body text-left"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Filtrar")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro),expression:"filtro"}],staticClass:"form-control",domProps:{"value":(_vm.filtro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filtro=$event.target.value}}})]),_c('div',{staticClass:"contenedor-iconos"},_vm._l((_vm.listado),function(icono){return _c('div',{staticClass:"icono",on:{"click":function($event){return _vm.seleccionar(icono)}}},[_c('span',{class:'fa fa-' + icono.id}),_c('div',[_vm._v(_vm._s(icono.name))])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Nueva alerta")]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Título")]),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){_vm.seleccionaIcono = true}}},[_c('span',{class:_vm.alerta.Icono})])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.alerta.Titulo),expression:"alerta.Titulo"}],staticClass:"form-control",domProps:{"value":(_vm.alerta.Titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.alerta, "Titulo", $event.target.value)}}})])]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Descripción")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.alerta.Descripcion),expression:"alerta.Descripcion"}],staticClass:"form-control",attrs:{"rows":"5"},domProps:{"value":(_vm.alerta.Descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.alerta, "Descripcion", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Fecha de inicio")]),_c('datepicker',{attrs:{"inputClass":"form-control"},model:{value:(_vm.alerta.FechaInicio),callback:function ($$v) {_vm.$set(_vm.alerta, "FechaInicio", $$v)},expression:"alerta.FechaInicio"}})],1),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v("Fecha de fin")]),_c('datepicker',{attrs:{"inputClass":"form-control"},model:{value:(_vm.alerta.FechaFin),callback:function ($$v) {_vm.$set(_vm.alerta, "FechaFin", $$v)},expression:"alerta.FechaFin"}})],1)]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_vm._m(0),_c('span',[_vm._v("Guardar")])])])])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-8 col-xl-9"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Alertas vigentes (no se muestran las pasadas)")]),_c('table',{staticClass:"table table-striped"},[_vm._m(1),_c('tbody',_vm._l((_vm.alertas),function(alerta){return _c('tr',{key:alerta.id,on:{"click":function($event){return _vm.editarAlerta(alerta)}}},[_c('td',{staticClass:"text-center"},[_c('span',{class:alerta.Icono})]),_c('td',[_vm._v(_vm._s(alerta.Titulo))]),_c('td',[_vm._v(_vm._s(alerta.Descripcion))]),_c('td',[_vm._v(_vm._s(alerta.FechaInicio))]),_c('td',[_vm._v(_vm._s(alerta.FechaFin))]),_c('td',[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.borrar($event, alerta)}}},[_c('div',{staticClass:"fa fa-trash"})])])])}),0)])])]),(_vm.seleccionaIcono)?_c('SeleccionarIconos',{on:{"close":function($event){_vm.seleccionaIcono = false},"seleccion":function($event){_vm.alerta.Icono = $event}}}):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-2"},[_c('div',{staticClass:"fa fa-save"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th'),_c('th',[_vm._v("Título")]),_c('th',[_vm._v("Descripción")]),_c('th',[_vm._v("Inicio")]),_c('th',[_vm._v("Fin")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(1369);


/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install() {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('objetivos-agentes', {
			name: 'Objetivos agentes',
			component: __WEBPACK_IMPORTED_MODULE_1__main__["a" /* default */]
		});
	}
});

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c7d442_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1371);
function injectStyle (ssrContext) {
  __webpack_require__(1370)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5c7d442"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c7d442_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filtro.ano),expression:"filtro.ano",modifiers:{"number":true}}],staticClass:"form-control",domProps:{"value":(_vm.filtro.ano)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "ano", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('div',{staticClass:"form-group"},[_vm._m(2),(!_vm.filtro.AgenteID)?_c('input-query',{attrs:{"input-class":"form-control","placeholder":"Busca agente","url":"objetivos-agentes/php/api/buscaAgente.php","realtime":true},on:{"selected":function($event){return _vm.seleccionaAgente($event)}}}):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.filtro.AgenteNombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.filtro.AgenteID = null}}},[_c('span',{staticClass:"fa fa-trash"})])])])],1)]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"disabled":!_vm.filtro.AgenteID || !_vm.filtro.ano},on:{"click":_vm.getObjetivos}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Ver objetivos")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-8 col-lg-10 col-xl-10"},[_c('div',{staticClass:"card"},[_vm._m(3),_c('div',{staticClass:"tablaObjetivos"},[_vm._m(4),_vm._l((_vm.objetivos.soportes),function(sop,s){return _c('div',{staticClass:"soporte"},[_c('div',{staticClass:"nombreSoporte"},[_vm._v(_vm._s(sop.SoporteNombre))]),_vm._l((sop.meses),function(mes,i){return _c('div',{staticClass:"mes"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.objetivos.soportes[s].meses[i]),expression:"objetivos.soportes[s].meses[i]",modifiers:{"number":true}}],staticClass:"inpObjetivo",attrs:{"placeholder":"0","disabled":_vm.filtro.ano < new Date().getFullYear()},domProps:{"value":(_vm.objetivos.soportes[s].meses[i])},on:{"blur":[function($event){return _vm.asignarSoporte(sop, i, $event)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.objetivos.soportes[s].meses, i, _vm._n($event.target.value))}}})])}),_c('div',{staticClass:"mes text-right p-1"},[_vm._v(_vm._s(_vm._f("currency")(_vm.total(sop),''))+" €")])],2)})],2)]),_c('div',{staticClass:"card"},[_vm._m(5),_c('div',{staticClass:"tablaObjetivos"},[_vm._m(6),_vm._l((_vm.objetivos.partidas),function(par,s){return _c('div',{staticClass:"soporte"},[_c('div',{staticClass:"nombreSoporte"},[_vm._v(_vm._s(par.PartidaNombre))]),_vm._l((par.meses),function(mes,i){return _c('div',{staticClass:"mes"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.objetivos.partidas[s].meses[i]),expression:"objetivos.partidas[s].meses[i]",modifiers:{"number":true}}],staticClass:"inpObjetivo",attrs:{"placeholder":"0","disabled":_vm.filtro.ano < new Date().getFullYear()},domProps:{"value":(_vm.objetivos.partidas[s].meses[i])},on:{"blur":[function($event){return _vm.asignarPartida(par, i, $event)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.objetivos.partidas[s].meses, i, _vm._n($event.target.value))}}})])}),_c('div',{staticClass:"mes text-right p-1"},[_vm._v(_vm._s(_vm._f("currency")(_vm.total(par),''))+" €")])],2)})],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-filter mr-2"}),_vm._v("Selecciona")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Año")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Agente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-warning text-dark"},[_c('span',{staticClass:"fa fa-calculator mr-2"}),_vm._v("Objetivos Soportes")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"soporte"},[_c('div',{staticClass:"nombreSoporte"},[_vm._v("Soporte")]),_c('div',{staticClass:"mes"},[_vm._v("Ene")]),_c('div',{staticClass:"mes"},[_vm._v("Feb")]),_c('div',{staticClass:"mes"},[_vm._v("Mar")]),_c('div',{staticClass:"mes"},[_vm._v("Abr")]),_c('div',{staticClass:"mes"},[_vm._v("May")]),_c('div',{staticClass:"mes"},[_vm._v("Jun")]),_c('div',{staticClass:"mes"},[_vm._v("Jul")]),_c('div',{staticClass:"mes"},[_vm._v("Ago")]),_c('div',{staticClass:"mes"},[_vm._v("Sep")]),_c('div',{staticClass:"mes"},[_vm._v("Oct")]),_c('div',{staticClass:"mes"},[_vm._v("Nov")]),_c('div',{staticClass:"mes"},[_vm._v("Dic")]),_c('div',{staticClass:"mes text-right p-1"},[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-danger text-white"},[_c('span',{staticClass:"fa fa-calculator mr-2"}),_vm._v("Objetivos Partidas")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"soporte"},[_c('div',{staticClass:"nombreSoporte"},[_vm._v("Partida")]),_c('div',{staticClass:"mes"},[_vm._v("Ene")]),_c('div',{staticClass:"mes"},[_vm._v("Feb")]),_c('div',{staticClass:"mes"},[_vm._v("Mar")]),_c('div',{staticClass:"mes"},[_vm._v("Abr")]),_c('div',{staticClass:"mes"},[_vm._v("May")]),_c('div',{staticClass:"mes"},[_vm._v("Jun")]),_c('div',{staticClass:"mes"},[_vm._v("Jul")]),_c('div',{staticClass:"mes"},[_vm._v("Ago")]),_c('div',{staticClass:"mes"},[_vm._v("Sep")]),_c('div',{staticClass:"mes"},[_vm._v("Oct")]),_c('div',{staticClass:"mes"},[_vm._v("Nov")]),_c('div',{staticClass:"mes"},[_vm._v("Dic")]),_c('div',{staticClass:"mes text-right p-1"},[_vm._v("Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paginas_organizar_organizar_vue__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_vue_store_stores__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(1403);






/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('organizar-emisoras', {
			name: 'Organizar emisoras',
			component: __WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('organizar-emisoras').child('organizar', {
			name: 'Organizar emisoras',
			component: __WEBPACK_IMPORTED_MODULE_2__paginas_organizar_organizar_vue__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('organizar-emisoras').child('', {
			redirect: '/main/organizar-emisoras/organizar'
		});

		__WEBPACK_IMPORTED_MODULE_3__core_vue_store_stores__["a" /* default */].registerModule(['organizar-emisoras'], __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]);
	}
});

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96b60c5c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1374);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96b60c5c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organizar_vue__ = __webpack_require__(584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f730ed6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_organizar_vue__ = __webpack_require__(1402);
function injectStyle (ssrContext) {
  __webpack_require__(1376)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f730ed6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_organizar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f730ed6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_organizar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","display":"block","width":"100%"}},_vm._l((_vm.listado),function(buzon){return _c('div',{key:buzon.BuzonID,staticClass:"bg-white buzon"},[_c('div',{staticClass:"tituloBuzon",class:(_vm.activo === buzon) ? 'bg-warning' : '',style:(_vm.estilo),on:{"dblclick":function($event){return _vm.toggleExpandir($event, buzon.BuzonID)},"click":function($event){return _vm.selecciona(buzon)}}},[_c('div',{staticStyle:{"cursor":"pointer","position":"relative","display":"inline-block","width":"10px"},on:{"click":function($event){return _vm.toggleExpandir($event, buzon.BuzonID)}}},[(buzon.buzonesHijos.length > 0)?_c('span',[(_vm.expandir.indexOf(buzon.BuzonID) >= 0)?_c('span',[_vm._v("-")]):_c('span',[_vm._v("+")])]):_vm._e()]),_c('div',{staticStyle:{"display":"inline-block"}},[_c('span',{staticClass:"fa fa-folder mr-2",style:(_vm.estiloBuzon(buzon))})]),_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v(_vm._s(buzon.BuzonDescripcion))])]),(buzon.buzonesHijos.length > 0 && _vm.expandir.indexOf(buzon.BuzonID) >= 0)?_c('arbol-buzones',{attrs:{"listado":buzon.buzonesHijos,"nivel":_vm.nivel + 1,"activo":_vm.activo},on:{"select":_vm.selecciona}}):_vm._e()],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objetos_buzon_vue__ = __webpack_require__(587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d89ed954_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_objetos_buzon_vue__ = __webpack_require__(1381);
function injectStyle (ssrContext) {
  __webpack_require__(1380)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d89ed954"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objetos_buzon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d89ed954_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_objetos_buzon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contenedor"},[_c('div',{staticClass:"contieneFiltro",staticStyle:{"max-height":"30px","min-height":"30px"}},[_c('div',{staticClass:"input-group input-group-sm"},[_vm._m(0),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtroNombre),expression:"filtroNombre"}],staticClass:"form-control",attrs:{"placeholder":"Filtrar por nombre"},domProps:{"value":(_vm.filtroNombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filtroNombre=$event.target.value}}}),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filtroSegundos),expression:"filtroSegundos",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"placeholder":"Por segundos"},domProps:{"value":(_vm.filtroSegundos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filtroSegundos=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}}),_vm._m(1)])]),_c('div',{staticClass:"contieneCabecera"},[_c('div',{staticClass:"text-left",on:{"click":function($event){return _vm.setOrdenBuzon('ObjetoDescripcion')}}},[_c('span',{staticClass:"mr-2 fa",class:(_vm.ordenar.campo === 'ObjetoDescripcion') ? (_vm.ordenar.asc) ? 'fa-caret-up' : 'fa-caret-down' : ''}),_vm._v("Fichero")]),_c('div',{staticClass:"text-right",on:{"click":function($event){return _vm.setOrdenBuzon('ObjetoDuracion')}}},[_c('span',{staticClass:"mr-2 fa",class:(_vm.ordenar.campo === 'ObjetoDuracion') ? (_vm.ordenar.asc) ? 'fa-caret-up' : 'fa-caret-down' : ''}),_vm._v("Duración")])]),_c('div',{ref:"tablaContainer",staticClass:"contieneTabla",attrs:{"tabindex":"6"},on:{"keydown":_vm.teclaAbajo,"keyup":_vm.teclaArriba}},[_c('table',{staticClass:"table table-striped",staticStyle:{"width":"100%"}},[_c('tbody',_vm._l((_vm.listaFicheros),function(objeto){return _c('tr',{key:objeto.ObjetoID,ref:'objeto' + objeto.ObjetoID,refInFor:true,class:(_vm.seleccion.indexOf(objeto) >= 0) ? 'bg-info' : '',style:(objeto.style),attrs:{"draggable":"draggable"},on:{"click":function($event){return _vm.seleccionaObjeto(objeto)},"dblclick":function($event){return _vm.agregarObjetos(objeto)},"dragstart":function($event){return _vm.arrastraObjeto($event, objeto)},"contextmenu":function($event){return _vm.menuContextual($event, objeto)}}},[_c('td',{staticClass:"p-1",staticStyle:{"max-width":"0","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v(_vm._s(objeto.ObjetoDescripcion))]),_c('td',{staticClass:"p-1 text-right",staticStyle:{"width":"60px"}},[_vm._v(_vm._s(_vm._getDuracionFisica(objeto.DuracionFisica)))])])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-filter"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("seg.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bloques_vue__ = __webpack_require__(588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bc6a36_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_bloques_vue__ = __webpack_require__(1384);
function injectStyle (ssrContext) {
  __webpack_require__(1383)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30bc6a36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bloques_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30bc6a36_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_bloques_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contieneBloques",attrs:{"tabindex":"4"},on:{"keydown":_vm.teclaAbajo,"keyup":_vm.teclaArriba}},[_c('div',{staticClass:"contieneTabla",staticStyle:{"flex-grow":"1"}},[_c('table',{staticClass:"table table-striped"},[_vm._m(0),_c('tbody',_vm._l((_vm.bloques),function(blo,index){return _c('tr',{key:blo.BloqueID,class:(_vm.bloqueActivo && _vm.bloqueActivo.BloqueID === blo.BloqueID) ? 'bg-info text-white' : '',staticStyle:{"cursor":"default"},attrs:{"id":'bloque-' + blo.BloqueID},on:{"click":function($event){return _vm.seleccionaBloque(blo)}}},[_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(blo.BloqueDescripcion)),(blo.insercionesEncontradas)?_c('span',{staticClass:"text-danger fa fa-podcast ml-2"}):_vm._e()]),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(blo.BloqueHoraInicio))]),_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(blo.BloqueHoraFin))]),_c('td',{staticClass:"p-1",class:(_vm.porcentajeBloque(blo) >= 110) ? 'bg-dark text-white' : (_vm.porcentajeBloque(blo) >= 100) ? 'bg-danger text-white' : (_vm.porcentajeBloque(blo) > 75) ? 'bg-warning' : (_vm.porcentajeBloque(blo) >= 15) ? 'bg-success text-white' : ''},[_c('span',[_vm._v(_vm._s(_vm._f("moment")(blo.duracion,'mm:ss')))])]),_c('td',{staticClass:"p-1",class:(_vm.porcentajeBloque(blo) >= 110) ? 'bg-dark text-white' : (_vm.porcentajeBloque(blo) >= 100) ? 'bg-danger text-white' : (_vm.porcentajeBloque(blo) > 75) ? 'bg-warning' : (_vm.porcentajeBloque(blo) >= 15) ? 'bg-success text-white' : ''},[_c('span',[_vm._v(_vm._s(_vm._getTiempo(blo.DuracionObjetosFisica, true))+" ("+_vm._s(_vm.porcentajeBloque(blo))+" %)")])])])}),0)])]),(_vm.bloqueActivo)?_c('div',{staticClass:"p-1 text-right bg-warning",staticStyle:{"font-size":"1.4em","flex-basis":"0","height":"auto"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('b',[_vm._v("Bloque:")]),_vm._v(" "+_vm._s(_vm.bloqueActivo.BloqueHoraInicio)+" - "+_vm._s(_vm.bloqueActivo.BloqueHoraFin))]),_c('div',{staticClass:"col text-center",class:(_vm.sobreOcupacionParrilla) ? 'text-danger font-weight-bold' : ''},[_vm._v("Quedan: "+_vm._s(_vm.tiempoRestanteParrilla))])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',{staticClass:"p-1"},[_vm._v("Nombre bloque")]),_c('th',{staticClass:"p-1"},[_vm._v("Hora de inicio")]),_c('th',{staticClass:"p-1"},[_vm._v("Hora de fin")]),_c('th',{staticClass:"p-1"},[_vm._v("Duración")]),_c('th',{staticClass:"p-1"},[_vm._v("Programado")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parrilla_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b4d7e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_parrilla_vue__ = __webpack_require__(1387);
function injectStyle (ssrContext) {
  __webpack_require__(1386)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11b4d7e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parrilla_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b4d7e2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_parrilla_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contieneBloque",attrs:{"droppable":"droppable","tabindex":"5"},on:{"drop":function($event){return _vm.dropped($event, true)},"dragover":function($event){return _vm.dragOver($event, true)},"dragenter":function($event){return _vm.dragEnter($event, true)},"dragleave":function($event){return _vm.dragOut($event, true)},"keydown":_vm.teclaAbajo,"keyup":_vm.teclaArriba}},[_c('img',{ref:"imgdrag",staticStyle:{"display":"none"},attrs:{"id":"imgdrag","src":__webpack_require__(1388)}}),_c('table',{staticClass:"table table-striped"},[_vm._m(0),_c('tbody',_vm._l((_vm.listadoParrilla),function(ins,i){return _c('tr',{key:ins.ProgramacionID,ref:'objeto-parrilla-' + ins.ProgramacionID,refInFor:true,staticClass:"fila",class:(_vm.seleccion.indexOf(ins) >= 0) ? 'bg-info' : '',staticStyle:{"cursor":"default","box-sizing":"border-box"},style:(_vm._getEstilo(ins.BuzonColor)),attrs:{"draggable":"draggable"},on:{"click":function($event){return _vm.selecciona(ins)},"dragstart":function($event){return _vm.dragStart($event, ins)},"dragover":function($event){return _vm.dragOver($event, false, ins)},"dragenter":function($event){return _vm.dragEnter($event, false, ins)},"dragleave":function($event){return _vm.dragOut($event, false, ins)},"drop":function($event){return _vm.dropped($event, ins)},"contextmenu":function($event){return _vm.menuContextual($event, ins, 'parrilla')}}},[_c('td',{staticClass:"p-1 bg-white text-dark"},[_vm._v(_vm._s(i + 1))]),_c('td',{staticClass:"p-1 text-white",style:((ins.HoraComienza > ins.HoraFinUnix) ? {backgroundColor: 'red'} : {backgroundColor: 'green'})},[_vm._v(_vm._s(_vm._f("moment")(ins.HoraComienza,'HH:mm:ss')))]),_c('td',{staticClass:"p-1 text-white",style:((ins.HoraFinaliza > ins.HoraFinUnix) ? {backgroundColor: 'red'} : {backgroundColor: 'green'})},[_vm._v(_vm._s(_vm._f("moment")(ins.HoraFinaliza,'HH:mm:ss')))]),_c('td',{staticClass:"p-1"},[(ins.alertaLocs)?_c('span',{staticClass:"text-danger mr-2 p-1",staticStyle:{"font-weight":"bold","background-color":"black"}},[_c('span',{staticClass:"fa fa-exclamation-triangle"})]):_vm._e(),(ins.alertaAnun)?_c('span',{staticClass:"text-warning mr-2 p-1",staticStyle:{"font-weight":"bold","background-color":"black"}},[_c('soan',{staticClass:"fa fa-bell-slash"})],1):_vm._e(),_c('span',[_vm._v(_vm._s(ins.ObjetoDescripcion))])]),_c('td',{staticClass:"p-1 text-right"},[_vm._v(_vm._s(_vm._getDuracionFisica(ins.DuracionFisica)))])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',{staticClass:"p-1"},[_vm._v("#")]),_c('th',{staticClass:"p-1"},[_vm._v("H. inicio")]),_c('th',{staticClass:"p-1"},[_vm._v("H. fin")]),_c('th',{staticClass:"p-1"},[_vm._v("Nombre fichero")]),_c('th',{staticClass:"p-1 text-right"},[_vm._v("Duración")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBhcJJDeTUvWJAAAAyklEQVQoz8XRoUpDYQCG4ecf/9lxiGNGg2GyoCiIgkm8AbtxUaOIVTDKLIsGYcmgoGAwmrQIsjYEg00WvALnYTvH4PEa9oaXL7ztY/oEz+rlLjBv36Oaaw09V0QL7iUSiSixag6zNpzZ/QsOLfk2Mir9al1Lw8Cxjs/gQ19QEQRBS8elW2+62mq60YtlwVgmk4kmJr4U6jal8mBFU0XVjKpU6saWRacOnDsxDAbuFHKFAjseXKDvXdM20dCevEzGfjyBI2t60/7gn19FaDhqH/EykAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNi0yM1QwOTozNjo1NSswMjowMACqow8AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDYtMjNUMDk6MzY6NTUrMDI6MDBx9xuzAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reproductor",class:(_vm.idObjeto) ? 'show' : ''},[_c('audio',{ref:"player",staticStyle:{"position":"relative","display":"inline-block","vertical-align":"middle","width":"calc(100% - 80px)"},attrs:{"autoplay":"true","src":'/src/modulos/organizar-emisoras/php/api/reproducir.php?ObjetoID=' + _vm.idObjeto,"type":"audio/mpeg"}}),_c('div',{staticClass:"player"},[_c('div',{staticClass:"duracion"},[(_vm.actual && _vm.duracion)?_c('div',[_c('span',[_vm._v(_vm._s(Math.round(_vm.actual)))]),_vm._v("/"),_c('span',[_vm._v(_vm._s(Math.round(_vm.duracion)))])]):_vm._e()]),_c('div',{ref:"barra",staticClass:"barra"},[_c('div',{staticClass:"progreso",style:(_vm.estiloBarra)})]),_c('div',{staticClass:"boton"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"border-radius":"0"},on:{"click":_vm.cerrar}},[_c('span',{staticClass:"fa fa-close mr-2"}),_vm._v("Cerrar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_favoritos_vue__ = __webpack_require__(592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da2586d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_favoritos_vue__ = __webpack_require__(1399);
function injectStyle (ssrContext) {
  __webpack_require__(1392)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0da2586d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_favoritos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0da2586d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_favoritos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":300}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-folder mr-2"}),_vm._v("Buzón"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Buzón padre")]),_c('input',{staticClass:"form-control",attrs:{"disabled":"true"},domProps:{"value":_vm.padre.nombre}})]),_c('hr'),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nombre del buzón")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buzon.nombre),expression:"buzon.nombre"}],ref:"nombre",staticClass:"form-control",domProps:{"value":(_vm.buzon.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.buzon, "nombre", $event.target.value)}}})])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","display":"block","width":"100%"}},_vm._l((_vm.listado),function(buzon){return _c('div',{key:buzon.ID_buzon,staticClass:"bg-white buzon"},[_c('div',{staticClass:"tituloBuzon pt-1 pb-1",class:(_vm.activo === buzon) ? 'bg-warning' : '',style:(_vm.estilo),on:{"dblclick":function($event){return _vm.toggleExpandir($event, buzon.ID_buzon)},"click":function($event){return _vm.selecciona(buzon)},"contextmenu":function($event){return _vm.menuContextual($event, buzon)}}},[_c('div',{staticStyle:{"cursor":"pointer","position":"relative","display":"inline-block","width":"10px"},on:{"click":function($event){return _vm.toggleExpandir($event, buzon.ID_buzon)}}},[(buzon.hijos.length > 0)?_c('span',[(_vm.expandir.indexOf(buzon.ID_buzon) >= 0)?_c('span',[_vm._v("-")]):_c('span',[_vm._v("+")])]):_vm._e()]),_c('div',{staticStyle:{"display":"inline-block"}},[_c('span',{staticClass:"fa fa-folder mr-2",style:(_vm.estiloBuzon(buzon))})]),_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v(_vm._s(buzon.nombre))])]),(buzon.hijos.length > 0 && _vm.expandir.indexOf(buzon.ID_buzon) >= 0)?_c('arbol-favoritos',{attrs:{"listado":buzon.hijos,"nivel":_vm.nivel + 1,"activo":_vm.activo},on:{"select":_vm.selecciona,"update":_vm.update}}):_vm._e(),(_vm.editar)?_c('editor-buzones',{attrs:{"padre":_vm.editar.padre,"buzon":_vm.editar.buzon},on:{"cerrar":function($event){_vm.editar = null},"guardado":_vm.update}}):_vm._e()],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ficheros_favoritos_vue__ = __webpack_require__(597);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702fbd50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ficheros_favoritos_vue__ = __webpack_require__(1398);
function injectStyle (ssrContext) {
  __webpack_require__(1397)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-702fbd50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ficheros_favoritos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_702fbd50_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ficheros_favoritos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"caja",staticClass:"cajaFicheros",attrs:{"tabindex":"3"},on:{"dragover":_vm.dragOverFicheros,"dragleave":_vm.dragLeaveFicheros,"drop":_vm.droppedFicheros,"keydown":_vm.teclaAbajo,"keyup":_vm.teclaArriba}},[_c('table',{staticClass:"table table-striped m-0",staticStyle:{"width":"100%"}},[_c('tbody',_vm._l((_vm.listadoFicheros),function(fichero,i){return _c('tr',{key:fichero.ID_favorito,class:(_vm.seleccion.indexOf(fichero) >= 0) ? 'bg-info' : '',attrs:{"id":'favorito-' + fichero.ID_favorito,"draggable":"draggable"},on:{"click":function($event){return _vm.seleccionaFichero(fichero)},"dragstart":function($event){return _vm.dragStart($event, fichero)},"dblclick":function($event){return _vm.agregarObjeto(fichero)},"contextmenu":function($event){return _vm.menuContextual($event, fichero)}}},[_c('td',{staticClass:"p-1",staticStyle:{"max-width":"0","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"}},[_vm._v(_vm._s(fichero.ObjetoDescripcion))]),_c('td',{staticClass:"p-1 text-right",staticStyle:{"width":"45px"}},[_vm._v(_vm._s(_vm._getDuracionFisica(fichero.ObjetoDuracion)))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contenedor"},[_vm._m(0),(_vm.listadoBuzones.length > 0)?_c('arbol-favoritos',{staticClass:"arbol",attrs:{"listado":_vm.listadoBuzones,"nivel":0},nativeOn:{"contextmenu":function($event){return _vm.menuContextualArbol($event)}}}):_vm._e(),(_vm.listadoBuzones.length === 0)?_c('div',{staticClass:"arbol text-center p-3 text-danger",on:{"contextmenu":_vm.menuContextualArbol}},[_c('h3',[_vm._v("No tienes buzones")]),_vm._m(1)]):_vm._e(),(_vm.buzonActivo)?_c('ficheros-favoritos',{staticClass:"ficheros",attrs:{"buzon":_vm.buzonActivo},on:{"insertar":_vm.insertar,"reproducir":_vm.reproducir}}):_vm._e(),(_vm.editarBuzon)?_c('editor-buzones',{attrs:{"padre":_vm.editarBuzon.padre,"buzon":_vm.editarBuzon.buzon},on:{"cerrar":function($event){_vm.editarBuzon = null},"guardado":_vm.getListado}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titulo"},[_c('div',{staticClass:"bg-dark text-white p-1"},[_c('span',{staticClass:"fa fa-star mr-2"}),_vm._v("Favoritos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('small',[_vm._v("Haz click derecho para crear uno")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_busqueda_global_vue__ = __webpack_require__(598);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1268b7c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_busqueda_global_vue__ = __webpack_require__(1401);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_busqueda_global_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1268b7c0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_busqueda_global_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Búqueda de ficheros"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-search"})])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cadena),expression:"cadena"}],staticClass:"form-control",domProps:{"value":(_vm.cadena)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.cadena=$event.target.value}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-gear"})])])])]),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"400px","overflow-y":"auto"}},[_c('table',{staticClass:"table table-striped",attrs:{"tabindex":"5"},on:{"keydown":_vm.teclaAbajo,"keyup":_vm.teclaArriba}},[_c('tbody',_vm._l((_vm.listadoFicheros),function(fichero){return _c('tr',{key:fichero.ObjetoID,class:(_vm.seleccion.indexOf(fichero) >= 0) ? 'bg-info' : '',attrs:{"draggable":"draggable","id":'fichero-' + fichero.ObjetoID},on:{"dragstart":function($event){return _vm.dragStart($event, fichero)},"click":function($event){return _vm.seleccionaFichero(fichero)}}},[_c('td',{staticClass:"p-1 text-left"},[_vm._v(_vm._s(fichero.ObjetoDescripcion))]),_c('td',{staticClass:"p-1 text-right"},[_vm._v(_vm._s(_vm._getDuracionFisica(fichero.ObjetoDuracion)))])])}),0)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"contenedor",staticClass:"contenedor",staticStyle:{"margin-top":"-20px"}},[_c('div',{staticClass:"colA"},[_c('div',{staticClass:"formulario"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"text-center"},[(_vm.imagenEmisora)?_c('img',{staticStyle:{"max-height":"50px","max-width":"90%","margin-bottom":"5px"},attrs:{"src":_vm.imagenEmisora}}):_vm._e()]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Emisora")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.EmisoraID),expression:"EmisoraID"}],staticClass:"form-control",attrs:{"tabindex":"1"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.EmisoraID=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_vm._l((_vm.listadoEmisoras),function(emi){return _c('option',{key:emi.ID_emisora,domProps:{"value":emi.xframe_ID}},[_vm._v(_vm._s(emi.nombre))])})],2)]),_c('div',{staticClass:"input-group mt-2"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.cambiaDia(-1)}}},[_c('span',{staticClass:"fa fa-caret-left"})])]),_c('datepicker',{attrs:{"language":_vm.$dateLang,"monday-first":true,"bootstrap-styling":true,"input-class":"form-control","format":"D dd MMM yyyy"},model:{value:(_vm.dia),callback:function ($$v) {_vm.dia=$$v},expression:"dia"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.cambiaDia(1)}}},[_c('span',{staticClass:"fa fa-caret-right"})])])],1),_c('span',{ref:"imgDrag"}),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.ocultarBloquesVacios) ? 'btn-primary' : '',attrs:{"tabindex":"2","title":"Ocultar bloques vacíos"},on:{"click":_vm.toggleOmitir}},[_c('span',{staticClass:"fa",class:(!_vm.ocultarBloquesVacios) ? 'fa-eye' : 'fa-eye-slash'})]),_c('button',{staticClass:"btn btn-warning",attrs:{"title":"Buscar ficheros en todo el sistema"},on:{"click":function($event){_vm.busquedaGlobal = true}}},[_c('span',{staticClass:"fa fa-search"})]),_c('button',{staticClass:"btn btn-warning",attrs:{"title":"Actualizar bloques"},on:{"click":function($event){_vm.actualizarBloques = true}}},[_c('span',{staticClass:"fa fa-refresh"})])]),_c('div',{staticClass:"input-group mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buscaInsercion),expression:"buscaInsercion"}],staticClass:"form-control",attrs:{"placeholder":"Buscar inserción"},domProps:{"value":(_vm.buscaInsercion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.buscaInsercion=$event.target.value}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.buscarInserciones}},[_c('span',{staticClass:"fa fa-search"})])])])])])]),_c('div',{staticClass:"favoritos"},[_c('favoritos',{staticStyle:{"flex-grow":"1","align-self":"stretch","align-content":"stretch"}})],1)]),_c('div',{staticClass:"colB"},[_c('bloques',{staticClass:"contieneTabla"}),_c('parrilla',{attrs:{"bloque":_vm.bloqueActivo,"filtro":_vm.filtro,"insertar":_vm.objetosInsertar},on:{"reproducir":function($event){_vm.reproducir = $event},"actualizar":function($event){_vm.actualizarBloques = true}}})],1),_c('div',{staticClass:"colC"},[_c('div',{staticClass:"contieneBuzones"},[_vm._m(0),(_vm.listadoBuzones.length > 0)?_c('arbol-buzones',{attrs:{"listado":_vm.listadoBuzones,"nivel":0,"activo":_vm.buzonActivo},on:{"select":_vm.seleccionaBuzon}}):_vm._e()],1),_c('div',{staticClass:"contieneFicheros"},[_c('objetos-buzon',{attrs:{"buzon":_vm.buzonActivo,"bloque":_vm.bloqueActivo},on:{"reproducir":function($event){_vm.reproducir = $event},"insertar":function($event){_vm.objetosInsertar = $event}}})],1)]),_c('reproductor',{attrs:{"id-objeto":_vm.reproducir},on:{"cerrar":function($event){_vm.reproducir = null}}}),(_vm.busquedaGlobal)?_c('busqueda-global',{on:{"cerrar":function($event){_vm.busquedaGlobal = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-dark text-white p-1"},[_c('span',{staticClass:"fa fa-folder mr-2"}),_vm._v("Buzones")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(21);



/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		filtro: {
			EmisoraID: null,
			dia: Math.round(new Date().getTime() / 1000),
			buscaInsercion: ''
		},
		parrilla: [],
		insercionActiva: null,
		seleccionInserciones: [],
		bloques: [],
		bloqueActivo: null,
		seleccionBloques: [],
		buzonesFavoritos: [],
		buzonFavorito: null,
		ficherosFavoritos: [],
		seleccionFavoritos: [],
		omitirBloquesSinMatricula: true,
		reproducir: null,
		xfavoritos: {
			buzones: [],
			ficheros: [],
			seleccion: [],
			buzonActivo: null
		},
		xbloques: {
			listado: [],
			bloqueActivo: null,
			omitirSinMatricula: true,
			insercionesEncontradas: []
		},
		xparrilla: {
			inserciones: [],
			seleccion: []
		}
	},
	getters: {
		// Filtro
		EmisoraID: function EmisoraID(state) {
			return state.filtro.EmisoraID;
		},
		dia: function dia(state) {
			return state.filtro.dia;
		},


		// Favoritos
		buzonesFavoritos: function buzonesFavoritos(state) {
			return state.xfavoritos.buzones;
		},
		ficherosFavoritos: function ficherosFavoritos(state) {
			return state.xfavoritos.ficheros;
		},
		seleccionFavoritos: function seleccionFavoritos(state) {
			return state.xfavoritos.seleccion;
		},
		buzonActivoFavoritos: function buzonActivoFavoritos(state) {
			return state.xfavoritos.buzonActivo;
		},


		// Bloques
		listadoBloques: function listadoBloques(state) {
			return state.xbloques.listado.filter(function (b) {
				return !state.xbloques.omitirSinMatricula || b.BloqueMatricula;
			}).map(function (b) {
				if (state.xbloques.insercionesEncontradas.map(function (blo) {
					return blo.BloqueID;
				}).indexOf(b.BloqueID) >= 0) {
					b.insercionesEncontradas = true;
				} else {
					b.insercionesEncontradas = false;
				}
				return b;
			});
		},
		bloqueActivo: function bloqueActivo(state) {
			return state.xbloques.bloqueActivo;
		},
		omitirBloquesSinMatricula: function omitirBloquesSinMatricula(state) {
			return state.xbloques.omitirSinMatricula;
		},
		insercionesBuscadas: function insercionesBuscadas(state) {
			return state.xbloques.insercionesBuscadas;
		},


		// Parrilla
		insercionesParrilla: function insercionesParrilla(state) {
			return state.xparrilla.inserciones;
		},
		seleccionInserciones: function seleccionInserciones(state) {
			return state.xparrilla.seleccion;
		},


		// OLD
		bloques: function bloques(state) {
			return state.bloques.filter(function (b) {
				return !state.omitirBloquesSinMatricula || b.BloqueMatricula;
			});
		}
	},
	mutations: {
		// Filtro
		SET_FILTRO: function SET_FILTRO(state, data) {
			state.filtro = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.filtro, data);
		},

		// Favoritos
		SET_BUZONES_FAVORITOS: function SET_BUZONES_FAVORITOS(state, data) {
			state.xfavoritos.buzones = data;
		},
		SET_BUZON_FAVORITO_ACTIVO: function SET_BUZON_FAVORITO_ACTIVO(state, data) {
			state.xfavoritos.buzonActivo = data;
			state.xfavoritos.seleccion = [];
			state.xfavoritos.ficheros = [];
		},
		SET_FICHEROS_FAVORITOS: function SET_FICHEROS_FAVORITOS(state, data) {
			state.xfavoritos.ficheros = data;
		},
		BORRA_SELECCION_FAVORITOS: function BORRA_SELECCION_FAVORITOS(state) {
			state.xfavoritos.seleccion = [];
		},
		SELECCIONA_FAVORITO: function SELECCIONA_FAVORITO(state, data) {
			var fichero = data.fichero;
			var ctrl = data.ctrl || false;
			var shift = data.shift || false;
			// Si no estamos pulsando ni control ni shift, solo seleccionamos
			// el objeto que se ha clicado
			if (!ctrl && !shift || state.xfavoritos.seleccion.length === 0) {
				state.xfavoritos.seleccion = [fichero];
			} else if (ctrl) {
				// Si el fichero ya está seleccionado lo desseleccionamos
				state.xfavoritos.seleccion = state.xfavoritos.ficheros.filter(function (f) {
					return state.xfavoritos.seleccion.indexOf(f) >= 0 && f.ObjetoID !== fichero.ObjetoID || state.xfavoritos.seleccion.indexOf(f) < 0 && f.ObjetoID === fichero.ObjetoID;
				});
			} else if (shift) {
				// Seleccionamos desde el primer fichero seleccionado hasta el que acaba de clicar
				// Primero hay que ver cual es el elemento con menor índice seleccionado
				var i = null;
				for (var f = 0; f < state.xfavoritos.seleccion.length; f++) {
					var idx = state.xfavoritos.ficheros.indexOf(state.xfavoritos.seleccion[f]);
					if (idx >= 0) {
						i = i === null || i > idx ? idx : i;
					}
				}

				// Ya tenemos el elemento con menor índice, ahora vamos a ver cual es el indice del elemento que hemos seleccionado
				var o = state.xfavoritos.ficheros.indexOf(fichero);
				var primero = i <= o ? i : o;
				var segundo = i >= o ? i : o;
				state.xfavoritos.seleccion = state.xfavoritos.ficheros.filter(function (f, i) {
					return i >= primero && i <= segundo;
				});
			}
		},


		// Bloques
		SET_LISTADO_BLOQUES: function SET_LISTADO_BLOQUES(state, data) {
			state.xbloques.listado = data;
		},

		// Actualiza la información de un bloque
		ACTUALIZA_BLOQUE: function ACTUALIZA_BLOQUE(state, data) {
			if (state.xbloques.bloqueActivo.BloqueID === data.BloqueID) {
				state.xbloques.bloqueActivo = data;
			}
			for (var i = 0; i < state.xbloques.listado.length; i++) {
				if (state.xbloques.listado[i].BloqueID === data.BloqueID) {
					__WEBPACK_IMPORTED_MODULE_2_vue__["default"].set(state.xbloques.listado, i, data);
					return;
				}
			}
		},
		SET_BLOQUE_ACTIVO: function SET_BLOQUE_ACTIVO(state, data) {
			state.xbloques.bloqueActivo = data;
		},
		TOGGLE_SIN_MATRICULA: function TOGGLE_SIN_MATRICULA(state, estado) {
			state.xbloques.omitirSinMatricula = !state.xbloques.omitirSinMatricula;
		},
		SET_INSERCIONES_ENCONTRADAS: function SET_INSERCIONES_ENCONTRADAS(state, listado) {
			state.xbloques.insercionesEncontradas = listado;
		},


		// Parrilla
		SET_INSERCIONES_PARRILLA: function SET_INSERCIONES_PARRILLA(state, data) {
			state.xparrilla.inserciones = data;
		},
		BORRA_SELECCION_INSERCIONES: function BORRA_SELECCION_INSERCIONES(state) {
			state.xparrilla.seleccion = [];
		},
		SELECCIONA_INSERCION: function SELECCIONA_INSERCION(state, data) {
			var insercion = data.insercion;
			var ctrl = data.ctrl;
			var shift = data.shift;

			// Si no estamos pulsando ni control ni shift, solo seleccionamos
			// el objeto que se ha clicado
			if (!ctrl && !shift || state.xparrilla.seleccion.length === 0) {
				state.xparrilla.seleccion = [insercion];
			} else if (ctrl) {
				// Si el fichero ya está seleccionado lo desseleccionamos
				state.xparrilla.seleccion = state.xparrilla.inserciones.filter(function (f) {
					return state.xparrilla.seleccion.indexOf(f) >= 0 && f.ProgramacionID !== insercion.ProgramacionID || state.xparrilla.seleccion.indexOf(f) < 0 && f.ProgramacionID === insercion.ProgramacionID;
				});
			} else if (shift) {
				// Seleccionamos desde el primer fichero seleccionado hasta el que acaba de clicar
				// Primero hay que ver cual es el elemento con menor índice seleccionado
				var i = null;
				for (var f = 0; f < state.xparrilla.seleccion.length; f++) {
					var idx = state.xparrilla.inserciones.indexOf(state.xparrilla.seleccion[f]);
					if (idx >= 0) {
						i = i === null || i > idx ? idx : i;
					}
				}

				// Ya tenemos el elemento con menor índice, ahora vamos a ver cual es el indice del elemento que hemos seleccionado
				var o = state.xparrilla.inserciones.indexOf(insercion);
				var primero = i <= o ? i : o;
				var segundo = i >= o ? i : o;
				state.xparrilla.seleccion = state.xparrilla.inserciones.filter(function (f, i) {
					return i >= primero && i <= segundo;
				});
			}
		},


		// Reproducir
		REPRODUCIR: function REPRODUCIR(state, data) {
			state.reproducir = data;
		}
	},
	actions: {
		// Filtro
		setFiltro: function setFiltro(context, data) {
			// Actualizamos el filtro y realizamos las consultas de todos los endpoints relacionados
			context.commit('SET_FILTRO', data);

			if (context.state.filtro.dia && context.state.filtro.EmisoraID) {
				// Disparamos las consultas
				context.dispatch('getBloques');
			}
		},


		// Favoritos
		getBuzonesFavoritos: function getBuzonesFavoritos(context, filtro) {
			var _this = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('organizar-emisoras/php/api/favoritos/get-buzones.php').then(function (res) {
				context.commit('SET_BUZONES_FAVORITOS', res.data.listado);
			}).catch(function (e) {
				_this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error descargando los buzones de favoritos'
				});
			});
		},
		seleccionaBuzonFavorito: function seleccionaBuzonFavorito(context, buzon) {
			var _this2 = this;

			context.commit('SET_BUZON_FAVORITO_ACTIVO', buzon);
			// Obtenemos sus ficheros
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('organizar-emisoras/php/api/favoritos/get-ficheros.php?ID_buzon=' + buzon.ID_buzon).then(function (res) {
				context.commit('SET_FICHEROS_FAVORITOS', res.data.listado);
			}).catch(function (e) {
				_this2.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error seleccionando el buzón de favoritos'
				});
			});
		},

		// Crea o modifica un buzón de favoritos
		setBuzonFavorito: function setBuzonFavorito(context, data) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('organizar-emisoras/php/api/favoritos/' + data.url, data.buzon).then(function () {
				context.dispatch('getBuzonesFavoritos');
			}).catch(function (e) {
				_this3.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error guardando el buzón'
				});
			});
		},

		// Elimina un buzón de favoritos y todos sus elementos dependientes (sub-buzones y ficheros)
		delBuzonFavorito: function delBuzonFavorito(context, data) {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('organizar-emisoras/php/api/favoritos/del-buzon.php?ID_buzon=' + data.ID_buzon).then(function (res) {
				context.dispatch('getBuzonesFavoritos');
			}).catch(function (e) {
				_this4.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error eliminando el buzón'
				});
			});
		},

		// Añade ficheros a un buzón de favoritos
		addFicherosFavoritos: function addFicherosFavoritos(context, data) {
			var _this5 = this;

			var datos = {
				ID_buzon: context.state.xfavoritos.buzonActivo.ID_buzon,
				objetos: data.map(function (o) {
					return o.ObjetoID;
				})
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('organizar-emisoras/php/api/favoritos/add-objetos.php', datos).then(function (res) {
				context.commit('SET_FICHEROS_FAVORITOS', res.data.listado);
			}).catch(function (e) {
				_this5.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error agregando los favoritos'
				});
			});
		},

		// Elimina ficheros de un buzón de favoritos
		delFicherosFavoritos: function delFicherosFavoritos(context, data) {
			var _this6 = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('organizar-emisoras/php/api/favoritos/del-favoritos.php', data).then(function (res) {
				var favs = context.getters.ficherosFavoritos.filter(function (f) {
					return data.indexOf(f.ID_favorito) < 0;
				});
				context.commit('SET_FICHEROS_FAVORITOS', favs);
			}).catch(function (e) {
				_this6.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		},


		// Bloques
		// Obtiene un listado de bloques en función del las opciones de filtrado
		getBloques: function getBloques(context, data) {
			var _this7 = this;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('organizar-emisoras/php/api/get-listado-bloques.php', context.state.filtro).then(function (res) {
				if (Array.isArray(res.data.listado) && res.data.listado.length > 0) {
					context.commit('SET_LISTADO_BLOQUES', res.data.listado);
					// TODO: Comprobar que el bloque seleccionado existe en este listado y recargar su parrilla
				} else {
					context.commit('SET_LISTADO_BLOQUES', []);
					context.commit('SET_INSERCIONES_PARRILLA', []);
				}
				context.dispatch('buscarInserciones');
			}).catch(function (e) {
				_this7.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Error obteniendo los bloques'
				});
			});
		},
		seleccionaBloque: function seleccionaBloque(context, data) {
			context.commit('SET_BLOQUE_ACTIVO', data);
			// Ahora obtenemos la parrilla
			context.dispatch('getParrilla');
		},
		buscarInserciones: function buscarInserciones(context) {
			var _this8 = this;

			if (!context.state.filtro.buscaInsercion) {
				context.commit('SET_INSERCIONES_ENCONTRADAS', []);
				return;
			}

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('organizar-emisoras/php/api/buscar-inserciones.php', context.state.filtro).then(function (res) {
				context.commit('SET_INSERCIONES_ENCONTRADAS', res.data.listado);
			}).catch(function (e) {
				_this8.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error buscando las inserciones'
				});
			});
		},


		// Parrilla
		getParrilla: function getParrilla(context) {
			var _this9 = this;

			if (!context.getters.bloqueActivo) {
				return;
			}
			var filtro = {
				EmisoraID: context.state.filtro.EmisoraID,
				dia: context.state.filtro.dia,
				BloqueID: context.state.xbloques.bloqueActivo.BloqueID
			};
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('organizar-emisoras/php/api/get-parrilla-bloque.php', filtro).then(function (res) {
				context.commit('SET_INSERCIONES_PARRILLA', res.data.parrilla);
			}).catch(function (e) {
				_this9.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error consultando la parrilla'
				});
			});
		},

		// Programa inserciones en la parrilla activa
		programarInserciones: function programarInserciones(context, data) {
			var _this10 = this;

			/*
   	Necesitamos:
   		- Array de ObjetoID
   		- Posicion (inicial) en la parrilla
   		- BloqueID
   		- fecha (en formato unix time)
   */

			if (!Array.isArray(data.ficheros) || data.ficheros.length === 0) {
				this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'No has definido ningún objeto a programar'
				});
				return;
			}

			if (typeof data.posicion !== 'number' || data.posicion <= 0) {
				this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'La posición debe ser un número entero superior a 0'
				});
				return;
			}

			if (typeof context.state.filtro.dia !== 'number') {
				this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Debes definir una fecha válida'
				});
				return;
			}

			data.dia = context.state.filtro.dia;
			data.BloqueID = context.getters.bloqueActivo.BloqueID;

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('organizar-emisoras/php/api/programar-objetos.php', data).then(function (res) {
				// Actualizamos el estado del bloque y de la parrilla
				if (typeof data.callback === 'function') {
					data.callback();
					context.commit('BORRA_SELECCION_INSERCIONES');
				} else {
					context.commit('SET_INSERCIONES_PARRILLA', res.data.parrilla);
					context.commit('ACTUALIZA_BLOQUE', res.data.bloque);
					context.commit('BORRA_SELECCION_INSERCIONES');
				}
			}).catch(function (e) {
				_this10.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error programando los objetos'
				});
			});
		},

		// Desprograma inserciones en la parrilla activa
		desprogramarInserciones: function desprogramarInserciones(context, data) {
			var _this11 = this;

			if (!Array.isArray(data) || data.length === 0) {
				this.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Tienes que seleccionar las inserciones a eliminar'
				});
				return;
			}

			var datos = {
				ProgramacionesID: data.map(function (p) {
					return p.ProgramacionID;
				}),
				BloqueID: context.getters.bloqueActivo.BloqueID,
				dia: context.state.filtro.dia
			};

			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('organizar-emisoras/php/api/desprogramar-objetos.php', datos).then(function (res) {
				if (typeof data.callback === 'function') {
					data.callback();
					context.commit('BORRA_SELECCION_INSERCIONES');
				} else {
					context.commit('SET_INSERCIONES_PARRILLA', res.data.parrilla);
					context.commit('ACTUALIZA_BLOQUE', res.data.bloque);
					context.commit('BORRA_SELECCION_INSERCIONES');
				}
			}).catch(function (e) {
				_this11.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: 'Error eliminando la programación'
				});
			});
		}
	}
});

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1405);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('produccion', {
			name: 'Producción',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('produccion/:seccion/:TareaID', {
			name: 'Vista de tarea',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('produccion/:seccion', {
			name: 'Sección de producción',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});
	}
});

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(599);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c59cd1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1464);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c59cd1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__ = __webpack_require__(600);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e71a14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__ = __webpack_require__(1463);
function injectStyle (ssrContext) {
  __webpack_require__(1407)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11e71a14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11e71a14_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_produccion_vue__ = __webpack_require__(601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c06f05e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_produccion_vue__ = __webpack_require__(1453);
function injectStyle (ssrContext) {
  __webpack_require__(1409)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c06f05e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_produccion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c06f05e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_produccion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comentarios_vue__ = __webpack_require__(602);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f1c2e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_comentarios_vue__ = __webpack_require__(1411);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comentarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f1c2e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_comentarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-warning text-dark"},[_vm._v("Comentarios (Más recientes primero)")]),(_vm.tarea.fase !== 'finalizada')?_c('div',{staticClass:"bg-light card-body text-right"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.texto),expression:"texto"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"Escribe tu comentario"},domProps:{"value":(_vm.texto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.texto=$event.target.value}}}),_c('button',{staticClass:"btn btn-primary btn-sm mt-1",on:{"click":function($event){return _vm.enviar()}}},[_vm._v("Enviar")])]):_vm._e(),_c('div',{staticStyle:{"max-height":"600px","overflow-y":"auto","margin":"0","padding":"0"}},_vm._l((_vm.tarea.comentarios),function(comentario,index){return _c('div',{key:comentario.ID_comentario,staticClass:"card-body m-0 p-2",class:(index % 2 === 1) ? 'bg-light' : ''},[_c('b',[_vm._v(_vm._s(comentario.usuario.nombre)+" | ")]),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(comentario.fecha))]),_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(comentario.comentario))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_texto_vue__ = __webpack_require__(603);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0472d72a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_texto_vue__ = __webpack_require__(1414);
function injectStyle (ssrContext) {
  __webpack_require__(1413)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0472d72a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_texto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0472d72a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_texto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.version.textos),function(texto,index){return _c('div',{key:index,staticClass:"contieneTexto"},[_c('div',{staticClass:"tipo"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(texto.tipo === 'loca') ? 'btn-info' : 'btn-default',on:{"click":function($event){return _vm.setTipo(texto, 'loca')}}},[_c('i',{staticClass:"fa fa-venus",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(texto.tipo === 'loc') ? 'btn-info' : 'btn-default',on:{"click":function($event){return _vm.setTipo(texto, 'loc')}}},[_c('i',{staticClass:"fa fa-mars",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(texto.tipo === 'locx') ? 'btn-info' : 'btn-default',on:{"click":function($event){return _vm.setTipo(texto, 'locx')}}},[_c('i',{staticClass:"fa fa-transgender",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(texto.tipo === 'tec') ? 'btn-info' : 'btn-default',on:{"click":function($event){return _vm.setTipo(texto, 'tec')}}},[_c('i',{staticClass:"fa fa-pencil-square",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),(texto.tipo !== 'tec')?_c('div',{staticClass:"input-group input-group-sm",staticStyle:{"margin-left":"10px"}},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[(texto.tipo === 'loc')?_c('span',[_vm._v("LOC")]):_vm._e(),_vm._v(" "),(texto.tipo === 'loca')?_c('span',[_vm._v("LOCA")]):_vm._e(),_vm._v(" "),(texto.tipo === 'locx')?_c('span',[_vm._v("LOCX")]):_vm._e()])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.version.textos[index].numero),expression:"version.textos[index].numero",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",staticStyle:{"width":"50px"},attrs:{"type":"text"},domProps:{"value":(_vm.version.textos[index].numero)},on:{"blur":[function($event){return _vm.guardaTexto(index)},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.version.textos[index], "numero", _vm._n($event.target.value))}}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",staticStyle:{"padding-top":"2px","padding-bottom":"2px","font-size":"0.9em"},on:{"click":function($event){_vm.nuevoTexto('loc', parseInt(texto.posicion))}}},[_c('span',{staticClass:"fa fa-plus"})])])])]),_vm._v(" "),_c('div',{staticClass:"texto"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(texto.texto),expression:"texto.texto"}],ref:"texto",refInFor:true,staticClass:"form-control form-control-sm",attrs:{"placeholder":"Escribe aquí el texto","autosize":"true","id":"cajaTexto"},domProps:{"value":(texto.texto)},on:{"focus":function($event){return _vm.enfocado(texto, index)},"keyup":_vm.ajustaCaja,"blur":function($event){return _vm.guardaTexto(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(texto, "texto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"pie"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[(_vm.permisoBorrar(index))?_c('button',{staticClass:"btn btn-sm btn-danger",staticStyle:{"padding-top":"2px","padding-bottom":"2px","font-size":"0.9em"},on:{"click":function($event){return _vm.quitarTexto(texto.ID_texto)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-sm btn-warning",staticStyle:{"padding-top":"2px","padding-bottom":"2px","font-size":"0.9em"},on:{"click":function($event){_vm.nuevoTexto('loc', parseInt(texto.posicion) + 1)}}},[_c('span',{staticClass:"fa fa-plus"})])])])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visualiza_texto_vue__ = __webpack_require__(604);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48dd6523_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visualiza_texto_vue__ = __webpack_require__(1416);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visualiza_texto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48dd6523_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visualiza_texto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.version.textos),function(texto){return _c('div',{key:texto.ID_texto,staticClass:"m-2"},[_c('div',{staticClass:"card"},[_c('div',{class:(texto.tipo === 'tec') ? 'bg-warning' : 'bg-light',staticStyle:{"position":"relative","display":"table","width":"100%"}},[_c('div',{staticClass:"p-1",staticStyle:{"display":"table-cell","width":"70px","text-align":"center"}},[(texto.tipo !== 'tec')?_c('div',[_c('img',{staticClass:"rounded-circle",staticStyle:{"border":"1px solid #e0e0e0","width":"60px","height":"60px"},attrs:{"src":_vm.getAvatar(texto.tipo, texto.numero)}}),_c('br'),_vm._v(_vm._s(texto.tipo)+_vm._s(texto.numero))]):_vm._e(),(texto.tipo === 'tec')?_c('div',[_c('span',{staticClass:"fa fa-info-circle",staticStyle:{"font-size":"4em"}})]):_vm._e()]),_c('div',{staticClass:"p-1",staticStyle:{"display":"table-cell","vertical-align":"top","font-size":"1.3em"},domProps:{"innerHTML":_vm._s(texto.texto.replace(/\n/gm, '<br>'))}}),_c('div',{staticStyle:{"display":"table-cell","text-align":"center","width":"100px","padding-right":"5px","vertical-align":"top","padding-top":"5px"}},[(_vm.tarea.fase === 'pteProduccion')?_c('div',{staticClass:"input-group input-group-sm"},[_c('div',{staticClass:"form-control form-control-sm"},[(texto.grabado)?_c('span',[_vm._v("Grabado")]):_c('span',[_vm._v("Pendiente")])]),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-sm",class:(!texto.grabado) ? 'btn-default' : 'btn-success',on:{"click":function($event){return _vm.setTextoGrabado(texto.ID_texto, !texto.grabado)}}},[_c('div',{staticClass:"fa fa-check"})])])]):_vm._e()])])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_locutor_vue__ = __webpack_require__(607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adcc0a7a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_locutor_vue__ = __webpack_require__(1420);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_locutor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adcc0a7a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editor_locutor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crop_image_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1aa8ed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_crop_image_vue__ = __webpack_require__(1419);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_crop_image_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1aa8ed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_crop_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("\n\t\t\t\t\t  Selecciona imagen\n\t\t\t\t\t  "),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"position":"relative","display":"block"}},[_c('vue-cropper',{on:{"img":function($event){return _vm.setImg($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"card-footer"},[(_vm.url)?_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.confirmar()}}},[_vm._v("Aceptar")]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info"},[_vm._v("\n\t\t\t\t\tEditor de locutores\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"80px","height":"80px"},attrs:{"src":_vm.avatarData}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-info mt-1",on:{"click":function($event){_vm.setAvatar = true}}},[_vm._v("Cambiar")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.locutor.nombre),expression:"locutor.nombre"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Nombre"},domProps:{"value":(_vm.locutor.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.locutor, "nombre", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Apellidos")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.locutor.apellidos),expression:"locutor.apellidos"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Apellidos"},domProps:{"value":(_vm.locutor.apellidos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.locutor, "apellidos", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Estilos")]),_vm._v(" "),_c('input',{staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Escribe un estilo y pulsa intro"},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.setEstilo($event)}}})]),_vm._v(" "),_vm._l((_vm.locutor.estilos),function(estilo){return _c('div',{key:estilo,staticClass:"badge badge-info p-1 m-1",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.quitaEstilo(estilo)}}},[_vm._v(_vm._s(estilo))])})],2),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Sexo")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.locutor.sexo === 'hombre') ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setSexo('hombre')}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tHombre\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.locutor.sexo === 'mujer') ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setSexo('mujer')}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tMujer\n\t\t\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Estado")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.locutor.activo === true) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.locutor.activo = true}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tActivo\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(_vm.locutor.activo === false) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.locutor.activo = false}}},[_vm._v("\n\t\t\t\t\t\t\t\t\tInactivo\n\t\t\t\t\t\t\t\t")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Procedencia")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.locutor.procedencia_ID),expression:"locutor.procedencia_ID"}],staticClass:"form-control form-control-sm",attrs:{"name":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.locutor, "procedencia_ID", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.setProcedencia($event)}]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona procedencia")]),_vm._v(" "),_vm._l((_vm.listadoProcedencias),function(p){return _c('option',{key:p.ID_procedencia,domProps:{"value":p.ID_procedencia}},[_vm._v(_vm._s(p.nombre))])}),_vm._v(" "),_c('option',{domProps:{"value":'nuevo'}},[_vm._v("Crear nueva")])],2)]),_vm._v(" "),(_vm.nuevaProcedencia)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Nueva procedencia")]),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nuevaProcedenciaValue),expression:"nuevaProcedenciaValue"}],staticClass:"form-control form-control-sm",attrs:{"type":"text"},domProps:{"value":(_vm.nuevaProcedenciaValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nuevaProcedenciaValue=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.guardaProcedencia()}}},[_vm._v("Crear")])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("E-mail")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.locutor.email),expression:"locutor.email"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"locutor@empresa.com"},domProps:{"value":(_vm.locutor.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.locutor, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Teléfono")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.locutor.telefono),expression:"locutor.telefono"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"6XX XXX XXX"},domProps:{"value":(_vm.locutor.telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.locutor, "telefono", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_vm._v("\n\t\t\t\t\t\tGuardar\n\t\t\t\t\t")])])]),_vm._v(" "),(_vm.setAvatar)?_c('set-avatar',{on:{"cerrar":function($event){_vm.setAvatar = false},"img":function($event){return _vm.setNuevoAvatar($event)}}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('b',[_vm._v(_vm._s(_vm.etiqueta.toUpperCase())+":")]),_vm._v("\tSelecciona un locutor\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('div',{staticClass:"input-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro),expression:"filtro"}],staticClass:"form-control form-control-sm",attrs:{"autofocus":"","type":"text","placeholder":"Escribe el nombre del locutor"},domProps:{"value":(_vm.filtro)},on:{"keyup":function($event){return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.filtro=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-info",on:{"click":function($event){return _vm.nuevo()}}},[_c('span',{staticClass:"fa fa-plus"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\tNuevo\n\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('table',{staticClass:"table table-hover table-condensed text-left"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.listado),function(loc){return _c('tr',{key:loc.ID_locutor},[_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"60px","height":"60px"},attrs:{"src":loc.avatar,"alt":"Avatar"}})]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(loc.nombre)+" "+_vm._s(loc.apellidos))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(loc.sexo))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(loc.procedenciaNombre))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('button',{staticClass:"btn btn-sm btn-success",on:{"click":function($event){return _vm.selecciona(loc)}}},[_c('span',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.editar(loc)}}},[_c('span',{staticClass:"fa fa-edit"})])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h5',[(_vm.etiqueta.match(/^loc[0-9]/))?_c('span',[_vm._v("Locutores")]):_vm._e(),_vm._v(" "),(_vm.etiqueta.match(/^loca[0-9]/))?_c('span',[_vm._v("Locutoras")]):_vm._e(),_vm._v(" "),(_vm.etiqueta.match(/^locx[0-9]/))?_c('span',[_vm._v("Locutores/as")]):_vm._e(),_vm._v("\n\t\t\t\t\t\t\t\thabituales de este cliente\n\t\t\t\t\t\t\t")]),_vm._v(" "),(_vm.habituales.length === 0)?_c('div',{staticClass:"text-center mt-3 text-danger"},[_c('b',[_vm._v("No hay histórico de este anunciante")])]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-hover table-condensed"},[_c('tbody',_vm._l((_vm.habituales),function(locutor){return _c('tr',{key:locutor.ID_locutor},[_c('td',{staticStyle:{"vertical-align":"middle","width":"45px"}},[_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"40px"},attrs:{"src":locutor.avatar}})]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle","text-align":"left"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(locutor.nombre)+" "+_vm._s(locutor.apellidos)+"\n\t\t\t\t\t\t\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('i',[_vm._v(_vm._s(locutor.total)+" cuñas grabadas")])]),_vm._v(" "),_c('td',{staticStyle:{"width":"30px","text-align":"right"}},[_c('button',{staticClass:"btn btn-success btn-sm",on:{"click":function($event){return _vm.selecciona(locutor)}}},[_c('span',{staticClass:"fa fa-check"})])])])}),0)])])])])]),_vm._v(" "),(_vm.editando)?_c('editor-locutor',{attrs:{"locutor":_vm.editando},on:{"cerrar":function($event){_vm.editando = null}}}):_vm._e()],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\tBuscar\n\t\t\t\t\t\t\t\t\t")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Avatar")]),_vm._v(" "),_c('th',[_vm._v("Nombre")]),_vm._v(" "),_c('th',[_vm._v("Sexo")]),_vm._v(" "),_c('th',[_vm._v("Procedencia")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rechazo_tarea_vue__ = __webpack_require__(609);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6786a4b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rechazo_tarea_vue__ = __webpack_require__(1423);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rechazo_tarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6786a4b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rechazo_tarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\tRechazar versión\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('h4',[_vm._v("Rechazar esta versión")]),_vm._v(" "),_c('div',[_vm._v("\n\t\t\t\t\t\tEstás a punto de rechazar esta versión en este momento de su producción.\n\t\t\t\t\t\tPor favor rellena el formulario y sé lo más explícito posible para que se entienda\n\t\t\t\t\t\tbien el motivo del rechazo y evitemos que se repita en la nueva versión\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Motivos")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.descripcion),expression:"form.descripcion"}],staticClass:"form-control form-control-sm",attrs:{"name":"","rows":"10","placeholder":"Explica aquí los motivos"},domProps:{"value":(_vm.form.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "descripcion", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_vm._v("\n\t\t\t\t\t\t\t\t\tMotivos del anunciante\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},_vm._l((_vm.motivos.cliente),function(motivo){return _c('div',{key:motivo.ID_motivo,staticClass:"mt-1 input-group input-group-sm"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.esMotivo(motivo.ID_motivo)) ? 'btn-danger': 'btn-default',on:{"click":function($event){return _vm.toggleMotivo(motivo.ID_motivo)}}},[_c('span',{staticClass:"fa fa-check"})])]),_vm._v(" "),_c('div',{staticClass:"form-control form-control-sm"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(motivo.titulo)+"\n\t\t\t\t\t\t\t\t\t\t")])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-warning text-dark"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.motivosDeQuien)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},[_vm._l((_vm.motivos.agente),function(motivo){return (_vm.tarea.fase.match(/(pteAprobarIdea|pteAprobarProduccion)/))?_c('div',{key:motivo.ID_motivo,staticClass:"mt-1 input-group input-group-sm"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.esMotivo(motivo.ID_motivo)) ? 'btn-danger': 'btn-default',on:{"click":function($event){return _vm.toggleMotivo(motivo.ID_motivo)}}},[_c('span',{staticClass:"fa fa-check"})])]),_vm._v(" "),_c('div',{staticClass:"form-control form-control-sm"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(motivo.titulo)+"\n\t\t\t\t\t\t\t\t\t\t")])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.motivos.marketing),function(motivo){return (_vm.tarea.fase.match(/(pteIdea)/))?_c('div',{key:motivo.ID_motivo,staticClass:"mt-1 input-group input-group-sm"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.esMotivo(motivo.ID_motivo)) ? 'btn-danger': 'btn-default',on:{"click":function($event){return _vm.toggleMotivo(motivo.ID_motivo)}}},[_c('span',{staticClass:"fa fa-check"})])]),_vm._v(" "),_c('div',{staticClass:"form-control form-control-sm"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(motivo.titulo)+"\n\t\t\t\t\t\t\t\t\t\t")])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.motivos.tecnico),function(motivo){return (_vm.tarea.fase ==='pteProduccion')?_c('div',{key:motivo.ID_motivo,staticClass:"mt-1 input-group input-group-sm"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.esMotivo(motivo.ID_motivo)) ? 'btn-danger': 'btn-default',on:{"click":function($event){return _vm.toggleMotivo(motivo.ID_motivo)}}},[_c('span',{staticClass:"fa fa-check"})])]),_vm._v(" "),_c('div',{staticClass:"form-control form-control-sm"},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(motivo.titulo)+"\n\t\t\t\t\t\t\t\t\t\t")])]):_vm._e()})],2)])])]),_vm._v(" "),(_vm.tarea.fase === 'pteAprobarProduccion')?_c('div',{staticClass:"form-group mt-2"},[_c('label',{staticClass:"font-weight-bold"},[_vm._v("¿Es necesario cambiar el texto?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.form.cambiaTexto) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.form.cambiaTexto = true}}},[_vm._v("\n\t\t\t\t\t\t\t\tSí\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm",class:(!_vm.form.cambiaTexto) ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.form.cambiaTexto = false}}},[_vm._v("\n\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.doRechazar()}}},[_vm._v("Rechazar")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editando_tarea_vue__ = __webpack_require__(610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eab9c3d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editando_tarea_vue__ = __webpack_require__(1427);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editando_tarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eab9c3d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editando_tarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between",staticStyle:{"border-bottom":"1px solid #e0e0e0","margin-bottom":"10px","padding-bottom":"10px"}},[_c('div',{staticStyle:{"font-size":"1.5em","font-weight":"bold"}},[_vm._v("Tarea "+_vm._s(_vm.index + 1)),_c('div',{staticClass:"bagde badge-success salvado",class:(_vm.salvado) ? 'activo': ''},[_vm._v("Cambios guardados")])]),_c('div',{staticClass:"btn-group mr-2"},[((_vm.tarea.fase !== 'finalizada' && _vm.tarea.esAgente) ||_vm.permisos.produccion_eliminarFinalizadas)?_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){return _vm.quitarTarea(_vm.index)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-3 text-left"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Tipo")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tarea.tipo),expression:"tarea.tipo"}],staticClass:"form-control form-control-sm",attrs:{"name":"","disabled":_vm.tarea.fase !== 'pteIdea'},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tarea, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.guardarTarea()}]}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona")]),_c('option',{attrs:{"value":"cuna"}},[_vm._v("Cuña")])])]),(_vm.tarea.tipo === 'cuna')?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Duración")]),_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##'),expression:"'##'"},{name:"model",rawName:"v-model",value:(_vm.tarea.duracion),expression:"tarea.duracion"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.tarea.fase !== 'pteIdea'},domProps:{"value":(_vm.tarea.duracion)},on:{"blur":function($event){return _vm.guardarTarea()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarea, "duracion", $event.target.value)}}}),_vm._m(0)])]):_vm._e(),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Voces externas")]),_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.tarea.vocesExternas),expression:"tarea.vocesExternas",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"placeholder":"0"},domProps:{"value":(_vm.tarea.vocesExternas)},on:{"blur":[function($event){return _vm.guardarTarea()},function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarea, "vocesExternas", _vm._n($event.target.value))}}}),_vm._m(1)])]),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Título")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tarea.titulo),expression:"tarea.titulo"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":_vm.tarea.fase === 'finalizada'},domProps:{"value":(_vm.tarea.titulo)},on:{"blur":function($event){return _vm.guardarTarea()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarea, "titulo", $event.target.value)}}})]),(_vm.tarea.tipo === 'cuna')?_c('div',[_c('div',{staticClass:"input-group input-group-sm mb-2"},[_vm._m(2),(_vm.tarea.fase !== 'finalizada')?_c('input-query',{attrs:{"url":"produccion/php/api/buscaSoportes.php","realtime":true,"input-class":"form-control","placeholder":"Añade los soportes"},on:{"selected":function($event){return _vm.setSoporte($event)}}}):_vm._e(),(_vm.tarea.fase === 'finalizada')?_c('div',{staticClass:"form-control form-control-sm bg-light"},[_vm._v("Soportes")]):_vm._e()],1),_vm._l((_vm.tarea.soportes),function(soporte){return _c('button',{key:soporte.ID_soporte,staticClass:"btn btn-info btn-sm mr-1 mb-1",staticStyle:{"font-size":"0.8em"},on:{"click":function($event){return _vm.quitaSoporte(soporte)}}},[_c('span',{staticClass:"fa fa-trash mr-2 border-right-1"}),_vm._v("\t"+_vm._s(soporte.nombre))])})],2):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha inicio")]),_c('datepicker',{attrs:{"language":_vm.$dateLang,"bootstrap-styling":true,"monday-first":true,"format":"dd-MM-yyyy","disabled-dates":_vm.disabledInicio,"input-class":"form-control form-control-sm"},on:{"closed":_vm.guardarTarea},model:{value:(_vm.tarea.fecha_inicio),callback:function ($$v) {_vm.$set(_vm.tarea, "fecha_inicio", $$v)},expression:"tarea.fecha_inicio"}})],1)]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha fin")]),_c('datepicker',{attrs:{"language":_vm.$dateLang,"bootstrap-styling":true,"monday-first":true,"format":"dd-MM-yyyy","disabled-dates":_vm.disabledFin,"input-class":"form-control form-control-sm"},on:{"closed":_vm.guardarTarea},model:{value:(_vm.tarea.fecha_fin),callback:function ($$v) {_vm.$set(_vm.tarea, "fecha_fin", $$v)},expression:"tarea.fecha_fin"}})],1)])]),(_vm.tarea.tipo === 'cuna')?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Descripción")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.tarea.descripcion),expression:"tarea.descripcion"}],staticClass:"form-control form-control-sm",attrs:{"disabled":_vm.tarea.fase !== 'pteIdea',"name":"","readonly":!_vm.esFaseInicial,"rows":"7"},domProps:{"value":(_vm.tarea.descripcion)},on:{"blur":function($event){return _vm.guardarTarea()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarea, "descripcion", $event.target.value)}}})]):_vm._e(),(!_vm.tarea.express_fecha)?_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning"},[_c('b',[_vm._v("Tarea express")]),_c('button',{staticClass:"pull-right btn btn-sm",class:(_vm.tarea.express) ? 'btn-primary' : '',on:{"click":_vm.toggleExpress}},[_c('span',{staticClass:"fa fa-check"})])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tarea.express),expression:"tarea.express"}],staticClass:"card-body bg-light"},[_c('p',[_vm._v("Si esta tarea necesitas que se realice en menos de 48 horas, explica los motivos. Ten en cuenta que el tiempo reglamentario es de 48 horas, por lo que si solicitas una tarea express esto generará una incidencia.")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.tarea.express_motivos),expression:"tarea.express_motivos"}],staticClass:"mt-2 form-control",attrs:{"rows":"3","placeholder":"Indica los motivos por los que necesitas acelerar el proceso de producción de esta tarea"},domProps:{"value":(_vm.tarea.express_motivos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tarea, "express_motivos", $event.target.value)}}})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tarea.express),expression:"tarea.express"}],staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.solicitarExpress}},[_c('span',{staticClass:"fa fa-star mr-2"}),_vm._v("Solicitar express")])])]):_vm._e(),(_vm.tarea.express_fecha)?_c('div',{staticClass:"alert alert-warning text-left"},[_vm._m(3),_c('p',[_vm._v("El agente ha solicitado que esta tarea se produzca de manera express. Los motivos son:"),_c('br'),_c('span',{staticStyle:{"opacity":"0.8","font-style":"italic"}},[_vm._v("\""+_vm._s(_vm.tarea.express_motivos)+"\"")])])]):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"},[_c('table',{staticClass:"table table-striped table-sm"},[_c('thead',[_c('tr',{staticClass:"bg-danger text-white"},[_c('th',{staticStyle:{"vertical-align":"middle"}},[_vm._v("Ficheros")]),_c('th',{staticClass:"text-right"},[(_vm.tarea.fase !== 'finalizada')?_c('button',{staticClass:"btn btn-sm btn-dark",on:{"click":function($event){return _vm.nuevoFichero(_vm.tarea)}}},[_c('span',{staticClass:"fa fa-plus",staticStyle:{"cursor":"pointer"}})]):_vm._e()])])]),_c('tbody',_vm._l((_vm.tarea.ficheros),function(fichero){return _c('tr',{key:fichero.ID_fichero},[_c('td',[_vm._v(_vm._s(fichero.nombre))]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaFichero(fichero.ID_fichero)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("seg.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("voces")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-info"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('span',{staticClass:"fa fa-star mr-2"}),_vm._v("Tarea express")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\tEditando tarea\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('editor-tarea',{attrs:{"tarea":_vm.tarea,"index":"0"},on:{"actualizar":function($event){return _vm.emiteActualizar($event)}}})],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editando_produccion_vue__ = __webpack_require__(613);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dfc2950_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editando_produccion_vue__ = __webpack_require__(1434);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editando_produccion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dfc2950_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editando_produccion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orden_vue__ = __webpack_require__(616);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b27f090_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_orden_vue__ = __webpack_require__(1432);
function injectStyle (ssrContext) {
  __webpack_require__(1430)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b27f090"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orden_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b27f090_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_orden_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white",on:{"click":_vm.cerrar}},[_vm._v("Asignar contrato"),_vm._m(0)]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("Buscar")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cadena),expression:"cadena"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Título/Cliente/Agente"},domProps:{"value":(_vm.cadena)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.cadena=$event.target.value}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search"})])])])]),_c('div',{staticClass:"table-responsive text-left"},[_c('table',{staticClass:"table table-striped table-sm"},[_vm._m(1),_c('tbody',[_vm._l((_vm.listadoContratos),function(contrato){return _c('tr',{key:contrato.ID_contrato},[_c('td',[_vm._v(_vm._s(contrato.fecha))]),_c('td',[_vm._v(_vm._s(contrato.nombreAgente))]),_c('td',[_vm._v(_vm._s(contrato.nombreCliente))]),_c('td',[_vm._v(_vm._s(contrato.titulo))]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(contrato.importe,'€')))]),_c('td',[_c('button',{staticClass:"btn btn-secondary btn-sm",on:{"click":function($event){return _vm.asignalo(contrato)}}},[_c('span',{staticClass:"fa fa-check"})])])])}),(this.listadoContratos.length === 0)?_c('tr',[_vm._m(2)]):_vm._e()],2)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close"},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Título")]),_c('th',[_vm._v("Importe")]),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",staticStyle:{"padding-top":"30px"},attrs:{"colspan":"6"}},[_c('b',{staticClass:"text-danger"},[_vm._v("No hay contratos")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-dark text-white"},[(!_vm.editando)?_c('div',{staticClass:"pull-left"},[_c('button',{staticClass:"btn btn-sm btn-warning mr-3",on:{"click":function($event){return _vm.nuevaOrden()}}},[_c('span',{staticClass:"fa fa-edit mr-1"}),_vm._v("Nueva")])]):_vm._e(),_vm._v("Información básica"),_c('div',{staticClass:"badge badge-success salvado",class:(_vm.salvado) ? 'activo': ''},[_vm._v("Cambios guardados")])]),(!_vm.produccion.anunciante.ID_anunciante)?_c('div',{staticClass:"card-body text-left"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Anunciante")]),_c('input-query',{attrs:{"realtime":true,"input-class":'form-control form-control-sm',"placeholder":"Busca el anunciante","url":'produccion/php/api/buscaAnunciante.php'},on:{"selected":function($event){return _vm.seleccionaAnunciante($event)}}})],1)]):_vm._e(),(_vm.produccion.anunciante.ID_anunciante)?_c('div',{staticClass:"card-body bg-light"},[_c('b',[_vm._v("Anunciante")]),_c('br'),_c('span',{staticClass:"text-info",staticStyle:{"font-size":"1.3em","font-weight":"bold"}},[_vm._v(_vm._s(_vm.produccion.anunciante.nombre))]),_c('br'),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.quitaAnunciante}},[_c('span',{staticClass:"fa fa-refresh mr-1"}),_vm._v("Cambiar")])]):_vm._e(),(_vm.produccion.ID_produccion && !_vm.produccion.contrato.ID_contrato && _vm.hayAnunciante)?_c('div',{staticClass:"card-body bg-danger text-white text-left"},[_c('div',{staticClass:"row justify-content-between"},[_vm._m(0),_c('div',{staticClass:"mr-3"},[_c('button',{staticClass:"btn btn-dark btn-sm",on:{"click":function($event){_vm.verAsociar = true}}},[_c('span',{staticClass:"fa fa-edit mr-1"}),_vm._v("Asociar")])])]),_c('p',{staticClass:"mt-3"},[_vm._v("Cada órden de producción debe estar asociada a un contrato previamente creado.\nNo es necesario que lo asocies en este momento, pero ten en cuenta que no podrás\naprobar la producción hasta que hayas hecho este paso.")])]):_vm._e(),(_vm.produccion.ID_produccion && _vm.produccion.contrato.ID_contrato && _vm.hayAnunciante)?_c('div',{staticClass:"card-body bg-white text-center"},[_c('b',[_vm._v("Contrato asociado")]),_c('br'),_c('span',{staticClass:"text-info",staticStyle:{"font-size":"1.3em","font-weight":"bold"}},[_vm._v(_vm._s(_vm.produccion.contrato.titulo))]),_c('br'),_vm._v(_vm._s(_vm.produccion.contrato.nombreCliente)),_c('br'),(_vm.permisoEditaContrato)?_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.cambiaContrato}},[_c('span',{staticClass:"fa fa-refresh"}),_vm._v("Cambiar")]):_vm._e()]):_vm._e()]),(_vm.hayAnunciante)?_c('div',{staticClass:"card mt-3 mb-3"},[_c('div',{staticClass:"card-header bg-warning"},[_vm._v("Información de la campaña")]),_c('div',{staticClass:"card-body text-left"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Título de la campaña")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.produccion.titulo),expression:"produccion.titulo"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Título"},domProps:{"value":(_vm.produccion.titulo)},on:{"blur":function($event){return _vm.guardar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produccion, "titulo", $event.target.value)}}})]),_c('hr'),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Descripción")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.produccion.descripcion),expression:"produccion.descripcion"}],staticClass:"form-control form-control-sm",attrs:{"name":"","rows":"5","placeholder":"Escribe una pequeña descripción que ayude en el proceso de producción"},domProps:{"value":(_vm.produccion.descripcion)},on:{"blur":function($event){return _vm.guardar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produccion, "descripcion", $event.target.value)}}})])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[(_vm.permisos['produccion_crearPublicas'])?_c('div',{staticClass:"text-left mt-2 mb-2"},[_c('b',[_vm._v("Ámbito de la producción")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(!_vm.produccion.publica) ? 'btn-danger' : 'btn-default',on:{"click":function($event){return _vm.setPublica(0)}}},[_c('span',{staticClass:"fa fa-lock mr-1"}),_vm._v("Privada")]),_c('button',{staticClass:"btn",class:(_vm.produccion.publica) ? 'btn-success' : 'btn-default',on:{"click":function($event){return _vm.setPublica(1)}}},[_c('span',{staticClass:"fa fa-unlock mr-1"}),_vm._v("Pública")])])]):_vm._e()]),_c('div',{staticClass:"col"},[(_vm.permisos['produccion_crearExternas'])?_c('div',{staticClass:"text-left mt-2"},[_c('b',[_vm._v("Tipo de producción")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(!_vm.produccion.externa) ? 'btn-danger' : 'btn-default',on:{"click":function($event){return _vm.setExterna(0)}}},[_c('span',{staticClass:"fa fa-flag mr-1"}),_vm._v("Propia")]),_c('button',{staticClass:"btn",class:(_vm.produccion.externa) ? 'btn-success' : 'btn-default',on:{"click":function($event){return _vm.setExterna(1)}}},[_c('span',{staticClass:"fa fa-gift mr-1"}),_vm._v("Producción externa")])])]):_vm._e()])])]),(_vm.produccion.ID_produccion)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-sm"},[_c('thead',{staticClass:"bg-danger text-white"},[_c('tr',[_c('th',{staticClass:"align-middle"},[_vm._v("Ficheros compartidos entre tareas")]),_c('th',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-dark",on:{"click":_vm.nuevoFichero}},[_c('span',{staticClass:"fa fa-plus"})])])])]),_c('tbody',{staticClass:"text-left"},_vm._l((_vm.produccion.ficheros),function(fichero){return _c('tr',{key:fichero.ID_fichero},[_c('td',[_vm._v(_vm._s(fichero.nombre))]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaFichero(fichero.ID_fichero)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])]):_vm._e()]):_vm._e(),(_vm.verAsociar)?_c('asocia-contrato',{on:{"asignar":function($event){return _vm.asociaContrato($event)},"cerrar":function($event){_vm.verAsociar = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-3 align-middle"},[_c('b',[_vm._v("Ningún contrato asociado")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.produccion)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('editor-orden',{attrs:{"produccion":_vm.produccion,"editando":_vm.idOrden},on:{"update:produccion":function($event){_vm.produccion=$event},"actualizar":function($event){return _vm.emiteActualizar()},"nueva":function($event){return _vm.nuevaProduccion()}}})],1),(_vm.produccion.ID_produccion)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Tareas")]),_vm._l((_vm.produccion.tareas),function(tarea,index){return _c('div',{key:tarea.ID_tarea,staticClass:"card-body text-left",class:(index % 2 == 0) ? 'bg-light' : ''},[_c('tarea',{attrs:{"tarea":_vm.produccion.tareas[index],"index":index},on:{"update:tarea":function($event){return _vm.$set(_vm.produccion.tareas, index, $event)},"quitar":function($event){return _vm.quitarTarea(index)},"actualizar":function($event){return _vm.emiteActualizar()}}})],1)}),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_c('button',{staticClass:"btn btn-sm btn-dark",on:{"click":function($event){return _vm.finalizar()}}},[_c('span',{staticClass:"fa fa-close"}),_vm._v("Finalizar edición")])]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.nuevaTarea()}}},[_c('span',{staticClass:"fa fa-plus"}),_vm._v("Nueva tarea")])])])])],2)]):_vm._e(),(!_vm.produccion.ID_produccion)?_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8"},[_vm._m(0)]):_vm._e()]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning"},[_c('b',[_vm._v("Información")]),_c('p',{staticClass:"text-left"},[_vm._v("Para crear una nueva producción primero tienes que completar los campos básicos:"),_c('ul',[_c('li',[_vm._v("Asigna un anunciante")]),_c('li',[_vm._v("Asocia la producción a un contrato (opcional)")]),_c('li',[_vm._v("Completa los datos básicos; titulo, fecha de inicio, fin y descripción")]),_c('li',[_vm._v("Añade ficheros que puedan ayudar en el proceso de producción")])]),_vm._v("Una vez completes estos pasos, podrás agregar las tareas que correspondan.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',{staticStyle:{"max-width":"99%"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\tEditando producción\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('nueva-produccion',{attrs:{"id-orden":_vm.idproduccion},on:{"actualizar":function($event){return _vm.emiteActualizar()}}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reproductor_vue__ = __webpack_require__(619);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e5eda0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reproductor_vue__ = __webpack_require__(1442);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reproductor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84e5eda0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reproductor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_descargar_vue__ = __webpack_require__(622);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4ef12c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_descargar_vue__ = __webpack_require__(1437);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_descargar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4ef12c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_descargar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\tDescargar auditoría de radiación\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body text-left"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col text-center"},[_c('b',[_vm._v("Programación")]),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin":"10px","border":"1px solid #e0e0e0","border-radius":"3px","cursor":"pointer","width":"120px","height":"120px"},style:((_vm.form.verProgramacion) ? {opacity: 1} : {opacity:0.2}),attrs:{"src":__webpack_require__(623),"alt":""},on:{"click":function($event){_vm.form.verProgramacion = !_vm.form.verProgramacion}}})]),_vm._v(" "),_c('div',{staticClass:"col text-center"},[_c('b',[_vm._v("Emisión")]),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin":"10px","border":"1px solid #e0e0e0","border-radius":"3px","cursor":"pointer","width":"120px","height":"120px"},style:((_vm.form.verEmision) ? {opacity: 1} : {opacity:0.2}),attrs:{"src":__webpack_require__(623),"alt":""},on:{"click":function($event){_vm.form.verEmision = !_vm.form.verEmision}}})])])]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light text-left"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row mt-3",staticStyle:{"display":"none"}},[_c('div',{staticClass:"col text-center"},[_c('b',[_vm._v("Globales")]),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin":"10px","border":"1px solid #e0e0e0","border-radius":"3px","cursor":"pointer","width":"120px","height":"120px"},style:((_vm.form.verStatsProgreso) ? {opacity: 1} : {opacity:0.2}),attrs:{"src":__webpack_require__(1438),"alt":""},on:{"click":function($event){_vm.form.verStatsProgreso = !_vm.form.verStatsProgreso}}})]),_vm._v(" "),_c('div',{staticClass:"col text-center"},[_c('b',[_vm._v("Por horas")]),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin":"10px","border":"1px solid #e0e0e0","border-radius":"3px","cursor":"pointer","width":"120px","height":"120px"},style:((_vm.form.verStatsHoras) ? {opacity: 1} : {opacity:0.2}),attrs:{"src":__webpack_require__(1439),"alt":""},on:{"click":function($event){_vm.form.verStatsHoras = !_vm.form.verStatsHoras}}})]),_vm._v(" "),_c('div',{staticClass:"col text-center"},[_c('b',[_vm._v("Presencia en antena")]),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"margin":"10px","border":"1px solid #e0e0e0","border-radius":"3px","cursor":"pointer","width":"120px","height":"120px"},style:((_vm.form.verStatsPresencia) ? {opacity: 1} : {opacity:0.2}),attrs:{"src":__webpack_require__(1440),"alt":""},on:{"click":function($event){_vm.form.verStatsPresencia = !_vm.form.verStatsPresencia}}})])]),_vm._v(" "),(!_vm.generando && _vm.haySeleccion)?_c('button',{staticClass:"btn btn-block btn-primary mt-2",on:{"click":function($event){return _vm.generar()}}},[_c('span',{staticClass:"fa fa-gear"}),_vm._v("\n\t\t\t\t\t\tGenerar informe\n\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.generando)?_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})]):_vm._e(),_vm._v(" "),(_vm.link)?_c('div',[_c('hr'),_vm._v(" "),_c('h5',[_vm._v("Informe listo")]),_vm._v(" "),_c('form',{attrs:{"action":"/src/modulos/produccion/php/api/get-programacion-pdf.php","method":"POST"}},[_c('input',{attrs:{"type":"hidden","name":"d"},domProps:{"value":_vm.link}}),_vm._v(" "),_vm._m(3)])]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body bg-info text-white"},[_c('h4',[_vm._v("Selecciona las opciones que deseas incluír en el informe")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('span',{staticClass:"fa fa-list"}),_vm._v("\n\t\t\t\t\t\tListados\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticStyle:{"display":"none"}},[_c('span',{staticClass:"fa fa-bar-chart"}),_vm._v("\n\t\t\t\t\t\tEstadísticas\n\t\t\t\t\t")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-block btn-success",attrs:{"typ":"submit"}},[_c('span',{staticClass:"fa fa-download"}),_vm._v("\n\t\t\t\t\t\t\t\tDescargar\n\t\t\t\t\t\t\t")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div"},[_c('div',{staticClass:"div",staticStyle:{"position":"relative","display":"block","text-align":"center","padding":"5px"}},[_c('button',{staticClass:"btn btn-sm",class:(_vm.verTipo === 'programados') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.verTipo = 'programados'}}},[_c('Ver',[_vm._v("programación")])],1),_c('div',{staticClass:"button btn btn-sm",class:(_vm.verTipo === 'emitidos') ? 'btn-primary' : 'btn-default',on:{"click":function($event){_vm.verTipo = 'emitidos'}}},[_c('Ver',[_vm._v("emisión")])],1),_c('div',{staticClass:"button btn btn-sm btn-success",on:{"click":function($event){return _vm.descargar()}}},[_c('span',{staticClass:"fa fa-download"}),_c('Descargar')],1)]),(_vm.verTipo === 'programados' && _vm.auditando)?_c('table',{staticClass:"table table-condensed striped text-left"},[_vm._m(0),_vm._l((_vm.detalles),function(data,emisora){return _c('tbody',{key:emisora},[_c('tr',{staticClass:"bg-light",staticStyle:{"font-weight":"bolder"}},[_c('td',[_c('span',{staticClass:"fa fa-info mr-2"}),_vm._v(_vm._s(emisora)),_c('div',{staticClass:"badge badge-info p-2 text-uppercase pull-right",staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(data.items.length)+" programados")])]),_c('td',[_vm._v("colspan=\"2\""),_c('div',{staticClass:"badge badge-warning p-2 text-uppercase",staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(data.emitidos)+" emitidos")])])]),_vm._l((data.items),function(item){return _c('tr',{key:item.ID_programacion,class:(!item.emitido && item.fecha < new Date().getTime()) ? 'bg-danger text-white' : ''},[_c('td',[_vm._v(_vm._s(new Date(item.fecha).toLocaleString()))]),_c('td',[(item.emitido)?_c('span',{staticClass:"fa fa-check"}):_vm._e(),(!item.emitido && item.fecha < new Date().getTime())?_c('span',{staticClass:"fa fa-ban"}):_vm._e(),(!item.emitido && item.fecha >= new Date().getTime())?_c('span',{staticClass:"fa fa-clock-o"}):_vm._e()]),_c('td',[(item.emitido)?_c('span',[_vm._v(_vm._s(new Date(item.emitido.fecha).toLocaleString()))]):_vm._e()])])})],2)}),(Object.keys(_vm.detalles).length === 0 && _vm.auditando)?_c('tbody',[_vm._m(1)]):_vm._e()],2):_vm._e(),(_vm.verTipo === 'emitidos' && _vm.auditando)?_c('table',{staticClass:"table table-condensed striped text-left"},[_vm._m(2),_vm._l((_vm.detallesEmitidos),function(items,emisora){return _c('tbody',{key:emisora},[_c('tr',{staticClass:"bg-light",staticStyle:{"font-weight":"bolder"}},[_c('td',[_c('span',{staticClass:"fa fa-info mr-2"}),_vm._v(_vm._s(emisora)),_c('div',{staticClass:"badge badge-success p-2 text-uppercase pull-right",staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(items.length)+" emitidos")])])]),_vm._l((items),function(item){return _c('tr',{key:item.ID_programacion},[_c('td',[_c('span',[_vm._v(_vm._s(new Date(item.fecha).toLocaleString()))])])])}),(Object.keys(_vm.detallesEmitidos).length === 0 && _vm.auditando)?_c('tr',[_vm._m(3,true)]):_vm._e()],2)})],2):_vm._e(),(_vm.descargando)?_c('modal-descargar',{attrs:{"idfichero":_vm.idfichero,"idversion":_vm.idversion},on:{"cerrar":function($event){_vm.descargando = false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Programada")]),_c('th',[_vm._v("Emitida")]),_c('th',[_vm._v("Día de emisión")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"3"}},[_c('div',{staticClass:"alert alert-danger"},[_c('h3',[_vm._v("No hay información de programación de este fichero")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("Día de emisión")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('div',{staticClass:"alert alert-danger"},[_c('h3',[_vm._v("No hay información de radiación de este fichero")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\tVisualizador de ficheros\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"card-body pt-0 pb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col bg-light p-3 text-left"},[_c('div',{staticStyle:{"display":"table","width":"100%"}},[_c('div',{staticStyle:{"display":"table-row"}},[_c('div',{staticStyle:{"display":"table-cell","width":"65px","vertical-align":"top"}},[(_vm.fichero.fichero.usuario)?_c('img',{staticClass:"rounded-circle mr-2",staticStyle:{"border":"1px solid #e0e0e0","width":"60px"},attrs:{"src":_vm.fichero.fichero.usuario.avatar,"alt":"avatar"}}):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"display":"table-cell","vertical-align":"top"}},[_c('div',{staticStyle:{"position":"relative","display":"inline-block","vertical-align":"top"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tSubido por: "),(_vm.fichero.fichero.usuario)?_c('b',[_vm._v(_vm._s(_vm.fichero.fichero.usuario.nombre))]):_vm._e(),_vm._v(" "),(!_vm.fichero.fichero.usuario)?_c('b',[_vm._v("Desconocido")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tTamaño: "),_c('b',[_vm._v(_vm._s(_vm.tamano))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tFecha: "),_c('b',[_vm._v(_vm._s(_vm.fichero.fichero.fecha))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tNombre del fichero: "),_c('b',[_vm._v(_vm._s(_vm.fichero.fichero.nombre))]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tDuración: "),_c('b',[_vm._v(_vm._s(_vm._f("round")(_vm.fichero.fichero.duracion,2))+" seg.")]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tDerechos de autor: "),_c('b',[_vm._v(_vm._s(_vm.fichero.fichero.musica_autor === 1 ? 'Sí' : 'No'))]),_vm._v(" "),(_vm.fichero.fichero.xframe_num)?_c('button',{staticClass:"mt-2 btn btn-sm",class:(_vm.verAuditor) ? 'btn-info' : 'btn-default',on:{"click":function($event){_vm.verAuditor = !_vm.verAuditor}}},[_c('span',{staticClass:"fa fa-calendar"})]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col p-0 bg-info text-white"},[(_vm.tipoFichero === 'audio')?_c('div',{staticStyle:{"padding":"0","margin":"0","position":"absolute","display":"block","bottom":"-5px","left":"0","right":"0"}},[_c('h3',[_vm._v("Reproductor")]),_vm._v(" "),_c('audio',{staticStyle:{"width":"100%"},attrs:{"controls":"true","autoplay":"true"}},[_c('source',{attrs:{"type":"audio/mp3","src":_vm.url}})])]):_vm._e(),_vm._v(" "),(_vm.tipoFichero === 'imagen')?_c('div',[_c('img',{staticStyle:{"position":"relative","display":"block","width":"100%","border":"1px solid #e0e0e0"},attrs:{"src":_vm.url,"alt":"Imágen producida"}})]):_vm._e(),_vm._v(" "),(_vm.tipoFichero === 'video')?_c('div',[_c('video',{staticStyle:{"max-width":"100%","margin-bottom":"-5px"},attrs:{"src":_vm.url,"controls":"true","autoplay":"true"}})]):_vm._e(),_vm._v(" "),(_vm.tipoFichero === 'desconocido')?_c('div',[_c('h1',[_vm._v("Fichero no visualizable")])]):_vm._e()])])]),_vm._v(" "),(_vm.fichero.fichero.xframe_num && _vm.verAuditor)?_c('div',{staticClass:"mt-4 text-left"},[_vm._m(0),_vm._v(" "),_c('detalles-auditor',{attrs:{"idfichero":_vm.fichero.fichero.ID_fichero}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"href":_vm.url}},[_c('span',{staticClass:"fa fa-download",staticStyle:{"margin-right":"3px"}}),_vm._v("\n\t\t\t\t\t\tDescargar\n\t\t\t\t\t")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-warning p-2 mb-3"},[_c('h3',{staticClass:"p-0 m-0 pl-3"},[_c('span',{staticClass:"fa fa-calendar"}),_vm._v("\n\t\t\t\t\t\t\tAuditor\n\t\t\t\t\t\t")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_versiones_vue__ = __webpack_require__(624);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03863df1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_versiones_vue__ = __webpack_require__(1445);
function injectStyle (ssrContext) {
  __webpack_require__(1444)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03863df1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_versiones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03863df1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_versiones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',{staticStyle:{"max-width":"200px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Listado de versiones")]),_c('table',{staticClass:"table table-condensed"},[_c('tbody',_vm._l((_vm.tarea.versiones),function(version,i){return _c('tr',{key:version.ID_version,class:(version.ID_version === _vm.actual.ID_version) ? 'bg-danger text-white' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.selecciona(version)}}},[_c('th',[_vm._v("Version "+_vm._s((i + 1)))]),_c('th',[(version.ID_version === _vm.actual)?_c('span',{staticClass:"fa fa-check"}):_vm._e()])])}),0)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_historial_vue__ = __webpack_require__(625);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12897747_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_historial_vue__ = __webpack_require__(1448);
function injectStyle (ssrContext) {
  __webpack_require__(1447)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12897747"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_historial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12897747_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_historial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',{staticStyle:{"max-width":"600px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n\t\t\t\t\tHistorial de la tarea\n\t\t\t\t\t"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('table',{staticClass:"table m-0 text-left"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.fases),function(fase){return _c('tr',{key:fase.ID_cambio,class:_vm.getClase(fase.fase)},[_c('td',{staticStyle:{"width":"40px"}},[(fase.usuario)?_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"40px","height":"auto"},attrs:{"src":fase.usuario.avatar,"alt":"avatar"}}):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[(fase.usuario)?_c('span',[_vm._v(_vm._s(fase.usuario.nombre))]):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.getAccion(fase.fase))+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(_vm.diaSem[fase.fecha.getDay()])+", "+_vm._s(fase.fecha.toLocaleDateString())),_c('br'),_vm._v("\n\t\t\t\t\t\t\t\ta las "+_vm._s(fase.fecha.toLocaleTimeString())+"\n\t\t\t\t\t\t\t")])])}),0)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_vm._v("Usuario")]),_vm._v(" "),_c('th',[_vm._v("Fase")]),_vm._v(" "),_c('th',[_vm._v("Fecha")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cronometro_vue__ = __webpack_require__(626);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39528b68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cronometro_vue__ = __webpack_require__(1450);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cronometro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39528b68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cronometro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","display":"inline-block","max-width":"220px"}},[_c('div',{staticClass:"input-group text-right"},[_vm._m(0),_vm._v(" "),_c('input',{staticClass:"form-control",staticStyle:{"width":"90px"},attrs:{"type":"text","disabled":"true"},domProps:{"value":_vm.tiempoCrono}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[(!_vm.hCrono)?_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.startCrono()}}},[_c('span',{staticClass:"fa fa-play"})]):_vm._e(),_vm._v(" "),(!_vm.momentoPause && _vm.hCrono)?_c('button',{staticClass:"btn btn-default",on:{"click":_vm.pauseCrono}},[_c('span',{staticClass:"fa fa-pause"})]):_vm._e(),_vm._v(" "),(_vm.momentoPause)?_c('button',{staticClass:"btn btn-default",on:{"click":_vm.resetCrono}},[_c('span',{staticClass:"fa fa-stop"})]):_vm._e(),_vm._v(" "),(_vm.momentoPause)?_c('button',{staticClass:"btn btn-success",on:{"click":_vm.confirmar}},[_c('span',{staticClass:"fa fa-check"})]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text fa fa-clock-o"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tarjeta_locutor_vue__ = __webpack_require__(627);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_971cafa2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tarjeta_locutor_vue__ = __webpack_require__(1452);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tarjeta_locutor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_971cafa2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tarjeta_locutor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[(!_vm.locutor.info)?_c('div',{staticClass:"card-img-top bg-light text-center"},[(_vm.locutor.titulo.match(/^loc[0-9]/))?_c('img',{staticStyle:{"height":"80px","margin":"5px"},attrs:{"src":"/static/recursos/hombre.svg"}}):_vm._e(),(_vm.locutor.titulo.match(/^loca[0-9]/))?_c('img',{staticStyle:{"height":"80px","margin":"5px"},attrs:{"src":"/static/recursos/mujer.svg"}}):_vm._e(),(_vm.locutor.titulo.match(/^locx[0-9]/))?_c('img',{staticStyle:{"height":"80px","margin":"5px"},attrs:{"src":"/static/recursos/otro.svg"}}):_vm._e()]):_vm._e(),(_vm.locutor.info)?_c('div',{staticClass:"card-img-top bg-light text-center"},[_c('img',{staticClass:"rounded-circle border",staticStyle:{"height":"80px","margin":"5px"},attrs:{"src":_vm.locutor.info.avatar,"alt":"loc"}})]):_vm._e(),_c('div',{staticClass:"card-block p-2"},[_c('h6',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.locutor.titulo))]),(!_vm.locutor.info)?_c('div',{staticClass:"card-text text-danger"},[_vm._v("Sin definir")]):_vm._e(),(_vm.locutor.info)?_c('div',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.locutor.info.nombre)+" "+_vm._s(_vm.locutor.info.apellidos))]):_vm._e()]),(_vm.tarea.fase !== 'finalizada' && _vm.esUltima && _vm.permisos.produccion_asignaLocutores)?_c('div',{staticClass:"card-footer p-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6 col-sm-6 col-md-6 col-xl-6 col-lg-6 text-left"},[_c('button',{staticClass:"btn btn-sm btn-info mr-2",on:{"click":function($event){_vm.locutorActual = _vm.locutor.titulo}}},[_c('span',{staticClass:"fa fa-user-o"})]),_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.desasignaLocutor(_vm.locutor.titulo)}}},[_c('span',{staticClass:"fa fa-trash"})])])])]):_vm._e()]),(_vm.locutorActual)?_c('selecciona-locutor',{attrs:{"tarea":_vm.tarea,"etiqueta":_vm.locutorActual},on:{"cerrar":function($event){_vm.locutorActual = null},"seleccion":function($event){return _vm.asignaLocutor($event)}}}):_vm._e(),_c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":function($event){return _vm.doUpload($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('h3',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))]):(_vm.tarea)?_c('div',{staticClass:"container-fluid text-left"},[_c('div',{staticClass:"card card-primary"},[_c('div',{staticClass:"card-header bg-info text-white"},[_vm._v("Información básica"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"},[_c('span',{staticClass:"fa fa-info-circle",staticStyle:{"position":"relative","float":"left","margin-right":"10px","vertical-align":"top","font-size":"5em","display":"inline-block","opacity":"0.1"}}),_c('b',[_vm._v(_vm._s(_vm.tarea.produccion.anunciante.nombre))]),_c('br'),_vm._v(_vm._s(_vm.tarea.produccion.titulo)),_c('br'),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.tarea.titulo))])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"},[_c('img',{staticClass:"rounded-circle",staticStyle:{"float":"left","position":"relative","display":"inline-block","vertical-align":"top","margin-right":"10px"},attrs:{"src":_vm.tarea.produccion.usuario.avatar,"width":"50"}}),_c('b',[_vm._v(_vm._s(_vm.tarea.produccion.usuario.nombre))]),_c('br'),_c('span',{staticClass:"text-muted"},[_vm._v("Creada el "+_vm._s(_vm.tarea.fecha_creacion))])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"},[_c('b',[_vm._v("Soportes")]),_c('br'),_vm._l((_vm.tarea.soportes),function(soporte){return _c('div',{key:soporte.ID_soporte,staticClass:"badge bg-warning text-dark p-1 mr-1 mb-1"},[_vm._v(_vm._s(soporte.nombre))])})],2),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2"},[_c('b',[_vm._v("Detalles")]),_c('br'),_vm._v("Tipo: "),_c('b',[(_vm.tarea.tipo === 'cuna')?_c('span',[_vm._v("Cuña")]):_vm._e()]),_c('br'),_vm._v("Fecha de inicio: "),_c('b',[_vm._v(_vm._s(_vm._f("moment")(_vm.tarea.fecha_inicio / 1000,'DD-MM-YYYY')))]),_c('br'),_vm._v("Fecha de fin: "),_c('b',[_vm._v(_vm._s(_vm._f("moment")(_vm.tarea.fecha_fin  / 1000,'DD-MM-YYYY')))]),_c('br'),(_vm.tarea.duracion)?_c('span',[_vm._v("Duración: "),_c('b',[_vm._v(_vm._s(_vm.tarea.duracion)+" segundos")])]):_vm._e()])])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('button',{staticClass:"btn btn-sm btn-success mr-1",attrs:{"title":"Información del proceso"},on:{"click":function($event){_vm.verHistorial = _vm.tarea.ID_tarea}}},[_c('span',{staticClass:"fa fa-info-circle"})]),_c('button',{staticClass:"btn btn-sm btn-info mr-1",attrs:{"title":'Hay ' + _vm.tarea.versiones.length + ' version(es)'},on:{"click":function($event){_vm.listadoVersiones = true}}},[_c('span',{staticClass:"fa fa-history",staticStyle:{"margin-right":"3px"}}),_vm._v(_vm._s(_vm.tarea.versiones.length))]),(_vm.tarea.esAgente || _vm.permisos.produccion_crearTodos)?_c('button',{staticClass:"btn btn-sm btn-dark mr-1",attrs:{"title":"Editar producción"},on:{"click":function($event){return _vm.editarProduccion()}}},[_c('span',{staticClass:"fa fa-ticket"})]):_vm._e(),(_vm.tarea.esAgente || _vm.permisos.produccion_crearTodos)?_c('button',{staticClass:"btn btn-sm btn-warning mr-1",attrs:{"title":"Editar tarea"},on:{"click":function($event){_vm.editarTarea = true}}},[_c('span',{staticClass:"fa fa-tasks"})]):_vm._e(),_c('button',{staticClass:"btn btn-sm mr-1",class:(_vm.versionActual.teleprompter) ? 'btn-danger' : 'btn-default',attrs:{"title":"Mandar al teleprompter"},on:{"click":function($event){return _vm.setTeleprompter()}}},[_c('span',{staticClass:"fa fa-desktop"})]),_c('button',{staticClass:"btn btn-sm btn-dark text-white mr-1",on:{"click":_vm.copiarTexto}},[_c('span',{staticClass:"fa fa-copy mr-2"}),_vm._v("Copiar texto")])]),_c('div',{staticClass:"col text-center"},[_c('span',{class:(_vm.esUltima) ? 'badge badge-warning p-0' : 'badge badge-danger p-0',staticStyle:{"font-weight":"bold","font-size":"1em","line-height":"30px","padding-left":"5px !important","padding-right":"5px !important"}},[(_vm.esUltima)?_c('span',[_vm._v(_vm._s(_vm.tituloFase))]):_vm._e(),(!_vm.esUltima)?_c('span',[_vm._v("Versión rechazada")]):_vm._e()])]),_c('div',{staticClass:"col text-right"},[(_vm.esUltima && _vm.esTareaValida)?_c('div',[(_vm.tarea.fase !== 'finalizada')?_c('div',[(_vm.tarea.esAgente || _vm.permisos.producciones_cancelarTareasAjenas)?_c('button',{staticClass:"btn btn-sm btn-warning mr-1",on:{"click":_vm.cancelarTarea}},[_c('span',{staticClass:"fa fa-ban mr-2"}),_vm._v("Cancelar tarea")]):_vm._e(),(_vm.tarea.fase !== 'pteIdea' && (_vm.tarea.esAgente || _vm.permisos.produccion_crearTodos))?_c('button',{staticClass:"btn btn-sm btn-danger mr-1",on:{"click":function($event){return _vm.rechazar()}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Rechazar")]):_vm._e(),(_vm.tarea.fase === 'pteIdea' && _vm.permisos.produccion_crearIdeas)?_c('button',{staticClass:"btn btn-sm btn-info mr-1",on:{"click":_vm.siguienteFase}},[_c('span',{class:_vm.iconoSiguienteFase,staticStyle:{"font-size":"1.2em","margin-right":"3px"}}),_vm._v(_vm._s(_vm.txtSiguienteFase))]):_vm._e(),(_vm.tarea.fase === 'pteAprobarIdea' && (_vm.tarea.esAgente || _vm.permisos.produccion_crearTodos))?_c('button',{staticClass:"btn btn-sm btn-info mr-1",on:{"click":_vm.siguienteFase}},[_c('span',{class:_vm.iconoSiguienteFase,staticStyle:{"font-size":"1.2em","margin-right":"3px"}}),_vm._v(_vm._s(_vm.txtSiguienteFase))]):_vm._e(),(_vm.tarea.fase === 'pteProduccion' && _vm.permisos.produccion_subirProducidos)?_c('button',{staticClass:"btn btn-sm btn-info mr-1",on:{"click":_vm.siguienteFase}},[_c('span',{class:_vm.iconoSiguienteFase,staticStyle:{"font-size":"1.2em","margin-right":"3px"}}),_vm._v(_vm._s(_vm.txtSiguienteFase))]):_vm._e(),(_vm.tarea.fase === 'pteAprobarProduccion' && (_vm.tarea.esAgente || _vm.permisos.produccion_crearTodos))?_c('button',{staticClass:"btn btn-sm btn-info",on:{"click":_vm.siguienteFase}},[_c('span',{class:_vm.iconoSiguienteFase,staticStyle:{"font-size":"1.2em","margin-right":"3px"}}),_vm._v(_vm._s(_vm.txtSiguienteFase))]):_vm._e()]):_vm._e(),(_vm.tarea.fase === 'finalizada')?_c('div',[_c('div',{staticClass:"btn btn-success btn-sm"},[_vm._v("Producción finalizada")])]):_vm._e()]):_vm._e()])])])]),_c('div',{staticClass:"row mt-3"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[(_vm.versionAnterior)?_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-header bg-danger text-light"},[_vm._v("Versión anterior rechazada por "+_vm._s(_vm.versionAnterior.usuario_rechaza.nombre)),_c('div',{staticClass:"pull-right"},[_c('span',{class:(!_vm.mostrarRechazo) ? 'fa fa-window-maximize': 'fa fa-window-minimize',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.mostrarRechazo = !_vm.mostrarRechazo}}})])]),(_vm.mostrarRechazo)?_c('div',{staticClass:"card-body"},[_c('img',{staticClass:"rounded-circle mr-1",staticStyle:{"width":"60px","position":"relative","display":"inline-block","float":"left"},attrs:{"src":_vm.versionAnterior.usuario_rechaza.avatar}}),_c('h5',{staticClass:"text-info"},[_vm._v("La explicación de "+_vm._s(_vm.versionAnterior.usuario_rechaza.nombre)+" es:")]),_c('p',{staticClass:"text-muted mt-1",domProps:{"innerHTML":_vm._s(_vm.versionAnterior.motivo_rechazo.replace('\n', '<br>'))}})]):_vm._e(),(_vm.mostrarRechazo && Object.keys(_vm.versionAnterior.listado_motivos_rechazo).length > 0)?_c('div',{staticClass:"card-body bg-light"},[_c('h5',{staticClass:"text-info"},[_vm._v("Motivos del rechazo")]),_c('br'),(_vm.versionAnterior.listado_motivos_rechazo['cliente'])?_c('div',[_c('b',[_vm._v("De parte del cliente")]),_c('ul',_vm._l((_vm.versionAnterior.listado_motivos_rechazo['cliente']),function(motivo){return _c('li',{key:motivo},[_vm._v(_vm._s(motivo))])}),0)]):_vm._e(),(_vm.versionAnterior.listado_motivos_rechazo['agente'])?_c('div',[_c('b',[_vm._v("De parte del agente")]),_c('ul',_vm._l((_vm.versionAnterior.listado_motivos_rechazo['agente']),function(motivo){return _c('li',{key:motivo},[_vm._v(_vm._s(motivo))])}),0)]):_vm._e(),(_vm.versionAnterior.listado_motivos_rechazo['marketing'])?_c('div',[_c('b',[_vm._v("De parte de márketing")]),_c('ul',_vm._l((_vm.versionAnterior.listado_motivos_rechazo['marketing']),function(motivo){return _c('li',{key:motivo},[_vm._v(_vm._s(motivo))])}),0)]):_vm._e(),(_vm.versionAnterior.listado_motivos_rechazo['tecnico'])?_c('div',[_c('b',[_vm._v("De parte de técnica")]),_c('ul',_vm._l((_vm.versionAnterior.listado_motivos_rechazo['tecnico']),function(motivo){return _c('li',{key:motivo},[_vm._v(_vm._s(motivo))])}),0)]):_vm._e()]):_vm._e()]):_vm._e(),(_vm.tarea.produccion.descripcion)?_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-header bg-light text-dark"},[_vm._v("Anotaciones de la producción"),_c('div',{staticClass:"pull-right"},[_c('span',{class:(!_vm.mostrarAnotacionesProduccion) ? 'fa fa-window-maximize': 'fa fa-window-minimize',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.mostrarAnotacionesProduccion = !_vm.mostrarAnotacionesProduccion}}})])]),(_vm.mostrarAnotacionesProduccion)?_c('div',{staticClass:"card-body"},[(_vm.tarea.produccion.descripcion)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.tarea.produccion.descripcion.replace('\n', '<br>'))}}):_vm._e()]):_vm._e()]):_vm._e(),(_vm.tarea.descripcion)?_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-header bg-light text-dark"},[_vm._v("Anotaciones de esta tarea"),_c('div',{staticClass:"pull-right"},[_c('span',{class:(!_vm.mostrarAnotacionesTarea) ? 'fa fa-window-maximize': 'fa fa-window-minimize',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.mostrarAnotacionesTarea = !_vm.mostrarAnotacionesTarea}}})])]),(_vm.mostrarAnotacionesTarea)?_c('div',{staticClass:"card-body"},[(_vm.tarea.descripcion)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.tarea.descripcion.replace('\n', '<br>'))}}):_vm._e(),(!_vm.tarea.descripcion)?_c('div',{staticClass:"text-danger text-center"},[_c('span',{staticClass:"fa fa-ban",staticStyle:{"font-size":"2em"}}),_c('br'),_vm._v("No hay anotaciones")]):_vm._e()]):_vm._e()]):_vm._e(),_c('comentarios',{attrs:{"tarea":_vm.tarea},on:{"update:tarea":function($event){_vm.tarea=$event}}})],1),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header",class:(!_vm.tarea.produccion.externa) ? 'bg-info text-white' : 'bg-warning text-dark'},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-left"},[_vm._v("Creatividad"),(_vm.tarea.produccion.externa)?_c('span',[_vm._v("(producción externa)")]):_vm._e()]),_c('div',{staticClass:"col text-right"},[(_vm.permisos.produccion_crearIdeas && _vm.tarea.fase === 'pteIdea' && !_vm.versionActual.tiempo_estimado)?_c('cronometro',{on:{"tiempo":function($event){return _vm.setDuracionEstimada($event)}}}):_vm._e(),(_vm.versionActual.tiempo_estimado)?_c('span',[_c('span',{staticClass:"fa fa-clock-o mr-2"}),_c('b',[_vm._v("Duración estimada: ")]),_vm._v(_vm._s(_vm.versionActual.tiempo_estimado)+" seg."),(_vm.permisos.produccion_crearIdeas && _vm.tarea.fase === 'pteIdea')?_c('button',{staticClass:"btn btn-sm btn-warning ml-2",on:{"click":function($event){_vm.versionActual.tiempo_estimado = null}}},[_c('span',{staticClass:"fa fa-edit"})]):_vm._e()]):_vm._e()],1)])]),_c('div',{staticClass:"card-body"},[(!_vm.esUltima)?_c('div',{staticClass:"alert alert-danger text-center"},[_c('span',{staticClass:"fa mb-2 fa-exclamation-triangle",staticStyle:{"font-size":"3em"}}),_c('h3',[_vm._v("Esta no es la última versión")])]):_vm._e(),(_vm.tarea.express_fecha)?_c('div',{staticClass:"alert alert-warning text-center"},[_c('span',{staticClass:"fa mb-2 fa-star",staticStyle:{"font-size":"3em"}}),_c('h3',[_vm._v("Esto es una producción express")])]):_vm._e(),(_vm.versionActual.tiempo_estimado > _vm.tarea.duracion)?_c('div',{staticClass:"alert alert-warning text-center"},[_c('span',{staticClass:"fa mb-2 fa-exclamation-triangle",staticStyle:{"font-size":"3em"}}),_c('h3',[_vm._v("La duración estimada excede el tiempo contratado por "+_vm._s(_vm.versionActual.tiempo_estimado - _vm.tarea.duracion)+" segundos")])]):_vm._e(),(!_vm.esTareaValida)?_c('div',{staticClass:"alert alert-warning text-center"},[_c('span',{staticClass:"mb-2 fa fa-ban",staticStyle:{"font-size":"3em"}}),_c('h3',[_vm._v("El agente debe completar los datos requeridos para poder continuar con esta tarea.")]),_c('h4',[_vm._v("Los datos obligatorios son: Fecha de inicio, fecha de fin y duración")]),_c('br'),(_vm.tarea.esAgente || _vm.permisos.produccion_crearTodos)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.editarTarea = true}}},[_c('span',{staticClass:"fa fa-tasks mr-2"}),_vm._v("Editar tarea")]):_vm._e()]):_vm._e(),(_vm.esTareaValida)?_c('div',[_c('h6',[_vm._v("Locutores requeridos")]),(_vm.tarea.vocesExternas > 0)?_c('alert',{staticClass:"alert-info"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Esta producción requiere "),_c('b',[_c('u',[_vm._v(_vm._s(_vm.tarea.vocesExternas)+" voces externas")])])]):_vm._e(),_c('div',{staticClass:"row"},_vm._l((_vm.versionActual.locutores),function(locutor){return _c('tarjeta-locutor',{key:locutor.titulo,staticClass:"col-xs-6 col-sm-4 col-md-3 col-lg-3 col-xl-3 mb-2",attrs:{"tarea":_vm.tarea,"version-actual":_vm.versionActual,"locutor":locutor},on:{"update:versionActual":function($event){_vm.versionActual=$event},"update:version-actual":function($event){_vm.versionActual=$event}}})}),1),(_vm.tarea.fase === 'pteIdea' && _vm.versionActual && _vm.esUltima && _vm.permisos.produccion_crearIdeas)?_c('editor-texto',{attrs:{"focoactivo":_vm.focoactivo,"version":_vm.versionActual},on:{"update:version":function($event){_vm.versionActual=$event}}}):_vm._e(),((_vm.tarea.fase !== 'pteIdea' && _vm.versionActual) || !_vm.esUltima)?_c('visualiza-texto',{attrs:{"tarea":_vm.tarea,"version":_vm.versionActual},on:{"update:version":function($event){_vm.versionActual=$event}}}):_vm._e()],1):_vm._e()])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[(_vm.tarea.produccion.ficheros.length > 0)?_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-header bg-success text-dark"},[_vm._v("Ficheros de apoyo de la producción")]),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped mb-0"},[_c('tbody',_vm._l((_vm.tarea.produccion.ficheros),function(fichero){return _c('tr',{key:fichero.ID_fichero,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verFichero(fichero, 'orden')}}},[_c('td',[_vm._v(_vm._s(fichero.nombre))])])}),0)])])]):_vm._e(),_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-header bg-warning text-dark"},[_vm._v("Ficheros de apoyo de la tarea"),(_vm.tarea.fase !== 'finalizada' && _vm.esTareaValida && _vm.esUltima && (_vm.tarea.esAgente || _vm.permisos.produccion_crearTodos))?_c('button',{staticClass:"btn btn-dark btn-sm",staticStyle:{"position":"absolute","display":"block","right":"5px","top":"6px"},on:{"click":function($event){return _vm.nuevoFichero('apoyo')}}},[_c('span',{staticClass:"fa fa-upload"})]):_vm._e()]),(_vm.tarea.ficheros.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped mb-0"},[_c('tbody',_vm._l((_vm.tarea.ficheros),function(fichero){return _c('tr',{key:fichero.ID_fichero},[_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verFichero(fichero, 'tarea')}}},[_vm._v(_vm._s(fichero.nombre))])])}),0)])]):_vm._e()]),_c('div',{staticClass:"card mb-2"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_vm._v("Ficheros producidos"),(_vm.tarea.fase === 'pteProduccion' && _vm.esTareaValida && _vm.esUltima && _vm.permisos.produccion_subirProducidos)?_c('button',{staticClass:"btn btn-dark btn-sm",staticStyle:{"position":"absolute","display":"block","right":"5px","top":"6px"},on:{"click":function($event){return _vm.nuevoFichero('final')}}},[_c('span',{staticClass:"fa fa-upload"})]):_vm._e()]),(_vm.versionActual.ficheros.length > 0)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped mb-0"},[_c('tbody',_vm._l((_vm.versionActual.ficheros),function(fichero){return _c('tr',{key:fichero.ID_fichero},[_c('td',[(fichero.musica_autor === 1)?_c('span',{staticClass:"fa fa-copyright",staticStyle:{"font-size":"2em","margin":"5px","vertical-align":"middle"},attrs:{"title":"Contiene fonográmas protegidos por derechos de autor"}}):_c('span',{staticClass:"fa fa-gift",staticStyle:{"font-size":"2em","margin":"5px","vertical-align":"middle"},attrs:{"title":"No contiene fonográmas protegidos por derechos de autor"}})]),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verFichero(fichero, 'version')}}},[_vm._v(_vm._s(fichero.nombre)),_c('br'),(fichero.duracion)?_c('span',{class:(_vm.tarea.duracion < fichero.duracion) ? 'text-danger' : 'text-success',staticStyle:{"font-weight":"bold"}},[_c('span',{staticClass:"text-info"},[_vm._v("Duración real: "+_vm._s(_vm._f("round")(fichero.duracion,2))+" seg")])]):_vm._e()]),_c('td',{staticClass:"text-right"},[(_vm.tarea.fase === 'pteProduccion' && _vm.esUltima && (_vm.tarea.esAgente || _vm.permisos.produccion_eliminarProducidos))?_c('button',{staticClass:"btn-sm btn-danger",on:{"click":function($event){return _vm.eliminaFicheroVersion(fichero)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e(),(_vm.tarea.fase === 'finalizada' && !fichero.xframe_num)?_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"title":"Subir al XFrame"},on:{"click":function($event){return _vm.subirXFrame(fichero)}}},[_c('span',{staticClass:"fa fa-upload"})]):_vm._e(),(fichero.xframe_num)?_c('div',{staticClass:"badge badge-danger p-2",staticStyle:{"font-size":"1em"}},[_vm._v(_vm._s(fichero.xframe_num))]):_vm._e()])])}),0)])]):_vm._e()])])]),(_vm.locutorActual)?_c('selecciona-locutor',{attrs:{"tarea":_vm.tarea,"etiqueta":_vm.locutorActual},on:{"cerrar":function($event){_vm.locutorActual = null},"seleccion":function($event){return _vm.setLocutor($event)}}}):_vm._e(),(_vm.rechazaTarea)?_c('rechazo-tarea',{attrs:{"tarea":_vm.tarea,"version":_vm.versionActual},on:{"cerrar":function($event){_vm.rechazaTarea = false},"nueva":function($event){return _vm.nuevaVersion($event)}}}):_vm._e(),(_vm.editarTarea)?_c('editando-tarea',{attrs:{"tarea":_vm.tarea},on:{"actualizar":function($event){return _vm.emiteActualizar($event)},"cerrar":function($event){return _vm.cierraEditorTarea()}}}):_vm._e(),(_vm.idproduccion)?_c('editando-produccion',{attrs:{"idproduccion":_vm.idproduccion},on:{"actualizar":function($event){return _vm.emiteActualizar()},"cerrar":function($event){_vm.idproduccion = null}}}):_vm._e(),(_vm.previsualizaFichero)?_c('reproductor',{attrs:{"fichero":_vm.previsualizaFichero},on:{"cerrar":function($event){_vm.previsualizaFichero = null}}}):_vm._e(),(_vm.verHistorial)?_c('historial',{attrs:{"idtarea":_vm.verHistorial},on:{"cerrar":function($event){_vm.verHistorial = false}}}):_vm._e(),(_vm.listadoVersiones)?_c('listado-versiones',{attrs:{"tarea":_vm.tarea,"actual":_vm.versionActual},on:{"cambia-version":function($event){return _vm.setVersion($event)}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscador_vue__ = __webpack_require__(628);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e8c45f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscador_vue__ = __webpack_require__(1458);
function injectStyle (ssrContext) {
  __webpack_require__(1455)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e8c45f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditor_vue__ = __webpack_require__(629);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45406e5b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_auditor_vue__ = __webpack_require__(1457);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45406e5b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_auditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fondoModal"},[_c('div',[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Auditor de emisión"),_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.cerrar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{staticClass:"card-body text-left"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('h4',{staticClass:"text-info mb-3"},[_vm._v("Selecciona el fichero para auditar"),_vm._l((_vm.ficheros),function(fichero){return _c('button',{key:fichero.ID_fichero,staticClass:"btn btn-block btn-sm m-1",class:(_vm.auditando === fichero.ID_fichero) ? 'btn-info' : 'btn-default',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.auditando = fichero.ID_fichero}}},[_vm._v("("+_vm._s(fichero.xframe_num)+") - "+_vm._s(fichero.nombre))])})],2)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"},[(_vm.auditando)?_c('detalles',{attrs:{"idfichero":_vm.auditando,"idversion":_vm.version.ID_version}}):_vm._e()],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card text-left"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Anunciante")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.anunciante),expression:"form.anunciante"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Nombre del anunciante"},domProps:{"value":(_vm.form.anunciante)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "anunciante", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Cliente (a quien se factura)")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cliente),expression:"form.cliente"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Nombre del cliente"},domProps:{"value":(_vm.form.cliente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cliente", $event.target.value)}}})])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.agente),expression:"form.agente"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Nombre del agente"},domProps:{"value":(_vm.form.agente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "agente", $event.target.value)}}})])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nº XFrame")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.xframe),expression:"form.xframe"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Nombre del agente"},domProps:{"value":(_vm.form.xframe)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "xframe", $event.target.value)}}})])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tipo),expression:"form.tipo"}],staticClass:"form-control form-control-sm",attrs:{"name":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.buscar()}]}},[_c('option',{domProps:{"value":null}},[_vm._v("Todos")]),_c('option',{attrs:{"value":"cuna"}},[_vm._v("Cuña")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Procedencia")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.procedencia),expression:"form.procedencia"}],staticClass:"form-control form-control-sm",attrs:{"name":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "procedencia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.buscar()}]}},[_c('option',{domProps:{"value":null}},[_vm._v("Todas")]),_c('option',{attrs:{"value":"directa"}},[_vm._v("Subida directa")]),_c('option',{attrs:{"value":"produccion"}},[_vm._v("Producción propia")])])])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.form.estado === 'todas') ? 'btn-danger' : 'btn-default',on:{"click":function($event){return _vm.setEstado('todas')}}},[_vm._v("Todas")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.form.estado === 'pendientes') ? 'btn-danger' : 'btn-default',on:{"click":function($event){return _vm.setEstado('pendientes')}}},[_vm._v("Pendientes")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.form.estado === 'finalizadas') ? 'btn-danger' : 'btn-default',on:{"click":function($event){return _vm.setEstado('finalizadas')}}},[_vm._v("Finalizadas")])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Destino")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:(_vm.form.externa === null) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setDestino(null)}}},[_vm._v("Todas")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.form.externa === 0) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setDestino(0)}}},[_vm._v("Propias")]),_c('button',{staticClass:"btn btn-sm",class:(_vm.form.externa === 1) ? 'btn-primary' : 'btn-default',on:{"click":function($event){return _vm.setDestino(1)}}},[_vm._v("Externas")])])])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Desde")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"language":_vm.$dateLang,"monday-first":true,"placeholder":"DD-MM-YYYY"},model:{value:(_vm.form.fechaIni),callback:function ($$v) {_vm.$set(_vm.form, "fechaIni", $$v)},expression:"form.fechaIni"}})],1)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hasta")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"language":_vm.$dateLang,"monday-first":true,"placeholder":"DD-MM-YYYY"},model:{value:(_vm.form.fechaFin),callback:function ($$v) {_vm.$set(_vm.form, "fechaFin", $$v)},expression:"form.fechaFin"}})],1)])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Locutor(es)")]),_c('input-query',{attrs:{"realtime":true,"input-class":'form-control form-control-sm',"placeholder":"Busca y selecciona los locutores","url":'produccion/php/api/buscaLocutores.php'},on:{"selected":function($event){return _vm.seleccionaLocutor($event)}}})],1),_vm._l((_vm.form.locutores),function(locutor){return _c('div',{key:locutor.ID_locutor,staticClass:"card mb-1 mr-1 p-0",staticStyle:{"position":"relative","display":"inline-block"}},[_c('div',{staticClass:"card-body p-1 bg-light text-left"},[_c('img',{staticClass:"rounded-circle mr-2",staticStyle:{"width":"30px","display":"inline-block","vertical-align":"middle"},attrs:{"src":locutor.avatar,"alt":""}}),_c('b',[_vm._v(_vm._s(locutor.nombre)+" "+_vm._s(locutor.apellidos))]),_c('button',{staticClass:"btn btn-sm btn-danger ml-2",on:{"click":function($event){return _vm.quitaLocutor(locutor)}}},[_c('span',{staticClass:"fa fa-trash"})])])])})],2)])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.buscar()}}},[_c('span',{staticClass:"fa fa-search mr-1"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-sm btn-danger",attrs:{"disabled":_vm.descargando},on:{"click":function($event){return _vm.descargar()}}},[_c('span',{staticClass:"fa fa-download mr-1"}),_vm._v("Descargar audios")])])]),_c('div',{staticClass:"card mt-2 text-left"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_vm._v(_vm._s(_vm.resultados.length)+" Resultados"),(_vm.limite)?_c('span',[_vm._v("(limitado a "+_vm._s(_vm.limite)+")")]):_vm._e()]),(_vm.resultados.length > 0)?_c('table',{staticClass:"table table-striped table-condensed"},[_vm._m(1),_c('tbody',_vm._l((_vm.resultados),function(tarea){return _c('tr',{key:tarea.ID_tarea,class:(tarea.fase === 'cancelada') ? 'bg-danger text-white' : ''},[_c('td',[_vm._v(_vm._s(tarea.agenteNombre))]),_c('td',[_vm._v(_vm._s(tarea.anuncianteNombre)),_c('br'),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(tarea.clienteNombre))])]),_c('td',[(tarea.externa)?_c('span',[_c('span',{staticClass:"fa fa-gift",attrs:{"title":"Externa"}})]):_vm._e(),(!tarea.externa)?_c('span',[_c('span',{staticClass:"fa fa-flag",attrs:{"title":"Propia"}})]):_vm._e()]),_c('td',[_vm._v(_vm._s(tarea.tareaTitulo))]),_c('td',[_vm._v(_vm._s(new Date(tarea.tareaFechaCreacion * 1000).toLocaleDateString()))]),_c('td',[(tarea.fase === 'cancelada')?_c('span',[_vm._v("Cancelada")]):(tarea.tareaFechaFin === null)?_c('span',[_vm._v("Pendiente")]):(tarea.tareaFechaFin !== null)?_c('span',[_vm._v("Finalizada")]):_vm._e()]),_c('td',[_vm._v(_vm._s(tarea.ficheros)+" ficheros")]),_c('td',[(tarea.tareaFechaFin)?_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.auditando = tarea.ID_tarea}}},[_c('span',{staticClass:"fa fa-calendar"})]):_vm._e(),_c('button',{staticClass:"btn btn-sm btn-info",on:{"click":function($event){return _vm.abrir(tarea)}}},[_c('span',{staticClass:"fa fa-eye"})])])])}),0)]):_vm._e(),(_vm.resultados.length === 0)?_c('div',{staticClass:"text-center text-muted"},[_c('span',{staticClass:"fa fa-list m-3",staticStyle:{"font-size":"4em"}}),_c('h3',[_vm._v("No hay resultados")])]):_vm._e()]),(_vm.auditando)?_c('auditor',{attrs:{"idtarea":_vm.auditando},on:{"cerrar":function($event){_vm.auditando = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscador de tareas")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("Anunciante y cliente")]),_c('th',[_vm._v("Tipo")]),_c('th',[_vm._v("Título")]),_c('th',[_vm._v("Fecha de creación")]),_c('th',[_vm._v("Estado")]),_c('th',[_vm._v("Ficheros")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fase_tareas_new_vue__ = __webpack_require__(630);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08137b0d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fase_tareas_new_vue__ = __webpack_require__(1460);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fase_tareas_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08137b0d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_fase_tareas_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3"},[_c('div',{staticClass:"card panel-success"},[_c('div',{staticClass:"card-header text-white",class:_vm.clase},[_vm._v(_vm._s(_vm.titulo)+" ("+_vm._s(_vm.listadoProcesado.length)+" tareas)")]),_c('table',{staticClass:"table table-striped mb-0"},[_c('tbody',_vm._l((_vm.listadoProcesado),function(tarea){return _c('tr',{key:tarea.ID_tarea,class:(tarea.publica) ? 'bg-dark text-white' : '',staticStyle:{"cursor":"pointer"},style:((_vm.tareaVieja(tarea)) ? {'opacity': 0.5} : {}),on:{"click":function($event){return _vm.seleccionar(tarea.ID_tarea, tarea.tareaTitulo)}}},[(tarea.fase === 'pteProduccion')?_c('td',{staticStyle:{"width":"3px","position":"relative"}},[_c('div',{staticClass:"bg-info",staticStyle:{"position":"absolute","display":"block","bottom":"0","left":"0","width":"2px","transition":"all 300ms ease-in-out"},style:({height: tarea.porcentaje_grabado + '%'})})]):_vm._e(),(!_vm.esTareaValida(tarea) || tarea.externa || tarea.vocesExternas || _vm.tareaVieja(tarea))?_c('td',{staticStyle:{"width":"30px","text-align":"center"}},[(!_vm.esTareaValida(tarea))?_c('span',{staticClass:"fa fa-ban text-danger",staticStyle:{"font-size":"2em"},attrs:{"title":"Faltan datos por completar"}}):_vm._e(),(_vm.esTareaValida(tarea) && tarea.externa)?_c('span',{staticClass:"fa fa-gift text-warning",staticStyle:{"font-size":"2em"},attrs:{"title":"Producción externa"}}):_vm._e(),(tarea.vocesExternas)?_c('span',{staticClass:"fa fa-globe text-danger",staticStyle:{"font-size":"2em"},attrs:{"title":"Locutores externos seleccionados"}}):_vm._e(),(_vm.tareaVieja(tarea))?_c('span',{staticClass:"fa fa-trash text-dark",staticStyle:{"font-size":"2em"},attrs:{"title":"Esta tarea se pasa más de 1 mes de la fecha de creación y será eliminada próximamente"}}):_vm._e()]):_vm._e(),_c('td',{attrs:{"colspan":(_vm.esTareaValida(tarea) && !tarea.externa && !tarea.vocesExternas && !_vm.tareaVieja(tarea)) ? 2 : 1}},[_c('b',[_vm._v(_vm._s(tarea.anuncianteNombre))]),_c('br'),_vm._v(_vm._s(tarea.ordenTitulo)),_c('br'),_c('span',{class:(tarea.publica) ? 'text-light' : 'text-muted'},[_vm._v(_vm._s(tarea.tareaTitulo))]),_c('br'),_c('span',{class:(tarea.publica) ? 'text-light' : 'text-muted',staticStyle:{"font-size":"0.8em"}},[_vm._v("Fecha de compromiso: "+_vm._s(_vm._f("moment")(tarea.fecha_inicio / 1000,'DD-MM-YYYY')))]),(tarea.express)?_c('div',{staticClass:"bg-warning p-1",staticStyle:{"border-radius":"3px"}},[_vm._m(0,true)]):_vm._e()]),_c('td',{staticStyle:{"width":"10px","font-size":"1.2em"}},[(tarea.tipo === 'cuna')?_c('span',{staticClass:"fa fa-volume-up"}):_vm._e(),_c('br'),(tarea.tipo === 'diseno')?_c('span',{staticClass:"fa fa-paint-brush"}):_vm._e()]),_c('td',{staticStyle:{"text-align":"center","width":"50px"}},[_c('img',{staticClass:"rounded-circle",attrs:{"src":tarea.agenteAvatar,"width":"50","title":tarea.agenteNombre}}),(tarea.numVersiones > 1)?_c('span',{staticClass:"badge badge-danger mt-2",attrs:{"title":tarea.numVersiones + ' versiones'}},[_vm._v(_vm._s(tarea.numVersiones)+" versiones")]):_vm._e()])])}),0),(_vm.listado.length === 0)?_c('div',{staticClass:"p-3 text-center"},[_c('span',{staticClass:"fa fa-smile-o text-muted",staticStyle:{"font-size":"6em"}}),_c('h4',{staticClass:"m-0 p-0 text-muted"},[_vm._v("No hay tareas")])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('span',{staticClass:"fa fa-star mr-2"}),_vm._v("Tarea express")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_estadisticas_vue__ = __webpack_require__(631);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22e99cea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_estadisticas_vue__ = __webpack_require__(1462);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_estadisticas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22e99cea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_estadisticas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-4 col-xl-4"},[(_vm.permisos.producciones_verEstadisticasTodos)?_c('div',[(!_vm.filtro.ID_agente)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),_c('input-query',{attrs:{"input-class":"form-control","placeholder":"Busca un anunciante","realtime":true,"url":"produccion/php/api/buscaAgente.php"},on:{"selected":function($event){return _vm.seleccionaAgente($event)}}})],1):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.agente.UsuarioNombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.filtro.ID_agente = null}}},[_c('span',{staticClass:"fa fa-trash"})])])])])]):_vm._e(),(!_vm.filtro.ID_anunciante)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Anunciante")]),_c('input-query',{attrs:{"input-class":"form-control","placeholder":"Busca un anunciante","realtime":true,"url":'produccion/php/api/buscaAnunciante.php?ID_agente=' + _vm.filtro.ID_agente},on:{"selected":function($event){return _vm.seleccionaAnunciante($event)}}})],1):_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Anunciante")]),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm.anunciante.nombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.filtro.ID_anunciante = null}}},[_c('span',{staticClass:"fa fa-trash"})])])])])]),_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Desde")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"language":_vm.$dateLang,"monday-first":true},model:{value:(_vm.filtro.fechaInicio),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaInicio", $$v)},expression:"filtro.fechaInicio"}})],1),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hasta")]),_c('datepicker',{attrs:{"bootstrap-styling":true,"language":_vm.$dateLang,"monday-first":true},model:{value:(_vm.filtro.fechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "fechaFin", $$v)},expression:"filtro.fechaFin"}})],1)]),_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-4 col-xl-4"},[_vm._v("Personalización"),_c('p',{staticClass:"mt-2"},[_c('label',{staticStyle:{"cursor":"pointer"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.excluirNoProducidas),expression:"filtro.excluirNoProducidas"}],staticClass:"mr-3",attrs:{"type":"checkbox","name":"producidas"},domProps:{"checked":Array.isArray(_vm.filtro.excluirNoProducidas)?_vm._i(_vm.filtro.excluirNoProducidas,null)>-1:(_vm.filtro.excluirNoProducidas)},on:{"change":function($event){var $$a=_vm.filtro.excluirNoProducidas,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.filtro, "excluirNoProducidas", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.filtro, "excluirNoProducidas", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.filtro, "excluirNoProducidas", $$c)}}}}),_vm._v("Excluír campañas sin producción")])]),_c('p',{staticClass:"mt-2"},[_c('label',{staticStyle:{"cursor":"pointer"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.omitirCanceladas),expression:"filtro.omitirCanceladas"}],staticClass:"mr-3",attrs:{"type":"checkbox","name":"canceladas"},domProps:{"checked":Array.isArray(_vm.filtro.omitirCanceladas)?_vm._i(_vm.filtro.omitirCanceladas,null)>-1:(_vm.filtro.omitirCanceladas)},on:{"change":function($event){var $$a=_vm.filtro.omitirCanceladas,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.filtro, "omitirCanceladas", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.filtro, "omitirCanceladas", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.filtro, "omitirCanceladas", $$c)}}}}),_vm._v("Omitir producciones canceladas")])]),_c('p',{staticClass:"mt-2"},[_c('label',{staticStyle:{"cursor":"pointer"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.omitirExternas),expression:"filtro.omitirExternas"}],staticClass:"mr-3",attrs:{"type":"checkbox","name":"externas"},domProps:{"checked":Array.isArray(_vm.filtro.omitirExternas)?_vm._i(_vm.filtro.omitirExternas,null)>-1:(_vm.filtro.omitirExternas)},on:{"change":function($event){var $$a=_vm.filtro.omitirExternas,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.filtro, "omitirExternas", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.filtro, "omitirExternas", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.filtro, "omitirExternas", $$c)}}}}),_vm._v("Omitir producciones externas")])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.consultar}},[_vm._v("Consultar")])])]),_vm._m(1),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8"},[(_vm.resultados.tareasPorMeses)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Tareas por meses")]),_c('div',{staticClass:"card-body"},[_c('chartjs-line',{attrs:{"beginatzero":true,"title":{display: true, text: 'Locutores Populares'},"label":"Locutores populares","legend":{display: false},"height":200,"labels":_vm.resultados.tareasPorMeses.labels,"datasets":_vm.resultados.tareasPorMeses.datasets}})],1)]):_vm._e(),(_vm.resultados.locutoresPopulares)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Locutores más utilizados")]),_c('div',{staticClass:"card-body"},[_c('chartjs-bar',{attrs:{"beginatzero":true,"title":{display: true, text: 'Locutores Populares'},"label":"Locutores populares","legend":{display: false},"height":200,"labels":_vm.resultados.locutoresPopulares.labels,"datasets":_vm.resultados.locutoresPopulares.datasets}})],1)]):_vm._e(),(_vm.resultados.versionesTareas)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Versiones por tarea")]),_c('div',{staticClass:"card-body"},[_c('chartjs-bar',{attrs:{"beginatzero":true,"label":"Versiones tareas","height":200,"labels":_vm.resultados.versionesTareas.labels,"datasets":_vm.resultados.versionesTareas.datasets}})],1)]):_vm._e(),(_vm.resultados.rankingAgentes)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Producciones por agente")]),_c('div',{staticClass:"card-body"},[_c('chartjs-bar',{attrs:{"beginatzero":true,"label":"Versiones tareas","height":200,"labels":_vm.resultados.rankingAgentes.labels,"datasets":_vm.resultados.rankingAgentes.datasets}})],1)]):_vm._e(),(_vm.resultados.rankingRechazan)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Rechazos por agente")]),_c('div',{staticClass:"card-body"},[_c('chartjs-bar',{attrs:{"beginatzero":true,"label":"Versiones tareas","height":200,"labels":_vm.resultados.rankingRechazan.labels,"datasets":_vm.resultados.rankingRechazan.datasets}})],1)]):_vm._e(),(_vm.resultados.tiempoMedio)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Tiempo medio por fase")]),_c('div',{staticClass:"card-body"},[_c('chartjs-bar',{attrs:{"beginatzero":true,"label":"Versiones tareas","height":200,"labels":_vm.resultados.tiempoMedio.labels,"datasets":_vm.resultados.tiempoMedio.datasets,"option":_vm.resultados.tiempoMedio.options}})],1)]):_vm._e(),(_vm.resultados.tareasMasVersiones)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Sobrecargo en producción"),_c('div',{staticClass:"badge badge-warning ml-2",staticStyle:{"font-size":"1.3em"}},[_vm._v(_vm._s((_vm.resultados.tareasMasVersiones.datasets[0].data[1] * 100 / _vm.resultados.tareasMasVersiones.datasets[0].data[0]).toFixed(2))+" %")])]),_c('div',{staticClass:"card-body"},[_c('chartjs-bar',{attrs:{"beginatzero":true,"label":"Sobrecargo producción","height":200,"labels":_vm.resultados.tareasMasVersiones.labels,"datasets":_vm.resultados.tareasMasVersiones.datasets,"option":_vm.resultados.tareasMasVersiones.options}})],1)]):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[(_vm.resultados.tareasTotales)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header bg-warning"},[_vm._v("Totales")]),_c('div',{staticClass:"card-body"},[_c('p',[_c('b',[_vm._v("Total tareas:")]),_vm._v(" "+_vm._s(_vm._f("currency")(_vm.resultados.tareasTotales.tareas,'', 0)))]),_c('p',[_c('b',[_vm._v("Total textos:")]),_vm._v(" "+_vm._s(_vm._f("currency")(_vm.resultados.tareasTotales.textos,'', 0))),_c('span',{staticClass:"badge bg-danger text-white ml-2",staticStyle:{"font-size":"1.1em"}},[_vm._v(_vm._s(Math.round(_vm.resultados.tareasTotales.textos * 100 / _vm.resultados.tareasTotales.tareas))+" %")])]),_c('p',[_c('b',[_vm._v("Total producciones:")]),_vm._v(" "+_vm._s(_vm._f("currency")(_vm.resultados.tareasTotales.producciones,'', 0))),_c('span',{staticClass:"badge bg-danger text-white ml-2",staticStyle:{"font-size":"1.1em"}},[_vm._v(_vm._s(Math.round(_vm.resultados.tareasTotales.producciones * 100 / _vm.resultados.tareasTotales.tareas))+" %")])])])]):_vm._e(),(_vm.resultados.vocesExternas)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Procedencia del locutor/a")]),_c('div',{staticClass:"card-body"},[_c('chartjs-pie',{attrs:{"option":{},"label":"Voces externas","datalabel":"VocesExternas","height":200,"labels":_vm.resultados.vocesExternas.labels,"data":_vm.resultados.vocesExternas.datasets[0].data}})],1)]):_vm._e(),(_vm.resultados.locutoresGenero)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Locutores por género")]),_c('div',{staticClass:"card-body"},[_c('chartjs-pie',{attrs:{"option":{},"label":"Voces externas","datalabel":"locutoresGenero","height":200,"labels":_vm.resultados.locutoresGenero.labels,"data":_vm.resultados.locutoresGenero.datasets[0].data}})],1)]):_vm._e(),(_vm.resultados.rankingFases)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Rechazos por fase")]),_c('div',{staticClass:"card-body"},[_c('chartjs-pie',{attrs:{"option":{},"label":"Fases de rechazo","datalabel":"rankingFases","height":200,"labels":_vm.resultados.rankingFases.labels,"data":_vm.resultados.rankingFases.datasets[0].data}})],1)]):_vm._e(),(_vm.resultados.externasInternas)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Producciones externas vs internas"),_c('div',{staticClass:"badge badge-warning ml-2",staticStyle:{"font-size":"1.3em"}},[_vm._v(_vm._s((_vm.resultados.externasInternas.datasets[0].data[0] * 100 / (_vm.resultados.externasInternas.datasets[0].data[1] + _vm.resultados.externasInternas.datasets[0].data[1])).toFixed(2))+" %")])]),_c('div',{staticClass:"card-body"},[_c('chartjs-pie',{attrs:{"option":{},"label":"Voces externas","datalabel":"externasInternas","height":200,"labels":_vm.resultados.externasInternas.labels,"data":_vm.resultados.externasInternas.datasets[0].data}})],1)]):_vm._e(),(_vm.resultados.produccionesExpress)?_c('div',{staticClass:"card mt-4"},[_c('div',{staticClass:"card-header"},[_vm._v("Producciones express"),_c('div',{staticClass:"badge badge-warning ml-2",staticStyle:{"font-size":"1.3em"}},[_vm._v(_vm._s((_vm.resultados.produccionesExpress.datasets[0].data[0] * 100 / (_vm.resultados.produccionesExpress.datasets[0].data[0] + _vm.resultados.produccionesExpress.datasets[0].data[1])).toFixed(2))+" %")])]),_c('div',{staticClass:"card-body"},[_c('chartjs-pie',{attrs:{"option":{},"label":"Voces externas","datalabel":"produccionesExpress","height":200,"labels":_vm.resultados.produccionesExpress.labels,"data":_vm.resultados.produccionesExpress.datasets[0].data}})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Filtrar los datos")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-4",staticStyle:{"display":"none"}},[_c('div',{staticClass:"card-header"},[_vm._v("Ideas")]),_c('div',{staticClass:"card-body"},[_c('ul',[_c('li',[_vm._v("[OK] 10 locutores más populares")]),_c('li',[_vm._v("[OK] Voces externas vs voces internas")]),_c('li',[_vm._v("[OK] Nº versiones por tarea")]),_c('li',[_vm._v("[OK] Ranking de agentes")]),_c('li',[_vm._v("[OK] Agentes que más rechazan")]),_c('li',[_vm._v("[OK] Fases en las que más rechazos hay")]),_c('li',[_vm._v("[OK] Tiempo medio en cada fase")]),_c('li',[_vm._v("[OK] Producciones externas vs producciones internas")]),_c('li',[_vm._v("[OK] % de producciones express")]),_c('li',[_vm._v("Días de la semana vs creacion de tareas")]),_c('li',[_vm._v("Días de la semana vs tareas finalizadas")]),_c('li',[_vm._v("[OK] Tareas totales + Versiones")]),_c('li',[_vm._v("Tareas por meses")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"padding-bottom":"40px"}},[(_vm.seccion === 'listado')?_c('div',{staticClass:"mb-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-primary text-white",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.verFiltros = !_vm.verFiltros}}},[_c('span',{staticClass:"fa fa-filter mr-2"}),_vm._v("Filtros"),(!_vm.filtro.locutor && !_vm.filtro.agente && !_vm.filtro.anunciante && !_vm.filtro.tipo)?_c('button',{staticClass:"close",staticStyle:{"color":"white","opacity":"1"}},[_c('span',{class:(_vm.verFiltros) ? 'fa fa-caret-up' : 'fa fa-caret-down'})]):_vm._e()]),(_vm.verFiltros)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Locutor/a")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.locutor),expression:"filtro.locutor"}],staticClass:"form-control",attrs:{"placeholder":"Filtra por locutor"},domProps:{"value":(_vm.filtro.locutor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "locutor", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Anunciante")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.anunciante),expression:"filtro.anunciante"}],staticClass:"form-control",attrs:{"placeholder":"Filtra por anunciante"},domProps:{"value":(_vm.filtro.anunciante)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "anunciante", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Agente")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.agente),expression:"filtro.agente"}],staticClass:"form-control",attrs:{"placeholder":"Filtra por agente"},domProps:{"value":(_vm.filtro.agente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "agente", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.tipo === null) ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.tipo = null}}},[_vm._v("Todas")]),_c('button',{staticClass:"btn",class:(_vm.filtro.tipo === 'propias') ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.tipo = 'propias'}}},[_vm._v("Propias")]),_c('button',{staticClass:"btn",class:(_vm.filtro.tipo === 'externas') ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.tipo = 'externas'}}},[_vm._v("Externas")])])])])]),(_vm.filtro.locutor || _vm.filtro.agente || _vm.filtro.anunciante || _vm.filtro.tipo)?_c('div',{staticClass:"alert alert-danger"},[_c('span',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("Se están filtrando los resultados")]):_vm._e()]):_vm._e()])]):_vm._e(),(_vm.seccion === 'listado')?_c('div',{staticClass:"row text-left"},_vm._l((_vm.fases),function(fase){return _c('fase-tareas',{key:fase.id,attrs:{"titulo":fase.titulo,"listado":fase.tareas,"clase":fase.clase},on:{"abrir":function($event){return _vm.cargaOrden($event)}}})}),1):_vm._e(),_c('buscador',{directives:[{name:"show",rawName:"v-show",value:(_vm.seccion == 'buscador'),expression:"seccion == 'buscador'"}],on:{"abrir":function($event){return _vm.cargaOrden($event)}}}),_c('nueva-orden',{directives:[{name:"show",rawName:"v-show",value:(_vm.seccion == 'nueva'),expression:"seccion == 'nueva'"}],attrs:{"principal":true},on:{"actualizar":function($event){return _vm.getTareas()},"cerrar":function($event){_vm.seccion = _vm.seccionAnterior}}}),_vm._l((_vm.listadoAbiertos),function(tarea){return _c('vista-tarea',{directives:[{name:"show",rawName:"v-show",value:((_vm.seccion === 'tarea' && _vm.ID_tarea === tarea.ID_tarea)),expression:"(seccion === 'tarea' && ID_tarea === tarea.ID_tarea)"}],key:tarea.ID_tarea,attrs:{"idtarea":tarea.ID_tarea,"focoactivo":(_vm.seccion === 'tarea' && _vm.ID_tarea === tarea.ID_tarea)},on:{"actualizar":function($event){return _vm.getTareas()},"cerrar":function($event){return _vm.cerrarTarea(tarea.ID_tarea)}}})}),_c('estadisticas',{directives:[{name:"show",rawName:"v-show",value:(_vm.seccion === 'estadisticas'),expression:"seccion === 'estadisticas'"}]}),(_vm.listadoAbiertos.length > 0)?_c('div',{staticClass:"barraInferior"},[_c('ul',_vm._l((_vm.listadoAbiertos),function(tarea){return _c('li',{key:tarea.ID_tarea,class:{ activo : (_vm.seccion === 'tarea' && _vm.ID_tarea === tarea.ID_tarea)},on:{"click":function($event){return _vm.maximizar(tarea.ID_tarea)}}},[_c('span',{staticClass:"fa-w fa fa-volume-up",staticStyle:{"margin-right":"5px"}}),_vm._v(_vm._s(tarea.nombre))])}),0)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('listado-tareas')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_component__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_overview_mainOverview_component__ = __webpack_require__(1470);




/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('produccion-audiovisual', {
			name: 'Producción',
			component: __WEBPACK_IMPORTED_MODULE_1__main_component__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('produccion-audiovisual').child('', {
			name: 'Vista rápida',
			component: __WEBPACK_IMPORTED_MODULE_2__components_overview_mainOverview_component__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('produccion-audiovisual').child('tarea/:TareaID', {
			name: 'Tarea',
			component: __WEBPACK_IMPORTED_MODULE_2__components_overview_mainOverview_component__["a" /* default */]
		});
	}
});

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_component_vue__ = __webpack_require__(632);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c64e81_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_component_vue__ = __webpack_require__(1469);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40c64e81_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_main_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_c('span',[_vm._v("Editor de producciones")]),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Usuario que solicita")])]),_c('seleccion-usuario',{model:{value:(_vm.datos.UsuarioID),callback:function ($$v) {_vm.$set(_vm.datos, "UsuarioID", $$v)},expression:"datos.UsuarioID"}})],1)]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Fecha de solicitud")])]),_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.$moment().format('DD-MM-YYYY') + ' a las ' + _vm.$moment().format('HH:mm')}})])])])]),_c('div',{staticClass:"card-body"},[_c('h4',[_c('span',{staticClass:"fa fa-search mr-2"}),_c('span',[_vm._v("Detalles de la solicitud")])]),_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Título")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.Titulo),expression:"datos.Titulo"}],staticClass:"form-control",domProps:{"value":(_vm.datos.Titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "Titulo", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Tipo de trabajo")])]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:_vm.datos.Fotografia === 'Si' ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleTipo('Fotografia')}}},[_c('span',{staticClass:"fa fa-camera mr-2"}),_c('span',[_vm._v("Fotografía")])]),_c('button',{staticClass:"btn",class:_vm.datos.Video === 'Si' ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleTipo('Video')}}},[_c('span',{staticClass:"fa fa-video-camera mr-2"}),_c('span',[_vm._v("Vídeo")])])])])])]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Descripción")])]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.Descripcion),expression:"datos.Descripcion"}],staticClass:"form-control",attrs:{"placeholder":"Especifica con detalle que es lo que solicitas y para que lo necesitas","rows":"6"},domProps:{"value":(_vm.datos.Descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "Descripcion", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Fecha prevista de publicación (si se va a publicar)")])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm._f("moment")(_vm.datos.FechaPublicacion,'DD-MM-YYYY')}}),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('vc-date-picker',{attrs:{"popover":{placement: 'bottom', visibility: 'click'}},model:{value:(_vm.datos.FechaPublicacion),callback:function ($$v) {_vm.$set(_vm.datos, "FechaPublicacion", $$v)},expression:"datos.FechaPublicacion"}},[_c('button',{staticClass:"btn btn-primary"},[_c('span',{staticClass:"fa fa-calendar"})])])],1),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.datos.FechaPublicacion = null}}},[_c('span',{staticClass:"fa fa-trash"})])])])])])]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Destino de la publicación")])]),_c('br'),_c('div',{staticClass:"destinos"},_vm._l((_vm.destinos),function(destino){return _c('span',{key:destino.DestinoID,class:_vm.claseDestino(destino),on:{"click":function($event){return _vm.toggleDestino(destino.DestinoID)}}})}),0)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Fecha y hora del evento (en caso de que la haya)")])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm._f("moment")(_vm.datos.FechaEvento,'DD-MM-YYYY')}}),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('vc-date-picker',{attrs:{"popover":{placement: 'bottom', visibility: 'click'}},model:{value:(_vm.datos.FechaEvento),callback:function ($$v) {_vm.$set(_vm.datos, "FechaEvento", $$v)},expression:"datos.FechaEvento"}},[_c('button',{staticClass:"btn btn-primary"},[_c('span',{staticClass:"fa fa-calendar"})])])],1),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger"},[_c('span',{staticClass:"fa fa-trash",on:{"click":function($event){_vm.datos.FechaEvento = null}}})])])])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-clock-o"})])]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.datos.HoraEvento),expression:"datos.HoraEvento"}],staticClass:"form-control",attrs:{"disabled":!_vm.datos.FechaEvento},domProps:{"value":(_vm.datos.HoraEvento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "HoraEvento", $event.target.value)}}})])])])]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Lugar del evento")])]),_c('input-query-location',{attrs:{"placeholder":"Busca en google por nombre o dirección","inputClass":"form-control"},on:{"selected":function($event){return _vm.seleccionaUbicacion($event)}}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.datos.LatitudEvento && _vm.datos.LongitudEvento),expression:"datos.LatitudEvento && datos.LongitudEvento"}],attrs:{"id":"mapaEvento"}})])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_c('span',[_vm._v("Guardar")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.crear)?_c('Nueva',{on:{"cerrar":function($event){_vm.crear = null}}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainOverview_component_vue__ = __webpack_require__(635);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9d61d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mainOverview_component_vue__ = __webpack_require__(1489);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mainOverview_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9d61d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mainOverview_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendario_component_vue__ = __webpack_require__(636);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa002a70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendario_component_vue__ = __webpack_require__(1476);
function injectStyle (ssrContext) {
  __webpack_require__(1472)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa002a70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendario_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa002a70_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_calendario_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mes_component_vue__ = __webpack_require__(637);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a22a8430_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mes_component_vue__ = __webpack_require__(1475);
function injectStyle (ssrContext) {
  __webpack_require__(1474)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a22a8430"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mes_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a22a8430_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mes_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mes"},_vm._l((_vm.semanas),function(semana,s){return _c('div',{key:semana.numero,staticClass:"semana",style:({minHeight: _vm.altoCelda + 'px'})},[_c('div',{staticStyle:{"position":"absolute","display":"flex","left":"0","top":"0","right":"0","bottom":"0"}},_vm._l((semana.dias),function(dia,d){return _c('div',{key:dia.diaStr,staticClass:"dia",class:dia.dia.getMonth() !== _vm.fecha.getMonth() ? 'disabled' : dia.hoy ? 'hoy' : ''},[(s === 0)?[_c('div',{staticClass:"mb-0 text-center",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.dias[d]))])]:_vm._e(),_c('div',{staticClass:"m-0 text-center"},[_c('span',[_vm._v(_vm._s(dia.dia.getDate()))]),(dia.hoy)?_c('span',{staticClass:"ml-2",staticStyle:{"opacity":"0.7"}},[_vm._v("(hoy)")]):_vm._e()])],2)}),0),_c('div',{staticStyle:{"position":"absolute","display":"flex","left":"0","top":"0","right":"0","bottom":"0","margin-top":"30px","background-color":"rgba(0,0,0,0.1)"}},_vm._l((semana.dias),function(dia,d){return _c('div',{key:dia.diaStr + '-ev',staticClass:"diaEvento"})}),0)])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contenedorCalendario"},[_c('div',{staticClass:"controles"},[_c('div',{staticClass:"avance"},[_c('div',{staticClass:"btn-group mr-2"},[_c('button',{staticClass:"btn",on:{"click":_vm.anterior}},[_c('span',{staticClass:"fa fa-caret-left"})]),_c('button',{staticClass:"btn",on:{"click":_vm.siguiente}},[_c('span',{staticClass:"fa fa-caret-right"})])]),_c('button',{staticClass:"btn mr-2"},[_vm._v("Hoy")])]),_c('div',{staticClass:"fechaActual"},[_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.fecha,'MMMM, YYYY')))])]),_vm._m(0)]),_c('div',{staticClass:"calendario"},[_c('Mes',{attrs:{"fecha":_vm.fecha,"eventos":_vm.eventos}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modos"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn"},[_c('span',[_vm._v("Mes")])]),_c('button',{staticClass:"btn"},[_c('span',[_vm._v("Semana")])]),_c('button',{staticClass:"btn"},[_c('span',[_vm._v("Día")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_overview_component_vue__ = __webpack_require__(638);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad6308a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_overview_component_vue__ = __webpack_require__(1488);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_overview_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad6308a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_overview_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tareaDetalle_component_vue__ = __webpack_require__(639);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157e9226_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tareaDetalle_component_vue__ = __webpack_require__(1484);
function injectStyle (ssrContext) {
  __webpack_require__(1479)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-157e9226"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tareaDetalle_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157e9226_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tareaDetalle_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tareaRealizada_component_vue__ = __webpack_require__(640);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6601df86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tareaRealizada_component_vue__ = __webpack_require__(1481);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tareaRealizada_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6601df86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tareaRealizada_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":700}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_c('span',[_vm._v("Tarea realizada")]),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b',[_vm._v("¿En qué galería está el trabajo realizado?")])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-search"})])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cadena),expression:"cadena"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"buscar"},domProps:{"value":(_vm.cadena)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarGalerias($event)},"input":function($event){if($event.target.composing){ return; }_vm.cadena=$event.target.value}}})])])])]),(!_vm.seleccion)?_c('div',{staticClass:"card-body bg-light",staticStyle:{"border-top":"1px solid #e0e0e0"}},_vm._l((_vm.galerias),function(galeria,i){return _c('MiniGaleria',{key:galeria.GaleriaID,attrs:{"galeria":galeria},on:{"selecciona":function($event){return _vm.selecciona($event)}}})}),1):_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('MiniGaleria',{key:_vm.seleccion.GaleriaID,attrs:{"galeria":_vm.seleccion},on:{"selecciona":function($event){return _vm.selecciona($event)}}})],1),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Comentarios finales")])]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.ComentariosFinales),expression:"datos.ComentariosFinales"}],staticClass:"form-control",attrs:{"rows":"6","placeholder":"Escribe algún comentario si es necesario aclarar algo"},domProps:{"value":(_vm.datos.ComentariosFinales)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "ComentariosFinales", $event.target.value)}}})])])])]),(_vm.seleccion)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.confirmar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_c('span',[_vm._v("Confirmar")])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rechazarTarea_component_vue__ = __webpack_require__(641);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_712b39d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_rechazarTarea_component_vue__ = __webpack_require__(1483);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rechazarTarea_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_712b39d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_rechazarTarea_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":500}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_c('span',[_vm._v("Rechazar")]),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Motivos del rechazo")])]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.ComentariosFinales),expression:"datos.ComentariosFinales"}],staticClass:"form-control",attrs:{"rows":"6","placeholder":"Explica por qué motivo rechazas esta tarea"},domProps:{"value":(_vm.datos.ComentariosFinales)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "ComentariosFinales", $event.target.value)}}})])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.rechazar}},[_c('span',{staticClass:"fa fa-ban mr-2"}),_c('span',[_vm._v("Rechazar tarea")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tarea.TareaID)?_c('modal',{attrs:{"max-width":900}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-info mr-2"}),_c('span',[_vm._v(_vm._s(_vm.tarea.Titulo)+" - "),_c('i',[_vm._v(_vm._s(_vm.tarea.UsuarioNombre))])]),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light",staticStyle:{"border-bottom":"1px solid #e0e0e0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"},[_c('h2',[_c('span',{staticClass:"fa fa-edit mr-2"}),_c('span',[_vm._v(_vm._s(_vm.tarea.Titulo))])]),_c('div',[(_vm.tarea.Fotografia === 'Si')?_c('span',{staticClass:"text-danger",staticStyle:{"font-size":"1.5em","margin-right":"20px"}},[_c('span',{staticClass:"fa fa-camera mr-2"}),_c('span',[_vm._v("Fotografía")])]):_vm._e(),(_vm.tarea.Fotografia === 'Si')?_c('span',{staticClass:"text-danger",staticStyle:{"font-size":"1.5em","margin-right":"20px"}},[_c('span',{staticClass:"fa fa-video-camera mr-2"}),_c('span',[_vm._v("Vídeo")])]):_vm._e()])]),_c('div',{staticClass:"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right"},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row-reverse"}},[_c('avatar',{attrs:{"usuario":_vm.tarea.UsuarioID,"width":60}}),_c('div',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.tarea.UsuarioNombre))])]),_c('br'),_c('span',{staticStyle:{"font-size":"0.9em"}},[_vm._v(_vm._s(_vm._f("moment")(_vm.tarea.FechaCreacion,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.tarea.FechaCreacion,'HH:mm:ss')))]),_c('br'),_c('span',{staticStyle:{"font-size":"0.9em","opacity":"0.7"}},[_c('i',[_vm._v("(Creado por "+_vm._s(_vm.tarea.UsuarioCreadorNombre)+")")])])])],1)])])]),_c('div',{staticClass:"card-body",staticStyle:{"border-bottom":"1px solid #e0e0e0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-6"},[_c('h4',[_vm._v("¿Qué se pide?")]),_c('hr'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.Descripcion)}}),_c('h4',{staticClass:"mt-4"},[_vm._v("¿Cuando hay que hacerlo?")]),_c('hr'),(!_vm.tarea.FechaEvento)?_c('span',{staticClass:"text-danger"},[_c('span',{staticClass:"fa fa-ban mr-2"}),_c('span',[_vm._v("No se ha especificado fecha")])]):_c('span',[_c('span',{staticClass:"fa fa-calendar mr-2"}),_c('span',[_vm._v("El "+_vm._s(_vm._f("moment")(_vm.tarea.FechaEvento,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.tarea.FechaEvento,'HH:mm'))+" h.")])]),_c('h4',{staticClass:"mt-4"},[_vm._v("¿Para cuando se necesita?")]),_c('hr'),(!_vm.tarea.FechaPublicacion)?_c('span',{staticClass:"text-danger"},[_c('span',{staticClass:"fa fa-ban mr-2"}),_c('span',[_vm._v("No se ha especificado fecha")])]):_c('span',[_c('span',{staticClass:"fa fa-calendar mr-2"}),_c('span',[_vm._v("El "+_vm._s(_vm._f("moment")(_vm.tarea.FechaPublicacion,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.tarea.FechaPublicacion,'HH:mm'))+" h.")])]),_c('h4',{staticClass:"mt-4"},[_vm._v("¿Dónde va destinado?")]),_c('hr'),_vm._l((_vm.Destinos),function(destino){return _c('span',{key:destino.DestinoID,staticClass:"m-3",class:destino.Icono,staticStyle:{"font-size":"2em"},attrs:{"title":destino.Nombre}})})],2),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-6"},[_c('h4',[_vm._v("¿Dónde?")]),_c('hr'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tarea.LatitudEvento && _vm.tarea.LongitudEvento),expression:"tarea.LatitudEvento && tarea.LongitudEvento"}],attrs:{"id":"mapaEvento"}})])])]),(_vm.tarea.FechaRealizada)?_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-xl-6 col-lg-6"},[_c('h4',[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Trabajo finalizado por "+_vm._s(_vm.tarea.UsuarioRealizadorNombre)),_c('br'),_c('span',{staticStyle:{"font-size":"0.6em"}},[_vm._v("El "+_vm._s(_vm._f("moment")(_vm.tarea.FechaRealizada,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.tarea.FechaRealizada,'HH:mm'))+" h.")])]),(_vm.tarea.ComentariosFinales)?_c('p',[_c('span',{staticClass:"fa fa-quote-left mr-2"}),_c('span',[_vm._v(_vm._s(_vm.tarea.ComentariosFinales))])]):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 text-right"},[_c('MiniGaleria',{key:_vm.tarea.GaleriaID,attrs:{"GaleriaID":_vm.tarea.GaleriaID},on:{"selecciona":_vm.acceder}})],1)])]):_vm._e(),(_vm.tarea.FechaFinalizada)?_c('div',{staticClass:"card-body"},[_c('h4',[_c('span',{staticClass:"fa fa-thumbs-up mr-2"}),_vm._v("Trabajo publicado por "+_vm._s(_vm.tarea.UsuarioNombre)+" el "+_vm._s(_vm._f("moment")(_vm.tarea.FechaFinalizada,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.tarea.FechaFinalizada,'HH:mm')))])]):_vm._e(),_c('div',{staticClass:"card-footer"},[(_vm.puedeEditar)?_c('button',{staticClass:"m-2 btn btn-primary",on:{"click":_vm.editar}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_c('span',[_vm._v("Editar")])]):_vm._e(),(_vm.puedeEditar)?_c('button',{staticClass:"m-2 btn btn-danger",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_c('span',[_vm._v("Eliminar")])]):_vm._e(),(_vm.puedeRealizar)?_c('button',{staticClass:"m-2 btn btn-danger",on:{"click":function($event){_vm.rechazar = true}}},[_c('span',{staticClass:"fa fa-ban mr-2"}),_c('span',[_vm._v("Rechazar")])]):_vm._e(),(_vm.puedeRealizar)?_c('button',{staticClass:"m-2 btn btn-warning",on:{"click":function($event){_vm.realizar = true}}},[_c('span',{staticClass:"fa fa-check mr-2"}),_c('span',[_vm._v("Terminado")])]):_vm._e(),(_vm.puedePublicar)?_c('button',{staticClass:"m-2 btn btn-success",on:{"click":_vm.publicar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_c('span',[_vm._v("Publicado")])]):_vm._e()])]),(_vm.realizar)?_c('RealizarTarea',{attrs:{"TareaID":_vm.TareaID},on:{"cerrar":function($event){_vm.realizar = null},"finalizada":_vm.cerrar}}):_vm._e(),(_vm.rechazar)?_c('RechazarTarea',{attrs:{"TareaID":_vm.TareaID},on:{"rechazada":_vm.cerrar,"cerrar":function($event){_vm.rechazar = null}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tarea_component_vue__ = __webpack_require__(642);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082e57c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tarea_component_vue__ = __webpack_require__(1487);
function injectStyle (ssrContext) {
  __webpack_require__(1486)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-082e57c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tarea_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082e57c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tarea_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tarea",on:{"click":function($event){return _vm.$emit('ver')}}},[_c('div',{staticClass:"icono"},[(_vm.tarea.Fotografia == 'Si')?_c('span',{staticClass:"fa fa-camera"}):_vm._e(),(_vm.tarea.Video == 'Si')?_c('span',{staticClass:"fa fa-video-camera"}):_vm._e()]),_c('div',{staticClass:"contenido"},[_c('div',{staticClass:"titulo"},[_vm._v(_vm._s(_vm.tarea.Titulo))]),_c('div',{staticClass:"fechaCreacion"},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_c('span',[_vm._v("Creada el "+_vm._s(_vm._f("moment")(new Date(_vm.tarea.FechaCreacionUnix * 1000),'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(new Date(_vm.tarea.FechaCreacionUnix * 1000),'HH:mm')))])]),(_vm.tarea.FechaEvento)?_c('div',{staticClass:"fechaEvento"},[_c('span',{staticClass:"fa fa-calendar-plus-o mr-2"}),_c('span',[_vm._v("Evento el "+_vm._s(_vm._f("moment")(_vm.tarea.FechaEvento,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.tarea.FechaEvento,'HH:mm')))])]):_vm._e(),_c('div',{staticClass:"fechaPublicacion",class:!_vm.tarea.FechaPublicacion ? 'danger' : ''},[_c('span',{staticClass:"fa fa-calendar-times-o mr-2"}),(!_vm.tarea.FechaPublicacion)?_c('span',[_vm._v("Publicación sin definir")]):_c('span',[_vm._v("Publicación el "+_vm._s(_vm._f("moment")(_vm.tarea.FechaPublicacion,'DD-MM-YYYY')))])]),_c('div',{staticClass:"destinos"},_vm._l((_vm.tarea.Destinos),function(destino){return _c('span',{key:destino.DestinoID,class:destino.Icono})}),0)]),_c('div',{staticClass:"avatar"},[_c('avatar',{attrs:{"usuario":_vm.tarea.UsuarioID}}),_c('div',{staticClass:"nombre"},[_vm._v(_vm._s(_vm.tarea.UsuarioNombre))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('div',{staticClass:"row"},[_vm._m(0),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",staticStyle:{"position":"absolute","display":"block","right":"10px","top":"-2px"},on:{"click":_vm.setNueva}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_c('span',[_vm._v("Nueva")])])])])]),_vm._l((_vm.tareasPendientes),function(tarea){return _c('Tarea',{key:tarea.TareaID,attrs:{"tarea":tarea},on:{"ver":function($event){return _vm.verTarea(tarea)}}})})],2)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._l((_vm.tareasRealizadas),function(tarea){return _c('Tarea',{key:tarea.TareaID,attrs:{"tarea":tarea},on:{"ver":function($event){return _vm.verTarea(tarea)}}})})],2)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._l((_vm.tareasFinalizadas),function(tarea){return _c('Tarea',{key:tarea.TareaID,attrs:{"tarea":tarea},on:{"ver":function($event){return _vm.verTarea(tarea)}}})})],2)])]),(_vm.EditarID)?_c('Editor',{attrs:{"TareaID":_vm.EditarID},on:{"actualizar":function($event){return _vm.buscar()},"cerrar":function($event){_vm.EditarID = null}}}):_vm._e(),(_vm.TareaID)?_c('TareaDetalle',{attrs:{"TareaID":_vm.TareaID},on:{"cerrar":function($event){return _vm.$router.push('/main/produccion-audiovisual')},"actualizar":function($event){return _vm.buscar()},"editar":function($event){_vm.EditarID = $event}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('span',{staticClass:"fa fa-tasks mr-2"}),_c('span',[_vm._v("Pendientes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-danger text-white"},[_c('span',{staticClass:"fa fa-check-square mr-2"}),_c('span',[_vm._v("Realizados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-success text-white"},[_c('span',{staticClass:"fa fa-flag-checkered mr-2"}),_c('span',[_vm._v("Publicado")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Overview')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listado_listado__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_radiacion_radiacion__ = __webpack_require__(1497);





/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('radiacion', {
			name: 'Radiación',
			component: __WEBPACK_IMPORTED_MODULE_1__Main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('radiacion').child('listado', {
			name: 'Listado radiaciones',
			component: __WEBPACK_IMPORTED_MODULE_2__components_listado_listado__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('radiacion').child(':id', {
			name: 'Editor de radiaciones',
			component: __WEBPACK_IMPORTED_MODULE_3__components_radiacion_radiacion__["a" /* default */]
		});
	}
});

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dddafa0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1492);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dddafa0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__ = __webpack_require__(643);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4191e3b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__ = __webpack_require__(1496);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4191e3b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__ = __webpack_require__(644);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e92870_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__ = __webpack_require__(1495);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e92870_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[(_vm.resultados.length > 0)?_c('table',{staticClass:"table table-striped"},[_vm._m(0)]):_c('div',{staticClass:"alert alert-warning text-center"},[_c('h1',[_vm._v("No hay resultados")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Agente")]),_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Contrato")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.agente),expression:"filtro.agente"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.agente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "agente", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_vm._m(2),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cliente),expression:"filtro.cliente"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.cliente)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cliente", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.contrato),expression:"filtro.contrato"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.contrato)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "contrato", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3"})])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"m-1 btn btn-sm btn-primary",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"m-1 btn btn-sm btn-dark",on:{"click":_vm.nueva}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Nueva radiación")])])]),_c('Resultados',{attrs:{"resultados":_vm.resultados}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-light"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Búsqueda")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Agente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Cliente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Título del contrato")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiacion_vue__ = __webpack_require__(645);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121699a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_radiacion_vue__ = __webpack_require__(1530);
function injectStyle (ssrContext) {
  __webpack_require__(1498)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-121699a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_radiacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121699a2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_radiacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__ = __webpack_require__(646);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194c1240_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__ = __webpack_require__(1501);
function injectStyle (ssrContext) {
  __webpack_require__(1500)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-194c1240"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194c1240_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caja-herramientas"},[_c('div',{class:(_vm.opciones.activoColocacion) ? '' : 'disabled',on:{"click":function($event){return _vm.accion('colocacion')}}},[_c('span',{staticClass:"fa fa-puzzle-piece"}),_c('div',{staticClass:"textoMenu"},[_vm._v("Colocación")])]),_c('div',{class:(_vm.opciones.activoInsertar) ? '' : 'disabled',on:{"click":function($event){return _vm.accion('insertarOriginales')}}},[_c('span',{staticClass:"fa fa-plus-square"}),_c('div',{staticClass:"textoMenu"},[_vm._v("Insertar Originales")])]),_c('div',{class:(_vm.opciones.activoRotacionV) ? '' : 'disabled',on:{"click":function($event){return _vm.accion('rotacionVertical')}}},[_c('span',{staticClass:"fa fa-arrows-v"}),_c('div',{staticClass:"textoMenu"},[_vm._v("Rotación vertical")])]),_c('div',{class:(_vm.opciones.activoRotacionH) ? '' : 'disabled',on:{"click":function($event){return _vm.accion('copiarInserciones')}}},[_c('span',{staticClass:"fa fa-copy"}),_c('div',{staticClass:"textoMenu"},[_vm._v("Copiar a otro original")])]),_c('div',{class:(_vm.opciones.activoAnulaIns) ? '' : 'disabled',on:{"click":function($event){return _vm.accion('eliminarInserciones')}}},[_c('span',{staticClass:"fa fa-calendar-times-o"}),_c('div',{staticClass:"textoMenu"},[_vm._v("Anular inserciones")])]),_c('div',{class:(_vm.opciones.activoRecuperaIns) ? '' : 'disabled',on:{"click":function($event){return _vm.accion('recuperarInserciones')}}},[_c('span',{staticClass:"fa fa-calendar-plus-o"}),_c('div',{staticClass:"textoMenu"},[_vm._v("Recuperar inserciones")])]),_c('div',{class:(_vm.opciones.activoModVarias) ? '' : 'disabled'},[_c('span',{staticClass:"fa fa-gears"}),_c('div',{staticClass:"textoMenu"},[_vm._v("Modificar varias")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programa_vue__ = __webpack_require__(648);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f10af8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_programa_vue__ = __webpack_require__(1503);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programa_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f10af8e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_programa_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-striped m-0"},[_vm._m(0),_c('tbody',_vm._l((_vm.listadoProgramas),function(programa){return _c('tr',{class:_vm.colocacion.ProgramaID === programa.ProgramaID ? 'bg-danger text-white' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.seleccionaPrograma(programa)}}},[_c('td',[_vm._v(_vm._s(programa.Nombre))])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Programa")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenido_vue__ = __webpack_require__(649);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_325e909f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenido_vue__ = __webpack_require__(1505);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contenido_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_325e909f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contenido_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-striped m-0"},[_vm._m(0),_c('tbody',_vm._l((_vm.listadoContenidos),function(contenido){return _c('tr',{class:_vm.colocacion.ContenidoID === contenido.ContenidoID ? 'bg-danger text-white' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.seleccionaPrograma(contenido)}}},[_c('td',[_vm._v("("+_vm._s(contenido.HoraInicio)+" - "+_vm._s(contenido.HoraFin)+") "+_vm._s(contenido.Nombre))])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Contenidos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manual_vue__ = __webpack_require__(650);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e0f25e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_manual_vue__ = __webpack_require__(1507);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_manual_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e0f25e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_manual_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('b',[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Intérvalo manual"),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hora de inicio")]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"},{name:"model",rawName:"v-model",value:(_vm.colocacion.HoraInicio),expression:"colocacion.HoraInicio"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"HH:MM:SS"},domProps:{"value":(_vm.colocacion.HoraInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.colocacion, "HoraInicio", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hora de fin")]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##:##'),expression:"'##:##:##'"},{name:"model",rawName:"v-model",value:(_vm.colocacion.HoraFin),expression:"colocacion.HoraFin"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"HH:MM:SS"},domProps:{"value":(_vm.colocacion.HoraFin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.colocacion, "HoraFin", $event.target.value)}}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.EmisoraID)?_c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-puzzle-piece mr-2"}),_vm._v("Colocación"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light text-center"},[_c('div',{staticClass:"alert alert-success text-left"},[_c('b',[_c('span',{staticClass:"fa fa-puzzle-piece mr-2"}),_vm._v("Tipo de colocación")]),_c('p',[_vm._v("Debes definir el tipo de colocación que vas a emplear:"),_c('ul',[_c('li',[_c('b',[_vm._v("Por programa:")]),_vm._v(" Los originales siempre se colocarán dentro del programa seleccionado")]),_c('li',[_c('b',[_vm._v("Por contenido:")]),_vm._v(" Los originales siempre se colocación dentro de los contenidos seleccionados")]),_c('li',[_c('b',[_vm._v("Manual:")]),_vm._v(" Debes definir un intérvalo de días de la semana y horas para colocar los originales")])])])]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tipo de colocación")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.tipoColocacion === 'Programa') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoColocacion('Programa')}}},[_vm._v("Programa")]),_c('button',{staticClass:"btn",class:(_vm.tipoColocacion === 'Contenido') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoColocacion('Contenido')}}},[_vm._v("Contenido")]),_c('button',{staticClass:"btn",class:(_vm.tipoColocacion === 'Manual') ? 'btn-primary' : '',on:{"click":function($event){return _vm.setTipoColocacion('Manual')}}},[_vm._v("Manual")])])])]),(_vm.tipoColocacion === 'Programa')?_c('SeleccionPrograma',{attrs:{"EmisoraID":_vm.EmisoraID,"colocacion":_vm.colocacion},on:{"update:colocacion":function($event){_vm.colocacion=$event}}}):_vm._e(),(_vm.tipoColocacion === 'Contenido')?_c('SeleccionContenido',{attrs:{"EmisoraID":_vm.EmisoraID,"colocacion":_vm.colocacion},on:{"update:colocacion":function($event){_vm.colocacion=$event}}}):_vm._e(),(_vm.tipoColocacion === 'Manual')?_c('ColocacionManual',{attrs:{"colocacion":_vm.colocacion},on:{"update:colocacion":function($event){_vm.colocacion=$event}}}):_vm._e(),_c('div',{staticClass:"card-body bg-light"},[_c('span',{staticClass:"fa fa-list mr-2"}),_c('b',[_vm._v("Fijación")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.colocacion.Fijar),expression:"colocacion.Fijar"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.colocacion, "Fijar", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Aleatorio")]),_vm._l((_vm.fijaciones),function(tipo){return _c('option',{domProps:{"value":tipo}},[_vm._v(_vm._s(tipo))])})],2)]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.confirmar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Confirmar")])])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insertar_originales_vue__ = __webpack_require__(651);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd13f822_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_insertar_originales_vue__ = __webpack_require__(1513);
function injectStyle (ssrContext) {
  __webpack_require__(1510)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd13f822"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insertar_originales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd13f822_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_insertar_originales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_calendario_vue__ = __webpack_require__(652);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c91584_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_calendario_vue__ = __webpack_require__(1512);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_calendario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c91584_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_modal_calendario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('CalendarioAnual',{attrs:{"seleccion":_vm.linea.dias,"from":_vm.contrato.FechaInicio,"to":_vm.contrato.FechaFin},on:{"update:seleccion":function($event){return _vm.$set(_vm.linea, "dias", $event)}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":1600}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info"},[_c('span',{staticClass:"fa fa-plus-square mr-2"}),_vm._v("Insertar originales"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"contenedor"},[_c('div',{staticClass:"barraLateral"},[_c('div',[_c('h5',[_c('span',{staticClass:"fa fa-user mr-2"}),_c('b',[_vm._v(_vm._s(_vm.contrato.ClienteNombre))])]),_c('hr'),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Fecha creación")])]),_c('div',{staticClass:"input-group input-group-sm"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Desde")])]),_c('datepicker',{attrs:{"monday-first":true,"inputClass":"form-control form-control-sm"},model:{value:(_vm.filtro.FechaDesde),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaDesde", $$v)},expression:"filtro.FechaDesde"}})],1),_c('div',{staticClass:"input-group input-group-sm mt-2"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Hasta")])]),_c('datepicker',{attrs:{"monday-first":true,"inputClass":"form-control form-control-sm"},model:{value:(_vm.filtro.FechaHasta),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaHasta", $$v)},expression:"filtro.FechaHasta"}})],1)]),_c('hr'),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Filtro")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Cadena),expression:"filtro.Cadena"}],staticClass:"form-control form-control-sm",attrs:{"placeholder":"ID fichero o nombre"},domProps:{"value":(_vm.filtro.Cadena)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Cadena", $event.target.value)}}})]),_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.buscarOriginales}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])]),_c('div',{staticClass:"mt-2 mb-0 p-2 bg-dark text-white"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Originales")]),_c('div',{staticClass:"contieneFicheros"},[_c('table',{staticClass:"tablaOriginales"},[_c('tbody',_vm._l((_vm.listadoFicheros),function(original){return _c('tr',{key:original.FicheroID},[_c('td',{staticClass:"p-1"},[_vm._v(_vm._s(original.FicheroID)+" - "+_vm._s(original.Nombre))]),_c('td',{staticClass:"p-1 text-right",staticStyle:{"width":"30px"}},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.agregarOriginal(original)}}},[_c('span',{staticClass:"fa fa-caret-right"})])])])}),0)])])]),_c('div',{staticClass:"contenidoCentral"},[_c('ul',{staticClass:"barraOpciones"},[_c('li',{class:!_vm.originalSeleccionado ? 'disabled' : '',attrs:{"title":"Seleccionar días de inserción"},on:{"click":function($event){return _vm.setFechas()}}},[_c('span',{staticClass:"fa fa-calendar"})]),_c('li',{class:!_vm.originalSeleccionado ? 'disabled' : '',attrs:{"title":"Particularizar parámetros de colocación"},on:{"click":function($event){return _vm.setColocacion()}}},[_c('span',{staticClass:"fa fa-cubes"})])]),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped m-0",staticStyle:{"width":"100%"}},[_c('thead',[_c('tr',{staticClass:"bg-dark text-white"},[_c('th',[_vm._v("Días")]),_c('th',[_vm._v("Ref ext.")]),_c('th',[_vm._v("FicheroID")]),_c('th',[_vm._v("Descripcion")]),_c('th',[_vm._v("Ins")]),_c('th',[_vm._v("Precio")]),_c('th',[_vm._v("Recargo")]),_c('th',[_vm._v("Dto (%)")]),_c('th',[_vm._v("Contenido")]),_c('th',[_vm._v("Programa")]),_c('th',[_vm._v("H. Inicio")]),_c('th',[_vm._v("H. Fin")]),_c('th',[_vm._v("Posición")]),_c('th',[_vm._v("Fijar")]),_c('th',[_vm._v("Precio final")])])]),_c('tbody',_vm._l((_vm.linea.originales),function(original){return _c('tr',{key:original.OriginalID,staticClass:"filaOriginal",class:_vm.originalSeleccionado === original ? 'bg-warning' : '',on:{"click":function($event){_vm.originalSeleccionado = original},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){ return null; }return _vm.eliminarOriginal(original)}}},[_c('td',[_vm._v(_vm._s(original.dias.length))]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(original.RefExterna),expression:"original.RefExterna"}],staticClass:"inline",domProps:{"value":(original.RefExterna)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(original, "RefExterna", $event.target.value)}}})]),_c('td',[_vm._v(_vm._s(original.FicheroID))]),_c('td',{staticStyle:{"max-width":"150px"}},[_c('div',{staticClass:"descripcion"},[_vm._v(_vm._s(original.Descripcion))])]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(original.Inserciones),expression:"original.Inserciones",modifiers:{"number":true}}],staticClass:"inline",attrs:{"size":"2"},domProps:{"value":(original.Inserciones)},on:{"focus":function($event){return _vm.seleccionarTodo($event)},"keyup":_vm.calculaImportes,"input":function($event){if($event.target.composing){ return; }_vm.$set(original, "Inserciones", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(original.Importe),expression:"original.Importe",modifiers:{"number":true}}],staticClass:"inline",attrs:{"size":"6"},domProps:{"value":(original.Importe)},on:{"focus":function($event){return _vm.seleccionarTodo($event)},"keyup":_vm.calculaImportes,"input":function($event){if($event.target.composing){ return; }_vm.$set(original, "Importe", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(original.Recargo),expression:"original.Recargo",modifiers:{"number":true}}],staticClass:"inline",attrs:{"size":"6"},domProps:{"value":(original.Recargo)},on:{"focus":function($event){return _vm.seleccionarTodo($event)},"keyup":_vm.calculaImportes,"input":function($event){if($event.target.composing){ return; }_vm.$set(original, "Recargo", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(original.Descuento),expression:"original.Descuento",modifiers:{"number":true}}],staticClass:"inline",attrs:{"size":"6"},domProps:{"value":(original.Descuento)},on:{"focus":function($event){return _vm.seleccionarTodo($event)},"keyup":_vm.calculaImportes,"input":function($event){if($event.target.composing){ return; }_vm.$set(original, "Descuento", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',[_vm._v(_vm._s(original.ContenidoNombre))]),_c('td',[_vm._v(_vm._s(original.ProgramaNombre))]),_c('td',[_vm._v(_vm._s(original.HoraInicio))]),_c('td',[_vm._v(_vm._s(original.HoraFin))]),_c('td',[_vm._v(_vm._s(original.Posicion))]),_c('td',[_vm._v(_vm._s(original.Fijar))]),_c('td',{staticClass:"bg-danger text-white"},[_vm._v(_vm._s(_vm._f("currency")(original.ImporteFinal,''))+" €")])])}),0)])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.insertar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])]),(_vm.definirFechas)?_c('ModalCalendario',{attrs:{"linea":_vm.definirFechas,"contrato":_vm.contrato},on:{"update:linea":function($event){_vm.definirFechas=$event},"cerrar":function($event){_vm.definirFechas = null}}}):_vm._e(),(_vm.colocando)?_c('Colocacion',{attrs:{"EmisoraID":_vm.linea.EmisoraID,"datos":_vm.originalSeleccionado},on:{"colocacion":function($event){return _vm.colocar($event)},"cerrar":function($event){_vm.colocando = null}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eliminar_inserciones_vue__ = __webpack_require__(653);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd3d896_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_eliminar_inserciones_vue__ = __webpack_require__(1515);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eliminar_inserciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd3d896_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_eliminar_inserciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar inserciones"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('CalendarioAnual',{attrs:{"seleccion":_vm.dias,"from":_vm.contrato.FechaInicio,"to":_vm.contrato.FechaFin,"resaltados":_vm.resaltados},on:{"update:seleccion":function($event){_vm.dias=$event}}})],1),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":_vm.eliminar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")]),_c('button',{staticClass:"btn btn-warning btn-sm ml-2",on:{"click":_vm.anular}},[_c('span',{staticClass:"fa fa-ban mr-2"}),_vm._v("Anular")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recuperar_inserciones_vue__ = __webpack_require__(654);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7abcf4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_recuperar_inserciones_vue__ = __webpack_require__(1517);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recuperar_inserciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7abcf4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_recuperar_inserciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Recuperar inserciones"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('CalendarioAnual',{attrs:{"seleccion":_vm.dias,"from":_vm.contrato.FechaInicio,"to":_vm.contrato.FechaFin,"resaltados":_vm.resaltados},on:{"update:seleccion":function($event){_vm.dias=$event}}})],1),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.recuperar}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Recuperar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_dia_vue__ = __webpack_require__(655);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c521cb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_dia_vue__ = __webpack_require__(1524);
function injectStyle (ssrContext) {
  __webpack_require__(1519)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04c521cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detalles_dia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04c521cb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_detalles_dia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":800}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Selección de originales"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"contenedor"},[_c('div',{staticClass:"formulario"},[_c('div',{staticStyle:{"margin":"10px"}},[_c('b',[_vm._v("Fecha de vigencia")]),_c('vc-date-picker',{attrs:{"is-expanded":"is-expanded","rows":2,"columns":2,"mode":"range","input-props":{
							class: "form-control",
							readonly: true
						}},model:{value:(_vm.filtro.fechas),callback:function ($$v) {_vm.$set(_vm.filtro, "fechas", $$v)},expression:"filtro.fechas"}}),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_c('b',[_vm._v("Cliente")])]),(!_vm.filtro.ClienteID)?_c('input-query',{attrs:{"placeholder":"Busca cliente","realtime":true,"input-class":"form-control form-control-sm","url":"mis-contratos/php/api/buscaCliente.php"},on:{"selected":function($event){return _vm.setCliente($event)}}}):_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":true},domProps:{"value":_vm.ClienteNombre}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.delCliente}},[_c('span',{staticClass:"fa fa-trash"})])])])],1),_c('div',{staticClass:"form-group mt-2"},[_c('label',[_c('b',[_vm._v("Título de campaña o fichero")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Titulo),expression:"filtro.Titulo"}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.Titulo)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getFicheros()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Titulo", $event.target.value)}}})])],1),_c('button',{staticClass:"btn-block btn-primary",on:{"click":_vm.getFicheros}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")])]),_c('div',{staticClass:"listado"},[_c('div',{staticClass:"bg-dark text-white p-1 pl-3"},[_c('span',{staticClass:"fa fa-list mr-2"}),_c('b',[_vm._v("Resultados")])]),_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.ficheros),function(fichero){return _c('tr',{key:fichero.FicheroID,class:_vm.seleccionado.indexOf(fichero) >= 0 ? 'bg-warning' : '',on:{"click":function($event){return _vm.toggle(fichero)}}},[_c('td',{staticClass:"pl-3"},[_c('div',{staticClass:"nombreFichero"},[_c('span',[_vm._v(_vm._s(fichero.FicheroID)+" - "+_vm._s(fichero.Nombre))])])]),_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"ml-2",staticStyle:{"opacity":"0.4"}},[_vm._v(_vm._s(_vm._f("round")(fichero.FicheroDuracion))+" s.")])])])}),0)])])]),_c('div',{staticClass:"card-footer text-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",attrs:{"disabled":!_vm.seleccionado},on:{"click":_vm.seleccionar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Seleccionar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resumen_bloques_component_vue__ = __webpack_require__(657);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f83678_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resumen_bloques_component_vue__ = __webpack_require__(1523);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resumen_bloques_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f83678_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resumen_bloques_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":800}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Bloques seleccionados"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("ID bloque")]),_c('th',[_vm._v("Hora")]),_c('th',[_vm._v("Inserciones")]),_c('th',[_vm._v("Inserciones tot")]),_c('th',[_vm._v("Ocupación bloque")]),_c('th',[_vm._v("Restante bloque")])])]),_c('tbody',_vm._l((_vm.bloquesUsados),function(bloque,i){return _c('tr',{key:i},[_c('th',[_vm._v(_vm._s(bloque.BloqueID))]),_c('th',[_vm._v(_vm._s(bloque.HoraInicio))]),_c('th',[_vm._v(_vm._s(bloque.Inserciones))]),_c('th',[_vm._v(_vm._s(_vm.getInsercionesTotales(bloque)))]),_c('th',[_vm._v(_vm._s(_vm.getOcupacion(bloque).porcentaje)+" %")]),_c('th',[_vm._v(_vm._s(_vm.getOcupacion(bloque).segundos)+" s")])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":1200}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info"},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v("Inserciones"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"contenedor"},[_c('div',{staticClass:"listadoInserciones"},[_c('table',{staticClass:"table table-hover m-0 bordes"},[_c('thead',[_c('tr',{staticClass:"bg-dark text-white"},[_c('th',{staticClass:"text-right p-1"},[_vm._v("ID")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Ref. Externa")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Descripción")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Ins")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Importe")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Dto")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Recargo")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Programa")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Contenido")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("H. inicio")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("H. fin")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Fijar")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Importe final")]),_c('th',{staticClass:"text-center p-1"},[_c('span',{staticClass:"fa fa-eye"})])])]),_c('tbody',_vm._l((_vm.inserciones),function(insercion,i){return _c('tr',{key:insercion.InsercionID,class:_vm.insercionSeleccionada === insercion.InsercionID ? 'bg-warning' : '',on:{"click":function($event){return _vm.seleccionarInsercion(insercion.InsercionID)}}},[_c('td',{staticClass:"p-1 text-center",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.seleccionarOriginal(insercion)}}},[(!/^I/.test(insercion.InsercionID))?_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(insercion.InsercionID))]):_vm._e(),_c('span',{staticClass:"fa fa-search text-danger",attrs:{"title":"Asociar original"}})]),_c('td',{staticClass:"p-1 text-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inserciones[i].RefExterna),expression:"inserciones[i].RefExterna"}],staticClass:"inline",domProps:{"value":(_vm.inserciones[i].RefExterna)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "RefExterna", $event.target.value)}}})]),_c('td',{staticClass:"p-1 text-right",staticStyle:{"max-width":"150px"},attrs:{"title":insercion.FicheroID + ' - ' + insercion.Descripcion}},[_c('div',{staticClass:"titulo"},[_vm._v(_vm._s(insercion.FicheroID)+" - "+_vm._s(insercion.Descripcion))])]),_c('td',{staticClass:"p-1 text-right"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.inserciones[i].Inserciones),expression:"inserciones[i].Inserciones",modifiers:{"number":true}}],staticClass:"inline",attrs:{"size":"2"},domProps:{"value":(_vm.inserciones[i].Inserciones)},on:{"focus":function($event){return _vm.seleccionarTodo($event)},"keyup":_vm.calculaImportes,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "Inserciones", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-1 text-right"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.inserciones[i].Importe),expression:"inserciones[i].Importe",modifiers:{"number":true}}],staticClass:"inline",attrs:{"size":"2"},domProps:{"value":(_vm.inserciones[i].Importe)},on:{"focus":function($event){return _vm.seleccionarTodo($event)},"keyup":_vm.calculaImportes,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "Importe", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-1 text-right"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.inserciones[i].Descuento),expression:"inserciones[i].Descuento",modifiers:{"number":true}}],staticClass:"inline",attrs:{"size":"2"},domProps:{"value":(_vm.inserciones[i].Descuento)},on:{"focus":function($event){return _vm.seleccionarTodo($event)},"keyup":_vm.calculaImportes,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "Descuento", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-1 text-right"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.inserciones[i].Recargo),expression:"inserciones[i].Recargo",modifiers:{"number":true}}],staticClass:"inline",attrs:{"size":"2"},domProps:{"value":(_vm.inserciones[i].Recargo)},on:{"focus":function($event){return _vm.seleccionarTodo($event)},"keyup":_vm.calculaImportes,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "Recargo", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"p-1 text-right"},[_vm._v(_vm._s(insercion.ProgramaNombre))]),_c('td',{staticClass:"p-1 text-right"},[_vm._v(_vm._s(insercion.ContenidoNombre))]),_c('td',{staticClass:"p-1 text-right"},[_vm._v(_vm._s(insercion.HoraInicio))]),_c('td',{staticClass:"p-1 text-right"},[_vm._v(_vm._s(insercion.HoraFin))]),_c('td',{staticClass:"p-1 text-right"},[_vm._v(_vm._s(insercion.Fijar))]),_c('td',{staticClass:"p-1 text-right bg-danger text-white"},[_vm._v(_vm._s(_vm._f("currency")(insercion.ImporteFinal,''))+" €")]),_c('td',{staticClass:"p-1 text-center",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.resumen = insercion}}},[_c('span',{staticClass:"fa fa-eye"})])])}),0)])]),_c('div',{staticClass:"menu"},[_c('div',{staticClass:"icono",on:{"click":_vm.nuevaInsercion}},[_c('span',{staticClass:"fa fa-plus"})]),_c('div',{staticClass:"icono",class:!_vm.insercionSeleccionada ? 'disabled' : '',on:{"click":_vm.eliminarRadiacion}},[_c('span',{staticClass:"fa fa-trash"})]),_c('div',{staticClass:"icono",class:!_vm.insercionSeleccionada ? 'disabled' : '',on:{"click":_vm.colocar}},[_c('span',{staticClass:"fa fa-cubes"})])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])]),(_vm.insercionSeleccionada && _vm.colocando)?_c('Colocacion',{attrs:{"EmisoraID":_vm.linea.EmisoraID},on:{"cerrar":function($event){_vm.colocando = false},"colocacion":function($event){return _vm.setColocacion($event)}}}):_vm._e(),(_vm.seleccionOriginal)?_c('ModalSeleccionOriginal',{attrs:{"solo":true,"ClienteID":_vm.contrato.ClienteID},on:{"cerrar":function($event){_vm.seleccionOriginal = null},"seleccionar":function($event){return _vm.onSeleccionarOriginal($event)}}}):_vm._e(),(_vm.resumen)?_c('ResumenBloques',{attrs:{"insercion":_vm.resumen,"bloques":_vm.bloques},on:{"cerrar":function($event){_vm.resumen = null}}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_copiar_inserciones_vue__ = __webpack_require__(658);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b547d3ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_copiar_inserciones_vue__ = __webpack_require__(1526);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_copiar_inserciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b547d3ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_copiar_inserciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info"},[_c('span',{staticClass:"fa fa-copy mr-2"}),_vm._v("Copiar inserciones"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('b',[_vm._v("Ficheros")]),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group input-group-sm mb-2"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Origen")])]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Origen),expression:"filtro.Origen"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "Origen", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.listadoFicheros),function(fichero){return _c('option',{key:fichero.FicheroID,domProps:{"value":fichero.FicheroID}},[_vm._v(_vm._s(fichero.FicheroID)+" - "+_vm._s(fichero.Descripcion))])}),0)]),_c('b',[_vm._v("Fechas")]),_c('div',{staticClass:"input-group input-group-sm"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Desde")])]),_c('datepicker',{attrs:{"monday-first":true,"input-class":"form-control form-control-sm"},model:{value:(_vm.filtro.FechaInicio),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaInicio", $$v)},expression:"filtro.FechaInicio"}}),_c('div',{staticClass:"input-group-prepend input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Hasta")])]),_c('datepicker',{attrs:{"monday-first":true,"input-class":"form-control form-control-sm"},model:{value:(_vm.filtro.FechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaFin", $$v)},expression:"filtro.FechaFin"}})],1)]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Destinos")])]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Destinos),expression:"filtro.Destinos"}],staticClass:"form-control form-control-sm",attrs:{"multiple":true},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtro, "Destinos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.cambiaDestinos($event)}]}},_vm._l((_vm.listadoFicheros),function(fichero){return _c('option',{key:fichero.FicheroID,domProps:{"value":fichero.FicheroID}},[_vm._v(_vm._s(fichero.FicheroID)+" - "+_vm._s(fichero.Descripcion))])}),0),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.agregarDestino}},[_c('span',{staticClass:"fa fa-plus"})])])])])]),_c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col"},[_c('b',[_vm._v("Acción")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm",class:_vm.filtro.Accion === 'copiar' ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.Accion = 'copiar'}}},[_vm._v("Copiar")]),_c('button',{staticClass:"btn btn-sm",class:_vm.filtro.Accion === 'mover' ? 'btn-primary' : '',on:{"click":function($event){_vm.filtro.Accion = 'mover'}}},[_vm._v("Mover")])])]),(_vm.filtro.Destinos.length > 1)?_c('div',{staticClass:"col"},[_c('b',[_vm._v("Define los porcentajes de reparto (deben sumar 100)")]),_vm._l((_vm.filtro.DestinosAsignados),function(destino){return _c('div',{key:destino.FicheroID,staticClass:"row mt-2"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('div',{staticStyle:{"font-size":"0.9em","max-width":"170px","text-overflow":"ellipsis","white-space":"nowrap","overflow":"hidden"}},[_vm._v(_vm._s(destino.FicheroID)+" - "+_vm._s(_vm.nombreFichero(destino.FicheroID)))])])]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(destino.Porcentaje),expression:"destino.Porcentaje",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",staticStyle:{"text-align":"right"},attrs:{"size":"2"},domProps:{"value":(destino.Porcentaje)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(destino, "Porcentaje", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}}),_c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_vm._v("%")])])])])])})],2):_vm._e()])]),_c('div',{staticClass:"card-body bg-light"},[_c('b',[_vm._v("Personalizar importes")]),_c('div',{staticClass:"mt-2"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.ModificarImportes),expression:"filtro.ModificarImportes"}],staticClass:"mr-2",attrs:{"type":"checkbox","id":"modificarImportes"},domProps:{"checked":Array.isArray(_vm.filtro.ModificarImportes)?_vm._i(_vm.filtro.ModificarImportes,null)>-1:(_vm.filtro.ModificarImportes)},on:{"change":function($event){var $$a=_vm.filtro.ModificarImportes,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.filtro, "ModificarImportes", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.filtro, "ModificarImportes", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.filtro, "ModificarImportes", $$c)}}}}),_c('label',[_vm._v("Personalizar importes")])])]),(_vm.filtro.ModificarImportes)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col p-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Precio")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filtro.Importe),expression:"filtro.Importe",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.Importe)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Importe", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_c('div',{staticClass:"col p-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descuento")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filtro.Descuento),expression:"filtro.Descuento",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.Descuento)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Descuento", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_c('div',{staticClass:"col p-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Recargo")]),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.filtro.Recargo),expression:"filtro.Recargo",modifiers:{"number":true}}],staticClass:"form-control form-control-sm",domProps:{"value":(_vm.filtro.Recargo)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Recargo", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})])]),_c('div',{staticClass:"col p-1"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Final")]),_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"true"},domProps:{"value":_vm.filtro.ImporteFinal}})])])]):_vm._e()]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])]),(_vm.nuevoDestino)?_c('ModalOriginal',{attrs:{"ClienteID":_vm.contrato.ClienteID},on:{"seleccionar":function($event){return _vm.setNuevoDestino($event)},"cerrar":function($event){_vm.nuevoDestino = null}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rotacion_vertical_vue__ = __webpack_require__(659);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8693af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_rotacion_vertical_vue__ = __webpack_require__(1529);
function injectStyle (ssrContext) {
  __webpack_require__(1528)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c8693af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rotacion_vertical_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c8693af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_rotacion_vertical_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":1600}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info"},[_c('span',{staticClass:"fa fa-table mr-2"}),_vm._v("Rotación vertical"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Acción")])]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.Accion),expression:"Accion"}],staticClass:"form-control form-control-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.Accion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"reemplazar"}},[_vm._v("Reemplazar inserciones")]),_c('option',{attrs:{"value":"agregar"}},[_vm._v("Agregar inserciones")])])])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group input-group-sm"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Fechas")])]),_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":true},domProps:{"value":_vm.dias.length + ' dias seleccionados'}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.verSeleccionarFechas = true}}},[_c('span',{staticClass:"fa fa-calendar"})])])])]),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.verSeleccionFicheros = true}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Agregar ficheros")])])])]),_c('table',{staticClass:"table table-striped m-0"},[_c('thead',[_c('tr',[_c('th',{staticClass:"p-1 bg-dark text-white"},[_c('span',{staticClass:"fa fa-table mr-2"}),_vm._v("Ficheros")])])]),_c('tbody',_vm._l((_vm.listadoFicheros),function(fichero){return _c('tr',{key:fichero.FicheroID},[_c('td',{staticClass:"p-1",class:_vm.seleccionado === fichero ? 'bg-info text-white' : '',staticStyle:{"cursor":"default","user-select":"none","text-align":"left"},on:{"dblclick":function($event){return _vm.insertar(fichero)},"click":function($event){_vm.seleccionado = fichero}}},[_vm._v(_vm._s(fichero.FicheroID)+" - "+_vm._s(fichero.Descripcion))])])}),0)]),_c('div',{staticClass:"contieneRotacion"},[_c('div',{staticClass:"originales"},[_c('div',{staticClass:"tabla"},[_c('table',{staticClass:"table table-striped"},[_c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',{staticClass:"p-1"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Originales")])])]),_c('tbody',_vm._l((_vm.ficheros),function(fichero,i){return _c('tr',{key:i,class:_vm.ficheroFoco === i ? 'bg-warning' : '',on:{"dblclick":function($event){return _vm.delFichero(i)},"click":function($event){_vm.ficheroFoco = i}}},[_c('td',{staticClass:"p-1 celdaFichero",staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(fichero.FicheroID)+" - "+_vm._s(fichero.Descripcion))])])}),0)])])]),_c('div',{staticClass:"inserciones"},[_c('table',{staticClass:"table table-hover m-0"},[_c('thead',{staticClass:"bg-dark text-white"},[_c('tr',[_c('th',{staticClass:"text-right p-1"},[_vm._v("Ins")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Ref ext.")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Hora Ini.")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Hora Fin")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Importe")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Descuento")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Recargo")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Contenido")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Programa")]),_c('th',{staticClass:"text-right p-1"},[_vm._v("Importe final")]),_c('th',{staticClass:"text-right p-1 text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",staticStyle:{"width":"15px","height":"15px","font-size":"0.8em","padding":"1px","padding-left":"2px"},on:{"click":_vm.addInsercion}},[_c('span',{staticClass:"fa fa-plus"})])])])]),_c('tbody',_vm._l((_vm.inserciones),function(insercion,i){return _c('tr',{key:i,class:_vm.insercionSel === i ? 'activa' : '',on:{"click":function($event){_vm.insercionSel = i},"dblclick":function($event){_vm.verColocacion = true}}},[_c('td',{staticClass:"celdaInsercion p-1"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.inserciones[i].Inserciones),expression:"inserciones[i].Inserciones",modifiers:{"number":true}}],staticClass:"input",attrs:{"placeholder":"0","size":"2"},domProps:{"value":(_vm.inserciones[i].Inserciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "Inserciones", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"celdaInsercion p-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inserciones[i].RefExterna),expression:"inserciones[i].RefExterna"}],staticClass:"input",domProps:{"value":(_vm.inserciones[i].RefExterna)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "RefExterna", $event.target.value)}}})]),_c('td',{staticClass:"celdaInsercion p-1"},[_vm._v(_vm._s(insercion.HoraInicio))]),_c('td',{staticClass:"celdaInsercion p-1"},[_vm._v(_vm._s(insercion.HoraFin))]),_c('td',{staticClass:"celdaInsercion p-1"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.inserciones[i].Importe),expression:"inserciones[i].Importe",modifiers:{"number":true}}],staticClass:"input",domProps:{"value":(_vm.inserciones[i].Importe)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "Importe", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"celdaInsercion p-1"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.inserciones[i].Descuento),expression:"inserciones[i].Descuento",modifiers:{"number":true}}],staticClass:"input",domProps:{"value":(_vm.inserciones[i].Descuento)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "Descuento", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"celdaInsercion p-1"},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.inserciones[i].Recargo),expression:"inserciones[i].Recargo",modifiers:{"number":true}}],staticClass:"input",domProps:{"value":(_vm.inserciones[i].Recargo)},on:{"keyup":_vm.calculaImporte,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inserciones[i], "Recargo", _vm._n($event.target.value))},"blur":function($event){return _vm.$forceUpdate()}}})]),_c('td',{staticClass:"celdaInsercion p-1"},[_vm._v(_vm._s(insercion.ContenidoNombre))]),_c('td',{staticClass:"celdaInsercion p-1"},[_vm._v(_vm._s(insercion.ProgramaNombre))]),_c('td',{staticClass:"celdaInsercion p-1"},[_vm._v(_vm._s(_vm._f("currency")(insercion.ImporteFinal,''))+" €")]),_c('td',{staticClass:"celdaInsercion p-1 text-right"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.delInsercion(i)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":_vm.aplicar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Aplicar")])])]),(_vm.verSeleccionFicheros)?_c('ModalSeleccionFicheros',{attrs:{"ClienteID":_vm.contrato.ClienteID},on:{"cerrar":function($event){_vm.verSeleccionFicheros = false},"seleccionar":function($event){return _vm.addFicheros($event)}}}):_vm._e(),(_vm.verSeleccionarFechas)?_c('modal',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('button',{staticClass:"close",on:{"click":function($event){_vm.verSeleccionarFechas = false}}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('CalendarioAnual',{attrs:{"from":_vm.contrato.FechaInicio,"to":_vm.contrato.FechaFin,"seleccion":_vm.dias},on:{"update:seleccion":function($event){_vm.dias=$event}}})],1)])]):_vm._e(),(_vm.verColocacion)?_c('ModalColocacion',{attrs:{"EmisoraID":_vm.linea.EmisoraID},on:{"cerrar":function($event){_vm.verColocacion = false},"colocacion":function($event){return _vm.setColocacion($event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),(!_vm.contrato)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Selecciona el contrato")]),_c('input-query',{attrs:{"input-class":"form-control","placeholder":"Busca el contrato","realtime":true,"url":"radiacion/php/api/buscar-contrato.php"},on:{"selected":function($event){return _vm.seleccionaContrato($event)}}})],1)])])]):_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('b',[_vm._v("Agente")]),_c('br'),_vm._v(_vm._s(_vm.contrato.AgenteNombre))]),_c('div',{staticClass:"col"},[_c('b',[_vm._v("Cliente")]),_c('br'),_vm._v(_vm._s(_vm.contrato.ClienteNombre))]),_c('div',{staticClass:"col"},[_c('b',[_vm._v("Título")]),_c('br'),_vm._v(_vm._s(_vm.contrato.Titulo))]),_c('div',{staticClass:"col"},[_c('b',[_vm._v("Importe")]),_c('br'),_vm._v(_vm._s(_vm._f("currency")(_vm.contrato.ImporteTotal,''))+" €")])])])]),(_vm.radiacion)?_c('div',[_c('MenuOriginales',{attrs:{"linea":_vm.lineaSeleccionada},on:{"accion":function($event){_vm.ver = $event}}}),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-condensed"},[_c('thead',[_c('tr',[_c('th',{attrs:{"rowspan":"2"}},[_vm._v("Línea")]),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2"}},[_vm._v("Tot")]),_c('th',{staticClass:"text-center",attrs:{"rowspan":"2"}},[_vm._v("Mes")]),_vm._l((_vm.dias),function(dia){return _c('th',{key:dia.getTime(),staticClass:"text-center dia"},[_vm._v(_vm._s(_vm._f("moment")(dia,'dd')))])})],2),_c('tr',_vm._l((_vm.dias),function(dia){return _c('th',{key:dia.getTime(),staticClass:"dia"},[_vm._v(_vm._s(dia.getDate()))])}),0)]),_c('tbody',[_vm._l((_vm.radiacion.lineas),function(linea){return (linea.ArticuloID)?_c('tr',{class:(_vm.lineaSeleccionada && _vm.lineaSeleccionada.LineaID === linea.LineaID) ? 'lineaSeleccionada' : ''},[_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.seleccionaLinea(linea)}}},[_c('div',{staticClass:"desglose"},[_c('div',{staticClass:"bold"},[_c('span',{staticClass:"badge badge-danger mr-2",staticStyle:{"font-size":"1em"}},[(/^d+$/.test(linea.LineaID))?_c('span',[_vm._v(_vm._s(linea.LineaID))]):_c('span',[_vm._v("Nueva")])]),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(linea.Concepto))]),_c('span',{staticClass:"badge ml-2",class:linea.inserciones.length < linea.Cantidad ? 'badge-warning' : linea.inserciones.length > linea.Cantidad ? 'badge-danger' : 'badge-success'},[_vm._v(_vm._s(linea.inserciones.length)+"/"+_vm._s(linea.Cantidad)+" inserciones")])]),(_vm.desgloseLinea && _vm.desgloseLinea.ficheros.length > 0 && _vm.desgloseLinea.linea.LineaID === linea.LineaID)?_vm._l((_vm.desgloseLinea.ficheros),function(fichero){return _c('div',{key:fichero.FicheroID},[_vm._v(_vm._s(fichero.FicheroID)+" - "+_vm._s(fichero.Descripcion))])}):_vm._e()],2)]),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"desglose"},[_c('div',{staticClass:"bold"},[_vm._v(_vm._s(_vm.getTotalLinea(linea)))]),(_vm.desgloseLinea && _vm.desgloseLinea.ficheros.length > 0 && _vm.desgloseLinea.linea.LineaID === linea.LineaID)?_vm._l((_vm.desgloseLinea.ficheros),function(fichero){return _c('div',{key:fichero.FicheroID},[_vm._v(_vm._s(_vm.getTotalFichero(fichero)))])}):_vm._e()],2)]),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"desglose"},[_c('div',{staticClass:"bold"},[_vm._v(_vm._s(_vm.getInsercionesMes(linea)))]),(_vm.desgloseLinea && _vm.desgloseLinea.ficheros.length > 0 && _vm.desgloseLinea.linea.LineaID === linea.LineaID)?_vm._l((_vm.desgloseLinea.ficheros),function(fichero){return _c('div',{key:fichero.FicheroID},[_vm._v(_vm._s(_vm.getInsercionesMesFichero(fichero)))])}):_vm._e()],2)]),_vm._l((_vm.dias),function(dia){return _c('td',{key:linea.LineaID + '-' + dia.getTime(),staticClass:"dia",class:(dia < _vm.radiacion.FechaInicio || dia > _vm.radiacion.FechaFin) ? 'dia-inactivo' : 'dia-activo',on:{"click":function($event){return _vm.verDetallesDia(linea, dia)}}},[_c('div',{staticClass:"desglose text-center"},[_c('div',{staticClass:"bold",domProps:{"innerHTML":_vm._s(_vm.insercionesDia(linea.LineaID, dia))}}),(_vm.desgloseLinea && _vm.desgloseLinea.ficheros.length > 0 && _vm.desgloseLinea.linea.LineaID === linea.LineaID)?_vm._l((_vm.desgloseLinea.ficheros),function(fichero){return _c('div',{key:fichero.FicheroID,domProps:{"innerHTML":_vm._s(_vm.insercionesDiaFichero(fichero, dia))}})}):_vm._e()],2)])})],2):_vm._e()}),_c('tr',[_c('td',{staticClass:"text-center"},[_vm._v(" ")]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.totalInserciones))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.totalInsercionesMes))]),_vm._l((_vm.dias),function(dia){return _c('td',{key:'TotDia -' + dia.getTime(),staticClass:"text-center dia",class:(dia < _vm.radiacion.FechaInicio || dia > _vm.radiacion.FechaFin) ? 'dia-inactivo' : 'dia-activo',domProps:{"innerHTML":_vm._s(_vm.insercionesDia(null, dia))}})})],2)],2)])]),_c('nav',{staticClass:"mt-3"},[_c('ul',{staticClass:"pagination"},_vm._l((_vm.meses),function(mes){return _c('li',{key:mes.getTime(),staticClass:"page-item",class:(_vm.mesActivo === mes) ? 'active' : '',on:{"click":function($event){_vm.mesActivo = mes}}},[_c('a',{staticClass:"page-link"},[_c('span',[_vm._v(_vm._s(_vm.nombreMes[mes.getMonth()]))]),(_vm.variosAnos)?_c('span',[_vm._v(", "+_vm._s(mes.getFullYear()))]):_vm._e()])])}),0)]),_c('p'),_c('div',{staticClass:"btn-group"},[(_vm.historialModificaciones.length > 0 && _vm.punteroHistorial > 0)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.deshacer()}}},[_vm._v("Deshacer")]):_vm._e(),(_vm.historialModificaciones.length - 1 > _vm.punteroHistorial)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.rehacer()}}},[_vm._v("Rehacer")]):_vm._e()]),_c('p'),(_vm.lineaSeleccionada && _vm.ver === 'colocacion')?_c('colocacion',{attrs:{"EmisoraID":_vm.lineaSeleccionada.EmisoraID},on:{"cerrar":function($event){_vm.ver = ''},"colocacion":function($event){return _vm.setColocacion($event)}}}):_vm._e(),(_vm.ver === 'insertarOriginales')?_c('InsertarOriginales',{attrs:{"linea":_vm.lineaSeleccionada,"contrato":_vm.contrato},on:{"cerrar":function($event){_vm.ver = ''},"inserciones":function($event){return _vm.setInserciones($event)}}}):_vm._e(),(_vm.ver === 'eliminarInserciones')?_c('EliminarInserciones',{attrs:{"contrato":_vm.contrato,"radiacion":_vm.radiacion},on:{"cerrar":function($event){_vm.ver = ''},"eliminar":function($event){return _vm.eliminarInserciones($event)},"anular":function($event){return _vm.anularInserciones($event)}}}):_vm._e(),(_vm.ver === 'recuperarInserciones')?_c('RecuperarInserciones',{attrs:{"contrato":_vm.contrato,"radiacion":_vm.radiacion},on:{"cerrar":function($event){_vm.ver = ''},"recuperar":function($event){return _vm.recuperarInserciones($event)}}}):_vm._e(),(_vm.diaSeleccionado)?_c('DetallesDia',{attrs:{"bloques":_vm.bloques,"linea":_vm.diaSeleccionado.linea,"contrato":_vm.contrato,"dia":_vm.diaSeleccionado.dia},on:{"cerrar":_vm.cerrarDetallesDia,"guardar":function($event){return _vm.guardarInsercionesDia($event)}}}):_vm._e(),(_vm.ver === 'copiarInserciones')?_c('CopiarInserciones',{attrs:{"contrato":_vm.contrato,"linea":_vm.lineaSeleccionada},on:{"cerrar":function($event){_vm.ver = ''},"guardar":function($event){return _vm.reemplazaInserciones($event)}}}):_vm._e(),(_vm.ver === 'rotacionVertical')?_c('RotacionVertical',{attrs:{"contrato":_vm.contrato,"linea":_vm.lineaSeleccionada},on:{"cerrar":function($event){_vm.ver = ''},"rotacion":function($event){return _vm.reemplazaInserciones($event)}}}):_vm._e()],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-info mr-2"}),_vm._v("Datos del contrato")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__componentes_editor_editor__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__componentes_buscador_buscador__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__componentes_agenda_agenda_vue__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_vue_store_stores__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(1566);








/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('redaccion', {
			name: 'Redacción',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('redaccion').child('editor/:id', {
			name: 'Editor',
			component: __WEBPACK_IMPORTED_MODULE_2__componentes_editor_editor__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('redaccion').child('agenda', {
			name: 'Agenda informativa',
			component: __WEBPACK_IMPORTED_MODULE_4__componentes_agenda_agenda_vue__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('redaccion').child('', {
			name: 'Buscador de noticias',
			component: __WEBPACK_IMPORTED_MODULE_3__componentes_buscador_buscador__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_5__core_vue_store_stores__["a" /* default */].registerModule(['redaccion'], __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */]);
	}
});

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1497f61d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1533);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1497f61d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(660);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351b98ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1555);
function injectStyle (ssrContext) {
  __webpack_require__(1535)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-351b98ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351b98ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_etiquetas_vue__ = __webpack_require__(661);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d46b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_etiquetas_vue__ = __webpack_require__(1537);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_etiquetas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d46b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_etiquetas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_vm._m(0),(!_vm.readonly)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nueva),expression:"nueva"}],staticClass:"form-control",attrs:{"placeholder":"Escribe una etiqueta y pulsa intro"},domProps:{"value":(_vm.nueva)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.crear($event)},"input":function($event){if($event.target.composing){ return; }_vm.nueva=$event.target.value}}}):_vm._e()]),(!_vm.readonly)?_c('hr'):_vm._e(),_vm._l((_vm.texto.Etiquetas),function(etiqueta){return _c('button',{key:etiqueta.Etiqueta,staticClass:"btn btn-sm btn-warning m-1",on:{"click":function($event){return _vm.quitar(etiqueta.Etiqueta)}}},[_vm._v(_vm._s(etiqueta.Etiqueta))])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Etiquetas")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_categorias_vue__ = __webpack_require__(662);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40ca0fe4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_categorias_vue__ = __webpack_require__(1539);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_categorias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40ca0fe4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_categorias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_vm._m(0),(!_vm.readonly)?_c('input-query',{attrs:{"placeholder":"Busca una categoría","input-class":"form-control","realtime":true,"url":"redaccion/php/api/buscar-categorias.php"},on:{"selected":function($event){return _vm.seleccionada($event)}}}):_vm._e()],1),(!_vm.readonly)?_c('hr'):_vm._e(),_vm._l((_vm.texto.Categorias),function(cat){return _c('button',{key:cat.CategoriaID,staticClass:"btn btn-sm btn-warning m-1",on:{"click":function($event){return _vm.quitar(cat.CategoriaID)}}},[_vm._v(_vm._s(cat.Titulo))])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Categorias")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agenda_vue__ = __webpack_require__(663);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_106a7da0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_agenda_vue__ = __webpack_require__(1541);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agenda_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_106a7da0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_agenda_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_vm._m(0),(!_vm.readonly)?_c('input-query',{attrs:{"placeholder":"Busca una evento de agenda","input-class":"form-control","realtime":true,"url":"redaccion/php/api/buscar-agenda.php"},on:{"selected":function($event){return _vm.seleccionada($event)}}}):_vm._e()],1),(!_vm.readonly)?_c('hr'):_vm._e(),_vm._l((_vm.texto.Agenda),function(agenda){return _c('button',{key:agenda.AgendaID,staticClass:"btn btn-sm btn-warning m-1",on:{"click":function($event){return _vm.quitar(agenda.AgendaID)}}},[_vm._v(_vm._s(agenda.Titulo))])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Agenda")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_audios_vue__ = __webpack_require__(664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_718b8f4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_audios_vue__ = __webpack_require__(1543);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_audios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_718b8f4e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_audios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.texto.Audios)?_c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-header bg-warning",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.desplegado = !_vm.desplegado}}},[_c('span',{staticClass:"fa fa-volume-up mr-2"}),_vm._v("Audios"),_vm._m(0)]),(_vm.desplegado && !_vm.readonly)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"input-group"},[_vm._m(1),_c('input-query',{attrs:{"url":"redaccion/php/api/buscarAudio.php","realtime":false,"input-class":"form-control","placeholder":"Buscar un audio en el XFrame","disabled":_vm.procesando},on:{"selected":function($event){return _vm.addAudio($event)}}})],1),(_vm.procesando)?_c('div',{staticClass:"text-danger m-2 text-center",staticStyle:{"font-weight":"bold","font-size":"2em"}},[_vm._v("Procesando...")]):_vm._e()]):_vm._e(),(_vm.texto.Audios.length > 0)?_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.texto.Audios),function(audio){return _c('tr',{key:audio.AudioID},[_c('td',{staticClass:"text-center",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.ReproducirID = audio.XFrameID}}},[_c('span',{staticClass:"fa fa-play text-primary"})]),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(audio.NombreFichero))]),(!_vm.readonly)?_c('td',{staticClass:"text-right"},[_c('span',{staticClass:"fa fa-trash text-danger mr-2",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.delAudio(audio.AudioID)}}})]):_vm._e()])}),0)]):_vm._e(),(_vm.ReproducirID)?_c('Reproductor',{attrs:{"id-objeto":_vm.ReproducirID},on:{"cerrar":function($event){_vm.ReproducirID = null}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close"},[_c('span',{staticClass:"fa fa-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imagenes_vue__ = __webpack_require__(665);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_100594ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_imagenes_vue__ = __webpack_require__(1549);
function injectStyle (ssrContext) {
  __webpack_require__(1545)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-100594ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imagenes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_100594ac_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_imagenes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscadorImagenes_vue__ = __webpack_require__(666);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399b36d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscadorImagenes_vue__ = __webpack_require__(1548);
function injectStyle (ssrContext) {
  __webpack_require__(1547)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-399b36d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscadorImagenes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_399b36d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscadorImagenes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-picture mr-2"}),_vm._v("Imágenes"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-search"})])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cadena),expression:"filtro.cadena"}],staticClass:"form-control",attrs:{"autofocus":"autofocus"},domProps:{"value":(_vm.filtro.cadena)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cadena", $event.target.value)}}})]),(_vm.galerias.length > 0)?_c('div',{staticClass:"text-left mt-2"},[_c('h5',[_vm._v("Galerías")]),(_vm.galerias.length > 0)?_c('div',{staticClass:"imagenes mt-2"},_vm._l((_vm.galerias),function(galeria){return _c('MiniGaleria',{key:galeria.GaleriaID,attrs:{"galeria":galeria},on:{"selecciona":function($event){return _vm.getGaleria($event)}}})}),1):_vm._e()]):_vm._e(),(_vm.imagenes.length > 0)?_c('div',{staticClass:"text-left mt-2"},[(_vm.imagenes.length > 0)?_c('div',{staticClass:"imagenes mt-2"},_vm._l((_vm.imagenes),function(imagen){return _c('div',{key:imagen.ItemID,class:(_vm.seleccion.indexOf(imagen.ItemID) >= 0) ? 'seleccionada' : '',style:(imagen.estilo),on:{"click":function($event){return _vm.selecciona(imagen.ItemID)}}})}),0):_vm._e()]):_vm._e(),(_vm.buscado && _vm.imagenes.length === 0 && _vm.galerias.length === 0)?_c('div',{staticClass:"mt-2 text-center text-danger",staticStyle:{"font-weight":"bold"}},[_c('h3',[_c('span',{staticClass:"fa fa-ban"}),_c('br'),_vm._v("No hay resultados")])]):_vm._e()]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.seleccion.length === 0},on:{"click":_vm.adjuntar}},[_c('span',{staticClass:"fa fa-check mr-2"}),_vm._v("Adjuntar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_vm._m(0),(_vm.texto.Imagenes.length === 0)?_c('div',{staticClass:"text-danger text-center",staticStyle:{"font-size":"1.3em","font-weight":"bold"}},[_vm._v("No hay imágenes asociadas")]):_c('div',[_c('div',{staticClass:"contieneImagenes"},_vm._l((_vm.texto.Imagenes),function(img){return _c('div',{key:img.ImagenID,staticClass:"imagen",staticStyle:{"position":"relative","margin":"2px","width":"150px","cursor":"pointer","height":"150px","background-size":"cover","background-position":"center","background-repeat":"no-repeat"},style:({'background-image': 'url(src/modulos/galerias/php/api/thumb.php?ItemID=' + img.ItemID + ')'}),on:{"click":function($event){_vm.verItem = img.ItemID}}},[(!_vm.readonly)?_c('button',{staticClass:"btn btn-danger",staticStyle:{"position":"absolute","bottom":"5px","right":"5px"},on:{"click":function($event){return _vm.delImagen($event, img.ItemID)}}},[_c('span',{staticClass:"fa fa-trash"})]):_vm._e()])}),0)]),(!_vm.readonly)?_c('div',{staticClass:"text-center m-2"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){_vm.buscador = true}}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_vm._v("Adjuntar imágenes")])]):_vm._e(),(_vm.verItem)?_c('VisorItem',{attrs:{"item-id":_vm.verItem,"listado":_vm.listadoItemID},on:{"update:itemId":function($event){_vm.verItem=$event},"update:item-id":function($event){_vm.verItem=$event},"cerrar":function($event){_vm.verItem = null}}}):_vm._e(),(_vm.buscador)?_c('BuscadorImagenes',{on:{"cerrar":function($event){_vm.buscador = null},"adjuntar":function($event){return _vm.adjuntar($event)}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-camera mr-2"}),_vm._v("Imágenes y vídeos")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_palabrasClave_vue__ = __webpack_require__(667);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_722c186c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_palabrasClave_vue__ = __webpack_require__(1551);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_palabrasClave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_722c186c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_palabrasClave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3"},[_vm._m(0),_c('div',{staticClass:"card-body"},_vm._l((_vm.palabras),function(palabra){return _c('button',{key:palabra[0],staticClass:"btn btn-warning btn-sm m-1"},[_vm._v(_vm._s(palabra[0])+" ("+_vm._s(palabra[1])+")")])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-star mr-2"}),_vm._v("Palabras clave")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visor_texto_vue__ = __webpack_require__(668);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ecefcb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visor_texto_vue__ = __webpack_require__(1554);
function injectStyle (ssrContext) {
  __webpack_require__(1553)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44ecefcb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visor_texto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44ecefcb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visor_texto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contieneTexto"},[_c('div',{staticClass:"titular"},[_vm._v(_vm._s(_vm.texto.Titular))]),_c('div',{staticClass:"lead"},[_vm._v(_vm._s(_vm.texto.Lead))]),_c('div',{staticClass:"contenido",domProps:{"innerHTML":_vm._s(_vm.texto.Texto)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"contenedor"},[_c('div',{staticClass:"contieneMenu"},[_c('div',{staticClass:"card"},[_vm._m(0),(_vm.Texto.Editando && _vm.Texto.Editando.EdicionID !== _vm.EdicionID)?_c('div',{staticClass:"card-body bg-danger text-white"},[_c('span',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("Este texto está siendo editado por"),_c('b',[_vm._v(" "+_vm._s(_vm.Texto.Editando.UsuarioNombre))])]):_vm._e(),(_vm.Texto.Editando && _vm.Texto.Editando.EdicionID === _vm.EdicionID)?_c('div',{staticClass:"card-body bg-warning text-dark"},[_c('span',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("Estás editando esta noticia"),_c('button',{staticClass:"btn btn-sm btn-dark pull-right",on:{"click":_vm.cerrarEdicion}},[_c('span',{staticClass:"fa fa-times mr-2"}),_vm._v("Finalizar edición")])]):_vm._e(),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-12"},[_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',[_c('tr',[_vm._m(1),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Texto.Nombre),expression:"Texto.Nombre"}],staticClass:"form-control",attrs:{"disabled":_vm.readonly},domProps:{"value":(_vm.Texto.Nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Texto, "Nombre", $event.target.value)}}})])]),_c('tr',{class:(_vm.Texto.Nevera) ? 'bg-primary text-white' : ''},[_vm._m(2),_c('td',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Texto.Nevera),expression:"Texto.Nevera"}],staticClass:"mr-3",attrs:{"type":"checkbox","disabled":_vm.readonly},domProps:{"checked":Array.isArray(_vm.Texto.Nevera)?_vm._i(_vm.Texto.Nevera,null)>-1:(_vm.Texto.Nevera)},on:{"change":[function($event){var $$a=_vm.Texto.Nevera,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.Texto, "Nevera", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.Texto, "Nevera", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.Texto, "Nevera", $$c)}},function($event){return _vm.guardarNoticia()}]}}),(_vm.Texto.Nevera)?_c('span',[_vm._v("Guardado en nevera")]):_c('span')])])]),_c('tr',[_vm._m(3),_c('td',[_vm._v(_vm._s(_vm.Texto.AutorNombre))])]),_c('tr',[_vm._m(4),_c('td',[_vm._v(_vm._s(_vm.Texto.FechaCreacion))])]),_c('tr',[_vm._m(5),_c('td',[_vm._v(_vm._s(_vm.Texto.FechaModificacion))])]),_c('tr',[_vm._m(6),_c('td',[_vm._v(_vm._s(_vm.contador))])]),(!_vm.readonly)?_c('tr',{class:(_vm.modificado) ? 'bg-danger text-white' : ''},[_vm._m(7),_c('td',[(_vm.modificado)?_c('span',[_vm._v("No")]):_c('span',{staticClass:"text-success"},[_vm._v("Sí")])])]):_vm._e()])])]),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-12"},[_c('div',{staticClass:"card-body bg-light"},[_c('Agenda',{attrs:{"texto":_vm.Texto,"readonly":_vm.readonly}})],1),_c('div',{staticClass:"card-body bg-light"},[_c('Categorias',{attrs:{"texto":_vm.Texto,"readonly":_vm.readonly}})],1),_c('div',{staticClass:"card-body bg-light"},[_c('Etiquetas',{attrs:{"texto":_vm.Texto,"readonly":_vm.readonly}})],1)])]),_c('div',{staticClass:"card-footer"},[(!_vm.readonly)?_c('button',{staticClass:"btn btn-sm btn-primary mr-2",on:{"click":_vm.guardarNoticia}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")]):_vm._e(),(!_vm.readonly)?_c('button',{staticClass:"btn btn-sm btn-danger mr-2",on:{"click":_vm.eliminarNoticia}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Eliminar")]):_vm._e(),(!_vm.Texto.Editando)?_c('button',{staticClass:"btn btn-sm btn-dark mr-2",on:{"click":function($event){return _vm.editarNoticia()}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editar")]):_vm._e(),_c('button',{staticClass:"btn btn-sm btn-warning mr-2",on:{"click":function($event){return _vm.descargarPDF()}}},[_c('span',{staticClass:"fa fa-file-pdf-o mr-2"}),_vm._v("PDF")]),_c('button',{staticClass:"btn btn-sm btn-warning mr-2",on:{"click":function($event){_vm.imprimir = true}}},[_c('span',{staticClass:"fa fa-print mr-2"}),_vm._v("Imprimir")])])])]),(_vm.readonly)?_c('div',{staticClass:"contieneEditor"},[_c('VisorTexto',{attrs:{"texto":_vm.Texto}})],1):_c('div',{staticClass:"contieneEditor"},[_c('div',{staticClass:"input-group input-group-lg mb-3 inp"},[_vm._m(8),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Texto.Titular),expression:"Texto.Titular"}],staticClass:"form-control",domProps:{"value":(_vm.Texto.Titular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Texto, "Titular", $event.target.value)}}})]),_c('div',{staticClass:"input-group input-group-lg mb-3 inp"},[_vm._m(9),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.Texto.Lead),expression:"Texto.Lead"}],staticClass:"form-control",attrs:{"rows":"6"},domProps:{"value":(_vm.Texto.Lead)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.Texto, "Lead", $event.target.value)}}})]),(!_vm.readonly)?_c('vue-mce',{staticClass:"editor",attrs:{"config":_vm.configuracionEditor},model:{value:(_vm.Texto.Texto),callback:function ($$v) {_vm.$set(_vm.Texto, "Texto", $$v)},expression:"Texto.Texto"}}):_vm._e()],1),_c('div',{staticClass:"contieneImagenes"},[_c('Audios',{attrs:{"texto":_vm.Texto,"readonly":_vm.readonly}}),_c('Imagenes',{attrs:{"texto":_vm.Texto,"palabras-clave":_vm.palabrasClave,"readonly":_vm.readonly}}),_c('PalabrasClave',{attrs:{"palabras-clave":_vm.palabrasClave}})],1)]),(_vm.imprimir)?_c('imprimir',{on:{"imprimir":function($event){return _vm.goImprimir($event)},"cerrar":function($event){_vm.imprimir=false}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-info-circle mr-2"}),_vm._v("Información")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Nombre")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Guardar en nevera")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Autor")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Fecha de creación")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Última modificación")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Nº de palabras")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Cambios guardados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Titular")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_vm._v("Lead")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscador_vue__ = __webpack_require__(669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c08adf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscador_vue__ = __webpack_require__(1559);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buscador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c08adf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buscador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__ = __webpack_require__(670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78c758e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__ = __webpack_require__(1558);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_resultados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78c758e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_resultados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('table',{staticClass:"table table-striped m-0"},[_vm._m(0),_c('tbody',_vm._l((_vm.resultados),function(noticia){return _c('tr',{key:noticia.NoticiaID,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.editarNoticia(noticia)}}},[_c('td',[_vm._v(_vm._s(noticia.NoticiaID))]),_c('td',[_vm._v(_vm._s(noticia.AutorNombre))]),_c('td',[_c('b',[_vm._v(_vm._s(noticia.Nombre))])]),_c('td',[_vm._v(_vm._s(noticia.Titular))]),_c('td',[_vm._v(_vm._s(noticia.NumeroPalabras))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(noticia.FechaModificacionUnix,'DD-MM-Y'))+" a las "+_vm._s(_vm._f("moment")(noticia.FechaModificacionUnix,'hh:mm:ss')))]),_c('td',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.setImprimir($event, noticia)}}},[_c('span',{staticClass:"fa fa-print"})])])])}),0)]),(_vm.imprimir)?_c('imprimir',{on:{"cerrar":function($event){_vm.imprimir = null},"imprimir":function($event){return _vm.goImprimir($event)}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Usuario")]),_c('th',[_vm._v("Nombre")]),_c('th',[_vm._v("Titular")]),_c('th',[_vm._v("Nº Palabras")]),_c('th',[_vm._v("Fecha Modificación")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Texto),expression:"filtro.Texto"}],staticClass:"form-control",attrs:{"placeholder":"Buscar en el título, contenido, etiquetas, palabras clave..."},domProps:{"value":(_vm.filtro.Texto)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Texto", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_vm._m(2),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.Autor),expression:"filtro.Autor"}],staticClass:"form-control",attrs:{"placeholder":"Autor de la noticia"},domProps:{"value":(_vm.filtro.Autor)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "Autor", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_vm._m(3),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"placeholder":"Fecha de inicio","monday-first":true,"bootstrap-styling":true,"input-class":"form-control","language":_vm.$dateLang},on:{"input":function($event){return _vm.buscar()}},model:{value:(_vm.filtro.FechaIni),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaIni", $$v)},expression:"filtro.FechaIni"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.filtro.FechaIni = null}}},[_c('span',{staticClass:"fa fa-trash"})])])],1)]),_c('div',{staticClass:"form-group"},[_vm._m(4),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"placeholder":"Fecha de fin","monday-first":true,"bootstrap-styling":true,"input-class":"form-control","language":_vm.$dateLang},on:{"input":function($event){return _vm.buscar()}},model:{value:(_vm.filtro.FechaFin),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaFin", $$v)},expression:"filtro.FechaFin"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.filtro.FechaFin = null}}},[_c('span',{staticClass:"fa fa-trash"})])])],1)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_vm._m(5),_c('input-query',{attrs:{"url":"redaccion/php/api/buscar-categorias.php","placeholder":"Busca una categoria","realtime":true,"input-class":"form-control"},on:{"selected":function($event){return _vm.seleccionaCategoria($event)}}})],1),(_vm.filtro.Categorias.length > 0)?_c('table',{staticClass:"table table-striped"},[_c('tbody',_vm._l((_vm.filtro.Categorias),function(cat){return _c('tr',{key:cat.CategoriaID},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(cat.Titulo))]),_c('td',{staticClass:"text-right text-danger"},[_c('span',{staticClass:"fa fa-trash",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.quitarCategoria(cat)}}})])])}),0)]):_vm._e()]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3"},[_c('div',{staticClass:"form-group"},[_vm._m(6),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.verNevera) ? 'btn-primary' : '',on:{"click":function($event){return _vm.toggleNevera()}}},[_c('span',{staticClass:"fa fa-snowflake-o mr-2"}),_vm._v("Ver nevera")])])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary mr-2",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-success mr-2",on:{"click":function($event){return _vm.$router.push('/main/redaccion/editor/nueva')}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Nueva")])])]),(_vm.resultados.length > 0)?_c('Resultados',{staticClass:"mt-3",attrs:{"resultados":_vm.resultados}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscador de noticias")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Texto")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Autor")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Desde")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Hasta")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Categorias")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v("Nevera")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agenda_vue__ = __webpack_require__(671);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f827d8fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_agenda_vue__ = __webpack_require__(1565);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_agenda_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f827d8fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_agenda_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(672);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c76d0880_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1562);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c76d0880_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Editor"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Título")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.Titulo),expression:"datos.Titulo"}],staticClass:"form-control",attrs:{"placeholder":"Título del tema"},domProps:{"value":(_vm.datos.Titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "Titulo", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Descripción")]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.Descripcion),expression:"datos.Descripcion"}],staticClass:"form-control",attrs:{"rows":"4","placeholder":"Descripción del tema"},domProps:{"value":(_vm.datos.Descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "Descripcion", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Fecha límite")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"monday-first":true,"input-class":"form-control","language":_vm.$dateLang,"placeholder":"Selecciona una fecha"},model:{value:(_vm.datos.FechaLimite),callback:function ($$v) {_vm.$set(_vm.datos, "FechaLimite", $$v)},expression:"datos.FechaLimite"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.datos.FechaLimite = null}}},[_c('span',{staticClass:"fa fa-trash"})])])],1)])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":_vm.guardar}},[_c('span',{staticClass:"fa fa-save mr-2"}),_vm._v("Guardar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listadoNoticias_vue__ = __webpack_require__(673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d55272d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listadoNoticias_vue__ = __webpack_require__(1564);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listadoNoticias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d55272d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_listadoNoticias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.agenda)?_c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Listado noticias de: "+_vm._s(_vm.agenda.Titulo)),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('table',{staticClass:"table table-striped m-0"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Usuario")]),_c('th',[_vm._v("Fecha")]),_c('th',[_vm._v("Titular")]),_c('th')])]),_c('tbody',_vm._l((_vm.listado),function(noticia){return _c('tr',{key:noticia.NoticiaID},[_c('td',[_vm._v(_vm._s(noticia.AutorNombre))]),_c('td',[_vm._v(_vm._s(_vm._f("moment")(noticia.FechaModificacionUnix,'DD-MM-YYYY')))]),_c('td',[_vm._v(_vm._s(noticia.Titular))]),_c('td',[_c('a',{staticClass:"btn btn-sm btn-primary",attrs:{"href":'/#/main/redaccion/editor/' + noticia.NoticiaID,"target":"_blank"}},[_c('span',{staticClass:"fa fa-eye"})])])])}),0)])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Texto")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtro.cadena),expression:"filtro.cadena"}],staticClass:"form-control",attrs:{"placeholder":"Busca por cadena de texto"},domProps:{"value":(_vm.filtro.cadena)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtro, "cadena", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Mes caduca")]),_c('div',{staticClass:"input-group"},[_c('datepicker',{attrs:{"minimum-view":"month","monday-first":true,"input-class":"form-control","language":_vm.$dateLang,"format":"MMMM, yyyy"},on:{"input":_vm.buscar},model:{value:(_vm.filtro.FechaLimite),callback:function ($$v) {_vm.$set(_vm.filtro, "FechaLimite", $$v)},expression:"filtro.FechaLimite"}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.borrarMes}},[_c('span',{staticClass:"fa fa-trash"})])])],1)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Estado")]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.filtro.caducada === false) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado(false)}}},[_vm._v("Activas")]),_c('button',{staticClass:"btn",class:(_vm.filtro.caducada === null) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado(null)}}},[_vm._v("Todas")]),_c('button',{staticClass:"btn",class:(_vm.filtro.caducada === true) ? 'btn-primary' : '',on:{"click":function($event){return _vm.setEstado(true)}}},[_vm._v("Caducadas")])])])])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary mr-2",on:{"click":_vm.buscar}},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscar")]),_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){_vm.editando = 'nuevo'}}},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Nuevo elemento")])])]),_c('div',{staticClass:"card mt-3"},[_vm._m(1),_c('table',{staticClass:"table table-striped m-0"},[_vm._m(2),_c('tbody',_vm._l((_vm.resultados),function(res){return _c('tr',{key:res.AgendaID},[_c('td',[(res.FechaLimite)?_c('span',[_vm._v(_vm._s(_vm._f("moment")(res.FechaLimite * 1,'DD-MM-YYYY')))]):_c('span',[_vm._v("Sin fecha")])]),_c('td',[_vm._v(_vm._s(res.Titulo))]),_c('td',[_vm._v(_vm._s(res.UsuarioNombre))]),(res.NumeroNoticias > 0)?_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.verNoticias(res)}}},[_vm._v(_vm._s(res.NumeroNoticias))]):_c('td',[_vm._v("0")]),_c('td',[_c('button',{staticClass:"m-1 btn btn-sm btn-warning",on:{"click":function($event){_vm.editando = res.AgendaID}}},[_c('span',{staticClass:"fa fa-edit"})]),_c('button',{staticClass:"m-1 btn btn-sm btn-danger",on:{"click":function($event){return _vm.eliminar(res)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)])]),(_vm.editando)?_c('Editor',{attrs:{"AgendaID":_vm.editando},on:{"cerrar":function($event){_vm.editando = null},"actualizar":_vm.buscar}}):_vm._e(),(_vm.verNoticiasAgenda)?_c('ListadoNoticias',{attrs:{"agenda":_vm.verNoticiasAgenda},on:{"cerrar":function($event){_vm.verNoticiasAgenda = null}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-search mr-2"}),_vm._v("Buscador")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-list mr-2"}),_vm._v("Resultados")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha límite")]),_c('th',[_vm._v("Título")]),_c('th',[_vm._v("Usuario")]),_c('th',[_vm._v("Noticias vinculadas")]),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		resultados: []
	},
	getters: {
		resultados: function resultados(state) {
			return state.resultados;
		}
	},
	mutations: {
		SET_RESULTADOS: function SET_RESULTADOS(state, payload) {
			state.resultados = payload;
		}
	},
	actions: {
		buscar: function buscar(context, payload) {
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('redaccion/php/api/buscarNoticias.php', payload).then(function (res) {
				context.commit('SET_RESULTADOS', res.data);
			}).catch(function (e) {
				console.error(e);
			});
		}
	}
});

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Main__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tablero__ = __webpack_require__(1572);



// import OverView from './components/overview/mainOverview.component'

/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('solicitudes', {
			name: 'Solicitudes',
			component: __WEBPACK_IMPORTED_MODULE_1__Main__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('solicitudes').child('', {
			name: 'Tablero',
			component: __WEBPACK_IMPORTED_MODULE_2__components_tablero__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('solicitudes').child('solicitud/:SolicitudID', {
			name: 'Solicitud',
			component: __WEBPACK_IMPORTED_MODULE_2__components_tablero__["a" /* default */]
		});
	}
});

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(674);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd1838e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1571);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dd1838e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-warning"},[_c('span',{staticClass:"fa fa-edit mr-2"}),(_vm.datos.Titulo)?_c('span',[_vm._v("Editor de solicitudes")]):_vm._e(),(!_vm.datos.Titulo)?_c('span',[_vm._v("Creador de solicitudes")]):_vm._e(),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Usuario que solicita")])]),_c('seleccion-usuario',{model:{value:(_vm.datos.UsuarioID),callback:function ($$v) {_vm.$set(_vm.datos, "UsuarioID", $$v)},expression:"datos.UsuarioID"}})],1)]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Fecha de solicitud")])]),_c('input',{staticClass:"form-control form-control-sm",attrs:{"disabled":"disabled"},domProps:{"value":_vm.$moment().format('DD-MM-YYYY') + ' a las ' + _vm.$moment().format('HH:mm')}})])])])]),_c('div',{staticClass:"card-body"},[_c('h4',[_c('span',{staticClass:"fa fa-search mr-2"}),_c('span',[_vm._v("Detalles de la solicitud")])]),_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Título")])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.titulo),expression:"datos.titulo"}],staticClass:"form-control",domProps:{"value":(_vm.datos.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "titulo", $event.target.value)}}})])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Prioridad")])]),_c('br'),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn",class:(_vm.datos.prioridad=='1 Alta') ? 'btn-danger' : '',on:{"click":function($event){return _vm.togglePrioridad('1 Alta')}}},[_c('span',{staticClass:"fa fa-camera mr-2"}),_c('span',[_vm._v("Alta")])]),_c('button',{staticClass:"btn",class:(_vm.datos.prioridad=='2 Media') ? 'btn-warning' : '',on:{"click":function($event){return _vm.togglePrioridad('2 Media')}}},[_c('span',{staticClass:"fa fa-video-camera mr-2"}),_c('span',[_vm._v("Media")])]),_c('button',{staticClass:"btn",class:(_vm.datos.prioridad=='3 Baja') ? 'btn-primary' : '',on:{"click":function($event){return _vm.togglePrioridad('3 Baja')}}},[_c('span',{staticClass:"fa fa-video-camera mr-2"}),_c('span',[_vm._v("Baja")])])])])])]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Descripción")])]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.datos.Descripcion),expression:"datos.Descripcion"}],staticClass:"form-control",attrs:{"placeholder":"Especifica con detalle que es lo que solicitas y para que lo necesitas","rows":"6"},domProps:{"value":(_vm.datos.Descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "Descripcion", $event.target.value)}}})]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Fecha prevista de publicación (si se va a publicar)")])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm._f("moment")(_vm.datos.FechaPublicacion,'DD-MM-YYYY')}}),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('vc-date-picker',{attrs:{"popover":{placement: 'bottom', visibility: 'click'}},model:{value:(_vm.datos.FechaPublicacion),callback:function ($$v) {_vm.$set(_vm.datos, "FechaPublicacion", $$v)},expression:"datos.FechaPublicacion"}},[_c('button',{staticClass:"btn btn-primary"},[_c('span',{staticClass:"fa fa-calendar"})])])],1),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.datos.FechaPublicacion = null}}},[_c('span',{staticClass:"fa fa-trash"})])])])])])]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Destino de la publicación")])]),_c('br'),_c('div',{staticClass:"destinos"},_vm._l((_vm.destinos),function(destino){return _c('span',{key:destino.DestinoID,class:_vm.claseDestino(destino),on:{"click":function($event){return _vm.toggleDestino(destino.DestinoID)}}})}),0)])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Fecha y hora del evento (en caso de que la haya)")])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"disabled":"disabled"},domProps:{"value":_vm._f("moment")(_vm.datos.FechaEvento,'DD-MM-YYYY')}}),_c('div',{staticClass:"input-group-append input-group-prepend"},[_c('vc-date-picker',{attrs:{"popover":{placement: 'bottom', visibility: 'click'}},model:{value:(_vm.datos.FechaEvento),callback:function ($$v) {_vm.$set(_vm.datos, "FechaEvento", $$v)},expression:"datos.FechaEvento"}},[_c('button',{staticClass:"btn btn-primary"},[_c('span',{staticClass:"fa fa-calendar"})])])],1),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-danger"},[_c('span',{staticClass:"fa fa-trash",on:{"click":function($event){_vm.datos.FechaEvento = null}}})])])])]),_c('div',{staticClass:"col"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-clock-o"})])]),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:('##:##'),expression:"'##:##'"},{name:"model",rawName:"v-model",value:(_vm.datos.HoraEvento),expression:"datos.HoraEvento"}],staticClass:"form-control",attrs:{"disabled":!_vm.datos.FechaEvento},domProps:{"value":(_vm.datos.HoraEvento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.datos, "HoraEvento", $event.target.value)}}})])])])]),_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Lugar del evento")])]),_c('input-query-location',{attrs:{"placeholder":"Busca en google por nombre o dirección","inputClass":"form-control"},on:{"selected":function($event){return _vm.seleccionaUbicacion($event)}}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.datos.LatitudEvento && _vm.datos.LongitudEvento),expression:"datos.LatitudEvento && datos.LongitudEvento"}],attrs:{"id":"mapaEvento"}})])])]),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.guardar()}}},[_c('span',{staticClass:"fa fa-save mr-2"}),_c('span',[_vm._v("Guardar")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.crear)?_c('Nueva',{on:{"cerrar":function($event){_vm.crear = null}}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablero_vue__ = __webpack_require__(677);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c8d85ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tablero_vue__ = __webpack_require__(1577);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tablero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c8d85ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_tablero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_solicitud_vue__ = __webpack_require__(678);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741ccedf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_solicitud_vue__ = __webpack_require__(1576);
function injectStyle (ssrContext) {
  __webpack_require__(1575)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-741ccedf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_solicitud_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741ccedf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_solicitud_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"solicitud",on:{"click":function($event){return _vm.$emit('ver')}}},[_c('div',{staticClass:"contenido"},[_c('div',{staticClass:"titulo"},[_vm._v(_vm._s(_vm.solicitud.Titulo))]),_c('div',{staticClass:"fechaCreacion"},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_c('span',[_vm._v("Creada el "+_vm._s(_vm._f("moment")(new Date(_vm.solicitud.FechaCreacionUnix * 1000),'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(new Date(_vm.solicitud.FechaCreacionUnix * 1000),'HH:mm')))])]),_c('div',{staticClass:"fechaFinalizacion",class:!_vm.solicitud.FechaPublicacion ? 'danger' : ''},[_c('span',{staticClass:"fa fa-calendar-times-o mr-2"}),(!_vm.solicitud.FechaPublicacion)?_c('span',[_vm._v("Publicación sin definir")]):_c('span',[_vm._v("Finalizada el "+_vm._s(_vm._f("moment")(_vm.solicitud.FechaFinalizacion,'DD-MM-YYYY')))])])]),_c('div',{staticClass:"avatar"},[_c('avatar',{attrs:{"usuario":_vm.solicitud.UsuarioID}}),_c('div',{staticClass:"nombre"},[_vm._v(_vm._s(_vm.solicitud.UsuarioNombre))])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"bug"}}),_c('span',[_vm._v("Pendientes")])],1),_c('div',{staticClass:"col text-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",staticStyle:{"position":"absolute","display":"block","right":"10px","top":"-2px"},on:{"click":_vm.setNueva}},[_c('span',{staticClass:"fa fa-plus mr-2"}),_c('span',[_vm._v("Nueva")])])])])]),_vm._l((_vm.solicitudesPendientes),function(solicitud){return _c('Solicitud',{key:solicitud.solicitudID,attrs:{"solicitud":solicitud},on:{"ver":function($event){return _vm.verSolicitud(solicitud)}}})})],2)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-danger text-white"},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"spinner"}}),_c('span',[_vm._v("En curso")])],1),_vm._l((_vm.solicitudesRealizadas),function(solicitud){return _c('Solicitud',{key:solicitud.solicitudID,attrs:{"solicitud":solicitud},on:{"ver":function($event){return _vm.verSolicitud(solicitud)}}})})],2)]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._l((_vm.solicitudesFinalizadas),function(solicitud){return _c('Solicitud',{key:solicitud.SolicitudID,attrs:{"solicitud":solicitud},on:{"ver":function($event){return _vm.verSolicitud(solicitud)}}})})],2)])]),(_vm.EditarID)?_c('Editor',{attrs:{"SolicitudID":_vm.EditarID},on:{"actualizar":function($event){return _vm.buscar()},"cerrar":function($event){_vm.EditarID = null}}}):_vm._e(),(_vm.SolicitudID)?_c('SolicitudDetalle',{attrs:{"SolicitudID":_vm.SolicitudID},on:{"cerrar":function($event){return _vm.$router.push('/main/produccion-audiovisual')},"actualizar":function($event){return _vm.buscar()},"editar":function($event){_vm.EditarID = $event}}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-success text-white"},[_c('span',{staticClass:"fa fa-check-square mr-2"}),_c('span',[_vm._v("Finalizadas")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1579);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('subir-cunas', {
			name: 'Subir Cuñas',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});
	}
});

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(679);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0762a743_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1583);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0762a743_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(680);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d28687d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(1582);
function injectStyle (ssrContext) {
  __webpack_require__(1581)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d28687d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid text-left"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-2"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[(!_vm.produccion.anunciante.ID_anunciante)?_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Anunciante")]),_vm._v(" "),_c('input-query',{attrs:{"realtime":true,"input-class":'form-control form-control-sm',"placeholder":"Busca el anunciante","url":'/produccion/php/api/buscaAnunciante.php'},on:{"selected":function($event){return _vm.seleccionaAnunciante($event)}}})],1):_vm._e(),_vm._v(" "),(_vm.produccion.anunciante.ID_anunciante)?_c('div',[_c('b',[_vm._v("Anunciante:")]),_vm._v(" "),_c('div',{staticClass:"input-group input-group-sm"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.produccion.anunciante.nombre),expression:"produccion.anunciante.nombre"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.produccion.anunciante.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produccion.anunciante, "nombre", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":_vm.quitaAnunciante}},[_c('span',{staticClass:"fa fa-trash"})])])])]):_vm._e()]),_vm._v(" "),(_vm.produccion.anunciante.ID_anunciante)?_c('div',{staticClass:"card-body bg-danger text-white text-center"},[(_vm.produccion.contrato.ID_contrato)?_c('div',[_c('b',[_vm._v("Contrato asociado")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.produccion.contrato.nombreCliente))]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.produccion.contrato.titulo))]),_vm._v(" "),_c('button',{staticClass:"btn btn-dark btn-sm",on:{"click":function($event){_vm.asociando = true}}},[_c('span',{staticClass:"fa fa-gear"}),_vm._v("\n\t\t\t\tCambiar contrato\n\t\t\t  ")])]):_vm._e(),_vm._v(" "),(!_vm.produccion.contrato || !_vm.produccion.contrato.ID_contrato)?_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-dark btn-sm",on:{"click":function($event){_vm.asociando = true}}},[_c('span',{staticClass:"fa fa-gear"}),_vm._v("\n\t\t\t\tAsociar contrato\n\t\t\t  ")])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.produccion.contrato.ID_contrato)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Título de la campaña")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.produccion.titulo),expression:"produccion.titulo"}],staticClass:"form-control form-control-sm",attrs:{"type":"text","placeholder":"Escribe el título"},domProps:{"value":(_vm.produccion.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.produccion, "titulo", $event.target.value)}}})])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-4 mb-2"},[(_vm.esValido)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-dark text-white"},[_c('span',{staticClass:"fa fa-file-o mr-2",staticStyle:{"font-size":"1.3em","vertical-align":"middle"}}),_vm._v("\n\t\t\tSelección de ficheros\n\t\t\t"),_c('button',{staticClass:"btn btn-sm btn-warning pull-right",on:{"click":_vm.seleccionaFicheros}},[_c('span',{staticClass:"fa fa-upload"})])]),_vm._v(" "),_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.ficheros),function(fichero,index){return _c('tr',{key:fichero.name},[_c('td',{staticStyle:{"vertical-align":"middle"}},[(fichero.musica_autor === 1)?_c('span',{staticClass:"fa fa-copyright",staticStyle:{"font-size":"2em"},attrs:{"title":"Contiene fonográmas protegidos por derechos de autor"}}):_c('span',{staticClass:"fa fa-gift",staticStyle:{"font-size":"2em"},attrs:{"title":"No contiene fonográmas protegidos por derechos de autor"}})]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(fichero.fichero.name))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.getTamano(fichero.fichero.size)))]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"vertical-align":"middle"}},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.quitaFichero(index)}}},[_c('span',{staticClass:"fa fa-trash"})])])])}),0)]),_vm._v(" "),(_vm.ficheros.length > 0)?_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.subirFicheros()}}},[_vm._v("\n\t\t\t  Subir ficheros\n\t\t\t")])]):_vm._e()]):_vm._e()])]),_vm._v(" "),(_vm.asociando)?_c('asocia-contrato',{on:{"cerrar":function($event){_vm.asociando = false},"asignar":_vm.asociaContrato}}):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 mb-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-info-circle mr-2",staticStyle:{"font-size":"1.3em","vertical-align":"middle"}}),_vm._v("\n\t\t\tInformación\n\t\t  ")]),_vm._v(" "),_c('div',{staticClass:"card-body bg-light"},[_c('p',[_vm._v("\n\t\t\t  Antes de continuar debes haber realizado los siguientes pasos:\n\t\t\t  "),_c('ol',[_c('li',[_vm._v("Haber "),_c('b',[_vm._v("creado el cliente")])]),_vm._v(" "),_c('li',[_vm._v("Haber "),_c('b',[_vm._v("creado el anunciante")])]),_vm._v(" "),_c('li',[_vm._v("Haber "),_c('b',[_vm._v("creado el contrato")]),_vm._v(" de esta campaña")])])]),_vm._v(" "),_c('p',[_vm._v("\n\t\t\t  Es necesario que todas las cuñas tengan un contrato asociado para poder\n\t\t\t  extraer correctamente las analíticas de seguimiento y de rendimiento de las\n\t\t\t  campañas.\n\t\t\t")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-light"},[_c('span',{staticClass:"fa fa-edit mr-2",staticStyle:{"font-size":"1.3em","vertical-align":"middle"}}),_vm._v("\n\t\t\tDatos de la campaña\n\t\t  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('subir-cunas')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1585);



/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('subir-xframe', {
			name: 'Subir XFrame',
			component: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
		});
	}
});

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(681);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e0d16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1587);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7e0d16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var uri = 'subir-xframe/php/';
var get = function get(url) {
	return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(uri + url);
};

/* harmony default export */ __webpack_exports__["a"] = ({
	getBuzones: function getBuzones() {
		return get('listado-buzones.php');
	},
	getPendientes: function getPendientes() {
		return get('check.php');
	}
});

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-condensed table-striped m-0"},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ID_buzon),expression:"form.ID_buzon"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "ID_buzon", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecciona buzón de destino")]),_vm._l((_vm.listadoBuzones),function(buzon){return _c('option',{key:buzon.ID,domProps:{"value":buzon.ID}},[_vm._v(_vm._s(buzon.titulo))])})],2),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":!_vm.form.ID_buzon},on:{"click":_vm.seleccionarFicheros}},[_c('span',{staticClass:"fa fa-upload"})])])])])])]),_c('tbody',_vm._l((_vm.pendientes),function(pendiente){return _c('tr',{key:pendiente.ID},[_c('td',{staticClass:"text-left"},[_c('span',{staticClass:"fa fa-file mr-2"},[_vm._v(_vm._s(pendiente.fichero.name))]),_c('div',{staticClass:"mt-2",staticStyle:{"position":"relative","display":"block"}},[_c('div',{staticStyle:{"position":"absolute","display":"block","left":"0","transition":"width 300ms ease-out","height":"2px","background-color":"darkred"},style:({ width: pendiente.porcentaje + '%' })})])]),_vm._m(1,true)])}),0)])])])]),_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-6 col-lg-8 col-xl-8"},[_c('div',{staticClass:"card"},[_vm._m(2),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped m-0"},[_c('tbody',_vm._l((_vm.listadoCola),function(fichero){return _c('tr',{key:fichero.FicheroID,class:(fichero.FechaSubido) ? 'text-success' : ''},[_c('td',{staticClass:"text-left"},[_c('span',{staticClass:"fa fa-file mr-2"}),_c('b',[_vm._v(_vm._s(fichero.Fichero))]),_c('div',{staticClass:"mt-2",staticStyle:{"opacity":"0.7"}},[_c('span',{staticClass:"fa fa-calendar mr-2"}),_vm._v("Subido el "+_vm._s(fichero.FechaCreado)+" a las "+_vm._s(fichero.HoraCreado)+" por "+_vm._s(fichero.nombre)+" "+_vm._s(fichero.apellidos))])]),_c('td',{staticClass:"text-right",staticStyle:{"vertical-align":"middle","font-size":"1.2em"}},[_vm._v(_vm._s(fichero.Buzon)),_c('span',{staticClass:"fa fa-folder ml-2"})])])}),0)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-info text-white"},[_c('span'),_vm._v("Selecciona los ficheros para subir")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-right",staticStyle:{"width":"30px"}},[_c('button',{staticClass:"btn btn-sm btn-danger"},[_c('span',{staticClass:"fa fa-trash"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header bg-warning text-dark"},[_c('span'),_vm._v("Ficheros actualmente en cola")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__webmail_component__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_vue_store_stores__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_redactar_redactar__ = __webpack_require__(1607);






/* harmony default export */ __webpack_exports__["a"] = ({
	install: function install(Vue) {
		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('webmail', {
			name: 'Webmail',
			component: __WEBPACK_IMPORTED_MODULE_1__webmail_component__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('webmail/:buzon', {
			name: 'Buzón',
			component: __WEBPACK_IMPORTED_MODULE_1__webmail_component__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_0_vue_routes_generator___default.a.route('/main').child('webmail/:buzon/:mensaje', {
			name: 'Mensaje',
			component: __WEBPACK_IMPORTED_MODULE_1__webmail_component__["a" /* default */]
		});

		__WEBPACK_IMPORTED_MODULE_3__core_vue_store_stores__["a" /* default */].registerModule(['webmail'], __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */]);

		Vue.component('redactar-email', __WEBPACK_IMPORTED_MODULE_4__components_redactar_redactar__["a" /* default */]);
	}
});

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webmail_component_vue__ = __webpack_require__(682);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edc0762e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_webmail_component_vue__ = __webpack_require__(1605);
function injectStyle (ssrContext) {
  __webpack_require__(1590)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-edc0762e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webmail_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_edc0762e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_webmail_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buzones_vue__ = __webpack_require__(683);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60aa7c88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buzones_vue__ = __webpack_require__(1596);
function injectStyle (ssrContext) {
  __webpack_require__(1592)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60aa7c88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buzones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60aa7c88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buzones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buzon_vue__ = __webpack_require__(684);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b12f4ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buzon_vue__ = __webpack_require__(1595);
function injectStyle (ssrContext) {
  __webpack_require__(1594)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b12f4ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_buzon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b12f4ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_buzon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{key:_vm.buzon.Name,on:{"click":function($event){return _vm.acceder($event, _vm.buzon)}}},[_c('div',{staticClass:"info",class:_vm.getClase(),on:{"mouseenter":function($event){return _vm.entraRaton($event)},"mouseleave":function($event){return _vm.saleRaton($event)}}},[_c('div',{staticClass:"icono",on:{"click":function($event){return _vm.desplegar($event)}}},[(_vm.buzon.Buzones.length === 0)?_c('span',{class:_vm.buzon.Icono}):_c('span',[(_vm.desplegado)?_c('span',{staticClass:"fa fa-caret-down"}):_c('span',{staticClass:"fa fa-caret-right"})])]),_c('div',{staticClass:"nombre"},[_c('span',[_vm._v(_vm._s(_vm.buzon.Nombre))])]),_c('div',{staticClass:"contadorMensajes"},[_c('span',{staticClass:"badge badge-primary"},[_vm._v(_vm._s(_vm.buzon.Mensajes))])])]),(_vm.buzon.Buzones.length > 0 && _vm.desplegado)?_c('ul',{staticClass:"listadoBuzones"},_vm._l((_vm.buzon.Buzones),function(buz){return _c('Buzon',{key:buz.Path,attrs:{"buzon":buz},on:{"selected":function($event){return _vm.acceder(null, $event)}}})}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapperRedactar"},[_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary btn-lg btn-labeled",staticStyle:{"box-shadow":"0 0 5px rgba(0,0,0,0.2)"},on:{"click":function($event){_vm.redactar = true}}},[_c('span',{staticClass:"btn-label fa fa-edit mr-2"}),_c('span',[_vm._v("Redactar")])])])]),_c('ul',{staticClass:"listadoBuzones"},_vm._l((_vm.buzones),function(buzon){return _c('Buzon',{key:buzon.Name,attrs:{"buzon":buzon},on:{"selected":function($event){return _vm.seleccionaBuzon($event)}}})}),1),_c('b',[_vm._v("Etiquetas")]),(_vm.redactar)?_c('redactar-email',{on:{"cerrar":function($event){_vm.redactar = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mensajes_vue__ = __webpack_require__(685);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a11a306_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mensajes_vue__ = __webpack_require__(1604);
function injectStyle (ssrContext) {
  __webpack_require__(1598)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a11a306"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mensajes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a11a306_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_mensajes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visorMensaje_vue__ = __webpack_require__(687);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4a830e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visorMensaje_vue__ = __webpack_require__(1601);
function injectStyle (ssrContext) {
  __webpack_require__(1600)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a4a830e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visorMensaje_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4a830e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_visorMensaje_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mensaje)?_c('modal',{attrs:{"max-width":1024}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_vm._v("Enviado el "+_vm._s(_vm._f("moment")(_vm.mensaje.cabecera.date,'DD-MM-YYYY'))+" a las "+_vm._s(_vm._f("moment")(_vm.mensaje.cabecera.date,'HH:mm:ss'))),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('h2',[_c('b',[_vm._v(_vm._s(_vm.mensaje.cabecera.Subject))])])]),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"cabeceraDatos"},[_c('div',{staticClass:"remitente"},[(_vm.mensaje.cabecera.avatar)?_c('div',{staticClass:"imagen"},[_c('img',{staticClass:"rounded-circle",staticStyle:{"width":"50px","height":"50px"},attrs:{"src":_vm.mensaje.cabecera.avatar}})]):_vm._e(),_c('div',{staticClass:"datos"},[_c('b',{staticStyle:{"font-size":"1.2em"}},[_vm._v(_vm._s(_vm.mensaje.cabecera.from[0].personal))]),_c('br'),_c('span',{staticStyle:{"opacity":"0.5"}},[_vm._v(_vm._s(_vm.mensaje.cabecera.fromaddress))])])]),_c('div',{staticClass:"datosCabecera"},[_c('b',[_vm._v("Destinatario(s)")]),_c('br'),_vm._l((_vm.mensaje.cabecera.to),function(para,i){return (i <= 2 || _vm.verTodosDestinatarios)?_c('div',{key:para.mailbox,staticStyle:{"color":"#555588"}},[_vm._v(_vm._s(para.personal)+" <"+_vm._s(para.mailbox)+"@"+_vm._s(para.host)+">")]):_vm._e()}),(_vm.mensaje.cabecera.to.length > 3)?_c('div',{staticStyle:{"opacity":"0.5","cursor":"pointer"},on:{"click":function($event){_vm.verTodosDestinatarios = !_vm.verTodosDestinatarios}}},[(!_vm.verTodosDestinatarios)?_c('span',[_vm._v("Ver "+_vm._s(_vm.mensaje.cabecera.to.length - 3)+" destinatarios mas")]):_c('span',[_vm._v("Ver menos")])]):_vm._e()],2)])]),_c('div',{staticClass:"card-body",staticStyle:{"border-top":"1px solid #e0e0e0"},domProps:{"innerHTML":_vm._s(_vm.mensaje.cuerpo)}}),(_vm.adjuntos.length > 0)?_c('div',{staticClass:"card-body bg-light"},[_c('b',[_vm._v("Adjuntos")]),_c('a',{ref:"descarga",staticStyle:{"display":"none"}}),_c('div',{staticClass:"capaAdjuntos"},_vm._l((_vm.adjuntos),function(adjunto,i){return _c('div',{key:i,staticClass:"adjunto",on:{"click":function($event){return _vm.download(adjunto.part, adjunto.nombre)}}},[_c('span',{staticClass:"iconoAdjunto"},[_c('span',{staticClass:"fa fa-file-o"})]),_c('span',{staticClass:"nombreAdjunto"},[_vm._v(_vm._s(adjunto.nombre))]),_c('span',{staticClass:"tamanoAdjunto"},[_vm._v(_vm._s(_vm._f("tamano")(adjunto.size)))])])}),0)]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vistaBuzones_vue__ = __webpack_require__(688);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4550e9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_vistaBuzones_vue__ = __webpack_require__(1603);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vistaBuzones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4550e9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_vistaBuzones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":400}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"fa fa-folder mr-2"}),_vm._v("Selecciona buzón de destino"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('ul',{staticClass:"list-group"},_vm._l((_vm.listadoBuzones),function(buzon){return _c('li',{key:buzon.Path,staticClass:"list-group-item list-group-item-action",style:({'padding-left': (buzon.Nivel * 25) + 'px', 'cursor': 'default'}),on:{"click":function($event){return _vm.seleccionar(buzon)}}},[_c('span',{staticClass:"mr-2",class:buzon.Icono}),_c('span',[_vm._v(_vm._s(buzon.Nombre))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buzon)?_c('div',[_c('div',{staticClass:"cabecera"},[_c('div',{staticClass:"nombreBuzon"},[_c('span',{staticClass:"mr-2",class:_vm.buzon.Icono}),_vm._v(_vm._s(_vm.buzon.Nombre))]),_c('div',{staticClass:"buscador"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control form-contorl-sm",attrs:{"placeholder":"Buscar mensajes","disabled":_vm.buscando},domProps:{"value":(_vm.busqueda)},on:{"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscar($event)},"keyup":_vm.comprobarCadena,"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}}),_vm._m(0)])])]),_c('div',{staticClass:"herramientas"},[_c('div',{staticClass:"acciones"},[_c('button',{staticClass:"btn btn-danger",attrs:{"disabled":_vm.seleccionados.length === 0},on:{"click":function($event){return _vm.prePapelera()}}},[_c('span',{staticClass:"fa fa-trash"})]),_vm._m(1),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.getMensajes()}}},[_c('span',{staticClass:"fa fa-refresh"})])]),_c('div',{staticClass:"paginacion"},[_c('nav',{attrs:{"aria-label":"Paginación de mensajes"}},[_c('ul',{staticClass:"pagination justify-content-end"},_vm._l((_vm.paginas),function(p){return _c('li',{key:p,staticClass:"page-item",class:_vm.pagina === p ? 'active' : '',on:{"click":function($event){return _vm.verPagina(p)}}},[_c('a',{staticClass:"page-link"},[_vm._v(_vm._s(p))])])}),0)])])]),(_vm.resultados.length === 0)?_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.listado),function(mensaje,i){return _c('tr',{key:mensaje.id,staticClass:"filaMensaje",class:_vm.claseMensaje(mensaje),on:{"click":function($event){return _vm.onClickFila($event, mensaje.uid)},"contextmenu":function($event){return _vm.botonDerecho($event, mensaje.uid)},"dblclick":function($event){return _vm.verMensaje(mensaje.uid)}}},[_c('td',{staticClass:"text-center text-info",staticStyle:{"font-size":"1.3em","cursor":"pointer"},on:{"click":function($event){return _vm.toggleFlag($event, mensaje, i)}}},[_c('span',{staticClass:"favorito fa",class:mensaje.Flagged === 'F' ? 'fa-star' : 'fa-star-o'})]),_c('td',{staticClass:"text-center",staticStyle:{"font-size":"1.3em","cursor":"pointer"}},[(mensaje.hasAttachments)?_c('span',{staticClass:"fa fa-paperclip"}):_vm._e()]),_c('td',[_c('span',[_vm._v(_vm._s(mensaje.Subject))])]),_c('td',{staticStyle:{}},[_c('div',{staticStyle:{"position":"relative","display":"inline-block","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis","max-width":"300px"}},[(/Sent/.test(_vm.buzon.Name))?_c('span',[_vm._v(_vm._s(mensaje.toaddress))]):_c('span',[_vm._v(_vm._s(mensaje.fromaddress))])])]),_c('td',[_c('span',[_vm._v(_vm._s(_vm._f("moment")(mensaje.date,'DD-MM-YYYY HH:mm:ss')))])])])}),0)]):_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.resultados),function(mensaje,i){return _c('tr',{key:mensaje.id,staticClass:"filaMensaje",class:_vm.claseMensaje(mensaje),on:{"click":function($event){return _vm.onClickFila($event, mensaje.uid)},"mousedown":function($event){return _vm.botonDerecho($event)},"dblclick":function($event){return _vm.verMensaje(mensaje.uid)}}},[_c('td',{staticClass:"text-center text-info",staticStyle:{"font-size":"1.3em","cursor":"pointer"},on:{"click":function($event){return _vm.toggleFlag($event, mensaje, i)}}},[_c('span',{staticClass:"favorito fa",class:mensaje.Flagged === 'F' ? 'fa-star' : 'fa-star-o'})]),_c('td',{staticClass:"text-center",staticStyle:{"font-size":"1.3em","cursor":"pointer"}},[(mensaje.hasAttachments)?_c('span',{staticClass:"fa fa-paperclip"}):_vm._e()]),_c('td',[_c('span',[_vm._v(_vm._s(mensaje.Subject))])]),_c('td',{staticStyle:{}},[_c('div',{staticStyle:{"position":"relative","display":"inline-block","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis","max-width":"300px"}},[(/Sent/.test(_vm.buzon.Name))?_c('span',[_vm._v(_vm._s(mensaje.toaddress))]):_c('span',[_vm._v(_vm._s(mensaje.fromaddress))])])]),_c('td',[_c('span',[_vm._v(_vm._s(_vm._f("moment")(mensaje.date,'DD-MM-YYYY HH:mm:ss')))])])])}),0)]),(_vm.ver)?_c('VisorMensaje',{attrs:{"numero":_vm.ver},on:{"cerrar":_vm.cerrarMensaje}}):_vm._e(),(_vm.verContextual)?_c('div',{staticClass:"fondoContextual",on:{"click":function($event){_vm.verContextual = null}}},[_c('div',{staticClass:"contextual",style:(_vm.verContextual)},[_vm._m(2),_c('ul',{staticClass:"list-group"},[(_vm.seleccionados.length === 1)?_c('li',{staticClass:"list-group-item list-group-item-action"},[_c('span',{staticClass:"fa fa-reply mr-2"}),_vm._v("Responder")]):_vm._e(),_c('li',{staticClass:"list-group-item list-group-item-action",on:{"click":function($event){_vm.seleccionarBuzon = true}}},[_c('span',{staticClass:"fa fa-copy mr-2"}),_vm._v("Mover a otro buzón")]),(_vm.seleccionNoLeidos || !_vm.seleccionLeidos)?_c('li',{staticClass:"list-group-item list-group-item-action",on:{"click":function($event){return _vm.marcaLeido(true)}}},[_c('span',{staticClass:"fa fa-eye mr-2"}),_vm._v("Marcar como leído")]):_vm._e(),(_vm.seleccionLeidos || !_vm.seleccionNoLeidos)?_c('li',{staticClass:"list-group-item list-group-item-action",on:{"click":function($event){return _vm.marcaLeido(false)}}},[_c('span',{staticClass:"fa fa-eye-slash mr-2"}),_vm._v("Marcar como no leído")]):_vm._e(),(_vm.soloNoFavoritos || !_vm.soloFavoritos)?_c('li',{staticClass:"list-group-item list-group-item-action",on:{"click":function($event){return _vm.setFav('F')}}},[_c('span',{staticClass:"fa fa-star mr-2"}),_vm._v("Marcar como favorito")]):_vm._e(),(_vm.soloFavoritos || !_vm.soloNoFavoritos)?_c('li',{staticClass:"list-group-item list-group-item-action",on:{"click":function($event){return _vm.setFav('')}}},[_c('span',{staticClass:"fa fa-star-o mr-2"}),_vm._v("Quitar marca de favorito")]):_vm._e(),_c('li',{staticClass:"list-group-item list-group-item-action",on:{"click":function($event){return _vm.prePapelera()}}},[_c('span',{staticClass:"fa fa-trash mr-2"}),_vm._v("Enviar a la papelera")]),_c('li',{staticClass:"list-group-item list-group-item-action",on:{"click":function($event){return _vm.enviarSpam()}}},[_c('span',{staticClass:"fa fa-bug mr-2"}),_vm._v("Marcar como spam")])])])]):_vm._e(),(_vm.seleccionarBuzon)?_c('VistaBuzones',{on:{"cerrar":function($event){_vm.seleccionarBuzon = false},"seleccion":function($event){return _vm.enviarBuzon({uid: _vm.seleccionados, Destino: $event.Path})}}}):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_c('div',{staticClass:"input-group-text"},[_c('span',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn"},[_c('span',{staticClass:"fa fa-star"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-light p-2 pl-4"},[_c('span',{staticClass:"fa fa-gear mr-2"}),_c('b',[_vm._v("Opciones")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contenedor"},[_c('Buzones',{staticClass:"buzones"}),_c('Mensajes',{staticClass:"mensajes"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__servicios__ = __webpack_require__(686);

/* harmony default export */ __webpack_exports__["a"] = ({
	namespaced: true,
	state: {
		cuenta: null,
		buzones: [],
		mensajes: [],
		mensaje: null,
		buzonOver: null,
		buzonActivo: null,
		pagina: null
	},
	getters: {
		cuenta: function cuenta(state) {
			return state.cuenta;
		},
		buzones: function buzones(state) {
			return state.buzones;
		},
		buzonesAnidados: function buzonesAnidados(state) {
			if (state.buzones.length === 0) {
				return [];
			}
			var buzones = [];
			var analizar = function analizar(buz) {
				var arbol = buz.buzon.split('}')[1].split('.');
				var Path = arbol.join('.');
				var Name = arbol.splice(-1, 1)[0];
				var buzon = {
					Path: Path,
					Padre: arbol.join('.'),
					Stats: buz.status,
					Name: Name,
					Nombre: null,
					Icono: null,
					Mensajes: null,
					Buzones: []
				};

				switch (buzon.Name) {
					case 'INBOX':
						buzon.Icono = 'fa fa-folder-open';
						buzon.Nombre = 'Entrada';
						break;
					case 'Sent':
						buzon.Icono = 'fa fa-send';
						buzon.Nombre = 'Enviados';
						break;
					case 'Junk':
						buzon.Icono = 'fa fa-bug';
						buzon.Nombre = 'Spam';
						break;
					case 'Draft':
						buzon.Icono = 'fa fa-edit';
						buzon.Nombre = 'Borradores';
						break;
					case 'Trash':
						buzon.Icono = 'fa fa-trash';
						buzon.Nombre = 'Papelera';
						break;
					default:
						buzon.Icono = 'fa fa-folder';
						buzon.Nombre = buzon.Name;
						break;
				}
				buzones.push(buzon);
			};

			state.buzones.forEach(analizar);

			buzones.sort(function (a, b) {
				var ba = a.Path.split('.');
				var bb = b.Path.split('.');
				if (ba.length > bb.length) {
					return 1;
				} else if (ba.length < bb.length) {
					return -1;
				} else {
					return 0;
				}
			});

			// Ahora creamos el arbol
			for (var i = buzones.length - 1; i >= 0; i--) {
				var buz = buzones[i];

				// buscamos a su padre
				for (var p = i; p >= 0; p--) {
					if (buzones[p].Path === buz.Padre) {
						buzones[p].Buzones.push(buzones[i]);
						buzones.splice(i, 1);
					}
				}
			}

			buzones.sort(function (a, b) {
				if (a.Name === 'INBOX') {
					return -1;
				} else if (a.Name === 'Sent') {
					return -1;
				} else if (a.Name === 'Draft') {
					return -1;
				} else if (a.Name === 'Trash') {
					return -1;
				} else if (a.Name === 'Junk') {
					return -1;
				}

				if (b.Name === 'INBOX') {
					return -1;
				} else if (b.Name === 'Sent') {
					return -1;
				} else if (b.Name === 'Draft') {
					return -1;
				} else if (b.Name === 'Trash') {
					return -1;
				} else if (b.Name === 'Junk') {
					return -1;
				}

				if (a.Name > b.Name) {
					return 1;
				} else if (a.Name < b.Name) {
					return -1;
				} else {
					return 0;
				}
			});
			return buzones;
		},
		mensajes: function mensajes(state) {
			return state.mensajes;
		},
		mensaje: function mensaje(state) {
			return state.mensaje;
		},
		buzonOver: function buzonOver(state) {
			return state.buzonOver;
		},
		buzonActivo: function buzonActivo(state) {
			return state.buzonActivo;
		},
		pagina: function pagina(state) {
			return state.pagina;
		}
	},
	mutations: {
		SET_CUENTA: function SET_CUENTA(state, email) {
			state.cuenta = email;
		},
		SET_BUZONES: function SET_BUZONES(state, payload) {
			state.buzones = payload;
		},
		SELECCIONA_BUZON: function SELECCIONA_BUZON(state, buzon) {
			buzon.mensajes = 0;
			state.buzonActivo = buzon;
			state.pagina = 1;
		},
		BUZON_OVER: function BUZON_OVER(state, buzon) {
			state.buzonOver = buzon;
		},
		SET_PAGINA: function SET_PAGINA(state, pagina) {
			state.pagina = pagina;
		},
		SET_MENSAJES: function SET_MENSAJES(state, mensajes) {
			state.mensajes = mensajes;
		},
		SET_MENSAJE: function SET_MENSAJE(state, mensaje) {
			state.mensaje = mensaje;
		},
		SET_TOTAL_BUZON_ACTIVO: function SET_TOTAL_BUZON_ACTIVO(state, total) {
			state.buzonActivo.mensajes = total;
		},
		SET_FLAG: function SET_FLAG(state, d) {
			state.mensajes = state.mensajes.map(function (m) {
				if (d.numero.indexOf(m.uid) >= 0) {
					m.Flagged = d.flag;
				}
				return m;
			});
		},
		DEL_MENSAJE: function DEL_MENSAJE(state, uid) {
			state.mensajes = state.mensajes.filter(function (m) {
				return uid.indexOf(m.uid) < 0;
			});
		},
		SET_LEIDO: function SET_LEIDO(state, _ref) {
			var uid = _ref.uid,
			    leido = _ref.leido;

			state.mensajes = state.mensajes.map(function (m) {
				if (uid.indexOf(m.uid) >= 0) {
					m.Recent = leido ? '' : m.Recent;
					m.Unseen = leido ? '' : 'U';
				}
				return m;
			});
		}
	},
	actions: {
		getListadoBuzones: function getListadoBuzones(context) {
			var _this = this;

			if (!context.state.cuenta) {
				console.error('No has seleccionado una cuenta');
				return;
			}
			__WEBPACK_IMPORTED_MODULE_0__servicios__["a" /* default */].GetBuzones(context.state.cuenta).then(function (listado) {
				context.commit('SET_BUZONES', listado);
			}).catch(function (e) {
				_this.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e
				});
			});
		},
		getMensajes: function getMensajes(context) {
			var _this2 = this;

			if (!context.state.buzonActivo) {
				return;
			}
			__WEBPACK_IMPORTED_MODULE_0__servicios__["a" /* default */].GetMensajes(context.state.cuenta, context.state.buzonActivo.Path, context.state.pagina).then(function (mensajes) {
				context.commit('SET_MENSAJES', mensajes.listado);
				context.commit('SET_TOTAL_BUZON_ACTIVO', mensajes.mensajes);
			}).catch(function (e) {
				_this2.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e
				});
			});
		},
		verMensaje: function verMensaje(context, numero) {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_0__servicios__["a" /* default */].GetMensaje(context.state.cuenta, context.state.buzonActivo.Path, numero).then(function (mensaje) {
				context.commit('SET_MENSAJE', mensaje);
				context.commit('SET_LEIDO', { uid: [numero], leido: true });
			}).catch(function (e) {
				_this3.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e
				});
			});
		},
		enviarPapelera: function enviarPapelera(context, uid) {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_0__servicios__["a" /* default */].enviarPapelera(context.state.cuenta, context.state.buzonActivo.Path, uid).then(function (res) {
				context.commit('DEL_MENSAJE', uid);
			}).catch(function (e) {
				_this4.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e
				});
			});
		},
		enviarBuzon: function enviarBuzon(context, _ref2) {
			var _this5 = this;

			var uid = _ref2.uid,
			    Destino = _ref2.Destino;

			__WEBPACK_IMPORTED_MODULE_0__servicios__["a" /* default */].enviarBuzon(context.state.cuenta, context.state.buzonActivo.Path, uid, Destino).then(function (res) {
				if (Destino !== context.state.buzonActivo.Path) {
					context.commit('DEL_MENSAJE', uid);
				}
			}).catch(function (e) {
				_this5.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e
				});
			});
		},
		setFlag: function setFlag(context, _ref3) {
			var _this6 = this;

			var numero = _ref3.numero,
			    flag = _ref3.flag;

			__WEBPACK_IMPORTED_MODULE_0__servicios__["a" /* default */].SetFlag(context.state.cuenta, context.state.buzonActivo.Path, numero, flag).then(function () {
				context.commit('SET_FLAG', { numero: numero, flag: flag });
			}).catch(function (e) {
				_this6.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e
				});
			});
		},
		setLeido: function setLeido(context, _ref4) {
			var _this7 = this;

			var numero = _ref4.numero,
			    leido = _ref4.leido;

			__WEBPACK_IMPORTED_MODULE_0__servicios__["a" /* default */].SetLeido(context.state.cuenta, context.state.buzonActivo.Path, numero, leido).then(function () {
				context.commit('SET_LEIDO', { uid: numero, leido: leido });
			}).catch(function (e) {
				_this7.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				});
			});
		}
	}
});

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_redactar_vue__ = __webpack_require__(689);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fdfb842_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_redactar_vue__ = __webpack_require__(1608);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_redactar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fdfb842_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_redactar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"max-width":1024}},[_c('div',{staticClass:"card text-left"},[_c('div',{staticClass:"card-header bg-info text-white"},[_c('span',{staticClass:"fa fa-edit mr-2"}),_vm._v("Redactar mensaje"),_c('button',{staticClass:"close",on:{"click":_vm.cerrar}},[_vm._v("×")])]),_c('div',{staticClass:"card-body"},[_c('b',[_vm._v(" Destinatarios")]),_c('span',{staticClass:"ml-2",staticStyle:{"cursor":"pointer"},on:{"click":_vm.nuevoDestinatario}},[_vm._v("(Añadir)")]),_c('br'),_vm._l((_vm.destinatarios),function(destinatario,i){return _c('div',{key:i,staticClass:"input-group input-group-sm m-1"},[_c('div',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn-sm btn",class:destinatario.tipo === 'Para' ? 'btn-primary' : '',on:{"click":function($event){_vm.destinatarios[i].tipo = 'Para'}}},[_vm._v("Para")])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn-sm btn",class:destinatario.tipo === 'CC' ? 'btn-primary' : '',on:{"click":function($event){_vm.destinatarios[i].tipo = 'CC'}}},[_vm._v("CC")])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn-sm btn",class:destinatario.tipo === 'CCO' ? 'btn-primary' : '',on:{"click":function($event){_vm.destinatarios[i].tipo = 'CCO'}}},[_vm._v("CCO")])]),_c('input',{staticClass:"form-control form-control-sm",attrs:{"placeholder":"dirección@email"}})])})],2),_c('div',{staticClass:"card-body bg-light"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('b',[_vm._v("Asunto")])]),_c('input',{staticClass:"form-control"})])]),_c('div',{staticClass:"card-body bg-light",staticStyle:{"height":"600px","padding-bottom":"50px"}},[_c('vue-mce',{staticClass:"editor",attrs:{"config":_vm.configuracionEditor},model:{value:(_vm.cuerpo),callback:function ($$v) {_vm.cuerpo=$$v},expression:"cuerpo"}})],1),_c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.cerrar}},[_c('span',{staticClass:"fa fa-send mr-2"}),_vm._v("Enviar")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[690]);


// WEBPACK FOOTER //
// static/js/app.34c3af0b9decff3709da.js